import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { VisuallyHidden as VisuallyHidden$1, useStyleConfig as useStyleConfig$1, useMultiStyleConfig as useMultiStyleConfig$1, keyframes, usePrefersReducedMotion, useTheme as useTheme$1, Box as Box$1, extendTheme as extendTheme$1, theme, ChakraProvider, Collapse as Collapse$1, Fade as Fade$1, ScaleFade as ScaleFade$1, Slide as Slide$1, Grid as Grid$1, GridItem as GridItem$1, SimpleGrid as SimpleGrid$1, FormControl as FormControl$1, useFormControlContext as useFormControlContext$1, Input as Input$1, forwardRef as forwardRef$2, InputGroup as InputGroup$1, InputLeftElement as InputLeftElement$1, InputRightElement as InputRightElement$1, Skeleton as Skeleton$1, SkeletonCircle as SkeletonCircle$1, SkeletonText as SkeletonText$1, useToast as useToast$1, AccordionItem as AccordionItem$1, AccordionButton, AccordionPanel, Accordion as Accordion$1, ModalBody, useModalContext, ModalFooter as ModalFooter$1, ModalHeader, Modal as Modal$1, ModalContent } from "@chakra-ui/react";
import * as React from "react";
import React__default, { useCallback as useCallback$1, useState as useState$1, useRef as useRef$1, useEffect as useEffect$1, useMemo as useMemo$1, useLayoutEffect as useLayoutEffect$1, forwardRef as forwardRef$1, useContext as useContext$1, createRef, useImperativeHandle as useImperativeHandle$1, createElement as createElement$1, createContext as createContext$1, Children, isValidElement, cloneElement, useReducer, Component, Fragment as Fragment$1 } from "react";
import * as ReactDOM from "react-dom";
import { createPortal } from "react-dom";
import { useIntl as useIntl$1 } from "react-intl";
import { SkipNavLink as SkipNavLink$1 } from "@chakra-ui/skip-nav";
const convertCurrencyToNumber = (r) => parseFloat(r.replace(/[^-0-9.]/g, "")), removeNonDigitsFromCurrency = (r) => {
  const a = convertCurrencyToNumber(r);
  if (isNaN(a))
    throw new Error("Amount is invalid");
  return a.toString();
}, createDate = (r) => {
  if (r && !/^\d{4}-\d{2}-\d{2}$/.test(r))
    throw new Error("Use YYYY-MM-DD");
  if (r)
    return /* @__PURE__ */ new Date(`${r}T12:00:00.000Z`);
  const a = /* @__PURE__ */ new Date();
  return a.setHours(12, 0, 0, 0), a;
};
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var format$2 = { exports: {} }, interopRequireDefault = { exports: {} };
(function(r) {
  function a(s) {
    return s && s.__esModule ? s : {
      default: s
    };
  }
  r.exports = a, r.exports.__esModule = !0, r.exports.default = r.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports, isValid$1 = { exports: {} }, isDate$1 = { exports: {} }, _typeof$1 = { exports: {} };
(function(r) {
  function a(s) {
    "@babel/helpers - typeof";
    return r.exports = a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
      return typeof c;
    } : function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, r.exports.__esModule = !0, r.exports.default = r.exports, a(s);
  }
  r.exports = a, r.exports.__esModule = !0, r.exports.default = r.exports;
})(_typeof$1);
var _typeofExports = _typeof$1.exports, requiredArgs$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c, u) {
    if (u.length < c)
      throw new TypeError(c + " argument" + (c > 1 ? "s" : "") + " required, but only " + u.length + " present");
  }
  r.exports = a.default;
})(requiredArgs$1, requiredArgs$1.exports);
var requiredArgsExports = requiredArgs$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = d;
  var c = s(_typeofExports), u = s(requiredArgsExports);
  function d(h) {
    return (0, u.default)(1, arguments), h instanceof Date || (0, c.default)(h) === "object" && Object.prototype.toString.call(h) === "[object Date]";
  }
  r.exports = a.default;
})(isDate$1, isDate$1.exports);
var isDateExports = isDate$1.exports, toDate$2 = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = d;
  var c = s(_typeofExports), u = s(requiredArgsExports);
  function d(h) {
    (0, u.default)(1, arguments);
    var p = Object.prototype.toString.call(h);
    return h instanceof Date || (0, c.default)(h) === "object" && p === "[object Date]" ? new Date(h.getTime()) : typeof h == "number" || p === "[object Number]" ? new Date(h) : ((typeof h == "string" || p === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  r.exports = a.default;
})(toDate$2, toDate$2.exports);
var toDateExports = toDate$2.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(isDateExports), u = s(toDateExports), d = s(requiredArgsExports);
  function h(p) {
    if ((0, d.default)(1, arguments), !(0, c.default)(p) && typeof p != "number")
      return !1;
    var m = (0, u.default)(p);
    return !isNaN(Number(m));
  }
  r.exports = a.default;
})(isValid$1, isValid$1.exports);
var isValidExports = isValid$1.exports, subMilliseconds$1 = { exports: {} }, addMilliseconds$1 = { exports: {} }, toInteger$2 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c) {
    if (c === null || c === !0 || c === !1)
      return NaN;
    var u = Number(c);
    return isNaN(u) ? u : u < 0 ? Math.ceil(u) : Math.floor(u);
  }
  r.exports = a.default;
})(toInteger$2, toInteger$2.exports);
var toIntegerExports = toInteger$2.exports;
const toInteger$1 = /* @__PURE__ */ getDefaultExportFromCjs(toIntegerExports);
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(toIntegerExports), u = s(toDateExports), d = s(requiredArgsExports);
  function h(p, m) {
    (0, d.default)(2, arguments);
    var g = (0, u.default)(p).getTime(), v = (0, c.default)(m);
    return new Date(g + v);
  }
  r.exports = a.default;
})(addMilliseconds$1, addMilliseconds$1.exports);
var addMillisecondsExports = addMilliseconds$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(addMillisecondsExports), u = s(requiredArgsExports), d = s(toIntegerExports);
  function h(p, m) {
    (0, u.default)(2, arguments);
    var g = (0, d.default)(m);
    return (0, c.default)(p, -g);
  }
  r.exports = a.default;
})(subMilliseconds$1, subMilliseconds$1.exports);
var subMillisecondsExports = subMilliseconds$1.exports, formatters$3 = { exports: {} }, getUTCDayOfYear$1 = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(toDateExports), u = s(requiredArgsExports), d = 864e5;
  function h(p) {
    (0, u.default)(1, arguments);
    var m = (0, c.default)(p), g = m.getTime();
    m.setUTCMonth(0, 1), m.setUTCHours(0, 0, 0, 0);
    var v = m.getTime(), y = g - v;
    return Math.floor(y / d) + 1;
  }
  r.exports = a.default;
})(getUTCDayOfYear$1, getUTCDayOfYear$1.exports);
var getUTCDayOfYearExports = getUTCDayOfYear$1.exports, getUTCISOWeek$1 = { exports: {} }, startOfUTCISOWeek$1 = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = d;
  var c = s(toDateExports), u = s(requiredArgsExports);
  function d(h) {
    (0, u.default)(1, arguments);
    var p = 1, m = (0, c.default)(h), g = m.getUTCDay(), v = (g < p ? 7 : 0) + g - p;
    return m.setUTCDate(m.getUTCDate() - v), m.setUTCHours(0, 0, 0, 0), m;
  }
  r.exports = a.default;
})(startOfUTCISOWeek$1, startOfUTCISOWeek$1.exports);
var startOfUTCISOWeekExports = startOfUTCISOWeek$1.exports, startOfUTCISOWeekYear$1 = { exports: {} }, getUTCISOWeekYear$1 = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(toDateExports), u = s(requiredArgsExports), d = s(startOfUTCISOWeekExports);
  function h(p) {
    (0, u.default)(1, arguments);
    var m = (0, c.default)(p), g = m.getUTCFullYear(), v = /* @__PURE__ */ new Date(0);
    v.setUTCFullYear(g + 1, 0, 4), v.setUTCHours(0, 0, 0, 0);
    var y = (0, d.default)(v), x = /* @__PURE__ */ new Date(0);
    x.setUTCFullYear(g, 0, 4), x.setUTCHours(0, 0, 0, 0);
    var w = (0, d.default)(x);
    return m.getTime() >= y.getTime() ? g + 1 : m.getTime() >= w.getTime() ? g : g - 1;
  }
  r.exports = a.default;
})(getUTCISOWeekYear$1, getUTCISOWeekYear$1.exports);
var getUTCISOWeekYearExports = getUTCISOWeekYear$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = h;
  var c = s(getUTCISOWeekYearExports), u = s(startOfUTCISOWeekExports), d = s(requiredArgsExports);
  function h(p) {
    (0, d.default)(1, arguments);
    var m = (0, c.default)(p), g = /* @__PURE__ */ new Date(0);
    g.setUTCFullYear(m, 0, 4), g.setUTCHours(0, 0, 0, 0);
    var v = (0, u.default)(g);
    return v;
  }
  r.exports = a.default;
})(startOfUTCISOWeekYear$1, startOfUTCISOWeekYear$1.exports);
var startOfUTCISOWeekYearExports = startOfUTCISOWeekYear$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = m;
  var c = s(toDateExports), u = s(startOfUTCISOWeekExports), d = s(startOfUTCISOWeekYearExports), h = s(requiredArgsExports), p = 6048e5;
  function m(g) {
    (0, h.default)(1, arguments);
    var v = (0, c.default)(g), y = (0, u.default)(v).getTime() - (0, d.default)(v).getTime();
    return Math.round(y / p) + 1;
  }
  r.exports = a.default;
})(getUTCISOWeek$1, getUTCISOWeek$1.exports);
var getUTCISOWeekExports = getUTCISOWeek$1.exports, getUTCWeek$1 = { exports: {} }, startOfUTCWeek$1 = { exports: {} }, defaultOptions$4 = {};
Object.defineProperty(defaultOptions$4, "__esModule", {
  value: !0
});
defaultOptions$4.getDefaultOptions = getDefaultOptions$1;
defaultOptions$4.setDefaultOptions = setDefaultOptions;
var defaultOptions$3 = {};
function getDefaultOptions$1() {
  return defaultOptions$3;
}
function setDefaultOptions(r) {
  defaultOptions$3 = r;
}
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = p;
  var c = s(toDateExports), u = s(requiredArgsExports), d = s(toIntegerExports), h = defaultOptions$4;
  function p(m, g) {
    var v, y, x, w, S, M, P, L;
    (0, u.default)(1, arguments);
    var I = (0, h.getDefaultOptions)(), T = (0, d.default)((v = (y = (x = (w = g == null ? void 0 : g.weekStartsOn) !== null && w !== void 0 ? w : g == null || (S = g.locale) === null || S === void 0 || (M = S.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && x !== void 0 ? x : I.weekStartsOn) !== null && y !== void 0 ? y : (P = I.locale) === null || P === void 0 || (L = P.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && v !== void 0 ? v : 0);
    if (!(T >= 0 && T <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var E = (0, c.default)(m), R = E.getUTCDay(), A = (R < T ? 7 : 0) + R - T;
    return E.setUTCDate(E.getUTCDate() - A), E.setUTCHours(0, 0, 0, 0), E;
  }
  r.exports = a.default;
})(startOfUTCWeek$1, startOfUTCWeek$1.exports);
var startOfUTCWeekExports = startOfUTCWeek$1.exports, startOfUTCWeekYear$1 = { exports: {} }, getUTCWeekYear$1 = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = m;
  var c = s(toDateExports), u = s(requiredArgsExports), d = s(startOfUTCWeekExports), h = s(toIntegerExports), p = defaultOptions$4;
  function m(g, v) {
    var y, x, w, S, M, P, L, I;
    (0, u.default)(1, arguments);
    var T = (0, c.default)(g), E = T.getUTCFullYear(), R = (0, p.getDefaultOptions)(), A = (0, h.default)((y = (x = (w = (S = v == null ? void 0 : v.firstWeekContainsDate) !== null && S !== void 0 ? S : v == null || (M = v.locale) === null || M === void 0 || (P = M.options) === null || P === void 0 ? void 0 : P.firstWeekContainsDate) !== null && w !== void 0 ? w : R.firstWeekContainsDate) !== null && x !== void 0 ? x : (L = R.locale) === null || L === void 0 || (I = L.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && y !== void 0 ? y : 1);
    if (!(A >= 1 && A <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var k = /* @__PURE__ */ new Date(0);
    k.setUTCFullYear(E + 1, 0, A), k.setUTCHours(0, 0, 0, 0);
    var V = (0, d.default)(k, v), B = /* @__PURE__ */ new Date(0);
    B.setUTCFullYear(E, 0, A), B.setUTCHours(0, 0, 0, 0);
    var q = (0, d.default)(B, v);
    return T.getTime() >= V.getTime() ? E + 1 : T.getTime() >= q.getTime() ? E : E - 1;
  }
  r.exports = a.default;
})(getUTCWeekYear$1, getUTCWeekYear$1.exports);
var getUTCWeekYearExports = getUTCWeekYear$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = m;
  var c = s(getUTCWeekYearExports), u = s(requiredArgsExports), d = s(startOfUTCWeekExports), h = s(toIntegerExports), p = defaultOptions$4;
  function m(g, v) {
    var y, x, w, S, M, P, L, I;
    (0, u.default)(1, arguments);
    var T = (0, p.getDefaultOptions)(), E = (0, h.default)((y = (x = (w = (S = v == null ? void 0 : v.firstWeekContainsDate) !== null && S !== void 0 ? S : v == null || (M = v.locale) === null || M === void 0 || (P = M.options) === null || P === void 0 ? void 0 : P.firstWeekContainsDate) !== null && w !== void 0 ? w : T.firstWeekContainsDate) !== null && x !== void 0 ? x : (L = T.locale) === null || L === void 0 || (I = L.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && y !== void 0 ? y : 1), R = (0, c.default)(g, v), A = /* @__PURE__ */ new Date(0);
    A.setUTCFullYear(R, 0, E), A.setUTCHours(0, 0, 0, 0);
    var k = (0, d.default)(A, v);
    return k;
  }
  r.exports = a.default;
})(startOfUTCWeekYear$1, startOfUTCWeekYear$1.exports);
var startOfUTCWeekYearExports = startOfUTCWeekYear$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = m;
  var c = s(toDateExports), u = s(startOfUTCWeekExports), d = s(startOfUTCWeekYearExports), h = s(requiredArgsExports), p = 6048e5;
  function m(g, v) {
    (0, h.default)(1, arguments);
    var y = (0, c.default)(g), x = (0, u.default)(y, v).getTime() - (0, d.default)(y, v).getTime();
    return Math.round(x / p) + 1;
  }
  r.exports = a.default;
})(getUTCWeek$1, getUTCWeek$1.exports);
var getUTCWeekExports = getUTCWeek$1.exports, addLeadingZeros$2 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c, u) {
    for (var d = c < 0 ? "-" : "", h = Math.abs(c).toString(); h.length < u; )
      h = "0" + h;
    return d + h;
  }
  r.exports = a.default;
})(addLeadingZeros$2, addLeadingZeros$2.exports);
var addLeadingZerosExports = addLeadingZeros$2.exports, lightFormatters = { exports: {} };
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(addLeadingZerosExports), u = {
    // Year
    y: function(p, m) {
      var g = p.getUTCFullYear(), v = g > 0 ? g : 1 - g;
      return (0, c.default)(m === "yy" ? v % 100 : v, m.length);
    },
    // Month
    M: function(p, m) {
      var g = p.getUTCMonth();
      return m === "M" ? String(g + 1) : (0, c.default)(g + 1, 2);
    },
    // Day of the month
    d: function(p, m) {
      return (0, c.default)(p.getUTCDate(), m.length);
    },
    // AM or PM
    a: function(p, m) {
      var g = p.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (m) {
        case "a":
        case "aa":
          return g.toUpperCase();
        case "aaa":
          return g;
        case "aaaaa":
          return g[0];
        case "aaaa":
        default:
          return g === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(p, m) {
      return (0, c.default)(p.getUTCHours() % 12 || 12, m.length);
    },
    // Hour [0-23]
    H: function(p, m) {
      return (0, c.default)(p.getUTCHours(), m.length);
    },
    // Minute
    m: function(p, m) {
      return (0, c.default)(p.getUTCMinutes(), m.length);
    },
    // Second
    s: function(p, m) {
      return (0, c.default)(p.getUTCSeconds(), m.length);
    },
    // Fraction of second
    S: function(p, m) {
      var g = m.length, v = p.getUTCMilliseconds(), y = Math.floor(v * Math.pow(10, g - 3));
      return (0, c.default)(y, m.length);
    }
  }, d = u;
  a.default = d, r.exports = a.default;
})(lightFormatters, lightFormatters.exports);
var lightFormattersExports = lightFormatters.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(getUTCDayOfYearExports), u = s(getUTCISOWeekExports), d = s(getUTCISOWeekYearExports), h = s(getUTCWeekExports), p = s(getUTCWeekYearExports), m = s(addLeadingZerosExports), g = s(lightFormattersExports), v = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, y = {
    // Era
    G: function(L, I, T) {
      var E = L.getUTCFullYear() > 0 ? 1 : 0;
      switch (I) {
        case "G":
        case "GG":
        case "GGG":
          return T.era(E, {
            width: "abbreviated"
          });
        case "GGGGG":
          return T.era(E, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return T.era(E, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(L, I, T) {
      if (I === "yo") {
        var E = L.getUTCFullYear(), R = E > 0 ? E : 1 - E;
        return T.ordinalNumber(R, {
          unit: "year"
        });
      }
      return g.default.y(L, I);
    },
    // Local week-numbering year
    Y: function(L, I, T, E) {
      var R = (0, p.default)(L, E), A = R > 0 ? R : 1 - R;
      if (I === "YY") {
        var k = A % 100;
        return (0, m.default)(k, 2);
      }
      return I === "Yo" ? T.ordinalNumber(A, {
        unit: "year"
      }) : (0, m.default)(A, I.length);
    },
    // ISO week-numbering year
    R: function(L, I) {
      var T = (0, d.default)(L);
      return (0, m.default)(T, I.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(L, I) {
      var T = L.getUTCFullYear();
      return (0, m.default)(T, I.length);
    },
    // Quarter
    Q: function(L, I, T) {
      var E = Math.ceil((L.getUTCMonth() + 1) / 3);
      switch (I) {
        case "Q":
          return String(E);
        case "QQ":
          return (0, m.default)(E, 2);
        case "Qo":
          return T.ordinalNumber(E, {
            unit: "quarter"
          });
        case "QQQ":
          return T.quarter(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return T.quarter(E, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return T.quarter(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(L, I, T) {
      var E = Math.ceil((L.getUTCMonth() + 1) / 3);
      switch (I) {
        case "q":
          return String(E);
        case "qq":
          return (0, m.default)(E, 2);
        case "qo":
          return T.ordinalNumber(E, {
            unit: "quarter"
          });
        case "qqq":
          return T.quarter(E, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return T.quarter(E, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return T.quarter(E, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(L, I, T) {
      var E = L.getUTCMonth();
      switch (I) {
        case "M":
        case "MM":
          return g.default.M(L, I);
        case "Mo":
          return T.ordinalNumber(E + 1, {
            unit: "month"
          });
        case "MMM":
          return T.month(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return T.month(E, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return T.month(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(L, I, T) {
      var E = L.getUTCMonth();
      switch (I) {
        case "L":
          return String(E + 1);
        case "LL":
          return (0, m.default)(E + 1, 2);
        case "Lo":
          return T.ordinalNumber(E + 1, {
            unit: "month"
          });
        case "LLL":
          return T.month(E, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return T.month(E, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return T.month(E, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(L, I, T, E) {
      var R = (0, h.default)(L, E);
      return I === "wo" ? T.ordinalNumber(R, {
        unit: "week"
      }) : (0, m.default)(R, I.length);
    },
    // ISO week of year
    I: function(L, I, T) {
      var E = (0, u.default)(L);
      return I === "Io" ? T.ordinalNumber(E, {
        unit: "week"
      }) : (0, m.default)(E, I.length);
    },
    // Day of the month
    d: function(L, I, T) {
      return I === "do" ? T.ordinalNumber(L.getUTCDate(), {
        unit: "date"
      }) : g.default.d(L, I);
    },
    // Day of year
    D: function(L, I, T) {
      var E = (0, c.default)(L);
      return I === "Do" ? T.ordinalNumber(E, {
        unit: "dayOfYear"
      }) : (0, m.default)(E, I.length);
    },
    // Day of week
    E: function(L, I, T) {
      var E = L.getUTCDay();
      switch (I) {
        case "E":
        case "EE":
        case "EEE":
          return T.day(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return T.day(E, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return T.day(E, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return T.day(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(L, I, T, E) {
      var R = L.getUTCDay(), A = (R - E.weekStartsOn + 8) % 7 || 7;
      switch (I) {
        case "e":
          return String(A);
        case "ee":
          return (0, m.default)(A, 2);
        case "eo":
          return T.ordinalNumber(A, {
            unit: "day"
          });
        case "eee":
          return T.day(R, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return T.day(R, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return T.day(R, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return T.day(R, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(L, I, T, E) {
      var R = L.getUTCDay(), A = (R - E.weekStartsOn + 8) % 7 || 7;
      switch (I) {
        case "c":
          return String(A);
        case "cc":
          return (0, m.default)(A, I.length);
        case "co":
          return T.ordinalNumber(A, {
            unit: "day"
          });
        case "ccc":
          return T.day(R, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return T.day(R, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return T.day(R, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return T.day(R, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(L, I, T) {
      var E = L.getUTCDay(), R = E === 0 ? 7 : E;
      switch (I) {
        case "i":
          return String(R);
        case "ii":
          return (0, m.default)(R, I.length);
        case "io":
          return T.ordinalNumber(R, {
            unit: "day"
          });
        case "iii":
          return T.day(E, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return T.day(E, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return T.day(E, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return T.day(E, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(L, I, T) {
      var E = L.getUTCHours(), R = E / 12 >= 1 ? "pm" : "am";
      switch (I) {
        case "a":
        case "aa":
          return T.dayPeriod(R, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return T.dayPeriod(R, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return T.dayPeriod(R, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return T.dayPeriod(R, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(L, I, T) {
      var E = L.getUTCHours(), R;
      switch (E === 12 ? R = v.noon : E === 0 ? R = v.midnight : R = E / 12 >= 1 ? "pm" : "am", I) {
        case "b":
        case "bb":
          return T.dayPeriod(R, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return T.dayPeriod(R, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return T.dayPeriod(R, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return T.dayPeriod(R, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(L, I, T) {
      var E = L.getUTCHours(), R;
      switch (E >= 17 ? R = v.evening : E >= 12 ? R = v.afternoon : E >= 4 ? R = v.morning : R = v.night, I) {
        case "B":
        case "BB":
        case "BBB":
          return T.dayPeriod(R, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return T.dayPeriod(R, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return T.dayPeriod(R, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(L, I, T) {
      if (I === "ho") {
        var E = L.getUTCHours() % 12;
        return E === 0 && (E = 12), T.ordinalNumber(E, {
          unit: "hour"
        });
      }
      return g.default.h(L, I);
    },
    // Hour [0-23]
    H: function(L, I, T) {
      return I === "Ho" ? T.ordinalNumber(L.getUTCHours(), {
        unit: "hour"
      }) : g.default.H(L, I);
    },
    // Hour [0-11]
    K: function(L, I, T) {
      var E = L.getUTCHours() % 12;
      return I === "Ko" ? T.ordinalNumber(E, {
        unit: "hour"
      }) : (0, m.default)(E, I.length);
    },
    // Hour [1-24]
    k: function(L, I, T) {
      var E = L.getUTCHours();
      return E === 0 && (E = 24), I === "ko" ? T.ordinalNumber(E, {
        unit: "hour"
      }) : (0, m.default)(E, I.length);
    },
    // Minute
    m: function(L, I, T) {
      return I === "mo" ? T.ordinalNumber(L.getUTCMinutes(), {
        unit: "minute"
      }) : g.default.m(L, I);
    },
    // Second
    s: function(L, I, T) {
      return I === "so" ? T.ordinalNumber(L.getUTCSeconds(), {
        unit: "second"
      }) : g.default.s(L, I);
    },
    // Fraction of second
    S: function(L, I) {
      return g.default.S(L, I);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(L, I, T, E) {
      var R = E._originalDate || L, A = R.getTimezoneOffset();
      if (A === 0)
        return "Z";
      switch (I) {
        case "X":
          return w(A);
        case "XXXX":
        case "XX":
          return S(A);
        case "XXXXX":
        case "XXX":
        default:
          return S(A, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(L, I, T, E) {
      var R = E._originalDate || L, A = R.getTimezoneOffset();
      switch (I) {
        case "x":
          return w(A);
        case "xxxx":
        case "xx":
          return S(A);
        case "xxxxx":
        case "xxx":
        default:
          return S(A, ":");
      }
    },
    // Timezone (GMT)
    O: function(L, I, T, E) {
      var R = E._originalDate || L, A = R.getTimezoneOffset();
      switch (I) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + x(A, ":");
        case "OOOO":
        default:
          return "GMT" + S(A, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(L, I, T, E) {
      var R = E._originalDate || L, A = R.getTimezoneOffset();
      switch (I) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + x(A, ":");
        case "zzzz":
        default:
          return "GMT" + S(A, ":");
      }
    },
    // Seconds timestamp
    t: function(L, I, T, E) {
      var R = E._originalDate || L, A = Math.floor(R.getTime() / 1e3);
      return (0, m.default)(A, I.length);
    },
    // Milliseconds timestamp
    T: function(L, I, T, E) {
      var R = E._originalDate || L, A = R.getTime();
      return (0, m.default)(A, I.length);
    }
  };
  function x(P, L) {
    var I = P > 0 ? "-" : "+", T = Math.abs(P), E = Math.floor(T / 60), R = T % 60;
    if (R === 0)
      return I + String(E);
    var A = L;
    return I + String(E) + A + (0, m.default)(R, 2);
  }
  function w(P, L) {
    if (P % 60 === 0) {
      var I = P > 0 ? "-" : "+";
      return I + (0, m.default)(Math.abs(P) / 60, 2);
    }
    return S(P, L);
  }
  function S(P, L) {
    var I = L || "", T = P > 0 ? "-" : "+", E = Math.abs(P), R = (0, m.default)(Math.floor(E / 60), 2), A = (0, m.default)(E % 60, 2);
    return T + R + I + A;
  }
  var M = y;
  a.default = M, r.exports = a.default;
})(formatters$3, formatters$3.exports);
var formattersExports = formatters$3.exports, longFormatters$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var s = function(m, g) {
    switch (m) {
      case "P":
        return g.date({
          width: "short"
        });
      case "PP":
        return g.date({
          width: "medium"
        });
      case "PPP":
        return g.date({
          width: "long"
        });
      case "PPPP":
      default:
        return g.date({
          width: "full"
        });
    }
  }, c = function(m, g) {
    switch (m) {
      case "p":
        return g.time({
          width: "short"
        });
      case "pp":
        return g.time({
          width: "medium"
        });
      case "ppp":
        return g.time({
          width: "long"
        });
      case "pppp":
      default:
        return g.time({
          width: "full"
        });
    }
  }, u = function(m, g) {
    var v = m.match(/(P+)(p+)?/) || [], y = v[1], x = v[2];
    if (!x)
      return s(m, g);
    var w;
    switch (y) {
      case "P":
        w = g.dateTime({
          width: "short"
        });
        break;
      case "PP":
        w = g.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        w = g.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        w = g.dateTime({
          width: "full"
        });
        break;
    }
    return w.replace("{{date}}", s(y, g)).replace("{{time}}", c(x, g));
  }, d = {
    p: c,
    P: u
  }, h = d;
  a.default = h, r.exports = a.default;
})(longFormatters$1, longFormatters$1.exports);
var longFormattersExports = longFormatters$1.exports, getTimezoneOffsetInMilliseconds$2 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c) {
    var u = new Date(Date.UTC(c.getFullYear(), c.getMonth(), c.getDate(), c.getHours(), c.getMinutes(), c.getSeconds(), c.getMilliseconds()));
    return u.setUTCFullYear(c.getFullYear()), c.getTime() - u.getTime();
  }
  r.exports = a.default;
})(getTimezoneOffsetInMilliseconds$2, getTimezoneOffsetInMilliseconds$2.exports);
var getTimezoneOffsetInMillisecondsExports = getTimezoneOffsetInMilliseconds$2.exports;
const getTimezoneOffsetInMilliseconds$1 = /* @__PURE__ */ getDefaultExportFromCjs(getTimezoneOffsetInMillisecondsExports);
var protectedTokens = {};
Object.defineProperty(protectedTokens, "__esModule", {
  value: !0
});
protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken$1;
protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken$1;
protectedTokens.throwProtectedError = throwProtectedError$1;
var protectedDayOfYearTokens$1 = ["D", "DD"], protectedWeekYearTokens$1 = ["YY", "YYYY"];
function isProtectedDayOfYearToken$1(r) {
  return protectedDayOfYearTokens$1.indexOf(r) !== -1;
}
function isProtectedWeekYearToken$1(r) {
  return protectedWeekYearTokens$1.indexOf(r) !== -1;
}
function throwProtectedError$1(r, a, s) {
  if (r === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(a, "`) for formatting years to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(a, "`) for formatting years to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(a, "`) for formatting days of the month to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(a, "`) for formatting days of the month to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var defaultLocale = { exports: {} }, enUS = { exports: {} }, formatDistance$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var s = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, c = function(h, p, m) {
    var g, v = s[h];
    return typeof v == "string" ? g = v : p === 1 ? g = v.one : g = v.other.replace("{{count}}", p.toString()), m != null && m.addSuffix ? m.comparison && m.comparison > 0 ? "in " + g : g + " ago" : g;
  }, u = c;
  a.default = u, r.exports = a.default;
})(formatDistance$1, formatDistance$1.exports);
var formatDistanceExports = formatDistance$1.exports, formatLong$1 = { exports: {} }, buildFormatLongFn$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c) {
    return function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = u.width ? String(u.width) : c.defaultWidth, h = c.formats[d] || c.formats[c.defaultWidth];
      return h;
    };
  }
  r.exports = a.default;
})(buildFormatLongFn$1, buildFormatLongFn$1.exports);
var buildFormatLongFnExports = buildFormatLongFn$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(buildFormatLongFnExports), u = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, d = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, h = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, p = {
    date: (0, c.default)({
      formats: u,
      defaultWidth: "full"
    }),
    time: (0, c.default)({
      formats: d,
      defaultWidth: "full"
    }),
    dateTime: (0, c.default)({
      formats: h,
      defaultWidth: "full"
    })
  }, m = p;
  a.default = m, r.exports = a.default;
})(formatLong$1, formatLong$1.exports);
var formatLongExports = formatLong$1.exports, formatRelative$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var s = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, c = function(h, p, m, g) {
    return s[h];
  }, u = c;
  a.default = u, r.exports = a.default;
})(formatRelative$1, formatRelative$1.exports);
var formatRelativeExports = formatRelative$1.exports, localize$1 = { exports: {} }, buildLocalizeFn$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c) {
    return function(u, d) {
      var h = d != null && d.context ? String(d.context) : "standalone", p;
      if (h === "formatting" && c.formattingValues) {
        var m = c.defaultFormattingWidth || c.defaultWidth, g = d != null && d.width ? String(d.width) : m;
        p = c.formattingValues[g] || c.formattingValues[m];
      } else {
        var v = c.defaultWidth, y = d != null && d.width ? String(d.width) : c.defaultWidth;
        p = c.values[y] || c.values[v];
      }
      var x = c.argumentCallback ? c.argumentCallback(u) : u;
      return p[x];
    };
  }
  r.exports = a.default;
})(buildLocalizeFn$1, buildLocalizeFn$1.exports);
var buildLocalizeFnExports = buildLocalizeFn$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(buildLocalizeFnExports), u = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, d = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, h = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, p = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, m = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, g = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, v = function(S, M) {
    var P = Number(S), L = P % 100;
    if (L > 20 || L < 10)
      switch (L % 10) {
        case 1:
          return P + "st";
        case 2:
          return P + "nd";
        case 3:
          return P + "rd";
      }
    return P + "th";
  }, y = {
    ordinalNumber: v,
    era: (0, c.default)({
      values: u,
      defaultWidth: "wide"
    }),
    quarter: (0, c.default)({
      values: d,
      defaultWidth: "wide",
      argumentCallback: function(S) {
        return S - 1;
      }
    }),
    month: (0, c.default)({
      values: h,
      defaultWidth: "wide"
    }),
    day: (0, c.default)({
      values: p,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, c.default)({
      values: m,
      defaultWidth: "wide",
      formattingValues: g,
      defaultFormattingWidth: "wide"
    })
  }, x = y;
  a.default = x, r.exports = a.default;
})(localize$1, localize$1.exports);
var localizeExports = localize$1.exports, match$1 = { exports: {} }, buildMatchFn$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(d) {
    return function(h) {
      var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, m = p.width, g = m && d.matchPatterns[m] || d.matchPatterns[d.defaultMatchWidth], v = h.match(g);
      if (!v)
        return null;
      var y = v[0], x = m && d.parsePatterns[m] || d.parsePatterns[d.defaultParseWidth], w = Array.isArray(x) ? u(x, function(P) {
        return P.test(y);
      }) : c(x, function(P) {
        return P.test(y);
      }), S;
      S = d.valueCallback ? d.valueCallback(w) : w, S = p.valueCallback ? p.valueCallback(S) : S;
      var M = h.slice(y.length);
      return {
        value: S,
        rest: M
      };
    };
  }
  function c(d, h) {
    for (var p in d)
      if (d.hasOwnProperty(p) && h(d[p]))
        return p;
  }
  function u(d, h) {
    for (var p = 0; p < d.length; p++)
      if (h(d[p]))
        return p;
  }
  r.exports = a.default;
})(buildMatchFn$1, buildMatchFn$1.exports);
var buildMatchFnExports = buildMatchFn$1.exports, buildMatchPatternFn$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c) {
    return function(u) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = u.match(c.matchPattern);
      if (!h) return null;
      var p = h[0], m = u.match(c.parsePattern);
      if (!m) return null;
      var g = c.valueCallback ? c.valueCallback(m[0]) : m[0];
      g = d.valueCallback ? d.valueCallback(g) : g;
      var v = u.slice(p.length);
      return {
        value: g,
        rest: v
      };
    };
  }
  r.exports = a.default;
})(buildMatchPatternFn$1, buildMatchPatternFn$1.exports);
var buildMatchPatternFnExports = buildMatchPatternFn$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(buildMatchFnExports), u = s(buildMatchPatternFnExports), d = /^(\d+)(th|st|nd|rd)?/i, h = /\d+/i, p = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, m = {
    any: [/^b/i, /^(a|c)/i]
  }, g = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, v = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, y = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, x = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, w = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, S = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, M = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, P = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, L = {
    ordinalNumber: (0, u.default)({
      matchPattern: d,
      parsePattern: h,
      valueCallback: function(E) {
        return parseInt(E, 10);
      }
    }),
    era: (0, c.default)({
      matchPatterns: p,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    quarter: (0, c.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any",
      valueCallback: function(E) {
        return E + 1;
      }
    }),
    month: (0, c.default)({
      matchPatterns: y,
      defaultMatchWidth: "wide",
      parsePatterns: x,
      defaultParseWidth: "any"
    }),
    day: (0, c.default)({
      matchPatterns: w,
      defaultMatchWidth: "wide",
      parsePatterns: S,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, c.default)({
      matchPatterns: M,
      defaultMatchWidth: "any",
      parsePatterns: P,
      defaultParseWidth: "any"
    })
  }, I = L;
  a.default = I, r.exports = a.default;
})(match$1, match$1.exports);
var matchExports = match$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(formatDistanceExports), u = s(formatLongExports), d = s(formatRelativeExports), h = s(localizeExports), p = s(matchExports), m = {
    code: "en-US",
    formatDistance: c.default,
    formatLong: u.default,
    formatRelative: d.default,
    localize: h.default,
    match: p.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, g = m;
  a.default = g, r.exports = a.default;
})(enUS, enUS.exports);
var enUSExports = enUS.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  var c = s(enUSExports), u = c.default;
  a.default = u, r.exports = a.default;
})(defaultLocale, defaultLocale.exports);
var defaultLocaleExports = defaultLocale.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = T;
  var c = s(isValidExports), u = s(subMillisecondsExports), d = s(toDateExports), h = s(formattersExports), p = s(longFormattersExports), m = s(getTimezoneOffsetInMillisecondsExports), g = protectedTokens, v = s(toIntegerExports), y = s(requiredArgsExports), x = defaultOptions$4, w = s(defaultLocaleExports), S = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, M = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, P = /^'([^]*?)'?$/, L = /''/g, I = /[a-zA-Z]/;
  function T(R, A, k) {
    var V, B, q, z, Z, G, K, U, F, N, D, j, H, W, re, ae, ee, X;
    (0, y.default)(2, arguments);
    var J = String(A), ie = (0, x.getDefaultOptions)(), oe = (V = (B = k == null ? void 0 : k.locale) !== null && B !== void 0 ? B : ie.locale) !== null && V !== void 0 ? V : w.default, fe = (0, v.default)((q = (z = (Z = (G = k == null ? void 0 : k.firstWeekContainsDate) !== null && G !== void 0 ? G : k == null || (K = k.locale) === null || K === void 0 || (U = K.options) === null || U === void 0 ? void 0 : U.firstWeekContainsDate) !== null && Z !== void 0 ? Z : ie.firstWeekContainsDate) !== null && z !== void 0 ? z : (F = ie.locale) === null || F === void 0 || (N = F.options) === null || N === void 0 ? void 0 : N.firstWeekContainsDate) !== null && q !== void 0 ? q : 1);
    if (!(fe >= 1 && fe <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ve = (0, v.default)((D = (j = (H = (W = k == null ? void 0 : k.weekStartsOn) !== null && W !== void 0 ? W : k == null || (re = k.locale) === null || re === void 0 || (ae = re.options) === null || ae === void 0 ? void 0 : ae.weekStartsOn) !== null && H !== void 0 ? H : ie.weekStartsOn) !== null && j !== void 0 ? j : (ee = ie.locale) === null || ee === void 0 || (X = ee.options) === null || X === void 0 ? void 0 : X.weekStartsOn) !== null && D !== void 0 ? D : 0);
    if (!(ve >= 0 && ve <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!oe.localize)
      throw new RangeError("locale must contain localize property");
    if (!oe.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var ue = (0, d.default)(R);
    if (!(0, c.default)(ue))
      throw new RangeError("Invalid time value");
    var pe = (0, m.default)(ue), we = (0, u.default)(ue, pe), ye = {
      firstWeekContainsDate: fe,
      weekStartsOn: ve,
      locale: oe,
      _originalDate: ue
    }, Ie = J.match(M).map(function(Ee) {
      var ne = Ee[0];
      if (ne === "p" || ne === "P") {
        var se = p.default[ne];
        return se(Ee, oe.formatLong);
      }
      return Ee;
    }).join("").match(S).map(function(Ee) {
      if (Ee === "''")
        return "'";
      var ne = Ee[0];
      if (ne === "'")
        return E(Ee);
      var se = h.default[ne];
      if (se)
        return !(k != null && k.useAdditionalWeekYearTokens) && (0, g.isProtectedWeekYearToken)(Ee) && (0, g.throwProtectedError)(Ee, A, String(R)), !(k != null && k.useAdditionalDayOfYearTokens) && (0, g.isProtectedDayOfYearToken)(Ee) && (0, g.throwProtectedError)(Ee, A, String(R)), se(we, Ee, oe.localize, ye);
      if (ne.match(I))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + ne + "`");
      return Ee;
    }).join("");
    return Ie;
  }
  function E(R) {
    var A = R.match(P);
    return A ? A[1].replace(L, "'") : R;
  }
  r.exports = a.default;
})(format$2, format$2.exports);
var formatExports = format$2.exports;
const dateFnsFormat = /* @__PURE__ */ getDefaultExportFromCjs(formatExports);
function tzIntlTimeZoneName(r, a, s) {
  var c = getDTF(r, s.timeZone, s.locale);
  return c.formatToParts ? partsTimeZone(c, a) : hackyTimeZone(c, a);
}
function partsTimeZone(r, a) {
  for (var s = r.formatToParts(a), c = s.length - 1; c >= 0; --c)
    if (s[c].type === "timeZoneName")
      return s[c].value;
}
function hackyTimeZone(r, a) {
  var s = r.format(a).replace(/\u200E/g, ""), c = / [\w-+ ]+$/.exec(s);
  return c ? c[0].substr(1) : "";
}
function getDTF(r, a, s) {
  if (s && !s.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(s ? [s.code, "en-US"] : void 0, {
    timeZone: a,
    timeZoneName: r
  });
}
function tzTokenizeDate(r, a) {
  var s = getDateTimeFormat(a);
  return s.formatToParts ? partsOffset(s, r) : hackyOffset(s, r);
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function partsOffset(r, a) {
  try {
    for (var s = r.formatToParts(a), c = [], u = 0; u < s.length; u++) {
      var d = typeToPos[s[u].type];
      d >= 0 && (c[d] = parseInt(s[u].value, 10));
    }
    return c;
  } catch (h) {
    if (h instanceof RangeError)
      return [NaN];
    throw h;
  }
}
function hackyOffset(r, a) {
  var s = r.format(a), c = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(s);
  return [c[3], c[1], c[2], c[4], c[5], c[6]];
}
var dtfCache = {};
function getDateTimeFormat(r) {
  if (!dtfCache[r]) {
    var a = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), s = a === "06/25/2014, 00:00:00" || a === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    dtfCache[r] = s ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: r,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: r,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return dtfCache[r];
}
function newDateUTC(r, a, s, c, u, d, h) {
  var p = /* @__PURE__ */ new Date(0);
  return p.setUTCFullYear(r, a, s), p.setUTCHours(c, u, d, h), p;
}
var MILLISECONDS_IN_HOUR$1 = 36e5, MILLISECONDS_IN_MINUTE$2 = 6e4, patterns$2 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(r, a, s) {
  var c, u;
  if (!r || (c = patterns$2.timezoneZ.exec(r), c))
    return 0;
  var d;
  if (c = patterns$2.timezoneHH.exec(r), c)
    return d = parseInt(c[1], 10), validateTimezone$1(d) ? -(d * MILLISECONDS_IN_HOUR$1) : NaN;
  if (c = patterns$2.timezoneHHMM.exec(r), c) {
    d = parseInt(c[2], 10);
    var h = parseInt(c[3], 10);
    return validateTimezone$1(d, h) ? (u = Math.abs(d) * MILLISECONDS_IN_HOUR$1 + h * MILLISECONDS_IN_MINUTE$2, c[1] === "+" ? -u : u) : NaN;
  }
  if (isValidTimezoneIANAString(r)) {
    a = new Date(a || Date.now());
    var p = s ? a : toUtcDate(a), m = calcOffset(p, r), g = s ? m : fixOffset(a, m, r);
    return -g;
  }
  return NaN;
}
function toUtcDate(r) {
  return newDateUTC(
    r.getFullYear(),
    r.getMonth(),
    r.getDate(),
    r.getHours(),
    r.getMinutes(),
    r.getSeconds(),
    r.getMilliseconds()
  );
}
function calcOffset(r, a) {
  var s = tzTokenizeDate(r, a), c = newDateUTC(
    s[0],
    s[1] - 1,
    s[2],
    s[3] % 24,
    s[4],
    s[5],
    0
  ).getTime(), u = r.getTime(), d = u % 1e3;
  return u -= d >= 0 ? d : 1e3 + d, c - u;
}
function fixOffset(r, a, s) {
  var c = r.getTime(), u = c - a, d = calcOffset(new Date(u), s);
  if (a === d)
    return a;
  u -= d - a;
  var h = calcOffset(new Date(u), s);
  return d === h ? d : Math.max(d, h);
}
function validateTimezone$1(r, a) {
  return -23 <= r && r <= 23 && (a == null || 0 <= a && a <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(r) {
  if (validIANATimezoneCache[r]) return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: r }), validIANATimezoneCache[r] = !0, !0;
  } catch {
    return !1;
  }
}
var MILLISECONDS_IN_MINUTE$1 = 60 * 1e3, formatters$2 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, a, s, c) {
    var u = getTimeZoneOffset(c.timeZone, r);
    if (u === 0)
      return "Z";
    switch (a) {
      case "X":
        return formatTimezoneWithOptionalMinutes$1(u);
      case "XXXX":
      case "XX":
        return formatTimezone$1(u);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone$1(u, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, a, s, c) {
    var u = getTimeZoneOffset(c.timeZone, r);
    switch (a) {
      case "x":
        return formatTimezoneWithOptionalMinutes$1(u);
      case "xxxx":
      case "xx":
        return formatTimezone$1(u);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone$1(u, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, a, s, c) {
    var u = getTimeZoneOffset(c.timeZone, r);
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort$1(u, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(u, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, a, s, c) {
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return tzIntlTimeZoneName("short", r, c);
      case "zzzz":
      default:
        return tzIntlTimeZoneName("long", r, c);
    }
  }
};
function getTimeZoneOffset(r, a) {
  var s = r ? tzParseTimezone(r, a, !0) / MILLISECONDS_IN_MINUTE$1 : a.getTimezoneOffset();
  if (Number.isNaN(s))
    throw new RangeError("Invalid time zone specified: " + r);
  return s;
}
function addLeadingZeros$1(r, a) {
  for (var s = r < 0 ? "-" : "", c = Math.abs(r).toString(); c.length < a; )
    c = "0" + c;
  return s + c;
}
function formatTimezone$1(r, a) {
  var s = a || "", c = r > 0 ? "-" : "+", u = Math.abs(r), d = addLeadingZeros$1(Math.floor(u / 60), 2), h = addLeadingZeros$1(Math.floor(u % 60), 2);
  return c + d + s + h;
}
function formatTimezoneWithOptionalMinutes$1(r, a) {
  if (r % 60 === 0) {
    var s = r > 0 ? "-" : "+";
    return s + addLeadingZeros$1(Math.abs(r) / 60, 2);
  }
  return formatTimezone$1(r, a);
}
function formatTimezoneShort$1(r, a) {
  var s = r > 0 ? "-" : "+", c = Math.abs(r), u = Math.floor(c / 60), d = c % 60;
  if (d === 0)
    return s + String(u);
  var h = a;
  return s + String(u) + h + addLeadingZeros$1(d, 2);
}
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, MILLISECONDS_IN_HOUR = 36e5, MILLISECONDS_IN_MINUTE = 6e4, DEFAULT_ADDITIONAL_DIGITS = 2, patterns$1 = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: tzPattern
};
function toDate$1(r, a) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  var s = a || {}, c = s.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger$1(s.additionalDigits);
  if (c !== 2 && c !== 1 && c !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]")
    return new Date(r.getTime());
  if (typeof r == "number" || Object.prototype.toString.call(r) === "[object Number]")
    return new Date(r);
  if (!(typeof r == "string" || Object.prototype.toString.call(r) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var u = splitDateString$1(r), d = parseYear$1(u.date, c), h = d.year, p = d.restDateString, m = parseDate$1(p, h);
  if (isNaN(m))
    return /* @__PURE__ */ new Date(NaN);
  if (m) {
    var g = m.getTime(), v = 0, y;
    if (u.time && (v = parseTime$1(u.time), isNaN(v)))
      return /* @__PURE__ */ new Date(NaN);
    if (u.timeZone || s.timeZone) {
      if (y = tzParseTimezone(u.timeZone || s.timeZone, new Date(g + v)), isNaN(y))
        return /* @__PURE__ */ new Date(NaN);
    } else
      y = getTimezoneOffsetInMilliseconds$1(new Date(g + v)), y = getTimezoneOffsetInMilliseconds$1(new Date(g + v + y));
    return new Date(g + v + y);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function splitDateString$1(r) {
  var a = {}, s = patterns$1.dateTimePattern.exec(r), c;
  if (s ? (a.date = s[1], c = s[3]) : (s = patterns$1.datePattern.exec(r), s ? (a.date = s[1], c = s[2]) : (a.date = null, c = r)), c) {
    var u = patterns$1.timeZone.exec(c);
    u ? (a.time = c.replace(u[1], ""), a.timeZone = u[1].trim()) : a.time = c;
  }
  return a;
}
function parseYear$1(r, a) {
  var s = patterns$1.YYY[a], c = patterns$1.YYYYY[a], u;
  if (u = patterns$1.YYYY.exec(r) || c.exec(r), u) {
    var d = u[1];
    return {
      year: parseInt(d, 10),
      restDateString: r.slice(d.length)
    };
  }
  if (u = patterns$1.YY.exec(r) || s.exec(r), u) {
    var h = u[1];
    return {
      year: parseInt(h, 10) * 100,
      restDateString: r.slice(h.length)
    };
  }
  return {
    year: null
  };
}
function parseDate$1(r, a) {
  if (a === null)
    return null;
  var s, c, u, d;
  if (r.length === 0)
    return c = /* @__PURE__ */ new Date(0), c.setUTCFullYear(a), c;
  if (s = patterns$1.MM.exec(r), s)
    return c = /* @__PURE__ */ new Date(0), u = parseInt(s[1], 10) - 1, validateDate$1(a, u) ? (c.setUTCFullYear(a, u), c) : /* @__PURE__ */ new Date(NaN);
  if (s = patterns$1.DDD.exec(r), s) {
    c = /* @__PURE__ */ new Date(0);
    var h = parseInt(s[1], 10);
    return validateDayOfYearDate$1(a, h) ? (c.setUTCFullYear(a, 0, h), c) : /* @__PURE__ */ new Date(NaN);
  }
  if (s = patterns$1.MMDD.exec(r), s) {
    c = /* @__PURE__ */ new Date(0), u = parseInt(s[1], 10) - 1;
    var p = parseInt(s[2], 10);
    return validateDate$1(a, u, p) ? (c.setUTCFullYear(a, u, p), c) : /* @__PURE__ */ new Date(NaN);
  }
  if (s = patterns$1.Www.exec(r), s)
    return d = parseInt(s[1], 10) - 1, validateWeekDate$1(a, d) ? dayOfISOWeekYear$1(a, d) : /* @__PURE__ */ new Date(NaN);
  if (s = patterns$1.WwwD.exec(r), s) {
    d = parseInt(s[1], 10) - 1;
    var m = parseInt(s[2], 10) - 1;
    return validateWeekDate$1(a, d, m) ? dayOfISOWeekYear$1(a, d, m) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function parseTime$1(r) {
  var a, s, c;
  if (a = patterns$1.HH.exec(r), a)
    return s = parseFloat(a[1].replace(",", ".")), validateTime$1(s) ? s % 24 * MILLISECONDS_IN_HOUR : NaN;
  if (a = patterns$1.HHMM.exec(r), a)
    return s = parseInt(a[1], 10), c = parseFloat(a[2].replace(",", ".")), validateTime$1(s, c) ? s % 24 * MILLISECONDS_IN_HOUR + c * MILLISECONDS_IN_MINUTE : NaN;
  if (a = patterns$1.HHMMSS.exec(r), a) {
    s = parseInt(a[1], 10), c = parseInt(a[2], 10);
    var u = parseFloat(a[3].replace(",", "."));
    return validateTime$1(s, c, u) ? s % 24 * MILLISECONDS_IN_HOUR + c * MILLISECONDS_IN_MINUTE + u * 1e3 : NaN;
  }
  return null;
}
function dayOfISOWeekYear$1(r, a, s) {
  a = a || 0, s = s || 0;
  var c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(r, 0, 4);
  var u = c.getUTCDay() || 7, d = a * 7 + s + 1 - u;
  return c.setUTCDate(c.getUTCDate() + d), c;
}
var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$2(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function validateDate$1(r, a, s) {
  if (a < 0 || a > 11)
    return !1;
  if (s != null) {
    if (s < 1)
      return !1;
    var c = isLeapYearIndex$2(r);
    if (c && s > DAYS_IN_MONTH_LEAP_YEAR$1[a] || !c && s > DAYS_IN_MONTH$1[a])
      return !1;
  }
  return !0;
}
function validateDayOfYearDate$1(r, a) {
  if (a < 1)
    return !1;
  var s = isLeapYearIndex$2(r);
  return !(s && a > 366 || !s && a > 365);
}
function validateWeekDate$1(r, a, s) {
  return !(a < 0 || a > 52 || s != null && (s < 0 || s > 6));
}
function validateTime$1(r, a, s) {
  return !(r != null && (r < 0 || r >= 25) || a != null && (a < 0 || a >= 60) || s != null && (s < 0 || s >= 60));
}
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format$1(r, a, s) {
  var c = String(a), u = s || {}, d = c.match(tzFormattingTokensRegExp);
  if (d) {
    var h = toDate$1(u.originalDate || r, u);
    c = d.reduce(function(p, m) {
      if (m[0] === "'")
        return p;
      var g = p.indexOf(m), v = p[g - 1] === "'", y = p.replace(
        m,
        "'" + formatters$2[m[0]](h, m, null, u) + "'"
      );
      return v ? y.substring(0, g - 1) + y.substring(g + 1) : y;
    }, c);
  }
  return dateFnsFormat(r, c, u);
}
var cloneObject$2 = { exports: {} }, assign$1 = { exports: {} };
(function(r, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = s;
  function s(c, u) {
    if (c == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var d in u)
      Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
    return c;
  }
  r.exports = a.default;
})(assign$1, assign$1.exports);
var assignExports = assign$1.exports;
(function(r, a) {
  var s = interopRequireDefaultExports.default;
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = u;
  var c = s(assignExports);
  function u(d) {
    return (0, c.default)({}, d);
  }
  r.exports = a.default;
})(cloneObject$2, cloneObject$2.exports);
var cloneObjectExports = cloneObject$2.exports;
const cloneObject$1 = /* @__PURE__ */ getDefaultExportFromCjs(cloneObjectExports);
function utcToZonedTime(r, a, s) {
  var c = toDate$1(r, s), u = tzParseTimezone(a, c, !0), d = new Date(c.getTime() - u), h = /* @__PURE__ */ new Date(0);
  return h.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), h.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), h;
}
function formatInTimeZone(r, a, s, c) {
  var u = cloneObject$1(c);
  return u.timeZone = a, u.originalDate = r, format$1(utcToZonedTime(r, a), s, u);
}
function zonedTimeToUtc(r, a, s) {
  if (typeof r == "string" && !r.match(tzPattern)) {
    var c = cloneObject$1(s);
    return c.timeZone = a, toDate$1(r, c);
  }
  var u = toDate$1(r, s), d = newDateUTC(
    u.getFullYear(),
    u.getMonth(),
    u.getDate(),
    u.getHours(),
    u.getMinutes(),
    u.getSeconds(),
    u.getMilliseconds()
  ).getTime(), h = tzParseTimezone(a, new Date(d));
  return new Date(d + h);
}
function _typeof(r) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(r);
}
function toInteger(r) {
  if (r === null || r === !0 || r === !1)
    return NaN;
  var a = Number(r);
  return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
}
function requiredArgs(r, a) {
  if (a.length < r)
    throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + a.length + " present");
}
function toDate(r) {
  requiredArgs(1, arguments);
  var a = Object.prototype.toString.call(r);
  return r instanceof Date || _typeof(r) === "object" && a === "[object Date]" ? new Date(r.getTime()) : typeof r == "number" || a === "[object Number]" ? new Date(r) : ((typeof r == "string" || a === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function addDays(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toInteger(a);
  return isNaN(c) ? /* @__PURE__ */ new Date(NaN) : (c && s.setDate(s.getDate() + c), s);
}
function addMonths(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toInteger(a);
  if (isNaN(c))
    return /* @__PURE__ */ new Date(NaN);
  if (!c)
    return s;
  var u = s.getDate(), d = new Date(s.getTime());
  d.setMonth(s.getMonth() + c + 1, 0);
  var h = d.getDate();
  return u >= h ? d : (s.setFullYear(d.getFullYear(), d.getMonth(), u), s);
}
function addMilliseconds(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r).getTime(), c = toInteger(a);
  return new Date(s + c);
}
var defaultOptions$2 = {};
function getDefaultOptions() {
  return defaultOptions$2;
}
function startOfWeek(r, a) {
  var s, c, u, d, h, p, m, g;
  requiredArgs(1, arguments);
  var v = getDefaultOptions(), y = toInteger((s = (c = (u = (d = a == null ? void 0 : a.weekStartsOn) !== null && d !== void 0 ? d : a == null || (h = a.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && u !== void 0 ? u : v.weekStartsOn) !== null && c !== void 0 ? c : (m = v.locale) === null || m === void 0 || (g = m.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && s !== void 0 ? s : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var x = toDate(r), w = x.getDay(), S = (w < y ? 7 : 0) + w - y;
  return x.setDate(x.getDate() - S), x.setHours(0, 0, 0, 0), x;
}
function getTimezoneOffsetInMilliseconds(r) {
  var a = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
  return a.setUTCFullYear(r.getFullYear()), r.getTime() - a.getTime();
}
function startOfDay(r) {
  requiredArgs(1, arguments);
  var a = toDate(r);
  return a.setHours(0, 0, 0, 0), a;
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(r, a) {
  requiredArgs(2, arguments);
  var s = startOfDay(r), c = startOfDay(a), u = s.getTime() - getTimezoneOffsetInMilliseconds(s), d = c.getTime() - getTimezoneOffsetInMilliseconds(c);
  return Math.round((u - d) / MILLISECONDS_IN_DAY$1);
}
function addYears(r, a) {
  requiredArgs(2, arguments);
  var s = toInteger(a);
  return addMonths(r, s * 12);
}
var millisecondsInMinute = 6e4, millisecondsInHour = 36e5, millisecondsInSecond = 1e3;
function isSameDay(r, a) {
  requiredArgs(2, arguments);
  var s = startOfDay(r), c = startOfDay(a);
  return s.getTime() === c.getTime();
}
function isDate(r) {
  return requiredArgs(1, arguments), r instanceof Date || _typeof(r) === "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function isValid(r) {
  if (requiredArgs(1, arguments), !isDate(r) && typeof r != "number")
    return !1;
  var a = toDate(r);
  return !isNaN(Number(a));
}
var MILLISECONDS_IN_WEEK$3 = 6048e5;
function differenceInCalendarWeeks(r, a, s) {
  requiredArgs(2, arguments);
  var c = startOfWeek(r, s), u = startOfWeek(a, s), d = c.getTime() - getTimezoneOffsetInMilliseconds(c), h = u.getTime() - getTimezoneOffsetInMilliseconds(u);
  return Math.round((d - h) / MILLISECONDS_IN_WEEK$3);
}
function eachMonthOfInterval(r) {
  requiredArgs(1, arguments);
  var a = r || {}, s = toDate(a.start), c = toDate(a.end), u = c.getTime(), d = [];
  if (!(s.getTime() <= u))
    throw new RangeError("Invalid interval");
  var h = s;
  for (h.setHours(0, 0, 0, 0), h.setDate(1); h.getTime() <= u; )
    d.push(toDate(h)), h.setMonth(h.getMonth() + 1);
  return d;
}
function startOfMonth(r) {
  requiredArgs(1, arguments);
  var a = toDate(r);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function subMilliseconds(r, a) {
  requiredArgs(2, arguments);
  var s = toInteger(a);
  return addMilliseconds(r, -s);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getTime();
  a.setUTCMonth(0, 1), a.setUTCHours(0, 0, 0, 0);
  var c = a.getTime(), u = s - c;
  return Math.floor(u / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(r) {
  requiredArgs(1, arguments);
  var a = 1, s = toDate(r), c = s.getUTCDay(), u = (c < a ? 7 : 0) + c - a;
  return s.setUTCDate(s.getUTCDate() - u), s.setUTCHours(0, 0, 0, 0), s;
}
function getUTCISOWeekYear(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getUTCFullYear(), c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(s + 1, 0, 4), c.setUTCHours(0, 0, 0, 0);
  var u = startOfUTCISOWeek(c), d = /* @__PURE__ */ new Date(0);
  d.setUTCFullYear(s, 0, 4), d.setUTCHours(0, 0, 0, 0);
  var h = startOfUTCISOWeek(d);
  return a.getTime() >= u.getTime() ? s + 1 : a.getTime() >= h.getTime() ? s : s - 1;
}
function startOfUTCISOWeekYear(r) {
  requiredArgs(1, arguments);
  var a = getUTCISOWeekYear(r), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(a, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var c = startOfUTCISOWeek(s);
  return c;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCISOWeek(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = startOfUTCISOWeek(a).getTime() - startOfUTCISOWeekYear(a).getTime();
  return Math.round(s / MILLISECONDS_IN_WEEK$2) + 1;
}
function startOfUTCWeek(r, a) {
  var s, c, u, d, h, p, m, g;
  requiredArgs(1, arguments);
  var v = getDefaultOptions(), y = toInteger((s = (c = (u = (d = a == null ? void 0 : a.weekStartsOn) !== null && d !== void 0 ? d : a == null || (h = a.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && u !== void 0 ? u : v.weekStartsOn) !== null && c !== void 0 ? c : (m = v.locale) === null || m === void 0 || (g = m.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && s !== void 0 ? s : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var x = toDate(r), w = x.getUTCDay(), S = (w < y ? 7 : 0) + w - y;
  return x.setUTCDate(x.getUTCDate() - S), x.setUTCHours(0, 0, 0, 0), x;
}
function getUTCWeekYear(r, a) {
  var s, c, u, d, h, p, m, g;
  requiredArgs(1, arguments);
  var v = toDate(r), y = v.getUTCFullYear(), x = getDefaultOptions(), w = toInteger((s = (c = (u = (d = a == null ? void 0 : a.firstWeekContainsDate) !== null && d !== void 0 ? d : a == null || (h = a.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && u !== void 0 ? u : x.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = x.locale) === null || m === void 0 || (g = m.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(w >= 1 && w <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(y + 1, 0, w), S.setUTCHours(0, 0, 0, 0);
  var M = startOfUTCWeek(S, a), P = /* @__PURE__ */ new Date(0);
  P.setUTCFullYear(y, 0, w), P.setUTCHours(0, 0, 0, 0);
  var L = startOfUTCWeek(P, a);
  return v.getTime() >= M.getTime() ? y + 1 : v.getTime() >= L.getTime() ? y : y - 1;
}
function startOfUTCWeekYear(r, a) {
  var s, c, u, d, h, p, m, g;
  requiredArgs(1, arguments);
  var v = getDefaultOptions(), y = toInteger((s = (c = (u = (d = a == null ? void 0 : a.firstWeekContainsDate) !== null && d !== void 0 ? d : a == null || (h = a.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && u !== void 0 ? u : v.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = v.locale) === null || m === void 0 || (g = m.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && s !== void 0 ? s : 1), x = getUTCWeekYear(r, a), w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(x, 0, y), w.setUTCHours(0, 0, 0, 0);
  var S = startOfUTCWeek(w, a);
  return S;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCWeek(r, a) {
  requiredArgs(1, arguments);
  var s = toDate(r), c = startOfUTCWeek(s, a).getTime() - startOfUTCWeekYear(s, a).getTime();
  return Math.round(c / MILLISECONDS_IN_WEEK$1) + 1;
}
function addLeadingZeros(r, a) {
  for (var s = r < 0 ? "-" : "", c = Math.abs(r).toString(); c.length < a; )
    c = "0" + c;
  return s + c;
}
var formatters$1 = {
  // Year
  y: function(a, s) {
    var c = a.getUTCFullYear(), u = c > 0 ? c : 1 - c;
    return addLeadingZeros(s === "yy" ? u % 100 : u, s.length);
  },
  // Month
  M: function(a, s) {
    var c = a.getUTCMonth();
    return s === "M" ? String(c + 1) : addLeadingZeros(c + 1, 2);
  },
  // Day of the month
  d: function(a, s) {
    return addLeadingZeros(a.getUTCDate(), s.length);
  },
  // AM or PM
  a: function(a, s) {
    var c = a.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (s) {
      case "a":
      case "aa":
        return c.toUpperCase();
      case "aaa":
        return c;
      case "aaaaa":
        return c[0];
      case "aaaa":
      default:
        return c === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(a, s) {
    return addLeadingZeros(a.getUTCHours() % 12 || 12, s.length);
  },
  // Hour [0-23]
  H: function(a, s) {
    return addLeadingZeros(a.getUTCHours(), s.length);
  },
  // Minute
  m: function(a, s) {
    return addLeadingZeros(a.getUTCMinutes(), s.length);
  },
  // Second
  s: function(a, s) {
    return addLeadingZeros(a.getUTCSeconds(), s.length);
  },
  // Fraction of second
  S: function(a, s) {
    var c = s.length, u = a.getUTCMilliseconds(), d = Math.floor(u * Math.pow(10, c - 3));
    return addLeadingZeros(d, s.length);
  }
}, dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, formatters = {
  // Era
  G: function(a, s, c) {
    var u = a.getUTCFullYear() > 0 ? 1 : 0;
    switch (s) {
      case "G":
      case "GG":
      case "GGG":
        return c.era(u, {
          width: "abbreviated"
        });
      case "GGGGG":
        return c.era(u, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return c.era(u, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(a, s, c) {
    if (s === "yo") {
      var u = a.getUTCFullYear(), d = u > 0 ? u : 1 - u;
      return c.ordinalNumber(d, {
        unit: "year"
      });
    }
    return formatters$1.y(a, s);
  },
  // Local week-numbering year
  Y: function(a, s, c, u) {
    var d = getUTCWeekYear(a, u), h = d > 0 ? d : 1 - d;
    if (s === "YY") {
      var p = h % 100;
      return addLeadingZeros(p, 2);
    }
    return s === "Yo" ? c.ordinalNumber(h, {
      unit: "year"
    }) : addLeadingZeros(h, s.length);
  },
  // ISO week-numbering year
  R: function(a, s) {
    var c = getUTCISOWeekYear(a);
    return addLeadingZeros(c, s.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(a, s) {
    var c = a.getUTCFullYear();
    return addLeadingZeros(c, s.length);
  },
  // Quarter
  Q: function(a, s, c) {
    var u = Math.ceil((a.getUTCMonth() + 1) / 3);
    switch (s) {
      case "Q":
        return String(u);
      case "QQ":
        return addLeadingZeros(u, 2);
      case "Qo":
        return c.ordinalNumber(u, {
          unit: "quarter"
        });
      case "QQQ":
        return c.quarter(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return c.quarter(u, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return c.quarter(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(a, s, c) {
    var u = Math.ceil((a.getUTCMonth() + 1) / 3);
    switch (s) {
      case "q":
        return String(u);
      case "qq":
        return addLeadingZeros(u, 2);
      case "qo":
        return c.ordinalNumber(u, {
          unit: "quarter"
        });
      case "qqq":
        return c.quarter(u, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return c.quarter(u, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return c.quarter(u, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(a, s, c) {
    var u = a.getUTCMonth();
    switch (s) {
      case "M":
      case "MM":
        return formatters$1.M(a, s);
      case "Mo":
        return c.ordinalNumber(u + 1, {
          unit: "month"
        });
      case "MMM":
        return c.month(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return c.month(u, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return c.month(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(a, s, c) {
    var u = a.getUTCMonth();
    switch (s) {
      case "L":
        return String(u + 1);
      case "LL":
        return addLeadingZeros(u + 1, 2);
      case "Lo":
        return c.ordinalNumber(u + 1, {
          unit: "month"
        });
      case "LLL":
        return c.month(u, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return c.month(u, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return c.month(u, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(a, s, c, u) {
    var d = getUTCWeek(a, u);
    return s === "wo" ? c.ordinalNumber(d, {
      unit: "week"
    }) : addLeadingZeros(d, s.length);
  },
  // ISO week of year
  I: function(a, s, c) {
    var u = getUTCISOWeek(a);
    return s === "Io" ? c.ordinalNumber(u, {
      unit: "week"
    }) : addLeadingZeros(u, s.length);
  },
  // Day of the month
  d: function(a, s, c) {
    return s === "do" ? c.ordinalNumber(a.getUTCDate(), {
      unit: "date"
    }) : formatters$1.d(a, s);
  },
  // Day of year
  D: function(a, s, c) {
    var u = getUTCDayOfYear(a);
    return s === "Do" ? c.ordinalNumber(u, {
      unit: "dayOfYear"
    }) : addLeadingZeros(u, s.length);
  },
  // Day of week
  E: function(a, s, c) {
    var u = a.getUTCDay();
    switch (s) {
      case "E":
      case "EE":
      case "EEE":
        return c.day(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return c.day(u, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return c.day(u, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return c.day(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(a, s, c, u) {
    var d = a.getUTCDay(), h = (d - u.weekStartsOn + 8) % 7 || 7;
    switch (s) {
      case "e":
        return String(h);
      case "ee":
        return addLeadingZeros(h, 2);
      case "eo":
        return c.ordinalNumber(h, {
          unit: "day"
        });
      case "eee":
        return c.day(d, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return c.day(d, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return c.day(d, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return c.day(d, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(a, s, c, u) {
    var d = a.getUTCDay(), h = (d - u.weekStartsOn + 8) % 7 || 7;
    switch (s) {
      case "c":
        return String(h);
      case "cc":
        return addLeadingZeros(h, s.length);
      case "co":
        return c.ordinalNumber(h, {
          unit: "day"
        });
      case "ccc":
        return c.day(d, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return c.day(d, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return c.day(d, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return c.day(d, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(a, s, c) {
    var u = a.getUTCDay(), d = u === 0 ? 7 : u;
    switch (s) {
      case "i":
        return String(d);
      case "ii":
        return addLeadingZeros(d, s.length);
      case "io":
        return c.ordinalNumber(d, {
          unit: "day"
        });
      case "iii":
        return c.day(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return c.day(u, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return c.day(u, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return c.day(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(a, s, c) {
    var u = a.getUTCHours(), d = u / 12 >= 1 ? "pm" : "am";
    switch (s) {
      case "a":
      case "aa":
        return c.dayPeriod(d, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return c.dayPeriod(d, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return c.dayPeriod(d, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return c.dayPeriod(d, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(a, s, c) {
    var u = a.getUTCHours(), d;
    switch (u === 12 ? d = dayPeriodEnum.noon : u === 0 ? d = dayPeriodEnum.midnight : d = u / 12 >= 1 ? "pm" : "am", s) {
      case "b":
      case "bb":
        return c.dayPeriod(d, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return c.dayPeriod(d, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return c.dayPeriod(d, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return c.dayPeriod(d, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(a, s, c) {
    var u = a.getUTCHours(), d;
    switch (u >= 17 ? d = dayPeriodEnum.evening : u >= 12 ? d = dayPeriodEnum.afternoon : u >= 4 ? d = dayPeriodEnum.morning : d = dayPeriodEnum.night, s) {
      case "B":
      case "BB":
      case "BBB":
        return c.dayPeriod(d, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return c.dayPeriod(d, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return c.dayPeriod(d, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(a, s, c) {
    if (s === "ho") {
      var u = a.getUTCHours() % 12;
      return u === 0 && (u = 12), c.ordinalNumber(u, {
        unit: "hour"
      });
    }
    return formatters$1.h(a, s);
  },
  // Hour [0-23]
  H: function(a, s, c) {
    return s === "Ho" ? c.ordinalNumber(a.getUTCHours(), {
      unit: "hour"
    }) : formatters$1.H(a, s);
  },
  // Hour [0-11]
  K: function(a, s, c) {
    var u = a.getUTCHours() % 12;
    return s === "Ko" ? c.ordinalNumber(u, {
      unit: "hour"
    }) : addLeadingZeros(u, s.length);
  },
  // Hour [1-24]
  k: function(a, s, c) {
    var u = a.getUTCHours();
    return u === 0 && (u = 24), s === "ko" ? c.ordinalNumber(u, {
      unit: "hour"
    }) : addLeadingZeros(u, s.length);
  },
  // Minute
  m: function(a, s, c) {
    return s === "mo" ? c.ordinalNumber(a.getUTCMinutes(), {
      unit: "minute"
    }) : formatters$1.m(a, s);
  },
  // Second
  s: function(a, s, c) {
    return s === "so" ? c.ordinalNumber(a.getUTCSeconds(), {
      unit: "second"
    }) : formatters$1.s(a, s);
  },
  // Fraction of second
  S: function(a, s) {
    return formatters$1.S(a, s);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(a, s, c, u) {
    var d = u._originalDate || a, h = d.getTimezoneOffset();
    if (h === 0)
      return "Z";
    switch (s) {
      case "X":
        return formatTimezoneWithOptionalMinutes(h);
      case "XXXX":
      case "XX":
        return formatTimezone(h);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(h, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(a, s, c, u) {
    var d = u._originalDate || a, h = d.getTimezoneOffset();
    switch (s) {
      case "x":
        return formatTimezoneWithOptionalMinutes(h);
      case "xxxx":
      case "xx":
        return formatTimezone(h);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(h, ":");
    }
  },
  // Timezone (GMT)
  O: function(a, s, c, u) {
    var d = u._originalDate || a, h = d.getTimezoneOffset();
    switch (s) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(h, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(h, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(a, s, c, u) {
    var d = u._originalDate || a, h = d.getTimezoneOffset();
    switch (s) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(h, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(h, ":");
    }
  },
  // Seconds timestamp
  t: function(a, s, c, u) {
    var d = u._originalDate || a, h = Math.floor(d.getTime() / 1e3);
    return addLeadingZeros(h, s.length);
  },
  // Milliseconds timestamp
  T: function(a, s, c, u) {
    var d = u._originalDate || a, h = d.getTime();
    return addLeadingZeros(h, s.length);
  }
};
function formatTimezoneShort(r, a) {
  var s = r > 0 ? "-" : "+", c = Math.abs(r), u = Math.floor(c / 60), d = c % 60;
  if (d === 0)
    return s + String(u);
  var h = a;
  return s + String(u) + h + addLeadingZeros(d, 2);
}
function formatTimezoneWithOptionalMinutes(r, a) {
  if (r % 60 === 0) {
    var s = r > 0 ? "-" : "+";
    return s + addLeadingZeros(Math.abs(r) / 60, 2);
  }
  return formatTimezone(r, a);
}
function formatTimezone(r, a) {
  var s = a || "", c = r > 0 ? "-" : "+", u = Math.abs(r), d = addLeadingZeros(Math.floor(u / 60), 2), h = addLeadingZeros(u % 60, 2);
  return c + d + s + h;
}
var dateLongFormatter = function(a, s) {
  switch (a) {
    case "P":
      return s.date({
        width: "short"
      });
    case "PP":
      return s.date({
        width: "medium"
      });
    case "PPP":
      return s.date({
        width: "long"
      });
    case "PPPP":
    default:
      return s.date({
        width: "full"
      });
  }
}, timeLongFormatter = function(a, s) {
  switch (a) {
    case "p":
      return s.time({
        width: "short"
      });
    case "pp":
      return s.time({
        width: "medium"
      });
    case "ppp":
      return s.time({
        width: "long"
      });
    case "pppp":
    default:
      return s.time({
        width: "full"
      });
  }
}, dateTimeLongFormatter = function(a, s) {
  var c = a.match(/(P+)(p+)?/) || [], u = c[1], d = c[2];
  if (!d)
    return dateLongFormatter(a, s);
  var h;
  switch (u) {
    case "P":
      h = s.dateTime({
        width: "short"
      });
      break;
    case "PP":
      h = s.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      h = s.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      h = s.dateTime({
        width: "full"
      });
      break;
  }
  return h.replace("{{date}}", dateLongFormatter(u, s)).replace("{{time}}", timeLongFormatter(d, s));
}, longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
}, protectedDayOfYearTokens = ["D", "DD"], protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(r) {
  return protectedDayOfYearTokens.indexOf(r) !== -1;
}
function isProtectedWeekYearToken(r) {
  return protectedWeekYearTokens.indexOf(r) !== -1;
}
function throwProtectedError(r, a, s) {
  if (r === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(a, "`) for formatting years to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(a, "`) for formatting years to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(a, "`) for formatting days of the month to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(a, "`) for formatting days of the month to the input `").concat(s, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, formatDistance = function(a, s, c) {
  var u, d = formatDistanceLocale[a];
  return typeof d == "string" ? u = d : s === 1 ? u = d.one : u = d.other.replace("{{count}}", s.toString()), c != null && c.addSuffix ? c.comparison && c.comparison > 0 ? "in " + u : u + " ago" : u;
};
function buildFormatLongFn(r) {
  return function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.width ? String(a.width) : r.defaultWidth, c = r.formats[s] || r.formats[r.defaultWidth];
    return c;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
}, formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, formatRelative = function(a, s, c, u) {
  return formatRelativeLocale[a];
};
function buildLocalizeFn(r) {
  return function(a, s) {
    var c = s != null && s.context ? String(s.context) : "standalone", u;
    if (c === "formatting" && r.formattingValues) {
      var d = r.defaultFormattingWidth || r.defaultWidth, h = s != null && s.width ? String(s.width) : d;
      u = r.formattingValues[h] || r.formattingValues[d];
    } else {
      var p = r.defaultWidth, m = s != null && s.width ? String(s.width) : r.defaultWidth;
      u = r.values[m] || r.values[p];
    }
    var g = r.argumentCallback ? r.argumentCallback(a) : a;
    return u[g];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ordinalNumber = function(a, s) {
  var c = Number(a), u = c % 100;
  if (u > 20 || u < 10)
    switch (u % 10) {
      case 1:
        return c + "st";
      case 2:
        return c + "nd";
      case 3:
        return c + "rd";
    }
  return c + "th";
}, localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(a) {
      return a - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(r) {
  return function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = s.width, u = c && r.matchPatterns[c] || r.matchPatterns[r.defaultMatchWidth], d = a.match(u);
    if (!d)
      return null;
    var h = d[0], p = c && r.parsePatterns[c] || r.parsePatterns[r.defaultParseWidth], m = Array.isArray(p) ? findIndex(p, function(y) {
      return y.test(h);
    }) : findKey(p, function(y) {
      return y.test(h);
    }), g;
    g = r.valueCallback ? r.valueCallback(m) : m, g = s.valueCallback ? s.valueCallback(g) : g;
    var v = a.slice(h.length);
    return {
      value: g,
      rest: v
    };
  };
}
function findKey(r, a) {
  for (var s in r)
    if (r.hasOwnProperty(s) && a(r[s]))
      return s;
}
function findIndex(r, a) {
  for (var s = 0; s < r.length; s++)
    if (a(r[s]))
      return s;
}
function buildMatchPatternFn(r) {
  return function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = a.match(r.matchPattern);
    if (!c) return null;
    var u = c[0], d = a.match(r.parsePattern);
    if (!d) return null;
    var h = r.valueCallback ? r.valueCallback(d[0]) : d[0];
    h = s.valueCallback ? s.valueCallback(h) : h;
    var p = a.slice(u.length);
    return {
      value: h,
      rest: p
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i, parseOrdinalNumberPattern = /\d+/i, matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
}, matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(a) {
      return parseInt(a, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(a) {
      return a + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
}, locale = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp$1 = /^'([^]*?)'?$/, doubleQuoteRegExp$1 = /''/g, unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(r, a, s) {
  var c, u, d, h, p, m, g, v, y, x, w, S, M, P;
  requiredArgs(2, arguments);
  var L = String(a), I = getDefaultOptions(), T = (c = (u = void 0) !== null && u !== void 0 ? u : I.locale) !== null && c !== void 0 ? c : locale, E = toInteger((d = (h = (p = (m = void 0) !== null && m !== void 0 ? m : void 0) !== null && p !== void 0 ? p : I.firstWeekContainsDate) !== null && h !== void 0 ? h : (g = I.locale) === null || g === void 0 || (v = g.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && d !== void 0 ? d : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = toInteger((y = (x = (w = (S = void 0) !== null && S !== void 0 ? S : void 0) !== null && w !== void 0 ? w : I.weekStartsOn) !== null && x !== void 0 ? x : (M = I.locale) === null || M === void 0 || (P = M.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && y !== void 0 ? y : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!T.localize)
    throw new RangeError("locale must contain localize property");
  if (!T.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var A = toDate(r);
  if (!isValid(A))
    throw new RangeError("Invalid time value");
  var k = getTimezoneOffsetInMilliseconds(A), V = subMilliseconds(A, k), B = {
    firstWeekContainsDate: E,
    weekStartsOn: R,
    locale: T,
    _originalDate: A
  }, q = L.match(longFormattingTokensRegExp$1).map(function(z) {
    var Z = z[0];
    if (Z === "p" || Z === "P") {
      var G = longFormatters[Z];
      return G(z, T.formatLong);
    }
    return z;
  }).join("").match(formattingTokensRegExp$1).map(function(z) {
    if (z === "''")
      return "'";
    var Z = z[0];
    if (Z === "'")
      return cleanEscapedString$1(z);
    var G = formatters[Z];
    if (G)
      return isProtectedWeekYearToken(z) && throwProtectedError(z, a, String(r)), isProtectedDayOfYearToken(z) && throwProtectedError(z, a, String(r)), G(V, z, T.localize, B);
    if (Z.match(unescapedLatinCharacterRegExp$1))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Z + "`");
    return z;
  }).join("");
  return q;
}
function cleanEscapedString$1(r) {
  var a = r.match(escapedStringRegExp$1);
  return a ? a[1].replace(doubleQuoteRegExp$1, "'") : r;
}
function assign(r, a) {
  if (r == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var s in a)
    Object.prototype.hasOwnProperty.call(a, s) && (r[s] = a[s]);
  return r;
}
function getDate(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getDate();
  return s;
}
function getDay(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getDay();
  return s;
}
function getDaysInMonth$1(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getFullYear(), c = a.getMonth(), u = /* @__PURE__ */ new Date(0);
  return u.setFullYear(s, c + 1, 0), u.setHours(0, 0, 0, 0), u.getDate();
}
function getMonth(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getMonth();
  return s;
}
function getWeekYear(r, a) {
  var s, c, u, d, h, p;
  requiredArgs(1, arguments);
  var m = toDate(r), g = m.getFullYear(), v = getDefaultOptions(), y = toInteger((s = (c = (u = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && u !== void 0 ? u : v.firstWeekContainsDate) !== null && c !== void 0 ? c : (h = v.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(y >= 1 && y <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var x = /* @__PURE__ */ new Date(0);
  x.setFullYear(g + 1, 0, y), x.setHours(0, 0, 0, 0);
  var w = startOfWeek(x, a), S = /* @__PURE__ */ new Date(0);
  S.setFullYear(g, 0, y), S.setHours(0, 0, 0, 0);
  var M = startOfWeek(S, a);
  return m.getTime() >= w.getTime() ? g + 1 : m.getTime() >= M.getTime() ? g : g - 1;
}
function startOfWeekYear(r, a) {
  var s, c, u, d, h, p;
  requiredArgs(1, arguments);
  var m = getDefaultOptions(), g = toInteger((s = (c = (u = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && u !== void 0 ? u : m.firstWeekContainsDate) !== null && c !== void 0 ? c : (h = m.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : 1), v = getWeekYear(r, a), y = /* @__PURE__ */ new Date(0);
  y.setFullYear(v, 0, g), y.setHours(0, 0, 0, 0);
  var x = startOfWeek(y, a);
  return x;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getWeek(r, a) {
  requiredArgs(1, arguments);
  var s = toDate(r), c = startOfWeek(s, a).getTime() - startOfWeekYear(s, a).getTime();
  return Math.round(c / MILLISECONDS_IN_WEEK) + 1;
}
function lastDayOfMonth(r) {
  requiredArgs(1, arguments);
  var a = toDate(r), s = a.getMonth();
  return a.setFullYear(a.getFullYear(), s + 1, 0), a.setHours(0, 0, 0, 0), a;
}
function getWeeksInMonth(r, a) {
  return requiredArgs(1, arguments), differenceInCalendarWeeks(lastDayOfMonth(r), startOfMonth(r), a) + 1;
}
function getYear(r) {
  return requiredArgs(1, arguments), toDate(r).getFullYear();
}
function isAfter(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toDate(a);
  return s.getTime() > c.getTime();
}
function isBefore(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toDate(a);
  return s.getTime() < c.getTime();
}
function isEqual(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toDate(a);
  return s.getTime() === c.getTime();
}
function _arrayLikeToArray$1(r, a) {
  (a == null || a > r.length) && (a = r.length);
  for (var s = 0, c = Array(a); s < a; s++) c[s] = r[s];
  return c;
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if (typeof r == "string") return _arrayLikeToArray$1(r, a);
    var s = {}.toString.call(r).slice(8, -1);
    return s === "Object" && r.constructor && (s = r.constructor.name), s === "Map" || s === "Set" ? Array.from(r) : s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}
function _createForOfIteratorHelper(r, a) {
  var s = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!s) {
    if (Array.isArray(r) || (s = _unsupportedIterableToArray$1(r)) || a) {
      s && (r = s);
      var c = 0, u = function() {
      };
      return {
        s: u,
        n: function() {
          return c >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[c++]
          };
        },
        e: function(g) {
          throw g;
        },
        f: u
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var d, h = !0, p = !1;
  return {
    s: function() {
      s = s.call(r);
    },
    n: function() {
      var g = s.next();
      return h = g.done, g;
    },
    e: function(g) {
      p = !0, d = g;
    },
    f: function() {
      try {
        h || s.return == null || s.return();
      } finally {
        if (p) throw d;
      }
    }
  };
}
function _assertThisInitialized$1(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function _setPrototypeOf$1(r, a) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, c) {
    return s.__proto__ = c, s;
  }, _setPrototypeOf$1(r, a);
}
function _inherits(r, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(a && a.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), a && _setPrototypeOf$1(r, a);
}
function _getPrototypeOf(r) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(r);
}
function _isNativeReflectConstruct() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!r;
  })();
}
function _possibleConstructorReturn(r, a) {
  if (a && (_typeof(a) == "object" || typeof a == "function")) return a;
  if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(r);
}
function _createSuper(r) {
  var a = _isNativeReflectConstruct();
  return function() {
    var s, c = _getPrototypeOf(r);
    if (a) {
      var u = _getPrototypeOf(this).constructor;
      s = Reflect.construct(c, arguments, u);
    } else s = c.apply(this, arguments);
    return _possibleConstructorReturn(this, s);
  };
}
function _classCallCheck(r, a) {
  if (!(r instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(r, a) {
  if (_typeof(r) != "object" || !r) return r;
  var s = r[Symbol.toPrimitive];
  if (s !== void 0) {
    var c = s.call(r, a || "default");
    if (_typeof(c) != "object") return c;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(r);
}
function toPropertyKey(r) {
  var a = toPrimitive(r, "string");
  return _typeof(a) == "symbol" ? a : a + "";
}
function _defineProperties(r, a) {
  for (var s = 0; s < a.length; s++) {
    var c = a[s];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(r, toPropertyKey(c.key), c);
  }
}
function _createClass(r, a, s) {
  return a && _defineProperties(r.prototype, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function _defineProperty$2(r, a, s) {
  return (a = toPropertyKey(a)) in r ? Object.defineProperty(r, a, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[a] = s, r;
}
var TIMEZONE_UNIT_PRIORITY = 10, Setter = /* @__PURE__ */ function() {
  function r() {
    _classCallCheck(this, r), _defineProperty$2(this, "priority", void 0), _defineProperty$2(this, "subPriority", 0);
  }
  return _createClass(r, [{
    key: "validate",
    value: function(s, c) {
      return !0;
    }
  }]), r;
}(), ValueSetter = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s(c, u, d, h, p) {
    var m;
    return _classCallCheck(this, s), m = a.call(this), m.value = c, m.validateValue = u, m.setValue = d, m.priority = h, p && (m.subPriority = p), m;
  }
  return _createClass(s, [{
    key: "validate",
    value: function(u, d) {
      return this.validateValue(u, this.value, d);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return this.setValue(u, d, this.value, h);
    }
  }]), s;
}(Setter), DateToSystemTimezoneSetter = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", TIMEZONE_UNIT_PRIORITY), _defineProperty$2(_assertThisInitialized$1(c), "subPriority", -1), c;
  }
  return _createClass(s, [{
    key: "set",
    value: function(u, d) {
      if (d.timestampIsSet)
        return u;
      var h = /* @__PURE__ */ new Date(0);
      return h.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), h.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), h;
    }
  }]), s;
}(Setter), Parser = /* @__PURE__ */ function() {
  function r() {
    _classCallCheck(this, r), _defineProperty$2(this, "incompatibleTokens", void 0), _defineProperty$2(this, "priority", void 0), _defineProperty$2(this, "subPriority", void 0);
  }
  return _createClass(r, [{
    key: "run",
    value: function(s, c, u, d) {
      var h = this.parse(s, c, u, d);
      return h ? {
        setter: new ValueSetter(h.value, this.validate, this.set, this.priority, this.subPriority),
        rest: h.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(s, c, u) {
      return !0;
    }
  }]), r;
}(), EraParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 140), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["R", "u", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "G":
        case "GG":
        case "GGG":
          return h.era(u, {
            width: "abbreviated"
          }) || h.era(u, {
            width: "narrow"
          });
        case "GGGGG":
          return h.era(u, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return h.era(u, {
            width: "wide"
          }) || h.era(u, {
            width: "abbreviated"
          }) || h.era(u, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return d.era = h, u.setUTCFullYear(h, 0, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(r, a) {
  return r && {
    value: a(r.value),
    rest: r.rest
  };
}
function parseNumericPattern(r, a) {
  var s = a.match(r);
  return s ? {
    value: parseInt(s[0], 10),
    rest: a.slice(s[0].length)
  } : null;
}
function parseTimezonePattern(r, a) {
  var s = a.match(r);
  if (!s)
    return null;
  if (s[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  var c = s[1] === "+" ? 1 : -1, u = s[2] ? parseInt(s[2], 10) : 0, d = s[3] ? parseInt(s[3], 10) : 0, h = s[5] ? parseInt(s[5], 10) : 0;
  return {
    value: c * (u * millisecondsInHour + d * millisecondsInMinute + h * millisecondsInSecond),
    rest: a.slice(s[0].length)
  };
}
function parseAnyDigitsSigned(r) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, r);
}
function parseNDigits(r, a) {
  switch (r) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, a);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, a);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, a);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, a);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + r + "}"), a);
  }
}
function parseNDigitsSigned(r, a) {
  switch (r) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, a);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, a);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, a);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, a);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + r + "}"), a);
  }
}
function dayPeriodEnumToHours(r) {
  switch (r) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(r, a) {
  var s = a > 0, c = s ? a : 1 - a, u;
  if (c <= 50)
    u = r || 100;
  else {
    var d = c + 50, h = Math.floor(d / 100) * 100, p = r >= d % 100;
    u = r + h - (p ? 100 : 0);
  }
  return s ? u : 1 - u;
}
function isLeapYearIndex$1(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 130), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      var p = function(g) {
        return {
          year: g,
          isTwoDigitYear: d === "yy"
        };
      };
      switch (d) {
        case "y":
          return mapValue(parseNDigits(4, u), p);
        case "yo":
          return mapValue(h.ordinalNumber(u, {
            unit: "year"
          }), p);
        default:
          return mapValue(parseNDigits(d.length, u), p);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d.isTwoDigitYear || d.year > 0;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      var p = u.getUTCFullYear();
      if (h.isTwoDigitYear) {
        var m = normalizeTwoDigitYear(h.year, p);
        return u.setUTCFullYear(m, 0, 1), u.setUTCHours(0, 0, 0, 0), u;
      }
      var g = !("era" in d) || d.era === 1 ? h.year : 1 - h.year;
      return u.setUTCFullYear(g, 0, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), LocalWeekYearParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 130), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      var p = function(g) {
        return {
          year: g,
          isTwoDigitYear: d === "YY"
        };
      };
      switch (d) {
        case "Y":
          return mapValue(parseNDigits(4, u), p);
        case "Yo":
          return mapValue(h.ordinalNumber(u, {
            unit: "year"
          }), p);
        default:
          return mapValue(parseNDigits(d.length, u), p);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d.isTwoDigitYear || d.year > 0;
    }
  }, {
    key: "set",
    value: function(u, d, h, p) {
      var m = getUTCWeekYear(u, p);
      if (h.isTwoDigitYear) {
        var g = normalizeTwoDigitYear(h.year, m);
        return u.setUTCFullYear(g, 0, p.firstWeekContainsDate), u.setUTCHours(0, 0, 0, 0), startOfUTCWeek(u, p);
      }
      var v = !("era" in d) || d.era === 1 ? h.year : 1 - h.year;
      return u.setUTCFullYear(v, 0, p.firstWeekContainsDate), u.setUTCHours(0, 0, 0, 0), startOfUTCWeek(u, p);
    }
  }]), s;
}(Parser), ISOWeekYearParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 130), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d) {
      return parseNDigitsSigned(d === "R" ? 4 : d.length, u);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      var p = /* @__PURE__ */ new Date(0);
      return p.setUTCFullYear(h, 0, 4), p.setUTCHours(0, 0, 0, 0), startOfUTCISOWeek(p);
    }
  }]), s;
}(Parser), ExtendedYearParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 130), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d) {
      return parseNDigitsSigned(d === "u" ? 4 : d.length, u);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCFullYear(h, 0, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), QuarterParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 120), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "Q":
        case "QQ":
          return parseNDigits(d.length, u);
        case "Qo":
          return h.ordinalNumber(u, {
            unit: "quarter"
          });
        case "QQQ":
          return h.quarter(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.quarter(u, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return h.quarter(u, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return h.quarter(u, {
            width: "wide",
            context: "formatting"
          }) || h.quarter(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.quarter(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 4;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMonth((h - 1) * 3, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), StandAloneQuarterParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 120), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "q":
        case "qq":
          return parseNDigits(d.length, u);
        case "qo":
          return h.ordinalNumber(u, {
            unit: "quarter"
          });
        case "qqq":
          return h.quarter(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.quarter(u, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return h.quarter(u, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return h.quarter(u, {
            width: "wide",
            context: "standalone"
          }) || h.quarter(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.quarter(u, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 4;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMonth((h - 1) * 3, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), MonthParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), _defineProperty$2(_assertThisInitialized$1(c), "priority", 110), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      var p = function(g) {
        return g - 1;
      };
      switch (d) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, u), p);
        case "MM":
          return mapValue(parseNDigits(2, u), p);
        case "Mo":
          return mapValue(h.ordinalNumber(u, {
            unit: "month"
          }), p);
        case "MMM":
          return h.month(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.month(u, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return h.month(u, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return h.month(u, {
            width: "wide",
            context: "formatting"
          }) || h.month(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.month(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 11;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMonth(h, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), StandAloneMonthParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 110), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      var p = function(g) {
        return g - 1;
      };
      switch (d) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, u), p);
        case "LL":
          return mapValue(parseNDigits(2, u), p);
        case "Lo":
          return mapValue(h.ordinalNumber(u, {
            unit: "month"
          }), p);
        case "LLL":
          return h.month(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.month(u, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return h.month(u, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return h.month(u, {
            width: "wide",
            context: "standalone"
          }) || h.month(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.month(u, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 11;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMonth(h, 1), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser);
function setUTCWeek(r, a, s) {
  requiredArgs(2, arguments);
  var c = toDate(r), u = toInteger(a), d = getUTCWeek(c, s) - u;
  return c.setUTCDate(c.getUTCDate() - d * 7), c;
}
var LocalWeekParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 100), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "w":
          return parseNumericPattern(numericPatterns.week, u);
        case "wo":
          return h.ordinalNumber(u, {
            unit: "week"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 53;
    }
  }, {
    key: "set",
    value: function(u, d, h, p) {
      return startOfUTCWeek(setUTCWeek(u, h, p), p);
    }
  }]), s;
}(Parser);
function setUTCISOWeek(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toInteger(a), u = getUTCISOWeek(s) - c;
  return s.setUTCDate(s.getUTCDate() - u * 7), s;
}
var ISOWeekParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 100), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "I":
          return parseNumericPattern(numericPatterns.week, u);
        case "Io":
          return h.ordinalNumber(u, {
            unit: "week"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 53;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return startOfUTCISOWeek(setUTCISOWeek(u, h));
    }
  }]), s;
}(Parser), DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DateParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "subPriority", 1), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "d":
          return parseNumericPattern(numericPatterns.date, u);
        case "do":
          return h.ordinalNumber(u, {
            unit: "date"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      var h = u.getUTCFullYear(), p = isLeapYearIndex$1(h), m = u.getUTCMonth();
      return p ? d >= 1 && d <= DAYS_IN_MONTH_LEAP_YEAR[m] : d >= 1 && d <= DAYS_IN_MONTH[m];
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCDate(h), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), DayOfYearParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "subpriority", 1), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, u);
        case "Do":
          return h.ordinalNumber(u, {
            unit: "date"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      var h = u.getUTCFullYear(), p = isLeapYearIndex$1(h);
      return p ? d >= 1 && d <= 366 : d >= 1 && d <= 365;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMonth(0, h), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser);
function setUTCDay(r, a, s) {
  var c, u, d, h, p, m, g, v;
  requiredArgs(2, arguments);
  var y = getDefaultOptions(), x = toInteger((c = (u = (d = (h = s == null ? void 0 : s.weekStartsOn) !== null && h !== void 0 ? h : s == null || (p = s.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && d !== void 0 ? d : y.weekStartsOn) !== null && u !== void 0 ? u : (g = y.locale) === null || g === void 0 || (v = g.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && c !== void 0 ? c : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var w = toDate(r), S = toInteger(a), M = w.getUTCDay(), P = S % 7, L = (P + 7) % 7, I = (L < x ? 7 : 0) + S - M;
  return w.setUTCDate(w.getUTCDate() + I), w;
}
var DayParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "E":
        case "EE":
        case "EEE":
          return h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return h.day(u, {
            width: "wide",
            context: "formatting"
          }) || h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 6;
    }
  }, {
    key: "set",
    value: function(u, d, h, p) {
      return u = setUTCDay(u, h, p), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), LocalDayParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h, p) {
      var m = function(v) {
        var y = Math.floor((v - 1) / 7) * 7;
        return (v + p.weekStartsOn + 6) % 7 + y;
      };
      switch (d) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(d.length, u), m);
        case "eo":
          return mapValue(h.ordinalNumber(u, {
            unit: "day"
          }), m);
        case "eee":
          return h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return h.day(u, {
            width: "wide",
            context: "formatting"
          }) || h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 6;
    }
  }, {
    key: "set",
    value: function(u, d, h, p) {
      return u = setUTCDay(u, h, p), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), StandAloneLocalDayParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h, p) {
      var m = function(v) {
        var y = Math.floor((v - 1) / 7) * 7;
        return (v + p.weekStartsOn + 6) % 7 + y;
      };
      switch (d) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(d.length, u), m);
        case "co":
          return mapValue(h.ordinalNumber(u, {
            unit: "day"
          }), m);
        case "ccc":
          return h.day(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.day(u, {
            width: "short",
            context: "standalone"
          }) || h.day(u, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return h.day(u, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return h.day(u, {
            width: "short",
            context: "standalone"
          }) || h.day(u, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return h.day(u, {
            width: "wide",
            context: "standalone"
          }) || h.day(u, {
            width: "abbreviated",
            context: "standalone"
          }) || h.day(u, {
            width: "short",
            context: "standalone"
          }) || h.day(u, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 6;
    }
  }, {
    key: "set",
    value: function(u, d, h, p) {
      return u = setUTCDay(u, h, p), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser);
function setUTCISODay(r, a) {
  requiredArgs(2, arguments);
  var s = toInteger(a);
  s % 7 === 0 && (s = s - 7);
  var c = 1, u = toDate(r), d = u.getUTCDay(), h = s % 7, p = (h + 7) % 7, m = (p < c ? 7 : 0) + s - d;
  return u.setUTCDate(u.getUTCDate() + m), u;
}
var ISODayParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 90), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      var p = function(g) {
        return g === 0 ? 7 : g;
      };
      switch (d) {
        case "i":
        case "ii":
          return parseNDigits(d.length, u);
        case "io":
          return h.ordinalNumber(u, {
            unit: "day"
          });
        case "iii":
          return mapValue(h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          }), p);
        case "iiiii":
          return mapValue(h.day(u, {
            width: "narrow",
            context: "formatting"
          }), p);
        case "iiiiii":
          return mapValue(h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          }), p);
        case "iiii":
        default:
          return mapValue(h.day(u, {
            width: "wide",
            context: "formatting"
          }) || h.day(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.day(u, {
            width: "short",
            context: "formatting"
          }) || h.day(u, {
            width: "narrow",
            context: "formatting"
          }), p);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 7;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u = setUTCISODay(u, h), u.setUTCHours(0, 0, 0, 0), u;
    }
  }]), s;
}(Parser), AMPMParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 80), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "a":
        case "aa":
        case "aaa":
          return h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return h.dayPeriod(u, {
            width: "wide",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCHours(dayPeriodEnumToHours(h), 0, 0, 0), u;
    }
  }]), s;
}(Parser), AMPMMidnightParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 80), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "b":
        case "bb":
        case "bbb":
          return h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return h.dayPeriod(u, {
            width: "wide",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCHours(dayPeriodEnumToHours(h), 0, 0, 0), u;
    }
  }]), s;
}(Parser), DayPeriodParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 80), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["a", "b", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "B":
        case "BB":
        case "BBB":
          return h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return h.dayPeriod(u, {
            width: "wide",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "abbreviated",
            context: "formatting"
          }) || h.dayPeriod(u, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCHours(dayPeriodEnumToHours(h), 0, 0, 0), u;
    }
  }]), s;
}(Parser), Hour1to12Parser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 70), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["H", "K", "k", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, u);
        case "ho":
          return h.ordinalNumber(u, {
            unit: "hour"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 12;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      var p = u.getUTCHours() >= 12;
      return p && h < 12 ? u.setUTCHours(h + 12, 0, 0, 0) : !p && h === 12 ? u.setUTCHours(0, 0, 0, 0) : u.setUTCHours(h, 0, 0, 0), u;
    }
  }]), s;
}(Parser), Hour0to23Parser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 70), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, u);
        case "Ho":
          return h.ordinalNumber(u, {
            unit: "hour"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 23;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCHours(h, 0, 0, 0), u;
    }
  }]), s;
}(Parser), Hour0To11Parser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 70), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["h", "H", "k", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, u);
        case "Ko":
          return h.ordinalNumber(u, {
            unit: "hour"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 11;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      var p = u.getUTCHours() >= 12;
      return p && h < 12 ? u.setUTCHours(h + 12, 0, 0, 0) : u.setUTCHours(h, 0, 0, 0), u;
    }
  }]), s;
}(Parser), Hour1To24Parser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 70), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, u);
        case "ko":
          return h.ordinalNumber(u, {
            unit: "hour"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 1 && d <= 24;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      var p = h <= 24 ? h % 24 : h;
      return u.setUTCHours(p, 0, 0, 0), u;
    }
  }]), s;
}(Parser), MinuteParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 60), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, u);
        case "mo":
          return h.ordinalNumber(u, {
            unit: "minute"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 59;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMinutes(h, 0, 0), u;
    }
  }]), s;
}(Parser), SecondParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 50), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d, h) {
      switch (d) {
        case "s":
          return parseNumericPattern(numericPatterns.second, u);
        case "so":
          return h.ordinalNumber(u, {
            unit: "second"
          });
        default:
          return parseNDigits(d.length, u);
      }
    }
  }, {
    key: "validate",
    value: function(u, d) {
      return d >= 0 && d <= 59;
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCSeconds(h, 0), u;
    }
  }]), s;
}(Parser), FractionOfSecondParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 30), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["t", "T"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d) {
      var h = function(m) {
        return Math.floor(m * Math.pow(10, -d.length + 3));
      };
      return mapValue(parseNDigits(d.length, u), h);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return u.setUTCMilliseconds(h), u;
    }
  }]), s;
}(Parser), ISOTimezoneWithZParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 10), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["t", "T", "x"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d) {
      switch (d) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, u);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, u);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, u);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, u);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, u);
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return d.timestampIsSet ? u : new Date(u.getTime() - h);
    }
  }]), s;
}(Parser), ISOTimezoneParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 10), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", ["t", "T", "X"]), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u, d) {
      switch (d) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, u);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, u);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, u);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, u);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, u);
      }
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return d.timestampIsSet ? u : new Date(u.getTime() - h);
    }
  }]), s;
}(Parser), TimestampSecondsParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 40), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", "*"), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u) {
      return parseAnyDigitsSigned(u);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return [new Date(h * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), s;
}(Parser), TimestampMillisecondsParser = /* @__PURE__ */ function(r) {
  _inherits(s, r);
  var a = _createSuper(s);
  function s() {
    var c;
    _classCallCheck(this, s);
    for (var u = arguments.length, d = new Array(u), h = 0; h < u; h++)
      d[h] = arguments[h];
    return c = a.call.apply(a, [this].concat(d)), _defineProperty$2(_assertThisInitialized$1(c), "priority", 20), _defineProperty$2(_assertThisInitialized$1(c), "incompatibleTokens", "*"), c;
  }
  return _createClass(s, [{
    key: "parse",
    value: function(u) {
      return parseAnyDigitsSigned(u);
    }
  }, {
    key: "set",
    value: function(u, d, h) {
      return [new Date(h), {
        timestampIsSet: !0
      }];
    }
  }]), s;
}(Parser), parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
}, formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp = /^'([^]*?)'?$/, doubleQuoteRegExp = /''/g, notWhitespaceRegExp = /\S/, unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(r, a, s, c) {
  var u, d, h, p, m, g, v, y, x, w, S, M, P, L;
  requiredArgs(3, arguments);
  var I = String(r), T = String(a), E = getDefaultOptions(), R = (u = (d = void 0) !== null && d !== void 0 ? d : E.locale) !== null && u !== void 0 ? u : locale;
  if (!R.match)
    throw new RangeError("locale must contain match property");
  var A = toInteger((h = (p = (m = (g = void 0) !== null && g !== void 0 ? g : void 0) !== null && m !== void 0 ? m : E.firstWeekContainsDate) !== null && p !== void 0 ? p : (v = E.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.firstWeekContainsDate) !== null && h !== void 0 ? h : 1);
  if (!(A >= 1 && A <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = toInteger((x = (w = (S = (M = void 0) !== null && M !== void 0 ? M : void 0) !== null && S !== void 0 ? S : E.weekStartsOn) !== null && w !== void 0 ? w : (P = E.locale) === null || P === void 0 || (L = P.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && x !== void 0 ? x : 0);
  if (!(k >= 0 && k <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (T === "")
    return I === "" ? toDate(s) : /* @__PURE__ */ new Date(NaN);
  var V = {
    firstWeekContainsDate: A,
    weekStartsOn: k,
    locale: R
  }, B = [new DateToSystemTimezoneSetter()], q = T.match(longFormattingTokensRegExp).map(function(ee) {
    var X = ee[0];
    if (X in longFormatters) {
      var J = longFormatters[X];
      return J(ee, R.formatLong);
    }
    return ee;
  }).join("").match(formattingTokensRegExp), z = [], Z = _createForOfIteratorHelper(q), G;
  try {
    var K = function() {
      var X = G.value;
      !(c != null && c.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(X) && throwProtectedError(X, T, r), !(c != null && c.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(X) && throwProtectedError(X, T, r);
      var J = X[0], ie = parsers[J];
      if (ie) {
        var oe = ie.incompatibleTokens;
        if (Array.isArray(oe)) {
          var fe = z.find(function(ue) {
            return oe.includes(ue.token) || ue.token === J;
          });
          if (fe)
            throw new RangeError("The format string mustn't contain `".concat(fe.fullToken, "` and `").concat(X, "` at the same time"));
        } else if (ie.incompatibleTokens === "*" && z.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(X, "` and any other token at the same time"));
        z.push({
          token: J,
          fullToken: X
        });
        var ve = ie.run(I, X, R.match, V);
        if (!ve)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        B.push(ve.setter), I = ve.rest;
      } else {
        if (J.match(unescapedLatinCharacterRegExp))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + J + "`");
        if (X === "''" ? X = "'" : J === "'" && (X = cleanEscapedString(X)), I.indexOf(X) === 0)
          I = I.slice(X.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Z.s(); !(G = Z.n()).done; ) {
      var U = K();
      if (_typeof(U) === "object") return U.v;
    }
  } catch (ee) {
    Z.e(ee);
  } finally {
    Z.f();
  }
  if (I.length > 0 && notWhitespaceRegExp.test(I))
    return /* @__PURE__ */ new Date(NaN);
  var F = B.map(function(ee) {
    return ee.priority;
  }).sort(function(ee, X) {
    return X - ee;
  }).filter(function(ee, X, J) {
    return J.indexOf(ee) === X;
  }).map(function(ee) {
    return B.filter(function(X) {
      return X.priority === ee;
    }).sort(function(X, J) {
      return J.subPriority - X.subPriority;
    });
  }).map(function(ee) {
    return ee[0];
  }), N = toDate(s);
  if (isNaN(N.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var D = subMilliseconds(N, getTimezoneOffsetInMilliseconds(N)), j = {}, H = _createForOfIteratorHelper(F), W;
  try {
    for (H.s(); !(W = H.n()).done; ) {
      var re = W.value;
      if (!re.validate(D, V))
        return /* @__PURE__ */ new Date(NaN);
      var ae = re.set(D, j, V);
      Array.isArray(ae) ? (D = ae[0], assign(j, ae[1])) : D = ae;
    }
  } catch (ee) {
    H.e(ee);
  } finally {
    H.f();
  }
  return D;
}
function cleanEscapedString(r) {
  return r.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameMonth(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toDate(a);
  return s.getFullYear() === c.getFullYear() && s.getMonth() === c.getMonth();
}
function isToday(r) {
  return requiredArgs(1, arguments), isSameDay(r, Date.now());
}
function subDays(r, a) {
  requiredArgs(2, arguments);
  var s = toInteger(a);
  return addDays(r, -s);
}
function parseISO(r, a) {
  var s;
  requiredArgs(1, arguments);
  var c = toInteger((s = void 0) !== null && s !== void 0 ? s : 2);
  if (c !== 2 && c !== 1 && c !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof r == "string" || Object.prototype.toString.call(r) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var u = splitDateString(r), d;
  if (u.date) {
    var h = parseYear(u.date, c);
    d = parseDate(h.restDateString, h.year);
  }
  if (!d || isNaN(d.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var p = d.getTime(), m = 0, g;
  if (u.time && (m = parseTime(u.time), isNaN(m)))
    return /* @__PURE__ */ new Date(NaN);
  if (u.timezone) {
    if (g = parseTimezone(u.timezone), isNaN(g))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var v = new Date(p + m), y = /* @__PURE__ */ new Date(0);
    return y.setFullYear(v.getUTCFullYear(), v.getUTCMonth(), v.getUTCDate()), y.setHours(v.getUTCHours(), v.getUTCMinutes(), v.getUTCSeconds(), v.getUTCMilliseconds()), y;
  }
  return new Date(p + m + g);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(r) {
  var a = {}, s = r.split(patterns.dateTimeDelimiter), c;
  if (s.length > 2)
    return a;
  if (/:/.test(s[0]) ? c = s[0] : (a.date = s[0], c = s[1], patterns.timeZoneDelimiter.test(a.date) && (a.date = r.split(patterns.timeZoneDelimiter)[0], c = r.substr(a.date.length, r.length))), c) {
    var u = patterns.timezone.exec(c);
    u ? (a.time = c.replace(u[1], ""), a.timezone = u[1]) : a.time = c;
  }
  return a;
}
function parseYear(r, a) {
  var s = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + a) + "})|(\\d{2}|[+-]\\d{" + (2 + a) + "})$)"), c = r.match(s);
  if (!c) return {
    year: NaN,
    restDateString: ""
  };
  var u = c[1] ? parseInt(c[1]) : null, d = c[2] ? parseInt(c[2]) : null;
  return {
    year: d === null ? u : d * 100,
    restDateString: r.slice((c[1] || c[2]).length)
  };
}
function parseDate(r, a) {
  if (a === null) return /* @__PURE__ */ new Date(NaN);
  var s = r.match(dateRegex);
  if (!s) return /* @__PURE__ */ new Date(NaN);
  var c = !!s[4], u = parseDateUnit(s[1]), d = parseDateUnit(s[2]) - 1, h = parseDateUnit(s[3]), p = parseDateUnit(s[4]), m = parseDateUnit(s[5]) - 1;
  if (c)
    return validateWeekDate(a, p, m) ? dayOfISOWeekYear(a, p, m) : /* @__PURE__ */ new Date(NaN);
  var g = /* @__PURE__ */ new Date(0);
  return !validateDate(a, d, h) || !validateDayOfYearDate(a, u) ? /* @__PURE__ */ new Date(NaN) : (g.setUTCFullYear(a, d, Math.max(u, h)), g);
}
function parseDateUnit(r) {
  return r ? parseInt(r) : 1;
}
function parseTime(r) {
  var a = r.match(timeRegex);
  if (!a) return NaN;
  var s = parseTimeUnit(a[1]), c = parseTimeUnit(a[2]), u = parseTimeUnit(a[3]);
  return validateTime(s, c, u) ? s * millisecondsInHour + c * millisecondsInMinute + u * 1e3 : NaN;
}
function parseTimeUnit(r) {
  return r && parseFloat(r.replace(",", ".")) || 0;
}
function parseTimezone(r) {
  if (r === "Z") return 0;
  var a = r.match(timezoneRegex);
  if (!a) return 0;
  var s = a[1] === "+" ? -1 : 1, c = parseInt(a[2]), u = a[3] && parseInt(a[3]) || 0;
  return validateTimezone(c, u) ? s * (c * millisecondsInHour + u * millisecondsInMinute) : NaN;
}
function dayOfISOWeekYear(r, a, s) {
  var c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(r, 0, 4);
  var u = c.getUTCDay() || 7, d = (a - 1) * 7 + s + 1 - u;
  return c.setUTCDate(c.getUTCDate() + d), c;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function validateDate(r, a, s) {
  return a >= 0 && a <= 11 && s >= 1 && s <= (daysInMonths[a] || (isLeapYearIndex(r) ? 29 : 28));
}
function validateDayOfYearDate(r, a) {
  return a >= 1 && a <= (isLeapYearIndex(r) ? 366 : 365);
}
function validateWeekDate(r, a, s) {
  return a >= 1 && a <= 53 && s >= 0 && s <= 6;
}
function validateTime(r, a, s) {
  return r === 24 ? a === 0 && s === 0 : s >= 0 && s < 60 && a >= 0 && a < 60 && r >= 0 && r < 25;
}
function validateTimezone(r, a) {
  return a >= 0 && a <= 59;
}
function setDate(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toInteger(a);
  return s.setDate(c), s;
}
function setDay(r, a, s) {
  var c, u, d, h, p, m;
  requiredArgs(2, arguments);
  var g = getDefaultOptions(), v = toInteger((c = (u = (d = (h = void 0) !== null && h !== void 0 ? h : void 0) !== null && d !== void 0 ? d : g.weekStartsOn) !== null && u !== void 0 ? u : (p = g.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && c !== void 0 ? c : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = toDate(r), x = toInteger(a), w = y.getDay(), S = x % 7, M = (S + 7) % 7, P = 7 - v, L = x < 0 || x > 6 ? x - (w + P) % 7 : (M + P) % 7 - (w + P) % 7;
  return addDays(y, L);
}
function setHours(r, a) {
  requiredArgs(2, arguments);
  var s = toDate(r), c = toInteger(a);
  return s.setHours(c), s;
}
function setWeek(r, a, s) {
  requiredArgs(2, arguments);
  var c = toDate(r), u = toInteger(a), d = getWeek(c, s) - u;
  return c.setDate(c.getDate() - d * 7), c;
}
const DEFAULT_DATE_TIME_FORMAT = "MMM d, yyyy";
var Month$1 = /* @__PURE__ */ ((r) => (r[r.JAN = 0] = "JAN", r[r.FEB = 1] = "FEB", r[r.MAR = 2] = "MAR", r[r.APR = 3] = "APR", r[r.MAY = 4] = "MAY", r[r.JUN = 5] = "JUN", r[r.JUL = 6] = "JUL", r[r.AUG = 7] = "AUG", r[r.SEP = 8] = "SEP", r[r.OCT = 9] = "OCT", r[r.NOV = 10] = "NOV", r[r.DEC = 11] = "DEC", r))(Month$1 || {}), Day$1 = /* @__PURE__ */ ((r) => (r[r.SUN = 0] = "SUN", r[r.MON = 1] = "MON", r[r.TUE = 2] = "TUE", r[r.WED = 3] = "WED", r[r.THU = 4] = "THU", r[r.FRI = 5] = "FRI", r[r.SAT = 6] = "SAT", r))(Day$1 || {});
function formatDateTime(r, a) {
  if (!r) return "";
  const { format: s = DEFAULT_DATE_TIME_FORMAT, timeZone: c } = a ?? {}, u = toDate$1(r);
  return c ? formatInTimeZone(u, c, s) : format(u, s);
}
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(r, a) {
  (function() {
    var s, c = "4.17.21", u = 200, d = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", p = "Invalid `variable` option passed into `_.template`", m = "__lodash_hash_undefined__", g = 500, v = "__lodash_placeholder__", y = 1, x = 2, w = 4, S = 1, M = 2, P = 1, L = 2, I = 4, T = 8, E = 16, R = 32, A = 64, k = 128, V = 256, B = 512, q = 30, z = "...", Z = 800, G = 16, K = 1, U = 2, F = 3, N = 1 / 0, D = 9007199254740991, j = 17976931348623157e292, H = NaN, W = 4294967295, re = W - 1, ae = W >>> 1, ee = [
      ["ary", k],
      ["bind", P],
      ["bindKey", L],
      ["curry", T],
      ["curryRight", E],
      ["flip", B],
      ["partial", R],
      ["partialRight", A],
      ["rearg", V]
    ], X = "[object Arguments]", J = "[object Array]", ie = "[object AsyncFunction]", oe = "[object Boolean]", fe = "[object Date]", ve = "[object DOMException]", ue = "[object Error]", pe = "[object Function]", we = "[object GeneratorFunction]", ye = "[object Map]", Ie = "[object Number]", Ee = "[object Null]", ne = "[object Object]", se = "[object Promise]", de = "[object Proxy]", Ce = "[object RegExp]", me = "[object Set]", xe = "[object String]", Se = "[object Symbol]", Re = "[object Undefined]", Pe = "[object WeakMap]", ke = "[object WeakSet]", De = "[object ArrayBuffer]", Fe = "[object DataView]", Xe = "[object Float32Array]", ze = "[object Float64Array]", Ge = "[object Int8Array]", Tt = "[object Int16Array]", _t = "[object Int32Array]", ht = "[object Uint8Array]", Ye = "[object Uint8ClampedArray]", et = "[object Uint16Array]", nt = "[object Uint32Array]", vt = /\b__p \+= '';/g, xt = /\b(__p \+=) '' \+/g, mt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, tr = /&(?:amp|lt|gt|quot|#39);/g, rr = /[&<>"']/g, br = RegExp(tr.source), Be = RegExp(rr.source), pt = /<%-([\s\S]+?)%>/g, Rr = /<%([\s\S]+?)%>/g, Ur = /<%=([\s\S]+?)%>/g, $r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, t1 = /^\w*$/, r1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, fn = /[\\^$.*+?()[\]{}|]/g, qr = RegExp(fn.source), n1 = /^\s+/, Bo = /\s/, No = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Zo = /\{\n\/\* \[wrapped with (.+)\] \*/, zo = /,? & /, Wo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Go = /[()=,{}\[\]\/\s]/, Uo = /\\(\\)?/g, qo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, pi = /\w*$/, Yo = /^[-+]0x[0-9a-f]+$/i, Ko = /^0b[01]+$/i, Xo = /^\[object .+?Constructor\]$/, Qo = /^0o[0-7]+$/i, Jo = /^(?:0|[1-9]\d*)$/, es = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, hn = /($^)/, ts = /['\n\r\u2028\u2029\\]/g, pn = "\\ud800-\\udfff", rs = "\\u0300-\\u036f", ns = "\\ufe20-\\ufe2f", as = "\\u20d0-\\u20ff", mi = rs + ns + as, gi = "\\u2700-\\u27bf", Ci = "a-z\\xdf-\\xf6\\xf8-\\xff", os = "\\xac\\xb1\\xd7\\xf7", ss = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ls = "\\u2000-\\u206f", cs = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", vi = "A-Z\\xc0-\\xd6\\xd8-\\xde", yi = "\\ufe0e\\ufe0f", xi = os + ss + ls + cs, i1 = "['’]", us = "[" + pn + "]", bi = "[" + xi + "]", mn = "[" + mi + "]", wi = "\\d+", ds = "[" + gi + "]", _i = "[" + Ci + "]", Si = "[^" + pn + xi + wi + gi + Ci + vi + "]", a1 = "\\ud83c[\\udffb-\\udfff]", fs = "(?:" + mn + "|" + a1 + ")", Mi = "[^" + pn + "]", o1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", s1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ar = "[" + vi + "]", Ti = "\\u200d", Li = "(?:" + _i + "|" + Si + ")", hs = "(?:" + Ar + "|" + Si + ")", Ii = "(?:" + i1 + "(?:d|ll|m|re|s|t|ve))?", Ei = "(?:" + i1 + "(?:D|LL|M|RE|S|T|VE))?", Pi = fs + "?", Ri = "[" + yi + "]?", ps = "(?:" + Ti + "(?:" + [Mi, o1, s1].join("|") + ")" + Ri + Pi + ")*", ms = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gs = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $i = Ri + Pi + ps, Cs = "(?:" + [ds, o1, s1].join("|") + ")" + $i, vs = "(?:" + [Mi + mn + "?", mn, o1, s1, us].join("|") + ")", ys = RegExp(i1, "g"), xs = RegExp(mn, "g"), l1 = RegExp(a1 + "(?=" + a1 + ")|" + vs + $i, "g"), bs = RegExp([
      Ar + "?" + _i + "+" + Ii + "(?=" + [bi, Ar, "$"].join("|") + ")",
      hs + "+" + Ei + "(?=" + [bi, Ar + Li, "$"].join("|") + ")",
      Ar + "?" + Li + "+" + Ii,
      Ar + "+" + Ei,
      gs,
      ms,
      wi,
      Cs
    ].join("|"), "g"), ws = RegExp("[" + Ti + pn + mi + yi + "]"), _s = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ss = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Ms = -1, st = {};
    st[Xe] = st[ze] = st[Ge] = st[Tt] = st[_t] = st[ht] = st[Ye] = st[et] = st[nt] = !0, st[X] = st[J] = st[De] = st[oe] = st[Fe] = st[fe] = st[ue] = st[pe] = st[ye] = st[Ie] = st[ne] = st[Ce] = st[me] = st[xe] = st[Pe] = !1;
    var ot = {};
    ot[X] = ot[J] = ot[De] = ot[Fe] = ot[oe] = ot[fe] = ot[Xe] = ot[ze] = ot[Ge] = ot[Tt] = ot[_t] = ot[ye] = ot[Ie] = ot[ne] = ot[Ce] = ot[me] = ot[xe] = ot[Se] = ot[ht] = ot[Ye] = ot[et] = ot[nt] = !0, ot[ue] = ot[pe] = ot[Pe] = !1;
    var Ts = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Ls = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Is = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Es = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Ps = parseFloat, Rs = parseInt, Ai = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, $s = typeof self == "object" && self && self.Object === Object && self, bt = Ai || $s || Function("return this")(), c1 = a && !a.nodeType && a, wr = c1 && !0 && r && !r.nodeType && r, ki = wr && wr.exports === c1, u1 = ki && Ai.process, Ht = function() {
      try {
        var he = wr && wr.require && wr.require("util").types;
        return he || u1 && u1.binding && u1.binding("util");
      } catch {
      }
    }(), Di = Ht && Ht.isArrayBuffer, Vi = Ht && Ht.isDate, Fi = Ht && Ht.isMap, ji = Ht && Ht.isRegExp, Oi = Ht && Ht.isSet, Hi = Ht && Ht.isTypedArray;
    function kt(he, _e, be) {
      switch (be.length) {
        case 0:
          return he.call(_e);
        case 1:
          return he.call(_e, be[0]);
        case 2:
          return he.call(_e, be[0], be[1]);
        case 3:
          return he.call(_e, be[0], be[1], be[2]);
      }
      return he.apply(_e, be);
    }
    function As(he, _e, be, Ae) {
      for (var Ne = -1, tt = he == null ? 0 : he.length; ++Ne < tt; ) {
        var gt = he[Ne];
        _e(Ae, gt, be(gt), he);
      }
      return Ae;
    }
    function Bt(he, _e) {
      for (var be = -1, Ae = he == null ? 0 : he.length; ++be < Ae && _e(he[be], be, he) !== !1; )
        ;
      return he;
    }
    function ks(he, _e) {
      for (var be = he == null ? 0 : he.length; be-- && _e(he[be], be, he) !== !1; )
        ;
      return he;
    }
    function Bi(he, _e) {
      for (var be = -1, Ae = he == null ? 0 : he.length; ++be < Ae; )
        if (!_e(he[be], be, he))
          return !1;
      return !0;
    }
    function fr(he, _e) {
      for (var be = -1, Ae = he == null ? 0 : he.length, Ne = 0, tt = []; ++be < Ae; ) {
        var gt = he[be];
        _e(gt, be, he) && (tt[Ne++] = gt);
      }
      return tt;
    }
    function gn(he, _e) {
      var be = he == null ? 0 : he.length;
      return !!be && kr(he, _e, 0) > -1;
    }
    function d1(he, _e, be) {
      for (var Ae = -1, Ne = he == null ? 0 : he.length; ++Ae < Ne; )
        if (be(_e, he[Ae]))
          return !0;
      return !1;
    }
    function lt(he, _e) {
      for (var be = -1, Ae = he == null ? 0 : he.length, Ne = Array(Ae); ++be < Ae; )
        Ne[be] = _e(he[be], be, he);
      return Ne;
    }
    function hr(he, _e) {
      for (var be = -1, Ae = _e.length, Ne = he.length; ++be < Ae; )
        he[Ne + be] = _e[be];
      return he;
    }
    function f1(he, _e, be, Ae) {
      var Ne = -1, tt = he == null ? 0 : he.length;
      for (Ae && tt && (be = he[++Ne]); ++Ne < tt; )
        be = _e(be, he[Ne], Ne, he);
      return be;
    }
    function Ds(he, _e, be, Ae) {
      var Ne = he == null ? 0 : he.length;
      for (Ae && Ne && (be = he[--Ne]); Ne--; )
        be = _e(be, he[Ne], Ne, he);
      return be;
    }
    function h1(he, _e) {
      for (var be = -1, Ae = he == null ? 0 : he.length; ++be < Ae; )
        if (_e(he[be], be, he))
          return !0;
      return !1;
    }
    var Vs = p1("length");
    function Fs(he) {
      return he.split("");
    }
    function js(he) {
      return he.match(Wo) || [];
    }
    function Ni(he, _e, be) {
      var Ae;
      return be(he, function(Ne, tt, gt) {
        if (_e(Ne, tt, gt))
          return Ae = tt, !1;
      }), Ae;
    }
    function Cn(he, _e, be, Ae) {
      for (var Ne = he.length, tt = be + (Ae ? 1 : -1); Ae ? tt-- : ++tt < Ne; )
        if (_e(he[tt], tt, he))
          return tt;
      return -1;
    }
    function kr(he, _e, be) {
      return _e === _e ? Ks(he, _e, be) : Cn(he, Zi, be);
    }
    function Os(he, _e, be, Ae) {
      for (var Ne = be - 1, tt = he.length; ++Ne < tt; )
        if (Ae(he[Ne], _e))
          return Ne;
      return -1;
    }
    function Zi(he) {
      return he !== he;
    }
    function zi(he, _e) {
      var be = he == null ? 0 : he.length;
      return be ? g1(he, _e) / be : H;
    }
    function p1(he) {
      return function(_e) {
        return _e == null ? s : _e[he];
      };
    }
    function m1(he) {
      return function(_e) {
        return he == null ? s : he[_e];
      };
    }
    function Wi(he, _e, be, Ae, Ne) {
      return Ne(he, function(tt, gt, at) {
        be = Ae ? (Ae = !1, tt) : _e(be, tt, gt, at);
      }), be;
    }
    function Hs(he, _e) {
      var be = he.length;
      for (he.sort(_e); be--; )
        he[be] = he[be].value;
      return he;
    }
    function g1(he, _e) {
      for (var be, Ae = -1, Ne = he.length; ++Ae < Ne; ) {
        var tt = _e(he[Ae]);
        tt !== s && (be = be === s ? tt : be + tt);
      }
      return be;
    }
    function C1(he, _e) {
      for (var be = -1, Ae = Array(he); ++be < he; )
        Ae[be] = _e(be);
      return Ae;
    }
    function Bs(he, _e) {
      return lt(_e, function(be) {
        return [be, he[be]];
      });
    }
    function Gi(he) {
      return he && he.slice(0, Ki(he) + 1).replace(n1, "");
    }
    function Dt(he) {
      return function(_e) {
        return he(_e);
      };
    }
    function v1(he, _e) {
      return lt(_e, function(be) {
        return he[be];
      });
    }
    function Yr(he, _e) {
      return he.has(_e);
    }
    function Ui(he, _e) {
      for (var be = -1, Ae = he.length; ++be < Ae && kr(_e, he[be], 0) > -1; )
        ;
      return be;
    }
    function qi(he, _e) {
      for (var be = he.length; be-- && kr(_e, he[be], 0) > -1; )
        ;
      return be;
    }
    function Ns(he, _e) {
      for (var be = he.length, Ae = 0; be--; )
        he[be] === _e && ++Ae;
      return Ae;
    }
    var Zs = m1(Ts), zs = m1(Ls);
    function Ws(he) {
      return "\\" + Es[he];
    }
    function Gs(he, _e) {
      return he == null ? s : he[_e];
    }
    function Dr(he) {
      return ws.test(he);
    }
    function Us(he) {
      return _s.test(he);
    }
    function qs(he) {
      for (var _e, be = []; !(_e = he.next()).done; )
        be.push(_e.value);
      return be;
    }
    function y1(he) {
      var _e = -1, be = Array(he.size);
      return he.forEach(function(Ae, Ne) {
        be[++_e] = [Ne, Ae];
      }), be;
    }
    function Yi(he, _e) {
      return function(be) {
        return he(_e(be));
      };
    }
    function pr(he, _e) {
      for (var be = -1, Ae = he.length, Ne = 0, tt = []; ++be < Ae; ) {
        var gt = he[be];
        (gt === _e || gt === v) && (he[be] = v, tt[Ne++] = be);
      }
      return tt;
    }
    function vn(he) {
      var _e = -1, be = Array(he.size);
      return he.forEach(function(Ae) {
        be[++_e] = Ae;
      }), be;
    }
    function Ys(he) {
      var _e = -1, be = Array(he.size);
      return he.forEach(function(Ae) {
        be[++_e] = [Ae, Ae];
      }), be;
    }
    function Ks(he, _e, be) {
      for (var Ae = be - 1, Ne = he.length; ++Ae < Ne; )
        if (he[Ae] === _e)
          return Ae;
      return -1;
    }
    function Xs(he, _e, be) {
      for (var Ae = be + 1; Ae--; )
        if (he[Ae] === _e)
          return Ae;
      return Ae;
    }
    function Vr(he) {
      return Dr(he) ? Js(he) : Vs(he);
    }
    function qt(he) {
      return Dr(he) ? el(he) : Fs(he);
    }
    function Ki(he) {
      for (var _e = he.length; _e-- && Bo.test(he.charAt(_e)); )
        ;
      return _e;
    }
    var Qs = m1(Is);
    function Js(he) {
      for (var _e = l1.lastIndex = 0; l1.test(he); )
        ++_e;
      return _e;
    }
    function el(he) {
      return he.match(l1) || [];
    }
    function tl(he) {
      return he.match(bs) || [];
    }
    var rl = function he(_e) {
      _e = _e == null ? bt : Fr.defaults(bt.Object(), _e, Fr.pick(bt, Ss));
      var be = _e.Array, Ae = _e.Date, Ne = _e.Error, tt = _e.Function, gt = _e.Math, at = _e.Object, x1 = _e.RegExp, nl = _e.String, Nt = _e.TypeError, yn = be.prototype, il = tt.prototype, jr = at.prototype, xn = _e["__core-js_shared__"], bn = il.toString, it = jr.hasOwnProperty, al = 0, Xi = function() {
        var C = /[^.]+$/.exec(xn && xn.keys && xn.keys.IE_PROTO || "");
        return C ? "Symbol(src)_1." + C : "";
      }(), wn = jr.toString, ol = bn.call(at), sl = bt._, ll = x1(
        "^" + bn.call(it).replace(fn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), _n = ki ? _e.Buffer : s, mr = _e.Symbol, Sn = _e.Uint8Array, Qi = _n ? _n.allocUnsafe : s, Mn = Yi(at.getPrototypeOf, at), Ji = at.create, ea = jr.propertyIsEnumerable, Tn = yn.splice, ta = mr ? mr.isConcatSpreadable : s, Kr = mr ? mr.iterator : s, _r = mr ? mr.toStringTag : s, Ln = function() {
        try {
          var C = Ir(at, "defineProperty");
          return C({}, "", {}), C;
        } catch {
        }
      }(), cl = _e.clearTimeout !== bt.clearTimeout && _e.clearTimeout, ul = Ae && Ae.now !== bt.Date.now && Ae.now, dl = _e.setTimeout !== bt.setTimeout && _e.setTimeout, In = gt.ceil, En = gt.floor, b1 = at.getOwnPropertySymbols, fl = _n ? _n.isBuffer : s, ra = _e.isFinite, hl = yn.join, pl = Yi(at.keys, at), Ct = gt.max, St = gt.min, ml = Ae.now, gl = _e.parseInt, na = gt.random, Cl = yn.reverse, w1 = Ir(_e, "DataView"), Xr = Ir(_e, "Map"), _1 = Ir(_e, "Promise"), Or = Ir(_e, "Set"), Qr = Ir(_e, "WeakMap"), Jr = Ir(at, "create"), Pn = Qr && new Qr(), Hr = {}, vl = Er(w1), yl = Er(Xr), xl = Er(_1), bl = Er(Or), wl = Er(Qr), Rn = mr ? mr.prototype : s, en = Rn ? Rn.valueOf : s, ia = Rn ? Rn.toString : s;
      function Q(C) {
        if (ut(C) && !Ze(C) && !(C instanceof Qe)) {
          if (C instanceof Zt)
            return C;
          if (it.call(C, "__wrapped__"))
            return ao(C);
        }
        return new Zt(C);
      }
      var Br = /* @__PURE__ */ function() {
        function C() {
        }
        return function(b) {
          if (!ct(b))
            return {};
          if (Ji)
            return Ji(b);
          C.prototype = b;
          var $ = new C();
          return C.prototype = s, $;
        };
      }();
      function $n() {
      }
      function Zt(C, b) {
        this.__wrapped__ = C, this.__actions__ = [], this.__chain__ = !!b, this.__index__ = 0, this.__values__ = s;
      }
      Q.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: pt,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Rr,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ur,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Q
        }
      }, Q.prototype = $n.prototype, Q.prototype.constructor = Q, Zt.prototype = Br($n.prototype), Zt.prototype.constructor = Zt;
      function Qe(C) {
        this.__wrapped__ = C, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = W, this.__views__ = [];
      }
      function _l() {
        var C = new Qe(this.__wrapped__);
        return C.__actions__ = Pt(this.__actions__), C.__dir__ = this.__dir__, C.__filtered__ = this.__filtered__, C.__iteratees__ = Pt(this.__iteratees__), C.__takeCount__ = this.__takeCount__, C.__views__ = Pt(this.__views__), C;
      }
      function Sl() {
        if (this.__filtered__) {
          var C = new Qe(this);
          C.__dir__ = -1, C.__filtered__ = !0;
        } else
          C = this.clone(), C.__dir__ *= -1;
        return C;
      }
      function Ml() {
        var C = this.__wrapped__.value(), b = this.__dir__, $ = Ze(C), O = b < 0, Y = $ ? C.length : 0, te = F2(0, Y, this.__views__), le = te.start, ce = te.end, ge = ce - le, Me = O ? ce : le - 1, Te = this.__iteratees__, Le = Te.length, $e = 0, Ve = St(ge, this.__takeCount__);
        if (!$ || !O && Y == ge && Ve == ge)
          return Ia(C, this.__actions__);
        var Oe = [];
        e:
          for (; ge-- && $e < Ve; ) {
            Me += b;
            for (var Ue = -1, He = C[Me]; ++Ue < Le; ) {
              var Ke = Te[Ue], Je = Ke.iteratee, jt = Ke.type, Et = Je(He);
              if (jt == U)
                He = Et;
              else if (!Et) {
                if (jt == K)
                  continue e;
                break e;
              }
            }
            Oe[$e++] = He;
          }
        return Oe;
      }
      Qe.prototype = Br($n.prototype), Qe.prototype.constructor = Qe;
      function Sr(C) {
        var b = -1, $ = C == null ? 0 : C.length;
        for (this.clear(); ++b < $; ) {
          var O = C[b];
          this.set(O[0], O[1]);
        }
      }
      function Tl() {
        this.__data__ = Jr ? Jr(null) : {}, this.size = 0;
      }
      function Ll(C) {
        var b = this.has(C) && delete this.__data__[C];
        return this.size -= b ? 1 : 0, b;
      }
      function Il(C) {
        var b = this.__data__;
        if (Jr) {
          var $ = b[C];
          return $ === m ? s : $;
        }
        return it.call(b, C) ? b[C] : s;
      }
      function El(C) {
        var b = this.__data__;
        return Jr ? b[C] !== s : it.call(b, C);
      }
      function Pl(C, b) {
        var $ = this.__data__;
        return this.size += this.has(C) ? 0 : 1, $[C] = Jr && b === s ? m : b, this;
      }
      Sr.prototype.clear = Tl, Sr.prototype.delete = Ll, Sr.prototype.get = Il, Sr.prototype.has = El, Sr.prototype.set = Pl;
      function nr(C) {
        var b = -1, $ = C == null ? 0 : C.length;
        for (this.clear(); ++b < $; ) {
          var O = C[b];
          this.set(O[0], O[1]);
        }
      }
      function Rl() {
        this.__data__ = [], this.size = 0;
      }
      function $l(C) {
        var b = this.__data__, $ = An(b, C);
        if ($ < 0)
          return !1;
        var O = b.length - 1;
        return $ == O ? b.pop() : Tn.call(b, $, 1), --this.size, !0;
      }
      function Al(C) {
        var b = this.__data__, $ = An(b, C);
        return $ < 0 ? s : b[$][1];
      }
      function kl(C) {
        return An(this.__data__, C) > -1;
      }
      function Dl(C, b) {
        var $ = this.__data__, O = An($, C);
        return O < 0 ? (++this.size, $.push([C, b])) : $[O][1] = b, this;
      }
      nr.prototype.clear = Rl, nr.prototype.delete = $l, nr.prototype.get = Al, nr.prototype.has = kl, nr.prototype.set = Dl;
      function ir(C) {
        var b = -1, $ = C == null ? 0 : C.length;
        for (this.clear(); ++b < $; ) {
          var O = C[b];
          this.set(O[0], O[1]);
        }
      }
      function Vl() {
        this.size = 0, this.__data__ = {
          hash: new Sr(),
          map: new (Xr || nr)(),
          string: new Sr()
        };
      }
      function Fl(C) {
        var b = Wn(this, C).delete(C);
        return this.size -= b ? 1 : 0, b;
      }
      function jl(C) {
        return Wn(this, C).get(C);
      }
      function Ol(C) {
        return Wn(this, C).has(C);
      }
      function Hl(C, b) {
        var $ = Wn(this, C), O = $.size;
        return $.set(C, b), this.size += $.size == O ? 0 : 1, this;
      }
      ir.prototype.clear = Vl, ir.prototype.delete = Fl, ir.prototype.get = jl, ir.prototype.has = Ol, ir.prototype.set = Hl;
      function Mr(C) {
        var b = -1, $ = C == null ? 0 : C.length;
        for (this.__data__ = new ir(); ++b < $; )
          this.add(C[b]);
      }
      function Bl(C) {
        return this.__data__.set(C, m), this;
      }
      function Nl(C) {
        return this.__data__.has(C);
      }
      Mr.prototype.add = Mr.prototype.push = Bl, Mr.prototype.has = Nl;
      function Yt(C) {
        var b = this.__data__ = new nr(C);
        this.size = b.size;
      }
      function Zl() {
        this.__data__ = new nr(), this.size = 0;
      }
      function zl(C) {
        var b = this.__data__, $ = b.delete(C);
        return this.size = b.size, $;
      }
      function Wl(C) {
        return this.__data__.get(C);
      }
      function Gl(C) {
        return this.__data__.has(C);
      }
      function Ul(C, b) {
        var $ = this.__data__;
        if ($ instanceof nr) {
          var O = $.__data__;
          if (!Xr || O.length < u - 1)
            return O.push([C, b]), this.size = ++$.size, this;
          $ = this.__data__ = new ir(O);
        }
        return $.set(C, b), this.size = $.size, this;
      }
      Yt.prototype.clear = Zl, Yt.prototype.delete = zl, Yt.prototype.get = Wl, Yt.prototype.has = Gl, Yt.prototype.set = Ul;
      function aa(C, b) {
        var $ = Ze(C), O = !$ && Pr(C), Y = !$ && !O && xr(C), te = !$ && !O && !Y && Wr(C), le = $ || O || Y || te, ce = le ? C1(C.length, nl) : [], ge = ce.length;
        for (var Me in C)
          (b || it.call(C, Me)) && !(le && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Me == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          Y && (Me == "offset" || Me == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          te && (Me == "buffer" || Me == "byteLength" || Me == "byteOffset") || // Skip index properties.
          lr(Me, ge))) && ce.push(Me);
        return ce;
      }
      function oa(C) {
        var b = C.length;
        return b ? C[k1(0, b - 1)] : s;
      }
      function ql(C, b) {
        return Gn(Pt(C), Tr(b, 0, C.length));
      }
      function Yl(C) {
        return Gn(Pt(C));
      }
      function S1(C, b, $) {
        ($ !== s && !Kt(C[b], $) || $ === s && !(b in C)) && ar(C, b, $);
      }
      function tn(C, b, $) {
        var O = C[b];
        (!(it.call(C, b) && Kt(O, $)) || $ === s && !(b in C)) && ar(C, b, $);
      }
      function An(C, b) {
        for (var $ = C.length; $--; )
          if (Kt(C[$][0], b))
            return $;
        return -1;
      }
      function Kl(C, b, $, O) {
        return gr(C, function(Y, te, le) {
          b(O, Y, $(Y), le);
        }), O;
      }
      function sa(C, b) {
        return C && Jt(b, yt(b), C);
      }
      function Xl(C, b) {
        return C && Jt(b, $t(b), C);
      }
      function ar(C, b, $) {
        b == "__proto__" && Ln ? Ln(C, b, {
          configurable: !0,
          enumerable: !0,
          value: $,
          writable: !0
        }) : C[b] = $;
      }
      function M1(C, b) {
        for (var $ = -1, O = b.length, Y = be(O), te = C == null; ++$ < O; )
          Y[$] = te ? s : ai(C, b[$]);
        return Y;
      }
      function Tr(C, b, $) {
        return C === C && ($ !== s && (C = C <= $ ? C : $), b !== s && (C = C >= b ? C : b)), C;
      }
      function zt(C, b, $, O, Y, te) {
        var le, ce = b & y, ge = b & x, Me = b & w;
        if ($ && (le = Y ? $(C, O, Y, te) : $(C)), le !== s)
          return le;
        if (!ct(C))
          return C;
        var Te = Ze(C);
        if (Te) {
          if (le = O2(C), !ce)
            return Pt(C, le);
        } else {
          var Le = Mt(C), $e = Le == pe || Le == we;
          if (xr(C))
            return Ra(C, ce);
          if (Le == ne || Le == X || $e && !Y) {
            if (le = ge || $e ? {} : Ka(C), !ce)
              return ge ? I2(C, Xl(le, C)) : L2(C, sa(le, C));
          } else {
            if (!ot[Le])
              return Y ? C : {};
            le = H2(C, Le, ce);
          }
        }
        te || (te = new Yt());
        var Ve = te.get(C);
        if (Ve)
          return Ve;
        te.set(C, le), To(C) ? C.forEach(function(He) {
          le.add(zt(He, b, $, He, C, te));
        }) : So(C) && C.forEach(function(He, Ke) {
          le.set(Ke, zt(He, b, $, Ke, C, te));
        });
        var Oe = Me ? ge ? W1 : z1 : ge ? $t : yt, Ue = Te ? s : Oe(C);
        return Bt(Ue || C, function(He, Ke) {
          Ue && (Ke = He, He = C[Ke]), tn(le, Ke, zt(He, b, $, Ke, C, te));
        }), le;
      }
      function Ql(C) {
        var b = yt(C);
        return function($) {
          return la($, C, b);
        };
      }
      function la(C, b, $) {
        var O = $.length;
        if (C == null)
          return !O;
        for (C = at(C); O--; ) {
          var Y = $[O], te = b[Y], le = C[Y];
          if (le === s && !(Y in C) || !te(le))
            return !1;
        }
        return !0;
      }
      function ca(C, b, $) {
        if (typeof C != "function")
          throw new Nt(h);
        return un(function() {
          C.apply(s, $);
        }, b);
      }
      function rn(C, b, $, O) {
        var Y = -1, te = gn, le = !0, ce = C.length, ge = [], Me = b.length;
        if (!ce)
          return ge;
        $ && (b = lt(b, Dt($))), O ? (te = d1, le = !1) : b.length >= u && (te = Yr, le = !1, b = new Mr(b));
        e:
          for (; ++Y < ce; ) {
            var Te = C[Y], Le = $ == null ? Te : $(Te);
            if (Te = O || Te !== 0 ? Te : 0, le && Le === Le) {
              for (var $e = Me; $e--; )
                if (b[$e] === Le)
                  continue e;
              ge.push(Te);
            } else te(b, Le, O) || ge.push(Te);
          }
        return ge;
      }
      var gr = Va(Qt), ua = Va(L1, !0);
      function Jl(C, b) {
        var $ = !0;
        return gr(C, function(O, Y, te) {
          return $ = !!b(O, Y, te), $;
        }), $;
      }
      function kn(C, b, $) {
        for (var O = -1, Y = C.length; ++O < Y; ) {
          var te = C[O], le = b(te);
          if (le != null && (ce === s ? le === le && !Ft(le) : $(le, ce)))
            var ce = le, ge = te;
        }
        return ge;
      }
      function e2(C, b, $, O) {
        var Y = C.length;
        for ($ = We($), $ < 0 && ($ = -$ > Y ? 0 : Y + $), O = O === s || O > Y ? Y : We(O), O < 0 && (O += Y), O = $ > O ? 0 : Io(O); $ < O; )
          C[$++] = b;
        return C;
      }
      function da(C, b) {
        var $ = [];
        return gr(C, function(O, Y, te) {
          b(O, Y, te) && $.push(O);
        }), $;
      }
      function wt(C, b, $, O, Y) {
        var te = -1, le = C.length;
        for ($ || ($ = N2), Y || (Y = []); ++te < le; ) {
          var ce = C[te];
          b > 0 && $(ce) ? b > 1 ? wt(ce, b - 1, $, O, Y) : hr(Y, ce) : O || (Y[Y.length] = ce);
        }
        return Y;
      }
      var T1 = Fa(), fa = Fa(!0);
      function Qt(C, b) {
        return C && T1(C, b, yt);
      }
      function L1(C, b) {
        return C && fa(C, b, yt);
      }
      function Dn(C, b) {
        return fr(b, function($) {
          return cr(C[$]);
        });
      }
      function Lr(C, b) {
        b = vr(b, C);
        for (var $ = 0, O = b.length; C != null && $ < O; )
          C = C[er(b[$++])];
        return $ && $ == O ? C : s;
      }
      function ha(C, b, $) {
        var O = b(C);
        return Ze(C) ? O : hr(O, $(C));
      }
      function Lt(C) {
        return C == null ? C === s ? Re : Ee : _r && _r in at(C) ? V2(C) : Y2(C);
      }
      function I1(C, b) {
        return C > b;
      }
      function t2(C, b) {
        return C != null && it.call(C, b);
      }
      function r2(C, b) {
        return C != null && b in at(C);
      }
      function n2(C, b, $) {
        return C >= St(b, $) && C < Ct(b, $);
      }
      function E1(C, b, $) {
        for (var O = $ ? d1 : gn, Y = C[0].length, te = C.length, le = te, ce = be(te), ge = 1 / 0, Me = []; le--; ) {
          var Te = C[le];
          le && b && (Te = lt(Te, Dt(b))), ge = St(Te.length, ge), ce[le] = !$ && (b || Y >= 120 && Te.length >= 120) ? new Mr(le && Te) : s;
        }
        Te = C[0];
        var Le = -1, $e = ce[0];
        e:
          for (; ++Le < Y && Me.length < ge; ) {
            var Ve = Te[Le], Oe = b ? b(Ve) : Ve;
            if (Ve = $ || Ve !== 0 ? Ve : 0, !($e ? Yr($e, Oe) : O(Me, Oe, $))) {
              for (le = te; --le; ) {
                var Ue = ce[le];
                if (!(Ue ? Yr(Ue, Oe) : O(C[le], Oe, $)))
                  continue e;
              }
              $e && $e.push(Oe), Me.push(Ve);
            }
          }
        return Me;
      }
      function i2(C, b, $, O) {
        return Qt(C, function(Y, te, le) {
          b(O, $(Y), te, le);
        }), O;
      }
      function nn(C, b, $) {
        b = vr(b, C), C = eo(C, b);
        var O = C == null ? C : C[er(Gt(b))];
        return O == null ? s : kt(O, C, $);
      }
      function pa(C) {
        return ut(C) && Lt(C) == X;
      }
      function a2(C) {
        return ut(C) && Lt(C) == De;
      }
      function o2(C) {
        return ut(C) && Lt(C) == fe;
      }
      function an(C, b, $, O, Y) {
        return C === b ? !0 : C == null || b == null || !ut(C) && !ut(b) ? C !== C && b !== b : s2(C, b, $, O, an, Y);
      }
      function s2(C, b, $, O, Y, te) {
        var le = Ze(C), ce = Ze(b), ge = le ? J : Mt(C), Me = ce ? J : Mt(b);
        ge = ge == X ? ne : ge, Me = Me == X ? ne : Me;
        var Te = ge == ne, Le = Me == ne, $e = ge == Me;
        if ($e && xr(C)) {
          if (!xr(b))
            return !1;
          le = !0, Te = !1;
        }
        if ($e && !Te)
          return te || (te = new Yt()), le || Wr(C) ? Ua(C, b, $, O, Y, te) : k2(C, b, ge, $, O, Y, te);
        if (!($ & S)) {
          var Ve = Te && it.call(C, "__wrapped__"), Oe = Le && it.call(b, "__wrapped__");
          if (Ve || Oe) {
            var Ue = Ve ? C.value() : C, He = Oe ? b.value() : b;
            return te || (te = new Yt()), Y(Ue, He, $, O, te);
          }
        }
        return $e ? (te || (te = new Yt()), D2(C, b, $, O, Y, te)) : !1;
      }
      function l2(C) {
        return ut(C) && Mt(C) == ye;
      }
      function P1(C, b, $, O) {
        var Y = $.length, te = Y, le = !O;
        if (C == null)
          return !te;
        for (C = at(C); Y--; ) {
          var ce = $[Y];
          if (le && ce[2] ? ce[1] !== C[ce[0]] : !(ce[0] in C))
            return !1;
        }
        for (; ++Y < te; ) {
          ce = $[Y];
          var ge = ce[0], Me = C[ge], Te = ce[1];
          if (le && ce[2]) {
            if (Me === s && !(ge in C))
              return !1;
          } else {
            var Le = new Yt();
            if (O)
              var $e = O(Me, Te, ge, C, b, Le);
            if (!($e === s ? an(Te, Me, S | M, O, Le) : $e))
              return !1;
          }
        }
        return !0;
      }
      function ma(C) {
        if (!ct(C) || z2(C))
          return !1;
        var b = cr(C) ? ll : Xo;
        return b.test(Er(C));
      }
      function c2(C) {
        return ut(C) && Lt(C) == Ce;
      }
      function u2(C) {
        return ut(C) && Mt(C) == me;
      }
      function d2(C) {
        return ut(C) && Qn(C.length) && !!st[Lt(C)];
      }
      function ga(C) {
        return typeof C == "function" ? C : C == null ? At : typeof C == "object" ? Ze(C) ? ya(C[0], C[1]) : va(C) : Oo(C);
      }
      function R1(C) {
        if (!cn(C))
          return pl(C);
        var b = [];
        for (var $ in at(C))
          it.call(C, $) && $ != "constructor" && b.push($);
        return b;
      }
      function f2(C) {
        if (!ct(C))
          return q2(C);
        var b = cn(C), $ = [];
        for (var O in C)
          O == "constructor" && (b || !it.call(C, O)) || $.push(O);
        return $;
      }
      function $1(C, b) {
        return C < b;
      }
      function Ca(C, b) {
        var $ = -1, O = Rt(C) ? be(C.length) : [];
        return gr(C, function(Y, te, le) {
          O[++$] = b(Y, te, le);
        }), O;
      }
      function va(C) {
        var b = U1(C);
        return b.length == 1 && b[0][2] ? Qa(b[0][0], b[0][1]) : function($) {
          return $ === C || P1($, C, b);
        };
      }
      function ya(C, b) {
        return Y1(C) && Xa(b) ? Qa(er(C), b) : function($) {
          var O = ai($, C);
          return O === s && O === b ? oi($, C) : an(b, O, S | M);
        };
      }
      function Vn(C, b, $, O, Y) {
        C !== b && T1(b, function(te, le) {
          if (Y || (Y = new Yt()), ct(te))
            h2(C, b, le, $, Vn, O, Y);
          else {
            var ce = O ? O(X1(C, le), te, le + "", C, b, Y) : s;
            ce === s && (ce = te), S1(C, le, ce);
          }
        }, $t);
      }
      function h2(C, b, $, O, Y, te, le) {
        var ce = X1(C, $), ge = X1(b, $), Me = le.get(ge);
        if (Me) {
          S1(C, $, Me);
          return;
        }
        var Te = te ? te(ce, ge, $ + "", C, b, le) : s, Le = Te === s;
        if (Le) {
          var $e = Ze(ge), Ve = !$e && xr(ge), Oe = !$e && !Ve && Wr(ge);
          Te = ge, $e || Ve || Oe ? Ze(ce) ? Te = ce : dt(ce) ? Te = Pt(ce) : Ve ? (Le = !1, Te = Ra(ge, !0)) : Oe ? (Le = !1, Te = $a(ge, !0)) : Te = [] : dn(ge) || Pr(ge) ? (Te = ce, Pr(ce) ? Te = Eo(ce) : (!ct(ce) || cr(ce)) && (Te = Ka(ge))) : Le = !1;
        }
        Le && (le.set(ge, Te), Y(Te, ge, O, te, le), le.delete(ge)), S1(C, $, Te);
      }
      function xa(C, b) {
        var $ = C.length;
        if ($)
          return b += b < 0 ? $ : 0, lr(b, $) ? C[b] : s;
      }
      function ba(C, b, $) {
        b.length ? b = lt(b, function(te) {
          return Ze(te) ? function(le) {
            return Lr(le, te.length === 1 ? te[0] : te);
          } : te;
        }) : b = [At];
        var O = -1;
        b = lt(b, Dt(je()));
        var Y = Ca(C, function(te, le, ce) {
          var ge = lt(b, function(Me) {
            return Me(te);
          });
          return { criteria: ge, index: ++O, value: te };
        });
        return Hs(Y, function(te, le) {
          return T2(te, le, $);
        });
      }
      function p2(C, b) {
        return wa(C, b, function($, O) {
          return oi(C, O);
        });
      }
      function wa(C, b, $) {
        for (var O = -1, Y = b.length, te = {}; ++O < Y; ) {
          var le = b[O], ce = Lr(C, le);
          $(ce, le) && sn(te, vr(le, C), ce);
        }
        return te;
      }
      function m2(C) {
        return function(b) {
          return Lr(b, C);
        };
      }
      function A1(C, b, $, O) {
        var Y = O ? Os : kr, te = -1, le = b.length, ce = C;
        for (C === b && (b = Pt(b)), $ && (ce = lt(C, Dt($))); ++te < le; )
          for (var ge = 0, Me = b[te], Te = $ ? $(Me) : Me; (ge = Y(ce, Te, ge, O)) > -1; )
            ce !== C && Tn.call(ce, ge, 1), Tn.call(C, ge, 1);
        return C;
      }
      function _a(C, b) {
        for (var $ = C ? b.length : 0, O = $ - 1; $--; ) {
          var Y = b[$];
          if ($ == O || Y !== te) {
            var te = Y;
            lr(Y) ? Tn.call(C, Y, 1) : F1(C, Y);
          }
        }
        return C;
      }
      function k1(C, b) {
        return C + En(na() * (b - C + 1));
      }
      function g2(C, b, $, O) {
        for (var Y = -1, te = Ct(In((b - C) / ($ || 1)), 0), le = be(te); te--; )
          le[O ? te : ++Y] = C, C += $;
        return le;
      }
      function D1(C, b) {
        var $ = "";
        if (!C || b < 1 || b > D)
          return $;
        do
          b % 2 && ($ += C), b = En(b / 2), b && (C += C);
        while (b);
        return $;
      }
      function qe(C, b) {
        return Q1(Ja(C, b, At), C + "");
      }
      function C2(C) {
        return oa(Gr(C));
      }
      function v2(C, b) {
        var $ = Gr(C);
        return Gn($, Tr(b, 0, $.length));
      }
      function sn(C, b, $, O) {
        if (!ct(C))
          return C;
        b = vr(b, C);
        for (var Y = -1, te = b.length, le = te - 1, ce = C; ce != null && ++Y < te; ) {
          var ge = er(b[Y]), Me = $;
          if (ge === "__proto__" || ge === "constructor" || ge === "prototype")
            return C;
          if (Y != le) {
            var Te = ce[ge];
            Me = O ? O(Te, ge, ce) : s, Me === s && (Me = ct(Te) ? Te : lr(b[Y + 1]) ? [] : {});
          }
          tn(ce, ge, Me), ce = ce[ge];
        }
        return C;
      }
      var Sa = Pn ? function(C, b) {
        return Pn.set(C, b), C;
      } : At, y2 = Ln ? function(C, b) {
        return Ln(C, "toString", {
          configurable: !0,
          enumerable: !1,
          value: li(b),
          writable: !0
        });
      } : At;
      function x2(C) {
        return Gn(Gr(C));
      }
      function Wt(C, b, $) {
        var O = -1, Y = C.length;
        b < 0 && (b = -b > Y ? 0 : Y + b), $ = $ > Y ? Y : $, $ < 0 && ($ += Y), Y = b > $ ? 0 : $ - b >>> 0, b >>>= 0;
        for (var te = be(Y); ++O < Y; )
          te[O] = C[O + b];
        return te;
      }
      function b2(C, b) {
        var $;
        return gr(C, function(O, Y, te) {
          return $ = b(O, Y, te), !$;
        }), !!$;
      }
      function Fn(C, b, $) {
        var O = 0, Y = C == null ? O : C.length;
        if (typeof b == "number" && b === b && Y <= ae) {
          for (; O < Y; ) {
            var te = O + Y >>> 1, le = C[te];
            le !== null && !Ft(le) && ($ ? le <= b : le < b) ? O = te + 1 : Y = te;
          }
          return Y;
        }
        return V1(C, b, At, $);
      }
      function V1(C, b, $, O) {
        var Y = 0, te = C == null ? 0 : C.length;
        if (te === 0)
          return 0;
        b = $(b);
        for (var le = b !== b, ce = b === null, ge = Ft(b), Me = b === s; Y < te; ) {
          var Te = En((Y + te) / 2), Le = $(C[Te]), $e = Le !== s, Ve = Le === null, Oe = Le === Le, Ue = Ft(Le);
          if (le)
            var He = O || Oe;
          else Me ? He = Oe && (O || $e) : ce ? He = Oe && $e && (O || !Ve) : ge ? He = Oe && $e && !Ve && (O || !Ue) : Ve || Ue ? He = !1 : He = O ? Le <= b : Le < b;
          He ? Y = Te + 1 : te = Te;
        }
        return St(te, re);
      }
      function Ma(C, b) {
        for (var $ = -1, O = C.length, Y = 0, te = []; ++$ < O; ) {
          var le = C[$], ce = b ? b(le) : le;
          if (!$ || !Kt(ce, ge)) {
            var ge = ce;
            te[Y++] = le === 0 ? 0 : le;
          }
        }
        return te;
      }
      function Ta(C) {
        return typeof C == "number" ? C : Ft(C) ? H : +C;
      }
      function Vt(C) {
        if (typeof C == "string")
          return C;
        if (Ze(C))
          return lt(C, Vt) + "";
        if (Ft(C))
          return ia ? ia.call(C) : "";
        var b = C + "";
        return b == "0" && 1 / C == -N ? "-0" : b;
      }
      function Cr(C, b, $) {
        var O = -1, Y = gn, te = C.length, le = !0, ce = [], ge = ce;
        if ($)
          le = !1, Y = d1;
        else if (te >= u) {
          var Me = b ? null : $2(C);
          if (Me)
            return vn(Me);
          le = !1, Y = Yr, ge = new Mr();
        } else
          ge = b ? [] : ce;
        e:
          for (; ++O < te; ) {
            var Te = C[O], Le = b ? b(Te) : Te;
            if (Te = $ || Te !== 0 ? Te : 0, le && Le === Le) {
              for (var $e = ge.length; $e--; )
                if (ge[$e] === Le)
                  continue e;
              b && ge.push(Le), ce.push(Te);
            } else Y(ge, Le, $) || (ge !== ce && ge.push(Le), ce.push(Te));
          }
        return ce;
      }
      function F1(C, b) {
        return b = vr(b, C), C = eo(C, b), C == null || delete C[er(Gt(b))];
      }
      function La(C, b, $, O) {
        return sn(C, b, $(Lr(C, b)), O);
      }
      function jn(C, b, $, O) {
        for (var Y = C.length, te = O ? Y : -1; (O ? te-- : ++te < Y) && b(C[te], te, C); )
          ;
        return $ ? Wt(C, O ? 0 : te, O ? te + 1 : Y) : Wt(C, O ? te + 1 : 0, O ? Y : te);
      }
      function Ia(C, b) {
        var $ = C;
        return $ instanceof Qe && ($ = $.value()), f1(b, function(O, Y) {
          return Y.func.apply(Y.thisArg, hr([O], Y.args));
        }, $);
      }
      function j1(C, b, $) {
        var O = C.length;
        if (O < 2)
          return O ? Cr(C[0]) : [];
        for (var Y = -1, te = be(O); ++Y < O; )
          for (var le = C[Y], ce = -1; ++ce < O; )
            ce != Y && (te[Y] = rn(te[Y] || le, C[ce], b, $));
        return Cr(wt(te, 1), b, $);
      }
      function Ea(C, b, $) {
        for (var O = -1, Y = C.length, te = b.length, le = {}; ++O < Y; ) {
          var ce = O < te ? b[O] : s;
          $(le, C[O], ce);
        }
        return le;
      }
      function O1(C) {
        return dt(C) ? C : [];
      }
      function H1(C) {
        return typeof C == "function" ? C : At;
      }
      function vr(C, b) {
        return Ze(C) ? C : Y1(C, b) ? [C] : io(rt(C));
      }
      var w2 = qe;
      function yr(C, b, $) {
        var O = C.length;
        return $ = $ === s ? O : $, !b && $ >= O ? C : Wt(C, b, $);
      }
      var Pa = cl || function(C) {
        return bt.clearTimeout(C);
      };
      function Ra(C, b) {
        if (b)
          return C.slice();
        var $ = C.length, O = Qi ? Qi($) : new C.constructor($);
        return C.copy(O), O;
      }
      function B1(C) {
        var b = new C.constructor(C.byteLength);
        return new Sn(b).set(new Sn(C)), b;
      }
      function _2(C, b) {
        var $ = b ? B1(C.buffer) : C.buffer;
        return new C.constructor($, C.byteOffset, C.byteLength);
      }
      function S2(C) {
        var b = new C.constructor(C.source, pi.exec(C));
        return b.lastIndex = C.lastIndex, b;
      }
      function M2(C) {
        return en ? at(en.call(C)) : {};
      }
      function $a(C, b) {
        var $ = b ? B1(C.buffer) : C.buffer;
        return new C.constructor($, C.byteOffset, C.length);
      }
      function Aa(C, b) {
        if (C !== b) {
          var $ = C !== s, O = C === null, Y = C === C, te = Ft(C), le = b !== s, ce = b === null, ge = b === b, Me = Ft(b);
          if (!ce && !Me && !te && C > b || te && le && ge && !ce && !Me || O && le && ge || !$ && ge || !Y)
            return 1;
          if (!O && !te && !Me && C < b || Me && $ && Y && !O && !te || ce && $ && Y || !le && Y || !ge)
            return -1;
        }
        return 0;
      }
      function T2(C, b, $) {
        for (var O = -1, Y = C.criteria, te = b.criteria, le = Y.length, ce = $.length; ++O < le; ) {
          var ge = Aa(Y[O], te[O]);
          if (ge) {
            if (O >= ce)
              return ge;
            var Me = $[O];
            return ge * (Me == "desc" ? -1 : 1);
          }
        }
        return C.index - b.index;
      }
      function ka(C, b, $, O) {
        for (var Y = -1, te = C.length, le = $.length, ce = -1, ge = b.length, Me = Ct(te - le, 0), Te = be(ge + Me), Le = !O; ++ce < ge; )
          Te[ce] = b[ce];
        for (; ++Y < le; )
          (Le || Y < te) && (Te[$[Y]] = C[Y]);
        for (; Me--; )
          Te[ce++] = C[Y++];
        return Te;
      }
      function Da(C, b, $, O) {
        for (var Y = -1, te = C.length, le = -1, ce = $.length, ge = -1, Me = b.length, Te = Ct(te - ce, 0), Le = be(Te + Me), $e = !O; ++Y < Te; )
          Le[Y] = C[Y];
        for (var Ve = Y; ++ge < Me; )
          Le[Ve + ge] = b[ge];
        for (; ++le < ce; )
          ($e || Y < te) && (Le[Ve + $[le]] = C[Y++]);
        return Le;
      }
      function Pt(C, b) {
        var $ = -1, O = C.length;
        for (b || (b = be(O)); ++$ < O; )
          b[$] = C[$];
        return b;
      }
      function Jt(C, b, $, O) {
        var Y = !$;
        $ || ($ = {});
        for (var te = -1, le = b.length; ++te < le; ) {
          var ce = b[te], ge = O ? O($[ce], C[ce], ce, $, C) : s;
          ge === s && (ge = C[ce]), Y ? ar($, ce, ge) : tn($, ce, ge);
        }
        return $;
      }
      function L2(C, b) {
        return Jt(C, q1(C), b);
      }
      function I2(C, b) {
        return Jt(C, qa(C), b);
      }
      function On(C, b) {
        return function($, O) {
          var Y = Ze($) ? As : Kl, te = b ? b() : {};
          return Y($, C, je(O, 2), te);
        };
      }
      function Nr(C) {
        return qe(function(b, $) {
          var O = -1, Y = $.length, te = Y > 1 ? $[Y - 1] : s, le = Y > 2 ? $[2] : s;
          for (te = C.length > 3 && typeof te == "function" ? (Y--, te) : s, le && It($[0], $[1], le) && (te = Y < 3 ? s : te, Y = 1), b = at(b); ++O < Y; ) {
            var ce = $[O];
            ce && C(b, ce, O, te);
          }
          return b;
        });
      }
      function Va(C, b) {
        return function($, O) {
          if ($ == null)
            return $;
          if (!Rt($))
            return C($, O);
          for (var Y = $.length, te = b ? Y : -1, le = at($); (b ? te-- : ++te < Y) && O(le[te], te, le) !== !1; )
            ;
          return $;
        };
      }
      function Fa(C) {
        return function(b, $, O) {
          for (var Y = -1, te = at(b), le = O(b), ce = le.length; ce--; ) {
            var ge = le[C ? ce : ++Y];
            if ($(te[ge], ge, te) === !1)
              break;
          }
          return b;
        };
      }
      function E2(C, b, $) {
        var O = b & P, Y = ln(C);
        function te() {
          var le = this && this !== bt && this instanceof te ? Y : C;
          return le.apply(O ? $ : this, arguments);
        }
        return te;
      }
      function ja(C) {
        return function(b) {
          b = rt(b);
          var $ = Dr(b) ? qt(b) : s, O = $ ? $[0] : b.charAt(0), Y = $ ? yr($, 1).join("") : b.slice(1);
          return O[C]() + Y;
        };
      }
      function Zr(C) {
        return function(b) {
          return f1(Fo(Vo(b).replace(ys, "")), C, "");
        };
      }
      function ln(C) {
        return function() {
          var b = arguments;
          switch (b.length) {
            case 0:
              return new C();
            case 1:
              return new C(b[0]);
            case 2:
              return new C(b[0], b[1]);
            case 3:
              return new C(b[0], b[1], b[2]);
            case 4:
              return new C(b[0], b[1], b[2], b[3]);
            case 5:
              return new C(b[0], b[1], b[2], b[3], b[4]);
            case 6:
              return new C(b[0], b[1], b[2], b[3], b[4], b[5]);
            case 7:
              return new C(b[0], b[1], b[2], b[3], b[4], b[5], b[6]);
          }
          var $ = Br(C.prototype), O = C.apply($, b);
          return ct(O) ? O : $;
        };
      }
      function P2(C, b, $) {
        var O = ln(C);
        function Y() {
          for (var te = arguments.length, le = be(te), ce = te, ge = zr(Y); ce--; )
            le[ce] = arguments[ce];
          var Me = te < 3 && le[0] !== ge && le[te - 1] !== ge ? [] : pr(le, ge);
          if (te -= Me.length, te < $)
            return Za(
              C,
              b,
              Hn,
              Y.placeholder,
              s,
              le,
              Me,
              s,
              s,
              $ - te
            );
          var Te = this && this !== bt && this instanceof Y ? O : C;
          return kt(Te, this, le);
        }
        return Y;
      }
      function Oa(C) {
        return function(b, $, O) {
          var Y = at(b);
          if (!Rt(b)) {
            var te = je($, 3);
            b = yt(b), $ = function(ce) {
              return te(Y[ce], ce, Y);
            };
          }
          var le = C(b, $, O);
          return le > -1 ? Y[te ? b[le] : le] : s;
        };
      }
      function Ha(C) {
        return sr(function(b) {
          var $ = b.length, O = $, Y = Zt.prototype.thru;
          for (C && b.reverse(); O--; ) {
            var te = b[O];
            if (typeof te != "function")
              throw new Nt(h);
            if (Y && !le && zn(te) == "wrapper")
              var le = new Zt([], !0);
          }
          for (O = le ? O : $; ++O < $; ) {
            te = b[O];
            var ce = zn(te), ge = ce == "wrapper" ? G1(te) : s;
            ge && K1(ge[0]) && ge[1] == (k | T | R | V) && !ge[4].length && ge[9] == 1 ? le = le[zn(ge[0])].apply(le, ge[3]) : le = te.length == 1 && K1(te) ? le[ce]() : le.thru(te);
          }
          return function() {
            var Me = arguments, Te = Me[0];
            if (le && Me.length == 1 && Ze(Te))
              return le.plant(Te).value();
            for (var Le = 0, $e = $ ? b[Le].apply(this, Me) : Te; ++Le < $; )
              $e = b[Le].call(this, $e);
            return $e;
          };
        });
      }
      function Hn(C, b, $, O, Y, te, le, ce, ge, Me) {
        var Te = b & k, Le = b & P, $e = b & L, Ve = b & (T | E), Oe = b & B, Ue = $e ? s : ln(C);
        function He() {
          for (var Ke = arguments.length, Je = be(Ke), jt = Ke; jt--; )
            Je[jt] = arguments[jt];
          if (Ve)
            var Et = zr(He), Ot = Ns(Je, Et);
          if (O && (Je = ka(Je, O, Y, Ve)), te && (Je = Da(Je, te, le, Ve)), Ke -= Ot, Ve && Ke < Me) {
            var ft = pr(Je, Et);
            return Za(
              C,
              b,
              Hn,
              He.placeholder,
              $,
              Je,
              ft,
              ce,
              ge,
              Me - Ke
            );
          }
          var Xt = Le ? $ : this, dr = $e ? Xt[C] : C;
          return Ke = Je.length, ce ? Je = K2(Je, ce) : Oe && Ke > 1 && Je.reverse(), Te && ge < Ke && (Je.length = ge), this && this !== bt && this instanceof He && (dr = Ue || ln(dr)), dr.apply(Xt, Je);
        }
        return He;
      }
      function Ba(C, b) {
        return function($, O) {
          return i2($, C, b(O), {});
        };
      }
      function Bn(C, b) {
        return function($, O) {
          var Y;
          if ($ === s && O === s)
            return b;
          if ($ !== s && (Y = $), O !== s) {
            if (Y === s)
              return O;
            typeof $ == "string" || typeof O == "string" ? ($ = Vt($), O = Vt(O)) : ($ = Ta($), O = Ta(O)), Y = C($, O);
          }
          return Y;
        };
      }
      function N1(C) {
        return sr(function(b) {
          return b = lt(b, Dt(je())), qe(function($) {
            var O = this;
            return C(b, function(Y) {
              return kt(Y, O, $);
            });
          });
        });
      }
      function Nn(C, b) {
        b = b === s ? " " : Vt(b);
        var $ = b.length;
        if ($ < 2)
          return $ ? D1(b, C) : b;
        var O = D1(b, In(C / Vr(b)));
        return Dr(b) ? yr(qt(O), 0, C).join("") : O.slice(0, C);
      }
      function R2(C, b, $, O) {
        var Y = b & P, te = ln(C);
        function le() {
          for (var ce = -1, ge = arguments.length, Me = -1, Te = O.length, Le = be(Te + ge), $e = this && this !== bt && this instanceof le ? te : C; ++Me < Te; )
            Le[Me] = O[Me];
          for (; ge--; )
            Le[Me++] = arguments[++ce];
          return kt($e, Y ? $ : this, Le);
        }
        return le;
      }
      function Na(C) {
        return function(b, $, O) {
          return O && typeof O != "number" && It(b, $, O) && ($ = O = s), b = ur(b), $ === s ? ($ = b, b = 0) : $ = ur($), O = O === s ? b < $ ? 1 : -1 : ur(O), g2(b, $, O, C);
        };
      }
      function Zn(C) {
        return function(b, $) {
          return typeof b == "string" && typeof $ == "string" || (b = Ut(b), $ = Ut($)), C(b, $);
        };
      }
      function Za(C, b, $, O, Y, te, le, ce, ge, Me) {
        var Te = b & T, Le = Te ? le : s, $e = Te ? s : le, Ve = Te ? te : s, Oe = Te ? s : te;
        b |= Te ? R : A, b &= ~(Te ? A : R), b & I || (b &= ~(P | L));
        var Ue = [
          C,
          b,
          Y,
          Ve,
          Le,
          Oe,
          $e,
          ce,
          ge,
          Me
        ], He = $.apply(s, Ue);
        return K1(C) && to(He, Ue), He.placeholder = O, ro(He, C, b);
      }
      function Z1(C) {
        var b = gt[C];
        return function($, O) {
          if ($ = Ut($), O = O == null ? 0 : St(We(O), 292), O && ra($)) {
            var Y = (rt($) + "e").split("e"), te = b(Y[0] + "e" + (+Y[1] + O));
            return Y = (rt(te) + "e").split("e"), +(Y[0] + "e" + (+Y[1] - O));
          }
          return b($);
        };
      }
      var $2 = Or && 1 / vn(new Or([, -0]))[1] == N ? function(C) {
        return new Or(C);
      } : di;
      function za(C) {
        return function(b) {
          var $ = Mt(b);
          return $ == ye ? y1(b) : $ == me ? Ys(b) : Bs(b, C(b));
        };
      }
      function or(C, b, $, O, Y, te, le, ce) {
        var ge = b & L;
        if (!ge && typeof C != "function")
          throw new Nt(h);
        var Me = O ? O.length : 0;
        if (Me || (b &= ~(R | A), O = Y = s), le = le === s ? le : Ct(We(le), 0), ce = ce === s ? ce : We(ce), Me -= Y ? Y.length : 0, b & A) {
          var Te = O, Le = Y;
          O = Y = s;
        }
        var $e = ge ? s : G1(C), Ve = [
          C,
          b,
          $,
          O,
          Y,
          Te,
          Le,
          te,
          le,
          ce
        ];
        if ($e && U2(Ve, $e), C = Ve[0], b = Ve[1], $ = Ve[2], O = Ve[3], Y = Ve[4], ce = Ve[9] = Ve[9] === s ? ge ? 0 : C.length : Ct(Ve[9] - Me, 0), !ce && b & (T | E) && (b &= ~(T | E)), !b || b == P)
          var Oe = E2(C, b, $);
        else b == T || b == E ? Oe = P2(C, b, ce) : (b == R || b == (P | R)) && !Y.length ? Oe = R2(C, b, $, O) : Oe = Hn.apply(s, Ve);
        var Ue = $e ? Sa : to;
        return ro(Ue(Oe, Ve), C, b);
      }
      function Wa(C, b, $, O) {
        return C === s || Kt(C, jr[$]) && !it.call(O, $) ? b : C;
      }
      function Ga(C, b, $, O, Y, te) {
        return ct(C) && ct(b) && (te.set(b, C), Vn(C, b, s, Ga, te), te.delete(b)), C;
      }
      function A2(C) {
        return dn(C) ? s : C;
      }
      function Ua(C, b, $, O, Y, te) {
        var le = $ & S, ce = C.length, ge = b.length;
        if (ce != ge && !(le && ge > ce))
          return !1;
        var Me = te.get(C), Te = te.get(b);
        if (Me && Te)
          return Me == b && Te == C;
        var Le = -1, $e = !0, Ve = $ & M ? new Mr() : s;
        for (te.set(C, b), te.set(b, C); ++Le < ce; ) {
          var Oe = C[Le], Ue = b[Le];
          if (O)
            var He = le ? O(Ue, Oe, Le, b, C, te) : O(Oe, Ue, Le, C, b, te);
          if (He !== s) {
            if (He)
              continue;
            $e = !1;
            break;
          }
          if (Ve) {
            if (!h1(b, function(Ke, Je) {
              if (!Yr(Ve, Je) && (Oe === Ke || Y(Oe, Ke, $, O, te)))
                return Ve.push(Je);
            })) {
              $e = !1;
              break;
            }
          } else if (!(Oe === Ue || Y(Oe, Ue, $, O, te))) {
            $e = !1;
            break;
          }
        }
        return te.delete(C), te.delete(b), $e;
      }
      function k2(C, b, $, O, Y, te, le) {
        switch ($) {
          case Fe:
            if (C.byteLength != b.byteLength || C.byteOffset != b.byteOffset)
              return !1;
            C = C.buffer, b = b.buffer;
          case De:
            return !(C.byteLength != b.byteLength || !te(new Sn(C), new Sn(b)));
          case oe:
          case fe:
          case Ie:
            return Kt(+C, +b);
          case ue:
            return C.name == b.name && C.message == b.message;
          case Ce:
          case xe:
            return C == b + "";
          case ye:
            var ce = y1;
          case me:
            var ge = O & S;
            if (ce || (ce = vn), C.size != b.size && !ge)
              return !1;
            var Me = le.get(C);
            if (Me)
              return Me == b;
            O |= M, le.set(C, b);
            var Te = Ua(ce(C), ce(b), O, Y, te, le);
            return le.delete(C), Te;
          case Se:
            if (en)
              return en.call(C) == en.call(b);
        }
        return !1;
      }
      function D2(C, b, $, O, Y, te) {
        var le = $ & S, ce = z1(C), ge = ce.length, Me = z1(b), Te = Me.length;
        if (ge != Te && !le)
          return !1;
        for (var Le = ge; Le--; ) {
          var $e = ce[Le];
          if (!(le ? $e in b : it.call(b, $e)))
            return !1;
        }
        var Ve = te.get(C), Oe = te.get(b);
        if (Ve && Oe)
          return Ve == b && Oe == C;
        var Ue = !0;
        te.set(C, b), te.set(b, C);
        for (var He = le; ++Le < ge; ) {
          $e = ce[Le];
          var Ke = C[$e], Je = b[$e];
          if (O)
            var jt = le ? O(Je, Ke, $e, b, C, te) : O(Ke, Je, $e, C, b, te);
          if (!(jt === s ? Ke === Je || Y(Ke, Je, $, O, te) : jt)) {
            Ue = !1;
            break;
          }
          He || (He = $e == "constructor");
        }
        if (Ue && !He) {
          var Et = C.constructor, Ot = b.constructor;
          Et != Ot && "constructor" in C && "constructor" in b && !(typeof Et == "function" && Et instanceof Et && typeof Ot == "function" && Ot instanceof Ot) && (Ue = !1);
        }
        return te.delete(C), te.delete(b), Ue;
      }
      function sr(C) {
        return Q1(Ja(C, s, lo), C + "");
      }
      function z1(C) {
        return ha(C, yt, q1);
      }
      function W1(C) {
        return ha(C, $t, qa);
      }
      var G1 = Pn ? function(C) {
        return Pn.get(C);
      } : di;
      function zn(C) {
        for (var b = C.name + "", $ = Hr[b], O = it.call(Hr, b) ? $.length : 0; O--; ) {
          var Y = $[O], te = Y.func;
          if (te == null || te == C)
            return Y.name;
        }
        return b;
      }
      function zr(C) {
        var b = it.call(Q, "placeholder") ? Q : C;
        return b.placeholder;
      }
      function je() {
        var C = Q.iteratee || ci;
        return C = C === ci ? ga : C, arguments.length ? C(arguments[0], arguments[1]) : C;
      }
      function Wn(C, b) {
        var $ = C.__data__;
        return Z2(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
      }
      function U1(C) {
        for (var b = yt(C), $ = b.length; $--; ) {
          var O = b[$], Y = C[O];
          b[$] = [O, Y, Xa(Y)];
        }
        return b;
      }
      function Ir(C, b) {
        var $ = Gs(C, b);
        return ma($) ? $ : s;
      }
      function V2(C) {
        var b = it.call(C, _r), $ = C[_r];
        try {
          C[_r] = s;
          var O = !0;
        } catch {
        }
        var Y = wn.call(C);
        return O && (b ? C[_r] = $ : delete C[_r]), Y;
      }
      var q1 = b1 ? function(C) {
        return C == null ? [] : (C = at(C), fr(b1(C), function(b) {
          return ea.call(C, b);
        }));
      } : fi, qa = b1 ? function(C) {
        for (var b = []; C; )
          hr(b, q1(C)), C = Mn(C);
        return b;
      } : fi, Mt = Lt;
      (w1 && Mt(new w1(new ArrayBuffer(1))) != Fe || Xr && Mt(new Xr()) != ye || _1 && Mt(_1.resolve()) != se || Or && Mt(new Or()) != me || Qr && Mt(new Qr()) != Pe) && (Mt = function(C) {
        var b = Lt(C), $ = b == ne ? C.constructor : s, O = $ ? Er($) : "";
        if (O)
          switch (O) {
            case vl:
              return Fe;
            case yl:
              return ye;
            case xl:
              return se;
            case bl:
              return me;
            case wl:
              return Pe;
          }
        return b;
      });
      function F2(C, b, $) {
        for (var O = -1, Y = $.length; ++O < Y; ) {
          var te = $[O], le = te.size;
          switch (te.type) {
            case "drop":
              C += le;
              break;
            case "dropRight":
              b -= le;
              break;
            case "take":
              b = St(b, C + le);
              break;
            case "takeRight":
              C = Ct(C, b - le);
              break;
          }
        }
        return { start: C, end: b };
      }
      function j2(C) {
        var b = C.match(Zo);
        return b ? b[1].split(zo) : [];
      }
      function Ya(C, b, $) {
        b = vr(b, C);
        for (var O = -1, Y = b.length, te = !1; ++O < Y; ) {
          var le = er(b[O]);
          if (!(te = C != null && $(C, le)))
            break;
          C = C[le];
        }
        return te || ++O != Y ? te : (Y = C == null ? 0 : C.length, !!Y && Qn(Y) && lr(le, Y) && (Ze(C) || Pr(C)));
      }
      function O2(C) {
        var b = C.length, $ = new C.constructor(b);
        return b && typeof C[0] == "string" && it.call(C, "index") && ($.index = C.index, $.input = C.input), $;
      }
      function Ka(C) {
        return typeof C.constructor == "function" && !cn(C) ? Br(Mn(C)) : {};
      }
      function H2(C, b, $) {
        var O = C.constructor;
        switch (b) {
          case De:
            return B1(C);
          case oe:
          case fe:
            return new O(+C);
          case Fe:
            return _2(C, $);
          case Xe:
          case ze:
          case Ge:
          case Tt:
          case _t:
          case ht:
          case Ye:
          case et:
          case nt:
            return $a(C, $);
          case ye:
            return new O();
          case Ie:
          case xe:
            return new O(C);
          case Ce:
            return S2(C);
          case me:
            return new O();
          case Se:
            return M2(C);
        }
      }
      function B2(C, b) {
        var $ = b.length;
        if (!$)
          return C;
        var O = $ - 1;
        return b[O] = ($ > 1 ? "& " : "") + b[O], b = b.join($ > 2 ? ", " : " "), C.replace(No, `{
/* [wrapped with ` + b + `] */
`);
      }
      function N2(C) {
        return Ze(C) || Pr(C) || !!(ta && C && C[ta]);
      }
      function lr(C, b) {
        var $ = typeof C;
        return b = b ?? D, !!b && ($ == "number" || $ != "symbol" && Jo.test(C)) && C > -1 && C % 1 == 0 && C < b;
      }
      function It(C, b, $) {
        if (!ct($))
          return !1;
        var O = typeof b;
        return (O == "number" ? Rt($) && lr(b, $.length) : O == "string" && b in $) ? Kt($[b], C) : !1;
      }
      function Y1(C, b) {
        if (Ze(C))
          return !1;
        var $ = typeof C;
        return $ == "number" || $ == "symbol" || $ == "boolean" || C == null || Ft(C) ? !0 : t1.test(C) || !$r.test(C) || b != null && C in at(b);
      }
      function Z2(C) {
        var b = typeof C;
        return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? C !== "__proto__" : C === null;
      }
      function K1(C) {
        var b = zn(C), $ = Q[b];
        if (typeof $ != "function" || !(b in Qe.prototype))
          return !1;
        if (C === $)
          return !0;
        var O = G1($);
        return !!O && C === O[0];
      }
      function z2(C) {
        return !!Xi && Xi in C;
      }
      var W2 = xn ? cr : hi;
      function cn(C) {
        var b = C && C.constructor, $ = typeof b == "function" && b.prototype || jr;
        return C === $;
      }
      function Xa(C) {
        return C === C && !ct(C);
      }
      function Qa(C, b) {
        return function($) {
          return $ == null ? !1 : $[C] === b && (b !== s || C in at($));
        };
      }
      function G2(C) {
        var b = Kn(C, function(O) {
          return $.size === g && $.clear(), O;
        }), $ = b.cache;
        return b;
      }
      function U2(C, b) {
        var $ = C[1], O = b[1], Y = $ | O, te = Y < (P | L | k), le = O == k && $ == T || O == k && $ == V && C[7].length <= b[8] || O == (k | V) && b[7].length <= b[8] && $ == T;
        if (!(te || le))
          return C;
        O & P && (C[2] = b[2], Y |= $ & P ? 0 : I);
        var ce = b[3];
        if (ce) {
          var ge = C[3];
          C[3] = ge ? ka(ge, ce, b[4]) : ce, C[4] = ge ? pr(C[3], v) : b[4];
        }
        return ce = b[5], ce && (ge = C[5], C[5] = ge ? Da(ge, ce, b[6]) : ce, C[6] = ge ? pr(C[5], v) : b[6]), ce = b[7], ce && (C[7] = ce), O & k && (C[8] = C[8] == null ? b[8] : St(C[8], b[8])), C[9] == null && (C[9] = b[9]), C[0] = b[0], C[1] = Y, C;
      }
      function q2(C) {
        var b = [];
        if (C != null)
          for (var $ in at(C))
            b.push($);
        return b;
      }
      function Y2(C) {
        return wn.call(C);
      }
      function Ja(C, b, $) {
        return b = Ct(b === s ? C.length - 1 : b, 0), function() {
          for (var O = arguments, Y = -1, te = Ct(O.length - b, 0), le = be(te); ++Y < te; )
            le[Y] = O[b + Y];
          Y = -1;
          for (var ce = be(b + 1); ++Y < b; )
            ce[Y] = O[Y];
          return ce[b] = $(le), kt(C, this, ce);
        };
      }
      function eo(C, b) {
        return b.length < 2 ? C : Lr(C, Wt(b, 0, -1));
      }
      function K2(C, b) {
        for (var $ = C.length, O = St(b.length, $), Y = Pt(C); O--; ) {
          var te = b[O];
          C[O] = lr(te, $) ? Y[te] : s;
        }
        return C;
      }
      function X1(C, b) {
        if (!(b === "constructor" && typeof C[b] == "function") && b != "__proto__")
          return C[b];
      }
      var to = no(Sa), un = dl || function(C, b) {
        return bt.setTimeout(C, b);
      }, Q1 = no(y2);
      function ro(C, b, $) {
        var O = b + "";
        return Q1(C, B2(O, X2(j2(O), $)));
      }
      function no(C) {
        var b = 0, $ = 0;
        return function() {
          var O = ml(), Y = G - (O - $);
          if ($ = O, Y > 0) {
            if (++b >= Z)
              return arguments[0];
          } else
            b = 0;
          return C.apply(s, arguments);
        };
      }
      function Gn(C, b) {
        var $ = -1, O = C.length, Y = O - 1;
        for (b = b === s ? O : b; ++$ < b; ) {
          var te = k1($, Y), le = C[te];
          C[te] = C[$], C[$] = le;
        }
        return C.length = b, C;
      }
      var io = G2(function(C) {
        var b = [];
        return C.charCodeAt(0) === 46 && b.push(""), C.replace(r1, function($, O, Y, te) {
          b.push(Y ? te.replace(Uo, "$1") : O || $);
        }), b;
      });
      function er(C) {
        if (typeof C == "string" || Ft(C))
          return C;
        var b = C + "";
        return b == "0" && 1 / C == -N ? "-0" : b;
      }
      function Er(C) {
        if (C != null) {
          try {
            return bn.call(C);
          } catch {
          }
          try {
            return C + "";
          } catch {
          }
        }
        return "";
      }
      function X2(C, b) {
        return Bt(ee, function($) {
          var O = "_." + $[0];
          b & $[1] && !gn(C, O) && C.push(O);
        }), C.sort();
      }
      function ao(C) {
        if (C instanceof Qe)
          return C.clone();
        var b = new Zt(C.__wrapped__, C.__chain__);
        return b.__actions__ = Pt(C.__actions__), b.__index__ = C.__index__, b.__values__ = C.__values__, b;
      }
      function Q2(C, b, $) {
        ($ ? It(C, b, $) : b === s) ? b = 1 : b = Ct(We(b), 0);
        var O = C == null ? 0 : C.length;
        if (!O || b < 1)
          return [];
        for (var Y = 0, te = 0, le = be(In(O / b)); Y < O; )
          le[te++] = Wt(C, Y, Y += b);
        return le;
      }
      function J2(C) {
        for (var b = -1, $ = C == null ? 0 : C.length, O = 0, Y = []; ++b < $; ) {
          var te = C[b];
          te && (Y[O++] = te);
        }
        return Y;
      }
      function e0() {
        var C = arguments.length;
        if (!C)
          return [];
        for (var b = be(C - 1), $ = arguments[0], O = C; O--; )
          b[O - 1] = arguments[O];
        return hr(Ze($) ? Pt($) : [$], wt(b, 1));
      }
      var t0 = qe(function(C, b) {
        return dt(C) ? rn(C, wt(b, 1, dt, !0)) : [];
      }), r0 = qe(function(C, b) {
        var $ = Gt(b);
        return dt($) && ($ = s), dt(C) ? rn(C, wt(b, 1, dt, !0), je($, 2)) : [];
      }), n0 = qe(function(C, b) {
        var $ = Gt(b);
        return dt($) && ($ = s), dt(C) ? rn(C, wt(b, 1, dt, !0), s, $) : [];
      });
      function i0(C, b, $) {
        var O = C == null ? 0 : C.length;
        return O ? (b = $ || b === s ? 1 : We(b), Wt(C, b < 0 ? 0 : b, O)) : [];
      }
      function a0(C, b, $) {
        var O = C == null ? 0 : C.length;
        return O ? (b = $ || b === s ? 1 : We(b), b = O - b, Wt(C, 0, b < 0 ? 0 : b)) : [];
      }
      function o0(C, b) {
        return C && C.length ? jn(C, je(b, 3), !0, !0) : [];
      }
      function s0(C, b) {
        return C && C.length ? jn(C, je(b, 3), !0) : [];
      }
      function l0(C, b, $, O) {
        var Y = C == null ? 0 : C.length;
        return Y ? ($ && typeof $ != "number" && It(C, b, $) && ($ = 0, O = Y), e2(C, b, $, O)) : [];
      }
      function oo(C, b, $) {
        var O = C == null ? 0 : C.length;
        if (!O)
          return -1;
        var Y = $ == null ? 0 : We($);
        return Y < 0 && (Y = Ct(O + Y, 0)), Cn(C, je(b, 3), Y);
      }
      function so(C, b, $) {
        var O = C == null ? 0 : C.length;
        if (!O)
          return -1;
        var Y = O - 1;
        return $ !== s && (Y = We($), Y = $ < 0 ? Ct(O + Y, 0) : St(Y, O - 1)), Cn(C, je(b, 3), Y, !0);
      }
      function lo(C) {
        var b = C == null ? 0 : C.length;
        return b ? wt(C, 1) : [];
      }
      function c0(C) {
        var b = C == null ? 0 : C.length;
        return b ? wt(C, N) : [];
      }
      function u0(C, b) {
        var $ = C == null ? 0 : C.length;
        return $ ? (b = b === s ? 1 : We(b), wt(C, b)) : [];
      }
      function d0(C) {
        for (var b = -1, $ = C == null ? 0 : C.length, O = {}; ++b < $; ) {
          var Y = C[b];
          O[Y[0]] = Y[1];
        }
        return O;
      }
      function co(C) {
        return C && C.length ? C[0] : s;
      }
      function f0(C, b, $) {
        var O = C == null ? 0 : C.length;
        if (!O)
          return -1;
        var Y = $ == null ? 0 : We($);
        return Y < 0 && (Y = Ct(O + Y, 0)), kr(C, b, Y);
      }
      function h0(C) {
        var b = C == null ? 0 : C.length;
        return b ? Wt(C, 0, -1) : [];
      }
      var p0 = qe(function(C) {
        var b = lt(C, O1);
        return b.length && b[0] === C[0] ? E1(b) : [];
      }), m0 = qe(function(C) {
        var b = Gt(C), $ = lt(C, O1);
        return b === Gt($) ? b = s : $.pop(), $.length && $[0] === C[0] ? E1($, je(b, 2)) : [];
      }), g0 = qe(function(C) {
        var b = Gt(C), $ = lt(C, O1);
        return b = typeof b == "function" ? b : s, b && $.pop(), $.length && $[0] === C[0] ? E1($, s, b) : [];
      });
      function C0(C, b) {
        return C == null ? "" : hl.call(C, b);
      }
      function Gt(C) {
        var b = C == null ? 0 : C.length;
        return b ? C[b - 1] : s;
      }
      function v0(C, b, $) {
        var O = C == null ? 0 : C.length;
        if (!O)
          return -1;
        var Y = O;
        return $ !== s && (Y = We($), Y = Y < 0 ? Ct(O + Y, 0) : St(Y, O - 1)), b === b ? Xs(C, b, Y) : Cn(C, Zi, Y, !0);
      }
      function y0(C, b) {
        return C && C.length ? xa(C, We(b)) : s;
      }
      var x0 = qe(uo);
      function uo(C, b) {
        return C && C.length && b && b.length ? A1(C, b) : C;
      }
      function b0(C, b, $) {
        return C && C.length && b && b.length ? A1(C, b, je($, 2)) : C;
      }
      function w0(C, b, $) {
        return C && C.length && b && b.length ? A1(C, b, s, $) : C;
      }
      var _0 = sr(function(C, b) {
        var $ = C == null ? 0 : C.length, O = M1(C, b);
        return _a(C, lt(b, function(Y) {
          return lr(Y, $) ? +Y : Y;
        }).sort(Aa)), O;
      });
      function S0(C, b) {
        var $ = [];
        if (!(C && C.length))
          return $;
        var O = -1, Y = [], te = C.length;
        for (b = je(b, 3); ++O < te; ) {
          var le = C[O];
          b(le, O, C) && ($.push(le), Y.push(O));
        }
        return _a(C, Y), $;
      }
      function J1(C) {
        return C == null ? C : Cl.call(C);
      }
      function M0(C, b, $) {
        var O = C == null ? 0 : C.length;
        return O ? ($ && typeof $ != "number" && It(C, b, $) ? (b = 0, $ = O) : (b = b == null ? 0 : We(b), $ = $ === s ? O : We($)), Wt(C, b, $)) : [];
      }
      function T0(C, b) {
        return Fn(C, b);
      }
      function L0(C, b, $) {
        return V1(C, b, je($, 2));
      }
      function I0(C, b) {
        var $ = C == null ? 0 : C.length;
        if ($) {
          var O = Fn(C, b);
          if (O < $ && Kt(C[O], b))
            return O;
        }
        return -1;
      }
      function E0(C, b) {
        return Fn(C, b, !0);
      }
      function P0(C, b, $) {
        return V1(C, b, je($, 2), !0);
      }
      function R0(C, b) {
        var $ = C == null ? 0 : C.length;
        if ($) {
          var O = Fn(C, b, !0) - 1;
          if (Kt(C[O], b))
            return O;
        }
        return -1;
      }
      function $0(C) {
        return C && C.length ? Ma(C) : [];
      }
      function A0(C, b) {
        return C && C.length ? Ma(C, je(b, 2)) : [];
      }
      function k0(C) {
        var b = C == null ? 0 : C.length;
        return b ? Wt(C, 1, b) : [];
      }
      function D0(C, b, $) {
        return C && C.length ? (b = $ || b === s ? 1 : We(b), Wt(C, 0, b < 0 ? 0 : b)) : [];
      }
      function V0(C, b, $) {
        var O = C == null ? 0 : C.length;
        return O ? (b = $ || b === s ? 1 : We(b), b = O - b, Wt(C, b < 0 ? 0 : b, O)) : [];
      }
      function F0(C, b) {
        return C && C.length ? jn(C, je(b, 3), !1, !0) : [];
      }
      function j0(C, b) {
        return C && C.length ? jn(C, je(b, 3)) : [];
      }
      var O0 = qe(function(C) {
        return Cr(wt(C, 1, dt, !0));
      }), H0 = qe(function(C) {
        var b = Gt(C);
        return dt(b) && (b = s), Cr(wt(C, 1, dt, !0), je(b, 2));
      }), B0 = qe(function(C) {
        var b = Gt(C);
        return b = typeof b == "function" ? b : s, Cr(wt(C, 1, dt, !0), s, b);
      });
      function N0(C) {
        return C && C.length ? Cr(C) : [];
      }
      function Z0(C, b) {
        return C && C.length ? Cr(C, je(b, 2)) : [];
      }
      function z0(C, b) {
        return b = typeof b == "function" ? b : s, C && C.length ? Cr(C, s, b) : [];
      }
      function ei(C) {
        if (!(C && C.length))
          return [];
        var b = 0;
        return C = fr(C, function($) {
          if (dt($))
            return b = Ct($.length, b), !0;
        }), C1(b, function($) {
          return lt(C, p1($));
        });
      }
      function fo(C, b) {
        if (!(C && C.length))
          return [];
        var $ = ei(C);
        return b == null ? $ : lt($, function(O) {
          return kt(b, s, O);
        });
      }
      var W0 = qe(function(C, b) {
        return dt(C) ? rn(C, b) : [];
      }), G0 = qe(function(C) {
        return j1(fr(C, dt));
      }), U0 = qe(function(C) {
        var b = Gt(C);
        return dt(b) && (b = s), j1(fr(C, dt), je(b, 2));
      }), q0 = qe(function(C) {
        var b = Gt(C);
        return b = typeof b == "function" ? b : s, j1(fr(C, dt), s, b);
      }), Y0 = qe(ei);
      function K0(C, b) {
        return Ea(C || [], b || [], tn);
      }
      function X0(C, b) {
        return Ea(C || [], b || [], sn);
      }
      var Q0 = qe(function(C) {
        var b = C.length, $ = b > 1 ? C[b - 1] : s;
        return $ = typeof $ == "function" ? (C.pop(), $) : s, fo(C, $);
      });
      function ho(C) {
        var b = Q(C);
        return b.__chain__ = !0, b;
      }
      function J0(C, b) {
        return b(C), C;
      }
      function Un(C, b) {
        return b(C);
      }
      var e5 = sr(function(C) {
        var b = C.length, $ = b ? C[0] : 0, O = this.__wrapped__, Y = function(te) {
          return M1(te, C);
        };
        return b > 1 || this.__actions__.length || !(O instanceof Qe) || !lr($) ? this.thru(Y) : (O = O.slice($, +$ + (b ? 1 : 0)), O.__actions__.push({
          func: Un,
          args: [Y],
          thisArg: s
        }), new Zt(O, this.__chain__).thru(function(te) {
          return b && !te.length && te.push(s), te;
        }));
      });
      function t5() {
        return ho(this);
      }
      function r5() {
        return new Zt(this.value(), this.__chain__);
      }
      function n5() {
        this.__values__ === s && (this.__values__ = Lo(this.value()));
        var C = this.__index__ >= this.__values__.length, b = C ? s : this.__values__[this.__index__++];
        return { done: C, value: b };
      }
      function i5() {
        return this;
      }
      function a5(C) {
        for (var b, $ = this; $ instanceof $n; ) {
          var O = ao($);
          O.__index__ = 0, O.__values__ = s, b ? Y.__wrapped__ = O : b = O;
          var Y = O;
          $ = $.__wrapped__;
        }
        return Y.__wrapped__ = C, b;
      }
      function o5() {
        var C = this.__wrapped__;
        if (C instanceof Qe) {
          var b = C;
          return this.__actions__.length && (b = new Qe(this)), b = b.reverse(), b.__actions__.push({
            func: Un,
            args: [J1],
            thisArg: s
          }), new Zt(b, this.__chain__);
        }
        return this.thru(J1);
      }
      function s5() {
        return Ia(this.__wrapped__, this.__actions__);
      }
      var l5 = On(function(C, b, $) {
        it.call(C, $) ? ++C[$] : ar(C, $, 1);
      });
      function c5(C, b, $) {
        var O = Ze(C) ? Bi : Jl;
        return $ && It(C, b, $) && (b = s), O(C, je(b, 3));
      }
      function u5(C, b) {
        var $ = Ze(C) ? fr : da;
        return $(C, je(b, 3));
      }
      var d5 = Oa(oo), f5 = Oa(so);
      function h5(C, b) {
        return wt(qn(C, b), 1);
      }
      function p5(C, b) {
        return wt(qn(C, b), N);
      }
      function m5(C, b, $) {
        return $ = $ === s ? 1 : We($), wt(qn(C, b), $);
      }
      function po(C, b) {
        var $ = Ze(C) ? Bt : gr;
        return $(C, je(b, 3));
      }
      function mo(C, b) {
        var $ = Ze(C) ? ks : ua;
        return $(C, je(b, 3));
      }
      var g5 = On(function(C, b, $) {
        it.call(C, $) ? C[$].push(b) : ar(C, $, [b]);
      });
      function C5(C, b, $, O) {
        C = Rt(C) ? C : Gr(C), $ = $ && !O ? We($) : 0;
        var Y = C.length;
        return $ < 0 && ($ = Ct(Y + $, 0)), Jn(C) ? $ <= Y && C.indexOf(b, $) > -1 : !!Y && kr(C, b, $) > -1;
      }
      var v5 = qe(function(C, b, $) {
        var O = -1, Y = typeof b == "function", te = Rt(C) ? be(C.length) : [];
        return gr(C, function(le) {
          te[++O] = Y ? kt(b, le, $) : nn(le, b, $);
        }), te;
      }), y5 = On(function(C, b, $) {
        ar(C, $, b);
      });
      function qn(C, b) {
        var $ = Ze(C) ? lt : Ca;
        return $(C, je(b, 3));
      }
      function x5(C, b, $, O) {
        return C == null ? [] : (Ze(b) || (b = b == null ? [] : [b]), $ = O ? s : $, Ze($) || ($ = $ == null ? [] : [$]), ba(C, b, $));
      }
      var b5 = On(function(C, b, $) {
        C[$ ? 0 : 1].push(b);
      }, function() {
        return [[], []];
      });
      function w5(C, b, $) {
        var O = Ze(C) ? f1 : Wi, Y = arguments.length < 3;
        return O(C, je(b, 4), $, Y, gr);
      }
      function _5(C, b, $) {
        var O = Ze(C) ? Ds : Wi, Y = arguments.length < 3;
        return O(C, je(b, 4), $, Y, ua);
      }
      function S5(C, b) {
        var $ = Ze(C) ? fr : da;
        return $(C, Xn(je(b, 3)));
      }
      function M5(C) {
        var b = Ze(C) ? oa : C2;
        return b(C);
      }
      function T5(C, b, $) {
        ($ ? It(C, b, $) : b === s) ? b = 1 : b = We(b);
        var O = Ze(C) ? ql : v2;
        return O(C, b);
      }
      function L5(C) {
        var b = Ze(C) ? Yl : x2;
        return b(C);
      }
      function I5(C) {
        if (C == null)
          return 0;
        if (Rt(C))
          return Jn(C) ? Vr(C) : C.length;
        var b = Mt(C);
        return b == ye || b == me ? C.size : R1(C).length;
      }
      function E5(C, b, $) {
        var O = Ze(C) ? h1 : b2;
        return $ && It(C, b, $) && (b = s), O(C, je(b, 3));
      }
      var P5 = qe(function(C, b) {
        if (C == null)
          return [];
        var $ = b.length;
        return $ > 1 && It(C, b[0], b[1]) ? b = [] : $ > 2 && It(b[0], b[1], b[2]) && (b = [b[0]]), ba(C, wt(b, 1), []);
      }), Yn = ul || function() {
        return bt.Date.now();
      };
      function R5(C, b) {
        if (typeof b != "function")
          throw new Nt(h);
        return C = We(C), function() {
          if (--C < 1)
            return b.apply(this, arguments);
        };
      }
      function go(C, b, $) {
        return b = $ ? s : b, b = C && b == null ? C.length : b, or(C, k, s, s, s, s, b);
      }
      function Co(C, b) {
        var $;
        if (typeof b != "function")
          throw new Nt(h);
        return C = We(C), function() {
          return --C > 0 && ($ = b.apply(this, arguments)), C <= 1 && (b = s), $;
        };
      }
      var ti = qe(function(C, b, $) {
        var O = P;
        if ($.length) {
          var Y = pr($, zr(ti));
          O |= R;
        }
        return or(C, O, b, $, Y);
      }), vo = qe(function(C, b, $) {
        var O = P | L;
        if ($.length) {
          var Y = pr($, zr(vo));
          O |= R;
        }
        return or(b, O, C, $, Y);
      });
      function yo(C, b, $) {
        b = $ ? s : b;
        var O = or(C, T, s, s, s, s, s, b);
        return O.placeholder = yo.placeholder, O;
      }
      function xo(C, b, $) {
        b = $ ? s : b;
        var O = or(C, E, s, s, s, s, s, b);
        return O.placeholder = xo.placeholder, O;
      }
      function bo(C, b, $) {
        var O, Y, te, le, ce, ge, Me = 0, Te = !1, Le = !1, $e = !0;
        if (typeof C != "function")
          throw new Nt(h);
        b = Ut(b) || 0, ct($) && (Te = !!$.leading, Le = "maxWait" in $, te = Le ? Ct(Ut($.maxWait) || 0, b) : te, $e = "trailing" in $ ? !!$.trailing : $e);
        function Ve(ft) {
          var Xt = O, dr = Y;
          return O = Y = s, Me = ft, le = C.apply(dr, Xt), le;
        }
        function Oe(ft) {
          return Me = ft, ce = un(Ke, b), Te ? Ve(ft) : le;
        }
        function Ue(ft) {
          var Xt = ft - ge, dr = ft - Me, Ho = b - Xt;
          return Le ? St(Ho, te - dr) : Ho;
        }
        function He(ft) {
          var Xt = ft - ge, dr = ft - Me;
          return ge === s || Xt >= b || Xt < 0 || Le && dr >= te;
        }
        function Ke() {
          var ft = Yn();
          if (He(ft))
            return Je(ft);
          ce = un(Ke, Ue(ft));
        }
        function Je(ft) {
          return ce = s, $e && O ? Ve(ft) : (O = Y = s, le);
        }
        function jt() {
          ce !== s && Pa(ce), Me = 0, O = ge = Y = ce = s;
        }
        function Et() {
          return ce === s ? le : Je(Yn());
        }
        function Ot() {
          var ft = Yn(), Xt = He(ft);
          if (O = arguments, Y = this, ge = ft, Xt) {
            if (ce === s)
              return Oe(ge);
            if (Le)
              return Pa(ce), ce = un(Ke, b), Ve(ge);
          }
          return ce === s && (ce = un(Ke, b)), le;
        }
        return Ot.cancel = jt, Ot.flush = Et, Ot;
      }
      var $5 = qe(function(C, b) {
        return ca(C, 1, b);
      }), A5 = qe(function(C, b, $) {
        return ca(C, Ut(b) || 0, $);
      });
      function k5(C) {
        return or(C, B);
      }
      function Kn(C, b) {
        if (typeof C != "function" || b != null && typeof b != "function")
          throw new Nt(h);
        var $ = function() {
          var O = arguments, Y = b ? b.apply(this, O) : O[0], te = $.cache;
          if (te.has(Y))
            return te.get(Y);
          var le = C.apply(this, O);
          return $.cache = te.set(Y, le) || te, le;
        };
        return $.cache = new (Kn.Cache || ir)(), $;
      }
      Kn.Cache = ir;
      function Xn(C) {
        if (typeof C != "function")
          throw new Nt(h);
        return function() {
          var b = arguments;
          switch (b.length) {
            case 0:
              return !C.call(this);
            case 1:
              return !C.call(this, b[0]);
            case 2:
              return !C.call(this, b[0], b[1]);
            case 3:
              return !C.call(this, b[0], b[1], b[2]);
          }
          return !C.apply(this, b);
        };
      }
      function D5(C) {
        return Co(2, C);
      }
      var V5 = w2(function(C, b) {
        b = b.length == 1 && Ze(b[0]) ? lt(b[0], Dt(je())) : lt(wt(b, 1), Dt(je()));
        var $ = b.length;
        return qe(function(O) {
          for (var Y = -1, te = St(O.length, $); ++Y < te; )
            O[Y] = b[Y].call(this, O[Y]);
          return kt(C, this, O);
        });
      }), ri = qe(function(C, b) {
        var $ = pr(b, zr(ri));
        return or(C, R, s, b, $);
      }), wo = qe(function(C, b) {
        var $ = pr(b, zr(wo));
        return or(C, A, s, b, $);
      }), F5 = sr(function(C, b) {
        return or(C, V, s, s, s, b);
      });
      function j5(C, b) {
        if (typeof C != "function")
          throw new Nt(h);
        return b = b === s ? b : We(b), qe(C, b);
      }
      function O5(C, b) {
        if (typeof C != "function")
          throw new Nt(h);
        return b = b == null ? 0 : Ct(We(b), 0), qe(function($) {
          var O = $[b], Y = yr($, 0, b);
          return O && hr(Y, O), kt(C, this, Y);
        });
      }
      function H5(C, b, $) {
        var O = !0, Y = !0;
        if (typeof C != "function")
          throw new Nt(h);
        return ct($) && (O = "leading" in $ ? !!$.leading : O, Y = "trailing" in $ ? !!$.trailing : Y), bo(C, b, {
          leading: O,
          maxWait: b,
          trailing: Y
        });
      }
      function B5(C) {
        return go(C, 1);
      }
      function N5(C, b) {
        return ri(H1(b), C);
      }
      function Z5() {
        if (!arguments.length)
          return [];
        var C = arguments[0];
        return Ze(C) ? C : [C];
      }
      function z5(C) {
        return zt(C, w);
      }
      function W5(C, b) {
        return b = typeof b == "function" ? b : s, zt(C, w, b);
      }
      function G5(C) {
        return zt(C, y | w);
      }
      function U5(C, b) {
        return b = typeof b == "function" ? b : s, zt(C, y | w, b);
      }
      function q5(C, b) {
        return b == null || la(C, b, yt(b));
      }
      function Kt(C, b) {
        return C === b || C !== C && b !== b;
      }
      var Y5 = Zn(I1), K5 = Zn(function(C, b) {
        return C >= b;
      }), Pr = pa(/* @__PURE__ */ function() {
        return arguments;
      }()) ? pa : function(C) {
        return ut(C) && it.call(C, "callee") && !ea.call(C, "callee");
      }, Ze = be.isArray, X5 = Di ? Dt(Di) : a2;
      function Rt(C) {
        return C != null && Qn(C.length) && !cr(C);
      }
      function dt(C) {
        return ut(C) && Rt(C);
      }
      function Q5(C) {
        return C === !0 || C === !1 || ut(C) && Lt(C) == oe;
      }
      var xr = fl || hi, J5 = Vi ? Dt(Vi) : o2;
      function ec(C) {
        return ut(C) && C.nodeType === 1 && !dn(C);
      }
      function tc(C) {
        if (C == null)
          return !0;
        if (Rt(C) && (Ze(C) || typeof C == "string" || typeof C.splice == "function" || xr(C) || Wr(C) || Pr(C)))
          return !C.length;
        var b = Mt(C);
        if (b == ye || b == me)
          return !C.size;
        if (cn(C))
          return !R1(C).length;
        for (var $ in C)
          if (it.call(C, $))
            return !1;
        return !0;
      }
      function rc(C, b) {
        return an(C, b);
      }
      function nc(C, b, $) {
        $ = typeof $ == "function" ? $ : s;
        var O = $ ? $(C, b) : s;
        return O === s ? an(C, b, s, $) : !!O;
      }
      function ni(C) {
        if (!ut(C))
          return !1;
        var b = Lt(C);
        return b == ue || b == ve || typeof C.message == "string" && typeof C.name == "string" && !dn(C);
      }
      function ic(C) {
        return typeof C == "number" && ra(C);
      }
      function cr(C) {
        if (!ct(C))
          return !1;
        var b = Lt(C);
        return b == pe || b == we || b == ie || b == de;
      }
      function _o(C) {
        return typeof C == "number" && C == We(C);
      }
      function Qn(C) {
        return typeof C == "number" && C > -1 && C % 1 == 0 && C <= D;
      }
      function ct(C) {
        var b = typeof C;
        return C != null && (b == "object" || b == "function");
      }
      function ut(C) {
        return C != null && typeof C == "object";
      }
      var So = Fi ? Dt(Fi) : l2;
      function ac(C, b) {
        return C === b || P1(C, b, U1(b));
      }
      function oc(C, b, $) {
        return $ = typeof $ == "function" ? $ : s, P1(C, b, U1(b), $);
      }
      function sc(C) {
        return Mo(C) && C != +C;
      }
      function lc(C) {
        if (W2(C))
          throw new Ne(d);
        return ma(C);
      }
      function cc(C) {
        return C === null;
      }
      function uc(C) {
        return C == null;
      }
      function Mo(C) {
        return typeof C == "number" || ut(C) && Lt(C) == Ie;
      }
      function dn(C) {
        if (!ut(C) || Lt(C) != ne)
          return !1;
        var b = Mn(C);
        if (b === null)
          return !0;
        var $ = it.call(b, "constructor") && b.constructor;
        return typeof $ == "function" && $ instanceof $ && bn.call($) == ol;
      }
      var ii = ji ? Dt(ji) : c2;
      function dc(C) {
        return _o(C) && C >= -D && C <= D;
      }
      var To = Oi ? Dt(Oi) : u2;
      function Jn(C) {
        return typeof C == "string" || !Ze(C) && ut(C) && Lt(C) == xe;
      }
      function Ft(C) {
        return typeof C == "symbol" || ut(C) && Lt(C) == Se;
      }
      var Wr = Hi ? Dt(Hi) : d2;
      function fc(C) {
        return C === s;
      }
      function hc(C) {
        return ut(C) && Mt(C) == Pe;
      }
      function pc(C) {
        return ut(C) && Lt(C) == ke;
      }
      var mc = Zn($1), gc = Zn(function(C, b) {
        return C <= b;
      });
      function Lo(C) {
        if (!C)
          return [];
        if (Rt(C))
          return Jn(C) ? qt(C) : Pt(C);
        if (Kr && C[Kr])
          return qs(C[Kr]());
        var b = Mt(C), $ = b == ye ? y1 : b == me ? vn : Gr;
        return $(C);
      }
      function ur(C) {
        if (!C)
          return C === 0 ? C : 0;
        if (C = Ut(C), C === N || C === -N) {
          var b = C < 0 ? -1 : 1;
          return b * j;
        }
        return C === C ? C : 0;
      }
      function We(C) {
        var b = ur(C), $ = b % 1;
        return b === b ? $ ? b - $ : b : 0;
      }
      function Io(C) {
        return C ? Tr(We(C), 0, W) : 0;
      }
      function Ut(C) {
        if (typeof C == "number")
          return C;
        if (Ft(C))
          return H;
        if (ct(C)) {
          var b = typeof C.valueOf == "function" ? C.valueOf() : C;
          C = ct(b) ? b + "" : b;
        }
        if (typeof C != "string")
          return C === 0 ? C : +C;
        C = Gi(C);
        var $ = Ko.test(C);
        return $ || Qo.test(C) ? Rs(C.slice(2), $ ? 2 : 8) : Yo.test(C) ? H : +C;
      }
      function Eo(C) {
        return Jt(C, $t(C));
      }
      function Cc(C) {
        return C ? Tr(We(C), -D, D) : C === 0 ? C : 0;
      }
      function rt(C) {
        return C == null ? "" : Vt(C);
      }
      var vc = Nr(function(C, b) {
        if (cn(b) || Rt(b)) {
          Jt(b, yt(b), C);
          return;
        }
        for (var $ in b)
          it.call(b, $) && tn(C, $, b[$]);
      }), Po = Nr(function(C, b) {
        Jt(b, $t(b), C);
      }), e1 = Nr(function(C, b, $, O) {
        Jt(b, $t(b), C, O);
      }), yc = Nr(function(C, b, $, O) {
        Jt(b, yt(b), C, O);
      }), xc = sr(M1);
      function bc(C, b) {
        var $ = Br(C);
        return b == null ? $ : sa($, b);
      }
      var wc = qe(function(C, b) {
        C = at(C);
        var $ = -1, O = b.length, Y = O > 2 ? b[2] : s;
        for (Y && It(b[0], b[1], Y) && (O = 1); ++$ < O; )
          for (var te = b[$], le = $t(te), ce = -1, ge = le.length; ++ce < ge; ) {
            var Me = le[ce], Te = C[Me];
            (Te === s || Kt(Te, jr[Me]) && !it.call(C, Me)) && (C[Me] = te[Me]);
          }
        return C;
      }), _c = qe(function(C) {
        return C.push(s, Ga), kt(Ro, s, C);
      });
      function Sc(C, b) {
        return Ni(C, je(b, 3), Qt);
      }
      function Mc(C, b) {
        return Ni(C, je(b, 3), L1);
      }
      function Tc(C, b) {
        return C == null ? C : T1(C, je(b, 3), $t);
      }
      function Lc(C, b) {
        return C == null ? C : fa(C, je(b, 3), $t);
      }
      function Ic(C, b) {
        return C && Qt(C, je(b, 3));
      }
      function Ec(C, b) {
        return C && L1(C, je(b, 3));
      }
      function Pc(C) {
        return C == null ? [] : Dn(C, yt(C));
      }
      function Rc(C) {
        return C == null ? [] : Dn(C, $t(C));
      }
      function ai(C, b, $) {
        var O = C == null ? s : Lr(C, b);
        return O === s ? $ : O;
      }
      function $c(C, b) {
        return C != null && Ya(C, b, t2);
      }
      function oi(C, b) {
        return C != null && Ya(C, b, r2);
      }
      var Ac = Ba(function(C, b, $) {
        b != null && typeof b.toString != "function" && (b = wn.call(b)), C[b] = $;
      }, li(At)), kc = Ba(function(C, b, $) {
        b != null && typeof b.toString != "function" && (b = wn.call(b)), it.call(C, b) ? C[b].push($) : C[b] = [$];
      }, je), Dc = qe(nn);
      function yt(C) {
        return Rt(C) ? aa(C) : R1(C);
      }
      function $t(C) {
        return Rt(C) ? aa(C, !0) : f2(C);
      }
      function Vc(C, b) {
        var $ = {};
        return b = je(b, 3), Qt(C, function(O, Y, te) {
          ar($, b(O, Y, te), O);
        }), $;
      }
      function Fc(C, b) {
        var $ = {};
        return b = je(b, 3), Qt(C, function(O, Y, te) {
          ar($, Y, b(O, Y, te));
        }), $;
      }
      var jc = Nr(function(C, b, $) {
        Vn(C, b, $);
      }), Ro = Nr(function(C, b, $, O) {
        Vn(C, b, $, O);
      }), Oc = sr(function(C, b) {
        var $ = {};
        if (C == null)
          return $;
        var O = !1;
        b = lt(b, function(te) {
          return te = vr(te, C), O || (O = te.length > 1), te;
        }), Jt(C, W1(C), $), O && ($ = zt($, y | x | w, A2));
        for (var Y = b.length; Y--; )
          F1($, b[Y]);
        return $;
      });
      function Hc(C, b) {
        return $o(C, Xn(je(b)));
      }
      var Bc = sr(function(C, b) {
        return C == null ? {} : p2(C, b);
      });
      function $o(C, b) {
        if (C == null)
          return {};
        var $ = lt(W1(C), function(O) {
          return [O];
        });
        return b = je(b), wa(C, $, function(O, Y) {
          return b(O, Y[0]);
        });
      }
      function Nc(C, b, $) {
        b = vr(b, C);
        var O = -1, Y = b.length;
        for (Y || (Y = 1, C = s); ++O < Y; ) {
          var te = C == null ? s : C[er(b[O])];
          te === s && (O = Y, te = $), C = cr(te) ? te.call(C) : te;
        }
        return C;
      }
      function Zc(C, b, $) {
        return C == null ? C : sn(C, b, $);
      }
      function zc(C, b, $, O) {
        return O = typeof O == "function" ? O : s, C == null ? C : sn(C, b, $, O);
      }
      var Ao = za(yt), ko = za($t);
      function Wc(C, b, $) {
        var O = Ze(C), Y = O || xr(C) || Wr(C);
        if (b = je(b, 4), $ == null) {
          var te = C && C.constructor;
          Y ? $ = O ? new te() : [] : ct(C) ? $ = cr(te) ? Br(Mn(C)) : {} : $ = {};
        }
        return (Y ? Bt : Qt)(C, function(le, ce, ge) {
          return b($, le, ce, ge);
        }), $;
      }
      function Gc(C, b) {
        return C == null ? !0 : F1(C, b);
      }
      function Uc(C, b, $) {
        return C == null ? C : La(C, b, H1($));
      }
      function qc(C, b, $, O) {
        return O = typeof O == "function" ? O : s, C == null ? C : La(C, b, H1($), O);
      }
      function Gr(C) {
        return C == null ? [] : v1(C, yt(C));
      }
      function Yc(C) {
        return C == null ? [] : v1(C, $t(C));
      }
      function Kc(C, b, $) {
        return $ === s && ($ = b, b = s), $ !== s && ($ = Ut($), $ = $ === $ ? $ : 0), b !== s && (b = Ut(b), b = b === b ? b : 0), Tr(Ut(C), b, $);
      }
      function Xc(C, b, $) {
        return b = ur(b), $ === s ? ($ = b, b = 0) : $ = ur($), C = Ut(C), n2(C, b, $);
      }
      function Qc(C, b, $) {
        if ($ && typeof $ != "boolean" && It(C, b, $) && (b = $ = s), $ === s && (typeof b == "boolean" ? ($ = b, b = s) : typeof C == "boolean" && ($ = C, C = s)), C === s && b === s ? (C = 0, b = 1) : (C = ur(C), b === s ? (b = C, C = 0) : b = ur(b)), C > b) {
          var O = C;
          C = b, b = O;
        }
        if ($ || C % 1 || b % 1) {
          var Y = na();
          return St(C + Y * (b - C + Ps("1e-" + ((Y + "").length - 1))), b);
        }
        return k1(C, b);
      }
      var Jc = Zr(function(C, b, $) {
        return b = b.toLowerCase(), C + ($ ? Do(b) : b);
      });
      function Do(C) {
        return si(rt(C).toLowerCase());
      }
      function Vo(C) {
        return C = rt(C), C && C.replace(es, Zs).replace(xs, "");
      }
      function eu(C, b, $) {
        C = rt(C), b = Vt(b);
        var O = C.length;
        $ = $ === s ? O : Tr(We($), 0, O);
        var Y = $;
        return $ -= b.length, $ >= 0 && C.slice($, Y) == b;
      }
      function tu(C) {
        return C = rt(C), C && Be.test(C) ? C.replace(rr, zs) : C;
      }
      function ru(C) {
        return C = rt(C), C && qr.test(C) ? C.replace(fn, "\\$&") : C;
      }
      var nu = Zr(function(C, b, $) {
        return C + ($ ? "-" : "") + b.toLowerCase();
      }), iu = Zr(function(C, b, $) {
        return C + ($ ? " " : "") + b.toLowerCase();
      }), au = ja("toLowerCase");
      function ou(C, b, $) {
        C = rt(C), b = We(b);
        var O = b ? Vr(C) : 0;
        if (!b || O >= b)
          return C;
        var Y = (b - O) / 2;
        return Nn(En(Y), $) + C + Nn(In(Y), $);
      }
      function su(C, b, $) {
        C = rt(C), b = We(b);
        var O = b ? Vr(C) : 0;
        return b && O < b ? C + Nn(b - O, $) : C;
      }
      function lu(C, b, $) {
        C = rt(C), b = We(b);
        var O = b ? Vr(C) : 0;
        return b && O < b ? Nn(b - O, $) + C : C;
      }
      function cu(C, b, $) {
        return $ || b == null ? b = 0 : b && (b = +b), gl(rt(C).replace(n1, ""), b || 0);
      }
      function uu(C, b, $) {
        return ($ ? It(C, b, $) : b === s) ? b = 1 : b = We(b), D1(rt(C), b);
      }
      function du() {
        var C = arguments, b = rt(C[0]);
        return C.length < 3 ? b : b.replace(C[1], C[2]);
      }
      var fu = Zr(function(C, b, $) {
        return C + ($ ? "_" : "") + b.toLowerCase();
      });
      function hu(C, b, $) {
        return $ && typeof $ != "number" && It(C, b, $) && (b = $ = s), $ = $ === s ? W : $ >>> 0, $ ? (C = rt(C), C && (typeof b == "string" || b != null && !ii(b)) && (b = Vt(b), !b && Dr(C)) ? yr(qt(C), 0, $) : C.split(b, $)) : [];
      }
      var pu = Zr(function(C, b, $) {
        return C + ($ ? " " : "") + si(b);
      });
      function mu(C, b, $) {
        return C = rt(C), $ = $ == null ? 0 : Tr(We($), 0, C.length), b = Vt(b), C.slice($, $ + b.length) == b;
      }
      function gu(C, b, $) {
        var O = Q.templateSettings;
        $ && It(C, b, $) && (b = s), C = rt(C), b = e1({}, b, O, Wa);
        var Y = e1({}, b.imports, O.imports, Wa), te = yt(Y), le = v1(Y, te), ce, ge, Me = 0, Te = b.interpolate || hn, Le = "__p += '", $e = x1(
          (b.escape || hn).source + "|" + Te.source + "|" + (Te === Ur ? qo : hn).source + "|" + (b.evaluate || hn).source + "|$",
          "g"
        ), Ve = "//# sourceURL=" + (it.call(b, "sourceURL") ? (b.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ms + "]") + `
`;
        C.replace($e, function(He, Ke, Je, jt, Et, Ot) {
          return Je || (Je = jt), Le += C.slice(Me, Ot).replace(ts, Ws), Ke && (ce = !0, Le += `' +
__e(` + Ke + `) +
'`), Et && (ge = !0, Le += `';
` + Et + `;
__p += '`), Je && (Le += `' +
((__t = (` + Je + `)) == null ? '' : __t) +
'`), Me = Ot + He.length, He;
        }), Le += `';
`;
        var Oe = it.call(b, "variable") && b.variable;
        if (!Oe)
          Le = `with (obj) {
` + Le + `
}
`;
        else if (Go.test(Oe))
          throw new Ne(p);
        Le = (ge ? Le.replace(vt, "") : Le).replace(xt, "$1").replace(mt, "$1;"), Le = "function(" + (Oe || "obj") + `) {
` + (Oe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ce ? ", __e = _.escape" : "") + (ge ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Le + `return __p
}`;
        var Ue = jo(function() {
          return tt(te, Ve + "return " + Le).apply(s, le);
        });
        if (Ue.source = Le, ni(Ue))
          throw Ue;
        return Ue;
      }
      function Cu(C) {
        return rt(C).toLowerCase();
      }
      function vu(C) {
        return rt(C).toUpperCase();
      }
      function yu(C, b, $) {
        if (C = rt(C), C && ($ || b === s))
          return Gi(C);
        if (!C || !(b = Vt(b)))
          return C;
        var O = qt(C), Y = qt(b), te = Ui(O, Y), le = qi(O, Y) + 1;
        return yr(O, te, le).join("");
      }
      function xu(C, b, $) {
        if (C = rt(C), C && ($ || b === s))
          return C.slice(0, Ki(C) + 1);
        if (!C || !(b = Vt(b)))
          return C;
        var O = qt(C), Y = qi(O, qt(b)) + 1;
        return yr(O, 0, Y).join("");
      }
      function bu(C, b, $) {
        if (C = rt(C), C && ($ || b === s))
          return C.replace(n1, "");
        if (!C || !(b = Vt(b)))
          return C;
        var O = qt(C), Y = Ui(O, qt(b));
        return yr(O, Y).join("");
      }
      function wu(C, b) {
        var $ = q, O = z;
        if (ct(b)) {
          var Y = "separator" in b ? b.separator : Y;
          $ = "length" in b ? We(b.length) : $, O = "omission" in b ? Vt(b.omission) : O;
        }
        C = rt(C);
        var te = C.length;
        if (Dr(C)) {
          var le = qt(C);
          te = le.length;
        }
        if ($ >= te)
          return C;
        var ce = $ - Vr(O);
        if (ce < 1)
          return O;
        var ge = le ? yr(le, 0, ce).join("") : C.slice(0, ce);
        if (Y === s)
          return ge + O;
        if (le && (ce += ge.length - ce), ii(Y)) {
          if (C.slice(ce).search(Y)) {
            var Me, Te = ge;
            for (Y.global || (Y = x1(Y.source, rt(pi.exec(Y)) + "g")), Y.lastIndex = 0; Me = Y.exec(Te); )
              var Le = Me.index;
            ge = ge.slice(0, Le === s ? ce : Le);
          }
        } else if (C.indexOf(Vt(Y), ce) != ce) {
          var $e = ge.lastIndexOf(Y);
          $e > -1 && (ge = ge.slice(0, $e));
        }
        return ge + O;
      }
      function _u(C) {
        return C = rt(C), C && br.test(C) ? C.replace(tr, Qs) : C;
      }
      var Su = Zr(function(C, b, $) {
        return C + ($ ? " " : "") + b.toUpperCase();
      }), si = ja("toUpperCase");
      function Fo(C, b, $) {
        return C = rt(C), b = $ ? s : b, b === s ? Us(C) ? tl(C) : js(C) : C.match(b) || [];
      }
      var jo = qe(function(C, b) {
        try {
          return kt(C, s, b);
        } catch ($) {
          return ni($) ? $ : new Ne($);
        }
      }), Mu = sr(function(C, b) {
        return Bt(b, function($) {
          $ = er($), ar(C, $, ti(C[$], C));
        }), C;
      });
      function Tu(C) {
        var b = C == null ? 0 : C.length, $ = je();
        return C = b ? lt(C, function(O) {
          if (typeof O[1] != "function")
            throw new Nt(h);
          return [$(O[0]), O[1]];
        }) : [], qe(function(O) {
          for (var Y = -1; ++Y < b; ) {
            var te = C[Y];
            if (kt(te[0], this, O))
              return kt(te[1], this, O);
          }
        });
      }
      function Lu(C) {
        return Ql(zt(C, y));
      }
      function li(C) {
        return function() {
          return C;
        };
      }
      function Iu(C, b) {
        return C == null || C !== C ? b : C;
      }
      var Eu = Ha(), Pu = Ha(!0);
      function At(C) {
        return C;
      }
      function ci(C) {
        return ga(typeof C == "function" ? C : zt(C, y));
      }
      function Ru(C) {
        return va(zt(C, y));
      }
      function $u(C, b) {
        return ya(C, zt(b, y));
      }
      var Au = qe(function(C, b) {
        return function($) {
          return nn($, C, b);
        };
      }), ku = qe(function(C, b) {
        return function($) {
          return nn(C, $, b);
        };
      });
      function ui(C, b, $) {
        var O = yt(b), Y = Dn(b, O);
        $ == null && !(ct(b) && (Y.length || !O.length)) && ($ = b, b = C, C = this, Y = Dn(b, yt(b)));
        var te = !(ct($) && "chain" in $) || !!$.chain, le = cr(C);
        return Bt(Y, function(ce) {
          var ge = b[ce];
          C[ce] = ge, le && (C.prototype[ce] = function() {
            var Me = this.__chain__;
            if (te || Me) {
              var Te = C(this.__wrapped__), Le = Te.__actions__ = Pt(this.__actions__);
              return Le.push({ func: ge, args: arguments, thisArg: C }), Te.__chain__ = Me, Te;
            }
            return ge.apply(C, hr([this.value()], arguments));
          });
        }), C;
      }
      function Du() {
        return bt._ === this && (bt._ = sl), this;
      }
      function di() {
      }
      function Vu(C) {
        return C = We(C), qe(function(b) {
          return xa(b, C);
        });
      }
      var Fu = N1(lt), ju = N1(Bi), Ou = N1(h1);
      function Oo(C) {
        return Y1(C) ? p1(er(C)) : m2(C);
      }
      function Hu(C) {
        return function(b) {
          return C == null ? s : Lr(C, b);
        };
      }
      var Bu = Na(), Nu = Na(!0);
      function fi() {
        return [];
      }
      function hi() {
        return !1;
      }
      function Zu() {
        return {};
      }
      function zu() {
        return "";
      }
      function Wu() {
        return !0;
      }
      function Gu(C, b) {
        if (C = We(C), C < 1 || C > D)
          return [];
        var $ = W, O = St(C, W);
        b = je(b), C -= W;
        for (var Y = C1(O, b); ++$ < C; )
          b($);
        return Y;
      }
      function Uu(C) {
        return Ze(C) ? lt(C, er) : Ft(C) ? [C] : Pt(io(rt(C)));
      }
      function qu(C) {
        var b = ++al;
        return rt(C) + b;
      }
      var Yu = Bn(function(C, b) {
        return C + b;
      }, 0), Ku = Z1("ceil"), Xu = Bn(function(C, b) {
        return C / b;
      }, 1), Qu = Z1("floor");
      function Ju(C) {
        return C && C.length ? kn(C, At, I1) : s;
      }
      function e4(C, b) {
        return C && C.length ? kn(C, je(b, 2), I1) : s;
      }
      function t4(C) {
        return zi(C, At);
      }
      function r4(C, b) {
        return zi(C, je(b, 2));
      }
      function n4(C) {
        return C && C.length ? kn(C, At, $1) : s;
      }
      function i4(C, b) {
        return C && C.length ? kn(C, je(b, 2), $1) : s;
      }
      var a4 = Bn(function(C, b) {
        return C * b;
      }, 1), o4 = Z1("round"), s4 = Bn(function(C, b) {
        return C - b;
      }, 0);
      function l4(C) {
        return C && C.length ? g1(C, At) : 0;
      }
      function c4(C, b) {
        return C && C.length ? g1(C, je(b, 2)) : 0;
      }
      return Q.after = R5, Q.ary = go, Q.assign = vc, Q.assignIn = Po, Q.assignInWith = e1, Q.assignWith = yc, Q.at = xc, Q.before = Co, Q.bind = ti, Q.bindAll = Mu, Q.bindKey = vo, Q.castArray = Z5, Q.chain = ho, Q.chunk = Q2, Q.compact = J2, Q.concat = e0, Q.cond = Tu, Q.conforms = Lu, Q.constant = li, Q.countBy = l5, Q.create = bc, Q.curry = yo, Q.curryRight = xo, Q.debounce = bo, Q.defaults = wc, Q.defaultsDeep = _c, Q.defer = $5, Q.delay = A5, Q.difference = t0, Q.differenceBy = r0, Q.differenceWith = n0, Q.drop = i0, Q.dropRight = a0, Q.dropRightWhile = o0, Q.dropWhile = s0, Q.fill = l0, Q.filter = u5, Q.flatMap = h5, Q.flatMapDeep = p5, Q.flatMapDepth = m5, Q.flatten = lo, Q.flattenDeep = c0, Q.flattenDepth = u0, Q.flip = k5, Q.flow = Eu, Q.flowRight = Pu, Q.fromPairs = d0, Q.functions = Pc, Q.functionsIn = Rc, Q.groupBy = g5, Q.initial = h0, Q.intersection = p0, Q.intersectionBy = m0, Q.intersectionWith = g0, Q.invert = Ac, Q.invertBy = kc, Q.invokeMap = v5, Q.iteratee = ci, Q.keyBy = y5, Q.keys = yt, Q.keysIn = $t, Q.map = qn, Q.mapKeys = Vc, Q.mapValues = Fc, Q.matches = Ru, Q.matchesProperty = $u, Q.memoize = Kn, Q.merge = jc, Q.mergeWith = Ro, Q.method = Au, Q.methodOf = ku, Q.mixin = ui, Q.negate = Xn, Q.nthArg = Vu, Q.omit = Oc, Q.omitBy = Hc, Q.once = D5, Q.orderBy = x5, Q.over = Fu, Q.overArgs = V5, Q.overEvery = ju, Q.overSome = Ou, Q.partial = ri, Q.partialRight = wo, Q.partition = b5, Q.pick = Bc, Q.pickBy = $o, Q.property = Oo, Q.propertyOf = Hu, Q.pull = x0, Q.pullAll = uo, Q.pullAllBy = b0, Q.pullAllWith = w0, Q.pullAt = _0, Q.range = Bu, Q.rangeRight = Nu, Q.rearg = F5, Q.reject = S5, Q.remove = S0, Q.rest = j5, Q.reverse = J1, Q.sampleSize = T5, Q.set = Zc, Q.setWith = zc, Q.shuffle = L5, Q.slice = M0, Q.sortBy = P5, Q.sortedUniq = $0, Q.sortedUniqBy = A0, Q.split = hu, Q.spread = O5, Q.tail = k0, Q.take = D0, Q.takeRight = V0, Q.takeRightWhile = F0, Q.takeWhile = j0, Q.tap = J0, Q.throttle = H5, Q.thru = Un, Q.toArray = Lo, Q.toPairs = Ao, Q.toPairsIn = ko, Q.toPath = Uu, Q.toPlainObject = Eo, Q.transform = Wc, Q.unary = B5, Q.union = O0, Q.unionBy = H0, Q.unionWith = B0, Q.uniq = N0, Q.uniqBy = Z0, Q.uniqWith = z0, Q.unset = Gc, Q.unzip = ei, Q.unzipWith = fo, Q.update = Uc, Q.updateWith = qc, Q.values = Gr, Q.valuesIn = Yc, Q.without = W0, Q.words = Fo, Q.wrap = N5, Q.xor = G0, Q.xorBy = U0, Q.xorWith = q0, Q.zip = Y0, Q.zipObject = K0, Q.zipObjectDeep = X0, Q.zipWith = Q0, Q.entries = Ao, Q.entriesIn = ko, Q.extend = Po, Q.extendWith = e1, ui(Q, Q), Q.add = Yu, Q.attempt = jo, Q.camelCase = Jc, Q.capitalize = Do, Q.ceil = Ku, Q.clamp = Kc, Q.clone = z5, Q.cloneDeep = G5, Q.cloneDeepWith = U5, Q.cloneWith = W5, Q.conformsTo = q5, Q.deburr = Vo, Q.defaultTo = Iu, Q.divide = Xu, Q.endsWith = eu, Q.eq = Kt, Q.escape = tu, Q.escapeRegExp = ru, Q.every = c5, Q.find = d5, Q.findIndex = oo, Q.findKey = Sc, Q.findLast = f5, Q.findLastIndex = so, Q.findLastKey = Mc, Q.floor = Qu, Q.forEach = po, Q.forEachRight = mo, Q.forIn = Tc, Q.forInRight = Lc, Q.forOwn = Ic, Q.forOwnRight = Ec, Q.get = ai, Q.gt = Y5, Q.gte = K5, Q.has = $c, Q.hasIn = oi, Q.head = co, Q.identity = At, Q.includes = C5, Q.indexOf = f0, Q.inRange = Xc, Q.invoke = Dc, Q.isArguments = Pr, Q.isArray = Ze, Q.isArrayBuffer = X5, Q.isArrayLike = Rt, Q.isArrayLikeObject = dt, Q.isBoolean = Q5, Q.isBuffer = xr, Q.isDate = J5, Q.isElement = ec, Q.isEmpty = tc, Q.isEqual = rc, Q.isEqualWith = nc, Q.isError = ni, Q.isFinite = ic, Q.isFunction = cr, Q.isInteger = _o, Q.isLength = Qn, Q.isMap = So, Q.isMatch = ac, Q.isMatchWith = oc, Q.isNaN = sc, Q.isNative = lc, Q.isNil = uc, Q.isNull = cc, Q.isNumber = Mo, Q.isObject = ct, Q.isObjectLike = ut, Q.isPlainObject = dn, Q.isRegExp = ii, Q.isSafeInteger = dc, Q.isSet = To, Q.isString = Jn, Q.isSymbol = Ft, Q.isTypedArray = Wr, Q.isUndefined = fc, Q.isWeakMap = hc, Q.isWeakSet = pc, Q.join = C0, Q.kebabCase = nu, Q.last = Gt, Q.lastIndexOf = v0, Q.lowerCase = iu, Q.lowerFirst = au, Q.lt = mc, Q.lte = gc, Q.max = Ju, Q.maxBy = e4, Q.mean = t4, Q.meanBy = r4, Q.min = n4, Q.minBy = i4, Q.stubArray = fi, Q.stubFalse = hi, Q.stubObject = Zu, Q.stubString = zu, Q.stubTrue = Wu, Q.multiply = a4, Q.nth = y0, Q.noConflict = Du, Q.noop = di, Q.now = Yn, Q.pad = ou, Q.padEnd = su, Q.padStart = lu, Q.parseInt = cu, Q.random = Qc, Q.reduce = w5, Q.reduceRight = _5, Q.repeat = uu, Q.replace = du, Q.result = Nc, Q.round = o4, Q.runInContext = he, Q.sample = M5, Q.size = I5, Q.snakeCase = fu, Q.some = E5, Q.sortedIndex = T0, Q.sortedIndexBy = L0, Q.sortedIndexOf = I0, Q.sortedLastIndex = E0, Q.sortedLastIndexBy = P0, Q.sortedLastIndexOf = R0, Q.startCase = pu, Q.startsWith = mu, Q.subtract = s4, Q.sum = l4, Q.sumBy = c4, Q.template = gu, Q.times = Gu, Q.toFinite = ur, Q.toInteger = We, Q.toLength = Io, Q.toLower = Cu, Q.toNumber = Ut, Q.toSafeInteger = Cc, Q.toString = rt, Q.toUpper = vu, Q.trim = yu, Q.trimEnd = xu, Q.trimStart = bu, Q.truncate = wu, Q.unescape = _u, Q.uniqueId = qu, Q.upperCase = Su, Q.upperFirst = si, Q.each = po, Q.eachRight = mo, Q.first = co, ui(Q, function() {
        var C = {};
        return Qt(Q, function(b, $) {
          it.call(Q.prototype, $) || (C[$] = b);
        }), C;
      }(), { chain: !1 }), Q.VERSION = c, Bt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(C) {
        Q[C].placeholder = Q;
      }), Bt(["drop", "take"], function(C, b) {
        Qe.prototype[C] = function($) {
          $ = $ === s ? 1 : Ct(We($), 0);
          var O = this.__filtered__ && !b ? new Qe(this) : this.clone();
          return O.__filtered__ ? O.__takeCount__ = St($, O.__takeCount__) : O.__views__.push({
            size: St($, W),
            type: C + (O.__dir__ < 0 ? "Right" : "")
          }), O;
        }, Qe.prototype[C + "Right"] = function($) {
          return this.reverse()[C]($).reverse();
        };
      }), Bt(["filter", "map", "takeWhile"], function(C, b) {
        var $ = b + 1, O = $ == K || $ == F;
        Qe.prototype[C] = function(Y) {
          var te = this.clone();
          return te.__iteratees__.push({
            iteratee: je(Y, 3),
            type: $
          }), te.__filtered__ = te.__filtered__ || O, te;
        };
      }), Bt(["head", "last"], function(C, b) {
        var $ = "take" + (b ? "Right" : "");
        Qe.prototype[C] = function() {
          return this[$](1).value()[0];
        };
      }), Bt(["initial", "tail"], function(C, b) {
        var $ = "drop" + (b ? "" : "Right");
        Qe.prototype[C] = function() {
          return this.__filtered__ ? new Qe(this) : this[$](1);
        };
      }), Qe.prototype.compact = function() {
        return this.filter(At);
      }, Qe.prototype.find = function(C) {
        return this.filter(C).head();
      }, Qe.prototype.findLast = function(C) {
        return this.reverse().find(C);
      }, Qe.prototype.invokeMap = qe(function(C, b) {
        return typeof C == "function" ? new Qe(this) : this.map(function($) {
          return nn($, C, b);
        });
      }), Qe.prototype.reject = function(C) {
        return this.filter(Xn(je(C)));
      }, Qe.prototype.slice = function(C, b) {
        C = We(C);
        var $ = this;
        return $.__filtered__ && (C > 0 || b < 0) ? new Qe($) : (C < 0 ? $ = $.takeRight(-C) : C && ($ = $.drop(C)), b !== s && (b = We(b), $ = b < 0 ? $.dropRight(-b) : $.take(b - C)), $);
      }, Qe.prototype.takeRightWhile = function(C) {
        return this.reverse().takeWhile(C).reverse();
      }, Qe.prototype.toArray = function() {
        return this.take(W);
      }, Qt(Qe.prototype, function(C, b) {
        var $ = /^(?:filter|find|map|reject)|While$/.test(b), O = /^(?:head|last)$/.test(b), Y = Q[O ? "take" + (b == "last" ? "Right" : "") : b], te = O || /^find/.test(b);
        Y && (Q.prototype[b] = function() {
          var le = this.__wrapped__, ce = O ? [1] : arguments, ge = le instanceof Qe, Me = ce[0], Te = ge || Ze(le), Le = function(Ke) {
            var Je = Y.apply(Q, hr([Ke], ce));
            return O && $e ? Je[0] : Je;
          };
          Te && $ && typeof Me == "function" && Me.length != 1 && (ge = Te = !1);
          var $e = this.__chain__, Ve = !!this.__actions__.length, Oe = te && !$e, Ue = ge && !Ve;
          if (!te && Te) {
            le = Ue ? le : new Qe(this);
            var He = C.apply(le, ce);
            return He.__actions__.push({ func: Un, args: [Le], thisArg: s }), new Zt(He, $e);
          }
          return Oe && Ue ? C.apply(this, ce) : (He = this.thru(Le), Oe ? O ? He.value()[0] : He.value() : He);
        });
      }), Bt(["pop", "push", "shift", "sort", "splice", "unshift"], function(C) {
        var b = yn[C], $ = /^(?:push|sort|unshift)$/.test(C) ? "tap" : "thru", O = /^(?:pop|shift)$/.test(C);
        Q.prototype[C] = function() {
          var Y = arguments;
          if (O && !this.__chain__) {
            var te = this.value();
            return b.apply(Ze(te) ? te : [], Y);
          }
          return this[$](function(le) {
            return b.apply(Ze(le) ? le : [], Y);
          });
        };
      }), Qt(Qe.prototype, function(C, b) {
        var $ = Q[b];
        if ($) {
          var O = $.name + "";
          it.call(Hr, O) || (Hr[O] = []), Hr[O].push({ name: b, func: $ });
        }
      }), Hr[Hn(s, L).name] = [{
        name: "wrapper",
        func: s
      }], Qe.prototype.clone = _l, Qe.prototype.reverse = Sl, Qe.prototype.value = Ml, Q.prototype.at = e5, Q.prototype.chain = t5, Q.prototype.commit = r5, Q.prototype.next = n5, Q.prototype.plant = a5, Q.prototype.reverse = o5, Q.prototype.toJSON = Q.prototype.valueOf = Q.prototype.value = s5, Q.prototype.first = Q.prototype.head, Kr && (Q.prototype[Kr] = i5), Q;
    }, Fr = rl();
    wr ? ((wr.exports = Fr)._ = Fr, c1._ = Fr) : bt._ = Fr;
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const _ = /* @__PURE__ */ getDefaultExportFromCjs(lodashExports), useIntl = () => {
  const r = useIntl$1(), { timeZone: a, locale: s } = r, c = useCallback$1(
    (p, m = "USD", g) => r.formatNumber(p, { ...g, style: "currency", currencyDisplay: "narrowSymbol", currency: m }),
    [r]
  ), u = r.formatDate.bind(r), d = r.formatDateTimeRange.bind(r), h = r.formatNumberToParts.bind(r);
  return {
    locale: s,
    timeZone: a,
    formatCurrency: c,
    formatDate: u,
    formatDateTimeRange: d,
    formatNumberToParts: h
  };
}, useDateUtils = () => {
  const { timeZone: r, locale: a } = useIntl(), s = (p) => zonedTimeToUtc(p ? parseISO(p) : /* @__PURE__ */ new Date(), r), c = (p) => differenceInCalendarDays(
    lodashExports.isString(p) ? parseISO(p) : p,
    s()
  ) >= 0, u = (p) => lodashExports.isString(p) ? s(p) : p;
  return {
    createDate: s,
    isValidScheduledDate: c,
    isEqualDate: (p, m) => isEqual(u(p), u(m)),
    isDatePartEqual: (p, m) => p.toLocaleDateString(a, { timeZone: r }) === m.toLocaleDateString(a, { timeZone: r })
  };
}, getMatrix = (r, a) => {
  var u;
  const s = new Date(r, a, 1), c = Array.from({ length: 7 }).map(() => []);
  for (let d = 0; d < getDaysInMonth$1(a); d++)
    (u = c[getDay(setDate(s, d + 1))]) == null || u.push(d + 1);
  return c;
}, getWeekDayInMonth = (r, a, s) => getMatrix(r, a)[s], isHoliday = (r, a = "America/New_York") => {
  const s = utcToZonedTime(r, a), c = getYear(s), u = getMonth(s), d = getDate(s), h = getDay(s), p = h == Day$1.FRI, m = h == Day$1.MON, g = getWeekDayInMonth(c, u, h), v = (w, S, M) => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    u == w && h == S && g[M - 1] == d
  ), y = (w, S, M) => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    u == w && h == S && g[g.length - M] == d
  ), x = (w, S) => {
    const M = new Date(c, w, S);
    if (isSameDay(M, s)) return !0;
    const P = subDays(M, 1);
    if (getMonth(P) == u && getDate(P) == d && p) return !0;
    const L = addDays(M, 1);
    return !!(getMonth(L) == u && getDate(L) == d && m);
  };
  return !!(x(Month$1.JAN, 1) || x(Month$1.JUN, 19) || x(Month$1.JUL, 4) || x(Month$1.NOV, 11) || x(Month$1.DEC, 25) || v(Month$1.JAN, Day$1.MON, 3) || v(Month$1.FEB, Day$1.MON, 3) || v(Month$1.SEP, Day$1.MON, 1) || v(Month$1.OCT, Day$1.MON, 2) || v(Month$1.NOV, Day$1.THU, 4) || y(Month$1.MAY, Day$1.MON, 1));
}, useBoolean = (r = !1) => {
  const [a, s] = useState$1(r);
  return [
    a,
    {
      on: () => s(!0),
      off: () => s(!1),
      toggle: () => s(!a)
    }
  ];
};
function useResolvedElement(r, a) {
  var s = useRef$1(null), c = useRef$1(null);
  c.current = a;
  var u = useRef$1(null);
  useEffect$1(function() {
    d();
  });
  var d = useCallback$1(function() {
    var h = u.current, p = c.current, m = h || (p ? p instanceof Element ? p : p.current : null);
    s.current && s.current.element === m && s.current.subscriber === r || (s.current && s.current.cleanup && s.current.cleanup(), s.current = {
      element: m,
      subscriber: r,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: m ? r(m) : void 0
    });
  }, [r]);
  return useEffect$1(function() {
    return function() {
      s.current && s.current.cleanup && (s.current.cleanup(), s.current = null);
    };
  }, []), useCallback$1(function(h) {
    u.current = h, d();
  }, [d]);
}
function extractSize(r, a, s) {
  return r[a] ? r[a][0] ? r[a][0][s] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    r[a][s]
  ) : a === "contentBoxSize" ? r.contentRect[s === "inlineSize" ? "width" : "height"] : void 0;
}
function useResizeObserver$1(r) {
  r === void 0 && (r = {});
  var a = r.onResize, s = useRef$1(void 0);
  s.current = a;
  var c = r.round || Math.round, u = useRef$1(), d = useState$1({
    width: void 0,
    height: void 0
  }), h = d[0], p = d[1], m = useRef$1(!1);
  useEffect$1(function() {
    return m.current = !1, function() {
      m.current = !0;
    };
  }, []);
  var g = useRef$1({
    width: void 0,
    height: void 0
  }), v = useResolvedElement(useCallback$1(function(y) {
    return (!u.current || u.current.box !== r.box || u.current.round !== c) && (u.current = {
      box: r.box,
      round: c,
      instance: new ResizeObserver(function(x) {
        var w = x[0], S = r.box === "border-box" ? "borderBoxSize" : r.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", M = extractSize(w, S, "inlineSize"), P = extractSize(w, S, "blockSize"), L = M ? c(M) : void 0, I = P ? c(P) : void 0;
        if (g.current.width !== L || g.current.height !== I) {
          var T = {
            width: L,
            height: I
          };
          g.current.width = L, g.current.height = I, s.current ? s.current(T) : m.current || p(T);
        }
      })
    }), u.current.instance.observe(y, {
      box: r.box
    }), function() {
      u.current && u.current.instance.unobserve(y);
    };
  }, [r.box, c]), r.ref);
  return useMemo$1(function() {
    return {
      ref: v,
      width: h.width,
      height: h.height
    };
  }, [v, h.width, h.height]);
}
const useResizeObserver = (r) => useResizeObserver$1(r), useHasOverflow = (r) => {
  var x, w, S, M;
  const { width: a, height: s } = useResizeObserver({ ref: r }), c = r.current, u = (x = r.current) == null ? void 0 : x.scrollWidth, d = (w = r.current) == null ? void 0 : w.clientWidth, [h, p] = useState$1(!1);
  useLayoutEffect$1(() => {
    !c || !u || !d || p(u > d);
  }, [d, c, u, a]);
  const m = (S = r.current) == null ? void 0 : S.scrollHeight, g = (M = r.current) == null ? void 0 : M.clientHeight, [v, y] = useState$1(!1);
  return useLayoutEffect$1(() => {
    !c || !m || !g || y(m > g);
  }, [g, c, m, s]), { hasOverflowX: h, hasOverflowY: v };
}, useIntersectionObserver = ({ threshold: r = 0.1, root: a = null, rootMargin: s = "0px" } = {}) => {
  const [c, u] = useState$1(!1), d = useRef$1(null), h = useRef$1(null);
  return useEffect$1(() => {
    if (typeof window > "u" || !("IntersectionObserver" in window)) return;
    const p = d == null ? void 0 : d.current, m = new IntersectionObserver(
      ([g]) => {
        u(!!(g != null && g.isIntersecting));
      },
      { root: a, rootMargin: s, threshold: r }
    );
    return h.current && m.observe(h.current), () => {
      p && m.disconnect();
    };
  }, [a, s, r]), { targetRef: h, isVisible: c };
};
function useIsFirstRender() {
  const r = useRef$1(!0);
  return r.current ? (r.current = !1, !0) : r.current;
}
function useUpdateEffect$1(r, a) {
  const s = useIsFirstRender();
  useEffect$1(() => {
    s || r();
  }, a);
}
const useTestId = (r) => useCallback$1(
  (...s) => ({ "data-testid": [r, ...s].filter(Boolean).join("-") }),
  [r]
), VisuallyHidden = ({ "data-testid": r = "visually-hidden", ...a }) => {
  const s = useTestId(r);
  return /* @__PURE__ */ jsx(VisuallyHidden$1, { "data-component": "VisuallyHidden", ...s(), ...a });
};
VisuallyHidden.displayName = "VisuallyHidden";
function useStyleConfig(r, a) {
  return useStyleConfig$1(r, a);
}
function useMultiStyleConfig(r, a) {
  return useMultiStyleConfig$1(r, a);
}
const FallbackImage = () => {
  const r = useMultiStyleConfig("Image", {});
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "svg",
      fill: "none",
      __css: r.fallbackIcon,
      viewBox: "0 0 39 39",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.9476 11.6165C14.9476 13.3816 13.5167 14.8125 11.7516 14.8125C9.98657 14.8125 8.55569 13.3816 8.55569 11.6165C8.55569 9.85145 9.98657 8.42058 11.7516 8.42058C13.5167 8.42058 14.9476 9.85145 14.9476 11.6165Z",
            fill: "#A7A9B4"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.1638 6.82261C2.1638 4.175 4.31011 2.02869 6.95772 2.02869H32.5253C35.1729 2.02869 37.3192 4.175 37.3192 6.82261V29.1712C37.3194 29.1856 37.3194 29.2 37.3192 29.2144V32.3902C37.3192 35.0378 35.1729 37.1841 32.5253 37.1841H6.95772C4.31011 37.1841 2.1638 35.0378 2.1638 32.3902V6.82261ZM6.95772 5.22463H32.5253C33.4078 5.22463 34.1233 5.94007 34.1233 6.82261V24.0493L28.4588 15.8101C27.7959 14.8458 26.4314 14.695 25.5739 15.4913L15.8458 24.5244L12.3961 20.7092C11.6449 19.8785 10.3446 19.8656 9.57717 20.6813L5.35975 25.1638V6.82261C5.35975 5.94007 6.07519 5.22463 6.95772 5.22463ZM34.1233 29.6905V32.3902C34.1233 33.2727 33.4078 33.9881 32.5253 33.9881H6.95772C6.07519 33.9881 5.35975 33.2727 5.35975 32.3902V29.8278L10.9551 23.8807L14.3441 27.6288C15.061 28.4217 16.2879 28.4753 17.0712 27.7479L26.6638 18.8405L34.1233 29.6905Z",
            fill: "#A7A9B4"
          }
        )
      ] })
    }
  );
}, ImageComponent = (r, a) => {
  const {
    isDisabled: s,
    isReadOnly: c,
    src: u,
    onError: d,
    onClick: h,
    width: p,
    height: m,
    objectFit: g = "cover",
    objectPosition: v = "center",
    borderRadius: y,
    aspectRatio: x,
    ...w
  } = r, [S, M] = useState$1(!1), L = useMultiStyleConfig("Image", {
    objectFit: g,
    objectPosition: v,
    borderRadius: y,
    aspectRatio: x,
    variant: y === "full" || y === "global.full" ? "circle" : "square",
    width: p ?? (S ? "100%" : "auto"),
    height: m ?? (S ? "100%" : "inherit")
  }), I = (E) => {
    M(!0), d == null || d(E);
  };
  useEffect$1(() => {
    M(!1);
  }, [u]);
  const T = {
    "data-component": "Image",
    "aria-disabled": s,
    "data-readonly": c,
    onClick: !s && !c ? h : void 0,
    ref: a
  };
  return S ? /* @__PURE__ */ jsx(Box, { ...T, "data-testid": "fallback-image", __css: L.fallbackImage, children: /* @__PURE__ */ jsx(FallbackImage, {}) }) : /* @__PURE__ */ jsx(
    Box,
    {
      as: "img",
      ...T,
      ...w,
      role: h ? "button" : void 0,
      onError: I,
      __css: L.image,
      src: u
    }
  );
}, Image$1 = forwardRef$1(ImageComponent);
Image$1.displayName = "Image";
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(r, a) {
    module.exports = a();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(a) {
      _useWebWorker = !!a;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(a) {
      locationHref = a;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(r) {
      return document.createElement(r);
    }
    function extendPrototype(r, a) {
      var s, c = r.length, u;
      for (s = 0; s < c; s += 1) {
        u = r[s].prototype;
        for (var d in u)
          Object.prototype.hasOwnProperty.call(u, d) && (a.prototype[d] = u[d]);
      }
    }
    function getDescriptor(r, a) {
      return Object.getOwnPropertyDescriptor(r, a);
    }
    function createProxyFunction(r) {
      function a() {
      }
      return a.prototype = r, a;
    }
    var audioControllerFactory = function() {
      function r(a) {
        this.audios = [], this.audioFactory = a, this._volume = 1, this._isMuted = !1;
      }
      return r.prototype = {
        addAudio: function(s) {
          this.audios.push(s);
        },
        pause: function() {
          var s, c = this.audios.length;
          for (s = 0; s < c; s += 1)
            this.audios[s].pause();
        },
        resume: function() {
          var s, c = this.audios.length;
          for (s = 0; s < c; s += 1)
            this.audios[s].resume();
        },
        setRate: function(s) {
          var c, u = this.audios.length;
          for (c = 0; c < u; c += 1)
            this.audios[c].setRate(s);
        },
        createAudio: function(s) {
          return this.audioFactory ? this.audioFactory(s) : window.Howl ? new window.Howl({
            src: [s]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(s) {
          this.audioFactory = s;
        },
        setVolume: function(s) {
          this._volume = s, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var s, c = this.audios.length;
          for (s = 0; s < c; s += 1)
            this.audios[s].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new r();
      };
    }(), createTypedArray = /* @__PURE__ */ function() {
      function r(s, c) {
        var u = 0, d = [], h;
        switch (s) {
          case "int16":
          case "uint8c":
            h = 1;
            break;
          default:
            h = 1.1;
            break;
        }
        for (u = 0; u < c; u += 1)
          d.push(h);
        return d;
      }
      function a(s, c) {
        return s === "float32" ? new Float32Array(c) : s === "int16" ? new Int16Array(c) : s === "uint8c" ? new Uint8ClampedArray(c) : r(s, c);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? a : r;
    }();
    function createSizedArray(r) {
      return Array.apply(null, {
        length: r
      });
    }
    function _typeof$6(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(s) {
        return typeof s;
      } : _typeof$6 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$6(r);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var r = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], a, s = r.length;
      for (a = 0; a < s; a += 1)
        BMMath[r[a]] = Math[r[a]];
    })(), BMMath.random = Math.random, BMMath.abs = function(r) {
      var a = _typeof$6(r);
      if (a === "object" && r.length) {
        var s = createSizedArray(r.length), c, u = r.length;
        for (c = 0; c < u; c += 1)
          s[c] = Math.abs(r[c]);
        return s;
      }
      return Math.abs(r);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(r) {
      r.style.position = "absolute", r.style.top = 0, r.style.left = 0, r.style.display = "block", r.style.transformOrigin = "0 0", r.style.webkitTransformOrigin = "0 0", r.style.backfaceVisibility = "visible", r.style.webkitBackfaceVisibility = "visible", r.style.transformStyle = "preserve-3d", r.style.webkitTransformStyle = "preserve-3d", r.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(r, a, s, c) {
      this.type = r, this.currentTime = a, this.totalTime = s, this.direction = c < 0 ? -1 : 1;
    }
    function BMCompleteEvent(r, a) {
      this.type = r, this.direction = a < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(r, a, s, c) {
      this.type = r, this.currentLoop = s, this.totalLoops = a, this.direction = c < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(r, a, s) {
      this.type = r, this.firstFrame = a, this.totalFrames = s;
    }
    function BMDestroyEvent(r, a) {
      this.type = r, this.target = a;
    }
    function BMRenderFrameErrorEvent(r, a) {
      this.type = "renderFrameError", this.nativeError = r, this.currentTime = a;
    }
    function BMConfigErrorEvent(r) {
      this.type = "configError", this.nativeError = r;
    }
    var createElementID = /* @__PURE__ */ function() {
      var r = 0;
      return function() {
        return r += 1, idPrefix$1 + "__lottie_element_" + r;
      };
    }();
    function HSVtoRGB(r, a, s) {
      var c, u, d, h, p, m, g, v;
      switch (h = Math.floor(r * 6), p = r * 6 - h, m = s * (1 - a), g = s * (1 - p * a), v = s * (1 - (1 - p) * a), h % 6) {
        case 0:
          c = s, u = v, d = m;
          break;
        case 1:
          c = g, u = s, d = m;
          break;
        case 2:
          c = m, u = s, d = v;
          break;
        case 3:
          c = m, u = g, d = s;
          break;
        case 4:
          c = v, u = m, d = s;
          break;
        case 5:
          c = s, u = m, d = g;
          break;
      }
      return [c, u, d];
    }
    function RGBtoHSV(r, a, s) {
      var c = Math.max(r, a, s), u = Math.min(r, a, s), d = c - u, h, p = c === 0 ? 0 : d / c, m = c / 255;
      switch (c) {
        case u:
          h = 0;
          break;
        case r:
          h = a - s + d * (a < s ? 6 : 0), h /= 6 * d;
          break;
        case a:
          h = s - r + d * 2, h /= 6 * d;
          break;
        case s:
          h = r - a + d * 4, h /= 6 * d;
          break;
      }
      return [h, p, m];
    }
    function addSaturationToRGB(r, a) {
      var s = RGBtoHSV(r[0] * 255, r[1] * 255, r[2] * 255);
      return s[1] += a, s[1] > 1 ? s[1] = 1 : s[1] <= 0 && (s[1] = 0), HSVtoRGB(s[0], s[1], s[2]);
    }
    function addBrightnessToRGB(r, a) {
      var s = RGBtoHSV(r[0] * 255, r[1] * 255, r[2] * 255);
      return s[2] += a, s[2] > 1 ? s[2] = 1 : s[2] < 0 && (s[2] = 0), HSVtoRGB(s[0], s[1], s[2]);
    }
    function addHueToRGB(r, a) {
      var s = RGBtoHSV(r[0] * 255, r[1] * 255, r[2] * 255);
      return s[0] += a / 360, s[0] > 1 ? s[0] -= 1 : s[0] < 0 && (s[0] += 1), HSVtoRGB(s[0], s[1], s[2]);
    }
    var rgbToHex = function() {
      var r = [], a, s;
      for (a = 0; a < 256; a += 1)
        s = a.toString(16), r[a] = s.length === 1 ? "0" + s : s;
      return function(c, u, d) {
        return c < 0 && (c = 0), u < 0 && (u = 0), d < 0 && (d = 0), "#" + r[c] + r[u] + r[d];
      };
    }(), setSubframeEnabled = function(a) {
      subframeEnabled = !!a;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(a) {
      expressionsPlugin = a;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(a) {
      expressionsInterfaces = a;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(a) {
      defaultCurveSegments = a;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(a) {
      idPrefix$1 = a;
    };
    function createNS(r) {
      return document.createElementNS(svgNS, r);
    }
    function _typeof$5(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(s) {
        return typeof s;
      } : _typeof$5 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$5(r);
    }
    var dataManager = /* @__PURE__ */ function() {
      var r = 1, a = [], s, c, u = {
        onmessage: function() {
        },
        postMessage: function(w) {
          s({
            data: w
          });
        }
      }, d = {
        postMessage: function(w) {
          u.onmessage({
            data: w
          });
        }
      };
      function h(x) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var w = new Blob(["var _workerSelf = self; self.onmessage = ", x.toString()], {
            type: "text/javascript"
          }), S = URL.createObjectURL(w);
          return new Worker(S);
        }
        return s = x, u;
      }
      function p() {
        c || (c = h(function(w) {
          function S() {
            function P(U, F) {
              var N, D, j = U.length, H, W, re, ae;
              for (D = 0; D < j; D += 1)
                if (N = U[D], "ks" in N && !N.completed) {
                  if (N.completed = !0, N.hasMask) {
                    var ee = N.masksProperties;
                    for (W = ee.length, H = 0; H < W; H += 1)
                      if (ee[H].pt.k.i)
                        R(ee[H].pt.k);
                      else
                        for (ae = ee[H].pt.k.length, re = 0; re < ae; re += 1)
                          ee[H].pt.k[re].s && R(ee[H].pt.k[re].s[0]), ee[H].pt.k[re].e && R(ee[H].pt.k[re].e[0]);
                  }
                  N.ty === 0 ? (N.layers = T(N.refId, F), P(N.layers, F)) : N.ty === 4 ? E(N.shapes) : N.ty === 5 && G(N);
                }
            }
            function L(U, F) {
              if (U) {
                var N = 0, D = U.length;
                for (N = 0; N < D; N += 1)
                  U[N].t === 1 && (U[N].data.layers = T(U[N].data.refId, F), P(U[N].data.layers, F));
              }
            }
            function I(U, F) {
              for (var N = 0, D = F.length; N < D; ) {
                if (F[N].id === U)
                  return F[N];
                N += 1;
              }
              return null;
            }
            function T(U, F) {
              var N = I(U, F);
              return N ? N.layers.__used ? JSON.parse(JSON.stringify(N.layers)) : (N.layers.__used = !0, N.layers) : null;
            }
            function E(U) {
              var F, N = U.length, D, j;
              for (F = N - 1; F >= 0; F -= 1)
                if (U[F].ty === "sh")
                  if (U[F].ks.k.i)
                    R(U[F].ks.k);
                  else
                    for (j = U[F].ks.k.length, D = 0; D < j; D += 1)
                      U[F].ks.k[D].s && R(U[F].ks.k[D].s[0]), U[F].ks.k[D].e && R(U[F].ks.k[D].e[0]);
                else U[F].ty === "gr" && E(U[F].it);
            }
            function R(U) {
              var F, N = U.i.length;
              for (F = 0; F < N; F += 1)
                U.i[F][0] += U.v[F][0], U.i[F][1] += U.v[F][1], U.o[F][0] += U.v[F][0], U.o[F][1] += U.v[F][1];
            }
            function A(U, F) {
              var N = F ? F.split(".") : [100, 100, 100];
              return U[0] > N[0] ? !0 : N[0] > U[0] ? !1 : U[1] > N[1] ? !0 : N[1] > U[1] ? !1 : U[2] > N[2] ? !0 : N[2] > U[2] ? !1 : null;
            }
            var k = /* @__PURE__ */ function() {
              var U = [4, 4, 14];
              function F(D) {
                var j = D.t.d;
                D.t.d = {
                  k: [{
                    s: j,
                    t: 0
                  }]
                };
              }
              function N(D) {
                var j, H = D.length;
                for (j = 0; j < H; j += 1)
                  D[j].ty === 5 && F(D[j]);
              }
              return function(D) {
                if (A(U, D.v) && (N(D.layers), D.assets)) {
                  var j, H = D.assets.length;
                  for (j = 0; j < H; j += 1)
                    D.assets[j].layers && N(D.assets[j].layers);
                }
              };
            }(), V = /* @__PURE__ */ function() {
              var U = [4, 7, 99];
              return function(F) {
                if (F.chars && !A(U, F.v)) {
                  var N, D = F.chars.length;
                  for (N = 0; N < D; N += 1) {
                    var j = F.chars[N];
                    j.data && j.data.shapes && (E(j.data.shapes), j.data.ip = 0, j.data.op = 99999, j.data.st = 0, j.data.sr = 1, j.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, F.chars[N].t || (j.data.shapes.push({
                      ty: "no"
                    }), j.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), B = /* @__PURE__ */ function() {
              var U = [5, 7, 15];
              function F(D) {
                var j = D.t.p;
                typeof j.a == "number" && (j.a = {
                  a: 0,
                  k: j.a
                }), typeof j.p == "number" && (j.p = {
                  a: 0,
                  k: j.p
                }), typeof j.r == "number" && (j.r = {
                  a: 0,
                  k: j.r
                });
              }
              function N(D) {
                var j, H = D.length;
                for (j = 0; j < H; j += 1)
                  D[j].ty === 5 && F(D[j]);
              }
              return function(D) {
                if (A(U, D.v) && (N(D.layers), D.assets)) {
                  var j, H = D.assets.length;
                  for (j = 0; j < H; j += 1)
                    D.assets[j].layers && N(D.assets[j].layers);
                }
              };
            }(), q = /* @__PURE__ */ function() {
              var U = [4, 1, 9];
              function F(D) {
                var j, H = D.length, W, re;
                for (j = 0; j < H; j += 1)
                  if (D[j].ty === "gr")
                    F(D[j].it);
                  else if (D[j].ty === "fl" || D[j].ty === "st")
                    if (D[j].c.k && D[j].c.k[0].i)
                      for (re = D[j].c.k.length, W = 0; W < re; W += 1)
                        D[j].c.k[W].s && (D[j].c.k[W].s[0] /= 255, D[j].c.k[W].s[1] /= 255, D[j].c.k[W].s[2] /= 255, D[j].c.k[W].s[3] /= 255), D[j].c.k[W].e && (D[j].c.k[W].e[0] /= 255, D[j].c.k[W].e[1] /= 255, D[j].c.k[W].e[2] /= 255, D[j].c.k[W].e[3] /= 255);
                    else
                      D[j].c.k[0] /= 255, D[j].c.k[1] /= 255, D[j].c.k[2] /= 255, D[j].c.k[3] /= 255;
              }
              function N(D) {
                var j, H = D.length;
                for (j = 0; j < H; j += 1)
                  D[j].ty === 4 && F(D[j].shapes);
              }
              return function(D) {
                if (A(U, D.v) && (N(D.layers), D.assets)) {
                  var j, H = D.assets.length;
                  for (j = 0; j < H; j += 1)
                    D.assets[j].layers && N(D.assets[j].layers);
                }
              };
            }(), z = /* @__PURE__ */ function() {
              var U = [4, 4, 18];
              function F(D) {
                var j, H = D.length, W, re;
                for (j = H - 1; j >= 0; j -= 1)
                  if (D[j].ty === "sh")
                    if (D[j].ks.k.i)
                      D[j].ks.k.c = D[j].closed;
                    else
                      for (re = D[j].ks.k.length, W = 0; W < re; W += 1)
                        D[j].ks.k[W].s && (D[j].ks.k[W].s[0].c = D[j].closed), D[j].ks.k[W].e && (D[j].ks.k[W].e[0].c = D[j].closed);
                  else D[j].ty === "gr" && F(D[j].it);
              }
              function N(D) {
                var j, H, W = D.length, re, ae, ee, X;
                for (H = 0; H < W; H += 1) {
                  if (j = D[H], j.hasMask) {
                    var J = j.masksProperties;
                    for (ae = J.length, re = 0; re < ae; re += 1)
                      if (J[re].pt.k.i)
                        J[re].pt.k.c = J[re].cl;
                      else
                        for (X = J[re].pt.k.length, ee = 0; ee < X; ee += 1)
                          J[re].pt.k[ee].s && (J[re].pt.k[ee].s[0].c = J[re].cl), J[re].pt.k[ee].e && (J[re].pt.k[ee].e[0].c = J[re].cl);
                  }
                  j.ty === 4 && F(j.shapes);
                }
              }
              return function(D) {
                if (A(U, D.v) && (N(D.layers), D.assets)) {
                  var j, H = D.assets.length;
                  for (j = 0; j < H; j += 1)
                    D.assets[j].layers && N(D.assets[j].layers);
                }
              };
            }();
            function Z(U) {
              U.__complete || (q(U), k(U), V(U), B(U), z(U), P(U.layers, U.assets), L(U.chars, U.assets), U.__complete = !0);
            }
            function G(U) {
              U.t.a.length === 0 && "m" in U.t.p;
            }
            var K = {};
            return K.completeData = Z, K.checkColors = q, K.checkChars = V, K.checkPathProperties = B, K.checkShapes = z, K.completeLayers = P, K;
          }
          if (d.dataManager || (d.dataManager = S()), d.assetLoader || (d.assetLoader = /* @__PURE__ */ function() {
            function P(I) {
              var T = I.getResponseHeader("content-type");
              return T && I.responseType === "json" && T.indexOf("json") !== -1 || I.response && _typeof$5(I.response) === "object" ? I.response : I.response && typeof I.response == "string" ? JSON.parse(I.response) : I.responseText ? JSON.parse(I.responseText) : null;
            }
            function L(I, T, E, R) {
              var A, k = new XMLHttpRequest();
              try {
                k.responseType = "json";
              } catch {
              }
              k.onreadystatechange = function() {
                if (k.readyState === 4)
                  if (k.status === 200)
                    A = P(k), E(A);
                  else
                    try {
                      A = P(k), E(A);
                    } catch (V) {
                      R && R(V);
                    }
              };
              try {
                k.open(["G", "E", "T"].join(""), I, !0);
              } catch {
                k.open(["G", "E", "T"].join(""), T + "/" + I, !0);
              }
              k.send();
            }
            return {
              load: L
            };
          }()), w.data.type === "loadAnimation")
            d.assetLoader.load(w.data.path, w.data.fullPath, function(P) {
              d.dataManager.completeData(P), d.postMessage({
                id: w.data.id,
                payload: P,
                status: "success"
              });
            }, function() {
              d.postMessage({
                id: w.data.id,
                status: "error"
              });
            });
          else if (w.data.type === "complete") {
            var M = w.data.animation;
            d.dataManager.completeData(M), d.postMessage({
              id: w.data.id,
              payload: M,
              status: "success"
            });
          } else w.data.type === "loadData" && d.assetLoader.load(w.data.path, w.data.fullPath, function(P) {
            d.postMessage({
              id: w.data.id,
              payload: P,
              status: "success"
            });
          }, function() {
            d.postMessage({
              id: w.data.id,
              status: "error"
            });
          });
        }), c.onmessage = function(x) {
          var w = x.data, S = w.id, M = a[S];
          a[S] = null, w.status === "success" ? M.onComplete(w.payload) : M.onError && M.onError();
        });
      }
      function m(x, w) {
        r += 1;
        var S = "processId_" + r;
        return a[S] = {
          onComplete: x,
          onError: w
        }, S;
      }
      function g(x, w, S) {
        p();
        var M = m(w, S);
        c.postMessage({
          type: "loadAnimation",
          path: x,
          fullPath: window.location.origin + window.location.pathname,
          id: M
        });
      }
      function v(x, w, S) {
        p();
        var M = m(w, S);
        c.postMessage({
          type: "loadData",
          path: x,
          fullPath: window.location.origin + window.location.pathname,
          id: M
        });
      }
      function y(x, w, S) {
        p();
        var M = m(w, S);
        c.postMessage({
          type: "complete",
          animation: x,
          id: M
        });
      }
      return {
        loadAnimation: g,
        loadData: v,
        completeAnimation: y
      };
    }(), ImagePreloader = function() {
      var r = function() {
        var L = createTag("canvas");
        L.width = 1, L.height = 1;
        var I = L.getContext("2d");
        return I.fillStyle = "rgba(0,0,0,0)", I.fillRect(0, 0, 1, 1), L;
      }();
      function a() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function s() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function c(L, I, T) {
        var E = "";
        if (L.e)
          E = L.p;
        else if (I) {
          var R = L.p;
          R.indexOf("images/") !== -1 && (R = R.split("/")[1]), E = I + R;
        } else
          E = T, E += L.u ? L.u : "", E += L.p;
        return E;
      }
      function u(L) {
        var I = 0, T = setInterval((function() {
          var E = L.getBBox();
          (E.width || I > 500) && (this._imageLoaded(), clearInterval(T)), I += 1;
        }).bind(this), 50);
      }
      function d(L) {
        var I = c(L, this.assetsPath, this.path), T = createNS("image");
        isSafari ? this.testImageLoaded(T) : T.addEventListener("load", this._imageLoaded, !1), T.addEventListener("error", (function() {
          E.img = r, this._imageLoaded();
        }).bind(this), !1), T.setAttributeNS("http://www.w3.org/1999/xlink", "href", I), this._elementHelper.append ? this._elementHelper.append(T) : this._elementHelper.appendChild(T);
        var E = {
          img: T,
          assetData: L
        };
        return E;
      }
      function h(L) {
        var I = c(L, this.assetsPath, this.path), T = createTag("img");
        T.crossOrigin = "anonymous", T.addEventListener("load", this._imageLoaded, !1), T.addEventListener("error", (function() {
          E.img = r, this._imageLoaded();
        }).bind(this), !1), T.src = I;
        var E = {
          img: T,
          assetData: L
        };
        return E;
      }
      function p(L) {
        var I = {
          assetData: L
        }, T = c(L, this.assetsPath, this.path);
        return dataManager.loadData(T, (function(E) {
          I.img = E, this._footageLoaded();
        }).bind(this), (function() {
          I.img = {}, this._footageLoaded();
        }).bind(this)), I;
      }
      function m(L, I) {
        this.imagesLoadedCb = I;
        var T, E = L.length;
        for (T = 0; T < E; T += 1)
          L[T].layers || (!L[T].t || L[T].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(L[T]))) : L[T].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(L[T]))));
      }
      function g(L) {
        this.path = L || "";
      }
      function v(L) {
        this.assetsPath = L || "";
      }
      function y(L) {
        for (var I = 0, T = this.images.length; I < T; ) {
          if (this.images[I].assetData === L)
            return this.images[I].img;
          I += 1;
        }
        return null;
      }
      function x() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function w() {
        return this.totalImages === this.loadedAssets;
      }
      function S() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function M(L, I) {
        L === "svg" ? (this._elementHelper = I, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function P() {
        this._imageLoaded = a.bind(this), this._footageLoaded = s.bind(this), this.testImageLoaded = u.bind(this), this.createFootageData = p.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return P.prototype = {
        loadAssets: m,
        setAssetsPath: v,
        setPath: g,
        loadedImages: w,
        loadedFootages: S,
        destroy: x,
        getAsset: y,
        createImgData: h,
        createImageData: d,
        imageLoaded: a,
        footageLoaded: s,
        setCacheType: M
      }, P;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(a, s) {
        if (this._cbs[a])
          for (var c = this._cbs[a], u = 0; u < c.length; u += 1)
            c[u](s);
      },
      addEventListener: function(a, s) {
        return this._cbs[a] || (this._cbs[a] = []), this._cbs[a].push(s), (function() {
          this.removeEventListener(a, s);
        }).bind(this);
      },
      removeEventListener: function(a, s) {
        if (!s)
          this._cbs[a] = null;
        else if (this._cbs[a]) {
          for (var c = 0, u = this._cbs[a].length; c < u; )
            this._cbs[a][c] === s && (this._cbs[a].splice(c, 1), c -= 1, u -= 1), c += 1;
          this._cbs[a].length || (this._cbs[a] = null);
        }
      }
    };
    var markerParser = /* @__PURE__ */ function() {
      function r(a) {
        for (var s = a.split(`\r
`), c = {}, u, d = 0, h = 0; h < s.length; h += 1)
          u = s[h].split(":"), u.length === 2 && (c[u[0]] = u[1].trim(), d += 1);
        if (d === 0)
          throw new Error();
        return c;
      }
      return function(a) {
        for (var s = [], c = 0; c < a.length; c += 1) {
          var u = a[c], d = {
            time: u.tm,
            duration: u.dr
          };
          try {
            d.payload = JSON.parse(a[c].cm);
          } catch {
            try {
              d.payload = r(a[c].cm);
            } catch {
              d.payload = {
                name: a[c].cm
              };
            }
          }
          s.push(d);
        }
        return s;
      };
    }(), ProjectInterface = /* @__PURE__ */ function() {
      function r(a) {
        this.compositions.push(a);
      }
      return function() {
        function a(s) {
          for (var c = 0, u = this.compositions.length; c < u; ) {
            if (this.compositions[c].data && this.compositions[c].data.nm === s)
              return this.compositions[c].prepareFrame && this.compositions[c].data.xt && this.compositions[c].prepareFrame(this.currentFrame), this.compositions[c].compInterface;
            c += 1;
          }
          return null;
        }
        return a.compositions = [], a.currentFrame = 0, a.registerComposition = r, a;
      };
    }(), renderers = {}, registerRenderer = function(a, s) {
      renderers[a] = s;
    };
    function getRenderer(r) {
      return renderers[r];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var r in renderers)
        if (renderers[r])
          return r;
      return "";
    }
    function _typeof$4(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(s) {
        return typeof s;
      } : _typeof$4 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$4(r);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(r) {
      (r.wrapper || r.container) && (this.wrapper = r.wrapper || r.container);
      var a = "svg";
      r.animType ? a = r.animType : r.renderer && (a = r.renderer);
      var s = getRenderer(a);
      this.renderer = new s(this, r.rendererSettings), this.imagePreloader.setCacheType(a, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = a, r.loop === "" || r.loop === null || r.loop === void 0 || r.loop === !0 ? this.loop = !0 : r.loop === !1 ? this.loop = !1 : this.loop = parseInt(r.loop, 10), this.autoplay = "autoplay" in r ? r.autoplay : !0, this.name = r.name ? r.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(r, "autoloadSegments") ? r.autoloadSegments : !0, this.assetsPath = r.assetsPath, this.initialSegment = r.initialSegment, r.audioFactory && this.audioController.setAudioFactory(r.audioFactory), r.animationData ? this.setupAnimation(r.animationData) : r.path && (r.path.lastIndexOf("\\") !== -1 ? this.path = r.path.substr(0, r.path.lastIndexOf("\\") + 1) : this.path = r.path.substr(0, r.path.lastIndexOf("/") + 1), this.fileName = r.path.substr(r.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(r.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(r) {
      dataManager.completeAnimation(r, this.configAnimation);
    }, AnimationItem.prototype.setData = function(r, a) {
      a && _typeof$4(a) !== "object" && (a = JSON.parse(a));
      var s = {
        wrapper: r,
        animationData: a
      }, c = r.attributes;
      s.path = c.getNamedItem("data-animation-path") ? c.getNamedItem("data-animation-path").value : c.getNamedItem("data-bm-path") ? c.getNamedItem("data-bm-path").value : c.getNamedItem("bm-path") ? c.getNamedItem("bm-path").value : "", s.animType = c.getNamedItem("data-anim-type") ? c.getNamedItem("data-anim-type").value : c.getNamedItem("data-bm-type") ? c.getNamedItem("data-bm-type").value : c.getNamedItem("bm-type") ? c.getNamedItem("bm-type").value : c.getNamedItem("data-bm-renderer") ? c.getNamedItem("data-bm-renderer").value : c.getNamedItem("bm-renderer") ? c.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var u = c.getNamedItem("data-anim-loop") ? c.getNamedItem("data-anim-loop").value : c.getNamedItem("data-bm-loop") ? c.getNamedItem("data-bm-loop").value : c.getNamedItem("bm-loop") ? c.getNamedItem("bm-loop").value : "";
      u === "false" ? s.loop = !1 : u === "true" ? s.loop = !0 : u !== "" && (s.loop = parseInt(u, 10));
      var d = c.getNamedItem("data-anim-autoplay") ? c.getNamedItem("data-anim-autoplay").value : c.getNamedItem("data-bm-autoplay") ? c.getNamedItem("data-bm-autoplay").value : c.getNamedItem("bm-autoplay") ? c.getNamedItem("bm-autoplay").value : !0;
      s.autoplay = d !== "false", s.name = c.getNamedItem("data-name") ? c.getNamedItem("data-name").value : c.getNamedItem("data-bm-name") ? c.getNamedItem("data-bm-name").value : c.getNamedItem("bm-name") ? c.getNamedItem("bm-name").value : "";
      var h = c.getNamedItem("data-anim-prerender") ? c.getNamedItem("data-anim-prerender").value : c.getNamedItem("data-bm-prerender") ? c.getNamedItem("data-bm-prerender").value : c.getNamedItem("bm-prerender") ? c.getNamedItem("bm-prerender").value : "";
      h === "false" && (s.prerender = !1), s.path ? this.setParams(s) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(r) {
      r.op > this.animationData.op && (this.animationData.op = r.op, this.totalFrames = Math.floor(r.op - this.animationData.ip));
      var a = this.animationData.layers, s, c = a.length, u = r.layers, d, h = u.length;
      for (d = 0; d < h; d += 1)
        for (s = 0; s < c; ) {
          if (a[s].id === u[d].id) {
            a[s] = u[d];
            break;
          }
          s += 1;
        }
      if ((r.chars || r.fonts) && (this.renderer.globalData.fontManager.addChars(r.chars), this.renderer.globalData.fontManager.addFonts(r.fonts, this.renderer.globalData.defs)), r.assets)
        for (c = r.assets.length, s = 0; s < c; s += 1)
          this.animationData.assets.push(r.assets[s]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(r) {
      this.animationData = r;
      var a = getExpressionsPlugin();
      a && a.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var r = this.animationData.segments;
      if (!r || r.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var a = r.shift();
      this.timeCompleted = a.time * this.frameRate;
      var s = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(s, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var r = this.animationData.segments;
      r || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(r) {
      if (this.renderer)
        try {
          this.animationData = r, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(r), r.assets || (r.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(r.assets), this.markers = markerParser(r.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (a) {
          this.triggerConfigError(a);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var r = getExpressionsPlugin();
        r && r.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(r, a) {
      var s = typeof r == "number" ? r : void 0, c = typeof a == "number" ? a : void 0;
      this.renderer.updateContainerSize(s, c);
    }, AnimationItem.prototype.setSubframe = function(r) {
      this.isSubframeEnabled = !!r;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (r) {
          this.triggerRenderFrameError(r);
        }
    }, AnimationItem.prototype.play = function(r) {
      r && this.name !== r || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(r) {
      r && this.name !== r || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(r) {
      r && this.name !== r || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(r) {
      r && this.name !== r || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(r) {
      for (var a, s = 0; s < this.markers.length; s += 1)
        if (a = this.markers[s], a.payload && a.payload.name === r)
          return a;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(r, a, s) {
      if (!(s && this.name !== s)) {
        var c = Number(r);
        if (isNaN(c)) {
          var u = this.getMarkerData(r);
          u && this.goToAndStop(u.time, !0);
        } else a ? this.setCurrentRawFrameValue(r) : this.setCurrentRawFrameValue(r * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(r, a, s) {
      if (!(s && this.name !== s)) {
        var c = Number(r);
        if (isNaN(c)) {
          var u = this.getMarkerData(r);
          u && (u.duration ? this.playSegments([u.time, u.time + u.duration], !0) : this.goToAndStop(u.time, !0));
        } else
          this.goToAndStop(c, a, s);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(r) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var a = this.currentRawFrame + r * this.frameModifier, s = !1;
        a >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(a > this.totalFrames ? a % this.totalFrames : 0) || (s = !0, a = this.totalFrames - 1) : a >= this.totalFrames ? (this.playCount += 1, this.checkSegments(a % this.totalFrames) || (this.setCurrentRawFrameValue(a % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(a) : a < 0 ? this.checkSegments(a % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + a % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (s = !0, a = 0)) : this.setCurrentRawFrameValue(a), s && (this.setCurrentRawFrameValue(a), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(r, a) {
      this.playCount = 0, r[1] < r[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = r[0] - r[1], this.timeCompleted = this.totalFrames, this.firstFrame = r[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - a)) : r[1] > r[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = r[1] - r[0], this.timeCompleted = this.totalFrames, this.firstFrame = r[0], this.setCurrentRawFrameValue(1e-3 + a)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(r, a) {
      var s = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < r ? s = r : this.currentRawFrame + this.firstFrame > a && (s = a - r)), this.firstFrame = r, this.totalFrames = a - r, this.timeCompleted = this.totalFrames, s !== -1 && this.goToAndStop(s, !0);
    }, AnimationItem.prototype.playSegments = function(r, a) {
      if (a && (this.segments.length = 0), _typeof$4(r[0]) === "object") {
        var s, c = r.length;
        for (s = 0; s < c; s += 1)
          this.segments.push(r[s]);
      } else
        this.segments.push(r);
      this.segments.length && a && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(r) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), r && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(r) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), r), !0) : !1;
    }, AnimationItem.prototype.destroy = function(r) {
      r && this.name !== r || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(r) {
      this.currentRawFrame = r, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(r) {
      this.playSpeed = r, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(r) {
      this.playDirection = r < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(r) {
      this.loop = r;
    }, AnimationItem.prototype.setVolume = function(r, a) {
      a && this.name !== a || this.audioController.setVolume(r);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(r) {
      r && this.name !== r || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(r) {
      r && this.name !== r || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(r) {
      var a = "";
      if (r.e)
        a = r.p;
      else if (this.assetsPath) {
        var s = r.p;
        s.indexOf("images/") !== -1 && (s = s.split("/")[1]), a = this.assetsPath + s;
      } else
        a = this.path, a += r.u ? r.u : "", a += r.p;
      return a;
    }, AnimationItem.prototype.getAssetData = function(r) {
      for (var a = 0, s = this.assets.length; a < s; ) {
        if (r === this.assets[a].id)
          return this.assets[a];
        a += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(r) {
      return r ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(r, a, s) {
      try {
        var c = this.renderer.getElementByPath(r);
        c.updateDocumentData(a, s);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(r) {
      if (this._cbs && this._cbs[r])
        switch (r) {
          case "enterFrame":
            this.triggerEvent(r, new BMEnterFrameEvent(r, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(r, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(r, new BMCompleteLoopEvent(r, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(r, new BMCompleteEvent(r, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(r, new BMSegmentStartEvent(r, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(r, new BMDestroyEvent(r, this));
            break;
          default:
            this.triggerEvent(r);
        }
      r === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(r, this.currentFrame, this.totalFrames, this.frameMult)), r === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(r, this.loop, this.playCount, this.frameMult)), r === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(r, this.frameMult)), r === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(r, this.firstFrame, this.totalFrames)), r === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(r, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(r) {
      var a = new BMRenderFrameErrorEvent(r, this.currentFrame);
      this.triggerEvent("error", a), this.onError && this.onError.call(this, a);
    }, AnimationItem.prototype.triggerConfigError = function(r) {
      var a = new BMConfigErrorEvent(r, this.currentFrame);
      this.triggerEvent("error", a), this.onError && this.onError.call(this, a);
    };
    var animationManager = function() {
      var r = {}, a = [], s = 0, c = 0, u = 0, d = !0, h = !1;
      function p(F) {
        for (var N = 0, D = F.target; N < c; )
          a[N].animation === D && (a.splice(N, 1), N -= 1, c -= 1, D.isPaused || y()), N += 1;
      }
      function m(F, N) {
        if (!F)
          return null;
        for (var D = 0; D < c; ) {
          if (a[D].elem === F && a[D].elem !== null)
            return a[D].animation;
          D += 1;
        }
        var j = new AnimationItem();
        return x(j, F), j.setData(F, N), j;
      }
      function g() {
        var F, N = a.length, D = [];
        for (F = 0; F < N; F += 1)
          D.push(a[F].animation);
        return D;
      }
      function v() {
        u += 1, q();
      }
      function y() {
        u -= 1;
      }
      function x(F, N) {
        F.addEventListener("destroy", p), F.addEventListener("_active", v), F.addEventListener("_idle", y), a.push({
          elem: N,
          animation: F
        }), c += 1;
      }
      function w(F) {
        var N = new AnimationItem();
        return x(N, null), N.setParams(F), N;
      }
      function S(F, N) {
        var D;
        for (D = 0; D < c; D += 1)
          a[D].animation.setSpeed(F, N);
      }
      function M(F, N) {
        var D;
        for (D = 0; D < c; D += 1)
          a[D].animation.setDirection(F, N);
      }
      function P(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.play(F);
      }
      function L(F) {
        var N = F - s, D;
        for (D = 0; D < c; D += 1)
          a[D].animation.advanceTime(N);
        s = F, u && !h ? window.requestAnimationFrame(L) : d = !0;
      }
      function I(F) {
        s = F, window.requestAnimationFrame(L);
      }
      function T(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.pause(F);
      }
      function E(F, N, D) {
        var j;
        for (j = 0; j < c; j += 1)
          a[j].animation.goToAndStop(F, N, D);
      }
      function R(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.stop(F);
      }
      function A(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.togglePause(F);
      }
      function k(F) {
        var N;
        for (N = c - 1; N >= 0; N -= 1)
          a[N].animation.destroy(F);
      }
      function V(F, N, D) {
        var j = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), H, W = j.length;
        for (H = 0; H < W; H += 1)
          D && j[H].setAttribute("data-bm-type", D), m(j[H], F);
        if (N && W === 0) {
          D || (D = "svg");
          var re = document.getElementsByTagName("body")[0];
          re.innerText = "";
          var ae = createTag("div");
          ae.style.width = "100%", ae.style.height = "100%", ae.setAttribute("data-bm-type", D), re.appendChild(ae), m(ae, F);
        }
      }
      function B() {
        var F;
        for (F = 0; F < c; F += 1)
          a[F].animation.resize();
      }
      function q() {
        !h && u && d && (window.requestAnimationFrame(I), d = !1);
      }
      function z() {
        h = !0;
      }
      function Z() {
        h = !1, q();
      }
      function G(F, N) {
        var D;
        for (D = 0; D < c; D += 1)
          a[D].animation.setVolume(F, N);
      }
      function K(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.mute(F);
      }
      function U(F) {
        var N;
        for (N = 0; N < c; N += 1)
          a[N].animation.unmute(F);
      }
      return r.registerAnimation = m, r.loadAnimation = w, r.setSpeed = S, r.setDirection = M, r.play = P, r.pause = T, r.stop = R, r.togglePause = A, r.searchAnimations = V, r.resize = B, r.goToAndStop = E, r.destroy = k, r.freeze = z, r.unfreeze = Z, r.setVolume = G, r.mute = K, r.unmute = U, r.getRegisteredAnimations = g, r;
    }(), BezierFactory = function() {
      var r = {};
      r.getBezierEasing = s;
      var a = {};
      function s(I, T, E, R, A) {
        var k = A || ("bez_" + I + "_" + T + "_" + E + "_" + R).replace(/\./g, "p");
        if (a[k])
          return a[k];
        var V = new L([I, T, E, R]);
        return a[k] = V, V;
      }
      var c = 4, u = 1e-3, d = 1e-7, h = 10, p = 11, m = 1 / (p - 1), g = typeof Float32Array == "function";
      function v(I, T) {
        return 1 - 3 * T + 3 * I;
      }
      function y(I, T) {
        return 3 * T - 6 * I;
      }
      function x(I) {
        return 3 * I;
      }
      function w(I, T, E) {
        return ((v(T, E) * I + y(T, E)) * I + x(T)) * I;
      }
      function S(I, T, E) {
        return 3 * v(T, E) * I * I + 2 * y(T, E) * I + x(T);
      }
      function M(I, T, E, R, A) {
        var k, V, B = 0;
        do
          V = T + (E - T) / 2, k = w(V, R, A) - I, k > 0 ? E = V : T = V;
        while (Math.abs(k) > d && ++B < h);
        return V;
      }
      function P(I, T, E, R) {
        for (var A = 0; A < c; ++A) {
          var k = S(T, E, R);
          if (k === 0) return T;
          var V = w(T, E, R) - I;
          T -= V / k;
        }
        return T;
      }
      function L(I) {
        this._p = I, this._mSampleValues = g ? new Float32Array(p) : new Array(p), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return L.prototype = {
        get: function(T) {
          var E = this._p[0], R = this._p[1], A = this._p[2], k = this._p[3];
          return this._precomputed || this._precompute(), E === R && A === k ? T : T === 0 ? 0 : T === 1 ? 1 : w(this._getTForX(T), R, k);
        },
        // Private part
        _precompute: function() {
          var T = this._p[0], E = this._p[1], R = this._p[2], A = this._p[3];
          this._precomputed = !0, (T !== E || R !== A) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var T = this._p[0], E = this._p[2], R = 0; R < p; ++R)
            this._mSampleValues[R] = w(R * m, T, E);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(T) {
          for (var E = this._p[0], R = this._p[2], A = this._mSampleValues, k = 0, V = 1, B = p - 1; V !== B && A[V] <= T; ++V)
            k += m;
          --V;
          var q = (T - A[V]) / (A[V + 1] - A[V]), z = k + q * m, Z = S(z, E, R);
          return Z >= u ? P(T, z, E, R) : Z === 0 ? z : M(T, k, k + m, E, R);
        }
      }, r;
    }(), pooling = /* @__PURE__ */ function() {
      function r(a) {
        return a.concat(createSizedArray(a.length));
      }
      return {
        double: r
      };
    }(), poolFactory = /* @__PURE__ */ function() {
      return function(r, a, s) {
        var c = 0, u = r, d = createSizedArray(u), h = {
          newElement: p,
          release: m
        };
        function p() {
          var g;
          return c ? (c -= 1, g = d[c]) : g = a(), g;
        }
        function m(g) {
          c === u && (d = pooling.double(d), u *= 2), s && s(g), d[c] = g, c += 1;
        }
        return h;
      };
    }(), bezierLengthPool = function() {
      function r() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, r);
    }(), segmentsLengthPool = function() {
      function r() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function a(s) {
        var c, u = s.lengths.length;
        for (c = 0; c < u; c += 1)
          bezierLengthPool.release(s.lengths[c]);
        s.lengths.length = 0;
      }
      return poolFactory(8, r, a);
    }();
    function bezFunction() {
      var r = Math;
      function a(x, w, S, M, P, L) {
        var I = x * M + w * P + S * L - P * M - L * x - S * w;
        return I > -1e-3 && I < 1e-3;
      }
      function s(x, w, S, M, P, L, I, T, E) {
        if (S === 0 && L === 0 && E === 0)
          return a(x, w, M, P, I, T);
        var R = r.sqrt(r.pow(M - x, 2) + r.pow(P - w, 2) + r.pow(L - S, 2)), A = r.sqrt(r.pow(I - x, 2) + r.pow(T - w, 2) + r.pow(E - S, 2)), k = r.sqrt(r.pow(I - M, 2) + r.pow(T - P, 2) + r.pow(E - L, 2)), V;
        return R > A ? R > k ? V = R - A - k : V = k - A - R : k > A ? V = k - A - R : V = A - R - k, V > -1e-4 && V < 1e-4;
      }
      var c = /* @__PURE__ */ function() {
        return function(x, w, S, M) {
          var P = getDefaultCurveSegments(), L, I, T, E, R, A = 0, k, V = [], B = [], q = bezierLengthPool.newElement();
          for (T = S.length, L = 0; L < P; L += 1) {
            for (R = L / (P - 1), k = 0, I = 0; I < T; I += 1)
              E = bmPow(1 - R, 3) * x[I] + 3 * bmPow(1 - R, 2) * R * S[I] + 3 * (1 - R) * bmPow(R, 2) * M[I] + bmPow(R, 3) * w[I], V[I] = E, B[I] !== null && (k += bmPow(V[I] - B[I], 2)), B[I] = V[I];
            k && (k = bmSqrt(k), A += k), q.percents[L] = R, q.lengths[L] = A;
          }
          return q.addedLength = A, q;
        };
      }();
      function u(x) {
        var w = segmentsLengthPool.newElement(), S = x.c, M = x.v, P = x.o, L = x.i, I, T = x._length, E = w.lengths, R = 0;
        for (I = 0; I < T - 1; I += 1)
          E[I] = c(M[I], M[I + 1], P[I], L[I + 1]), R += E[I].addedLength;
        return S && T && (E[I] = c(M[I], M[0], P[I], L[0]), R += E[I].addedLength), w.totalLength = R, w;
      }
      function d(x) {
        this.segmentLength = 0, this.points = new Array(x);
      }
      function h(x, w) {
        this.partialLength = x, this.point = w;
      }
      var p = /* @__PURE__ */ function() {
        var x = {};
        return function(w, S, M, P) {
          var L = (w[0] + "_" + w[1] + "_" + S[0] + "_" + S[1] + "_" + M[0] + "_" + M[1] + "_" + P[0] + "_" + P[1]).replace(/\./g, "p");
          if (!x[L]) {
            var I = getDefaultCurveSegments(), T, E, R, A, k, V = 0, B, q, z = null;
            w.length === 2 && (w[0] !== S[0] || w[1] !== S[1]) && a(w[0], w[1], S[0], S[1], w[0] + M[0], w[1] + M[1]) && a(w[0], w[1], S[0], S[1], S[0] + P[0], S[1] + P[1]) && (I = 2);
            var Z = new d(I);
            for (R = M.length, T = 0; T < I; T += 1) {
              for (q = createSizedArray(R), k = T / (I - 1), B = 0, E = 0; E < R; E += 1)
                A = bmPow(1 - k, 3) * w[E] + 3 * bmPow(1 - k, 2) * k * (w[E] + M[E]) + 3 * (1 - k) * bmPow(k, 2) * (S[E] + P[E]) + bmPow(k, 3) * S[E], q[E] = A, z !== null && (B += bmPow(q[E] - z[E], 2));
              B = bmSqrt(B), V += B, Z.points[T] = new h(B, q), z = q;
            }
            Z.segmentLength = V, x[L] = Z;
          }
          return x[L];
        };
      }();
      function m(x, w) {
        var S = w.percents, M = w.lengths, P = S.length, L = bmFloor((P - 1) * x), I = x * w.addedLength, T = 0;
        if (L === P - 1 || L === 0 || I === M[L])
          return S[L];
        for (var E = M[L] > I ? -1 : 1, R = !0; R; )
          if (M[L] <= I && M[L + 1] > I ? (T = (I - M[L]) / (M[L + 1] - M[L]), R = !1) : L += E, L < 0 || L >= P - 1) {
            if (L === P - 1)
              return S[L];
            R = !1;
          }
        return S[L] + (S[L + 1] - S[L]) * T;
      }
      function g(x, w, S, M, P, L) {
        var I = m(P, L), T = 1 - I, E = r.round((T * T * T * x[0] + (I * T * T + T * I * T + T * T * I) * S[0] + (I * I * T + T * I * I + I * T * I) * M[0] + I * I * I * w[0]) * 1e3) / 1e3, R = r.round((T * T * T * x[1] + (I * T * T + T * I * T + T * T * I) * S[1] + (I * I * T + T * I * I + I * T * I) * M[1] + I * I * I * w[1]) * 1e3) / 1e3;
        return [E, R];
      }
      var v = createTypedArray("float32", 8);
      function y(x, w, S, M, P, L, I) {
        P < 0 ? P = 0 : P > 1 && (P = 1);
        var T = m(P, I);
        L = L > 1 ? 1 : L;
        var E = m(L, I), R, A = x.length, k = 1 - T, V = 1 - E, B = k * k * k, q = T * k * k * 3, z = T * T * k * 3, Z = T * T * T, G = k * k * V, K = T * k * V + k * T * V + k * k * E, U = T * T * V + k * T * E + T * k * E, F = T * T * E, N = k * V * V, D = T * V * V + k * E * V + k * V * E, j = T * E * V + k * E * E + T * V * E, H = T * E * E, W = V * V * V, re = E * V * V + V * E * V + V * V * E, ae = E * E * V + V * E * E + E * V * E, ee = E * E * E;
        for (R = 0; R < A; R += 1)
          v[R * 4] = r.round((B * x[R] + q * S[R] + z * M[R] + Z * w[R]) * 1e3) / 1e3, v[R * 4 + 1] = r.round((G * x[R] + K * S[R] + U * M[R] + F * w[R]) * 1e3) / 1e3, v[R * 4 + 2] = r.round((N * x[R] + D * S[R] + j * M[R] + H * w[R]) * 1e3) / 1e3, v[R * 4 + 3] = r.round((W * x[R] + re * S[R] + ae * M[R] + ee * w[R]) * 1e3) / 1e3;
        return v;
      }
      return {
        getSegmentsLength: u,
        getNewSegment: y,
        getPointInSegment: g,
        buildBezierData: p,
        pointOnLine2D: a,
        pointOnLine3D: s
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(r, a) {
      var s = this.offsetTime, c;
      this.propType === "multidimensional" && (c = createTypedArray("float32", this.pv.length));
      for (var u = a.lastIndex, d = u, h = this.keyframes.length - 1, p = !0, m, g, v; p; ) {
        if (m = this.keyframes[d], g = this.keyframes[d + 1], d === h - 1 && r >= g.t - s) {
          m.h && (m = g), u = 0;
          break;
        }
        if (g.t - s > r) {
          u = d;
          break;
        }
        d < h - 1 ? d += 1 : (u = 0, p = !1);
      }
      v = this.keyframesMetadata[d] || {};
      var y, x, w, S, M, P, L = g.t - s, I = m.t - s, T;
      if (m.to) {
        v.bezierData || (v.bezierData = bez.buildBezierData(m.s, g.s || m.e, m.to, m.ti));
        var E = v.bezierData;
        if (r >= L || r < I) {
          var R = r >= L ? E.points.length - 1 : 0;
          for (x = E.points[R].point.length, y = 0; y < x; y += 1)
            c[y] = E.points[R].point[y];
        } else {
          v.__fnct ? P = v.__fnct : (P = BezierFactory.getBezierEasing(m.o.x, m.o.y, m.i.x, m.i.y, m.n).get, v.__fnct = P), w = P((r - I) / (L - I));
          var A = E.segmentLength * w, k, V = a.lastFrame < r && a._lastKeyframeIndex === d ? a._lastAddedLength : 0;
          for (M = a.lastFrame < r && a._lastKeyframeIndex === d ? a._lastPoint : 0, p = !0, S = E.points.length; p; ) {
            if (V += E.points[M].partialLength, A === 0 || w === 0 || M === E.points.length - 1) {
              for (x = E.points[M].point.length, y = 0; y < x; y += 1)
                c[y] = E.points[M].point[y];
              break;
            } else if (A >= V && A < V + E.points[M + 1].partialLength) {
              for (k = (A - V) / E.points[M + 1].partialLength, x = E.points[M].point.length, y = 0; y < x; y += 1)
                c[y] = E.points[M].point[y] + (E.points[M + 1].point[y] - E.points[M].point[y]) * k;
              break;
            }
            M < S - 1 ? M += 1 : p = !1;
          }
          a._lastPoint = M, a._lastAddedLength = V - E.points[M].partialLength, a._lastKeyframeIndex = d;
        }
      } else {
        var B, q, z, Z, G;
        if (h = m.s.length, T = g.s || m.e, this.sh && m.h !== 1)
          if (r >= L)
            c[0] = T[0], c[1] = T[1], c[2] = T[2];
          else if (r <= I)
            c[0] = m.s[0], c[1] = m.s[1], c[2] = m.s[2];
          else {
            var K = createQuaternion(m.s), U = createQuaternion(T), F = (r - I) / (L - I);
            quaternionToEuler(c, slerp(K, U, F));
          }
        else
          for (d = 0; d < h; d += 1)
            m.h !== 1 && (r >= L ? w = 1 : r < I ? w = 0 : (m.o.x.constructor === Array ? (v.__fnct || (v.__fnct = []), v.__fnct[d] ? P = v.__fnct[d] : (B = m.o.x[d] === void 0 ? m.o.x[0] : m.o.x[d], q = m.o.y[d] === void 0 ? m.o.y[0] : m.o.y[d], z = m.i.x[d] === void 0 ? m.i.x[0] : m.i.x[d], Z = m.i.y[d] === void 0 ? m.i.y[0] : m.i.y[d], P = BezierFactory.getBezierEasing(B, q, z, Z).get, v.__fnct[d] = P)) : v.__fnct ? P = v.__fnct : (B = m.o.x, q = m.o.y, z = m.i.x, Z = m.i.y, P = BezierFactory.getBezierEasing(B, q, z, Z).get, m.keyframeMetadata = P), w = P((r - I) / (L - I)))), T = g.s || m.e, G = m.h === 1 ? m.s[d] : m.s[d] + (T[d] - m.s[d]) * w, this.propType === "multidimensional" ? c[d] = G : c = G;
      }
      return a.lastIndex = u, c;
    }
    function slerp(r, a, s) {
      var c = [], u = r[0], d = r[1], h = r[2], p = r[3], m = a[0], g = a[1], v = a[2], y = a[3], x, w, S, M, P;
      return w = u * m + d * g + h * v + p * y, w < 0 && (w = -w, m = -m, g = -g, v = -v, y = -y), 1 - w > 1e-6 ? (x = Math.acos(w), S = Math.sin(x), M = Math.sin((1 - s) * x) / S, P = Math.sin(s * x) / S) : (M = 1 - s, P = s), c[0] = M * u + P * m, c[1] = M * d + P * g, c[2] = M * h + P * v, c[3] = M * p + P * y, c;
    }
    function quaternionToEuler(r, a) {
      var s = a[0], c = a[1], u = a[2], d = a[3], h = Math.atan2(2 * c * d - 2 * s * u, 1 - 2 * c * c - 2 * u * u), p = Math.asin(2 * s * c + 2 * u * d), m = Math.atan2(2 * s * d - 2 * c * u, 1 - 2 * s * s - 2 * u * u);
      r[0] = h / degToRads, r[1] = p / degToRads, r[2] = m / degToRads;
    }
    function createQuaternion(r) {
      var a = r[0] * degToRads, s = r[1] * degToRads, c = r[2] * degToRads, u = Math.cos(a / 2), d = Math.cos(s / 2), h = Math.cos(c / 2), p = Math.sin(a / 2), m = Math.sin(s / 2), g = Math.sin(c / 2), v = u * d * h - p * m * g, y = p * m * h + u * d * g, x = p * d * h + u * m * g, w = u * m * h - p * d * g;
      return [y, x, w, v];
    }
    function getValueAtCurrentTime() {
      var r = this.comp.renderedFrame - this.offsetTime, a = this.keyframes[0].t - this.offsetTime, s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(r === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= s && r >= s || this._caching.lastFrame < a && r < a))) {
        this._caching.lastFrame >= r && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var c = this.interpolateValue(r, this._caching);
        this.pv = c;
      }
      return this._caching.lastFrame = r, this.pv;
    }
    function setVValue(r) {
      var a;
      if (this.propType === "unidimensional")
        a = r * this.mult, mathAbs(this.v - a) > 1e-5 && (this.v = a, this._mdf = !0);
      else
        for (var s = 0, c = this.v.length; s < c; )
          a = r[s] * this.mult, mathAbs(this.v[s] - a) > 1e-5 && (this.v[s] = a, this._mdf = !0), s += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var r, a = this.effectsSequence.length, s = this.kf ? this.pv : this.data.k;
        for (r = 0; r < a; r += 1)
          s = this.effectsSequence[r](s);
        this.setVValue(s), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(r) {
      this.effectsSequence.push(r), this.container.addDynamicProperty(this);
    }
    function ValueProperty(r, a, s, c) {
      this.propType = "unidimensional", this.mult = s || 1, this.data = a, this.v = s ? a.k * s : a.k, this.pv = a.k, this._mdf = !1, this.elem = r, this.container = c, this.comp = r.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(r, a, s, c) {
      this.propType = "multidimensional", this.mult = s || 1, this.data = a, this._mdf = !1, this.elem = r, this.container = c, this.comp = r.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var u, d = a.k.length;
      for (this.v = createTypedArray("float32", d), this.pv = createTypedArray("float32", d), this.vel = createTypedArray("float32", d), u = 0; u < d; u += 1)
        this.v[u] = a.k[u] * this.mult, this.pv[u] = a.k[u];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(r, a, s, c) {
      this.propType = "unidimensional", this.keyframes = a.k, this.keyframesMetadata = [], this.offsetTime = r.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = a, this.mult = s || 1, this.elem = r, this.container = c, this.comp = r.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(r, a, s, c) {
      this.propType = "multidimensional";
      var u, d = a.k.length, h, p, m, g;
      for (u = 0; u < d - 1; u += 1)
        a.k[u].to && a.k[u].s && a.k[u + 1] && a.k[u + 1].s && (h = a.k[u].s, p = a.k[u + 1].s, m = a.k[u].to, g = a.k[u].ti, (h.length === 2 && !(h[0] === p[0] && h[1] === p[1]) && bez.pointOnLine2D(h[0], h[1], p[0], p[1], h[0] + m[0], h[1] + m[1]) && bez.pointOnLine2D(h[0], h[1], p[0], p[1], p[0] + g[0], p[1] + g[1]) || h.length === 3 && !(h[0] === p[0] && h[1] === p[1] && h[2] === p[2]) && bez.pointOnLine3D(h[0], h[1], h[2], p[0], p[1], p[2], h[0] + m[0], h[1] + m[1], h[2] + m[2]) && bez.pointOnLine3D(h[0], h[1], h[2], p[0], p[1], p[2], p[0] + g[0], p[1] + g[1], p[2] + g[2])) && (a.k[u].to = null, a.k[u].ti = null), h[0] === p[0] && h[1] === p[1] && m[0] === 0 && m[1] === 0 && g[0] === 0 && g[1] === 0 && (h.length === 2 || h[2] === p[2] && m[2] === 0 && g[2] === 0) && (a.k[u].to = null, a.k[u].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = a, this.keyframes = a.k, this.keyframesMetadata = [], this.offsetTime = r.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = s || 1, this.elem = r, this.container = c, this.comp = r.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var v = a.k[0].s.length;
      for (this.v = createTypedArray("float32", v), this.pv = createTypedArray("float32", v), u = 0; u < v; u += 1)
        this.v[u] = initFrame, this.pv[u] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", v)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = /* @__PURE__ */ function() {
      function r(s, c, u, d, h) {
        c.sid && (c = s.globalData.slotManager.getProp(c));
        var p;
        if (!c.k.length)
          p = new ValueProperty(s, c, d, h);
        else if (typeof c.k[0] == "number")
          p = new MultiDimensionalProperty(s, c, d, h);
        else
          switch (u) {
            case 0:
              p = new KeyframedValueProperty(s, c, d, h);
              break;
            case 1:
              p = new KeyframedMultidimensionalProperty(s, c, d, h);
              break;
          }
        return p.effectsSequence.length && h.addDynamicProperty(p), p;
      }
      var a = {
        getProp: r
      };
      return a;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(a) {
        this.dynamicProperties.indexOf(a) === -1 && (this.dynamicProperties.push(a), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var a, s = this.dynamicProperties.length;
        for (a = 0; a < s; a += 1)
          this.dynamicProperties[a].getValue(), this.dynamicProperties[a]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(a) {
        this.container = a, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function r() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, r);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(r, a) {
      this.c = r, this.setLength(a);
      for (var s = 0; s < a; )
        this.v[s] = pointPool.newElement(), this.o[s] = pointPool.newElement(), this.i[s] = pointPool.newElement(), s += 1;
    }, ShapePath.prototype.setLength = function(r) {
      for (; this._maxLength < r; )
        this.doubleArrayLength();
      this._length = r;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(r, a, s, c, u) {
      var d;
      switch (this._length = Math.max(this._length, c + 1), this._length >= this._maxLength && this.doubleArrayLength(), s) {
        case "v":
          d = this.v;
          break;
        case "i":
          d = this.i;
          break;
        case "o":
          d = this.o;
          break;
        default:
          d = [];
          break;
      }
      (!d[c] || d[c] && !u) && (d[c] = pointPool.newElement()), d[c][0] = r, d[c][1] = a;
    }, ShapePath.prototype.setTripleAt = function(r, a, s, c, u, d, h, p) {
      this.setXYAt(r, a, "v", h, p), this.setXYAt(s, c, "o", h, p), this.setXYAt(u, d, "i", h, p);
    }, ShapePath.prototype.reverse = function() {
      var r = new ShapePath();
      r.setPathData(this.c, this._length);
      var a = this.v, s = this.o, c = this.i, u = 0;
      this.c && (r.setTripleAt(a[0][0], a[0][1], c[0][0], c[0][1], s[0][0], s[0][1], 0, !1), u = 1);
      var d = this._length - 1, h = this._length, p;
      for (p = u; p < h; p += 1)
        r.setTripleAt(a[d][0], a[d][1], c[d][0], c[d][1], s[d][0], s[d][1], p, !1), d -= 1;
      return r;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function r() {
        return new ShapePath();
      }
      function a(u) {
        var d = u._length, h;
        for (h = 0; h < d; h += 1)
          pointPool.release(u.v[h]), pointPool.release(u.i[h]), pointPool.release(u.o[h]), u.v[h] = null, u.i[h] = null, u.o[h] = null;
        u._length = 0, u.c = !1;
      }
      function s(u) {
        var d = c.newElement(), h, p = u._length === void 0 ? u.v.length : u._length;
        for (d.setLength(p), d.c = u.c, h = 0; h < p; h += 1)
          d.setTripleAt(u.v[h][0], u.v[h][1], u.o[h][0], u.o[h][1], u.i[h][0], u.i[h][1], h);
        return d;
      }
      var c = poolFactory(4, r, a);
      return c.clone = s, c;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(r) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = r, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var r;
      for (r = 0; r < this._length; r += 1)
        shapePool.release(this.shapes[r]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var r = {
        newShapeCollection: u,
        release: d
      }, a = 0, s = 4, c = createSizedArray(s);
      function u() {
        var h;
        return a ? (a -= 1, h = c[a]) : h = new ShapeCollection(), h;
      }
      function d(h) {
        var p, m = h._length;
        for (p = 0; p < m; p += 1)
          shapePool.release(h.shapes[p]);
        h._length = 0, a === s && (c = pooling.double(c), s *= 2), c[a] = h, a += 1;
      }
      return r;
    }(), ShapePropertyFactory = function() {
      var r = -999999;
      function a(L, I, T) {
        var E = T.lastIndex, R, A, k, V, B, q, z, Z, G, K = this.keyframes;
        if (L < K[0].t - this.offsetTime)
          R = K[0].s[0], k = !0, E = 0;
        else if (L >= K[K.length - 1].t - this.offsetTime)
          R = K[K.length - 1].s ? K[K.length - 1].s[0] : K[K.length - 2].e[0], k = !0;
        else {
          for (var U = E, F = K.length - 1, N = !0, D, j, H; N && (D = K[U], j = K[U + 1], !(j.t - this.offsetTime > L)); )
            U < F - 1 ? U += 1 : N = !1;
          if (H = this.keyframesMetadata[U] || {}, k = D.h === 1, E = U, !k) {
            if (L >= j.t - this.offsetTime)
              Z = 1;
            else if (L < D.t - this.offsetTime)
              Z = 0;
            else {
              var W;
              H.__fnct ? W = H.__fnct : (W = BezierFactory.getBezierEasing(D.o.x, D.o.y, D.i.x, D.i.y).get, H.__fnct = W), Z = W((L - (D.t - this.offsetTime)) / (j.t - this.offsetTime - (D.t - this.offsetTime)));
            }
            A = j.s ? j.s[0] : D.e[0];
          }
          R = D.s[0];
        }
        for (q = I._length, z = R.i[0].length, T.lastIndex = E, V = 0; V < q; V += 1)
          for (B = 0; B < z; B += 1)
            G = k ? R.i[V][B] : R.i[V][B] + (A.i[V][B] - R.i[V][B]) * Z, I.i[V][B] = G, G = k ? R.o[V][B] : R.o[V][B] + (A.o[V][B] - R.o[V][B]) * Z, I.o[V][B] = G, G = k ? R.v[V][B] : R.v[V][B] + (A.v[V][B] - R.v[V][B]) * Z, I.v[V][B] = G;
      }
      function s() {
        var L = this.comp.renderedFrame - this.offsetTime, I = this.keyframes[0].t - this.offsetTime, T = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, E = this._caching.lastFrame;
        return E !== r && (E < I && L < I || E > T && L > T) || (this._caching.lastIndex = E < L ? this._caching.lastIndex : 0, this.interpolateShape(L, this.pv, this._caching)), this._caching.lastFrame = L, this.pv;
      }
      function c() {
        this.paths = this.localShapeCollection;
      }
      function u(L, I) {
        if (L._length !== I._length || L.c !== I.c)
          return !1;
        var T, E = L._length;
        for (T = 0; T < E; T += 1)
          if (L.v[T][0] !== I.v[T][0] || L.v[T][1] !== I.v[T][1] || L.o[T][0] !== I.o[T][0] || L.o[T][1] !== I.o[T][1] || L.i[T][0] !== I.i[T][0] || L.i[T][1] !== I.i[T][1])
            return !1;
        return !0;
      }
      function d(L) {
        u(this.v, L) || (this.v = shapePool.clone(L), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function h() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var L;
          this.kf ? L = this.pv : this.data.ks ? L = this.data.ks.k : L = this.data.pt.k;
          var I, T = this.effectsSequence.length;
          for (I = 0; I < T; I += 1)
            L = this.effectsSequence[I](L);
          this.setVValue(L), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function p(L, I, T) {
        this.propType = "shape", this.comp = L.comp, this.container = L, this.elem = L, this.data = I, this.k = !1, this.kf = !1, this._mdf = !1;
        var E = T === 3 ? I.pt.k : I.ks.k;
        this.v = shapePool.clone(E), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = c, this.effectsSequence = [];
      }
      function m(L) {
        this.effectsSequence.push(L), this.container.addDynamicProperty(this);
      }
      p.prototype.interpolateShape = a, p.prototype.getValue = h, p.prototype.setVValue = d, p.prototype.addEffect = m;
      function g(L, I, T) {
        this.propType = "shape", this.comp = L.comp, this.elem = L, this.container = L, this.offsetTime = L.data.st, this.keyframes = T === 3 ? I.pt.k : I.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var E = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, E), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = r, this.reset = c, this._caching = {
          lastFrame: r,
          lastIndex: 0
        }, this.effectsSequence = [s.bind(this)];
      }
      g.prototype.getValue = h, g.prototype.interpolateShape = a, g.prototype.setVValue = d, g.prototype.addEffect = m;
      var v = function() {
        var L = roundCorner;
        function I(T, E) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = E.d, this.elem = T, this.comp = T.comp, this.frameId = -1, this.initDynamicPropertyContainer(T), this.p = PropertyFactory.getProp(T, E.p, 1, 0, this), this.s = PropertyFactory.getProp(T, E.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return I.prototype = {
          reset: c,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var E = this.p.v[0], R = this.p.v[1], A = this.s.v[0] / 2, k = this.s.v[1] / 2, V = this.d !== 3, B = this.v;
            B.v[0][0] = E, B.v[0][1] = R - k, B.v[1][0] = V ? E + A : E - A, B.v[1][1] = R, B.v[2][0] = E, B.v[2][1] = R + k, B.v[3][0] = V ? E - A : E + A, B.v[3][1] = R, B.i[0][0] = V ? E - A * L : E + A * L, B.i[0][1] = R - k, B.i[1][0] = V ? E + A : E - A, B.i[1][1] = R - k * L, B.i[2][0] = V ? E + A * L : E - A * L, B.i[2][1] = R + k, B.i[3][0] = V ? E - A : E + A, B.i[3][1] = R + k * L, B.o[0][0] = V ? E + A * L : E - A * L, B.o[0][1] = R - k, B.o[1][0] = V ? E + A : E - A, B.o[1][1] = R + k * L, B.o[2][0] = V ? E - A * L : E + A * L, B.o[2][1] = R + k, B.o[3][0] = V ? E - A : E + A, B.o[3][1] = R - k * L;
          }
        }, extendPrototype([DynamicPropertyContainer], I), I;
      }(), y = function() {
        function L(I, T) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = I, this.comp = I.comp, this.data = T, this.frameId = -1, this.d = T.d, this.initDynamicPropertyContainer(I), T.sy === 1 ? (this.ir = PropertyFactory.getProp(I, T.ir, 0, 0, this), this.is = PropertyFactory.getProp(I, T.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(I, T.pt, 0, 0, this), this.p = PropertyFactory.getProp(I, T.p, 1, 0, this), this.r = PropertyFactory.getProp(I, T.r, 0, degToRads, this), this.or = PropertyFactory.getProp(I, T.or, 0, 0, this), this.os = PropertyFactory.getProp(I, T.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return L.prototype = {
          reset: c,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var T = Math.floor(this.pt.v) * 2, E = Math.PI * 2 / T, R = !0, A = this.or.v, k = this.ir.v, V = this.os.v, B = this.is.v, q = 2 * Math.PI * A / (T * 2), z = 2 * Math.PI * k / (T * 2), Z, G, K, U, F = -Math.PI / 2;
            F += this.r.v;
            var N = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, Z = 0; Z < T; Z += 1) {
              G = R ? A : k, K = R ? V : B, U = R ? q : z;
              var D = G * Math.cos(F), j = G * Math.sin(F), H = D === 0 && j === 0 ? 0 : j / Math.sqrt(D * D + j * j), W = D === 0 && j === 0 ? 0 : -D / Math.sqrt(D * D + j * j);
              D += +this.p.v[0], j += +this.p.v[1], this.v.setTripleAt(D, j, D - H * U * K * N, j - W * U * K * N, D + H * U * K * N, j + W * U * K * N, Z, !0), R = !R, F += E * N;
            }
          },
          convertPolygonToPath: function() {
            var T = Math.floor(this.pt.v), E = Math.PI * 2 / T, R = this.or.v, A = this.os.v, k = 2 * Math.PI * R / (T * 4), V, B = -Math.PI * 0.5, q = this.data.d === 3 ? -1 : 1;
            for (B += this.r.v, this.v._length = 0, V = 0; V < T; V += 1) {
              var z = R * Math.cos(B), Z = R * Math.sin(B), G = z === 0 && Z === 0 ? 0 : Z / Math.sqrt(z * z + Z * Z), K = z === 0 && Z === 0 ? 0 : -z / Math.sqrt(z * z + Z * Z);
              z += +this.p.v[0], Z += +this.p.v[1], this.v.setTripleAt(z, Z, z - G * k * A * q, Z - K * k * A * q, z + G * k * A * q, Z + K * k * A * q, V, !0), B += E * q;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], L), L;
      }(), x = function() {
        function L(I, T) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = I, this.comp = I.comp, this.frameId = -1, this.d = T.d, this.initDynamicPropertyContainer(I), this.p = PropertyFactory.getProp(I, T.p, 1, 0, this), this.s = PropertyFactory.getProp(I, T.s, 1, 0, this), this.r = PropertyFactory.getProp(I, T.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return L.prototype = {
          convertRectToPath: function() {
            var T = this.p.v[0], E = this.p.v[1], R = this.s.v[0] / 2, A = this.s.v[1] / 2, k = bmMin(R, A, this.r.v), V = k * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(T + R, E - A + k, T + R, E - A + k, T + R, E - A + V, 0, !0), this.v.setTripleAt(T + R, E + A - k, T + R, E + A - V, T + R, E + A - k, 1, !0), k !== 0 ? (this.v.setTripleAt(T + R - k, E + A, T + R - k, E + A, T + R - V, E + A, 2, !0), this.v.setTripleAt(T - R + k, E + A, T - R + V, E + A, T - R + k, E + A, 3, !0), this.v.setTripleAt(T - R, E + A - k, T - R, E + A - k, T - R, E + A - V, 4, !0), this.v.setTripleAt(T - R, E - A + k, T - R, E - A + V, T - R, E - A + k, 5, !0), this.v.setTripleAt(T - R + k, E - A, T - R + k, E - A, T - R + V, E - A, 6, !0), this.v.setTripleAt(T + R - k, E - A, T + R - V, E - A, T + R - k, E - A, 7, !0)) : (this.v.setTripleAt(T - R, E + A, T - R + V, E + A, T - R, E + A, 2), this.v.setTripleAt(T - R, E - A, T - R, E - A + V, T - R, E - A, 3))) : (this.v.setTripleAt(T + R, E - A + k, T + R, E - A + V, T + R, E - A + k, 0, !0), k !== 0 ? (this.v.setTripleAt(T + R - k, E - A, T + R - k, E - A, T + R - V, E - A, 1, !0), this.v.setTripleAt(T - R + k, E - A, T - R + V, E - A, T - R + k, E - A, 2, !0), this.v.setTripleAt(T - R, E - A + k, T - R, E - A + k, T - R, E - A + V, 3, !0), this.v.setTripleAt(T - R, E + A - k, T - R, E + A - V, T - R, E + A - k, 4, !0), this.v.setTripleAt(T - R + k, E + A, T - R + k, E + A, T - R + V, E + A, 5, !0), this.v.setTripleAt(T + R - k, E + A, T + R - V, E + A, T + R - k, E + A, 6, !0), this.v.setTripleAt(T + R, E + A - k, T + R, E + A - k, T + R, E + A - V, 7, !0)) : (this.v.setTripleAt(T - R, E - A, T - R + V, E - A, T - R, E - A, 1, !0), this.v.setTripleAt(T - R, E + A, T - R, E + A - V, T - R, E + A, 2, !0), this.v.setTripleAt(T + R, E + A, T + R - V, E + A, T + R, E + A, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: c
        }, extendPrototype([DynamicPropertyContainer], L), L;
      }();
      function w(L, I, T) {
        var E;
        if (T === 3 || T === 4) {
          var R = T === 3 ? I.pt : I.ks, A = R.k;
          A.length ? E = new g(L, I, T) : E = new p(L, I, T);
        } else T === 5 ? E = new x(L, I) : T === 6 ? E = new v(L, I) : T === 7 && (E = new y(L, I));
        return E.k && L.addDynamicProperty(E), E;
      }
      function S() {
        return p;
      }
      function M() {
        return g;
      }
      var P = {};
      return P.getShapeProp = w, P.getConstructorFunction = S, P.getKeyframedConstructorFunction = M, P;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = /* @__PURE__ */ function() {
      var r = Math.cos, a = Math.sin, s = Math.tan, c = Math.round;
      function u() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function d(D) {
        if (D === 0)
          return this;
        var j = r(D), H = a(D);
        return this._t(j, -H, 0, 0, H, j, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function h(D) {
        if (D === 0)
          return this;
        var j = r(D), H = a(D);
        return this._t(1, 0, 0, 0, 0, j, -H, 0, 0, H, j, 0, 0, 0, 0, 1);
      }
      function p(D) {
        if (D === 0)
          return this;
        var j = r(D), H = a(D);
        return this._t(j, 0, H, 0, 0, 1, 0, 0, -H, 0, j, 0, 0, 0, 0, 1);
      }
      function m(D) {
        if (D === 0)
          return this;
        var j = r(D), H = a(D);
        return this._t(j, -H, 0, 0, H, j, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function g(D, j) {
        return this._t(1, j, D, 1, 0, 0);
      }
      function v(D, j) {
        return this.shear(s(D), s(j));
      }
      function y(D, j) {
        var H = r(j), W = a(j);
        return this._t(H, W, 0, 0, -W, H, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, s(D), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(H, -W, 0, 0, W, H, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function x(D, j, H) {
        return !H && H !== 0 && (H = 1), D === 1 && j === 1 && H === 1 ? this : this._t(D, 0, 0, 0, 0, j, 0, 0, 0, 0, H, 0, 0, 0, 0, 1);
      }
      function w(D, j, H, W, re, ae, ee, X, J, ie, oe, fe, ve, ue, pe, we) {
        return this.props[0] = D, this.props[1] = j, this.props[2] = H, this.props[3] = W, this.props[4] = re, this.props[5] = ae, this.props[6] = ee, this.props[7] = X, this.props[8] = J, this.props[9] = ie, this.props[10] = oe, this.props[11] = fe, this.props[12] = ve, this.props[13] = ue, this.props[14] = pe, this.props[15] = we, this;
      }
      function S(D, j, H) {
        return H = H || 0, D !== 0 || j !== 0 || H !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, D, j, H, 1) : this;
      }
      function M(D, j, H, W, re, ae, ee, X, J, ie, oe, fe, ve, ue, pe, we) {
        var ye = this.props;
        if (D === 1 && j === 0 && H === 0 && W === 0 && re === 0 && ae === 1 && ee === 0 && X === 0 && J === 0 && ie === 0 && oe === 1 && fe === 0)
          return ye[12] = ye[12] * D + ye[15] * ve, ye[13] = ye[13] * ae + ye[15] * ue, ye[14] = ye[14] * oe + ye[15] * pe, ye[15] *= we, this._identityCalculated = !1, this;
        var Ie = ye[0], Ee = ye[1], ne = ye[2], se = ye[3], de = ye[4], Ce = ye[5], me = ye[6], xe = ye[7], Se = ye[8], Re = ye[9], Pe = ye[10], ke = ye[11], De = ye[12], Fe = ye[13], Xe = ye[14], ze = ye[15];
        return ye[0] = Ie * D + Ee * re + ne * J + se * ve, ye[1] = Ie * j + Ee * ae + ne * ie + se * ue, ye[2] = Ie * H + Ee * ee + ne * oe + se * pe, ye[3] = Ie * W + Ee * X + ne * fe + se * we, ye[4] = de * D + Ce * re + me * J + xe * ve, ye[5] = de * j + Ce * ae + me * ie + xe * ue, ye[6] = de * H + Ce * ee + me * oe + xe * pe, ye[7] = de * W + Ce * X + me * fe + xe * we, ye[8] = Se * D + Re * re + Pe * J + ke * ve, ye[9] = Se * j + Re * ae + Pe * ie + ke * ue, ye[10] = Se * H + Re * ee + Pe * oe + ke * pe, ye[11] = Se * W + Re * X + Pe * fe + ke * we, ye[12] = De * D + Fe * re + Xe * J + ze * ve, ye[13] = De * j + Fe * ae + Xe * ie + ze * ue, ye[14] = De * H + Fe * ee + Xe * oe + ze * pe, ye[15] = De * W + Fe * X + Xe * fe + ze * we, this._identityCalculated = !1, this;
      }
      function P(D) {
        var j = D.props;
        return this.transform(j[0], j[1], j[2], j[3], j[4], j[5], j[6], j[7], j[8], j[9], j[10], j[11], j[12], j[13], j[14], j[15]);
      }
      function L() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function I(D) {
        for (var j = 0; j < 16; ) {
          if (D.props[j] !== this.props[j])
            return !1;
          j += 1;
        }
        return !0;
      }
      function T(D) {
        var j;
        for (j = 0; j < 16; j += 1)
          D.props[j] = this.props[j];
        return D;
      }
      function E(D) {
        var j;
        for (j = 0; j < 16; j += 1)
          this.props[j] = D[j];
      }
      function R(D, j, H) {
        return {
          x: D * this.props[0] + j * this.props[4] + H * this.props[8] + this.props[12],
          y: D * this.props[1] + j * this.props[5] + H * this.props[9] + this.props[13],
          z: D * this.props[2] + j * this.props[6] + H * this.props[10] + this.props[14]
        };
      }
      function A(D, j, H) {
        return D * this.props[0] + j * this.props[4] + H * this.props[8] + this.props[12];
      }
      function k(D, j, H) {
        return D * this.props[1] + j * this.props[5] + H * this.props[9] + this.props[13];
      }
      function V(D, j, H) {
        return D * this.props[2] + j * this.props[6] + H * this.props[10] + this.props[14];
      }
      function B() {
        var D = this.props[0] * this.props[5] - this.props[1] * this.props[4], j = this.props[5] / D, H = -this.props[1] / D, W = -this.props[4] / D, re = this.props[0] / D, ae = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / D, ee = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / D, X = new Matrix();
        return X.props[0] = j, X.props[1] = H, X.props[4] = W, X.props[5] = re, X.props[12] = ae, X.props[13] = ee, X;
      }
      function q(D) {
        var j = this.getInverseMatrix();
        return j.applyToPointArray(D[0], D[1], D[2] || 0);
      }
      function z(D) {
        var j, H = D.length, W = [];
        for (j = 0; j < H; j += 1)
          W[j] = q(D[j]);
        return W;
      }
      function Z(D, j, H) {
        var W = createTypedArray("float32", 6);
        if (this.isIdentity())
          W[0] = D[0], W[1] = D[1], W[2] = j[0], W[3] = j[1], W[4] = H[0], W[5] = H[1];
        else {
          var re = this.props[0], ae = this.props[1], ee = this.props[4], X = this.props[5], J = this.props[12], ie = this.props[13];
          W[0] = D[0] * re + D[1] * ee + J, W[1] = D[0] * ae + D[1] * X + ie, W[2] = j[0] * re + j[1] * ee + J, W[3] = j[0] * ae + j[1] * X + ie, W[4] = H[0] * re + H[1] * ee + J, W[5] = H[0] * ae + H[1] * X + ie;
        }
        return W;
      }
      function G(D, j, H) {
        var W;
        return this.isIdentity() ? W = [D, j, H] : W = [D * this.props[0] + j * this.props[4] + H * this.props[8] + this.props[12], D * this.props[1] + j * this.props[5] + H * this.props[9] + this.props[13], D * this.props[2] + j * this.props[6] + H * this.props[10] + this.props[14]], W;
      }
      function K(D, j) {
        if (this.isIdentity())
          return D + "," + j;
        var H = this.props;
        return Math.round((D * H[0] + j * H[4] + H[12]) * 100) / 100 + "," + Math.round((D * H[1] + j * H[5] + H[13]) * 100) / 100;
      }
      function U() {
        for (var D = 0, j = this.props, H = "matrix3d(", W = 1e4; D < 16; )
          H += c(j[D] * W) / W, H += D === 15 ? ")" : ",", D += 1;
        return H;
      }
      function F(D) {
        var j = 1e4;
        return D < 1e-6 && D > 0 || D > -1e-6 && D < 0 ? c(D * j) / j : D;
      }
      function N() {
        var D = this.props, j = F(D[0]), H = F(D[1]), W = F(D[4]), re = F(D[5]), ae = F(D[12]), ee = F(D[13]);
        return "matrix(" + j + "," + H + "," + W + "," + re + "," + ae + "," + ee + ")";
      }
      return function() {
        this.reset = u, this.rotate = d, this.rotateX = h, this.rotateY = p, this.rotateZ = m, this.skew = v, this.skewFromAxis = y, this.shear = g, this.scale = x, this.setTransform = w, this.translate = S, this.transform = M, this.multiply = P, this.applyToPoint = R, this.applyToX = A, this.applyToY = k, this.applyToZ = V, this.applyToPointArray = G, this.applyToTriplePoints = Z, this.applyToPointStringified = K, this.toCSS = U, this.to2dCSS = N, this.clone = T, this.cloneFromProps = E, this.equals = I, this.inversePoints = z, this.inversePoint = q, this.getInverseMatrix = B, this._t = this.transform, this.isIdentity = L, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(s) {
        return typeof s;
      } : _typeof$3 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$3(r);
    }
    var lottie = {};
    function setLocation(r) {
      setLocationHref(r);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(r) {
      setSubframeEnabled(r);
    }
    function setPrefix(r) {
      setIdPrefix(r);
    }
    function loadAnimation(r) {
      return animationManager.loadAnimation(r);
    }
    function setQuality(r) {
      if (typeof r == "string")
        switch (r) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else !isNaN(r) && r > 1 && setDefaultCurveSegments(r);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(r, a) {
      r === "expressions" && setExpressionsPlugin(a);
    }
    function getFactory(r) {
      switch (r) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(r) {
      for (var a = queryString.split("&"), s = 0; s < a.length; s += 1) {
        var c = a[s].split("=");
        if (decodeURIComponent(c[0]) == r)
          return decodeURIComponent(c[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (r) {
    }
    var ShapeModifiers = function() {
      var r = {}, a = {};
      r.registerModifier = s, r.getModifier = c;
      function s(u, d) {
        a[u] || (a[u] = d);
      }
      function c(u, d, h) {
        return new a[u](d, h);
      }
      return r;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(r) {
      if (!this.closed) {
        r.sh.container.addDynamicProperty(r.sh);
        var a = {
          shape: r.sh,
          data: r,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(a), this.addShapeToModifier(a), this._isAnimated && r.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(r, a) {
      this.shapes = [], this.elem = r, this.initDynamicPropertyContainer(r), this.initModifierProperties(r, a), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(r, a) {
      this.s = PropertyFactory.getProp(r, a.s, 0, 0.01, this), this.e = PropertyFactory.getProp(r, a.e, 0, 0.01, this), this.o = PropertyFactory.getProp(r, a.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = a.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(r) {
      r.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(r, a, s, c, u) {
      var d = [];
      a <= 1 ? d.push({
        s: r,
        e: a
      }) : r >= 1 ? d.push({
        s: r - 1,
        e: a - 1
      }) : (d.push({
        s: r,
        e: 1
      }), d.push({
        s: 0,
        e: a - 1
      }));
      var h = [], p, m = d.length, g;
      for (p = 0; p < m; p += 1)
        if (g = d[p], !(g.e * u < c || g.s * u > c + s)) {
          var v, y;
          g.s * u <= c ? v = 0 : v = (g.s * u - c) / s, g.e * u >= c + s ? y = 1 : y = (g.e * u - c) / s, h.push([v, y]);
        }
      return h.length || h.push([0, 0]), h;
    }, TrimModifier.prototype.releasePathsData = function(r) {
      var a, s = r.length;
      for (a = 0; a < s; a += 1)
        segmentsLengthPool.release(r[a]);
      return r.length = 0, r;
    }, TrimModifier.prototype.processShapes = function(r) {
      var a, s;
      if (this._mdf || r) {
        var c = this.o.v % 360 / 360;
        if (c < 0 && (c += 1), this.s.v > 1 ? a = 1 + c : this.s.v < 0 ? a = 0 + c : a = this.s.v + c, this.e.v > 1 ? s = 1 + c : this.e.v < 0 ? s = 0 + c : s = this.e.v + c, a > s) {
          var u = a;
          a = s, s = u;
        }
        a = Math.round(a * 1e4) * 1e-4, s = Math.round(s * 1e4) * 1e-4, this.sValue = a, this.eValue = s;
      } else
        a = this.sValue, s = this.eValue;
      var d, h, p = this.shapes.length, m, g, v, y, x, w = 0;
      if (s === a)
        for (h = 0; h < p; h += 1)
          this.shapes[h].localShapeCollection.releaseShapes(), this.shapes[h].shape._mdf = !0, this.shapes[h].shape.paths = this.shapes[h].localShapeCollection, this._mdf && (this.shapes[h].pathsData.length = 0);
      else if (s === 1 && a === 0 || s === 0 && a === 1) {
        if (this._mdf)
          for (h = 0; h < p; h += 1)
            this.shapes[h].pathsData.length = 0, this.shapes[h].shape._mdf = !0;
      } else {
        var S = [], M, P;
        for (h = 0; h < p; h += 1)
          if (M = this.shapes[h], !M.shape._mdf && !this._mdf && !r && this.m !== 2)
            M.shape.paths = M.localShapeCollection;
          else {
            if (d = M.shape.paths, g = d._length, x = 0, !M.shape._mdf && M.pathsData.length)
              x = M.totalShapeLength;
            else {
              for (v = this.releasePathsData(M.pathsData), m = 0; m < g; m += 1)
                y = bez.getSegmentsLength(d.shapes[m]), v.push(y), x += y.totalLength;
              M.totalShapeLength = x, M.pathsData = v;
            }
            w += x, M.shape._mdf = !0;
          }
        var L = a, I = s, T = 0, E;
        for (h = p - 1; h >= 0; h -= 1)
          if (M = this.shapes[h], M.shape._mdf) {
            for (P = M.localShapeCollection, P.releaseShapes(), this.m === 2 && p > 1 ? (E = this.calculateShapeEdges(a, s, M.totalShapeLength, T, w), T += M.totalShapeLength) : E = [[L, I]], g = E.length, m = 0; m < g; m += 1) {
              L = E[m][0], I = E[m][1], S.length = 0, I <= 1 ? S.push({
                s: M.totalShapeLength * L,
                e: M.totalShapeLength * I
              }) : L >= 1 ? S.push({
                s: M.totalShapeLength * (L - 1),
                e: M.totalShapeLength * (I - 1)
              }) : (S.push({
                s: M.totalShapeLength * L,
                e: M.totalShapeLength
              }), S.push({
                s: 0,
                e: M.totalShapeLength * (I - 1)
              }));
              var R = this.addShapes(M, S[0]);
              if (S[0].s !== S[0].e) {
                if (S.length > 1) {
                  var A = M.shape.paths.shapes[M.shape.paths._length - 1];
                  if (A.c) {
                    var k = R.pop();
                    this.addPaths(R, P), R = this.addShapes(M, S[1], k);
                  } else
                    this.addPaths(R, P), R = this.addShapes(M, S[1]);
                }
                this.addPaths(R, P);
              }
            }
            M.shape.paths = P;
          }
      }
    }, TrimModifier.prototype.addPaths = function(r, a) {
      var s, c = r.length;
      for (s = 0; s < c; s += 1)
        a.addShape(r[s]);
    }, TrimModifier.prototype.addSegment = function(r, a, s, c, u, d, h) {
      u.setXYAt(a[0], a[1], "o", d), u.setXYAt(s[0], s[1], "i", d + 1), h && u.setXYAt(r[0], r[1], "v", d), u.setXYAt(c[0], c[1], "v", d + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(r, a, s, c) {
      a.setXYAt(r[1], r[5], "o", s), a.setXYAt(r[2], r[6], "i", s + 1), c && a.setXYAt(r[0], r[4], "v", s), a.setXYAt(r[3], r[7], "v", s + 1);
    }, TrimModifier.prototype.addShapes = function(r, a, s) {
      var c = r.pathsData, u = r.shape.paths.shapes, d, h = r.shape.paths._length, p, m, g = 0, v, y, x, w, S = [], M, P = !0;
      for (s ? (y = s._length, M = s._length) : (s = shapePool.newElement(), y = 0, M = 0), S.push(s), d = 0; d < h; d += 1) {
        for (x = c[d].lengths, s.c = u[d].c, m = u[d].c ? x.length : x.length + 1, p = 1; p < m; p += 1)
          if (v = x[p - 1], g + v.addedLength < a.s)
            g += v.addedLength, s.c = !1;
          else if (g > a.e) {
            s.c = !1;
            break;
          } else
            a.s <= g && a.e >= g + v.addedLength ? (this.addSegment(u[d].v[p - 1], u[d].o[p - 1], u[d].i[p], u[d].v[p], s, y, P), P = !1) : (w = bez.getNewSegment(u[d].v[p - 1], u[d].v[p], u[d].o[p - 1], u[d].i[p], (a.s - g) / v.addedLength, (a.e - g) / v.addedLength, x[p - 1]), this.addSegmentFromArray(w, s, y, P), P = !1, s.c = !1), g += v.addedLength, y += 1;
        if (u[d].c && x.length) {
          if (v = x[p - 1], g <= a.e) {
            var L = x[p - 1].addedLength;
            a.s <= g && a.e >= g + L ? (this.addSegment(u[d].v[p - 1], u[d].o[p - 1], u[d].i[0], u[d].v[0], s, y, P), P = !1) : (w = bez.getNewSegment(u[d].v[p - 1], u[d].v[0], u[d].o[p - 1], u[d].i[0], (a.s - g) / L, (a.e - g) / L, x[p - 1]), this.addSegmentFromArray(w, s, y, P), P = !1, s.c = !1);
          } else
            s.c = !1;
          g += v.addedLength, y += 1;
        }
        if (s._length && (s.setXYAt(s.v[M][0], s.v[M][1], "i", M), s.setXYAt(s.v[s._length - 1][0], s.v[s._length - 1][1], "o", s._length - 1)), g > a.e)
          break;
        d < h - 1 && (s = shapePool.newElement(), P = !0, S.push(s), y = 0);
      }
      return S;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(r, a) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(r, a.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(r, a) {
      var s = a / 100, c = [0, 0], u = r._length, d = 0;
      for (d = 0; d < u; d += 1)
        c[0] += r.v[d][0], c[1] += r.v[d][1];
      c[0] /= u, c[1] /= u;
      var h = shapePool.newElement();
      h.c = r.c;
      var p, m, g, v, y, x;
      for (d = 0; d < u; d += 1)
        p = r.v[d][0] + (c[0] - r.v[d][0]) * s, m = r.v[d][1] + (c[1] - r.v[d][1]) * s, g = r.o[d][0] + (c[0] - r.o[d][0]) * -s, v = r.o[d][1] + (c[1] - r.o[d][1]) * -s, y = r.i[d][0] + (c[0] - r.i[d][0]) * -s, x = r.i[d][1] + (c[1] - r.i[d][1]) * -s, h.setTripleAt(p, m, g, v, y, x, d);
      return h;
    }, PuckerAndBloatModifier.prototype.processShapes = function(r) {
      var a, s, c = this.shapes.length, u, d, h = this.amount.v;
      if (h !== 0) {
        var p, m;
        for (s = 0; s < c; s += 1) {
          if (p = this.shapes[s], m = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !r))
            for (m.releaseShapes(), p.shape._mdf = !0, a = p.shape.paths.shapes, d = p.shape.paths._length, u = 0; u < d; u += 1)
              m.addShape(this.processPath(a[u], h));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var r = [0, 0];
      function a(m) {
        var g = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || g, this.a && m.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && m.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && m.skewFromAxis(-this.sk.v, this.sa.v), this.r ? m.rotate(-this.r.v) : m.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? m.translate(this.px.v, this.py.v, -this.pz.v) : m.translate(this.px.v, this.py.v, 0) : m.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function s(m) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || m) {
            var g;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var v, y;
              if (g = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (v = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / g, 0), y = this.p.getValueAtTime(this.p.keyframes[0].t / g, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (v = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / g, 0), y = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / g, 0)) : (v = this.p.pv, y = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / g, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                v = [], y = [];
                var x = this.px, w = this.py;
                x._caching.lastFrame + x.offsetTime <= x.keyframes[0].t ? (v[0] = x.getValueAtTime((x.keyframes[0].t + 0.01) / g, 0), v[1] = w.getValueAtTime((w.keyframes[0].t + 0.01) / g, 0), y[0] = x.getValueAtTime(x.keyframes[0].t / g, 0), y[1] = w.getValueAtTime(w.keyframes[0].t / g, 0)) : x._caching.lastFrame + x.offsetTime >= x.keyframes[x.keyframes.length - 1].t ? (v[0] = x.getValueAtTime(x.keyframes[x.keyframes.length - 1].t / g, 0), v[1] = w.getValueAtTime(w.keyframes[w.keyframes.length - 1].t / g, 0), y[0] = x.getValueAtTime((x.keyframes[x.keyframes.length - 1].t - 0.01) / g, 0), y[1] = w.getValueAtTime((w.keyframes[w.keyframes.length - 1].t - 0.01) / g, 0)) : (v = [x.pv, w.pv], y[0] = x.getValueAtTime((x._caching.lastFrame + x.offsetTime - 0.01) / g, x.offsetTime), y[1] = w.getValueAtTime((w._caching.lastFrame + w.offsetTime - 0.01) / g, w.offsetTime));
              } else
                y = r, v = y;
              this.v.rotate(-Math.atan2(v[1] - y[1], v[0] - y[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function c() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function u() {
      }
      function d(m) {
        this._addDynamicProperty(m), this.elem.addDynamicProperty(m), this._isDirty = !0;
      }
      function h(m, g, v) {
        if (this.elem = m, this.frameId = -1, this.propType = "transform", this.data = g, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(v || m), g.p && g.p.s ? (this.px = PropertyFactory.getProp(m, g.p.x, 0, 0, this), this.py = PropertyFactory.getProp(m, g.p.y, 0, 0, this), g.p.z && (this.pz = PropertyFactory.getProp(m, g.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(m, g.p || {
          k: [0, 0, 0]
        }, 1, 0, this), g.rx) {
          if (this.rx = PropertyFactory.getProp(m, g.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(m, g.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(m, g.rz, 0, degToRads, this), g.or.k[0].ti) {
            var y, x = g.or.k.length;
            for (y = 0; y < x; y += 1)
              g.or.k[y].to = null, g.or.k[y].ti = null;
          }
          this.or = PropertyFactory.getProp(m, g.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(m, g.r || {
            k: 0
          }, 0, degToRads, this);
        g.sk && (this.sk = PropertyFactory.getProp(m, g.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(m, g.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(m, g.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(m, g.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), g.o ? this.o = PropertyFactory.getProp(m, g.o, 0, 0.01, m) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      h.prototype = {
        applyToMatrix: a,
        getValue: s,
        precalculateMatrix: c,
        autoOrient: u
      }, extendPrototype([DynamicPropertyContainer], h), h.prototype.addDynamicProperty = d, h.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function p(m, g, v) {
        return new h(m, g, v);
      }
      return {
        getTransformProperty: p
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(r, a) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(r, a.c, 0, null, this), this.o = PropertyFactory.getProp(r, a.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(r, a.tr, this), this.so = PropertyFactory.getProp(r, a.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(r, a.tr.eo, 0, 0.01, this), this.data = a, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(r, a, s, c, u, d) {
      var h = d ? -1 : 1, p = c.s.v[0] + (1 - c.s.v[0]) * (1 - u), m = c.s.v[1] + (1 - c.s.v[1]) * (1 - u);
      r.translate(c.p.v[0] * h * u, c.p.v[1] * h * u, c.p.v[2]), a.translate(-c.a.v[0], -c.a.v[1], c.a.v[2]), a.rotate(-c.r.v * h * u), a.translate(c.a.v[0], c.a.v[1], c.a.v[2]), s.translate(-c.a.v[0], -c.a.v[1], c.a.v[2]), s.scale(d ? 1 / p : p, d ? 1 / m : m), s.translate(c.a.v[0], c.a.v[1], c.a.v[2]);
    }, RepeaterModifier.prototype.init = function(r, a, s, c) {
      for (this.elem = r, this.arr = a, this.pos = s, this.elemsData = c, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(r), this.initModifierProperties(r, a[s]); s > 0; )
        s -= 1, this._elements.unshift(a[s]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(r) {
      var a, s = r.length;
      for (a = 0; a < s; a += 1)
        r[a]._processed = !1, r[a].ty === "gr" && this.resetElements(r[a].it);
    }, RepeaterModifier.prototype.cloneElements = function(r) {
      var a = JSON.parse(JSON.stringify(r));
      return this.resetElements(a), a;
    }, RepeaterModifier.prototype.changeGroupRender = function(r, a) {
      var s, c = r.length;
      for (s = 0; s < c; s += 1)
        r[s]._render = a, r[s].ty === "gr" && this.changeGroupRender(r[s].it, a);
    }, RepeaterModifier.prototype.processShapes = function(r) {
      var a, s, c, u, d, h = !1;
      if (this._mdf || r) {
        var p = Math.ceil(this.c.v);
        if (this._groups.length < p) {
          for (; this._groups.length < p; ) {
            var m = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            m.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, m), this._groups.splice(0, 0, m), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), h = !0;
        }
        d = 0;
        var g;
        for (c = 0; c <= this._groups.length - 1; c += 1) {
          if (g = d < p, this._groups[c]._render = g, this.changeGroupRender(this._groups[c].it, g), !g) {
            var v = this.elemsData[c].it, y = v[v.length - 1];
            y.transform.op.v !== 0 ? (y.transform.op._mdf = !0, y.transform.op.v = 0) : y.transform.op._mdf = !1;
          }
          d += 1;
        }
        this._currentCopies = p;
        var x = this.o.v, w = x % 1, S = x > 0 ? Math.floor(x) : Math.ceil(x), M = this.pMatrix.props, P = this.rMatrix.props, L = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var I = 0;
        if (x > 0) {
          for (; I < S; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), I += 1;
          w && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, w, !1), I += w);
        } else if (x < 0) {
          for (; I > S; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), I -= 1;
          w && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -w, !0), I -= w);
        }
        c = this.data.m === 1 ? 0 : this._currentCopies - 1, u = this.data.m === 1 ? 1 : -1, d = this._currentCopies;
        for (var T, E; d; ) {
          if (a = this.elemsData[c].it, s = a[a.length - 1].transform.mProps.v.props, E = s.length, a[a.length - 1].transform.mProps._mdf = !0, a[a.length - 1].transform.op._mdf = !0, a[a.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (c / (this._currentCopies - 1)), I !== 0) {
            for ((c !== 0 && u === 1 || c !== this._currentCopies - 1 && u === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(P[0], P[1], P[2], P[3], P[4], P[5], P[6], P[7], P[8], P[9], P[10], P[11], P[12], P[13], P[14], P[15]), this.matrix.transform(L[0], L[1], L[2], L[3], L[4], L[5], L[6], L[7], L[8], L[9], L[10], L[11], L[12], L[13], L[14], L[15]), this.matrix.transform(M[0], M[1], M[2], M[3], M[4], M[5], M[6], M[7], M[8], M[9], M[10], M[11], M[12], M[13], M[14], M[15]), T = 0; T < E; T += 1)
              s[T] = this.matrix.props[T];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), T = 0; T < E; T += 1)
              s[T] = this.matrix.props[T];
          I += 1, d -= 1, c += u;
        }
      } else
        for (d = this._currentCopies, c = 0, u = 1; d; )
          a = this.elemsData[c].it, s = a[a.length - 1].transform.mProps.v.props, a[a.length - 1].transform.mProps._mdf = !1, a[a.length - 1].transform.op._mdf = !1, d -= 1, c += u;
      return h;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(r, a) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(r, a.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(r, a) {
      var s = shapePool.newElement();
      s.c = r.c;
      var c, u = r._length, d, h, p, m, g, v, y = 0, x, w, S, M, P, L;
      for (c = 0; c < u; c += 1)
        d = r.v[c], p = r.o[c], h = r.i[c], d[0] === p[0] && d[1] === p[1] && d[0] === h[0] && d[1] === h[1] ? (c === 0 || c === u - 1) && !r.c ? (s.setTripleAt(d[0], d[1], p[0], p[1], h[0], h[1], y), y += 1) : (c === 0 ? m = r.v[u - 1] : m = r.v[c - 1], g = Math.sqrt(Math.pow(d[0] - m[0], 2) + Math.pow(d[1] - m[1], 2)), v = g ? Math.min(g / 2, a) / g : 0, P = d[0] + (m[0] - d[0]) * v, x = P, L = d[1] - (d[1] - m[1]) * v, w = L, S = x - (x - d[0]) * roundCorner, M = w - (w - d[1]) * roundCorner, s.setTripleAt(x, w, S, M, P, L, y), y += 1, c === u - 1 ? m = r.v[0] : m = r.v[c + 1], g = Math.sqrt(Math.pow(d[0] - m[0], 2) + Math.pow(d[1] - m[1], 2)), v = g ? Math.min(g / 2, a) / g : 0, S = d[0] + (m[0] - d[0]) * v, x = S, M = d[1] + (m[1] - d[1]) * v, w = M, P = x - (x - d[0]) * roundCorner, L = w - (w - d[1]) * roundCorner, s.setTripleAt(x, w, S, M, P, L, y), y += 1) : (s.setTripleAt(r.v[c][0], r.v[c][1], r.o[c][0], r.o[c][1], r.i[c][0], r.i[c][1], y), y += 1);
      return s;
    }, RoundCornersModifier.prototype.processShapes = function(r) {
      var a, s, c = this.shapes.length, u, d, h = this.rd.v;
      if (h !== 0) {
        var p, m;
        for (s = 0; s < c; s += 1) {
          if (p = this.shapes[s], m = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !r))
            for (m.releaseShapes(), p.shape._mdf = !0, a = p.shape.paths.shapes, d = p.shape.paths._length, u = 0; u < d; u += 1)
              m.addShape(this.processPath(a[u], h));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(r, a) {
      return Math.abs(r - a) * 1e5 <= Math.min(Math.abs(r), Math.abs(a));
    }
    function floatZero(r) {
      return Math.abs(r) <= 1e-5;
    }
    function lerp(r, a, s) {
      return r * (1 - s) + a * s;
    }
    function lerpPoint(r, a, s) {
      return [lerp(r[0], a[0], s), lerp(r[1], a[1], s)];
    }
    function quadRoots(r, a, s) {
      if (r === 0) return [];
      var c = a * a - 4 * r * s;
      if (c < 0) return [];
      var u = -a / (2 * r);
      if (c === 0) return [u];
      var d = Math.sqrt(c) / (2 * r);
      return [u - d, u + d];
    }
    function polynomialCoefficients(r, a, s, c) {
      return [-r + 3 * a - 3 * s + c, 3 * r - 6 * a + 3 * s, -3 * r + 3 * a, r];
    }
    function singlePoint(r) {
      return new PolynomialBezier(r, r, r, r, !1);
    }
    function PolynomialBezier(r, a, s, c, u) {
      u && pointEqual(r, a) && (a = lerpPoint(r, c, 1 / 3)), u && pointEqual(s, c) && (s = lerpPoint(r, c, 2 / 3));
      var d = polynomialCoefficients(r[0], a[0], s[0], c[0]), h = polynomialCoefficients(r[1], a[1], s[1], c[1]);
      this.a = [d[0], h[0]], this.b = [d[1], h[1]], this.c = [d[2], h[2]], this.d = [d[3], h[3]], this.points = [r, a, s, c];
    }
    PolynomialBezier.prototype.point = function(r) {
      return [((this.a[0] * r + this.b[0]) * r + this.c[0]) * r + this.d[0], ((this.a[1] * r + this.b[1]) * r + this.c[1]) * r + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(r) {
      return [(3 * r * this.a[0] + 2 * this.b[0]) * r + this.c[0], (3 * r * this.a[1] + 2 * this.b[1]) * r + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(r) {
      var a = this.derivative(r);
      return Math.atan2(a[1], a[0]);
    }, PolynomialBezier.prototype.normalAngle = function(r) {
      var a = this.derivative(r);
      return Math.atan2(a[0], a[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var r = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(r)) return [];
      var a = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / r, s = a * a - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / r;
      if (s < 0) return [];
      var c = Math.sqrt(s);
      return floatZero(c) ? c > 0 && c < 1 ? [a] : [] : [a - c, a + c].filter(function(u) {
        return u > 0 && u < 1;
      });
    }, PolynomialBezier.prototype.split = function(r) {
      if (r <= 0) return [singlePoint(this.points[0]), this];
      if (r >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
      var a = lerpPoint(this.points[0], this.points[1], r), s = lerpPoint(this.points[1], this.points[2], r), c = lerpPoint(this.points[2], this.points[3], r), u = lerpPoint(a, s, r), d = lerpPoint(s, c, r), h = lerpPoint(u, d, r);
      return [new PolynomialBezier(this.points[0], a, u, h, !0), new PolynomialBezier(h, d, c, this.points[3], !0)];
    };
    function extrema(r, a) {
      var s = r.points[0][a], c = r.points[r.points.length - 1][a];
      if (s > c) {
        var u = c;
        c = s, s = u;
      }
      for (var d = quadRoots(3 * r.a[a], 2 * r.b[a], r.c[a]), h = 0; h < d.length; h += 1)
        if (d[h] > 0 && d[h] < 1) {
          var p = r.point(d[h])[a];
          p < s ? s = p : p > c && (c = p);
        }
      return {
        min: s,
        max: c
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var r = this.bounds();
      return {
        left: r.x.min,
        right: r.x.max,
        top: r.y.min,
        bottom: r.y.max,
        width: r.x.max - r.x.min,
        height: r.y.max - r.y.min,
        cx: (r.x.max + r.x.min) / 2,
        cy: (r.y.max + r.y.min) / 2
      };
    };
    function intersectData(r, a, s) {
      var c = r.boundingBox();
      return {
        cx: c.cx,
        cy: c.cy,
        width: c.width,
        height: c.height,
        bez: r,
        t: (a + s) / 2,
        t1: a,
        t2: s
      };
    }
    function splitData(r) {
      var a = r.bez.split(0.5);
      return [intersectData(a[0], r.t1, r.t), intersectData(a[1], r.t, r.t2)];
    }
    function boxIntersect(r, a) {
      return Math.abs(r.cx - a.cx) * 2 < r.width + a.width && Math.abs(r.cy - a.cy) * 2 < r.height + a.height;
    }
    function intersectsImpl(r, a, s, c, u, d) {
      if (boxIntersect(r, a)) {
        if (s >= d || r.width <= c && r.height <= c && a.width <= c && a.height <= c) {
          u.push([r.t, a.t]);
          return;
        }
        var h = splitData(r), p = splitData(a);
        intersectsImpl(h[0], p[0], s + 1, c, u, d), intersectsImpl(h[0], p[1], s + 1, c, u, d), intersectsImpl(h[1], p[0], s + 1, c, u, d), intersectsImpl(h[1], p[1], s + 1, c, u, d);
      }
    }
    PolynomialBezier.prototype.intersections = function(r, a, s) {
      a === void 0 && (a = 2), s === void 0 && (s = 7);
      var c = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(r, 0, 1), 0, a, c, s), c;
    }, PolynomialBezier.shapeSegment = function(r, a) {
      var s = (a + 1) % r.length();
      return new PolynomialBezier(r.v[a], r.o[a], r.i[s], r.v[s], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(r, a) {
      var s = (a + 1) % r.length();
      return new PolynomialBezier(r.v[s], r.i[s], r.o[a], r.v[a], !0);
    };
    function crossProduct(r, a) {
      return [r[1] * a[2] - r[2] * a[1], r[2] * a[0] - r[0] * a[2], r[0] * a[1] - r[1] * a[0]];
    }
    function lineIntersection(r, a, s, c) {
      var u = [r[0], r[1], 1], d = [a[0], a[1], 1], h = [s[0], s[1], 1], p = [c[0], c[1], 1], m = crossProduct(crossProduct(u, d), crossProduct(h, p));
      return floatZero(m[2]) ? null : [m[0] / m[2], m[1] / m[2]];
    }
    function polarOffset(r, a, s) {
      return [r[0] + Math.cos(a) * s, r[1] - Math.sin(a) * s];
    }
    function pointDistance(r, a) {
      return Math.hypot(r[0] - a[0], r[1] - a[1]);
    }
    function pointEqual(r, a) {
      return floatEqual(r[0], a[0]) && floatEqual(r[1], a[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(r, a) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(r, a.s, 0, null, this), this.frequency = PropertyFactory.getProp(r, a.r, 0, null, this), this.pointsType = PropertyFactory.getProp(r, a.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(r, a, s, c, u, d, h) {
      var p = s - Math.PI / 2, m = s + Math.PI / 2, g = a[0] + Math.cos(s) * c * u, v = a[1] - Math.sin(s) * c * u;
      r.setTripleAt(g, v, g + Math.cos(p) * d, v - Math.sin(p) * d, g + Math.cos(m) * h, v - Math.sin(m) * h, r.length());
    }
    function getPerpendicularVector(r, a) {
      var s = [a[0] - r[0], a[1] - r[1]], c = -Math.PI * 0.5, u = [Math.cos(c) * s[0] - Math.sin(c) * s[1], Math.sin(c) * s[0] + Math.cos(c) * s[1]];
      return u;
    }
    function getProjectingAngle(r, a) {
      var s = a === 0 ? r.length() - 1 : a - 1, c = (a + 1) % r.length(), u = r.v[s], d = r.v[c], h = getPerpendicularVector(u, d);
      return Math.atan2(0, 1) - Math.atan2(h[1], h[0]);
    }
    function zigZagCorner(r, a, s, c, u, d, h) {
      var p = getProjectingAngle(a, s), m = a.v[s % a._length], g = a.v[s === 0 ? a._length - 1 : s - 1], v = a.v[(s + 1) % a._length], y = d === 2 ? Math.sqrt(Math.pow(m[0] - g[0], 2) + Math.pow(m[1] - g[1], 2)) : 0, x = d === 2 ? Math.sqrt(Math.pow(m[0] - v[0], 2) + Math.pow(m[1] - v[1], 2)) : 0;
      setPoint(r, a.v[s % a._length], p, h, c, x / ((u + 1) * 2), y / ((u + 1) * 2));
    }
    function zigZagSegment(r, a, s, c, u, d) {
      for (var h = 0; h < c; h += 1) {
        var p = (h + 1) / (c + 1), m = u === 2 ? Math.sqrt(Math.pow(a.points[3][0] - a.points[0][0], 2) + Math.pow(a.points[3][1] - a.points[0][1], 2)) : 0, g = a.normalAngle(p), v = a.point(p);
        setPoint(r, v, g, d, s, m / ((c + 1) * 2), m / ((c + 1) * 2)), d = -d;
      }
      return d;
    }
    ZigZagModifier.prototype.processPath = function(r, a, s, c) {
      var u = r._length, d = shapePool.newElement();
      if (d.c = r.c, r.c || (u -= 1), u === 0) return d;
      var h = -1, p = PolynomialBezier.shapeSegment(r, 0);
      zigZagCorner(d, r, 0, a, s, c, h);
      for (var m = 0; m < u; m += 1)
        h = zigZagSegment(d, p, a, s, c, -h), m === u - 1 && !r.c ? p = null : p = PolynomialBezier.shapeSegment(r, (m + 1) % u), zigZagCorner(d, r, m + 1, a, s, c, h);
      return d;
    }, ZigZagModifier.prototype.processShapes = function(r) {
      var a, s, c = this.shapes.length, u, d, h = this.amplitude.v, p = Math.max(0, Math.round(this.frequency.v)), m = this.pointsType.v;
      if (h !== 0) {
        var g, v;
        for (s = 0; s < c; s += 1) {
          if (g = this.shapes[s], v = g.localShapeCollection, !(!g.shape._mdf && !this._mdf && !r))
            for (v.releaseShapes(), g.shape._mdf = !0, a = g.shape.paths.shapes, d = g.shape.paths._length, u = 0; u < d; u += 1)
              v.addShape(this.processPath(a[u], h, p, m));
          g.shape.paths = g.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(r, a, s) {
      var c = Math.atan2(a[0] - r[0], a[1] - r[1]);
      return [polarOffset(r, c, s), polarOffset(a, c, s)];
    }
    function offsetSegment(r, a) {
      var s, c, u, d, h, p, m;
      m = linearOffset(r.points[0], r.points[1], a), s = m[0], c = m[1], m = linearOffset(r.points[1], r.points[2], a), u = m[0], d = m[1], m = linearOffset(r.points[2], r.points[3], a), h = m[0], p = m[1];
      var g = lineIntersection(s, c, u, d);
      g === null && (g = c);
      var v = lineIntersection(h, p, u, d);
      return v === null && (v = h), new PolynomialBezier(s, g, v, p);
    }
    function joinLines(r, a, s, c, u) {
      var d = a.points[3], h = s.points[0];
      if (c === 3 || pointEqual(d, h)) return d;
      if (c === 2) {
        var p = -a.tangentAngle(1), m = -s.tangentAngle(0) + Math.PI, g = lineIntersection(d, polarOffset(d, p + Math.PI / 2, 100), h, polarOffset(h, p + Math.PI / 2, 100)), v = g ? pointDistance(g, d) : pointDistance(d, h) / 2, y = polarOffset(d, p, 2 * v * roundCorner);
        return r.setXYAt(y[0], y[1], "o", r.length() - 1), y = polarOffset(h, m, 2 * v * roundCorner), r.setTripleAt(h[0], h[1], h[0], h[1], y[0], y[1], r.length()), h;
      }
      var x = pointEqual(d, a.points[2]) ? a.points[0] : a.points[2], w = pointEqual(h, s.points[1]) ? s.points[3] : s.points[1], S = lineIntersection(x, d, h, w);
      return S && pointDistance(S, d) < u ? (r.setTripleAt(S[0], S[1], S[0], S[1], S[0], S[1], r.length()), S) : d;
    }
    function getIntersection(r, a) {
      var s = r.intersections(a);
      return s.length && floatEqual(s[0][0], 1) && s.shift(), s.length ? s[0] : null;
    }
    function pruneSegmentIntersection(r, a) {
      var s = r.slice(), c = a.slice(), u = getIntersection(r[r.length - 1], a[0]);
      return u && (s[r.length - 1] = r[r.length - 1].split(u[0])[0], c[0] = a[0].split(u[1])[1]), r.length > 1 && a.length > 1 && (u = getIntersection(r[0], a[a.length - 1]), u) ? [[r[0].split(u[0])[0]], [a[a.length - 1].split(u[1])[1]]] : [s, c];
    }
    function pruneIntersections(r) {
      for (var a, s = 1; s < r.length; s += 1)
        a = pruneSegmentIntersection(r[s - 1], r[s]), r[s - 1] = a[0], r[s] = a[1];
      return r.length > 1 && (a = pruneSegmentIntersection(r[r.length - 1], r[0]), r[r.length - 1] = a[0], r[0] = a[1]), r;
    }
    function offsetSegmentSplit(r, a) {
      var s = r.inflectionPoints(), c, u, d, h;
      if (s.length === 0)
        return [offsetSegment(r, a)];
      if (s.length === 1 || floatEqual(s[1], 1))
        return d = r.split(s[0]), c = d[0], u = d[1], [offsetSegment(c, a), offsetSegment(u, a)];
      d = r.split(s[0]), c = d[0];
      var p = (s[1] - s[0]) / (1 - s[0]);
      return d = d[1].split(p), h = d[0], u = d[1], [offsetSegment(c, a), offsetSegment(h, a), offsetSegment(u, a)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(r, a) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(r, a.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(r, a.ml, 0, null, this), this.lineJoin = a.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(r, a, s, c) {
      var u = shapePool.newElement();
      u.c = r.c;
      var d = r.length();
      r.c || (d -= 1);
      var h, p, m, g = [];
      for (h = 0; h < d; h += 1)
        m = PolynomialBezier.shapeSegment(r, h), g.push(offsetSegmentSplit(m, a));
      if (!r.c)
        for (h = d - 1; h >= 0; h -= 1)
          m = PolynomialBezier.shapeSegmentInverted(r, h), g.push(offsetSegmentSplit(m, a));
      g = pruneIntersections(g);
      var v = null, y = null;
      for (h = 0; h < g.length; h += 1) {
        var x = g[h];
        for (y && (v = joinLines(u, y, x[0], s, c)), y = x[x.length - 1], p = 0; p < x.length; p += 1)
          m = x[p], v && pointEqual(m.points[0], v) ? u.setXYAt(m.points[1][0], m.points[1][1], "o", u.length() - 1) : u.setTripleAt(m.points[0][0], m.points[0][1], m.points[1][0], m.points[1][1], m.points[0][0], m.points[0][1], u.length()), u.setTripleAt(m.points[3][0], m.points[3][1], m.points[3][0], m.points[3][1], m.points[2][0], m.points[2][1], u.length()), v = m.points[3];
      }
      return g.length && joinLines(u, y, g[0][0], s, c), u;
    }, OffsetPathModifier.prototype.processShapes = function(r) {
      var a, s, c = this.shapes.length, u, d, h = this.amount.v, p = this.miterLimit.v, m = this.lineJoin;
      if (h !== 0) {
        var g, v;
        for (s = 0; s < c; s += 1) {
          if (g = this.shapes[s], v = g.localShapeCollection, !(!g.shape._mdf && !this._mdf && !r))
            for (v.releaseShapes(), g.shape._mdf = !0, a = g.shape.paths.shapes, d = g.shape.paths._length, u = 0; u < d; u += 1)
              v.addShape(this.processPath(a[u], h, m, p));
          g.shape.paths = g.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(r) {
      for (var a = r.fStyle ? r.fStyle.split(" ") : [], s = "normal", c = "normal", u = a.length, d, h = 0; h < u; h += 1)
        switch (d = a[h].toLowerCase(), d) {
          case "italic":
            c = "italic";
            break;
          case "bold":
            s = "700";
            break;
          case "black":
            s = "900";
            break;
          case "medium":
            s = "500";
            break;
          case "regular":
          case "normal":
            s = "400";
            break;
          case "light":
          case "thin":
            s = "200";
            break;
        }
      return {
        style: c,
        weight: r.fWeight || s
      };
    }
    var FontManager = function() {
      var r = 5e3, a = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, s = [];
      s = s.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var c = 127988, u = 917631, d = 917601, h = 917626, p = 65039, m = 8205, g = 127462, v = 127487, y = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function x(F) {
        var N = F.split(","), D, j = N.length, H = [];
        for (D = 0; D < j; D += 1)
          N[D] !== "sans-serif" && N[D] !== "monospace" && H.push(N[D]);
        return H.join(",");
      }
      function w(F, N) {
        var D = createTag("span");
        D.setAttribute("aria-hidden", !0), D.style.fontFamily = N;
        var j = createTag("span");
        j.innerText = "giItT1WQy@!-/#", D.style.position = "absolute", D.style.left = "-10000px", D.style.top = "-10000px", D.style.fontSize = "300px", D.style.fontVariant = "normal", D.style.fontStyle = "normal", D.style.fontWeight = "normal", D.style.letterSpacing = "0", D.appendChild(j), document.body.appendChild(D);
        var H = j.offsetWidth;
        return j.style.fontFamily = x(F) + ", " + N, {
          node: j,
          w: H,
          parent: D
        };
      }
      function S() {
        var F, N = this.fonts.length, D, j, H = N;
        for (F = 0; F < N; F += 1)
          this.fonts[F].loaded ? H -= 1 : this.fonts[F].fOrigin === "n" || this.fonts[F].origin === 0 ? this.fonts[F].loaded = !0 : (D = this.fonts[F].monoCase.node, j = this.fonts[F].monoCase.w, D.offsetWidth !== j ? (H -= 1, this.fonts[F].loaded = !0) : (D = this.fonts[F].sansCase.node, j = this.fonts[F].sansCase.w, D.offsetWidth !== j && (H -= 1, this.fonts[F].loaded = !0)), this.fonts[F].loaded && (this.fonts[F].sansCase.parent.parentNode.removeChild(this.fonts[F].sansCase.parent), this.fonts[F].monoCase.parent.parentNode.removeChild(this.fonts[F].monoCase.parent)));
        H !== 0 && Date.now() - this.initTime < r ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function M(F, N) {
        var D = document.body && N ? "svg" : "canvas", j, H = getFontProperties(F);
        if (D === "svg") {
          var W = createNS("text");
          W.style.fontSize = "100px", W.setAttribute("font-family", F.fFamily), W.setAttribute("font-style", H.style), W.setAttribute("font-weight", H.weight), W.textContent = "1", F.fClass ? (W.style.fontFamily = "inherit", W.setAttribute("class", F.fClass)) : W.style.fontFamily = F.fFamily, N.appendChild(W), j = W;
        } else {
          var re = new OffscreenCanvas(500, 500).getContext("2d");
          re.font = H.style + " " + H.weight + " 100px " + F.fFamily, j = re;
        }
        function ae(ee) {
          return D === "svg" ? (j.textContent = ee, j.getComputedTextLength()) : j.measureText(ee).width;
        }
        return {
          measureText: ae
        };
      }
      function P(F, N) {
        if (!F) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = F.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, F.list.forEach(function(oe) {
            oe.helper = M(oe), oe.cache = {};
          }), this.fonts = F.list;
          return;
        }
        var D = F.list, j, H = D.length, W = H;
        for (j = 0; j < H; j += 1) {
          var re = !0, ae, ee;
          if (D[j].loaded = !1, D[j].monoCase = w(D[j].fFamily, "monospace"), D[j].sansCase = w(D[j].fFamily, "sans-serif"), !D[j].fPath)
            D[j].loaded = !0, W -= 1;
          else if (D[j].fOrigin === "p" || D[j].origin === 3) {
            if (ae = document.querySelectorAll('style[f-forigin="p"][f-family="' + D[j].fFamily + '"], style[f-origin="3"][f-family="' + D[j].fFamily + '"]'), ae.length > 0 && (re = !1), re) {
              var X = createTag("style");
              X.setAttribute("f-forigin", D[j].fOrigin), X.setAttribute("f-origin", D[j].origin), X.setAttribute("f-family", D[j].fFamily), X.type = "text/css", X.innerText = "@font-face {font-family: " + D[j].fFamily + "; font-style: normal; src: url('" + D[j].fPath + "');}", N.appendChild(X);
            }
          } else if (D[j].fOrigin === "g" || D[j].origin === 1) {
            for (ae = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), ee = 0; ee < ae.length; ee += 1)
              ae[ee].href.indexOf(D[j].fPath) !== -1 && (re = !1);
            if (re) {
              var J = createTag("link");
              J.setAttribute("f-forigin", D[j].fOrigin), J.setAttribute("f-origin", D[j].origin), J.type = "text/css", J.rel = "stylesheet", J.href = D[j].fPath, document.body.appendChild(J);
            }
          } else if (D[j].fOrigin === "t" || D[j].origin === 2) {
            for (ae = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), ee = 0; ee < ae.length; ee += 1)
              D[j].fPath === ae[ee].src && (re = !1);
            if (re) {
              var ie = createTag("link");
              ie.setAttribute("f-forigin", D[j].fOrigin), ie.setAttribute("f-origin", D[j].origin), ie.setAttribute("rel", "stylesheet"), ie.setAttribute("href", D[j].fPath), N.appendChild(ie);
            }
          }
          D[j].helper = M(D[j], N), D[j].cache = {}, this.fonts.push(D[j]);
        }
        W === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function L(F) {
        if (F) {
          this.chars || (this.chars = []);
          var N, D = F.length, j, H = this.chars.length, W;
          for (N = 0; N < D; N += 1) {
            for (j = 0, W = !1; j < H; )
              this.chars[j].style === F[N].style && this.chars[j].fFamily === F[N].fFamily && this.chars[j].ch === F[N].ch && (W = !0), j += 1;
            W || (this.chars.push(F[N]), H += 1);
          }
        }
      }
      function I(F, N, D) {
        for (var j = 0, H = this.chars.length; j < H; ) {
          if (this.chars[j].ch === F && this.chars[j].style === N && this.chars[j].fFamily === D)
            return this.chars[j];
          j += 1;
        }
        return (typeof F == "string" && F.charCodeAt(0) !== 13 || !F) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", F, N, D)), a;
      }
      function T(F, N, D) {
        var j = this.getFontByName(N), H = F;
        if (!j.cache[H]) {
          var W = j.helper;
          if (F === " ") {
            var re = W.measureText("|" + F + "|"), ae = W.measureText("||");
            j.cache[H] = (re - ae) / 100;
          } else
            j.cache[H] = W.measureText(F) / 100;
        }
        return j.cache[H] * D;
      }
      function E(F) {
        for (var N = 0, D = this.fonts.length; N < D; ) {
          if (this.fonts[N].fName === F)
            return this.fonts[N];
          N += 1;
        }
        return this.fonts[0];
      }
      function R(F) {
        var N = 0, D = F.charCodeAt(0);
        if (D >= 55296 && D <= 56319) {
          var j = F.charCodeAt(1);
          j >= 56320 && j <= 57343 && (N = (D - 55296) * 1024 + j - 56320 + 65536);
        }
        return N;
      }
      function A(F, N) {
        var D = F.toString(16) + N.toString(16);
        return y.indexOf(D) !== -1;
      }
      function k(F) {
        return F === m;
      }
      function V(F) {
        return F === p;
      }
      function B(F) {
        var N = R(F);
        return N >= g && N <= v;
      }
      function q(F) {
        return B(F.substr(0, 2)) && B(F.substr(2, 2));
      }
      function z(F) {
        return s.indexOf(F) !== -1;
      }
      function Z(F, N) {
        var D = R(F.substr(N, 2));
        if (D !== c)
          return !1;
        var j = 0;
        for (N += 2; j < 5; ) {
          if (D = R(F.substr(N, 2)), D < d || D > h)
            return !1;
          j += 1, N += 2;
        }
        return R(F.substr(N, 2)) === u;
      }
      function G() {
        this.isLoaded = !0;
      }
      var K = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      K.isModifier = A, K.isZeroWidthJoiner = k, K.isFlagEmoji = q, K.isRegionalCode = B, K.isCombinedCharacter = z, K.isRegionalFlag = Z, K.isVariationSelector = V, K.BLACK_FLAG_CODE_POINT = c;
      var U = {
        addChars: L,
        addFonts: P,
        getCharData: I,
        getFontByName: E,
        measureText: T,
        checkLoadedFonts: S,
        setIsLoaded: G
      };
      return K.prototype = U, K;
    }();
    function SlotManager(r) {
      this.animationData = r;
    }
    SlotManager.prototype.getProp = function(r) {
      return this.animationData.slots && this.animationData.slots[r.sid] ? Object.assign(r, this.animationData.slots[r.sid].p) : r;
    };
    function slotFactory(r) {
      return new SlotManager(r);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(a) {
        this.renderableComponents.indexOf(a) === -1 && this.renderableComponents.push(a);
      },
      removeRenderableComponent: function(a) {
        this.renderableComponents.indexOf(a) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(a), 1);
      },
      prepareRenderableFrame: function(a) {
        this.checkLayerLimits(a);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(a) {
        this.data.ip - this.data.st <= a && this.data.op - this.data.st > a ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var a, s = this.renderableComponents.length;
        for (a = 0; a < s; a += 1)
          this.renderableComponents[a].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = /* @__PURE__ */ function() {
      var r = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(a) {
        return r[a] || "";
      };
    }();
    function SliderEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 0, 0, s);
    }
    function AngleEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 0, 0, s);
    }
    function ColorEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 1, 0, s);
    }
    function PointEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 1, 0, s);
    }
    function LayerIndexEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 0, 0, s);
    }
    function MaskIndexEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 0, 0, s);
    }
    function CheckboxEffect(r, a, s) {
      this.p = PropertyFactory.getProp(a, r.v, 0, 0, s);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(r, a) {
      var s = r.ef || [];
      this.effectElements = [];
      var c, u = s.length, d;
      for (c = 0; c < u; c += 1)
        d = new GroupEffect(s[c], a), this.effectElements.push(d);
    }
    function GroupEffect(r, a) {
      this.init(r, a);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(r, a) {
      this.data = r, this.effectElements = [], this.initDynamicPropertyContainer(a);
      var s, c = this.data.ef.length, u, d = this.data.ef;
      for (s = 0; s < c; s += 1) {
        switch (u = null, d[s].ty) {
          case 0:
            u = new SliderEffect(d[s], a, this);
            break;
          case 1:
            u = new AngleEffect(d[s], a, this);
            break;
          case 2:
            u = new ColorEffect(d[s], a, this);
            break;
          case 3:
            u = new PointEffect(d[s], a, this);
            break;
          case 4:
          case 7:
            u = new CheckboxEffect(d[s], a, this);
            break;
          case 10:
            u = new LayerIndexEffect(d[s], a, this);
            break;
          case 11:
            u = new MaskIndexEffect(d[s], a, this);
            break;
          case 5:
            u = new EffectsManager(d[s], a);
            break;
          default:
            u = new NoValueEffect(d[s]);
            break;
        }
        u && this.effectElements.push(u);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var a = 0, s = this.data.masksProperties.length; a < s; ) {
          if (this.data.masksProperties[a].mode !== "n" && this.data.masksProperties[a].cl !== !1)
            return !0;
          a += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var a = getExpressionInterfaces();
        if (a) {
          var s = a("layer"), c = a("effects"), u = a("shape"), d = a("text"), h = a("comp");
          this.layerInterface = s(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var p = c.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(p), this.data.ty === 0 || this.data.xt ? this.compInterface = h(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = u(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = d(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var a = getBlendMode(this.data.bm), s = this.baseElement || this.layerElement;
        s.style["mix-blend-mode"] = a;
      },
      initBaseData: function(a, s, c) {
        this.globalData = s, this.comp = c, this.data = a, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(a, s) {
        var c, u = this.dynamicProperties.length;
        for (c = 0; c < u; c += 1)
          (s || this._isParent && this.dynamicProperties[c].propType === "transform") && (this.dynamicProperties[c].getValue(), this.dynamicProperties[c]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(a) {
        this.dynamicProperties.indexOf(a) === -1 && this.dynamicProperties.push(a);
      }
    };
    function FootageElement(r, a, s) {
      this.initFrame(), this.initRenderable(), this.assetData = a.getAssetData(r.refId), this.footageData = a.imageLoader.getAsset(this.assetData), this.initBaseData(r, a, s);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var r = getExpressionInterfaces();
      if (r) {
        var a = r("footage");
        this.layerInterface = a(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(r, a, s) {
      this.initFrame(), this.initRenderable(), this.assetData = a.getAssetData(r.refId), this.initBaseData(r, a, s), this._isPlaying = !1, this._canPlay = !1;
      var c = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(c), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = r.tm ? PropertyFactory.getProp(this, r.tm, 0, a.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, r.au && r.au.lv ? r.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(r) {
      if (this.prepareRenderableFrame(r, !0), this.prepareProperties(r, !0), this.tm._placeholder)
        this._currentTime = r / this.data.sr;
      else {
        var a = this.tm.v;
        this._currentTime = a;
      }
      this._volume = this.lv.v[0];
      var s = this._volume * this._volumeMultiplier;
      this._previousVolume !== s && (this._previousVolume = s, this.audio.volume(s));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(r) {
      this.audio.rate(r);
    }, AudioElement.prototype.volume = function(r) {
      this._volumeMultiplier = r, this._previousVolume = r * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(r) {
      var a, s = this.layers.length, c;
      for (this.completeLayers = !0, a = s - 1; a >= 0; a -= 1)
        this.elements[a] || (c = this.layers[a], c.ip - c.st <= r - this.layers[a].st && c.op - c.st > r - this.layers[a].st && this.buildItem(a)), this.completeLayers = this.elements[a] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(r) {
      switch (r.ty) {
        case 2:
          return this.createImage(r);
        case 0:
          return this.createComp(r);
        case 1:
          return this.createSolid(r);
        case 3:
          return this.createNull(r);
        case 4:
          return this.createShape(r);
        case 5:
          return this.createText(r);
        case 6:
          return this.createAudio(r);
        case 13:
          return this.createCamera(r);
        case 15:
          return this.createFootage(r);
        default:
          return this.createNull(r);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(r) {
      return new AudioElement(r, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(r) {
      return new FootageElement(r, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var r, a = this.layers.length;
      for (r = 0; r < a; r += 1)
        this.buildItem(r);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(r) {
      this.completeLayers = !1;
      var a, s = r.length, c, u = this.layers.length;
      for (a = 0; a < s; a += 1)
        for (c = 0; c < u; ) {
          if (this.layers[c].id === r[a].id) {
            this.layers[c] = r[a];
            break;
          }
          c += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(r) {
      this.globalData.projectInterface = r;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(r, a, s) {
      for (var c = this.elements, u = this.layers, d = 0, h = u.length; d < h; )
        u[d].ind == a && (!c[d] || c[d] === !0 ? (this.buildItem(d), this.addPendingElement(r)) : (s.push(c[d]), c[d].setAsParent(), u[d].parent !== void 0 ? this.buildElementParenting(r, u[d].parent, s) : r.setHierarchy(s))), d += 1;
    }, BaseRenderer.prototype.addPendingElement = function(r) {
      this.pendingElements.push(r);
    }, BaseRenderer.prototype.searchExtraCompositions = function(r) {
      var a, s = r.length;
      for (a = 0; a < s; a += 1)
        if (r[a].xt) {
          var c = this.createComp(r[a]);
          c.initExpressions(), this.globalData.projectInterface.registerComposition(c);
        }
    }, BaseRenderer.prototype.getElementById = function(r) {
      var a, s = this.elements.length;
      for (a = 0; a < s; a += 1)
        if (this.elements[a].data.ind === r)
          return this.elements[a];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(r) {
      var a = r.shift(), s;
      if (typeof a == "number")
        s = this.elements[a];
      else {
        var c, u = this.elements.length;
        for (c = 0; c < u; c += 1)
          if (this.elements[c].data.nm === a) {
            s = this.elements[c];
            break;
          }
      }
      return r.length === 0 ? s : s.getElementByPath(r);
    }, BaseRenderer.prototype.setupGlobalData = function(r, a) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(r), this.globalData.fontManager.addChars(r.chars), this.globalData.fontManager.addFonts(r.fonts, a), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = r.fr, this.globalData.nm = r.nm, this.globalData.compSize = {
        w: r.w,
        h: r.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var a = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: a,
          localMat: a,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var a, s = this.finalTransform.mat, c = 0, u = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; c < u; ) {
              if (this.hierarchy[c].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              c += 1;
            }
          if (this.finalTransform._matMdf)
            for (a = this.finalTransform.mProp.v.props, s.cloneFromProps(a), c = 0; c < u; c += 1)
              s.multiply(this.hierarchy[c].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var a = 0, s = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; a < s; )
              this.localTransforms[a]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[a]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), a += 1;
          if (this.finalTransform._localMatMdf) {
            var c = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(c), a = 1; a < s; a += 1) {
              var u = this.localTransforms[a].matrix;
              c.multiply(u);
            }
            c.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var d = this.finalTransform.localOpacity;
            for (a = 0; a < s; a += 1)
              d *= this.localTransforms[a].opacity * 0.01;
            this.finalTransform.localOpacity = d;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var a = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (a.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var s = 0, c = a.length;
            for (s = 0; s < c; s += 1)
              this.localTransforms.push(a[s]);
          }
        }
      },
      globalToLocal: function(a) {
        var s = [];
        s.push(this.finalTransform);
        for (var c = !0, u = this.comp; c; )
          u.finalTransform ? (u.data.hasMask && s.splice(0, 0, u.finalTransform), u = u.comp) : c = !1;
        var d, h = s.length, p;
        for (d = 0; d < h; d += 1)
          p = s[d].mat.applyToPointArray(0, 0, 0), a = [a[0] - p[0], a[1] - p[1], 0];
        return a;
      },
      mHelper: new Matrix()
    };
    function MaskElement(r, a, s) {
      this.data = r, this.element = a, this.globalData = s, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var c = this.globalData.defs, u, d = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(d), this.solidPath = "";
      var h, p = this.masksProperties, m = 0, g = [], v, y, x = createElementID(), w, S, M, P, L = "clipPath", I = "clip-path";
      for (u = 0; u < d; u += 1)
        if ((p[u].mode !== "a" && p[u].mode !== "n" || p[u].inv || p[u].o.k !== 100 || p[u].o.x) && (L = "mask", I = "mask"), (p[u].mode === "s" || p[u].mode === "i") && m === 0 ? (w = createNS("rect"), w.setAttribute("fill", "#ffffff"), w.setAttribute("width", this.element.comp.data.w || 0), w.setAttribute("height", this.element.comp.data.h || 0), g.push(w)) : w = null, h = createNS("path"), p[u].mode === "n")
          this.viewData[u] = {
            op: PropertyFactory.getProp(this.element, p[u].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, p[u], 3),
            elem: h,
            lastPath: ""
          }, c.appendChild(h);
        else {
          m += 1, h.setAttribute("fill", p[u].mode === "s" ? "#000000" : "#ffffff"), h.setAttribute("clip-rule", "nonzero");
          var T;
          if (p[u].x.k !== 0 ? (L = "mask", I = "mask", P = PropertyFactory.getProp(this.element, p[u].x, 0, null, this.element), T = createElementID(), S = createNS("filter"), S.setAttribute("id", T), M = createNS("feMorphology"), M.setAttribute("operator", "erode"), M.setAttribute("in", "SourceGraphic"), M.setAttribute("radius", "0"), S.appendChild(M), c.appendChild(S), h.setAttribute("stroke", p[u].mode === "s" ? "#000000" : "#ffffff")) : (M = null, P = null), this.storedData[u] = {
            elem: h,
            x: P,
            expan: M,
            lastPath: "",
            lastOperator: "",
            filterId: T,
            lastRadius: 0
          }, p[u].mode === "i") {
            y = g.length;
            var E = createNS("g");
            for (v = 0; v < y; v += 1)
              E.appendChild(g[v]);
            var R = createNS("mask");
            R.setAttribute("mask-type", "alpha"), R.setAttribute("id", x + "_" + m), R.appendChild(h), c.appendChild(R), E.setAttribute("mask", "url(" + getLocationHref() + "#" + x + "_" + m + ")"), g.length = 0, g.push(E);
          } else
            g.push(h);
          p[u].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[u] = {
            elem: h,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, p[u].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, p[u], 3),
            invRect: w
          }, this.viewData[u].prop.k || this.drawPath(p[u], this.viewData[u].prop.v, this.viewData[u]);
        }
      for (this.maskElement = createNS(L), d = g.length, u = 0; u < d; u += 1)
        this.maskElement.appendChild(g[u]);
      m > 0 && (this.maskElement.setAttribute("id", x), this.element.maskedElement.setAttribute(I, "url(" + getLocationHref() + "#" + x + ")"), c.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(r) {
      return this.viewData[r].prop;
    }, MaskElement.prototype.renderFrame = function(r) {
      var a = this.element.finalTransform.mat, s, c = this.masksProperties.length;
      for (s = 0; s < c; s += 1)
        if ((this.viewData[s].prop._mdf || r) && this.drawPath(this.masksProperties[s], this.viewData[s].prop.v, this.viewData[s]), (this.viewData[s].op._mdf || r) && this.viewData[s].elem.setAttribute("fill-opacity", this.viewData[s].op.v), this.masksProperties[s].mode !== "n" && (this.viewData[s].invRect && (this.element.finalTransform.mProp._mdf || r) && this.viewData[s].invRect.setAttribute("transform", a.getInverseMatrix().to2dCSS()), this.storedData[s].x && (this.storedData[s].x._mdf || r))) {
          var u = this.storedData[s].expan;
          this.storedData[s].x.v < 0 ? (this.storedData[s].lastOperator !== "erode" && (this.storedData[s].lastOperator = "erode", this.storedData[s].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[s].filterId + ")")), u.setAttribute("radius", -this.storedData[s].x.v)) : (this.storedData[s].lastOperator !== "dilate" && (this.storedData[s].lastOperator = "dilate", this.storedData[s].elem.setAttribute("filter", null)), this.storedData[s].elem.setAttribute("stroke-width", this.storedData[s].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var r = "M0,0 ";
      return r += " h" + this.globalData.compSize.w, r += " v" + this.globalData.compSize.h, r += " h-" + this.globalData.compSize.w, r += " v-" + this.globalData.compSize.h + " ", r;
    }, MaskElement.prototype.drawPath = function(r, a, s) {
      var c = " M" + a.v[0][0] + "," + a.v[0][1], u, d;
      for (d = a._length, u = 1; u < d; u += 1)
        c += " C" + a.o[u - 1][0] + "," + a.o[u - 1][1] + " " + a.i[u][0] + "," + a.i[u][1] + " " + a.v[u][0] + "," + a.v[u][1];
      if (a.c && d > 1 && (c += " C" + a.o[u - 1][0] + "," + a.o[u - 1][1] + " " + a.i[0][0] + "," + a.i[0][1] + " " + a.v[0][0] + "," + a.v[0][1]), s.lastPath !== c) {
        var h = "";
        s.elem && (a.c && (h = r.inv ? this.solidPath + c : c), s.elem.setAttribute("d", h)), s.lastPath = c;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var r = {};
      r.createFilter = a, r.createAlphaToLuminanceFilter = s;
      function a(c, u) {
        var d = createNS("filter");
        return d.setAttribute("id", c), u !== !0 && (d.setAttribute("filterUnits", "objectBoundingBox"), d.setAttribute("x", "0%"), d.setAttribute("y", "0%"), d.setAttribute("width", "100%"), d.setAttribute("height", "100%")), d;
      }
      function s() {
        var c = createNS("feColorMatrix");
        return c.setAttribute("type", "matrix"), c.setAttribute("color-interpolation-filters", "sRGB"), c.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), c;
      }
      return r;
    }(), featureSupport = function() {
      var r = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (r.maskType = !1), /firefox/i.test(navigator.userAgent) && (r.svgLumaHidden = !1), r;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(r) {
      var a, s = "SourceGraphic", c = r.data.ef ? r.data.ef.length : 0, u = createElementID(), d = filtersFactory.createFilter(u, !0), h = 0;
      this.filters = [];
      var p;
      for (a = 0; a < c; a += 1) {
        p = null;
        var m = r.data.ef[a].ty;
        if (registeredEffects$1[m]) {
          var g = registeredEffects$1[m].effect;
          p = new g(d, r.effectsManager.effectElements[a], r, idPrefix + h, s), s = idPrefix + h, registeredEffects$1[m].countsAsEffect && (h += 1);
        }
        p && this.filters.push(p);
      }
      h && (r.globalData.defs.appendChild(d), r.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + u + ")")), this.filters.length && r.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(r) {
      var a, s = this.filters.length;
      for (a = 0; a < s; a += 1)
        this.filters[a].renderFrame(r);
    }, SVGEffects.prototype.getEffects = function(r) {
      var a, s = this.filters.length, c = [];
      for (a = 0; a < s; a += 1)
        this.filters[a].type === r && c.push(this.filters[a]);
      return c;
    };
    function registerEffect$1(r, a, s) {
      registeredEffects$1[r] = {
        effect: a,
        countsAsEffect: s
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var a = null;
        if (this.data.td) {
          this.matteMasks = {};
          var s = createNS("g");
          s.setAttribute("id", this.layerId), s.appendChild(this.layerElement), a = s, this.globalData.defs.appendChild(s);
        } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), a = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var c = createNS("clipPath"), u = createNS("path");
          u.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var d = createElementID();
          if (c.setAttribute("id", d), c.appendChild(u), this.globalData.defs.appendChild(c), this.checkMasks()) {
            var h = createNS("g");
            h.setAttribute("clip-path", "url(" + getLocationHref() + "#" + d + ")"), h.appendChild(this.layerElement), this.transformedElement = h, a ? a.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + d + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(a) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[a]) {
          var s = this.layerId + "_" + a, c, u, d, h;
          if (a === 1 || a === 3) {
            var p = createNS("mask");
            p.setAttribute("id", s), p.setAttribute("mask-type", a === 3 ? "luminance" : "alpha"), d = createNS("use"), d.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), p.appendChild(d), this.globalData.defs.appendChild(p), !featureSupport.maskType && a === 1 && (p.setAttribute("mask-type", "luminance"), c = createElementID(), u = filtersFactory.createFilter(c), this.globalData.defs.appendChild(u), u.appendChild(filtersFactory.createAlphaToLuminanceFilter()), h = createNS("g"), h.appendChild(d), p.appendChild(h), h.setAttribute("filter", "url(" + getLocationHref() + "#" + c + ")"));
          } else if (a === 2) {
            var m = createNS("mask");
            m.setAttribute("id", s), m.setAttribute("mask-type", "alpha");
            var g = createNS("g");
            m.appendChild(g), c = createElementID(), u = filtersFactory.createFilter(c);
            var v = createNS("feComponentTransfer");
            v.setAttribute("in", "SourceGraphic"), u.appendChild(v);
            var y = createNS("feFuncA");
            y.setAttribute("type", "table"), y.setAttribute("tableValues", "1.0 0.0"), v.appendChild(y), this.globalData.defs.appendChild(u);
            var x = createNS("rect");
            x.setAttribute("width", this.comp.data.w), x.setAttribute("height", this.comp.data.h), x.setAttribute("x", "0"), x.setAttribute("y", "0"), x.setAttribute("fill", "#ffffff"), x.setAttribute("opacity", "0"), g.setAttribute("filter", "url(" + getLocationHref() + "#" + c + ")"), g.appendChild(x), d = createNS("use"), d.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), g.appendChild(d), featureSupport.maskType || (m.setAttribute("mask-type", "luminance"), u.appendChild(filtersFactory.createAlphaToLuminanceFilter()), h = createNS("g"), g.appendChild(x), h.appendChild(this.layerElement), g.appendChild(h)), this.globalData.defs.appendChild(m);
          }
          this.matteMasks[a] = s;
        }
        return this.matteMasks[a];
      },
      setMatte: function(a) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + a + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(a) {
        this.hierarchy = a;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var r = {
        initElement: function(s, c, u) {
          this.initFrame(), this.initBaseData(s, c, u), this.initTransform(s, c, u), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var s = this.baseElement || this.layerElement;
            s.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var s = this.baseElement || this.layerElement;
              s.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(s) {
          this._mdf = !1, this.prepareRenderableFrame(s), this.prepareProperties(s, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(r)], RenderableDOMElement);
    })();
    function IImageElement(r, a, s) {
      this.assetData = a.getAssetData(r.refId), this.assetData && this.assetData.sid && (this.assetData = a.slotManager.getProp(this.assetData)), this.initElement(r, a, s), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var r = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(r, a) {
      this.elem = r, this.pos = a;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(a) {
        var s, c = this.shapeModifiers.length;
        for (s = 0; s < c; s += 1)
          this.shapeModifiers[s].addShape(a);
      },
      isShapeInAnimatedModifiers: function(a) {
        for (var s = 0, c = this.shapeModifiers.length; s < c; )
          if (this.shapeModifiers[s].isAnimatedWithShape(a))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var a, s = this.shapes.length;
          for (a = 0; a < s; a += 1)
            this.shapes[a].sh.reset();
          s = this.shapeModifiers.length;
          var c;
          for (a = s - 1; a >= 0 && (c = this.shapeModifiers[a].processShapes(this._isFirstFrame), !c); a -= 1)
            ;
        }
      },
      searchProcessedElement: function(a) {
        for (var s = this.processedElements, c = 0, u = s.length; c < u; ) {
          if (s[c].elem === a)
            return s[c].pos;
          c += 1;
        }
        return 0;
      },
      addProcessedElement: function(a, s) {
        for (var c = this.processedElements, u = c.length; u; )
          if (u -= 1, c[u].elem === a) {
            c[u].pos = s;
            return;
          }
        c.push(new ProcessedElement(a, s));
      },
      prepareFrame: function(a) {
        this.prepareRenderableFrame(a), this.prepareProperties(a, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(r, a, s) {
      this.caches = [], this.styles = [], this.transformers = r, this.lStr = "", this.sh = s, this.lvl = a, this._isAnimated = !!s.k;
      for (var c = 0, u = r.length; c < u; ) {
        if (r[c].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        c += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(r, a) {
      this.data = r, this.type = r.ty, this.d = "", this.lvl = a, this._mdf = !1, this.closed = r.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(r, a, s, c) {
      this.elem = r, this.frameId = -1, this.dataProps = createSizedArray(a.length), this.renderer = s, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", a.length ? a.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(c);
      var u, d = a.length || 0, h;
      for (u = 0; u < d; u += 1)
        h = PropertyFactory.getProp(r, a[u].v, 0, 0, this), this.k = h.k || this.k, this.dataProps[u] = {
          n: a[u].n,
          p: h
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(r) {
      if (!(this.elem.globalData.frameId === this.frameId && !r) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || r, this._mdf)) {
        var a = 0, s = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), a = 0; a < s; a += 1)
          this.dataProps[a].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[a].p.v : this.dashArray[a] = this.dataProps[a].p.v : this.dashoffset[0] = this.dataProps[a].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(r, a, s) {
      this.initDynamicPropertyContainer(r), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(r, a.o, 0, 0.01, this), this.w = PropertyFactory.getProp(r, a.w, 0, null, this), this.d = new DashProperty(r, a.d || {}, "svg", this), this.c = PropertyFactory.getProp(r, a.c, 1, 255, this), this.style = s, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(r, a, s) {
      this.initDynamicPropertyContainer(r), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(r, a.o, 0, 0.01, this), this.c = PropertyFactory.getProp(r, a.c, 1, 255, this), this.style = s;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(r, a, s) {
      this.initDynamicPropertyContainer(r), this.getValue = this.iterateDynamicProperties, this.style = s;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(r, a, s) {
      this.data = a, this.c = createTypedArray("uint8c", a.p * 4);
      var c = a.k.k[0].s ? a.k.k[0].s.length - a.p * 4 : a.k.k.length - a.p * 4;
      this.o = createTypedArray("float32", c), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = c, this.initDynamicPropertyContainer(s), this.prop = PropertyFactory.getProp(r, a.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(r, a) {
      for (var s = 0, c = this.o.length / 2, u; s < c; ) {
        if (u = Math.abs(r[s * 4] - r[a * 4 + s * 2]), u > 0.01)
          return !1;
        s += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var r = 0, a = this.data.k.k.length; r < a; ) {
          if (!this.comparePoints(this.data.k.k[r].s, this.data.p))
            return !1;
          r += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(r) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || r) {
        var a, s = this.data.p * 4, c, u;
        for (a = 0; a < s; a += 1)
          c = a % 4 === 0 ? 100 : 255, u = Math.round(this.prop.v[a] * c), this.c[a] !== u && (this.c[a] = u, this._cmdf = !r);
        if (this.o.length)
          for (s = this.prop.v.length, a = this.data.p * 4; a < s; a += 1)
            c = a % 2 === 0 ? 100 : 1, u = a % 2 === 0 ? Math.round(this.prop.v[a] * 100) : this.prop.v[a], this.o[a - this.data.p * 4] !== u && (this.o[a - this.data.p * 4] = u, this._omdf = !r);
        this._mdf = !r;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(r, a, s) {
      this.initDynamicPropertyContainer(r), this.getValue = this.iterateDynamicProperties, this.initGradientData(r, a, s);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(r, a, s) {
      this.o = PropertyFactory.getProp(r, a.o, 0, 0.01, this), this.s = PropertyFactory.getProp(r, a.s, 1, null, this), this.e = PropertyFactory.getProp(r, a.e, 1, null, this), this.h = PropertyFactory.getProp(r, a.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(r, a.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(r, a.g, this), this.style = s, this.stops = [], this.setGradientData(s.pElem, a), this.setGradientOpacity(a, s), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(r, a) {
      var s = createElementID(), c = createNS(a.t === 1 ? "linearGradient" : "radialGradient");
      c.setAttribute("id", s), c.setAttribute("spreadMethod", "pad"), c.setAttribute("gradientUnits", "userSpaceOnUse");
      var u = [], d, h, p;
      for (p = a.g.p * 4, h = 0; h < p; h += 4)
        d = createNS("stop"), c.appendChild(d), u.push(d);
      r.setAttribute(a.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + s + ")"), this.gf = c, this.cst = u;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(r, a) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var s, c, u, d = createNS("mask"), h = createNS("path");
        d.appendChild(h);
        var p = createElementID(), m = createElementID();
        d.setAttribute("id", m);
        var g = createNS(r.t === 1 ? "linearGradient" : "radialGradient");
        g.setAttribute("id", p), g.setAttribute("spreadMethod", "pad"), g.setAttribute("gradientUnits", "userSpaceOnUse"), u = r.g.k.k[0].s ? r.g.k.k[0].s.length : r.g.k.k.length;
        var v = this.stops;
        for (c = r.g.p * 4; c < u; c += 2)
          s = createNS("stop"), s.setAttribute("stop-color", "rgb(255,255,255)"), g.appendChild(s), v.push(s);
        h.setAttribute(r.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + p + ")"), r.ty === "gs" && (h.setAttribute("stroke-linecap", lineCapEnum[r.lc || 2]), h.setAttribute("stroke-linejoin", lineJoinEnum[r.lj || 2]), r.lj === 1 && h.setAttribute("stroke-miterlimit", r.ml)), this.of = g, this.ms = d, this.ost = v, this.maskId = m, a.msElem = h;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(r, a, s) {
      this.initDynamicPropertyContainer(r), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(r, a.w, 0, null, this), this.d = new DashProperty(r, a.d || {}, "svg", this), this.initGradientData(r, a, s), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(r, a, s) {
      this.transform = {
        mProps: r,
        op: a,
        container: s
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(a, s, c, u) {
      if (s === 0)
        return "";
      var d = a.o, h = a.i, p = a.v, m, g = " M" + u.applyToPointStringified(p[0][0], p[0][1]);
      for (m = 1; m < s; m += 1)
        g += " C" + u.applyToPointStringified(d[m - 1][0], d[m - 1][1]) + " " + u.applyToPointStringified(h[m][0], h[m][1]) + " " + u.applyToPointStringified(p[m][0], p[m][1]);
      return c && s && (g += " C" + u.applyToPointStringified(d[m - 1][0], d[m - 1][1]) + " " + u.applyToPointStringified(h[0][0], h[0][1]) + " " + u.applyToPointStringified(p[0][0], p[0][1]), g += "z"), g;
    }, SVGElementsRenderer = function() {
      var r = new Matrix(), a = new Matrix(), s = {
        createRenderFunction: c
      };
      function c(y) {
        switch (y.ty) {
          case "fl":
            return p;
          case "gf":
            return g;
          case "gs":
            return m;
          case "st":
            return v;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return h;
          case "tr":
            return u;
          case "no":
            return d;
          default:
            return null;
        }
      }
      function u(y, x, w) {
        (w || x.transform.op._mdf) && x.transform.container.setAttribute("opacity", x.transform.op.v), (w || x.transform.mProps._mdf) && x.transform.container.setAttribute("transform", x.transform.mProps.v.to2dCSS());
      }
      function d() {
      }
      function h(y, x, w) {
        var S, M, P, L, I, T, E = x.styles.length, R = x.lvl, A, k, V, B;
        for (T = 0; T < E; T += 1) {
          if (L = x.sh._mdf || w, x.styles[T].lvl < R) {
            for (k = a.reset(), V = R - x.styles[T].lvl, B = x.transformers.length - 1; !L && V > 0; )
              L = x.transformers[B].mProps._mdf || L, V -= 1, B -= 1;
            if (L)
              for (V = R - x.styles[T].lvl, B = x.transformers.length - 1; V > 0; )
                k.multiply(x.transformers[B].mProps.v), V -= 1, B -= 1;
          } else
            k = r;
          if (A = x.sh.paths, M = A._length, L) {
            for (P = "", S = 0; S < M; S += 1)
              I = A.shapes[S], I && I._length && (P += buildShapeString(I, I._length, I.c, k));
            x.caches[T] = P;
          } else
            P = x.caches[T];
          x.styles[T].d += y.hd === !0 ? "" : P, x.styles[T]._mdf = L || x.styles[T]._mdf;
        }
      }
      function p(y, x, w) {
        var S = x.style;
        (x.c._mdf || w) && S.pElem.setAttribute("fill", "rgb(" + bmFloor(x.c.v[0]) + "," + bmFloor(x.c.v[1]) + "," + bmFloor(x.c.v[2]) + ")"), (x.o._mdf || w) && S.pElem.setAttribute("fill-opacity", x.o.v);
      }
      function m(y, x, w) {
        g(y, x, w), v(y, x, w);
      }
      function g(y, x, w) {
        var S = x.gf, M = x.g._hasOpacity, P = x.s.v, L = x.e.v;
        if (x.o._mdf || w) {
          var I = y.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          x.style.pElem.setAttribute(I, x.o.v);
        }
        if (x.s._mdf || w) {
          var T = y.t === 1 ? "x1" : "cx", E = T === "x1" ? "y1" : "cy";
          S.setAttribute(T, P[0]), S.setAttribute(E, P[1]), M && !x.g._collapsable && (x.of.setAttribute(T, P[0]), x.of.setAttribute(E, P[1]));
        }
        var R, A, k, V;
        if (x.g._cmdf || w) {
          R = x.cst;
          var B = x.g.c;
          for (k = R.length, A = 0; A < k; A += 1)
            V = R[A], V.setAttribute("offset", B[A * 4] + "%"), V.setAttribute("stop-color", "rgb(" + B[A * 4 + 1] + "," + B[A * 4 + 2] + "," + B[A * 4 + 3] + ")");
        }
        if (M && (x.g._omdf || w)) {
          var q = x.g.o;
          for (x.g._collapsable ? R = x.cst : R = x.ost, k = R.length, A = 0; A < k; A += 1)
            V = R[A], x.g._collapsable || V.setAttribute("offset", q[A * 2] + "%"), V.setAttribute("stop-opacity", q[A * 2 + 1]);
        }
        if (y.t === 1)
          (x.e._mdf || w) && (S.setAttribute("x2", L[0]), S.setAttribute("y2", L[1]), M && !x.g._collapsable && (x.of.setAttribute("x2", L[0]), x.of.setAttribute("y2", L[1])));
        else {
          var z;
          if ((x.s._mdf || x.e._mdf || w) && (z = Math.sqrt(Math.pow(P[0] - L[0], 2) + Math.pow(P[1] - L[1], 2)), S.setAttribute("r", z), M && !x.g._collapsable && x.of.setAttribute("r", z)), x.e._mdf || x.h._mdf || x.a._mdf || w) {
            z || (z = Math.sqrt(Math.pow(P[0] - L[0], 2) + Math.pow(P[1] - L[1], 2)));
            var Z = Math.atan2(L[1] - P[1], L[0] - P[0]), G = x.h.v;
            G >= 1 ? G = 0.99 : G <= -1 && (G = -0.99);
            var K = z * G, U = Math.cos(Z + x.a.v) * K + P[0], F = Math.sin(Z + x.a.v) * K + P[1];
            S.setAttribute("fx", U), S.setAttribute("fy", F), M && !x.g._collapsable && (x.of.setAttribute("fx", U), x.of.setAttribute("fy", F));
          }
        }
      }
      function v(y, x, w) {
        var S = x.style, M = x.d;
        M && (M._mdf || w) && M.dashStr && (S.pElem.setAttribute("stroke-dasharray", M.dashStr), S.pElem.setAttribute("stroke-dashoffset", M.dashoffset[0])), x.c && (x.c._mdf || w) && S.pElem.setAttribute("stroke", "rgb(" + bmFloor(x.c.v[0]) + "," + bmFloor(x.c.v[1]) + "," + bmFloor(x.c.v[2]) + ")"), (x.o._mdf || w) && S.pElem.setAttribute("stroke-opacity", x.o.v), (x.w._mdf || w) && (S.pElem.setAttribute("stroke-width", x.w.v), S.msElem && S.msElem.setAttribute("stroke-width", x.w.v));
      }
      return s;
    }();
    function SVGShapeElement(r, a, s) {
      this.shapes = [], this.shapesData = r.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(r, a, s), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var r, a = this.shapes.length, s, c, u = this.stylesList.length, d, h = [], p = !1;
      for (c = 0; c < u; c += 1) {
        for (d = this.stylesList[c], p = !1, h.length = 0, r = 0; r < a; r += 1)
          s = this.shapes[r], s.styles.indexOf(d) !== -1 && (h.push(s), p = s._isAnimated || p);
        h.length > 1 && p && this.setShapesAsAnimated(h);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(r) {
      var a, s = r.length;
      for (a = 0; a < s; a += 1)
        r[a].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(r, a) {
      var s, c = new SVGStyleData(r, a), u = c.pElem;
      if (r.ty === "st")
        s = new SVGStrokeStyleData(this, r, c);
      else if (r.ty === "fl")
        s = new SVGFillStyleData(this, r, c);
      else if (r.ty === "gf" || r.ty === "gs") {
        var d = r.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        s = new d(this, r, c), this.globalData.defs.appendChild(s.gf), s.maskId && (this.globalData.defs.appendChild(s.ms), this.globalData.defs.appendChild(s.of), u.setAttribute("mask", "url(" + getLocationHref() + "#" + s.maskId + ")"));
      } else r.ty === "no" && (s = new SVGNoStyleData(this, r, c));
      return (r.ty === "st" || r.ty === "gs") && (u.setAttribute("stroke-linecap", lineCapEnum[r.lc || 2]), u.setAttribute("stroke-linejoin", lineJoinEnum[r.lj || 2]), u.setAttribute("fill-opacity", "0"), r.lj === 1 && u.setAttribute("stroke-miterlimit", r.ml)), r.r === 2 && u.setAttribute("fill-rule", "evenodd"), r.ln && u.setAttribute("id", r.ln), r.cl && u.setAttribute("class", r.cl), r.bm && (u.style["mix-blend-mode"] = getBlendMode(r.bm)), this.stylesList.push(c), this.addToAnimatedContents(r, s), s;
    }, SVGShapeElement.prototype.createGroupElement = function(r) {
      var a = new ShapeGroupData();
      return r.ln && a.gr.setAttribute("id", r.ln), r.cl && a.gr.setAttribute("class", r.cl), r.bm && (a.gr.style["mix-blend-mode"] = getBlendMode(r.bm)), a;
    }, SVGShapeElement.prototype.createTransformElement = function(r, a) {
      var s = TransformPropertyFactory.getTransformProperty(this, r, this), c = new SVGTransformData(s, s.o, a);
      return this.addToAnimatedContents(r, c), c;
    }, SVGShapeElement.prototype.createShapeElement = function(r, a, s) {
      var c = 4;
      r.ty === "rc" ? c = 5 : r.ty === "el" ? c = 6 : r.ty === "sr" && (c = 7);
      var u = ShapePropertyFactory.getShapeProp(this, r, c, this), d = new SVGShapeData(a, s, u);
      return this.shapes.push(d), this.addShapeToModifiers(d), this.addToAnimatedContents(r, d), d;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(r, a) {
      for (var s = 0, c = this.animatedContents.length; s < c; ) {
        if (this.animatedContents[s].element === a)
          return;
        s += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(r),
        element: a,
        data: r
      });
    }, SVGShapeElement.prototype.setElementStyles = function(r) {
      var a = r.styles, s, c = this.stylesList.length;
      for (s = 0; s < c; s += 1)
        this.stylesList[s].closed || a.push(this.stylesList[s]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var r, a = this.itemsData.length;
      for (r = 0; r < a; r += 1)
        this.prevViewData[r] = this.itemsData[r];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), a = this.dynamicProperties.length, r = 0; r < a; r += 1)
        this.dynamicProperties[r].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(r, a, s, c, u, d, h) {
      var p = [].concat(d), m, g = r.length - 1, v, y, x = [], w = [], S, M, P;
      for (m = g; m >= 0; m -= 1) {
        if (P = this.searchProcessedElement(r[m]), P ? a[m] = s[P - 1] : r[m]._render = h, r[m].ty === "fl" || r[m].ty === "st" || r[m].ty === "gf" || r[m].ty === "gs" || r[m].ty === "no")
          P ? a[m].style.closed = !1 : a[m] = this.createStyleElement(r[m], u), r[m]._render && a[m].style.pElem.parentNode !== c && c.appendChild(a[m].style.pElem), x.push(a[m].style);
        else if (r[m].ty === "gr") {
          if (!P)
            a[m] = this.createGroupElement(r[m]);
          else
            for (y = a[m].it.length, v = 0; v < y; v += 1)
              a[m].prevViewData[v] = a[m].it[v];
          this.searchShapes(r[m].it, a[m].it, a[m].prevViewData, a[m].gr, u + 1, p, h), r[m]._render && a[m].gr.parentNode !== c && c.appendChild(a[m].gr);
        } else r[m].ty === "tr" ? (P || (a[m] = this.createTransformElement(r[m], c)), S = a[m].transform, p.push(S)) : r[m].ty === "sh" || r[m].ty === "rc" || r[m].ty === "el" || r[m].ty === "sr" ? (P || (a[m] = this.createShapeElement(r[m], p, u)), this.setElementStyles(a[m])) : r[m].ty === "tm" || r[m].ty === "rd" || r[m].ty === "ms" || r[m].ty === "pb" || r[m].ty === "zz" || r[m].ty === "op" ? (P ? (M = a[m], M.closed = !1) : (M = ShapeModifiers.getModifier(r[m].ty), M.init(this, r[m]), a[m] = M, this.shapeModifiers.push(M)), w.push(M)) : r[m].ty === "rp" && (P ? (M = a[m], M.closed = !0) : (M = ShapeModifiers.getModifier(r[m].ty), a[m] = M, M.init(this, r, m, a), this.shapeModifiers.push(M), h = !1), w.push(M));
        this.addProcessedElement(r[m], m + 1);
      }
      for (g = x.length, m = 0; m < g; m += 1)
        x[m].closed = !0;
      for (g = w.length, m = 0; m < g; m += 1)
        w[m].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var r, a = this.stylesList.length;
      for (r = 0; r < a; r += 1)
        this.stylesList[r].reset();
      for (this.renderShape(), r = 0; r < a; r += 1)
        (this.stylesList[r]._mdf || this._isFirstFrame) && (this.stylesList[r].msElem && (this.stylesList[r].msElem.setAttribute("d", this.stylesList[r].d), this.stylesList[r].d = "M0 0" + this.stylesList[r].d), this.stylesList[r].pElem.setAttribute("d", this.stylesList[r].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var r, a = this.animatedContents.length, s;
      for (r = 0; r < a; r += 1)
        s = this.animatedContents[r], (this._isFirstFrame || s.element._isAnimated) && s.data !== !0 && s.fn(s.data, s.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(r, a, s, c, u, d) {
      this.o = r, this.sw = a, this.sc = s, this.fc = c, this.m = u, this.p = d, this._mdf = {
        o: !0,
        sw: !!a,
        sc: !!s,
        fc: !!c,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(r, a, s, c, u, d) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var h = !1;
      return this.o !== r && (this.o = r, this._mdf.o = !0, h = !0), this.sw !== a && (this.sw = a, this._mdf.sw = !0, h = !0), this.sc !== s && (this.sc = s, this._mdf.sc = !0, h = !0), this.fc !== c && (this.fc = c, this._mdf.fc = !0, h = !0), this.m !== u && (this.m = u, this._mdf.m = !0, h = !0), d.length && (this.p[0] !== d[0] || this.p[1] !== d[1] || this.p[4] !== d[4] || this.p[5] !== d[5] || this.p[12] !== d[12] || this.p[13] !== d[13]) && (this.p = d, this._mdf.p = !0, h = !0), h;
    };
    function TextProperty(r, a) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, a.d && a.d.sid && (a.d = r.globalData.slotManager.getProp(a.d)), this.data = a, this.elem = r, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(r, a) {
      for (var s in a)
        Object.prototype.hasOwnProperty.call(a, s) && (r[s] = a[s]);
      return r;
    }, TextProperty.prototype.setCurrentData = function(r) {
      r.__complete || this.completeTextData(r), this.currentData = r, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(r) {
      this.effectsSequence.push(r), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(r) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !r)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var a = this.currentData, s = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var c, u = this.effectsSequence.length, d = r || this.data.d.k[this.keysIndex].s;
        for (c = 0; c < u; c += 1)
          s !== this.keysIndex ? d = this.effectsSequence[c](d, d.t) : d = this.effectsSequence[c](this.currentData, d.t);
        a !== d && this.setCurrentData(d), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var r = this.data.d.k, a = this.elem.comp.renderedFrame, s = 0, c = r.length; s <= c - 1 && !(s === c - 1 || r[s + 1].t > a); )
        s += 1;
      return this.keysIndex !== s && (this.keysIndex = s), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(r) {
      for (var a = [], s = 0, c = r.length, u, d, h = !1, p = !1, m = ""; s < c; )
        h = p, p = !1, u = r.charCodeAt(s), m = r.charAt(s), FontManager.isCombinedCharacter(u) ? h = !0 : u >= 55296 && u <= 56319 ? FontManager.isRegionalFlag(r, s) ? m = r.substr(s, 14) : (d = r.charCodeAt(s + 1), d >= 56320 && d <= 57343 && (FontManager.isModifier(u, d) ? (m = r.substr(s, 2), h = !0) : FontManager.isFlagEmoji(r.substr(s, 4)) ? m = r.substr(s, 4) : m = r.substr(s, 2))) : u > 56319 ? (d = r.charCodeAt(s + 1), FontManager.isVariationSelector(u) && (h = !0)) : FontManager.isZeroWidthJoiner(u) && (h = !0, p = !0), h ? (a[a.length - 1] += m, h = !1) : a.push(m), s += m.length;
      return a;
    }, TextProperty.prototype.completeTextData = function(r) {
      r.__complete = !0;
      var a = this.elem.globalData.fontManager, s = this.data, c = [], u, d, h, p = 0, m, g = s.m.g, v = 0, y = 0, x = 0, w = [], S = 0, M = 0, P, L, I = a.getFontByName(r.f), T, E = 0, R = getFontProperties(I);
      r.fWeight = R.weight, r.fStyle = R.style, r.finalSize = r.s, r.finalText = this.buildFinalText(r.t), d = r.finalText.length, r.finalLineHeight = r.lh;
      var A = r.tr / 1e3 * r.finalSize, k;
      if (r.sz)
        for (var V = !0, B = r.sz[0], q = r.sz[1], z, Z; V; ) {
          Z = this.buildFinalText(r.t), z = 0, S = 0, d = Z.length, A = r.tr / 1e3 * r.finalSize;
          var G = -1;
          for (u = 0; u < d; u += 1)
            k = Z[u].charCodeAt(0), h = !1, Z[u] === " " ? G = u : (k === 13 || k === 3) && (S = 0, h = !0, z += r.finalLineHeight || r.finalSize * 1.2), a.chars ? (T = a.getCharData(Z[u], I.fStyle, I.fFamily), E = h ? 0 : T.w * r.finalSize / 100) : E = a.measureText(Z[u], r.f, r.finalSize), S + E > B && Z[u] !== " " ? (G === -1 ? d += 1 : u = G, z += r.finalLineHeight || r.finalSize * 1.2, Z.splice(u, G === u ? 1 : 0, "\r"), G = -1, S = 0) : (S += E, S += A);
          z += I.ascent * r.finalSize / 100, this.canResize && r.finalSize > this.minimumFontSize && q < z ? (r.finalSize -= 1, r.finalLineHeight = r.finalSize * r.lh / r.s) : (r.finalText = Z, d = r.finalText.length, V = !1);
        }
      S = -A, E = 0;
      var K = 0, U;
      for (u = 0; u < d; u += 1)
        if (h = !1, U = r.finalText[u], k = U.charCodeAt(0), k === 13 || k === 3 ? (K = 0, w.push(S), M = S > M ? S : M, S = -2 * A, m = "", h = !0, x += 1) : m = U, a.chars ? (T = a.getCharData(U, I.fStyle, a.getFontByName(r.f).fFamily), E = h ? 0 : T.w * r.finalSize / 100) : E = a.measureText(m, r.f, r.finalSize), U === " " ? K += E + A : (S += E + A + K, K = 0), c.push({
          l: E,
          an: E,
          add: v,
          n: h,
          anIndexes: [],
          val: m,
          line: x,
          animatorJustifyOffset: 0
        }), g == 2) {
          if (v += E, m === "" || m === " " || u === d - 1) {
            for ((m === "" || m === " ") && (v -= E); y <= u; )
              c[y].an = v, c[y].ind = p, c[y].extra = E, y += 1;
            p += 1, v = 0;
          }
        } else if (g == 3) {
          if (v += E, m === "" || u === d - 1) {
            for (m === "" && (v -= E); y <= u; )
              c[y].an = v, c[y].ind = p, c[y].extra = E, y += 1;
            v = 0, p += 1;
          }
        } else
          c[p].ind = p, c[p].extra = 0, p += 1;
      if (r.l = c, M = S > M ? S : M, w.push(S), r.sz)
        r.boxWidth = r.sz[0], r.justifyOffset = 0;
      else
        switch (r.boxWidth = M, r.j) {
          case 1:
            r.justifyOffset = -r.boxWidth;
            break;
          case 2:
            r.justifyOffset = -r.boxWidth / 2;
            break;
          default:
            r.justifyOffset = 0;
        }
      r.lineWidths = w;
      var F = s.a, N, D;
      L = F.length;
      var j, H, W = [];
      for (P = 0; P < L; P += 1) {
        for (N = F[P], N.a.sc && (r.strokeColorAnim = !0), N.a.sw && (r.strokeWidthAnim = !0), (N.a.fc || N.a.fh || N.a.fs || N.a.fb) && (r.fillColorAnim = !0), H = 0, j = N.s.b, u = 0; u < d; u += 1)
          D = c[u], D.anIndexes[P] = H, (j == 1 && D.val !== "" || j == 2 && D.val !== "" && D.val !== " " || j == 3 && (D.n || D.val == " " || u == d - 1) || j == 4 && (D.n || u == d - 1)) && (N.s.rn === 1 && W.push(H), H += 1);
        s.a[P].s.totalChars = H;
        var re = -1, ae;
        if (N.s.rn === 1)
          for (u = 0; u < d; u += 1)
            D = c[u], re != D.anIndexes[P] && (re = D.anIndexes[P], ae = W.splice(Math.floor(Math.random() * W.length), 1)[0]), D.anIndexes[P] = ae;
      }
      r.yOffset = r.finalLineHeight || r.finalSize * 1.2, r.ls = r.ls || 0, r.ascent = I.ascent * r.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(r, a) {
      a = a === void 0 ? this.keysIndex : a;
      var s = this.copyData({}, this.data.d.k[a].s);
      s = this.copyData(s, r), this.data.d.k[a].s = s, this.recalculate(a), this.setCurrentData(s), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(r) {
      var a = this.data.d.k[r].s;
      a.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(a);
    }, TextProperty.prototype.canResizeFont = function(r) {
      this.canResize = r, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(r) {
      this.minimumFontSize = Math.floor(r) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var r = Math.max, a = Math.min, s = Math.floor;
      function c(d, h) {
        this._currentTextLength = -1, this.k = !1, this.data = h, this.elem = d, this.comp = d.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(d), this.s = PropertyFactory.getProp(d, h.s || {
          k: 0
        }, 0, 0, this), "e" in h ? this.e = PropertyFactory.getProp(d, h.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(d, h.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(d, h.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(d, h.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(d, h.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(d, h.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      c.prototype = {
        getMult: function(h) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var p = 0, m = 0, g = 1, v = 1;
          this.ne.v > 0 ? p = this.ne.v / 100 : m = -this.ne.v / 100, this.xe.v > 0 ? g = 1 - this.xe.v / 100 : v = 1 + this.xe.v / 100;
          var y = BezierFactory.getBezierEasing(p, m, g, v).get, x = 0, w = this.finalS, S = this.finalE, M = this.data.sh;
          if (M === 2)
            S === w ? x = h >= S ? 1 : 0 : x = r(0, a(0.5 / (S - w) + (h - w) / (S - w), 1)), x = y(x);
          else if (M === 3)
            S === w ? x = h >= S ? 0 : 1 : x = 1 - r(0, a(0.5 / (S - w) + (h - w) / (S - w), 1)), x = y(x);
          else if (M === 4)
            S === w ? x = 0 : (x = r(0, a(0.5 / (S - w) + (h - w) / (S - w), 1)), x < 0.5 ? x *= 2 : x = 1 - 2 * (x - 0.5)), x = y(x);
          else if (M === 5) {
            if (S === w)
              x = 0;
            else {
              var P = S - w;
              h = a(r(0, h + 0.5 - w), S - w);
              var L = -P / 2 + h, I = P / 2;
              x = Math.sqrt(1 - L * L / (I * I));
            }
            x = y(x);
          } else M === 6 ? (S === w ? x = 0 : (h = a(r(0, h + 0.5 - w), S - w), x = (1 + Math.cos(Math.PI + Math.PI * 2 * h / (S - w))) / 2), x = y(x)) : (h >= s(w) && (h - w < 0 ? x = r(0, a(a(S, 1) - (w - h), 1)) : x = r(0, a(S - h, 1))), x = y(x));
          if (this.sm.v !== 100) {
            var T = this.sm.v * 0.01;
            T === 0 && (T = 1e-8);
            var E = 0.5 - T * 0.5;
            x < E ? x = 0 : (x = (x - E) / T, x > 1 && (x = 1));
          }
          return x * this.a.v;
        },
        getValue: function(h) {
          this.iterateDynamicProperties(), this._mdf = h || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, h && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var p = this.data.r === 2 ? 1 : 100 / this.data.totalChars, m = this.o.v / p, g = this.s.v / p + m, v = this.e.v / p + m;
          if (g > v) {
            var y = g;
            g = v, v = y;
          }
          this.finalS = g, this.finalE = v;
        }
      }, extendPrototype([DynamicPropertyContainer], c);
      function u(d, h, p) {
        return new c(d, h);
      }
      return {
        getTextSelectorProp: u
      };
    }();
    function TextAnimatorDataProperty(r, a, s) {
      var c = {
        propType: !1
      }, u = PropertyFactory.getProp, d = a.a;
      this.a = {
        r: d.r ? u(r, d.r, 0, degToRads, s) : c,
        rx: d.rx ? u(r, d.rx, 0, degToRads, s) : c,
        ry: d.ry ? u(r, d.ry, 0, degToRads, s) : c,
        sk: d.sk ? u(r, d.sk, 0, degToRads, s) : c,
        sa: d.sa ? u(r, d.sa, 0, degToRads, s) : c,
        s: d.s ? u(r, d.s, 1, 0.01, s) : c,
        a: d.a ? u(r, d.a, 1, 0, s) : c,
        o: d.o ? u(r, d.o, 0, 0.01, s) : c,
        p: d.p ? u(r, d.p, 1, 0, s) : c,
        sw: d.sw ? u(r, d.sw, 0, 0, s) : c,
        sc: d.sc ? u(r, d.sc, 1, 0, s) : c,
        fc: d.fc ? u(r, d.fc, 1, 0, s) : c,
        fh: d.fh ? u(r, d.fh, 0, 0, s) : c,
        fs: d.fs ? u(r, d.fs, 0, 0.01, s) : c,
        fb: d.fb ? u(r, d.fb, 0, 0.01, s) : c,
        t: d.t ? u(r, d.t, 0, 0, s) : c
      }, this.s = TextSelectorProp.getTextSelectorProp(r, a.s, s), this.s.t = a.s.t;
    }
    function TextAnimatorProperty(r, a, s) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = r, this._renderType = a, this._elem = s, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(s);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var r, a = this._textData.a.length, s, c = PropertyFactory.getProp;
      for (r = 0; r < a; r += 1)
        s = this._textData.a[r], this._animatorsData[r] = new TextAnimatorDataProperty(this._elem, s, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: c(this._elem, this._textData.p.a, 0, 0, this),
        f: c(this._elem, this._textData.p.f, 0, 0, this),
        l: c(this._elem, this._textData.p.l, 0, 0, this),
        r: c(this._elem, this._textData.p.r, 0, 0, this),
        p: c(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = c(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(r, a) {
      if (this.lettersChangedFlag = a, !(!this._mdf && !this._isFirstFrame && !a && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var s = this._moreOptions.alignment.v, c = this._animatorsData, u = this._textData, d = this.mHelper, h = this._renderType, p = this.renderedLetters.length, m, g, v, y, x = r.l, w, S, M, P, L, I, T, E, R, A, k, V, B, q, z;
        if (this._hasMaskedPath) {
          if (z = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var Z = z.v;
            this._pathData.r.v && (Z = Z.reverse()), w = {
              tLength: 0,
              segments: []
            }, y = Z._length - 1;
            var G;
            for (V = 0, v = 0; v < y; v += 1)
              G = bez.buildBezierData(Z.v[v], Z.v[v + 1], [Z.o[v][0] - Z.v[v][0], Z.o[v][1] - Z.v[v][1]], [Z.i[v + 1][0] - Z.v[v + 1][0], Z.i[v + 1][1] - Z.v[v + 1][1]]), w.tLength += G.segmentLength, w.segments.push(G), V += G.segmentLength;
            v = y, z.v.c && (G = bez.buildBezierData(Z.v[v], Z.v[0], [Z.o[v][0] - Z.v[v][0], Z.o[v][1] - Z.v[v][1]], [Z.i[0][0] - Z.v[0][0], Z.i[0][1] - Z.v[0][1]]), w.tLength += G.segmentLength, w.segments.push(G), V += G.segmentLength), this._pathData.pi = w;
          }
          if (w = this._pathData.pi, S = this._pathData.f.v, T = 0, I = 1, P = 0, L = !0, A = w.segments, S < 0 && z.v.c)
            for (w.tLength < Math.abs(S) && (S = -Math.abs(S) % w.tLength), T = A.length - 1, R = A[T].points, I = R.length - 1; S < 0; )
              S += R[I].partialLength, I -= 1, I < 0 && (T -= 1, R = A[T].points, I = R.length - 1);
          R = A[T].points, E = R[I - 1], M = R[I], k = M.partialLength;
        }
        y = x.length, m = 0, g = 0;
        var K = r.finalSize * 1.2 * 0.714, U = !0, F, N, D, j, H;
        j = c.length;
        var W, re = -1, ae, ee, X, J = S, ie = T, oe = I, fe = -1, ve, ue, pe, we, ye, Ie, Ee, ne, se = "", de = this.defaultPropsArray, Ce;
        if (r.j === 2 || r.j === 1) {
          var me = 0, xe = 0, Se = r.j === 2 ? -0.5 : -1, Re = 0, Pe = !0;
          for (v = 0; v < y; v += 1)
            if (x[v].n) {
              for (me && (me += xe); Re < v; )
                x[Re].animatorJustifyOffset = me, Re += 1;
              me = 0, Pe = !0;
            } else {
              for (D = 0; D < j; D += 1)
                F = c[D].a, F.t.propType && (Pe && r.j === 2 && (xe += F.t.v * Se), N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), W.length ? me += F.t.v * W[0] * Se : me += F.t.v * W * Se);
              Pe = !1;
            }
          for (me && (me += xe); Re < v; )
            x[Re].animatorJustifyOffset = me, Re += 1;
        }
        for (v = 0; v < y; v += 1) {
          if (d.reset(), ve = 1, x[v].n)
            m = 0, g += r.yOffset, g += U ? 1 : 0, S = J, U = !1, this._hasMaskedPath && (T = ie, I = oe, R = A[T].points, E = R[I - 1], M = R[I], k = M.partialLength, P = 0), se = "", ne = "", Ie = "", Ce = "", de = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (fe !== x[v].line) {
                switch (r.j) {
                  case 1:
                    S += V - r.lineWidths[x[v].line];
                    break;
                  case 2:
                    S += (V - r.lineWidths[x[v].line]) / 2;
                    break;
                }
                fe = x[v].line;
              }
              re !== x[v].ind && (x[re] && (S += x[re].extra), S += x[v].an / 2, re = x[v].ind), S += s[0] * x[v].an * 5e-3;
              var ke = 0;
              for (D = 0; D < j; D += 1)
                F = c[D].a, F.p.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), W.length ? ke += F.p.v[0] * W[0] : ke += F.p.v[0] * W), F.a.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), W.length ? ke += F.a.v[0] * W[0] : ke += F.a.v[0] * W);
              for (L = !0, this._pathData.a.v && (S = x[0].an * 0.5 + (V - this._pathData.f.v - x[0].an * 0.5 - x[x.length - 1].an * 0.5) * re / (y - 1), S += this._pathData.f.v); L; )
                P + k >= S + ke || !R ? (B = (S + ke - P) / M.partialLength, ee = E.point[0] + (M.point[0] - E.point[0]) * B, X = E.point[1] + (M.point[1] - E.point[1]) * B, d.translate(-s[0] * x[v].an * 5e-3, -(s[1] * K) * 0.01), L = !1) : R && (P += M.partialLength, I += 1, I >= R.length && (I = 0, T += 1, A[T] ? R = A[T].points : z.v.c ? (I = 0, T = 0, R = A[T].points) : (P -= M.partialLength, R = null)), R && (E = M, M = R[I], k = M.partialLength));
              ae = x[v].an / 2 - x[v].add, d.translate(-ae, 0, 0);
            } else
              ae = x[v].an / 2 - x[v].add, d.translate(-ae, 0, 0), d.translate(-s[0] * x[v].an * 5e-3, -s[1] * K * 0.01, 0);
            for (D = 0; D < j; D += 1)
              F = c[D].a, F.t.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), (m !== 0 || r.j !== 0) && (this._hasMaskedPath ? W.length ? S += F.t.v * W[0] : S += F.t.v * W : W.length ? m += F.t.v * W[0] : m += F.t.v * W));
            for (r.strokeWidthAnim && (pe = r.sw || 0), r.strokeColorAnim && (r.sc ? ue = [r.sc[0], r.sc[1], r.sc[2]] : ue = [0, 0, 0]), r.fillColorAnim && r.fc && (we = [r.fc[0], r.fc[1], r.fc[2]]), D = 0; D < j; D += 1)
              F = c[D].a, F.a.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), W.length ? d.translate(-F.a.v[0] * W[0], -F.a.v[1] * W[1], F.a.v[2] * W[2]) : d.translate(-F.a.v[0] * W, -F.a.v[1] * W, F.a.v[2] * W));
            for (D = 0; D < j; D += 1)
              F = c[D].a, F.s.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), W.length ? d.scale(1 + (F.s.v[0] - 1) * W[0], 1 + (F.s.v[1] - 1) * W[1], 1) : d.scale(1 + (F.s.v[0] - 1) * W, 1 + (F.s.v[1] - 1) * W, 1));
            for (D = 0; D < j; D += 1) {
              if (F = c[D].a, N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), F.sk.propType && (W.length ? d.skewFromAxis(-F.sk.v * W[0], F.sa.v * W[1]) : d.skewFromAxis(-F.sk.v * W, F.sa.v * W)), F.r.propType && (W.length ? d.rotateZ(-F.r.v * W[2]) : d.rotateZ(-F.r.v * W)), F.ry.propType && (W.length ? d.rotateY(F.ry.v * W[1]) : d.rotateY(F.ry.v * W)), F.rx.propType && (W.length ? d.rotateX(F.rx.v * W[0]) : d.rotateX(F.rx.v * W)), F.o.propType && (W.length ? ve += (F.o.v * W[0] - ve) * W[0] : ve += (F.o.v * W - ve) * W), r.strokeWidthAnim && F.sw.propType && (W.length ? pe += F.sw.v * W[0] : pe += F.sw.v * W), r.strokeColorAnim && F.sc.propType)
                for (ye = 0; ye < 3; ye += 1)
                  W.length ? ue[ye] += (F.sc.v[ye] - ue[ye]) * W[0] : ue[ye] += (F.sc.v[ye] - ue[ye]) * W;
              if (r.fillColorAnim && r.fc) {
                if (F.fc.propType)
                  for (ye = 0; ye < 3; ye += 1)
                    W.length ? we[ye] += (F.fc.v[ye] - we[ye]) * W[0] : we[ye] += (F.fc.v[ye] - we[ye]) * W;
                F.fh.propType && (W.length ? we = addHueToRGB(we, F.fh.v * W[0]) : we = addHueToRGB(we, F.fh.v * W)), F.fs.propType && (W.length ? we = addSaturationToRGB(we, F.fs.v * W[0]) : we = addSaturationToRGB(we, F.fs.v * W)), F.fb.propType && (W.length ? we = addBrightnessToRGB(we, F.fb.v * W[0]) : we = addBrightnessToRGB(we, F.fb.v * W));
              }
            }
            for (D = 0; D < j; D += 1)
              F = c[D].a, F.p.propType && (N = c[D].s, W = N.getMult(x[v].anIndexes[D], u.a[D].s.totalChars), this._hasMaskedPath ? W.length ? d.translate(0, F.p.v[1] * W[0], -F.p.v[2] * W[1]) : d.translate(0, F.p.v[1] * W, -F.p.v[2] * W) : W.length ? d.translate(F.p.v[0] * W[0], F.p.v[1] * W[1], -F.p.v[2] * W[2]) : d.translate(F.p.v[0] * W, F.p.v[1] * W, -F.p.v[2] * W));
            if (r.strokeWidthAnim && (Ie = pe < 0 ? 0 : pe), r.strokeColorAnim && (Ee = "rgb(" + Math.round(ue[0] * 255) + "," + Math.round(ue[1] * 255) + "," + Math.round(ue[2] * 255) + ")"), r.fillColorAnim && r.fc && (ne = "rgb(" + Math.round(we[0] * 255) + "," + Math.round(we[1] * 255) + "," + Math.round(we[2] * 255) + ")"), this._hasMaskedPath) {
              if (d.translate(0, -r.ls), d.translate(0, s[1] * K * 0.01 + g, 0), this._pathData.p.v) {
                q = (M.point[1] - E.point[1]) / (M.point[0] - E.point[0]);
                var De = Math.atan(q) * 180 / Math.PI;
                M.point[0] < E.point[0] && (De += 180), d.rotate(-De * Math.PI / 180);
              }
              d.translate(ee, X, 0), S -= s[0] * x[v].an * 5e-3, x[v + 1] && re !== x[v + 1].ind && (S += x[v].an / 2, S += r.tr * 1e-3 * r.finalSize);
            } else {
              switch (d.translate(m, g, 0), r.ps && d.translate(r.ps[0], r.ps[1] + r.ascent, 0), r.j) {
                case 1:
                  d.translate(x[v].animatorJustifyOffset + r.justifyOffset + (r.boxWidth - r.lineWidths[x[v].line]), 0, 0);
                  break;
                case 2:
                  d.translate(x[v].animatorJustifyOffset + r.justifyOffset + (r.boxWidth - r.lineWidths[x[v].line]) / 2, 0, 0);
                  break;
              }
              d.translate(0, -r.ls), d.translate(ae, 0, 0), d.translate(s[0] * x[v].an * 5e-3, s[1] * K * 0.01, 0), m += x[v].l + r.tr * 1e-3 * r.finalSize;
            }
            h === "html" ? se = d.toCSS() : h === "svg" ? se = d.to2dCSS() : de = [d.props[0], d.props[1], d.props[2], d.props[3], d.props[4], d.props[5], d.props[6], d.props[7], d.props[8], d.props[9], d.props[10], d.props[11], d.props[12], d.props[13], d.props[14], d.props[15]], Ce = ve;
          }
          p <= v ? (H = new LetterProps(Ce, Ie, Ee, ne, se, de), this.renderedLetters.push(H), p += 1, this.lettersChangedFlag = !0) : (H = this.renderedLetters[v], this.lettersChangedFlag = H.update(Ce, Ie, Ee, ne, se, de) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(r, a, s) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(r, a, s), this.textProperty = new TextProperty(this, r.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(r.t, this.renderType, this), this.initTransform(r, a, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(r) {
      this._mdf = !1, this.prepareRenderableFrame(r), this.prepareProperties(r, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(r, a) {
      var s, c = a.length, u, d = "";
      for (s = 0; s < c; s += 1)
        a[s].ty === "sh" && (u = a[s].ks.k, d += buildShapeString(u, u.i.length, !0, r));
      return d;
    }, ITextElement.prototype.updateDocumentData = function(r, a) {
      this.textProperty.updateDocumentData(r, a);
    }, ITextElement.prototype.canResizeFont = function(r) {
      this.textProperty.canResizeFont(r);
    }, ITextElement.prototype.setMinimumFontSize = function(r) {
      this.textProperty.setMinimumFontSize(r);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(r, a, s, c, u) {
      switch (r.ps && a.translate(r.ps[0], r.ps[1] + r.ascent, 0), a.translate(0, -r.ls, 0), r.j) {
        case 1:
          a.translate(r.justifyOffset + (r.boxWidth - r.lineWidths[s]), 0, 0);
          break;
        case 2:
          a.translate(r.justifyOffset + (r.boxWidth - r.lineWidths[s]) / 2, 0, 0);
          break;
      }
      a.translate(c, u, 0);
    }, ITextElement.prototype.buildColor = function(r) {
      return "rgb(" + Math.round(r[0] * 255) + "," + Math.round(r[1] * 255) + "," + Math.round(r[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(r, a, s) {
      this.textSpans = [], this.renderType = "svg", this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(r) {
      for (var a = 0, s = r.length, c = [], u = ""; a < s; )
        r[a] === "\r" || r[a] === "" ? (c.push(u), u = "") : u += r[a], a += 1;
      return c.push(u), c;
    }, SVGTextLottieElement.prototype.buildShapeData = function(r, a) {
      if (r.shapes && r.shapes.length) {
        var s = r.shapes[0];
        if (s.it) {
          var c = s.it[s.it.length - 1];
          c.s && (c.s.k[0] = a, c.s.k[1] = a);
        }
      }
      return r;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var r, a, s = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(s ? s.l.length : 0), s.fc ? this.layerElement.setAttribute("fill", this.buildColor(s.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), s.sc && (this.layerElement.setAttribute("stroke", this.buildColor(s.sc)), this.layerElement.setAttribute("stroke-width", s.sw)), this.layerElement.setAttribute("font-size", s.finalSize);
      var c = this.globalData.fontManager.getFontByName(s.f);
      if (c.fClass)
        this.layerElement.setAttribute("class", c.fClass);
      else {
        this.layerElement.setAttribute("font-family", c.fFamily);
        var u = s.fWeight, d = s.fStyle;
        this.layerElement.setAttribute("font-style", d), this.layerElement.setAttribute("font-weight", u);
      }
      this.layerElement.setAttribute("aria-label", s.t);
      var h = s.l || [], p = !!this.globalData.fontManager.chars;
      a = h.length;
      var m, g = this.mHelper, v = "", y = this.data.singleShape, x = 0, w = 0, S = !0, M = s.tr * 1e-3 * s.finalSize;
      if (y && !p && !s.sz) {
        var P = this.textContainer, L = "start";
        switch (s.j) {
          case 1:
            L = "end";
            break;
          case 2:
            L = "middle";
            break;
          default:
            L = "start";
            break;
        }
        P.setAttribute("text-anchor", L), P.setAttribute("letter-spacing", M);
        var I = this.buildTextContents(s.finalText);
        for (a = I.length, w = s.ps ? s.ps[1] + s.ascent : 0, r = 0; r < a; r += 1)
          m = this.textSpans[r].span || createNS("tspan"), m.textContent = I[r], m.setAttribute("x", 0), m.setAttribute("y", w), m.style.display = "inherit", P.appendChild(m), this.textSpans[r] || (this.textSpans[r] = {
            span: null,
            glyph: null
          }), this.textSpans[r].span = m, w += s.finalLineHeight;
        this.layerElement.appendChild(P);
      } else {
        var T = this.textSpans.length, E;
        for (r = 0; r < a; r += 1) {
          if (this.textSpans[r] || (this.textSpans[r] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !p || !y || r === 0) {
            if (m = T > r ? this.textSpans[r].span : createNS(p ? "g" : "text"), T <= r) {
              if (m.setAttribute("stroke-linecap", "butt"), m.setAttribute("stroke-linejoin", "round"), m.setAttribute("stroke-miterlimit", "4"), this.textSpans[r].span = m, p) {
                var R = createNS("g");
                m.appendChild(R), this.textSpans[r].childSpan = R;
              }
              this.textSpans[r].span = m, this.layerElement.appendChild(m);
            }
            m.style.display = "inherit";
          }
          if (g.reset(), y && (h[r].n && (x = -M, w += s.yOffset, w += S ? 1 : 0, S = !1), this.applyTextPropertiesToMatrix(s, g, h[r].line, x, w), x += h[r].l || 0, x += M), p) {
            E = this.globalData.fontManager.getCharData(s.finalText[r], c.fStyle, this.globalData.fontManager.getFontByName(s.f).fFamily);
            var A;
            if (E.t === 1)
              A = new SVGCompElement(E.data, this.globalData, this);
            else {
              var k = emptyShapeData;
              E.data && E.data.shapes && (k = this.buildShapeData(E.data, s.finalSize)), A = new SVGShapeElement(k, this.globalData, this);
            }
            if (this.textSpans[r].glyph) {
              var V = this.textSpans[r].glyph;
              this.textSpans[r].childSpan.removeChild(V.layerElement), V.destroy();
            }
            this.textSpans[r].glyph = A, A._debug = !0, A.prepareFrame(0), A.renderFrame(), this.textSpans[r].childSpan.appendChild(A.layerElement), E.t === 1 && this.textSpans[r].childSpan.setAttribute("transform", "scale(" + s.finalSize / 100 + "," + s.finalSize / 100 + ")");
          } else
            y && m.setAttribute("transform", "translate(" + g.props[12] + "," + g.props[13] + ")"), m.textContent = h[r].val, m.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        y && m && m.setAttribute("d", v);
      }
      for (; r < this.textSpans.length; )
        this.textSpans[r].span.style.display = "none", r += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var r = this.layerElement.getBBox();
        this.bbox = {
          top: r.y,
          left: r.x,
          width: r.width,
          height: r.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var r, a = this.textSpans.length, s;
      for (this.renderedFrame = this.comp.renderedFrame, r = 0; r < a; r += 1)
        s = this.textSpans[r].glyph, s && (s.prepareFrame(this.comp.renderedFrame - this.data.st), s._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var r, a, s = this.textAnimator.renderedLetters, c = this.textProperty.currentData.l;
        a = c.length;
        var u, d, h;
        for (r = 0; r < a; r += 1)
          c[r].n || (u = s[r], d = this.textSpans[r].span, h = this.textSpans[r].glyph, h && h.renderFrame(), u._mdf.m && d.setAttribute("transform", u.m), u._mdf.o && d.setAttribute("opacity", u.o), u._mdf.sw && d.setAttribute("stroke-width", u.sw), u._mdf.sc && d.setAttribute("stroke", u.sc), u._mdf.fc && d.setAttribute("fill", u.fc));
      }
    };
    function ISolidElement(r, a, s) {
      this.initElement(r, a, s);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var r = createNS("rect");
      r.setAttribute("width", this.data.sw), r.setAttribute("height", this.data.sh), r.setAttribute("fill", this.data.sc), this.layerElement.appendChild(r);
    };
    function NullElement(r, a, s) {
      this.initFrame(), this.initBaseData(r, a, s), this.initFrame(), this.initTransform(r, a, s), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(r) {
      this.prepareProperties(r, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(r) {
      return new NullElement(r, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(r) {
      return new SVGShapeElement(r, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(r) {
      return new SVGTextLottieElement(r, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(r) {
      return new IImageElement(r, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(r) {
      return new ISolidElement(r, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(r) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + r.w + " " + r.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", r.w), this.svgElement.setAttribute("height", r.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var a = this.globalData.defs;
      this.setupGlobalData(r, a), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = r;
      var s = createNS("clipPath"), c = createNS("rect");
      c.setAttribute("width", r.w), c.setAttribute("height", r.h), c.setAttribute("x", 0), c.setAttribute("y", 0);
      var u = createElementID();
      s.setAttribute("id", u), s.appendChild(c), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + u + ")"), a.appendChild(s), this.layers = r.layers, this.elements = createSizedArray(r.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var r, a = this.layers ? this.layers.length : 0;
      for (r = 0; r < a; r += 1)
        this.elements[r] && this.elements[r].destroy && this.elements[r].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(r) {
      var a = 0, s = this.layers.length;
      for (a = 0; a < s; a += 1)
        if (this.layers[a].ind === r)
          return a;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(r) {
      var a = this.elements;
      if (!(a[r] || this.layers[r].ty === 99)) {
        a[r] = !0;
        var s = this.createItem(this.layers[r]);
        if (a[r] = s, getExpressionsPlugin() && (this.layers[r].ty === 0 && this.globalData.projectInterface.registerComposition(s), s.initExpressions()), this.appendElementInPos(s, r), this.layers[r].tt) {
          var c = "tp" in this.layers[r] ? this.findIndexByInd(this.layers[r].tp) : r - 1;
          if (c === -1)
            return;
          if (!this.elements[c] || this.elements[c] === !0)
            this.buildItem(c), this.addPendingElement(s);
          else {
            var u = a[c], d = u.getMatte(this.layers[r].tt);
            s.setMatte(d);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var r = this.pendingElements.pop();
        if (r.checkParenting(), r.data.tt)
          for (var a = 0, s = this.elements.length; a < s; ) {
            if (this.elements[a] === r) {
              var c = "tp" in r.data ? this.findIndexByInd(r.data.tp) : a - 1, u = this.elements[c], d = u.getMatte(this.layers[a].tt);
              r.setMatte(d);
              break;
            }
            a += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(r) {
      if (!(this.renderedFrame === r || this.destroyed)) {
        r === null ? r = this.renderedFrame : this.renderedFrame = r, this.globalData.frameNum = r, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = r, this.globalData._mdf = !1;
        var a, s = this.layers.length;
        for (this.completeLayers || this.checkLayers(r), a = s - 1; a >= 0; a -= 1)
          (this.completeLayers || this.elements[a]) && this.elements[a].prepareFrame(r - this.layers[a].st);
        if (this.globalData._mdf)
          for (a = 0; a < s; a += 1)
            (this.completeLayers || this.elements[a]) && this.elements[a].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(r, a) {
      var s = r.getBaseElement();
      if (s) {
        for (var c = 0, u; c < a; )
          this.elements[c] && this.elements[c] !== !0 && this.elements[c].getBaseElement() && (u = this.elements[c].getBaseElement()), c += 1;
        u ? this.layerElement.insertBefore(s, u) : this.layerElement.appendChild(s);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(r, a, s) {
      this.initFrame(), this.initBaseData(r, a, s), this.initTransform(r, a, s), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !a.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(r) {
      if (this._mdf = !1, this.prepareRenderableFrame(r), this.prepareProperties(r, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = r / this.data.sr;
        else {
          var a = this.tm.v;
          a === this.data.op && (a = this.data.op - 1), this.renderedFrame = a;
        }
        var s, c = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), s = c - 1; s >= 0; s -= 1)
          (this.completeLayers || this.elements[s]) && (this.elements[s].prepareFrame(this.renderedFrame - this.layers[s].st), this.elements[s]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var r, a = this.layers.length;
      for (r = 0; r < a; r += 1)
        (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
    }, ICompElement.prototype.setElements = function(r) {
      this.elements = r;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var r, a = this.layers.length;
      for (r = 0; r < a; r += 1)
        this.elements[r] && this.elements[r].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(r, a, s) {
      this.layers = r.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(r, a, s), this.tm = r.tm ? PropertyFactory.getProp(this, r.tm, 0, a.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(r) {
      return new SVGCompElement(r, this.globalData, this);
    };
    function SVGRenderer(r, a) {
      this.animationItem = r, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var s = "";
      if (a && a.title) {
        var c = createNS("title"), u = createElementID();
        c.setAttribute("id", u), c.textContent = a.title, this.svgElement.appendChild(c), s += u;
      }
      if (a && a.description) {
        var d = createNS("desc"), h = createElementID();
        d.setAttribute("id", h), d.textContent = a.description, this.svgElement.appendChild(d), s += " " + h;
      }
      s && this.svgElement.setAttribute("aria-labelledby", s);
      var p = createNS("defs");
      this.svgElement.appendChild(p);
      var m = createNS("g");
      this.svgElement.appendChild(m), this.layerElement = m, this.renderConfig = {
        preserveAspectRatio: a && a.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: a && a.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: a && a.contentVisibility || "visible",
        progressiveLoad: a && a.progressiveLoad || !1,
        hideOnTransparent: !(a && a.hideOnTransparent === !1),
        viewBoxOnly: a && a.viewBoxOnly || !1,
        viewBoxSize: a && a.viewBoxSize || !1,
        className: a && a.className || "",
        id: a && a.id || "",
        focusable: a && a.focusable,
        filterSize: {
          width: a && a.filterSize && a.filterSize.width || "100%",
          height: a && a.filterSize && a.filterSize.height || "100%",
          x: a && a.filterSize && a.filterSize.x || "0%",
          y: a && a.filterSize && a.filterSize.y || "0%"
        },
        width: a && a.width,
        height: a && a.height,
        runExpressions: !a || a.runExpressions === void 0 || a.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: p,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(r) {
      return new SVGCompElement(r, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(a) {
        var s, c = a.length, u = "_";
        for (s = 0; s < c; s += 1)
          u += a[s].transform.key + "_";
        var d = this.sequences[u];
        return d || (d = {
          transforms: [].concat(a),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[u] = d, this.sequenceList.push(d)), d;
      },
      processSequence: function(a, s) {
        for (var c = 0, u = a.transforms.length, d = s; c < u && !s; ) {
          if (a.transforms[c].transform.mProps._mdf) {
            d = !0;
            break;
          }
          c += 1;
        }
        if (d)
          for (a.finalTransform.reset(), c = u - 1; c >= 0; c -= 1)
            a.finalTransform.multiply(a.transforms[c].transform.mProps.v);
        a._mdf = d;
      },
      processSequences: function(a) {
        var s, c = this.sequenceList.length;
        for (s = 0; s < c; s += 1)
          this.processSequence(this.sequenceList[s], a);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var a = "__lottie_element_luma_buffer", s = null, c = null, u = null;
      function d() {
        var m = createNS("svg"), g = createNS("filter"), v = createNS("feColorMatrix");
        return g.setAttribute("id", a), v.setAttribute("type", "matrix"), v.setAttribute("color-interpolation-filters", "sRGB"), v.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), g.appendChild(v), m.appendChild(g), m.setAttribute("id", a + "_svg"), featureSupport.svgLumaHidden && (m.style.display = "none"), m;
      }
      function h() {
        s || (u = d(), document.body.appendChild(u), s = createTag("canvas"), c = s.getContext("2d"), c.filter = "url(#" + a + ")", c.fillStyle = "rgba(0,0,0,0)", c.fillRect(0, 0, 1, 1));
      }
      function p(m) {
        return s || h(), s.width = m.width, s.height = m.height, c.filter = "url(#" + a + ")", s;
      }
      return {
        load: h,
        get: p
      };
    };
    function createCanvas(r, a) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(r, a);
      var s = createTag("canvas");
      return s.width = r, s.height = a, s;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(r) {
      var a, s = r.data.ef ? r.data.ef.length : 0;
      this.filters = [];
      var c;
      for (a = 0; a < s; a += 1) {
        c = null;
        var u = r.data.ef[a].ty;
        if (registeredEffects[u]) {
          var d = registeredEffects[u].effect;
          c = new d(r.effectsManager.effectElements[a], r);
        }
        c && this.filters.push(c);
      }
      this.filters.length && r.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(r) {
      var a, s = this.filters.length;
      for (a = 0; a < s; a += 1)
        this.filters[a].renderFrame(r);
    }, CVEffects.prototype.getEffects = function(r) {
      var a, s = this.filters.length, c = [];
      for (a = 0; a < s; a += 1)
        this.filters[a].type === r && c.push(this.filters[a]);
      return c;
    };
    function registerEffect(r, a) {
      registeredEffects[r] = {
        effect: a
      };
    }
    function CVMaskElement(r, a) {
      this.data = r, this.element = a, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var s, c = this.masksProperties.length, u = !1;
      for (s = 0; s < c; s += 1)
        this.masksProperties[s].mode !== "n" && (u = !0), this.viewData[s] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[s], 3);
      this.hasMasks = u, u && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var r = this.element.finalTransform.mat, a = this.element.canvasContext, s, c = this.masksProperties.length, u, d, h;
        for (a.beginPath(), s = 0; s < c; s += 1)
          if (this.masksProperties[s].mode !== "n") {
            this.masksProperties[s].inv && (a.moveTo(0, 0), a.lineTo(this.element.globalData.compSize.w, 0), a.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), a.lineTo(0, this.element.globalData.compSize.h), a.lineTo(0, 0)), h = this.viewData[s].v, u = r.applyToPointArray(h.v[0][0], h.v[0][1], 0), a.moveTo(u[0], u[1]);
            var p, m = h._length;
            for (p = 1; p < m; p += 1)
              d = r.applyToTriplePoints(h.o[p - 1], h.i[p], h.v[p]), a.bezierCurveTo(d[0], d[1], d[2], d[3], d[4], d[5]);
            d = r.applyToTriplePoints(h.o[p - 1], h.i[0], h.v[0]), a.bezierCurveTo(d[0], d[1], d[2], d[3], d[4], d[5]);
          }
        this.element.globalData.renderer.save(!0), a.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var a = this.globalData.canvasContext, s = assetLoader.createCanvas(a.canvas.width, a.canvas.height);
          this.buffers.push(s);
          var c = assetLoader.createCanvas(a.canvas.width, a.canvas.height);
          this.buffers.push(c), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var a = this.globalData;
        if (a.blendMode !== this.data.bm) {
          a.blendMode = this.data.bm;
          var s = getBlendMode(this.data.bm);
          a.canvasContext.globalCompositeOperation = s;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(a) {
        a.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var a = this.buffers[0], s = a.getContext("2d");
          this.clearCanvas(s), s.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var a = this.buffers[1], s = a.getContext("2d");
          this.clearCanvas(s), s.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var c = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (c.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var u = assetLoader.getLumaCanvas(this.canvasContext.canvas), d = u.getContext("2d");
            d.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(u, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(a, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(a) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !a)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var s = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(s), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(s), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(r, a, s, c) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var u = 4;
      a.ty === "rc" ? u = 5 : a.ty === "el" ? u = 6 : a.ty === "sr" && (u = 7), this.sh = ShapePropertyFactory.getShapeProp(r, a, u, r);
      var d, h = s.length, p;
      for (d = 0; d < h; d += 1)
        s[d].closed || (p = {
          transforms: c.addTransformSequence(s[d].transforms),
          trNodes: []
        }, this.styledShapes.push(p), s[d].elements.push(p));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(r, a, s) {
      this.shapes = [], this.shapesData = r.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(r, a) {
      var s = {
        data: r,
        type: r.ty,
        preTransforms: this.transformsManager.addTransformSequence(a),
        transforms: [],
        elements: [],
        closed: r.hd === !0
      }, c = {};
      if (r.ty === "fl" || r.ty === "st" ? (c.c = PropertyFactory.getProp(this, r.c, 1, 255, this), c.c.k || (s.co = "rgb(" + bmFloor(c.c.v[0]) + "," + bmFloor(c.c.v[1]) + "," + bmFloor(c.c.v[2]) + ")")) : (r.ty === "gf" || r.ty === "gs") && (c.s = PropertyFactory.getProp(this, r.s, 1, null, this), c.e = PropertyFactory.getProp(this, r.e, 1, null, this), c.h = PropertyFactory.getProp(this, r.h || {
        k: 0
      }, 0, 0.01, this), c.a = PropertyFactory.getProp(this, r.a || {
        k: 0
      }, 0, degToRads, this), c.g = new GradientProperty(this, r.g, this)), c.o = PropertyFactory.getProp(this, r.o, 0, 0.01, this), r.ty === "st" || r.ty === "gs") {
        if (s.lc = lineCapEnum[r.lc || 2], s.lj = lineJoinEnum[r.lj || 2], r.lj == 1 && (s.ml = r.ml), c.w = PropertyFactory.getProp(this, r.w, 0, null, this), c.w.k || (s.wi = c.w.v), r.d) {
          var u = new DashProperty(this, r.d, "canvas", this);
          c.d = u, c.d.k || (s.da = c.d.dashArray, s.do = c.d.dashoffset[0]);
        }
      } else
        s.r = r.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(s), c.style = s, c;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var r = {
        it: [],
        prevViewData: []
      };
      return r;
    }, CVShapeElement.prototype.createTransformElement = function(r) {
      var a = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, r.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, r, this)
        }
      };
      return a;
    }, CVShapeElement.prototype.createShapeElement = function(r) {
      var a = new CVShapeData(this, r, this.stylesList, this.transformsManager);
      return this.shapes.push(a), this.addShapeToModifiers(a), a;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var r, a = this.itemsData.length;
      for (r = 0; r < a; r += 1)
        this.prevViewData[r] = this.itemsData[r];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), a = this.dynamicProperties.length, r = 0; r < a; r += 1)
        this.dynamicProperties[r].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(r) {
      var a, s = this.stylesList.length;
      for (a = 0; a < s; a += 1)
        this.stylesList[a].closed || this.stylesList[a].transforms.push(r);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var r, a = this.stylesList.length;
      for (r = 0; r < a; r += 1)
        this.stylesList[r].closed || this.stylesList[r].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(r) {
      var a, s = r.length;
      for (a = 0; a < s; a += 1)
        r[a].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(r, a, s, c, u) {
      var d, h = r.length - 1, p, m, g = [], v = [], y, x, w, S = [].concat(u);
      for (d = h; d >= 0; d -= 1) {
        if (y = this.searchProcessedElement(r[d]), y ? a[d] = s[y - 1] : r[d]._shouldRender = c, r[d].ty === "fl" || r[d].ty === "st" || r[d].ty === "gf" || r[d].ty === "gs")
          y ? a[d].style.closed = !1 : a[d] = this.createStyleElement(r[d], S), g.push(a[d].style);
        else if (r[d].ty === "gr") {
          if (!y)
            a[d] = this.createGroupElement(r[d]);
          else
            for (m = a[d].it.length, p = 0; p < m; p += 1)
              a[d].prevViewData[p] = a[d].it[p];
          this.searchShapes(r[d].it, a[d].it, a[d].prevViewData, c, S);
        } else r[d].ty === "tr" ? (y || (w = this.createTransformElement(r[d]), a[d] = w), S.push(a[d]), this.addTransformToStyleList(a[d])) : r[d].ty === "sh" || r[d].ty === "rc" || r[d].ty === "el" || r[d].ty === "sr" ? y || (a[d] = this.createShapeElement(r[d])) : r[d].ty === "tm" || r[d].ty === "rd" || r[d].ty === "pb" || r[d].ty === "zz" || r[d].ty === "op" ? (y ? (x = a[d], x.closed = !1) : (x = ShapeModifiers.getModifier(r[d].ty), x.init(this, r[d]), a[d] = x, this.shapeModifiers.push(x)), v.push(x)) : r[d].ty === "rp" && (y ? (x = a[d], x.closed = !0) : (x = ShapeModifiers.getModifier(r[d].ty), a[d] = x, x.init(this, r, d, a), this.shapeModifiers.push(x), c = !1), v.push(x));
        this.addProcessedElement(r[d], d + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(g), h = v.length, d = 0; d < h; d += 1)
        v[d].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(r, a) {
      (r._opMdf || a.op._mdf || this._isFirstFrame) && (a.opacity = r.opacity, a.opacity *= a.op.v, a._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var r, a = this.stylesList.length, s, c, u, d, h, p, m = this.globalData.renderer, g = this.globalData.canvasContext, v, y;
      for (r = 0; r < a; r += 1)
        if (y = this.stylesList[r], v = y.type, !((v === "st" || v === "gs") && y.wi === 0 || !y.data._shouldRender || y.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (m.save(), h = y.elements, v === "st" || v === "gs" ? (m.ctxStrokeStyle(v === "st" ? y.co : y.grd), m.ctxLineWidth(y.wi), m.ctxLineCap(y.lc), m.ctxLineJoin(y.lj), m.ctxMiterLimit(y.ml || 0)) : m.ctxFillStyle(v === "fl" ? y.co : y.grd), m.ctxOpacity(y.coOp), v !== "st" && v !== "gs" && g.beginPath(), m.ctxTransform(y.preTransforms.finalTransform.props), c = h.length, s = 0; s < c; s += 1) {
            for ((v === "st" || v === "gs") && (g.beginPath(), y.da && (g.setLineDash(y.da), g.lineDashOffset = y.do)), p = h[s].trNodes, d = p.length, u = 0; u < d; u += 1)
              p[u].t === "m" ? g.moveTo(p[u].p[0], p[u].p[1]) : p[u].t === "c" ? g.bezierCurveTo(p[u].pts[0], p[u].pts[1], p[u].pts[2], p[u].pts[3], p[u].pts[4], p[u].pts[5]) : g.closePath();
            (v === "st" || v === "gs") && (m.ctxStroke(), y.da && g.setLineDash(this.dashResetter));
          }
          v !== "st" && v !== "gs" && this.globalData.renderer.ctxFill(y.r), m.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(r, a, s, c) {
      var u, d = a.length - 1, h;
      for (h = r, u = d; u >= 0; u -= 1)
        a[u].ty === "tr" ? (h = s[u].transform, this.renderShapeTransform(r, h)) : a[u].ty === "sh" || a[u].ty === "el" || a[u].ty === "rc" || a[u].ty === "sr" ? this.renderPath(a[u], s[u]) : a[u].ty === "fl" ? this.renderFill(a[u], s[u], h) : a[u].ty === "st" ? this.renderStroke(a[u], s[u], h) : a[u].ty === "gf" || a[u].ty === "gs" ? this.renderGradientFill(a[u], s[u], h) : a[u].ty === "gr" ? this.renderShape(h, a[u].it, s[u].it) : a[u].ty;
      c && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(r, a) {
      if (this._isFirstFrame || a._mdf || r.transforms._mdf) {
        var s = r.trNodes, c = a.paths, u, d, h, p = c._length;
        s.length = 0;
        var m = r.transforms.finalTransform;
        for (h = 0; h < p; h += 1) {
          var g = c.shapes[h];
          if (g && g.v) {
            for (d = g._length, u = 1; u < d; u += 1)
              u === 1 && s.push({
                t: "m",
                p: m.applyToPointArray(g.v[0][0], g.v[0][1], 0)
              }), s.push({
                t: "c",
                pts: m.applyToTriplePoints(g.o[u - 1], g.i[u], g.v[u])
              });
            d === 1 && s.push({
              t: "m",
              p: m.applyToPointArray(g.v[0][0], g.v[0][1], 0)
            }), g.c && d && (s.push({
              t: "c",
              pts: m.applyToTriplePoints(g.o[u - 1], g.i[0], g.v[0])
            }), s.push({
              t: "z"
            }));
          }
        }
        r.trNodes = s;
      }
    }, CVShapeElement.prototype.renderPath = function(r, a) {
      if (r.hd !== !0 && r._shouldRender) {
        var s, c = a.styledShapes.length;
        for (s = 0; s < c; s += 1)
          this.renderStyledShape(a.styledShapes[s], a.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(r, a, s) {
      var c = a.style;
      (a.c._mdf || this._isFirstFrame) && (c.co = "rgb(" + bmFloor(a.c.v[0]) + "," + bmFloor(a.c.v[1]) + "," + bmFloor(a.c.v[2]) + ")"), (a.o._mdf || s._opMdf || this._isFirstFrame) && (c.coOp = a.o.v * s.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(r, a, s) {
      var c = a.style, u;
      if (!c.grd || a.g._mdf || a.s._mdf || a.e._mdf || r.t !== 1 && (a.h._mdf || a.a._mdf)) {
        var d = this.globalData.canvasContext, h = a.s.v, p = a.e.v;
        if (r.t === 1)
          u = d.createLinearGradient(h[0], h[1], p[0], p[1]);
        else {
          var m = Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)), g = Math.atan2(p[1] - h[1], p[0] - h[0]), v = a.h.v;
          v >= 1 ? v = 0.99 : v <= -1 && (v = -0.99);
          var y = m * v, x = Math.cos(g + a.a.v) * y + h[0], w = Math.sin(g + a.a.v) * y + h[1];
          u = d.createRadialGradient(x, w, 0, h[0], h[1], m);
        }
        var S, M = r.g.p, P = a.g.c, L = 1;
        for (S = 0; S < M; S += 1)
          a.g._hasOpacity && a.g._collapsable && (L = a.g.o[S * 2 + 1]), u.addColorStop(P[S * 4] / 100, "rgba(" + P[S * 4 + 1] + "," + P[S * 4 + 2] + "," + P[S * 4 + 3] + "," + L + ")");
        c.grd = u;
      }
      c.coOp = a.o.v * s.opacity;
    }, CVShapeElement.prototype.renderStroke = function(r, a, s) {
      var c = a.style, u = a.d;
      u && (u._mdf || this._isFirstFrame) && (c.da = u.dashArray, c.do = u.dashoffset[0]), (a.c._mdf || this._isFirstFrame) && (c.co = "rgb(" + bmFloor(a.c.v[0]) + "," + bmFloor(a.c.v[1]) + "," + bmFloor(a.c.v[2]) + ")"), (a.o._mdf || s._opMdf || this._isFirstFrame) && (c.coOp = a.o.v * s.opacity), (a.w._mdf || this._isFirstFrame) && (c.wi = a.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(r, a, s) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var r = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(r.l ? r.l.length : 0);
      var a = !1;
      r.fc ? (a = !0, this.values.fill = this.buildColor(r.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = a;
      var s = !1;
      r.sc && (s = !0, this.values.stroke = this.buildColor(r.sc), this.values.sWidth = r.sw);
      var c = this.globalData.fontManager.getFontByName(r.f), u, d, h = r.l, p = this.mHelper;
      this.stroke = s, this.values.fValue = r.finalSize + "px " + this.globalData.fontManager.getFontByName(r.f).fFamily, d = r.finalText.length;
      var m, g, v, y, x, w, S, M, P, L, I = this.data.singleShape, T = r.tr * 1e-3 * r.finalSize, E = 0, R = 0, A = !0, k = 0;
      for (u = 0; u < d; u += 1) {
        m = this.globalData.fontManager.getCharData(r.finalText[u], c.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily), g = m && m.data || {}, p.reset(), I && h[u].n && (E = -T, R += r.yOffset, R += A ? 1 : 0, A = !1), x = g.shapes ? g.shapes[0].it : [], S = x.length, p.scale(r.finalSize / 100, r.finalSize / 100), I && this.applyTextPropertiesToMatrix(r, p, h[u].line, E, R), P = createSizedArray(S - 1);
        var V = 0;
        for (w = 0; w < S; w += 1)
          if (x[w].ty === "sh") {
            for (y = x[w].ks.k.i.length, M = x[w].ks.k, L = [], v = 1; v < y; v += 1)
              v === 1 && L.push(p.applyToX(M.v[0][0], M.v[0][1], 0), p.applyToY(M.v[0][0], M.v[0][1], 0)), L.push(p.applyToX(M.o[v - 1][0], M.o[v - 1][1], 0), p.applyToY(M.o[v - 1][0], M.o[v - 1][1], 0), p.applyToX(M.i[v][0], M.i[v][1], 0), p.applyToY(M.i[v][0], M.i[v][1], 0), p.applyToX(M.v[v][0], M.v[v][1], 0), p.applyToY(M.v[v][0], M.v[v][1], 0));
            L.push(p.applyToX(M.o[v - 1][0], M.o[v - 1][1], 0), p.applyToY(M.o[v - 1][0], M.o[v - 1][1], 0), p.applyToX(M.i[0][0], M.i[0][1], 0), p.applyToY(M.i[0][0], M.i[0][1], 0), p.applyToX(M.v[0][0], M.v[0][1], 0), p.applyToY(M.v[0][0], M.v[0][1], 0)), P[V] = L, V += 1;
          }
        I && (E += h[u].l, E += T), this.textSpans[k] ? this.textSpans[k].elem = P : this.textSpans[k] = {
          elem: P
        }, k += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var r = this.canvasContext;
      r.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var a, s, c, u, d, h, p = this.textAnimator.renderedLetters, m = this.textProperty.currentData.l;
      s = m.length;
      var g, v = null, y = null, x = null, w, S, M = this.globalData.renderer;
      for (a = 0; a < s; a += 1)
        if (!m[a].n) {
          if (g = p[a], g && (M.save(), M.ctxTransform(g.p), M.ctxOpacity(g.o)), this.fill) {
            for (g && g.fc ? v !== g.fc && (M.ctxFillStyle(g.fc), v = g.fc) : v !== this.values.fill && (v = this.values.fill, M.ctxFillStyle(this.values.fill)), w = this.textSpans[a].elem, u = w.length, this.globalData.canvasContext.beginPath(), c = 0; c < u; c += 1)
              for (S = w[c], h = S.length, this.globalData.canvasContext.moveTo(S[0], S[1]), d = 2; d < h; d += 6)
                this.globalData.canvasContext.bezierCurveTo(S[d], S[d + 1], S[d + 2], S[d + 3], S[d + 4], S[d + 5]);
            this.globalData.canvasContext.closePath(), M.ctxFill();
          }
          if (this.stroke) {
            for (g && g.sw ? x !== g.sw && (x = g.sw, M.ctxLineWidth(g.sw)) : x !== this.values.sWidth && (x = this.values.sWidth, M.ctxLineWidth(this.values.sWidth)), g && g.sc ? y !== g.sc && (y = g.sc, M.ctxStrokeStyle(g.sc)) : y !== this.values.stroke && (y = this.values.stroke, M.ctxStrokeStyle(this.values.stroke)), w = this.textSpans[a].elem, u = w.length, this.globalData.canvasContext.beginPath(), c = 0; c < u; c += 1)
              for (S = w[c], h = S.length, this.globalData.canvasContext.moveTo(S[0], S[1]), d = 2; d < h; d += 6)
                this.globalData.canvasContext.bezierCurveTo(S[d], S[d + 1], S[d + 2], S[d + 3], S[d + 4], S[d + 5]);
            this.globalData.canvasContext.closePath(), M.ctxStroke();
          }
          g && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(r, a, s) {
      this.assetData = a.getAssetData(r.refId), this.img = a.imageLoader.getAsset(this.assetData), this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var r = createTag("canvas");
        r.width = this.assetData.w, r.height = this.assetData.h;
        var a = r.getContext("2d"), s = this.img.width, c = this.img.height, u = s / c, d = this.assetData.w / this.assetData.h, h, p, m = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        u > d && m === "xMidYMid slice" || u < d && m !== "xMidYMid slice" ? (p = c, h = p * d) : (h = s, p = h / d), a.drawImage(this.img, (s - h) / 2, (c - p) / 2, h, p, 0, 0, this.assetData.w, this.assetData.h), this.img = r;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(r, a, s) {
      this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(r) {
      return new CVShapeElement(r, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(r) {
      return new CVTextElement(r, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(r) {
      return new CVImageElement(r, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(r) {
      return new CVSolidElement(r, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(r) {
      r[0] === 1 && r[1] === 0 && r[4] === 0 && r[5] === 1 && r[12] === 0 && r[13] === 0 || this.canvasContext.transform(r[0], r[1], r[4], r[5], r[12], r[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(r) {
      this.canvasContext.globalAlpha *= r < 0 ? 0 : r;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(r) {
      this.canvasContext.fillStyle = r;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(r) {
      this.canvasContext.strokeStyle = r;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(r) {
      this.canvasContext.lineWidth = r;
    }, CanvasRendererBase.prototype.ctxLineCap = function(r) {
      this.canvasContext.lineCap = r;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(r) {
      this.canvasContext.lineJoin = r;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(r) {
      this.canvasContext.miterLimit = r;
    }, CanvasRendererBase.prototype.ctxFill = function(r) {
      this.canvasContext.fill(r);
    }, CanvasRendererBase.prototype.ctxFillRect = function(r, a, s, c) {
      this.canvasContext.fillRect(r, a, s, c);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(r) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      r && (this.globalData.blendMode = "source-over"), this.contextData.restore(r);
    }, CanvasRendererBase.prototype.configAnimation = function(r) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var a = this.animationItem.container.style;
        a.width = "100%", a.height = "100%";
        var s = "0px 0px 0px";
        a.transformOrigin = s, a.mozTransformOrigin = s, a.webkitTransformOrigin = s, a["-webkit-transform"] = s, a.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = r, this.layers = r.layers, this.transformCanvas = {
        w: r.w,
        h: r.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(r, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(r.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(r, a) {
      this.reset();
      var s, c;
      r ? (s = r, c = a, this.canvasContext.canvas.width = s, this.canvasContext.canvas.height = c) : (this.animationItem.wrapper && this.animationItem.container ? (s = this.animationItem.wrapper.offsetWidth, c = this.animationItem.wrapper.offsetHeight) : (s = this.canvasContext.canvas.width, c = this.canvasContext.canvas.height), this.canvasContext.canvas.width = s * this.renderConfig.dpr, this.canvasContext.canvas.height = c * this.renderConfig.dpr);
      var u, d;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var h = this.renderConfig.preserveAspectRatio.split(" "), p = h[1] || "meet", m = h[0] || "xMidYMid", g = m.substr(0, 4), v = m.substr(4);
        u = s / c, d = this.transformCanvas.w / this.transformCanvas.h, d > u && p === "meet" || d < u && p === "slice" ? (this.transformCanvas.sx = s / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = s / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = c / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = c / (this.transformCanvas.h / this.renderConfig.dpr)), g === "xMid" && (d < u && p === "meet" || d > u && p === "slice") ? this.transformCanvas.tx = (s - this.transformCanvas.w * (c / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : g === "xMax" && (d < u && p === "meet" || d > u && p === "slice") ? this.transformCanvas.tx = (s - this.transformCanvas.w * (c / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, v === "YMid" && (d > u && p === "meet" || d < u && p === "slice") ? this.transformCanvas.ty = (c - this.transformCanvas.h * (s / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : v === "YMax" && (d > u && p === "meet" || d < u && p === "slice") ? this.transformCanvas.ty = (c - this.transformCanvas.h * (s / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = s / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = c / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var r, a = this.layers ? this.layers.length : 0;
      for (r = a - 1; r >= 0; r -= 1)
        this.elements[r] && this.elements[r].destroy && this.elements[r].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(r, a) {
      if (!(this.renderedFrame === r && this.renderConfig.clearCanvas === !0 && !a || this.destroyed || r === -1)) {
        this.renderedFrame = r, this.globalData.frameNum = r - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || a, this.globalData.projectInterface.currentFrame = r;
        var s, c = this.layers.length;
        for (this.completeLayers || this.checkLayers(r), s = c - 1; s >= 0; s -= 1)
          (this.completeLayers || this.elements[s]) && this.elements[s].prepareFrame(r - this.layers[s].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), s = c - 1; s >= 0; s -= 1)
            (this.completeLayers || this.elements[s]) && this.elements[s].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(r) {
      var a = this.elements;
      if (!(a[r] || this.layers[r].ty === 99)) {
        var s = this.createItem(this.layers[r], this, this.globalData);
        a[r] = s, s.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var r = this.pendingElements.pop();
        r.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var r, a = 15;
      for (r = 0; r < a; r += 1) {
        var s = new CanvasContext();
        this.stack[r] = s;
      }
      this._length = a, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var r = this._length * 2, a = 0;
      for (a = this._length; a < r; a += 1)
        this.stack[a] = new CanvasContext();
      this._length = r;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(r) {
      this.cArrPos -= 1;
      var a = this.stack[this.cArrPos], s = a.transform, c, u = this.cTr.props;
      for (c = 0; c < 16; c += 1)
        u[c] = s[c];
      if (r) {
        this.nativeContext.restore();
        var d = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = d.fillStyle, this.appliedStrokeStyle = d.strokeStyle, this.appliedLineWidth = d.lineWidth, this.appliedLineCap = d.lineCap, this.appliedLineJoin = d.lineJoin, this.appliedMiterLimit = d.miterLimit;
      }
      this.nativeContext.setTransform(s[0], s[1], s[4], s[5], s[12], s[13]), (r || a.opacity !== -1 && this.currentOpacity !== a.opacity) && (this.nativeContext.globalAlpha = a.opacity, this.currentOpacity = a.opacity), this.currentFillStyle = a.fillStyle, this.currentStrokeStyle = a.strokeStyle, this.currentLineWidth = a.lineWidth, this.currentLineCap = a.lineCap, this.currentLineJoin = a.lineJoin, this.currentMiterLimit = a.miterLimit;
    }, CVContextData.prototype.save = function(r) {
      r && this.nativeContext.save();
      var a = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var s = this.stack[this.cArrPos], c;
      for (c = 0; c < 16; c += 1)
        s.transform[c] = a[c];
      this.cArrPos += 1;
      var u = this.stack[this.cArrPos];
      u.opacity = s.opacity, u.fillStyle = s.fillStyle, u.strokeStyle = s.strokeStyle, u.lineWidth = s.lineWidth, u.lineCap = s.lineCap, u.lineJoin = s.lineJoin, u.miterLimit = s.miterLimit;
    }, CVContextData.prototype.setOpacity = function(r) {
      this.stack[this.cArrPos].opacity = r;
    }, CVContextData.prototype.setContext = function(r) {
      this.nativeContext = r;
    }, CVContextData.prototype.fillStyle = function(r) {
      this.stack[this.cArrPos].fillStyle !== r && (this.currentFillStyle = r, this.stack[this.cArrPos].fillStyle = r);
    }, CVContextData.prototype.strokeStyle = function(r) {
      this.stack[this.cArrPos].strokeStyle !== r && (this.currentStrokeStyle = r, this.stack[this.cArrPos].strokeStyle = r);
    }, CVContextData.prototype.lineWidth = function(r) {
      this.stack[this.cArrPos].lineWidth !== r && (this.currentLineWidth = r, this.stack[this.cArrPos].lineWidth = r);
    }, CVContextData.prototype.lineCap = function(r) {
      this.stack[this.cArrPos].lineCap !== r && (this.currentLineCap = r, this.stack[this.cArrPos].lineCap = r);
    }, CVContextData.prototype.lineJoin = function(r) {
      this.stack[this.cArrPos].lineJoin !== r && (this.currentLineJoin = r, this.stack[this.cArrPos].lineJoin = r);
    }, CVContextData.prototype.miterLimit = function(r) {
      this.stack[this.cArrPos].miterLimit !== r && (this.currentMiterLimit = r, this.stack[this.cArrPos].miterLimit = r);
    }, CVContextData.prototype.transform = function(r) {
      this.transformMat.cloneFromProps(r);
      var a = this.cTr;
      this.transformMat.multiply(a), a.cloneFromProps(this.transformMat.props);
      var s = a.props;
      this.nativeContext.setTransform(s[0], s[1], s[4], s[5], s[12], s[13]);
    }, CVContextData.prototype.opacity = function(r) {
      var a = this.stack[this.cArrPos].opacity;
      a *= r < 0 ? 0 : r, this.stack[this.cArrPos].opacity !== a && (this.currentOpacity !== r && (this.nativeContext.globalAlpha = r, this.currentOpacity = r), this.stack[this.cArrPos].opacity = a);
    }, CVContextData.prototype.fill = function(r) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(r);
    }, CVContextData.prototype.fillRect = function(r, a, s, c) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(r, a, s, c);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(r, a, s) {
      this.completeLayers = !1, this.layers = r.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(r, a, s), this.tm = r.tm ? PropertyFactory.getProp(this, r.tm, 0, a.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var r = this.canvasContext;
      r.beginPath(), r.moveTo(0, 0), r.lineTo(this.data.w, 0), r.lineTo(this.data.w, this.data.h), r.lineTo(0, this.data.h), r.lineTo(0, 0), r.clip();
      var a, s = this.layers.length;
      for (a = s - 1; a >= 0; a -= 1)
        (this.completeLayers || this.elements[a]) && this.elements[a].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var r, a = this.layers.length;
      for (r = a - 1; r >= 0; r -= 1)
        this.elements[r] && this.elements[r].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(r) {
      return new CVCompElement(r, this.globalData, this);
    };
    function CanvasRenderer(r, a) {
      this.animationItem = r, this.renderConfig = {
        clearCanvas: a && a.clearCanvas !== void 0 ? a.clearCanvas : !0,
        context: a && a.context || null,
        progressiveLoad: a && a.progressiveLoad || !1,
        preserveAspectRatio: a && a.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: a && a.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: a && a.contentVisibility || "visible",
        className: a && a.className || "",
        id: a && a.id || "",
        runExpressions: !a || a.runExpressions === void 0 || a.runExpressions
      }, this.renderConfig.dpr = a && a.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = a && a.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(r) {
      return new CVCompElement(r, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var a = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var s = this.finalTransform.mat.toCSS();
          a.transform = s, a.webkitTransform = s;
        }
        this.finalTransform._opMdf && (a.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(r, a, s) {
      this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var r;
      this.data.hasMask ? (r = createNS("rect"), r.setAttribute("width", this.data.sw), r.setAttribute("height", this.data.sh), r.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (r = createTag("div"), r.style.width = this.data.sw + "px", r.style.height = this.data.sh + "px", r.style.backgroundColor = this.data.sc), this.layerElement.appendChild(r);
    };
    function HShapeElement(r, a, s) {
      this.shapes = [], this.shapesData = r.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(r, a, s), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var r;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), r = this.svgElement;
      else {
        r = createNS("svg");
        var a = this.comp.data ? this.comp.data : this.globalData.compSize;
        r.setAttribute("width", a.w), r.setAttribute("height", a.h), r.appendChild(this.shapesContainer), this.layerElement.appendChild(r);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = r;
    }, HShapeElement.prototype.getTransformedPoint = function(r, a) {
      var s, c = r.length;
      for (s = 0; s < c; s += 1)
        a = r[s].mProps.v.applyToPointArray(a[0], a[1], 0);
      return a;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(r, a) {
      var s = r.sh.v, c = r.transformers, u, d = s._length, h, p, m, g;
      if (!(d <= 1)) {
        for (u = 0; u < d - 1; u += 1)
          h = this.getTransformedPoint(c, s.v[u]), p = this.getTransformedPoint(c, s.o[u]), m = this.getTransformedPoint(c, s.i[u + 1]), g = this.getTransformedPoint(c, s.v[u + 1]), this.checkBounds(h, p, m, g, a);
        s.c && (h = this.getTransformedPoint(c, s.v[u]), p = this.getTransformedPoint(c, s.o[u]), m = this.getTransformedPoint(c, s.i[0]), g = this.getTransformedPoint(c, s.v[0]), this.checkBounds(h, p, m, g, a));
      }
    }, HShapeElement.prototype.checkBounds = function(r, a, s, c, u) {
      this.getBoundsOfCurve(r, a, s, c);
      var d = this.shapeBoundingBox;
      u.x = bmMin(d.left, u.x), u.xMax = bmMax(d.right, u.xMax), u.y = bmMin(d.top, u.y), u.yMax = bmMax(d.bottom, u.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(r, a, s, c) {
      for (var u = [[r[0], c[0]], [r[1], c[1]]], d, h, p, m, g, v, y, x = 0; x < 2; ++x)
        h = 6 * r[x] - 12 * a[x] + 6 * s[x], d = -3 * r[x] + 9 * a[x] - 9 * s[x] + 3 * c[x], p = 3 * a[x] - 3 * r[x], h |= 0, d |= 0, p |= 0, d === 0 && h === 0 || (d === 0 ? (m = -p / h, m > 0 && m < 1 && u[x].push(this.calculateF(m, r, a, s, c, x))) : (g = h * h - 4 * p * d, g >= 0 && (v = (-h + bmSqrt(g)) / (2 * d), v > 0 && v < 1 && u[x].push(this.calculateF(v, r, a, s, c, x)), y = (-h - bmSqrt(g)) / (2 * d), y > 0 && y < 1 && u[x].push(this.calculateF(y, r, a, s, c, x)))));
      this.shapeBoundingBox.left = bmMin.apply(null, u[0]), this.shapeBoundingBox.top = bmMin.apply(null, u[1]), this.shapeBoundingBox.right = bmMax.apply(null, u[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, u[1]);
    }, HShapeElement.prototype.calculateF = function(r, a, s, c, u, d) {
      return bmPow(1 - r, 3) * a[d] + 3 * bmPow(1 - r, 2) * r * s[d] + 3 * (1 - r) * bmPow(r, 2) * c[d] + bmPow(r, 3) * u[d];
    }, HShapeElement.prototype.calculateBoundingBox = function(r, a) {
      var s, c = r.length;
      for (s = 0; s < c; s += 1)
        r[s] && r[s].sh ? this.calculateShapeBoundingBox(r[s], a) : r[s] && r[s].it ? this.calculateBoundingBox(r[s].it, a) : r[s] && r[s].style && r[s].w && this.expandStrokeBoundingBox(r[s].w, a);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(r, a) {
      var s = 0;
      if (r.keyframes) {
        for (var c = 0; c < r.keyframes.length; c += 1) {
          var u = r.keyframes[c].s;
          u > s && (s = u);
        }
        s *= r.mult;
      } else
        s = r.v * r.mult;
      a.x -= s, a.xMax += s, a.y -= s, a.yMax += s;
    }, HShapeElement.prototype.currentBoxContains = function(r) {
      return this.currentBBox.x <= r.x && this.currentBBox.y <= r.y && this.currentBBox.width + this.currentBBox.x >= r.x + r.width && this.currentBBox.height + this.currentBBox.y >= r.y + r.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var r = this.tempBoundingBox, a = 999999;
        if (r.x = a, r.xMax = -a, r.y = a, r.yMax = -a, this.calculateBoundingBox(this.itemsData, r), r.width = r.xMax < r.x ? 0 : r.xMax - r.x, r.height = r.yMax < r.y ? 0 : r.yMax - r.y, this.currentBoxContains(r))
          return;
        var s = !1;
        if (this.currentBBox.w !== r.width && (this.currentBBox.w = r.width, this.shapeCont.setAttribute("width", r.width), s = !0), this.currentBBox.h !== r.height && (this.currentBBox.h = r.height, this.shapeCont.setAttribute("height", r.height), s = !0), s || this.currentBBox.x !== r.x || this.currentBBox.y !== r.y) {
          this.currentBBox.w = r.width, this.currentBBox.h = r.height, this.currentBBox.x = r.x, this.currentBBox.y = r.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var c = this.shapeCont.style, u = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          c.transform = u, c.webkitTransform = u;
        }
      }
    };
    function HTextElement(r, a, s) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var r = createNS("g");
        this.maskedElement.appendChild(r), this.innerElem = r;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var r = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(r.l ? r.l.length : 0);
      var a = this.innerElem.style, s = r.fc ? this.buildColor(r.fc) : "rgba(0,0,0,0)";
      a.fill = s, a.color = s, r.sc && (a.stroke = this.buildColor(r.sc), a.strokeWidth = r.sw + "px");
      var c = this.globalData.fontManager.getFontByName(r.f);
      if (!this.globalData.fontManager.chars)
        if (a.fontSize = r.finalSize + "px", a.lineHeight = r.finalSize + "px", c.fClass)
          this.innerElem.className = c.fClass;
        else {
          a.fontFamily = c.fFamily;
          var u = r.fWeight, d = r.fStyle;
          a.fontStyle = d, a.fontWeight = u;
        }
      var h, p, m = r.l;
      p = m.length;
      var g, v, y, x = this.mHelper, w, S = "", M = 0;
      for (h = 0; h < p; h += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[M] ? g = this.textPaths[M] : (g = createNS("path"), g.setAttribute("stroke-linecap", lineCapEnum[1]), g.setAttribute("stroke-linejoin", lineJoinEnum[2]), g.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[M] ? (v = this.textSpans[M], y = v.children[0]) : (v = createTag("div"), v.style.lineHeight = 0, y = createNS("svg"), y.appendChild(g), styleDiv(v)))) : this.isMasked ? g = this.textPaths[M] ? this.textPaths[M] : createNS("text") : this.textSpans[M] ? (v = this.textSpans[M], g = this.textPaths[M]) : (v = createTag("span"), styleDiv(v), g = createTag("span"), styleDiv(g), v.appendChild(g)), this.globalData.fontManager.chars) {
          var P = this.globalData.fontManager.getCharData(r.finalText[h], c.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily), L;
          if (P ? L = P.data : L = null, x.reset(), L && L.shapes && L.shapes.length && (w = L.shapes[0].it, x.scale(r.finalSize / 100, r.finalSize / 100), S = this.createPathShape(x, w), g.setAttribute("d", S)), this.isMasked)
            this.innerElem.appendChild(g);
          else {
            if (this.innerElem.appendChild(v), L && L.shapes) {
              document.body.appendChild(y);
              var I = y.getBBox();
              y.setAttribute("width", I.width + 2), y.setAttribute("height", I.height + 2), y.setAttribute("viewBox", I.x - 1 + " " + (I.y - 1) + " " + (I.width + 2) + " " + (I.height + 2));
              var T = y.style, E = "translate(" + (I.x - 1) + "px," + (I.y - 1) + "px)";
              T.transform = E, T.webkitTransform = E, m[h].yOffset = I.y - 1;
            } else
              y.setAttribute("width", 1), y.setAttribute("height", 1);
            v.appendChild(y);
          }
        } else if (g.textContent = m[h].val, g.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(g);
        else {
          this.innerElem.appendChild(v);
          var R = g.style, A = "translate3d(0," + -r.finalSize / 1.2 + "px,0)";
          R.transform = A, R.webkitTransform = A;
        }
        this.isMasked ? this.textSpans[M] = g : this.textSpans[M] = v, this.textSpans[M].style.display = "block", this.textPaths[M] = g, M += 1;
      }
      for (; M < this.textSpans.length; )
        this.textSpans[M].style.display = "none", M += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var r;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), r = this.svgElement.style;
          var a = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          r.transform = a, r.webkitTransform = a;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var s, c, u = 0, d = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
        c = h.length;
        var p, m, g;
        for (s = 0; s < c; s += 1)
          h[s].n ? u += 1 : (m = this.textSpans[s], g = this.textPaths[s], p = d[u], u += 1, p._mdf.m && (this.isMasked ? m.setAttribute("transform", p.m) : (m.style.webkitTransform = p.m, m.style.transform = p.m)), m.style.opacity = p.o, p.sw && p._mdf.sw && g.setAttribute("stroke-width", p.sw), p.sc && p._mdf.sc && g.setAttribute("stroke", p.sc), p.fc && p._mdf.fc && (g.setAttribute("fill", p.fc), g.style.color = p.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var v = this.innerElem.getBBox();
          this.currentBBox.w !== v.width && (this.currentBBox.w = v.width, this.svgElement.setAttribute("width", v.width)), this.currentBBox.h !== v.height && (this.currentBBox.h = v.height, this.svgElement.setAttribute("height", v.height));
          var y = 1;
          if (this.currentBBox.w !== v.width + y * 2 || this.currentBBox.h !== v.height + y * 2 || this.currentBBox.x !== v.x - y || this.currentBBox.y !== v.y - y) {
            this.currentBBox.w = v.width + y * 2, this.currentBBox.h = v.height + y * 2, this.currentBBox.x = v.x - y, this.currentBBox.y = v.y - y, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), r = this.svgElement.style;
            var x = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            r.transform = x, r.webkitTransform = x;
          }
        }
      }
    };
    function HCameraElement(r, a, s) {
      this.initFrame(), this.initBaseData(r, a, s), this.initHierarchy();
      var c = PropertyFactory.getProp;
      if (this.pe = c(this, r.pe, 0, 0, this), r.ks.p.s ? (this.px = c(this, r.ks.p.x, 1, 0, this), this.py = c(this, r.ks.p.y, 1, 0, this), this.pz = c(this, r.ks.p.z, 1, 0, this)) : this.p = c(this, r.ks.p, 1, 0, this), r.ks.a && (this.a = c(this, r.ks.a, 1, 0, this)), r.ks.or.k.length && r.ks.or.k[0].to) {
        var u, d = r.ks.or.k.length;
        for (u = 0; u < d; u += 1)
          r.ks.or.k[u].to = null, r.ks.or.k[u].ti = null;
      }
      this.or = c(this, r.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = c(this, r.ks.rx, 0, degToRads, this), this.ry = c(this, r.ks.ry, 0, degToRads, this), this.rz = c(this, r.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var r, a = this.comp.threeDElements.length, s, c, u;
      for (r = 0; r < a; r += 1)
        if (s = this.comp.threeDElements[r], s.type === "3d") {
          c = s.perspectiveElem.style, u = s.container.style;
          var d = this.pe.v + "px", h = "0px 0px 0px", p = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          c.perspective = d, c.webkitPerspective = d, u.transformOrigin = h, u.mozTransformOrigin = h, u.webkitTransformOrigin = h, c.transform = p, c.webkitTransform = p;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var r = this._isFirstFrame, a, s;
      if (this.hierarchy)
        for (s = this.hierarchy.length, a = 0; a < s; a += 1)
          r = this.hierarchy[a].finalTransform.mProp._mdf || r;
      if (r || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (s = this.hierarchy.length - 1, a = s; a >= 0; a -= 1) {
            var c = this.hierarchy[a].finalTransform.mProp;
            this.mat.translate(-c.p.v[0], -c.p.v[1], c.p.v[2]), this.mat.rotateX(-c.or.v[0]).rotateY(-c.or.v[1]).rotateZ(c.or.v[2]), this.mat.rotateX(-c.rx.v).rotateY(-c.ry.v).rotateZ(c.rz.v), this.mat.scale(1 / c.s.v[0], 1 / c.s.v[1], 1 / c.s.v[2]), this.mat.translate(c.a.v[0], c.a.v[1], c.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var u;
          this.p ? u = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : u = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var d = Math.sqrt(Math.pow(u[0], 2) + Math.pow(u[1], 2) + Math.pow(u[2], 2)), h = [u[0] / d, u[1] / d, u[2] / d], p = Math.sqrt(h[2] * h[2] + h[0] * h[0]), m = Math.atan2(h[1], p), g = Math.atan2(h[0], -h[2]);
          this.mat.rotateY(g).rotateX(-m);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var v = !this._prevMat.equals(this.mat);
        if ((v || this.pe._mdf) && this.comp.threeDElements) {
          s = this.comp.threeDElements.length;
          var y, x, w;
          for (a = 0; a < s; a += 1)
            if (y = this.comp.threeDElements[a], y.type === "3d") {
              if (v) {
                var S = this.mat.toCSS();
                w = y.container.style, w.transform = S, w.webkitTransform = S;
              }
              this.pe._mdf && (x = y.perspectiveElem.style, x.perspective = this.pe.v + "px", x.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(r) {
      this.prepareProperties(r, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(r, a, s) {
      this.assetData = a.getAssetData(r.refId), this.initElement(r, a, s);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var r = this.globalData.getAssetsPath(this.assetData), a = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(a), a.crossOrigin = "anonymous", a.src = r, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(r, a) {
      this.animationItem = r, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: a && a.className || "",
        imagePreserveAspectRatio: a && a.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(a && a.hideOnTransparent === !1),
        filterSize: {
          width: a && a.filterSize && a.filterSize.width || "400%",
          height: a && a.filterSize && a.filterSize.height || "400%",
          x: a && a.filterSize && a.filterSize.x || "-100%",
          y: a && a.filterSize && a.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var r = this.pendingElements.pop();
        r.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(r, a) {
      var s = r.getBaseElement();
      if (s) {
        var c = this.layers[a];
        if (!c.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(s, a);
          else {
            for (var u = 0, d, h, p; u < a; )
              this.elements[u] && this.elements[u] !== !0 && this.elements[u].getBaseElement && (h = this.elements[u], p = this.layers[u].ddd ? this.getThreeDContainerByPos(u) : h.getBaseElement(), d = p || d), u += 1;
            d ? (!c.ddd || !this.supports3d) && this.layerElement.insertBefore(s, d) : (!c.ddd || !this.supports3d) && this.layerElement.appendChild(s);
          }
        else
          this.addTo3dContainer(s, a);
      }
    }, HybridRendererBase.prototype.createShape = function(r) {
      return this.supports3d ? new HShapeElement(r, this.globalData, this) : new SVGShapeElement(r, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(r) {
      return this.supports3d ? new HTextElement(r, this.globalData, this) : new SVGTextLottieElement(r, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(r) {
      return this.camera = new HCameraElement(r, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(r) {
      return this.supports3d ? new HImageElement(r, this.globalData, this) : new IImageElement(r, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(r) {
      return this.supports3d ? new HSolidElement(r, this.globalData, this) : new ISolidElement(r, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(r) {
      for (var a = 0, s = this.threeDElements.length; a < s; ) {
        if (this.threeDElements[a].startPos <= r && this.threeDElements[a].endPos >= r)
          return this.threeDElements[a].perspectiveElem;
        a += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(r, a) {
      var s = createTag("div"), c, u;
      styleDiv(s);
      var d = createTag("div");
      if (styleDiv(d), a === "3d") {
        c = s.style, c.width = this.globalData.compSize.w + "px", c.height = this.globalData.compSize.h + "px";
        var h = "50% 50%";
        c.webkitTransformOrigin = h, c.mozTransformOrigin = h, c.transformOrigin = h, u = d.style;
        var p = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        u.transform = p, u.webkitTransform = p;
      }
      s.appendChild(d);
      var m = {
        container: d,
        perspectiveElem: s,
        startPos: r,
        endPos: r,
        type: a
      };
      return this.threeDElements.push(m), m;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var r, a = this.layers.length, s, c = "";
      for (r = 0; r < a; r += 1)
        this.layers[r].ddd && this.layers[r].ty !== 3 ? (c !== "3d" && (c = "3d", s = this.createThreeDContainer(r, "3d")), s.endPos = Math.max(s.endPos, r)) : (c !== "2d" && (c = "2d", s = this.createThreeDContainer(r, "2d")), s.endPos = Math.max(s.endPos, r));
      for (a = this.threeDElements.length, r = a - 1; r >= 0; r -= 1)
        this.resizerElem.appendChild(this.threeDElements[r].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(r, a) {
      for (var s = 0, c = this.threeDElements.length; s < c; ) {
        if (a <= this.threeDElements[s].endPos) {
          for (var u = this.threeDElements[s].startPos, d; u < a; )
            this.elements[u] && this.elements[u].getBaseElement && (d = this.elements[u].getBaseElement()), u += 1;
          d ? this.threeDElements[s].container.insertBefore(r, d) : this.threeDElements[s].container.appendChild(r);
          break;
        }
        s += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(r) {
      var a = createTag("div"), s = this.animationItem.wrapper, c = a.style;
      c.width = r.w + "px", c.height = r.h + "px", this.resizerElem = a, styleDiv(a), c.transformStyle = "flat", c.mozTransformStyle = "flat", c.webkitTransformStyle = "flat", this.renderConfig.className && a.setAttribute("class", this.renderConfig.className), s.appendChild(a), c.overflow = "hidden";
      var u = createNS("svg");
      u.setAttribute("width", "1"), u.setAttribute("height", "1"), styleDiv(u), this.resizerElem.appendChild(u);
      var d = createNS("defs");
      u.appendChild(d), this.data = r, this.setupGlobalData(r, u), this.globalData.defs = d, this.layers = r.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var r, a = this.layers ? this.layers.length : 0;
      for (r = 0; r < a; r += 1)
        this.elements[r] && this.elements[r].destroy && this.elements[r].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var r = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight, s = r / a, c = this.globalData.compSize.w / this.globalData.compSize.h, u, d, h, p;
      c > s ? (u = r / this.globalData.compSize.w, d = r / this.globalData.compSize.w, h = 0, p = (a - this.globalData.compSize.h * (r / this.globalData.compSize.w)) / 2) : (u = a / this.globalData.compSize.h, d = a / this.globalData.compSize.h, h = (r - this.globalData.compSize.w * (a / this.globalData.compSize.h)) / 2, p = 0);
      var m = this.resizerElem.style;
      m.webkitTransform = "matrix3d(" + u + ",0,0,0,0," + d + ",0,0,0,0,1,0," + h + "," + p + ",0,1)", m.transform = m.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var r = this.globalData.compSize.w, a = this.globalData.compSize.h, s, c = this.threeDElements.length;
        for (s = 0; s < c; s += 1) {
          var u = this.threeDElements[s].perspectiveElem.style;
          u.webkitPerspective = Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2)) + "px", u.perspective = u.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(r) {
      var a, s = r.length, c = createTag("div");
      for (a = 0; a < s; a += 1)
        if (r[a].xt) {
          var u = this.createComp(r[a], c, this.globalData.comp, null);
          u.initExpressions(), this.globalData.projectInterface.registerComposition(u);
        }
    };
    function HCompElement(r, a, s) {
      this.layers = r.layers, this.supports3d = !r.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(r, a, s), this.tm = r.tm ? PropertyFactory.getProp(this, r.tm, 0, a.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(r, a) {
      for (var s = 0, c; s < a; )
        this.elements[s] && this.elements[s].getBaseElement && (c = this.elements[s].getBaseElement()), s += 1;
      c ? this.layerElement.insertBefore(r, c) : this.layerElement.appendChild(r);
    }, HCompElement.prototype.createComp = function(r) {
      return this.supports3d ? new HCompElement(r, this.globalData, this) : new SVGCompElement(r, this.globalData, this);
    };
    function HybridRenderer(r, a) {
      this.animationItem = r, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: a && a.className || "",
        imagePreserveAspectRatio: a && a.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(a && a.hideOnTransparent === !1),
        filterSize: {
          width: a && a.filterSize && a.filterSize.width || "400%",
          height: a && a.filterSize && a.filterSize.height || "400%",
          x: a && a.filterSize && a.filterSize.x || "-100%",
          y: a && a.filterSize && a.filterSize.y || "-100%"
        },
        runExpressions: !a || a.runExpressions === void 0 || a.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(r) {
      return this.supports3d ? new HCompElement(r, this.globalData, this) : new SVGCompElement(r, this.globalData, this);
    };
    var CompExpressionInterface = /* @__PURE__ */ function() {
      return function(r) {
        function a(s) {
          for (var c = 0, u = r.layers.length; c < u; ) {
            if (r.layers[c].nm === s || r.layers[c].ind === s)
              return r.elements[c].layerInterface;
            c += 1;
          }
          return null;
        }
        return Object.defineProperty(a, "_name", {
          value: r.data.nm
        }), a.layer = a, a.pixelAspect = 1, a.height = r.data.h || r.globalData.compSize.h, a.width = r.data.w || r.globalData.compSize.w, a.pixelAspect = 1, a.frameDuration = 1 / r.globalData.frameRate, a.displayStartTime = 0, a.numLayers = r.layers.length, a;
      };
    }();
    function _typeof$2(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(s) {
        return typeof s;
      } : _typeof$2 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$2(r);
    }
    function seedRandom(r, a) {
      var s = this, c = 256, u = 6, d = 52, h = "random", p = a.pow(c, u), m = a.pow(2, d), g = m * 2, v = c - 1, y;
      function x(T, E, R) {
        var A = [];
        E = E === !0 ? {
          entropy: !0
        } : E || {};
        var k = P(M(E.entropy ? [T, I(r)] : T === null ? L() : T, 3), A), V = new w(A), B = function() {
          for (var z = V.g(u), Z = p, G = 0; z < m; )
            z = (z + G) * c, Z *= c, G = V.g(1);
          for (; z >= g; )
            z /= 2, Z /= 2, G >>>= 1;
          return (z + G) / Z;
        };
        return B.int32 = function() {
          return V.g(4) | 0;
        }, B.quick = function() {
          return V.g(4) / 4294967296;
        }, B.double = B, P(I(V.S), r), (E.pass || R || function(q, z, Z, G) {
          return G && (G.S && S(G, V), q.state = function() {
            return S(V, {});
          }), Z ? (a[h] = q, z) : q;
        })(B, k, "global" in E ? E.global : this == a, E.state);
      }
      a["seed" + h] = x;
      function w(T) {
        var E, R = T.length, A = this, k = 0, V = A.i = A.j = 0, B = A.S = [];
        for (R || (T = [R++]); k < c; )
          B[k] = k++;
        for (k = 0; k < c; k++)
          B[k] = B[V = v & V + T[k % R] + (E = B[k])], B[V] = E;
        A.g = function(q) {
          for (var z, Z = 0, G = A.i, K = A.j, U = A.S; q--; )
            z = U[G = v & G + 1], Z = Z * c + U[v & (U[G] = U[K = v & K + z]) + (U[K] = z)];
          return A.i = G, A.j = K, Z;
        };
      }
      function S(T, E) {
        return E.i = T.i, E.j = T.j, E.S = T.S.slice(), E;
      }
      function M(T, E) {
        var R = [], A = _typeof$2(T), k;
        if (E && A == "object")
          for (k in T)
            try {
              R.push(M(T[k], E - 1));
            } catch {
            }
        return R.length ? R : A == "string" ? T : T + "\0";
      }
      function P(T, E) {
        for (var R = T + "", A, k = 0; k < R.length; )
          E[v & k] = v & (A ^= E[v & k] * 19) + R.charCodeAt(k++);
        return I(E);
      }
      function L() {
        try {
          var T = new Uint8Array(c);
          return (s.crypto || s.msCrypto).getRandomValues(T), I(T);
        } catch {
          var E = s.navigator, R = E && E.plugins;
          return [+/* @__PURE__ */ new Date(), s, R, s.screen, I(r)];
        }
      }
      function I(T) {
        return String.fromCharCode.apply(0, T);
      }
      P(a.random(), r);
    }
    function initialize$2(r) {
      seedRandom([], r);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(s) {
        return typeof s;
      } : _typeof$1 = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof$1(r);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(r) {
        return r.constructor === Array || r.constructor === Float32Array;
      }
      function isNumerable(r, a) {
        return r === "number" || a instanceof Number || r === "boolean" || r === "string";
      }
      function $bm_neg(r) {
        var a = _typeof$1(r);
        if (a === "number" || r instanceof Number || a === "boolean")
          return -r;
        if ($bm_isInstanceOfArray(r)) {
          var s, c = r.length, u = [];
          for (s = 0; s < c; s += 1)
            u[s] = -r[s];
          return u;
        }
        return r.propType ? r.v : -r;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(r, a) {
        var s = _typeof$1(r), c = _typeof$1(a);
        if (isNumerable(s, r) && isNumerable(c, a) || s === "string" || c === "string")
          return r + a;
        if ($bm_isInstanceOfArray(r) && isNumerable(c, a))
          return r = r.slice(0), r[0] += a, r;
        if (isNumerable(s, r) && $bm_isInstanceOfArray(a))
          return a = a.slice(0), a[0] = r + a[0], a;
        if ($bm_isInstanceOfArray(r) && $bm_isInstanceOfArray(a)) {
          for (var u = 0, d = r.length, h = a.length, p = []; u < d || u < h; )
            (typeof r[u] == "number" || r[u] instanceof Number) && (typeof a[u] == "number" || a[u] instanceof Number) ? p[u] = r[u] + a[u] : p[u] = a[u] === void 0 ? r[u] : r[u] || a[u], u += 1;
          return p;
        }
        return 0;
      }
      var add = sum;
      function sub(r, a) {
        var s = _typeof$1(r), c = _typeof$1(a);
        if (isNumerable(s, r) && isNumerable(c, a))
          return s === "string" && (r = parseInt(r, 10)), c === "string" && (a = parseInt(a, 10)), r - a;
        if ($bm_isInstanceOfArray(r) && isNumerable(c, a))
          return r = r.slice(0), r[0] -= a, r;
        if (isNumerable(s, r) && $bm_isInstanceOfArray(a))
          return a = a.slice(0), a[0] = r - a[0], a;
        if ($bm_isInstanceOfArray(r) && $bm_isInstanceOfArray(a)) {
          for (var u = 0, d = r.length, h = a.length, p = []; u < d || u < h; )
            (typeof r[u] == "number" || r[u] instanceof Number) && (typeof a[u] == "number" || a[u] instanceof Number) ? p[u] = r[u] - a[u] : p[u] = a[u] === void 0 ? r[u] : r[u] || a[u], u += 1;
          return p;
        }
        return 0;
      }
      function mul(r, a) {
        var s = _typeof$1(r), c = _typeof$1(a), u;
        if (isNumerable(s, r) && isNumerable(c, a))
          return r * a;
        var d, h;
        if ($bm_isInstanceOfArray(r) && isNumerable(c, a)) {
          for (h = r.length, u = createTypedArray("float32", h), d = 0; d < h; d += 1)
            u[d] = r[d] * a;
          return u;
        }
        if (isNumerable(s, r) && $bm_isInstanceOfArray(a)) {
          for (h = a.length, u = createTypedArray("float32", h), d = 0; d < h; d += 1)
            u[d] = r * a[d];
          return u;
        }
        return 0;
      }
      function div(r, a) {
        var s = _typeof$1(r), c = _typeof$1(a), u;
        if (isNumerable(s, r) && isNumerable(c, a))
          return r / a;
        var d, h;
        if ($bm_isInstanceOfArray(r) && isNumerable(c, a)) {
          for (h = r.length, u = createTypedArray("float32", h), d = 0; d < h; d += 1)
            u[d] = r[d] / a;
          return u;
        }
        if (isNumerable(s, r) && $bm_isInstanceOfArray(a)) {
          for (h = a.length, u = createTypedArray("float32", h), d = 0; d < h; d += 1)
            u[d] = r / a[d];
          return u;
        }
        return 0;
      }
      function mod(r, a) {
        return typeof r == "string" && (r = parseInt(r, 10)), typeof a == "string" && (a = parseInt(a, 10)), r % a;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(r, a, s) {
        if (a > s) {
          var c = s;
          s = a, a = c;
        }
        return Math.min(Math.max(r, a), s);
      }
      function radiansToDegrees(r) {
        return r / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(r) {
        return r * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(r, a) {
        if (typeof r == "number" || r instanceof Number)
          return a = a || 0, Math.abs(r - a);
        a || (a = helperLengthArray);
        var s, c = Math.min(r.length, a.length), u = 0;
        for (s = 0; s < c; s += 1)
          u += Math.pow(a[s] - r[s], 2);
        return Math.sqrt(u);
      }
      function normalize(r) {
        return div(r, length(r));
      }
      function rgbToHsl(r) {
        var a = r[0], s = r[1], c = r[2], u = Math.max(a, s, c), d = Math.min(a, s, c), h, p, m = (u + d) / 2;
        if (u === d)
          h = 0, p = 0;
        else {
          var g = u - d;
          switch (p = m > 0.5 ? g / (2 - u - d) : g / (u + d), u) {
            case a:
              h = (s - c) / g + (s < c ? 6 : 0);
              break;
            case s:
              h = (c - a) / g + 2;
              break;
            case c:
              h = (a - s) / g + 4;
              break;
          }
          h /= 6;
        }
        return [h, p, m, r[3]];
      }
      function hue2rgb(r, a, s) {
        return s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? r + (a - r) * 6 * s : s < 1 / 2 ? a : s < 2 / 3 ? r + (a - r) * (2 / 3 - s) * 6 : r;
      }
      function hslToRgb(r) {
        var a = r[0], s = r[1], c = r[2], u, d, h;
        if (s === 0)
          u = c, h = c, d = c;
        else {
          var p = c < 0.5 ? c * (1 + s) : c + s - c * s, m = 2 * c - p;
          u = hue2rgb(m, p, a + 1 / 3), d = hue2rgb(m, p, a), h = hue2rgb(m, p, a - 1 / 3);
        }
        return [u, d, h, r[3]];
      }
      function linear(r, a, s, c, u) {
        if ((c === void 0 || u === void 0) && (c = a, u = s, a = 0, s = 1), s < a) {
          var d = s;
          s = a, a = d;
        }
        if (r <= a)
          return c;
        if (r >= s)
          return u;
        var h = s === a ? 0 : (r - a) / (s - a);
        if (!c.length)
          return c + (u - c) * h;
        var p, m = c.length, g = createTypedArray("float32", m);
        for (p = 0; p < m; p += 1)
          g[p] = c[p] + (u[p] - c[p]) * h;
        return g;
      }
      function random(r, a) {
        if (a === void 0 && (r === void 0 ? (r = 0, a = 1) : (a = r, r = void 0)), a.length) {
          var s, c = a.length;
          r || (r = createTypedArray("float32", c));
          var u = createTypedArray("float32", c), d = BMMath.random();
          for (s = 0; s < c; s += 1)
            u[s] = r[s] + d * (a[s] - r[s]);
          return u;
        }
        r === void 0 && (r = 0);
        var h = BMMath.random();
        return r + h * (a - r);
      }
      function createPath(r, a, s, c) {
        var u, d = r.length, h = shapePool.newElement();
        h.setPathData(!!c, d);
        var p = [0, 0], m, g;
        for (u = 0; u < d; u += 1)
          m = a && a[u] ? a[u] : p, g = s && s[u] ? s[u] : p, h.setTripleAt(r[u][0], r[u][1], g[0] + r[u][0], g[1] + r[u][1], m[0] + r[u][0], m[1] + r[u][1], u, !0);
        return h;
      }
      function initiateExpression(elem, data, property) {
        function noOp(r) {
          return r;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function r(a, s) {
          var c, u, d = this.pv.length ? this.pv.length : 1, h = createTypedArray("float32", d);
          a = 5;
          var p = Math.floor(time * a);
          for (c = 0, u = 0; c < p; ) {
            for (u = 0; u < d; u += 1)
              h[u] += -s + s * 2 * BMMath.random();
            c += 1;
          }
          var m = time * a, g = m - Math.floor(m), v = createTypedArray("float32", d);
          if (d > 1) {
            for (u = 0; u < d; u += 1)
              v[u] = this.pv[u] + h[u] + (-s + s * 2 * BMMath.random()) * g;
            return v;
          }
          return this.pv + h[0] + (-s + s * 2 * BMMath.random()) * g;
        }).bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(r, a) {
          return loopIn(r, a, !0);
        }
        function loopOutDuration(r, a) {
          return loopOut(r, a, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(r, a) {
          var s = [a[0] - r[0], a[1] - r[1], a[2] - r[2]], c = Math.atan2(s[0], Math.sqrt(s[1] * s[1] + s[2] * s[2])) / degToRads, u = -Math.atan2(s[1], s[2]) / degToRads;
          return [u, c, 0];
        }
        function easeOut(r, a, s, c, u) {
          return applyEase(easeOutBez, r, a, s, c, u);
        }
        function easeIn(r, a, s, c, u) {
          return applyEase(easeInBez, r, a, s, c, u);
        }
        function ease(r, a, s, c, u) {
          return applyEase(easeInOutBez, r, a, s, c, u);
        }
        function applyEase(r, a, s, c, u, d) {
          u === void 0 ? (u = s, d = c) : a = (a - s) / (c - s), a > 1 ? a = 1 : a < 0 && (a = 0);
          var h = r(a);
          if ($bm_isInstanceOfArray(u)) {
            var p, m = u.length, g = createTypedArray("float32", m);
            for (p = 0; p < m; p += 1)
              g[p] = (d[p] - u[p]) * h + u[p];
            return g;
          }
          return (d - u) * h + u;
        }
        function nearestKey(r) {
          var a, s = data.k.length, c, u;
          if (!data.k.length || typeof data.k[0] == "number")
            c = 0, u = 0;
          else if (c = -1, r *= elem.comp.globalData.frameRate, r < data.k[0].t)
            c = 1, u = data.k[0].t;
          else {
            for (a = 0; a < s - 1; a += 1)
              if (r === data.k[a].t) {
                c = a + 1, u = data.k[a].t;
                break;
              } else if (r > data.k[a].t && r < data.k[a + 1].t) {
                r - data.k[a].t > data.k[a + 1].t - r ? (c = a + 2, u = data.k[a + 1].t) : (c = a + 1, u = data.k[a].t);
                break;
              }
            c === -1 && (c = a + 1, u = data.k[a].t);
          }
          var d = {};
          return d.index = c, d.time = u / elem.comp.globalData.frameRate, d;
        }
        function key(r) {
          var a, s, c;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + r);
          r -= 1, a = {
            time: data.k[r].t / elem.comp.globalData.frameRate,
            value: []
          };
          var u = Object.prototype.hasOwnProperty.call(data.k[r], "s") ? data.k[r].s : data.k[r - 1].e;
          for (c = u.length, s = 0; s < c; s += 1)
            a[s] = u[s], a.value[s] = u[s];
          return a;
        }
        function framesToTime(r, a) {
          return a || (a = elem.comp.globalData.frameRate), r / a;
        }
        function timeToFrames(r, a) {
          return !r && r !== 0 && (r = time), a || (a = elem.comp.globalData.frameRate), r * a;
        }
        function seedRandom(r) {
          BMMath.seedrandom(randSeed + r);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(r, a) {
          return typeof value == "string" ? a === void 0 ? value.substring(r) : value.substring(r, a) : "";
        }
        function substr(r, a) {
          return typeof value == "string" ? a === void 0 ? value.substr(r) : value.substr(r, a) : "";
        }
        function posterizeTime(r) {
          time = r === 0 ? 0 : Math.floor(time * r) / r, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(r) {
          return value = r, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var r = {};
      r.initExpressions = a, r.resetFrame = ExpressionManager.resetFrame;
      function a(s) {
        var c = 0, u = [];
        function d() {
          c += 1;
        }
        function h() {
          c -= 1, c === 0 && m();
        }
        function p(g) {
          u.indexOf(g) === -1 && u.push(g);
        }
        function m() {
          var g, v = u.length;
          for (g = 0; g < v; g += 1)
            u[g].release();
          u.length = 0;
        }
        s.renderer.compInterface = CompExpressionInterface(s.renderer), s.renderer.globalData.projectInterface.registerComposition(s.renderer), s.renderer.globalData.pushExpression = d, s.renderer.globalData.popExpression = h, s.renderer.globalData.registerExpressionProperty = p;
      }
      return r;
    }(), MaskManagerInterface = function() {
      function r(s, c) {
        this._mask = s, this._data = c;
      }
      Object.defineProperty(r.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(r.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var a = function(c) {
        var u = createSizedArray(c.viewData.length), d, h = c.viewData.length;
        for (d = 0; d < h; d += 1)
          u[d] = new r(c.viewData[d], c.masksProperties[d]);
        var p = function(g) {
          for (d = 0; d < h; ) {
            if (c.masksProperties[d].nm === g)
              return u[d];
            d += 1;
          }
          return null;
        };
        return p;
      };
      return a;
    }(), ExpressionPropertyInterface = /* @__PURE__ */ function() {
      var r = {
        pv: 0,
        v: 0,
        mult: 1
      }, a = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function s(h, p, m) {
        Object.defineProperty(h, "velocity", {
          get: function() {
            return p.getVelocityAtTime(p.comp.currentFrame);
          }
        }), h.numKeys = p.keyframes ? p.keyframes.length : 0, h.key = function(g) {
          if (!h.numKeys)
            return 0;
          var v = "";
          "s" in p.keyframes[g - 1] ? v = p.keyframes[g - 1].s : "e" in p.keyframes[g - 2] ? v = p.keyframes[g - 2].e : v = p.keyframes[g - 2].s;
          var y = m === "unidimensional" ? new Number(v) : Object.assign({}, v);
          return y.time = p.keyframes[g - 1].t / p.elem.comp.globalData.frameRate, y.value = m === "unidimensional" ? v[0] : v, y;
        }, h.valueAtTime = p.getValueAtTime, h.speedAtTime = p.getSpeedAtTime, h.velocityAtTime = p.getVelocityAtTime, h.propertyGroup = p.propertyGroup;
      }
      function c(h) {
        (!h || !("pv" in h)) && (h = r);
        var p = 1 / h.mult, m = h.pv * p, g = new Number(m);
        return g.value = m, s(g, h, "unidimensional"), function() {
          return h.k && h.getValue(), m = h.v * p, g.value !== m && (g = new Number(m), g.value = m, s(g, h, "unidimensional")), g;
        };
      }
      function u(h) {
        (!h || !("pv" in h)) && (h = a);
        var p = 1 / h.mult, m = h.data && h.data.l || h.pv.length, g = createTypedArray("float32", m), v = createTypedArray("float32", m);
        return g.value = v, s(g, h, "multidimensional"), function() {
          h.k && h.getValue();
          for (var y = 0; y < m; y += 1)
            v[y] = h.v[y] * p, g[y] = v[y];
          return g;
        };
      }
      function d() {
        return r;
      }
      return function(h) {
        return h ? h.propType === "unidimensional" ? c(h) : u(h) : d;
      };
    }(), TransformExpressionInterface = /* @__PURE__ */ function() {
      return function(r) {
        function a(h) {
          switch (h) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return a.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return a.rotation;
            case "ADBE Rotate X":
              return a.xRotation;
            case "ADBE Rotate Y":
              return a.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return a.position;
            case "ADBE Position_0":
              return a.xPosition;
            case "ADBE Position_1":
              return a.yPosition;
            case "ADBE Position_2":
              return a.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return a.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return a.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(a, "rotation", {
          get: ExpressionPropertyInterface(r.r || r.rz)
        }), Object.defineProperty(a, "zRotation", {
          get: ExpressionPropertyInterface(r.rz || r.r)
        }), Object.defineProperty(a, "xRotation", {
          get: ExpressionPropertyInterface(r.rx)
        }), Object.defineProperty(a, "yRotation", {
          get: ExpressionPropertyInterface(r.ry)
        }), Object.defineProperty(a, "scale", {
          get: ExpressionPropertyInterface(r.s)
        });
        var s, c, u, d;
        return r.p ? d = ExpressionPropertyInterface(r.p) : (s = ExpressionPropertyInterface(r.px), c = ExpressionPropertyInterface(r.py), r.pz && (u = ExpressionPropertyInterface(r.pz))), Object.defineProperty(a, "position", {
          get: function() {
            return r.p ? d() : [s(), c(), u ? u() : 0];
          }
        }), Object.defineProperty(a, "xPosition", {
          get: ExpressionPropertyInterface(r.px)
        }), Object.defineProperty(a, "yPosition", {
          get: ExpressionPropertyInterface(r.py)
        }), Object.defineProperty(a, "zPosition", {
          get: ExpressionPropertyInterface(r.pz)
        }), Object.defineProperty(a, "anchorPoint", {
          get: ExpressionPropertyInterface(r.a)
        }), Object.defineProperty(a, "opacity", {
          get: ExpressionPropertyInterface(r.o)
        }), Object.defineProperty(a, "skew", {
          get: ExpressionPropertyInterface(r.sk)
        }), Object.defineProperty(a, "skewAxis", {
          get: ExpressionPropertyInterface(r.sa)
        }), Object.defineProperty(a, "orientation", {
          get: ExpressionPropertyInterface(r.or)
        }), a;
      };
    }(), LayerExpressionInterface = /* @__PURE__ */ function() {
      function r(g) {
        var v = new Matrix();
        if (g !== void 0) {
          var y = this._elem.finalTransform.mProp.getValueAtTime(g);
          y.clone(v);
        } else {
          var x = this._elem.finalTransform.mProp;
          x.applyToMatrix(v);
        }
        return v;
      }
      function a(g, v) {
        var y = this.getMatrix(v);
        return y.props[12] = 0, y.props[13] = 0, y.props[14] = 0, this.applyPoint(y, g);
      }
      function s(g, v) {
        var y = this.getMatrix(v);
        return this.applyPoint(y, g);
      }
      function c(g, v) {
        var y = this.getMatrix(v);
        return y.props[12] = 0, y.props[13] = 0, y.props[14] = 0, this.invertPoint(y, g);
      }
      function u(g, v) {
        var y = this.getMatrix(v);
        return this.invertPoint(y, g);
      }
      function d(g, v) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var y, x = this._elem.hierarchy.length;
          for (y = 0; y < x; y += 1)
            this._elem.hierarchy[y].finalTransform.mProp.applyToMatrix(g);
        }
        return g.applyToPointArray(v[0], v[1], v[2] || 0);
      }
      function h(g, v) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var y, x = this._elem.hierarchy.length;
          for (y = 0; y < x; y += 1)
            this._elem.hierarchy[y].finalTransform.mProp.applyToMatrix(g);
        }
        return g.inversePoint(v);
      }
      function p(g) {
        var v = new Matrix();
        if (v.reset(), this._elem.finalTransform.mProp.applyToMatrix(v), this._elem.hierarchy && this._elem.hierarchy.length) {
          var y, x = this._elem.hierarchy.length;
          for (y = 0; y < x; y += 1)
            this._elem.hierarchy[y].finalTransform.mProp.applyToMatrix(v);
          return v.inversePoint(g);
        }
        return v.inversePoint(g);
      }
      function m() {
        return [1, 1, 1, 1];
      }
      return function(g) {
        var v;
        function y(M) {
          w.mask = new MaskManagerInterface(M, g);
        }
        function x(M) {
          w.effect = M;
        }
        function w(M) {
          switch (M) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return w.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return v;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return w.effect;
            case "ADBE Text Properties":
              return w.textInterface;
            default:
              return null;
          }
        }
        w.getMatrix = r, w.invertPoint = h, w.applyPoint = d, w.toWorld = s, w.toWorldVec = a, w.fromWorld = u, w.fromWorldVec = c, w.toComp = s, w.fromComp = p, w.sampleImage = m, w.sourceRectAtTime = g.sourceRectAtTime.bind(g), w._elem = g, v = TransformExpressionInterface(g.finalTransform.mProp);
        var S = getDescriptor(v, "anchorPoint");
        return Object.defineProperties(w, {
          hasParent: {
            get: function() {
              return g.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return g.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(v, "rotation"),
          scale: getDescriptor(v, "scale"),
          position: getDescriptor(v, "position"),
          opacity: getDescriptor(v, "opacity"),
          anchorPoint: S,
          anchor_point: S,
          transform: {
            get: function() {
              return v;
            }
          },
          active: {
            get: function() {
              return g.isInRange;
            }
          }
        }), w.startTime = g.data.st, w.index = g.data.ind, w.source = g.data.refId, w.height = g.data.ty === 0 ? g.data.h : 100, w.width = g.data.ty === 0 ? g.data.w : 100, w.inPoint = g.data.ip / g.comp.globalData.frameRate, w.outPoint = g.data.op / g.comp.globalData.frameRate, w._name = g.data.nm, w.registerMaskInterface = y, w.registerEffectsInterface = x, w;
      };
    }(), propertyGroupFactory = /* @__PURE__ */ function() {
      return function(r, a) {
        return function(s) {
          return s = s === void 0 ? 1 : s, s <= 0 ? r : a(s - 1);
        };
      };
    }(), PropertyInterface = /* @__PURE__ */ function() {
      return function(r, a) {
        var s = {
          _name: r
        };
        function c(u) {
          return u = u === void 0 ? 1 : u, u <= 0 ? s : a(u - 1);
        }
        return c;
      };
    }(), EffectsExpressionInterface = /* @__PURE__ */ function() {
      var r = {
        createEffectsInterface: a
      };
      function a(u, d) {
        if (u.effectsManager) {
          var h = [], p = u.data.ef, m, g = u.effectsManager.effectElements.length;
          for (m = 0; m < g; m += 1)
            h.push(s(p[m], u.effectsManager.effectElements[m], d, u));
          var v = u.data.ef || [], y = function(w) {
            for (m = 0, g = v.length; m < g; ) {
              if (w === v[m].nm || w === v[m].mn || w === v[m].ix)
                return h[m];
              m += 1;
            }
            return null;
          };
          return Object.defineProperty(y, "numProperties", {
            get: function() {
              return v.length;
            }
          }), y;
        }
        return null;
      }
      function s(u, d, h, p) {
        function m(w) {
          for (var S = u.ef, M = 0, P = S.length; M < P; ) {
            if (w === S[M].nm || w === S[M].mn || w === S[M].ix)
              return S[M].ty === 5 ? v[M] : v[M]();
            M += 1;
          }
          throw new Error();
        }
        var g = propertyGroupFactory(m, h), v = [], y, x = u.ef.length;
        for (y = 0; y < x; y += 1)
          u.ef[y].ty === 5 ? v.push(s(u.ef[y], d.effectElements[y], d.effectElements[y].propertyGroup, p)) : v.push(c(d.effectElements[y], u.ef[y].ty, p, g));
        return u.mn === "ADBE Color Control" && Object.defineProperty(m, "color", {
          get: function() {
            return v[0]();
          }
        }), Object.defineProperties(m, {
          numProperties: {
            get: function() {
              return u.np;
            }
          },
          _name: {
            value: u.nm
          },
          propertyGroup: {
            value: g
          }
        }), m.enabled = u.en !== 0, m.active = m.enabled, m;
      }
      function c(u, d, h, p) {
        var m = ExpressionPropertyInterface(u.p);
        function g() {
          return d === 10 ? h.comp.compInterface(u.p.v) : m();
        }
        return u.p.setGroupProperty && u.p.setGroupProperty(PropertyInterface("", p)), g;
      }
      return r;
    }(), ShapePathInterface = /* @__PURE__ */ function() {
      return function(a, s, c) {
        var u = s.sh;
        function d(p) {
          return p === "Shape" || p === "shape" || p === "Path" || p === "path" || p === "ADBE Vector Shape" || p === 2 ? d.path : null;
        }
        var h = propertyGroupFactory(d, c);
        return u.setGroupProperty(PropertyInterface("Path", h)), Object.defineProperties(d, {
          path: {
            get: function() {
              return u.k && u.getValue(), u;
            }
          },
          shape: {
            get: function() {
              return u.k && u.getValue(), u;
            }
          },
          _name: {
            value: a.nm
          },
          ix: {
            value: a.ix
          },
          propertyIndex: {
            value: a.ix
          },
          mn: {
            value: a.mn
          },
          propertyGroup: {
            value: c
          }
        }), d;
      };
    }(), ShapeExpressionInterface = /* @__PURE__ */ function() {
      function r(S, M, P) {
        var L = [], I, T = S ? S.length : 0;
        for (I = 0; I < T; I += 1)
          S[I].ty === "gr" ? L.push(s(S[I], M[I], P)) : S[I].ty === "fl" ? L.push(c(S[I], M[I], P)) : S[I].ty === "st" ? L.push(h(S[I], M[I], P)) : S[I].ty === "tm" ? L.push(p(S[I], M[I], P)) : S[I].ty === "tr" || (S[I].ty === "el" ? L.push(g(S[I], M[I], P)) : S[I].ty === "sr" ? L.push(v(S[I], M[I], P)) : S[I].ty === "sh" ? L.push(ShapePathInterface(S[I], M[I], P)) : S[I].ty === "rc" ? L.push(y(S[I], M[I], P)) : S[I].ty === "rd" ? L.push(x(S[I], M[I], P)) : S[I].ty === "rp" ? L.push(w(S[I], M[I], P)) : S[I].ty === "gf" ? L.push(u(S[I], M[I], P)) : L.push(d(S[I], M[I])));
        return L;
      }
      function a(S, M, P) {
        var L, I = function(R) {
          for (var A = 0, k = L.length; A < k; ) {
            if (L[A]._name === R || L[A].mn === R || L[A].propertyIndex === R || L[A].ix === R || L[A].ind === R)
              return L[A];
            A += 1;
          }
          return typeof R == "number" ? L[R - 1] : null;
        };
        I.propertyGroup = propertyGroupFactory(I, P), L = r(S.it, M.it, I.propertyGroup), I.numProperties = L.length;
        var T = m(S.it[S.it.length - 1], M.it[M.it.length - 1], I.propertyGroup);
        return I.transform = T, I.propertyIndex = S.cix, I._name = S.nm, I;
      }
      function s(S, M, P) {
        var L = function(R) {
          switch (R) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return L.content;
            default:
              return L.transform;
          }
        };
        L.propertyGroup = propertyGroupFactory(L, P);
        var I = a(S, M, L.propertyGroup), T = m(S.it[S.it.length - 1], M.it[M.it.length - 1], L.propertyGroup);
        return L.content = I, L.transform = T, Object.defineProperty(L, "_name", {
          get: function() {
            return S.nm;
          }
        }), L.numProperties = S.np, L.propertyIndex = S.ix, L.nm = S.nm, L.mn = S.mn, L;
      }
      function c(S, M, P) {
        function L(I) {
          return I === "Color" || I === "color" ? L.color : I === "Opacity" || I === "opacity" ? L.opacity : null;
        }
        return Object.defineProperties(L, {
          color: {
            get: ExpressionPropertyInterface(M.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(M.o)
          },
          _name: {
            value: S.nm
          },
          mn: {
            value: S.mn
          }
        }), M.c.setGroupProperty(PropertyInterface("Color", P)), M.o.setGroupProperty(PropertyInterface("Opacity", P)), L;
      }
      function u(S, M, P) {
        function L(I) {
          return I === "Start Point" || I === "start point" ? L.startPoint : I === "End Point" || I === "end point" ? L.endPoint : I === "Opacity" || I === "opacity" ? L.opacity : null;
        }
        return Object.defineProperties(L, {
          startPoint: {
            get: ExpressionPropertyInterface(M.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(M.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(M.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: S.nm
          },
          mn: {
            value: S.mn
          }
        }), M.s.setGroupProperty(PropertyInterface("Start Point", P)), M.e.setGroupProperty(PropertyInterface("End Point", P)), M.o.setGroupProperty(PropertyInterface("Opacity", P)), L;
      }
      function d() {
        function S() {
          return null;
        }
        return S;
      }
      function h(S, M, P) {
        var L = propertyGroupFactory(k, P), I = propertyGroupFactory(A, L);
        function T(V) {
          Object.defineProperty(A, S.d[V].nm, {
            get: ExpressionPropertyInterface(M.d.dataProps[V].p)
          });
        }
        var E, R = S.d ? S.d.length : 0, A = {};
        for (E = 0; E < R; E += 1)
          T(E), M.d.dataProps[E].p.setGroupProperty(I);
        function k(V) {
          return V === "Color" || V === "color" ? k.color : V === "Opacity" || V === "opacity" ? k.opacity : V === "Stroke Width" || V === "stroke width" ? k.strokeWidth : null;
        }
        return Object.defineProperties(k, {
          color: {
            get: ExpressionPropertyInterface(M.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(M.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(M.w)
          },
          dash: {
            get: function() {
              return A;
            }
          },
          _name: {
            value: S.nm
          },
          mn: {
            value: S.mn
          }
        }), M.c.setGroupProperty(PropertyInterface("Color", L)), M.o.setGroupProperty(PropertyInterface("Opacity", L)), M.w.setGroupProperty(PropertyInterface("Stroke Width", L)), k;
      }
      function p(S, M, P) {
        function L(T) {
          return T === S.e.ix || T === "End" || T === "end" ? L.end : T === S.s.ix ? L.start : T === S.o.ix ? L.offset : null;
        }
        var I = propertyGroupFactory(L, P);
        return L.propertyIndex = S.ix, M.s.setGroupProperty(PropertyInterface("Start", I)), M.e.setGroupProperty(PropertyInterface("End", I)), M.o.setGroupProperty(PropertyInterface("Offset", I)), L.propertyIndex = S.ix, L.propertyGroup = P, Object.defineProperties(L, {
          start: {
            get: ExpressionPropertyInterface(M.s)
          },
          end: {
            get: ExpressionPropertyInterface(M.e)
          },
          offset: {
            get: ExpressionPropertyInterface(M.o)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      function m(S, M, P) {
        function L(T) {
          return S.a.ix === T || T === "Anchor Point" ? L.anchorPoint : S.o.ix === T || T === "Opacity" ? L.opacity : S.p.ix === T || T === "Position" ? L.position : S.r.ix === T || T === "Rotation" || T === "ADBE Vector Rotation" ? L.rotation : S.s.ix === T || T === "Scale" ? L.scale : S.sk && S.sk.ix === T || T === "Skew" ? L.skew : S.sa && S.sa.ix === T || T === "Skew Axis" ? L.skewAxis : null;
        }
        var I = propertyGroupFactory(L, P);
        return M.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", I)), M.transform.mProps.p.setGroupProperty(PropertyInterface("Position", I)), M.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", I)), M.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", I)), M.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", I)), M.transform.mProps.sk && (M.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", I)), M.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", I))), M.transform.op.setGroupProperty(PropertyInterface("Opacity", I)), Object.defineProperties(L, {
          opacity: {
            get: ExpressionPropertyInterface(M.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(M.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(M.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(M.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(M.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(M.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(M.transform.mProps.sa)
          },
          _name: {
            value: S.nm
          }
        }), L.ty = "tr", L.mn = S.mn, L.propertyGroup = P, L;
      }
      function g(S, M, P) {
        function L(E) {
          return S.p.ix === E ? L.position : S.s.ix === E ? L.size : null;
        }
        var I = propertyGroupFactory(L, P);
        L.propertyIndex = S.ix;
        var T = M.sh.ty === "tm" ? M.sh.prop : M.sh;
        return T.s.setGroupProperty(PropertyInterface("Size", I)), T.p.setGroupProperty(PropertyInterface("Position", I)), Object.defineProperties(L, {
          size: {
            get: ExpressionPropertyInterface(T.s)
          },
          position: {
            get: ExpressionPropertyInterface(T.p)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      function v(S, M, P) {
        function L(E) {
          return S.p.ix === E ? L.position : S.r.ix === E ? L.rotation : S.pt.ix === E ? L.points : S.or.ix === E || E === "ADBE Vector Star Outer Radius" ? L.outerRadius : S.os.ix === E ? L.outerRoundness : S.ir && (S.ir.ix === E || E === "ADBE Vector Star Inner Radius") ? L.innerRadius : S.is && S.is.ix === E ? L.innerRoundness : null;
        }
        var I = propertyGroupFactory(L, P), T = M.sh.ty === "tm" ? M.sh.prop : M.sh;
        return L.propertyIndex = S.ix, T.or.setGroupProperty(PropertyInterface("Outer Radius", I)), T.os.setGroupProperty(PropertyInterface("Outer Roundness", I)), T.pt.setGroupProperty(PropertyInterface("Points", I)), T.p.setGroupProperty(PropertyInterface("Position", I)), T.r.setGroupProperty(PropertyInterface("Rotation", I)), S.ir && (T.ir.setGroupProperty(PropertyInterface("Inner Radius", I)), T.is.setGroupProperty(PropertyInterface("Inner Roundness", I))), Object.defineProperties(L, {
          position: {
            get: ExpressionPropertyInterface(T.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(T.r)
          },
          points: {
            get: ExpressionPropertyInterface(T.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(T.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(T.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(T.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(T.is)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      function y(S, M, P) {
        function L(E) {
          return S.p.ix === E ? L.position : S.r.ix === E ? L.roundness : S.s.ix === E || E === "Size" || E === "ADBE Vector Rect Size" ? L.size : null;
        }
        var I = propertyGroupFactory(L, P), T = M.sh.ty === "tm" ? M.sh.prop : M.sh;
        return L.propertyIndex = S.ix, T.p.setGroupProperty(PropertyInterface("Position", I)), T.s.setGroupProperty(PropertyInterface("Size", I)), T.r.setGroupProperty(PropertyInterface("Rotation", I)), Object.defineProperties(L, {
          position: {
            get: ExpressionPropertyInterface(T.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(T.r)
          },
          size: {
            get: ExpressionPropertyInterface(T.s)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      function x(S, M, P) {
        function L(E) {
          return S.r.ix === E || E === "Round Corners 1" ? L.radius : null;
        }
        var I = propertyGroupFactory(L, P), T = M;
        return L.propertyIndex = S.ix, T.rd.setGroupProperty(PropertyInterface("Radius", I)), Object.defineProperties(L, {
          radius: {
            get: ExpressionPropertyInterface(T.rd)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      function w(S, M, P) {
        function L(E) {
          return S.c.ix === E || E === "Copies" ? L.copies : S.o.ix === E || E === "Offset" ? L.offset : null;
        }
        var I = propertyGroupFactory(L, P), T = M;
        return L.propertyIndex = S.ix, T.c.setGroupProperty(PropertyInterface("Copies", I)), T.o.setGroupProperty(PropertyInterface("Offset", I)), Object.defineProperties(L, {
          copies: {
            get: ExpressionPropertyInterface(T.c)
          },
          offset: {
            get: ExpressionPropertyInterface(T.o)
          },
          _name: {
            value: S.nm
          }
        }), L.mn = S.mn, L;
      }
      return function(S, M, P) {
        var L;
        function I(E) {
          if (typeof E == "number")
            return E = E === void 0 ? 1 : E, E === 0 ? P : L[E - 1];
          for (var R = 0, A = L.length; R < A; ) {
            if (L[R]._name === E)
              return L[R];
            R += 1;
          }
          return null;
        }
        function T() {
          return P;
        }
        return I.propertyGroup = propertyGroupFactory(I, T), L = r(S, M, I.propertyGroup), I.numProperties = L.length, I._name = "Contents", I;
      };
    }(), TextExpressionInterface = /* @__PURE__ */ function() {
      return function(r) {
        var a;
        function s(c) {
          switch (c) {
            case "ADBE Text Document":
              return s.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(s, "sourceText", {
          get: function() {
            r.textProperty.getValue();
            var u = r.textProperty.currentData.t;
            return (!a || u !== a.value) && (a = new String(u), a.value = u || new String(u), Object.defineProperty(a, "style", {
              get: function() {
                return {
                  fillColor: r.textProperty.currentData.fc
                };
              }
            })), a;
          }
        }), s;
      };
    }();
    function _typeof(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(s) {
        return typeof s;
      } : _typeof = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, _typeof(r);
    }
    var FootageInterface = /* @__PURE__ */ function() {
      var r = function(c) {
        var u = "", d = c.getFootageData();
        function h() {
          return u = "", d = c.getFootageData(), p;
        }
        function p(m) {
          if (d[m])
            return u = m, d = d[m], _typeof(d) === "object" ? p : d;
          var g = m.indexOf(u);
          if (g !== -1) {
            var v = parseInt(m.substr(g + u.length), 10);
            return d = d[v], _typeof(d) === "object" ? p : d;
          }
          return "";
        }
        return h;
      }, a = function(c) {
        function u(d) {
          return d === "Outline" ? u.outlineInterface() : null;
        }
        return u._name = "Outline", u.outlineInterface = r(c), u;
      };
      return function(s) {
        function c(u) {
          return u === "Data" ? c.dataInterface : null;
        }
        return c._name = "Data", c.dataInterface = a(s), c;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(r) {
      return interfaces[r] || null;
    }
    var expressionHelpers = /* @__PURE__ */ function() {
      function r(h, p, m) {
        p.x && (m.k = !0, m.x = !0, m.initiateExpression = ExpressionManager.initiateExpression, m.effectsSequence.push(m.initiateExpression(h, p, m).bind(m)));
      }
      function a(h) {
        return h *= this.elem.globalData.frameRate, h -= this.offsetTime, h !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < h ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(h, this._cachingAtTime), this._cachingAtTime.lastFrame = h), this._cachingAtTime.value;
      }
      function s(h) {
        var p = -0.01, m = this.getValueAtTime(h), g = this.getValueAtTime(h + p), v = 0;
        if (m.length) {
          var y;
          for (y = 0; y < m.length; y += 1)
            v += Math.pow(g[y] - m[y], 2);
          v = Math.sqrt(v) * 100;
        } else
          v = 0;
        return v;
      }
      function c(h) {
        if (this.vel !== void 0)
          return this.vel;
        var p = -1e-3, m = this.getValueAtTime(h), g = this.getValueAtTime(h + p), v;
        if (m.length) {
          v = createTypedArray("float32", m.length);
          var y;
          for (y = 0; y < m.length; y += 1)
            v[y] = (g[y] - m[y]) / p;
        } else
          v = (g - m) / p;
        return v;
      }
      function u() {
        return this.pv;
      }
      function d(h) {
        this.propertyGroup = h;
      }
      return {
        searchExpressions: r,
        getSpeedAtTime: s,
        getVelocityAtTime: c,
        getValueAtTime: a,
        getStaticValueAtTime: u,
        setGroupProperty: d
      };
    }();
    function addPropertyDecorator() {
      function r(x, w, S) {
        if (!this.k || !this.keyframes)
          return this.pv;
        x = x ? x.toLowerCase() : "";
        var M = this.comp.renderedFrame, P = this.keyframes, L = P[P.length - 1].t;
        if (M <= L)
          return this.pv;
        var I, T;
        S ? (w ? I = Math.abs(L - this.elem.comp.globalData.frameRate * w) : I = Math.max(0, L - this.elem.data.ip), T = L - I) : ((!w || w > P.length - 1) && (w = P.length - 1), T = P[P.length - 1 - w].t, I = L - T);
        var E, R, A;
        if (x === "pingpong") {
          var k = Math.floor((M - T) / I);
          if (k % 2 !== 0)
            return this.getValueAtTime((I - (M - T) % I + T) / this.comp.globalData.frameRate, 0);
        } else if (x === "offset") {
          var V = this.getValueAtTime(T / this.comp.globalData.frameRate, 0), B = this.getValueAtTime(L / this.comp.globalData.frameRate, 0), q = this.getValueAtTime(((M - T) % I + T) / this.comp.globalData.frameRate, 0), z = Math.floor((M - T) / I);
          if (this.pv.length) {
            for (A = new Array(V.length), R = A.length, E = 0; E < R; E += 1)
              A[E] = (B[E] - V[E]) * z + q[E];
            return A;
          }
          return (B - V) * z + q;
        } else if (x === "continue") {
          var Z = this.getValueAtTime(L / this.comp.globalData.frameRate, 0), G = this.getValueAtTime((L - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(Z.length), R = A.length, E = 0; E < R; E += 1)
              A[E] = Z[E] + (Z[E] - G[E]) * ((M - L) / this.comp.globalData.frameRate) / 5e-4;
            return A;
          }
          return Z + (Z - G) * ((M - L) / 1e-3);
        }
        return this.getValueAtTime(((M - T) % I + T) / this.comp.globalData.frameRate, 0);
      }
      function a(x, w, S) {
        if (!this.k)
          return this.pv;
        x = x ? x.toLowerCase() : "";
        var M = this.comp.renderedFrame, P = this.keyframes, L = P[0].t;
        if (M >= L)
          return this.pv;
        var I, T;
        S ? (w ? I = Math.abs(this.elem.comp.globalData.frameRate * w) : I = Math.max(0, this.elem.data.op - L), T = L + I) : ((!w || w > P.length - 1) && (w = P.length - 1), T = P[w].t, I = T - L);
        var E, R, A;
        if (x === "pingpong") {
          var k = Math.floor((L - M) / I);
          if (k % 2 === 0)
            return this.getValueAtTime(((L - M) % I + L) / this.comp.globalData.frameRate, 0);
        } else if (x === "offset") {
          var V = this.getValueAtTime(L / this.comp.globalData.frameRate, 0), B = this.getValueAtTime(T / this.comp.globalData.frameRate, 0), q = this.getValueAtTime((I - (L - M) % I + L) / this.comp.globalData.frameRate, 0), z = Math.floor((L - M) / I) + 1;
          if (this.pv.length) {
            for (A = new Array(V.length), R = A.length, E = 0; E < R; E += 1)
              A[E] = q[E] - (B[E] - V[E]) * z;
            return A;
          }
          return q - (B - V) * z;
        } else if (x === "continue") {
          var Z = this.getValueAtTime(L / this.comp.globalData.frameRate, 0), G = this.getValueAtTime((L + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(Z.length), R = A.length, E = 0; E < R; E += 1)
              A[E] = Z[E] + (Z[E] - G[E]) * (L - M) / 1e-3;
            return A;
          }
          return Z + (Z - G) * (L - M) / 1e-3;
        }
        return this.getValueAtTime((I - ((L - M) % I + L)) / this.comp.globalData.frameRate, 0);
      }
      function s(x, w) {
        if (!this.k)
          return this.pv;
        if (x = (x || 0.4) * 0.5, w = Math.floor(w || 5), w <= 1)
          return this.pv;
        var S = this.comp.renderedFrame / this.comp.globalData.frameRate, M = S - x, P = S + x, L = w > 1 ? (P - M) / (w - 1) : 1, I = 0, T = 0, E;
        this.pv.length ? E = createTypedArray("float32", this.pv.length) : E = 0;
        for (var R; I < w; ) {
          if (R = this.getValueAtTime(M + I * L), this.pv.length)
            for (T = 0; T < this.pv.length; T += 1)
              E[T] += R[T];
          else
            E += R;
          I += 1;
        }
        if (this.pv.length)
          for (T = 0; T < this.pv.length; T += 1)
            E[T] /= w;
        else
          E /= w;
        return E;
      }
      function c(x) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var w = this._transformCachingAtTime.v;
        if (w.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var S = this.a.getValueAtTime(x);
          w.translate(-S[0] * this.a.mult, -S[1] * this.a.mult, S[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var M = this.s.getValueAtTime(x);
          w.scale(M[0] * this.s.mult, M[1] * this.s.mult, M[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var P = this.sk.getValueAtTime(x), L = this.sa.getValueAtTime(x);
          w.skewFromAxis(-P * this.sk.mult, L * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var I = this.r.getValueAtTime(x);
          w.rotate(-I * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var T = this.rz.getValueAtTime(x), E = this.ry.getValueAtTime(x), R = this.rx.getValueAtTime(x), A = this.or.getValueAtTime(x);
          w.rotateZ(-T * this.rz.mult).rotateY(E * this.ry.mult).rotateX(R * this.rx.mult).rotateZ(-A[2] * this.or.mult).rotateY(A[1] * this.or.mult).rotateX(A[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var k = this.px.getValueAtTime(x), V = this.py.getValueAtTime(x);
          if (this.data.p.z) {
            var B = this.pz.getValueAtTime(x);
            w.translate(k * this.px.mult, V * this.py.mult, -B * this.pz.mult);
          } else
            w.translate(k * this.px.mult, V * this.py.mult, 0);
        } else {
          var q = this.p.getValueAtTime(x);
          w.translate(q[0] * this.p.mult, q[1] * this.p.mult, -q[2] * this.p.mult);
        }
        return w;
      }
      function u() {
        return this.v.clone(new Matrix());
      }
      var d = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(x, w, S) {
        var M = d(x, w, S);
        return M.dynamicProperties.length ? M.getValueAtTime = c.bind(M) : M.getValueAtTime = u.bind(M), M.setGroupProperty = expressionHelpers.setGroupProperty, M;
      };
      var h = PropertyFactory.getProp;
      PropertyFactory.getProp = function(x, w, S, M, P) {
        var L = h(x, w, S, M, P);
        L.kf ? L.getValueAtTime = expressionHelpers.getValueAtTime.bind(L) : L.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(L), L.setGroupProperty = expressionHelpers.setGroupProperty, L.loopOut = r, L.loopIn = a, L.smooth = s, L.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(L), L.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(L), L.numKeys = w.a === 1 ? w.k.length : 0, L.propertyIndex = w.ix;
        var I = 0;
        return S !== 0 && (I = createTypedArray("float32", w.a === 1 ? w.k[0].s.length : w.k.length)), L._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: I
        }, expressionHelpers.searchExpressions(x, w, L), L.k && P.addDynamicProperty(L), L;
      };
      function p(x) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), x *= this.elem.globalData.frameRate, x -= this.offsetTime, x !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < x ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = x, this.interpolateShape(x, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var m = ShapePropertyFactory.getConstructorFunction(), g = ShapePropertyFactory.getKeyframedConstructorFunction();
      function v() {
      }
      v.prototype = {
        vertices: function(w, S) {
          this.k && this.getValue();
          var M = this.v;
          S !== void 0 && (M = this.getValueAtTime(S, 0));
          var P, L = M._length, I = M[w], T = M.v, E = createSizedArray(L);
          for (P = 0; P < L; P += 1)
            w === "i" || w === "o" ? E[P] = [I[P][0] - T[P][0], I[P][1] - T[P][1]] : E[P] = [I[P][0], I[P][1]];
          return E;
        },
        points: function(w) {
          return this.vertices("v", w);
        },
        inTangents: function(w) {
          return this.vertices("i", w);
        },
        outTangents: function(w) {
          return this.vertices("o", w);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(w, S) {
          var M = this.v;
          S !== void 0 && (M = this.getValueAtTime(S, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(M));
          for (var P = this._segmentsLength, L = P.lengths, I = P.totalLength * w, T = 0, E = L.length, R = 0, A; T < E; ) {
            if (R + L[T].addedLength > I) {
              var k = T, V = M.c && T === E - 1 ? 0 : T + 1, B = (I - R) / L[T].addedLength;
              A = bez.getPointInSegment(M.v[k], M.v[V], M.o[k], M.i[V], B, L[T]);
              break;
            } else
              R += L[T].addedLength;
            T += 1;
          }
          return A || (A = M.c ? [M.v[0][0], M.v[0][1]] : [M.v[M._length - 1][0], M.v[M._length - 1][1]]), A;
        },
        vectorOnPath: function(w, S, M) {
          w == 1 ? w = this.v.c : w == 0 && (w = 0.999);
          var P = this.pointOnPath(w, S), L = this.pointOnPath(w + 1e-3, S), I = L[0] - P[0], T = L[1] - P[1], E = Math.sqrt(Math.pow(I, 2) + Math.pow(T, 2));
          if (E === 0)
            return [0, 0];
          var R = M === "tangent" ? [I / E, T / E] : [-T / E, I / E];
          return R;
        },
        tangentOnPath: function(w, S) {
          return this.vectorOnPath(w, S, "tangent");
        },
        normalOnPath: function(w, S) {
          return this.vectorOnPath(w, S, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([v], m), extendPrototype([v], g), g.prototype.getValueAtTime = p, g.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var y = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(x, w, S, M, P) {
        var L = y(x, w, S, M, P);
        return L.propertyIndex = w.ix, L.lock = !1, S === 3 ? expressionHelpers.searchExpressions(x, w.pt, L) : S === 4 && expressionHelpers.searchExpressions(x, w.ks, L), L.k && x.addDynamicProperty(L), L;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function r() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(a, s) {
        var c = this.calculateExpression(s);
        if (a.t !== c) {
          var u = {};
          return this.copyData(u, a), u.t = c.toString(), u.__complete = !1, u;
        }
        return a;
      }, TextProperty.prototype.searchProperty = function() {
        var a = this.searchKeyframes(), s = this.searchExpressions();
        return this.kf = a || s, this.kf;
      }, TextProperty.prototype.searchExpressions = r;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function r(a, s) {
        var c = createNS("feMerge");
        c.setAttribute("result", a);
        var u, d;
        for (d = 0; d < s.length; d += 1)
          u = createNS("feMergeNode"), u.setAttribute("in", s[d]), c.appendChild(u), c.appendChild(u);
        return c;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(r, a, s, c, u) {
      this.filterManager = a;
      var d = createNS("feColorMatrix");
      d.setAttribute("type", "matrix"), d.setAttribute("color-interpolation-filters", "linearRGB"), d.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = d, d.setAttribute("result", c + "_tint_1"), r.appendChild(d), d = createNS("feColorMatrix"), d.setAttribute("type", "matrix"), d.setAttribute("color-interpolation-filters", "sRGB"), d.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), d.setAttribute("result", c + "_tint_2"), r.appendChild(d), this.matrixFilter = d;
      var h = this.createMergeNode(c, [u, c + "_tint_1", c + "_tint_2"]);
      r.appendChild(h);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        var a = this.filterManager.effectElements[0].p.v, s = this.filterManager.effectElements[1].p.v, c = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + c + " 0"), this.matrixFilter.setAttribute("values", s[0] - a[0] + " 0 0 0 " + a[0] + " " + (s[1] - a[1]) + " 0 0 0 " + a[1] + " " + (s[2] - a[2]) + " 0 0 0 " + a[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(r, a, s, c) {
      this.filterManager = a;
      var u = createNS("feColorMatrix");
      u.setAttribute("type", "matrix"), u.setAttribute("color-interpolation-filters", "sRGB"), u.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), u.setAttribute("result", c), r.appendChild(u), this.matrixFilter = u;
    }
    SVGFillFilter.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        var a = this.filterManager.effectElements[2].p.v, s = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + a[0] + " 0 0 0 0 " + a[1] + " 0 0 0 0 " + a[2] + " 0 0 0 " + s + " 0");
      }
    };
    function SVGStrokeEffect(r, a, s) {
      this.initialized = !1, this.filterManager = a, this.elem = s, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var r = this.elem.layerElement.children || this.elem.layerElement.childNodes, a, s, c, u;
      for (this.filterManager.effectElements[1].p.v === 1 ? (u = this.elem.maskManager.masksProperties.length, c = 0) : (c = this.filterManager.effectElements[0].p.v - 1, u = c + 1), s = createNS("g"), s.setAttribute("fill", "none"), s.setAttribute("stroke-linecap", "round"), s.setAttribute("stroke-dashoffset", 1), c; c < u; c += 1)
        a = createNS("path"), s.appendChild(a), this.paths.push({
          p: a,
          m: c
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var d = createNS("mask"), h = createElementID();
        d.setAttribute("id", h), d.setAttribute("mask-type", "alpha"), d.appendChild(s), this.elem.globalData.defs.appendChild(d);
        var p = createNS("g");
        for (p.setAttribute("mask", "url(" + getLocationHref() + "#" + h + ")"); r[0]; )
          p.appendChild(r[0]);
        this.elem.layerElement.appendChild(p), this.masker = d, s.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (r = this.elem.layerElement.children || this.elem.layerElement.childNodes; r.length; )
            this.elem.layerElement.removeChild(r[0]);
        this.elem.layerElement.appendChild(s), this.elem.layerElement.removeAttribute("mask"), s.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = s;
    }, SVGStrokeEffect.prototype.renderFrame = function(r) {
      this.initialized || this.initialize();
      var a, s = this.paths.length, c, u;
      for (a = 0; a < s; a += 1)
        if (this.paths[a].m !== -1 && (c = this.elem.maskManager.viewData[this.paths[a].m], u = this.paths[a].p, (r || this.filterManager._mdf || c.prop._mdf) && u.setAttribute("d", c.lastPath), r || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || c.prop._mdf)) {
          var d;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var h = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, p = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, m = u.getTotalLength();
            d = "0 0 0 " + m * h + " ";
            var g = m * (p - h), v = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, y = Math.floor(g / v), x;
            for (x = 0; x < y; x += 1)
              d += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            d += "0 " + m * 10 + " 0 0";
          } else
            d = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          u.setAttribute("stroke-dasharray", d);
        }
      if ((r || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (r || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (r || this.filterManager.effectElements[3].p._mdf)) {
        var w = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(w[0] * 255) + "," + bmFloor(w[1] * 255) + "," + bmFloor(w[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(r, a, s, c) {
      this.filterManager = a;
      var u = createNS("feColorMatrix");
      u.setAttribute("type", "matrix"), u.setAttribute("color-interpolation-filters", "linearRGB"), u.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), r.appendChild(u);
      var d = createNS("feComponentTransfer");
      d.setAttribute("color-interpolation-filters", "sRGB"), d.setAttribute("result", c), this.matrixFilter = d;
      var h = createNS("feFuncR");
      h.setAttribute("type", "table"), d.appendChild(h), this.feFuncR = h;
      var p = createNS("feFuncG");
      p.setAttribute("type", "table"), d.appendChild(p), this.feFuncG = p;
      var m = createNS("feFuncB");
      m.setAttribute("type", "table"), d.appendChild(m), this.feFuncB = m, r.appendChild(d);
    }
    SVGTritoneFilter.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        var a = this.filterManager.effectElements[0].p.v, s = this.filterManager.effectElements[1].p.v, c = this.filterManager.effectElements[2].p.v, u = c[0] + " " + s[0] + " " + a[0], d = c[1] + " " + s[1] + " " + a[1], h = c[2] + " " + s[2] + " " + a[2];
        this.feFuncR.setAttribute("tableValues", u), this.feFuncG.setAttribute("tableValues", d), this.feFuncB.setAttribute("tableValues", h);
      }
    };
    function SVGProLevelsFilter(r, a, s, c) {
      this.filterManager = a;
      var u = this.filterManager.effectElements, d = createNS("feComponentTransfer");
      (u[10].p.k || u[10].p.v !== 0 || u[11].p.k || u[11].p.v !== 1 || u[12].p.k || u[12].p.v !== 1 || u[13].p.k || u[13].p.v !== 0 || u[14].p.k || u[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", d)), (u[17].p.k || u[17].p.v !== 0 || u[18].p.k || u[18].p.v !== 1 || u[19].p.k || u[19].p.v !== 1 || u[20].p.k || u[20].p.v !== 0 || u[21].p.k || u[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", d)), (u[24].p.k || u[24].p.v !== 0 || u[25].p.k || u[25].p.v !== 1 || u[26].p.k || u[26].p.v !== 1 || u[27].p.k || u[27].p.v !== 0 || u[28].p.k || u[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", d)), (u[31].p.k || u[31].p.v !== 0 || u[32].p.k || u[32].p.v !== 1 || u[33].p.k || u[33].p.v !== 1 || u[34].p.k || u[34].p.v !== 0 || u[35].p.k || u[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", d)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (d.setAttribute("color-interpolation-filters", "sRGB"), r.appendChild(d)), (u[3].p.k || u[3].p.v !== 0 || u[4].p.k || u[4].p.v !== 1 || u[5].p.k || u[5].p.v !== 1 || u[6].p.k || u[6].p.v !== 0 || u[7].p.k || u[7].p.v !== 1) && (d = createNS("feComponentTransfer"), d.setAttribute("color-interpolation-filters", "sRGB"), d.setAttribute("result", c), r.appendChild(d), this.feFuncRComposed = this.createFeFunc("feFuncR", d), this.feFuncGComposed = this.createFeFunc("feFuncG", d), this.feFuncBComposed = this.createFeFunc("feFuncB", d));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(r, a) {
      var s = createNS(r);
      return s.setAttribute("type", "table"), a.appendChild(s), s;
    }, SVGProLevelsFilter.prototype.getTableValue = function(r, a, s, c, u) {
      for (var d = 0, h = 256, p, m = Math.min(r, a), g = Math.max(r, a), v = Array.call(null, {
        length: h
      }), y, x = 0, w = u - c, S = a - r; d <= 256; )
        p = d / 256, p <= m ? y = S < 0 ? u : c : p >= g ? y = S < 0 ? c : u : y = c + w * Math.pow((p - r) / S, 1 / s), v[x] = y, x += 1, d += 256 / (h - 1);
      return v.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        var a, s = this.filterManager.effectElements;
        this.feFuncRComposed && (r || s[3].p._mdf || s[4].p._mdf || s[5].p._mdf || s[6].p._mdf || s[7].p._mdf) && (a = this.getTableValue(s[3].p.v, s[4].p.v, s[5].p.v, s[6].p.v, s[7].p.v), this.feFuncRComposed.setAttribute("tableValues", a), this.feFuncGComposed.setAttribute("tableValues", a), this.feFuncBComposed.setAttribute("tableValues", a)), this.feFuncR && (r || s[10].p._mdf || s[11].p._mdf || s[12].p._mdf || s[13].p._mdf || s[14].p._mdf) && (a = this.getTableValue(s[10].p.v, s[11].p.v, s[12].p.v, s[13].p.v, s[14].p.v), this.feFuncR.setAttribute("tableValues", a)), this.feFuncG && (r || s[17].p._mdf || s[18].p._mdf || s[19].p._mdf || s[20].p._mdf || s[21].p._mdf) && (a = this.getTableValue(s[17].p.v, s[18].p.v, s[19].p.v, s[20].p.v, s[21].p.v), this.feFuncG.setAttribute("tableValues", a)), this.feFuncB && (r || s[24].p._mdf || s[25].p._mdf || s[26].p._mdf || s[27].p._mdf || s[28].p._mdf) && (a = this.getTableValue(s[24].p.v, s[25].p.v, s[26].p.v, s[27].p.v, s[28].p.v), this.feFuncB.setAttribute("tableValues", a)), this.feFuncA && (r || s[31].p._mdf || s[32].p._mdf || s[33].p._mdf || s[34].p._mdf || s[35].p._mdf) && (a = this.getTableValue(s[31].p.v, s[32].p.v, s[33].p.v, s[34].p.v, s[35].p.v), this.feFuncA.setAttribute("tableValues", a));
      }
    };
    function SVGDropShadowEffect(r, a, s, c, u) {
      var d = a.container.globalData.renderConfig.filterSize, h = a.data.fs || d;
      r.setAttribute("x", h.x || d.x), r.setAttribute("y", h.y || d.y), r.setAttribute("width", h.width || d.width), r.setAttribute("height", h.height || d.height), this.filterManager = a;
      var p = createNS("feGaussianBlur");
      p.setAttribute("in", "SourceAlpha"), p.setAttribute("result", c + "_drop_shadow_1"), p.setAttribute("stdDeviation", "0"), this.feGaussianBlur = p, r.appendChild(p);
      var m = createNS("feOffset");
      m.setAttribute("dx", "25"), m.setAttribute("dy", "0"), m.setAttribute("in", c + "_drop_shadow_1"), m.setAttribute("result", c + "_drop_shadow_2"), this.feOffset = m, r.appendChild(m);
      var g = createNS("feFlood");
      g.setAttribute("flood-color", "#00ff00"), g.setAttribute("flood-opacity", "1"), g.setAttribute("result", c + "_drop_shadow_3"), this.feFlood = g, r.appendChild(g);
      var v = createNS("feComposite");
      v.setAttribute("in", c + "_drop_shadow_3"), v.setAttribute("in2", c + "_drop_shadow_2"), v.setAttribute("operator", "in"), v.setAttribute("result", c + "_drop_shadow_4"), r.appendChild(v);
      var y = this.createMergeNode(c, [c + "_drop_shadow_4", u]);
      r.appendChild(y);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        if ((r || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), r || this.filterManager.effectElements[0].p._mdf) {
          var a = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(a[0] * 255), Math.round(a[1] * 255), Math.round(a[2] * 255)));
        }
        if ((r || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), r || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var s = this.filterManager.effectElements[3].p.v, c = (this.filterManager.effectElements[2].p.v - 90) * degToRads, u = s * Math.cos(c), d = s * Math.sin(c);
          this.feOffset.setAttribute("dx", u), this.feOffset.setAttribute("dy", d);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(r, a, s) {
      this.initialized = !1, this.filterManager = a, this.filterElem = r, this.elem = s, s.matteElement = createNS("g"), s.matteElement.appendChild(s.layerElement), s.matteElement.appendChild(s.transformedElement), s.baseElement = s.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(r) {
      for (var a = 0, s = _svgMatteSymbols.length; a < s; ) {
        if (_svgMatteSymbols[a] === r)
          return _svgMatteSymbols[a];
        a += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(r, a) {
      var s = r.layerElement.parentNode;
      if (s) {
        for (var c = s.children, u = 0, d = c.length; u < d && c[u] !== r.layerElement; )
          u += 1;
        var h;
        u <= d - 2 && (h = c[u + 1]);
        var p = createNS("use");
        p.setAttribute("href", "#" + a), h ? s.insertBefore(p, h) : s.appendChild(p);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(r, a) {
      if (!this.findSymbol(a)) {
        var s = createElementID(), c = createNS("mask");
        c.setAttribute("id", a.layerId), c.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(a);
        var u = r.globalData.defs;
        u.appendChild(c);
        var d = createNS("symbol");
        d.setAttribute("id", s), this.replaceInParent(a, s), d.appendChild(a.layerElement), u.appendChild(d);
        var h = createNS("use");
        h.setAttribute("href", "#" + s), c.appendChild(h), a.data.hd = !1, a.show();
      }
      r.setMatte(a.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var r = this.filterManager.effectElements[0].p.v, a = this.elem.comp.elements, s = 0, c = a.length; s < c; )
        a[s] && a[s].data.ind === r && this.setElementAsMask(this.elem, a[s]), s += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(r, a, s, c) {
      r.setAttribute("x", "-100%"), r.setAttribute("y", "-100%"), r.setAttribute("width", "300%"), r.setAttribute("height", "300%"), this.filterManager = a;
      var u = createNS("feGaussianBlur");
      u.setAttribute("result", c), r.appendChild(u), this.feGaussianBlur = u;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(r) {
      if (r || this.filterManager._mdf) {
        var a = 0.3, s = this.filterManager.effectElements[0].p.v * a, c = this.filterManager.effectElements[1].p.v, u = c == 3 ? 0 : s, d = c == 2 ? 0 : s;
        this.feGaussianBlur.setAttribute("stdDeviation", u + " " + d);
        var h = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", h);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(r) {
      this.effectsManager = r, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(r) {
      if (this._opMdf = !1, this._mdf = !1, r || this.effectsManager._mdf) {
        var a = this.effectsManager.effectElements, s = a[0].p.v, c = a[1].p.v, u = a[2].p.v === 1, d = a[3].p.v, h = u ? d : a[4].p.v, p = a[5].p.v, m = a[6].p.v, g = a[7].p.v;
        this.matrix.reset(), this.matrix.translate(-s[0], -s[1], s[2]), this.matrix.scale(h * 0.01, d * 0.01, 1), this.matrix.rotate(-g * degToRads), this.matrix.skewFromAxis(-p * degToRads, (m + 90) * degToRads), this.matrix.translate(c[0], c[1], 0), this._mdf = !0, this.opacity !== a[8].p.v && (this.opacity = a[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(r, a) {
      this.init(a);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(r) {
      this.init(r);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports);
function _iterableToArrayLimit(r, a) {
  var s = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (s != null) {
    var c, u, d, h, p = [], m = !0, g = !1;
    try {
      if (d = (s = s.call(r)).next, a !== 0) for (; !(m = (c = d.call(s)).done) && (p.push(c.value), p.length !== a); m = !0) ;
    } catch (v) {
      g = !0, u = v;
    } finally {
      try {
        if (!m && s.return != null && (h = s.return(), Object(h) !== h)) return;
      } finally {
        if (g) throw u;
      }
    }
    return p;
  }
}
function ownKeys(r, a) {
  var s = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(r);
    a && (c = c.filter(function(u) {
      return Object.getOwnPropertyDescriptor(r, u).enumerable;
    })), s.push.apply(s, c);
  }
  return s;
}
function _objectSpread2(r) {
  for (var a = 1; a < arguments.length; a++) {
    var s = arguments[a] != null ? arguments[a] : {};
    a % 2 ? ownKeys(Object(s), !0).forEach(function(c) {
      _defineProperty$1(r, c, s[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(s)) : ownKeys(Object(s)).forEach(function(c) {
      Object.defineProperty(r, c, Object.getOwnPropertyDescriptor(s, c));
    });
  }
  return r;
}
function _defineProperty$1(r, a, s) {
  return a = _toPropertyKey(a), a in r ? Object.defineProperty(r, a, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[a] = s, r;
}
function _objectWithoutPropertiesLoose$2(r, a) {
  if (r == null) return {};
  var s = {}, c = Object.keys(r), u, d;
  for (d = 0; d < c.length; d++)
    u = c[d], !(a.indexOf(u) >= 0) && (s[u] = r[u]);
  return s;
}
function _objectWithoutProperties(r, a) {
  if (r == null) return {};
  var s = _objectWithoutPropertiesLoose$2(r, a), c, u;
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(r);
    for (u = 0; u < d.length; u++)
      c = d[u], !(a.indexOf(c) >= 0) && Object.prototype.propertyIsEnumerable.call(r, c) && (s[c] = r[c]);
  }
  return s;
}
function _slicedToArray(r, a) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, a) || _unsupportedIterableToArray(r, a) || _nonIterableRest();
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if (typeof r == "string") return _arrayLikeToArray(r, a);
    var s = Object.prototype.toString.call(r).slice(8, -1);
    if (s === "Object" && r.constructor && (s = r.constructor.name), s === "Map" || s === "Set") return Array.from(r);
    if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)) return _arrayLikeToArray(r, a);
  }
}
function _arrayLikeToArray(r, a) {
  (a == null || a > r.length) && (a = r.length);
  for (var s = 0, c = new Array(a); s < a; s++) c[s] = r[s];
  return c;
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(r, a) {
  if (typeof r != "object" || r === null) return r;
  var s = r[Symbol.toPrimitive];
  if (s !== void 0) {
    var c = s.call(r, a || "default");
    if (typeof c != "object") return c;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(r);
}
function _toPropertyKey(r) {
  var a = _toPrimitive(r, "string");
  return typeof a == "symbol" ? a : String(a);
}
var _excluded$1$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"], useLottie = function r(a, s) {
  var c = a.animationData, u = a.loop, d = a.autoplay, h = a.initialSegment, p = a.onComplete, m = a.onLoopComplete, g = a.onEnterFrame, v = a.onSegmentStart, y = a.onConfigReady, x = a.onDataReady, w = a.onDataFailed, S = a.onLoadedImages, M = a.onDOMLoaded, P = a.onDestroy;
  a.lottieRef, a.renderer, a.name, a.assetsPath, a.rendererSettings;
  var L = _objectWithoutProperties(a, _excluded$1$1), I = useState$1(!1), T = _slicedToArray(I, 2), E = T[0], R = T[1], A = useRef$1(), k = useRef$1(null), V = function() {
    var re;
    (re = A.current) === null || re === void 0 || re.play();
  }, B = function() {
    var re;
    (re = A.current) === null || re === void 0 || re.stop();
  }, q = function() {
    var re;
    (re = A.current) === null || re === void 0 || re.pause();
  }, z = function(re) {
    var ae;
    (ae = A.current) === null || ae === void 0 || ae.setSpeed(re);
  }, Z = function(re, ae) {
    var ee;
    (ee = A.current) === null || ee === void 0 || ee.goToAndPlay(re, ae);
  }, G = function(re, ae) {
    var ee;
    (ee = A.current) === null || ee === void 0 || ee.goToAndStop(re, ae);
  }, K = function(re) {
    var ae;
    (ae = A.current) === null || ae === void 0 || ae.setDirection(re);
  }, U = function(re, ae) {
    var ee;
    (ee = A.current) === null || ee === void 0 || ee.playSegments(re, ae);
  }, F = function(re) {
    var ae;
    (ae = A.current) === null || ae === void 0 || ae.setSubframe(re);
  }, N = function(re) {
    var ae;
    return (ae = A.current) === null || ae === void 0 ? void 0 : ae.getDuration(re);
  }, D = function() {
    var re;
    (re = A.current) === null || re === void 0 || re.destroy(), A.current = void 0;
  }, j = function() {
    var re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ae;
    if (k.current) {
      (ae = A.current) === null || ae === void 0 || ae.destroy();
      var ee = _objectSpread2(_objectSpread2(_objectSpread2({}, a), re), {}, {
        container: k.current
      });
      return A.current = lottie.loadAnimation(ee), R(!!A.current), function() {
        var X;
        (X = A.current) === null || X === void 0 || X.destroy(), A.current = void 0;
      };
    }
  };
  useEffect$1(function() {
    var W = j();
    return function() {
      return W == null ? void 0 : W();
    };
  }, [c, u]), useEffect$1(function() {
    A.current && (A.current.autoplay = !!d);
  }, [d]), useEffect$1(function() {
    if (A.current) {
      if (!h) {
        A.current.resetSegments(!0);
        return;
      }
      !Array.isArray(h) || !h.length || ((A.current.currentRawFrame < h[0] || A.current.currentRawFrame > h[1]) && (A.current.currentRawFrame = h[0]), A.current.setSegment(h[0], h[1]));
    }
  }, [h]), useEffect$1(function() {
    var W = [{
      name: "complete",
      handler: p
    }, {
      name: "loopComplete",
      handler: m
    }, {
      name: "enterFrame",
      handler: g
    }, {
      name: "segmentStart",
      handler: v
    }, {
      name: "config_ready",
      handler: y
    }, {
      name: "data_ready",
      handler: x
    }, {
      name: "data_failed",
      handler: w
    }, {
      name: "loaded_images",
      handler: S
    }, {
      name: "DOMLoaded",
      handler: M
    }, {
      name: "destroy",
      handler: P
    }], re = W.filter(function(ee) {
      return ee.handler != null;
    });
    if (re.length) {
      var ae = re.map(
        /**
         * Handle the process of adding an event listener
         * @param {Listener} listener
         * @return {Function} Function that deregister the listener
         */
        function(ee) {
          var X;
          return (X = A.current) === null || X === void 0 || X.addEventListener(ee.name, ee.handler), function() {
            var J;
            (J = A.current) === null || J === void 0 || J.removeEventListener(ee.name, ee.handler);
          };
        }
      );
      return function() {
        ae.forEach(function(ee) {
          return ee();
        });
      };
    }
  }, [p, m, g, v, y, x, w, S, M, P]);
  var H = /* @__PURE__ */ React__default.createElement("div", _objectSpread2({
    style: s,
    ref: k
  }, L));
  return {
    View: H,
    play: V,
    stop: B,
    pause: q,
    setSpeed: z,
    goToAndStop: G,
    goToAndPlay: Z,
    setDirection: K,
    playSegments: U,
    setSubframe: F,
    getDuration: N,
    destroy: D,
    animationContainerRef: k,
    animationLoaded: E,
    animationItem: A.current
  };
};
function getContainerVisibility(r) {
  var a = r.getBoundingClientRect(), s = a.top, c = a.height, u = window.innerHeight - s, d = window.innerHeight + c;
  return u / d;
}
function getContainerCursorPosition(r, a, s) {
  var c = r.getBoundingClientRect(), u = c.top, d = c.left, h = c.width, p = c.height, m = (a - d) / h, g = (s - u) / p;
  return {
    x: m,
    y: g
  };
}
var useInitInteractivity = function r(a) {
  var s = a.wrapperRef, c = a.animationItem, u = a.mode, d = a.actions;
  useEffect$1(function() {
    var h = s.current;
    if (!(!h || !c || !d.length)) {
      c.stop();
      var p = function() {
        var v = null, y = function() {
          var w = getContainerVisibility(h), S = d.find(function(P) {
            var L = P.visibility;
            return L && w >= L[0] && w <= L[1];
          });
          if (S) {
            if (S.type === "seek" && S.visibility && S.frames.length === 2) {
              var M = S.frames[0] + Math.ceil((w - S.visibility[0]) / (S.visibility[1] - S.visibility[0]) * S.frames[1]);
              //! goToAndStop must be relative to the start of the current segment
              c.goToAndStop(M - c.firstFrame - 1, !0);
            }
            S.type === "loop" && (v === null || v !== S.frames || c.isPaused) && (c.playSegments(S.frames, !0), v = S.frames), S.type === "play" && c.isPaused && (c.resetSegments(!0), c.play()), S.type === "stop" && c.goToAndStop(S.frames[0] - c.firstFrame - 1, !0);
          }
        };
        return document.addEventListener("scroll", y), function() {
          document.removeEventListener("scroll", y);
        };
      }, m = function() {
        var v = function(S, M) {
          var P = S, L = M;
          if (P !== -1 && L !== -1) {
            var I = getContainerCursorPosition(h, P, L);
            P = I.x, L = I.y;
          }
          var T = d.find(function(A) {
            var k = A.position;
            return k && Array.isArray(k.x) && Array.isArray(k.y) ? P >= k.x[0] && P <= k.x[1] && L >= k.y[0] && L <= k.y[1] : k && !Number.isNaN(k.x) && !Number.isNaN(k.y) ? P === k.x && L === k.y : !1;
          });
          if (T) {
            if (T.type === "seek" && T.position && Array.isArray(T.position.x) && Array.isArray(T.position.y) && T.frames.length === 2) {
              var E = (P - T.position.x[0]) / (T.position.x[1] - T.position.x[0]), R = (L - T.position.y[0]) / (T.position.y[1] - T.position.y[0]);
              c.playSegments(T.frames, !0), c.goToAndStop(Math.ceil((E + R) / 2 * (T.frames[1] - T.frames[0])), !0);
            }
            T.type === "loop" && c.playSegments(T.frames, !0), T.type === "play" && (c.isPaused && c.resetSegments(!1), c.playSegments(T.frames)), T.type === "stop" && c.goToAndStop(T.frames[0], !0);
          }
        }, y = function(S) {
          v(S.clientX, S.clientY);
        }, x = function() {
          v(-1, -1);
        };
        return h.addEventListener("mousemove", y), h.addEventListener("mouseout", x), function() {
          h.removeEventListener("mousemove", y), h.removeEventListener("mouseout", x);
        };
      };
      switch (u) {
        case "scroll":
          return p();
        case "cursor":
          return m();
      }
    }
  }, [u, c]);
}, useLottieInteractivity = function r(a) {
  var s = a.actions, c = a.mode, u = a.lottieObj, d = u.animationItem, h = u.View, p = u.animationContainerRef;
  return useInitInteractivity({
    actions: s,
    animationItem: d,
    mode: c,
    wrapperRef: p
  }), h;
}, _excluded$5 = ["style", "interactivity"], Lottie$1 = function r(a) {
  var s, c, u, d = a.style, h = a.interactivity, p = _objectWithoutProperties(a, _excluded$5), m = useLottie(p, d), g = m.View, v = m.play, y = m.stop, x = m.pause, w = m.setSpeed, S = m.goToAndStop, M = m.goToAndPlay, P = m.setDirection, L = m.playSegments, I = m.setSubframe, T = m.getDuration, E = m.destroy, R = m.animationContainerRef, A = m.animationLoaded, k = m.animationItem;
  return useEffect$1(function() {
    a.lottieRef && (a.lottieRef.current = {
      play: v,
      stop: y,
      pause: x,
      setSpeed: w,
      goToAndPlay: M,
      goToAndStop: S,
      setDirection: P,
      playSegments: L,
      setSubframe: I,
      getDuration: T,
      destroy: E,
      animationContainerRef: R,
      animationLoaded: A,
      animationItem: k
    });
  }, [(s = a.lottieRef) === null || s === void 0 ? void 0 : s.current]), useLottieInteractivity({
    lottieObj: {
      View: g,
      play: v,
      stop: y,
      pause: x,
      setSpeed: w,
      goToAndStop: S,
      goToAndPlay: M,
      setDirection: P,
      playSegments: L,
      setSubframe: I,
      getDuration: T,
      destroy: E,
      animationContainerRef: R,
      animationLoaded: A,
      animationItem: k
    },
    actions: (c = h == null ? void 0 : h.actions) !== null && c !== void 0 ? c : [],
    mode: (u = h == null ? void 0 : h.mode) !== null && u !== void 0 ? u : "scroll"
  });
};
const gradientMove = keyframes`
  0% { background-position: 100% 0%; }
  25% { background-position: 75% 25%; }
  50% { background-position: 50% 50%; }
  75% { background-position: 25% 75%; }
  100% { background-position: 0% 90%; }
`, breathing = keyframes`
  0% { transform: scale(0.9); }
  25% { transform: scale(1.2); }
  60% { transform: scale(1.1); }
  100% { transform: scale(0.9); }
`, appear = keyframes`
  0% { transform: scale(0); }
  100% { transform: scale(1); }
`, disappear = keyframes`
  0% { transform: scale(1); }
  100% { transform: scale(0); }
`, shiftRight = keyframes`
  0% { transform: translateX(0px); }
  100% { transform: translateX(16px); }
`, cssAnimations = {
  breathing: { keyframes: breathing, animation: "2s linear infinite" },
  gradientMove: { keyframes: gradientMove, animation: "5s linear" },
  appear: { keyframes: appear, animation: "0.6s ease infinite" },
  disappear: { keyframes: disappear, animation: "0.6s ease infinite" },
  shiftRight: { keyframes: shiftRight, animation: "0.6s ease infinite" }
}, defaultComponentColors = {
  button: {
    textPrimary: {
      rest: { label: "{semantic.text.primary}" },
      hover: { label: "{semantic.text.brand.rest}" },
      pressed: { label: "{semantic.text.brand.hover}" },
      disabled: { label: "{semantic.text.disabled}" }
    },
    textSecondary: {
      rest: { label: "{semantic.text.brand.rest}" },
      hover: { label: "{semantic.text.brand.hover}" },
      pressed: { label: "{semantic.text.brand.pressed}" },
      disabled: { label: "{semantic.text.disabled}" }
    },
    textCritical: {
      rest: { label: "{semantic.text.critical.rest}" },
      hover: { label: "{semantic.text.critical.hover}" },
      pressed: { label: "{semantic.text.critical.pressed}" },
      disabled: { label: "{semantic.text.disabled}" }
    },
    textInverse: {
      rest: { label: "{semantic.link.inverse.rest}" },
      hover: { label: "{semantic.link.inverse.hover}" },
      pressed: { label: "{semantic.link.inverse.pressed}" },
      disabled: { label: "{semantic.link.inverse.disabled}" }
    }
  },
  tab: {
    default: {
      rest: { label: "{semantic.text.secondary}", border: "{semantic.border.static}" },
      pressed: { label: "{semantic.text.brand.pressed}", border: "{semantic.border.static}" },
      hover: { label: "{semantic.text.brand.hover}", border: "{semantic.border.static}" },
      selected: { label: "{semantic.text.brand.rest}", border: "{semantic.border.brand}" }
    },
    neutral: {
      rest: { label: "{semantic.text.secondary}", border: "{semantic.border.static}" },
      pressed: { label: "{semantic.text.primary}", border: "{semantic.border.static}" },
      hover: { label: "{semantic.text.primary}", border: "{semantic.border.static}" },
      selected: { label: "{semantic.text.primary}", border: "{semantic.border.neutral}" }
    }
  },
  pill: {
    secondaryWarning: {
      rest: {
        label: "{semantic.text.primary}"
      }
    },
    secondaryCritical: {
      rest: {
        label: "{semantic.text.critical.onColor}"
      }
    },
    secondarySuccess: {
      rest: {
        label: "{semantic.text.success.onColor}"
      }
    },
    secondaryNeutral: {
      rest: {
        label: "{semantic.text.primary}"
      }
    },
    secondaryBrand: {
      rest: {
        label: "{semantic.text.brand.onColor}"
      }
    },
    secondaryInformative: {
      rest: {
        label: "{semantic.text.informative.onColor}"
      }
    }
  }
}, defaultGlobalBorderRadii = {
  none: "0",
  50: "2px",
  100: "4px",
  200: "8px",
  300: "12px",
  400: "16px",
  600: "24px",
  // We use 9999px for the border-radius because using 100% creates elliptical corners, which is not the desired outcome.
  full: "9999px"
}, defaultGlobalColors = {
  neutral: {
    100: "#ffffff",
    200: "#f8fafc",
    300: "#f1f5f8",
    400: "#e4e7ec",
    500: "#c3cad5",
    600: "#8b95a9",
    700: "#646F87",
    800: "#475467",
    900: "#344054",
    1e3: "#18191b",
    A0: "#ffffff00",
    A15: "#ffffff26",
    A35: "#ffffff59",
    A60: "#ffffff99",
    A80: "#ffffffcc"
  },
  brand: {
    100: "#f6f2fd",
    200: "#e4dbff",
    300: "#d9ccff",
    400: "#c9b6ff",
    500: "#b79eff",
    600: "#9470ff",
    700: "#7849ff",
    800: "#5f33e6",
    900: "#4315cb",
    1e3: "#321098"
  },
  brandSecondary: {
    100: "#f3f0ff",
    200: "#e4dbff",
    300: "#d9ccff",
    400: "#c9b6ff",
    500: "#b79eff",
    600: "#9470ff",
    700: "#7849ff",
    800: "#5f33e6",
    900: "#4315cb",
    1e3: "#321098"
  },
  warning: {
    100: "#fff8e6",
    200: "#fff0ca",
    300: "#ffe9b2",
    400: "#ffe299",
    500: "#ffd875",
    600: "#fdc535",
    700: "#fdb702",
    800: "#e6a702",
    900: "#b88501",
    1e3: "#986e01"
  },
  success: {
    100: "#dff5e7",
    200: "#b1e2c4",
    300: "#9bdab3",
    400: "#7dcf9d",
    500: "#54bf7e",
    600: "#41ae6c",
    700: "#028838",
    800: "#00702d",
    900: "#014b1f",
    1e3: "#012811"
  },
  informative: {
    100: "#e6f0fe",
    200: "#c7dafd",
    300: "#b5cefc",
    400: "#a2c1fb",
    500: "#8fb4fa",
    600: "#5484f8",
    700: "#306af7",
    800: "#2256d6",
    900: "#0351c0",
    1e3: "#023d91"
  },
  critical: {
    100: "#fde7e9",
    200: "#fac4c9",
    300: "#f9b4ba",
    400: "#f79ca4",
    500: "#f57f89",
    600: "#f14755",
    700: "#d80e25",
    800: "#c50c22",
    900: "#8d0411",
    1e3: "#6d030d"
  },
  decorative: { 1: "#ead6d4", 2: "#ffe0d6", 3: "#ffd0ea", 4: "#d9e1fd", 5: "#c9f8f8" },
  focus: { primary: "#0548cf", inverse: "#3798f2" }
}, defaultSemanticBorderRadii = {
  action: { medium: "{global.200}" },
  container: { small: "{global.200}", medium: "{global.300}", large: "{global.600}" },
  input: { small: "{global.100}", medium: "{global.200}" }
}, defaultSemanticColors = {
  background: {
    primary: "{global.neutral.100}",
    secondary: "{global.neutral.200}",
    brand: {
      primary: "{global.brand.700}",
      secondary: "{global.brand.100}"
    }
  },
  surface: {
    primary: {
      rest: "{global.neutral.100}",
      hover: "{global.neutral.300}",
      pressed: "{global.neutral.400}",
      selected: "{global.brand.100}",
      disabled: "{global.neutral.300}"
    },
    secondary: {
      rest: "{global.neutral.200}",
      hover: "{global.neutral.400}",
      pressed: "{global.neutral.500}",
      selected: "{global.brand.100}",
      disabled: "{global.neutral.300}"
    },
    inverse: "{global.neutral.1000}"
  },
  action: {
    primary: {
      rest: "{global.brand.700}",
      hover: "{global.brand.800}",
      pressed: "{global.brand.900}",
      disabled: "{global.neutral.300}"
    },
    secondary: {
      rest: "{global.neutral.A0}",
      hover: "{global.brand.100}",
      pressed: "{global.brand.200}",
      disabled: "{global.neutral.300}"
    },
    tertiary: {
      rest: "{global.neutral.A0}",
      hover: "{global.neutral.300}",
      pressed: "{global.neutral.400}",
      disabled: "{global.neutral.300}"
    },
    success: {
      rest: "{global.success.700}",
      hover: "{global.success.800}",
      pressed: "{global.success.900}",
      disabled: "{global.neutral.300}"
    },
    criticalPrimary: {
      rest: "{global.critical.700}",
      hover: "{global.critical.800}",
      pressed: "{global.critical.900}",
      disabled: "{global.neutral.300}"
    },
    criticalSecondary: {
      rest: "{global.neutral.A0}",
      hover: "{global.critical.100}",
      pressed: "{global.critical.200}",
      disabled: "{global.neutral.300}"
    },
    inversePrimary: {
      rest: "{global.neutral.100}",
      hover: "{global.neutral.A80}",
      pressed: "{global.neutral.A60}",
      disabled: "{global.neutral.300}"
    },
    inverseSecondary: {
      rest: "{global.neutral.A0}",
      hover: "{global.neutral.A15}",
      pressed: "{global.neutral.A35}",
      disabled: "{global.neutral.300}"
    },
    inverseTertiary: {
      rest: "{global.neutral.A0}",
      hover: "{global.neutral.A15}",
      pressed: "{global.neutral.A35}",
      disabled: "{global.neutral.300}"
    }
  },
  fill: {
    primary: "{global.neutral.100}",
    secondary: "{global.neutral.300}",
    tertiary: "{global.neutral.400}",
    disabled: "{global.neutral.300}",
    inverse: "{global.neutral.1000}",
    readOnly: "{global.neutral.700}",
    brand: {
      primary: "{global.brand.700}",
      secondary: "{global.brand.100}"
    },
    informative: {
      primary: "{global.informative.700}",
      secondary: "{global.informative.100}"
    },
    critical: {
      primary: "{global.critical.700}",
      secondary: "{global.critical.100}"
    },
    success: {
      primary: "{global.success.700}",
      secondary: "{global.success.100}"
    },
    warning: {
      primary: "{global.warning.700}",
      secondary: "{global.warning.100}"
    },
    decorative: {
      1: "{global.decorative.1}",
      2: "{global.decorative.2}",
      3: "{global.decorative.3}",
      4: "{global.decorative.4}",
      5: "{global.decorative.5}"
    }
  },
  text: {
    primary: "{global.neutral.1000}",
    secondary: "{global.neutral.700}",
    inverse: "{global.neutral.100}",
    disabled: "{global.neutral.500}",
    brand: {
      rest: "{global.brand.700}",
      hover: "{global.brand.800}",
      pressed: "{global.brand.900}",
      onColor: "{global.brand.900}"
    },
    informative: {
      rest: "{global.informative.700}",
      hover: "{global.informative.800}",
      pressed: "{global.informative.900}",
      onColor: "{global.informative.900}"
    },
    critical: {
      rest: "{global.critical.700}",
      hover: "{global.critical.800}",
      pressed: "{global.critical.900}",
      onColor: "{global.critical.900}"
    },
    success: {
      rest: "{global.success.700}",
      hover: "{global.success.800}",
      pressed: "{global.success.900}",
      onColor: "{global.success.900}"
    }
  },
  link: {
    primary: {
      rest: "{global.neutral.1000}",
      hover: "{global.neutral.1000}",
      pressed: "{global.neutral.700}",
      disabled: "{global.neutral.500}"
    },
    secondary: {
      rest: "{global.brand.700}",
      hover: "{global.brand.800}",
      pressed: "{global.brand.900}",
      disabled: "{global.neutral.500}"
    },
    inverse: {
      rest: "{global.neutral.100}",
      hover: "{global.neutral.A80}",
      pressed: "{global.neutral.A60}",
      disabled: "{global.neutral.A35}"
    }
  },
  border: {
    static: "{global.neutral.400}",
    interactive: {
      rest: "{global.neutral.600}",
      hover: "{global.neutral.1000}",
      selected: "{global.brand.700}",
      disabled: "{global.neutral.400}"
    },
    inverse: "{global.neutral.100}",
    brand: "{global.brand.700}",
    critical: "{global.critical.700}",
    success: "{global.success.700}",
    warning: "{global.warning.700}",
    informative: "{global.informative.700}",
    neutral: "{global.neutral.1000}"
  },
  icon: {
    primary: "{global.neutral.1000}",
    disabled: "{global.neutral.500}",
    readOnly: "{global.neutral.700}",
    inverse: "{global.neutral.100}",
    inverseDisabled: "{global.neutral.A35}",
    brand: "{global.brand.700}",
    informative: "{global.informative.700}",
    critical: "{global.critical.700}",
    success: "{global.success.700}",
    warning: "{global.warning.700}"
  },
  illustration: {
    background: "{global.neutral.100}",
    border: "{global.neutral.1000}",
    critical: "{global.critical.700}",
    success: "{global.success.700}",
    brand: {
      primary: "{global.brand.700}",
      secondary: "{global.brand.100}"
    }
  },
  focus: {
    primary: "{global.focus.primary}",
    inverse: "{global.focus.inverse}"
  }
}, defaultDesignTokens = {
  colors: {
    global: defaultGlobalColors,
    semantic: defaultSemanticColors,
    component: defaultComponentColors
  },
  borderRadii: {
    global: defaultGlobalBorderRadii,
    semantic: defaultSemanticBorderRadii
  }
};
var flat = flatten;
flatten.flatten = flatten;
flatten.unflatten = unflatten;
function isBuffer$3(r) {
  return r && r.constructor && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function keyIdentity(r) {
  return r;
}
function flatten(r, a) {
  a = a || {};
  const s = a.delimiter || ".", c = a.maxDepth, u = a.transformKey || keyIdentity, d = {};
  function h(p, m, g) {
    g = g || 1, Object.keys(p).forEach(function(v) {
      const y = p[v], x = a.safe && Array.isArray(y), w = Object.prototype.toString.call(y), S = isBuffer$3(y), M = w === "[object Object]" || w === "[object Array]", P = m ? m + s + u(v) : u(v);
      if (!x && !S && M && Object.keys(y).length && (!a.maxDepth || g < c))
        return h(y, P, g + 1);
      d[P] = y;
    });
  }
  return h(r), d;
}
function unflatten(r, a) {
  a = a || {};
  const s = a.delimiter || ".", c = a.overwrite || !1, u = a.transformKey || keyIdentity, d = {};
  if (isBuffer$3(r) || Object.prototype.toString.call(r) !== "[object Object]")
    return r;
  function p(v) {
    const y = Number(v);
    return isNaN(y) || v.indexOf(".") !== -1 || a.object ? v : y;
  }
  function m(v, y, x) {
    return Object.keys(x).reduce(function(w, S) {
      return w[v + s + S] = x[S], w;
    }, y);
  }
  function g(v) {
    const y = Object.prototype.toString.call(v), x = y === "[object Array]", w = y === "[object Object]";
    if (v) {
      if (x)
        return !v.length;
      if (w)
        return !Object.keys(v).length;
    } else return !0;
  }
  return r = Object.keys(r).reduce(function(v, y) {
    const x = Object.prototype.toString.call(r[y]);
    return !(x === "[object Object]" || x === "[object Array]") || g(r[y]) ? (v[y] = r[y], v) : m(
      y,
      v,
      flatten(r[y], a)
    );
  }, {}), Object.keys(r).forEach(function(v) {
    const y = v.split(s).map(u);
    let x = p(y.shift()), w = p(y[0]), S = d;
    for (; w !== void 0; ) {
      if (x === "__proto__")
        return;
      const M = Object.prototype.toString.call(S[x]), P = M === "[object Object]" || M === "[object Array]";
      if (!c && !P && typeof S[x] < "u")
        return;
      (c && !P || !c && S[x] == null) && (S[x] = typeof w == "number" && !a.object ? [] : {}), S = S[x], y.length > 0 && (x = p(y.shift()), w = p(y[0]));
    }
    S[x] = unflatten(r[v], a);
  }), d;
}
const replaceReferenceTokens = (r, a) => {
  if (!r) return r;
  const s = flat.flatten(a), c = (u, d) => {
    if (typeof d == "object")
      return d;
    const h = Object.keys(s).find(
      (p) => d === `{${p}}`
    );
    return h ? s[h] : d;
  };
  return JSON.parse(JSON.stringify(r), c);
}, getBorderRadii = (r) => {
  const a = lodashExports.merge(lodashExports.cloneDeep(defaultDesignTokens.borderRadii), lodashExports.cloneDeep(r)), s = replaceReferenceTokens(a.semantic, { global: a.global });
  return { ...a, semantic: s };
}, surface = {
  default: "1px solid global.neutral.400",
  empty: "1px solid global.neutral.300",
  transparent: "1px solid transparent"
}, basic$1 = {
  critical: "1px solid global.critical.700",
  success: "1px solid global.success.700",
  warning: "1px solid global.warning.700",
  info: "1px solid global.informative.700",
  brand: "1px solid global.brand.700",
  black: "1px solid global.neutral.1000",
  dark: "1px solid global.neutral.600",
  darker: "1px solid global.neutral.800",
  darkest: "1px solid global.neutral.900",
  light: "1px solid global.neutral.400",
  lighter: "1px solid global.neutral.300",
  white: "1px solid global.neutral.100"
}, selection = {
  selectedBrand: "2px solid global.brand.700",
  selectedNeutral: "2px solid global.neutral.1000",
  disabled: "2px solid global.neutral.400",
  transparent: "2px solid transparent"
}, input$1 = {
  enabled: "1px solid global.neutral.400",
  hover: "1px solid global.neutral.600",
  readOnly: "1px solid global.neutral.400",
  disabled: "1px solid global.neutral.400",
  error: "1px solid global.critical.700",
  brand: "1px solid global.brand.700",
  transparent: "1px solid transparent"
}, inputThick = {
  enabled: "2px solid global.neutral.600",
  focused: "2px solid global.neutral.1000",
  hover: "2px solid global.neutral.900",
  readOnly: "2px solid global.neutral.800",
  disabled: "2px solid global.neutral.400",
  error: "2px solid global.critical.700",
  brand: "2px solid global.brand.700",
  transparent: "2px solid transparent"
}, textArea = {
  enabled: "1px solid global.neutral.400",
  hover: "1px solid global.neutral.600",
  readOnly: "1px solid global.neutral.300",
  disabled: "1px solid global.neutral.400",
  error: "1px solid global.critical.700",
  brand: "1px solid global.brand.700"
}, inputDashed = {
  enabled: "1px dashed global.neutral.600",
  focused: "1px dashed global.neutral.1000",
  hover: "1px dashed global.neutral.900",
  readOnly: "1px dashed global.neutral.800",
  disabled: "1px dashed global.neutral.400",
  error: "1px dashed global.critical.700",
  transparent: "1px dashed transparent"
}, inputDashedThick = {
  enabled: "2px dashed global.neutral.600",
  focused: "2px dashed global.neutral.1000",
  hover: "2px dashed global.neutral.900",
  readOnly: "2px dashed global.neutral.800",
  disabled: "2px dashed global.neutral.400",
  error: "2px dashed global.critical.700",
  transparent: "2px dashed transparent"
}, defaultBorders = {
  surface,
  basic: basic$1,
  selection,
  input: input$1,
  "input-thick": inputThick,
  "text-area": textArea,
  "input-dashed": inputDashed,
  "input-dashed-thick": inputDashedThick
}, getBorders = (r) => {
  const a = lodashExports.cloneDeep(defaultBorders);
  return Object.values(a).forEach((s) => {
    Object.entries(s).forEach(([c, u]) => {
      const [d, h, p] = u.split(" ");
      s[c] = `${d} ${h} ${lodashExports.get(r, p, "transparent")}`;
    });
  }), { none: 0, ...a };
}, themeBreakpoints = {
  xs: "0px",
  // 0 - 599
  s: "600px",
  // 600 - 904
  m: "905px",
  // 905 - 1239
  l: "1240px",
  // 1240 - 1439
  xl: "1440px"
  // 1440
}, getColorPalettes = (r) => {
  const a = getThemeColorsFromTokens(defaultDesignTokens.colors, r);
  return Object.values(a).forEach((s) => {
    Object.entries(s).forEach(
      ([c, u]) => s[c] = lodashExports.get(a, u, u)
    );
  }), a;
}, getThemeColorsFromTokens = (r, a) => {
  const s = lodashExports.merge(lodashExports.cloneDeep(r), lodashExports.cloneDeep(a)), c = replaceReferenceTokens(s.semantic, { global: s.global }), u = replaceReferenceTokens(s.component, { global: s.global, semantic: c });
  return { ...s, semantic: c, component: u };
}, fonts = {
  primary: "Poppins, system-ui, sans-serif",
  inherit: "inherit"
}, radii = {
  none: 0,
  s: "2px",
  m: "4px",
  l: "8px",
  xl: "16px",
  xxl: "24px",
  full: "9999px"
}, shadows = {
  0: "none",
  200: "1px 0px 0px #D8D8D8",
  300: "0px -5px 15px rgba(33, 33, 36, 0.05)",
  400: "0px 5px 10px rgba(33, 33, 36, 0.1)",
  500: "0px 5px 15px rgba(33, 33, 36, 0.1)",
  600: "0px 5px 15px rgba(33, 33, 36, 0.2)"
}, sizes = {
  full: "100%"
}, themeSpaces = {
  none: "0",
  xxxs: "2px",
  xxs: "4px",
  xs: "8px",
  "xs-s": "12px",
  s: "16px",
  "s-m": "20px",
  m: "24px",
  l: "32px",
  xl: "40px",
  xxl: "48px",
  xxxl: "72px"
}, getThemeSpacingAsNumber = (r) => Number(themeSpaces[r].split("px")[0]);
Object.keys(themeSpaces).reduce(
  (r, a) => ({
    ...r,
    [a]: a
  }),
  {}
);
const textStyles = {
  display1Semi: {
    fontSize: { xs: "40px", s: "48px" },
    lineHeight: { xs: "48px", s: "60px" },
    fontWeight: 600
  },
  display2Semi: {
    fontSize: { xs: "32px", s: "40px" },
    lineHeight: { xs: "40px", s: "48px" },
    fontWeight: 600
  },
  display2: {
    fontSize: { xs: "32px", s: "40px" },
    lineHeight: { xs: "40px", s: "48px" },
    fontWeight: 400
  },
  heading1Semi: {
    fontSize: { xs: "28px", s: "32px" },
    lineHeight: { xs: "36px", s: "40px" },
    fontWeight: 600
  },
  heading2Semi: {
    fontSize: { xs: "24px", s: "24px" },
    lineHeight: { xs: "32px", s: "32px" },
    fontWeight: 600
  },
  heading2: {
    fontSize: { xs: "24px", s: "24px" },
    lineHeight: { xs: "32px", s: "32px" },
    fontWeight: 400
  },
  heading3Semi: {
    fontSize: { xs: "20px", s: "20px" },
    lineHeight: { xs: "28px", s: "28px" },
    fontWeight: 600
  },
  body1Semi: {
    fontSize: { xs: "20px", s: "20px" },
    lineHeight: { xs: "28px", s: "28px" },
    fontWeight: 600
  },
  body1: {
    fontSize: { xs: "20px", s: "20px" },
    lineHeight: { xs: "28px", s: "28px" },
    fontWeight: 400
  },
  body2Semi: {
    fontSize: { xs: "16px", s: "16px" },
    lineHeight: { xs: "24px", s: "24px" },
    fontWeight: 600
  },
  body2: {
    fontSize: { xs: "16px", s: "16px" },
    lineHeight: { xs: "24px", s: "24px" },
    fontWeight: 400
  },
  body3Semi: {
    fontSize: { xs: "14px", s: "14px" },
    lineHeight: { xs: "20px", s: "20px" },
    fontWeight: 600
  },
  body3: {
    fontSize: { xs: "14px", s: "14px" },
    lineHeight: { xs: "20px", s: "20px" },
    fontWeight: 400
  },
  body4Semi: {
    fontSize: { xs: "12px", s: "12px" },
    lineHeight: { xs: "16px", s: "16px" },
    fontWeight: 600
  },
  body4: {
    fontSize: { xs: "12px", s: "12px" },
    lineHeight: { xs: "16px", s: "16px" },
    fontWeight: 400
  },
  body4SemiUpper: {
    fontSize: { xs: "12px", s: "12px" },
    lineHeight: { xs: "16px", s: "16px" },
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.4px"
  },
  body5SemiUpper: {
    fontSize: { xs: "12px", s: "10px" },
    lineHeight: { xs: "16px", s: "16px" },
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.4px"
  },
  caption1Semi: {
    fontSize: { xs: "12px", s: "10px" },
    lineHeight: { xs: "16px", s: "14px" },
    fontWeight: 600,
    letterSpacing: "0.2px"
  },
  caption1: {
    fontSize: { xs: "12px", s: "10px" },
    lineHeight: { xs: "16px", s: "14px" },
    fontWeight: 400,
    letterSpacing: "0.2px"
  },
  caption1SemiUpper: {
    fontSize: { xs: "12px", s: "10px" },
    lineHeight: { xs: "16px", s: "14px" },
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.2px"
  },
  caption2Semi: {
    fontSize: { xs: "12px", s: "8px" },
    lineHeight: { xs: "16px", s: "12px" },
    fontWeight: 600,
    letterSpacing: "0.2px"
  },
  inline: {
    fontSize: "inherit",
    lineHeight: "inherit",
    fontWeight: "inherit"
  }
}, zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
};
function useCssAnimation(r) {
  const a = usePrefersReducedMotion(), s = cssAnimations[r];
  return a ? void 0 : `${s.keyframes} ${s == null ? void 0 : s.animation}`;
}
const BorderRadiiContext = React__default.createContext({}), BorderRadiiProvider = ({ children: r, borderRadii: a = {} }) => /* @__PURE__ */ jsx(BorderRadiiContext.Provider, { value: getBorderRadii(a), children: r }), ColorPalettesContext = React__default.createContext({}), ColorPalettesProvider = ({ children: r, colors: a }) => /* @__PURE__ */ jsx(ColorPalettesContext.Provider, { value: getColorPalettes(a), children: r }), CDN_URL = "https://penny-static.meliopayments.com", getFlagPath = (r) => `${CDN_URL}/flags/${r}.svg`, flagsMap = {
  AD: getFlagPath("andorra"),
  AE: getFlagPath("united-arab-emirates"),
  AM: getFlagPath("armenia"),
  AR: getFlagPath("argentina"),
  AT: getFlagPath("austria"),
  AU: getFlagPath("australia"),
  AZ: getFlagPath("azerbaijan"),
  BA: getFlagPath("bosnia"),
  BB: getFlagPath("barbados"),
  BD: getFlagPath("bangladesh"),
  BE: getFlagPath("belgium"),
  BF: getFlagPath("burkina"),
  BG: getFlagPath("bulgaria"),
  BH: getFlagPath("bahrain"),
  BI: getFlagPath("burundi"),
  BJ: getFlagPath("benin"),
  BL: getFlagPath("saint-barthelemy"),
  BM: getFlagPath("bermuda"),
  BN: getFlagPath("brunei"),
  BO: getFlagPath("bolivia"),
  // This (BQ) code is used for Bonaire, Saba and Sint Eustatius.
  BQ: getFlagPath("netherlands"),
  BR: getFlagPath("brazil"),
  BS: getFlagPath("bahamas"),
  BT: getFlagPath("bhutan"),
  BV: getFlagPath("bouvet-island"),
  BW: getFlagPath("botswana"),
  BY: getFlagPath("belarus"),
  BZ: getFlagPath("belize"),
  CA: getFlagPath("canada"),
  CC: getFlagPath("cocos-islands"),
  CD: getFlagPath("democratic-republic-of-the-congo"),
  CF: getFlagPath("central-african-republic"),
  CG: getFlagPath("republic-of-the-congo"),
  CH: getFlagPath("switzerland"),
  CI: getFlagPath("ivory-coast"),
  CK: getFlagPath("cook-islands"),
  CL: getFlagPath("chile"),
  CM: getFlagPath("cameroon"),
  CN: getFlagPath("china"),
  CO: getFlagPath("colombia"),
  CR: getFlagPath("costa-rica"),
  CU: getFlagPath("cuba"),
  CV: getFlagPath("cabo-verde"),
  CW: getFlagPath("curacao"),
  CX: getFlagPath("christmas-island"),
  CY: getFlagPath("cyprus"),
  CZ: getFlagPath("czech-republic"),
  DE: getFlagPath("germany"),
  DJ: getFlagPath("djibouti"),
  DK: getFlagPath("denmark"),
  DM: getFlagPath("dominica"),
  DO: getFlagPath("dominican-republic"),
  EC: getFlagPath("ecuador"),
  EE: getFlagPath("estonia"),
  EG: getFlagPath("egypt"),
  EH: getFlagPath("western-sahara"),
  ER: getFlagPath("eritrea"),
  ES: getFlagPath("spain"),
  ET: getFlagPath("ethiopia"),
  EU: getFlagPath("european-union"),
  FI: getFlagPath("finland"),
  FJ: getFlagPath("fiji"),
  FK: getFlagPath("falkland-islands"),
  FM: getFlagPath("micronesia"),
  FO: getFlagPath("faroe-islands"),
  FR: getFlagPath("france"),
  GA: getFlagPath("gabon"),
  // This (GB) code is used for England, Wales, Northern Ireland and Scotland.
  GB: getFlagPath("united-kingdom"),
  GD: getFlagPath("grenada"),
  GE: getFlagPath("georgia"),
  GF: getFlagPath("french-guiana"),
  GG: getFlagPath("guernsey"),
  GH: getFlagPath("ghana"),
  GI: getFlagPath("gibraltar"),
  GM: getFlagPath("gambia"),
  GN: getFlagPath("guinea"),
  GP: getFlagPath("guadeloupe"),
  GQ: getFlagPath("equatorial-guinea"),
  GR: getFlagPath("greece"),
  GS: getFlagPath("sgssi"),
  GT: getFlagPath("guatemala"),
  GU: getFlagPath("guam"),
  GW: getFlagPath("guinea-bissau"),
  GY: getFlagPath("guyana"),
  HK: getFlagPath("hong-kong"),
  HM: getFlagPath("heard-and-mcdonald-islands"),
  HN: getFlagPath("honduras"),
  HR: getFlagPath("croatia"),
  HT: getFlagPath("haiti"),
  HU: getFlagPath("hungary"),
  ID: getFlagPath("indonesia"),
  IE: getFlagPath("ireland"),
  IL: getFlagPath("israel"),
  IM: getFlagPath("isle-of-man"),
  IN: getFlagPath("india"),
  IO: getFlagPath("british-indian-ocean-territory"),
  IQ: getFlagPath("iraq"),
  IR: getFlagPath("iran"),
  IS: getFlagPath("iceland"),
  IT: getFlagPath("italy"),
  JE: getFlagPath("jersey"),
  JM: getFlagPath("jamaica"),
  JO: getFlagPath("jordan"),
  JP: getFlagPath("japan"),
  KE: getFlagPath("kenya"),
  KG: getFlagPath("kyrgyzstan"),
  KH: getFlagPath("cambodia"),
  KI: getFlagPath("kiribati"),
  KM: getFlagPath("comoros"),
  KN: getFlagPath("saint-kitts-and-nevis"),
  KP: getFlagPath("north-korea"),
  KR: getFlagPath("south-korea"),
  KW: getFlagPath("kuwait"),
  KY: getFlagPath("cayman-islands"),
  KZ: getFlagPath("kazakhstan"),
  LA: getFlagPath("laos"),
  LB: getFlagPath("lebanon"),
  LC: getFlagPath("saint-lucia"),
  LI: getFlagPath("liechtenstein"),
  LK: getFlagPath("sri-lanka"),
  LR: getFlagPath("liberia"),
  LS: getFlagPath("lesotho"),
  LT: getFlagPath("lithuania"),
  LU: getFlagPath("luxembourg"),
  LV: getFlagPath("latvia"),
  LY: getFlagPath("libya"),
  MA: getFlagPath("morocco"),
  MC: getFlagPath("monaco"),
  MD: getFlagPath("moldova"),
  ME: getFlagPath("montenegro"),
  MF: getFlagPath("saint-martin"),
  MG: getFlagPath("madagascar"),
  MH: getFlagPath("marshall-islands"),
  MK: getFlagPath("north-macedonia"),
  ML: getFlagPath("mali"),
  MM: getFlagPath("myanmar"),
  MN: getFlagPath("mongolia"),
  MO: getFlagPath("macao"),
  MP: getFlagPath("northern-mariana-islands"),
  MQ: getFlagPath("martinique"),
  MR: getFlagPath("mauritania"),
  MS: getFlagPath("montserrat"),
  MT: getFlagPath("malta"),
  MU: getFlagPath("mauritius"),
  MV: getFlagPath("maldives"),
  MW: getFlagPath("malawi"),
  MX: getFlagPath("mexico"),
  MY: getFlagPath("malaysia"),
  MZ: getFlagPath("mozambique"),
  NA: getFlagPath("namibia"),
  NC: getFlagPath("new-caledonia"),
  NE: getFlagPath("niger"),
  NF: getFlagPath("norfolk-island"),
  NG: getFlagPath("nigeria"),
  NI: getFlagPath("nicaragua"),
  NL: getFlagPath("netherlands"),
  NO: getFlagPath("norway"),
  NP: getFlagPath("nepal"),
  NR: getFlagPath("nauru"),
  NU: getFlagPath("niue"),
  NZ: getFlagPath("new-zealand"),
  OM: getFlagPath("oman"),
  PA: getFlagPath("panama"),
  PE: getFlagPath("peru"),
  PF: getFlagPath("french-polynesia"),
  PG: getFlagPath("papua-new-guinea"),
  PH: getFlagPath("philippines"),
  PK: getFlagPath("pakistan"),
  PL: getFlagPath("poland"),
  PM: getFlagPath("saint-pierre-and-miquelon"),
  PN: getFlagPath("pitcairn-islands"),
  PR: getFlagPath("puerto-rico"),
  PT: getFlagPath("portugal"),
  PW: getFlagPath("palau"),
  PY: getFlagPath("paraguay"),
  QA: getFlagPath("qatar"),
  RE: getFlagPath("reunion"),
  RO: getFlagPath("romania"),
  RS: getFlagPath("serbia"),
  RU: getFlagPath("russia"),
  RW: getFlagPath("rwanda"),
  SA: getFlagPath("saudi-arabia"),
  SB: getFlagPath("solomon-islands"),
  SC: getFlagPath("seychelles"),
  SD: getFlagPath("sudan"),
  SE: getFlagPath("sweden"),
  SG: getFlagPath("singapore"),
  SH: getFlagPath("saint-helena"),
  SI: getFlagPath("slovenia"),
  SK: getFlagPath("slovakia"),
  SL: getFlagPath("sierra-leone"),
  SM: getFlagPath("san-marino"),
  SN: getFlagPath("senegal"),
  SO: getFlagPath("somalia"),
  SR: getFlagPath("suriname"),
  SS: getFlagPath("south-sudan"),
  ST: getFlagPath("sao-tome-and-principe"),
  SV: getFlagPath("el-salvador"),
  SX: getFlagPath("sint-maarten"),
  SY: getFlagPath("syria"),
  SZ: getFlagPath("swaziland"),
  TC: getFlagPath("turks-and-caicos-islands"),
  TD: getFlagPath("chad"),
  TF: getFlagPath("french-southern-and-antarctic-lands"),
  TG: getFlagPath("togo"),
  TH: getFlagPath("thailand"),
  TJ: getFlagPath("tajikistan"),
  TK: getFlagPath("tokelau"),
  TL: getFlagPath("timor-leste"),
  TM: getFlagPath("turkmenistan"),
  TN: getFlagPath("tunisia"),
  TO: getFlagPath("tonga"),
  TR: getFlagPath("turkey"),
  TT: getFlagPath("trinidad-and-tobago"),
  TV: getFlagPath("tuvalu"),
  TW: getFlagPath("taiwan"),
  TZ: getFlagPath("tanzania"),
  UA: getFlagPath("ukraine"),
  UG: getFlagPath("uganda"),
  US: getFlagPath("united-states"),
  UY: getFlagPath("uruguay"),
  UZ: getFlagPath("uzbekistan"),
  VA: getFlagPath("vatican-city"),
  VC: getFlagPath("saint-vincent-and-the-grenadines"),
  VE: getFlagPath("venezuela"),
  VG: getFlagPath("virgin-islands-british"),
  VI: getFlagPath("virgin-islands-us"),
  VN: getFlagPath("vietnam"),
  VU: getFlagPath("vanuatu"),
  WF: getFlagPath("wallis-and-futuna"),
  WS: getFlagPath("samoa"),
  YE: getFlagPath("yemen"),
  YT: getFlagPath("mayotte"),
  ZA: getFlagPath("south-africa"),
  ZM: getFlagPath("zambia"),
  ZW: getFlagPath("zimbabwe")
}, flags = flagsMap, getBrandPath = (r) => `${CDN_URL}/brand/${r}.svg`, brandMap = {
  amex: {
    default: getBrandPath("amex"),
    neutral: getBrandPath("amex-neutral"),
    inverse: getBrandPath("amex-inverse")
  },
  diners: {
    default: getBrandPath("diners"),
    neutral: getBrandPath("diners-neutral"),
    inverse: getBrandPath("diners-inverse")
  },
  mastercard: {
    default: getBrandPath("mastercard"),
    neutral: getBrandPath("mastercard-neutral"),
    inverse: getBrandPath("mastercard-inverse")
  },
  visa: {
    default: getBrandPath("visa"),
    neutral: getBrandPath("visa-neutral"),
    inverse: getBrandPath("visa-inverse")
  },
  discover: {
    default: getBrandPath("discover"),
    neutral: getBrandPath("discover-neutral"),
    inverse: getBrandPath("discover-inverse")
  },
  melio: {
    default: getBrandPath("melio"),
    neutral: getBrandPath("melio-neutral"),
    inverse: getBrandPath("melio-inverse")
  },
  freshbooks: {
    default: getBrandPath("freshbooks"),
    neutral: getBrandPath("freshbooks-neutral"),
    inverse: getBrandPath("freshbooks-inverse")
  },
  quickbooks: {
    default: getBrandPath("quickbooks"),
    neutral: getBrandPath("quickbooks-neutral"),
    inverse: getBrandPath("quickbooks-inverse")
  },
  "credit-key": {
    default: getBrandPath("credit-key"),
    neutral: getBrandPath("credit-key-neutral"),
    inverse: getBrandPath("credit-key-inverse")
  },
  evolve: {
    default: getBrandPath("evolve"),
    neutral: getBrandPath("evolve-neutral"),
    inverse: getBrandPath("evolve-inverse")
  },
  intuit: {
    default: getBrandPath("intuit"),
    neutral: getBrandPath("intuit-neutral"),
    inverse: getBrandPath("intuit-inverse")
  },
  "pci-dds": {
    default: getBrandPath("pci-dss"),
    neutral: getBrandPath("pci-dss-neutral"),
    inverse: getBrandPath("pci-dss-inverse")
  },
  "jp-morgan": {
    default: getBrandPath("jp-morgan"),
    neutral: getBrandPath("jp-morgan-neutral"),
    inverse: getBrandPath("jp-morgan-inverse")
  },
  flex: {
    default: getBrandPath("flex"),
    neutral: getBrandPath("flex-neutral"),
    inverse: getBrandPath("flex-inverse")
  }
}, getBrandSymbolPath = (r) => `${CDN_URL}/brand-symbols/${r}.svg`, brandSymbolsMap = {
  "amex-logo": { default: getBrandSymbolPath("amex"), inverse: getBrandSymbolPath("amex-inverse") },
  google: { default: getBrandSymbolPath("google"), inverse: getBrandSymbolPath("google-inverse") },
  diners: { default: getBrandSymbolPath("diners"), inverse: getBrandSymbolPath("diners-inverse") },
  "us-bank": { default: getBrandSymbolPath("us-bank"), inverse: getBrandSymbolPath("us-bank-inverse") },
  "bank-of-america": {
    default: getBrandSymbolPath("bank-of-america"),
    inverse: getBrandSymbolPath("bank-of-america-inverse")
  },
  "citi-bank": { default: getBrandSymbolPath("citi-bank"), inverse: getBrandSymbolPath("citi-bank-inverse") },
  chase: { default: getBrandSymbolPath("chase"), inverse: getBrandSymbolPath("chase-inverse") },
  "wells-fargo": { default: getBrandSymbolPath("wells-fargo"), inverse: getBrandSymbolPath("wells-fargo-inverse") },
  mastercard: { default: getBrandSymbolPath("mastercard"), inverse: getBrandSymbolPath("mastercard-inverse") },
  visa: { default: getBrandSymbolPath("visa"), inverse: getBrandSymbolPath("visa-inverse") },
  discover: { default: getBrandSymbolPath("discover"), inverse: getBrandSymbolPath("discover-inverse") },
  melio: { default: getBrandSymbolPath("melio"), inverse: getBrandSymbolPath("melio-inverse") },
  "xero-logo": { default: getBrandSymbolPath("xero"), inverse: getBrandSymbolPath("xero-inverse") },
  "freshbooks-logo": { default: getBrandSymbolPath("freshbooks"), inverse: getBrandSymbolPath("freshbooks-inverse") },
  quickbooks: { default: getBrandSymbolPath("quickbooks"), inverse: getBrandSymbolPath("quickbooks-inverse") },
  "credit-key": { default: getBrandSymbolPath("credit-key"), inverse: getBrandSymbolPath("credit-key-inverse") },
  dynamics365bc: { default: getBrandSymbolPath("dynamic365bc"), inverse: getBrandSymbolPath("dynamic365bc-inverse") },
  "capital-one": { default: getBrandSymbolPath("capital-one"), inverse: getBrandSymbolPath("capital-one-inverse") },
  meta: { default: getBrandSymbolPath("meta"), inverse: getBrandSymbolPath("meta-inverse") },
  amazon: { default: getBrandSymbolPath("amazon"), inverse: getBrandSymbolPath("amazon-inverse") },
  gmail: { default: getBrandSymbolPath("gmail"), inverse: getBrandSymbolPath("gmail-inverse") },
  googleAds: { default: getBrandSymbolPath("google-ads"), inverse: getBrandSymbolPath("google-ads-inverse") },
  flex: { default: getBrandSymbolPath("flex"), inverse: getBrandSymbolPath("flex-inverse") },
  "first-financial": {
    default: getBrandSymbolPath("first-financial"),
    inverse: getBrandSymbolPath("first-financial-inverse")
  }
}, iconSizes = ["extra-small", "small", "small-medium", "medium", "large", "extra-large"], iconSizeMapping = {
  "extra-small": "12px",
  small: "16px",
  "small-medium": "20px",
  medium: "24px",
  large: "32px",
  "extra-large": "40px"
}, AddBillLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 4C4.22386 4 4 4.22386 4 4.5V19C4 19.163 4.09516 19.4227 4.33424 19.6632C4.5725 19.9029 4.83077 20 5 20C5.17393 20 5.43238 19.9026 5.66757 19.6672C5.90289 19.4317 6 19.173 6 19C6 17.7448 7.01754 16.7273 8.27273 16.7273H18V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V16.7773C21.1411 17.0089 22 18.0178 22 19.2273V19.5273C22 20.9329 20.8137 22 19.4571 22H5C4.16923 22 3.4275 21.588 2.91576 21.0731C2.40484 20.5591 2 19.8188 2 19V4.5C2 3.11929 3.11929 2 4.5 2H14C14.5523 2 15 2.44772 15 3C15 3.55228 14.5523 4 14 4H4.5ZM7.80204 20H19.4571C19.7978 20 20 19.7417 20 19.5273V19.2273C20 18.9511 19.7761 18.7273 19.5 18.7273H8.27273C8.1221 18.7273 8 18.8494 8 19C8 19.3522 7.92644 19.6893 7.80204 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16 5C16 4.44772 16.4477 4 17 4H18V3C18 2.44772 18.4477 2 19 2C19.5523 2 20 2.44772 20 3V4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H20V7.00011C20 7.55239 19.5523 8.00011 19 8.00011C18.4477 8.00011 18 7.55239 18 7.00011V6H17C16.4477 6 16 5.55228 16 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 10.5C10 9.94772 10.4477 9.5 11 9.5H15C15.5523 9.5 16 9.94772 16 10.5C16 11.0523 15.5523 11.5 15 11.5H11C10.4477 11.5 10 11.0523 10 10.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 14C10 13.4477 10.4477 13 11 13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H11C10.4477 15 10 14.5523 10 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 9.5C6.44772 9.5 6 9.94772 6 10.5C6 11.0523 6.44772 11.5 7 11.5H8C8.55228 11.5 9 11.0523 9 10.5C9 9.94772 8.55228 9.5 8 9.5H7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6 7C6 6.44772 6.44772 6 7 6H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H7C6.44772 8 6 7.55228 6 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H8C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13H7Z",
      fill: "currentColor"
    }
  )
] }), AddBillSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.75 2.5C2.61193 2.5 2.5 2.61193 2.5 2.75V12.8611C2.5 12.9561 2.55748 13.1231 2.71596 13.2825C2.87382 13.4413 3.03974 13.5 3.13889 13.5C3.24156 13.5 3.40762 13.4409 3.56318 13.2852C3.71883 13.1294 3.77778 12.9632 3.77778 12.8611V12.131C3.77778 11.1645 4.56128 10.381 5.52778 10.381H11.75V8.01888C11.75 7.60466 12.0858 7.26888 12.5 7.26888C12.9142 7.26888 13.25 7.60466 13.25 8.01888V10.381C14.2165 10.381 15 11.1645 15 12.131V12.8611C15 13.3251 14.814 13.8197 14.5493 14.1971C14.2958 14.5587 13.8311 15 13.1786 15H3.13889C2.54359 15 2.01507 14.7051 1.6521 14.34C1.28974 13.9754 1 13.4479 1 12.8611V2.75C1 1.7835 1.7835 1 2.75 1H8.50081C8.91503 1 9.25081 1.33579 9.25081 1.75C9.25081 2.16421 8.91503 2.5 8.50081 2.5H2.75ZM5.16513 13.5H13.1593C13.1632 13.4979 13.1686 13.4948 13.1756 13.49C13.2111 13.4661 13.2642 13.4172 13.3212 13.3359C13.445 13.1594 13.5 12.9596 13.5 12.8611V12.131C13.5 11.9929 13.3881 11.881 13.25 11.881H5.52778C5.38971 11.881 5.27778 11.9929 5.27778 12.131V12.8611C5.27778 13.0848 5.2364 13.2996 5.16513 13.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.27344 5C4.27344 4.58579 4.60922 4.25 5.02344 4.25H9.02344C9.43765 4.25 9.77344 4.58579 9.77344 5C9.77344 5.41421 9.43765 5.75 9.02344 5.75H5.02344C4.60922 5.75 4.27344 5.41421 4.27344 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.02344 7.25C4.60922 7.25 4.27344 7.58579 4.27344 8C4.27344 8.41421 4.60922 8.75 5.02344 8.75H9.02344C9.43765 8.75 9.77344 8.41421 9.77344 8C9.77344 7.58579 9.43765 7.25 9.02344 7.25H5.02344Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.2422 3.25C10.2422 2.83579 10.578 2.5 10.9922 2.5H11.7422V1.75C11.7422 1.33579 12.078 1 12.4922 1C12.9064 1 13.2422 1.33579 13.2422 1.75V2.5H13.9922C14.4064 2.5 14.7422 2.83579 14.7422 3.25C14.7422 3.66421 14.4064 4 13.9922 4H13.2422V4.75C13.2422 5.16421 12.9064 5.5 12.4922 5.5C12.078 5.5 11.7422 5.16421 11.7422 4.75V4H10.9922C10.578 4 10.2422 3.66421 10.2422 3.25Z",
      fill: "currentColor"
    }
  )
] }), AddLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L11 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H11L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H13V4Z",
    fill: "currentColor"
  }
) }), AddSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M8.75 2.75C8.75 2.33579 8.41421 2 8 2C7.58579 2 7.25 2.33579 7.25 2.75V7.25H2.75C2.33579 7.25 2 7.58579 2 8C2 8.41421 2.33579 8.75 2.75 8.75H7.25V13.25C7.25 13.6642 7.58579 14 8 14C8.41421 14 8.75 13.6642 8.75 13.25V8.75H13.25C13.6642 8.75 14 8.41421 14 8C14 7.58579 13.6642 7.25 13.25 7.25H8.75V2.75Z",
    fill: "currentColor"
  }
) }), AiFraudDidectionLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 6C9.81643 6 9.63673 6.01649 9.46228 6.04807L8.70711 5.29289C8.31658 4.90237 7.68342 4.90237 7.29289 5.29289C6.90237 5.68342 6.90237 6.31658 7.29289 6.70711L7.6819 7.09611C7.46266 7.36282 7.2885 7.66802 7.17108 8H7C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10V12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H7.76435C8.31354 14.6137 9.1115 15 10 15C10.8885 15 11.6865 14.6137 12.2357 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12V10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8H12.8289C12.7115 7.66802 12.5373 7.36282 12.3181 7.09611L12.7071 6.70711C13.0976 6.31658 13.0976 5.68342 12.7071 5.29289C12.3166 4.90237 11.6834 4.90237 11.2929 5.29289L10.5377 6.04807C10.3633 6.01649 10.1836 6 10 6ZM9 9.0015C9 8.44768 9.44842 8 10 8C10.5516 8 11 8.44768 11 9.0015V11.9985C11 12.5523 10.5516 13 10 13C9.44842 13 9 12.5523 9 11.9985V9.0015Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8477 17.3736 13.5491 16.3216 14.9034L21.7071 20.289C22.0976 20.6795 22.0976 21.3127 21.7071 21.7032C21.3166 22.0937 20.6834 22.0937 20.2929 21.7032L14.9078 16.3181C13.5528 17.3722 11.8497 18 10 18C5.58172 18 2 14.4183 2 10ZM10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4Z",
      fill: "currentColor"
    }
  )
] }), AiFraudDidectionSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.77416 4.76266C6.71239 4.76266 6.65083 4.76454 6.58964 4.76827L5.80042 3.9797C5.5063 3.68581 5.02943 3.68581 4.7353 3.9797C4.44118 4.27358 4.44118 4.75005 4.7353 5.04394L5.05703 5.3654C4.75252 5.64115 4.51471 6.03212 4.51471 6.51932V8.02288C4.51471 8.6298 4.88374 9.08739 5.29106 9.35891C5.70358 9.6339 6.23014 9.77954 6.77416 9.77954C7.31818 9.77954 7.84475 9.6339 8.25727 9.35891C8.66459 9.08739 9.03362 8.6298 9.03362 8.02288V6.51932C9.03362 6.03212 8.79581 5.64115 8.49129 5.3654L8.81303 5.04394C9.10715 4.75005 9.10715 4.27358 8.81303 3.9797C8.5189 3.68581 8.04203 3.68581 7.74791 3.9797L6.95868 4.76827C6.8975 4.76454 6.83594 4.76266 6.77416 4.76266ZM6.12704 6.4353C6.05451 6.48364 6.02895 6.51886 6.02101 6.53377V8.00843C6.02895 8.02334 6.05451 8.05856 6.12704 8.10691C6.25968 8.19533 6.48628 8.27448 6.77416 8.27448C7.06205 8.27448 7.28864 8.19533 7.42129 8.10691C7.49382 8.05856 7.51938 8.02334 7.52732 8.00843V6.53377C7.51938 6.51886 7.49382 6.48364 7.42129 6.4353C7.28864 6.34687 7.06205 6.26772 6.77416 6.26772C6.48628 6.26772 6.25968 6.34687 6.12704 6.4353ZM6.01947 8.00533C6.01877 8.00206 6.01806 8.00052 6.01788 8.00056L6.01801 8.00159C6.01824 8.00239 6.01869 8.00364 6.01947 8.00533ZM7.53029 8.00171C7.5305 8.00097 7.53054 8.00058 7.53045 8.00056C7.53027 8.00052 7.52956 8.00206 7.52886 8.00533L7.53029 8.00171Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 6.77158C1 3.58433 3.58488 1 6.77417 1C9.96346 1 12.5483 3.58433 12.5483 6.77158C12.5483 8.09584 12.1021 9.31602 11.3517 10.29L14.7794 13.7154C15.0735 14.0093 15.0735 14.4858 14.7794 14.7796C14.4852 15.0735 14.0084 15.0735 13.7143 14.7796L10.2858 11.3535C9.31287 12.0996 8.09538 12.5432 6.77417 12.5432C3.58488 12.5432 1 9.95883 1 6.77158ZM6.77417 2.50506C4.4174 2.50506 2.5063 4.41494 2.5063 6.77158C2.5063 9.12822 4.4174 11.0381 6.77417 11.0381C9.13093 11.0381 11.042 9.12822 11.042 6.77158C11.042 4.41494 9.13093 2.50506 6.77417 2.50506Z",
      fill: "currentColor"
    }
  )
] }), ApprovalLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.3893 11.6204C15.6752 11.2122 15.5834 10.6443 15.1843 10.3519C14.7852 10.0596 14.2299 10.1534 13.944 10.5616L11.3832 14.2178L9.97438 12.7179C9.6343 12.3558 9.0716 12.3442 8.71756 12.692C8.36352 13.0398 8.3522 13.6153 8.69229 13.9774L10.842 16.2662C11.025 16.4611 11.2833 16.5626 11.5469 16.5432C11.8104 16.5238 12.0518 16.3855 12.2057 16.1658L15.3893 11.6204Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.2222 2C15.2973 2 16.1941 2.7808 16.4 3.81818H17.7778C19.0051 3.81818 20 4.83572 20 6.09091V19.7273C20 20.9825 19.0051 22 17.7778 22H6.22222C4.99492 22 4 20.9825 4 19.7273V6.09091C4 4.83572 4.99492 3.81818 6.22222 3.81818H7.60002C7.80592 2.7808 8.7027 2 9.77779 2H14.2222ZM9.77779 3.81818C9.53233 3.81818 9.33335 4.02169 9.33335 4.27273V4.72451C9.33507 4.96577 9.42955 5.19669 9.5964 5.36733C9.76324 5.53797 9.98902 5.63459 10.2249 5.63636H13.7751C14.011 5.63459 14.2368 5.53797 14.4036 5.36733C14.5705 5.19669 14.665 4.96576 14.6667 4.72449V4.27273C14.6667 4.02169 14.4677 3.81818 14.2222 3.81818H9.77779ZM6.22222 5.63636H7.71078C7.84277 6.0152 8.05603 6.36325 8.33932 6.65298C8.83776 7.16275 9.51273 7.4508 10.2176 7.45455L13.7778 7.45456L13.7824 7.45453C14.4873 7.45079 15.1623 7.16275 15.6607 6.65298C15.944 6.36325 16.1573 6.0152 16.2893 5.63636H17.7778C18.0232 5.63636 18.2222 5.83987 18.2222 6.09091V19.7273C18.2222 19.9783 18.0232 20.1818 17.7778 20.1818H6.22222C5.97676 20.1818 5.77778 19.9783 5.77778 19.7273V6.09091C5.77778 5.83987 5.97676 5.63636 6.22222 5.63636Z",
      fill: "currentColor"
    }
  )
] }), ApprovalSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.4128 6.88451C10.7442 7.13389 10.8113 7.60561 10.5628 7.93811L8.21886 11.0741C8.08863 11.2483 7.88957 11.3574 7.6731 11.3732C7.45662 11.3889 7.24396 11.3098 7.09005 11.1562L5.50733 9.57716C5.21359 9.2841 5.21223 8.8076 5.50428 8.51286C5.79634 8.21812 6.27121 8.21676 6.56494 8.50981L7.53621 9.47884L9.36281 7.03503C9.61133 6.70252 10.0814 6.63513 10.4128 6.88451Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.77644 1.45027C4.92063 0.626202 5.63744 0 6.50001 0H9.50001C10.3626 0 11.0794 0.626202 11.2236 1.45027H12.25C13.2165 1.45027 14 2.23646 14 3.20627V14.244C14 15.2138 13.2165 16 12.25 16H3.75C2.7835 16 2 15.2138 2 14.244V3.20627C2 2.23646 2.7835 1.45027 3.75 1.45027H4.77644ZM6.50001 1.50514C6.36194 1.50514 6.25001 1.61746 6.25001 1.756V2.00533C6.2511 2.13906 6.30449 2.26693 6.39854 2.36136C6.49257 2.45578 6.61968 2.5092 6.7524 2.51029H9.24762C9.38034 2.5092 9.50745 2.45578 9.60148 2.36136C9.69554 2.26692 9.74892 2.13905 9.75001 2.00532V1.756C9.75001 1.61746 9.63808 1.50514 9.50001 1.50514H6.50001ZM4.98944 2.95541H3.75C3.61193 2.95541 3.5 3.06773 3.5 3.20627V14.244C3.5 14.3825 3.61193 14.4949 3.75 14.4949H12.25C12.3881 14.4949 12.5 14.3825 12.5 14.244V3.20627C12.5 3.06773 12.3881 2.95541 12.25 2.95541H11.0106C10.9188 3.12671 10.802 3.28525 10.6625 3.4253C10.2888 3.80054 9.78262 4.01267 9.25391 4.01542L9.25001 4.01544L6.74611 4.01543C6.2174 4.01268 5.71122 3.80054 5.33751 3.4253C5.19805 3.28525 5.08123 3.12671 4.98944 2.95541Z",
      fill: "currentColor"
    }
  )
] }), ApprovalWorkflowLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7H7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5H6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.5 6C8.5 5.44772 8.94772 5 9.5 5H10.5C11.0523 5 11.5 5.44772 11.5 6C11.5 6.55228 11.0523 7 10.5 7H9.5C8.94772 7 8.5 6.55228 8.5 6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 19.5L4 10L20 10V12.9938C20 13.546 20.4477 13.9938 21 13.9938C21.5523 13.9938 22 13.546 22 12.9938V4.5C22 3.11929 20.8807 2 19.5 2H4.5C3.11929 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11928 22 4.5 22H12.9925C13.5448 22 13.9925 21.5523 13.9925 21C13.9925 20.4477 13.5448 20 12.9925 20H4.5C4.22386 20 4 19.7761 4 19.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5V8L20 8V4.5C20 4.22386 19.7761 4 19.5 4H4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.8 17.6001C22.1314 17.1582 22.0418 16.5314 21.6 16.2001C21.1582 15.8687 20.5314 15.9582 20.2 16.4001L17.8918 19.4777L16.7071 18.293C16.3166 17.9024 15.6834 17.9024 15.2929 18.293C14.9024 18.6835 14.9024 19.3166 15.2929 19.7072L17.2929 21.7072C17.4979 21.9121 17.7817 22.0181 18.0709 21.9975C18.3601 21.977 18.6261 21.832 18.8 21.6001L21.8 17.6001Z",
      fill: "currentColor"
    }
  )
] }), ApprovalWorkflowSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.354 3.25C3.93979 3.25 3.604 3.58579 3.604 4C3.604 4.41421 3.93979 4.75 4.354 4.75H4.854C5.26822 4.75 5.604 4.41421 5.604 4C5.604 3.58579 5.26822 3.25 4.854 3.25H4.354Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.2085 4C6.2085 3.58579 6.54428 3.25 6.9585 3.25H7.4585C7.87271 3.25 8.2085 3.58579 8.2085 4C8.2085 4.41421 7.87271 4.75 7.4585 4.75H6.9585C6.54428 4.75 6.2085 4.41421 6.2085 4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.5 13.25V6.75H13.5V8.0367C13.5 8.45092 13.8358 8.7867 14.25 8.7867C14.6642 8.7867 15 8.45092 15 8.0367V2.75C15 1.7835 14.2165 1 13.25 1H2.75C1.7835 1 1 1.7835 1 2.75V13.25C1 14.2165 1.7835 15 2.75 15H7.99732C8.41154 15 8.74732 14.6642 8.74732 14.25C8.74732 13.8358 8.41154 13.5 7.99732 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25ZM2.75 2.5C2.61193 2.5 2.5 2.61193 2.5 2.75V5.25H13.5V2.75C13.5 2.61193 13.3881 2.5 13.25 2.5H2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.8452 12.1047C15.0972 11.776 15.0349 11.3052 14.7062 11.0532C14.3774 10.8012 13.9066 10.8635 13.6547 11.1922L12.18 13.1163L11.5359 12.4722C11.243 12.1793 10.7681 12.1794 10.4753 12.4723C10.1824 12.7652 10.1824 13.2401 10.4753 13.5329L11.7245 14.782C11.8773 14.9347 12.0885 15.0142 12.3041 15C12.5196 14.9858 12.7186 14.8793 12.8501 14.7079L14.8452 12.1047Z",
      fill: "currentColor"
    }
  )
] }), ArrowDownLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M17.2408 14.3492C17.6002 13.9299 18.2315 13.8813 18.6508 14.2408C19.0701 14.6002 19.1187 15.2315 18.7593 15.6508L12.7635 22.6459C12.7526 22.6587 12.7415 22.6712 12.73 22.6835C12.5575 22.8676 12.3162 22.9864 12.0471 22.9989C12.0315 22.9996 12.0158 23 12 23C11.7689 23 11.547 22.9201 11.3703 22.7768C11.3237 22.7391 11.2804 22.697 11.2408 22.6508L5.24076 15.6508C4.88134 15.2315 4.9299 14.6002 5.34923 14.2408C5.76855 13.8813 6.39985 13.9299 6.75927 14.3492L11 19.2968L11 2C11 1.44772 11.4478 1 12 1C12.5523 1 13 1.44772 13 2L13 19.2967L17.2408 14.3492Z",
    fill: "currentColor"
  }
) }), ArrowDownSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M3.33551 9.70689C3.02961 9.41368 2.53409 9.41409 2.22873 9.70782C1.92338 10.0015 1.92381 10.4774 2.22971 10.7706L7.45629 15.7804C7.60319 15.9212 7.80232 16.0002 8.00988 16C8.21744 15.9998 8.41643 15.9205 8.56307 15.7794L13.7713 10.7696C14.0766 10.4759 14.0762 10.0001 13.7703 9.70688C13.4644 9.41368 12.9689 9.41409 12.6635 9.70782L8.83777 13.3878L8.82802 0.750915C8.8277 0.335889 8.47706 -0.000306798 8.04484 2.10099e-07C7.61261 0.000307641 7.26249 0.337002 7.26281 0.752027L7.27262 13.4807L3.33551 9.70689Z",
    fill: "currentColor"
  }
) }), ArrowLeftLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M9.65067 6.75927C10.07 6.39985 10.1186 5.76855 9.75914 5.34923C9.39971 4.9299 8.76841 4.88134 8.34909 5.24076L1.34909 11.2408C1.19727 11.3709 1.08959 11.542 1.03681 11.7307C1.01254 11.8175 0.999878 11.9081 0.999878 12C0.999878 12.0968 1.01389 12.1919 1.0407 12.2829C1.05344 12.3261 1.06902 12.3682 1.08723 12.4088C1.14689 12.542 1.23567 12.6621 1.34909 12.7593L8.34909 18.7593C8.76842 19.1187 9.39972 19.0701 9.75914 18.6508C10.1186 18.2315 10.07 17.6002 9.65067 17.2408L4.70312 13L22.0001 13C22.5524 13 23.0001 12.5523 23.0001 12C23.0001 11.4477 22.5524 11 22.0001 11L4.70316 11L9.65067 6.75927Z",
    fill: "currentColor"
  }
) }), ArrowLeftSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M6.29311 3.33551C6.58632 3.02961 6.58591 2.53409 6.29218 2.22873C5.99845 1.92338 5.52265 1.92381 5.22944 2.22971L0.219634 7.45629C0.0788298 7.60319 -0.000173569 7.80232 9.53674e-07 8.00988C0.000177383 8.21744 0.0795183 8.41643 0.220571 8.56307L5.23038 13.7713C5.5241 14.0766 5.99991 14.0762 6.29312 13.7703C6.58632 13.4644 6.58591 12.9689 6.29218 12.6635L2.61216 8.83777L15.2491 8.82802C15.6641 8.8277 16.0003 8.47706 16 8.04484C15.9997 7.61261 15.663 7.26249 15.248 7.26281L2.5193 7.27262L6.29311 3.33551Z",
    fill: "currentColor"
  }
) }), ArrowRightLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M14.3493 6.75927C13.93 6.39985 13.8815 5.76855 14.2409 5.34923C14.6003 4.9299 15.2316 4.88134 15.6509 5.24076L22.6509 11.2408C22.8027 11.3709 22.9104 11.542 22.9632 11.7307C22.9875 11.8175 23.0001 11.9081 23.0001 12C23.0001 12.0968 22.9861 12.1919 22.9593 12.2829C22.9466 12.3261 22.931 12.3682 22.9128 12.4088C22.8531 12.542 22.7643 12.6621 22.6509 12.7593L15.6509 18.7593C15.2316 19.1187 14.6003 19.0701 14.2409 18.6508C13.8815 18.2315 13.93 17.6002 14.3493 17.2408L19.2969 13L1.99988 13C1.44759 13 0.999878 12.5523 0.999878 12C0.999878 11.4477 1.44759 11 1.99988 11L19.2969 11L14.3493 6.75927Z",
    fill: "currentColor"
  }
) }), ArrowRightSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M9.70689 3.33551C9.41368 3.02961 9.41409 2.53409 9.70782 2.22873C10.0015 1.92338 10.4774 1.92381 10.7706 2.22971L15.7804 7.45629C15.9212 7.60319 16.0002 7.80232 16 8.00988C15.9998 8.21744 15.9205 8.41643 15.7794 8.56307L10.7696 13.7713C10.4759 14.0766 10.0001 14.0762 9.70688 13.7703C9.41368 13.4644 9.41409 12.9689 9.70782 12.6635L13.3878 8.83777L0.750915 8.82802C0.335889 8.8277 -0.000306798 8.47706 2.10099e-07 8.04484C0.000307641 7.61261 0.337002 7.26249 0.752027 7.26281L13.4807 7.27262L9.70689 3.33551Z",
    fill: "currentColor"
  }
) }), ArrowUpLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M6.75927 9.65079C6.39985 10.0701 5.76855 10.1187 5.34923 9.75926C4.9299 9.39984 4.88134 8.76854 5.24076 8.34921L11.2365 1.3542C11.2481 1.3405 11.26 1.32712 11.2724 1.31406C11.4447 1.13135 11.685 1.01352 11.9529 1.00111C11.9686 1.00037 11.9843 1 12 1C12.2311 1 12.4531 1.07993 12.6298 1.22319C12.6763 1.26091 12.7197 1.30301 12.7593 1.34921L18.7593 8.34921C19.1187 8.76854 19.0701 9.39984 18.6508 9.75926C18.2315 10.1187 17.6002 10.0701 17.2408 9.65079L13 4.70324L13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22L11 4.70328L6.75927 9.65079Z",
    fill: "currentColor"
  }
) }), ArrowUpSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M3.33551 6.29311C3.02961 6.58632 2.53409 6.58591 2.22873 6.29218C1.92338 5.99845 1.92381 5.52265 2.22971 5.22944L7.45629 0.219634C7.60319 0.0788298 7.80232 -0.000173569 8.00988 9.53674e-07C8.21744 0.000177383 8.41643 0.0795183 8.56307 0.220571L13.7713 5.23038C14.0766 5.5241 14.0762 5.99991 13.7703 6.29312C13.4644 6.58632 12.9689 6.58591 12.6635 6.29218L8.83777 2.61216L8.82802 15.2491C8.8277 15.6641 8.47706 16.0003 8.04484 16C7.61261 15.9997 7.26249 15.663 7.26281 15.248L7.27262 2.5193L3.33551 6.29311Z",
    fill: "currentColor"
  }
) }), AttachmentLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3077 3C8.94821 3.00001 7.84615 4.19392 7.84615 5.66667V16.5C7.84615 18.9852 9.7059 21 12 21C14.2941 20.9999 16.1538 18.9852 16.1538 16.5V8.66663C16.1538 8.11434 16.5671 7.66663 17.0769 7.66663C17.5867 7.66663 18 8.11434 18 8.66663V16.5C18 20.0898 15.3137 22.9999 12 23C8.68631 23 6 20.0898 6 16.5V5.66667C6 3.08935 7.9286 1.00002 10.3077 1C12.6867 0.999983 14.6154 3.08932 14.6154 5.66667V16.8333C14.6154 18.3981 13.4445 19.6666 12 19.6666C10.5556 19.6666 9.38462 18.3981 9.38462 16.8333V7.55557C9.38462 7.00328 9.79789 6.55557 10.3077 6.55557C10.8175 6.55557 11.2308 7.00328 11.2308 7.55557V16.8333C11.2308 17.2935 11.5752 17.6666 12 17.6666C12.4248 17.6666 12.7692 17.2935 12.7692 16.8333V5.66667C12.7692 4.1939 11.6672 2.99999 10.3077 3Z",
    fill: "currentColor"
  }
) }), AttachmentSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68721 1.5C5.52287 1.50001 4.57898 2.39668 4.57898 3.50278V11.2501C4.57898 13.0449 6.11063 14.5 8.00002 14.5C9.88939 14.5 11.421 13.0449 11.421 11.2501V5.5833C11.421 5.16909 11.7745 4.8333 12.2105 4.8333C12.6465 4.8333 13 5.16909 13 5.5833V11.2501C13 13.8734 10.7614 16 8.00002 16C5.23859 16 3 13.8734 3 11.2501V3.50278C3 1.56826 4.65081 1.25171e-05 6.6872 0C8.72361 -1.25765e-05 10.3744 1.56824 10.3744 3.50278V10.1347C10.3744 11.3919 9.30161 12.4111 7.9782 12.4111C6.65476 12.4111 5.58189 11.3919 5.58189 10.1347V4.37597C5.58189 3.96175 5.93536 3.62597 6.37138 3.62597C6.80741 3.62597 7.16087 3.96175 7.16087 4.37597V10.1347C7.16087 10.5635 7.5268 10.9111 7.97818 10.9111C8.42955 10.9111 8.79546 10.5635 8.79546 10.1347V3.50278C8.79546 2.39667 7.85156 1.49999 6.68721 1.5Z",
    fill: "currentColor"
  }
) }), AudioLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.607 1.2053C20.8547 1.39449 21 1.68834 21 2.00001V5.97821C21.0003 5.99334 21.0003 6.00843 21 6.02347V17C21 17.1975 20.9427 17.3817 20.8439 17.5367C20.402 18.9636 19.0721 20 17.5 20C15.567 20 14 18.433 14 16.5C14 14.567 15.567 13 17.5 13C18.0368 13 18.5454 13.1208 19 13.3368V7.3095L10 9.76405V19C10 19.0592 9.99485 19.1172 9.98498 19.1736C9.99492 19.2811 10 19.3899 10 19.5C10 21.433 8.433 23 6.5 23C4.567 23 3 21.433 3 19.5C3 17.567 4.567 16 6.5 16C7.0368 16 7.54537 16.1208 8 16.3368V9.02167C7.99967 9.00696 7.99968 8.99228 8 8.97765V5.00001C8 4.54906 8.30182 4.1539 8.73688 4.03525L19.7369 1.03525C20.0376 0.953239 20.3593 1.01612 20.607 1.2053ZM10 7.691L19 5.23646V3.30926L10 5.76381V7.691ZM17.5 15C18.3284 15 19 15.6716 19 16.5C19 17.3284 18.3284 18 17.5 18C16.6716 18 16 17.3284 16 16.5C16 15.6716 16.6716 15 17.5 15ZM5 19.5C5 18.6716 5.67157 18 6.5 18C7.32843 18 8 18.6716 8 19.5C8 20.3284 7.32843 21 6.5 21C5.67157 21 5 20.3284 5 19.5Z",
    fill: "currentColor"
  }
) }), AudioSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6978 0.155585C13.8855 0.297399 13.9959 0.519031 13.9959 0.754279V10.6904C14.0012 10.7569 14.0039 10.8241 14.0039 10.892C14.0039 12.2734 12.8838 13.3933 11.5022 13.3933C10.1205 13.3933 9.00045 12.2734 9.00045 10.892C9.00045 9.51065 10.1205 8.39081 11.5022 8.39081C11.8549 8.39081 12.1905 8.46379 12.4949 8.59545V4.66512L7.00737 6.20491V13.4656L7.00726 13.4787L7.00737 13.5027C7.00737 14.8841 5.8873 16.0039 4.50564 16.0039C3.12397 16.0039 2.00391 14.8841 2.00391 13.5027C2.00391 12.1213 3.12397 11.0015 4.50564 11.0015C4.86143 11.0015 5.19989 11.0757 5.50633 11.2096V2.73858C5.50633 2.40312 5.72904 2.10841 6.05181 2.01676L13.0403 0.032457C13.2667 -0.0318108 13.5101 0.01377 13.6978 0.155585ZM7.00737 4.64619L12.4065 3.13118C12.4359 3.12293 12.4654 3.11655 12.4949 3.11197V1.74742L7.00737 3.30552V4.64619ZM12.4949 10.8701V10.7648C12.4323 10.2723 12.0117 9.89155 11.5022 9.89155C10.9495 9.89155 10.5015 10.3395 10.5015 10.892C10.5015 11.4446 10.9495 11.8925 11.5022 11.8925C12.0313 11.8925 12.4644 11.482 12.5004 10.9622C12.4968 10.932 12.4949 10.9013 12.4949 10.8701ZM3.50494 13.5027C3.50494 12.9501 3.95297 12.5022 4.50564 12.5022C5.0583 12.5022 5.50633 12.9501 5.50633 13.5027C5.50633 14.0552 5.0583 14.5032 4.50564 14.5032C3.95297 14.5032 3.50494 14.0552 3.50494 13.5027Z",
    fill: "currentColor"
  }
) }), BankInLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.44828 5.37265C2.57133 5.73996 2 6.602 2 7.55785C2 8.61405 2.68748 9.50868 3.63672 9.81331V19.9874H3C2.44772 19.9874 2 20.438 2 20.9937C2 21.5495 2.44772 22 3 22H21C21.5523 22 22 21.5495 22 20.9937C22 20.438 21.5523 19.9874 21 19.9874H10.5488V9.92478H13V10.9308C13 11.4866 13.4477 11.9371 14 11.9371C14.5523 11.9371 15 11.4866 15 10.9308V9.92478H18V10.9308C18 11.4866 18.4477 11.9371 19 11.9371C19.5523 11.9371 20 11.4866 20 10.9308V9.92453C20 9.91923 20 9.91395 19.9999 9.90867C19.9998 9.90527 19.9998 9.90188 19.9997 9.89848C21.1318 9.72762 22 8.74476 22 7.55785C22 6.602 21.4287 5.73996 20.5517 5.37265L12.9607 2.19316C12.3458 1.93561 11.6542 1.93561 11.0393 2.19316L3.44828 5.37265ZM11.8079 4.05121C11.9308 3.9997 12.0692 3.9997 12.1921 4.05121L19.7832 7.2307C19.9145 7.28569 20 7.41475 20 7.55785C20 7.75355 19.8423 7.9122 19.6479 7.9122H4.35214C4.15766 7.9122 4 7.75355 4 7.55785C4 7.41475 4.08553 7.28569 4.21682 7.2307L11.8079 4.05121ZM8.54883 9.92478H5.63672V19.9874H8.54883V9.92478Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M22 15.9623C22 15.4065 21.5523 14.956 21 14.956H15.7621L16.6402 14.2196C17.0644 13.8638 17.1218 13.2293 16.7682 12.8024C16.4146 12.3754 15.7841 12.3177 15.3598 12.6735L12.3661 15.184C12.3274 15.2159 12.2912 15.2506 12.2578 15.2879C12.1087 15.4539 12.0139 15.6702 12.0014 15.9085C12.0005 15.9264 12 15.9443 12 15.9623C12 15.9814 12.0005 16.0004 12.0016 16.0193C12.0172 16.2967 12.1464 16.5564 12.3598 16.7353L15.3598 19.2511C15.7841 19.6069 16.4146 19.5492 16.7682 19.1222C17.1218 18.6953 17.0644 18.0607 16.6402 17.705L15.762 16.9686H21C21.5523 16.9686 22 16.518 22 15.9623Z",
      fill: "currentColor"
    }
  )
] }), BankInSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.76774 4.04112C1.29583 4.28806 1 4.77712 1 5.31032C1 6.04015 1.5452 6.64247 2.25 6.73113V13.4961H1.75C1.33579 13.4961 1 13.8323 1 14.2471C1 14.6619 1.33579 14.9982 1.75 14.9982H14.25C14.6642 14.9982 15 14.6619 15 14.2471C15 13.8323 14.6642 13.4961 14.25 13.4961H7.11523V6.74237H8.88477V7.19136C8.88477 7.60615 9.22055 7.94241 9.63477 7.94241C10.049 7.94241 10.3848 7.60615 10.3848 7.19136V6.74237H13.5696C14.3596 6.74237 15 6.10106 15 5.30995C15 4.77727 14.7048 4.28858 14.2337 4.04127L8.82144 1.20031C8.31332 0.933596 7.70693 0.93321 7.19848 1.19928L1.76774 4.04112ZM7.89319 2.53056C7.96582 2.49255 8.05245 2.49261 8.12504 2.53071L13.287 5.24027H2.71495L7.89319 2.53056ZM5.61523 6.74237H3.75V13.4961H5.61523V6.74237Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15 10.2668C15 10.6816 14.6642 11.0179 14.25 11.0179H11.5028L11.7023 11.1679C12.0335 11.417 12.1003 11.8878 11.8516 12.2195C11.6028 12.5511 11.1327 12.6181 10.8015 12.369L8.85837 10.9075C8.64339 10.7754 8.5 10.5379 8.5 10.2668C8.5 10.2434 8.50107 10.2202 8.50317 10.1973C8.52171 9.98552 8.62931 9.79029 8.8009 9.66168L10.8025 8.1615C11.1341 7.91295 11.6042 7.98067 11.8524 8.31275C12.1006 8.64483 12.0329 9.11552 11.7013 9.36407L11.4989 9.51579L14.25 9.51579C14.6642 9.51579 15 9.85204 15 10.2668Z",
      fill: "currentColor"
    }
  )
] }), BankLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44828 5.37265C2.57133 5.73996 2 6.602 2 7.55785C2 8.61442 2.68796 9.50929 3.6377 9.81362V19.9874H3C2.44772 19.9874 2 20.438 2 20.9937C2 21.5495 2.44772 22 3 22H21C21.5523 22 22 21.5495 22 20.9937C22 20.438 21.5523 19.9874 21 19.9874H20.3623V9.81362C21.312 9.50929 22 8.61442 22 7.55785C22 6.602 21.4287 5.73996 20.5517 5.37265L12.9607 2.19316C12.3458 1.93561 11.6542 1.93561 11.0393 2.19316L3.44828 5.37265ZM11.8079 4.05121C11.9308 3.9997 12.0692 3.9997 12.1921 4.05121L19.7832 7.2307C19.9145 7.28569 20 7.41475 20 7.55785C20 7.75355 19.8423 7.9122 19.6479 7.9122H4.35214C4.15766 7.9122 4 7.75355 4 7.55785C4 7.41475 4.08553 7.28569 4.21682 7.2307L11.8079 4.05121ZM18.3623 9.92478H15.4521V19.9874H18.3623V9.92478ZM13.4521 9.92478V19.9874H10.5479V9.92478H13.4521ZM8.54785 9.92478H5.6377V19.9874H8.54785V9.92478Z",
    fill: "currentColor"
  }
) }), BankOutLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.44828 5.37265C2.57133 5.73996 2 6.602 2 7.55785C2 8.61405 2.68748 9.50868 3.63672 9.81331V19.9874H3C2.44772 19.9874 2 20.438 2 20.9937C2 21.5495 2.44772 22 3 22H21C21.5523 22 22 21.5495 22 20.9937C22 20.438 21.5523 19.9874 21 19.9874H10.5488V9.92478H13V10.9308C13 11.4866 13.4477 11.9371 14 11.9371C14.5523 11.9371 15 11.4866 15 10.9308V9.92478H18V10.9308C18 11.4866 18.4477 11.9371 19 11.9371C19.5523 11.9371 20 11.4866 20 10.9308V9.92453C20 9.91923 20 9.91395 19.9999 9.90867C19.9998 9.90527 19.9998 9.90188 19.9997 9.89848C21.1318 9.72762 22 8.74476 22 7.55785C22 6.602 21.4287 5.73996 20.5517 5.37265L12.9607 2.19316C12.3458 1.93561 11.6542 1.93561 11.0393 2.19316L3.44828 5.37265ZM11.8079 4.05121C11.9308 3.9997 12.0692 3.9997 12.1921 4.05121L19.7832 7.2307C19.9145 7.28569 20 7.41475 20 7.55785C20 7.75355 19.8423 7.9122 19.6479 7.9122H4.35214C4.15766 7.9122 4 7.75355 4 7.55785C4 7.41475 4.08553 7.28569 4.21682 7.2307L11.8079 4.05121ZM8.54883 9.92478H5.63672V19.9874H8.54883V9.92478Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 15.9623C12 15.4065 12.4477 14.956 13 14.956H18.2379L17.3598 14.2196C16.9356 13.8638 16.8782 13.2293 17.2318 12.8024C17.5854 12.3754 18.2159 12.3177 18.6402 12.6735L21.634 15.184C21.6527 15.1995 21.6708 15.2156 21.6884 15.2324C21.708 15.2511 21.7268 15.2706 21.7449 15.2908C21.8924 15.4565 21.9862 15.6716 21.9986 15.9085C21.9995 15.9264 22 15.9443 22 15.9623C22 15.9814 21.9995 16.0004 21.9984 16.0193C21.9828 16.2967 21.8536 16.5564 21.6402 16.7353L18.6402 19.2511C18.2159 19.6069 17.5854 19.5492 17.2318 19.1222C16.8782 18.6953 16.9356 18.0607 17.3598 17.705L18.238 16.9686H13C12.4477 16.9686 12 16.518 12 15.9623Z",
      fill: "currentColor"
    }
  )
] }), BankOutSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89319 2.53056C7.96582 2.49255 8.05245 2.49261 8.12504 2.53071L13.287 5.24027H2.71495L7.89319 2.53056ZM1.76774 4.04112C1.29583 4.28806 1 4.77712 1 5.31032C1 6.04015 1.5452 6.64247 2.25 6.73113V13.4979H1.75C1.33579 13.4979 1 13.8342 1 14.249C1 14.6637 1.33579 15 1.75 15H14.25C14.6642 15 15 14.6637 15 14.249C15 13.8342 14.6642 13.4979 14.25 13.4979H7.11523V6.74237H8.88477V7.19333C8.88477 7.60812 9.22055 7.94438 9.63477 7.94438C10.049 7.94438 10.3848 7.60812 10.3848 7.19333V6.74237H13.5696C14.3596 6.74237 15 6.10106 15 5.30995C15 4.77727 14.7048 4.28858 14.2337 4.04127L8.82144 1.20031C8.31332 0.933596 7.70693 0.93321 7.19848 1.19928L1.76774 4.04112ZM5.61523 6.74237H3.75V13.4979H5.61523V6.74237ZM8.5 10.2668C8.5 10.6816 8.83579 11.0179 9.25 11.0179H11.9978L11.7977 11.1684C11.4665 11.4175 11.3997 11.8883 11.6484 12.2199C11.8972 12.5516 12.3673 12.6185 12.6985 12.3694L14.645 10.9054C14.8581 10.773 15 10.5365 15 10.2668C15 10.2396 14.9986 10.2127 14.9957 10.1861C14.9743 9.97886 14.8675 9.78838 14.6991 9.66213L12.6975 8.16194C12.3659 7.9134 11.8958 7.98112 11.6476 8.3132C11.3994 8.64528 11.4671 9.11597 11.7987 9.36451L12.0005 9.51579L9.25 9.51579C8.83579 9.51579 8.5 9.85204 8.5 10.2668Z",
    fill: "currentColor"
  }
) }), BankSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01379 3.36086C1.39993 3.61797 1 4.2214 1 4.89049C1 5.63009 1.48157 6.2565 2.14639 6.46954V13.5912H1.7C1.3134 13.5912 1 13.9066 1 14.2956C1 14.6846 1.3134 15 1.7 15H14.3C14.6866 15 15 14.6846 15 14.2956C15 13.9066 14.6866 13.5912 14.3 13.5912H13.8536V6.46954C14.5184 6.2565 15 5.63009 15 4.8905C15 4.2214 14.6001 3.61797 13.9862 3.36086L8.67248 1.13521C8.24206 0.95493 7.75794 0.95493 7.32752 1.13521L2.01379 3.36086ZM7.8655 2.43585C7.95159 2.39979 8.04841 2.39979 8.13449 2.43585L13.4482 4.66149C13.5401 4.69999 13.6 4.79032 13.6 4.8905C13.6 5.02749 13.4896 5.13854 13.3535 5.13854H2.6465C2.51036 5.13854 2.4 5.02749 2.4 4.89049C2.4 4.79032 2.45987 4.69999 2.55177 4.66149L7.8655 2.43585ZM12.4536 6.54735H10.4165V13.5912H12.4536V6.54735ZM9.0165 6.54735V13.5912H6.9835V6.54735H9.0165ZM5.5835 6.54735H3.54639V13.5912H5.5835V6.54735Z",
    fill: "currentColor"
  }
) }), BillingSettingsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13 8C12.4477 8 12 8.44771 12 9C12 9.55228 12.4477 10 13 10H16C16.5523 10 17 9.55228 17 9C17 8.44771 16.5523 8 16 8H13Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 13C12 12.4477 12.4477 12 13 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H13C12.4477 14 12 13.5523 12 13Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 17C12 16.4477 12.4477 16 13 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H13C12.4477 18 12 17.5523 12 17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 13C7 12.4477 7.44772 12 8 12H9.12537C9.67765 12 10.1254 12.4477 10.1254 13C10.1254 13.5523 9.67765 14 9.12537 14H8C7.44772 14 7 13.5523 7 13Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 8C7.44772 8 7 8.44771 7 9C7 9.55228 7.44772 10 8 10H9.12537C9.67765 10 10.1254 9.55228 10.1254 9C10.1254 8.44771 9.67765 8 9.12537 8H8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 17C7 16.4477 7.44772 16 8 16H9.12537C9.67765 16 10.1254 16.4477 10.1254 17C10.1254 17.5523 9.67765 18 9.12537 18H8C7.44772 18 7 17.5523 7 17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.5 22C19.8807 22 21 20.8807 21 19.5L21 3C21 2.44772 20.5523 2 20 2L18.0578 2C17.861 2 17.6685 2.05809 17.5045 2.167L16.0275 3.14799L14.566 2.16914C14.2233 1.93956 13.7747 1.94405 13.4366 2.18044L12.0574 3.14467L10.539 2.16078C10.2011 1.94185 9.76495 1.94688 9.43222 2.17354L8.00849 3.1434L6.55244 2.16894C6.38787 2.0588 6.19429 2 5.99626 2L4 2C3.44772 2 3 2.44772 3 3L3 19.5C3 20.8807 4.11929 22 5.5 22L18.5 22ZM19 19.5C19 19.7761 18.7761 20 18.5 20L5.5 20C5.22386 20 5 19.7761 5 19.5L5 4L5.69251 4L7.45726 5.18106C7.79632 5.40798 8.23924 5.40616 8.57643 5.17646L10.009 4.20055L11.5348 5.18922C11.8764 5.41055 12.318 5.40278 12.6516 5.16957L14.0217 4.21169L15.4687 5.18086C15.8043 5.4056 16.2421 5.40644 16.5785 5.18301L18.3596 4H19L19 19.5Z",
      fill: "currentColor"
    }
  )
] }), BillingSettingsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.98389 6.45313C3.98389 6.03891 4.31967 5.70313 4.73389 5.70313H5.73389C6.1481 5.70313 6.48389 6.03891 6.48389 6.45313C6.48389 6.86734 6.1481 7.20313 5.73389 7.20313H4.73389C4.31967 7.20313 3.98389 6.86734 3.98389 6.45313Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.98438 9.97656C3.98438 9.56235 4.32016 9.22656 4.73438 9.22656H5.73438C6.14859 9.22656 6.48438 9.56235 6.48438 9.97656C6.48438 10.3908 6.14859 10.7266 5.73438 10.7266H4.73438C4.32016 10.7266 3.98438 10.3908 3.98438 9.97656Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.77783 9.22656C8.36362 9.22656 8.02783 9.56235 8.02783 9.97656C8.02783 10.3908 8.36362 10.7266 8.77783 10.7266H11.2778C11.692 10.7266 12.0278 10.3908 12.0278 9.97656C12.0278 9.56235 11.692 9.22656 11.2778 9.22656H8.77783Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.02783 6.45313C8.02783 6.03891 8.36362 5.70313 8.77783 5.70313H11.2778C11.692 5.70313 12.0278 6.03891 12.0278 6.45313C12.0278 6.86734 11.692 7.20313 11.2778 7.20313H8.77783C8.36362 7.20313 8.02783 6.86734 8.02783 6.45313Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.25 15C14.2165 15 15 14.2165 15 13.25L15 1.75C15 1.33579 14.6642 1 14.25 1H12.7327C12.5865 1 12.4435 1.04271 12.3213 1.12289L11.1464 1.89357L9.98376 1.12447C9.72833 0.95551 9.39583 0.958821 9.14382 1.13284L8.04564 1.89113L6.83804 1.11829C6.58634 0.957209 6.26303 0.960917 6.0151 1.12773L4.88182 1.8902L3.72314 1.12433C3.60046 1.04324 3.45664 1 3.30958 1H1.75C1.33579 1 1 1.33579 1 1.75V13.25C1 14.2165 1.7835 15 2.75 15L13.25 15ZM13.5 13.25C13.5 13.3881 13.3881 13.5 13.25 13.5L2.75 13.5C2.61193 13.5 2.5 13.3881 2.5 13.25L2.5 2.5H3.08411L4.47194 3.41734C4.72459 3.58434 5.05289 3.583 5.30416 3.41394L6.44405 2.64703L7.65713 3.42338C7.91161 3.58623 8.23895 3.5805 8.48757 3.40883L9.57899 2.6552L10.7309 3.41719C10.9809 3.58258 11.3054 3.5832 11.5561 3.41878L12.9567 2.5H13.5L13.5 13.25Z",
      fill: "currentColor"
    }
  )
] }), BillsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 10.5C10 9.94772 10.4477 9.5 11 9.5H15C15.5523 9.5 16 9.94772 16 10.5C16 11.0523 15.5523 11.5 15 11.5H11C10.4477 11.5 10 11.0523 10 10.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 14C10 13.4477 10.4477 13 11 13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H11C10.4477 15 10 14.5523 10 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 9.5C6.44772 9.5 6 9.94772 6 10.5C6 11.0523 6.44772 11.5 7 11.5H8C8.55228 11.5 9 11.0523 9 10.5C9 9.94772 8.55228 9.5 8 9.5H7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6 7C6 6.44772 6.44772 6 7 6H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H7C6.44772 8 6 7.55228 6 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H8C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13H7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 16.7773V4.5C20 3.11929 18.8807 2 17.5 2H4.5C3.11929 2 2 3.11929 2 4.5V19C2 19.8188 2.40484 20.5591 2.91576 21.0731C3.4275 21.588 4.16923 22 5 22H19.4571C20.8137 22 22 20.9329 22 19.5273V19.2273C22 18.0178 21.1411 17.0089 20 16.7773ZM4.5 4C4.22386 4 4 4.22386 4 4.5V19C4 19.163 4.09516 19.4227 4.33424 19.6632C4.5725 19.9029 4.83077 20 5 20C5.17393 20 5.43238 19.9026 5.66757 19.6672C5.90289 19.4317 6 19.173 6 19C6 17.7448 7.01754 16.7273 8.27273 16.7273H18V4.5C18 4.22386 17.7761 4 17.5 4H4.5ZM7.80204 20H19.4571C19.7978 20 20 19.7417 20 19.5273V19.2273C20 18.9511 19.7761 18.7273 19.5 18.7273H8.27273C8.1221 18.7273 8 18.8494 8 19C8 19.3522 7.92644 19.6893 7.80204 20Z",
      fill: "currentColor"
    }
  )
] }), BillsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.27393 5C4.27393 4.58579 4.60971 4.25 5.02393 4.25H9.02393C9.43814 4.25 9.77393 4.58579 9.77393 5C9.77393 5.41421 9.43814 5.75 9.02393 5.75H5.02393C4.60971 5.75 4.27393 5.41421 4.27393 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.02393 7.25C4.60971 7.25 4.27393 7.58579 4.27393 8C4.27393 8.41421 4.60971 8.75 5.02393 8.75H9.02393C9.43814 8.75 9.77393 8.41421 9.77393 8C9.77393 7.58579 9.43814 7.25 9.02393 7.25H5.02393Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9266 10.381V2.75C12.9266 1.7835 12.1431 1 11.1766 1H2.75C1.7835 1 1 1.7835 1 2.75V12.8611C1 13.4479 1.28974 13.9754 1.6521 14.34C2.01507 14.7051 2.54359 15 3.13889 15H13.1786C13.8311 15 14.2958 14.5587 14.5493 14.1971C14.814 13.8197 15 13.3251 15 12.8611V12.131C15 11.1645 14.2165 10.381 13.25 10.381H12.9266ZM2.75 2.5C2.61193 2.5 2.5 2.61193 2.5 2.75V12.8611C2.5 12.9561 2.55748 13.1231 2.71596 13.2825C2.87382 13.4413 3.03974 13.5 3.13889 13.5C3.24156 13.5 3.40762 13.4409 3.56318 13.2852C3.71883 13.1294 3.77778 12.9632 3.77778 12.8611V12.131C3.77778 11.1645 4.56128 10.381 5.52778 10.381H11.4266V2.75C11.4266 2.61193 11.3147 2.5 11.1766 2.5H2.75ZM5.52778 11.881C5.38971 11.881 5.27778 11.9929 5.27778 12.131V12.8611C5.27778 13.0848 5.2364 13.2996 5.16513 13.5H13.1593C13.1632 13.4979 13.1686 13.4948 13.1756 13.49C13.2111 13.4661 13.2642 13.4172 13.3212 13.3359C13.445 13.1594 13.5 12.9596 13.5 12.8611V12.131C13.5 11.9929 13.3881 11.881 13.25 11.881H5.52778Z",
      fill: "currentColor"
    }
  )
] }), CalculatorLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5 5C8.11929 5 7 6.11929 7 7.5V8.5C7 9.88071 8.11929 11 9.5 11H14.5C15.8807 11 17 9.88071 17 8.5V7.5C17 6.11929 15.8807 5 14.5 5H9.5ZM9 7.5C9 7.22386 9.22386 7 9.5 7H14.5C14.7761 7 15 7.22386 15 7.5V8.5C15 8.77614 14.7761 9 14.5 9H9.5C9.22386 9 9 8.77614 9 8.5V7.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.5 14C10.5 13.4477 10.9477 13 11.5 13H12.5C13.0523 13 13.5 13.4477 13.5 14C13.5 14.5523 13.0523 15 12.5 15H11.5C10.9477 15 10.5 14.5523 10.5 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.5 17C10.9477 17 10.5 17.4477 10.5 18C10.5 18.5523 10.9477 19 11.5 19H12.5C13.0523 19 13.5 18.5523 13.5 18C13.5 17.4477 13.0523 17 12.5 17H11.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 14C7 13.4477 7.44772 13 8 13H9C9.55228 13 10 13.4477 10 14C10 14.5523 9.55228 15 9 15H8C7.44772 15 7 14.5523 7 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19H9C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17H8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14 14C14 13.4477 14.4477 13 15 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15C14.4477 15 14 14.5523 14 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H16C16.5523 19 17 18.5523 17 18C17 17.4477 16.5523 17 16 17H15Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5 1C4.11929 1 3 2.11929 3 3.5V20.5C3 21.8807 4.11929 23 5.5 23H18.5C19.8807 23 21 21.8807 21 20.5V3.5C21 2.11929 19.8807 1 18.5 1H5.5ZM5 3.5C5 3.22386 5.22386 3 5.5 3H18.5C18.7761 3 19 3.22386 19 3.5V20.5C19 20.7761 18.7761 21 18.5 21H5.5C5.22386 21 5 20.7761 5 20.5V3.5Z",
      fill: "currentColor"
    }
  )
] }), CalculatorSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 3.00781C5.5335 3.00781 4.75 3.79131 4.75 4.75781V5.75781C4.75 6.72431 5.5335 7.50781 6.5 7.50781H9.5C10.4665 7.50781 11.25 6.72431 11.25 5.75781V4.75781C11.25 3.79131 10.4665 3.00781 9.5 3.00781H6.5ZM6.25 4.75781C6.25 4.61974 6.36193 4.50781 6.5 4.50781H9.5C9.63807 4.50781 9.75 4.61974 9.75 4.75781V5.75781C9.75 5.89588 9.63807 6.00781 9.5 6.00781H6.5C6.36193 6.00781 6.25 5.89588 6.25 5.75781V4.75781Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.50439 10.0078C5.50439 9.5936 5.84018 9.25781 6.25439 9.25781H6.75439C7.16861 9.25781 7.50439 9.5936 7.50439 10.0078C7.50439 10.422 7.16861 10.7578 6.75439 10.7578H6.25439C5.84018 10.7578 5.50439 10.422 5.50439 10.0078Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.25439 11.7578C5.84018 11.7578 5.50439 12.0936 5.50439 12.5078C5.50439 12.922 5.84018 13.2578 6.25439 13.2578H6.75439C7.16861 13.2578 7.50439 12.922 7.50439 12.5078C7.50439 12.0936 7.16861 11.7578 6.75439 11.7578H6.25439Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.49609 10.0078C8.49609 9.5936 8.83188 9.25781 9.24609 9.25781H9.74609C10.1603 9.25781 10.4961 9.5936 10.4961 10.0078C10.4961 10.422 10.1603 10.7578 9.74609 10.7578H9.24609C8.83188 10.7578 8.49609 10.422 8.49609 10.0078Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.24609 11.7578C8.83188 11.7578 8.49609 12.0936 8.49609 12.5078C8.49609 12.922 8.83188 13.2578 9.24609 13.2578H9.74609C10.1603 13.2578 10.4961 12.922 10.4961 12.5078C10.4961 12.0936 10.1603 11.7578 9.74609 11.7578H9.24609Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 0C2.7835 0 2 0.783501 2 1.75V14.25C2 15.2165 2.7835 16 3.75 16H12.25C13.2165 16 14 15.2165 14 14.25V1.75C14 0.783502 13.2165 0 12.25 0H3.75ZM3.5 1.75C3.5 1.61193 3.61193 1.5 3.75 1.5H12.25C12.3881 1.5 12.5 1.61193 12.5 1.75V14.25C12.5 14.3881 12.3881 14.5 12.25 14.5H3.75C3.61193 14.5 3.5 14.3881 3.5 14.25V1.75Z",
      fill: "currentColor"
    }
  )
] }), CalendarLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00012 2C6.55241 2 7.00012 2.44772 7.00012 3V4H17.0001V3C17.0001 2.44772 17.4478 2 18.0001 2C18.5524 2 19.0001 2.44772 19.0001 3V4H19.4999C20.8806 4 21.9999 5.11929 21.9999 6.5V8.97768L22.0001 9V19.5C22.0001 20.8807 20.8808 22 19.5001 22H4.50012C3.11941 22 2.00012 20.8807 2.00012 19.5V9.02232L1.99988 9V6.5C1.99988 5.11929 3.11917 4 4.49988 4H5.00012V3C5.00012 2.44772 5.44784 2 6.00012 2ZM4.49988 6C4.22374 6 3.99988 6.22386 3.99988 6.5V8H19.9999V6.5C19.9999 6.22386 19.776 6 19.4999 6H4.49988ZM20.0001 10H4.00012V19.5C4.00012 19.7761 4.22398 20 4.50012 20H19.5001C19.7763 20 20.0001 19.7761 20.0001 19.5V10Z",
    fill: "currentColor"
  }
) }), CalendarMoveLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 2C6.55228 2 7 2.44772 7 3V4H17V3C17 2.44772 17.4477 2 18 2C18.5523 2 19 2.44772 19 3V4H19.5C20.8807 4 22 5.11929 22 6.5V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V10H4V19.5C4 19.7761 4.22386 20 4.5 20H13C13.5523 20 14 20.4477 14 21C14 21.5523 13.5523 22 13 22H4.5C3.11929 22 2 20.8807 2 19.5V6.5C2 5.11929 3.11929 4 4.5 4H5V3C5 2.44772 5.44772 2 6 2ZM20 8V6.5C20 6.22386 19.7761 6 19.5 6H4.5C4.22386 6 4 6.22386 4 6.5V8H20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14 18.5C14 17.9477 14.4477 17.5 15 17.5L18.2379 17.5L17.3598 16.7682C16.9356 16.4147 16.8782 15.7841 17.2318 15.3598C17.5854 14.9356 18.2159 14.8782 18.6402 15.2318L21.634 17.7266C21.6527 17.742 21.6709 17.758 21.6884 17.7747C21.7085 17.7938 21.7279 17.8137 21.7464 17.8345C21.8931 17.9988 21.9862 18.212 21.9986 18.4466C21.9995 18.4643 22 18.4821 22 18.5C22 18.519 21.9995 18.5379 21.9984 18.5567C21.9828 18.8324 21.8536 19.0904 21.6402 19.2682L18.6402 21.7682C18.2159 22.1218 17.5854 22.0645 17.2318 21.6402C16.8782 21.2159 16.9356 20.5854 17.3598 20.2318L18.238 19.5H15C14.4477 19.5 14 19.0523 14 18.5Z",
      fill: "currentColor"
    }
  )
] }), CalendarMoveSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5835 1.75C4.5835 1.33579 4.24771 1 3.8335 1C3.41928 1 3.0835 1.33579 3.0835 1.75V3H2.75019C1.78371 3 1.00021 3.78348 1.00019 4.74996L1.00015 6.73502L1 6.75L1.00015 6.76495L1 13.25C0.999978 14.2165 1.78349 15 2.75 15H5.91659C6.33081 15 6.66659 14.6642 6.66659 14.25C6.66659 13.8358 6.33081 13.5 5.91659 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25L2.50013 7.5H13.5001V8.73915C13.5001 9.15336 13.8359 9.48915 14.2501 9.48915C14.6643 9.48915 15.0001 9.15336 15.0001 8.73915V4.75C15.0001 3.7835 14.2166 3 13.2501 3H12.9165V1.75C12.9165 1.33579 12.5807 1 12.1665 1C11.7523 1 11.4165 1.33579 11.4165 1.75V3H4.5835V1.75ZM13.5001 6V4.75C13.5001 4.61193 13.3881 4.5 13.2501 4.5H2.75019C2.61212 4.5 2.50019 4.61193 2.50019 4.74999L2.50016 6H13.5001Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.5 12.7305C8.5 12.3163 8.83579 11.9805 9.25 11.9805L12.0034 11.9805L11.7982 11.8263C11.467 11.5775 11.4002 11.1074 11.6489 10.7762C11.8977 10.445 12.3678 10.3782 12.699 10.6269L14.7006 12.1303C14.8893 12.2721 15.0003 12.4945 15.0001 12.7306C15.0001 12.7872 14.9936 12.843 14.9813 12.897C14.9397 13.0804 14.831 13.2382 14.6823 13.3433L12.698 14.8285C12.3664 15.0767 11.8963 15.0091 11.6481 14.6775C11.3999 14.3459 11.4676 13.8758 11.7992 13.6276L11.9958 13.4805L9.25 13.4805C8.83579 13.4805 8.5 13.1447 8.5 12.7305Z",
      fill: "currentColor"
    }
  )
] }), CalendarSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58325 1.75C4.58325 1.33579 4.24747 1 3.83325 1C3.41904 1 3.08325 1.33579 3.08325 1.75V3.08203H2.75C1.7835 3.08203 1 3.86553 1 4.83203V13.2487C1 14.2152 1.7835 14.9987 2.75 14.9987H13.25C14.2165 14.9987 15 14.2152 15 13.2487V4.83203C15 3.86553 14.2165 3.08203 13.25 3.08203H12.9167V1.75C12.9167 1.33579 12.581 1 12.1667 1C11.7525 1 11.4167 1.33579 11.4167 1.75V3.08203H4.58325V1.75ZM13.5 6.20703V4.83203C13.5 4.69396 13.3881 4.58203 13.25 4.58203H12.2113C12.1966 4.5829 12.1817 4.58333 12.1667 4.58333C12.1518 4.58333 12.1369 4.5829 12.1222 4.58203H3.87782C3.86307 4.5829 3.84821 4.58333 3.83325 4.58333C3.81829 4.58333 3.80343 4.5829 3.78869 4.58203H2.75C2.61193 4.58203 2.5 4.69396 2.5 4.83203V6.20703H13.5ZM2.5 7.70703H13.5V13.2487C13.5 13.3868 13.3881 13.4987 13.25 13.4987H2.75C2.61193 13.4987 2.5 13.3868 2.5 13.2487V7.70703Z",
    fill: "currentColor"
  }
) }), CameraLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 13C9 10.2386 11.2386 8 14 8C16.7614 8 19 10.2386 19 13C19 15.7614 16.7614 18 14 18C11.2386 18 9 15.7614 9 13ZM14 10C12.3431 10 11 11.3431 11 13C11 14.6569 12.3431 16 14 16C15.6569 16 17 14.6569 17 13C17 11.3431 15.6569 10 14 10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11H7C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9H6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.79374 3.86783C10.2686 3.31683 10.96 3 11.6874 3H16.2974C17.0394 3 17.743 3.32956 18.218 3.89954L18.9851 4.82009C19.0801 4.93409 19.2208 5 19.3692 5H20.5C21.8807 5 23 6.11929 23 7.5V18.5C23 19.8807 21.8807 21 20.5 21H3.5C2.11929 21 1 19.8807 1 18.5V7.5C1 6.11929 2.11929 5 3.5 5H8.58878C8.73426 5 8.87253 4.93663 8.96751 4.82643L9.79374 3.86783ZM11.6874 5C11.5419 5 11.4037 5.06337 11.3087 5.17357L10.4825 6.13217C10.0075 6.68317 9.3162 7 8.58878 7H3.5C3.22386 7 3 7.22386 3 7.5V18.5C3 18.7761 3.22386 19 3.5 19H20.5C20.7761 19 21 18.7761 21 18.5V7.5C21 7.22386 20.7761 7 20.5 7H19.3692C18.6273 7 17.9237 6.67044 17.4487 6.10046L16.6815 5.17991C16.5866 5.06591 16.4458 5 16.2974 5H11.6874Z",
      fill: "currentColor"
    }
  )
] }), CameraSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.25 8.74609C7.25 7.22731 8.48122 5.99609 10 5.99609C11.5188 5.99609 12.75 7.22731 12.75 8.74609C12.75 10.2649 11.5188 11.4961 10 11.4961C8.48122 11.4961 7.25 10.2649 7.25 8.74609ZM10 7.49609C9.30964 7.49609 8.75 8.05574 8.75 8.74609C8.75 9.43645 9.30964 9.99609 10 9.99609C10.6904 9.99609 11.25 9.43645 11.25 8.74609C11.25 8.05574 10.6904 7.49609 10 7.49609Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.66309 6.25C3.24887 6.25 2.91309 6.58579 2.91309 7C2.91309 7.41421 3.24887 7.75 3.66309 7.75H5.16309C5.5773 7.75 5.91309 7.41421 5.91309 7C5.91309 6.58579 5.5773 6.25 5.16309 6.25H3.66309Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.59453 2.38372C6.90488 2.13533 7.29054 2 7.68805 2H10.9851C11.3368 2 11.6804 2.106 11.971 2.30417L13.001 3.00655C13.0425 3.03486 13.0916 3.05 13.1418 3.05H14.25C15.2165 3.05 16 3.8335 16 4.8V12.25C16 13.2165 15.2165 14 14.25 14H1.75C0.783503 14 0 13.2165 0 12.25V4.8C0 3.8335 0.783502 3.05 1.75 3.05H5.67433C5.73112 3.05 5.78621 3.03067 5.83055 2.99518L6.59453 2.38372ZM7.68805 3.5C7.63126 3.5 7.57617 3.51933 7.53183 3.55482L6.76785 4.16628C6.45751 4.41467 6.07184 4.55 5.67433 4.55H1.75C1.61193 4.55 1.5 4.66193 1.5 4.8V12.25C1.5 12.3881 1.61193 12.5 1.75 12.5H14.25C14.3881 12.5 14.5 12.3881 14.5 12.25V4.8C14.5 4.66193 14.3881 4.55 14.25 4.55H13.1418C12.7901 4.55 12.4465 4.444 12.1559 4.24583L11.1259 3.54345C11.0844 3.51514 11.0353 3.5 10.9851 3.5H7.68805Z",
      fill: "currentColor"
    }
  )
] }), CancelCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289Z",
    fill: "currentColor"
  }
) }), CancelCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99988 -0.00012207C3.5816 -0.00012207 -0.00012207 3.5816 -0.00012207 7.99988C-0.00012207 12.4182 3.5816 15.9999 7.99988 15.9999C12.4182 15.9999 15.9999 12.4182 15.9999 7.99988C15.9999 3.5816 12.4182 -0.00012207 7.99988 -0.00012207ZM10.5555 5.44611C10.8484 5.739 10.8484 6.21388 10.5555 6.50677L9.06433 7.99793L10.5355 9.46908C10.8284 9.76197 10.8284 10.2368 10.5355 10.5297C10.2426 10.8226 9.76771 10.8226 9.47482 10.5297L8.00367 9.05859L6.55021 10.512C6.25732 10.8049 5.78244 10.8049 5.48955 10.512C5.19666 10.2192 5.19666 9.74428 5.48955 9.45138L6.94301 7.99793L5.46954 6.52446C5.17665 6.23157 5.17665 5.7567 5.46954 5.4638C5.76244 5.17091 6.23731 5.17091 6.5302 5.4638L8.00367 6.93727L9.49482 5.44611C9.78771 5.15322 10.2626 5.15322 10.5555 5.44611Z",
    fill: "currentColor"
  }
) }), CancelCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), CancelCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.5555 5.44611C10.8484 5.739 10.8484 6.21388 10.5555 6.50677L9.06433 7.99793L10.5355 9.46908C10.8284 9.76197 10.8284 10.2368 10.5355 10.5297C10.2426 10.8226 9.76771 10.8226 9.47482 10.5297L8.00367 9.05859L6.55021 10.512C6.25732 10.8049 5.78245 10.8049 5.48955 10.512C5.19666 10.2192 5.19666 9.74428 5.48955 9.45138L6.94301 7.99793L5.46955 6.52446C5.17665 6.23157 5.17665 5.7567 5.46955 5.4638C5.76244 5.17091 6.23731 5.17091 6.53021 5.4638L8.00367 6.93727L9.49483 5.44611C9.78772 5.15322 10.2626 5.15322 10.5555 5.44611Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99988 15.9999C12.4182 15.9999 15.9999 12.4182 15.9999 7.99988C15.9999 3.5816 12.4182 -0.00012207 7.99988 -0.00012207C3.5816 -0.00012207 -0.00012207 3.5816 -0.00012207 7.99988C-0.00012207 12.4182 3.5816 15.9999 7.99988 15.9999ZM14.4999 7.99988C14.4999 11.5897 11.5897 14.4999 7.99988 14.4999C4.41003 14.4999 1.49988 11.5897 1.49988 7.99988C1.49988 4.41003 4.41003 1.49988 7.99988 1.49988C11.5897 1.49988 14.4999 4.41003 14.4999 7.99988Z",
      fill: "currentColor"
    }
  )
] }), CaretDownLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M8.11697 9L15.8802 9C16.2293 9 16.5746 9.13785 16.7798 9.39765C17.0963 9.8006 17.0656 10.3131 16.7261 10.6666L12.9682 14.5918C12.8704 14.6943 12.7572 14.788 12.6268 14.8516C12.0667 15.1308 11.424 14.9983 11.0442 14.6024L7.27486 10.6666C6.93725 10.3149 6.90272 9.8059 7.2154 9.40295C7.42065 9.13785 7.76593 9 8.11889 9H8.11697Z",
    fill: "currentColor"
  }
) }), CaretDownSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M4.89357 5.5H11.1041C11.3834 5.5 11.6597 5.61488 11.8239 5.83137C12.0771 6.16716 12.0525 6.59426 11.7809 6.88882L8.7746 10.1598C8.69633 10.2453 8.60579 10.3233 8.50143 10.3763C8.05333 10.609 7.53924 10.4986 7.23538 10.1687L4.21989 6.88882C3.9498 6.59574 3.92218 6.17158 4.17232 5.83579C4.33652 5.61488 4.61274 5.5 4.89511 5.5H4.89357Z",
    fill: "currentColor"
  }
) }), CaretLeftLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M15 8.11697L15 15.8802C15 16.2293 14.8621 16.5746 14.6024 16.7798C14.1994 17.0963 13.6869 17.0656 13.3334 16.7261L9.4082 12.9682C9.3057 12.8704 9.21203 12.7572 9.14841 12.6268C8.86917 12.0667 9.00172 11.424 9.3976 11.0442L13.3334 7.27486C13.6851 6.93725 14.1941 6.90272 14.5971 7.2154C14.8621 7.42065 15 7.76593 15 8.11889L15 8.11697Z",
    fill: "currentColor"
  }
) }), CaretLeftSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M10.5 4.89357L10.5 11.1041C10.5 11.3834 10.3851 11.6597 10.1686 11.8239C9.83284 12.0771 9.40574 12.0525 9.11118 11.7809L5.84017 8.7746C5.75475 8.69633 5.67669 8.60579 5.62367 8.50143C5.39098 8.05333 5.50143 7.53924 5.83133 7.23538L9.11118 4.21989C9.40426 3.9498 9.82842 3.92218 10.1642 4.17232C10.3851 4.33652 10.5 4.61274 10.5 4.89511L10.5 4.89357Z",
    fill: "currentColor"
  }
) }), CaretRightLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M9 8.11697L9 15.8802C9 16.2293 9.13785 16.5746 9.39765 16.7798C9.8006 17.0963 10.3131 17.0656 10.6666 16.7261L14.5918 12.9682C14.6943 12.8704 14.788 12.7572 14.8516 12.6268C15.1308 12.0667 14.9983 11.424 14.6024 11.0442L10.6666 7.27486C10.3149 6.93725 9.8059 6.90272 9.40295 7.2154C9.13785 7.42065 9 7.76593 9 8.11889L9 8.11697Z",
    fill: "currentColor"
  }
) }), CaretRightSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M5.5 4.89357L5.5 11.1041C5.5 11.3834 5.61488 11.6597 5.83137 11.8239C6.16716 12.0771 6.59426 12.0525 6.88882 11.7809L10.1598 8.7746C10.2453 8.69633 10.3233 8.60579 10.3763 8.50143C10.609 8.05333 10.4986 7.53924 10.1687 7.23538L6.88882 4.21989C6.59574 3.9498 6.17158 3.92218 5.83579 4.17232C5.61488 4.33652 5.5 4.61274 5.5 4.89511L5.5 4.89357Z",
    fill: "currentColor"
  }
) }), CaretUpLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M8.11697 15L15.8802 15C16.2293 15 16.5746 14.8621 16.7798 14.6024C17.0963 14.1994 17.0656 13.6869 16.7261 13.3334L12.9682 9.4082C12.8704 9.3057 12.7572 9.21203 12.6268 9.14841C12.0667 8.86917 11.424 9.00172 11.0442 9.3976L7.27486 13.3334C6.93725 13.6851 6.90272 14.1941 7.2154 14.5971C7.42065 14.8621 7.76593 15 8.11889 15H8.11697Z",
    fill: "currentColor"
  }
) }), CaretUpSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M11.1064 10.5L4.89587 10.5C4.61657 10.5 4.34034 10.3851 4.17614 10.1686C3.92293 9.83284 3.94749 9.40574 4.21911 9.11118L7.2254 5.84017C7.30367 5.75475 7.39421 5.67669 7.49857 5.62367C7.94667 5.39098 8.46076 5.50143 8.76462 5.83133L11.7801 9.11118C12.0502 9.40426 12.0778 9.82842 11.8277 10.1642C11.6635 10.3851 11.3873 10.5 11.1049 10.5H11.1064Z",
    fill: "currentColor"
  }
) }), ChatEmptyLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7546 3.26554C19.9555 2.45666 18.869 2 17.7335 2H6.26651C5.13104 2 4.04454 2.45666 3.24537 3.26554C2.44661 4.07401 2 5.168 2 6.3062V14.223C2 15.3042 2.46219 16.1839 3.18491 16.8781C3.55773 17.2362 3.99817 17.5183 4.4801 17.71C4.96198 17.9018 5.47714 18 5.99651 18H9.69621L15.4479 21.8322C15.7547 22.0367 16.1492 22.0557 16.4743 21.8816C16.7994 21.7076 17.0023 21.3687 17.0023 21V18H18.0035C19.0507 18 20.0628 17.6008 20.8151 16.8781C21.5378 16.1839 22 15.3042 22 14.223V6.3062C22 5.168 21.5534 4.07401 20.7546 3.26554ZM17.7335 4C18.3307 4 18.9059 4.24 19.3319 4.67119C19.7583 5.10278 20 5.69069 20 6.3062V14.223C20 14.6685 19.8308 15.0504 19.4296 15.4358C19.058 15.7927 18.5457 16 18.0035 16H16.0023C15.45 16 15.0023 16.4477 15.0023 17V19.1321L10.5533 16.1678C10.3891 16.0584 10.1962 16 9.99884 16H5.99651C5.72886 16 5.46472 15.9493 5.21949 15.8517C4.97431 15.7542 4.75409 15.6122 4.57041 15.4358C4.16922 15.0504 4 14.6685 4 14.223V6.3062C4 5.69069 4.24169 5.10278 4.6681 4.67119C5.09411 4.24 5.66932 4 6.26651 4H17.7335Z",
    fill: "currentColor"
  }
) }), ChatEmptySmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1191 1.89536C13.5538 1.32314 12.7851 1 11.9816 1H4.01841C3.21493 1 2.44622 1.32314 1.88088 1.89536C1.31584 2.46726 1 3.24103 1 4.04597V8.50205C1 8.78429 1.01282 9.14956 1.09174 9.51093C1.16964 9.86765 1.32724 10.293 1.67206 10.6242C1.93622 10.878 2.24819 11.0777 2.58945 11.2135C2.93066 11.3493 3.29538 11.4188 3.66305 11.4188H6.16417L10.115 14.8185C10.337 15.0095 10.6499 15.0539 10.9162 14.932C11.1825 14.8102 11.3536 14.5444 11.3542 14.2515L11.36 11.4188H12.0012C12.7425 11.4188 13.4592 11.1362 13.9922 10.6242C14.2528 10.3739 14.4949 10.0425 14.6742 9.69473C14.8494 9.35503 15 8.93167 15 8.50205V4.04597C15 3.24103 14.6842 2.46726 14.1191 1.89536ZM11.9816 2.5C12.3814 2.5 12.7666 2.66065 13.0521 2.94959C13.3379 3.23884 13.5 3.63305 13.5 4.04597V8.50205C13.5 8.60257 13.457 8.78242 13.3411 9.00711C13.2294 9.22374 13.0827 9.41793 12.9531 9.54245C12.7056 9.78019 12.3637 9.91879 12.0012 9.91879H10.6115C10.1979 9.91879 9.86238 10.2536 9.86153 10.6672L9.85752 12.6181L6.93164 10.1003C6.79555 9.98319 6.62197 9.91879 6.44244 9.91879H3.66305C3.48418 9.91879 3.30772 9.88492 3.14399 9.81977C2.98031 9.75465 2.83349 9.65993 2.71118 9.54245C2.66575 9.49881 2.60255 9.39858 2.5572 9.19091C2.51287 8.98788 2.5 8.74995 2.5 8.50205V4.04597C2.5 3.63305 2.66215 3.23884 2.94792 2.94959C3.2334 2.66065 3.61864 2.5 4.01841 2.5H11.9816Z",
    fill: "currentColor"
  }
) }), ChatLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18 8C18 8.55228 17.5523 9 17 9H7C6.44771 9 6 8.55228 6 8C6 7.44772 6.44771 7 7 7H17C17.5523 7 18 7.44772 18 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H7C6.44771 11 6 11.4477 6 12C6 12.5523 6.44771 13 7 13H15Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.7546 3.26554C19.9555 2.45666 18.869 2 17.7335 2H6.26651C5.13104 2 4.04454 2.45666 3.24537 3.26554C2.44661 4.07401 2 5.168 2 6.3062V14.223C2 15.3042 2.46219 16.1839 3.18491 16.8781C3.55773 17.2362 3.99817 17.5183 4.4801 17.71C4.96198 17.9018 5.47714 18 5.99651 18H9.69621L15.4479 21.8322C15.7547 22.0367 16.1492 22.0557 16.4743 21.8816C16.7994 21.7076 17.0023 21.3687 17.0023 21V18H18.0035C19.0507 18 20.0628 17.6008 20.8151 16.8781C21.5378 16.1839 22 15.3042 22 14.223V6.3062C22 5.168 21.5534 4.07401 20.7546 3.26554ZM17.7335 4C18.3307 4 18.9059 4.24 19.3319 4.67119C19.7583 5.10278 20 5.69069 20 6.3062V14.223C20 14.6685 19.8308 15.0504 19.4296 15.4358C19.058 15.7927 18.5457 16 18.0035 16H16.0023C15.45 16 15.0023 16.4477 15.0023 17V19.1321L10.5533 16.1678C10.3891 16.0584 10.1962 16 9.99884 16H5.99651C5.72886 16 5.46472 15.9493 5.21949 15.8517C4.97431 15.7542 4.75409 15.6122 4.57041 15.4358C4.16922 15.0504 4 14.6685 4 14.223V6.3062C4 5.69069 4.24169 5.10278 4.6681 4.67119C5.09411 4.24 5.66932 4 6.26651 4H17.7335Z",
      fill: "currentColor"
    }
  )
] }), ChatSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.125 4.875C4.125 4.46079 4.46079 4.125 4.875 4.125L11.125 4.125C11.5392 4.125 11.875 4.46079 11.875 4.875C11.875 5.28921 11.5392 5.625 11.125 5.625L4.875 5.625C4.46079 5.625 4.125 5.28921 4.125 4.875Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.875 6.76562C4.46079 6.76562 4.125 7.10141 4.125 7.51562C4.125 7.92984 4.46079 8.26562 4.875 8.26562L9.5625 8.26563C9.97671 8.26563 10.3125 7.92984 10.3125 7.51563C10.3125 7.10141 9.97671 6.76563 9.5625 6.76563L4.875 6.76562Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.1191 1.89536C13.5538 1.32314 12.7851 1 11.9816 1H4.01841C3.21493 1 2.44622 1.32314 1.88088 1.89536C1.31584 2.46726 1 3.24103 1 4.04597V8.50205C1 8.78429 1.01282 9.14956 1.09174 9.51093C1.16964 9.86765 1.32724 10.293 1.67206 10.6242C1.93622 10.878 2.24819 11.0777 2.58945 11.2135C2.93066 11.3493 3.29538 11.4188 3.66305 11.4188H6.16417L10.115 14.8185C10.337 15.0095 10.6499 15.0539 10.9162 14.932C11.1825 14.8102 11.3536 14.5444 11.3542 14.2515L11.36 11.4188H12.0012C12.7425 11.4188 13.4592 11.1362 13.9922 10.6242C14.2528 10.3739 14.4949 10.0425 14.6742 9.69473C14.8494 9.35503 15 8.93167 15 8.50205V4.04597C15 3.24103 14.6842 2.46726 14.1191 1.89536ZM11.9816 2.5C12.3814 2.5 12.7666 2.66065 13.0521 2.94959C13.3379 3.23884 13.5 3.63305 13.5 4.04597V8.50205C13.5 8.60257 13.457 8.78242 13.3411 9.00711C13.2294 9.22374 13.0827 9.41793 12.9531 9.54245C12.7056 9.78019 12.3637 9.91879 12.0012 9.91879H10.6115C10.1979 9.91879 9.86238 10.2536 9.86153 10.6672L9.85752 12.6181L6.93164 10.1003C6.79555 9.98319 6.62197 9.91879 6.44244 9.91879H3.66305C3.48418 9.91879 3.30772 9.88492 3.14399 9.81977C2.98031 9.75465 2.83349 9.65993 2.71118 9.54245C2.66575 9.49881 2.60255 9.39858 2.5572 9.19091C2.51287 8.98788 2.5 8.74995 2.5 8.50205V4.04597C2.5 3.63305 2.66215 3.23884 2.94792 2.94959C3.2334 2.66065 3.61864 2.5 4.01841 2.5H11.9816Z",
      fill: "currentColor"
    }
  )
] }), CheckedCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM16.7809 9.62473C17.1259 9.19347 17.056 8.56418 16.6247 8.21917C16.1934 7.87416 15.5641 7.94408 15.2191 8.37534L11.0948 13.5307L8.68394 11.2705C8.28103 10.8928 7.6482 10.9132 7.27047 11.3161C6.89274 11.719 6.91315 12.3518 7.31606 12.7296L10.5161 15.7296C10.7195 15.9203 10.9933 16.0174 11.2714 15.9975C11.5495 15.9776 11.8067 15.8425 11.9809 15.6247L16.7809 9.62473Z",
    fill: "currentColor"
  }
) }), CheckedCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.477 6.27253C11.7279 5.95889 11.6771 5.50122 11.3634 5.2503C11.0498 4.99939 10.5921 5.05024 10.3412 5.36389L7.3417 9.11325L5.58832 7.46945C5.2953 7.19474 4.83505 7.20959 4.56034 7.50261C4.28563 7.79564 4.30047 8.25589 4.5935 8.5306L6.92077 10.7124C7.06871 10.8511 7.26784 10.9217 7.47011 10.9073C7.67237 10.8928 7.85941 10.7945 7.98609 10.6362L11.477 6.27253Z",
    fill: "currentColor"
  }
) }), CheckedCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.7809 9.62473C17.1259 9.19347 17.056 8.56418 16.6247 8.21917C16.1934 7.87416 15.5641 7.94408 15.2191 8.37534L11.0948 13.5307L8.68394 11.2705C8.28103 10.8928 7.6482 10.9132 7.27047 11.3161C6.89274 11.719 6.91315 12.3518 7.31606 12.7296L10.5161 15.7296C10.7195 15.9203 10.9933 16.0174 11.2714 15.9975C11.5495 15.9776 11.8067 15.8425 11.9809 15.6247L16.7809 9.62473Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), CheckedCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.1022 6.45701C11.3546 6.12861 11.293 5.65775 10.9646 5.4053C10.6362 5.15286 10.1654 5.21443 9.91293 5.54282L7.3579 8.86656L6.03684 7.54956C5.74349 7.25712 5.26862 7.25785 4.97618 7.55119C4.68374 7.84453 4.68447 8.31941 4.97781 8.61185L6.90306 10.5312C7.05579 10.6834 7.26667 10.7626 7.48187 10.7484C7.69707 10.7342 7.89575 10.6281 8.02718 10.4571L11.1022 6.45701Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15.9999C12.4183 15.9999 16 12.4182 16 7.99988C16 3.5816 12.4183 -0.00012207 8 -0.00012207C3.58172 -0.00012207 0 3.5816 0 7.99988C0 12.4182 3.58172 15.9999 8 15.9999ZM14.5 7.99988C14.5 11.5897 11.5899 14.4999 8 14.4999C4.41015 14.4999 1.5 11.5897 1.5 7.99988C1.5 4.41003 4.41015 1.49988 8 1.49988C11.5899 1.49988 14.5 4.41003 14.5 7.99988Z",
      fill: "currentColor"
    }
  )
] }), CheckedDoubleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.7897 8.6135C21.1285 8.17734 21.0496 7.54911 20.6135 7.21031C20.1773 6.87151 19.5491 6.95044 19.2103 7.3866L13.6464 14.5493L13.1585 14.1224C12.7429 13.7588 12.1111 13.8009 11.7474 14.2165C11.3838 14.6322 11.4259 15.2639 11.8415 15.6276L13.1273 16.7526C13.3345 16.9339 13.6073 17.0218 13.8814 16.9955C14.1555 16.9691 14.4066 16.8309 14.5755 16.6135L20.7897 8.6135Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.2855 8.61885C14.6273 8.18501 14.5527 7.55626 14.1188 7.2145C13.685 6.87274 13.0562 6.94739 12.7145 7.38123L7.08705 14.5248L4.68418 12.2707C4.28138 11.8929 3.64854 11.9131 3.27068 12.3159C2.89283 12.7187 2.91304 13.3515 3.31583 13.7294L6.51379 16.7294C6.71814 16.9211 6.99354 17.0182 7.27295 16.9972C7.55235 16.9762 7.81012 16.839 7.98351 16.6189L14.2855 8.61885Z",
      fill: "currentColor"
    }
  )
] }), CheckedDoubleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.8378 6.31682C13.1013 5.95857 13.037 5.44492 12.6942 5.16954C12.3514 4.89416 11.8598 4.96133 11.5963 5.31958L8.91678 8.96241C8.61445 8.76664 8.21236 8.80621 7.95044 9.08075C7.64516 9.40075 7.64591 9.91878 7.95212 10.2378L8.45453 10.7612C8.61396 10.9273 8.8341 11.0137 9.05875 10.9982C9.2834 10.9828 9.4908 10.867 9.628 10.6805L12.8378 6.31682Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.62325 6.31683C8.88677 5.95859 8.8225 5.44493 8.47969 5.16955C8.13688 4.89416 7.64536 4.96133 7.38183 5.31957L4.71469 8.94536L3.33566 7.50867C3.02944 7.18965 2.53373 7.19045 2.22846 7.51045C1.92318 7.83045 1.92395 8.34848 2.23016 8.6675L4.23989 10.7613C4.39932 10.9274 4.61946 11.0137 4.8441 10.9982C5.06874 10.9828 5.27613 10.867 5.41334 10.6805L8.62325 6.31683Z",
      fill: "currentColor"
    }
  )
] }), CheckedLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6123 5.20943C20.049 5.54759 20.1288 6.1757 19.7906 6.61235L10.4971 18.6124C10.3233 18.8368 10.0623 18.9768 9.7791 18.9974C9.49596 19.018 9.21739 18.9173 9.01289 18.7204L4.30639 14.1886C3.90855 13.8055 3.89658 13.1725 4.27965 12.7746C4.66272 12.3768 5.29577 12.3648 5.69361 12.7479L9.59783 16.5072L18.2094 5.38774C18.5475 4.95109 19.1757 4.87126 19.6123 5.20943Z",
    fill: "currentColor"
  }
) }), CheckedMini = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7167 4.13363C13.032 4.35273 13.0934 4.76416 12.8539 5.05258L7.2989 11.7409C7.17363 11.8917 6.98318 11.9856 6.77656 11.9985C6.56995 12.0113 6.36736 11.9418 6.22093 11.8079L3.21 9.05389C2.92999 8.79778 2.93 8.38253 3.21002 8.12642C3.49003 7.87031 3.94403 7.87031 4.22404 8.12643L6.65399 10.349L11.712 4.25914C11.9515 3.97072 12.4013 3.91453 12.7167 4.13363Z",
    fill: "currentColor"
  }
) }), CheckedSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7037 3.15282C14.0335 3.40339 14.0978 3.87389 13.8472 4.20373L7.39005 12.7037C7.25867 12.8767 7.05878 12.9842 6.84206 12.9984C6.62534 13.0127 6.41308 12.9323 6.26018 12.778L2.21735 8.69959C1.92574 8.40541 1.92783 7.93054 2.222 7.63894C2.51618 7.34733 2.99105 7.34941 3.28265 7.64359L6.71779 11.109L12.6528 3.29635C12.9033 2.96652 13.3739 2.90226 13.7037 3.15282Z",
    fill: "currentColor"
  }
) }), ChevronDownLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36114 8.29339C6.80897 7.87115 7.49874 7.90918 7.90178 8.37834L12 13.1487L16.0982 8.37834C16.5013 7.90918 17.191 7.87115 17.6389 8.29339C18.0867 8.71563 18.123 9.43824 17.7199 9.9074L12.8109 15.6217C12.604 15.8625 12.3093 16 12 16C11.6907 16 11.396 15.8625 11.1891 15.6217L6.28005 9.9074C5.87701 9.43824 5.91331 8.71563 6.36114 8.29339Z",
    fill: "currentColor"
  }
) }), ChevronDownSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40082 5.16315C2.9587 5.43382 2.86855 5.94643 3.19944 6.30808L7.19243 10.6722C7.38105 10.8783 7.67733 10.9998 7.99211 11C8.30688 11.0002 8.60341 10.8792 8.79245 10.6733L12.7995 6.30919C13.1312 5.94799 13.0421 5.43526 12.6005 5.16398C12.159 4.89269 11.5322 4.96557 11.2005 5.32676L7.99436 8.81859L4.80048 5.32787C4.46958 4.96622 3.84293 4.89247 3.40082 5.16315Z",
    fill: "currentColor"
  }
) }), ChevronLeftLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7066 17.6389C16.1289 17.191 16.0908 16.5013 15.6217 16.0982L10.8513 12L15.6217 7.90178C16.0908 7.49874 16.1289 6.80897 15.7066 6.36114C15.2844 5.91331 14.5618 5.87701 14.0926 6.28005L8.37833 11.1891C8.13751 11.396 8 11.6907 8 12C8 12.3093 8.13751 12.604 8.37833 12.8109L14.0926 17.7199C14.5618 18.123 15.2844 18.0867 15.7066 17.6389Z",
    fill: "currentColor"
  }
) }), ChevronLeftSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8369 12.5992C10.5662 13.0413 10.0536 13.1315 9.69192 12.8006L5.32782 8.80757C5.12167 8.61895 5.00022 8.32267 5 8.00789C4.99978 7.69312 5.12083 7.39659 5.32671 7.20755L9.69081 3.20046C10.052 2.86881 10.5647 2.95791 10.836 3.39946C11.1073 3.84101 11.0344 4.46782 10.6732 4.79946L7.18141 8.00564L10.6721 11.1995C11.0338 11.5304 11.1075 12.1571 10.8369 12.5992Z",
    fill: "currentColor"
  }
) }), ChevronRightLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29339 17.6389C7.87115 17.191 7.90918 16.5013 8.37834 16.0982L13.1487 12L8.37834 7.90178C7.90918 7.49874 7.87115 6.80897 8.29339 6.36114C8.71563 5.91331 9.43824 5.87701 9.9074 6.28005L15.6217 11.1891C15.8625 11.396 16 11.6907 16 12C16 12.3093 15.8625 12.604 15.6217 12.8109L9.9074 17.7199C9.43824 18.123 8.71563 18.0867 8.29339 17.6389Z",
    fill: "currentColor"
  }
) }), ChevronRightSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16315 12.5992C5.43382 13.0413 5.94643 13.1315 6.30808 12.8006L10.6722 8.80757C10.8783 8.61895 10.9998 8.32267 11 8.00789C11.0002 7.69312 10.8792 7.39659 10.6733 7.20755L6.30919 3.20046C5.94799 2.86881 5.43526 2.95791 5.16398 3.39946C4.89269 3.84101 4.96557 4.46782 5.32676 4.79946L8.81859 8.00564L5.32787 11.1995C4.96622 11.5304 4.89247 12.1571 5.16315 12.5992Z",
    fill: "currentColor"
  }
) }), ChevronUpLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36114 15.7066C6.80897 16.1289 7.49874 16.0908 7.90178 15.6217L12 10.8513L16.0982 15.6217C16.5013 16.0908 17.191 16.1289 17.6389 15.7066C18.0867 15.2844 18.123 14.5618 17.7199 14.0926L12.8109 8.37833C12.604 8.13751 12.3093 8 12 8C11.6907 8 11.396 8.13751 11.1891 8.37833L6.28005 14.0926C5.87701 14.5618 5.91331 15.2844 6.36114 15.7066Z",
    fill: "currentColor"
  }
) }), ChevronUpSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40082 10.8369C2.9587 10.5662 2.86855 10.0536 3.19944 9.69192L7.19243 5.32782C7.38105 5.12167 7.67733 5.00022 7.99211 5C8.30688 4.99978 8.60341 5.12083 8.79245 5.32671L12.7995 9.69081C13.1312 10.052 13.0421 10.5647 12.6005 10.836C12.159 11.1073 11.5322 11.0344 11.2005 10.6732L7.99436 7.18141L4.80048 10.6721C4.46958 11.0338 3.84293 11.1075 3.40082 10.8369Z",
    fill: "currentColor"
  }
) }), CloseLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M18.1001 19.7097C18.4815 20.0968 19.1 20.0968 19.4815 19.7097C19.8629 19.3226 19.8629 18.695 19.4815 18.3079L13.3814 12.118L19.714 5.69208C20.0954 5.30499 20.0954 4.6774 19.714 4.29031C19.3325 3.90323 18.714 3.90323 18.3326 4.29031L12 10.7162L5.66749 4.29031C5.28603 3.90323 4.66756 3.90323 4.2861 4.29031C3.90463 4.6774 3.90463 5.30499 4.2861 5.69208L10.6186 12.118L4.51858 18.3079C4.13712 18.695 4.13712 19.3226 4.51858 19.7097C4.90005 20.0968 5.51852 20.0968 5.89998 19.7097L12 13.5197L18.1001 19.7097Z",
    fill: "currentColor"
  }
) }), CloseMiniLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M15.1032 7.32544C15.5371 6.89152 16.2406 6.89152 16.6746 7.32544C17.1085 7.75935 17.1085 8.46287 16.6746 8.89679L13.5713 12L16.6746 15.1032C17.1085 15.5371 17.1085 16.2406 16.6746 16.6746C16.2406 17.1085 15.5371 17.1085 15.1032 16.6746L12 13.5713L8.89679 16.6746C8.46287 17.1085 7.75935 17.1085 7.32544 16.6746C6.89152 16.2406 6.89152 15.5371 7.32544 15.1032L10.4287 12L7.32544 8.89679C6.89152 8.46287 6.89152 7.75935 7.32544 7.32544C7.75935 6.89152 8.46287 6.89152 8.89679 7.32544L12 10.4287L15.1032 7.32544Z",
    fill: "currentColor"
  }
) }), CloseMiniSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M11.7765 5.30214C12.0745 5.00425 12.0745 4.52129 11.7765 4.22341C11.4786 3.92553 10.9955 3.92553 10.6976 4.22341L7.99895 6.92137L5.30245 4.22551C5.0045 3.92763 4.52142 3.92763 4.22346 4.22551C3.92551 4.52339 3.92551 5.00636 4.22346 5.30424L6.91997 8.00009L4.22365 10.6958C3.9257 10.9936 3.9257 11.4766 4.22365 11.7745C4.5216 12.0724 5.00468 12.0724 5.30263 11.7745L7.99895 9.07882L10.6974 11.7766C10.9953 12.0745 11.4784 12.0745 11.7763 11.7766C12.0743 11.4787 12.0743 10.9957 11.7763 10.6979L9.07793 8.00009L11.7765 5.30214Z",
    fill: "currentColor"
  }
) }), CloseSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33599 2.22922C3.03037 1.92359 2.53485 1.92359 2.22922 2.22922C1.92359 2.53485 1.92359 3.03037 2.22922 3.336L6.89329 8.00009L2.22939 12.664C1.92376 12.9696 1.92376 13.4652 2.22939 13.7708C2.53501 14.0764 3.03053 14.0764 3.33616 13.7708L8.00007 9.10686L12.664 13.7708C12.9696 14.0764 13.4651 14.0764 13.7707 13.7708C14.0764 13.4652 14.0764 12.9696 13.7707 12.664L9.10684 8.00009L13.7709 3.336C14.0765 3.03037 14.0765 2.53485 13.7709 2.22922C13.4653 1.92359 12.9698 1.92359 12.6641 2.22922L8.00007 6.89331L3.33599 2.22922Z",
    fill: "currentColor"
  }
) }), CompanyLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 9C7 8.44772 7.44772 8 8 8H10C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13 9C13 8.44772 13.4477 8 14 8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H14C13.4477 10 13 9.55228 13 9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13 13C13 12.4477 13.4477 12 14 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H14C13.4477 14 13 13.5523 13 13Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.0105 2C7.90595 2 7.01051 2.89537 7.01043 3.99992L6.5 4C5.11927 4 3.99997 5.11932 4 6.50005L4.00027 20C3.44798 20 3 20.4477 3 21C3 21.5523 3.44772 22 4 22L14.9984 22L15 22L15.0016 22H18.9982C18.9988 22 18.9995 22 19.0001 22C19.0008 22 19.0014 22 19.0021 22H20C20.5523 22 21 21.5523 21 21C21 20.4478 20.5523 20.0001 20.0001 20L20 6.49674C20 5.11782 18.8821 4 17.5032 4H17.0065C17.0065 2.89543 16.111 2 15.0065 2H9.0105ZM18.0001 20L18 6.49676C18 6.22241 17.7776 6 17.5032 6H17.0065C15.9019 6 15.0065 5.10457 15.0065 4H9.0105C9.01042 5.10455 8.1149 6 7.01035 6H6.5C6.22385 6 5.99999 6.22386 6 6.50001L6.00027 20H8V18C8 16.8954 8.89543 16 10 16H14C15.1046 16 16 16.8954 16 18V20H18.0001ZM14 20L10 20V18H14V20Z",
      fill: "currentColor"
    }
  )
] }), CompanySmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.50387 4.98528C4.50387 4.56903 4.83965 4.2316 5.25387 4.2316H5.75387C6.16808 4.2316 6.50387 4.56903 6.50387 4.98528C6.50387 5.40153 6.16808 5.73896 5.75387 5.73896H5.25387C4.83965 5.73896 4.50387 5.40153 4.50387 4.98528Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.25387 7.24632C4.83965 7.24632 4.50387 7.58375 4.50387 8C4.50387 8.41625 4.83965 8.75368 5.25387 8.75368H5.75387C6.16808 8.75368 6.50387 8.41625 6.50387 8C6.50387 7.58375 6.16808 7.24632 5.75387 7.24632H5.25387Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.49556 4.98528C7.49556 4.56903 7.83135 4.2316 8.24556 4.2316H8.74556C9.15978 4.2316 9.49556 4.56903 9.49556 4.98528C9.49556 5.40153 9.15978 5.73896 8.74556 5.73896H8.24556C7.83135 5.73896 7.49556 5.40153 7.49556 4.98528Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.24556 7.24632C7.83135 7.24632 7.49556 7.58375 7.49556 8C7.49556 8.41625 7.83135 8.75368 8.24556 8.75368H8.74556C9.15978 8.75368 9.49556 8.41625 9.49556 8C9.49556 7.58375 9.15978 7.24632 8.74556 7.24632H8.24556Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.54992 1.60329C3.54992 0.717817 4.26423 0 5.14538 0H8.85436C9.73551 0 10.4498 0.717816 10.4498 1.60329C10.4498 1.65627 10.4926 1.69921 10.5453 1.69921H10.5998C11.5111 1.69921 12.2498 2.44156 12.2498 3.35729V14.2404C12.2498 14.3261 12.2437 14.4103 12.2319 14.4926H12.25C12.6642 14.4926 13 14.8301 13 15.2463C13 15.6626 12.6642 16 12.25 16H1.75C1.33579 16 1 15.6626 1 15.2463C1 14.8301 1.33579 14.4926 1.75 14.4926H1.76782C1.75605 14.4103 1.74996 14.3261 1.74996 14.2404V3.35729C1.74996 2.44156 2.48868 1.69921 3.39994 1.69921H3.45447C3.50719 1.69921 3.54992 1.65627 3.54992 1.60329ZM5.04992 1.60329C5.04992 2.48876 4.33561 3.20658 3.45447 3.20658H3.39994C3.31711 3.20658 3.24996 3.27405 3.24996 3.35729V14.2404C3.24996 14.3792 3.36189 14.4917 3.49996 14.4917H4.24996V12.0196C4.24996 11.0484 5.03346 10.261 5.99996 10.261H7.99996C8.96646 10.261 9.74996 11.0484 9.74996 12.0196V14.4917H10.4998C10.6379 14.4917 10.7498 14.3792 10.7498 14.2404V3.35729C10.7498 3.27405 10.6826 3.20658 10.5998 3.20658H10.5453C9.66413 3.20658 8.94982 2.48876 8.94982 1.60329C8.94982 1.55031 8.90708 1.50736 8.85436 1.50736H5.14538C5.09266 1.50736 5.04992 1.55031 5.04992 1.60329ZM5.74996 12.0196C5.74996 11.8809 5.86189 11.7684 5.99996 11.7684H7.99996C8.13803 11.7684 8.24996 11.8809 8.24996 12.0196V14.2785H5.74996V12.0196Z",
      fill: "currentColor"
    }
  )
] }), ComposeLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.99792 4.5C3.99792 4.22386 4.22155 4 4.4974 4H11.9896C12.5413 4 12.9886 3.55228 12.9886 3C12.9886 2.44772 12.5413 2 11.9896 2H4.4974C3.11813 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11812 22 4.4974 22H19.4818C20.8611 22 21.9792 20.8807 21.9792 19.5V12C21.9792 11.4477 21.532 11 20.9803 11C20.4285 11 19.9813 11.4477 19.9813 12V19.5C19.9813 19.7761 19.7577 20 19.4818 20H4.4974C4.22155 20 3.99792 19.7761 3.99792 19.5V4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.8819 2.29304C18.4918 1.90252 17.8593 1.90252 17.4692 2.29304L10.2541 9.51564C10.1063 9.6636 10.0086 9.85425 9.97471 10.0607L9.4197 13.4447C9.36757 13.7626 9.47157 14.0861 9.69909 14.3139C9.92661 14.5416 10.2498 14.6457 10.5673 14.5935L13.9478 14.038C14.1541 14.0041 14.3445 13.9062 14.4923 13.7583L21.7074 6.53569C22.0975 6.14516 22.0975 5.512 21.7074 5.12147L18.8819 2.29304ZM11.8942 10.7023L18.1756 4.41436L19.5883 5.82858L13.3069 12.1165L11.6166 12.3943L11.8942 10.7023Z",
      fill: "currentColor"
    }
  )
] }), ComposeSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H8C8.41421 2.5 8.75 2.16421 8.75 1.75C8.75 1.33579 8.41421 1 8 1H2.75C1.7835 1 1 1.7835 1 2.75V13.25C1 14.2165 1.7835 15 2.75 15H13.25C14.2165 15 15 14.2165 15 13.25V8C15 7.58579 14.6642 7.25 14.25 7.25C13.8358 7.25 13.5 7.58579 13.5 8V13.25C13.5 13.3881 13.3881 13.5 13.25 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25V2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.8287 1.46783C12.5358 1.17494 12.0609 1.17494 11.768 1.46783L6.82207 6.41377C6.71999 6.51585 6.64954 6.64523 6.61917 6.78637L6.11708 9.12031C6.06262 9.37348 6.14261 9.63683 6.32868 9.81694C6.51475 9.99705 6.78056 10.0684 7.03182 10.0058L9.30168 9.43957C9.4337 9.40664 9.55428 9.33841 9.6505 9.2422L14.5964 4.29626C14.8893 4.00336 14.8893 3.52849 14.5964 3.2356L12.8287 1.46783ZM8.03911 7.31805L12.2983 3.05882L13.0054 3.76593L8.73688 8.03449L7.83668 8.25903L8.03911 7.31805Z",
      fill: "currentColor"
    }
  )
] }), ConfigurationLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.126 18C14.5701 19.7252 16.1362 21 18 21C20.2091 21 22 19.2091 22 17C22 14.7909 20.2091 13 18 13C16.1362 13 14.5701 14.2748 14.126 16H4C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H14.126ZM16 17C16 15.8954 16.8954 15 18 15C19.1046 15 20 15.8954 20 17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.87398 6C9.42994 4.27477 7.86384 3 6 3C3.79086 3 2 4.79086 2 7C2 9.20914 3.79086 11 6 11C7.86384 11 9.42994 9.72523 9.87398 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H9.87398ZM4 7C4 5.89543 4.89543 5 6 5C7.10457 5 8 5.89543 8 7C8 8.10457 7.10457 9 6 9C4.89543 9 4 8.10457 4 7Z",
      fill: "currentColor"
    }
  )
] }), ConfigurationSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.14673 3.75C6.82026 2.59575 5.75902 1.75 4.50024 1.75C2.98146 1.75 1.75024 2.98122 1.75024 4.5C1.75024 6.01878 2.98146 7.25 4.50024 7.25C5.75902 7.25 6.82026 6.40425 7.14673 5.25H12.5002C12.9145 5.25 13.2502 4.91421 13.2502 4.5C13.2502 4.08579 12.9145 3.75 12.5002 3.75H7.14673ZM3.25024 4.5C3.25024 3.80964 3.80989 3.25 4.50024 3.25C5.1906 3.25 5.75024 3.80964 5.75024 4.5C5.75024 5.19036 5.1906 5.75 4.50024 5.75C3.80989 5.75 3.25024 5.19036 3.25024 4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.85376 10.75C9.18022 9.59575 10.2415 8.75 11.5002 8.75C13.019 8.75 14.2502 9.98122 14.2502 11.5C14.2502 13.0188 13.019 14.25 11.5002 14.25C10.2415 14.25 9.18022 13.4043 8.85376 12.25H3.50024C3.08603 12.25 2.75024 11.9142 2.75024 11.5C2.75024 11.0858 3.08603 10.75 3.50024 10.75H8.85376ZM12.7502 11.5C12.7502 10.8096 12.1906 10.25 11.5002 10.25C10.8099 10.25 10.2502 10.8096 10.2502 11.5C10.2502 12.1904 10.8099 12.75 11.5002 12.75C12.1906 12.75 12.7502 12.1904 12.7502 11.5Z",
      fill: "currentColor"
    }
  )
] }), ContactsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 13.5C12.2044 13.5 11.4413 13.8161 10.8787 14.3787C10.3161 14.9413 10 15.7044 10 16.5C10 17.0523 9.55228 17.5 9 17.5C8.44772 17.5 8 17.0523 8 16.5C8 15.1739 8.52678 13.9021 9.46447 12.9645C10.0784 12.3505 10.8356 11.9127 11.6575 11.6836C10.6747 11.191 10 10.1743 10 9C10 7.34315 11.3431 6 13 6C14.6569 6 16 7.34315 16 9C16 10.1743 15.3253 11.191 14.3425 11.6836C15.1644 11.9127 15.9216 12.3505 16.5355 12.9645C17.4732 13.9021 18 15.1739 18 16.5C18 17.0523 17.5523 17.5 17 17.5C16.4477 17.5 16 17.0523 16 16.5C16 15.7044 15.6839 14.9413 15.1213 14.3787C14.5587 13.8161 13.7956 13.5 13 13.5ZM12 9C12 8.44772 12.4477 8 13 8C13.5523 8 14 8.44772 14 9C14 9.55229 13.5523 10 13 10C12.4477 10 12 9.55229 12 9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 2C5.11929 2 4 3.11929 4 4.5V6H3C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H4V11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H4V16H3C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18H4V19.5C4 20.8807 5.11929 22 6.5 22H19.5C20.8807 22 22 20.8807 22 19.5V4.5C22 3.11929 20.8807 2 19.5 2H6.5ZM6 18V19.5C6 19.7761 6.22386 20 6.5 20H19.5C19.7761 20 20 19.7761 20 19.5V4.5C20 4.22386 19.7761 4 19.5 4H6.5C6.22386 4 6 4.22386 6 4.5V6C6.55228 6 7 6.44772 7 7C7 7.55228 6.55228 8 6 8V11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13V16C6.55228 16 7 16.4477 7 17C7 17.5523 6.55228 18 6 18Z",
      fill: "currentColor"
    }
  )
] }), ContactsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 9.75C8.53569 9.75 8.09052 9.93431 7.76237 10.2622C7.43424 10.5901 7.25 11.0347 7.25 11.4982C7.25 11.9124 6.91421 12.2482 6.5 12.2482C6.08579 12.2482 5.75 11.9124 5.75 11.4982C5.75 10.6365 6.09254 9.81028 6.7021 9.20117C7.31163 8.59208 8.13822 8.25 9 8.25C9.86178 8.25 10.6884 8.59208 11.2979 9.20117C11.9075 9.81028 12.25 10.6365 12.25 11.4982C12.25 11.9124 11.9142 12.2482 11.5 12.2482C11.0858 12.2482 10.75 11.9124 10.75 11.4982C10.75 11.0347 10.5658 10.5901 10.2376 10.2622C9.90948 9.93432 9.46431 9.75 9 9.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 4.25C7.89543 4.25 7 5.14543 7 6.25C7 7.35457 7.89543 8.25 9 8.25C10.1046 8.25 11 7.35457 11 6.25C11 5.14543 10.1046 4.25 9 4.25ZM8.5 6.25C8.5 5.97386 8.72386 5.75 9 5.75C9.27614 5.75 9.5 5.97386 9.5 6.25C9.5 6.52614 9.27614 6.75 9 6.75C8.72386 6.75 8.5 6.52614 8.5 6.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75 1C3.7835 1 3 1.7835 3 2.75V4.25H1.75C1.33579 4.25 1 4.58579 1 5C1 5.41421 1.33579 5.75 1.75 5.75H3V7.25H1.75C1.33579 7.25 1 7.58579 1 8C1 8.41421 1.33579 8.75 1.75 8.75H3V10.25H1.75C1.33579 10.25 1 10.5858 1 11C1 11.4142 1.33579 11.75 1.75 11.75H3V13.25C3 14.2165 3.7835 15 4.75 15H13.25C14.2165 15 15 14.2165 15 13.25V2.75C15 1.7835 14.2165 1 13.25 1H4.75ZM4.5 13.25C4.5 13.3881 4.61193 13.5 4.75 13.5H13.25C13.3881 13.5 13.5 13.3881 13.5 13.25V2.75C13.5 2.61193 13.3881 2.5 13.25 2.5H4.75C4.61193 2.5 4.5 2.61193 4.5 2.75V13.25Z",
      fill: "currentColor"
    }
  )
] }), CreditCardLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.72776 16C4.72776 15.4477 5.13477 15 5.63685 15L11.0914 15C11.5935 15 12.0005 15.4477 12.0005 16C12.0005 16.5523 11.5935 17 11.0914 17L5.63685 17C5.13477 17 4.72776 16.5523 4.72776 16Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00049 17.5C2.00049 18.8807 3.01802 20 4.27322 20H19.7278C20.983 20 22.0005 18.8807 22.0005 17.5V6.5C22.0005 5.11929 20.983 4 19.7278 4H4.27322C3.01802 4 2.00049 5.11929 2.00049 6.5V17.5ZM4.27322 6C4.02218 6 3.81867 6.22386 3.81867 6.5V8H20.1823V6.5C20.1823 6.22386 19.9788 6 19.7278 6H4.27322ZM20.1823 10H3.81867V17.5C3.81867 17.7761 4.02218 18 4.27322 18H19.7278C19.9788 18 20.1823 17.7761 20.1823 17.5V10Z",
      fill: "currentColor"
    }
  )
] }), CreditCardSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75049 2C0.78399 2 0.000488281 2.7835 0.000488281 3.75V12.25C0.000488281 13.2165 0.783989 14 1.75049 14H14.2505C15.217 14 16.0005 13.2165 16.0005 12.25V3.75C16.0005 2.7835 15.217 2 14.2505 2H1.75049ZM1.50049 3.75C1.50049 3.61193 1.61242 3.5 1.75049 3.5H14.2505C14.3886 3.5 14.5005 3.61193 14.5005 3.75V5.24219H1.50049V3.75ZM1.50049 6.74219V12.25C1.50049 12.3881 1.61242 12.5 1.75049 12.5H14.2505C14.3886 12.5 14.5005 12.3881 14.5005 12.25V6.74219H1.50049Z",
    fill: "currentColor"
  }
) }), CrownLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "m10.227 11.088 1.203-3.64c.197-.597.943-.597 1.14 0l1.203 3.64 2.279-1.724c.474-.359 1.085.154.92.774l-1.42 5.37c-.076.292-.313.492-.582.492H9.03c-.269 0-.506-.2-.583-.492l-1.42-5.37c-.164-.62.447-1.133.921-.774l2.279 1.724Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
      fill: "currentColor"
    }
  )
] }), CrownSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip_crown_small)", fill: "currentColor", children: [
    /* @__PURE__ */ jsx("path", { d: "M7.62 4.966c.131-.399.628-.399.76 0l.802 2.426 1.519-1.149c.316-.24.723.102.614.516l-.947 3.58c-.051.194-.21.328-.388.328H6.02c-.18 0-.337-.134-.389-.329l-.946-3.58c-.11-.413.297-.754.614-.515l1.519 1.149.802-2.426Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.455 8a6.545 6.545 0 1 1 13.09 0 6.545 6.545 0 0 1-13.09 0Z"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip_crown_small", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
] }), CustomerLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 17C10.6193 17 9.5 15.8807 9.5 14.5C9.5 13.1193 10.6193 12 12 12C13.3807 12 14.5 13.1193 14.5 14.5C14.5 15.8807 13.3807 17 12 17ZM11.5 14.5C11.5 14.2239 11.7239 14 12 14C12.2761 14 12.5 14.2239 12.5 14.5C12.5 14.7761 12.2761 15 12 15C11.7239 15 11.5 14.7761 11.5 14.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.99791 2C4.5938 2 4.22941 2.24322 4.0744 2.61642L2.07649 7.42663C2.02599 7.54821 2 7.67856 2 7.81021C2 8.70217 2.40565 9.52602 3.07334 10.1109C3.35023 10.3534 3.66389 10.5484 4 10.6932V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H20V10.6932C20.3361 10.5484 20.6498 10.3534 20.9267 10.1109C21.5943 9.52602 22 8.70217 22 7.81021C22 7.67856 21.974 7.54821 21.9235 7.42663L19.9256 2.61642C19.7706 2.24322 19.4062 2 19.0021 2H16L15.9979 2L15.9958 2H12.0042L12 2.00001L11.9958 2H8.00418L8.00209 2L8 2H4.99791ZM18 10.9674C17.293 10.8746 16.6194 10.5857 16.0826 10.1189C15.8326 10.3717 15.5402 10.5794 15.2168 10.7298C14.8354 10.9072 14.421 11 14 11C13.579 11 13.1646 10.9072 12.7832 10.7298C12.4947 10.5957 12.231 10.416 12 10.1994C11.769 10.416 11.5053 10.5957 11.2168 10.7298C10.8354 10.9072 10.421 11 10 11C9.57902 11 9.16464 10.9072 8.7832 10.7298C8.45977 10.5794 8.16741 10.3717 7.91741 10.1189C7.3806 10.5857 6.70697 10.8746 6 10.9674V20H8.12701C8.30414 19.3141 8.66201 18.6811 9.17157 18.1716C9.92172 17.4214 10.9391 17 12 17C13.0609 17 14.0783 17.4214 14.8284 18.1716C15.338 18.6811 15.6959 19.314 15.873 20L18 20V10.9674ZM13.0658 8.26106C13.0222 8.13065 12.9998 7.99194 13 7.85163C13 7.82616 13.0008 7.80064 13.0024 7.77511C13.0036 7.75505 13.0042 7.73495 13.0042 7.71485V4H14.9958V7.71485C14.9958 7.73495 14.9964 7.75505 14.9976 7.77511C15.0077 7.9413 14.9857 8.10697 14.9342 8.26106C14.8828 8.41508 14.8039 8.55157 14.706 8.66364C14.6083 8.77555 14.4943 8.86014 14.3735 8.91631C14.253 8.97236 14.1261 9 14 9C13.8739 9 13.747 8.97236 13.6265 8.91631C13.5057 8.86014 13.3917 8.77555 13.294 8.66364C13.1961 8.55157 13.1172 8.41508 13.0658 8.26106ZM10.9976 7.77511C10.9992 7.80064 11 7.82616 11 7.85163C11.0002 7.99194 10.9778 8.13065 10.9342 8.26106C10.8828 8.41508 10.8039 8.55157 10.706 8.66364C10.6083 8.77555 10.4943 8.86014 10.3735 8.91631C10.253 8.97236 10.1261 9 10 9C9.87391 9 9.74703 8.97236 9.6265 8.91631C9.50571 8.86014 9.3917 8.77555 9.29397 8.66364C9.19608 8.55157 9.11723 8.41508 9.06579 8.26106C9.01432 8.10697 8.99233 7.9413 9.00237 7.77511C9.00358 7.75505 9.00418 7.73495 9.00418 7.71485V4H10.9958V7.71485C10.9958 7.73495 10.9964 7.75505 10.9976 7.77511ZM4.01479 7.97401L5.66539 4H7V7.81021C7 8.07978 6.87887 8.3699 6.60887 8.60639C6.33464 8.84659 5.93746 9 5.5 9C5.06254 9 4.66536 8.84659 4.39113 8.60639C4.17519 8.41725 4.05448 8.19381 4.01479 7.97401ZM19.9852 7.97401L18.3346 4H17V7.81021C17 8.07978 17.1211 8.3699 17.3911 8.60639C17.6654 8.84659 18.0625 9 18.5 9C18.9375 9 19.3346 8.84659 19.6089 8.60639C19.8248 8.41725 19.9455 8.19381 19.9852 7.97401ZM13.4142 19.5858C13.5389 19.7105 13.6454 19.8499 13.7321 20H10.2679C10.3546 19.8499 10.4611 19.7105 10.5858 19.5858C10.9609 19.2107 11.4696 19 12 19C12.5304 19 13.0391 19.2107 13.4142 19.5858Z",
      fill: "currentColor"
    }
  )
] }), CustomerSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 11.5C7.0335 11.5 6.25 10.7165 6.25 9.75C6.25 8.7835 7.0335 8 8 8C8.9665 8 9.75 8.7835 9.75 9.75C9.75 10.7165 8.9665 11.5 8 11.5ZM7.65 9.75C7.65 9.5567 7.8067 9.4 8 9.4C8.1933 9.4 8.35 9.5567 8.35 9.75C8.35 9.9433 8.1933 10.1 8 10.1C7.8067 10.1 7.65 9.9433 7.65 9.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.09854 1C2.81566 1 2.56058 1.17026 2.45208 1.4315L1.05354 4.79864C1.0182 4.88375 1 4.97499 1 5.06715C1 5.69152 1.28396 6.26822 1.75134 6.6776C1.94516 6.84737 2.16472 6.98385 2.4 7.08524V13.6H1.7C1.3134 13.6 1 13.9134 1 14.3C1 14.6866 1.3134 15 1.7 15H14.3C14.6866 15 15 14.6866 15 14.3C15 13.9134 14.6866 13.6 14.3 13.6H13.6V7.08524C13.8353 6.98385 14.0548 6.84737 14.2487 6.6776C14.716 6.26822 15 5.69152 15 5.06715C15 4.97499 14.9818 4.88375 14.9465 4.79864L13.5479 1.4315C13.4394 1.17026 13.1843 1 12.9015 1H10.8L10.7985 1L10.7971 1H8.00293L8 1.00001L7.99707 1H5.20293L5.20146 1L5.2 1H3.09854ZM12.2 7.27715C11.7051 7.21224 11.2336 7.01 10.8578 6.68325C10.6828 6.86021 10.4782 7.0056 10.2518 7.11088C9.98475 7.23504 9.69469 7.3 9.4 7.3C9.10531 7.3 8.81525 7.23504 8.54824 7.11088C8.34632 7.01699 8.16171 6.89119 8 6.73955C7.83829 6.89119 7.65368 7.01699 7.45176 7.11088C7.18475 7.23504 6.89469 7.3 6.6 7.3C6.30531 7.3 6.01525 7.23504 5.74824 7.11088C5.52184 7.0056 5.31719 6.86021 5.14219 6.68325C4.76642 7.01 4.29488 7.21224 3.8 7.27715V13.6H5.28891C5.4129 13.1198 5.6634 12.6768 6.0201 12.3201C6.5452 11.795 7.25739 11.5 8 11.5C8.74261 11.5 9.4548 11.795 9.9799 12.3201C10.3366 12.6768 10.5871 13.1198 10.7111 13.6L12.2 13.6V7.27715ZM8.74605 5.38274C8.71556 5.29145 8.69985 5.19436 8.7 5.09614C8.70003 5.07831 8.70058 5.06045 8.70166 5.04258C8.7025 5.02853 8.70293 5.01447 8.70293 5.0004V2.4H10.0971V5.0004C10.0971 5.01447 10.0975 5.02853 10.0983 5.04258C10.1054 5.15891 10.09 5.27488 10.0539 5.38274C10.0179 5.49056 9.96274 5.5861 9.89422 5.66455C9.82581 5.74288 9.74601 5.8021 9.66145 5.84142C9.57708 5.88065 9.48826 5.9 9.4 5.9C9.31174 5.9 9.22292 5.88065 9.13855 5.84142C9.05399 5.8021 8.97419 5.74288 8.90578 5.66455C8.83726 5.5861 8.78206 5.49055 8.74605 5.38274ZM7.29834 5.04258C7.29942 5.06045 7.29997 5.07831 7.3 5.09614C7.30015 5.19436 7.28444 5.29145 7.25395 5.38274C7.21794 5.49055 7.16274 5.5861 7.09422 5.66455C7.02581 5.74288 6.94601 5.8021 6.86145 5.84142C6.77708 5.88065 6.68826 5.9 6.6 5.9C6.51174 5.9 6.42292 5.88065 6.33855 5.84142C6.25399 5.8021 6.17419 5.74288 6.10578 5.66455C6.03726 5.5861 5.98206 5.49056 5.94605 5.38274C5.91003 5.27488 5.89463 5.15891 5.90166 5.04258C5.9025 5.02853 5.90293 5.01447 5.90293 5.0004V2.4H7.29707V5.0004C7.29707 5.01447 7.2975 5.02853 7.29834 5.04258ZM2.41035 5.18181L3.56577 2.4H4.5V5.06715C4.5 5.25585 4.41521 5.45893 4.22621 5.62447C4.03425 5.79262 3.75622 5.9 3.45 5.9C3.14378 5.9 2.86575 5.79262 2.67379 5.62447C2.52264 5.49207 2.43813 5.33567 2.41035 5.18181ZM13.5896 5.18181L12.4342 2.4H11.5V5.06715C11.5 5.25585 11.5848 5.45893 11.7738 5.62447C11.9658 5.79262 12.2438 5.9 12.55 5.9C12.8562 5.9 13.1342 5.79262 13.3262 5.62447C13.4774 5.49207 13.5619 5.33567 13.5896 5.18181ZM8.98995 13.3101C9.07722 13.3973 9.15178 13.4949 9.21244 13.6H6.78756C6.84822 13.4949 6.92278 13.3973 7.01005 13.3101C7.2726 13.0475 7.6287 12.9 8 12.9C8.3713 12.9 8.7274 13.0475 8.98995 13.3101Z",
      fill: "currentColor"
    }
  )
] }), DashboardLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7V17C7 17.5523 7.44772 18 8 18C8.55228 18 9 17.5523 9 17V7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 11C12.5523 11 13 11.4477 13 12V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V12C11 11.4477 11.4477 11 12 11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17 9C17 8.44772 16.5523 8 16 8C15.4477 8 15 8.44772 15 9V17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17V9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V4.5C22 3.11929 20.8807 2 19.5 2H4.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H19.5C19.7761 4 20 4.22386 20 4.5V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V4.5Z",
      fill: "currentColor"
    }
  )
] }), DashboardSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.625 4.875C6.625 4.46079 6.28921 4.125 5.875 4.125C5.46079 4.125 5.125 4.46079 5.125 4.875V11.125C5.125 11.5392 5.46079 11.875 5.875 11.875C6.28921 11.875 6.625 11.5392 6.625 11.125V4.875Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.75 7.21875C10.75 6.80454 10.4142 6.46875 10 6.46875C9.58579 6.46875 9.25 6.80454 9.25 7.21875V11.125C9.25 11.5392 9.58579 11.875 10 11.875C10.4142 11.875 10.75 11.5392 10.75 11.125V7.21875Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.75 1C1.7835 1 1 1.7835 1 2.75V13.25C1 14.2165 1.7835 15 2.75 15H13.25C14.2165 15 15 14.2165 15 13.25V2.75C15 1.7835 14.2165 1 13.25 1H2.75ZM2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H13.25C13.3881 2.5 13.5 2.61193 13.5 2.75V13.25C13.5 13.3881 13.3881 13.5 13.25 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25V2.75Z",
      fill: "currentColor"
    }
  )
] }), DebitCardLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5.64706C2 4.18513 3.11929 3 4.5 3H19.5C20.8807 3 22 4.18513 22 5.64706V17.8673C22 18.452 21.5523 18.9261 21 18.9261C20.4477 18.9261 20 18.452 20 17.8673V9.35294L4 9.35294V17.2941C4 17.5865 4.22386 17.8235 4.5 17.8235H12C12.5523 17.8235 13 18.2976 13 18.8824C13 19.4671 12.5523 19.9412 12 19.9412H4.5C3.11929 19.9412 2 18.756 2 17.2941V5.64706ZM4 5.64706C4 5.35467 4.22386 5.11765 4.5 5.11765H19.5C19.7761 5.11765 20 5.35467 20 5.64706V7.2353L4 7.23529V5.64706Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 15.7059C5 15.1211 5.44772 14.6471 6 14.6471H10C10.5523 14.6471 11 15.1211 11 15.7059C11 16.2907 10.5523 16.7647 10 16.7647H6C5.44772 16.7647 5 16.2907 5 15.7059Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9835 12.4566C16.9482 11.9058 16.515 11.4706 15.9858 11.4706C15.4564 11.4706 15.023 11.9063 14.9881 12.4576C14.578 12.5764 14.2157 12.7795 13.9203 13.0794C13.4 13.6078 13.2303 14.2916 13.2359 14.8884C13.2412 15.4612 13.4311 16.1038 13.9483 16.597C14.4532 17.0786 15.1493 17.3024 15.958 17.3224C16.3615 17.3324 16.5482 17.4772 16.6342 17.571C16.6851 17.6265 16.7159 17.6813 16.732 17.7198L16.7352 17.7278C16.7322 17.8891 16.7157 17.9515 16.6942 17.9844C16.692 17.988 16.674 18.0174 16.5969 18.0529C16.5068 18.0943 16.321 18.1503 15.9814 18.1503C15.5876 18.1503 15.3919 18.0752 15.311 18.0311C14.82 17.7633 14.217 17.9676 13.964 18.4874C13.7111 19.0073 13.9041 19.6458 14.395 19.9136C14.5807 20.0149 14.7842 20.0946 15.0058 20.1526C15.0983 20.6361 15.5019 21 15.9858 21C16.4713 21 16.876 20.6337 16.9668 20.1478C17.5653 19.9866 18.0283 19.6645 18.3387 19.1897C18.7385 18.5781 18.7364 17.9094 18.7358 17.6941L18.7357 17.6719C18.7357 16.7123 17.8689 15.2514 16.0047 15.2053C15.4976 15.1928 15.3241 15.0591 15.2868 15.0235C15.2617 14.9996 15.2367 14.9654 15.2358 14.8675C15.2342 14.6959 15.2794 14.6335 15.3047 14.6078C15.3338 14.5782 15.489 14.4444 15.9814 14.4444C16.3032 14.4444 16.4967 14.5025 16.6018 14.5519C16.6226 14.5617 16.6402 14.5712 16.655 14.5801C17.1351 14.8692 17.7456 14.6915 18.0186 14.1832C18.2917 13.6749 18.1238 13.0285 17.6438 12.7394C17.5701 12.695 17.4934 12.654 17.4135 12.6165C17.2782 12.5529 17.1348 12.4995 16.9835 12.4566Z",
      fill: "currentColor"
    }
  )
] }), DebitCardSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 12.25V6.74219H14.5V11.0049C14.5 11.4191 14.8358 11.7549 15.25 11.7549C15.6642 11.7549 16 11.4191 16 11.0049V3.75C16 2.7835 15.2165 2 14.25 2H1.75C0.783502 2 0 2.7835 0 3.75V12.25C0 13.2165 0.783502 14 1.75 14H7.00851C7.42273 14 7.75851 13.6642 7.75851 13.25C7.75851 12.8358 7.42273 12.5 7.00851 12.5H1.75C1.61193 12.5 1.5 12.3881 1.5 12.25ZM1.75 3.5C1.61193 3.5 1.5 3.61193 1.5 3.75V5.24219H14.5V3.75C14.5 3.61193 14.3881 3.5 14.25 3.5H1.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.8795 9.56077C10.9048 9.55089 10.9318 9.54619 10.959 9.54695L10.98 9.54725H11.2848L11.2998 9.5474L11.3148 9.54725H12.5733C12.9875 9.54725 13.3233 9.21146 13.3233 8.79725C13.3233 8.38303 12.9875 8.04725 12.5733 8.04725H12.0408C11.9847 7.68851 11.6743 7.41406 11.2998 7.41406C10.909 7.41406 10.588 7.71294 10.553 8.09459C10.4789 8.11252 10.4059 8.13544 10.3345 8.16326C10.1223 8.24601 9.92887 8.37047 9.76562 8.52927C9.60237 8.68808 9.47263 8.87802 9.38406 9.08784C9.29553 9.29758 9.24995 9.52323 9.25 9.75087C9.25008 10.2025 9.42953 10.6357 9.74889 10.955C10.0683 11.2745 10.5016 11.4539 10.9533 11.4539H11.62C11.6468 11.4539 11.6734 11.4592 11.6982 11.4695C11.7229 11.4798 11.7454 11.4949 11.7643 11.514C11.7832 11.533 11.7981 11.5556 11.8083 11.5804C11.8184 11.6053 11.8235 11.6318 11.8233 11.6587V11.6639C11.8233 11.7178 11.8019 11.7696 11.7638 11.8077C11.7256 11.8458 11.6739 11.8672 11.62 11.8672H11.3095C11.3063 11.8672 11.303 11.8672 11.2998 11.8672C11.2966 11.8672 11.2934 11.8672 11.2901 11.8672H10.0267C9.61245 11.8672 9.27667 12.203 9.27667 12.6172C9.27667 13.0315 9.61245 13.3672 10.0267 13.3672H10.5588C10.6149 13.726 10.9253 14.0005 11.2998 14.0005C11.693 14.0005 12.0156 13.6979 12.0473 13.3128C12.3388 13.2372 12.6078 13.085 12.8244 12.8684C13.1433 12.5495 13.3226 12.1173 13.3233 11.6665L13.3233 11.6692L12.5733 11.6639H13.3233L13.3233 11.6665C13.3246 11.4427 13.2817 11.2209 13.1971 11.0137C13.1122 10.8056 12.987 10.6164 12.8287 10.457C12.6703 10.2976 12.482 10.171 12.2746 10.0847C12.0672 9.99836 11.8447 9.95391 11.62 9.95391H10.9533C10.8994 9.95391 10.8477 9.93249 10.8096 9.89436C10.7714 9.85623 10.75 9.80422 10.75 9.75029C10.75 9.7231 10.7554 9.69619 10.766 9.67114C10.7766 9.64609 10.7921 9.62342 10.8116 9.60446C10.831 9.5855 10.8541 9.57065 10.8795 9.56077Z",
      fill: "currentColor"
    }
  )
] }), DeclineCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7Z",
    fill: "currentColor"
  }
) }), DeclineCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.9999C12.4183 15.9999 16 12.4182 16 7.99988C16 3.5816 12.4183 -0.00012207 8 -0.00012207C3.58172 -0.00012207 0 3.5816 0 7.99988C0 12.4182 3.58172 15.9999 8 15.9999ZM4.36368 7.27269C3.96202 7.27269 3.63641 7.5983 3.63641 7.99997C3.63641 8.40163 3.96202 8.72724 4.36368 8.72724H11.6364C12.0381 8.72724 12.3637 8.40163 12.3637 7.99997C12.3637 7.5983 12.0381 7.27269 11.6364 7.27269H4.36368Z",
    fill: "currentColor"
  }
) }), DeclineCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), DeclineCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.3637 7.27261C3.96204 7.27261 3.63642 7.59822 3.63642 7.99988C3.63642 8.40154 3.96204 8.72715 4.3637 8.72715H11.6364C12.0381 8.72715 12.3637 8.40154 12.3637 7.99988C12.3637 7.59822 12.0381 7.27261 11.6364 7.27261H4.3637Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00006 -0.00012207C3.58178 -0.00012207 6.10352e-05 3.5816 6.10352e-05 7.99988C6.10352e-05 12.4182 3.58178 15.9999 8.00006 15.9999C12.4183 15.9999 16.0001 12.4182 16.0001 7.99988C16.0001 3.5816 12.4183 -0.00012207 8.00006 -0.00012207ZM1.45461 7.99988C1.45461 4.38492 4.38511 1.45442 8.00006 1.45442C11.615 1.45442 14.5455 4.38492 14.5455 7.99988C14.5455 11.6148 11.615 14.5453 8.00006 14.5453C4.38511 14.5453 1.45461 11.6148 1.45461 7.99988Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10678_566709", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), DeleteLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57143 5V4.8C7.57143 4.07271 7.84613 3.36598 8.34939 2.83755C8.85424 2.30747 9.54966 2 10.2857 2H13.7143C14.4503 2 15.1458 2.30747 15.6506 2.83755C16.1539 3.36598 16.4286 4.07271 16.4286 4.8V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H19V19.2C19 19.9273 18.7253 20.634 18.222 21.1624C17.7172 21.6925 17.0218 22 16.2857 22H7.71429C6.97823 22 6.28281 21.6925 5.77796 21.1624C5.2747 20.634 5 19.9273 5 19.2V7H4C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5H7.57143ZM9.79767 4.21686C9.93581 4.07182 10.1125 4 10.2857 4H13.7143C13.8875 4 14.0642 4.07182 14.2023 4.21686C14.342 4.36357 14.4286 4.57251 14.4286 4.8V5H9.57143V4.8C9.57143 4.57251 9.65795 4.36357 9.79767 4.21686ZM7 7V19.2C7 19.4275 7.08652 19.6364 7.22624 19.7831C7.36438 19.9282 7.54103 20 7.71429 20H16.2857C16.459 20 16.6356 19.9282 16.7738 19.7831C16.9135 19.6364 17 19.4275 17 19.2V7H7Z",
    fill: "currentColor"
  }
) }), DeleteSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55556 2.4V2.24C4.55556 1.65817 4.76921 1.09278 5.16064 0.670042C5.5533 0.245974 6.09418 0 6.66667 0H9.33333C9.90582 0 10.4467 0.245974 10.8394 0.670042C11.2308 1.09278 11.4444 1.65817 11.4444 2.24V2.4H14.2222C14.6518 2.4 15 2.75817 15 3.2C15 3.64183 14.6518 4 14.2222 4H13.4444V13.76C13.4444 14.3418 13.2308 14.9072 12.8394 15.33C12.4467 15.754 11.9058 16 11.3333 16H4.66667C4.09418 16 3.55329 15.754 3.16064 15.33C2.76921 14.9072 2.55556 14.3418 2.55556 13.76V4H1.77778C1.34822 4 1 3.64183 1 3.2C1 2.75817 1.34822 2.4 1.77778 2.4H4.55556ZM6.28708 1.77349C6.39452 1.65745 6.53191 1.6 6.66667 1.6H9.33333C9.46809 1.6 9.60548 1.65745 9.71292 1.77349C9.82159 1.89085 9.88889 2.05801 9.88889 2.24V2.4H6.11111V2.24C6.11111 2.05801 6.17841 1.89085 6.28708 1.77349ZM4.11111 4V13.76C4.11111 13.942 4.17841 14.1091 4.28708 14.2265C4.39452 14.3425 4.53191 14.4 4.66667 14.4H11.3333C11.4681 14.4 11.6055 14.3425 11.7129 14.2265C11.8216 14.1091 11.8889 13.942 11.8889 13.76V4H4.11111Z",
    fill: "currentColor"
  }
) }), DirectoryPaymentLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.8 3.52387C21.1314 3.10308 21.0418 2.50612 20.6 2.19053C20.1582 1.87494 19.5314 1.96022 19.2 2.38101L16.8918 5.31205L15.7071 4.18376C15.3166 3.81184 14.6834 3.81184 14.2929 4.18376C13.9024 4.55569 13.9024 5.15871 14.2929 5.53063L16.2929 7.4354C16.4979 7.63062 16.7817 7.73152 17.0709 7.71195C17.3601 7.69237 17.6261 7.55426 17.8 7.33339L20.8 3.52387Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19 19.619C19 20.934 17.8807 22 16.5 22H5.5C4.11929 22 3 20.934 3 19.619V5.33333C3 4.01837 4.11929 2.95238 5.5 2.95238H12C12.5523 2.95238 13 3.37878 13 3.90476C13 4.43075 12.5523 4.85714 12 4.85714L5.5 4.85714C5.22386 4.85714 5 5.07034 5 5.33333L5 19.619C5 19.882 5.22386 20.0952 5.5 20.0952H16.5C16.7761 20.0952 17 19.882 17 19.619V10.0952C17 9.56925 17.4477 9.14286 18 9.14286C18.5523 9.14286 19 9.56925 19 10.0952V19.619Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.9951 6.28571C11.5474 6.28571 11.9951 6.71211 11.9951 7.2381V7.83802C12.9184 8.08361 13.5134 8.66557 13.7913 9.31805C13.999 9.80544 13.7524 10.3609 13.2406 10.5586C12.7289 10.7564 12.1457 10.5216 11.938 10.0342C11.9015 9.94828 11.834 9.85526 11.7153 9.78039C11.5994 9.70726 11.383 9.61905 10.995 9.61905C10.4815 9.61905 10.2898 9.76923 10.2039 9.86857C10.0906 9.99959 9.99712 10.2389 10.0001 10.6061C10.0024 10.8921 10.0831 11.0915 10.1922 11.211C10.2827 11.31 10.4923 11.4654 11.0248 11.4805C12.1148 11.5114 12.8825 12.0118 13.3532 12.601C13.7909 13.149 13.995 13.7994 13.995 14.2746L13.9951 14.3C13.9956 14.5634 13.9969 15.2715 13.624 15.9261C13.4189 16.2862 13.1026 16.6299 12.6364 16.8762C12.4389 16.9805 12.2249 17.0619 11.9951 17.1209V17.7143C11.9951 18.2403 11.5474 18.6667 10.9951 18.6667C10.4428 18.6667 9.99512 18.2403 9.99512 17.7143V17.1221C9.66102 17.0376 9.36458 16.9083 9.10624 16.7376C8.61534 16.4134 8.33953 15.9913 8.19012 15.6224C7.99138 15.1317 8.24799 14.5804 8.76328 14.3911C9.27857 14.2018 9.8574 14.4462 10.0561 14.937C10.0928 15.0276 10.1493 15.1086 10.246 15.1724C10.3414 15.2354 10.5536 15.3333 10.995 15.3333C11.3641 15.3333 11.5639 15.2646 11.6662 15.2106C11.7625 15.1597 11.8212 15.0965 11.8661 15.0178C11.9805 14.8169 11.995 14.5456 11.995 14.2746C11.995 14.2747 11.9951 14.2749 11.995 14.2746C11.9946 14.2688 11.989 14.2 11.9485 14.0889C11.9086 13.9792 11.8463 13.8606 11.7614 13.7543C11.6069 13.5609 11.3746 13.396 10.9653 13.3844C9.99776 13.3569 9.21349 13.0416 8.68331 12.4612C8.17173 11.9011 8.00497 11.2123 8.00016 10.6209C7.99498 9.98273 8.14898 9.24861 8.66016 8.65756C9.00323 8.26089 9.45638 7.98683 9.99512 7.84013V7.2381C9.99512 6.71211 10.4428 6.28571 10.9951 6.28571Z",
      fill: "currentColor"
    }
  )
] }), DirectoryPaymentSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.9303 6.99168C11.9303 6.57747 12.2638 6.24169 12.6751 6.24169C13.0864 6.24169 13.4199 6.57747 13.4199 6.99169V13.25C13.4199 14.2165 12.6418 15 11.6821 15H3.73781C2.77804 15 2 14.2165 2 13.25V2.75C2 1.7835 2.77804 1 3.73781 1H7.05548C7.4668 1 7.80025 1.33579 7.80025 1.75C7.80025 2.16421 7.4668 2.5 7.05548 2.5L3.73781 2.5C3.6007 2.5 3.48955 2.61193 3.48955 2.75L3.48955 13.25C3.48955 13.3881 3.6007 13.5 3.73781 13.5H11.6821C11.8192 13.5 11.9303 13.3881 11.9303 13.25V6.99168Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.70993 3.75C8.12126 3.75 8.45471 4.08579 8.45471 4.5V4.83574C8.96168 4.96125 9.35132 5.21835 9.60919 5.56599C9.85535 5.89784 9.78776 6.36781 9.45822 6.6157C9.12868 6.86359 8.66199 6.79552 8.41583 6.46367C8.38598 6.42343 8.23208 6.25 7.708 6.25C7.28252 6.25 7.12483 6.36502 7.07182 6.41895C7.01572 6.47603 6.96338 6.58056 6.96513 6.77063C6.96635 6.90243 7.00534 6.9838 7.06158 7.03798C7.12041 7.09466 7.29117 7.21065 7.72645 7.2215C8.48919 7.24053 9.05355 7.54766 9.4227 7.95434C9.76324 8.32952 9.94418 8.79987 9.94418 9.18021L9.94421 9.19796C9.94467 9.37717 9.94598 9.89805 9.6369 10.3755C9.38294 10.7678 8.98749 11.0409 8.45471 11.1684V11.5C8.45471 11.9142 8.12126 12.25 7.70993 12.25C7.2986 12.25 6.96516 11.9142 6.96516 11.5V11.1704C6.46162 11.0527 6.08651 10.81 5.83279 10.4802C5.58086 10.1528 5.64022 9.6817 5.96537 9.428C6.29052 9.17431 6.75834 9.23409 7.01026 9.56152C7.0264 9.5825 7.15514 9.75 7.708 9.75C8.00194 9.75 8.16938 9.70126 8.25803 9.66005C8.33931 9.62226 8.37159 9.58339 8.38906 9.55639C8.44011 9.47754 8.45373 9.3638 8.45459 9.19777C8.45297 9.19056 8.44826 9.17149 8.43606 9.14198C8.41449 9.0898 8.37797 9.02665 8.32325 8.96636C8.22621 8.85945 8.04487 8.72991 7.68956 8.72104C7.00628 8.704 6.43589 8.51108 6.03188 8.12186C5.62528 7.73014 5.47975 7.22863 5.47565 6.78457C5.47131 6.31487 5.6035 5.7806 6.01309 5.36382C6.26856 5.10387 6.59165 4.93054 6.96516 4.8362V4.5C6.96516 4.08579 7.2986 3.75 7.70993 3.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.8463 2.21409C14.0965 1.88533 14.0347 1.41456 13.7082 1.16258C13.3818 0.910608 12.9143 0.972854 12.6641 1.30161L11.1997 3.22564L10.5601 2.5816C10.2692 2.28872 9.79765 2.28875 9.50681 2.58166C9.21597 2.87457 9.216 3.34944 9.50686 3.64232L10.7473 4.89135C10.899 5.04411 11.1088 5.12357 11.3229 5.10938C11.5369 5.09518 11.7345 4.98871 11.8651 4.81723L13.8463 2.21409Z",
      fill: "currentColor"
    }
  )
] }), DiscountLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.252 1.29187C11.6736 0.901084 12.3264 0.901084 12.7479 1.29187L14.6238 3.03082C14.8246 3.21698 15.0986 3.30357 15.3704 3.26673L18.1261 2.89322C18.611 2.82751 19.0619 3.15352 19.1498 3.63325L19.6186 6.1943C19.6698 6.47396 19.8489 6.71384 20.103 6.84303L22.5005 8.06202C22.9503 8.29069 23.1293 8.83919 22.9004 9.28774L21.7283 11.5855C21.5958 11.8452 21.5958 12.1524 21.7283 12.4121L22.9004 14.7098C23.1293 15.1584 22.9503 15.7069 22.5005 15.9355L20.103 17.1545C19.8489 17.2837 19.6698 17.5236 19.6186 17.8033L19.1498 20.3643C19.0619 20.844 18.611 21.1701 18.1261 21.1043L15.3704 20.7308C15.0986 20.694 14.8246 20.7806 14.6238 20.9667L12.7479 22.7057C12.3264 23.0965 11.6736 23.0965 11.252 22.7057L9.3762 20.9667C9.17538 20.7806 8.90135 20.694 8.62958 20.7308L5.87385 21.1043C5.389 21.1701 4.93806 20.844 4.85024 20.3643L4.38143 17.8033C4.33023 17.5236 4.15112 17.2837 3.89702 17.1545L1.49945 15.9355C1.04969 15.7069 0.870745 15.1584 1.09956 14.7098L2.27168 12.4121C2.40417 12.1524 2.40417 11.8452 2.27168 11.5855L1.09956 9.28774C0.870745 8.83919 1.04969 8.29069 1.49946 8.06202L3.89702 6.84303C4.15112 6.71384 4.33023 6.47396 4.38143 6.1943L4.85024 3.63325C4.93806 3.15352 5.389 2.82751 5.87385 2.89322L8.62958 3.26673C8.90135 3.30357 9.17538 3.21698 9.3762 3.03081L11.252 1.29187ZM10.4627 10.4536C10.7322 10.184 10.8837 9.81843 10.8837 9.43719C10.8837 9.05596 10.7322 8.69034 10.4627 8.42077C10.1931 8.1512 9.82746 7.99976 9.44623 7.99976C9.065 7.99976 8.69938 8.1512 8.42981 8.42077C8.16023 8.69034 8.00879 9.05596 8.00879 9.43719C8.00879 9.81843 8.16023 10.184 8.42981 10.4536C8.69938 10.7232 9.065 10.8746 9.44623 10.8746C9.82746 10.8746 10.1931 10.7232 10.4627 10.4536ZM10.2081 15.9488L15.9578 10.199C16.0637 10.1003 16.1487 9.98132 16.2076 9.84908C16.2665 9.71683 16.2982 9.57407 16.3008 9.42932C16.3033 9.28457 16.2767 9.14078 16.2225 9.00654C16.1683 8.8723 16.0876 8.75036 15.9852 8.64799C15.8828 8.54561 15.7609 8.46491 15.6266 8.41069C15.4924 8.35646 15.3486 8.32984 15.2039 8.33239C15.0591 8.33495 14.9163 8.36663 14.7841 8.42555C14.6519 8.48448 14.5328 8.56943 14.4341 8.67535L8.68438 14.4251C8.57846 14.5238 8.49351 14.6428 8.43459 14.7751C8.37566 14.9073 8.34398 15.0501 8.34142 15.1948C8.33887 15.3396 8.3655 15.4834 8.41972 15.6176C8.47394 15.7518 8.55465 15.8738 8.65702 15.9762C8.75939 16.0785 8.88133 16.1592 9.01557 16.2135C9.14981 16.2677 9.2936 16.2943 9.43835 16.2918C9.58311 16.2892 9.72587 16.2575 9.85811 16.1986C9.99035 16.1397 10.1094 16.0547 10.2081 15.9488ZM16.2124 16.2034C16.482 15.9338 16.6334 15.5682 16.6334 15.1869C16.6334 14.8057 16.482 14.4401 16.2124 14.1705C15.9428 13.901 15.5772 13.7495 15.196 13.7495C14.8148 13.7495 14.4491 13.901 14.1796 14.1705C13.91 14.4401 13.7585 14.8057 13.7585 15.1869C13.7585 15.5682 13.91 15.9338 14.1796 16.2034C14.4491 16.4729 14.8148 16.6244 15.196 16.6244C15.5772 16.6244 15.9428 16.4729 16.2124 16.2034Z",
    fill: "currentColor"
  }
) }), DiscountSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52403 1.18651C7.79229 0.93783 8.20771 0.93783 8.47597 1.18651L9.66969 2.29311C9.79748 2.41158 9.97186 2.46668 10.1448 2.44324L11.8985 2.20555C12.207 2.16373 12.494 2.3712 12.5498 2.67648L12.8482 4.30624C12.8808 4.48421 12.9947 4.63686 13.1564 4.71907L14.6822 5.49479C14.9684 5.64031 15.0823 5.98935 14.9366 6.27479L14.1907 7.73698C14.1064 7.90226 14.1064 8.09774 14.1907 8.26302L14.9366 9.72521C15.0823 10.0106 14.9684 10.3597 14.6822 10.5052L13.1564 11.2809C12.9947 11.3631 12.8808 11.5158 12.8482 11.6938L12.5498 13.3235C12.494 13.6288 12.207 13.8363 11.8985 13.7944L10.1448 13.5568C9.97186 13.5333 9.79748 13.5884 9.66969 13.7069L8.47597 14.8135C8.20771 15.0622 7.79229 15.0622 7.52403 14.8135L6.33031 13.7069C6.20251 13.5884 6.02814 13.5333 5.85519 13.5568L4.10154 13.7944C3.793 13.8363 3.50604 13.6288 3.45015 13.3235L3.15182 11.6938C3.11924 11.5158 3.00526 11.3631 2.84356 11.2809L1.31783 10.5052C1.03162 10.3597 0.917747 10.0106 1.06336 9.72521L1.80925 8.26302C1.89356 8.09774 1.89356 7.90226 1.80925 7.73698L1.06336 6.27479C0.917747 5.98935 1.03162 5.64031 1.31784 5.49479L2.84356 4.71907C3.00526 4.63686 3.11924 4.48421 3.15182 4.30624L3.45015 2.67648C3.50604 2.3712 3.793 2.16373 4.10154 2.20555L5.85519 2.44324C6.02813 2.46668 6.20251 2.41158 6.33031 2.29311L7.52403 1.18651ZM7.02169 7.01609C7.19323 6.84455 7.28961 6.61188 7.28961 6.36928C7.28961 6.12668 7.19323 5.89401 7.02169 5.72246C6.85014 5.55092 6.61748 5.45455 6.37487 5.45455C6.13227 5.45455 5.8996 5.55092 5.72806 5.72246C5.55651 5.89401 5.46014 6.12668 5.46014 6.36928C5.46014 6.61188 5.55651 6.84455 5.72806 7.01609C5.8996 7.18764 6.13227 7.28401 6.37487 7.28401C6.61748 7.28401 6.85014 7.18764 7.02169 7.01609ZM6.85968 10.513L10.5186 6.85409C10.586 6.79128 10.6401 6.71554 10.6776 6.63138C10.7151 6.54723 10.7352 6.45638 10.7369 6.36427C10.7385 6.27215 10.7215 6.18065 10.687 6.09523C10.6525 6.0098 10.6012 5.9322 10.536 5.86706C10.4709 5.80191 10.3933 5.75055 10.3079 5.71605C10.2224 5.68154 10.1309 5.6646 10.0388 5.66622C9.9467 5.66785 9.85586 5.68801 9.7717 5.72551C9.68755 5.763 9.61181 5.81707 9.549 5.88447L5.89006 9.5434C5.82266 9.60621 5.7686 9.68195 5.7311 9.76611C5.6936 9.85026 5.67344 9.94111 5.67182 10.0332C5.67019 10.1253 5.68714 10.2168 5.72164 10.3023C5.75614 10.3877 5.8075 10.4653 5.87265 10.5304C5.93779 10.5956 6.0154 10.6469 6.10082 10.6814C6.18625 10.716 6.27775 10.7329 6.36986 10.7313C6.46198 10.7296 6.55282 10.7095 6.63698 10.672C6.72113 10.6345 6.79687 10.5804 6.85968 10.513ZM10.6806 10.675C10.8522 10.5035 10.9485 10.2708 10.9485 10.0282C10.9485 9.78561 10.8522 9.55294 10.6806 9.3814C10.5091 9.20985 10.2764 9.11348 10.0338 9.11348C9.79121 9.11348 9.55854 9.20985 9.38699 9.3814C9.21545 9.55294 9.11907 9.78561 9.11907 10.0282C9.11907 10.2708 9.21545 10.5035 9.38699 10.675C9.55854 10.8466 9.79121 10.9429 10.0338 10.9429C10.2764 10.9429 10.5091 10.8466 10.6806 10.675Z",
    fill: "currentColor"
  }
) }), DownloadLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 2C12.5523 2 13 2.44772 13 3L13 13.238L16.2318 9.35984C16.5854 8.93556 17.2159 8.87824 17.6402 9.2318C18.0645 9.58537 18.1218 10.2159 17.7682 10.6402L12.7682 16.6402C12.7233 16.6942 12.6732 16.7427 12.619 16.7855C12.4442 16.9232 12.2266 17 12 17C11.9821 17 11.9643 16.9995 11.9466 16.9986C11.6824 16.9847 11.4454 16.8683 11.2747 16.6884C11.258 16.6709 11.242 16.6527 11.2266 16.634L6.2318 10.6402C5.87824 10.2159 5.93556 9.58537 6.35984 9.2318C6.78412 8.87824 7.41468 8.93556 7.76825 9.35984L11 13.2379L11 3C11 2.44772 11.4477 2 12 2Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3 16C3.55228 16 4 16.4477 4 17V20H20V17C20 16.4477 20.4477 16 21 16C21.5523 16 22 16.4477 22 17V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V17C2 16.4477 2.44772 16 3 16Z",
      fill: "currentColor"
    }
  )
] }), DownloadSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.00098 1C8.41519 1.00046 8.7506 1.33759 8.75014 1.75298L8.74279 8.36673L10.4005 6.15333C10.6493 5.82119 11.1194 5.75417 11.4506 6.00364C11.7818 6.25311 11.8486 6.7246 11.5999 7.05675L8.59427 11.0699C8.45247 11.2592 8.23006 11.3705 7.99395 11.3703C7.75784 11.3701 7.53561 11.2584 7.39414 11.0689L4.3991 7.05573C4.1509 6.72316 4.21852 6.25178 4.55014 6.00287C4.88176 5.75397 5.35179 5.82178 5.59999 6.15435L7.24281 8.35559L7.25014 1.75131C7.2506 1.33591 7.58676 0.999538 8.00098 1Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1.75 10.4872C2.16421 10.4872 2.5 10.8239 2.5 11.2393V13.4957H13.5V11.2393C13.5 10.8239 13.8358 10.4872 14.25 10.4872C14.6642 10.4872 15 10.8239 15 11.2393V14.2479C15 14.6633 14.6642 15 14.25 15H1.75C1.33579 15 1 14.6633 1 14.2479V11.2393C1 10.8239 1.33579 10.4872 1.75 10.4872Z",
      fill: "currentColor"
    }
  )
] }), DuplicateFlipLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 1C16.1046 1 17 1.89543 17 3L17 17C17 18.1046 16.1046 19 15 19L5 19C3.89543 19 3 18.1046 3 17L3 3C3 1.89543 3.89543 1 5 1H15ZM15 3L5 3L5 17H15L15 3Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19 5C19 4.44772 19.4477 4 20 4C20.5523 4 21 4.44772 21 5V19.5C21 21.433 19.433 23 17.5 23L7 23C6.44771 23 6 22.5523 6 22C6 21.4477 6.44771 21 7 21L17.5 21C18.3284 21 19 20.3284 19 19.5V5Z",
      fill: "currentColor"
    }
  )
] }), DuplicateFlipSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.77246 0C10.7418 0 11.5275 0.834096 11.5275 1.863L11.5275 11.4442C11.5275 12.4731 10.7418 13.3072 9.77245 13.3072L3.75507 13.3072C2.78577 13.3072 2 12.4731 2 11.4442V1.863C2 0.834095 2.78577 0 3.75507 0H9.77246ZM10.0232 1.863C10.0232 1.71602 9.91093 1.59686 9.77246 1.59686L3.75507 1.59686C3.6166 1.59686 3.50435 1.71602 3.50435 1.863L3.50435 11.4442C3.50435 11.5912 3.6166 11.7103 3.75507 11.7103L9.77245 11.7103C9.91093 11.7103 10.0232 11.5912 10.0232 11.4442L10.0232 1.863Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.4957 3.38501C12.4957 2.94405 12.8324 2.58658 13.2478 2.58658C13.6632 2.58658 14 2.94405 14 3.38501V12.5401C14 14.451 12.5407 16 10.7406 16L4.73515 16C4.31973 16 3.98297 15.6425 3.98298 15.2016C3.98298 14.7606 4.31973 14.4031 4.73515 14.4031L10.7406 14.4031C11.7099 14.4031 12.4957 13.569 12.4957 12.5401V3.38501Z",
      fill: "currentColor"
    }
  )
] }), DuplicateLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 1C7.89543 1 7 1.89543 7 3L7 17C7 18.1046 7.89543 19 9 19L19 19C20.1046 19 21 18.1046 21 17L21 3C21 1.89543 20.1046 1 19 1H9ZM9 3L19 3L19 17H9L9 3Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 5C5 4.44772 4.55228 4 4 4C3.44772 4 3 4.44772 3 5V19.5C3 21.433 4.567 23 6.5 23L17 23C17.5523 23 18 22.5523 18 22C18 21.4477 17.5523 21 17 21L6.5 21C5.67157 21 5 20.3284 5 19.5V5Z",
      fill: "currentColor"
    }
  )
] }), DuplicateSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.22754 0C5.25824 0 4.47247 0.834096 4.47247 1.863L4.47248 11.4442C4.47248 12.4731 5.25825 13.3072 6.22755 13.3072L12.2449 13.3072C13.2142 13.3072 14 12.4731 14 11.4442V1.863C14 0.834095 13.2142 0 12.2449 0H6.22754ZM5.97682 1.863C5.97682 1.71602 6.08907 1.59686 6.22754 1.59686L12.2449 1.59686C12.3834 1.59686 12.4957 1.71602 12.4957 1.863L12.4957 11.4442C12.4957 11.5912 12.3834 11.7103 12.2449 11.7103L6.22755 11.7103C6.08907 11.7103 5.97682 11.5912 5.97682 11.4442L5.97682 1.863Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.50435 3.38501C3.50435 2.94405 3.16759 2.58658 2.75217 2.58658C2.33676 2.58658 2 2.94405 2 3.38501V12.5401C2 14.451 3.45929 16 5.25942 16L11.2649 16C11.6803 16 12.017 15.6425 12.017 15.2016C12.017 14.7606 11.6803 14.4031 11.2649 14.4031L5.25942 14.4031C4.29012 14.4031 3.50435 13.569 3.50435 12.5401V3.38501Z",
      fill: "currentColor"
    }
  )
] }), EditLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.829 2.29768C18.6383 2.10708 18.3798 2 18.1102 2C17.8406 2 17.582 2.10708 17.3914 2.29768L14.2614 5.42709C14.2549 5.43326 14.2485 5.43952 14.2421 5.44589C14.2357 5.45228 14.2294 5.45873 14.2232 5.46525L4.36761 15.319C4.27408 15.4125 4.19971 15.5234 4.14865 15.6454L2.07881 20.5913C1.91955 20.9719 2.00616 21.4109 2.298 21.7025C2.58984 21.9941 3.02902 22.0804 3.40953 21.9209L8.3565 19.8476C8.47832 19.7966 8.58902 19.7223 8.68241 19.6289L18.5123 9.79805C18.5267 9.78518 18.5408 9.77183 18.5547 9.75799C18.5686 9.74406 18.582 9.72983 18.595 9.71532L21.7024 6.60763C22.0993 6.21071 22.0992 5.56728 21.7023 5.17042L18.829 2.29768ZM17.8347 7.6007L19.546 5.88918L18.1102 4.45364L16.3987 6.16485L17.8347 7.6007ZM14.9611 7.60216L5.94683 16.6147L4.91212 19.0872L7.38605 18.0503L16.3973 9.03821L14.9611 7.60216Z",
    fill: "currentColor"
  }
) }), EditSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1987 1.22367C11.9 0.925444 11.4155 0.925444 11.1168 1.22367L2.89723 9.42786C2.82259 9.50237 2.7642 9.59149 2.72574 9.68961L1.05261 13.9581C0.941494 14.2416 1.00967 14.5639 1.22612 14.7783C1.44257 14.9928 1.76595 15.0584 2.04913 14.9454L6.29942 13.2493C6.39567 13.2109 6.48309 13.1534 6.55639 13.0802L14.7759 4.876C15.0747 4.57777 15.0747 4.09425 14.7759 3.79603L12.1987 1.22367ZM9.87604 4.62202L11.6578 2.84363L13.1529 4.33601L11.3712 6.1144L9.87604 4.62202ZM8.79405 5.70199L4.0924 10.3949L3.12114 12.8728L5.58549 11.8893L10.2892 7.19437L8.79405 5.70199Z",
    fill: "currentColor"
  }
) }), EmailLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4C2.11929 4 1 5.11929 1 6.5V17.5C1 18.8807 2.11929 20 3.5 20H20.5C21.8807 20 23 18.8807 23 17.5V6.5C23 5.11929 21.8807 4 20.5 4H3.5ZM3 7.08029V17.5C3 17.7761 3.22386 18 3.5 18H20.5C20.7761 18 21 17.7761 21 17.5V7.08019L12.6246 13.7805C12.2594 14.0727 11.7405 14.0727 11.3752 13.7805L3 7.08029ZM19.1487 6H4.8512L11.9999 11.719L19.1487 6Z",
    fill: "currentColor"
  }
) }), EmailSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 2.5C0.783502 2.5 0 3.2835 0 4.25V11.75C0 12.7165 0.783501 13.5 1.75 13.5H14.25C15.2165 13.5 16 12.7165 16 11.75V4.25C16 3.2835 15.2165 2.5 14.25 2.5H1.75ZM1.5 4.81467V11.75C1.5 11.8881 1.61193 12 1.75 12H14.25C14.3881 12 14.5 11.8881 14.5 11.75V4.81384L8.46937 9.66146C8.19495 9.88205 7.80402 9.88205 7.5296 9.66146L1.5 4.81467ZM13.1183 4H2.88071L7.99949 8.11464L13.1183 4Z",
    fill: "currentColor"
  }
) }), ErrorCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z",
    fill: "currentColor"
  }
) }), ErrorCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99988 15.9999C12.4182 15.9999 15.9999 12.4182 15.9999 7.99988C15.9999 3.5816 12.4182 -0.00012207 7.99988 -0.00012207C3.5816 -0.00012207 -0.00012207 3.5816 -0.00012207 7.99988C-0.00012207 12.4182 3.5816 15.9999 7.99988 15.9999ZM7.99988 9.45442C7.59822 9.45442 7.27261 9.12881 7.27261 8.72715V4.36351C7.27261 3.96185 7.59822 3.63624 7.99988 3.63624C8.40154 3.63624 8.72715 3.96185 8.72715 4.36351V8.72715C8.72715 9.12881 8.40154 9.45442 7.99988 9.45442ZM7.27261 11.6362C7.27261 11.2346 7.59822 10.909 7.99988 10.909C8.40154 10.909 8.72715 11.2346 8.72715 11.6362C8.72715 12.0379 8.40154 12.3635 7.99988 12.3635C7.59822 12.3635 7.27261 12.0379 7.27261 11.6362Z",
    fill: "currentColor"
  }
) }), ErrorCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
      fill: "currentColor"
    }
  )
] }), ErrorCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 9.45455C7.59834 9.45455 7.27273 9.12893 7.27273 8.72727V4.36364C7.27273 3.96197 7.59834 3.63636 8 3.63636C8.40166 3.63636 8.72727 3.96197 8.72727 4.36364V8.72727C8.72727 9.12893 8.40166 9.45455 8 9.45455Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.27273 11.6364C7.27273 11.2347 7.59834 10.9091 8 10.9091C8.40166 10.9091 8.72727 11.2347 8.72727 11.6364C8.72727 12.038 8.40166 12.3636 8 12.3636C7.59834 12.3636 7.27273 12.038 7.27273 11.6364Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 1.45455C4.38505 1.45455 1.45455 4.38505 1.45455 8C1.45455 11.615 4.38505 14.5455 8 14.5455C11.615 14.5455 14.5455 11.615 14.5455 8C14.5455 4.38505 11.615 1.45455 8 1.45455Z",
      fill: "currentColor"
    }
  )
] }), ExitLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.9909 2.00004C2.7527 2.00221 2.53438 2.08929 2.36366 2.23305C2.32111 2.26883 2.28176 2.30796 2.2459 2.34996C2.09275 2.5291 2 2.76333 2 3.01965V18.0878C2 18.4196 2.15836 18.7307 2.42451 18.9216L6.06127 21.5311C7.71764 22.7196 10 21.5116 10 19.4464V19.334H12.5C13.8807 19.334 15 18.1927 15 16.7849V15.2554C15 14.6923 14.5523 14.2358 14 14.2358C13.4477 14.2358 13 14.6923 13 15.2554V16.7849C13 17.0664 12.7761 17.2947 12.5 17.2947H10V8.11874C10 7.28917 9.6041 6.51147 8.93873 6.03406L6.15869 4.03929H12.5C12.7761 4.03929 13 4.26755 13 4.54912V6.0836C13 6.64673 13.4477 7.10324 14 7.10324C14.5523 7.10324 15 6.64673 15 6.0836V4.54912C15 3.14128 13.8807 2 12.5 2H3L2.9909 2.00004ZM8 8.11874C8 7.95283 7.92082 7.79729 7.78775 7.7018L4 4.98399V17.5585L7.21225 19.8634C7.54353 20.1011 8 19.8595 8 19.4464V8.11874Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.2001 14.3496C15.8687 13.8991 15.9582 13.26 16.4001 12.9221L18 11.6986L13 11.6986C12.4477 11.6986 12 11.2421 12 10.6789C12 10.1158 12.4477 9.6593 13 9.6593L18.0001 9.6593L16.4001 8.43566C15.9582 8.09778 15.8687 7.45867 16.2001 7.00816C16.5314 6.55765 17.1582 6.46635 17.6001 6.80423L21.6001 9.86317C21.8519 10.0557 22.0001 10.3579 22.0001 10.6789C22.0001 10.9091 21.9238 11.1297 21.7878 11.307C21.7473 11.3599 21.7014 11.4089 21.6507 11.4532C21.6315 11.47 21.6117 11.4861 21.5912 11.5014L17.6001 14.5535C17.1582 14.8914 16.5314 14.8001 16.2001 14.3496Z",
      fill: "currentColor"
    }
  )
] }), ExitSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.74596 1.00003C1.56708 1.00174 1.40311 1.06573 1.27474 1.17135C1.10697 1.30937 1 1.51847 1 1.75254V11.7076C1 12.2699 1.26953 12.7981 1.72497 13.1285L3.83887 14.6618C4.84545 15.392 6.20219 14.8673 6.54701 13.7813H7.96413C8.9349 13.7813 9.72186 12.9952 9.72185 12.0254L9.72183 11.0596C9.72183 10.644 9.38455 10.3071 8.96851 10.3071C8.55247 10.3071 8.21521 10.644 8.21521 11.0596L8.21523 12.0254C8.21523 12.164 8.10281 12.2763 7.96413 12.2763H6.62934V5.2544C6.62934 4.69215 6.35981 4.1639 5.90437 3.83354L4.0729 2.50507H7.96366C8.10234 2.50507 8.21477 2.61738 8.21477 2.75592V3.7502C8.21477 4.16582 8.55203 4.50274 8.96808 4.50274C9.38412 4.50274 9.72139 4.16582 9.72139 3.7502V2.75592C9.72139 1.78615 8.93443 1 7.96366 1H1.75331L1.74596 1.00003ZM2.50662 3.22894V11.7076C2.50662 11.788 2.54512 11.8634 2.61019 11.9106L4.72408 13.4439C4.89008 13.5643 5.12272 13.4459 5.12272 13.241V5.2544C5.12272 5.17408 5.08422 5.09862 5.01916 5.05142L2.50662 3.22894Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.44384 7.40439C7.44384 6.98878 7.78111 6.65185 8.19715 6.65185L12.101 6.65185L11.2656 5.9853C10.9405 5.72593 10.8874 5.25241 11.147 4.92766C11.4067 4.6029 11.8807 4.5499 12.2058 4.80926L14.7168 6.81265C14.8956 6.95531 14.9998 7.17142 15 7.40002C15 7.41179 14.9997 7.42354 14.9992 7.43524C14.9892 7.68358 14.8587 7.90093 14.6645 8.03054L12.2068 9.99833C11.8821 10.2583 11.4081 10.2061 11.1479 9.88176C10.8877 9.55745 10.9399 9.08384 11.2646 8.82392L12.0976 8.15693L8.19715 8.15693C7.78111 8.15693 7.44384 7.82 7.44384 7.40439Z",
      fill: "currentColor"
    }
  )
] }), FastLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.83463 6.2908C8.76481 6.36238 9.66814 6.70537 10.4435 7.25379L13.5719 4.12541C14.5244 3.17265 15.7235 2.50383 17.0346 2.19419C18.3458 1.88453 19.7173 1.94618 20.9954 2.37223C21.294 2.47176 21.5283 2.70607 21.6278 3.00467C22.0539 4.28279 22.1155 5.6543 21.8059 6.96549C21.4962 8.27667 20.8275 9.47569 19.8747 10.4282L16.7628 13.5401C16.9346 13.787 17.086 14.0472 17.2149 14.3178C17.4862 14.8877 17.6536 15.4973 17.7011 16.1139C17.7486 16.7309 17.675 17.3452 17.475 17.9192C17.2748 18.4939 16.9531 19.0126 16.5254 19.4403L14.7073 21.2585C14.3167 21.649 13.6836 21.649 13.293 21.2585C12.3876 20.353 11.8087 19.1595 11.7131 17.9181C11.6829 17.5251 11.7021 17.1359 11.7699 16.7599L10.0675 17.8436C10.0273 17.8692 9.9858 17.8916 9.94335 17.9109C9.88518 18.2293 9.7827 18.5387 9.63838 18.8299C9.4389 19.2324 9.16337 19.5924 8.82711 19.89C7.6923 21.0108 6.20165 21.5219 5.07566 21.7631C4.49699 21.887 3.98456 21.9459 3.61511 21.9741C3.42977 21.9882 3.27872 21.9947 3.17132 21.9976C3.11757 21.9991 3.07461 21.9997 3.0436 21.9999L3.00615 22L2.99439 21.9999L2.99029 21.9999L2.98869 21.9999C2.98838 21.9999 2.9874 21.9998 3.00005 21.0001L2.9874 21.9998C2.44502 21.993 2.00699 21.5544 2.00013 21.012C2.00013 21.0123 2.00013 21.0128 3.00005 21.0001L2.00013 21.012L2.0001 21.0097L2.00007 21.0056L2 20.9938L2.00007 20.9564C2.00027 20.9254 2.00086 20.8824 2.00233 20.8287C2.00528 20.7213 2.01179 20.5702 2.02591 20.3849C2.05407 20.0154 2.113 19.503 2.23692 18.9243C2.47805 17.7983 2.98921 16.3077 4.11002 15.1729C4.40758 14.8366 4.76753 14.5611 5.17006 14.3616C5.4613 14.2173 5.77072 14.1148 6.08916 14.0566C6.10842 14.0142 6.13084 13.9727 6.15645 13.9325L7.25303 12.2099C6.85715 12.2874 6.44589 12.3107 6.03046 12.2788C4.78908 12.1832 3.59552 11.6043 2.69005 10.6988C2.50252 10.5113 2.39716 10.257 2.39716 9.99173C2.39716 9.72652 2.50252 9.47216 2.69005 9.28463L4.5082 7.46648C5.37696 6.59772 6.58699 6.19478 7.83463 6.2908ZM19.8688 4.13129C19.0892 3.95363 18.2769 3.95582 17.4943 4.14064C16.5446 4.36491 15.6762 4.84925 14.9864 5.53935L10.0743 10.4514L13.5486 13.9257L18.4606 9.01381C19.1507 8.32398 19.6352 7.45543 19.8594 6.5058C20.0443 5.7232 20.0464 4.91092 19.8688 4.13129ZM9.587 15.6423C9.45653 15.399 9.29725 15.1716 9.11216 14.9651C9.08783 14.9379 9.06204 14.9122 9.0349 14.8878C8.82839 14.7027 8.60097 14.5435 8.35774 14.413L8.27445 14.3297L9.38295 12.5884L11.4116 14.6171L9.67032 15.7256L9.587 15.6423ZM7.19774 16.0814C7.01255 16.0173 6.81646 15.9906 6.62086 16.0029C6.42514 16.0153 6.23384 16.0665 6.05813 16.1536C5.88241 16.2407 5.72579 16.3619 5.5974 16.5101C5.58177 16.5282 5.56549 16.5457 5.5486 16.5626C4.80366 17.3075 4.39975 18.3757 4.19258 19.3431C4.14982 19.5428 4.11647 19.7333 4.0905 19.9095C4.26664 19.8835 4.45716 19.8502 4.65687 19.8074C5.6243 19.6002 6.69248 19.1963 7.43742 18.4514C7.45431 18.4345 7.47179 18.4182 7.48985 18.4026C7.63809 18.2742 7.75928 18.1176 7.84636 17.9419C7.93344 17.7661 7.98466 17.5748 7.99704 17.3791C8.00941 17.1835 7.98273 16.9874 7.91857 16.8023L7.19774 16.0814ZM14.303 16.0059L15.3149 14.994C15.3482 15.0544 15.3796 15.1155 15.409 15.1773C15.5804 15.5373 15.6794 15.9085 15.707 16.2674C15.7346 16.626 15.6903 16.9628 15.5864 17.2613C15.4826 17.5591 15.3201 17.8172 15.1112 18.0261L14.0993 19.038C13.874 18.6296 13.7402 18.1924 13.7072 17.7646C13.6516 17.0421 13.8859 16.423 14.303 16.0059ZM4.91053 9.89258C5.31899 10.1179 5.75617 10.2517 6.18392 10.2847C6.9064 10.3403 7.52556 10.106 7.94267 9.68886L8.95455 8.67698C8.5461 8.4517 8.10892 8.31782 7.68117 8.2849C6.95868 8.2293 6.33953 8.46358 5.92241 8.8807L4.91053 9.89258Z",
      fill: "currentColor"
    }
  )
] }), FastSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08424 4.00356C5.73537 4.05367 6.36771 4.29376 6.91049 4.67765L9.10035 2.48779C9.76706 1.82085 10.6064 1.35268 11.5242 1.13593C12.4421 0.91917 13.4021 0.962325 14.2968 1.26056C14.5058 1.33023 14.6698 1.49425 14.7395 1.70327C15.0377 2.59795 15.0809 3.55801 14.8641 4.47584C14.6474 5.39367 14.1793 6.23299 13.5123 6.89972L11.3339 9.07805C11.4542 9.25087 11.5602 9.43301 11.6504 9.62243C11.8403 10.0214 11.9576 10.4481 11.9908 10.8798C12.024 11.3116 11.9725 11.7417 11.8325 12.1435C11.6924 12.5458 11.4672 12.9088 11.1678 13.2083L9.89509 14.481C9.62172 14.7543 9.1785 14.7543 8.90514 14.481C8.27131 13.8471 7.86607 13.0116 7.7992 12.1427C7.77803 11.8676 7.79151 11.5951 7.83891 11.3319L6.64729 12.0905C6.61912 12.1084 6.59006 12.1241 6.56035 12.1376C6.51963 12.3605 6.4479 12.5771 6.34687 12.781C6.20724 13.0627 6.01436 13.3147 5.77898 13.523C4.98461 14.3076 3.94116 14.6654 3.15297 14.8342C2.74789 14.9209 2.38919 14.9622 2.13058 14.9819C2.00084 14.9917 1.89511 14.9963 1.81992 14.9984C1.7823 14.9994 1.75223 14.9998 1.73052 14.9999L1.70431 15L1.69607 15L1.6932 14.9999L1.69208 14.9999C1.69208 14.9999 1.69118 14.9999 1.70004 14.3001L1.69208 14.9999C1.31242 14.9951 1.0049 14.6881 1.00009 14.3084C1.00009 14.3084 1.00009 14.3089 1.70004 14.3001L1.00009 14.3084L1.00007 14.3068L1.00005 14.3039L1 14.2957L1.00005 14.2695C1.00019 14.2478 1.0006 14.2177 1.00163 14.1801C1.0037 14.1049 1.00825 13.9992 1.01814 13.8694C1.03785 13.6108 1.0791 13.2521 1.16585 12.847C1.33463 12.0588 1.69245 11.0154 2.47702 10.221C2.68531 9.98564 2.93728 9.79276 3.21905 9.65313C3.42291 9.5521 3.63951 9.48036 3.86241 9.43964C3.8759 9.40994 3.89159 9.38089 3.90952 9.35273L4.67712 8.14696C4.40001 8.20117 4.11212 8.21751 3.82132 8.19514C2.95236 8.12826 2.11686 7.72302 1.48304 7.08919C1.35176 6.95792 1.27801 6.77987 1.27801 6.59422C1.27801 6.40857 1.35176 6.23052 1.48304 6.09924L2.75574 4.82654C3.36387 4.21841 4.2109 3.93635 5.08424 4.00356ZM13.5082 2.4919C12.9624 2.36754 12.3938 2.36907 11.846 2.49845C11.1813 2.65544 10.5734 2.99447 10.0905 3.47755L6.65205 6.91599L9.08406 9.34803L12.5224 5.90967C13.0055 5.42679 13.3446 4.81881 13.5016 4.15406C13.631 3.60624 13.6325 3.03765 13.5082 2.4919ZM6.31091 10.5496C6.21958 10.3793 6.10808 10.2201 5.97851 10.0756C5.96149 10.0566 5.94343 10.0385 5.92444 10.0215C5.77988 9.89192 5.62069 9.78043 5.45042 9.6891L5.39212 9.6308L6.16807 8.41192L7.58811 9.83197L6.36923 10.6079L6.31091 10.5496ZM4.63842 10.857C4.50879 10.8121 4.37152 10.7934 4.23461 10.8021C4.0976 10.8107 3.96369 10.8466 3.84069 10.9075C3.71769 10.9685 3.60806 11.0533 3.51818 11.1571C3.50724 11.1697 3.49584 11.182 3.48402 11.1938C2.96256 11.7153 2.67983 12.463 2.53481 13.1402C2.50487 13.28 2.48153 13.4133 2.46335 13.5366C2.58665 13.5185 2.72001 13.4951 2.85981 13.4652C3.53701 13.3202 4.28474 13.0374 4.8062 12.516C4.81802 12.5042 4.83026 12.4928 4.8429 12.4818C4.94666 12.3919 5.0315 12.2823 5.09246 12.1593C5.15341 12.0363 5.18927 11.9024 5.19793 11.7654C5.20659 11.6285 5.18792 11.4912 5.143 11.3616L4.63842 10.857ZM9.61212 10.8041L10.3204 10.0958C10.3437 10.1381 10.3657 10.1809 10.3863 10.2241C10.5063 10.4761 10.5756 10.7359 10.5949 10.9872C10.6142 11.2382 10.5833 11.4739 10.5105 11.6829C10.4378 11.8913 10.3241 12.072 10.1778 12.2183L9.46952 12.9266C9.31183 12.6407 9.21811 12.3347 9.19507 12.0352C9.15615 11.5295 9.32014 11.0961 9.61212 10.8041ZM3.03737 6.52481C3.32329 6.6825 3.62932 6.77622 3.92875 6.79926C4.43448 6.83818 4.8679 6.67419 5.15988 6.38221L5.86819 5.67389C5.58227 5.5162 5.27625 5.42248 4.97682 5.39944C4.47108 5.36052 4.03767 5.52451 3.74569 5.81649L3.03737 6.52481Z",
    fill: "currentColor"
  }
) }), FavouriteLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.3879 2 12.7408 2.22429 12.9054 2.57548L15.4548 8.01279L21.1496 8.87399C21.5203 8.93006 21.8285 9.18883 21.948 9.54427C22.0674 9.89972 21.9779 10.2921 21.7162 10.5607L17.5589 14.8269L18.5398 20.839C18.6015 21.2172 18.4416 21.5973 18.1283 21.8178C17.8149 22.0383 17.4031 22.0604 17.068 21.8746L12 19.065L6.9321 21.8746C6.59697 22.0604 6.18515 22.0383 5.87178 21.8178C5.5584 21.5973 5.39858 21.2172 5.46028 20.839L6.44118 14.8269L2.28384 10.5607C2.02214 10.2921 1.93267 9.89972 2.05209 9.54427C2.17151 9.18883 2.47974 8.93006 2.8505 8.87399L8.54526 8.01279L11.0946 2.57548C11.2593 2.22429 11.6122 2 12 2ZM12 5.35562L10.129 9.34609C9.98719 9.64865 9.70357 9.86036 9.37315 9.91033L5.07593 10.5602L8.22553 13.7923C8.4469 14.0195 8.54737 14.3382 8.49629 14.6512L7.76632 19.1253L11.5152 17.047C11.8168 16.8798 12.1833 16.8798 12.4849 17.047L16.2337 19.1253L15.5038 14.6512C15.4527 14.3382 15.5532 14.0195 15.7745 13.7923L18.9241 10.5602L14.6269 9.91033C14.2965 9.86036 14.0129 9.64865 13.871 9.34609L12 5.35562Z",
    fill: "currentColor"
  }
) }), FavouriteSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00014 1C8.29104 1 8.55571 1.16822 8.6792 1.43161L10.437 5.18061L14.3624 5.77423C14.6405 5.81628 14.8716 6.01036 14.9612 6.27694C15.0508 6.54353 14.9837 6.83782 14.7874 7.03923L11.9199 9.98184L12.5965 14.1292C12.6428 14.4129 12.5229 14.698 12.2879 14.8634C12.0529 15.0287 11.744 15.0453 11.4927 14.9059L8.00014 12.9697L4.5076 14.9059C4.25626 15.0453 3.94739 15.0287 3.71236 14.8634C3.47733 14.698 3.35747 14.4129 3.40375 14.1292L4.08043 9.98184L1.21288 7.03923C1.01661 6.83782 0.949506 6.54353 1.03907 6.27694C1.12863 6.01036 1.35981 5.81628 1.63788 5.77423L5.56328 5.18061L7.32108 1.43161C7.44457 1.16822 7.70924 1 8.00014 1ZM8.00014 3.51669L6.75111 6.18059C6.64471 6.40751 6.432 6.56629 6.18419 6.60377L3.30697 7.03887L5.41869 9.20587C5.58472 9.37624 5.66007 9.61528 5.62176 9.85007L5.13328 12.844L7.6365 11.4563C7.86271 11.3308 8.13757 11.3308 8.36378 11.4563L10.867 12.844L10.3785 9.85007C10.3402 9.61528 10.4156 9.37624 10.5816 9.20587L12.6933 7.03887L9.81609 6.60377C9.56828 6.56629 9.35556 6.40751 9.24917 6.18059L8.00014 3.51669Z",
    fill: "currentColor"
  }
) }), FileAddLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.50122 2.99994C5.22508 2.99994 5.00122 3.2238 5.00122 3.49994V18.4999C5.00122 18.7761 5.22508 18.9999 5.50122 18.9999H12.0012C12.5535 18.9999 13.0012 19.4477 13.0012 19.9999C13.0012 20.5522 12.5535 20.9999 12.0012 20.9999H5.50122C4.12051 20.9999 3.00122 19.8807 3.00122 18.4999V3.49994C3.00122 2.11923 4.12051 0.999939 5.50122 0.999939H14.0012C14.2664 0.999939 14.5208 1.1053 14.7083 1.29283L15.147 1.7315C15.1468 1.73127 15.1472 1.73172 15.147 1.7315L18.269 4.85349C18.2693 4.85379 18.2696 4.85409 18.2699 4.85439L18.7083 5.29283C18.8959 5.48037 19.0012 5.73472 19.0012 5.99994V13.9999C19.0012 14.5522 18.5535 14.9999 18.0012 14.9999C17.4489 14.9999 17.0012 14.5522 17.0012 13.9999V7.99994H13.0012C12.4489 7.99994 12.0012 7.55222 12.0012 6.99994V2.99994H5.50122ZM14.0012 3.41415V5.99994H16.587L14.0012 3.41415Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.9988 20.9999V22C16.9988 22.5523 17.4465 23 17.9988 23C18.5511 23 18.9988 22.5523 18.9988 22V20.9999H19.9988C20.551 20.9999 20.9988 20.5522 20.9988 19.9999C20.9988 19.4477 20.551 18.9999 19.9988 18.9999H18.9988V17.9999C18.9988 17.4477 18.5511 16.9999 17.9988 16.9999C17.4465 16.9999 16.9988 17.4477 16.9988 17.9999V18.9999H15.9988C15.4465 18.9999 14.9988 19.4477 14.9988 19.9999C14.9988 20.5522 15.4465 20.9999 15.9988 20.9999H16.9988Z",
      fill: "currentColor"
    }
  )
] }), FileAddSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 1.69355C3.5 1.55993 3.61193 1.45161 3.75 1.45161H8.41699V4.27419C8.41699 5.20952 9.20049 5.96774 10.167 5.96774H12.5V8.71767C12.5 9.11852 12.8357 9.44348 13.25 9.44348C13.6642 9.44348 14 9.11852 14 8.71767V4.48897C14 4.09513 13.8581 3.71361 13.5989 3.41005L11.2114 0.61463C10.8789 0.225371 10.3843 0 9.86249 0H3.75C2.7835 0 2 0.758228 2 1.69355V13.3065C2 14.2418 2.7835 15 3.75 15H7.95725C8.37147 15 8.70725 14.675 8.70725 14.2742C8.70725 13.8733 8.37147 13.5484 7.95725 13.5484H3.75C3.61193 13.5484 3.5 13.4401 3.5 13.3065V1.69355ZM9.91699 1.45743V4.27419C9.91699 4.40781 10.0289 4.51613 10.167 4.51613H12.5V4.48897C12.5 4.4327 12.4797 4.3782 12.4427 4.33483L10.0552 1.53942C10.0195 1.49761 9.97069 1.46904 9.91699 1.45743Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.5 12.8226C9.5 12.4217 9.83579 12.0968 10.25 12.0968H11V11.371C11 10.9701 11.3358 10.6452 11.75 10.6452C12.1642 10.6452 12.5 10.9701 12.5 11.371V12.0968H13.25C13.6642 12.0968 14 12.4217 14 12.8226C14 13.2234 13.6642 13.5484 13.25 13.5484H12.5V14.2742C12.5 14.675 12.1642 15 11.75 15C11.3358 15 11 14.675 11 14.2742V13.5484H10.25C9.83579 13.5484 9.5 13.2234 9.5 12.8226Z",
      fill: "currentColor"
    }
  )
] }), FileMoveLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 4.5C5 4.22386 5.22386 4 5.5 4H12V8C12 8.55228 12.4477 9 13 9H18C18.5523 9 19 8.55228 19 8V7C19 6.73478 18.8946 6.48043 18.7071 6.29289L14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2H5.5C4.11929 2 3 3.11929 3 4.5V19.5C3 20.8807 4.11929 22 5.5 22H15C15.5523 22 16 21.5523 16 21C16 20.4477 15.5523 20 15 20H5.5C5.22386 20 5 19.7761 5 19.5V4.5ZM16.5858 7L14 4.41421V7H16.5858Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.2001 18.0999C14.8687 17.6581 14.9582 17.0313 15.4001 16.6999L17 15.5L13 15.5C12.4477 15.5 12 15.0523 12 14.5C12 13.9477 12.4477 13.5 13 13.5L17.0001 13.5L15.4001 12.2999C14.9582 11.9686 14.8687 11.3418 15.2001 10.8999C15.5314 10.4581 16.1582 10.3686 16.6001 10.6999L20.6001 13.6999C20.8519 13.8888 21.0001 14.1852 21.0001 14.4999C21.0001 14.8147 20.8519 15.1111 20.6001 15.2999L16.6001 18.2999C16.1582 18.6313 15.5314 18.5418 15.2001 18.0999Z",
      fill: "currentColor"
    }
  )
] }), FileMoveSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.33333 2.75C3.33333 2.5567 3.48257 2.4 3.66666 2.4H7.99998V5.2C7.99998 5.5866 8.29846 5.9 8.66665 5.9H12C12.3682 5.9 12.6666 5.5866 12.6666 5.2V4.5C12.6666 4.31435 12.5964 4.1363 12.4714 4.00503L9.80471 1.20503C9.67969 1.07375 9.51012 1 9.33331 1H3.66666C2.74619 1 2 1.7835 2 2.75V13.25C2 14.2165 2.74619 15 3.66666 15H9.99997C10.3682 15 10.6666 14.6866 10.6666 14.3C10.6666 13.9134 10.3682 13.6 9.99997 13.6H3.66666C3.48257 13.6 3.33333 13.4433 3.33333 13.25V2.75ZM11.0572 4.5L9.33331 2.68995V4.5H11.0572Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.1333 12.27C9.91243 11.9607 9.97213 11.5219 10.2667 11.29L11.3333 10.45L8.66665 10.45C8.29846 10.45 7.99998 10.1366 7.99998 9.75C7.99998 9.3634 8.29846 9.05 8.66665 9.05L11.3334 9.05L10.2667 8.20996C9.97213 7.978 9.91243 7.53924 10.1333 7.22996C10.3543 6.92068 10.7721 6.858 11.0667 7.08996L13.7333 9.18996C13.9012 9.32216 14 9.52963 14 9.74996C14 9.97029 13.9012 10.1778 13.7333 10.31L11.0667 12.41C10.7721 12.6419 10.3543 12.5792 10.1333 12.27Z",
      fill: "currentColor"
    }
  )
] }), FilterLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1 7C1 6.44772 1.44772 6 2 6L22 6C22.5523 6 23 6.44772 23 7C23 7.55229 22.5523 8 22 8L2 8C1.44772 8 1 7.55228 1 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4 12C4 11.4477 4.44772 11 5 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L5 13C4.44772 13 4 12.5523 4 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18L15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16L9 16Z",
      fill: "currentColor"
    }
  )
] }), FilterSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2 4.8C2 4.35817 2.35039 4 2.78261 4H13.2174C13.6496 4 14 4.35817 14 4.8C14 5.24183 13.6496 5.6 13.2174 5.6L2.78261 5.6C2.35039 5.6 2 5.24183 2 4.8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.73896 8C3.73896 7.55817 4.08935 7.2 4.52157 7.2L11.4781 7.2C11.9103 7.2 12.2607 7.55817 12.2607 8C12.2607 8.44183 11.9103 8.8 11.4781 8.8L4.52157 8.8C4.08935 8.8 3.73896 8.44183 3.73896 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.26104 10.4C5.82882 10.4 5.47843 10.7582 5.47843 11.2C5.47843 11.6418 5.82882 12 6.26104 12H9.7393C10.1715 12 10.5219 11.6418 10.5219 11.2C10.5219 10.7582 10.1715 10.4 9.7393 10.4L6.26104 10.4Z",
      fill: "currentColor"
    }
  )
] }), FlowLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8C17.6938 8 16.5825 7.16519 16.1707 6H13.5C13.2239 6 13 6.22386 13 6.5V17.5C13 17.7761 13.2239 18 13.5 18H16.1707C16.5825 16.8348 17.6938 16 19 16C20.6569 16 22 17.3431 22 19C22 20.6569 20.6569 22 19 22C17.6938 22 16.5825 21.1652 16.1707 20H13.5C12.1193 20 11 18.8807 11 17.5V13H7.82929C7.41746 14.1652 6.30622 15 5 15C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9C6.30622 9 7.41746 9.83481 7.82929 11H11V6.5C11 5.11929 12.1193 4 13.5 4H16.1707C16.5825 2.83481 17.6938 2 19 2C20.6569 2 22 3.34315 22 5C22 6.65686 20.6569 8 19 8ZM19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4ZM19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18ZM4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13C4.44771 13 4 12.5523 4 12Z",
    fill: "currentColor"
  }
) }), FlowSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M15 2.99773C15 4.10105 14.1046 4.99546 13 4.99546C12.1623 4.99546 11.4449 4.48106 11.1472 3.75125H9.03562C8.89755 3.75125 8.78562 3.86323 8.78562 4.00136V12.005C8.78562 12.1431 8.89755 12.2551 9.03562 12.2551H11.1446C11.4408 11.5219 12.1599 11.0045 13 11.0045C14.1046 11.0045 15 11.899 15 13.0023C15 14.1056 14.1046 15 13 15C12.1623 15 11.4449 14.4856 11.1472 13.7558H9.03562C8.06912 13.7558 7.28562 12.9719 7.28562 12.005V8.75352H4.88423C4.60811 9.52654 3.86874 10.0798 3 10.0798C1.89543 10.0798 1 9.18539 1 8.08207C1 6.97875 1.89543 6.08434 3 6.08434C3.8084 6.08434 4.50478 6.56341 4.8201 7.25283H7.28562V4.00136C7.28562 3.03442 8.06912 2.25057 9.03562 2.25057H11.1446C11.4408 1.51739 12.1599 1 13 1C14.1046 1 15 1.89442 15 2.99773Z",
    fill: "currentColor"
  }
) }), ForeignCurrencyLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1525 3.50038C11.0501 3.14508 12.0248 2.95048 13.0436 2.95048C17.4971 2.95048 21.1074 6.67122 21.1074 11.261C21.1074 12.9161 20.5632 14.5091 19.5834 15.8564C19.8066 15.026 19.9258 14.1512 19.9258 13.2476C19.9258 7.86153 15.6891 3.49524 10.4629 3.49524C10.3591 3.49524 10.2556 3.49696 10.1525 3.50038ZM6.22599 6.78114L6.24327 6.79252L6.26891 6.75143C7.4695 5.92653 8.91172 5.44571 10.4629 5.44571C14.6439 5.44571 18.0332 8.93875 18.0332 13.2476C18.0332 15.457 17.1421 17.4519 15.7101 18.8714C15.6694 18.8884 15.6286 18.9052 15.5876 18.9217L15.6067 18.972C14.2563 20.2614 12.4489 21.0495 10.4629 21.0495C6.28193 21.0495 2.89258 17.5565 2.89258 13.2476C2.89258 10.5565 4.21467 8.18358 6.22599 6.78114ZM4.89821 5.35883C6.69877 2.72419 9.67551 1 13.0436 1C18.5424 1 23 5.59401 23 11.261C23 15.2746 20.5087 18.8225 16.7527 20.5341C15.0808 22.068 12.8775 23 10.4629 23C5.23669 23 1 18.6337 1 13.2476C1 10.005 2.53559 7.13198 4.89821 5.35883ZM11.6379 9.15619C10.4335 9.15619 9.37921 9.81876 8.79955 10.8095H12.2303C12.7529 10.8095 13.1766 11.2462 13.1766 11.7848C13.1766 12.3234 12.7529 12.76 12.2303 12.76H8.3259V13.7352H12.2303C12.7529 13.7352 13.1766 14.1719 13.1766 14.7105C13.1766 15.2491 12.7529 15.6857 12.2303 15.6857H8.79719C9.37634 16.6787 10.4318 17.3431 11.6379 17.3431H12.2305C12.7531 17.3431 13.1768 17.7797 13.1768 18.3183C13.1768 18.8569 12.7531 19.2936 12.2305 19.2936H11.6379C9.36022 19.2936 7.42425 17.7857 6.71861 15.6857H6.07846C5.55583 15.6857 5.13217 15.2491 5.13217 14.7105C5.13217 14.1719 5.55583 13.7352 6.07846 13.7352H6.43331V12.76H6.07846C5.55583 12.76 5.13217 12.3234 5.13217 11.7848C5.13217 11.2462 5.55583 10.8095 6.07846 10.8095H6.71997C7.42674 8.71165 9.36168 7.20571 11.6379 7.20571H12.2305C12.7531 7.20571 13.1768 7.64234 13.1768 8.18095C13.1768 8.71956 12.7531 9.15619 12.2305 9.15619H11.6379Z",
    fill: "currentColor"
  }
) }), ForeignCurrencySmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_12449_3059)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.69518 6.07543C6.8736 6.07543 6.15218 6.51733 5.74257 7.18306H8.12376C8.50182 7.18306 8.80829 7.49885 8.80829 7.88841C8.80829 8.27797 8.50182 8.59377 8.12376 8.59377H5.3849V9.29912H8.12401C8.50207 9.29912 8.80854 9.61492 8.80854 10.0045C8.80854 10.394 8.50207 10.7098 8.12401 10.7098H5.74078C6.15007 11.3772 6.87239 11.8204 7.69518 11.8204H8.12385C8.54916 11.8204 8.89394 12.1757 8.89394 12.6139C8.89394 13.0522 8.54916 13.4074 8.12385 13.4074H7.69518C5.99967 13.4074 4.56012 12.2782 4.04619 10.7098H3.67391C3.29585 10.7098 2.98938 10.394 2.98938 10.0045C2.98938 9.61492 3.29585 9.29912 3.67391 9.29912H3.84471V8.59377H3.67366C3.2956 8.59377 2.98913 8.27797 2.98913 7.88841C2.98913 7.49885 3.2956 7.18306 3.67366 7.18306H4.04715C4.56191 5.61619 6.00073 4.48838 7.69518 4.48838H8.12385C8.54916 4.48838 8.89394 4.84365 8.89394 5.2819C8.89394 5.72015 8.54916 6.07543 8.12385 6.07543H7.69518Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.607 3.40713C3.90668 1.35729 6.15534 0 8.71215 0C12.7371 0 16 3.36216 16 7.50959C16 10.5409 14.0618 13.2031 11.1793 14.4064C9.99899 15.4024 8.48987 16 6.84528 16C3.06474 16 0 12.842 0 8.94644C0 6.70002 1.01914 4.69887 2.607 3.40713ZM6.88349 1.893C7.45799 1.69452 8.07291 1.58705 8.71215 1.58705C11.8865 1.58705 14.4598 4.23866 14.4598 7.50959C14.4598 8.61214 14.1198 9.67795 13.5018 10.5982C13.6252 10.0684 13.6906 9.51527 13.6906 8.94644C13.6906 5.064 10.6465 1.91418 6.88349 1.893ZM6.84528 14.413C9.77521 14.413 12.1504 11.9655 12.1504 8.94644C12.1504 5.92738 9.77521 3.47994 6.84528 3.47994C3.91536 3.47994 1.54019 5.92738 1.54019 8.94644C1.54019 11.9655 3.91536 14.413 6.84528 14.413Z",
        fill: "currentColor"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_12449_3059", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), GalleryLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V8.5C2 9.88071 3.11929 11 4.5 11H8.5C9.88071 11 11 9.88071 11 8.5V4.5C11 3.11929 9.88071 2 8.5 2H4.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H8.5C8.77614 4 9 4.22386 9 4.5V8.5C9 8.77614 8.77614 9 8.5 9H4.5C4.22386 9 4 8.77614 4 8.5V4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 13C3.11929 13 2 14.1193 2 15.5V19.5C2 20.8807 3.11929 22 4.5 22H8.5C9.88071 22 11 20.8807 11 19.5V15.5C11 14.1193 9.88071 13 8.5 13H4.5ZM4 15.5C4 15.2239 4.22386 15 4.5 15H8.5C8.77614 15 9 15.2239 9 15.5V19.5C9 19.7761 8.77614 20 8.5 20H4.5C4.22386 20 4 19.7761 4 19.5V15.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 4.5C13 3.11929 14.1193 2 15.5 2H19.5C20.8807 2 22 3.11929 22 4.5V8.5C22 9.88071 20.8807 11 19.5 11H15.5C14.1193 11 13 9.88071 13 8.5V4.5ZM15.5 4C15.2239 4 15 4.22386 15 4.5V8.5C15 8.77614 15.2239 9 15.5 9H19.5C19.7761 9 20 8.77614 20 8.5V4.5C20 4.22386 19.7761 4 19.5 4H15.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5 13C14.1193 13 13 14.1193 13 15.5V19.5C13 20.8807 14.1193 22 15.5 22H19.5C20.8807 22 22 20.8807 22 19.5V15.5C22 14.1193 20.8807 13 19.5 13H15.5ZM15 15.5C15 15.2239 15.2239 15 15.5 15H19.5C19.7761 15 20 15.2239 20 15.5V19.5C20 19.7761 19.7761 20 19.5 20H15.5C15.2239 20 15 19.7761 15 19.5V15.5Z",
      fill: "currentColor"
    }
  )
] }), GallerySmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0002 1.79178C15.0002 1.55891 14.8982 1.35062 14.7392 1.20866C14.6066 1.09023 14.4674 1.04658 14.4009 1.02944C14.2787 0.997953 14.1623 0.999868 14.1482 1.0001L14.1469 1.00012H10.1205C9.87971 1.00012 9.66397 1.10952 9.52145 1.28105C9.40542 1.4207 9.36797 1.56442 9.35442 1.62695C9.33881 1.69901 9.33549 1.76003 9.33436 1.78997C9.3337 1.80722 9.33355 1.82202 9.33351 1.83188L9.3335 1.84441L9.33351 1.85062V5.87512C9.33351 6.10799 9.43544 6.31628 9.59445 6.45824C9.72711 6.57667 9.86627 6.62032 9.93279 6.63746C10.055 6.66894 10.1713 6.66704 10.1854 6.6668L10.1867 6.66678H14.1992C14.4321 6.66678 14.6402 6.56492 14.7821 6.40615C14.9005 6.27367 14.9442 6.13468 14.9614 6.06826C14.993 5.94607 14.9913 5.82948 14.9911 5.81637L14.9911 5.81525L15.0002 1.79349L15.0002 1.79178ZM14.1469 2.50012C14.1616 2.50012 14.1587 2.50081 14.1442 2.50012H14.1469ZM13.4925 5.16678L13.4986 2.50012H10.8335V5.16678H13.4925ZM10.8338 1.83024C10.8339 1.83057 10.8339 1.8347 10.8335 1.84169C10.8336 1.83341 10.8338 1.82992 10.8338 1.83024ZM10.1867 5.16678C10.1721 5.16678 10.175 5.16609 10.1895 5.16678H10.1867ZM13.4911 5.81184C13.491 5.8269 13.4903 5.824 13.4911 5.80939L13.4911 5.81184Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.66668 1.79178C6.66668 1.55891 6.56474 1.35062 6.40573 1.20866C6.27307 1.09023 6.13391 1.04658 6.06739 1.02944C5.94516 0.997953 5.82881 0.999868 5.81473 1.0001L5.81344 1.00012H1.78705C1.54622 1.00012 1.33047 1.10952 1.18795 1.28105C1.07192 1.4207 1.03447 1.56442 1.02092 1.62695C1.00531 1.69901 1.002 1.76003 1.00086 1.78997C1.0002 1.80722 1.00005 1.82202 1.00001 1.83188L1 1.84441L1.00001 1.85062V5.87512C1.00001 6.108 1.10195 6.31628 1.26095 6.45824C1.39362 6.57667 1.53278 6.62032 1.59929 6.63746C1.7215 6.66894 1.83783 6.66704 1.85195 6.6668L1.85325 6.66678H5.86575C6.09857 6.66678 6.30671 6.56491 6.44861 6.40615C6.56701 6.27367 6.61075 6.13468 6.62794 6.06826C6.65955 5.94607 6.65777 5.82948 6.65757 5.81637L6.65756 5.81525L6.66668 1.79349L6.66668 1.79178ZM5.81344 2.50012C5.82813 2.50012 5.8252 2.50081 5.8107 2.50012H5.81344ZM5.15902 5.16678L5.16507 2.50012H2.50001V5.16678H5.15902ZM2.50034 1.83024C2.5004 1.83057 2.50037 1.8347 2.50005 1.84169C2.50012 1.83341 2.50028 1.82992 2.50034 1.83024ZM1.85325 5.16678C1.83856 5.16678 1.84149 5.16609 1.85599 5.16678H1.85325ZM5.15756 5.81184C5.15753 5.8269 5.15683 5.824 5.15757 5.80939L5.15756 5.81184Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.40573 9.54069C6.56474 9.68265 6.66668 9.89094 6.66668 10.1238L6.66668 10.1255L6.65756 14.1473L6.65757 14.1484C6.65777 14.1615 6.65955 14.2781 6.62794 14.4003C6.61075 14.4667 6.56701 14.6057 6.44861 14.7382C6.30671 14.8969 6.09857 14.9988 5.86575 14.9988H1.85325L1.85196 14.9988C1.83782 14.9991 1.72149 15.001 1.59929 14.9695C1.53278 14.9524 1.39362 14.9087 1.26095 14.7903C1.10195 14.6483 1.00001 14.44 1.00001 14.2071V10.1827L1 10.1764L1.00001 10.1639C1.00005 10.154 1.0002 10.1393 1.00086 10.122C1.002 10.0921 1.00531 10.031 1.02092 9.95898C1.03447 9.89645 1.07192 9.75273 1.18795 9.61308C1.33047 9.44155 1.54622 9.33215 1.78705 9.33215H5.81344L5.81473 9.33213C5.82881 9.3319 5.94516 9.32998 6.06739 9.36147C6.13391 9.37861 6.27307 9.42226 6.40573 9.54069ZM5.81344 10.8321C5.82813 10.8321 5.8252 10.8328 5.8107 10.8321H5.81344ZM5.16507 10.8321L5.15902 13.4988H2.50001V10.8321H5.16507ZM2.50034 10.1623C2.5004 10.1626 2.50037 10.1667 2.50005 10.1737C2.50012 10.1654 2.50028 10.162 2.50034 10.1623ZM1.85325 13.4988C1.83856 13.4988 1.84149 13.4981 1.85599 13.4988H1.85325ZM5.15756 14.1439C5.15754 14.1516 5.15735 14.1546 5.15727 14.1537C5.15719 14.1529 5.15721 14.1486 5.15757 14.1414L5.15756 14.1439Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0002 10.1238C15.0002 9.89094 14.8982 9.68265 14.7392 9.5407C14.6066 9.42226 14.4674 9.37861 14.4009 9.36147C14.2787 9.32998 14.1623 9.3319 14.1482 9.33213L14.1469 9.33215H10.1205C9.87971 9.33215 9.66397 9.44155 9.52145 9.61308C9.40542 9.75273 9.36797 9.89645 9.35442 9.95898C9.33881 10.031 9.33549 10.0921 9.33436 10.122C9.3337 10.1393 9.33355 10.154 9.33351 10.1639L9.3335 10.1764L9.33351 10.1827V14.2071C9.33351 14.44 9.43544 14.6483 9.59445 14.7903C9.72711 14.9087 9.86627 14.9524 9.93279 14.9695C10.055 15.001 10.1713 14.9991 10.1854 14.9988L10.1867 14.9988H14.1992C14.4321 14.9988 14.6402 14.8969 14.7821 14.7382C14.9005 14.6057 14.9442 14.4667 14.9614 14.4003C14.993 14.2781 14.9913 14.1615 14.9911 14.1484L14.9911 14.1473L15.0002 10.1255L15.0002 10.1238ZM14.1469 10.8321C14.1616 10.8321 14.1587 10.8328 14.1442 10.8321H14.1469ZM13.4925 13.4988L13.4986 10.8321H10.8335V13.4988H13.4925ZM10.8335 10.1737C10.8339 10.1667 10.8339 10.1626 10.8338 10.1623C10.8338 10.1621 10.8337 10.1631 10.8337 10.1655C10.8336 10.1674 10.8336 10.1701 10.8335 10.1737ZM10.1829 13.4986C10.1745 13.4983 10.1747 13.4988 10.1867 13.4988H10.1895C10.1869 13.4987 10.1847 13.4986 10.1829 13.4986ZM13.4911 14.1439C13.491 14.1589 13.4903 14.156 13.4911 14.1414L13.4911 14.1439Z",
      fill: "currentColor"
    }
  )
] }), GetPaidLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.9995 4.5L16.9995 7C16.9995 7.55229 17.4472 8 17.9995 8C18.5518 8 18.9995 7.55228 18.9995 7L18.9995 4.5C18.9995 3.11929 17.8802 2 16.4995 2H5.49951C4.1188 2 2.99951 3.11929 2.99951 4.5V19.5C2.99951 20.8807 4.1188 22 5.49951 22H16.4995C17.8802 22 18.9995 20.8807 18.9995 19.5V17C18.9995 16.4477 18.5518 16 17.9995 16C17.4472 16 16.9995 16.4477 16.9995 17V19.5C16.9995 19.7761 16.7757 20 16.4995 20H5.49951C5.22337 20 4.99951 19.7761 4.99951 19.5L4.99951 4.5C4.99951 4.22386 5.22337 4 5.49951 4H16.4995C16.7757 4 16.9995 4.22386 16.9995 4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.9946 5.5C11.5469 5.5 11.9946 5.94772 11.9946 6.5V7.12992C12.9179 7.38779 13.5129 7.99885 13.7908 8.68395C13.9985 9.19572 13.7519 9.77891 13.2402 9.98655C12.7284 10.1942 12.1452 9.94764 11.9376 9.43587C11.901 9.34569 11.8335 9.24802 11.7148 9.16941C11.5989 9.09263 11.3825 9 10.9946 9C10.481 9 10.2893 9.1577 10.2034 9.262C10.0901 9.39957 9.99663 9.65082 9.99962 10.0364C10.0019 10.3367 10.0826 10.5461 10.1917 10.6715C10.2822 10.7755 10.4918 10.9386 11.0243 10.9545C12.1143 10.9869 12.882 11.5124 13.3527 12.1311C13.7904 12.7065 13.9946 13.3894 13.9946 13.8883L13.9946 13.915C13.9951 14.1916 13.9964 14.9351 13.6235 15.6224C13.4184 16.0005 13.1021 16.3614 12.6359 16.62C12.4385 16.7296 12.2245 16.815 11.9946 16.877V17.5C11.9946 18.0523 11.5469 18.5 10.9946 18.5C10.4423 18.5 9.99463 18.0523 9.99463 17.5V16.8782C9.66054 16.7895 9.3641 16.6537 9.10576 16.4745C8.61485 16.134 8.33904 15.6909 8.18964 15.3035C7.9909 14.7882 8.24751 14.2094 8.76279 14.0107C9.27808 13.8119 9.85691 14.0685 10.0557 14.5838C10.0924 14.679 10.1488 14.764 10.2456 14.8311C10.3409 14.8972 10.5531 15 10.9946 15C11.3636 15 11.5634 14.9278 11.6657 14.8711C11.762 14.8177 11.8207 14.7513 11.8656 14.6687C11.98 14.4578 11.9946 14.1729 11.9946 13.8883C11.9946 13.8884 11.9946 13.8884 11.9946 13.8883C11.9941 13.8822 11.9885 13.81 11.948 13.6933C11.9081 13.5781 11.8458 13.4536 11.7609 13.342C11.6064 13.139 11.3741 12.9658 10.9648 12.9536C9.99727 12.9248 9.213 12.5936 8.68282 11.9842C8.17125 11.3962 8.00448 10.673 7.99968 10.0519C7.99449 9.38187 8.14849 8.61104 8.65967 7.99044C9.00274 7.57393 9.45589 7.28617 9.99463 7.13214V6.5C9.99463 5.94772 10.4423 5.5 10.9946 5.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.7085 9.29327C20.3184 8.90227 19.6852 8.9015 19.2942 9.29154L17.2926 11.2883C17.1048 11.4757 16.9991 11.73 16.9989 11.9954C16.9986 12.2607 17.1039 12.5152 17.2914 12.703L19.293 14.7067C19.6833 15.0975 20.3165 15.0978 20.7072 14.7075C21.0979 14.3172 21.0983 13.684 20.708 13.2933L19.4136 11.9975L20.7067 10.7075C21.0977 10.3174 21.0985 9.68427 20.7085 9.29327Z",
      fill: "currentColor"
    }
  )
] }), GetPaidSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.5143 12.1521C13.5143 11.7379 13.1781 11.4021 12.7634 11.4021C12.3486 11.4021 12.0124 11.7379 12.0124 12.1521V13.25C12.0124 13.3881 11.9004 13.5 11.7621 13.5H3.75217C3.61393 13.5 3.50186 13.3881 3.50186 13.25L3.50186 2.75C3.50186 2.61193 3.61393 2.5 3.75217 2.5H11.7621C11.9004 2.5 12.0124 2.61193 12.0124 2.75V3.83333C12.0124 4.24755 12.3486 4.58333 12.7634 4.58333C13.1781 4.58333 13.5143 4.24755 13.5143 3.83333V2.75C13.5143 1.7835 12.7298 1 11.7621 1H3.75217C2.78448 1 2 1.7835 2 2.75V13.25C2 14.2165 2.78448 15 3.75217 15H11.7621C12.7298 15 13.5143 14.2165 13.5143 13.25V12.1521Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.75714 3.75C8.17187 3.75 8.50808 4.08579 8.50808 4.5V4.83574C9.01924 4.96125 9.4121 5.21835 9.67211 5.56599C9.9203 5.89784 9.85215 6.36781 9.51989 6.6157C9.18763 6.86359 8.71707 6.79552 8.46888 6.46367C8.43878 6.42343 8.28361 6.25 7.7552 6.25C7.3262 6.25 7.1672 6.36502 7.11376 6.41895C7.0572 6.47603 7.00442 6.58056 7.00619 6.77063C7.00741 6.90243 7.04673 6.9838 7.10343 7.03798C7.16275 7.09466 7.33493 7.21065 7.7738 7.2215C8.54284 7.24053 9.11187 7.54766 9.48407 7.95434C9.82744 8.32952 10.0099 8.79987 10.0099 9.18021L10.0099 9.19796C10.0104 9.37717 10.0117 9.89805 9.70005 10.3755C9.44399 10.7678 9.04526 11.0409 8.50808 11.1684V11.5C8.50808 11.9142 8.17187 12.25 7.75714 12.25C7.34242 12.25 7.00621 11.9142 7.00621 11.5V11.1704C6.49851 11.0527 6.1203 10.81 5.86448 10.4802C5.61047 10.1528 5.67032 9.6817 5.99816 9.428C6.326 9.17431 6.79768 9.23409 7.05169 9.56152C7.06796 9.5825 7.19777 9.75 7.7552 9.75C8.05156 9.75 8.2204 9.70126 8.30977 9.66005C8.39173 9.62226 8.42427 9.58339 8.44189 9.55639C8.49336 9.47754 8.50709 9.3638 8.50796 9.19777C8.50633 9.19056 8.50158 9.17149 8.48928 9.14198C8.46752 9.0898 8.4307 9.02665 8.37554 8.96636C8.27769 8.85945 8.09485 8.72991 7.7366 8.72104C7.04767 8.704 6.47257 8.51108 6.06522 8.12186C5.65526 7.73014 5.50852 7.22863 5.50439 6.78457C5.50002 6.31487 5.63329 5.7806 6.04627 5.36382C6.30385 5.10387 6.62962 4.93054 7.00621 4.8362V4.5C7.00621 4.08579 7.34242 3.75 7.75714 3.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.7627 10.0486C13.4601 10.3319 12.9849 10.3166 12.7012 10.0144L11.295 8.51632C11.0246 8.2282 11.0242 7.77998 11.2941 7.49138L12.7003 5.98802C12.9834 5.68533 13.4586 5.66918 13.7617 5.95194C14.0647 6.23471 14.0809 6.70931 13.7978 7.01199L12.8714 8.00247L13.7969 8.98852C14.0806 9.2907 14.0652 9.76533 13.7627 10.0486Z",
      fill: "currentColor"
    }
  )
] }), GetStartedLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.316 1.77354C7.42131 1.32058 7.82498 1 8.29002 1H18.5C18.8528 1 19.1796 1.18595 19.3598 1.48931C19.54 1.79266 19.5469 2.16853 19.3782 2.47838L15.8254 9H17.4336C17.8197 9 18.1713 9.22227 18.3369 9.57105C18.5026 9.91983 18.4526 10.3328 18.2086 10.632L8.42217 22.632C8.13894 22.9793 7.65923 23.0958 7.24828 22.917C6.83733 22.7382 6.59551 22.3078 6.65652 21.8639L7.59977 15H5.50001C5.19497 15 4.90662 14.8608 4.71692 14.6219C4.52722 14.383 4.45691 14.0706 4.52599 13.7735L7.316 1.77354ZM9.08419 3L6.75918 13H8.74659C9.03555 13 9.31039 13.125 9.5003 13.3428C9.6902 13.5606 9.77662 13.8499 9.73728 14.1361L9.12267 18.6085L15.3277 11H14.1419C13.7891 11 13.4624 10.8141 13.2822 10.5107C13.102 10.2073 13.095 9.83147 13.2638 9.52162L16.8165 3H9.08419Z",
    fill: "currentColor"
  }
) }), GetStartedSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97348 1.25336C5.19407 0.510019 5.87875 0 6.65606 0H11.1235C12.4407 0 13.2882 1.39343 12.6797 2.55847L10.858 6.04639H12.248C12.5428 6.04639 12.8105 6.21823 12.9325 6.48591C13.0546 6.75359 13.0085 7.06772 12.8147 7.28934L5.4224 15.7429C5.20324 15.9936 4.84478 16.0703 4.54177 15.9316C4.23876 15.7928 4.06356 15.4716 4.11137 15.1425L5.03823 8.76204H3.75203C3.5148 8.76204 3.29148 8.6504 3.14952 8.46085C3.00756 8.2713 2.9636 8.02606 3.03093 7.79919L4.97348 1.25336ZM6.65606 1.5C6.54502 1.5 6.44721 1.57286 6.41569 1.67905L4.75888 7.26204H5.90706C6.12532 7.26204 6.33282 7.35661 6.47566 7.5212C6.61851 7.68578 6.68261 7.90414 6.65131 8.11957L5.96567 12.8395L10.5943 7.54639H9.6183C9.35544 7.54639 9.11167 7.40951 8.97533 7.18538C8.839 6.96125 8.8299 6.6824 8.95133 6.4499L11.3458 1.8655C11.4327 1.69906 11.3116 1.5 11.1235 1.5H6.65606Z",
    fill: "currentColor"
  }
) }), GlassesLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04733 5.00008C7.52584 4.99578 7.01367 5.15792 6.58194 5.46746C6.14984 5.77726 5.8188 6.22029 5.6392 6.73782L5.63688 6.74451L3.41617 13H7.99811C8.20778 13 8.40239 13.0645 8.56314 13.1748C8.76713 13.1186 8.99051 13.1265 9.2019 13.2117C9.55341 13.3534 9.87408 13.5625 10.1449 13.8279C10.3088 13.9885 10.4524 14.1679 10.5729 14.362C11.0075 14.1265 11.4978 14 12.0011 14C12.5031 14 12.9922 14.1259 13.426 14.3602C13.5463 14.1666 13.6897 13.9878 13.8532 13.8275C14.124 13.5621 14.4446 13.353 14.7961 13.2113C14.8415 13.193 14.8917 13.1701 14.9445 13.1461C15.1377 13.058 15.3666 12.9536 15.5268 12.9978C15.6283 12.9281 15.7067 12.9472 15.8034 12.9706C15.8599 12.9844 15.9226 12.9996 15.9999 12.9996H20.5837L18.3631 6.74451L18.3608 6.73782C18.1812 6.22029 17.8502 5.77726 17.4181 5.46746C16.9863 5.15792 16.4742 4.99578 15.9527 5.00008L14 5.00012C13.4477 5.00012 13 4.5524 13 4.00012C13 3.44783 13.4477 3.00012 14 3.00012H15.9405C16.8879 2.99323 17.8116 3.28867 18.5834 3.84207C19.3551 4.39533 19.9357 5.17798 20.249 6.07856L22.9424 13.6655C23.1271 14.1859 22.855 14.7576 22.3345 14.9424C22.2212 14.9826 22.1054 15.0012 21.9918 15.0002L21.998 17.2158V17.2187C21.998 18.228 21.5887 19.1918 20.8669 19.8993C20.1457 20.606 19.1718 20.9996 18.1605 20.9996L16.8101 20.9996L16.8007 20.9995C15.7978 20.99 14.8352 20.5939 14.1223 19.8907C13.4088 19.1869 13.0032 18.2317 13 17.2308V16.9772C12.9941 16.7201 12.8895 16.4749 12.7074 16.2927C12.52 16.1053 12.2659 16 12.0011 16C11.7362 16 11.4822 16.1053 11.2947 16.2927C11.1073 16.4802 11.002 16.7346 11.002 17C11.002 17.0298 11.0006 17.0594 10.9981 17.0886V17.2312C10.9948 18.2321 10.5893 19.1873 9.87573 19.8912C9.16287 20.5943 8.20022 20.9905 7.19735 20.9999L7.1879 21L5.83755 21C4.82621 21 3.85232 20.6064 3.13116 19.8997C2.40932 19.1922 2 18.2284 2 17.2191V17.2162L2.00628 15.0003C1.89325 15.001 1.77817 14.9824 1.66549 14.9424C1.14502 14.7576 0.872885 14.1859 1.05765 13.6655L3.75098 6.07856C4.06432 5.17798 4.6449 4.39533 5.41657 3.84207C6.18842 3.28867 7.1121 2.99323 8.05945 3.00012H10C10.5523 3.00012 11 3.44783 11 4.00012C11 4.5524 10.5523 5.00012 10 5.00012L8.04733 5.00008ZM15.0002 17L15 17.023V17.2258C15.0018 17.6872 15.1887 18.1334 15.5268 18.4669C15.8649 18.8004 16.3273 18.9939 16.8154 18.9996H18.1605C18.6543 18.9996 19.1239 18.8071 19.467 18.4709C19.8091 18.1356 19.9977 17.6852 19.998 17.2199L19.9918 14.9996H15.9999C15.9082 14.9996 15.8194 14.9872 15.735 14.9641C15.6764 15.0042 15.6126 15.0386 15.544 15.0662C15.4339 15.1106 15.3352 15.1754 15.2531 15.2559C15.171 15.3364 15.1071 15.4309 15.064 15.5334C15.021 15.6359 14.9994 15.745 15 15.8546V16.9605L15.0002 17ZM7.99811 15C8.08982 15 8.17864 14.9877 8.26301 14.9645C8.32165 15.0046 8.38549 15.039 8.45406 15.0666C8.56414 15.111 8.66285 15.1758 8.74499 15.2563C8.82709 15.3368 8.89099 15.4313 8.93403 15.5338C8.97704 15.6363 8.99863 15.7454 8.99809 15.855V17.2262C8.99621 17.6876 8.80933 18.1338 8.47123 18.4673C8.1331 18.8008 7.67074 18.9943 7.18269 19H5.83755C5.34377 19 4.87417 18.8076 4.53104 18.4713C4.18891 18.136 4.00034 17.6856 4 17.2203L4.00629 15H7.99811Z",
    fill: "currentColor"
  }
) }), GlassesSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12539 2.9445C4.74614 2.94139 4.37366 3.0585 4.05968 3.28205C3.74543 3.5058 3.50468 3.82576 3.37407 4.19953L3.37238 4.20436L1.75735 8.72221H5.0896C5.24208 8.72221 5.38361 8.76882 5.50052 8.84847C5.64887 8.80789 5.81133 8.81356 5.96506 8.87511C6.2207 8.97746 6.45391 9.12848 6.65085 9.32015C6.77004 9.43616 6.87453 9.56568 6.96212 9.70587C7.27823 9.53583 7.63476 9.44443 8.00079 9.44443C8.3659 9.44443 8.72155 9.53537 9.03707 9.70459C9.12454 9.56478 9.22881 9.43559 9.34773 9.31986C9.54467 9.12819 9.77788 8.97717 10.0335 8.87482C10.0665 8.86161 10.103 8.8451 10.1414 8.82771C10.2819 8.76408 10.4484 8.68873 10.5649 8.7206C10.6387 8.67031 10.6957 8.68405 10.766 8.70101C10.8071 8.71091 10.8528 8.72192 10.909 8.72192H14.2425L12.6276 4.20436L12.6259 4.19953C12.4953 3.82576 12.2546 3.5058 11.9403 3.28205C11.6263 3.0585 11.2539 2.94139 10.8746 2.9445L9.45449 2.94453C9.05284 2.94453 8.72724 2.62118 8.72724 2.22231C8.72724 1.82343 9.05284 1.50009 9.45449 1.50009H10.8658C11.5548 1.49511 12.2265 1.70848 12.7878 2.10816C13.349 2.50774 13.7713 3.07298 13.9992 3.7234L15.9579 9.20282C16.0923 9.57871 15.8944 9.9916 15.5158 10.125C15.4334 10.1541 15.3492 10.1675 15.2666 10.1668L15.2711 11.767V11.769C15.2711 12.498 14.9735 13.1941 14.4485 13.705C13.924 14.2154 13.2158 14.4997 12.4803 14.4997L11.4982 14.4997L11.4913 14.4996C10.762 14.4928 10.0619 14.2067 9.54347 13.6989C9.02456 13.1905 8.72958 12.5007 8.72723 11.7778V11.5946C8.72297 11.409 8.64688 11.2318 8.51448 11.1003C8.37819 10.9649 8.1934 10.8889 8.00079 10.8889C7.80818 10.8889 7.62339 10.9649 7.4871 11.1003C7.3508 11.2357 7.27416 11.4195 7.27416 11.6111C7.27416 11.6327 7.27321 11.654 7.27135 11.6751V11.7781C7.269 12.501 6.97402 13.1908 6.45511 13.6992C5.93668 14.207 5.23658 14.4931 4.50724 14.4999L4.50037 14.5L3.51832 14.5C2.78281 14.5 2.07454 14.2157 1.55008 13.7053C1.02511 13.1944 0.727434 12.4983 0.727434 11.7693V11.7673L0.732004 10.1668C0.649797 10.1674 0.566104 10.1539 0.484157 10.125C0.105647 9.9916 -0.0922677 9.57871 0.0421022 9.20282L2.00084 3.7234C2.22873 3.07298 2.65096 2.50774 3.21216 2.10816C3.77349 1.70848 4.44524 1.49511 5.13421 1.50009H6.54551C6.94716 1.50009 7.27276 1.82343 7.27276 2.22231C7.27276 2.62118 6.94716 2.94453 6.54551 2.94453L5.12539 2.9445ZM10.1819 11.6111L10.1817 11.6277V11.7742C10.1831 12.1074 10.319 12.4297 10.5649 12.6705C10.8108 12.9114 11.1471 13.0511 11.502 13.0552H12.4803C12.8394 13.0552 13.1809 12.9163 13.4304 12.6734C13.6792 12.4312 13.8164 12.106 13.8166 11.7699L13.8121 10.1664H10.909C10.8423 10.1664 10.7777 10.1574 10.7163 10.1407C10.6737 10.1697 10.6273 10.1945 10.5774 10.2145C10.4973 10.2465 10.4255 10.2933 10.3658 10.3515C10.3061 10.4096 10.2596 10.4778 10.2283 10.5519C10.197 10.6259 10.1813 10.7047 10.1817 10.7838V11.5826L10.1819 11.6111ZM5.0896 10.1667C5.15629 10.1667 5.22089 10.1577 5.28225 10.141C5.3249 10.17 5.37132 10.1948 5.42119 10.2148C5.50125 10.2468 5.57303 10.2936 5.63277 10.3518C5.69248 10.4099 5.73895 10.4781 5.77025 10.5522C5.80153 10.6262 5.81723 10.705 5.81684 10.7841V11.7745C5.81547 12.1077 5.67956 12.4299 5.43368 12.6708C5.18778 12.9117 4.85151 13.0514 4.49658 13.0555H3.51832C3.15921 13.0555 2.8177 12.9165 2.56815 12.6737C2.31933 12.4315 2.1822 12.1063 2.18195 11.7702L2.18652 10.1667H5.0896Z",
    fill: "currentColor"
  }
) }), HelpCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM14.06 7.74C13.49 7.25 12.75 7 12 7C11.25 7 10.51 7.25 9.94 7.74C9.49 8.12 9.24 8.56 9.11 9C9 9.39 9 9.75 9 9.97V10.01C9 10.56 9.44 11.01 9.99 11.02C10.54 11.02 10.99 10.58 11 10.03C11 9.78 11 9.67 11.04 9.56C11.06 9.49 11.1 9.4 11.24 9.27C11.42 9.12 11.69 9.01 12 9.01C12.31 9.01 12.58 9.12 12.76 9.27C12.93 9.42 13 9.59 13 9.72V9.87C13 10.01 12.94 10.18 12.76 10.33L11.94 11.04C11.66 11.28 11.42 11.58 11.26 11.92C11.1 12.26 11.01 12.63 11.01 13.01C11.01 13.56 11.46 14.01 12.01 14.01C12.56 14.01 13.01 13.56 13.01 13.01C13.01 12.94 13.03 12.87 13.06 12.79C13.1 12.71 13.16 12.63 13.24 12.56L14.07 11.85C14.64 11.36 15 10.65 15 9.88V9.72C15 8.94 14.63 8.24 14.06 7.75V7.74ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "currentColor"
  }
) }), HelpCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9.49818 4.90182C9.08364 4.54545 8.54545 4.36364 8 4.36364C7.45455 4.36364 6.91636 4.54545 6.50182 4.90182C6.17455 5.17818 5.99273 5.49818 5.89818 5.81818C5.81818 6.10182 5.81818 6.36364 5.81818 6.52364V6.55273C5.81818 6.95273 6.13818 7.28 6.53818 7.28727C6.93818 7.28727 7.26545 6.96727 7.27273 6.56727C7.27273 6.38545 7.27273 6.30545 7.30182 6.22545C7.31636 6.17455 7.34545 6.10909 7.44727 6.01455C7.57818 5.90546 7.77455 5.82545 8 5.82545C8.22546 5.82545 8.42182 5.90546 8.55273 6.01455C8.67636 6.12364 8.72727 6.24727 8.72727 6.34182V6.45091C8.72727 6.55273 8.68364 6.67636 8.55273 6.78545L7.95636 7.30182C7.75273 7.47636 7.57818 7.69455 7.46182 7.94182C7.34546 8.18909 7.28 8.45818 7.28 8.73455C7.28 9.13455 7.60727 9.46182 8.00727 9.46182C8.40727 9.46182 8.73455 9.13455 8.73455 8.73455C8.73455 8.68364 8.74909 8.63273 8.77091 8.57455C8.8 8.51636 8.84364 8.45818 8.90182 8.40727L9.50546 7.89091C9.92 7.53455 10.1818 7.01818 10.1818 6.45818V6.34182C10.1818 5.77455 9.91273 5.26545 9.49818 4.90909V4.90182ZM8 11.6364C8.40166 11.6364 8.72727 11.3108 8.72727 10.9091C8.72727 10.5074 8.40166 10.1818 8 10.1818C7.59834 10.1818 7.27273 10.5074 7.27273 10.9091C7.27273 11.3108 7.59834 11.6364 8 11.6364Z",
    fill: "currentColor"
  }
) }), HelpCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.06 7.74C13.49 7.25 12.75 7 12 7C11.25 7 10.51 7.25 9.94 7.74C9.49 8.12 9.24 8.56 9.11 9C9 9.39 9 9.75 9 9.97V10.01C9 10.56 9.44 11.01 9.99 11.02C10.54 11.02 10.99 10.58 11 10.03C11 9.78 11 9.67 11.04 9.56C11.06 9.49 11.1 9.4 11.24 9.27C11.42 9.12 11.69 9.01 12 9.01C12.31 9.01 12.58 9.12 12.76 9.27C12.93 9.42 13 9.59 13 9.72V9.87C13 10.01 12.94 10.18 12.76 10.33L11.94 11.04C11.66 11.28 11.42 11.58 11.26 11.92C11.1 12.26 11.01 12.63 11.01 13.01C11.01 13.56 11.46 14.01 12.01 14.01C12.56 14.01 13.01 13.56 13.01 13.01C13.01 12.94 13.03 12.87 13.06 12.79C13.1 12.71 13.16 12.63 13.24 12.56L14.07 11.85C14.64 11.36 15 10.65 15 9.88V9.72C15 8.94 14.63 8.24 14.06 7.75V7.74Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), HelpCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.49824 4.9017C9.0837 4.54533 8.54552 4.36351 8.00006 4.36351C7.45461 4.36351 6.91642 4.54533 6.50188 4.9017C6.17461 5.17806 5.99279 5.49806 5.89824 5.81806C5.81824 6.1017 5.81824 6.36351 5.81824 6.52351V6.55261C5.81824 6.95261 6.13824 7.27988 6.53824 7.28715C6.93824 7.28715 7.26552 6.96715 7.27279 6.56715C7.27279 6.38533 7.27279 6.30533 7.30188 6.22533C7.31643 6.17442 7.34551 6.10897 7.44733 6.01442C7.57824 5.90533 7.77461 5.82533 8.00006 5.82533C8.22552 5.82533 8.42188 5.90533 8.55279 6.01442C8.67642 6.12351 8.72733 6.24715 8.72733 6.3417V6.45079C8.72733 6.55261 8.6837 6.67624 8.55279 6.78533L7.95642 7.3017C7.75279 7.47624 7.57824 7.69442 7.46188 7.9417C7.34551 8.18897 7.28006 8.45806 7.28006 8.73442C7.28006 9.13442 7.60733 9.4617 8.00733 9.4617C8.40733 9.4617 8.73461 9.13442 8.73461 8.73442C8.73461 8.68351 8.74915 8.63261 8.77097 8.57442C8.80006 8.51624 8.8437 8.45806 8.90188 8.40715L9.50552 7.89079C9.92006 7.53442 10.1819 7.01806 10.1819 6.45806V6.3417C10.1819 5.77442 9.91279 5.26533 9.49824 4.90897V4.9017Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.00006 11.6362C8.40172 11.6362 8.72733 11.3106 8.72733 10.909C8.72733 10.5073 8.40172 10.1817 8.00006 10.1817C7.5984 10.1817 7.27279 10.5073 7.27279 10.909C7.27279 11.3106 7.5984 11.6362 8.00006 11.6362Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00006 -0.00012207C3.58178 -0.00012207 6.10352e-05 3.5816 6.10352e-05 7.99988C6.10352e-05 12.4182 3.58178 15.9999 8.00006 15.9999C12.4183 15.9999 16.0001 12.4182 16.0001 7.99988C16.0001 3.5816 12.4183 -0.00012207 8.00006 -0.00012207ZM1.45461 7.99988C1.45461 4.38492 4.38511 1.45442 8.00006 1.45442C11.615 1.45442 14.5455 4.38492 14.5455 7.99988C14.5455 11.6148 11.615 14.5453 8.00006 14.5453C4.38511 14.5453 1.45461 11.6148 1.45461 7.99988Z",
      fill: "currentColor"
    }
  )
] }), HideLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6247 4.78088C23.056 4.43587 23.1259 3.80657 22.7809 3.37531C22.4359 2.94405 21.8066 2.87413 21.3753 3.21914L18.0721 5.86175C16.2188 4.62275 14.1326 3.97373 12 4.00078C9.78517 3.97269 7.62038 4.67382 5.71455 6.00773C3.80805 7.34212 2.22726 9.26176 1.10187 11.5603C0.966042 11.8377 0.966042 12.1623 1.10187 12.4397C1.94044 14.1525 3.03187 15.6548 4.32249 16.8614L1.37534 19.2191C0.94408 19.5641 0.874158 20.1934 1.21917 20.6247C1.56418 21.056 2.19347 21.1259 2.62473 20.7809L5.92796 18.1383C7.78124 19.3773 9.86743 20.0263 12 19.9992C14.2148 20.0273 16.3796 19.3262 18.2854 17.9923C20.1919 16.6579 21.7727 14.7383 22.8981 12.4397C23.034 12.1623 23.034 11.8377 22.8981 11.5603C22.0596 9.84757 20.9681 8.34523 19.6775 7.13863L22.6247 4.78088ZM16.4169 7.18589C15.0216 6.37939 13.5199 5.97957 12.0141 6.00077C12.0047 6.0009 11.9953 6.0009 11.9859 6.00077C10.2167 5.97587 8.45322 6.53211 6.86138 7.64626C5.38279 8.68115 4.09594 10.1681 3.12249 12C3.87921 13.4241 4.82531 14.6397 5.90365 15.5965L8.35024 13.6392C8.1252 13.139 8 12.5841 8 12C8 9.79083 9.79086 7.99997 12 7.99997C12.9004 7.99997 13.7313 8.29747 14.3998 8.79955L16.4169 7.18589ZM15.6498 10.3608L18.0964 8.40355C19.1747 9.36038 20.1208 10.5759 20.8775 12C19.9041 13.8319 18.6172 15.3189 17.1386 16.3538C15.5468 17.4679 13.7833 18.0242 12.0141 17.9992C12.0047 17.9991 11.9953 17.9991 11.9859 17.9992C10.4801 18.0204 8.97837 17.6206 7.58313 16.8142L9.60026 15.2005C10.2687 15.7025 11.0996 16 12 16C14.2091 16 16 14.2091 16 12C16 11.4159 15.8748 10.861 15.6498 10.3608ZM12.7283 10.1367C12.5026 10.0484 12.257 9.99997 12 9.99997C10.8954 9.99997 10 10.8954 10 12C10 12.1024 10.0077 12.2031 10.0226 12.3014L12.7283 10.1367ZM11.2718 13.8633L13.9775 11.6987C13.9923 11.797 14 11.8976 14 12C14 13.1045 13.1046 14 12 14C11.7431 14 11.4974 13.9515 11.2718 13.8633Z",
    fill: "currentColor"
  }
) }), HideSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7707 3.65395C12.708 3.60597 12.6448 3.55891 12.5811 3.51278C11.1955 2.50953 9.61762 1.97953 8 2.00061C6.38238 1.97953 4.80454 2.50953 3.41893 3.51278C2.03319 4.51612 0.887078 5.95723 0.0720953 7.67915C-0.0240318 7.88225 -0.0240318 8.11775 0.0720953 8.32085C0.615142 9.46822 1.30521 10.4909 2.11522 11.3425L0.315109 12.6414C-0.0207909 12.8837 -0.0966112 13.3525 0.14576 13.6884C0.388131 14.0243 0.856913 14.1001 1.19281 13.8578L3.25779 12.3678C3.31114 12.4082 3.36485 12.4481 3.41893 12.4872C4.80454 13.4905 6.38238 14.0205 8 13.9994C9.61762 14.0205 11.1955 13.4905 12.5811 12.4872C13.9668 11.4839 15.1129 10.0428 15.9279 8.32085C16.024 8.11775 16.024 7.88225 15.9279 7.67915C15.3902 6.54303 14.7083 5.52916 13.9086 4.68262L15.679 3.40513C16.0149 3.16276 16.0908 2.69398 15.8484 2.35808C15.606 2.02218 15.1372 1.94636 14.8013 2.18873L12.7707 3.65395ZM7.98908 3.5006C6.71854 3.4821 5.44862 3.89509 4.29862 4.72774C3.2275 5.50329 2.293 6.62039 1.58597 8C2.0739 8.95208 2.67016 9.77914 3.34489 10.4552L5.42112 8.95708C5.31046 8.65903 5.25 8.33657 5.25 8C5.25 6.48122 6.48122 5.25 8 5.25C8.65123 5.25 9.24959 5.47637 9.72069 5.85471L11.4884 4.57922C10.3955 3.84604 9.2035 3.48323 8.01092 3.5006C8.00364 3.5007 7.99636 3.5007 7.98908 3.5006ZM12.6796 5.56941L10.5911 7.0764C10.694 7.36507 10.75 7.67599 10.75 8C10.75 9.51878 9.51878 10.75 8 10.75C7.36157 10.75 6.77395 10.5324 6.30723 10.1674L4.54207 11.4411C5.62658 12.1607 6.80756 12.5166 7.98908 12.4994C7.99636 12.4993 8.00364 12.4993 8.01092 12.4994C9.28146 12.5179 10.5514 12.1049 11.7014 11.2723C12.7725 10.4967 13.707 9.3796 14.414 8C13.932 7.05945 13.3443 6.2409 12.6796 5.56941ZM7.64822 9.19982C7.75981 9.23248 7.87786 9.25 8 9.25C8.67542 9.25 9.22573 8.71431 9.24922 8.04461L7.64822 9.19982ZM8.39269 6.81293C8.2692 6.7721 8.13718 6.75 8 6.75C7.31024 6.75 6.75096 7.30868 6.75 7.99822L8.39269 6.81293Z",
    fill: "currentColor"
  }
) }), IframeLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 6C5 5.44772 5.44772 5 6 5H7C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H6C5.44772 7 5 6.55228 5 6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.5 5C8.94772 5 8.5 5.44772 8.5 6C8.5 6.55228 8.94772 7 9.5 7H10.5C11.0523 7 11.5 6.55228 11.5 6C11.5 5.44772 11.0523 5 10.5 5H9.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V4.5C22 3.11929 20.8807 2 19.5 2H4.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H19.5C19.7761 4 20 4.22386 20 4.5V8L4 8V4.5ZM4 10L4 19.5C4 19.7761 4.22386 20 4.5 20H19.5C19.7761 20 20 19.7761 20 19.5V10L4 10Z",
      fill: "currentColor"
    }
  )
] }), IframeSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.604 5C3.604 4.58579 3.93979 4.25 4.354 4.25H6.854C7.26822 4.25 7.604 4.58579 7.604 5C7.604 5.41421 7.26822 5.75 6.854 5.75H4.354C3.93979 5.75 3.604 5.41421 3.604 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.75 1C1.7835 1 1 1.7835 1 2.75V13.25C1 14.2165 1.7835 15 2.75 15H13.25C14.2165 15 15 14.2165 15 13.25V2.75C15 1.7835 14.2165 1 13.25 1H2.75ZM2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H13.25C13.3881 2.5 13.5 2.61193 13.5 2.75V7.25H2.5V2.75ZM2.5 8.75V13.25C2.5 13.3881 2.61193 13.5 2.75 13.5H13.25C13.3881 13.5 13.5 13.3881 13.5 13.25V8.75H2.5Z",
      fill: "currentColor"
    }
  )
] }), ImageAddLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M22 4.49994C22 3.11923 20.8807 1.99994 19.5 1.99994H4.5C3.11929 1.99994 2 3.11923 2 4.49994V18.4999C2 19.8806 3.11929 20.9999 4.5 20.9999H12.9511C13.5033 20.9999 13.9511 20.5522 13.9511 19.9999C13.9511 19.4477 13.5033 18.9999 12.9511 18.9999H4.5C4.22386 18.9999 4 18.7761 4 18.4999V17.4329L7.34966 14.2898L9.86924 16.5062C10.2469 16.8385 10.8126 16.8385 11.1902 16.5062L14.7987 13.3318L16.3395 14.6872C16.7542 15.052 17.386 15.0115 17.7508 14.5969C18.1156 14.1822 18.0752 13.5503 17.6605 13.1855L15.4592 11.2491C15.0815 10.9169 14.5159 10.9169 14.1382 11.2491L10.5297 14.4235L7.98846 12.188C7.60159 11.8476 7.01944 11.857 6.64369 12.2096L4 14.6903V4.49994C4 4.2238 4.22386 3.99994 4.5 3.99994H19.5C19.7761 3.99994 20 4.2238 20 4.49994V13.6104C20 14.1627 20.4477 14.6104 21 14.6104C21.5523 14.6104 22 14.1627 22 13.6104V4.49994Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.00586 7.99994C6.00586 9.10451 6.90129 9.99994 8.00586 9.99994C9.11043 9.99994 10.0059 9.10451 10.0059 7.99994C10.0059 6.89537 9.11043 5.99994 8.00586 5.99994C6.90129 5.99994 6.00586 6.89537 6.00586 7.99994Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.001 18.9999C16.001 18.4477 16.4487 17.9999 17.001 17.9999H18.001V16.9999C18.001 16.4477 18.4487 15.9999 19.001 15.9999C19.5533 15.9999 20.001 16.4477 20.001 16.9999V17.9999H21.001C21.5532 17.9999 22.001 18.4477 22.001 18.9999C22.001 19.5522 21.5532 19.9999 21.001 19.9999H20.001V21C20.001 21.5523 19.5533 22 19.001 22C18.4487 22 18.001 21.5523 18.001 21V19.9999H17.001C16.4487 19.9999 16.001 19.5522 16.001 18.9999Z",
      fill: "currentColor"
    }
  )
] }), ImageAddSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.0005 2.75C15.0005 1.7835 14.217 1 13.2505 1H2.75049C1.78399 1 1.00049 1.7835 1.00049 2.75V11.75C1.00049 12.7165 1.78399 13.5 2.75049 13.5H7.97754C8.39176 13.5 8.72754 13.1642 8.72754 12.75C8.72754 12.3358 8.39176 12 7.97754 12H2.75049C2.69937 12 2.65184 11.9847 2.61224 11.9583L5.07911 8.65235L6.46251 10.0765C6.61088 10.2293 6.81717 10.3117 7.02994 10.3034C7.24271 10.295 7.44189 10.1966 7.57781 10.0327L9.57126 7.62878L10.4735 8.53294C10.7661 8.82614 11.241 8.82665 11.5342 8.53407C11.8274 8.24149 11.8279 7.76662 11.5353 7.47341L10.0509 5.98586C9.90175 5.83638 9.69648 5.75671 9.48553 5.76642C9.27458 5.77613 9.07749 5.87433 8.9427 6.03688L6.95641 8.43217L5.5421 6.97617C5.38906 6.81862 5.17466 6.73608 4.95548 6.75033C4.7363 6.76457 4.53438 6.87418 4.40303 7.05021L2.50049 9.5999V2.75C2.50049 2.61193 2.61242 2.5 2.75049 2.5H13.2505C13.3886 2.5 13.5005 2.61193 13.5005 2.75V8.07884C13.5005 8.49305 13.8363 8.82884 14.2505 8.82884C14.6647 8.82884 15.0005 8.49305 15.0005 8.07884V2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.00049 5.00391C5.00049 5.55619 5.4482 6.00391 6.00049 6.00391C6.55277 6.00391 7.00049 5.55619 7.00049 5.00391C7.00049 4.45162 6.55277 4.00391 6.00049 4.00391C5.4482 4.00391 5.00049 4.45162 5.00049 5.00391Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.4888 12.75C10.4888 12.3358 10.8246 12 11.2388 12H11.9888V11.25C11.9888 10.8358 12.3246 10.5 12.7388 10.5C13.153 10.5 13.4888 10.8358 13.4888 11.25V12H14.2388C14.653 12 14.9888 12.3358 14.9888 12.75C14.9888 13.1642 14.653 13.5 14.2388 13.5H13.4888V14.25C13.4888 14.6642 13.153 15 12.7388 15C12.3246 15 11.9888 14.6642 11.9888 14.25V13.5H11.2388C10.8246 13.5 10.4888 13.1642 10.4888 12.75Z",
      fill: "currentColor"
    }
  )
] }), InfoCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 8.25C12.5523 8.25 13 7.80228 13 7.25C13 6.69772 12.5523 6.25 12 6.25C11.4477 6.25 11 6.69772 11 7.25C11 7.80228 11.4477 8.25 12 8.25ZM12 10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11C11 10.4477 11.4477 10 12 10Z",
    fill: "currentColor"
  }
) }), InfoCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM9 5C9 5.55229 8.55228 6 8 6C7.44771 6 7 5.55228 7 5C7 4.44772 7.44771 4 8 4C8.55228 4 9 4.44772 9 5ZM8 6.78516C8.41421 6.78516 8.75 7.12094 8.75 7.53516V10.999C8.75 11.4132 8.41421 11.749 8 11.749C7.58578 11.749 7.25 11.4132 7.25 10.999V7.53516C7.25 7.12094 7.58578 6.78516 8 6.78516Z",
    fill: "currentColor"
  }
) }), InfoCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 8.25C12.5523 8.25 13 7.80228 13 7.25C13 6.69772 12.5523 6.25 12 6.25C11.4477 6.25 11 6.69772 11 7.25C11 7.80228 11.4477 8.25 12 8.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), InfoCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 4.99988C9 5.55216 8.55229 5.99988 8 5.99988C7.44772 5.99988 7 5.55216 7 4.99988C7 4.44759 7.44772 3.99988 8 3.99988C8.55229 3.99988 9 4.44759 9 4.99988Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 6.78504C8.41421 6.78504 8.75 7.12082 8.75 7.53504V10.9989C8.75 11.4131 8.41422 11.7489 8 11.7489C7.58579 11.7489 7.25 11.4131 7.25 10.9989V7.53504C7.25 7.12082 7.58579 6.78504 8 6.78504Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15.9999C12.4183 15.9999 16 12.4182 16 7.99988C16 3.5816 12.4183 -0.00012207 8 -0.00012207C3.58172 -0.00012207 0 3.5816 0 7.99988C0 12.4182 3.58172 15.9999 8 15.9999ZM14.5 7.99988C14.5 11.5897 11.5899 14.4999 8 14.4999C4.41015 14.4999 1.5 11.5897 1.5 7.99988C1.5 4.41003 4.41015 1.49988 8 1.49988C11.5899 1.49988 14.5 4.41003 14.5 7.99988Z",
      fill: "currentColor"
    }
  )
] }), InstallLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.4753 13.4557L20.2665 12.7654C20.2964 12.5053 20.3064 12.2451 20.3064 11.985C20.3064 11.7149 20.2964 11.4447 20.2665 11.1746L21.4553 10.4842C21.9348 10.2041 22.0947 9.5938 21.8249 9.12356L19.3773 4.85143C19.2474 4.62131 19.0276 4.45123 18.7679 4.38119C18.5082 4.31116 18.2384 4.35118 18.0086 4.48124L16.8198 5.17159C16.3802 4.86143 15.9107 4.5913 15.4211 4.37119V3.0005C15.4311 2.73037 15.3312 2.48024 15.1414 2.29015C14.9516 2.10005 14.7018 2 14.4321 2L9.5468 2.02001C8.99733 2.02001 8.54776 2.47024 8.54776 3.02051V4.4012C8.05824 4.62131 7.58869 4.89145 7.14911 5.21161L5.96026 4.52126C5.48072 4.24112 4.87131 4.41121 4.59158 4.89145L2.13395 9.14357C2.00408 9.37369 1.96412 9.64382 2.03405 9.90395C2.10398 10.1641 2.27382 10.3842 2.5036 10.5143L3.71243 11.2046C3.66248 11.7449 3.66248 12.2851 3.71243 12.8254L2.52358 13.5158C2.04404 13.7859 1.88419 14.4062 2.15393 14.8764L4.60157 19.1486C4.73145 19.3787 4.95123 19.5488 5.21098 19.6188C5.47073 19.6888 5.74047 19.6488 5.97025 19.5188L7.1591 18.8284C7.59868 19.1386 8.05824 19.4087 8.54776 19.6288L8.52778 20.9795C8.52778 21.2496 8.62769 21.4997 8.8175 21.6999C9.00732 21.9 9.25708 22 9.52682 22H11.9745C12.5239 22 12.9735 21.5498 12.9735 20.9995C12.9735 20.4492 12.5239 19.999 11.9745 19.999H10.5358V18.9785C10.5558 18.5483 10.2861 18.1681 9.88647 18.018C9.14718 17.7579 8.47783 17.3677 7.87841 16.8674C7.55872 16.5973 7.09916 16.5573 6.72952 16.7674L5.8204 17.2876L4.37179 14.7564L5.29091 14.2261C5.66055 14.016 5.85037 13.5858 5.77044 13.1656C5.62059 12.4052 5.62059 11.6248 5.77044 10.8644C5.85037 10.4442 5.66055 10.024 5.29091 9.8039L4.3618 9.27364L5.8204 6.74237L6.72952 7.27264C7.08917 7.48274 7.54873 7.44272 7.87841 7.17259C8.46784 6.67234 9.14718 6.28214 9.87648 6.02201C10.2761 5.88194 10.5458 5.50175 10.5458 5.08154V4.02101H13.433V5.04152C13.433 5.47174 13.7028 5.85193 14.1024 5.992C14.8417 6.25213 15.511 6.64232 16.1105 7.14257C16.4302 7.41271 16.8897 7.46273 17.2594 7.24262L18.1685 6.72236L19.6171 9.25363L18.698 9.78389C18.3283 9.994 18.1285 10.4242 18.2184 10.8444C18.2884 11.2246 18.3283 11.6048 18.3283 11.995C18.3283 12.3652 18.2884 12.7454 18.2184 13.1156C18.1385 13.5358 18.3283 13.966 18.698 14.1761L20.4962 15.2066C20.9758 15.4767 21.5852 15.3167 21.8649 14.8364C22.1446 14.3562 21.9748 13.7459 21.4953 13.4657L21.4753 13.4557Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0006 12.0245C16.0006 9.81344 14.2124 8.02254 12.0045 8.02254C9.79664 8.02254 8.00836 9.81344 8.00836 12.0245C8.00836 14.2356 9.79664 16.0265 12.0045 16.0265C14.2124 16.0265 16.0006 14.2356 16.0006 12.0245ZM12.0045 14.0255C10.9056 14.0255 10.0064 13.1251 10.0064 12.0245C10.0064 10.924 10.9056 10.0235 12.0045 10.0235C13.1034 10.0235 14.0026 10.924 14.0026 12.0245C14.0026 13.1251 13.1034 14.0255 12.0045 14.0255Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.0086 18.2364L18.7379 17.356C19.0875 16.9257 19.7169 16.8757 20.1465 17.2259C20.5761 17.5861 20.626 18.2164 20.2764 18.6366L17.7788 21.6381C17.7738 21.6431 17.7663 21.6481 17.7588 21.6531C17.7513 21.6581 17.7438 21.6631 17.7388 21.6681C17.6889 21.7181 17.6289 21.7582 17.569 21.7982C17.5464 21.8132 17.5267 21.8283 17.5076 21.8429C17.4761 21.8669 17.4465 21.8895 17.4091 21.9082C17.3725 21.9303 17.3305 21.9361 17.2909 21.9416C17.2766 21.9436 17.2626 21.9456 17.2493 21.9483C17.2281 21.9536 17.2076 21.9596 17.1873 21.9655C17.1309 21.9821 17.0756 21.9983 17.0095 21.9983C16.9434 21.9983 16.8881 21.9821 16.8317 21.9655C16.8114 21.9596 16.7909 21.9536 16.7698 21.9483C16.7448 21.9382 16.7173 21.9332 16.6898 21.9282C16.6624 21.9232 16.6349 21.9182 16.6099 21.9082C16.55 21.8782 16.5 21.8382 16.4501 21.7982C16.3901 21.7582 16.3302 21.7181 16.2802 21.6681C16.2702 21.6581 16.2403 21.6381 16.2403 21.6381L13.7427 18.6366C13.393 18.2064 13.453 17.5761 13.8726 17.2259C14.3021 16.8757 14.9315 16.9357 15.2812 17.356L16.0105 18.2364V14.9948C16.0105 14.4445 16.4601 13.9943 17.0095 13.9943C17.559 13.9943 18.0086 14.4445 18.0086 14.9948V18.2364Z",
      fill: "currentColor"
    }
  )
] }), InstallmentsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 4C7.44772 4 7 3.55228 7 3C7 2.44772 7.44772 2 8 2H19C20.6569 2 22 3.34315 22 5L22 16C22 16.5523 21.5523 17 21 17C20.4477 17 20 16.5523 20 16L20 5C20 4.44772 19.5523 4 19 4L8 4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 7C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5L17.5 5C18.3284 5 19 5.67158 19 6.5L19 19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19L17 7L5 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2438 11.4312C10.2084 10.911 9.77526 10.5 9.24609 10.5C8.71662 10.5 8.28325 10.9115 8.24836 11.4321C7.83825 11.5444 7.47592 11.7362 7.18054 12.0195C6.66024 12.5185 6.49056 13.1643 6.49612 13.7279C6.50146 14.2689 6.69136 14.8758 7.20851 15.3416C7.71347 15.7964 8.40959 16.0079 9.21829 16.0267C9.62173 16.0361 9.80848 16.1729 9.89444 16.2615C9.94533 16.3139 9.97615 16.3657 9.99224 16.4021L9.99549 16.4096C9.99247 16.5619 9.97598 16.6209 9.95447 16.652C9.95227 16.6554 9.93429 16.6831 9.85714 16.7166C9.76709 16.7557 9.58122 16.8086 9.24161 16.8086C8.84785 16.8086 8.65213 16.7377 8.57121 16.696C8.08025 16.4431 7.47721 16.6361 7.22428 17.127C6.97134 17.618 7.16431 18.221 7.65527 18.474C7.84095 18.5696 8.04447 18.6449 8.26603 18.6996C8.35854 19.1563 8.76218 19.5 9.24609 19.5C9.73159 19.5 10.1363 19.154 10.2271 18.6952C10.8256 18.5429 11.2885 18.2387 11.5989 17.7903C11.9988 17.2127 11.9967 16.5811 11.996 16.3778L11.996 16.3568C11.996 15.4505 11.1292 14.0708 9.26493 14.0273C8.75785 14.0154 8.58433 13.8891 8.54703 13.8555C8.52191 13.8329 8.49693 13.8007 8.49602 13.7082C8.49442 13.5461 8.53962 13.4872 8.56493 13.4629C8.59405 13.435 8.74922 13.3086 9.24161 13.3086C9.56348 13.3086 9.75699 13.3635 9.86205 13.4101C9.88284 13.4194 9.90046 13.4284 9.91526 13.4368C10.3953 13.7098 11.0058 13.542 11.2789 13.0619C11.5519 12.5819 11.3841 11.9713 10.904 11.6983C10.8304 11.6564 10.7536 11.6177 10.6738 11.5822C10.5384 11.5221 10.395 11.4717 10.2438 11.4312Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 8C2.44771 8 2 8.44772 2 9V21C2 21.5523 2.44772 22 3 22L15 22C15.5523 22 16 21.5523 16 21L16 9C16 8.44771 15.5523 8 15 8L3 8ZM4 10L14 10L14 20L4 20L4 10Z",
      fill: "currentColor"
    }
  )
] }), InstallmentsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.23029 2.50084C2.81538 2.50084 2.47904 2.16486 2.47904 1.75042C2.47904 1.33597 2.81539 1 3.2303 1L12.7462 1.00004C13.991 1.00005 15 2.00797 15 3.2513V12.7566C15 13.171 14.6637 13.507 14.2487 13.507C13.8338 13.507 13.4975 13.171 13.4975 12.7566V3.2513C13.4975 2.83686 13.1611 2.50088 12.7462 2.50088L3.23029 2.50084Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.43149 8.08607C6.40427 8.0853 6.37717 8.09 6.3518 8.09989C6.32643 8.10977 6.3033 8.12464 6.28378 8.1436C6.26426 8.16257 6.24874 8.18526 6.23815 8.21032C6.22756 8.23538 6.22211 8.26231 6.22212 8.28951C6.22212 8.34347 6.24358 8.39551 6.28178 8.43366C6.31997 8.47182 6.37178 8.49325 6.4258 8.49325H7.09356C7.31862 8.49325 7.54148 8.53772 7.74926 8.62411C7.95705 8.71051 8.14567 8.83711 8.30426 8.99663C8.46285 9.15615 8.58828 9.34544 8.67332 9.55359C8.75802 9.76093 8.80099 9.98291 8.79977 10.2068C8.79907 10.6579 8.61939 11.0903 8.30004 11.4093C8.08305 11.6261 7.81363 11.7784 7.52155 11.854C7.48985 12.2393 7.16675 12.5421 6.77285 12.5421C6.39771 12.5421 6.08679 12.2675 6.03063 11.9085H5.49757C5.08267 11.9085 4.74632 11.5725 4.74632 11.1581C4.74632 10.7436 5.08267 10.4077 5.49757 10.4077H6.76316L6.77285 10.4076L6.78253 10.4077H7.09358C7.1476 10.4077 7.1994 10.3862 7.2376 10.3481C7.2758 10.3099 7.29725 10.2582 7.29725 10.2042V10.199C7.29744 10.1721 7.29233 10.1455 7.28218 10.1207C7.27203 10.0958 7.25706 10.0732 7.23812 10.0542C7.21919 10.0351 7.19668 10.02 7.17187 10.0097C7.14707 9.9994 7.12046 9.99409 7.0936 9.99409H6.4258C5.97329 9.99409 5.53931 9.81453 5.21934 9.49492C4.89943 9.17537 4.71968 8.742 4.71961 8.2901C4.71956 8.06232 4.76522 7.83655 4.85389 7.6267C4.9426 7.41675 5.07257 7.22671 5.23609 7.06782C5.39961 6.90892 5.59338 6.78439 5.80592 6.7016C5.87741 6.67376 5.95053 6.65083 6.02477 6.63289C6.05988 6.25103 6.3814 5.95198 6.77285 5.95198C7.14795 5.95198 7.45885 6.22659 7.51505 6.58552H8.04851C8.46342 6.58552 8.79977 6.9215 8.79977 7.33594C8.79977 7.75038 8.46342 8.08636 8.04851 8.08636H6.78791L6.77285 8.08651L6.75778 8.08636H6.45251L6.43149 8.08607ZM8.79977 10.2068L8.79977 10.2042H8.04851L8.79975 10.2095L8.79977 10.2068Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.75126 3.49358C1.33635 3.49358 1 3.82955 1 4.244V14.2496C1 14.664 1.33635 15 1.75126 15L11.768 15C12.1829 15 12.5193 14.664 12.5193 14.2496L12.5193 4.244C12.5193 3.82955 12.1829 3.49358 11.768 3.49358L1.75126 3.49358ZM2.50252 4.99442L11.0168 4.99442L11.0168 13.4992L2.50252 13.4992L2.50252 4.99442Z",
      fill: "currentColor"
    }
  )
] }), InstallSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.29794 1C6.35769 1 5.51404 1.69688 5.44602 2.66351C5.08514 2.81844 4.7403 3.00601 4.41637 3.22387C3.56417 2.80319 2.48461 3.07169 1.97297 3.90457L1.25941 5.06615C0.735272 5.91937 1.03695 6.98077 1.85519 7.48587C1.82081 7.8364 1.82083 8.18921 1.85525 8.53974C1.04545 9.04544 0.746419 10.0985 1.26406 10.9485L1.97299 12.1126C2.48212 12.9486 3.56241 13.2201 4.4162 12.801C4.73917 13.0182 5.08292 13.2054 5.44262 13.36C5.5225 14.3195 6.37037 15.0084 7.31021 14.9999L8.70849 14.9873C9.12269 14.9836 9.45543 14.6448 9.4517 14.2306C9.44796 13.8164 9.10916 13.4836 8.69496 13.4874L7.29668 13.5C7.0507 13.5022 6.93484 13.3249 6.93651 13.207L6.94152 12.8537C6.94616 12.5266 6.73826 12.2342 6.42778 12.1312C5.88367 11.9507 5.38135 11.6787 4.94498 11.3301C4.70926 11.1419 4.38367 11.1132 4.11864 11.2573L3.76951 11.4471C3.57212 11.5544 3.34005 11.4735 3.25412 11.3324L2.54519 10.1683C2.50586 10.1037 2.5002 10.0383 2.5176 9.97783C2.53532 9.91629 2.58105 9.84841 2.66971 9.80043L3.03095 9.60494C3.32157 9.44767 3.47502 9.11871 3.40877 8.79497C3.30297 8.27797 3.30297 7.74702 3.40877 7.23002C3.47502 6.90628 3.32158 6.57733 3.03096 6.42005L2.66147 6.2201C2.57258 6.17199 2.52685 6.10391 2.50923 6.04225C2.49192 5.98167 2.49775 5.91603 2.53751 5.8513L3.25108 4.68972C3.33752 4.549 3.56916 4.46894 3.76591 4.57592L4.11864 4.76772C4.38367 4.91184 4.70926 4.88313 4.94498 4.69486C5.38135 4.34632 5.88367 4.07431 6.42778 3.89378C6.73454 3.792 6.9416 3.50514 6.9416 3.18194V2.78979C6.9416 2.6729 7.05662 2.5 7.29794 2.5H8.69111C8.93243 2.5 9.04745 2.6729 9.04745 2.78979V3.15817C9.04745 3.48138 9.25451 3.76823 9.56127 3.87001C10.1054 4.05054 10.6077 4.32256 11.0441 4.67109C11.2785 4.85836 11.6021 4.88785 11.8665 4.74605L12.2132 4.5602C12.4099 4.45474 12.6399 4.53495 12.726 4.6749L13.4391 5.8341C13.4789 5.89886 13.4847 5.96453 13.4674 6.02512C13.4498 6.08681 13.4041 6.15492 13.3152 6.20305L12.9581 6.39628C12.667 6.55383 12.5136 6.88362 12.5806 7.20779C12.6337 7.46473 12.6602 7.72571 12.6596 7.98712C12.6587 8.40134 12.9938 8.73784 13.408 8.73873C13.8222 8.73961 14.1587 8.40455 14.1596 7.99033C14.16 7.81343 14.1515 7.63674 14.1342 7.46087C14.9432 6.95242 15.2388 5.89699 14.7167 5.04817L14.0036 3.88897C13.4948 3.06192 12.4254 2.79165 11.5755 3.202C11.2502 2.98295 10.9037 2.79446 10.5411 2.63893C10.4607 1.68509 9.62337 1 8.69111 1H7.29794Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.98828 5.24219C6.4695 5.24219 5.23828 6.4734 5.23828 7.99219C5.23828 9.51097 6.4695 10.7422 7.98828 10.7422C9.50706 10.7422 10.7383 9.51097 10.7383 7.99219C10.7383 6.4734 9.50706 5.24219 7.98828 5.24219ZM6.73828 7.99219C6.73828 7.30183 7.29792 6.74219 7.98828 6.74219C8.67864 6.74219 9.23828 7.30183 9.23828 7.99219C9.23828 8.68254 8.67864 9.24219 7.98828 9.24219C7.29792 9.24219 6.73828 8.68254 6.73828 7.99219Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.2532 9.48828C12.6674 9.48828 13.0032 9.82407 13.0032 10.2383L13.0032 12.4379L13.7191 11.7203C14.0116 11.4271 14.4865 11.4265 14.7797 11.7191C15.0729 12.0116 15.0735 12.4865 14.7809 12.7797L12.7915 14.7738C12.6552 14.9143 12.4644 15.0016 12.2532 15.0016C12.09 15.0016 11.939 14.9495 11.8159 14.861C11.7824 14.837 11.7507 14.81 11.7212 14.7804L9.7313 12.7788C9.43927 12.485 9.44066 12.0102 9.73441 11.7181C10.0282 11.4261 10.503 11.4275 10.7951 11.7212L11.5032 12.4335L11.5032 10.2383C11.5032 9.82407 11.839 9.48828 12.2532 9.48828Z",
      fill: "currentColor"
    }
  )
] }), InternationalLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9984 4.00005L12.0275 4C12.5798 4 13.0275 3.55228 13.0275 3C13.0275 2.44772 12.5798 2 12.0275 2L12.0065 2.00002L11.9999 2L11.9772 2.00012C6.46515 2.0271 1.99994 6.491 1.99994 12C1.99994 17.509 6.46515 21.9729 11.9772 21.9999L11.9999 22L12.0085 22L12.0275 22C17.1871 22 21.4391 18.1135 21.9938 13.1102C22.0547 12.5613 21.6591 12.067 21.1101 12.0061C20.572 11.9464 20.0864 12.3255 20.0101 12.8576C19.9963 12.8598 19.9824 12.8622 19.9685 12.8648C18.5246 13.1414 17.2499 13.3453 15.9615 13.4714C15.9869 12.9906 15.9999 12.4991 15.9999 12C15.9999 11.4477 15.5522 11 14.9999 11C14.4477 11 13.9999 11.4477 13.9999 12C13.9999 12.55 13.9829 13.0859 13.9506 13.6033C13.4774 13.6192 12.991 13.6253 12.4837 13.6212L12.4674 13.6211L12.4512 13.6214C11.6494 13.6364 10.8482 13.6284 10.0489 13.5973C10.0169 13.0817 9.99994 12.5478 9.99994 12C9.99994 11.3095 10.0268 10.6412 10.077 10.0037C10.8015 9.98824 11.5294 9.98831 12.26 10.0013L12.2762 10.0016L12.2924 10.0014C12.5362 9.99924 12.7797 9.99861 13.023 9.99965C13.6105 10.0021 14.0893 9.58695 14.0924 9.07229C14.0955 8.55763 13.6218 8.13838 13.0343 8.13589C12.7853 8.13483 12.5365 8.13543 12.2878 8.1376C11.6271 8.12603 10.9652 8.12457 10.303 8.1353C10.4402 7.31476 10.6187 6.57822 10.8273 5.95227C11.0793 5.19616 11.3574 4.65642 11.6176 4.32624C11.7454 4.16408 11.8494 4.07752 11.9185 4.03507C11.9515 4.01483 11.9735 4.00645 11.9846 4.00305C11.9921 4.00079 11.9964 4.0002 11.9984 4.00005ZM9.24182 4.4947C7.27829 5.2187 5.67726 6.68602 4.78139 8.55298C5.93877 8.38647 7.10208 8.27554 8.2669 8.2089C8.42537 7.13685 8.65018 6.15907 8.92994 5.31981C9.02541 5.0334 9.12923 4.75714 9.24182 4.4947ZM4.13145 10.5503C4.04506 11.0205 3.99994 11.505 3.99994 12C3.99994 12.3126 4.01793 12.6209 4.05295 12.9242C5.36882 13.1708 6.69933 13.353 8.03834 13.4703C8.01299 12.9898 7.99994 12.4987 7.99994 12C7.99994 11.3479 8.02226 10.7089 8.06518 10.0895C6.73868 10.1759 5.4259 10.3239 4.13145 10.5503ZM4.54854 14.9123C5.38057 17.0326 7.09441 18.7135 9.24182 19.5053C9.12923 19.2429 9.02541 18.9666 8.92994 18.6802C8.61281 17.7288 8.36628 16.5994 8.20696 15.3565C6.97991 15.2597 5.75903 15.1115 4.54854 14.9123ZM12.0013 20L11.9984 19.9999C11.9964 19.9998 11.9921 19.9992 11.9846 19.9969C11.9735 19.9936 11.9515 19.9852 11.9185 19.9649C11.8494 19.9225 11.7454 19.8359 11.6176 19.6738C11.3574 19.3436 11.0793 18.8038 10.8273 18.0477C10.5857 17.3229 10.3845 16.4497 10.2411 15.4695C10.9865 15.4936 11.7333 15.4988 12.4805 15.4851C12.9195 15.4884 13.3441 15.4846 13.7581 15.4739C13.6147 16.4523 13.4138 17.3239 13.1726 18.0477C12.9205 18.8038 12.6425 19.3436 12.3823 19.6738C12.2545 19.8359 12.1505 19.9225 12.0814 19.9649C12.0484 19.9852 12.0264 19.9936 12.0152 19.9969C12.0106 19.9984 12.0072 19.9991 12.0047 19.9995L12.0013 20ZM14.7479 19.529C16.9466 18.7398 18.6995 17.0215 19.5305 14.851C18.2354 15.0821 17.0323 15.2545 15.7923 15.361C15.633 16.6021 15.3867 17.7299 15.0699 18.6802C14.9716 18.9752 14.8644 19.2595 14.7479 19.529Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.9999 6C18.9999 6.55228 18.5522 7 17.9999 7C17.4477 7 16.9999 6.55228 16.9999 6C16.9999 5.44772 17.4477 5 17.9999 5C18.5522 5 18.9999 5.44772 18.9999 6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.1823 3.13472C15.9346 2.40486 16.9487 2 17.9999 2C19.0512 2 20.0653 2.40486 20.8176 3.13472C21.5709 3.86558 21.9999 4.86341 21.9999 5.91048C21.9999 7.07765 21.5188 8.16735 20.9869 9.02912C20.4471 9.90377 19.796 10.6382 19.3285 11.116C18.5941 11.8668 17.4058 11.8668 16.6713 11.116C16.2039 10.6382 15.5528 9.90377 15.013 9.02912C14.4811 8.16735 13.9999 7.07765 13.9999 5.91048C13.9999 4.86341 14.429 3.86558 15.1823 3.13472ZM17.9999 4C17.4599 4 16.9478 4.20841 16.5749 4.57019C16.2031 4.93097 15.9999 5.41373 15.9999 5.91048C15.9999 6.54789 16.2731 7.26277 16.7149 7.97872C17.1141 8.62542 17.6046 9.1988 17.9999 9.61287C18.3952 9.1988 18.8858 8.62542 19.2849 7.97872C19.7268 7.26277 19.9999 6.54789 19.9999 5.91048C19.9999 5.41373 19.7968 4.93097 19.4249 4.57019C19.052 4.20841 18.54 4 17.9999 4Z",
      fill: "currentColor"
    }
  )
] }), InternationalSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99895 2.40004L8.01928 2.4C8.40588 2.4 8.71928 2.0866 8.71928 1.7C8.71928 1.3134 8.40588 1 8.01928 1L8.00462 1.00001L8 1L7.98411 1.00009C4.12565 1.01897 1 4.1437 1 8C1 11.8563 4.12565 14.981 7.98411 14.9999L8 15L8.006 15L8.01928 15C11.631 15 14.6074 12.2794 14.9957 8.77715C15.0383 8.3929 14.7614 8.04687 14.3771 8.00426C14.0005 7.9625 13.6605 8.22784 13.6071 8.60032C13.5974 8.60183 13.5877 8.60351 13.578 8.60537C12.5673 8.79896 11.675 8.94169 10.7731 9.03001C10.7908 8.69341 10.8 8.34938 10.8 8C10.8 7.6134 10.4866 7.3 10.1 7.3C9.7134 7.3 9.4 7.6134 9.4 8C9.4 8.38497 9.38807 8.7601 9.36547 9.12233C9.03423 9.13346 8.69378 9.13769 8.33861 9.13485L8.32724 9.13476L8.31587 9.13498C7.7546 9.14551 7.19376 9.13986 6.63426 9.11811C6.61184 8.75719 6.6 8.38348 6.6 8C6.6 7.51668 6.61881 7.04886 6.65391 6.60262C7.16111 6.59177 7.67065 6.59182 8.18202 6.6009L8.19339 6.6011L8.20476 6.601C8.37535 6.59947 8.54582 6.59903 8.71615 6.59975C9.12739 6.6015 9.46253 6.31087 9.46471 5.9506C9.46688 5.59034 9.13527 5.29687 8.72403 5.29512C8.54978 5.29438 8.37559 5.2948 8.2015 5.29632C7.739 5.28822 7.2757 5.2872 6.81215 5.29471C6.90818 4.72033 7.0331 4.20476 7.17915 3.76659C7.35558 3.23731 7.55023 2.85949 7.73237 2.62837C7.82183 2.51486 7.8946 2.45426 7.943 2.42455C7.96608 2.41038 7.9815 2.40451 7.9893 2.40214C7.9945 2.40055 7.99749 2.40014 7.99895 2.40004ZM6.06932 2.74629C4.69485 3.25309 3.57412 4.28021 2.94702 5.58709C3.75718 5.47053 4.5715 5.39288 5.38687 5.34623C5.4978 4.59579 5.65517 3.91135 5.851 3.32387C5.91783 3.12338 5.9905 2.93 6.06932 2.74629ZM2.49206 6.98524C2.43159 7.31438 2.4 7.65353 2.4 8C2.4 8.21879 2.4126 8.43466 2.43711 8.64693C3.35821 8.81954 4.28957 8.9471 5.22688 9.0292C5.20914 8.69286 5.2 8.34909 5.2 8C5.2 7.54354 5.21562 7.0962 5.24567 6.66263C4.31712 6.72311 3.39817 6.82673 2.49206 6.98524ZM2.78402 10.0386C3.36644 11.5228 4.56613 12.6994 6.06932 13.2537C5.9905 13.07 5.91783 12.8766 5.851 12.6761C5.62901 12.0102 5.45644 11.2196 5.34491 10.3495C4.48598 10.2818 3.63137 10.1781 2.78402 10.0386ZM8.00095 13.6L7.99895 13.6C7.99749 13.5999 7.99451 13.5995 7.9893 13.5979C7.98149 13.5955 7.96608 13.5896 7.943 13.5754C7.8946 13.5457 7.82183 13.4851 7.73237 13.3716C7.55023 13.1405 7.35558 12.7627 7.17915 12.2334C7.01001 11.726 6.86922 11.1148 6.76882 10.4286C7.29058 10.4455 7.81334 10.4492 8.33642 10.4395C8.64372 10.4419 8.94089 10.4392 9.23073 10.4317C9.13036 11.1166 8.98973 11.7268 8.82085 12.2334C8.64442 12.7627 8.44977 13.1405 8.26763 13.3716C8.17817 13.4851 8.1054 13.5457 8.057 13.5754C8.03392 13.5896 8.01851 13.5955 8.0107 13.5979C8.00744 13.5989 8.00505 13.5994 8.00337 13.5997L8.00095 13.6ZM9.92355 13.2703C11.4627 12.7179 12.6897 11.515 13.2714 9.99568C12.3648 10.1575 11.5227 10.2782 10.6547 10.3527C10.5431 11.2215 10.3707 12.011 10.149 12.6761C10.0802 12.8827 10.0051 13.0816 9.92355 13.2703Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2277 1.79431C10.7543 1.2834 11.4641 1 12.2 1C12.9359 1 13.6457 1.2834 14.1723 1.79431C14.6997 2.30591 15 3.00439 15 3.73733C15 4.55436 14.6632 5.31715 14.2909 5.92038C13.913 6.53264 13.4572 7.04675 13.13 7.38123C12.6159 7.90674 11.7841 7.90674 11.27 7.38123C10.9428 7.04675 10.487 6.53264 10.1091 5.92038C9.73682 5.31715 9.4 4.55436 9.4 3.73733C9.4 3.00439 9.70032 2.30591 10.2277 1.79431ZM12.2 2.4C11.822 2.4 11.4635 2.54589 11.2025 2.79914C10.9422 3.05168 10.8 3.38961 10.8 3.73733C10.8 4.18352 10.9912 4.68394 11.3005 5.1851C11.5799 5.63779 11.9233 6.03916 12.2 6.32901C12.4767 6.03916 12.8201 5.63779 13.0995 5.1851C13.4088 4.68394 13.6 4.18352 13.6 3.73733C13.6 3.38961 13.4578 3.05168 13.1975 2.79914C12.9365 2.54589 12.578 2.4 12.2 2.4Z",
      fill: "currentColor"
    }
  )
] }), InvoicesLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 7C8 6.44772 8.44772 6 9 6H11C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8H9C8.44772 8 8 7.55228 8 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 10C8 9.44772 8.44772 9 9 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H9C8.44772 11 8 10.5523 8 10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12H9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 6C16.5 5.44772 16.0523 5 15.5 5C14.9477 5 14.5 5.44772 14.5 6V6.64933C14.1626 6.7614 13.8615 6.93936 13.6128 7.19266C13.1432 7.67095 12.9992 8.27699 13.004 8.79064C13.0086 9.28451 13.1708 9.85612 13.6395 10.3044C14.1042 10.749 14.7454 10.9529 15.4735 10.971C15.6286 10.9748 15.7293 11.0055 15.7924 11.0343C15.8563 11.0635 15.9009 11.0996 15.9333 11.135C15.9668 11.1717 15.9882 11.209 15.9998 11.2361C15.999 11.2875 15.9967 11.3251 15.9905 11.3621C15.985 11.3946 15.9787 11.4111 15.9759 11.4173C15.9715 11.4205 15.9627 11.426 15.9473 11.4331C15.8987 11.4555 15.7678 11.5 15.4982 11.5C15.1085 11.5 14.9943 11.4083 14.9927 11.407C14.5575 11.0671 13.929 11.1442 13.589 11.5795C13.249 12.0147 13.3262 12.6431 13.7615 12.9831C13.9749 13.1499 14.2224 13.2764 14.502 13.3626V14C14.502 14.5523 14.9497 15 15.502 15C16.0542 15 16.502 14.5523 16.502 14V13.3579C16.9973 13.2012 17.3864 12.9166 17.6501 12.512C18.0031 11.9706 18.0009 11.3847 18.0002 11.2004L18.0001 11.1802C18.0001 10.729 17.7885 10.2003 17.4095 9.78567C16.9921 9.32902 16.3595 8.9923 15.523 8.97158C15.325 8.96668 15.1981 8.938 15.1229 8.91148C15.0505 8.88596 15.0254 8.86248 15.0219 8.85914C15.0188 8.85615 15.0175 8.85476 15.0149 8.84795C15.0111 8.83814 15.0043 8.81397 15.0039 8.77205C15.0032 8.7011 15.0132 8.65388 15.0224 8.6272C15.0304 8.60359 15.0374 8.59641 15.0399 8.59385C15.0422 8.5915 15.0617 8.57164 15.123 8.54991C15.1887 8.52658 15.3068 8.5 15.4982 8.5C15.8583 8.5 15.9843 8.59154 16.0025 8.606C16.434 8.95064 17.0632 8.88018 17.4079 8.44862C17.7525 8.01706 17.6821 7.38783 17.2505 7.04319C17.0343 6.87053 16.7827 6.73763 16.5 6.64651V6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 16.7773V4.5C4 3.11929 5.11929 2 6.5 2H19.5C20.8807 2 22 3.11929 22 4.5V19C22 19.8188 21.5952 20.5591 21.0842 21.0731C20.5725 21.588 19.8308 22 19 22H4.54286C3.18635 22 2 20.9329 2 19.5273V19.2273C2 18.0178 2.85888 17.0089 4 16.7773ZM19.5 4C19.7761 4 20 4.22386 20 4.5V19C20 19.163 19.9048 19.4227 19.6658 19.6632C19.4275 19.9029 19.1692 20 19 20C18.8261 20 18.5676 19.9026 18.3324 19.6672C18.0971 19.4317 18 19.173 18 19C18 17.7448 16.9825 16.7273 15.7273 16.7273H6V4.5C6 4.22386 6.22386 4 6.5 4H19.5ZM16.198 20H4.54286C4.20222 20 4 19.7417 4 19.5273V19.2273C4 18.9511 4.22386 18.7273 4.5 18.7273H15.7273C15.8779 18.7273 16 18.8494 16 19C16 19.3522 16.0736 19.6893 16.198 20Z",
      fill: "currentColor"
    }
  )
] }), InvoicesSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 7C8 6.44772 8.44772 6 9 6H11C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8H9C8.44772 8 8 7.55228 8 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 10C8 9.44772 8.44772 9 9 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H9C8.44772 11 8 10.5523 8 10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12H9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 6C16.5 5.44772 16.0523 5 15.5 5C14.9477 5 14.5 5.44772 14.5 6V6.64933C14.1626 6.7614 13.8615 6.93936 13.6128 7.19266C13.1432 7.67095 12.9992 8.27699 13.004 8.79064C13.0086 9.28451 13.1708 9.85612 13.6395 10.3044C14.1042 10.749 14.7454 10.9529 15.4735 10.971C15.6286 10.9748 15.7293 11.0055 15.7924 11.0343C15.8563 11.0635 15.9009 11.0996 15.9333 11.135C15.9668 11.1717 15.9882 11.209 15.9998 11.2361C15.999 11.2875 15.9967 11.3251 15.9905 11.3621C15.985 11.3946 15.9787 11.4111 15.9759 11.4173C15.9715 11.4205 15.9627 11.426 15.9473 11.4331C15.8987 11.4555 15.7678 11.5 15.4982 11.5C15.1085 11.5 14.9943 11.4083 14.9927 11.407C14.5575 11.0671 13.929 11.1442 13.589 11.5795C13.249 12.0147 13.3262 12.6431 13.7615 12.9831C13.9749 13.1499 14.2224 13.2764 14.502 13.3626V14C14.502 14.5523 14.9497 15 15.502 15C16.0542 15 16.502 14.5523 16.502 14V13.3579C16.9973 13.2012 17.3864 12.9166 17.6501 12.512C18.0031 11.9706 18.0009 11.3847 18.0002 11.2004L18.0001 11.1802C18.0001 10.729 17.7885 10.2003 17.4095 9.78567C16.9921 9.32902 16.3595 8.9923 15.523 8.97158C15.325 8.96668 15.1981 8.938 15.1229 8.91148C15.0505 8.88596 15.0254 8.86248 15.0219 8.85914C15.0188 8.85615 15.0175 8.85476 15.0149 8.84795C15.0111 8.83814 15.0043 8.81397 15.0039 8.77205C15.0032 8.7011 15.0132 8.65388 15.0224 8.6272C15.0304 8.60359 15.0374 8.59641 15.0399 8.59385C15.0422 8.5915 15.0617 8.57164 15.123 8.54991C15.1887 8.52658 15.3068 8.5 15.4982 8.5C15.8583 8.5 15.9843 8.59154 16.0025 8.606C16.434 8.95064 17.0632 8.88018 17.4079 8.44862C17.7525 8.01706 17.6821 7.38783 17.2505 7.04319C17.0343 6.87053 16.7827 6.73763 16.5 6.64651V6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 16.7773V4.5C4 3.11929 5.11929 2 6.5 2H19.5C20.8807 2 22 3.11929 22 4.5V19C22 19.8188 21.5952 20.5591 21.0842 21.0731C20.5725 21.588 19.8308 22 19 22H4.54286C3.18635 22 2 20.9329 2 19.5273V19.2273C2 18.0178 2.85888 17.0089 4 16.7773ZM19.5 4C19.7761 4 20 4.22386 20 4.5V19C20 19.163 19.9048 19.4227 19.6658 19.6632C19.4275 19.9029 19.1692 20 19 20C18.8261 20 18.5676 19.9026 18.3324 19.6672C18.0971 19.4317 18 19.173 18 19C18 17.7448 16.9825 16.7273 15.7273 16.7273H6V4.5C6 4.22386 6.22386 4 6.5 4H19.5ZM16.198 20H4.54286C4.20222 20 4 19.7417 4 19.5273V19.2273C4 18.9511 4.22386 18.7273 4.5 18.7273H15.7273C15.8779 18.7273 16 18.8494 16 19C16 19.3522 16.0736 19.6893 16.198 20Z",
      fill: "currentColor"
    }
  )
] }), LaptopLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04999 15C3.01721 14.8385 3 14.6713 3 14.5001V5.5C3 4.11929 4.11929 3 5.5 3H18.5C19.8807 3 21 4.11929 21 5.5V14.5001C21 14.6713 20.9828 14.8385 20.95 15H22C22.5523 15 23 15.4477 23 16V18C23 18.7667 22.7239 19.5188 22.207 20.0871C21.6872 20.6585 20.9609 21 20.181 21H3.81905C3.03914 21 2.31276 20.6585 1.79301 20.0871C1.27613 19.5188 1 18.7667 1 18V16C1 15.4477 1.44772 15 2 15H3.04999ZM5 5.5C5 5.22386 5.22386 5 5.5 5H18.5C18.7761 5 19 5.22386 19 5.5V14.5001C19 14.7731 18.7813 14.9949 18.5095 15H5.49049C5.21873 14.9949 5 14.7731 5 14.5001V5.5ZM5.47872 17H3V18C3 18.2942 3.10717 18.5595 3.27257 18.7414C3.43509 18.9201 3.63407 19 3.81905 19H20.181C20.3659 19 20.5649 18.9201 20.7274 18.7414C20.8928 18.5595 21 18.2942 21 18V17H18.5213C18.5142 17.0001 18.5071 17.0001 18.5 17.0001H5.5C5.4929 17.0001 5.48581 17.0001 5.47872 17Z",
    fill: "currentColor"
  }
) }), LaptopSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    id: "Vector\\",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76757 9.4708C1.75599 9.38942 1.75 9.30623 1.75 9.22165V3.75544C1.75 2.7882 2.5335 2.00409 3.5 2.00409H12.5C13.4665 2.00409 14.25 2.7882 14.25 3.75544V9.22165C14.25 9.30623 14.244 9.38942 14.2324 9.4708H15.25C15.6642 9.4708 16 9.80685 16 10.2214V11.7374C16 12.3076 15.8039 12.8718 15.4294 13.3023C15.052 13.7361 14.5161 14.0041 13.9312 14.0041H2.06881C1.48393 14.0041 0.947973 13.7361 0.570596 13.3023C0.196088 12.8718 0 12.3076 0 11.7374V10.2214C0 9.80685 0.335786 9.4708 0.75 9.4708H1.76757ZM3.25 3.75544C3.25 3.61727 3.36193 3.50525 3.5 3.50525H12.5C12.6381 3.50525 12.75 3.61727 12.75 3.75544V9.22165C12.75 9.35207 12.6503 9.45918 12.523 9.4708H3.47701C3.34971 9.45918 3.25 9.35207 3.25 9.22165V3.75544ZM3.439 10.972H1.5V11.7374C1.5 11.9715 1.5818 12.1785 1.70194 12.3166C1.81922 12.4514 1.95415 12.5029 2.06881 12.5029H13.9312C14.0459 12.5029 14.1808 12.4514 14.2981 12.3166C14.4182 12.1785 14.5 11.9715 14.5 11.7374V10.972H12.561C12.5408 10.9727 12.5204 10.973 12.5 10.973H3.5C3.47958 10.973 3.45925 10.9727 3.439 10.972Z",
    fill: "currentColor"
  }
) }), LinkCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM17.7276 6.51532C19.2897 8.07742 19.2897 10.6101 17.7276 12.1722L17.0205 12.8793C16.63 13.2698 15.9968 13.2698 15.6063 12.8793C15.2158 12.4888 15.2158 11.8556 15.6063 11.4651L16.3134 10.758C17.0944 9.97691 17.0944 8.71059 16.3134 7.92954C15.5323 7.14849 14.266 7.14849 13.485 7.92954L12.7779 8.63664C12.3873 9.02717 11.7542 9.02717 11.3636 8.63664C10.9731 8.24612 10.9731 7.61295 11.3636 7.22243L12.0708 6.51532C13.6328 4.95323 16.1655 4.95323 17.7276 6.51532ZM9.24264 13.5859C8.85211 13.9764 8.85211 14.6096 9.24264 15.0001C9.63316 15.3906 10.2663 15.3906 10.6568 15.0001L14.8995 10.7574C15.29 10.3669 15.29 9.73374 14.8995 9.34322C14.509 8.95269 13.8758 8.95269 13.4853 9.34322L9.24264 13.5859ZM6.41425 12.1716C4.85215 13.7337 4.85215 16.2663 6.41425 17.8284C7.97635 19.3905 10.509 19.3905 12.0711 17.8284L12.7782 17.1213C13.1687 16.7308 13.1687 16.0976 12.7782 15.7071C12.3877 15.3166 11.7545 15.3166 11.364 15.7071L10.6569 16.4142C9.87584 17.1953 8.60951 17.1953 7.82846 16.4142C7.04741 15.6332 7.04741 14.3668 7.82846 13.5858L8.53557 12.8787C8.92609 12.4882 8.92609 11.855 8.53557 11.4645C8.14504 11.0739 7.51188 11.0739 7.12135 11.4645L6.41425 12.1716Z",
    fill: "currentColor"
  }
) }), LinkCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM11.5738 8.31564C12.6477 7.24169 12.6477 5.50049 11.5738 4.42655C10.4998 3.35261 8.75862 3.35261 7.68468 4.42655L7.33112 4.7801C7.03823 5.073 7.03823 5.54787 7.33112 5.84076C7.62402 6.13366 8.09889 6.13366 8.39178 5.84076L8.74534 5.48721C9.23349 4.99905 10.0249 4.99905 10.5131 5.48721C11.0013 5.97537 11.0013 6.76682 10.5131 7.25498L10.1596 7.60853C9.86666 7.90142 9.86666 8.3763 10.1596 8.66919C10.4524 8.96208 10.9273 8.96208 11.2202 8.66919L11.5738 8.31564ZM9.53835 7.51949C9.83089 7.22624 9.83032 6.75137 9.53707 6.45883C9.24382 6.16629 8.76895 6.16686 8.47641 6.46011L6.46084 8.48057C6.1683 8.77381 6.16888 9.24869 6.46212 9.54122C6.75537 9.83376 7.23024 9.83319 7.52278 9.53994L9.53835 7.51949ZM4.4263 11.575C5.50025 12.6489 7.24145 12.6489 8.31539 11.575L8.66894 11.2214C8.96184 10.9285 8.96184 10.4537 8.66894 10.1608C8.37605 9.86788 7.90118 9.86788 7.60828 10.1608L7.25473 10.5143C6.76658 11.0025 5.97512 11.0025 5.48696 10.5143C4.99881 10.0262 4.99881 9.23472 5.48696 8.74656L5.84052 8.39301C6.13341 8.10011 6.13341 7.62524 5.84052 7.33235C5.54762 7.03945 5.07275 7.03945 4.77986 7.33235L4.4263 7.6859C3.35236 8.75984 3.35236 10.501 4.4263 11.575Z",
    fill: "currentColor"
  }
) }), LinkOpenLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.5 4C4.22386 4 4 4.22386 4 4.5V19.5C4 19.7761 4.22386 20 4.5 20H19.5C19.7761 20 20 19.7761 20 19.5V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V19.5C22 20.8807 20.8807 22 19.5 22H4.5C3.11929 22 2 20.8807 2 19.5V4.5C2 3.11929 3.11929 2 4.5 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.9299 9.06003C19.3831 8.98192 19.0032 8.47539 19.0813 7.92866L19.3643 5.94824L15.8282 9.4843C15.4377 9.87482 14.8045 9.87482 14.414 9.4843C14.0235 9.09378 14.0235 8.46061 14.414 8.07009L17.9495 4.53462L15.9701 4.81739C15.4233 4.89549 14.9168 4.51559 14.8387 3.96886C14.7606 3.42212 15.1405 2.91559 15.6872 2.83749L20.6219 2.13254C20.6564 2.12712 20.6911 2.1235 20.7259 2.1217C20.9138 2.11182 21.0994 2.15523 21.2619 2.245C21.3431 2.28981 21.4184 2.34617 21.4855 2.41322C21.7081 2.63579 21.8129 2.95016 21.7683 3.26175L21.0612 8.2115C20.9831 8.75823 20.4766 9.13813 19.9299 9.06003Z",
      fill: "currentColor"
    }
  )
] }), LinkOpenSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.6366 4.33142C14.5777 4.74142 14.198 5.02597 13.7885 4.96699C13.3791 4.90801 13.0949 4.52783 13.1538 4.11783L13.1884 3.87689L11.2498 5.81804C10.9573 6.11093 10.483 6.11093 10.1905 5.81804C9.89803 5.52514 9.89803 5.05027 10.1905 4.75738L12.137 2.80837L11.881 2.8448C11.4715 2.90308 11.0923 2.61789 11.0341 2.2078C10.9758 1.79771 11.2607 1.41801 11.6702 1.35972L14.1453 1.00747C14.3788 0.974246 14.6142 1.05303 14.7808 1.22013C14.899 1.3387 14.9728 1.49192 14.9936 1.65442C15.0039 1.7327 15.0018 1.81229 14.9873 1.89003L14.6366 4.33142Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.74771 2.50071C2.60982 2.50071 2.49804 2.61264 2.49804 2.75071V13.2507C2.49804 13.3888 2.60982 13.5007 2.74771 13.5007H13.234C13.3719 13.5007 13.4836 13.3888 13.4836 13.2507V8.08509C13.4836 7.67088 13.819 7.33509 14.2327 7.33509C14.6463 7.33509 14.9817 7.67088 14.9817 8.08509V13.2507C14.9817 14.2172 14.1992 15.0007 13.234 15.0007H2.74771C1.78248 15.0007 1 14.2172 1 13.2507V2.75071C1 1.78421 1.78248 1.00071 2.74771 1.00071H7.95539C8.36906 1.00071 8.7044 1.3365 8.7044 1.75071C8.7044 2.16493 8.36906 2.50071 7.95539 2.50071H2.74771Z",
      fill: "currentColor"
    }
  )
] }), LockLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5 9.9999C5.22386 9.9999 5 10.2238 5 10.4999V20.5C5 20.7761 5.22386 21 5.5 21H18.5C18.7761 21 19 20.7761 19 20.5V10.4999C19 10.2238 18.7761 9.9999 18.5 9.9999H5.5ZM3 10.4999C3 9.11919 4.11929 7.9999 5.5 7.9999H18.5C19.8807 7.9999 21 9.11919 21 10.4999V20.5C21 21.8807 19.8807 23 18.5 23H5.5C4.11929 23 3 21.8807 3 20.5V10.4999Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V10H15V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V10H7V6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 18V14H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18Z",
      fill: "currentColor"
    }
  )
] }), LockSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 6.5C3.61193 6.5 3.5 6.61193 3.5 6.75V14.25C3.5 14.3881 3.61193 14.5 3.75 14.5H12.25C12.3881 14.5 12.5 14.3881 12.5 14.25V6.75C12.5 6.61193 12.3881 6.5 12.25 6.5H3.75ZM2 6.75C2 5.7835 2.7835 5 3.75 5H12.25C13.2165 5 14 5.7835 14 6.75V14.25C14 15.2165 13.2165 16 12.25 16H3.75C2.7835 16 2 15.2165 2 14.25V6.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75 3.25C4.75 1.45507 6.20507 0 8 0C9.79493 0 11.25 1.45507 11.25 3.25V5.25H9.75V3.25C9.75 2.2835 8.9665 1.5 8 1.5C7.0335 1.5 6.25 2.2835 6.25 3.25V5.25H4.75V3.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00016 9.5C8.04619 9.5 8.0835 9.46269 8.0835 9.41667C8.0835 9.37064 8.04619 9.33333 8.00016 9.33333C7.95414 9.33333 7.91683 9.37064 7.91683 9.41667C7.91683 9.46269 7.95414 9.5 8.00016 9.5ZM6.5835 9.41667C6.5835 8.63426 7.21776 8 8.00016 8C8.78257 8 9.41683 8.63426 9.41683 9.41667C9.41683 10.1991 8.78257 10.8333 8.00016 10.8333C7.21776 10.8333 6.5835 10.1991 6.5835 9.41667Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.24984 12.0807V9.08073H8.74984V12.0807C8.74984 12.4949 8.41405 12.8307 7.99984 12.8307C7.58562 12.8307 7.24984 12.4949 7.24984 12.0807Z",
      fill: "currentColor"
    }
  )
] }), MailInboxLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.0009 3.50151C20.4509 3.50151 20.0009 3.9515 20.0009 4.5015V19.4715C20.0009 20.0415 19.5509 20.5015 19.0009 20.5015H8.0009C7.4509 20.5015 7.0009 20.9515 7.0009 21.5015C7.0009 22.0515 7.4509 22.5015 8.0009 22.5015H19.0009C20.6509 22.5015 22.0009 21.1415 22.0009 19.4715V4.5015C22.0009 3.9515 21.5509 3.50151 21.0009 3.50151Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.0009 16.5015V2.50151C18.0009 1.40151 17.1009 0.501505 16.0009 0.501505H10.6209C9.7709 0.161505 8.8609 -0.018495 7.9009 0.00150504C4.1509 0.051505 1.0509 3.1515 1.0009 6.9015C0.970901 8.7915 1.6909 10.5715 3.0209 11.9115C3.3309 12.2215 3.6609 12.4915 4.0009 12.7415V16.5015C4.0009 17.6015 4.9009 18.5015 6.0009 18.5015H16.0009C17.1009 18.5015 18.0009 17.6015 18.0009 16.5015ZM6.0009 13.7115C6.6409 13.9015 7.3109 14.0015 8.0009 14.0015C8.5509 14.0015 9.0009 13.5515 9.0009 13.0015C9.0009 12.4515 8.5509 12.0015 8.0009 12.0015C6.6509 12.0015 5.3909 11.4715 4.4409 10.5115C3.4909 9.55151 2.9809 8.2815 3.0009 6.9315C3.0409 4.3015 5.2909 2.04151 7.9309 2.00151C9.2809 1.96151 10.5509 2.49151 11.5109 3.44151C12.4709 4.39151 13.0009 5.6515 13.0009 7.0015C13.0009 7.72151 12.8509 8.4215 12.5509 9.0715C12.3609 9.4715 12.0009 9.4415 11.8509 9.4115C11.7309 9.38151 11.3209 9.2515 11.3209 8.76151V5.0015C11.3209 4.4515 10.8709 4.0015 10.3209 4.0015C10.0709 4.0015 9.8609 4.1015 9.6809 4.2515C9.1909 3.9515 8.6209 3.77151 8.0109 3.77151C6.2309 3.77151 4.7809 5.22151 4.7809 7.0015C4.7809 8.7815 6.2309 10.2315 8.0109 10.2315C8.5709 10.2315 9.0809 10.0815 9.5409 9.8315C9.8709 10.5915 10.5409 11.1715 11.4209 11.3615C12.6609 11.6315 13.8409 11.0515 14.3709 9.9115C14.7909 8.9915 15.0109 8.01151 15.0109 7.0015C15.0109 5.3315 14.4309 3.76151 13.3709 2.50151H16.0109V16.5015H6.0009V13.7115ZM9.2309 7.0015C9.2309 7.6815 8.6809 8.2315 8.0009 8.2315C7.3209 8.2315 6.7709 7.6815 6.7709 7.0015C6.7709 6.32151 7.3209 5.7715 8.0009 5.7715C8.6809 5.7715 9.2309 6.32151 9.2309 7.0015Z",
      fill: "currentColor"
    }
  )
] }), MailInboxSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.5 2.86006C14.09 2.86006 13.75 3.20006 13.75 3.61006V13.2201C13.75 13.4801 13.5 13.6901 13.19 13.6901H5.33998C4.92998 13.6901 4.58998 14.0301 4.58998 14.4401C4.58998 14.8501 4.92998 15.1901 5.33998 15.1901H13.19C14.32 15.1901 15.25 14.3101 15.25 13.2201V3.61006C15.25 3.20006 14.91 2.86006 14.5 2.86006Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 12.5501C11.83 12.5501 12.5 11.8801 12.5 11.0501V3.23006C12.5 2.40006 11.83 1.73006 11 1.73006H8.31998C7.47998 1.09006 6.44998 0.730059 5.40998 0.750059C2.87998 0.790059 0.789979 2.88006 0.749979 5.41006C0.729979 6.69006 1.21998 7.89006 2.10998 8.80006C2.52998 9.22006 3.00998 9.55006 3.53998 9.78006V11.0501C3.53998 11.8801 4.20998 12.5501 5.03998 12.5501H11ZM5.47998 10.1901C5.88998 10.1901 6.22998 9.87006 6.22998 9.46006C6.22998 9.05006 5.88998 8.71006 5.47998 8.71006C4.60998 8.71006 3.78998 8.37006 3.17998 7.75006C2.56998 7.13006 2.23998 6.31006 2.24998 5.44006C2.26998 3.74006 3.72998 2.28006 5.42998 2.26006C6.31998 2.21006 7.11998 2.58006 7.73998 3.19006C8.35998 3.80006 8.69998 4.62006 8.69998 5.49006C8.69998 5.96006 8.59998 6.41006 8.40998 6.83006C8.31998 7.02006 8.15998 7.03006 8.03998 7.01006C7.94998 6.99006 7.74998 6.92006 7.74998 6.67006V4.18006C7.74998 3.77006 7.40998 3.43006 6.99998 3.43006C6.79998 3.43006 6.62998 3.51006 6.48998 3.63006C6.17998 3.46006 5.83998 3.36006 5.46998 3.36006C4.28998 3.36006 3.32998 4.32006 3.32998 5.50006C3.32998 6.68006 4.28998 7.64006 5.46998 7.64006C5.80998 7.64006 6.12998 7.55006 6.41998 7.41006C6.64998 7.94006 7.09998 8.34006 7.70998 8.47006C8.56998 8.66006 9.39998 8.25006 9.75998 7.46006C10.05 6.84006 10.19 6.18006 10.19 5.50006C10.19 4.70006 9.96998 3.93006 9.59998 3.25006H10.99V11.0801H5.02998V10.1901C5.20312 10.1901 5.32998 10.1901 5.47998 10.1901ZM6.11998 5.48006C6.11998 5.83006 5.82998 6.12006 5.47998 6.12006C5.12998 6.12006 4.83998 5.83006 4.83998 5.48006C4.83998 5.13006 5.12998 4.84006 5.47998 4.84006C5.82998 4.84006 6.11998 5.13006 6.11998 5.48006Z",
      fill: "currentColor"
    }
  )
] }), MenuLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z",
      fill: "currentColor"
    }
  )
] }), MenuSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.78261 7.18182C2.35039 7.18182 2 7.54813 2 8C2 8.45187 2.35039 8.81818 2.78261 8.81818H13.2174C13.6496 8.81818 14 8.45187 14 8C14 7.54813 13.6496 7.18182 13.2174 7.18182H2.78261Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.78261 11.3636C2.35039 11.3636 2 11.7299 2 12.1818C2 12.6337 2.35039 13 2.78261 13H13.2174C13.6496 13 14 12.6337 14 12.1818C14 11.7299 13.6496 11.3636 13.2174 11.3636H2.78261Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.78261 3C2.35039 3 2 3.36631 2 3.81818C2 4.27005 2.35039 4.63636 2.78261 4.63636H13.2174C13.6496 4.63636 14 4.27005 14 3.81818C14 3.36631 13.6496 3 13.2174 3H2.78261Z",
      fill: "currentColor"
    }
  )
] }), MobileLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.5 18C10.9477 18 10.5 18.4477 10.5 19C10.5 19.5523 10.9477 20 11.5 20H12.5C13.0523 20 13.5 19.5523 13.5 19C13.5 18.4477 13.0523 18 12.5 18H11.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 1C6.11929 1 5 2.11929 5 3.5V20.5C5 21.8807 6.11929 23 7.5 23H16.5C17.8807 23 19 21.8807 19 20.5V3.5C19 2.11929 17.8807 1 16.5 1H7.5ZM7 3.5C7 3.22386 7.22386 3 7.5 3H16.5C16.7761 3 17 3.22386 17 3.5V20.5C17 20.7761 16.7761 21 16.5 21H7.5C7.22386 21 7 20.7761 7 20.5V3.5Z",
      fill: "currentColor"
    }
  )
] }), MobileSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.45455 12.2578C7.00268 12.2578 6.63636 12.5936 6.63636 13.0078C6.63636 13.422 7.00268 13.7578 7.45455 13.7578H8.54545C8.99732 13.7578 9.36364 13.422 9.36364 13.0078C9.36364 12.5936 8.99732 12.2578 8.54545 12.2578H7.45455Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.90909 0C2.85473 0 2 0.783501 2 1.75V14.25C2 15.2165 2.85473 16 3.90909 16H12.0909C13.1453 16 14 15.2165 14 14.25V1.75C14 0.783502 13.1453 0 12.0909 0H3.90909ZM3.63636 1.75C3.63636 1.61193 3.75847 1.5 3.90909 1.5H12.0909C12.2415 1.5 12.3636 1.61193 12.3636 1.75V14.25C12.3636 14.3881 12.2415 14.5 12.0909 14.5H3.90909C3.75847 14.5 3.63636 14.3881 3.63636 14.25V1.75Z",
      fill: "currentColor"
    }
  )
] }), MoneyPaymentLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5ZM11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11.5C22 12.7095 21.1411 13.7183 20.0001 13.95L20 17.0486C19.9998 18.8017 19.2905 20.4794 18.034 21.7134C17.64 22.1004 17.0069 22.0947 16.6199 21.7007C16.2329 21.3067 16.2386 20.6735 16.6326 20.2865C17.5101 19.4247 17.9998 18.2596 18 17.0486V13.6266C17.9972 13.466 17.9307 13.309 17.8087 13.1905C17.6852 13.0704 17.5147 13 17.3334 13L17.3281 13C17.2387 12.9995 17.1504 13.0165 17.0686 13.0495C16.9868 13.0826 16.9137 13.1307 16.853 13.1904C16.7923 13.25 16.7453 13.3198 16.7136 13.3954C16.682 13.4709 16.6662 13.5512 16.6667 13.6318L16.6667 13.6371L16.6667 16.0886C16.6667 16.4699 16.4498 16.818 16.1075 16.9861L15.9342 17.0713C15.6504 17.2112 15.4139 17.4248 15.25 17.6856C15.086 17.9465 15.0001 18.2453 15 18.5488C14.9998 19.1011 14.552 19.5487 13.9997 19.5486C13.4474 19.5484 12.9998 19.1005 13 18.5483C13.0002 17.8664 13.1935 17.1992 13.5566 16.6214C13.8411 16.1687 14.2207 15.7854 14.6667 15.4954V14H10V16.6448C10.0002 17.4963 10.4867 18.4256 11.5707 19.1788C12.0242 19.494 12.1364 20.1171 11.8212 20.5707C11.506 21.0242 10.8829 21.1364 10.4293 20.8212C8.95253 19.7949 8.00025 18.3103 8 16.6451V14H4.5C3.11929 14 2 12.8807 2 11.5V4.5C2 3.11929 3.11929 2 4.5 2H19.5C20.8807 2 22 3.11929 22 4.5V11.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H19.5C19.7761 4 20 4.22386 20 4.5V11.5C20 11.7761 19.7761 12 19.5 12H19.424C19.3557 11.9147 19.2819 11.8333 19.2027 11.7564C18.7028 11.2704 18.0317 11.0006 17.3359 11L16.0044 12.3167C15.8219 12.1218 15.5623 12 15.2743 12H4.5C4.22386 12 4 11.7761 4 11.5V4.5Z",
      fill: "currentColor"
    }
  )
] }), MoneyPaymentSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.99994 3.76172C7.05646 3.76172 6.51294 4.62731 6.51294 5.39612C6.51294 6.16493 7.05646 7.03052 7.99994 7.03052C8.94342 7.03052 9.48694 6.16493 9.48694 5.39612C9.48694 4.62731 8.94342 3.76172 7.99994 3.76172Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.65352 9.79168H6.66675V11.0327C6.66687 11.7106 7.01252 12.4127 7.72296 12.9646C8.05008 13.2187 8.10928 13.6898 7.85519 14.017C7.60109 14.3441 7.12992 14.4033 6.8028 14.1492C5.78969 13.3622 5.16691 12.2484 5.16675 11.0329V9.79168H2.75C1.7835 9.79168 1 9.00817 1 8.04168V2.75C1 1.7835 1.7835 1 2.75 1H13.25C14.2165 1 15 1.7835 15 2.75V8.04168C15 8.95863 14.2948 9.71087 13.3971 9.78558L13.3971 11.506C13.3969 12.7309 12.9168 13.9077 12.0591 14.7768C11.7682 15.0716 11.2933 15.0748 10.9985 14.7838C10.7037 14.4929 10.7005 14.018 10.9915 13.7232C11.5701 13.1369 11.897 12.3395 11.8971 11.506V9.12987L11.8969 9.12414C11.8955 9.11078 11.8944 9.09731 11.8936 9.08375C11.8821 8.99739 11.8429 8.91811 11.7833 8.85835C11.7129 8.78777 11.62 8.75 11.5253 8.75001L11.5213 8.75C11.4743 8.74975 11.4275 8.75892 11.3836 8.77725C11.3395 8.79559 11.2989 8.82286 11.2642 8.85801C11.2295 8.89317 11.2015 8.93551 11.1823 8.98283C11.1631 9.03018 11.1532 9.08125 11.1535 9.13301L11.1535 9.13691L11.1535 10.8393C11.1535 11.1219 10.9946 11.3805 10.7425 11.5083L10.6259 11.5674C10.4492 11.6572 10.2992 11.7959 10.1937 11.969C10.0882 12.1423 10.0318 12.3427 10.0317 12.5478C10.0316 12.962 9.69574 13.2977 9.28152 13.2976C8.86731 13.2975 8.53162 12.9616 8.53174 12.5474C8.53188 12.0682 8.66345 11.5978 8.91264 11.1887C9.10252 10.877 9.35521 10.6099 9.65352 10.4044V9.79168ZM2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H13.25C13.3881 2.5 13.5 2.61193 13.5 2.75V8.04168C13.5 8.17975 13.3881 8.29168 13.25 8.29168H13.1988C13.1092 8.11119 12.9904 7.94457 12.8455 7.79921C12.4962 7.44898 12.0228 7.25052 11.5273 7.25001L10.4685 8.31719C10.4064 8.30055 10.3411 8.29168 10.2738 8.29168H2.75C2.61193 8.29168 2.5 8.17975 2.5 8.04168V2.75Z",
      fill: "currentColor"
    }
  )
] }), MoneyReceiveLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 2C5.34315 2 4 3.34315 4 5C4 6.65686 5.34315 8 7 8C8.65685 8 10 6.65686 10 5C10 3.34315 8.65685 2 7 2ZM6 5C6 4.44772 6.44772 4 7 4C7.55228 4 8 4.44772 8 5C8 5.55228 7.55229 6 7 6C6.44771 6 6 5.55228 6 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 6C12.3431 6 11 7.34315 11 9C11 10.6569 12.3431 12 14 12C15.6569 12 17 10.6569 17 9C17 7.34315 15.6569 6 14 6ZM13 9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9C15 9.55229 14.5523 10 14 10C13.4477 10 13 9.55229 13 9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.49263 13.5344L8.95833 13.7936H11.4779C12.0888 13.7826 12.6668 14.0118 13.1149 14.4126C13.5634 14.8139 13.8542 15.3603 13.963 15.9454C13.9651 15.9566 13.967 15.9677 13.9687 15.9789C13.9875 16.1037 13.9978 16.2296 13.9997 16.3555L17.5133 13.6575C18.0182 13.2247 18.6718 12.999 19.3316 13C20.004 13.001 20.6693 13.2376 21.1765 13.6886C21.6877 14.143 22.0014 14.7865 22 15.4866C21.9994 15.8142 21.9301 16.1666 21.8099 16.4868C21.6922 16.8003 21.4941 17.1663 21.1742 17.4487C21.1659 17.4561 21.1574 17.4633 21.1489 17.4703L17.1917 20.7363C16.7311 21.1418 16.1917 21.4584 15.6064 21.6732C15.0153 21.8901 14.3851 22.0004 13.7511 22H6C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20H13.7511C14.1537 20.0003 14.5508 19.9301 14.9174 19.7956C15.2839 19.6611 15.6096 19.4664 15.8784 19.2279C15.8874 19.2199 15.8964 19.2121 15.9057 19.2045L19.8515 15.9479C19.8595 15.938 19.8978 15.8896 19.9376 15.7837C19.9824 15.6643 19.9999 15.5482 20 15.4827C20.0002 15.3966 19.9629 15.2857 19.8477 15.1833C19.7285 15.0774 19.5434 15.0003 19.3285 15C19.1135 14.9997 18.9279 15.0761 18.8081 15.1819C18.791 15.197 18.7734 15.2115 18.7553 15.2254L14.109 18.7931C13.9343 18.9273 13.7203 19 13.5 19H12L11.9941 19L8.00513 19C7.45285 19 7.00513 18.5523 7.00513 18C7.00513 17.4477 7.45285 17 8.00513 17H11.6488C11.6712 16.9867 11.6926 16.9749 11.7127 16.9644C11.7618 16.9386 11.8155 16.8957 11.8643 16.8306C11.9133 16.7652 11.9541 16.6813 11.978 16.583C12.0005 16.4899 12.0059 16.3911 11.9934 16.2942C11.9576 16.1208 11.8746 15.9867 11.7813 15.9032C11.6879 15.8196 11.592 15.7914 11.512 15.7933L11.4882 15.7936H8.69876C8.52853 15.7936 8.36112 15.7502 8.21239 15.6674L7.51764 15.2806C7.10268 15.049 6.64789 14.9608 6.20329 15.0159C5.75785 15.071 5.32121 15.2703 4.94876 15.609L4.94607 15.6114C4.65705 15.8724 4.41596 16.212 4.24893 16.6099C4.08886 16.9913 3.99516 17.5211 4.00019 17.9892C4.00613 18.5415 3.56325 18.994 3.011 18.9999C2.45874 19.0059 2.00624 18.563 2.00031 18.0107C1.99282 17.3145 2.12293 16.5074 2.4048 15.8358C2.67948 15.1814 3.08705 14.5956 3.60448 14.1281C4.26623 13.5268 5.08162 13.1395 5.95758 13.031C6.83479 12.9224 7.7163 13.1011 8.49263 13.5344Z",
      fill: "currentColor"
    }
  )
] }), MoneyReceiveSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 1C3.3402 1 2.4 1.9402 2.4 3.1C2.4 4.2598 3.3402 5.2 4.5 5.2C5.6598 5.2 6.6 4.2598 6.6 3.1C6.6 1.9402 5.6598 1 4.5 1ZM3.8 3.1C3.8 2.7134 4.1134 2.4 4.5 2.4C4.8866 2.4 5.2 2.7134 5.2 3.1C5.2 3.4866 4.8866 3.8 4.5 3.8C4.1134 3.8 3.8 3.4866 3.8 3.1Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.4 3.8C8.2402 3.8 7.3 4.7402 7.3 5.9C7.3 7.0598 8.2402 8 9.4 8C10.5598 8 11.5 7.0598 11.5 5.9C11.5 4.7402 10.5598 3.8 9.4 3.8ZM8.7 5.9C8.7 5.5134 9.0134 5.2 9.4 5.2C9.7866 5.2 10.1 5.5134 10.1 5.9C10.1 6.2866 9.7866 6.6 9.4 6.6C9.0134 6.6 8.7 6.2866 8.7 5.9Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.54484 9.07407L5.87083 9.25553H7.63454C8.06213 9.24782 8.46674 9.40823 8.7804 9.68885C9.09435 9.96974 9.29797 10.3522 9.37411 10.7618C9.37556 10.7696 9.37687 10.7774 9.37806 10.7852C9.39125 10.8726 9.39849 10.9607 9.39979 11.0488L11.8593 9.16022C12.2128 8.85731 12.6703 8.69929 13.1321 8.7C13.6028 8.70073 14.0685 8.86634 14.4236 9.18199C14.7814 9.5001 15.001 9.95058 15 10.4406C14.9995 10.6699 14.9511 10.9166 14.8669 11.1407C14.7845 11.3602 14.6458 11.6164 14.4219 11.8141C14.4161 11.8193 14.4102 11.8243 14.4042 11.8292L11.6342 14.1154C11.3118 14.3993 10.9342 14.6209 10.5245 14.7712C10.1107 14.9231 9.66958 15.0003 9.22577 15H3.8C3.4134 15 3.1 14.6866 3.1 14.3C3.1 13.9134 3.4134 13.6 3.8 13.6H9.22577C9.50756 13.6002 9.78558 13.5511 10.0422 13.4569C10.2987 13.3628 10.5267 13.2265 10.7149 13.0595C10.7212 13.0539 10.7275 13.0485 10.734 13.0432L13.4961 10.7635C13.5016 10.7566 13.5285 10.7227 13.5563 10.6486C13.5877 10.565 13.5999 10.4837 13.6 10.4379C13.6001 10.3776 13.574 10.3 13.4934 10.2283C13.41 10.1541 13.2804 10.1002 13.1299 10.1C12.9795 10.0998 12.8495 10.1533 12.7657 10.2273C12.7537 10.2379 12.7414 10.2481 12.7287 10.2578L9.47632 12.7552C9.35404 12.8491 9.20418 12.9 9.05 12.9H8L7.99586 12.9L5.20359 12.9C4.81699 12.9 4.50359 12.5866 4.50359 12.2C4.50359 11.8134 4.81699 11.5 5.20359 11.5H7.75416C7.76981 11.4907 7.7848 11.4824 7.79888 11.4751C7.83328 11.457 7.87082 11.427 7.90498 11.3814C7.93928 11.3356 7.9679 11.2769 7.98458 11.2081C8.00035 11.143 8.00416 11.0738 7.99539 11.0059C7.97035 10.8846 7.91223 10.7907 7.84691 10.7322C7.78152 10.6737 7.71442 10.654 7.65842 10.6553L7.64173 10.6555H5.68913C5.56997 10.6555 5.45279 10.6251 5.34867 10.5672L4.86234 10.2964C4.57188 10.1343 4.25352 10.0726 3.94231 10.1111C3.6305 10.1497 3.32485 10.2892 3.06413 10.5263L3.06225 10.528C2.85993 10.7106 2.69117 10.9484 2.57425 11.2269C2.4622 11.4939 2.39661 11.8648 2.40013 12.1925C2.40429 12.579 2.09427 12.8958 1.7077 12.8999C1.32112 12.9041 1.00437 12.5941 1.00021 12.2075C0.994975 11.7202 1.08605 11.1552 1.28336 10.6851C1.47564 10.227 1.76093 9.81695 2.12314 9.48969C2.58636 9.06875 3.15713 8.79762 3.77031 8.72171C4.38435 8.64569 5.00141 8.77076 5.54484 9.07407Z",
      fill: "currentColor"
    }
  )
] }), MonitorLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2274 4.2387C3.38334 4.09228 3.60757 3.99994 3.85357 3.99994H20.1464C20.3924 3.99994 20.6167 4.09228 20.7726 4.2387C20.9264 4.38312 21 4.56503 21 4.74033V13.2595C21 13.4349 20.9264 13.6168 20.7726 13.7612C20.37 14.1392 20.35 14.7721 20.7281 15.1747C21.1061 15.5773 21.739 15.5972 22.1416 15.2192C22.683 14.7108 23 14.0074 23 13.2595V4.74033C23 3.99247 22.683 3.28903 22.1416 2.78068C21.6023 2.27432 20.8836 1.99994 20.1464 1.99994H3.85357C3.11637 1.99994 2.39768 2.27432 1.8584 2.78068C1.31698 3.28903 1 3.99248 1 4.74033V13.2595C1 14.0074 1.31698 14.7108 1.8584 15.2192C2.39768 15.7256 3.11637 15.9999 3.85357 15.9999H7.5C8.05228 15.9999 8.5 15.5522 8.5 14.9999C8.5 14.4477 8.05228 13.9999 7.5 13.9999H3.85357C3.60757 13.9999 3.38334 13.9076 3.2274 13.7612C3.07359 13.6168 3 13.4349 3 13.2595V4.74033C3 4.56502 3.07359 4.38312 3.2274 4.2387ZM6 5.99994C5.44772 5.99994 5 6.44765 5 6.99994C5 7.55222 5.44772 7.99994 6 7.99994H13.9999C14.5522 7.99994 15 7.55222 15 6.99994C15 6.44765 14.5516 5.99994 13.9993 5.99994H6ZM14.1686 12.5016C12.5415 12.7119 11.3882 14.2063 11.5987 15.8441C11.8093 17.4819 13.3029 18.6341 14.93 18.4238C16.5572 18.2134 17.7105 16.7191 17.4999 15.0813C17.2894 13.4435 15.7958 12.2913 14.1686 12.5016ZM9.61524 16.1005C9.26444 13.372 11.1861 10.8705 13.9136 10.5179C16.641 10.1654 19.1326 12.0964 19.4834 14.8249C19.8342 17.5534 17.9125 20.0549 15.1851 20.4074C13.8174 20.5842 12.5089 20.1868 11.5001 19.4025L8.99872 21.7317C8.59441 22.1082 7.96172 22.0858 7.58555 21.6817C7.20938 21.2776 7.2322 20.6448 7.63651 20.2683L10.1981 17.8828C9.9009 17.3464 9.69821 16.7457 9.61524 16.1005Z",
    fill: "currentColor"
  }
) }), MonitorSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51868 2.56712C2.625 2.46463 2.77789 2.39999 2.94561 2.39999H14.0544C14.2221 2.39999 14.375 2.46463 14.4813 2.56712C14.5862 2.66821 14.6364 2.79555 14.6364 2.91826V8.88167C14.6364 9.00438 14.5862 9.13171 14.4813 9.23281C14.2068 9.49743 14.1932 9.94042 14.451 10.2223C14.7087 10.5041 15.1402 10.518 15.4147 10.2534C15.7839 9.89757 16 9.40516 16 8.88167V2.91826C16 2.39476 15.7839 1.90236 15.4147 1.54651C15.047 1.19207 14.557 1 14.0544 1H2.94561C2.44298 1 1.95296 1.19207 1.58527 1.54651C1.21612 1.90236 1 2.39477 1 2.91826V8.88167C1 9.40516 1.21612 9.89757 1.58527 10.2534C1.95296 10.6079 2.44298 10.7999 2.94561 10.7999H5.43182C5.80838 10.7999 6.11364 10.4865 6.11364 10.0999C6.11364 9.71334 5.80838 9.39994 5.43182 9.39994H2.94561C2.77789 9.39994 2.625 9.3353 2.51868 9.23281C2.41381 9.13172 2.36364 9.00438 2.36364 8.88167V2.91826C2.36364 2.79555 2.41381 2.66821 2.51868 2.56712ZM9.97861 8.3511C8.86919 8.49833 8.08284 9.54438 8.22641 10.6908C8.36999 11.8373 9.38834 12.6438 10.4978 12.4966C11.6072 12.3494 12.3935 11.3033 12.25 10.1569C12.1064 9.01042 11.088 8.20387 9.97861 8.3511ZM6.87403 10.8703C6.63485 8.96036 7.9451 7.20932 9.80472 6.96254C11.6643 6.71575 13.3632 8.06747 13.6023 9.9774C13.8415 11.8873 12.5313 13.6384 10.6717 13.8852C9.73911 14.0089 8.84701 13.7307 8.15913 13.1817L6.45367 14.8122C6.17801 15.0757 5.74662 15.06 5.49015 14.7771C5.23367 14.4942 5.24923 14.0513 5.52489 13.7877L7.27146 12.1179C7.0688 11.7425 6.9306 11.322 6.87403 10.8703Z",
    fill: "currentColor"
  }
) }), More = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
      fill: "currentColor"
    }
  )
] }), MoreVertical = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 20C10 18.8954 10.8954 18 12 18C13.1046 18 14 18.8954 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z",
      fill: "currentColor"
    }
  )
] }), MoreVerticalAlignedLeft = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6C5.10457 6 6 5.10457 6 4ZM6 20C6 18.8954 5.10457 18 4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20ZM4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z",
    fill: "currentColor"
  }
) }), MultiCompanyLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27637 2C8.72408 2 8.27637 2.44772 8.27637 3V8.45714C8.27637 9.00943 8.72408 9.45714 9.27637 9.45714H11V11.9141H3.81885C3.26656 11.9141 2.81885 12.3618 2.81885 12.9141V16.3633H2C1.44772 16.3633 1 16.811 1 17.3633V21.0014C1 21.5537 1.44772 22.0014 2 22.0014H5.6381C6.19038 22.0014 6.6381 21.5537 6.6381 21.0014V17.3633C6.6381 16.811 6.19038 16.3633 5.6381 16.3633H4.81885V13.9141H11V16.3633H10.1812C9.62887 16.3633 9.18115 16.811 9.18115 17.3633V21.0014C9.18115 21.5537 9.62887 22.0014 10.1812 22.0014H13.8192C14.3715 22.0014 14.8192 21.5537 14.8192 21.0014V17.3633C14.8192 16.811 14.3715 16.3633 13.8192 16.3633H13V13.9141H19.1808V16.3633H18.3618C17.8095 16.3633 17.3618 16.811 17.3618 17.3633V21.0014C17.3618 21.5537 17.8095 22.0014 18.3618 22.0014H21.9999C22.5522 22.0014 22.9999 21.5537 22.9999 21.0014V17.3633C22.9999 16.811 22.5522 16.3633 21.9999 16.3633H21.1808V12.9141C21.1808 12.3618 20.733 11.9141 20.1808 11.9141H13V9.45714H14.7335C15.2858 9.45714 15.7335 9.00943 15.7335 8.45714V3C15.7335 2.44772 15.2858 2 14.7335 2H9.27637ZM11.1812 18.3633H12.8192V20.0014H11.1812V18.3633ZM10.2764 7.45714V4H13.7335V7.45714H10.2764ZM3 18.3633V20.0014H4.6381V18.3633H3ZM19.3618 20.0014V18.3633H20.9999V20.0014H19.3618Z",
    fill: "currentColor"
  }
) }), MultiCompanySmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27807 2C5.90394 2 5.60064 2.29848 5.60064 2.66668V5.90074C5.60064 6.26893 5.90394 6.56742 6.27807 6.56742H7.32266V7.87513H2.82742C2.45329 7.87513 2.15 8.17361 2.15 8.54181V10.5106H1.67743C1.30329 10.5106 1 10.8091 1 11.1773V13.3333C1 13.7015 1.30329 14 1.67743 14H3.97768C4.35182 14 4.65511 13.7015 4.65511 13.3333V11.1773C4.65511 10.8091 4.35182 10.5106 3.97768 10.5106H3.50485V9.20849H7.32266V10.5106H6.85009C6.47596 10.5106 6.17267 10.8091 6.17267 11.1773V13.3333C6.17267 13.7015 6.47596 14 6.85009 14H9.15035C9.52448 14 9.82778 13.7015 9.82778 13.3333V11.1773C9.82778 10.8091 9.52448 10.5106 9.15035 10.5106H8.67752V9.20849H12.4951V10.5106H12.0223C11.6482 10.5106 11.3449 10.8091 11.3449 11.1773V13.3333C11.3449 13.7015 11.6482 14 12.0223 14H14.3226C14.6967 14 15 13.7015 15 13.3333V11.1773C15 10.8091 14.6967 10.5106 14.3226 10.5106H13.85V8.54181C13.85 8.17361 13.5467 7.87513 13.1725 7.87513H8.67752V6.56742H9.72845C10.1026 6.56742 10.4059 6.26893 10.4059 5.90074V2.66668C10.4059 2.29848 10.1026 2 9.72845 2H6.27807ZM13.1517 11.844C13.1586 11.8442 13.1656 11.8443 13.1725 11.8443C13.1795 11.8443 13.1865 11.8442 13.1934 11.844H13.6451V12.6666H12.6997V11.844H13.1517ZM2.80656 11.844C2.81349 11.8442 2.82044 11.8443 2.82742 11.8443C2.8344 11.8443 2.84136 11.8442 2.84829 11.844H3.30025V12.6666H2.35486V11.844H2.80656ZM7.52752 11.844H7.95681C7.97112 11.8449 7.98555 11.8453 8.00009 11.8453C8.01463 11.8453 8.02906 11.8449 8.04337 11.844H8.47292V12.6666H7.52752V11.844ZM6.9555 5.23406V3.33336H9.05103V5.23406H6.9555Z",
    fill: "currentColor"
  }
) }), MultipuleApprovalLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00049 4C7.4482 4 7.00049 3.55228 7.00049 3C7.00049 2.44772 7.4482 2 8.00049 2H19.0005C20.6573 2 22.0005 3.34315 22.0005 5L22.0005 16C22.0005 16.5523 21.5528 17 21.0005 17C20.4482 17 20.0005 16.5523 20.0005 16L20.0005 5C20.0005 4.44772 19.5528 4 19.0005 4L8.00049 4ZM5.00049 7C4.4482 7 4.00049 6.55228 4.00049 6C4.00049 5.44772 4.4482 5 5.00049 5L17.5005 5C18.3289 5 19.0005 5.67158 19.0005 6.5L19.0005 19C19.0005 19.5523 18.5528 20 18.0005 20C17.4482 20 17.0005 19.5523 17.0005 19L17.0005 7L5.00049 7ZM3.00049 8C2.4482 8 2.00049 8.44772 2.00049 9V21C2.00049 21.5523 2.44821 22 3.00049 22L15.0005 22C15.5528 22 16.0005 21.5523 16.0005 21L16.0005 9C16.0005 8.44771 15.5528 8 15.0005 8L3.00049 8ZM4.00049 10L14.0005 10L14.0005 20L4.00049 20L4.00049 10ZM12.3005 13.6001C12.6319 13.1582 12.5423 12.5314 12.1005 12.2001C11.6587 11.8687 11.0319 11.9582 10.7005 12.4001L8.39229 15.4777L7.20759 14.293C6.81707 13.9024 6.18391 13.9024 5.79338 14.293C5.40286 14.6835 5.40286 15.3166 5.79338 15.7072L7.79338 17.7072C7.99837 17.9121 8.28222 18.0181 8.57138 17.9975C8.86054 17.977 9.12655 17.832 9.30049 17.6001L12.3005 13.6001Z",
    fill: "currentColor"
  }
) }), MultipuleApprovalSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.23078 2.50474C2.81587 2.50474 2.47952 2.16877 2.47953 1.75432C2.47953 1.33988 2.81588 1.00391 3.23079 1.00391L12.7467 1.00395C13.9914 1.00396 15.0005 2.01188 15.0005 3.25521V12.7605C15.0005 13.1749 14.6641 13.5109 14.2492 13.5109C13.8343 13.5109 13.498 13.1749 13.498 12.7605V3.25521C13.498 2.84076 13.1616 2.50479 12.7467 2.50479L3.23078 2.50474Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.09006 7.15429C9.41937 7.40641 9.48172 7.87745 9.22932 8.20639L6.92614 11.2081C6.7945 11.3796 6.59518 11.4862 6.37924 11.5004C6.1633 11.5146 5.95172 11.4351 5.79869 11.2822L4.35666 9.84197C4.06326 9.54893 4.06324 9.07379 4.35661 8.78072C4.64998 8.48764 5.12565 8.48762 5.41905 8.78066L6.25499 9.61558L8.03679 7.2934C8.28918 6.96446 8.76075 6.90218 9.09006 7.15429Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.75175 3.49749C1.33684 3.49749 1.00049 3.83346 1.00049 4.2479V14.2535C1.00049 14.6679 1.33684 15.0039 1.75175 15.0039L11.7685 15.0039C12.1834 15.0039 12.5198 14.6679 12.5198 14.2535L12.5198 4.2479C12.5198 3.83346 12.1834 3.49748 11.7685 3.49748L1.75175 3.49749ZM2.503 4.99832L11.0173 4.99832L11.0173 13.5031L2.50301 13.5031L2.503 4.99832Z",
      fill: "currentColor"
    }
  )
] }), MultiUseCardLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.999756 6.47689C0.999756 5.10894 2.11904 4 3.49976 4H20.4998C21.8805 4 22.9998 5.10894 22.9998 6.47689V10.9043C22.9998 11.4515 22.552 11.8951 21.9998 11.8951C21.4475 11.8951 20.9998 11.4515 20.9998 10.9043V9.94635H2.99976V17.3752C2.99976 17.6488 3.22361 17.8706 3.49976 17.8706H11.9998C12.552 17.8706 12.9998 18.3141 12.9998 18.8613C12.9998 19.4085 12.552 19.8521 11.9998 19.8521H3.49976C2.11904 19.8521 0.999756 18.7431 0.999756 17.3752V6.47689ZM2.99976 6.47689C2.99976 6.2033 3.22361 5.98151 3.49976 5.98151H20.4998C20.7759 5.98151 20.9998 6.2033 20.9998 6.47689V7.96484H2.99976V6.47689Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.99976 15.8892C3.99976 15.342 4.44747 14.8984 4.99976 14.8984L9.99976 14.8984C10.552 14.8984 10.9998 15.342 10.9998 15.8892C10.9998 16.4364 10.552 16.8799 9.99976 16.8799H4.99976C4.44747 16.8799 3.99976 16.4364 3.99976 15.8892Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17.7077 13.1304C17.3796 12.8753 17.2997 12.4061 17.5341 12.055C17.7795 11.6876 18.2763 11.5886 18.6437 11.834L21.0437 13.4368C21.2661 13.5854 21.3996 13.8353 21.3994 14.1027C21.3992 14.3702 21.2653 14.6199 21.0426 14.7681L18.6426 16.3653C18.2748 16.6101 17.7782 16.5103 17.5334 16.1425C17.3332 15.8417 17.3635 15.4547 17.5824 15.1898C17.3683 15.2523 17.1638 15.3474 16.9763 15.4727C16.6144 15.7147 16.3324 16.0587 16.1661 16.461C15.9997 16.8633 15.9565 17.306 16.0419 17.7329C16.1272 18.1598 16.3373 18.5518 16.6456 18.8592C16.9538 19.1667 17.3464 19.3758 17.7735 19.46C18.2006 19.5442 18.6432 19.4998 19.0451 19.3324C19.447 19.165 19.7902 18.8822 20.0312 18.5196C20.2722 18.1571 20.4003 17.7312 20.3992 17.2958C20.3977 16.7435 20.8443 16.2946 21.3965 16.2932C21.9488 16.2917 22.3977 16.7383 22.3992 17.2906C22.4013 18.1217 22.1569 18.9348 21.6967 19.627C21.2365 20.3191 20.5813 20.8591 19.8141 21.1787C19.0468 21.4983 18.202 21.583 17.3865 21.4222C16.5711 21.2614 15.8217 20.8622 15.2332 20.2753C14.6447 19.6884 14.2436 18.94 14.0807 18.125C13.9177 17.31 14.0003 16.4649 14.3178 15.6968C14.6354 14.9288 15.1737 14.2722 15.8646 13.8102C16.4185 13.4398 17.0506 13.2078 17.7077 13.1304Z",
      fill: "currentColor"
    }
  )
] }), MultiUseCardSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 3.69828C1 2.76035 1.71227 2 2.59091 2H13.4091C14.2877 2 15 2.76035 15 3.69828V6.73397C15 7.10914 14.7151 7.41328 14.3636 7.41328C14.0122 7.41328 13.7273 7.10914 13.7273 6.73397V6.07713H2.27273V11.1707C2.27273 11.3583 2.41518 11.5104 2.59091 11.5104H8C8.35145 11.5104 8.63636 11.8145 8.63636 12.1897C8.63636 12.5649 8.35145 12.869 8 12.869H2.59091C1.71227 12.869 1 12.1087 1 11.1707V3.69828ZM2.27273 3.69828C2.27273 3.5107 2.41518 3.35863 2.59091 3.35863H13.4091C13.5848 3.35863 13.7273 3.5107 13.7273 3.69828V4.71851H2.27273V3.69828Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.6323 8.26029C11.4235 8.08538 11.3727 7.76367 11.5219 7.52294C11.678 7.27101 11.9942 7.20318 12.228 7.37142L13.7552 8.47038C13.8968 8.57223 13.9817 8.74357 13.9816 8.92697C13.9815 9.11038 13.8963 9.28157 13.7546 9.38318L12.2273 10.4783C11.9932 10.6461 11.6772 10.5778 11.5214 10.3256C11.394 10.1193 11.4133 9.85395 11.5526 9.67232C11.4163 9.7152 11.2862 9.78038 11.1669 9.86631C10.9366 10.0322 10.7572 10.2681 10.6513 10.5439C10.5454 10.8198 10.5179 11.1233 10.5723 11.416C10.6266 11.7087 10.7603 11.9775 10.9564 12.1883C11.1526 12.3991 11.4024 12.5424 11.6742 12.6002C11.946 12.6579 12.2276 12.6275 12.4834 12.5127C12.7391 12.398 12.9575 12.204 13.1109 11.9554C13.2643 11.7068 13.3458 11.4148 13.3451 11.1163C13.3442 10.7376 13.6283 10.4299 13.9798 10.4289C14.3312 10.4279 14.6169 10.734 14.6178 11.1127C14.6192 11.6826 14.4636 12.2401 14.1708 12.7147C13.8779 13.1892 13.461 13.5595 12.9727 13.7786C12.4845 13.9977 11.9469 14.0558 11.428 13.9456C10.909 13.8353 10.4321 13.5616 10.0577 13.1592C9.68317 12.7568 9.42792 12.2437 9.32423 11.6848C9.22053 11.126 9.27305 10.5466 9.47513 10.02C9.67722 9.49333 10.0198 9.04313 10.4595 8.72637C10.812 8.47241 11.2142 8.31338 11.6323 8.26029Z",
      fill: "currentColor"
    }
  )
] }), NoBillsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.1875 10.5C6.1875 9.94772 6.63522 9.5 7.1875 9.5H8.25C8.80228 9.5 9.25 9.94772 9.25 10.5C9.25 11.0523 8.80228 11.5 8.25 11.5H7.1875C6.63522 11.5 6.1875 11.0523 6.1875 10.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.1875 6C6.63522 6 6.1875 6.44772 6.1875 7C6.1875 7.55228 6.63522 8 7.1875 8H8.25C8.80228 8 9.25 7.55228 9.25 7C9.25 6.44772 8.80228 6 8.25 6H7.1875Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.06687 19.5189L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L4.28298 21.1312C4.31553 21.1544 4.34805 21.1769 4.38048 21.1987C5.09608 21.6786 6.03805 22 7 22H19.5429C20.9066 22 22 20.8795 22 19.5273V19.2273C22 18.0574 21.1964 17.0752 20.1111 16.8025V5.3031L21.7071 3.70711C22.0976 3.31658 22.0976 2.68342 21.7071 2.29289C21.3166 1.90237 20.6834 1.90237 20.2929 2.29289L19.6003 2.98548C19.1436 2.38652 18.4225 2 17.6111 2H5.5C4.11929 2 3 3.11929 3 4.5V19C3 19.1807 3.02383 19.3538 3.06687 19.5189ZM5 4.5C5 4.22386 5.22386 4 5.5 4H17.6111C17.879 4 18.0976 4.21062 18.1105 4.47528L16.3419 6.24386C16.1665 6.09193 15.9378 6 15.6875 6H11.4375C10.8852 6 10.4375 6.44772 10.4375 7C10.4375 7.55228 10.8852 8 11.4375 8H14.5858L13.0858 9.5H11.4375C10.8852 9.5 10.4375 9.94772 10.4375 10.5C10.4375 10.9461 10.7296 11.324 11.133 11.4528L9.10488 13.4809C8.92943 13.1926 8.6122 13 8.25 13H7.1875C6.63522 13 6.1875 13.4477 6.1875 14C6.1875 14.5523 6.63522 15 7.1875 15H7.58579L5 17.5858V4.5ZM18.1111 7.3031V16.7273H11.2727C10.0176 16.7273 9.00018 17.7446 9 18.9997C8.99982 19.0024 8.99587 19.0557 8.9231 19.1596C8.8446 19.2716 8.70848 19.408 8.50745 19.5422C8.09994 19.8141 7.54149 20 7 20C6.56092 20 6.10852 19.875 5.73446 19.6798L10.7188 14.6954C10.9006 14.8832 11.1554 15 11.4375 15H15.6875C16.2398 15 16.6875 14.5523 16.6875 14C16.6875 13.4477 16.2398 13 15.6875 13H12.4142L13.9142 11.5H15.4375C15.9898 11.5 16.4375 11.0523 16.4375 10.5C16.4375 10.0882 16.1886 9.73451 15.833 9.58124L18.1111 7.3031ZM19.5429 20H10.7485C10.9037 19.7007 11 19.366 11 19C11 18.8494 11.1221 18.7273 11.2727 18.7273H19.5C19.7761 18.7273 20 18.9511 20 19.2273V19.5273C20 19.795 19.782 20 19.5429 20Z",
      fill: "currentColor"
    }
  )
] }), NoBillsSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18412 13.7577C0.927299 14.0524 0.939151 14.4998 1.21967 14.7803C1.51256 15.0732 1.98744 15.0732 2.28033 14.7803L2.33486 14.7258C2.80221 14.9104 3.36617 15 4.00111 15H13.1786C13.8311 15 14.2958 14.5587 14.5493 14.1971C14.814 13.8197 15 13.3251 15 12.8611V12.131C15 11.1645 14.2165 10.381 13.25 10.381H12.9266V4.13404L14.7803 2.28033C15.0732 1.98744 15.0732 1.51256 14.7803 1.21967C14.4874 0.926777 14.0126 0.926777 13.7197 1.21967L12.8124 2.1269C12.5613 1.46806 11.9236 1 11.1766 1H2.75C1.7835 1 1 1.7835 1 2.75V12.9975C1 13.2741 1.06597 13.5295 1.18412 13.7577ZM2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H11.1766C11.3147 2.5 11.4266 2.61193 11.4266 2.75V3.51272L9.7491 5.19024C9.76498 5.12949 9.77344 5.06573 9.77344 5C9.77344 4.58579 9.43765 4.25 9.02344 4.25H5.02344C4.60922 4.25 4.27344 4.58579 4.27344 5C4.27344 5.41421 4.60922 5.75 5.02344 5.75H9.02344C9.08917 5.75 9.15293 5.74154 9.21368 5.72566L7.68934 7.25H5.02344C4.60922 7.25 4.27344 7.58579 4.27344 8C4.27344 8.41421 4.60922 8.75 5.02344 8.75H6.18934L2.5 12.4393V2.75ZM11.4266 5.63404V10.381H7.46803C6.50154 10.381 5.71803 11.1645 5.71803 12.131V12.9971L5.7175 12.9987C5.71633 13.002 5.71155 13.0139 5.6966 13.0337C5.66499 13.0756 5.59304 13.1454 5.45088 13.2207C5.16272 13.3734 4.67636 13.5 4.00111 13.5C3.84705 13.5 3.70673 13.4933 3.57934 13.4813L8.31066 8.75H9.02344C9.43765 8.75 9.77344 8.41421 9.77344 8C9.77344 7.80236 9.69699 7.62258 9.57205 7.48861L11.4266 5.63404ZM7.21803 12.131C7.21803 11.9929 7.32996 11.881 7.46803 11.881H13.25C13.3881 11.881 13.5 11.9929 13.5 12.131V12.8611C13.5 12.9596 13.445 13.1594 13.3212 13.3359C13.2642 13.4172 13.2111 13.4661 13.1756 13.49C13.1686 13.4948 13.1632 13.4979 13.1593 13.5H7.13276C7.18733 13.3456 7.21803 13.1781 7.21803 12.9975V12.131Z",
    fill: "currentColor"
  }
) }), NoteAddLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V13.3787C2 14.0417 2.26339 14.6776 2.73223 15.1464L8.85355 21.2678C9.32239 21.7366 9.95828 22 10.6213 22H19.5C20.8807 22 22 20.8807 22 19.5V10C22 9.44772 21.5523 9 21 9C20.4477 9 20 9.44772 20 10V19.5C20 19.7761 19.7761 20 19.5 20H11V15.5C11 14.1193 9.88071 13 8.5 13H4V4.5C4 4.22386 4.22386 4 4.5 4H14C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2H4.5ZM5.41421 15L9 18.5858V15.5C9 15.2239 8.77614 15 8.5 15H5.41421Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16 5C16 4.44772 16.4477 4 17 4H18V3C18 2.44772 18.4477 2 19 2C19.5523 2 20 2.44772 20 3V4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H20V7.00011C20 7.55239 19.5523 8.00011 19 8.00011C18.4477 8.00011 18 7.55239 18 7.00011V6H17C16.4477 6 16 5.55228 16 5Z",
      fill: "currentColor"
    }
  )
] }), NoteAddSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.75 1C1.7835 1 1 1.7835 1 2.75V8.61906C1 9.04296 1.15386 9.45244 1.43299 9.77145L5.48509 14.4024C5.81739 14.7822 6.29746 15 6.80209 15H13.25C14.2165 15 15 14.2165 15 13.25V7.56047C15 7.14625 14.6642 6.81047 14.25 6.81047C13.8358 6.81047 13.5 7.14625 13.5 7.56047V13.25C13.5 13.3881 13.3881 13.5 13.25 13.5H7.75V10.25C7.75 9.2835 6.9665 8.5 6 8.5H2.5V2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H8.49974C8.91396 2.5 9.24974 2.16421 9.24974 1.75C9.24974 1.33579 8.91396 1 8.49974 1H2.75ZM3.62613 10L6.25 12.9987V10.25C6.25 10.1119 6.13807 10 6 10H3.62613Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.5002 3.25C10.5002 2.83579 10.836 2.5 11.2502 2.5H12.0002V1.75C12.0002 1.33579 12.336 1 12.7502 1C13.1645 1 13.5002 1.33579 13.5002 1.75V2.5H14.2502C14.6645 2.5 15.0002 2.83579 15.0002 3.25C15.0002 3.66421 14.6645 4 14.2502 4H13.5002V4.75C13.5002 5.16421 13.1645 5.5 12.7502 5.5C12.336 5.5 12.0002 5.16421 12.0002 4.75V4H11.2502C10.836 4 10.5002 3.66421 10.5002 3.25Z",
      fill: "currentColor"
    }
  )
] }), NotificationLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02266 4.10969C8.33854 2.76179 10.1284 2 12 2C12.9262 2 13.8427 2.1869 14.697 2.54938C15.5513 2.91185 16.3259 3.44245 16.9773 4.10969C17.6287 4.77689 18.1441 5.56767 18.4954 6.43628C18.8466 7.30485 19.0271 8.23497 19.0271 9.17375V14.4695C19.0271 15.1483 19.2905 15.7946 19.7521 16.2674C20.0883 16.6117 20.2634 16.7734 20.4287 16.8716C20.5502 16.9437 20.6983 17 21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H15C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17C3.30174 17 3.44984 16.9437 3.57132 16.8716C3.73656 16.7734 3.91175 16.6117 4.24789 16.2674C4.70947 15.7946 4.97293 15.1483 4.97293 14.4695V9.17375C4.97293 7.27881 5.70758 5.45678 7.02266 4.10969ZM12 20C11.4477 20 11 19.5523 11 19H13C13 19.5523 12.5523 20 12 20ZM17.7852 17H6.21476C6.70646 16.256 6.97293 15.3755 6.97293 14.4695V9.17375C6.97293 7.79393 7.50827 6.47533 8.45378 5.50681C9.39849 4.5391 10.6746 4 12 4C12.6568 4 13.3077 4.13248 13.9159 4.39051C14.5241 4.64857 15.0783 5.02748 15.5462 5.50681C16.0142 5.98618 16.3867 6.55658 16.6412 7.18604C16.8958 7.81554 17.0271 8.49103 17.0271 9.17375V14.4695C17.0271 15.3755 17.2935 16.256 17.7852 17Z",
    fill: "currentColor"
  }
) }), NotificationSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51586 2.47679C5.43698 1.53326 6.68991 1 8 1C8.64833 1 9.28991 1.13083 9.88793 1.38457C10.4859 1.63829 11.0282 2.00971 11.4841 2.47679C11.9401 2.94382 12.3009 3.49737 12.5468 4.10539C12.7926 4.71339 12.9189 5.36448 12.9189 6.02163V9.72865C12.9189 10.2038 13.1034 10.6562 13.4265 10.9872C13.6618 11.2282 13.7844 11.3414 13.9001 11.4101C13.9851 11.4606 14.0888 11.5 14.3 11.5C14.6866 11.5 15 11.8134 15 12.2C15 12.5866 14.6866 12.9 14.3 12.9H10.1C10.1 14.0598 9.1598 15 8 15C6.8402 15 5.9 14.0598 5.9 12.9H1.7C1.3134 12.9 1 12.5866 1 12.2C1 11.8134 1.3134 11.5 1.7 11.5C1.91122 11.5 2.01489 11.4606 2.09993 11.4101C2.21559 11.3414 2.33822 11.2282 2.57352 10.9872C2.89663 10.6562 3.08105 10.2038 3.08105 9.72865V6.02163C3.08105 4.69517 3.59531 3.41975 4.51586 2.47679ZM8 13.6C7.6134 13.6 7.3 13.2866 7.3 12.9H8.7C8.7 13.2866 8.3866 13.6 8 13.6ZM12.0497 11.5H3.95033C4.29452 10.9792 4.48105 10.3628 4.48105 9.72865V6.02163C4.48105 5.05575 4.85579 4.13273 5.51764 3.45476C6.17894 2.77737 7.07222 2.4 8 2.4C8.45975 2.4 8.9154 2.49274 9.34111 2.67336C9.76685 2.854 10.1548 3.11924 10.4824 3.45476C10.8099 3.79033 11.0707 4.18961 11.2488 4.63023C11.427 5.07088 11.5189 5.54372 11.5189 6.02163V9.72865C11.5189 10.3628 11.7055 10.9792 12.0497 11.5Z",
    fill: "currentColor"
  }
) }), PaperCheckLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.97363 17.7332C5.42135 17.7332 4.97363 18.2023 4.97363 18.7808C4.97363 19.3594 5.42135 19.8285 5.97363 19.8285H12.9736C13.5259 19.8285 13.9736 19.3594 13.9736 18.7808C13.9736 18.2023 13.5259 17.7332 12.9736 17.7332L5.97363 17.7332Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7929 1.30684C18.1834 0.897719 18.8166 0.897719 19.2071 1.30684L21.682 3.89959C21.8695 4.09605 21.9749 4.36252 21.9749 4.64037C21.9749 4.91822 21.8695 5.18469 21.682 5.38115L16.8641 10.4285H19.5C20.8807 10.4285 22 11.6011 22 13.0475V20.3809C22 21.8274 20.8807 23 19.5 23H4.5C3.11929 23 2 21.8274 2 20.3809V13.0475C2 11.6011 3.11929 10.4285 4.5 10.4285H9C9.0278 10.4285 9.05534 10.4297 9.08258 10.432L17.7929 1.30684ZM12.3065 15.2032L14.8641 12.5237H19.5C19.7761 12.5237 20 12.7583 20 13.0475V20.3809C20 20.6702 19.7761 20.9047 19.5 20.9047H4.5C4.22386 20.9047 4 20.6702 4 20.3809V13.0475C4 12.7583 4.22386 12.5237 4.5 12.5237H8.12673L8.13338 14.4622C8.13536 15.0387 8.58155 15.5052 9.13183 15.506L11.5978 15.51C11.8636 15.5105 12.1186 15.4001 12.3065 15.2032ZM15.75 6.41017L10.126 12.302L10.1298 13.4124L11.1858 13.4141L16.8107 7.52134L15.75 6.41017ZM17.1642 4.9286L18.2249 6.03978L19.5607 4.64037L18.5 3.52919L17.1642 4.9286Z",
      fill: "currentColor"
    }
  )
] }), PaperCheckSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0245 1.21983C12.7321 0.927187 12.2581 0.926658 11.965 1.21864L6.68965 6.47425C6.68323 6.48064 6.67693 6.48715 6.67075 6.49377H2.75C1.7835 6.49377 1 7.27782 1 8.24501V13.2485C1 14.2157 1.7835 14.9998 2.75 14.9998H13.25C14.2165 14.9998 15 14.2157 15 13.2485V8.24501C15 7.27782 14.2165 6.49377 13.25 6.49377H12.327L14.7805 4.0385C15.0734 3.7454 15.0734 3.27019 14.7805 2.97709L13.0245 1.21983ZM10.827 7.99483L9.4694 9.35338C9.38938 9.43347 9.29228 9.49438 9.18538 9.53158L6.57359 10.4403C6.30432 10.534 6.00524 10.4668 5.80182 10.267C5.5984 10.0671 5.52581 9.76907 5.6145 9.49794L6.1062 7.99483H2.75C2.61193 7.99483 2.5 8.10684 2.5 8.24501V13.2485C2.5 13.3867 2.61193 13.4987 2.75 13.4987H13.25C13.3881 13.4987 13.5 13.3867 13.5 13.2485V8.24501C13.5 8.10684 13.3881 7.99483 13.25 7.99483H10.827ZM7.87555 7.41089L12.493 2.81076L13.1895 3.50779L8.53034 8.17029L7.51113 8.52492L7.87555 7.41089Z",
    fill: "currentColor"
  }
) }), PathLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.34315 2 2 3.34315 2 5C2 6.65686 3.34315 8 5 8C6.30622 8 7.41746 7.16519 7.82929 6H17.5C18.8807 6 20 7.11929 20 8.5C20 9.88071 18.8807 11 17.5 11H14.8293C14.4175 9.83481 13.3062 9 12 9C10.6938 9 9.58254 9.83481 9.17071 11H6.5C4.01472 11 2 13.0147 2 15.5C2 17.9853 4.01472 20 6.5 20H16.1707C16.5825 21.1652 17.6938 22 19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.6938 16 16.5825 16.8348 16.1707 18H6.5C5.11929 18 4 16.8807 4 15.5C4 14.1193 5.11929 13 6.5 13H9.17071C9.58254 14.1652 10.6938 15 12 15C13.3062 15 14.4175 14.1652 14.8293 13H17.5C19.9853 13 22 10.9853 22 8.5C22 6.01472 19.9853 4 17.5 4H7.82929C7.41746 2.83481 6.30622 2 5 2ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM5 6C5.55228 6 6 5.55229 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55229 4.44772 6 5 6ZM20 19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19C18 18.4477 18.4477 18 19 18C19.5523 18 20 18.4477 20 19Z",
    fill: "currentColor"
  }
) }), PathSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.75 3.75H3.71643V2.25H11.75C13.5449 2.25 15 3.70507 15 5.5C15 7.29493 13.5449 8.75 11.75 8.75H4.25C3.2835 8.75 2.5 9.5335 2.5 10.5C2.5 11.4665 3.2835 12.25 4.25 12.25H13.5556V13.75H4.25C2.45507 13.75 1 12.2949 1 10.5C1 8.70507 2.45507 7.25 4.25 7.25H11.75C12.7165 7.25 13.5 6.4665 13.5 5.5C13.5 4.5335 12.7165 3.75 11.75 3.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13 15C14.1046 15 15 14.1046 15 13C15 11.8954 14.1046 11 13 11C11.8954 11 11 11.8954 11 13C11 14.1046 11.8954 15 13 15Z",
      fill: "currentColor"
    }
  )
] }), PauseCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM9.5 7C10.0523 7 10.5 7.44772 10.5 8V16C10.5 16.5523 10.0523 17 9.5 17C8.94771 17 8.5 16.5523 8.5 16V8C8.5 7.44772 8.94772 7 9.5 7ZM14.5 7C15.0523 7 15.5 7.44772 15.5 8V16C15.5 16.5523 15.0523 17 14.5 17C13.9477 17 13.5 16.5523 13.5 16V8C13.5 7.44772 13.9477 7 14.5 7Z",
    fill: "currentColor"
  }
) }), PauseCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 15.3333C12.05 15.3333 15.3333 12.05 15.3333 7.99996C15.3333 3.94987 12.05 0.666626 7.99996 0.666626C3.94987 0.666626 0.666626 3.94987 0.666626 7.99996C0.666626 12.05 3.94987 15.3333 7.99996 15.3333ZM6.33329 4.66663C6.70148 4.66663 6.99996 4.9651 6.99996 5.33329V10.6666C6.99996 11.0348 6.70148 11.3333 6.33329 11.3333C5.9651 11.3333 5.66663 11.0348 5.66663 10.6666V5.33329C5.66663 4.9651 5.9651 4.66663 6.33329 4.66663ZM9.66663 4.66663C10.0348 4.66663 10.3333 4.9651 10.3333 5.33329V10.6666C10.3333 11.0348 10.0348 11.3333 9.66663 11.3333C9.29844 11.3333 8.99996 11.0348 8.99996 10.6666V5.33329C8.99996 4.9651 9.29844 4.66663 9.66663 4.66663Z",
    fill: "currentColor"
  }
) }), PauseCircleLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.5 7C10.0523 7 10.5 7.44772 10.5 8V16C10.5 16.5523 10.0523 17 9.5 17C8.94771 17 8.5 16.5523 8.5 16L8.5 8C8.5 7.44772 8.94772 7 9.5 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.5 7C15.0523 7 15.5 7.44772 15.5 8V16C15.5 16.5523 15.0523 17 14.5 17C13.9477 17 13.5 16.5523 13.5 16V8C13.5 7.44772 13.9477 7 14.5 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), PauseCircleSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.33329 4.66663C6.70148 4.66663 6.99996 4.9651 6.99996 5.33329V10.6666C6.99996 11.0348 6.70148 11.3333 6.33329 11.3333C5.9651 11.3333 5.66663 11.0348 5.66663 10.6666V5.33329C5.66663 4.9651 5.9651 4.66663 6.33329 4.66663Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.66663 4.66663C10.0348 4.66663 10.3333 4.9651 10.3333 5.33329V10.6666C10.3333 11.0348 10.0348 11.3333 9.66663 11.3333C9.29844 11.3333 8.99996 11.0348 8.99996 10.6666V5.33329C8.99996 4.9651 9.29844 4.66663 9.66663 4.66663Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99996 0.666626C3.94987 0.666626 0.666626 3.94987 0.666626 7.99996C0.666626 12.05 3.94987 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.05 15.3333 7.99996C15.3333 3.94987 12.05 0.666626 7.99996 0.666626ZM1.99996 7.99996C1.99996 4.68625 4.68625 1.99996 7.99996 1.99996C11.3137 1.99996 14 4.68625 14 7.99996C14 11.3137 11.3137 14 7.99996 14C4.68625 14 1.99996 11.3137 1.99996 7.99996Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10678_566722", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), PauseLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 7C10 6.44772 9.55229 6 9 6C8.44772 6 8 6.44772 8 7V17C8 17.5523 8.44772 18 9 18C9.55228 18 10 17.5523 10 17L10 7Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7L14 17C14 17.5523 14.4477 18 15 18C15.5523 18 16 17.5523 16 17L16 7Z",
      fill: "currentColor"
    }
  )
] }), PauseSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.63636 4.8C6.63636 4.35817 6.27005 4 5.81818 4C5.36631 4 5 4.35817 5 4.8V11.2C5 11.6418 5.36631 12 5.81818 12C6.27005 12 6.63636 11.6418 6.63636 11.2V4.8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 4.8C11 4.35817 10.6337 4 10.1818 4C9.72995 4 9.36364 4.35817 9.36364 4.8V11.2C9.36364 11.6418 9.72995 12 10.1818 12C10.6337 12 11 11.6418 11 11.2V4.8Z",
      fill: "currentColor"
    }
  )
] }), PauseSolidLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx("circle", { cx: "20", cy: "19.9998", r: "18.3333", fill: "currentColor" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17.5 13.3332C17.5 12.4127 16.7538 11.6665 15.8333 11.6665C14.9128 11.6665 14.1666 12.4127 14.1666 13.3332V26.6665C14.1666 27.587 14.9128 28.3332 15.8333 28.3332C16.7538 28.3332 17.5 27.587 17.5 26.6665L17.5 13.3332Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25.8333 13.3332C25.8333 12.4127 25.0871 11.6665 24.1666 11.6665C23.2462 11.6665 22.5 12.4127 22.5 13.3332L22.5 26.6665C22.5 27.587 23.2462 28.3332 24.1666 28.3332C25.0871 28.3332 25.8333 27.587 25.8333 26.6665L25.8333 13.3332Z",
      fill: "black"
    }
  )
] }), PayLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16.9996 4.5L16.9996 7C16.9996 7.55229 17.4473 8 17.9996 8C18.5519 8 18.9996 7.55228 18.9996 7L18.9996 4.5C18.9996 3.11929 17.8803 2 16.4996 2H5.49963C4.11892 2 2.99963 3.11929 2.99963 4.5V19.5C2.99963 20.8807 4.11892 22 5.49963 22H16.4996C17.8803 22 18.9996 20.8807 18.9996 19.5V17C18.9996 16.4477 18.5519 16 17.9996 16C17.4473 16 16.9996 16.4477 16.9996 17V19.5C16.9996 19.7761 16.7758 20 16.4996 20H5.49963C5.22349 20 4.99963 19.7761 4.99963 19.5L4.99963 4.5C4.99963 4.22386 5.22349 4 5.49963 4H16.4996C16.7758 4 16.9996 4.22386 16.9996 4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.9948 5.5C11.547 5.5 11.9948 5.94772 11.9948 6.5V7.12992C12.9181 7.38779 13.513 7.99885 13.791 8.68395C13.9986 9.19572 13.752 9.77891 13.2403 9.98655C12.7285 10.1942 12.1453 9.94764 11.9377 9.43587C11.9011 9.34569 11.8337 9.24802 11.715 9.16941C11.599 9.09263 11.3826 9 10.9947 9C10.4811 9 10.2894 9.1577 10.2035 9.262C10.0902 9.39957 9.99676 9.65082 9.99974 10.0364C10.0021 10.3367 10.0828 10.5461 10.1918 10.6715C10.2823 10.7755 10.492 10.9386 11.0244 10.9545C12.1144 10.9869 12.8821 11.5124 13.3528 12.1311C13.7905 12.7065 13.9947 13.3894 13.9947 13.8883L13.9947 13.915C13.9952 14.1916 13.9965 14.9351 13.6236 15.6224C13.4185 16.0005 13.1022 16.3614 12.636 16.62C12.4386 16.7296 12.2246 16.815 11.9948 16.877V17.5C11.9948 18.0523 11.547 18.5 10.9948 18.5C10.4425 18.5 9.99475 18.0523 9.99475 17.5V16.8782C9.66066 16.7895 9.36422 16.6537 9.10588 16.4745C8.61497 16.134 8.33916 15.6909 8.18976 15.3035C7.99102 14.7882 8.24763 14.2094 8.76292 14.0107C9.2782 13.8119 9.85704 14.0685 10.0558 14.5838C10.0925 14.679 10.149 14.764 10.2457 14.8311C10.341 14.8972 10.5533 15 10.9947 15C11.3637 15 11.5636 14.9278 11.6658 14.8711C11.7622 14.8177 11.8209 14.7513 11.8657 14.6687C11.9801 14.4578 11.9947 14.1729 11.9947 13.8883C11.9947 13.8884 11.9947 13.8884 11.9947 13.8883C11.9942 13.8822 11.9886 13.81 11.9482 13.6933C11.9082 13.5781 11.8459 13.4536 11.7611 13.342C11.6066 13.139 11.3743 12.9658 10.9649 12.9536C9.9974 12.9248 9.21313 12.5936 8.68295 11.9842C8.17137 11.3962 8.0046 10.673 7.9998 10.0519C7.99461 9.38187 8.14861 8.61104 8.65979 7.99044C9.00286 7.57393 9.45601 7.28617 9.99475 7.13214V6.5C9.99475 5.94772 10.4425 5.5 10.9948 5.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17.2907 14.7067C17.6807 15.0977 18.3139 15.0985 18.7049 14.7085L20.7065 12.7117C20.8944 12.5243 21 12.27 21.0003 12.0046C21.0005 11.7393 20.8953 11.4848 20.7078 11.297L18.7062 9.29328C18.3159 8.90254 17.6827 8.9022 17.292 9.29251C16.9012 9.68282 16.9009 10.316 17.2912 10.7067L18.5856 12.0025L17.2924 13.2925C16.9014 13.6826 16.9006 14.3157 17.2907 14.7067Z",
      fill: "currentColor"
    }
  )
] }), PaymentsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 8.5C11 9.60457 10.1046 10.5 9 10.5C7.89543 10.5 7 9.60457 7 8.5C7 7.39543 7.89543 6.5 9 6.5C10.1046 6.5 11 7.39543 11 8.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 3C1.44772 3 1 3.44772 1 4L1 13C1 13.5523 1.44772 14 2 14L16 14C16.5523 14 17 13.5523 17 13V4C17 3.44772 16.5523 3 16 3L2 3ZM3 5L15 5L15 12L3 12L3 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 15.5C4.44772 15.5 4 15.9477 4 16.5C4 17.0523 4.44772 17.5 5 17.5H18.5C19.3284 17.5 20 16.8284 20 16V6.5C20 5.94772 19.5523 5.5 19 5.5C18.4477 5.5 18 5.94772 18 6.5V15.5L5 15.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 19C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H20C21.6569 21 23 19.6569 23 18V10C23 9.44772 22.5523 9 22 9C21.4477 9 21 9.44772 21 10V18C21 18.5523 20.5523 19 20 19H8Z",
      fill: "currentColor"
    }
  )
] }), PaymentsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.751192 2C0.33632 2 0 2.33579 0 2.75V7.99951C0 8.41373 0.33632 8.74951 0.751192 8.74951H10.0032C10.418 8.74951 10.7544 8.41373 10.7544 7.99951V2.75C10.7544 2.33579 10.418 2 10.0032 2H0.751192ZM1.50238 7.24951V3.5H9.25199V7.24951H1.50238Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.4778 5C12.0629 5 11.7266 5.33579 11.7266 5.75V9.49072C11.7266 9.62879 11.6145 9.74072 11.4762 9.74072H3.60973C3.19486 9.74072 2.85854 10.0765 2.85854 10.4907C2.85854 10.9049 3.19486 11.2407 3.60973 11.2407H11.4762C12.4443 11.2407 13.229 10.4572 13.229 9.49072V5.75C13.229 5.33579 12.8927 5 12.4778 5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.2488 7.81641C14.8339 7.81641 14.4976 8.15219 14.4976 8.56641V11.2501C14.4976 11.9404 13.9371 12.5001 13.2456 12.5001H6.08338C5.66851 12.5001 5.33219 12.8359 5.33219 13.2501C5.33219 13.6643 5.66851 14.0001 6.08338 14.0001H13.2456C14.7668 14.0001 16 12.7689 16 11.2501V8.56641C16 8.15219 15.6637 7.81641 15.2488 7.81641Z",
      fill: "currentColor"
    }
  )
] }), PaySmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.5142 11.1521C11.5142 10.7379 11.178 10.4021 10.7632 10.4021C10.3485 10.4021 10.0123 10.7379 10.0123 11.1521V12.25C10.0123 12.3881 9.90024 12.5 9.762 12.5H1.75215C1.61391 12.5 1.50185 12.3881 1.50185 12.25L1.50185 1.75C1.50185 1.61193 1.61391 1.5 1.75215 1.5H9.762C9.90024 1.5 10.0123 1.61193 10.0123 1.75V2.83333C10.0123 3.24755 10.3485 3.58333 10.7632 3.58333C11.178 3.58333 11.5142 3.24755 11.5142 2.83333V1.75C11.5142 0.783502 10.7297 0 9.762 0H1.75215C0.784466 0 0 0.783502 0 1.75V12.25C0 13.2165 0.784467 14 1.75215 14H9.762C10.7297 14 11.5142 13.2165 11.5142 12.25V11.1521Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.75708 2.75C6.1718 2.75 6.508 3.08579 6.508 3.5V3.83574C7.01916 3.96125 7.41201 4.21835 7.67201 4.56599C7.92021 4.89784 7.85206 5.36781 7.5198 5.6157C7.18754 5.86359 6.71699 5.79552 6.4688 5.46367C6.4387 5.42343 6.28353 5.25 5.75513 5.25C5.32614 5.25 5.16714 5.36502 5.1137 5.41895C5.05714 5.47603 5.00436 5.58056 5.00613 5.77063C5.00735 5.90243 5.04667 5.9838 5.10337 6.03798C5.16269 6.09466 5.33486 6.21065 5.77373 6.2215C6.54277 6.24053 7.11179 6.54766 7.48398 6.95434C7.82734 7.32952 8.00977 7.79987 8.00977 8.18021L8.00981 8.19796C8.01026 8.37717 8.01159 8.89805 7.69996 9.37552C7.4439 9.76785 7.04518 10.0409 6.508 10.1684V10.5C6.508 10.9142 6.1718 11.25 5.75708 11.25C5.34235 11.25 5.00615 10.9142 5.00615 10.5V10.1704C4.49846 10.0527 4.12025 9.80999 3.86443 9.48023C3.61043 9.15279 3.67028 8.6817 3.99811 8.428C4.32595 8.17431 4.79762 8.23409 5.05163 8.56152C5.0679 8.5825 5.19771 8.75 5.75513 8.75C6.05149 8.75 6.22032 8.70126 6.3097 8.66005C6.39165 8.62226 6.42419 8.58339 6.44182 8.55639C6.49328 8.47754 6.50702 8.3638 6.50788 8.19777C6.50625 8.19056 6.5015 8.17149 6.4892 8.14198C6.46745 8.0898 6.43063 8.02665 6.37546 7.96636C6.27761 7.85945 6.09478 7.72991 5.73653 7.72104C5.04761 7.704 4.47252 7.51108 4.06517 7.12186C3.65522 6.73014 3.50848 6.22863 3.50435 5.78457C3.49997 5.31487 3.63325 4.7806 4.04622 4.36382C4.3038 4.10387 4.62956 3.93054 5.00615 3.8362V3.5C5.00615 3.08579 5.34235 2.75 5.75708 2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.32933 9.04863C9.63189 9.33192 10.1071 9.3166 10.3907 9.01442L11.7969 7.51632C12.0673 7.2282 12.0677 6.77998 11.7978 6.49138L10.3917 4.98802C10.1085 4.68533 9.63336 4.66918 9.33031 4.95194C9.02725 5.23471 9.01108 5.70931 9.29419 6.01199L10.2206 7.00247L9.29508 7.98852C9.01144 8.2907 9.02677 8.76533 9.32933 9.04863Z",
      fill: "currentColor"
    }
  )
] }), PhoneLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.3248 2.93579C21.2902 2.88522 21.2507 2.83753 21.2067 2.79345C21.1602 2.74703 21.1098 2.70572 21.0562 2.66982C20.9636 2.60762 20.8629 2.56258 20.7586 2.5347C20.6354 2.50163 20.5054 2.49205 20.3755 2.50828L16.3755 3.00828C15.8275 3.07678 15.4388 3.57657 15.5073 4.12459C15.5758 4.67261 16.0756 5.06134 16.6236 4.99284L17.7316 4.85433L14.7924 7.79361C14.4018 8.18414 14.4018 8.8173 14.7924 9.20783C15.1829 9.59835 15.8161 9.59835 16.2066 9.20782L19.1458 6.26861L19.0073 7.37652C18.9388 7.92454 19.3275 8.42433 19.8755 8.49284C20.4235 8.56134 20.9233 8.17261 20.9918 7.62459L21.4918 3.62459C21.5068 3.50469 21.4998 3.3847 21.4726 3.26998C21.4449 3.15244 21.3956 3.03895 21.3248 2.93579Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.53666 3.50055C6.80187 3.50055 7.05623 3.60591 7.24376 3.79344L11.3664 7.9161C11.7555 8.3052 11.7572 8.93554 11.3701 9.32664L9.8271 10.8857L9.82523 10.8876C9.70152 11.0119 9.63207 11.1802 9.63207 11.3556C9.63207 11.5307 9.70127 11.6986 9.82457 11.8229L12.1763 14.1747C12.3006 14.298 12.4692 14.3678 12.6443 14.3678C12.8197 14.3678 12.988 14.2984 13.1123 14.1747L13.1142 14.1728L14.6732 12.6298C15.0643 12.2427 15.6947 12.2444 16.0838 12.6335L20.2064 16.7561C20.597 17.1466 20.597 17.7798 20.2064 18.1703L18.0673 20.3095C16.7113 21.6599 14.6446 21.7351 12.6847 21.159C10.684 20.5709 8.52829 19.2457 6.64122 17.3587C4.75416 15.4716 3.429 13.3159 2.84086 11.3151C2.26476 9.35532 2.33998 7.28859 3.69042 5.93258L3.69187 5.93112L5.82955 3.79344C6.01709 3.60591 6.27144 3.50055 6.53666 3.50055ZM5.10693 7.34449C4.51301 7.94149 4.27113 9.0891 4.75968 10.7511C5.23636 12.3727 6.35828 14.2473 8.05544 15.9444C9.7526 17.6416 11.6272 18.7635 13.2488 19.2402C14.911 19.7288 16.0586 19.4868 16.6556 18.8928L18.0851 17.4632L15.373 14.7511L14.5229 15.5924L14.5216 15.5938C14.0226 16.0895 13.3478 16.3678 12.6443 16.3678C11.9402 16.3678 11.2648 16.089 10.7657 15.5924L10.7639 15.5907L8.40923 13.236L8.40744 13.2342C7.91085 12.7351 7.63207 12.0597 7.63207 11.3556C7.63207 10.652 7.91048 9.97694 8.40647 9.47792L8.40744 9.47695L9.24876 8.62686L6.53666 5.91476L5.10693 7.34449Z",
      fill: "currentColor"
    }
  )
] }), PhoneSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.6338 4.34643C14.5746 4.75826 14.1926 5.04409 13.7808 4.98484C13.3689 4.92558 13.083 4.54369 13.1423 4.13186L13.177 3.89042L11.2275 5.83971C10.9333 6.13392 10.4562 6.13392 10.162 5.83971C9.86775 5.5455 9.86775 5.06849 10.162 4.77429L12.1201 2.81644L11.862 2.85312C11.45 2.91167 11.0686 2.6252 11.01 2.21327C10.9515 1.80134 11.238 1.41993 11.6499 1.36138L14.1397 1.00751C14.3745 0.974128 14.6114 1.05327 14.779 1.22111C14.8416 1.2839 14.8919 1.35636 14.9285 1.43476C14.9979 1.58227 15.0168 1.74765 14.9851 1.90489L14.6338 4.34643Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.65968 3.4492C3.85951 3.4492 4.05115 3.52857 4.19245 3.66985L6.78096 6.25809C7.07412 6.55122 7.07535 7.02609 6.78371 7.32074L5.81491 8.29952L5.81351 8.30094C5.75925 8.35547 5.72879 8.42927 5.72879 8.50619C5.72879 8.58292 5.75909 8.65654 5.8131 8.71103L7.28924 10.187C7.34373 10.241 7.41782 10.2717 7.49451 10.2717C7.57144 10.2717 7.64525 10.2413 7.69978 10.187L7.7012 10.1856L8.68009 9.21691C8.97477 8.9253 9.4497 8.92654 9.74286 9.21967L12.3314 11.8079C12.4727 11.9492 12.5521 12.1408 12.5521 12.3406C12.5521 12.5404 12.4727 12.732 12.3314 12.8733L10.9892 14.2154L10.9881 14.2165C10.089 15.1117 8.73367 15.1485 7.48449 14.7813C6.20444 14.4051 4.8333 13.5604 3.63654 12.3637C2.43978 11.1671 1.59499 9.79612 1.21871 8.51622C0.851508 7.26716 0.888251 5.91198 1.78362 5.013L1.78472 5.0119L3.12691 3.66985C3.26821 3.52857 3.45985 3.4492 3.65968 3.4492ZM2.85091 6.07667C2.52549 6.40385 2.36321 7.06664 2.66444 8.09128C2.95674 9.08554 3.6484 10.2448 4.70208 11.2983C5.75576 12.3519 6.9151 13.0435 7.90947 13.3357C8.93426 13.637 9.59714 13.4747 9.92434 13.1492L10.7331 12.3406L9.20734 10.815L8.76262 11.2551L8.76185 11.2559C8.42501 11.5906 7.96941 11.7785 7.49451 11.7785C7.01925 11.7785 6.56332 11.5903 6.2264 11.2551L6.22505 11.2538L4.74662 9.77551L4.74528 9.77416C4.41007 9.43729 4.22189 8.9814 4.22189 8.50619C4.22189 8.03137 4.40976 7.57584 4.74445 7.23905L4.74528 7.23822L5.18541 6.79355L3.65968 5.26799L2.85091 6.07667Z",
      fill: "currentColor"
    }
  )
] }), PlayLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5145 8.14251C10.2056 7.95715 9.82081 7.95229 9.5073 8.1298C9.19379 8.30731 9 8.63973 9 9V15C9 15.3603 9.19379 15.6927 9.5073 15.8702C9.82081 16.0477 10.2056 16.0429 10.5145 15.8575L15.5145 12.8575C15.8157 12.6768 16 12.3513 16 12C16 11.6487 15.8157 11.3232 15.5145 11.1425L10.5145 8.14251ZM13.0563 12L11 13.2338V10.7662L13.0563 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "currentColor"
    }
  )
] }), PlaySmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.63048 5.84735C6.86561 5.71422 7.15417 5.71786 7.38587 5.85688L9.88587 7.35688C10.1118 7.49242 10.25 7.73655 10.25 8C10.25 8.26345 10.1118 8.50758 9.88587 8.64312L7.38587 10.1431C7.15417 10.2821 6.86561 10.2858 6.63048 10.1526C6.39534 10.0195 6.25 9.7702 6.25 9.5V6.5C6.25 6.2298 6.39534 5.98048 6.63048 5.84735Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5898 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10678_566533", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), PremiumLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 4C12.3344 4 12.6466 4.1671 12.8321 4.4453L16.2271 9.53776L20.3754 6.21913C20.7036 5.95657 21.1609 5.92726 21.5199 6.14577C21.879 6.36428 22.0631 6.78398 21.9806 7.19612L19.9806 19.1961C19.8871 19.6635 19.4767 20 19.0001 20H5.00005C4.52337 20 4.11296 19.6635 4.01947 19.1961L2.01947 7.19612C1.93705 6.78398 2.12113 6.36428 2.48016 6.14577C2.8392 5.92726 3.29655 5.95657 3.62475 6.21913L7.77303 9.53776L11.168 4.4453C11.3535 4.1671 11.6657 4 12.0001 4ZM12.0001 6.80278L8.8321 11.5547C8.67663 11.7879 8.43043 11.9452 8.15347 11.9882C7.87651 12.0312 7.59422 11.956 7.37536 11.7809L4.51902 9.4958L5.81986 18H18.1803L19.4811 9.4958L16.6247 11.7809C16.4059 11.956 16.1236 12.0312 15.8466 11.9882C15.5697 11.9452 15.3235 11.7879 15.168 11.5547L12.0001 6.80278Z",
    fill: "currentColor"
  }
) }), PremiumSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.28724 2 8.5511 2.1593 8.68627 2.41432L10.9577 6.69974L13.6722 3.96835C13.9106 3.72845 14.2755 3.67044 14.5758 3.82471C14.8761 3.97897 15.0435 4.31037 14.9902 4.64538L13.6075 13.341C13.5471 13.7207 13.2216 14 12.8395 14H3.16052C2.7784 14 2.45289 13.7207 2.39252 13.341L1.00981 4.64538C0.956537 4.31037 1.12386 3.97897 1.42417 3.82471C1.72447 3.67044 2.08936 3.72845 2.32778 3.96835L5.04229 6.69974L7.31373 2.41432C7.4489 2.1593 7.71276 2 8 2ZM8 4.44565L5.92085 8.36829C5.8049 8.58705 5.59278 8.73759 5.34906 8.77409C5.10534 8.81058 4.85885 8.72871 4.68462 8.55339L2.92502 6.78286L3.82374 12.4348H12.1763L13.075 6.78286L11.3154 8.55339C11.1412 8.72871 10.8947 8.81058 10.6509 8.77409C10.4072 8.73759 10.1951 8.58705 10.0791 8.36829L8 4.44565Z",
    fill: "currentColor"
  }
) }), PrintLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C7.11929 2 6 3.11929 6 4.5V6.5C6 6.67123 6.01722 6.83845 6.05001 7H4.5C3.11929 7 2 8.11929 2 9.5V15.5C2 16.8807 3.11929 18 4.5 18H5V19.5C5 20.8807 6.11929 22 7.5 22H16.5C17.8807 22 19 20.8807 19 19.5V18H19.5C20.8807 18 22 16.8807 22 15.5V9.5C22 8.11929 20.8807 7 19.5 7H17.95C17.9828 6.83845 18 6.67123 18 6.5V4.5C18 3.11929 16.8807 2 15.5 2H8.5ZM7 15H17V20H7V15ZM19 15.5V16H19.5C19.7761 16 20 15.7761 20 15.5V9.5C20 9.22386 19.7761 9 19.5 9H4.5C4.22386 9 4 9.22386 4 9.5V15.5C4 15.7761 4.22386 16 4.5 16H5V15.5C5 14.1193 6.11929 13 7.5 13H16.5C17.8807 13 19 14.1193 19 15.5ZM15.5 7C15.7761 7 16 6.77614 16 6.5V4.5C16 4.22386 15.7761 4 15.5 4H8.5C8.22386 4 8 4.22386 8 4.5V6.5C8 6.77614 8.22386 7 8.5 7H15.5Z",
    fill: "currentColor"
  }
) }), PrintSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55 1C4.5835 1 3.8 1.7835 3.8 2.75V4.15C3.8 4.26986 3.81205 4.38691 3.83501 4.5H2.75C1.7835 4.5 1 5.2835 1 6.25V10.45C1 11.4165 1.7835 12.2 2.75 12.2H3.1V13.25C3.1 14.2165 3.8835 15 4.85 15H11.15C12.1165 15 12.9 14.2165 12.9 13.25V12.2H13.25C14.2165 12.2 15 11.4165 15 10.45V6.25C15 5.2835 14.2165 4.5 13.25 4.5H12.165C12.1879 4.38691 12.2 4.26986 12.2 4.15V2.75C12.2 1.7835 11.4165 1 10.45 1H5.55ZM4.5 10.1H11.5V13.6H4.5V10.1ZM12.9 10.45V10.8H13.25C13.4433 10.8 13.6 10.6433 13.6 10.45V6.25C13.6 6.0567 13.4433 5.9 13.25 5.9H2.75C2.5567 5.9 2.4 6.0567 2.4 6.25V10.45C2.4 10.6433 2.5567 10.8 2.75 10.8H3.1V10.45C3.1 9.4835 3.8835 8.7 4.85 8.7H11.15C12.1165 8.7 12.9 9.4835 12.9 10.45ZM10.45 4.5C10.6433 4.5 10.8 4.3433 10.8 4.15V2.75C10.8 2.5567 10.6433 2.4 10.45 2.4H5.55C5.3567 2.4 5.2 2.5567 5.2 2.75V4.15C5.2 4.3433 5.3567 4.5 5.55 4.5H10.45Z",
    fill: "currentColor"
  }
) }), ProcessFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM15.2318 8.85984C14.8782 9.28412 14.9356 9.91468 15.3598 10.2682L16.2379 11H12C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13H16.238L15.3598 13.7318C14.9356 14.0854 14.8782 14.7159 15.2318 15.1402C15.5854 15.5645 16.2159 15.6218 16.6402 15.2682L19.6211 12.7842C19.8522 12.601 20.0005 12.3178 20.0005 12C20.0005 11.6817 19.8517 11.3981 19.62 11.2149L16.6402 8.7318C16.2159 8.37824 15.5854 8.43556 15.2318 8.85984ZM5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H5.5C6.05228 13 6.5 12.5523 6.5 12C6.5 11.4477 6.05228 11 5.5 11H5ZM7.5 12C7.5 11.4477 7.94771 11 8.5 11H9C9.55228 11 10 11.4477 10 12C10 12.5523 9.55228 13 9 13H8.5C7.94772 13 7.5 12.5523 7.5 12Z",
    fill: "currentColor"
  }
) }), ProcessFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM9.73559 10.5296C10.0281 10.8229 10.503 10.8235 10.7962 10.531L12.7979 8.53452C12.9388 8.39398 13.018 8.20319 13.0182 8.00418C13.0184 7.80516 12.9394 7.61423 12.7988 7.47344L10.7972 5.46993C10.5045 5.17689 10.0296 5.17666 9.73654 5.46941C9.44351 5.76217 9.44328 6.23704 9.73603 6.53007L10.4592 7.2539L7.00684 7.25388C6.59262 7.25388 6.25684 7.58966 6.25683 8.00388C6.25683 8.41809 6.59262 8.75388 7.00683 8.75388L10.4539 8.7539L9.73695 9.46899C9.44368 9.76151 9.44307 10.2364 9.73559 10.5296ZM3.75635 7.25391C3.34213 7.25391 3.00635 7.58969 3.00635 8.00391C3.00635 8.41812 3.34213 8.75391 3.75635 8.75391H4.25635C4.67056 8.75391 5.00635 8.41812 5.00635 8.00391C5.00635 7.58969 4.67056 7.25391 4.25635 7.25391H3.75635Z",
    fill: "currentColor"
  }
) }), ProcessLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.9398 10.5156C14.5685 10.2126 14.5184 9.6721 14.8277 9.30843C15.1371 8.94477 15.6888 8.89563 16.0601 9.19869L18.6718 11.3307C18.8719 11.4878 19 11.7292 19 12C19 12.2701 18.8725 12.511 18.6732 12.6681L16.0601 14.8013C15.6888 15.1044 15.1371 15.0552 14.8277 14.6916C14.5184 14.3279 14.5685 13.7874 14.9398 13.4844L15.7081 12.8571L11.9998 12.8571C11.5166 12.8571 11.1248 12.4734 11.1248 12C11.1248 11.5266 11.5166 11.1428 11.9998 11.1428L15.7081 11.1428L14.9398 10.5156Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 12C5 11.5266 5.39174 11.1428 5.87497 11.1428H6.31246C6.79569 11.1428 7.18743 11.5266 7.18743 12C7.18743 12.4734 6.79569 12.8571 6.31246 12.8571H5.87497C5.39174 12.8571 5 12.4734 5 12Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.06241 12C8.06241 11.5266 8.45415 11.1428 8.93738 11.1428H9.37487C9.8581 11.1428 10.2498 11.5266 10.2498 12C10.2498 12.4734 9.8581 12.8571 9.37487 12.8571H8.93738C8.45415 12.8571 8.06241 12.4734 8.06241 12Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
      fill: "black"
    }
  )
] }), ProcessSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.73559 10.5296C10.0281 10.8229 10.503 10.8235 10.7963 10.531L12.7979 8.53452C12.9388 8.39398 13.018 8.20319 13.0182 8.00418C13.0184 7.80516 12.9395 7.61423 12.7988 7.47344L10.7972 5.46993C10.5045 5.17689 10.0296 5.17666 9.73655 5.46941C9.44351 5.76217 9.44328 6.23704 9.73604 6.53007L10.4592 7.2539L7.00717 7.25388C6.59295 7.25388 6.25716 7.58966 6.25716 8.00388C6.25716 8.41809 6.59295 8.75388 7.00716 8.75388L10.4539 8.7539L9.73695 9.46899C9.44368 9.76151 9.44308 10.2364 9.73559 10.5296Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.75635 7.25391C3.34213 7.25391 3.00635 7.58969 3.00635 8.00391C3.00635 8.41812 3.34213 8.75391 3.75635 8.75391H4.25635C4.67056 8.75391 5.00635 8.41812 5.00635 8.00391C5.00635 7.58969 4.67056 7.25391 4.25635 7.25391H3.75635Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 1.45455C4.38505 1.45455 1.45455 4.38505 1.45455 8C1.45455 11.615 4.38505 14.5455 8 14.5455C11.615 14.5455 14.5455 11.615 14.5455 8C14.5455 4.38505 11.615 1.45455 8 1.45455Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10773_586835", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), PromoteLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4C22 3.44772 21.5523 3 21 3C20.4477 3 20 3.44772 20 4V5.21923L4 9.21923V8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8V16.0002C2 16.5525 2.44772 17.0002 3 17.0002C3.55229 17.0002 4 16.5525 4 16.0002V14.7808L7 15.5308L7 17.4478L7.00001 17.4514C7.00301 18.2936 7.23141 19.1446 7.69049 19.8141C8.15106 20.4858 8.86965 20.9934 9.74243 21L13.25 21.0001L13.2576 21C14.1304 20.9934 14.849 20.4858 15.3095 19.8141C15.7093 19.2311 15.9342 18.5104 15.9876 17.7777L20 18.7808V20C20 20.5523 20.4477 21 21 21C21.5523 21 22 20.5523 22 20V4ZM14.0133 17.2841L9.00001 16.0308V17.4459C9.00212 17.9546 9.14392 18.3972 9.33997 18.6831C9.53242 18.9638 9.69957 18.9988 9.75561 19H13.2444C13.3004 18.9988 13.4676 18.9638 13.66 18.6831C13.8563 18.3969 13.9982 17.9537 14 17.4443C14.0002 17.3897 14.0048 17.3362 14.0133 17.2841ZM4 11.2808L20 7.28079V16.7192L4 12.7192V11.2808Z",
    fill: "currentColor"
  }
) }), PromoteSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 1.74902C15.9999 1.33535 15.6644 1 15.2505 1C14.8366 1 14.5011 1.33535 14.5011 1.74902V2.36812L1.49875 4.64302V4.49545C1.49875 4.08177 1.16325 3.74642 0.749377 3.74642C0.335507 3.74642 0 4.08177 0 4.49545V9.48894C0 9.90262 0.335507 10.238 0.749377 10.238C1.16325 10.238 1.49875 9.90262 1.49875 9.48894V9.34138L3.64054 9.7161L3.64053 10.8911L3.64055 10.8954C3.64388 11.4772 3.90061 12.0179 4.32748 12.4052C4.75201 12.7904 5.31282 12.9973 5.88514 13L8.88618 13L8.88971 13C9.46203 12.9973 10.0228 12.7904 10.4474 12.4052C10.842 12.0471 11.0913 11.5579 11.1293 11.0263L14.5011 11.6163V12.2354C14.5011 12.649 14.8366 12.9844 15.2505 12.9844C15.6644 12.9844 15.9999 12.649 15.9999 12.2354V11.0006L16 10.987V2.9974L15.9999 2.98377V1.74902ZM9.63555 10.765L5.13929 9.97833V10.8884C5.14055 11.0263 5.20101 11.1746 5.33486 11.296C5.47127 11.4198 5.6699 11.5005 5.8907 11.5019H8.88415C9.10495 11.5005 9.30358 11.4198 9.43999 11.296C9.57383 11.1746 9.63429 11.0263 9.63555 10.8884V10.765ZM1.49875 6.16385L14.5011 3.88895V10.0955L1.49875 7.82055V6.16385Z",
    fill: "currentColor"
  }
) }), ProtectionLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 11C7.5 10.4477 7.90294 10 8.4 10V8.5C8.4 7.50678 8.82737 6.60038 9.51465 5.96401C10.1971 5.33208 11.0929 5 12 5C12.9071 5 13.8029 5.33208 14.4854 5.96401C15.1726 6.60038 15.6 7.50678 15.6 8.5V10C16.0971 10 16.5 10.4477 16.5 11V16C16.5 16.5523 16.0971 17 15.6 17H8.4C7.90294 17 7.5 16.5523 7.5 16V11ZM14.7 12H9.3V15H14.7V12ZM13.8 10V8.5C13.8 8.16713 13.6584 7.80177 13.333 7.50045C13.0028 7.19471 12.5251 7 12 7C11.4749 7 10.9972 7.19471 10.667 7.50045C10.3416 7.80177 10.2 8.16713 10.2 8.5V10H13.8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.8389 2.01615C11.9454 1.99462 12.0546 1.99462 12.1611 2.01615L20.2611 3.65329C20.689 3.73978 21 4.15389 21 4.63714V11.0229C20.9998 13.6343 20.1032 16.1506 18.4839 18.1452C16.8664 20.1376 14.6289 21.4868 12.1605 21.984C12.0544 22.0053 11.9456 22.0053 11.8395 21.984C9.37112 21.4868 7.13365 20.1376 5.51611 18.1452C3.89682 16.1506 3.00023 13.6344 3 11.023V4.63714C3 4.15389 3.31102 3.73978 3.73893 3.65329L11.8389 2.01615ZM4.8 5.47165V11.0228C4.80021 13.1174 5.51819 15.1618 6.85267 16.8055C8.15475 18.4094 9.96641 19.5346 12 19.9822C14.0336 19.5346 15.8452 18.4094 17.1473 16.8055C18.4818 15.1618 19.1998 13.1175 19.2 11.0229V5.47165L12 4.01641L4.8 5.47165Z",
      fill: "currentColor"
    }
  )
] }), ProtectionSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19309 2.07747C5.94369 1.38673 6.95072 0.999782 7.99975 1C9.04878 0.999782 10.0563 1.38673 10.8069 2.07747C11.5575 2.76822 11.9924 3.70808 12.0198 4.69652L12.02 4.71417V7.34375H13.28C13.6776 7.34375 14 7.64701 14 8.0211V14.3233C14 14.6974 13.6776 15.0007 13.28 15.0007H2.72C2.32235 15.0007 2 14.6974 2 14.3233V8.0211C2 7.64701 2.32235 7.34375 2.72 7.34375H3.98V4.71417L3.98024 4.69652C4.00764 3.70808 4.44248 2.76822 5.19309 2.07747ZM6.20004 3.04588C6.68222 2.60216 7.32806 2.35448 7.99975 2.3547C8.67145 2.35448 9.31779 2.60216 9.79996 3.04588C10.2801 3.48777 10.5601 4.08934 10.58 4.72352V7.30222H5.42V4.72353C5.43985 4.08935 5.71986 3.48777 6.20004 3.04588ZM3.44 13.646V8.69845H12.56V13.646H3.44Z",
    fill: "currentColor"
  }
) }), QrCodeLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4.5C2 3.11929 3.11929 2 4.5 2H8.5C9.88071 2 11 3.11929 11 4.5V8.5C11 9.88071 9.88071 11 8.5 11H4.5C3.11929 11 2 9.88071 2 8.5V4.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5V8.5C4 8.77614 4.22386 9 4.5 9H8.5C8.77614 9 9 8.77614 9 8.5V4.5C9 4.22386 8.77614 4 8.5 4H4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 15.5C2 14.1193 3.11929 13 4.5 13H8.5C9.88071 13 11 14.1193 11 15.5V19.5C11 20.8807 9.88071 22 8.5 22H4.5C3.11929 22 2 20.8807 2 19.5V15.5ZM4.5 15C4.22386 15 4 15.2239 4 15.5V19.5C4 19.7761 4.22386 20 4.5 20H8.5C8.77614 20 9 19.7761 9 19.5V15.5C9 15.2239 8.77614 15 8.5 15H4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5 2C14.1193 2 13 3.11929 13 4.5V8.5C13 9.88071 14.1193 11 15.5 11H19.5C20.8807 11 22 9.88071 22 8.5V4.5C22 3.11929 20.8807 2 19.5 2H15.5ZM15 4.5C15 4.22386 15.2239 4 15.5 4H19.5C19.7761 4 20 4.22386 20 4.5V8.5C20 8.77614 19.7761 9 19.5 9H15.5C15.2239 9 15 8.77614 15 8.5V4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.9551 21C12.9551 20.4477 13.4028 20 13.9551 20H18.0002C18.5525 20 19.0002 20.4477 19.0002 21C19.0002 21.5523 18.5525 22 18.0002 22H13.9551C13.4028 22 12.9551 21.5523 12.9551 21Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.998 13C19.4458 13 18.998 13.4477 18.998 14C18.998 14.5523 19.4458 15 19.998 15H20.998C21.5502 15 21.998 14.5523 21.998 14C21.998 13.4477 21.5502 13 20.998 13H19.998Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.9551 15H16.9551C17.5074 15 17.9551 14.5523 17.9551 14C17.9551 13.4477 17.5074 13 16.9551 13H14.0182C13.6893 13 13.457 13.1516 13.3378 13.2546C13.2207 13.3559 13.1508 13.4612 13.1166 13.5175C13.0785 13.5804 13.0532 13.6359 13.0382 13.6714C13.0301 13.6905 13.0235 13.7075 13.0183 13.7216L13.0112 13.7414L13.0082 13.75L13.0069 13.754L13.0062 13.7559L13.0058 13.7573C12.9723 13.8586 12.9551 13.965 12.9551 14.0716V18C12.9551 18.5523 13.4028 19 13.9551 19C14.5074 19 14.9551 18.5523 14.9551 18V15ZM13.9551 14.0716L13.0058 13.7573C13.0057 13.7576 13.0056 13.7578 13.9551 14.0716Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18H20V21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21V17.066C22 16.7491 21.8593 16.5211 21.7576 16.3989C21.6585 16.2797 21.5543 16.2075 21.497 16.1714C21.4336 16.1315 21.3774 16.1047 21.3412 16.0889C21.3218 16.0803 21.3044 16.0733 21.29 16.0678L21.2697 16.0602L21.2609 16.057L21.2568 16.0556L21.2548 16.0549L21.2539 16.0546C21.2536 16.0545 21.2529 16.0543 20.928 17L21.2529 16.0543C21.1484 16.0183 21.0386 16 20.928 16H17Z",
      fill: "currentColor"
    }
  )
] }), QrCodeSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 2.75C1 1.7835 1.7835 1 2.75 1H5.55C6.5165 1 7.3 1.7835 7.3 2.75V5.55C7.3 6.5165 6.5165 7.3 5.55 7.3H2.75C1.7835 7.3 1 6.5165 1 5.55V2.75ZM2.75 2.4C2.5567 2.4 2.4 2.5567 2.4 2.75V5.55C2.4 5.7433 2.5567 5.9 2.75 5.9H5.55C5.7433 5.9 5.9 5.7433 5.9 5.55V2.75C5.9 2.5567 5.7433 2.4 5.55 2.4H2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 10.45C1 9.4835 1.7835 8.7 2.75 8.7H5.55C6.5165 8.7 7.3 9.4835 7.3 10.45V13.25C7.3 14.2165 6.5165 15 5.55 15H2.75C1.7835 15 1 14.2165 1 13.25V10.45ZM2.75 10.1C2.5567 10.1 2.4 10.2567 2.4 10.45V13.25C2.4 13.4433 2.5567 13.6 2.75 13.6H5.55C5.7433 13.6 5.9 13.4433 5.9 13.25V10.45C5.9 10.2567 5.7433 10.1 5.55 10.1H2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.45 1C9.4835 1 8.7 1.7835 8.7 2.75V5.55C8.7 6.5165 9.4835 7.3 10.45 7.3H13.25C14.2165 7.3 15 6.5165 15 5.55V2.75C15 1.7835 14.2165 1 13.25 1H10.45ZM10.1 2.75C10.1 2.5567 10.2567 2.4 10.45 2.4H13.25C13.4433 2.4 13.6 2.5567 13.6 2.75V5.55C13.6 5.7433 13.4433 5.9 13.25 5.9H10.45C10.2567 5.9 10.1 5.7433 10.1 5.55V2.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.66855 14.3C8.66855 13.9134 8.98196 13.6 9.36855 13.6H12.2002C12.5868 13.6 12.9002 13.9134 12.9002 14.3C12.9002 14.6866 12.5868 15 12.2002 15H9.36855C8.98196 15 8.66855 14.6866 8.66855 14.3Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.5986 8.7C13.212 8.7 12.8986 9.0134 12.8986 9.4C12.8986 9.7866 13.212 10.1 13.5986 10.1H14.2986C14.6852 10.1 14.9986 9.7866 14.9986 9.4C14.9986 9.0134 14.6852 8.7 14.2986 8.7H13.5986Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0686 10.1H11.4686C11.8552 10.1 12.1686 9.7866 12.1686 9.4C12.1686 9.0134 11.8552 8.7 11.4686 8.7H9.41276C9.18252 8.7 9.01989 8.80612 8.93644 8.87825C8.85446 8.94911 8.80553 9.02287 8.78164 9.06228C8.75497 9.1063 8.73721 9.14516 8.72674 9.16995C8.72108 9.18333 8.71646 9.19524 8.7128 9.20514L8.70782 9.21898L8.70575 9.22501L8.70481 9.2278L8.70436 9.22915L8.70403 9.23013C8.6806 9.30101 8.66855 9.3755 8.66855 9.45015V12.2C8.66855 12.5866 8.98196 12.9 9.36855 12.9C9.75515 12.9 10.0686 12.5866 10.0686 12.2V10.1ZM9.36855 9.45015L8.70403 9.23013C8.70398 9.23029 8.70392 9.23045 9.36855 9.45015Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.5 10.8C11.1134 10.8 10.8 11.1134 10.8 11.5C10.8 11.8866 11.1134 12.2 11.5 12.2H13.6V14.3C13.6 14.6866 13.9134 15 14.3 15C14.6866 15 15 14.6866 15 14.3V11.5462C15 11.3244 14.9015 11.1648 14.8303 11.0792C14.761 10.9958 14.688 10.9453 14.6479 10.92C14.6035 10.892 14.5642 10.8733 14.5389 10.8622C14.5252 10.8562 14.5131 10.8513 14.503 10.8474L14.4888 10.8421L14.4826 10.8399L14.4798 10.8389L14.4784 10.8384L14.4777 10.8382C14.4775 10.8382 14.477 10.838 14.2496 11.5L14.477 10.838C14.4039 10.8128 14.327 10.8 14.2496 10.8H11.5Z",
      fill: "currentColor"
    }
  )
] }), RefreshCircleFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM4.99693 12.8879C5.48732 12.8896 5.88623 12.4935 5.88792 12.0031C5.89246 10.6895 6.29322 9.41597 7.0259 8.36679C7.75816 7.31823 8.78153 6.55089 9.94213 6.16606C11.102 5.78148 12.3463 5.79601 13.4982 6.2079C14.0737 6.41366 14.5935 6.7209 15.0621 7.11951H13.9999C13.5136 7.11951 13.1194 7.51372 13.1194 8.00001C13.1194 8.4863 13.5136 8.88052 13.9999 8.88052H16.8854C17.0908 8.90733 17.3064 8.8628 17.4923 8.73892C17.7837 8.54477 17.9233 8.20821 17.8804 7.88303V5.00001C17.8804 4.51372 17.4862 4.11951 16.9999 4.11951C16.5136 4.11951 16.1194 4.51372 16.1194 5.00001V5.68872C15.5261 5.20068 14.8541 4.80675 14.0961 4.53571C12.5713 3.99046 10.9197 3.97098 9.38321 4.48044C7.84752 4.98964 6.51408 5.99802 5.56992 7.35002C4.62619 8.70141 4.11783 10.3288 4.11207 11.9969C4.11037 12.4873 4.50654 12.8862 4.99693 12.8879ZM18.1121 11.9969C18.1138 11.5065 18.5127 11.1104 19.0031 11.1121C19.4935 11.1138 19.8896 11.5127 19.8879 12.0031C19.8822 13.6712 19.3738 15.2986 18.4301 16.65C17.4859 18.002 16.1525 19.0104 14.6168 19.5196C13.0803 20.029 11.4287 20.0095 9.90387 19.4643C9.14588 19.1932 8.47391 18.7993 7.88062 18.3113V19C7.88062 19.4863 7.4864 19.8805 7.00011 19.8805C6.51382 19.8805 6.11961 19.4863 6.11961 19V16.117C6.07665 15.7918 6.21627 15.4552 6.50765 15.2611C6.69357 15.1372 6.90921 15.0927 7.1146 15.1195H10.0001C10.4864 15.1195 10.8806 15.5137 10.8806 16C10.8806 16.4863 10.4864 16.8805 10.0001 16.8805H8.93788C9.40646 17.2791 9.92634 17.5863 10.5018 17.7921C11.6537 18.204 12.898 18.2185 14.0579 17.8339C15.2185 17.4491 16.2418 16.6818 16.9741 15.6332C17.7068 14.584 18.1075 13.3105 18.1121 11.9969Z",
    fill: "currentColor"
  }
) }), RefreshCircleFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 15.3333C12.05 15.3333 15.3333 12.05 15.3333 7.99996C15.3333 3.94987 12.05 0.666626 7.99996 0.666626C3.94987 0.666626 0.666626 3.94987 0.666626 7.99996C0.666626 12.05 3.94987 15.3333 7.99996 15.3333ZM3.33124 8.59191C3.65817 8.59304 3.92411 8.32893 3.92524 8.002C3.92827 7.12627 4.19544 6.27727 4.68389 5.57782C5.17207 4.87878 5.85431 4.36722 6.62804 4.11066C7.40127 3.85428 8.23085 3.86397 8.99876 4.13856C9.3824 4.27573 9.72898 4.48056 10.0414 4.7463H9.33322C9.00903 4.7463 8.74622 5.00911 8.74622 5.3333C8.74622 5.65749 9.00903 5.9203 9.33322 5.9203H11.2569C11.3938 5.93818 11.5376 5.90849 11.6615 5.82591C11.8558 5.69648 11.9489 5.4721 11.9202 5.25532V3.3333C11.9202 3.00911 11.6574 2.7463 11.3332 2.7463C11.009 2.7463 10.7462 3.00911 10.7462 3.3333V3.79244C10.3507 3.46708 9.90271 3.20446 9.39738 3.02377C8.3808 2.66026 7.27973 2.64728 6.25543 2.98692C5.23164 3.32639 4.34268 3.99864 3.71324 4.89997C3.08408 5.8009 2.74518 6.88585 2.74134 7.99791C2.74021 8.32484 3.00432 8.59078 3.33124 8.59191ZM12.0747 7.99792C12.0758 7.67099 12.3417 7.40688 12.6687 7.40801C12.9956 7.40914 13.2597 7.67508 13.2586 8.00201C13.2547 9.11407 12.9158 10.199 12.2867 11.0999C11.6572 12.0013 10.7683 12.6735 9.74449 13.013C8.72019 13.3526 7.61912 13.3397 6.60254 12.9762C6.09721 12.7955 5.64923 12.5328 5.2537 12.2075V12.6666C5.2537 12.9908 4.99089 13.2536 4.6667 13.2536C4.34251 13.2536 4.0797 12.9908 4.0797 12.6666V10.7446C4.05106 10.5278 4.14414 10.3034 4.33839 10.174C4.46234 10.0914 4.6061 10.0617 4.74303 10.0796H6.6667C6.99089 10.0796 7.2537 10.3424 7.2537 10.6666C7.2537 10.9908 6.99089 11.2536 6.6667 11.2536H5.95855C6.27093 11.5194 6.61752 11.7242 7.00116 11.8614C7.76907 12.136 8.59865 12.1456 9.37188 11.8893C10.1456 11.6327 10.8279 11.1211 11.316 10.4221C11.8045 9.72265 12.0717 8.87365 12.0747 7.99792Z",
    fill: "currentColor"
  }
) }), RefreshLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.204 11.9968C20.2058 11.5008 20.6093 11.1002 21.1052 11.102C21.6012 11.1038 22.0018 11.5073 22 12.0032C21.9924 14.1286 21.3204 16.198 20.0791 17.912C18.8377 19.6262 17.0904 20.8968 15.0881 21.537C13.0857 22.1773 10.9346 22.1529 8.94678 21.4675C7.73582 21.0499 6.69719 20.3482 5.81126 19.4986V21.057C5.81126 21.5488 5.41258 21.9475 4.92078 21.9475C4.42898 21.9475 4.0303 21.5488 4.0303 21.057V17.1707C4.01694 17.0694 4.02106 16.967 4.04183 16.868C4.11053 16.4445 4.4779 16.1212 4.92078 16.1212H8.96611C9.45791 16.1212 9.8566 16.5199 9.8566 17.0117C9.8566 17.5035 9.45791 17.9022 8.96611 17.9022H6.75544C7.56161 18.7498 8.48388 19.4081 9.53222 19.7696C11.1539 20.3288 12.9078 20.3486 14.5412 19.8263C16.1747 19.304 17.6054 18.2657 18.6245 16.8585C19.6438 15.4511 20.1977 13.7485 20.204 11.9968Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.89478 12.898C3.39073 12.8998 3.79421 12.4992 3.79599 12.0032C3.80226 10.2515 4.35621 8.54887 5.37546 7.14147C6.39456 5.73428 7.82528 4.69596 9.45883 4.17366C11.0922 3.65141 12.8461 3.67125 14.4678 4.2304C15.5161 4.59188 16.4384 5.25018 17.2446 6.09782H15.0339C14.5421 6.09782 14.1434 6.4965 14.1434 6.98831C14.1434 7.48011 14.5421 7.87879 15.0339 7.87879L19.0792 7.87879C19.5221 7.87879 19.8895 7.55546 19.9582 7.13197C19.9789 7.03296 19.9831 6.93055 19.9697 6.8293L19.9697 2.94297C19.9697 2.45117 19.571 2.05249 19.0792 2.05249C18.5874 2.05249 18.1887 2.45117 18.1887 2.94297V4.50139C17.3028 3.65176 16.2642 2.95005 15.0532 2.53251C13.0654 1.84711 10.9143 1.82273 8.91186 2.46298C6.90963 3.10317 5.16232 4.3738 3.92086 6.08803C2.67956 7.80204 2.00762 9.8714 2.00001 11.9968C1.99823 12.4927 2.39883 12.8962 2.89478 12.898Z",
      fill: "currentColor"
    }
  )
] }), RefreshSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.4694 7.9979C13.4706 7.66727 13.7396 7.4002 14.0702 7.40138C14.4008 7.40257 14.6679 7.67156 14.6667 8.00219C14.6616 9.41911 14.2137 10.7987 13.3861 11.9414C12.5585 13.0842 11.3936 13.9313 10.0588 14.3581C8.72384 14.7849 7.28975 14.7686 5.96456 14.3117C5.15725 14.0333 4.46483 13.5655 3.87422 12.9991V14.0381C3.87422 14.3659 3.60843 14.6317 3.28056 14.6317C2.95269 14.6317 2.68691 14.3659 2.68691 14.0381V11.4472C2.678 11.3797 2.68075 11.3114 2.69459 11.2454C2.74039 10.9631 2.9853 10.7475 3.28056 10.7475H5.97745C6.30532 10.7475 6.5711 11.0133 6.5711 11.3412C6.5711 11.669 6.30532 11.9348 5.97745 11.9348H4.50366C5.04111 12.4999 5.65596 12.9388 6.35486 13.1798C7.43597 13.5525 8.60524 13.5658 9.69415 13.2176C10.7832 12.8694 11.737 12.1772 12.4164 11.2391C13.0959 10.3008 13.4652 9.16568 13.4694 7.9979Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1.92989 8.5987C2.26052 8.59988 2.52951 8.33281 2.5307 8.00218C2.53488 6.83441 2.90418 5.69929 3.58368 4.76102C4.26308 3.82289 5.21689 3.13068 6.30593 2.78248C7.39484 2.43431 8.56411 2.44754 9.64522 2.82031C10.3441 3.06129 10.959 3.50016 11.4964 4.06526H10.0226C9.69476 4.06526 9.42898 4.33104 9.42898 4.65891C9.42898 4.98678 9.69476 5.25257 10.0226 5.25257L12.7195 5.25257C13.0148 5.25257 13.2597 5.03701 13.3055 4.75468C13.3193 4.68868 13.3221 4.62041 13.3132 4.55291L13.3132 1.96202C13.3132 1.63416 13.0474 1.36837 12.7195 1.36837C12.3917 1.36837 12.1259 1.63416 12.1259 1.96202V3.00097C11.5352 2.43455 10.8428 1.96674 10.0355 1.68838C8.71033 1.23145 7.27623 1.21519 5.94128 1.64202C4.60646 2.06882 3.44159 2.91591 2.61395 4.05873C1.78642 5.2014 1.33845 6.58097 1.33338 7.99789C1.33219 8.32852 1.59926 8.59751 1.92989 8.5987Z",
      fill: "currentColor"
    }
  )
] }), RemoveLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 11.4477 2.44772 11 3 11L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L3 13C2.44772 13 2 12.5523 2 12Z",
    fill: "currentColor"
  }
) }), RemoveSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8C1.5 7.58579 1.83579 7.25 2.25 7.25H13.75C14.1642 7.25 14.5 7.58579 14.5 8C14.5 8.41421 14.1642 8.75 13.75 8.75H2.25C1.83579 8.75 1.5 8.41421 1.5 8Z",
    fill: "currentColor"
  }
) }), RepeatLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17.4001 4.80006C16.9583 4.46869 16.8687 3.84189 17.2001 3.40006C17.5315 2.95823 18.1583 2.86869 18.6001 3.20006L22.6001 6.20006C22.8519 6.38891 23.0001 6.6853 23.0001 7.00006C23.0001 7.31482 22.8519 7.6112 22.6001 7.80006L18.6001 10.8001C18.1583 11.1314 17.5315 11.0419 17.2001 10.6001C16.8687 10.1582 16.9583 9.53143 17.4001 9.20006L19.0002 8H6.8649C6.33297 8 5.80946 8.0863 5.3256 8.25109C4.84164 8.41591 4.41288 8.65389 4.06005 8.944C3.3491 9.52855 3.00006 10.2746 3.00006 11C3.00006 11.5523 2.55234 12 2.00006 12C1.44777 12 1.00006 11.5523 1.00006 11C1.00006 9.60369 1.6761 8.31489 2.78983 7.39915C3.34049 6.94639 3.98431 6.59509 4.68081 6.35788C5.37741 6.12063 6.11911 6 6.8649 6H19L17.4001 4.80006Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M22 12C22.5523 12 23 12.4477 23 13C23 14.4005 22.3149 15.6899 21.1913 16.6041C20.0735 17.5137 18.594 18 17.0841 18H5.00008L6.6 19.1999C7.04183 19.5313 7.13137 20.1581 6.8 20.5999C6.46863 21.0418 5.84183 21.1313 5.4 20.7999L1.4 17.7999C1.14819 17.6111 1 17.3147 1 16.9999C1 16.6852 1.14819 16.3888 1.4 16.1999L5.4 13.1999C5.84183 12.8686 6.46863 12.9581 6.8 13.3999C7.13137 13.8418 7.04183 14.4686 6.6 14.7999L4.99992 16H17.0841C18.1818 16 19.2031 15.6435 19.929 15.0528C20.6494 14.4667 21 13.7213 21 13C21 12.4477 21.4477 12 22 12Z",
      fill: "currentColor"
    }
  )
] }), RepeatSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.2107 2.16799C12.8862 1.90935 12.4131 1.96221 12.1539 2.28606C11.8947 2.60991 11.9477 3.08211 12.2722 3.34076L13.1062 4.00546L3.90396 4.00546C2.87964 4.00546 1.89061 4.39266 1.15608 5.0922C0.420357 5.79288 8.93557e-05 6.75089 8.92675e-05 7.75767C8.92312e-05 8.17212 0.336758 8.50811 0.75206 8.50811C1.16736 8.50811 1.50403 8.17212 1.50403 7.75767C1.50403 7.1722 1.74791 6.6032 2.19438 6.178C2.64205 5.75166 3.25641 5.50634 3.90396 5.50634L13.1028 5.50634L12.2712 6.17148C11.9471 6.43068 11.895 6.90297 12.1547 7.22638C12.4144 7.54978 12.8877 7.60183 13.2117 7.34263L15.7183 5.33776C15.8966 5.1952 16.0002 4.9795 16 4.75154C15.9998 4.52358 15.8958 4.30807 15.7173 4.16581L13.2107 2.16799Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.2479 7.4997C15.6632 7.4997 15.9999 7.83569 15.9999 8.25015C15.9999 9.25692 15.5796 10.2149 14.8439 10.9156C14.1094 11.6152 13.1204 12.0024 12.096 12.0024L2.89384 12.0024L3.72781 12.6671C4.05232 12.9257 4.10529 13.3979 3.84612 13.7218C3.58695 14.0456 3.11378 14.0985 2.78927 13.8398L0.282701 11.842C0.104213 11.6997 0.000197214 11.4842 2.76947e-07 11.2563C-0.000195531 11.0283 0.103449 10.8126 0.281692 10.6701L2.78826 8.66519C3.11232 8.40599 3.58558 8.45803 3.84531 8.78144C4.10504 9.10484 4.05288 9.57714 3.72882 9.83634L2.89724 10.5015L12.096 10.5015C12.7436 10.5015 13.358 10.2562 13.8056 9.82981C14.2521 9.40461 14.496 8.83561 14.496 8.25015C14.496 7.83569 14.8326 7.4997 15.2479 7.4997Z",
      fill: "currentColor"
    }
  )
] }), ResizeLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 7.70711C9.09763 7.31658 9.09763 6.68342 8.70711 6.29289C8.31658 5.90237 7.68342 5.90237 7.29289 6.29289L2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071L7.29289 17.7071C7.68342 18.0976 8.31658 18.0976 8.70711 17.7071C9.09763 17.3166 9.09763 16.6834 8.70711 16.2929L4.41421 12L8.70711 7.70711ZM15.2929 7.70711C14.9024 7.31658 14.9024 6.68342 15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L16.7071 17.7071C16.3166 18.0976 15.6834 18.0976 15.2929 17.7071C14.9024 17.3166 14.9024 16.6834 15.2929 16.2929L19.5858 12L15.2929 7.70711Z",
    fill: "currentColor"
  }
) }), ResizeSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.80515 10.3055C6.06527 10.5791 6.0649 11.0223 5.80432 11.2954C5.54374 11.5685 5.12163 11.5681 4.86151 11.2945L2.19485 8.4896C2.06993 8.35821 1.99984 8.1801 2 7.99445C2.00016 7.8088 2.07054 7.63081 2.19568 7.49965L4.86235 4.70459C5.12292 4.43146 5.54503 4.43185 5.80515 4.70546C6.06527 4.97907 6.0649 5.42229 5.80432 5.69541L3.60948 7.99594L5.80515 10.3055Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.1948 10.3055C9.93473 10.5791 9.9351 11.0223 10.1957 11.2954C10.4563 11.5685 10.8784 11.5681 11.1385 11.2945L13.8052 8.4896C13.9301 8.35821 14.0002 8.1801 14 7.99445C13.9998 7.8088 13.9295 7.63081 13.8043 7.49965L11.1377 4.70459C10.8771 4.43146 10.455 4.43185 10.1948 4.70546C9.93473 4.97907 9.9351 5.42229 10.1957 5.69541L12.3905 7.99594L10.1948 10.3055Z",
      fill: "currentColor"
    }
  )
] }), ScheduledLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 2C6.55228 2 7 2.44772 7 3V4H17V3C17 2.44772 17.4477 2 18 2C18.5523 2 19 2.44772 19 3V4H19.5C20.8807 4 22 5.11929 22 6.5V11.0216C22 11.5738 21.5523 12.0216 21 12.0216C20.4477 12.0216 20 11.5738 20 11.0216V10H4V19.5C4 19.7761 4.22386 20 4.5 20H11.0249C11.5772 20 12.0249 20.4477 12.0249 21C12.0249 21.5523 11.5772 22 11.0249 22H4.5C3.11929 22 2 20.8807 2 19.5V6.5C2 5.11929 3.11929 4 4.5 4H5V3C5 2.44772 5.44772 2 6 2ZM20 8V6.5C20 6.22386 19.7761 6 19.5 6H4.5C4.22386 6 4 6.22386 4 6.5V8H20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18 15.5C18 14.9477 17.5523 14.5 17 14.5C16.4477 14.5 16 14.9477 16 15.5V17.0485C16 17.3223 16.1123 17.5841 16.3107 17.7729L17.3107 18.7244C17.7108 19.1052 18.3437 19.0894 18.7244 18.6893C19.1052 18.2892 19.0894 17.6563 18.6893 17.2756L18 16.6196V15.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 17C12 14.2386 14.2386 12 17 12C19.7614 12 22 14.2386 22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17ZM17 14C15.3431 14 14 15.3431 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14Z",
      fill: "currentColor"
    }
  )
] }), ScheduledSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5835 1.75C4.5835 1.33579 4.24771 1 3.8335 1C3.41928 1 3.0835 1.33579 3.0835 1.75V3.08203H2.75C1.7835 3.08203 1 3.86553 1 4.83203V13.2487C1 14.2152 1.7835 14.9987 2.75 14.9987H6.97377C7.38798 14.9987 7.72377 14.6629 7.72377 14.2487C7.72377 13.8345 7.38798 13.4987 6.97377 13.4987H2.75C2.61193 13.4987 2.5 13.3868 2.5 13.2487V7.70703H14.25C14.6642 7.70703 15 7.37124 15 6.95703C15 6.94234 14.9996 6.92774 14.9987 6.91326C14.9996 6.89877 15 6.88418 15 6.86948V4.83203C15 3.86553 14.2165 3.08203 13.25 3.08203H12.9165V1.75C12.9165 1.33579 12.5807 1 12.1665 1C11.7523 1 11.4165 1.33579 11.4165 1.75V3.08203H4.5835V1.75ZM13.5 6.20703V4.83203C13.5 4.69396 13.3881 4.58203 13.25 4.58203H12.2111C12.1963 4.5829 12.1815 4.58333 12.1665 4.58333C12.1515 4.58333 12.1367 4.5829 12.1219 4.58203H3.87806C3.86332 4.5829 3.84846 4.58333 3.8335 4.58333C3.81854 4.58333 3.80368 4.5829 3.78893 4.58203H2.75C2.61193 4.58203 2.5 4.69396 2.5 4.83203V6.20703H13.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.0113 10.9522C11.7184 10.6593 11.2435 10.6593 10.9506 10.9522C10.6577 11.2451 10.6577 11.72 10.9506 12.0129L11.4881 12.5504C11.781 12.8433 12.2559 12.8433 12.5488 12.5504C12.8417 12.2575 12.8417 11.7826 12.5488 11.4897L12.0113 10.9522Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 11.75C8.5 9.95507 9.95507 8.5 11.75 8.5C13.5449 8.5 15 9.95507 15 11.75C15 13.5449 13.5449 15 11.75 15C9.95507 15 8.5 13.5449 8.5 11.75ZM11.75 10C10.7835 10 10 10.7835 10 11.75C10 12.7165 10.7835 13.5 11.75 13.5C12.7165 13.5 13.5 12.7165 13.5 11.75C13.5 10.7835 12.7165 10 11.75 10Z",
      fill: "currentColor"
    }
  )
] }), SearchLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2ZM4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10Z",
    fill: "currentColor"
  }
) }), SearchSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43467 1C3.4318 1 0.998047 3.43527 0.998047 6.43865C0.998047 9.44202 3.4318 11.8773 6.43467 11.8773C7.66736 11.8773 8.80415 11.4669 9.71605 10.7753L13.721 14.782C14.0138 15.0749 14.4887 15.075 14.7816 14.7822C15.0746 14.4894 15.0747 14.0145 14.7819 13.7215L10.7756 9.71351C11.4634 8.8025 11.8713 7.66818 11.8713 6.43865C11.8713 3.43527 9.43754 1 6.43467 1ZM2.49805 6.43865C2.49805 4.26309 4.26084 2.5 6.43467 2.5C8.6085 2.5 10.3713 4.26309 10.3713 6.43865C10.3713 8.6142 8.6085 10.3773 6.43467 10.3773C4.26084 10.3773 2.49805 8.6142 2.49805 6.43865Z",
    fill: "currentColor"
  }
) }), SendLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7482 2.33647C21.735 2.32161 21.7213 2.30709 21.7071 2.29292C21.6948 2.28055 21.6821 2.26854 21.6692 2.25692C21.3885 2.00367 20.9988 1.93764 20.6613 2.05884L2.68379 8.05134C2.3133 8.17484 2.0486 8.50271 2.00599 8.89091C1.96338 9.27911 2.15065 9.65659 2.48552 9.85752L9.77115 14.2289L14.1425 21.5145C14.3435 21.8494 14.7209 22.0367 15.1091 21.9941C15.4973 21.9514 15.8252 21.6867 15.9487 21.3163L21.9429 3.33374C21.9611 3.28223 21.9749 3.22953 21.9844 3.1762C22.0033 3.07058 22.0049 2.96367 21.9901 2.85942C21.9634 2.67063 21.8828 2.488 21.7482 2.33647ZM17.2975 5.28831L5.3789 9.26116L10.345 12.2408L17.2975 5.28831ZM11.7592 13.655L18.7118 6.70238L14.7389 18.6212L11.7592 13.655Z",
    fill: "currentColor"
  }
) }), SendSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6328 1.10501C14.6858 1.1365 14.7355 1.17484 14.7803 1.21969C14.9812 1.42056 15.0514 1.71769 14.9615 1.98719L10.7949 14.4872C10.7022 14.7651 10.4563 14.9636 10.1652 14.9955C9.87404 15.0275 9.59092 14.887 9.44023 14.6359L6.4117 9.58834L1.36414 6.55981C1.11299 6.40911 0.972534 6.126 1.00449 5.83485C1.03645 5.5437 1.23498 5.2978 1.51284 5.20517L13.9922 1.04539C14.2014 0.969104 14.4377 0.988979 14.6328 1.10501ZM7.90261 9.15772L12.534 4.52632L9.8875 12.4659L7.90261 9.15772ZM6.84186 8.09715L3.53417 6.11254L11.4726 3.46638L6.84186 8.09715Z",
    fill: "currentColor"
  }
) }), SettingsLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5008 2.00002C14.5947 1.99543 15.5572 2.85778 15.55 4.0093L15.5478 4.35825C16.0731 4.58581 16.5742 4.86338 17.0435 5.1871L17.4225 4.97696C18.3767 4.44802 19.617 4.74717 20.19 5.70643L21.7075 8.24686C22.2935 9.2278 21.9219 10.4574 20.9483 10.9945L20.5987 11.1874C20.6263 11.4546 20.6398 11.7231 20.6393 11.992C20.6385 12.2477 20.6249 12.504 20.5987 12.7581L20.9616 12.9584C21.9378 13.497 22.3082 14.7312 21.7169 15.7125L20.1895 18.2475C19.6144 19.2019 18.3776 19.498 17.4259 18.9704L17.0435 18.7584C16.5729 19.083 16.0704 19.3612 15.5434 19.5891V19.9752C15.5434 21.1101 14.6014 21.9622 13.5221 21.9721L10.5019 21.9999C9.3988 22.0101 8.42628 21.1379 8.44244 19.9758L8.44693 19.6534C7.92347 19.4262 7.42417 19.1494 6.9565 18.8268L6.57743 19.0369C5.6233 19.5659 4.38298 19.2667 3.80995 18.3075L2.29242 15.767C1.70645 14.7861 2.07807 13.5565 3.05168 13.0194L3.40195 12.8261C3.34688 12.2927 3.34688 11.7553 3.40195 11.2219L3.03836 11.0213C2.06211 10.4827 1.69174 9.24846 2.28303 8.26717L3.81048 5.73222C4.38556 4.77782 5.62233 4.48166 6.57405 5.00926L6.9565 5.22128C7.42702 4.89667 7.92956 4.61846 8.4565 4.39056V4.00962C8.4565 2.87047 9.4052 2.0172 10.4883 2.01266L13.5008 2.00002ZM13.5499 4.01114C13.5431 4.00611 13.5302 3.99991 13.5091 4L10.4967 4.01264C10.4759 4.01273 10.4632 4.0189 10.4565 4.02385V5.07648C10.4565 5.50528 10.1831 5.88636 9.77693 6.02375C9.00451 6.28503 8.29031 6.67908 7.66896 7.18503C7.35208 7.44306 6.91009 7.48232 6.55269 7.28419L5.60435 6.75846C5.58963 6.7503 5.56969 6.7467 5.54752 6.75238C5.5371 6.75505 5.53021 6.75892 5.52675 6.76143C5.52409 6.76335 5.52363 6.76424 5.52354 6.76441L4.01139 9.27397L4.97714 9.8068C5.35908 10.0175 5.56035 10.4515 5.47451 10.8792C5.32269 11.6355 5.32269 12.4125 5.47451 13.1689C5.56035 13.5966 5.35907 14.0306 4.97714 14.2413L4.0246 14.7668L5.52694 17.2818C5.5269 17.2817 5.52695 17.2818 5.52694 17.2818C5.52711 17.2821 5.52779 17.2831 5.53004 17.2847C5.53346 17.2872 5.54033 17.2911 5.55077 17.2938C5.57297 17.2995 5.59297 17.2959 5.60773 17.2877L6.55269 16.7639C6.91009 16.5658 7.35208 16.605 7.66896 16.863C8.29031 17.369 9.00451 17.763 9.77693 18.0243C10.188 18.1634 10.4624 18.5516 10.4564 18.9855L10.4425 19.9889C10.4494 19.994 10.4624 20.0002 10.4836 20L13.5037 19.9722C13.5243 19.972 13.5368 19.9659 13.5434 19.961V18.9032C13.5434 18.4744 13.8168 18.0933 14.223 17.9559C14.9954 17.6947 15.7096 17.3006 16.331 16.7947C16.6479 16.5366 17.0899 16.4974 17.4473 16.6955L18.3956 17.2212C18.4103 17.2294 18.4303 17.233 18.4524 17.2273C18.4629 17.2246 18.4697 17.2208 18.4732 17.2183C18.4759 17.2164 18.4763 17.2155 18.4764 17.2153L19.9886 14.7057L19.0228 14.1729C18.6402 13.9618 18.439 13.5267 18.5259 13.0985C18.6001 12.7324 18.6381 12.3605 18.6393 11.9878C18.6401 11.605 18.6021 11.223 18.5259 10.847C18.439 10.4188 18.6402 9.9837 19.0228 9.77261L19.9754 9.24708L18.473 6.73208C18.473 6.73196 18.4725 6.7311 18.4699 6.72918C18.4665 6.72669 18.4596 6.72281 18.4492 6.72011C18.427 6.71438 18.407 6.71797 18.3922 6.72615L17.4473 7.25001C17.0899 7.44814 16.6479 7.40887 16.331 7.15085C15.7096 6.6449 14.9954 6.25085 14.223 5.98957C13.8146 5.85143 13.5408 5.46711 13.5435 5.036L13.5499 4.01114Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9922 9.99219C10.8876 9.99219 9.99219 10.8876 9.99219 11.9922C9.99219 13.0968 10.8876 13.9922 11.9922 13.9922C13.0968 13.9922 13.9922 13.0968 13.9922 11.9922C13.9922 10.8876 13.0968 9.99219 11.9922 9.99219ZM7.99219 11.9922C7.99219 9.78305 9.78305 7.99219 11.9922 7.99219C14.2013 7.99219 15.9922 9.78305 15.9922 11.9922C15.9922 14.2013 14.2013 15.9922 11.9922 15.9922C9.78305 15.9922 7.99219 14.2013 7.99219 11.9922Z",
      fill: "currentColor"
    }
  )
] }), SettingsSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.98828 5.24219C6.4695 5.24219 5.23828 6.4734 5.23828 7.99219C5.23828 9.51097 6.4695 10.7422 7.98828 10.7422C9.50706 10.7422 10.7383 9.51097 10.7383 7.99219C10.7383 6.4734 9.50706 5.24219 7.98828 5.24219ZM6.73828 7.99219C6.73828 7.30183 7.29792 6.74219 7.98828 6.74219C8.67864 6.74219 9.23828 7.30183 9.23828 7.99219C9.23828 8.68254 8.67864 9.24219 7.98828 9.24219C7.29792 9.24219 6.73828 8.68254 6.73828 7.99219Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.29794 1C6.35769 1 5.51404 1.69688 5.44602 2.66351C5.08514 2.81844 4.7403 3.00601 4.41637 3.22387C3.56417 2.80319 2.48461 3.07169 1.97297 3.90457L1.25941 5.06615C0.735272 5.91937 1.03695 6.98077 1.85519 7.48587C1.82081 7.8364 1.82083 8.18921 1.85525 8.53974C1.04545 9.04544 0.746419 10.0985 1.26406 10.9485L1.97299 12.1126C2.48212 12.9486 3.56241 13.2201 4.4162 12.801C4.73917 13.0182 5.08292 13.2054 5.44262 13.36C5.5225 14.3195 6.37037 15.0084 7.31021 14.9999L8.70849 14.9873C9.64581 14.9789 10.4813 14.2787 10.5437 13.3137C10.9042 13.1589 11.2487 12.9715 11.5723 12.7539C12.4262 13.1827 13.5132 12.9155 14.0271 12.0789L14.7407 10.9173C15.2671 10.0604 14.9606 8.99361 14.1344 8.49113C14.1507 8.325 14.1591 8.15814 14.1596 7.99105C14.16 7.81415 14.1515 7.63674 14.1342 7.46087C14.9432 6.95242 15.2388 5.89699 14.7167 5.04817L14.0036 3.88897C13.4948 3.06192 12.4254 2.79165 11.5755 3.202C11.2502 2.98295 10.9037 2.79446 10.5411 2.63893C10.4607 1.68509 9.62337 1 8.69111 1H7.29794ZM6.9416 2.78979C6.9416 2.6729 7.05662 2.5 7.29794 2.5H8.69111C8.93243 2.5 9.04745 2.6729 9.04745 2.78979V3.15817C9.04745 3.48138 9.25451 3.76823 9.56127 3.87001C10.1054 4.05054 10.6077 4.32256 11.0441 4.67109C11.2785 4.85836 11.6021 4.88785 11.8665 4.74606L12.2132 4.5602C12.4099 4.45474 12.6399 4.53495 12.726 4.6749L13.4391 5.8341C13.4789 5.89886 13.4847 5.96453 13.4674 6.02512C13.4498 6.08681 13.4041 6.15492 13.3152 6.20305L12.9581 6.39628C12.667 6.55383 12.5136 6.88362 12.5806 7.20779C12.6337 7.46462 12.6602 7.72548 12.6596 7.98679C12.6588 8.24145 12.6324 8.49559 12.5806 8.74589C12.5136 9.07006 12.667 9.39985 12.9581 9.5574L13.3386 9.76335C13.4275 9.81145 13.4732 9.87953 13.4909 9.9412C13.5082 10.0018 13.5024 10.0674 13.4626 10.1321L12.749 11.2937C12.6626 11.4345 12.4309 11.5145 12.2342 11.4075L11.8704 11.2097C11.6054 11.0656 11.2798 11.0943 11.0441 11.2826C10.6077 11.6311 10.1054 11.9032 9.56127 12.0837C9.25451 12.1855 9.04745 12.4723 9.04745 12.7955V13.1976C9.04745 13.3138 8.93417 13.4852 8.69496 13.4874L7.29668 13.5C7.0507 13.5022 6.93484 13.3249 6.93651 13.207L6.94152 12.8537C6.94616 12.5266 6.73826 12.2342 6.42778 12.1312C5.88367 11.9507 5.38135 11.6787 4.94498 11.3301C4.70926 11.1419 4.38367 11.1132 4.11864 11.2573L3.76951 11.4471C3.57212 11.5544 3.34005 11.4735 3.25412 11.3324L2.54519 10.1683C2.50586 10.1037 2.5002 10.0383 2.5176 9.97783C2.53532 9.91629 2.58105 9.84841 2.66971 9.80043L3.03095 9.60494C3.32157 9.44767 3.47502 9.11871 3.40877 8.79497C3.30297 8.27797 3.30297 7.74702 3.40877 7.23002C3.47502 6.90628 3.32158 6.57733 3.03096 6.42005L2.66147 6.2201C2.57258 6.17199 2.52685 6.10391 2.50923 6.04225C2.49192 5.98167 2.49775 5.91603 2.53751 5.8513L3.25108 4.68972C3.33752 4.549 3.56916 4.46894 3.76591 4.57592L4.11864 4.76772C4.38367 4.91184 4.70926 4.88313 4.94498 4.69486C5.38135 4.34632 5.88367 4.07431 6.42778 3.89378C6.73454 3.792 6.9416 3.50514 6.9416 3.18194V2.78979Z",
      fill: "currentColor"
    }
  )
] }), ShareLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.592 3.08949C12.9492 2.9273 13.3683 2.98894 13.6636 3.24711L22.6581 11.1095C22.8731 11.2974 22.9975 11.5683 23 11.8538C23.0024 12.1394 22.8827 12.4123 22.6709 12.6039L13.6764 20.7416C13.3832 21.0068 12.9612 21.0744 12.5998 20.914C12.2384 20.7537 12.0055 20.3954 12.0055 20V15.2445C7.94268 15.0211 5.67438 15.8322 4.44637 16.6176C3.78477 17.0408 3.4 17.4717 3.18711 17.7719C3.07991 17.923 3.01462 18.0435 2.9793 18.1162C2.96163 18.1526 2.95147 18.1771 2.94734 18.1875C2.94677 18.1889 2.94632 18.19 2.94598 18.1909C2.78898 18.6493 2.32483 18.9301 1.84448 18.8545C1.35823 18.778 1 18.3589 1 17.8667C1 13.5259 4.2293 11.1182 7.09755 9.84696C8.55452 9.20123 9.99999 8.80698 11.0738 8.57392C11.4262 8.49742 11.7409 8.43781 12.0055 8.39213V4.00002C12.0055 3.60773 12.2349 3.25167 12.592 3.08949ZM13.1089 10.2503L13.1062 10.2506L13.0881 10.2527C13.071 10.2546 13.0439 10.2578 13.0075 10.2625C12.9347 10.2717 12.8249 10.2864 12.6833 10.308C12.3999 10.3512 11.9907 10.4215 11.498 10.5284C10.5082 10.7432 9.20234 11.1017 7.90793 11.6754C6.38355 12.351 4.98005 13.2711 4.06791 14.5321C5.90524 13.5903 8.74174 12.9363 13.0928 13.3175C13.6093 13.3628 14.0055 13.7953 14.0055 14.3137V17.7467L20.4953 11.8752L14.0055 6.20234V9.2557C14.0055 9.76771 13.6181 10.197 13.1089 10.2503C13.1091 10.2503 13.1087 10.2504 13.1089 10.2503Z",
    fill: "currentColor"
  }
) }), ShareSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89433 2.06891C9.1601 1.94638 9.47286 1.98963 9.6954 2.17969L15.7371 7.33939C15.9022 7.48043 15.9981 7.68614 16 7.90332C16.0018 8.1205 15.9094 8.32782 15.7467 8.47165L9.70504 13.812C9.48404 14.0073 9.16905 14.055 8.90014 13.9338C8.63123 13.8126 8.45833 13.545 8.45833 13.25V10.2218C5.5082 10.0793 3.73708 10.61 2.72038 11.142C2.17206 11.4289 1.83168 11.7219 1.63651 11.9262C1.53848 12.0289 1.47589 12.1104 1.4414 12.1593C1.42414 12.1838 1.41387 12.2002 1.40971 12.2071C1.40917 12.2079 1.40873 12.2087 1.40839 12.2092C1.24571 12.5076 0.902086 12.6597 0.571051 12.5784C0.235738 12.496 0 12.1953 0 11.85C0 8.87978 2.5697 7.29698 4.71371 6.4856C5.82625 6.06457 6.93006 5.80749 7.75004 5.65551C8.0179 5.60587 8.25708 5.56715 8.45833 5.53746V2.75001C8.45833 2.45736 8.62856 2.19144 8.89433 2.06891ZM9.27466 6.94611L9.27194 6.94636L9.25732 6.94777C9.24369 6.94911 9.22239 6.95126 9.19395 6.95434C9.13704 6.96049 9.05159 6.97031 8.9417 6.98462C8.72175 7.01325 8.40479 7.05971 8.0234 7.1304C7.25744 7.27236 6.24667 7.50928 5.24463 7.8885C4.10571 8.31951 3.09379 8.88585 2.40991 9.62555C3.82662 8.98464 5.99704 8.51132 9.26763 8.77072C9.65763 8.80166 9.95833 9.12716 9.95833 9.51838V11.5861L14.1065 7.91945L9.95833 4.37681V6.19905C9.95833 6.58745 9.66149 6.9116 9.27466 6.94611Z",
    fill: "currentColor"
  }
) }), ShieldLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8389 2.01615C11.9454 1.99462 12.0546 1.99462 12.1611 2.01615L20.2611 3.65329C20.689 3.73978 21 4.15389 21 4.63714V11.0229C20.9998 13.6343 20.1032 16.1506 18.4839 18.1452C16.8664 20.1376 14.6289 21.4868 12.1605 21.984C12.0544 22.0053 11.9456 22.0053 11.8395 21.984C9.37112 21.4868 7.13365 20.1376 5.51611 18.1452C3.89682 16.1506 3.00023 13.6344 3 11.023V4.63714C3 4.15389 3.31102 3.73978 3.73893 3.65329L11.8389 2.01615ZM4.8 5.47165V11.0228C4.80021 13.1174 5.51819 15.1618 6.85267 16.8055C8.15475 18.4094 9.96641 19.5346 12 19.9822C14.0336 19.5346 15.8452 18.4094 17.1473 16.8055C18.4818 15.1618 19.1998 13.1175 19.2 11.0229V5.47165L12 4.01641L4.8 5.47165Z",
    fill: "currentColor"
  }
) }), ShieldSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86577 1.01211C7.95453 0.995964 8.04547 0.995964 8.13423 1.01211L14.3842 2.14901C14.7408 2.21388 15 2.52446 15 2.8869V7.32143C14.9998 9.14928 14.3025 10.9098 13.0443 12.3047C11.7875 13.6979 10.0498 14.6407 8.13377 14.988C8.04531 15.004 7.95469 15.004 7.86623 14.988C5.95022 14.6407 4.21253 13.6979 2.95575 12.3047C1.6975 10.9098 1.00018 9.14935 1 7.3215V2.8869C1 2.52446 1.25918 2.21388 1.61577 2.14901L7.86577 1.01211ZM2.5 3.51278V7.32135C2.50016 8.76164 3.04865 10.1682 4.06954 11.3C5.06348 12.4018 6.44636 13.1765 8 13.4866C9.55363 13.1765 10.9365 12.4018 11.9305 11.3C12.9514 10.1682 13.4998 8.76171 13.5 7.32143V3.51278L8 2.51231L2.5 3.51278Z",
    fill: "currentColor"
  }
) }), ShipLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C9.44772 1 9 1.44772 9 2C9 2.55228 9.44772 3 10 3H11V5H8.8468C7.73078 5 6.74993 5.7397 6.44313 6.81272L5.03854 11.7251L5.03457 11.7394C3.81215 12.2452 3.17397 13.6463 3.65387 14.926L5.92915 20.9934C5.72029 20.9833 5.51569 20.9301 5.32848 20.837C5.11933 20.7331 4.93783 20.5825 4.79802 20.3974C4.46515 19.9566 3.83805 19.8692 3.39735 20.2021C2.95665 20.535 2.86923 21.1621 3.20209 21.6028C3.5291 22.0357 3.95249 22.3866 4.43852 22.6281C4.92452 22.8696 5.46003 22.9952 6.00279 22.9952C6.54555 22.9952 7.08106 22.8696 7.56706 22.6281C7.72004 22.5521 7.86573 22.4655 8.00358 22.3694C8.14348 22.4661 8.28992 22.5524 8.44132 22.6277C8.9269 22.8695 9.46212 22.9952 10.0046 22.9952C10.5471 22.9952 11.0823 22.8695 11.5679 22.6277C11.7188 22.5526 11.8636 22.467 12.0013 22.3715C12.1396 22.4679 12.285 22.5545 12.4367 22.6303C12.9228 22.8735 13.4591 23.0001 14.0028 23.0001C14.5464 23.0001 15.0828 22.8735 15.5689 22.6303C15.7205 22.5545 15.866 22.4679 16.0042 22.3715C16.142 22.467 16.2868 22.5526 16.4377 22.6277C16.9233 22.8695 17.4585 22.9952 18.001 22.9952C18.5435 22.9952 19.0787 22.8695 19.5643 22.6277C20.0499 22.386 20.4727 22.0348 20.7989 21.6016C21.1311 21.1604 21.0428 20.5334 20.6016 20.2012C20.1604 19.869 19.5334 19.9573 19.2012 20.3985C19.0621 20.5832 18.8814 20.7336 18.673 20.8373C18.4853 20.9307 18.2801 20.9839 18.0706 20.9936L20.3459 14.926C20.8258 13.6464 20.1877 12.2454 18.9655 11.7395L18.9615 11.7251L17.5569 6.81272C17.2501 5.7397 16.2692 5 15.1532 5H13V3H14C14.5523 3 15 2.55228 15 2C15 1.44772 14.5523 1 14 1H10ZM16.2911 20.0428L18.4733 14.2237C18.5781 13.9441 18.4161 13.6355 18.1264 13.5631L12.1212 12.0618C12.0415 12.0419 11.9582 12.0419 11.8786 12.0618L5.87342 13.5631C5.5837 13.6355 5.42167 13.9441 5.52652 14.2237L7.70889 20.0434C7.80243 20.0149 7.90069 20 8.00078 20.0001C8.31461 20.0003 8.61012 20.1478 8.7989 20.3985C8.9343 20.5783 9.1186 20.7308 9.33258 20.8373C9.54099 20.9411 9.77109 20.9952 10.0046 20.9952C10.2381 20.9952 10.4682 20.9411 10.6766 20.8373C10.794 20.7789 10.9027 20.7056 11 20.6198V15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V20.6156C13.0992 20.7051 13.2106 20.7812 13.3314 20.8416C13.5395 20.9457 13.7694 21.0001 14.0028 21.0001C14.2362 21.0001 14.4661 20.9457 14.6742 20.8416C14.8822 20.7376 15.0624 20.5868 15.2007 20.4016C15.389 20.1495 15.6852 20.0007 15.9999 20.0001C16.0997 19.9999 16.1978 20.0146 16.2911 20.0428ZM12.6062 10.1215L16.7166 11.1491L15.634 7.36254C15.5726 7.14794 15.3764 7 15.1532 7H8.8468C8.6236 7 8.42743 7.14794 8.36607 7.36254L7.2834 11.1491L11.3936 10.1215C11.7917 10.022 12.2081 10.022 12.6062 10.1215Z",
    fill: "currentColor"
  }
) }), ShipSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00024 0C6.58603 0 6.25024 0.336193 6.25024 0.750909C6.25024 1.16562 6.58603 1.50182 7.00024 1.50182H7.25024V2.812H5.94096C5.1248 2.812 4.41701 3.37685 4.23502 4.17343L3.34197 8.08233C2.49852 8.45524 2.08135 9.43123 2.41575 10.3089L4.00829 14.4886C3.94539 14.4781 3.86947 14.4484 3.78266 14.3826C3.66429 14.2929 3.53421 14.1408 3.42215 13.9144C3.23819 13.5428 2.78821 13.3909 2.41709 13.5751C2.04596 13.7593 1.89423 14.2098 2.07819 14.5814C2.27247 14.9738 2.53935 15.3238 2.87719 15.5799C3.21887 15.839 3.62624 15.9951 4.06446 15.9951C4.50268 15.9951 4.91004 15.839 5.25173 15.5799C5.2951 15.5471 5.3372 15.5127 5.37804 15.4769C5.41894 15.5126 5.46091 15.5468 5.50393 15.5795C5.84526 15.8387 6.25247 15.9951 6.69065 15.9951C7.12884 15.9951 7.53604 15.8387 7.87738 15.5795C7.9195 15.5475 7.96051 15.5141 8.00041 15.4792C8.04099 15.5149 8.08272 15.5492 8.12561 15.5819C8.46711 15.8425 8.87511 16 9.31446 16C9.75381 16 10.1618 15.8425 10.5033 15.5819C10.5462 15.5492 10.5879 15.5149 10.6285 15.4792C10.6684 15.5141 10.7094 15.5475 10.7515 15.5795C11.0929 15.8387 11.5001 15.9951 11.9383 15.9951C12.3764 15.9951 12.7837 15.8387 13.125 15.5795C13.4625 15.3232 13.7288 14.973 13.9225 14.5806C14.1061 14.2088 13.9538 13.7584 13.5824 13.5747C13.2111 13.391 12.7613 13.5434 12.5778 13.9152C12.4661 14.1414 12.3364 14.2934 12.2185 14.383C12.131 14.4494 12.0547 14.4788 11.9919 14.4889L13.5845 10.3089C13.9189 9.43125 13.5018 8.45528 12.6584 8.08235L11.7653 4.17342C11.5833 3.37685 10.8755 2.812 10.0594 2.812H8.75024V1.50182H9.00024C9.41446 1.50182 9.75024 1.16562 9.75024 0.750909C9.75024 0.336194 9.41446 0 9.00024 0H7.00024ZM10.7598 13.5089L12.1831 9.7736C12.2332 9.64192 12.165 9.49476 12.0321 9.44816L8.0828 8.06288C8.02929 8.04411 7.971 8.04411 7.91749 8.06288L3.96816 9.44816C3.83532 9.49476 3.76707 9.64193 3.81724 9.7736L5.24055 13.5091C5.28464 13.5011 5.32981 13.4969 5.37562 13.497C5.6608 13.4971 5.9212 13.6592 6.04755 13.9152C6.15699 14.1369 6.28914 14.2908 6.41045 14.383C6.52455 14.4696 6.61959 14.4933 6.69065 14.4933C6.76172 14.4933 6.85676 14.4696 6.97086 14.383C7.08882 14.2934 7.21853 14.1414 7.33018 13.9152C7.36082 13.8531 7.39934 13.7966 7.44419 13.7465C7.32367 13.6133 7.25024 13.4365 7.25024 13.2426V9.23774C7.25024 8.82303 7.58603 8.48683 8.00024 8.48683C8.41446 8.48683 8.75024 8.82303 8.75024 9.23774V13.2426C8.75024 13.4353 8.67776 13.611 8.55861 13.7439C8.60498 13.7952 8.64468 13.8534 8.67601 13.9174C8.78728 14.1447 8.91696 14.2975 9.03494 14.3875C9.14903 14.4746 9.24388 14.4982 9.31446 14.4982C9.38504 14.4982 9.47989 14.4746 9.59398 14.3875C9.71195 14.2975 9.84164 14.1447 9.95291 13.9174C10.0787 13.6605 10.3394 13.4974 10.6251 13.497C10.6708 13.4969 10.7159 13.501 10.7598 13.5089ZM8.57876 6.64553L10.9841 7.48924L10.3031 4.5083C10.2771 4.39451 10.176 4.31381 10.0594 4.31381H5.94096C5.82437 4.31381 5.72326 4.39451 5.69726 4.50831L5.01622 7.48922L7.42153 6.64553C7.79611 6.51414 8.20418 6.51414 8.57876 6.64553Z",
    fill: "currentColor"
  }
) }), ShopLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx("g", { id: "Small size=No", children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.00001L11.9958 2H8.00418L8.00209 2L8 2H4.99791C4.5938 2 4.22941 2.24322 4.0744 2.61642L2.07649 7.42663C2.02599 7.54821 2 7.67856 2 7.81021C2 8.70217 2.40565 9.52602 3.07334 10.1109C3.35023 10.3534 3.66389 10.5484 4 10.6932V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H20V10.6932C20.3361 10.5484 20.6498 10.3534 20.9267 10.1109C21.5943 9.52602 22 8.70217 22 7.81021C22 7.67856 21.974 7.54821 21.9235 7.42663L19.9256 2.61642C19.7706 2.24322 19.4062 2 19.0021 2H16L15.9979 2L15.9958 2H12.0042L12 2.00001ZM17 20H18V10.9674C17.293 10.8746 16.6194 10.5857 16.0826 10.1189C15.8326 10.3717 15.5402 10.5794 15.2168 10.7298C14.8354 10.9072 14.421 11 14 11C13.579 11 13.1646 10.9072 12.7832 10.7298C12.4947 10.5957 12.231 10.416 12 10.1994C11.769 10.416 11.5053 10.5957 11.2168 10.7298C10.8354 10.9072 10.421 11 10 11C9.57902 11 9.16464 10.9072 8.7832 10.7298C8.45977 10.5794 8.16741 10.3717 7.91741 10.1189C7.3806 10.5857 6.70696 10.8746 6 10.9674V20H7V15.5C7 14.1193 8.11929 13 9.5 13H14.5C15.8807 13 17 14.1193 17 15.5V20ZM9 20V15.5C9 15.2239 9.22386 15 9.5 15H14.5C14.7761 15 15 15.2239 15 15.5V20H9ZM11 7.85163C11 7.82616 10.9992 7.80064 10.9976 7.77511C10.9964 7.75505 10.9958 7.73495 10.9958 7.71485V4H9.00418V7.71485C9.00418 7.73495 9.00358 7.75505 9.00237 7.77511C8.99233 7.9413 9.01432 8.10697 9.06579 8.26106C9.11723 8.41508 9.19609 8.55157 9.29397 8.66364C9.3917 8.77555 9.50571 8.86014 9.6265 8.91631C9.74703 8.97236 9.87391 9 10 9C10.1261 9 10.253 8.97236 10.3735 8.91631C10.4943 8.86014 10.6083 8.77555 10.706 8.66364C10.8039 8.55157 10.8828 8.41508 10.9342 8.26106C10.9778 8.13065 11.0002 7.99194 11 7.85163ZM13 7.85163C12.9998 7.99194 13.0222 8.13065 13.0658 8.26106C13.1172 8.41508 13.1961 8.55157 13.294 8.66364C13.3917 8.77555 13.5057 8.86014 13.6265 8.91631C13.747 8.97236 13.8739 9 14 9C14.1261 9 14.253 8.97236 14.3735 8.91631C14.4943 8.86014 14.6083 8.77555 14.706 8.66364C14.8039 8.55157 14.8828 8.41508 14.9342 8.26106C14.9857 8.10697 15.0077 7.9413 14.9976 7.77511C14.9964 7.75505 14.9958 7.73495 14.9958 7.71485V4H13.0042V7.71485C13.0042 7.73495 13.0036 7.75505 13.0024 7.77511C13.0008 7.80064 13 7.82616 13 7.85163ZM5.66539 4L4.01479 7.97401C4.05448 8.19381 4.17519 8.41725 4.39113 8.60639C4.66536 8.84659 5.06254 9 5.5 9C5.93746 9 6.33464 8.84659 6.60887 8.60639C6.87887 8.3699 7 8.07978 7 7.81021V4H5.66539ZM18.3346 4L19.9852 7.97401C19.9455 8.19381 19.8248 8.41725 19.6089 8.60639C19.3346 8.84659 18.9375 9 18.5 9C18.0625 9 17.6654 8.84659 17.3911 8.60639C17.1211 8.3699 17 8.07978 17 7.81021V4H18.3346Z",
    fill: "currentColor"
  }
) }) }), ShopSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx("g", { id: "Small size=Yes", children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.00001L7.99707 1H5.20293L5.20146 1L5.2 1H3.09854C2.81566 1 2.56058 1.17026 2.45208 1.4315L1.05354 4.79864C1.0182 4.88375 1 4.97499 1 5.06715C1 5.69152 1.28396 6.26822 1.75134 6.6776C1.94516 6.84737 2.16472 6.98385 2.4 7.08524V13.6H1.7C1.3134 13.6 1 13.9134 1 14.3C1 14.6866 1.3134 15 1.7 15H14.3C14.6866 15 15 14.6866 15 14.3C15 13.9134 14.6866 13.6 14.3 13.6H13.6V7.08524C13.8353 6.98385 14.0548 6.84737 14.2487 6.6776C14.716 6.26822 15 5.69152 15 5.06715C15 4.97499 14.9818 4.88375 14.9465 4.79864L13.5479 1.4315C13.4394 1.17026 13.1843 1 12.9015 1H10.8L10.7985 1L10.7971 1H8.00293L8 1.00001ZM11.5 13.6H12.2V7.27715C11.7051 7.21224 11.2336 7.01 10.8578 6.68325C10.6828 6.86021 10.4782 7.0056 10.2518 7.11088C9.98475 7.23504 9.69469 7.3 9.4 7.3C9.10531 7.3 8.81525 7.23504 8.54824 7.11088C8.34632 7.01699 8.16171 6.89119 8 6.73955C7.83829 6.89119 7.65368 7.01699 7.45176 7.11088C7.18475 7.23504 6.89469 7.3 6.6 7.3C6.30531 7.3 6.01525 7.23504 5.74824 7.11088C5.52184 7.0056 5.31719 6.86021 5.14219 6.68325C4.76642 7.01 4.29487 7.21224 3.8 7.27715V13.6H4.5V10.45C4.5 9.4835 5.2835 8.7 6.25 8.7H9.75C10.7165 8.7 11.5 9.4835 11.5 10.45V13.6ZM5.9 13.6V10.45C5.9 10.2567 6.0567 10.1 6.25 10.1H9.75C9.9433 10.1 10.1 10.2567 10.1 10.45V13.6H5.9ZM7.3 5.09614C7.29997 5.07831 7.29942 5.06045 7.29834 5.04258C7.2975 5.02853 7.29707 5.01447 7.29707 5.0004V2.4H5.90293V5.0004C5.90293 5.01447 5.9025 5.02853 5.90166 5.04258C5.89463 5.15891 5.91003 5.27488 5.94605 5.38274C5.98206 5.49056 6.03726 5.5861 6.10578 5.66455C6.17419 5.74288 6.25399 5.8021 6.33855 5.84142C6.42292 5.88065 6.51174 5.9 6.6 5.9C6.68826 5.9 6.77708 5.88065 6.86145 5.84142C6.94601 5.8021 7.02581 5.74288 7.09422 5.66455C7.16274 5.5861 7.21794 5.49055 7.25395 5.38274C7.28444 5.29145 7.30015 5.19436 7.3 5.09614ZM8.7 5.09614C8.69985 5.19436 8.71556 5.29145 8.74605 5.38274C8.78206 5.49055 8.83726 5.5861 8.90578 5.66455C8.97419 5.74288 9.05399 5.8021 9.13855 5.84142C9.22292 5.88065 9.31174 5.9 9.4 5.9C9.48826 5.9 9.57708 5.88065 9.66145 5.84142C9.74601 5.8021 9.82581 5.74288 9.89422 5.66455C9.96274 5.5861 10.0179 5.49056 10.0539 5.38274C10.09 5.27488 10.1054 5.15891 10.0983 5.04258C10.0975 5.02853 10.0971 5.01447 10.0971 5.0004V2.4H8.70293V5.0004C8.70293 5.01447 8.7025 5.02853 8.70166 5.04258C8.70058 5.06045 8.70003 5.07831 8.7 5.09614ZM3.56577 2.4L2.41035 5.18181C2.43813 5.33567 2.52264 5.49207 2.67379 5.62447C2.86575 5.79262 3.14378 5.9 3.45 5.9C3.75622 5.9 4.03425 5.79262 4.22621 5.62447C4.41521 5.45893 4.5 5.25585 4.5 5.06715V2.4H3.56577ZM12.4342 2.4L13.5896 5.18181C13.5619 5.33567 13.4774 5.49207 13.3262 5.62447C13.1342 5.79262 12.8562 5.9 12.55 5.9C12.2438 5.9 11.9658 5.79262 11.7738 5.62447C11.5848 5.45893 11.5 5.25585 11.5 5.06715V2.4H12.4342Z",
    fill: "currentColor"
  }
) }) }), ShowLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7.99997C9.79086 7.99997 8 9.79083 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79083 14.2091 7.99997 12 7.99997ZM10 12C10 10.8954 10.8954 9.99997 12 9.99997C13.1046 9.99997 14 10.8954 14 12C14 13.1045 13.1046 14 12 14C10.8954 14 10 13.1045 10 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.71455 6.00773C7.62038 4.67382 9.78517 3.97269 12 4.00078C14.2148 3.97269 16.3796 4.67382 18.2854 6.00773C20.1919 7.34212 21.7727 9.26176 22.8981 11.5603C23.034 11.8377 23.034 12.1623 22.8981 12.4397C21.7727 14.7383 20.1919 16.6579 18.2854 17.9923C16.3796 19.3262 14.2148 20.0273 12 19.9992C9.78517 20.0273 7.62038 19.3262 5.71455 17.9923C3.80805 16.6579 2.22726 14.7383 1.10187 12.4397C0.966042 12.1623 0.966042 11.8377 1.10187 11.5603C2.22726 9.26176 3.80805 7.34212 5.71455 6.00773ZM6.86138 7.64626C8.45322 6.53211 10.2167 5.97587 11.9859 6.00077C11.9953 6.0009 12.0047 6.0009 12.0141 6.00077C13.7833 5.97587 15.5468 6.53211 17.1386 7.64626C18.6172 8.68115 19.9041 10.1681 20.8775 12C19.9041 13.8319 18.6172 15.3189 17.1386 16.3538C15.5468 17.4679 13.7833 18.0242 12.0141 17.9992C12.0047 17.9991 11.9953 17.9991 11.9859 17.9992C10.2167 18.0242 8.45322 17.4679 6.86138 16.3538C5.38279 15.3189 4.09594 13.8319 3.12249 12C4.09594 10.1681 5.38279 8.68115 6.86138 7.64626Z",
      fill: "currentColor"
    }
  )
] }), ShowSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 5.25C6.48122 5.25 5.25 6.48122 5.25 8C5.25 9.51878 6.48122 10.75 8 10.75C9.51878 10.75 10.75 9.51878 10.75 8C10.75 6.48122 9.51878 5.25 8 5.25ZM6.75 8C6.75 7.30964 7.30964 6.75 8 6.75C8.69036 6.75 9.25 7.30964 9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.41893 3.51278C4.80454 2.50953 6.38238 1.97953 8 2.00061C9.61762 1.97953 11.1955 2.50953 12.5811 3.51278C13.9668 4.51612 15.1129 5.95723 15.9279 7.67915C16.024 7.88225 16.024 8.11775 15.9279 8.32085C15.1129 10.0428 13.9668 11.4839 12.5811 12.4872C11.1955 13.4905 9.61762 14.0205 8 13.9994C6.38238 14.0205 4.80454 13.4905 3.41893 12.4872C2.03319 11.4839 0.887078 10.0428 0.0720953 8.32085C-0.0240318 8.11775 -0.0240318 7.88225 0.0720953 7.67915C0.887078 5.95723 2.03319 4.51612 3.41893 3.51278ZM4.29862 4.72774C5.44862 3.89509 6.71854 3.4821 7.98908 3.5006C7.99636 3.5007 8.00364 3.5007 8.01092 3.5006C9.28146 3.4821 10.5514 3.89509 11.7014 4.72774C12.7725 5.50329 13.707 6.62039 14.414 8C13.707 9.3796 12.7725 10.4967 11.7014 11.2723C10.5514 12.1049 9.28146 12.5179 8.01092 12.4994C8.00364 12.4993 7.99636 12.4993 7.98908 12.4994C6.71854 12.5179 5.44862 12.1049 4.29862 11.2723C3.2275 10.4967 2.293 9.37961 1.58597 8C2.293 6.62039 3.2275 5.50329 4.29862 4.72774Z",
      fill: "currentColor"
    }
  )
] }), SingleUseCardLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.00049 5.5V16.5C1.00049 17.8807 2.11978 19 3.50049 19H11.0005C11.5528 19 12.0005 18.5523 12.0005 18C12.0005 17.4477 11.5528 17 11.0005 17H3.50049C3.22435 17 3.00049 16.7761 3.00049 16.5V9H21.0005V10.9688C21.0005 11.521 21.4482 11.9688 22.0005 11.9688C22.5528 11.9688 23.0005 11.521 23.0005 10.9688V5.5C23.0005 4.11929 21.8812 3 20.5005 3H3.50049C2.11978 3 1.00049 4.11929 1.00049 5.5ZM3.50049 5C3.22435 5 3.00049 5.22386 3.00049 5.5V7H21.0005V5.5C21.0005 5.22386 20.7766 5 20.5005 5H3.50049Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.00049 14C4.4482 14 4.00049 14.4477 4.00049 15C4.00049 15.5523 4.4482 16 5.00049 16L10.0005 16C10.5528 16 11.0005 15.5523 11.0005 15C11.0005 14.4477 10.5528 14 10.0005 14L5.00049 14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.0005 15.5C19.0005 15.2136 18.8374 14.9521 18.58 14.8263C18.3227 14.7004 18.0162 14.7321 17.7901 14.908L16.6651 15.783C16.3381 16.0373 16.2792 16.5085 16.5335 16.8355C16.7664 17.1349 17.1812 17.2095 17.5005 17.0246V18.5C17.5005 18.9142 17.8363 19.25 18.2505 19.25C18.6647 19.25 19.0005 18.9142 19.0005 18.5V15.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0005 17C13.0005 14.2386 15.2391 12 18.0005 12C20.7619 12 23.0005 14.2386 23.0005 17C23.0005 19.7614 20.7619 22 18.0005 22C15.2391 22 13.0005 19.7614 13.0005 17ZM18.0005 14C16.3436 14 15.0005 15.3431 15.0005 17C15.0005 18.6569 16.3436 20 18.0005 20C19.6573 20 21.0005 18.6569 21.0005 17C21.0005 15.3431 19.6573 14 18.0005 14Z",
      fill: "currentColor"
    }
  )
] }), SingleUseCardSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 11.639V4.19241C1 3.25772 1.71227 2.5 2.59091 2.5H13.4091C14.2877 2.5 15 3.25772 15 4.19241V7.89455C15 8.26842 14.7151 8.57151 14.3636 8.57151C14.0122 8.57151 13.7273 8.26842 13.7273 7.89455V6.56178H2.27273V11.639C2.27273 11.8259 2.41518 11.9775 2.59091 11.9775H9.27273C9.62418 11.9775 9.90909 12.2806 9.90909 12.6544C9.90909 13.0283 9.62418 13.3314 9.27273 13.3314H2.59091C1.71227 13.3314 1 12.5737 1 11.639ZM2.27273 4.19241C2.27273 4.00547 2.41518 3.85393 2.59091 3.85393H13.4091C13.5848 3.85393 13.7273 4.00547 13.7273 4.19241V5.20785H2.27273V4.19241Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.5704 9.00728C12.8161 9.1351 12.9718 9.40061 12.9718 9.69153V12.7383C12.9718 13.159 12.6513 13.5 12.2558 13.5C11.8604 13.5 11.5398 13.159 11.5398 12.7383V11.2399C11.2349 11.4277 10.8389 11.3519 10.6166 11.0478C10.3738 10.7157 10.4301 10.2372 10.7422 9.97892L11.8162 9.09028C12.0321 8.91168 12.3247 8.87947 12.5704 9.00728Z",
      fill: "currentColor"
    }
  )
] }), SoftwareSyncLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 6C5 5.44772 5.44772 5 6 5H7C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H6C5.44772 7 5 6.55228 5 6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.5 5C8.94772 5 8.5 5.44772 8.5 6C8.5 6.55228 8.94772 7 9.5 7H10.5C11.0523 7 11.5 6.55228 11.5 6C11.5 5.44772 11.0523 5 10.5 5H9.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071L6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929L9.29289 11.2929C9.68342 10.9024 10.3166 10.9024 10.7071 11.2929C11.0976 11.6834 11.0976 12.3166 10.7071 12.7071L8.41421 15L10.7071 17.2929C11.0976 17.6834 11.0976 18.3166 10.7071 18.7071Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071C12.9024 18.3166 12.9024 17.6834 13.2929 17.2929L15.5858 15L13.2929 12.7071C12.9024 12.3166 12.9024 11.6834 13.2929 11.2929C13.6834 10.9024 14.3166 10.9024 14.7071 11.2929L17.7071 14.2929C18.0976 14.6834 18.0976 15.3166 17.7071 15.7071L14.7071 18.7071Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V4.5C22 3.11929 20.8807 2 19.5 2H4.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H19.5C19.7761 4 20 4.22386 20 4.5V8L4 8V4.5ZM4 10L4 19.5C4 19.7761 4.22386 20 4.5 20H19.5C19.7761 20 20 19.7761 20 19.5V10L4 10Z",
      fill: "currentColor"
    }
  )
] }), SoftwareSyncSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.604 4C3.604 3.58579 3.93979 3.25 4.354 3.25H4.854C5.26822 3.25 5.604 3.58579 5.604 4C5.604 4.41421 5.26822 4.75 4.854 4.75H4.354C3.93979 4.75 3.604 4.41421 3.604 4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.9585 3.25C6.54428 3.25 6.2085 3.58579 6.2085 4C6.2085 4.41421 6.54428 4.75 6.9585 4.75H7.4585C7.87271 4.75 8.2085 4.41421 8.2085 4C8.2085 3.58579 7.87271 3.25 7.4585 3.25H6.9585Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.7808 12.0299C6.48816 12.323 6.01329 12.3234 5.72014 12.0308L4.47014 10.783C4.17699 10.4904 4.17657 10.0155 4.4692 9.72233L5.71919 8.47014C6.01182 8.17699 6.4867 8.17657 6.77985 8.4692C7.073 8.76184 7.07342 9.23671 6.78079 9.52986L6.06066 10.2513L6.77986 10.9692C7.07301 11.2618 7.07343 11.7367 6.7808 12.0299Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.2799 12.0308C9.98671 12.3234 9.51184 12.323 9.2192 12.0299C8.92657 11.7367 8.92699 11.2618 9.22014 10.9692L9.93934 10.2513L9.21921 9.52986C8.92658 9.23671 8.927 8.76184 9.22015 8.4692C9.5133 8.17657 9.98818 8.17699 10.2808 8.47014L11.5308 9.72233C11.8234 10.0155 11.823 10.4904 11.5299 10.783L10.2799 12.0308Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.75 1C1.7835 1 1 1.7835 1 2.75V13.25C1 14.2165 1.7835 15 2.75 15H13.25C14.2165 15 15 14.2165 15 13.25V2.75C15 1.7835 14.2165 1 13.25 1H2.75ZM2.5 2.75C2.5 2.61193 2.61193 2.5 2.75 2.5H13.25C13.3881 2.5 13.5 2.61193 13.5 2.75V5.25H2.5V2.75ZM2.5 6.75V13.25C2.5 13.3881 2.61193 13.5 2.75 13.5H13.25C13.3881 13.5 13.5 13.3881 13.5 13.25V6.75H2.5Z",
      fill: "currentColor"
    }
  )
] }), SortLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.3415 8.75258C12.7571 9.11626 13.3889 9.07414 13.7526 8.65851L15.5 6.66147L15.5 20C15.5 20.5523 15.9477 21 16.5 21C17.0523 21 17.5 20.5523 17.5 20L17.5 6.66143L19.2474 8.65851C19.6111 9.07414 20.2429 9.11626 20.6585 8.75258C21.0742 8.3889 21.1163 7.75713 20.7526 7.3415L17.2526 3.3415C17.2175 3.30136 17.1795 3.2644 17.139 3.23079C16.9754 3.09468 16.7675 3.0098 16.5402 3.00081C16.5269 3.00027 16.5135 3 16.5 3C16.4872 3 16.4744 3.00025 16.4617 3.00073C16.1749 3.01155 15.919 3.14314 15.7434 3.34612L12.2474 7.3415C11.8838 7.75713 11.9259 8.3889 12.3415 8.75258Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.5 4.00001C8.5 3.44773 8.05228 3.00001 7.5 3.00001C6.94772 3.00001 6.5 3.44773 6.5 4.00001L6.5 17.3386L4.75259 15.3415C4.38891 14.9259 3.75715 14.8838 3.34151 15.2475C2.92587 15.6111 2.88375 16.2429 3.24744 16.6585L6.74358 20.6541C6.75465 20.6669 6.76604 20.6794 6.77773 20.6916C6.79307 20.7076 6.80893 20.7231 6.82529 20.7381C6.99335 20.8918 7.21407 20.9889 7.45725 20.9991C7.47146 20.9997 7.48572 21 7.50001 21C7.5143 21 7.52855 20.9997 7.54276 20.9991C7.81535 20.9875 8.07211 20.8648 8.25259 20.6585L11.7526 16.6585C12.1163 16.2429 12.0742 15.6111 11.6585 15.2475C11.2429 14.8838 10.6111 14.9259 10.2474 15.3415L8.5 17.3386L8.5 4.00001Z",
      fill: "currentColor"
    }
  )
] }), SortSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.26561 5.47422C8.58888 5.75708 9.08025 5.72433 9.36311 5.40105L10.7222 3.8478L10.7222 14.2222C10.7222 14.6518 11.0704 15 11.5 15C11.9295 15 12.2778 14.6518 12.2778 14.2222V3.84778L13.6369 5.40105C13.9197 5.72433 14.4111 5.75708 14.7344 5.47422C15.0577 5.19136 15.0904 4.69999 14.8075 4.37671L12.0853 1.26561C12.058 1.23439 12.0285 1.20564 11.997 1.17951C11.8697 1.07364 11.7081 1.00763 11.5313 1.00063C11.5209 1.00021 11.5104 1 11.5 1C11.49 1 11.4801 1.00019 11.4702 1.00057C11.2471 1.00898 11.0481 1.11133 10.9115 1.2692L8.19244 4.37671C7.90958 4.69999 7.94233 5.19136 8.26561 5.47422Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.27777 1.77779C5.27777 1.34823 4.92955 1.00001 4.49999 1.00001C4.07044 1.00001 3.72222 1.34823 3.72222 1.77779L3.72222 12.1522L2.36312 10.5989C2.08026 10.2757 1.58889 10.2429 1.26562 10.5258C0.942345 10.8086 0.909587 11.3 1.19245 11.6233L3.91167 14.731C3.92028 14.7409 3.92913 14.7506 3.93823 14.7601C3.95016 14.7726 3.9625 14.7846 3.97522 14.7963C4.10593 14.9158 4.27761 14.9913 4.46674 14.9993C4.4778 14.9998 4.48889 15 4.50001 15C4.51112 15 4.5222 14.9998 4.53326 14.9993C4.74527 14.9902 4.94497 14.8948 5.08534 14.7344L7.80756 11.6233C8.09042 11.3 8.05766 10.8086 7.73439 10.5258C7.41112 10.2429 6.91975 10.2757 6.63689 10.5989L5.27777 12.1522L5.27777 1.77779Z",
      fill: "currentColor"
    }
  )
] }), StopwatchFastLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.55579 2.0025C6.55579 1.44883 7.0035 1 7.55579 1H16.4447C16.997 1 17.4447 1.44883 17.4447 2.0025C17.4447 2.55616 16.997 3.00499 16.4447 3.00499H7.55579C7.0035 3.00499 6.55579 2.55616 6.55579 2.0025Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.9999 6.96016C9.04528 6.96016 6.51585 8.79566 5.48897 11.395C5.2856 11.9097 4.70449 12.1618 4.19101 11.9579C3.67753 11.754 3.42613 11.1714 3.62949 10.6567C4.94817 7.31877 8.19749 4.95516 11.9999 4.95516C16.9704 4.95516 20.9999 8.99464 20.9999 13.9776C20.9999 18.9605 16.9704 23 11.9999 23C9.87262 23 7.91527 22.2588 6.3747 21.0209C5.94377 20.6746 5.87445 20.0437 6.21988 19.6117C6.5653 19.1796 7.19466 19.1102 7.62559 19.4564C8.82414 20.4196 10.3436 20.995 11.9999 20.995C15.8659 20.995 18.9999 17.8532 18.9999 13.9776C18.9999 10.102 15.8659 6.96016 11.9999 6.96016Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.0001 10.0225C13.0001 9.46881 12.5524 9.01998 12.0001 9.01998C11.4478 9.01998 11.0001 9.46881 11.0001 10.0225V14.0325C11.0001 14.5862 11.4478 15.035 12.0001 15.035H15.0001C15.5524 15.035 16.0001 14.5862 16.0001 14.0325C16.0001 13.4789 15.5524 13.03 15.0001 13.03H13.0001V10.0225Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.00012 14.0325C3.00012 13.4788 3.44784 13.03 4.00012 13.03H8.00004C8.55233 13.03 9.00004 13.4788 9.00004 14.0325C9.00004 14.5861 8.55233 15.035 8.00004 15.035H4.00012C3.44784 15.035 3.00012 14.5861 3.00012 14.0325Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.00012 16.0375C4.44784 16.0375 4.00012 16.4863 4.00012 17.04C4.00012 17.5936 4.44784 18.0424 5.00012 18.0424H10.0001C10.5524 18.0424 11.0001 17.5936 11.0001 17.04C11.0001 16.4863 10.5524 16.0375 10.0001 16.0375H5.00012Z",
      fill: "currentColor"
    }
  )
] }), StopwatchFastSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.75303 1.77778C4.75303 1.34822 5.07987 1 5.48305 1H11.3232C11.7264 1 12.0533 1.34822 12.0533 1.77778C12.0533 2.20733 11.7264 2.55556 11.3232 2.55556L5.48305 2.55556C5.07987 2.55556 4.75303 2.20733 4.75303 1.77778Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.40316 4.62963C7.05042 4.62963 5.84936 5.32058 5.09338 6.39258C4.85119 6.736 4.39356 6.80523 4.07122 6.54721C3.74888 6.28918 3.68391 5.80161 3.92609 5.45818C4.94597 4.01195 6.57187 3.07407 8.40316 3.07407C11.4942 3.07407 14 5.74378 14 9.03704C14 12.3303 11.4942 15 8.40316 15C7.42428 15 6.50206 14.7316 5.70002 14.2595C5.34712 14.0518 5.21909 13.5786 5.41406 13.2026C5.60903 12.8266 6.05317 12.6902 6.40608 12.8979C6.99745 13.246 7.67746 13.4444 8.40316 13.4444C10.6878 13.4444 12.54 11.4712 12.54 9.03704C12.54 6.60289 10.6878 4.62963 8.40316 4.62963Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.13317 5.92593C9.13317 5.49637 8.80632 5.14815 8.40314 5.14815C7.99996 5.14815 7.67312 5.49637 7.67312 5.92593V9.03501C7.67312 9.24129 7.75003 9.43912 7.88694 9.58498C8.02385 9.73084 8.20953 9.81279 8.40314 9.81279H10.8366C11.2397 9.81279 11.5666 9.46457 11.5666 9.03501C11.5666 8.60546 11.2397 8.25723 10.8366 8.25723H9.13317V5.92593Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.00024 8.53067C2.00024 8.10112 2.32708 7.75289 2.73026 7.75289H4.67699C5.08017 7.75289 5.40701 8.10112 5.40701 8.53067C5.40701 8.96023 5.08017 9.30845 4.67699 9.30845H2.73026C2.32708 9.30845 2.00024 8.96023 2.00024 8.53067Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.73002 10.3333C2.32684 10.3333 2 10.6816 2 11.1111C2 11.5407 2.32684 11.8889 2.73002 11.8889H4.67684C5.08002 11.8889 5.40686 11.5407 5.40686 11.1111C5.40686 10.6816 5.08002 10.3333 4.67684 10.3333H2.73002Z",
      fill: "currentColor"
    }
  )
] }), StopwatchFillLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.52797 1C6.97225 1 6.52175 1.44999 6.52175 2.00508C6.52175 2.56017 6.97225 3.01016 7.52797 3.01016H16.4721C17.0278 3.01016 17.4783 2.56017 17.4783 2.00508C17.4783 1.44999 17.0278 1 16.4721 1H7.52797Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 23C16.9706 23 21 18.9751 21 14.0102C21 9.04521 16.9706 5.02032 12 5.02032C7.02944 5.02032 3 9.04521 3 14.0102C3 18.9751 7.02944 23 12 23ZM11.9999 8.81685C12.5556 8.81685 13.0061 9.26684 13.0061 9.82193V13.0048H15.354C15.9097 13.0048 16.3602 13.4548 16.3602 14.0098C16.3602 14.5649 15.9097 15.0149 15.354 15.0149H11.9999C11.4442 15.0149 10.9937 14.5649 10.9937 14.0098V9.82193C10.9937 9.26684 11.4442 8.81685 11.9999 8.81685Z",
      fill: "currentColor"
    }
  )
] }), StopwatchFillSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5 1.3999C4.58579 1.3999 4.25 1.73569 4.25 2.1499C4.25 2.56412 4.58579 2.8999 5 2.8999L11 2.8999C11.4142 2.8999 11.75 2.56412 11.75 2.1499C11.75 1.73569 11.4142 1.3999 11 1.3999H5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 14.6499C11.0376 14.6499 13.5 12.1875 13.5 9.1499C13.5 6.11234 11.0376 3.6499 8 3.6499C4.96243 3.6499 2.5 6.11234 2.5 9.1499C2.5 12.1875 4.96243 14.6499 8 14.6499ZM8 5.40186C8.41421 5.40186 8.75 5.73764 8.75 6.15186V8.3999H10.5C10.9142 8.3999 11.25 8.73569 11.25 9.1499C11.25 9.56412 10.9142 9.8999 10.5 9.8999H8C7.80109 9.8999 7.61032 9.82088 7.46967 9.68023C7.32902 9.53958 7.25 9.34881 7.25 9.1499V6.15186C7.25 5.73764 7.58579 5.40186 8 5.40186Z",
      fill: "currentColor"
    }
  )
] }), StopwatchLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.55573 2.0025C6.55573 1.44883 7.00344 1 7.55573 1H16.4446C16.9969 1 17.4446 1.44883 17.4446 2.0025C17.4446 2.55616 16.9969 3.00499 16.4446 3.00499H7.55573C7.00344 3.00499 6.55573 2.55616 6.55573 2.0025Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.0001 9.79926C13.0001 9.2456 12.5523 8.79676 12.0001 8.79676C11.4478 8.79676 11.0001 9.2456 11.0001 9.79926V13.9764C11.0001 14.5301 11.4478 14.9789 12.0001 14.9789H15.3334C15.8857 14.9789 16.3334 14.5301 16.3334 13.9764C16.3334 13.4228 15.8857 12.9739 15.3334 12.9739H13.0001V9.79926Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.00006 13.9776C3.00006 8.99464 7.02947 4.95516 12 4.95516C16.9705 4.95516 21 8.99464 21 13.9776C21 18.9605 16.9705 23 12 23C7.02947 23 3.00006 18.9605 3.00006 13.9776ZM12 6.96016C8.13404 6.96016 5.00006 10.102 5.00006 13.9776C5.00006 17.8532 8.13404 20.995 12 20.995C15.866 20.995 19 17.8532 19 13.9776C19 10.102 15.866 6.96016 12 6.96016Z",
      fill: "currentColor"
    }
  )
] }), StopwatchSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.08696 1.77778C4.08696 1.34822 4.43734 1 4.86957 1H11.1304C11.5627 1 11.913 1.34822 11.913 1.77778C11.913 2.20733 11.5627 2.55556 11.1304 2.55556L4.86957 2.55556C4.43734 2.55556 4.08696 2.20733 4.08696 1.77778Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.78261 6.44445C8.78261 6.01489 8.43222 5.66667 8 5.66667C7.56778 5.66667 7.21739 6.01489 7.21739 6.44445V9.03704C7.21739 9.24332 7.29984 9.44115 7.44661 9.58701C7.59338 9.73287 7.79244 9.81482 8 9.81482H10.6087C11.0409 9.81482 11.3913 9.46659 11.3913 9.03704C11.3913 8.60748 11.0409 8.25926 10.6087 8.25926H8.78261V6.44445Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 9.03704C2 5.74378 4.68629 3.07407 8 3.07407C11.3137 3.07407 14 5.74378 14 9.03704C14 12.3303 11.3137 15 8 15C4.68629 15 2 12.3303 2 9.03704ZM8 4.62963C5.55074 4.62963 3.56522 6.60289 3.56522 9.03704C3.56522 11.4712 5.55074 13.4444 8 13.4444C10.4493 13.4444 12.4348 11.4712 12.4348 9.03704C12.4348 6.60289 10.4493 4.62963 8 4.62963Z",
      fill: "currentColor"
    }
  )
] }), SubArrowLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M1 8.12387V4C1 3.44772 1.44772 3 2 3C2.55228 3 3 3.44772 3 4L3 8.12387C3 8.85185 3.18706 9.58302 3.5642 10.2786C3.94231 10.9761 4.50729 11.6292 5.24314 12.1914C5.97919 12.7538 6.86604 13.2094 7.85757 13.5232C8.8488 13.8369 9.91717 14 11 14H19.238L15.3598 10.7682C14.9356 10.4147 14.8782 9.78412 15.2318 9.35984C15.5854 8.93556 16.2159 8.87824 16.6402 9.2318L22.6402 14.2318C22.8682 14.4218 23 14.7032 23 15C23 15.2968 22.8682 15.5783 22.6402 15.7682L16.6402 20.7682C16.2159 21.1218 15.5854 21.0645 15.2318 20.6402C14.8782 20.2159 14.9356 19.5854 15.3598 19.2318L19.238 16H11C9.71904 16 8.44675 15.8074 7.25413 15.43C6.0618 15.0527 4.96435 14.4953 4.02893 13.7807C3.09334 13.0659 2.33245 12.203 1.80597 11.2319C1.27852 10.259 1 9.20187 1 8.12387Z",
    fill: "currentColor"
  }
) }), SubArrowSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M0 4.97865V2.75148C0 2.33645 0.336589 2 0.751793 2C1.167 2 1.50359 2.33645 1.50359 2.75148V4.97865C1.50359 5.5454 1.64378 6.11277 1.9241 6.65025C2.20496 7.18877 2.6232 7.69048 3.16515 8.12091C3.7073 8.55149 4.35951 8.8996 5.08763 9.13914C5.81562 9.37862 6.59997 9.50308 7.39477 9.50308H13.0237L10.7788 7.81384C10.4471 7.56424 10.3806 7.09309 10.6303 6.7615C10.88 6.42992 11.3513 6.36346 11.6831 6.61307L15.7003 9.6359C15.8892 9.778 16.0002 10.0006 16 10.2369C15.9998 10.4732 15.8884 10.6956 15.6993 10.8374L11.6821 13.8496C11.3499 14.0987 10.8787 14.0314 10.6295 13.6994C10.3804 13.3674 10.4477 12.8964 10.7798 12.6473L12.9687 11.006H7.39477C6.44483 11.006 5.50153 10.8576 4.61759 10.5668C3.73379 10.276 2.92136 9.8469 2.2298 9.29765C1.53804 8.74826 0.977643 8.08674 0.590819 7.34504C0.20346 6.60233 0 5.79758 0 4.97865Z",
    fill: "currentColor"
  }
) }), SyncLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M6.70711 6.29289C7.09763 6.68342 7.09763 7.31658 6.70711 7.70711L3.41421 11L20.5858 11L17.2929 7.70711C16.9024 7.31658 16.9024 6.68342 17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289L23.7071 11.2929C23.8946 11.4804 24 11.7348 24 12C24 12.2652 23.8946 12.5196 23.7071 12.7071L18.7071 17.7071C18.3166 18.0976 17.6834 18.0976 17.2929 17.7071C16.9024 17.3166 16.9024 16.6834 17.2929 16.2929L20.5858 13L3.41421 13L6.70711 16.2929C7.09763 16.6834 7.09763 17.3166 6.70711 17.7071C6.31658 18.0976 5.68342 18.0976 5.29289 17.7071L0.292893 12.7071C0.105356 12.5196 1.1593e-08 12.2652 0 12C-1.1593e-08 11.7348 0.105356 11.4804 0.292892 11.2929L5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289Z",
    fill: "currentColor"
  }
) }), SyncSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M5.39505 4.16995C5.72119 4.42366 5.75896 4.86928 5.47941 5.16527L3.46885 7.29411L12.5312 7.29411L10.5206 5.16527C10.241 4.86928 10.2788 4.42366 10.6049 4.16995C10.9311 3.91624 11.4221 3.95052 11.7017 4.24651L14.8128 7.54062C15.0624 7.80496 15.0624 8.19504 14.8128 8.45938L11.7016 11.7535C11.4221 12.0495 10.9311 12.0838 10.6049 11.8301C10.2788 11.5763 10.241 11.1307 10.5206 10.8347L12.5312 8.70587H3.46882L5.47941 10.8347C5.75896 11.1307 5.72119 11.5763 5.39505 11.8301C5.06891 12.0838 4.5779 12.0495 4.29835 11.7535L1.18724 8.45938C0.937585 8.19504 0.937585 7.80496 1.18724 7.54062L4.29835 4.24651C4.5779 3.95052 5.06891 3.91624 5.39505 4.16995Z",
    fill: "currentColor"
  }
) }), TabletEditLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.00085 3.51258C5.00085 3.23505 5.22471 3.01006 5.50085 3.01006H14.5009C14.777 3.01006 15.0009 3.23505 15.0009 3.51258V9.04025C15.0009 9.59531 15.4486 10.0453 16.0009 10.0453C16.5531 10.0453 17.0009 9.59531 17.0009 9.04025V3.51258C17.0009 2.12492 15.8816 1 14.5009 1H5.50085C4.12014 1 3.00085 2.12492 3.00085 3.51258V18.588C3.00085 19.9757 4.12014 21.1006 5.50085 21.1006H6.96039C7.51268 21.1006 7.96039 20.6507 7.96039 20.0956C7.96039 19.5405 7.51268 19.0906 6.96039 19.0906H5.50085C5.22471 19.0906 5.00085 18.8656 5.00085 18.588V3.51258Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.5849 11.6903C18.1944 11.2978 17.5612 11.2978 17.1707 11.6903L10.8068 18.0863C10.697 18.1966 10.6143 18.3311 10.5652 18.4791L9.5045 21.6771C9.38473 22.0383 9.47825 22.4364 9.74608 22.7056C10.0139 22.9748 10.4101 23.0688 10.7694 22.9484L13.9514 21.8824C14.0987 21.833 14.2325 21.7499 14.3423 21.6396L20.7062 15.2436C21.0968 14.8511 21.0968 14.2148 20.7062 13.8223L18.5849 11.6903ZM12.3879 19.3398L17.8778 13.8223L18.5849 14.533L13.095 20.0505L12.0343 20.4058L12.3879 19.3398Z",
      fill: "currentColor"
    }
  )
] }), TabletEditSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.57274 1.75C3.57274 1.61193 3.6901 1.5 3.83487 1.5H11.6986C11.8433 1.5 11.9607 1.61193 11.9607 1.75V7.01575C11.9607 7.42997 12.3128 7.76575 12.7471 7.76575C13.1814 7.76575 13.5334 7.42997 13.5334 7.01575V1.75C13.5334 0.783502 12.7119 0 11.6986 0H3.83487C2.8215 0 2 0.783501 2 1.75V14.25C2 15.2165 2.8215 16 3.83487 16H4.59592C5.03023 16 5.3823 15.6642 5.3823 15.25C5.3823 14.8358 5.03023 14.5 4.59592 14.5H3.83487C3.6901 14.5 3.57274 14.3881 3.57274 14.25V1.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.2967 8.54754C11.9902 8.25514 11.4933 8.25458 11.186 8.54628L7.0508 12.4714C6.95195 12.5652 6.88104 12.6824 6.84534 12.811L6.29203 14.8042C6.21971 15.0647 6.2995 15.3422 6.50103 15.5311C6.70257 15.72 6.99486 15.7913 7.26671 15.7177L9.26123 15.1784C9.39032 15.1435 9.5079 15.0777 9.60278 14.9872L13.7697 11.013C14.0768 10.7201 14.0768 10.2452 13.7697 9.95236L12.2967 8.54754ZM8.31119 13.3913L11.7394 10.1373L12.1015 10.4827L8.63537 13.7885L8.16566 13.9155L8.31119 13.3913Z",
      fill: "currentColor"
    }
  )
] }), TabletSearchLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.5 3C5.22386 3 5 3.22386 5 3.5V18.5C5 18.7761 5.22386 19 5.5 19H9C9.55228 19 10 19.4477 10 20C10 20.5523 9.55228 21 9 21H5.5C4.11929 21 3 19.8807 3 18.5V3.5C3 2.11929 4.11929 1 5.5 1H14.5C15.8807 1 17 2.11929 17 3.5V11C17 11.5523 16.5523 12 16 12C15.4477 12 15 11.5523 15 11V3.5C15 3.22386 14.7761 3 14.5 3H5.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 17.5C12 15.567 13.567 14 15.5 14C17.433 14 19 15.567 19 17.5C19 18.1085 18.8447 18.6808 18.5716 19.1793C18.6192 19.2125 18.6646 19.2504 18.7071 19.2929L20.7071 21.2929C21.0976 21.6834 21.0976 22.3166 20.7071 22.7071C20.3166 23.0976 19.6834 23.0976 19.2929 22.7071L17.2929 20.7071C17.2504 20.6646 17.2125 20.6192 17.1793 20.5716C16.6808 20.8447 16.1085 21 15.5 21C13.567 21 12 19.433 12 17.5ZM15.5 16C14.6716 16 14 16.6716 14 17.5C14 18.3284 14.6716 19 15.5 19C16.3284 19 17 18.3284 17 17.5C17 16.6716 16.3284 16 15.5 16Z",
      fill: "currentColor"
    }
  )
] }), TabletSearchSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.82802 1.5C3.6838 1.5 3.56688 1.61193 3.56688 1.75V14.25C3.56688 14.3881 3.6838 14.5 3.82802 14.5H6.65345C7.08614 14.5 7.43689 14.8358 7.43689 15.25C7.43689 15.6642 7.08614 16 6.65345 16H3.82802C2.81843 16 2 15.2165 2 14.25V1.75C2 0.783501 2.81843 0 3.82802 0H11.6624C12.672 0 13.4904 0.783502 13.4904 1.75V7.01575C13.4904 7.42997 13.1397 7.76575 12.707 7.76575C12.2743 7.76575 11.9236 7.42997 11.9236 7.01575V1.75C11.9236 1.61193 11.8066 1.5 11.6624 1.5H3.82802Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.68788 11.25C6.68788 9.73122 7.97399 8.5 9.56049 8.5C11.147 8.5 12.4331 9.73122 12.4331 11.25C12.4331 11.8665 12.2212 12.4356 11.8634 12.8942L13.7705 14.7199C14.0765 15.0128 14.0765 15.4877 13.7705 15.7806C13.4646 16.0735 12.9685 16.0735 12.6626 15.7806L10.6063 13.8121C10.2822 13.9334 9.92947 14 9.56049 14C7.97399 14 6.68788 12.7688 6.68788 11.25ZM9.56049 10C8.83935 10 8.25476 10.5596 8.25476 11.25C8.25476 11.9404 8.83935 12.5 9.56049 12.5C10.2816 12.5 10.8662 11.9404 10.8662 11.25C10.8662 10.5596 10.2816 10 9.56049 10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10678_566220", children: /* @__PURE__ */ jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), TeamLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 6.75079V8.50094C11 9.05322 11.4477 9.50094 12 9.50094C12.5523 9.50094 13 9.05322 13 8.50094V6.75079H14.75C15.3023 6.75079 15.75 6.30308 15.75 5.75079C15.75 5.19851 15.3023 4.75079 14.75 4.75079H13V3.00079C13 2.44851 12.5523 2.00079 12 2.00079C11.4477 2.00079 11 2.44851 11 3.00079V4.75079H9.25C8.69772 4.75079 8.25 5.19851 8.25 5.75079C8.25 6.30308 8.69772 6.75079 9.25 6.75079H11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 18.3992C5.84619 18.3992 5.21327 18.6661 4.74212 19.1507C4.42168 19.4803 4.19408 19.8924 4.08103 20.3427C4.0277 20.5551 4 20.7756 4 20.9992C4 21.5515 3.55228 21.9992 3 21.9992C2.44772 21.9992 2 21.5515 2 20.9992C2 20.6104 2.04817 20.2264 2.14123 19.8557C2.33819 19.0712 2.73687 18.3441 3.30813 17.7566C3.95627 17.0899 4.78586 16.6451 5.68235 16.4758C4.55005 16.1185 3.75 15.0391 3.75 13.8008C3.75 12.2811 4.95485 11.0008 6.5 11.0008C8.04515 11.0008 9.25 12.2811 9.25 13.8008C9.25 15.0391 8.44995 16.1185 7.31765 16.4758C8.21414 16.6451 9.04373 17.0899 9.69187 17.7566C10.2631 18.3441 10.6618 19.0712 10.8588 19.8557C10.9518 20.2264 11 20.6104 11 20.9992C11 21.5515 10.5523 21.9992 10 21.9992C9.44772 21.9992 9 21.5515 9 20.9992C9 20.7756 8.9723 20.5551 8.91897 20.3427C8.80592 19.8924 8.57832 19.4803 8.25788 19.1507C7.78673 18.6661 7.15381 18.3992 6.5 18.3992ZM5.75 13.8008C5.75 13.3322 6.11215 13.0008 6.5 13.0008C6.88785 13.0008 7.25 13.3322 7.25 13.8008C7.25 14.2693 6.88785 14.6008 6.5 14.6008C6.11215 14.6008 5.75 14.2693 5.75 13.8008Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4999 18.3992C16.8462 18.3992 16.2133 18.6661 15.7421 19.1507C15.4217 19.4803 15.1941 19.8924 15.081 20.3427C15.0277 20.5551 15 20.7756 15 20.9992C15 21.5515 14.5523 21.9992 14 21.9992C13.4477 21.9992 13 21.5515 13 20.9992C13 20.6104 13.0482 20.2264 13.1412 19.8557C13.3382 19.0712 13.7369 18.3442 14.3081 17.7566C14.9562 17.0899 15.7858 16.645 16.6823 16.4757C15.55 16.1185 14.75 15.0391 14.75 13.8008C14.75 12.2811 15.9548 11.0008 17.5 11.0008C19.0451 11.0008 20.2499 12.2811 20.2499 13.8008C20.2499 15.0391 19.4499 16.1185 18.3176 16.4758C19.2141 16.6451 20.0437 17.0899 20.6918 17.7566C21.263 18.3442 21.6617 19.0712 21.8587 19.8557C21.9517 20.2264 21.9999 20.6104 21.9999 20.9992C21.9999 21.5515 21.5522 21.9992 20.9999 21.9992C20.4476 21.9992 19.9999 21.5515 19.9999 20.9992C19.9999 20.7756 19.9722 20.5551 19.9189 20.3427C19.8058 19.8924 19.5782 19.4803 19.2578 19.1507C18.7866 18.6661 18.1537 18.3992 17.4999 18.3992ZM16.75 13.8008C16.75 13.3322 17.1122 13.0008 17.5 13.0008C17.8878 13.0008 18.2499 13.3322 18.2499 13.8008C18.2499 14.2694 17.8878 14.6008 17.5 14.6008C17.1122 14.6008 16.75 14.2694 16.75 13.8008Z",
      fill: "currentColor"
    }
  )
] }), TeamSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.77754 2.70927C8.77754 2.31755 8.42933 2 7.99978 2C7.57024 2 7.22203 2.31755 7.22203 2.70927V3.89139H5.92577C5.49623 3.89139 5.14802 4.20895 5.14802 4.60067C5.14802 4.99239 5.49623 5.30994 5.92577 5.30994H7.22203V6.49206C7.22203 6.88378 7.57024 7.20133 7.99978 7.20133C8.42933 7.20133 8.77754 6.88378 8.77754 6.49206V5.30994H10.0738C10.5033 5.30994 10.8515 4.99239 10.8515 4.60067C10.8515 4.20895 10.5033 3.89139 10.0738 3.89139H8.77754V2.70927Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.29894 10.5448C5.02735 10.4267 5.58044 9.84633 5.58044 9.14814C5.58044 8.3647 4.88402 7.7296 4.02494 7.7296C3.16585 7.7296 2.46943 8.3647 2.46943 9.14814C2.46943 9.84637 3.0226 10.4268 3.75108 10.5448C3.04942 10.6029 2.38864 10.883 1.88625 11.3408C1.31886 11.8579 1 12.5593 1 13.2907C1 13.6824 1.34821 14 1.77775 14C2.2073 14 2.55551 13.6824 2.55551 13.2907C2.55551 12.9358 2.71021 12.5954 2.98575 12.3443C3.26132 12.0932 3.63519 11.952 4.02515 11.952C4.41511 11.952 4.78898 12.0932 5.06455 12.3443C5.3401 12.5954 5.49479 12.9358 5.49479 13.2907C5.49479 13.6824 5.84301 14 6.27255 14C6.70209 14 7.0503 13.6824 7.0503 13.2907C7.0503 12.5593 6.73144 11.8579 6.16405 11.3408C5.6616 10.883 5.0007 10.6029 4.29894 10.5448Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.9748 11.952C11.5849 11.952 11.211 12.0932 10.9355 12.3443C10.6599 12.5954 10.5052 12.9358 10.5052 13.2907C10.5052 13.6824 10.157 14 9.72745 14C9.29791 14 8.9497 13.6824 8.9497 13.2907C8.9497 12.5593 9.26856 11.8579 9.83594 11.3408C10.3383 10.883 10.9991 10.6029 11.7008 10.5448C10.9723 10.4268 10.4191 9.84637 10.4191 9.14814C10.4191 8.3647 11.1155 7.7296 11.9746 7.7296C12.8337 7.7296 13.5301 8.3647 13.5301 9.14814C13.5301 9.84633 12.977 10.4267 12.2486 10.5447C12.9504 10.6029 13.6113 10.883 14.1138 11.3408C14.6811 11.8579 15 12.5593 15 13.2907C15 13.6824 14.6518 14 14.2222 14C13.7927 14 13.4445 13.6824 13.4445 13.2907C13.4445 12.9358 13.2898 12.5954 13.0142 12.3443C12.7387 12.0932 12.3648 11.952 11.9748 11.952Z",
      fill: "currentColor"
    }
  )
] }), ThunderLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0127 4.59195L5.01333 13.0316H10.886C11.499 13.0316 11.9872 13.5296 11.9872 14.1331V19.4002L18.9866 10.9606H13.114C12.501 10.9606 12.0127 10.4626 12.0127 9.85909V4.59195ZM12.0638 1.39773C12.7295 0.595125 14.0127 1.08084 14.0127 2.10095V8.96114H20.8985C21.8411 8.96114 22.3351 10.0557 21.7461 10.7658L11.9361 22.5945C11.2705 23.3971 9.98722 22.9113 9.98722 21.8912V15.031H3.10144C2.15888 15.031 1.66487 13.9365 2.25382 13.2264L12.0638 1.39773Z",
    fill: "currentColor"
  }
) }), ThunderSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80932 3.87579L4.25338 8.50778H7.30149C7.80128 8.50778 8.19068 8.91247 8.19068 9.39224V12.1242L11.7466 7.49222H8.69851C8.19871 7.49222 7.80932 7.08754 7.80932 6.60777V3.87579ZM7.7787 1.35163C8.30776 0.66247 9.37459 1.06335 9.37459 1.88841V5.9375H13.1108C13.8647 5.9375 14.2536 6.79069 13.8175 7.35874L8.2213 14.6484C7.69224 15.3375 6.62541 14.9367 6.62541 14.1116V10.0625H2.8892C2.13525 10.0625 1.74641 9.20931 2.1825 8.64127L7.7787 1.35163Z",
    fill: "currentColor"
  }
) }), ToDoLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 3.9662H5.81543C5.29713 3.9662 4.87696 4.41472 4.87696 4.96798V19.9947C4.87696 20.5479 5.29713 20.9964 5.81543 20.9964H18.1846C18.7029 20.9964 19.123 20.5479 19.123 19.9947V4.96798C19.123 4.41471 18.7029 3.9662 18.1846 3.9662H16.9994C16.9831 4.72012 16.6658 5.43956 16.1128 5.97361C15.5486 6.51847 14.7846 6.82634 13.9867 6.83034L13.9813 6.83037L10.0133 6.83035C9.2154 6.82635 8.45137 6.51847 7.88717 5.97361C7.33416 5.43956 7.01692 4.72012 7.00065 3.9662ZM16.9992 1.96265H18.1846C19.7395 1.96265 21 3.30818 21 4.96798V19.9947C21 21.6545 19.7395 23 18.1846 23H5.81543C4.26051 23 3 21.6545 3 19.9947V4.96798C3 3.30818 4.26051 1.96265 5.81543 1.96265H7.00079C7.02208 1.42752 7.47802 1 8.03736 1H15.9627C16.522 1 16.9779 1.42752 16.9992 1.96265ZM9.0747 3.9121V3.00356H14.9253V3.91208C14.9234 4.15409 14.8231 4.38571 14.6458 4.55688C14.4686 4.72804 14.2287 4.82498 13.9782 4.82679H10.0219C9.77127 4.82498 9.53144 4.72804 9.3542 4.55688C9.17695 4.38571 9.07658 4.1541 9.0747 3.9121ZM11.5 10.4492C11.5 10.035 11.8787 9.69922 12.3459 9.69922H16.6541C17.1213 9.69922 17.5 10.035 17.5 10.4492C17.5 10.8634 17.1213 11.1992 16.6541 11.1992H12.3459C11.8787 11.1992 11.5 10.8634 11.5 10.4492ZM10.2985 16.0133C10.5672 15.7127 10.5672 15.2253 10.2985 14.9247C10.0298 14.6241 9.59409 14.6241 9.32539 14.9247L8.05963 16.3408L7.67461 15.91C7.40591 15.6094 6.97024 15.6094 6.70153 15.91C6.43282 16.2106 6.43282 16.6981 6.70153 16.9987L7.57309 17.9738C7.70213 18.1181 7.87714 18.1992 8.05963 18.1992C8.24212 18.1992 8.41714 18.1181 8.54617 17.9738L10.2985 16.0133ZM10.2985 8.92469C10.5672 9.22531 10.5672 9.71272 10.2985 10.0133L8.54617 11.9738C8.41714 12.1181 8.24212 12.1992 8.05963 12.1992C7.87714 12.1992 7.70213 12.1181 7.57309 11.9738L6.70153 10.9987C6.43282 10.6981 6.43282 10.2106 6.70153 9.91002C6.97024 9.6094 7.40591 9.6094 7.67461 9.91002L8.05963 10.3408L9.32539 8.92469C9.59409 8.62406 10.0298 8.62406 10.2985 8.92469ZM12.3459 15.6992C11.8787 15.6992 11.5 16.035 11.5 16.4492C11.5 16.8634 11.8787 17.1992 12.3459 17.1992H16.6541C17.1213 17.1992 17.5 16.8634 17.5 16.4492C17.5 16.035 17.1213 15.6992 16.6541 15.6992H12.3459Z",
    fill: "currentColor"
  }
) }), ToDoSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.06027 5.94723C7.25553 6.14249 7.25553 6.45907 7.06027 6.65434L5.78694 7.92767C5.69317 8.02144 5.56599 8.07411 5.43338 8.07411C5.30077 8.07411 5.1736 8.02144 5.07983 7.92767L4.4465 7.29433C4.25123 7.09907 4.25123 6.78249 4.4465 6.58723C4.64176 6.39196 4.95834 6.39197 5.1536 6.58723L5.43338 6.86701L6.35316 5.94723C6.54842 5.75197 6.86501 5.75197 7.06027 5.94723Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.58627 6.50781C8.22567 6.50781 7.93335 6.77644 7.93335 7.10781C7.93335 7.43918 8.22567 7.70781 8.58627 7.70781H11.0804C11.441 7.70781 11.7333 7.43918 11.7333 7.10781C11.7333 6.77644 11.441 6.50781 11.0804 6.50781H8.58627Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.06027 10.0488C7.25553 10.2441 7.25553 10.5606 7.06027 10.7559L5.78694 12.0292C5.69317 12.123 5.56599 12.1757 5.43338 12.1757C5.30077 12.1757 5.1736 12.123 5.07983 12.0292L4.4465 11.3959C4.25123 11.2006 4.25123 10.8841 4.4465 10.6888C4.64176 10.4935 4.95834 10.4935 5.1536 10.6888L5.43338 10.9686L6.35316 10.0488C6.54842 9.85353 6.86501 9.85353 7.06027 10.0488Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.58627 10.5039C8.22567 10.5039 7.93335 10.7725 7.93335 11.1039C7.93335 11.4353 8.22567 11.7039 8.58627 11.7039H11.0804C11.441 11.7039 11.7333 11.4353 11.7333 11.1039C11.7333 10.7725 11.441 10.5039 11.0804 10.5039H8.58627Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2415 0.636597H12.07C13.1359 0.636597 14 1.58056 14 2.745V13.8894C14 15.0538 13.1359 15.9978 12.07 15.9978H3.93C2.86409 15.9978 2 15.0538 2 13.8894V2.745C2 1.58056 2.86409 0.636597 3.93001 0.636597H4.75852C4.81318 0.276194 5.12434 0 5.5 0H10.5C10.8757 0 11.1868 0.276194 11.2415 0.636597ZM4.75224 2.14493C4.71595 2.15132 4.67871 2.15464 4.64076 2.15464H3.93001C3.63155 2.15464 3.3896 2.41895 3.3896 2.745V13.8894C3.3896 14.2154 3.63155 14.4797 3.93 14.4797H12.07C12.3685 14.4797 12.6104 14.2154 12.6104 13.8894V2.745C12.6104 2.41895 12.3685 2.15464 12.07 2.15464H11.2473C11.222 2.65293 11.021 3.13048 10.6734 3.49308C10.3023 3.88018 9.79299 4.10506 9.25406 4.10798L9.25 4.108L6.74594 4.10799C6.20701 4.10507 5.69767 3.88018 5.32659 3.49308C4.97675 3.12812 4.77544 2.64672 4.75224 2.14493ZM6.25 2.05176V1.5H9.75V2.05173C9.74885 2.20879 9.68829 2.35313 9.59056 2.45508C9.49394 2.55587 9.37003 2.60691 9.24747 2.60799H6.75253C6.62997 2.60691 6.50606 2.55587 6.40944 2.45508C6.31172 2.35313 6.25116 2.20881 6.25 2.05176Z",
      fill: "currentColor"
    }
  )
] }), TrackLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3C2.11929 3 1 4.11929 1 5.5V16.5C1 17.8807 2.11929 19 3.5 19H4.05C4.28161 20.1411 5.2904 21 6.4999 21C7.7094 21 8.71819 20.1411 8.9498 19H15.05C15.2816 20.1411 16.2904 21 17.4999 21C18.7094 21 19.7182 20.1411 19.9498 19H20.5C21.8807 19 23 17.8807 23 16.5V13.7146C23 13.6201 22.9866 13.5262 22.9603 13.4355L21.613 8.79857L21.6108 8.79104C21.4391 8.2172 21.0503 7.75147 20.5612 7.44282C20.0773 7.13748 19.5045 6.9891 18.935 7.00062H17V5.5C17 4.11929 15.8807 3 14.5 3H3.5ZM8.5 17H15V13H3V16.5C3 16.7761 3.22386 17 3.5 17H4.49981C4.95588 16.3928 5.682 16 6.4999 16C7.31781 16 8.04392 16.3928 8.5 17ZM17.4999 16C17.3287 16 17.1615 16.0172 17 16.05V9.00062H18.9461C18.9543 9.00062 18.9626 9.00052 18.9708 9.00032C19.1756 8.99526 19.3606 9.05013 19.4938 9.13419C19.6239 9.21626 19.6766 9.30612 19.694 9.36193L21 13.8569V16.5C21 16.7761 20.7761 17 20.5 17H19.5C19.0439 16.3928 18.3178 16 17.4999 16ZM15 5.5C15 5.22386 14.7761 5 14.5 5H3.5C3.22386 5 3 5.22386 3 5.5V11H15V5.5ZM17.4999 18C17.2239 18 17 18.2238 17 18.5C17 18.7763 17.2239 19 17.4999 19C17.7759 19 17.9998 18.7763 17.9998 18.5C17.9998 18.2238 17.7759 18 17.4999 18ZM6 18.5C6 18.2238 6.22389 18 6.4999 18C6.77591 18 6.9998 18.2238 6.9998 18.5C6.9998 18.7763 6.77591 19 6.4999 19C6.22389 19 6 18.7763 6 18.5Z",
    fill: "currentColor"
  }
) }), TrackSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31864 12.7607H5.92306C5.70275 13.4784 5.03725 14 4.25049 14C3.46372 14 2.79822 13.4784 2.57791 12.7607H1.75C0.783502 12.7607 0 11.9736 0 11.0027V3.75801C0 2.78709 0.783502 2 1.75 2H10.25C11.2165 2 12 2.78709 12 3.75801V4.22544H13.4838C13.8853 4.21584 14.2694 4.35658 14.5739 4.61047C14.8779 4.86399 15.0835 5.21323 15.1715 5.59345L15.9743 8.81642C15.9892 8.87597 15.9967 8.93712 15.9968 8.99851L15.9989 11.004C16 11.9757 15.2162 12.7639 14.2489 12.7639H12.6628C12.4415 13.48 11.7768 14 10.9912 14C10.2044 14 9.53895 13.4784 9.31864 12.7607ZM1.5 3.75801C1.5 3.61931 1.61193 3.50687 1.75 3.50687H10.25C10.3881 3.50687 10.5 3.61931 10.5 3.75801V10.5542C10.1059 10.6697 9.7693 10.9208 9.54361 11.2538H5.69809C5.38315 10.7891 4.8523 10.484 4.25049 10.484C3.64868 10.484 3.11782 10.7891 2.80289 11.2538H1.75C1.61193 11.2538 1.5 11.1414 1.5 11.0027V3.75801ZM12.441 11.257H14.2489C14.3871 11.257 14.4991 11.1444 14.4989 11.0056L14.4969 9.09256L13.7146 5.95236L13.7109 5.93653C13.6931 5.85814 13.6544 5.80207 13.6158 5.76995C13.5789 5.73916 13.5445 5.73107 13.5184 5.73191C13.5103 5.73218 13.5022 5.73231 13.4941 5.73231H12V10.8053C12.1727 10.9279 12.3223 11.0811 12.441 11.257Z",
    fill: "currentColor"
  }
) }), UploadLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.76825 9.64018C7.41468 10.0645 6.78412 10.1218 6.35984 9.76822C5.93556 9.41466 5.87824 8.78409 6.2318 8.35982L11.2266 2.36604C11.242 2.34732 11.258 2.32917 11.2747 2.31162C11.2934 2.2919 11.3128 2.27302 11.3329 2.255C11.4975 2.10759 11.7111 2.01388 11.9463 2.00144C11.9641 2.00048 11.9821 2 12 2C12.2266 2 12.4442 2.07681 12.619 2.21456C12.6732 2.25728 12.7233 2.30585 12.7682 2.35982L17.7682 8.35982C18.1218 8.78409 18.0645 9.41466 17.6402 9.76822C17.2159 10.1218 16.5854 10.0645 16.2318 9.64018L13 5.76202L13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16L11 5.76208L7.76825 9.64018Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3 16C3.55228 16 4 16.4477 4 17V20H20V17C20 16.4477 20.4477 16 21 16C21.5523 16 22 16.4477 22 17V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V17C2 16.4477 2.44772 16 3 16Z",
      fill: "currentColor"
    }
  )
] }), UploadSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.3991 5.315C4.1509 5.6476 4.21852 6.11902 4.55014 6.36795C4.88176 6.61688 5.35179 6.54906 5.59999 6.21646L7.24281 4.015L7.25014 10.6199C7.2506 11.0354 7.58676 11.3718 8.00098 11.3713C8.41519 11.3708 8.7506 11.0337 8.75014 10.6183L8.74279 4.00386L10.4005 6.21748C10.6493 6.54966 11.1194 6.61668 11.4506 6.36719C11.7818 6.11769 11.8486 5.64616 11.5999 5.31398L8.59427 1.30047C8.45247 1.11112 8.23006 0.9998 7.99395 1C7.75784 1.0002 7.53561 1.1119 7.39414 1.30149L4.3991 5.315Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1.75 10.4867C2.16421 10.4867 2.5 10.8235 2.5 11.2389V13.4956H13.5V11.2389C13.5 10.8235 13.8358 10.4867 14.25 10.4867C14.6642 10.4867 15 10.8235 15 11.2389V14.2478C15 14.6632 14.6642 15 14.25 15H1.75C1.33579 15 1 14.6632 1 14.2478V11.2389C1 10.8235 1.33579 10.4867 1.75 10.4867Z",
      fill: "currentColor"
    }
  )
] }), UserAddLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C9.23858 2 7 4.13197 7 6.76188C7 9.3918 9.23858 11.5238 12 11.5238C9.61305 11.5238 7.32387 12.4268 5.63604 14.0343C3.94821 15.6417 3 17.8219 3 20.0951C3 20.6211 3.44772 21.0475 4 21.0475C4.55228 21.0475 5 20.6211 5 20.0951C5 18.327 5.7375 16.6314 7.05025 15.3811C8.36301 14.1309 10.1435 13.4285 12 13.4285C13.5939 13.4285 15.1317 13.9462 16.3657 14.8839C16.7974 15.2119 17.4266 15.1446 17.771 14.7334C18.1155 14.3223 18.0448 13.723 17.613 13.395C16.0266 12.1894 14.0493 11.5238 12 11.5238C14.7614 11.5238 17 9.3918 17 6.76188C17 4.13197 14.7614 2 12 2ZM9 6.76188C9 5.18393 10.3431 3.90475 12 3.90475C13.6569 3.90475 15 5.18393 15 6.76188C15 8.33983 13.6569 9.61901 12 9.61901C10.3431 9.61901 9 8.33983 9 6.76188Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15 19.1428C15 18.6168 15.4477 18.1904 16 18.1904H17V17.238C17 16.712 17.4477 16.2856 18 16.2856C18.5523 16.2856 19 16.712 19 17.238V18.1904H20C20.5523 18.1904 21 18.6168 21 19.1428C21 19.6688 20.5523 20.0951 20 20.0951H19V21.0476C19 21.5736 18.5523 22 18 22C17.4477 22 17 21.5736 17 21.0476V20.0951H16C15.4477 20.0951 15 19.6688 15 19.1428Z",
      fill: "currentColor"
    }
  )
] }), UserAddSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.96576 1C5.10355 1 3.59392 2.45497 3.59392 4.24976C3.59392 6.04455 5.10355 7.49951 6.96576 7.49951C8.82798 7.49951 10.3376 6.04455 10.3376 4.24976C10.3376 2.45497 8.82798 1 6.96576 1ZM5.15027 4.24976C5.15027 3.28339 5.9631 2.5 6.96576 2.5C7.96843 2.5 8.78125 3.28339 8.78125 4.24976C8.78125 5.21612 7.96843 5.99951 6.96576 5.99951C5.9631 5.99951 5.15027 5.21612 5.15027 4.24976Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.84756 10.2438C4.6744 9.44746 5.79594 9 6.96551 9C7.75382 9 8.52035 9.20328 9.18958 9.57972C9.56076 9.78851 10.0373 9.66776 10.2539 9.31002C10.4705 8.95228 10.3453 8.49301 9.97408 8.28422C9.06882 7.77501 8.03213 7.49951 6.96576 7.49951C5.3838 7.49951 3.86625 8.10523 2.74746 9.18273C1.62865 10.2602 1 11.7218 1 13.2458C1 13.6601 1.3484 13.9958 1.77818 13.9958C2.20795 13.9958 2.55635 13.6601 2.55635 13.2458C2.55635 12.12 3.02075 11.0401 3.84756 10.2438Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.33094 11.75C9.33094 11.3358 9.67935 11 10.1091 11H10.8873V10.25C10.8873 9.83579 11.2357 9.5 11.6655 9.5C12.0952 9.5 12.4436 9.83579 12.4436 10.25V11H13.2218C13.6516 11 14 11.3358 14 11.75C14 12.1642 13.6516 12.5 13.2218 12.5H12.4436V13.25C12.4436 13.6642 12.0952 14 11.6655 14C11.2357 14 10.8873 13.6642 10.8873 13.25V12.5H10.1091C9.67935 12.5 9.33094 12.1642 9.33094 11.75Z",
      fill: "currentColor"
    }
  )
] }), UserCheckLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 6.76189C7 4.13197 9.23858 2 12 2C14.7614 2 17 4.13197 17 6.76189C17 9.39181 14.7614 11.5238 12 11.5238C9.23858 11.5238 7 9.39181 7 6.76189ZM12 3.90476C10.3431 3.90476 9 5.18394 9 6.76189C9 8.33984 10.3431 9.61902 12 9.61902C13.6569 9.61902 15 8.33984 15 6.76189C15 5.18394 13.6569 3.90476 12 3.90476Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 11.5238C14.0493 11.5238 16.0266 12.1894 17.613 13.395C18.0448 13.7231 18.1155 14.3223 17.771 14.7334C17.4266 15.1446 16.7974 15.212 16.3657 14.8839C15.1317 13.9462 13.5939 13.4285 12 13.4285C10.1435 13.4285 8.36301 14.1309 7.05025 15.3812C5.7375 16.6314 5 18.3271 5 20.0952C5 20.6212 4.55228 21.0476 4 21.0476C3.44772 21.0476 3 20.6212 3 20.0952C3 17.8219 3.94821 15.6417 5.63604 14.0343C7.32387 12.4268 9.61305 11.5238 12 11.5238Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.8 17.8095C21.1314 17.3887 21.0418 16.7918 20.6 16.4762C20.1582 16.1606 19.5314 16.2459 19.2 16.6667L16.8918 19.5977L15.7071 18.4694C15.3166 18.0975 14.6834 18.0975 14.2929 18.4694C13.9024 18.8414 13.9024 19.4444 14.2929 19.8163L16.2929 21.7211C16.4979 21.9163 16.7817 22.0172 17.0709 21.9976C17.3601 21.978 17.6261 21.8399 17.8 21.619L20.8 17.8095Z",
      fill: "currentColor"
    }
  )
] }), UserCheckSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.40005 4.24935C4.40005 2.45478 5.79685 1 7.51988 1C9.24292 1 10.6397 2.45478 10.6397 4.24935C10.6397 6.04392 9.24292 7.4987 7.51988 7.4987C5.79685 7.4987 4.40005 6.04392 4.40005 4.24935ZM7.51988 2.49981C6.59215 2.49981 5.84008 3.28311 5.84008 4.24935C5.84008 5.21559 6.59215 5.99889 7.51988 5.99889C8.44761 5.99889 9.19968 5.21559 9.19968 4.24935C9.19968 3.28311 8.44761 2.49981 7.51988 2.49981Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.51965 8.999C6.4375 8.999 5.39977 9.44641 4.63474 10.2426C3.86972 11.0388 3.44003 12.1186 3.44003 13.2443C3.44003 13.6585 3.11767 13.9942 2.72002 13.9942C2.32236 13.9942 2 13.6585 2 13.2443C2 11.7204 2.58166 10.2591 3.61685 9.18171C4.65203 8.10434 6.05615 7.4987 7.51988 7.4987C8.73468 7.4987 9.90797 7.916 10.8637 8.6736C11.1802 8.92442 11.2415 9.39493 11.0006 9.7245C10.7598 10.0541 10.3081 10.1179 9.99163 9.86709C9.28521 9.30714 8.4177 8.999 7.51965 8.999Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.8514 11.1035C14.0933 10.7747 14.0336 10.304 13.7179 10.0521C13.4023 9.80013 12.9504 9.86237 12.7085 10.1911L11.2928 12.1149L10.6744 11.4709C10.3932 11.1781 9.93734 11.1781 9.65617 11.471C9.37501 11.7638 9.37503 12.2387 9.65623 12.5315L10.8555 13.7804C11.0021 13.9331 11.2049 14.0126 11.4119 13.9984C11.6188 13.9842 11.8099 13.8777 11.936 13.7063L13.8514 11.1035Z",
      fill: "currentColor"
    }
  )
] }), UserIdLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.0005 12C13.4482 12 13.0005 12.4477 13.0005 13C13.0005 13.5523 13.4482 14 14.0005 14H18.0005C18.5528 14 19.0005 13.5523 19.0005 13C19.0005 12.4477 18.5528 12 18.0005 12H14.0005Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.0005 16C14.0005 15.4477 14.4482 15 15.0005 15H18.0005C18.5528 15 19.0005 15.4477 19.0005 16C19.0005 16.5523 18.5528 17 18.0005 17H15.0005C14.4482 17 14.0005 16.5523 14.0005 16Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.00049 16.0039C8.46982 16.0039 7.96103 16.2146 7.58602 16.5893C7.21102 16.964 7.00049 17.4721 7.00049 18.0017C7.00049 18.554 6.55277 19.0017 6.00049 19.0017C5.4482 19.0017 5.00049 18.554 5.00049 18.0017C5.00049 16.9412 5.42209 15.9243 6.17232 15.1746C6.92252 14.4249 7.93986 14.0039 9.00049 14.0039C10.0611 14.0039 11.0785 14.4249 11.8287 15.1746C12.5789 15.9243 13.0005 16.9412 13.0005 18.0017C13.0005 18.554 12.5528 19.0017 12.0005 19.0017C11.4482 19.0017 11.0005 18.554 11.0005 18.0017C11.0005 17.4721 10.79 16.964 10.415 16.5893C10.0399 16.2146 9.53116 16.0039 9.00049 16.0039Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.0005 12C11.0005 13.1046 10.1051 14 9.00049 14C7.89592 14 7.00049 13.1046 7.00049 12C7.00049 10.8954 7.89592 10 9.00049 10C10.1051 10 11.0005 10.8954 11.0005 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0005 2C10.3436 2 9.00049 3.34315 9.00049 5V7H4.50049C3.11978 7 2.00049 8.11929 2.00049 9.5V19.5C2.00049 20.8807 3.11978 22 4.50049 22H19.5005C20.8812 22 22.0005 20.8807 22.0005 19.5V9.5C22.0005 8.11929 20.8812 7 19.5005 7H15.0005V5C15.0005 3.34315 13.6573 2 12.0005 2ZM13.0005 7V5C13.0005 4.44772 12.5528 4 12.0005 4C11.4482 4 11.0005 4.44772 11.0005 5V7H13.0005ZM4.50049 9C4.22435 9 4.00049 9.22386 4.00049 9.5V19.5C4.00049 19.7761 4.22435 20 4.50049 20H19.5005C19.7766 20 20.0005 19.7761 20.0005 19.5V9.5C20.0005 9.22386 19.7766 9 19.5005 9H4.50049Z",
      fill: "currentColor"
    }
  )
] }), UserIdSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.46729 7.66723C9.46729 8.35814 9.00224 8.9402 8.36875 9.11613C8.99406 9.2031 9.57844 9.49174 10.0301 9.94405C10.5772 10.492 10.8847 11.2353 10.8847 12.0105C10.8847 12.4256 10.5489 12.7622 10.1347 12.7622C9.72048 12.7622 9.38469 12.4256 9.38469 12.0105C9.38469 11.6344 9.23551 11.2736 8.9698 11.0075C8.70406 10.7413 8.34353 10.5917 7.96749 10.5917C7.59145 10.5917 7.23092 10.7413 6.96519 11.0075C6.69947 11.2736 6.55029 11.6344 6.55029 12.0105C6.55029 12.4256 6.21451 12.7622 5.80029 12.7622C5.38608 12.7622 5.05029 12.4256 5.05029 12.0105C5.05029 11.2353 5.35777 10.492 5.90492 9.94405C6.35648 9.4918 6.94075 9.20319 7.56596 9.11617C6.9324 8.94028 6.46729 8.35819 6.46729 7.66723C6.46729 6.83695 7.13886 6.16387 7.96729 6.16387C8.79571 6.16387 9.46729 6.83695 9.46729 7.66723Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.75049 3.25503C5.75049 2.00961 6.75785 1 8.00049 1C9.24313 1 10.2505 2.00961 10.2505 3.25503V3.97539H14.2505C14.6647 3.97539 15.0005 4.31193 15.0005 4.72707V14.2483C15.0005 14.6635 14.6647 15 14.2505 15H1.75049C1.33627 15 1.00049 14.6635 1.00049 14.2483V4.72707C1.00049 4.31193 1.33627 3.97539 1.75049 3.97539H5.75049V3.25503ZM8.75049 3.25503V3.97539H7.25049V3.25503C7.25049 2.83989 7.58627 2.50336 8.00049 2.50336C8.4147 2.50336 8.75049 2.83989 8.75049 3.25503ZM2.50049 5.47875V13.4966H13.5005V5.47875H2.50049Z",
      fill: "currentColor"
    }
  )
] }), UserLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C9.23858 2 7 4.23858 7 7C7 9.76143 9.23858 12 12 12C9.61305 12 7.32387 12.9482 5.63604 14.636C3.94821 16.3239 3 18.6131 3 21C3 21.5523 3.44772 22 4 22C4.55228 22 5 21.5523 5 21C5 19.1435 5.7375 17.363 7.05025 16.0503C8.36301 14.7375 10.1435 14 12 14C13.8565 14 15.637 14.7375 16.9497 16.0503C18.2625 17.363 19 19.1435 19 21C19 21.5523 19.4477 22 20 22C20.5523 22 21 21.5523 21 21C21 18.6131 20.0518 16.3239 18.364 14.636C16.6761 12.9482 14.3869 12 12 12C14.7614 12 17 9.76143 17 7C17 4.23858 14.7614 2 12 2ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65686 13.6569 10 12 10C10.3431 10 9 8.65686 9 7Z",
    fill: "currentColor"
  }
) }), UserRemoveLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76143 14.7614 12 12 12C9.23858 12 7 9.76143 7 7ZM12 4C10.3431 4 9 5.34315 9 7C9 8.65686 10.3431 10 12 10C13.6569 10 15 8.65686 15 7C15 5.34315 13.6569 4 12 4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 12C14.0493 12 16.0266 12.6989 17.613 13.9648C18.0448 14.3092 18.1155 14.9384 17.771 15.3702C17.4266 15.8019 16.7974 15.8726 16.3657 15.5281C15.1317 14.5436 13.5939 14 12 14C10.1435 14 8.36301 14.7375 7.05025 16.0503C5.7375 17.363 5 19.1435 5 21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21C3 18.6131 3.94821 16.3239 5.63604 14.636C7.32387 12.9482 9.61305 12 12 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H16Z",
      fill: "currentColor"
    }
  )
] }), UserRemoveSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.65058 4.99976C4.65058 3.20497 6.0474 1.75 7.77047 1.75C9.49354 1.75 10.8904 3.20497 10.8904 4.99976C10.8904 6.79455 9.49354 8.24951 7.77047 8.24951C6.0474 8.24951 4.65058 6.79455 4.65058 4.99976ZM7.77047 3.25C6.84272 3.25 6.09064 4.03339 6.09064 4.99976C6.09064 5.96612 6.84272 6.74951 7.77047 6.74951C8.69822 6.74951 9.4503 5.96612 9.4503 4.99976C9.4503 4.03339 8.69822 3.25 7.77047 3.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.77024 9.75C6.68806 9.75 5.65032 10.1975 4.88527 10.9938C4.12024 11.7901 3.69054 12.87 3.69054 13.9958C3.69054 14.4101 3.36818 14.7458 2.97052 14.7458C2.57286 14.7458 2.25049 14.4101 2.25049 13.9958C2.25049 12.4718 2.83216 11.0102 3.86737 9.93273C4.90256 8.85523 6.30671 8.24951 7.77047 8.24951C8.98529 8.24951 10.1586 8.66687 11.1144 9.42456C11.4308 9.67541 11.4921 10.146 11.2513 10.4756C11.0105 10.8052 10.5587 10.869 10.2423 10.6182C9.53583 10.0582 8.6683 9.75 7.77024 9.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.1299 11.75C10.7322 11.75 10.4099 12.0858 10.4099 12.5C10.4099 12.9142 10.7322 13.25 11.1299 13.25H13.5305C13.9281 13.25 14.2505 12.9142 14.2505 12.5C14.2505 12.0858 13.9281 11.75 13.5305 11.75H11.1299Z",
      fill: "currentColor"
    }
  )
] }), UserSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.25074 1.75C6.37776 1.75 4.85941 3.20497 4.85941 4.99976C4.85941 6.79455 6.37776 8.24951 8.25074 8.24951C10.1237 8.24951 11.6421 6.79455 11.6421 4.99976C11.6421 3.20497 10.1237 1.75 8.25074 1.75ZM6.42476 4.99976C6.42476 4.03339 7.24228 3.25 8.25074 3.25C9.25921 3.25 10.0767 4.03339 10.0767 4.99976C10.0767 5.96612 9.25921 6.74951 8.25074 6.74951C7.24228 6.74951 6.42476 5.96612 6.42476 4.99976Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.11451 10.9938C5.94613 10.1975 7.07416 9.75 8.25049 9.75C9.42681 9.75 10.5548 10.1975 11.3865 10.9938C12.2181 11.7901 12.6851 12.87 12.6851 13.9958C12.6851 14.4101 13.0356 14.7458 13.4678 14.7458C13.9001 14.7458 14.2505 14.4101 14.2505 13.9958C14.2505 12.4718 13.6182 11.0102 12.4929 9.93273C11.3677 8.85523 9.84186 8.24951 8.25074 8.24951C6.65963 8.24951 5.13331 8.85523 4.00805 9.93273C2.88277 11.0102 2.25049 12.4718 2.25049 13.9958C2.25049 14.4101 2.6009 14.7458 3.03316 14.7458C3.46542 14.7458 3.81584 14.4101 3.81584 13.9958C3.81584 12.87 4.28292 11.7901 5.11451 10.9938Z",
      fill: "currentColor"
    }
  )
] }), VendorLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17H6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.14445 2C6.2476 2 5.41945 2.48041 4.97424 3.25895L2.32979 7.88327C2.28885 7.95486 2.25159 8.02824 2.21808 8.10312C2.08159 8.27408 2 8.49079 2 8.72656C2 8.77911 2.00405 8.83071 2.01186 8.88106C2.00398 8.9617 2 9.04288 2 9.12432V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V9.12432C22 9.04288 21.996 8.9617 21.9881 8.88106C21.9959 8.8307 22 8.77911 22 8.72656C22 8.4908 21.9184 8.27409 21.7819 8.10313C21.7484 8.02824 21.7111 7.95486 21.6702 7.88327L19.0258 3.25895C18.5805 2.48041 17.7524 2 16.8556 2H7.14445ZM19.2767 7.72656L17.2896 4.25179C17.2006 4.09608 17.0349 4 16.8556 4H13V7.72656H19.2767ZM11 9.72656V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V9.72656H20V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V9.72656H11ZM11 7.72656V4H7.14445C6.96508 4 6.79945 4.09608 6.7104 4.25179L4.72333 7.72656H11Z",
      fill: "currentColor"
    }
  )
] }), VendorSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.875 10.375C4.46079 10.375 4.125 10.7108 4.125 11.125C4.125 11.5392 4.46079 11.875 4.875 11.875H8C8.41421 11.875 8.75 11.5392 8.75 11.125C8.75 10.7108 8.41421 10.375 8 10.375H4.875Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.60392 1C3.97612 1 3.39642 1.33629 3.08477 1.88127L1.23085 5.12319C1.20402 5.17013 1.17944 5.21816 1.15715 5.26712C1.05865 5.39405 1 5.55346 1 5.72656C1 5.7623 1.0025 5.79746 1.00733 5.83187C1.00246 5.88495 1 5.93836 1 5.99193V13.25C1 14.2165 1.7835 15 2.75 15H13.25C14.2165 15 15 14.2165 15 13.25V5.99193C15 5.93836 14.9975 5.88495 14.9927 5.83187C14.9975 5.79746 15 5.7623 15 5.72656C15 5.55346 14.9414 5.39405 14.8428 5.26712C14.8206 5.21816 14.796 5.17013 14.7691 5.12319L12.9152 1.88127C12.6036 1.33629 12.0239 1 11.3961 1H4.60392ZM12.9573 4.97656L11.6131 2.6259C11.5686 2.54804 11.4858 2.5 11.3961 2.5H8.75V4.97656H12.9573ZM7.25 6.47656V8C7.25 8.41421 7.58579 8.75 8 8.75C8.41421 8.75 8.75 8.41421 8.75 8V6.47656H13.5V13.25C13.5 13.3881 13.3881 13.5 13.25 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25V6.47656H7.25ZM7.25 4.97656V2.5H4.60392C4.51423 2.5 4.43142 2.54804 4.3869 2.6259L3.04265 4.97656H7.25Z",
      fill: "currentColor"
    }
  )
] }), VerifiedLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7479 1.29309C12.3264 0.902305 11.6736 0.902305 11.252 1.29309L9.3762 3.03204C9.17538 3.2182 8.90135 3.30479 8.62958 3.26796L5.87385 2.89444C5.389 2.82873 4.93806 3.15474 4.85024 3.63447L4.38143 6.19552C4.33023 6.47518 4.15112 6.71506 3.89702 6.84425L1.49946 8.06324C1.04969 8.29191 0.870745 8.84041 1.09956 9.28896L2.27168 11.5867C2.40417 11.8464 2.40417 12.1536 2.27168 12.4133L1.09956 14.711C0.870745 15.1596 1.04969 15.7081 1.49945 15.9368L3.89702 17.1557C4.15112 17.2849 4.33023 17.5248 4.38143 17.8045L4.85024 20.3655C4.93806 20.8453 5.389 21.1713 5.87385 21.1056L8.62958 20.732C8.90136 20.6952 9.17538 20.7818 9.3762 20.968L11.252 22.7069C11.6736 23.0977 12.3264 23.0977 12.7479 22.7069L14.6238 20.968C14.8246 20.7818 15.0986 20.6952 15.3704 20.732L18.1261 21.1056C18.611 21.1713 19.0619 20.8453 19.1498 20.3655L19.6186 17.8045C19.6698 17.5248 19.8489 17.2849 20.103 17.1557L22.5005 15.9368C22.9503 15.7081 23.1293 15.1596 22.9004 14.711L21.7283 12.4133C21.5958 12.1536 21.5958 11.8464 21.7283 11.5867L22.9004 9.28896C23.1293 8.84041 22.9503 8.29191 22.5005 8.06324L20.103 6.84425C19.8489 6.71506 19.6698 6.47518 19.6186 6.19552L19.1498 3.63447C19.0619 3.15474 18.611 2.82873 18.1261 2.89444L15.3704 3.26796C15.0986 3.30479 14.8246 3.2182 14.6238 3.03204L12.7479 1.29309ZM16.7809 9.62473C17.1259 9.19347 17.056 8.56418 16.6247 8.21917C16.1934 7.87416 15.5641 7.94408 15.2191 8.37534L11.0948 13.5307L8.68394 11.2705C8.28103 10.8928 7.6482 10.9132 7.27047 11.3161C6.89274 11.719 6.91315 12.3518 7.31606 12.7296L10.5161 15.7296C10.7195 15.9203 10.9933 16.0174 11.2714 15.9975C11.5495 15.9776 11.8067 15.8425 11.9809 15.6247L16.7809 9.62473Z",
    fill: "currentColor"
  }
) }), VerifiedSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47597 1.18651C8.20771 0.93783 7.79229 0.93783 7.52403 1.18651L6.33031 2.29311C6.20251 2.41159 6.02814 2.46669 5.85519 2.44324L4.10154 2.20555C3.793 2.16374 3.50604 2.3712 3.45015 2.67648L3.15182 4.30624C3.11924 4.48421 3.00526 4.63686 2.84356 4.71907L1.31784 5.49479C1.03162 5.64031 0.917747 5.98935 1.06336 6.27479L1.80925 7.73698C1.89356 7.90226 1.89356 8.09774 1.80925 8.26302L1.06336 9.72521C0.917747 10.0107 1.03162 10.3597 1.31783 10.5052L2.84356 11.2809C3.00526 11.3631 3.11924 11.5158 3.15182 11.6938L3.45015 13.3235C3.50604 13.6288 3.793 13.8363 4.10154 13.7944L5.85519 13.5568C6.02814 13.5333 6.20251 13.5884 6.33031 13.7069L7.52403 14.8135C7.79229 15.0622 8.20771 15.0622 8.47597 14.8135L9.66969 13.7069C9.79749 13.5884 9.97186 13.5333 10.1448 13.5568L11.8985 13.7944C12.207 13.8363 12.494 13.6288 12.5498 13.3235L12.8482 11.6938C12.8808 11.5158 12.9947 11.3631 13.1564 11.2809L14.6822 10.5052C14.9684 10.3597 15.0823 10.0107 14.9366 9.72521L14.1907 8.26302C14.1064 8.09774 14.1064 7.90226 14.1907 7.73698L14.9366 6.27479C15.0823 5.98935 14.9684 5.64031 14.6822 5.49479L13.1564 4.71907C12.9947 4.63686 12.8808 4.48421 12.8482 4.30624L12.5498 2.67648C12.494 2.3712 12.207 2.16374 11.8985 2.20555L10.1448 2.44324C9.97186 2.46669 9.79749 2.41159 9.66969 2.29311L8.47597 1.18651ZM11.1019 6.45713C11.3544 6.12873 11.2928 5.65787 10.9644 5.40542C10.636 5.15298 10.1651 5.21455 9.91269 5.54294L7.35766 8.86668L6.03659 7.54968C5.74325 7.25724 5.26838 7.25797 4.97593 7.55131C4.68349 7.84466 4.68422 8.31953 4.97757 8.61197L6.90281 10.5313C7.05554 10.6836 7.26643 10.7627 7.48163 10.7485C7.69682 10.7344 7.8955 10.6282 8.02694 10.4572L11.1019 6.45713Z",
    fill: "currentColor"
  }
) }), VideoLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5C1.44772 5 1 5.48215 1 6.07692V15.4255C1 17.2422 2.20135 19 3.98857 19H14C14.5523 19 15 18.5178 15 17.9231V8.57449C15 6.75779 13.7986 5 12.0114 5H2ZM3 15.4255V7.15385H12.0114C12.4185 7.15385 13 7.62708 13 8.57449V16.8462H3.98857C3.5815 16.8462 3 16.3729 3 15.4255Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 7.15385C23 6.78454 22.8243 6.441 22.5344 6.24363C22.2446 6.04626 21.8811 6.02259 21.5713 6.18093L16.5713 8.73634C16.2224 8.91465 16 9.29337 16 9.70926V14.2725C16 14.6873 16.2212 15.0652 16.5688 15.2441L21.5688 17.8178C21.8786 17.9773 22.2428 17.9544 22.5333 17.7572C22.8238 17.5599 23 17.216 23 16.8462V7.15385ZM18 13.5936V10.3902L21 8.85697V15.1378L18 13.5936Z",
      fill: "currentColor"
    }
  )
] }), VideoSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.758331 4C0.339516 4 0 4.31603 0 4.70588V9.9051C0 10.9912 0.8667 12 2.09877 12H8.8472C9.26601 12 9.60553 11.684 9.60553 11.2941V6.0949C9.60553 5.00877 8.73883 4 7.50676 4H0.758331ZM1.51666 9.9051V5.41176H7.50676C7.75379 5.41176 8.08887 5.64378 8.08887 6.0949V10.5882H2.09877C1.85174 10.5882 1.51666 10.3562 1.51666 9.9051Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 4.70588C16 4.45852 15.8609 4.22921 15.6334 4.10145C15.4058 3.97369 15.123 3.96611 14.888 4.08149L11.3491 5.8185C11.1002 5.94065 10.9445 6.18101 10.9445 6.44289V9.5447C10.9445 9.80584 11.0993 10.0456 11.3471 10.1681L14.886 11.9175C15.121 12.0337 15.4043 12.0267 15.6324 11.8991C15.8605 11.7714 16 11.5418 16 11.2941V4.70588ZM12.4611 9.12032V6.86868L14.4833 5.87611V10.12L12.4611 9.12032Z",
      fill: "currentColor"
    }
  )
] }), WalletLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.6842 14.9512C16.2656 14.9512 16.7368 14.5004 16.7368 13.9443C16.7368 13.3883 16.2656 12.9375 15.6842 12.9375C15.1028 12.9375 14.6316 13.3883 14.6316 13.9443C14.6316 14.5004 15.1028 14.9512 15.6842 14.9512Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.4205 6.09987C20.4189 6.06117 20.4151 6.02216 20.4088 5.98297L20.1108 4.13383C19.8975 2.81011 18.6378 1.87798 17.2447 2.01299L4.36633 3.26095C3.02254 3.39117 2 4.47331 2 5.76521V19.2649L2.00001 19.2696C2.00339 19.9608 2.26256 20.6409 2.74969 21.1582C3.24 21.6788 3.92867 21.9959 4.67413 22L19.3684 22C20.8218 22 22 20.8731 22 19.4829V8.40776C22 7.37537 21.3502 6.48815 20.4205 6.09987ZM18.0301 4.44057C17.9875 4.17582 17.7355 3.9894 17.4569 4.0164L4.57853 5.26436C4.40504 5.28117 4.25832 5.37732 4.1761 5.51288C4.31791 5.61929 4.48037 5.73313 4.62943 5.83063L4.64446 5.83433C4.69989 5.84735 4.7816 5.86021 4.88799 5.87013C5.10198 5.89008 5.32658 5.89067 5.48972 5.89067H18.2638L18.0301 4.44057ZM4.10526 7.78093L4.14263 7.78996C4.32961 7.83385 4.51884 7.85892 4.68378 7.8743C5.00643 7.90438 5.32039 7.90435 5.4809 7.90434H19.3684C19.6591 7.90434 19.8947 8.12973 19.8947 8.40776V9.96736C19.7247 9.93435 19.5487 9.91701 19.3684 9.91701H14.6316C13.5149 9.91701 12.4439 10.3413 11.6543 11.0966C10.8647 11.8519 10.421 12.8762 10.421 13.9443C10.421 15.0125 10.8646 16.0368 11.6543 16.7921C12.4439 17.5474 13.5149 17.9717 14.6316 17.9717H19.3684C19.5487 17.9717 19.7247 17.9543 19.8947 17.9213V19.4829C19.8947 19.7609 19.6591 19.9863 19.3684 19.9863H4.68412C4.56812 19.9851 4.43238 19.9363 4.31393 19.8105C4.19192 19.6809 4.10684 19.4854 4.10526 19.2621V7.78093ZM14.6316 11.9307C14.0732 11.9307 13.5377 12.1428 13.1429 12.5205C12.7481 12.8981 12.5263 13.4103 12.5263 13.9443C12.5263 14.4784 12.7481 14.9906 13.1429 15.3682C13.5377 15.7459 14.0732 15.958 14.6316 15.958H19.3684C19.6591 15.958 19.8947 15.7326 19.8947 15.4546V12.4341C19.8947 12.1561 19.6591 11.9307 19.3684 11.9307H14.6316Z",
      fill: "currentColor"
    }
  )
] }), WalletSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8943 3.86991C13.8933 3.84282 13.8906 3.81551 13.8861 3.78808L13.6776 2.49368C13.5283 1.56708 12.6465 0.914589 11.6713 1.00909L2.65643 1.88266C1.71577 1.97382 1 2.73132 1 3.63565V13.0854L1.00001 13.0887C1.00237 13.5725 1.18379 14.0486 1.52478 14.4107C1.868 14.7752 2.35007 14.9971 2.87189 15L13.1579 15C14.1753 15 15 14.2111 15 13.238V5.48543C15 4.76276 14.5451 4.14171 13.8943 3.86991ZM12.2211 2.7084C12.1912 2.52307 12.0149 2.39258 11.8198 2.41148L2.80497 3.28505C2.68353 3.29682 2.58082 3.36412 2.52327 3.45901C2.62254 3.5335 2.73626 3.61319 2.8406 3.68144L2.85112 3.68403C2.88992 3.69314 2.94712 3.70215 3.02159 3.70909C3.17139 3.72305 3.3286 3.72347 3.44281 3.72347H12.3846L12.2211 2.7084ZM2.47368 5.04665L2.49984 5.05297C2.63073 5.0837 2.76319 5.10125 2.87865 5.11201C3.1045 5.13306 3.32427 5.13305 3.43663 5.13304H13.1579C13.3614 5.13304 13.5263 5.29081 13.5263 5.48543V6.57716C13.4073 6.55404 13.2841 6.54191 13.1579 6.54191H9.8421C9.06041 6.54191 8.31073 6.83892 7.75799 7.36761C7.20526 7.8963 6.89473 8.61336 6.89473 9.36104C6.89473 10.1087 7.20525 10.8258 7.75799 11.3545C8.31073 11.8832 9.06041 12.1802 9.8421 12.1802H13.1579C13.2841 12.1802 13.4073 12.168 13.5263 12.1449V13.238C13.5263 13.4327 13.3614 13.5904 13.1579 13.5904H2.87889C2.79769 13.5896 2.70266 13.5554 2.61975 13.4673C2.53434 13.3767 2.47479 13.2398 2.47368 13.0835V5.04665ZM9.8421 7.95147C9.45125 7.95147 9.07642 8.09998 8.80005 8.36433C8.52368 8.62867 8.36841 8.9872 8.36841 9.36104C8.36841 9.73488 8.52368 10.0934 8.80005 10.3578C9.07641 10.6221 9.45125 10.7706 9.8421 10.7706H13.1579C13.3614 10.7706 13.5263 10.6128 13.5263 10.4182V8.30387C13.5263 8.10925 13.3614 7.95147 13.1579 7.95147H9.8421Z",
    fill: "currentColor"
  }
) }), WarningFillLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8856 2H12.1335C12.374 1.99956 12.6105 2.07419 12.8208 2.21682C13.031 2.35944 13.2079 2.56532 13.3346 2.8149L21.7808 19.3573C21.9236 19.6323 21.9996 19.9512 22 20.2769C22 20.7339 21.8514 21.1721 21.5868 21.4952C21.3222 21.8183 20.9633 21.9998 20.5891 21.9998H3.42993C3.24306 22.0029 3.05754 21.9606 2.88416 21.8754C2.71078 21.7902 2.55299 21.6638 2.41995 21.5035C2.28691 21.3432 2.18128 21.1522 2.10919 20.9417C2.0371 20.7311 1.99998 20.5052 2 20.2769C2.00043 19.9512 2.07646 19.6323 2.21926 19.3573L10.6845 2.8149C10.8112 2.56532 10.9881 2.35944 11.1983 2.21682C11.4085 2.07419 11.6451 1.99956 11.8856 2ZM12 15C11.4477 15 11 14.5523 11 14V9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V14C13 14.5523 12.5523 15 12 15ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z",
    fill: "currentColor"
  }
) }), WarningFillSmall = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91987 1H8.09337C8.26171 0.999694 8.42732 1.05194 8.57448 1.15177C8.72163 1.25161 8.84545 1.39572 8.93417 1.57043L14.8465 13.1501C14.9464 13.3426 14.9997 13.5659 15 13.7938C15 14.1137 14.8959 14.4205 14.7107 14.6466C14.5255 14.8728 14.2743 14.9999 14.0123 14.9999H2.00089C1.87008 15.0021 1.74022 14.9724 1.61885 14.9128C1.49749 14.8532 1.38703 14.7647 1.29391 14.6525C1.20078 14.5403 1.12684 14.4066 1.07637 14.2592C1.02591 14.1118 0.999927 13.9536 0.999939 13.7938C1.00024 13.5659 1.05346 13.3426 1.15342 13.1501L7.07907 1.57043C7.16779 1.39572 7.2916 1.25161 7.43876 1.15177C7.58592 1.05194 7.75153 0.999694 7.91987 1ZM7.99994 10.1C7.61334 10.1 7.29994 9.7866 7.29994 9.4V5.9C7.29994 5.5134 7.61334 5.2 7.99994 5.2C8.38654 5.2 8.69994 5.5134 8.69994 5.9V9.4C8.69994 9.7866 8.38654 10.1 7.99994 10.1ZM7.99994 10.8C7.61334 10.8 7.29994 11.1134 7.29994 11.5C7.29994 11.8866 7.61334 12.2 7.99994 12.2C8.38654 12.2 8.69994 11.8866 8.69994 11.5C8.69994 11.1134 8.38654 10.8 7.99994 10.8Z",
    fill: "currentColor"
  }
) }), WarningLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C11.5026 2 11.0234 2.14856 10.6099 2.41728C10.1979 2.68499 9.86898 3.05975 9.64178 3.4921L9.63939 3.49667L2.34327 17.5564L2.33654 17.5696C2.11469 18.0131 2.00121 18.507 2.00001 19.0035C1.99881 19.5 2.10988 19.9944 2.32943 20.439C2.5491 20.8839 2.87458 21.2724 3.28725 21.5526C3.70152 21.834 4.18587 21.9935 4.69119 21.9999L4.70388 22H19.2961L19.3088 21.9999C19.8141 21.9935 20.2985 21.834 20.7128 21.5526C21.1254 21.2724 21.4509 20.8839 21.6706 20.439C21.8901 19.9944 22.0012 19.5 22 19.0035C21.9988 18.507 21.8853 18.0131 21.6635 17.5696L21.6567 17.5564L14.3606 3.49667L14.3582 3.4921C14.131 3.05975 13.8021 2.68499 13.3901 2.41728C12.9766 2.14856 12.4974 2 12 2ZM11.6997 4.09426C11.8022 4.02762 11.9052 4 12 4C12.0948 4 12.1978 4.02762 12.3003 4.09426C12.4039 4.16162 12.507 4.26945 12.5868 4.42054L12.5878 4.42246L19.8775 18.4699C19.9549 18.6267 19.9995 18.8127 20 19.0083C20.0005 19.2063 19.9557 19.3948 19.8773 19.5535C19.799 19.712 19.6949 19.8263 19.589 19.8982C19.4864 19.9679 19.3831 19.9979 19.288 20H4.71196C4.61694 19.9979 4.51358 19.9679 4.41098 19.8982C4.30511 19.8263 4.20098 19.712 4.12271 19.5535C4.04433 19.3948 3.99952 19.2063 4 19.0083C4.00048 18.8127 4.04513 18.6268 4.12244 18.47L11.4122 4.42246L11.4132 4.42054C11.493 4.26945 11.5961 4.16162 11.6997 4.09426Z",
      fill: "currentColor"
    }
  )
] }), WarningSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.29994 9.4C7.29994 9.7866 7.61334 10.1 7.99994 10.1C8.38654 10.1 8.69994 9.7866 8.69994 9.4V5.9C8.69994 5.5134 8.38654 5.2 7.99994 5.2C7.61334 5.2 7.29994 5.5134 7.29994 5.9V9.4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.99994 10.8C7.61334 10.8 7.29994 11.1134 7.29994 11.5C7.29994 11.8866 7.61334 12.2 7.99994 12.2C8.38654 12.2 8.69994 11.8866 8.69994 11.5C8.69994 11.1134 8.38654 10.8 7.99994 10.8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99994 1C7.65177 1 7.3163 1.10399 7.02685 1.2921C6.7385 1.47949 6.50822 1.74182 6.34918 2.04447L6.34751 2.04767L1.24023 11.8895L1.23551 11.8987C1.08022 12.2092 1.00079 12.5549 0.999946 12.9024C0.999103 13.25 1.07686 13.5961 1.23054 13.9073C1.38431 14.2187 1.61214 14.4907 1.90101 14.6869C2.191 14.8838 2.53005 14.9955 2.88377 14.9999L2.89265 15H13.1072L13.1161 14.9999C13.4698 14.9955 13.8089 14.8838 14.0989 14.6869C14.3877 14.4907 14.6156 14.2187 14.7693 13.9073C14.923 13.5961 15.0008 13.25 14.9999 12.9024C14.9991 12.5549 14.9197 12.2092 14.7644 11.8987L14.7597 11.8895L9.65237 2.04767L9.6507 2.04447C9.49166 1.74182 9.26138 1.47949 8.97303 1.2921C8.68358 1.10399 8.34811 1 7.99994 1ZM7.78974 2.46598C7.86151 2.41934 7.93358 2.4 7.99994 2.4C8.0663 2.4 8.13837 2.41934 8.21014 2.46598C8.2827 2.51314 8.35483 2.58861 8.41069 2.69438L8.41139 2.69572L13.5142 12.529C13.5683 12.6387 13.5996 12.7689 13.5999 12.9058C13.6003 13.0444 13.5689 13.1763 13.514 13.2874C13.4593 13.3984 13.3864 13.4784 13.3123 13.5287C13.2404 13.5775 13.1681 13.5985 13.1016 13.6H2.89831C2.8318 13.5985 2.75945 13.5775 2.68762 13.5287C2.61351 13.4784 2.54063 13.3984 2.48584 13.2874C2.43097 13.1763 2.39961 13.0444 2.39994 12.9058C2.40027 12.7689 2.43153 12.6387 2.48565 12.529L7.58849 2.69572L7.58919 2.69438C7.64504 2.58861 7.71717 2.51314 7.78974 2.46598Z",
      fill: "currentColor"
    }
  )
] }), WarningSolidLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.2225 3.3335H19.8094C19.4086 3.33276 19.0143 3.45715 18.6639 3.69486C18.3135 3.93256 18.0187 4.27569 17.8075 4.69166L3.6988 32.2623C3.4608 32.7207 3.3341 33.2522 3.33337 33.795C3.33335 34.1754 3.3952 34.552 3.51536 34.903C3.63551 35.2539 3.81156 35.5722 4.03329 35.8394C4.25502 36.1065 4.51801 36.3172 4.80698 36.4592C5.09595 36.6012 5.40514 36.6717 5.7166 36.6666H34.3153C34.9389 36.6666 35.537 36.364 35.978 35.8255C36.419 35.287 36.6667 34.5566 36.6667 33.795C36.666 33.2522 36.5393 32.7207 36.3013 32.2623L22.2244 4.69166C22.0132 4.27569 21.7184 3.93256 21.368 3.69486C21.0176 3.45715 20.6233 3.33276 20.2225 3.3335Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.3334 23.3335C18.3334 24.254 19.0796 25.0002 20 25.0002C20.9205 25.0002 21.6667 24.254 21.6667 23.3335V15.0002C21.6667 14.0797 20.9205 13.3335 20 13.3335C19.0796 13.3335 18.3334 14.0797 18.3334 15.0002V23.3335Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M18.3334 28.3335C18.3334 27.413 19.0796 26.6668 20 26.6668C20.9205 26.6668 21.6667 27.413 21.6667 28.3335C21.6667 29.254 20.9205 30.0002 20 30.0002C19.0796 30.0002 18.3334 29.254 18.3334 28.3335Z",
      fill: "black"
    }
  )
] }), WhiteLabelLarge = (r) => /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071L11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4.23471 10.0686C9.31981 10.6368 13.363 14.6734 13.9315 19.7653C17.4167 18.9012 20 15.7523 20 12C20 7.58172 16.4183 4 12 4C8.24767 4 5.09872 6.58337 4.23471 10.0686ZM4.54667 12.1325L11.8677 19.4535C11.2213 15.7204 8.27568 12.7786 4.54667 12.1325Z",
    fill: "currentColor"
  }
) }), WhiteLabelSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.50818 7.69752L8.30248 13.4918C11.1994 13.3348 13.5 10.9361 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C5.06393 2.5 2.6652 4.80063 2.50818 7.69752ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C7.80109 15 7.61032 14.921 7.46967 14.7803L1.21967 8.53033C1.07902 8.38968 1 8.19891 1 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.94427 14.25C7.94427 11.2101 5.47937 8.75 2.44427 8.75V7.25C6.30691 7.25 9.44427 10.3808 9.44427 14.25H7.94427Z",
      fill: "currentColor"
    }
  )
] }), WireTransferLarge = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.99996 2C5.61925 2 4.49996 3.11929 4.49996 4.5V8C4.49996 8.55228 4.94768 9 5.49996 9C6.05225 9 6.49996 8.55228 6.49996 8V4.5C6.49996 4.22386 6.72382 4 6.99996 4H17C17.2761 4 17.5 4.22386 17.5 4.5V5.39762C17.5 5.9499 17.9477 6.39762 18.5 6.39762C19.0522 6.39762 19.5 5.9499 19.5 5.39762V4.5C19.5 3.11929 18.3807 2 17 2H6.99996Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17 22C18.3807 22 19.5 20.8807 19.5 19.5V16.0024C19.5 15.4501 19.0522 15.0024 18.5 15.0024C17.9477 15.0024 17.5 15.4501 17.5 16.0024V19.5C17.5 19.7761 17.2761 20 17 20L6.99996 20C6.72382 20 6.49996 19.7761 6.49996 19.5V18.6024C6.49996 18.0501 6.05225 17.6024 5.49996 17.6024C4.94768 17.6024 4.49996 18.0501 4.49996 18.6024V19.5C4.49996 20.8807 5.61925 22 6.99996 22L17 22Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 10.5C12 9.94772 12.4477 9.5 13 9.5H17.2379L16.3598 8.76825C15.9355 8.41468 15.8782 7.78412 16.2318 7.35984C16.5853 6.93556 17.2159 6.87824 17.6402 7.2318L20.6315 9.72461C20.8564 9.90798 21 10.1872 21 10.5C21 10.7923 20.8746 11.0554 20.6745 11.2382C20.6617 11.25 20.6486 11.2614 20.6351 11.2725L17.6402 13.7682C17.2159 14.1218 16.5853 14.0645 16.2318 13.6402C15.8782 13.2159 15.9355 12.5854 16.3598 12.2318L17.238 11.5H13C12.4477 11.5 12 11.0523 12 10.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12 13.5C12 14.0523 11.5522 14.5 11 14.5H6.76202L7.64012 15.2318C8.0644 15.5853 8.12172 16.2159 7.76816 16.6402C7.4146 17.0644 6.78403 17.1218 6.35975 16.7682L3.36609 14.2735C3.32745 14.2418 3.29122 14.2072 3.25773 14.1702C3.10871 14.0052 3.0139 13.7904 3.00138 13.5537C3.00042 13.5359 2.99994 13.5179 2.99994 13.5C2.99994 13.2032 3.13176 12.9217 3.35975 12.7318L6.35975 10.2318C6.78403 9.87819 7.4146 9.93551 7.76816 10.3598C8.12172 10.7841 8.0644 11.4146 7.64012 11.7682L6.76196 12.5H11C11.5522 12.5 12 12.9477 12 13.5Z",
      fill: "currentColor"
    }
  )
] }), WireTransferSmall = (r) => /* @__PURE__ */ jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.75153 0C2.78427 0 2.00015 0.785803 2.00015 1.75514V4.99131C2.00015 5.40674 2.3362 5.74351 2.75074 5.74351C3.16528 5.74351 3.50134 5.40674 3.50134 4.99131V1.75514C3.50134 1.61667 3.61335 1.50441 3.75153 1.50441L12.2485 1.50441C12.3866 1.50441 12.4987 1.61667 12.4987 1.75515V2.92834C12.4987 3.34377 12.8347 3.68055 13.2493 3.68055C13.6638 3.68055 13.9998 3.34377 13.9998 2.92834V1.75515C13.9998 0.785811 13.2157 6.39644e-06 12.2485 5.73886e-06L3.75153 0Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 8.74045C8.41454 8.74045 8.75059 9.07722 8.75059 9.49265C8.75059 9.90808 8.41454 10.2449 8 10.2449H4.71722L5.24733 10.7085C5.55965 10.9817 5.59186 11.4569 5.31928 11.7698C5.0467 12.0828 4.57255 12.1151 4.26023 11.8419L2.25704 10.0899C2.09389 9.9472 2.00019 9.74084 2 9.52383C1.99981 9.30682 2.09315 9.1003 2.25605 8.95732L4.25922 7.19909C4.57106 6.92538 5.04527 6.95683 5.3184 7.26935C5.59152 7.58186 5.56014 8.05709 5.24829 8.3308L4.78158 8.74045H8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 5.70029C7.58546 5.70029 7.24941 6.03707 7.24941 6.4525C7.24941 6.86793 7.58546 7.2047 8 7.2047H11.2873L10.7527 7.67227C10.4404 7.94544 10.4081 8.42061 10.6807 8.7336C10.9533 9.04659 11.4275 9.07888 11.7398 8.80571L13.743 7.05365C13.9061 6.91096 13.9998 6.7046 14 6.48759C14.0002 6.27058 13.9068 6.06406 13.7439 5.92108L11.7408 4.16285C11.4289 3.88914 10.9547 3.92059 10.6816 4.23311C10.4085 4.54562 10.4399 5.02085 10.7517 5.29456L11.214 5.70029H8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.2485 16C13.2157 16 13.9998 15.2142 13.9998 14.2449V11.0087C13.9998 10.5933 13.6638 10.2565 13.2493 10.2565C12.8347 10.2565 12.4987 10.5933 12.4987 11.0087V14.2449C12.4987 14.3833 12.3866 14.4956 12.2485 14.4956L3.75153 14.4956C3.61335 14.4956 3.50133 14.3833 3.50133 14.2449V13.0717C3.50133 12.6562 3.16528 12.3195 2.75074 12.3195C2.3362 12.3195 2.00015 12.6562 2.00015 13.0717V14.2449C2.00015 15.2142 2.78427 16 3.75153 16L12.2485 16Z",
      fill: "currentColor"
    }
  )
] }), defaultIconsMap = {
  add: { small: AddSmall, medium: AddLarge },
  "add-bill": { small: AddBillSmall, medium: AddBillLarge },
  "ai-fraud-didection": { small: AiFraudDidectionSmall, medium: AiFraudDidectionLarge },
  approval: { small: ApprovalSmall, medium: ApprovalLarge },
  "approval-workflow": { small: ApprovalWorkflowSmall, medium: ApprovalWorkflowLarge },
  "arrow-down": { small: ArrowDownSmall, medium: ArrowDownLarge },
  "arrow-left": { small: ArrowLeftSmall, medium: ArrowLeftLarge },
  "arrow-right": { small: ArrowRightSmall, medium: ArrowRightLarge },
  "arrow-up": { small: ArrowUpSmall, medium: ArrowUpLarge },
  attachment: { small: AttachmentSmall, medium: AttachmentLarge },
  audio: { small: AudioSmall, medium: AudioLarge },
  bank: { small: BankSmall, medium: BankLarge },
  "bank-in": { small: BankInSmall, medium: BankInLarge },
  "bank-out": { small: BankOutSmall, medium: BankOutLarge },
  bills: { small: BillsSmall, medium: BillsLarge },
  "billing-settings": { small: BillingSettingsSmall, medium: BillingSettingsLarge },
  calculator: { small: CalculatorSmall, medium: CalculatorLarge },
  calendar: { small: CalendarSmall, medium: CalendarLarge },
  "calendar-move": { small: CalendarMoveSmall, medium: CalendarMoveLarge },
  camera: { small: CameraSmall, medium: CameraLarge },
  cancel: { small: CancelCircleFillSmall, medium: CancelCircleFillLarge },
  "cancel-circle": { small: CancelCircleSmall, medium: CancelCircleLarge },
  "caret-down": { small: CaretDownSmall, medium: CaretDownLarge },
  "caret-left": { small: CaretLeftSmall, medium: CaretLeftLarge },
  "caret-right": { small: CaretRightSmall, medium: CaretRightLarge },
  "caret-up": { small: CaretUpSmall, medium: CaretUpLarge },
  chat: { small: ChatSmall, medium: ChatLarge },
  "chat-empty": { small: ChatEmptySmall, medium: ChatEmptyLarge },
  checked: { small: CheckedSmall, medium: CheckedLarge },
  "checked-mini": CheckedMini,
  "checked-circle": { small: CheckedCircleSmall, medium: CheckedCircleLarge },
  "checked-circle-fill": { small: CheckedCircleFillSmall, medium: CheckedCircleFillLarge },
  "checked-double": { small: CheckedDoubleSmall, medium: CheckedDoubleLarge },
  "chevron-down": { small: ChevronDownSmall, medium: ChevronDownLarge },
  "chevron-left": { small: ChevronLeftSmall, medium: ChevronLeftLarge },
  "chevron-right": { small: ChevronRightSmall, medium: ChevronRightLarge },
  "chevron-up": { small: ChevronUpSmall, medium: ChevronUpLarge },
  close: { small: CloseSmall, medium: CloseLarge },
  "close-mini": { small: CloseMiniSmall, medium: CloseMiniLarge },
  company: { small: CompanySmall, medium: CompanyLarge },
  compose: { small: ComposeSmall, medium: ComposeLarge },
  configuration: { small: ConfigurationSmall, medium: ConfigurationLarge },
  contacts: { small: ContactsSmall, medium: ContactsLarge },
  "credit-card": { small: CreditCardSmall, medium: CreditCardLarge },
  crown: { small: CrownSmall, medium: CrownLarge },
  customer: { small: CustomerSmall, medium: CustomerLarge },
  dashboard: { small: DashboardSmall, medium: DashboardLarge },
  "debit-card": { small: DebitCardSmall, medium: DebitCardLarge },
  decline: { small: DeclineCircleSmall, medium: DeclineCircleLarge },
  "decline-fill": { small: DeclineCircleFillSmall, medium: DeclineCircleFillLarge },
  delete: { small: DeleteSmall, medium: DeleteLarge },
  "directory-payment": { small: DirectoryPaymentSmall, medium: DirectoryPaymentLarge },
  discount: { small: DiscountSmall, medium: DiscountLarge },
  download: { small: DownloadSmall, medium: DownloadLarge },
  duplicate: { small: DuplicateSmall, medium: DuplicateLarge },
  "duplicate-flip": { small: DuplicateFlipSmall, medium: DuplicateFlipLarge },
  edit: { small: EditSmall, medium: EditLarge },
  email: { small: EmailSmall, medium: EmailLarge },
  error: { small: ErrorCircleSmall, medium: ErrorCircleLarge },
  "error-fill": { small: ErrorCircleFillSmall, medium: ErrorCircleFillLarge },
  exit: { small: ExitSmall, medium: ExitLarge },
  fast: { small: FastSmall, medium: FastLarge },
  favourite: { small: FavouriteSmall, medium: FavouriteLarge },
  "file-add": { small: FileAddSmall, medium: FileAddLarge },
  "file-move": { small: FileMoveSmall, medium: FileMoveLarge },
  filter: { small: FilterSmall, medium: FilterLarge },
  flow: { small: FlowSmall, medium: FlowLarge },
  "foreign-currency": { small: ForeignCurrencySmall, medium: ForeignCurrencyLarge },
  gallery: { small: GallerySmall, medium: GalleryLarge },
  "get-paid": { small: GetPaidSmall, medium: GetPaidLarge },
  "get-started": { small: GetStartedSmall, medium: GetStartedLarge },
  glasses: { small: GlassesSmall, medium: GlassesLarge },
  "help-circle": { small: HelpCircleSmall, medium: HelpCircleLarge },
  "help-circle-fill": { small: HelpCircleFillSmall, medium: HelpCircleFillLarge },
  hide: { small: HideSmall, medium: HideLarge },
  iframe: { small: IframeSmall, medium: IframeLarge },
  "image-add": { small: ImageAddSmall, medium: ImageAddLarge },
  install: { small: InstallSmall, medium: InstallLarge },
  installments: { small: InstallmentsSmall, medium: InstallmentsLarge },
  info: { small: InfoCircleSmall, medium: InfoCircleLarge },
  "info-fill": { small: InfoCircleFillSmall, medium: InfoCircleFillLarge },
  international: { small: InternationalSmall, medium: InternationalLarge },
  invoices: { small: InvoicesSmall, medium: InvoicesLarge },
  laptop: { small: LaptopSmall, medium: LaptopLarge },
  "link-fill": { small: LinkCircleFillSmall, medium: LinkCircleFillLarge },
  "link-open": { small: LinkOpenSmall, medium: LinkOpenLarge },
  lock: { small: LockSmall, medium: LockLarge },
  "mail-inbox": { small: MailInboxSmall, medium: MailInboxLarge },
  menu: { small: MenuSmall, medium: MenuLarge },
  mobile: { small: MobileSmall, medium: MobileLarge },
  monitor: { small: MonitorSmall, medium: MonitorLarge },
  "money-payment": { small: MoneyPaymentSmall, medium: MoneyPaymentLarge },
  "money-receive": { small: MoneyReceiveSmall, medium: MoneyReceiveLarge },
  more: More,
  "more-vertical": MoreVertical,
  "more-vertical-aligned-left": MoreVerticalAlignedLeft,
  "multi-use-card": { small: MultiUseCardSmall, medium: MultiUseCardLarge },
  "no-bills": { small: NoBillsSmall, medium: NoBillsLarge },
  "note-add": { small: NoteAddSmall, medium: NoteAddLarge },
  notification: { small: NotificationSmall, medium: NotificationLarge },
  "multipule-approval": { small: MultipuleApprovalSmall, medium: MultipuleApprovalLarge },
  "paper-check": { small: PaperCheckSmall, medium: PaperCheckLarge },
  path: { small: PathSmall, medium: PathLarge },
  pause: { small: PauseSmall, medium: PauseLarge },
  "pause-circle": { small: PauseCircleSmall, medium: PauseCircleLarge },
  "pause-fill": { small: PauseCircleFillSmall, medium: PauseCircleFillLarge },
  pay: { small: PaySmall, medium: PayLarge },
  payments: { small: PaymentsSmall, medium: PaymentsLarge },
  "pause-solid": PauseSolidLarge,
  phone: { small: PhoneSmall, medium: PhoneLarge },
  play: { small: PlaySmall, medium: PlayLarge },
  premium: { small: PremiumSmall, medium: PremiumLarge },
  print: { small: PrintSmall, medium: PrintLarge },
  process: { small: ProcessSmall, medium: ProcessLarge },
  "process-fill": { small: ProcessFillSmall, medium: ProcessFillLarge },
  promote: { small: PromoteSmall, medium: PromoteLarge },
  protection: { small: ProtectionSmall, medium: ProtectionLarge },
  "qr-code": { small: QrCodeSmall, medium: QrCodeLarge },
  refresh: { small: RefreshSmall, medium: RefreshLarge },
  "refresh-fill": { small: RefreshCircleFillSmall, medium: RefreshCircleFillLarge },
  repeat: { small: RepeatSmall, medium: RepeatLarge },
  remove: { small: RemoveSmall, medium: RemoveLarge },
  scheduled: { small: ScheduledSmall, medium: ScheduledLarge },
  search: { small: SearchSmall, medium: SearchLarge },
  send: { small: SendSmall, medium: SendLarge },
  settings: { small: SettingsSmall, medium: SettingsLarge },
  share: { small: ShareSmall, medium: ShareLarge },
  shield: { small: ShieldSmall, medium: ShieldLarge },
  ship: { small: ShipSmall, medium: ShipLarge },
  shop: { small: ShopSmall, medium: ShopLarge },
  show: { small: ShowSmall, medium: ShowLarge },
  "single-use-card": { small: SingleUseCardSmall, medium: SingleUseCardLarge },
  "software-sync": { small: SoftwareSyncSmall, medium: SoftwareSyncLarge },
  sort: { small: SortSmall, medium: SortLarge },
  stopwatch: { small: StopwatchSmall, medium: StopwatchLarge },
  "stopwatch-fast": { small: StopwatchFastSmall, medium: StopwatchFastLarge },
  "stopwatch-fill": { small: StopwatchFillSmall, medium: StopwatchFillLarge },
  "sub-arrow": { small: SubArrowSmall, medium: SubArrowLarge },
  sync: { small: SyncSmall, medium: SyncLarge },
  "tablet-edit": { small: TabletEditSmall, medium: TabletEditLarge },
  "tablet-search": { small: TabletSearchSmall, medium: TabletSearchLarge },
  team: { small: TeamSmall, medium: TeamLarge },
  thunder: { small: ThunderSmall, medium: ThunderLarge },
  "to-do": { small: ToDoSmall, medium: ToDoLarge },
  track: { small: TrackSmall, medium: TrackLarge },
  upload: { small: UploadSmall, medium: UploadLarge },
  user: { small: UserSmall, medium: UserLarge },
  "user-add": { small: UserAddSmall, medium: UserAddLarge },
  "user-check": { small: UserCheckSmall, medium: UserCheckLarge },
  "user-id": { small: UserIdSmall, medium: UserIdLarge },
  "user-remove": { small: UserRemoveSmall, medium: UserRemoveLarge },
  vendor: { small: VendorSmall, medium: VendorLarge },
  verified: { small: VerifiedSmall, medium: VerifiedLarge },
  video: { small: VideoSmall, medium: VideoLarge },
  wallet: { small: WalletSmall, medium: WalletLarge },
  warning: { small: WarningSmall, medium: WarningLarge },
  "warning-fill": { small: WarningFillSmall, medium: WarningFillLarge },
  "warning-solid": WarningSolidLarge,
  "white-label": { small: WhiteLabelSmall, medium: WhiteLabelLarge },
  "wire-transfer": { small: WireTransferSmall, medium: WireTransferLarge },
  "multi-company": { small: MultiCompanySmall, medium: MultiCompanyLarge },
  resize: { small: ResizeSmall, medium: ResizeLarge }
}, allIcons = {
  ...defaultIconsMap,
  ...flagsMap
}, icons = defaultIconsMap, IconsProvider = ({ children: r, icons: a = {} }) => /* @__PURE__ */ jsx(IconsContext.Provider, { value: lodashExports.merge(allIcons, a), children: r }), IconsContext = React__default.createContext({}), AddCard = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18 112C16.8954 112 16 111.105 16 110L16 35.8286C16 34.724 16.8954 33.8286 18 33.8286L126 33.8286C127.105 33.8286 128 34.724 128 35.8286L128 110C128 111.105 127.105 112 126 112L18 112Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 113C15.7909 113 14 111.213 14 109.008L14 34.9917C14 32.7871 15.7909 31 18 31L126 31C128.209 31 130 32.7871 130 34.9917L130 109.008C130 111.213 128.209 113 126 113L18 113ZM18 34.9917L18 109.008L126 109.008L126 34.9917L18 34.9917Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M130 53H14V72H130V53Z", fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
        fill: (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
        fill: (y = (v = r.semantic) == null ? void 0 : v.illustration) == null ? void 0 : y.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M116 32H123V28H116V21L112 21V28H105L105 32H112V39H116V32Z",
        fill: (w = (x = r.semantic) == null ? void 0 : x.illustration) == null ? void 0 : w.border
      }
    )
  ] });
}, AddUser = () => {
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 120 120", children: [
    /* @__PURE__ */ jsx("circle", { cx: "57.56", cy: "62.441", r: "45.56", fill: r.semantic.illustration.brand.secondary }),
    /* @__PURE__ */ jsx("circle", { cx: "57.821", cy: "48.211", r: "15.72", fill: r.semantic.illustration.brand.primary }),
    /* @__PURE__ */ jsx(
      "mask",
      {
        id: "mask_add_user",
        style: { maskType: "alpha" },
        maskUnits: "userSpaceOnUse",
        x: "11",
        y: "16",
        width: "93",
        height: "92",
        children: /* @__PURE__ */ jsx("circle", { cx: "57.559", cy: "62.441", r: "45.56", fill: r.semantic.illustration.background })
      }
    ),
    /* @__PURE__ */ jsx("g", { mask: "url(#mask_add_user)", children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M58.014 68.806c-17.329 0-31.469 16.63-32.246 37.501-.04 1.074.67 2.025 1.699 2.337l30.547 9.263 30.547-9.263c1.029-.312 1.739-1.263 1.699-2.337-.777-20.871-14.917-37.501-32.246-37.501Z",
        fill: r.semantic.illustration.brand.primary
      }
    ) }),
    /* @__PURE__ */ jsx("circle", { cx: "57.56", cy: "62.441", r: "45.56", stroke: r.semantic.illustration.border, strokeWidth: "3" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M106.501 28.27c0 8.159-6.614 14.772-14.772 14.772-8.158 0-14.771-6.613-14.771-14.771 0-8.158 6.613-14.772 14.771-14.772 8.158 0 14.772 6.614 14.772 14.772Z",
        fill: r.semantic.illustration.background,
        stroke: r.semantic.illustration.border,
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "square",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M84.407 28.271H99.05M91.73 35.593V20.949", stroke: r.semantic.illustration.border, strokeWidth: "3" })
  ] });
}, Bank = () => {
  var a, s, c, u, d, h, p, m;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8923 53.6374L69.2877 18.5573C70.5931 17.7306 72.2555 17.7234 73.5681 18.5388L130.078 53.6417C131.263 54.3779 131.984 55.6753 131.984 57.0719L131.984 58.3692C131.984 60.5986 130.179 62.4059 127.953 62.4059H121.494C121.837 62.9996 122.034 63.689 122.034 64.4242V113.369C122.034 114.105 121.837 114.794 121.494 115.388H127.073C129.3 115.388 131.105 117.195 131.105 119.425V123.461C131.105 125.691 129.3 127.498 127.073 127.498H16.2044C13.9778 127.498 12.1728 125.691 12.1728 123.461V119.425C12.1728 117.195 13.9778 115.388 16.2044 115.388H22.7911C22.448 114.794 22.2515 114.105 22.2515 113.369V64.4242C22.2515 63.689 22.4479 62.9996 22.7909 62.4059H16.0474C13.8208 62.4059 12.0158 60.5986 12.0158 58.3692L12.0157 57.049C12.0157 55.6649 12.724 54.3773 13.8923 53.6374ZM38.8465 62.4059C39.1895 62.9996 39.3858 63.689 39.3858 64.4242V113.369C39.3858 114.105 39.1894 114.794 38.8463 115.388H64.115C63.7719 114.794 63.5755 114.105 63.5755 113.369V64.4242C63.5755 63.689 63.7718 62.9996 64.1148 62.4059L38.8465 62.4059ZM80.1704 62.4059C80.5134 62.9996 80.7098 63.689 80.7098 64.4242V113.369C80.7098 114.105 80.5134 114.794 80.1702 115.388H105.439C105.096 114.794 104.899 114.105 104.899 113.369V64.4242C104.899 63.689 105.096 62.9996 105.439 62.4059L80.1704 62.4059Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70.3653 20.2633C71.018 19.85 71.8492 19.8464 72.5054 20.254L129.015 55.357C129.608 55.7251 129.968 56.3737 129.968 57.072V58.3693C129.968 59.484 129.066 60.3877 127.953 60.3877L16.0474 60.3877C14.9341 60.3877 14.0316 59.4841 14.0316 58.3694L14.0316 57.0492C14.0316 56.3571 14.3857 55.7133 14.9699 55.3434L70.3653 20.2633ZM74.6309 16.8238C72.662 15.6008 70.1684 15.6116 68.2103 16.8517L12.8149 51.9318C11.0624 53.0415 9.99999 54.973 10 57.0492L10 58.3694C10 61.7135 12.7075 64.4244 16.0474 64.4244H22.2516C22.2516 64.4244 22.2516 64.4244 22.2516 64.4244V113.369V113.37H16.2045C12.8646 113.37 10.1571 116.081 10.1571 119.425V123.461C10.1571 126.805 12.8646 129.516 16.2045 129.516H127.073C130.413 129.516 133.121 126.805 133.121 123.461V119.425C133.121 116.081 130.413 113.37 127.073 113.37H122.034V113.369V64.4244L127.953 64.4244C131.293 64.4244 134 61.7134 134 58.3693V57.072C134 54.9772 132.919 53.0311 131.141 51.9268L74.6309 16.8238ZM104.899 64.4244L80.7098 64.4244V113.369V113.37H104.899V113.369V64.4244ZM63.5755 64.4244H39.3859C39.3859 64.4244 39.3859 64.4244 39.3859 64.4244V113.369V113.37H63.5755V113.369V64.4244C63.5755 64.4244 63.5755 64.4244 63.5755 64.4244ZM26.2832 64.4244H35.3543V113.369H26.2832V64.4244ZM76.6782 64.4244H67.6071V113.369H76.6782V64.4244ZM118.002 113.369V64.4244H108.931V113.369H118.002ZM16.2045 117.406C15.0912 117.406 14.1887 118.31 14.1887 119.425V123.461C14.1887 124.576 15.0912 125.48 16.2045 125.48H127.073C128.187 125.48 129.089 124.576 129.089 123.461V119.425C129.089 118.31 128.187 117.406 127.073 117.406H16.2045Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M80.71 42.8509C80.71 47.8671 76.6487 51.9335 71.6389 51.9335C66.629 51.9335 62.5677 47.8671 62.5677 42.8509C62.5677 37.8347 66.629 33.7683 71.6389 33.7683C76.6487 33.7683 80.71 37.8347 80.71 42.8509Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    )
  ] });
}, BankMissing = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8924 53.6375L69.2878 18.5575C70.5932 17.7308 72.2556 17.7236 73.5682 18.5389L130.078 53.6418C131.263 54.3781 131.984 55.6754 131.984 57.072V58.3693C131.984 60.5987 130.179 62.406 127.953 62.406H121.494C121.837 62.9998 122.034 63.6891 122.034 64.4244V113.369C122.034 114.105 121.837 114.794 121.494 115.388H127.073C129.3 115.388 131.105 117.195 131.105 119.425V123.461C131.105 125.691 129.3 127.498 127.073 127.498H16.2045C13.9779 127.498 12.1729 125.691 12.1729 123.461V119.425C12.1729 117.195 13.9779 115.388 16.2045 115.388H22.7911C22.448 114.794 22.2516 114.105 22.2516 113.369V64.4244C22.2516 63.6891 22.448 62.9998 22.791 62.406H16.0474C13.8208 62.406 12.0158 60.5987 12.0158 58.3693L12.0158 57.0492C12.0158 55.665 12.7241 54.3774 13.8924 53.6375ZM38.8465 62.406C39.1896 62.9998 39.3859 63.6891 39.3859 64.4244V113.369C39.3859 114.105 39.1895 114.794 38.8464 115.388H64.115C63.7719 114.794 63.5755 114.105 63.5755 113.369V64.4244C63.5755 63.6891 63.7718 62.9998 64.1149 62.406H38.8465ZM80.1704 62.406C80.5135 62.9998 80.7098 63.6891 80.7098 64.4244V113.369C80.7098 114.105 80.5134 114.794 80.1703 115.388H105.439C105.096 114.794 104.899 114.105 104.899 113.369V64.4244C104.899 63.6891 105.096 62.9998 105.439 62.406H80.1704Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70.3653 20.2633C71.018 19.85 71.8492 19.8464 72.5054 20.254L129.015 55.3569C129.608 55.7251 129.968 56.3737 129.968 57.072V58.3693C129.968 59.484 129.066 60.3877 127.953 60.3877L16.0474 60.3877C14.9341 60.3877 14.0316 59.484 14.0316 58.3693L14.0316 57.0492C14.0316 56.3571 14.3857 55.7133 14.9699 55.3434L70.3653 20.2633ZM74.6308 16.8238C72.662 15.6008 70.1684 15.6116 68.2102 16.8517L12.8149 51.9317C11.0624 53.0415 9.99999 54.973 10 57.0492L10 58.3694C10 61.7135 12.7075 64.4244 16.0474 64.4244H22.2517C22.2517 64.4244 22.2517 64.4244 22.2517 64.4244V113.369V113.37H16.2045C12.8646 113.37 10.1571 116.081 10.1571 119.425V123.461C10.1571 126.806 12.8646 129.516 16.2045 129.516H127.073C130.413 129.516 133.121 126.806 133.121 123.461V119.425C133.121 116.081 130.413 113.37 127.073 113.37H122.034V113.369V64.4244L127.953 64.4244C131.292 64.4244 134 61.7134 134 58.3693L134 57.072C134 54.9772 132.919 53.0311 131.141 51.9268L74.6308 16.8238ZM104.899 64.4244L80.7099 64.4244V113.369V113.37H104.899V113.369V64.4244ZM63.5756 64.4244H39.386C39.386 64.4244 39.386 64.4244 39.386 64.4244V113.369V113.37H63.5756V113.369V64.4244C63.5756 64.4244 63.5756 64.4244 63.5756 64.4244ZM26.2833 64.4244H35.3544V113.369H26.2833V64.4244ZM76.6783 64.4244H67.6072V113.369H76.6783V64.4244ZM118.002 113.369V64.4244H108.931V113.369H118.002ZM16.2045 117.406C15.0912 117.406 14.1887 118.31 14.1887 119.425V123.461C14.1887 124.576 15.0912 125.48 16.2045 125.48H127.073C128.187 125.48 129.089 124.576 129.089 123.461V119.425C129.089 118.31 128.187 117.406 127.073 117.406H16.2045Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M80.7098 42.8506C80.7098 47.8668 76.6486 51.9332 71.6387 51.9332C66.6289 51.9332 62.5676 47.8668 62.5676 42.8506C62.5676 37.8345 66.6289 33.7681 71.6387 33.7681C76.6486 33.7681 80.7098 37.8345 80.7098 42.8506Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50.7152C125.046 50.7152 134 41.7609 134 30.7152C134 19.6695 125.046 10.7152 114 10.7152C102.954 10.7152 94 19.6695 94 30.7152C94 41.7609 102.954 50.7152 114 50.7152Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M130 30.7152C130 39.5518 122.837 46.7152 114 46.7152C105.163 46.7152 98 39.5518 98 30.7152C98 21.8787 105.163 14.7152 114 14.7152C122.837 14.7152 130 21.8787 130 30.7152ZM114 50.7152C125.046 50.7152 134 41.7609 134 30.7152C134 19.6695 125.046 10.7152 114 10.7152C102.954 10.7152 94 19.6695 94 30.7152C94 41.7609 102.954 50.7152 114 50.7152ZM108.646 21.3466C110.117 20.2136 111.935 19.7152 113.5 19.7152C114.949 19.7152 116.77 20.0567 118.289 21.1315C119.909 22.2775 121 24.1355 121 26.693C121 29.8765 118.744 31.4792 117.421 32.4189L117.283 32.5171L117.283 32.5171C116.601 33.0011 116.179 33.301 115.876 33.6317C115.632 33.8976 115.591 34.0503 115.597 34.245L115.598 34.2742V35.2152H111.598V34.329C111.565 32.865 112.171 31.755 112.925 30.9307C113.536 30.2636 114.321 29.7105 114.909 29.2963C114.977 29.2486 115.042 29.2027 115.104 29.1586C116.507 28.162 117 27.6344 117 26.693C117 25.4105 116.52 24.7797 115.979 24.3967C115.337 23.9427 114.408 23.7152 113.5 23.7152C112.708 23.7152 111.776 23.9848 111.086 24.5158C110.46 24.9978 110 25.7093 110 26.8352H106C106 24.3772 107.111 22.5286 108.646 21.3466ZM116 40.2152C116 41.5959 114.881 42.7152 113.5 42.7152C112.119 42.7152 111 41.5959 111 40.2152C111 38.8345 112.119 37.7152 113.5 37.7152C114.881 37.7152 116 38.8345 116 40.2152Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    )
  ] });
}, BankSuccess = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.4207 53.8109L69.3125 19.0498C70.606 18.2306 72.2533 18.2235 73.5539 19.0314L129.55 53.8152C130.724 54.5448 131.439 55.8303 131.439 57.2142V58.4997C131.439 60.7088 129.65 62.4997 127.444 62.4997H121.044C121.384 63.0881 121.579 63.7712 121.579 64.4998V113C121.579 113.728 121.384 114.412 121.044 115H126.573C128.779 115 130.568 116.791 130.568 119V123C130.568 125.209 128.779 127 126.573 127H16.7118C14.5054 127 12.7168 125.209 12.7168 123V119C12.7168 116.791 14.5054 115 16.7118 115H23.2386C22.8986 114.412 22.704 113.728 22.704 113V64.4998C22.704 63.7712 22.8986 63.0881 23.2385 62.4997H16.5562C14.3498 62.4997 12.5612 60.7089 12.5612 58.4997L12.5612 57.1916C12.5612 55.82 13.263 54.5441 14.4207 53.8109ZM39.148 62.4997C39.488 63.0881 39.6825 63.7712 39.6825 64.4998V113C39.6825 113.728 39.4879 114.412 39.1479 115H64.1868C63.8468 114.412 63.6522 113.728 63.6522 113V64.4998C63.6522 63.7712 63.8468 63.0881 64.1867 62.4997H39.148ZM80.0962 62.4997C80.4361 63.0881 80.6307 63.7712 80.6307 64.4998V113C80.6307 113.728 80.4361 114.412 80.0961 115H105.135C104.795 114.412 104.6 113.728 104.6 113V64.4998C104.6 63.7712 104.795 63.0881 105.135 62.4997H80.0962Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70.3801 20.7401C71.0269 20.3305 71.8506 20.327 72.5009 20.7309L128.497 55.5147C129.084 55.8795 129.441 56.5223 129.441 57.2142L129.441 58.4997C129.441 59.6043 128.547 60.4997 127.444 60.4997H16.5561C15.453 60.4997 14.5587 59.6043 14.5587 58.4997L14.5587 57.1915C14.5587 56.5058 14.9096 55.8678 15.4884 55.5012L70.3801 20.7401ZM74.607 17.3319C72.656 16.12 70.1851 16.1308 68.2447 17.3595L13.353 52.1206C11.6165 53.2203 10.5637 55.1342 10.5637 57.1916L10.5637 58.4997C10.5637 61.8134 13.2466 64.4997 16.5561 64.4997H22.704C22.704 64.4997 22.704 64.4997 22.704 64.4997V113V113H16.7118C13.4023 113 10.7194 115.686 10.7194 119V123C10.7194 126.314 13.4023 129 16.7118 129H126.573C129.882 129 132.565 126.314 132.565 123V119C132.565 115.686 129.882 113 126.573 113H121.579V113V64.4997L127.444 64.4997C130.753 64.4997 133.436 61.8134 133.436 58.4997L133.436 57.2142C133.436 55.1384 132.365 53.21 130.603 52.1157L74.607 17.3319ZM104.6 64.4997H80.6307V113V113H104.6V113V64.4997ZM63.6522 64.4997L39.6825 64.4997C39.6825 64.4997 39.6825 64.4997 39.6825 64.4997V113V113H63.6522V113V64.4997C63.6522 64.4997 63.6522 64.4997 63.6522 64.4997ZM26.699 64.4997H35.6876V113H26.699V64.4997ZM76.6358 64.4997H67.6472V113H76.6358V64.4997ZM117.584 113V64.4997H108.595V113H117.584ZM16.7118 117C15.6087 117 14.7144 117.895 14.7144 119V123C14.7144 124.105 15.6087 125 16.7118 125H126.573C127.676 125 128.57 124.105 128.57 123V119C128.57 117.895 127.676 117 126.573 117H16.7118Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M80.6307 43.1221C80.6307 48.0926 76.6063 52.1221 71.6421 52.1221C66.6778 52.1221 62.6534 48.0926 62.6534 43.1221C62.6534 38.1515 66.6778 34.1221 71.6421 34.1221C76.6063 34.1221 80.6307 38.1515 80.6307 43.1221Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50.7152C125.046 50.7152 134 41.7609 134 30.7152C134 19.6695 125.046 10.7152 114 10.7152C102.954 10.7152 94 19.6695 94 30.7152C94 41.7609 102.954 50.7152 114 50.7152Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.success
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46.7152C122.837 46.7152 130 39.5518 130 30.7152C130 21.8787 122.837 14.7152 114 14.7152C105.163 14.7152 98 21.8787 98 30.7152C98 39.5518 105.163 46.7152 114 46.7152ZM134 30.7152C134 41.7609 125.046 50.7152 114 50.7152C102.954 50.7152 94 41.7609 94 30.7152C94 19.6695 102.954 10.7152 114 10.7152C125.046 10.7152 134 19.6695 134 30.7152Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.41 26.5639L114.085 39.3041C112.972 40.5569 111.047 40.6542 109.813 39.52L102.75 33.0293L105.456 30.0839L111.771 35.8868L122.42 23.9064L125.41 26.5639Z",
        fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.background
      }
    )
  ] });
}, Blocked = () => {
  var a, s, c, u;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M124 72C124 100.719 100.719 124 72 124C43.2812 124 20 100.719 20 72C20 43.2812 43.2812 20 72 20C100.719 20 124 43.2812 124 72ZM110.316 71.9992C110.316 93.1605 93.1613 110.315 72 110.315C64.7601 110.315 57.9892 108.307 52.2138 104.818L104.818 52.213C108.308 57.9883 110.316 64.7593 110.316 71.9992ZM91.9486 39.2795C86.1379 35.7293 79.3079 33.6834 72 33.6834C50.8388 33.6834 33.6843 50.838 33.6843 71.9992C33.6843 79.3071 35.7301 86.1371 39.2803 91.9478L91.9486 39.2795Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.critical
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72ZM72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22ZM31.6843 71.9992C31.6843 49.7334 49.7342 31.6834 72 31.6834C79.6862 31.6834 86.8756 33.8363 92.9913 37.5729L95.1592 38.8974L38.8982 95.1583L37.5737 92.9905C33.8371 86.8748 31.6843 79.6854 31.6843 71.9992ZM72 35.6834C51.9434 35.6834 35.6843 51.9426 35.6843 71.9992C35.6843 78.0124 37.1442 83.6799 39.7284 88.6713L88.6721 39.7276C83.6808 37.1434 78.0132 35.6834 72 35.6834ZM105.21 48.9932L106.53 51.1787C110.203 57.2573 112.316 64.3846 112.316 71.9992C112.316 94.265 94.2658 112.315 72 112.315C64.3854 112.315 57.2582 110.202 51.1795 106.529L48.994 105.209L105.21 48.9932ZM55.5003 104.359C60.4495 106.888 66.0559 108.315 72 108.315C92.0567 108.315 108.316 92.0559 108.316 71.9992C108.316 66.0551 106.889 60.4487 104.36 55.4994L55.5003 104.359Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    )
  ] });
}, Celebration = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k, V, B, q, z, Z, G, K, U, F, N, D;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("circle", { cx: "72", cy: "72", r: "54", fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.7298 113.998C29.0421 114.776 27.2985 113.032 28.0763 111.345L60.1821 41.6811C60.7648 40.4169 62.4285 40.1197 63.4127 41.104L100.97 78.6617C101.955 79.646 101.658 81.3097 100.393 81.8923L30.7298 113.998Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.5669 115.815C28.1915 117.37 24.7043 113.883 26.2599 110.508L58.3657 40.8442C59.531 38.3158 62.8584 37.7214 64.8269 39.69L102.385 77.2477C104.353 79.2162 103.759 82.5436 101.23 83.7089L31.5669 115.815ZM61.9985 42.5184L29.8927 112.182L99.5562 80.0761L61.9985 42.5184Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M55.1809 57.0315L48.1766 72.2198L94.0624 74.4402L78.8156 59.1838L55.1809 57.0315Z",
        fill: (v = (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.brand) == null ? void 0 : v.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.0991 85.4441L35.0144 100.819L52.9545 101.658L82.3621 88.0998L42.0991 85.4441Z",
        fill: (w = (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.brand) == null ? void 0 : w.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M104.863 6L110.082 8.73681L108.307 18.8307L103.735 18.2421L104.863 6Z",
        fill: (P = (M = (S = r.semantic) == null ? void 0 : S.illustration) == null ? void 0 : M.brand) == null ? void 0 : P.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M123.865 27.7374L121.373 23.4605L132.183 17.1726L135.028 20.498L123.865 27.7374Z",
        fill: (T = (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.brand) == null ? void 0 : T.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M127.426 43.1778V38.9009L135.862 36.7625L138 41.0394L127.426 43.1778Z",
        fill: (A = (R = (E = r.semantic) == null ? void 0 : E.illustration) == null ? void 0 : R.brand) == null ? void 0 : A.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M85.9854 46.8047H89.7521L90.8508 56.1531L86.466 56.7809L85.9854 46.8047Z",
        fill: (B = (V = (k = r.semantic) == null ? void 0 : k.illustration) == null ? void 0 : V.brand) == null ? void 0 : B.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M108.959 63.3136L112.049 66.9922L120.014 57.1337L115.973 53.3276L108.959 63.3136Z",
        fill: (Z = (z = (q = r.semantic) == null ? void 0 : q.illustration) == null ? void 0 : z.brand) == null ? void 0 : Z.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M113.835 39.0747L116.444 42.9985L107.302 46.8045L105.634 44.3031L113.835 39.0747Z",
        fill: (U = (K = (G = r.semantic) == null ? void 0 : G.illustration) == null ? void 0 : K.brand) == null ? void 0 : U.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M77.6619 31.2982H82.5274L85.3819 19.5465L81.2227 17.1726L77.6619 31.2982Z",
        fill: (D = (N = (F = r.semantic) == null ? void 0 : F.illustration) == null ? void 0 : N.brand) == null ? void 0 : D.primary
      }
    )
  ] });
}, CustomerAdd = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k, V, B, q, z, Z, G, K, U;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M123.245 44.3253C123.245 42.1161 121.45 40.3253 119.236 40.3253H23.0182C20.804 40.3253 19.0091 42.1161 19.0091 44.3253V120C19.0091 122.209 20.804 124 23.0182 124H119.236C121.45 124 123.245 122.209 123.245 120V44.3253Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M105.204 80.1859C105.204 77.9767 103.409 76.1859 101.195 76.1859H81.1496C78.9354 76.1859 77.1405 77.9767 77.1405 80.1859V124H105.204V80.1859Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M64.6768 80.3415C64.6768 78.1324 62.8819 76.3416 60.6677 76.3416H40.6224C38.4082 76.3416 36.6133 78.1324 36.6133 80.3416V101.421C36.6133 103.63 38.4082 105.421 40.6224 105.421H60.6677C62.8819 105.421 64.6768 103.63 64.6768 101.421V80.3415Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.0181 44.3253L119.236 44.3253V120H105.204V80.1859C105.204 77.9767 103.409 76.1859 101.195 76.1859H81.1496C78.9354 76.1859 77.1405 77.9767 77.1405 80.1859V120L23.0181 120V44.3253ZM77.1405 124H105.204H119.236C121.45 124 123.245 122.209 123.245 120V44.3253C123.245 42.1161 121.45 40.3253 119.236 40.3253H23.0181C20.804 40.3253 19.0091 42.1161 19.0091 44.3253V120C19.0091 122.209 20.804 124 23.0181 124H77.1405ZM101.195 80.1859V120H81.1496V80.1859H101.195ZM60.6677 80.3415L40.6224 80.3416V101.421L60.6677 101.421V80.3415ZM64.6768 80.3415C64.6768 78.1324 62.8819 76.3416 60.6677 76.3416H40.6224C38.4082 76.3416 36.6133 78.1324 36.6133 80.3416V101.421C36.6133 103.63 38.4082 105.421 40.6224 105.421H60.6677C62.8819 105.421 64.6768 103.63 64.6768 101.421V80.3415Z",
        fill: (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M100.937 20H70.8687V52C70.8687 60.2843 77.5996 67 85.9027 67C94.2057 67 100.937 60.2843 100.937 52V20Z",
        fill: (x = (y = (v = r.semantic) == null ? void 0 : v.illustration) == null ? void 0 : y.brand) == null ? void 0 : x.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M72.8731 20H42.8051V52C42.8051 60.2843 49.536 67 57.8391 67C66.1421 67 72.8731 60.2843 72.8731 52V20Z",
        fill: (M = (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.brand) == null ? void 0 : M.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.068 20H17.0045C15.8975 20 15 20.8954 15 22V52C15 60.2843 21.7309 67 30.034 67C38.337 67 45.068 60.2843 45.068 52V20Z",
        fill: (I = (L = (P = r.semantic) == null ? void 0 : P.illustration) == null ? void 0 : L.brand) == null ? void 0 : I.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M129 22C129 20.8954 128.103 20 126.995 20H98.932V52C98.932 60.2843 105.663 67 113.966 67C122.269 67 129 60.2843 129 52V22Z",
        fill: (R = (E = (T = r.semantic) == null ? void 0 : T.illustration) == null ? void 0 : E.brand) == null ? void 0 : R.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.0091 24H41.0589V52C41.0589 58.0751 36.1229 63 30.034 63C23.9451 63 19.0091 58.0751 19.0091 52V24ZM43.9365 57.7193C41.683 63.1665 36.3072 67 30.034 67C21.731 67 15 60.2843 15 52V22C15 20.8954 15.8975 20 17.0045 20H42.8051H45.068H70.8687H72.8731H98.932H100.937H126.995C128.103 20 129 20.8954 129 22V52C129 60.2843 122.269 67 113.966 67C107.57 67 102.106 63.0145 99.9343 57.3966C97.7625 63.0145 92.2991 67 85.9027 67C79.5062 67 74.0427 63.0143 71.8709 57.3962C69.6991 63.0143 64.2356 67 57.8391 67C51.5659 67 46.1901 63.1665 43.9365 57.7193ZM68.864 24H46.8141V52C46.8141 58.0751 51.7502 63 57.8391 63C63.928 63 68.864 58.0751 68.864 52V24ZM96.9276 24H74.8778V52C74.8778 58.0751 79.8138 63 85.9027 63C91.9916 63 96.9276 58.0751 96.9276 52V24ZM124.991 52V24H102.941V52C102.941 58.0751 107.877 63 113.966 63C120.055 63 124.991 58.0751 124.991 52Z",
        fill: (k = (A = r.semantic) == null ? void 0 : A.illustration) == null ? void 0 : k.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
        fill: (B = (V = r.semantic) == null ? void 0 : V.illustration) == null ? void 0 : B.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30ZM112 32L105 32L105 28L112 28L112 21L116 21L116 28L123 28L123 32L116 32L116 39L112 39L112 32Z",
        fill: (z = (q = r.semantic) == null ? void 0 : q.illustration) == null ? void 0 : z.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M50 114C50 125.046 41.0457 134 30 134C18.9543 134 10 125.046 10 114C10 102.954 18.9543 94 30 94C41.0457 94 50 102.954 50 114Z",
        fill: (G = (Z = r.semantic) == null ? void 0 : Z.illustration) == null ? void 0 : G.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.9596 124.629C44.4731 121.803 46 118.08 46 114C46 105.163 38.8366 98 30 98C21.1634 98 14 105.163 14 114C14 118.214 15.6292 122.048 18.2921 124.905C20.7341 120.013 25.1519 116.746 30.1963 116.746C35.1452 116.746 39.4909 119.891 41.9596 124.629ZM38.8386 127.339C37.015 123.142 33.538 120.746 30.1963 120.746C26.8022 120.746 23.2683 123.218 21.4693 127.539C23.9385 129.098 26.8639 130 30 130C33.2675 130 36.3062 129.021 38.8386 127.339ZM30 134C41.0457 134 50 125.046 50 114C50 102.954 41.0457 94 30 94C18.9543 94 10 102.954 10 114C10 125.046 18.9543 134 30 134ZM29.9999 109.887C31.0635 109.887 31.9258 109.025 31.9258 107.961C31.9258 106.898 31.0635 106.035 29.9999 106.035C28.9362 106.035 28.0739 106.898 28.0739 107.961C28.0739 109.025 28.9362 109.887 29.9999 109.887ZM29.9999 113.887C33.2727 113.887 35.9258 111.234 35.9258 107.961C35.9258 104.689 33.2727 102.035 29.9999 102.035C26.7271 102.035 24.0739 104.689 24.0739 107.961C24.0739 111.234 26.7271 113.887 29.9999 113.887Z",
        fill: (U = (K = r.semantic) == null ? void 0 : K.illustration) == null ? void 0 : U.border
      }
    )
  ] });
}, Declined = () => {
  var a, s, c, u, d, h;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.critical
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70.7578 80.2521C71.5388 79.4711 72.8052 79.4711 73.5862 80.2521L94.0908 100.757C94.8718 101.538 96.1382 101.538 96.9192 100.757L100.757 96.9188C101.538 96.1377 101.538 94.8714 100.757 94.0904L80.2525 73.5858C79.4715 72.8047 79.4715 71.5384 80.2525 70.7574L100.758 50.2521C101.539 49.4711 101.539 48.2047 100.758 47.4237L96.9199 43.5858C96.1388 42.8047 94.8725 42.8047 94.0915 43.5858L73.5862 64.091C72.8052 64.8721 71.5388 64.8721 70.7578 64.091L50.2525 43.5858C49.4715 42.8047 48.2052 42.8047 47.4241 43.5858L43.5862 47.4237C42.8052 48.2047 42.8052 49.4711 43.5862 50.2521L64.0915 70.7574C64.8725 71.5384 64.8725 72.8047 64.0915 73.5858L43.5869 94.0904C42.8058 94.8714 42.8058 96.1377 43.5869 96.9188L47.4248 100.757C48.2058 101.538 49.4722 101.538 50.2532 100.757L70.7578 80.2521Z",
        fill: (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.background
      }
    )
  ] });
}, Expired = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("circle", { cx: "72", cy: "72", r: "54", fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M118 72C118 97.4051 97.4051 118 72 118C46.5949 118 26 97.4051 26 72C26 46.5949 46.5949 26 72 26C97.4051 26 118 46.5949 118 72Z",
        fill: (v = (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.brand) == null ? void 0 : v.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72 114C95.196 114 114 95.196 114 72C114 48.804 95.196 30 72 30C48.804 30 30 48.804 30 72C30 95.196 48.804 114 72 114ZM72 118C97.4051 118 118 97.4051 118 72C118 46.5949 97.4051 26 72 26C46.5949 26 26 46.5949 26 72C26 97.4051 46.5949 118 72 118Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M74 41H70V71.2L50.5517 91.6207L53.4483 94.3793L74 72.8V41Z",
        fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M72 78C75.3137 78 78 75.3137 78 72C78 68.6863 75.3137 66 72 66C68.6863 66 66 68.6863 66 72C66 75.3137 68.6863 78 72 78Z",
        fill: (L = (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.brand) == null ? void 0 : L.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
        fill: (T = (I = r.semantic) == null ? void 0 : I.illustration) == null ? void 0 : T.critical
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
        fill: (R = (E = r.semantic) == null ? void 0 : E.illustration) == null ? void 0 : R.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M116 33V18H112V33H116ZM117 39C117 40.6569 115.657 42 114 42C112.343 42 111 40.6569 111 39C111 37.3431 112.343 36 114 36C115.657 36 117 37.3431 117 39Z",
        fill: (k = (A = r.semantic) == null ? void 0 : A.illustration) == null ? void 0 : k.background
      }
    )
  ] });
}, Fast = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.9129 111.193C38.0123 113.993 32.6113 115.093 29.7108 115.493C28.8106 115.593 28.0105 114.793 28.2105 113.893C28.7106 111.093 29.9108 105.593 32.8114 102.793C36.8121 98.8927 40.2127 99.2927 42.4131 101.593C44.7136 103.893 44.9136 107.293 40.9129 111.193Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.critical
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M133.93 26.7927L133.53 17.1927C133.43 13.7927 130.729 10.9927 127.329 10.7927L117.827 10.1927C89.5218 8.29274 62.4168 22.2927 47.5141 46.5927L34.1117 44.9927C29.6108 44.4927 25.21 46.8927 23.2097 50.8927L10.3073 76.8927C9.30711 78.9927 11.4075 81.1927 13.5079 80.1927L33.0115 71.0927L27.6105 80.1927L62.1168 115.793L72.9188 109.693L73.0188 109.993L63.517 130.493C62.5169 132.593 64.7173 134.693 66.8177 133.693L92.6224 120.693C96.7231 118.693 99.0236 114.293 98.5235 109.693L96.9232 95.9927C120.828 81.4927 135.13 54.9927 133.93 26.7927Z",
        fill: (d = (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.brand) == null ? void 0 : d.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M92.2223 72.4928C103.924 72.4928 113.326 62.9928 113.326 51.2928C113.326 39.5928 103.924 30.0928 92.2223 30.0928C80.5201 30.0928 71.1184 39.5928 71.1184 51.2928C71.1184 62.9928 80.6201 72.4928 92.2223 72.4928Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.7151 96.918C37.2941 96.918 34.97 98.0798 32.6459 100.307C29.6439 103.211 28.2882 108.343 27.6103 112.119C27.4167 113.184 27.804 114.249 28.4819 114.927C29.0629 115.604 29.9344 115.895 30.806 115.895C30.9997 115.895 31.0965 115.895 31.2902 115.895C34.389 115.507 39.9087 114.249 43.1044 111.247L43.2012 111.151C49.3988 105.051 45.9127 100.403 44.6538 99.1448C43.2981 97.7893 41.555 97.0148 39.7151 96.918ZM40.5866 108.44L40.4898 108.536C38.8435 110.086 35.6479 111.344 31.5807 112.022C32.3554 107.955 33.7111 104.76 35.3574 103.114C36.9068 101.565 38.3593 100.791 39.6182 100.791C40.3929 100.791 41.1676 101.178 41.8455 101.856C43.5886 103.695 43.2012 105.825 40.5866 108.44Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M133.841 28.0788L133.454 18.7841C133.26 14.524 129.968 11.0384 125.61 10.748L116.508 10.1671C88.715 8.32748 62.2783 21.7855 47.2684 45.3128L35.4542 43.8605C30.3218 43.2795 25.2862 45.9905 22.9621 50.6379L10.47 75.8111C9.5985 77.457 9.98585 79.3934 11.2447 80.7489C12.5036 82.1044 14.4404 82.3949 16.0866 81.6203L29.2566 75.4238L27.223 78.9093C26.7388 79.6839 26.9325 80.6521 27.5135 81.233L60.9226 115.701C61.5036 116.379 62.472 116.476 63.2467 115.991L68.7664 112.893L61.8909 127.803C61.1162 129.449 61.5036 131.386 62.7625 132.741C63.634 133.516 64.6024 134 65.7645 134C66.4423 134 67.1202 133.806 67.7012 133.516L92.6854 120.929C97.3336 118.606 100.045 113.571 99.464 108.343L98.1083 96.2401C121.349 81.6203 135.004 55.5757 133.841 28.0788ZM95.1063 93.626C94.4285 94.0133 94.138 94.7878 94.2348 95.4656L95.7842 108.73C96.1715 112.312 94.3316 115.798 91.136 117.347L66.1518 129.934C66.055 129.934 65.8613 130.03 65.6676 129.837C65.4739 129.74 65.474 129.546 65.5708 129.353L74.7704 109.505L85.5194 103.405L83.5826 100.016L62.7625 111.925L31.2902 79.5871L42.136 61.4817L38.8435 59.5453L32.8396 69.5178L14.4404 78.1348C14.3436 78.1348 14.1499 78.2316 13.9562 78.038C13.7625 77.8443 13.8594 77.6507 13.8594 77.5539L26.3514 52.3806C27.9977 49.1856 31.387 47.2492 34.97 47.7333L47.9463 49.1856C48.721 49.2824 49.3989 48.8951 49.7862 48.3142C64.0214 25.3678 89.3929 12.2003 116.217 14.0399L125.417 14.6208C127.741 14.8144 129.484 16.654 129.581 18.9777L129.968 28.2724C131.033 54.8011 117.67 79.7807 95.1063 93.626Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M91.5233 29.4343C79.2249 29.4343 69.1538 39.5036 69.1538 51.8966C69.1538 64.2896 79.2249 74.3589 91.5233 74.3589C103.822 74.3589 113.893 64.2896 113.893 51.8966C113.893 39.5036 103.919 29.4343 91.5233 29.4343ZM91.5233 70.4861C81.3554 70.4861 73.0273 62.1595 73.0273 51.8966C73.0273 41.6337 81.3554 33.3071 91.5233 33.3071C101.691 33.3071 110.019 41.6337 110.019 51.8966C110.019 62.1595 101.788 70.4861 91.5233 70.4861Z",
        fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M103.424 42.8928L100.624 40.0928L98.5234 42.1928C97.3232 41.4928 96.223 41.2928 95.4228 41.2928C93.8225 41.2928 92.3222 41.9928 91.022 43.2928C88.9216 45.3928 88.1215 49.1928 91.4221 52.3928C91.9222 52.8928 93.4224 54.3928 91.5221 56.2928C91.3221 56.5928 90.6219 57.0928 89.8218 57.0928C89.2217 57.0928 88.5216 56.6928 87.8214 55.9928C87.3213 55.4928 86.7212 54.6928 86.7212 53.8928C86.7212 53.1928 87.3213 52.5928 87.5214 52.3928L84.8209 49.3928C84.0207 50.0928 82.8205 51.5928 82.7205 53.6928C82.7205 54.7928 83.0205 55.8928 83.6206 56.9928L81.5203 59.0928L84.3208 61.8928L86.4212 59.7928C87.5214 60.4928 88.7216 60.8928 89.8218 60.8928C92.0222 60.8928 93.6225 59.5928 94.4226 58.7928C96.523 56.5928 97.7232 52.7928 94.2226 49.2928C92.5223 47.5928 93.4225 46.2928 93.8225 45.7928C94.3226 45.2928 94.9227 44.9928 95.4228 44.9928C96.223 44.9928 96.9231 45.5928 97.4232 46.0928C99.4235 48.0928 98.5234 48.9928 97.9233 49.5928L100.724 52.3928C103.024 50.0928 103.224 47.2928 101.324 44.6928L103.424 42.8928Z",
        fill: (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.background
      }
    )
  ] });
}, MoneySuccess = () => {
  var a, s, c, u, d, h, p, m, g, v;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126.441 30.6366V92.9122C126.441 95.1213 124.662 96.9449 122.46 97.1234C112.13 97.961 88.2277 101.321 70.9444 107.77C56.6946 113.087 34.6806 117.233 22.0874 119.174C19.6918 119.543 17.559 117.676 17.559 115.252V53.0606C17.559 50.9299 19.22 49.1736 21.3425 48.9871C32.999 47.9628 55.0362 44.592 70.9444 39.0027C87.3078 33.2534 107.37 27.656 122.447 26.7608C124.653 26.6298 126.441 28.4274 126.441 30.6366Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M122.329 24.7643C125.761 24.5605 128.441 27.3555 128.441 30.6366V92.9122C128.441 96.2247 125.8 98.8592 122.622 99.1169C112.368 99.9482 88.6762 103.289 71.6435 109.644C57.1868 115.038 34.9968 119.208 22.3921 121.15C18.7587 121.71 15.559 118.876 15.559 115.252V53.0606C15.559 49.8584 18.0472 47.2689 21.1675 46.9948C32.7423 45.9777 54.5948 42.6273 70.2814 37.1158C86.6853 31.3522 106.963 25.6767 122.329 24.7643ZM124.441 30.6366C124.441 29.4993 123.544 28.6991 122.566 28.7572C107.777 29.6354 87.9303 35.1545 71.6073 40.8896C55.4776 46.5568 33.2556 49.948 21.5176 50.9794C20.3928 51.0782 19.559 52.0013 19.559 53.0606V115.252C19.559 116.477 20.6248 117.375 21.7828 117.197C34.3644 115.258 56.2025 111.136 70.2452 105.896C87.7792 99.3539 111.891 95.9738 122.299 95.13C123.525 95.0306 124.441 94.018 124.441 92.9122V30.6366ZM100.807 38.6245C104.352 37.9202 107.125 40.5718 108.4 42.891C109.451 44.8032 111.211 46.3267 113.365 47.1238C115.806 48.0271 118.487 50.2798 118.487 53.63V75.399C118.487 78.7491 115.806 81.0018 113.365 81.9051C109.79 83.228 107.327 86.5266 107.327 90.3122C107.327 91.4422 106.519 92.5004 105.29 92.6833C95.2888 94.1731 81.3316 96.8698 71.7262 100.302C64.0487 103.046 51.5829 105.746 41.2849 107.659C37.9249 108.283 35.2186 105.931 33.8767 103.743C32.781 101.957 31.0507 100.55 28.9663 99.8197C26.4717 98.9455 23.702 96.6794 23.702 93.2691V72.2825C23.702 68.8722 26.4715 66.6061 28.9663 65.7319C32.6258 64.4496 35.1627 61.109 35.1627 57.2679C35.1627 55.7221 36.2315 54.1252 38.039 53.8616C48.3953 52.3515 61.7728 49.8111 70.4154 46.9031C79.055 43.9961 90.5525 40.6616 100.807 38.6245ZM39.154 57.7408C49.4917 56.2135 62.8485 53.6696 71.691 50.6943C80.2234 47.8233 91.5488 44.5418 101.586 42.5478C102.567 42.3531 103.947 43.0935 104.895 44.8177C106.418 47.5899 108.939 49.751 111.977 50.8752C113.607 51.4785 114.487 52.639 114.487 53.63V75.399C114.487 76.39 113.607 77.5505 111.977 78.1537C107.381 79.8543 103.947 83.9497 103.402 88.9238C93.4378 90.4594 79.943 93.1183 70.3802 96.5354C63.0357 99.1599 50.8541 101.813 40.5544 103.726C39.579 103.908 38.2502 103.223 37.2863 101.652C35.7022 99.0697 33.2292 97.075 30.2891 96.0448C28.6143 95.4579 27.702 94.2769 27.702 93.2691V72.2825C27.702 71.2746 28.6142 70.0937 30.289 69.5069C35.2785 67.7585 38.9528 63.2061 39.154 57.7408ZM72.5597 87.0901C74.7907 86.759 76.4472 85.7828 77.563 84.3796C78.8856 82.7164 79.2267 80.7296 79.2267 79.2734V79.2469L79.226 79.2204C79.1942 78.0177 78.9026 76.0348 77.6633 74.2992C76.3398 72.4455 74.1188 71.1346 70.8057 71.1346C68.7848 71.1346 67.8292 70.4292 67.3284 69.7932C66.7549 69.0648 66.568 68.1496 66.568 67.5898C66.568 66.229 66.9786 65.3715 67.5446 64.8408C68.1275 64.2943 69.1399 63.8471 70.8057 63.8471C72.5726 63.8471 73.6577 64.2358 74.2681 64.7298C74.8059 65.1652 75.2267 65.8845 75.2267 67.2372V69.2372H79.2267V67.2372C79.2267 64.9449 78.4506 62.9692 76.7847 61.6207C75.6118 60.6714 74.1507 60.1586 72.5597 59.9541V56.1962H68.5597V60.0629C67.1151 60.3579 65.8325 60.9629 64.8087 61.9228C63.2627 63.3724 62.568 65.3862 62.568 67.5898C62.568 68.8123 62.9271 70.6694 64.1858 72.2679C65.5173 73.9587 67.6806 75.1346 70.8057 75.1346C72.9302 75.1346 73.8934 75.9029 74.408 76.6235C75 77.4528 75.2023 78.5243 75.2267 79.2999C75.2223 80.2123 74.9937 81.1839 74.4322 81.89C73.9332 82.5175 72.9532 83.2141 70.8057 83.2141C68.6357 83.2141 67.6851 82.5252 67.2292 81.9479C66.7102 81.2906 66.5204 80.3798 66.5652 79.5337L66.671 77.5365L62.6766 77.325L62.5708 79.3222C62.4933 80.7864 62.7805 82.7686 64.09 84.4269C65.1064 85.714 66.5926 86.6232 68.5597 87.0084V90.8653H72.5597V87.0901Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50.9875C125.046 50.9875 134 42.0332 134 30.9875C134 19.9418 125.046 10.9875 114 10.9875C102.954 10.9875 94 19.9418 94 30.9875C94 42.0332 102.954 50.9875 114 50.9875Z",
        fill: (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.success
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46.9875C122.837 46.9875 130 39.824 130 30.9875C130 22.1509 122.837 14.9875 114 14.9875C105.163 14.9875 98 22.1509 98 30.9875C98 39.824 105.163 46.9875 114 46.9875ZM134 30.9875C134 42.0332 125.046 50.9875 114 50.9875C102.954 50.9875 94 42.0332 94 30.9875C94 19.9418 102.954 10.9875 114 10.9875C125.046 10.9875 134 19.9418 134 30.9875Z",
        fill: (m = (p = r.semantic) == null ? void 0 : p.illustration) == null ? void 0 : m.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.41 26.8361L114.085 39.5763C112.972 40.8292 111.047 40.9264 109.813 39.7923L102.75 33.3016L105.456 30.3562L111.771 36.159L122.42 24.1787L125.41 26.8361Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.background
      }
    )
  ] });
}, NetworkDownload = () => {
  var a, s, c, u, d, h, p, m, g, v, y;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.961 74H102.399C102.213 82.3207 100.87 90.2544 98.5766 97.4736H115.033C119.14 90.5504 121.624 82.5511 121.961 74ZM112.394 101.474H97.1814C94.4988 108.514 90.8777 114.755 86.5335 119.855C97.032 116.671 106.069 110.126 112.394 101.474ZM94.3685 97.4736C96.7682 90.361 98.2011 82.4209 98.3977 74H74V97.4736H94.3685ZM74 101.474H92.8825C89.5649 109.625 84.9259 116.484 79.4336 121.451C77.6514 121.717 75.8384 121.888 74 121.961V101.474ZM70 97.4736V74H44.6549C44.8515 82.4209 46.2845 90.361 48.6841 97.4736H70ZM50.1701 101.474H70V121.961C67.7643 121.873 65.5663 121.638 63.4155 121.266C58.0121 116.314 53.4467 109.524 50.1701 101.474ZM44.476 97.4736C42.1827 90.2544 40.8399 82.3207 40.6539 74H22.0393C22.3756 82.5511 24.8595 90.5504 28.9666 97.4736H44.476ZM31.6063 101.474H45.8712C48.482 108.325 51.9817 114.42 56.1717 119.443C46.2252 116.126 37.6692 109.769 31.6063 101.474ZM102.399 70C102.213 61.6793 100.87 53.7456 98.5767 46.5264H115.033C119.14 53.4496 121.624 61.4489 121.961 70H102.399ZM86.5336 24.145C90.8778 29.2453 94.4989 35.4864 97.1814 42.5264H112.394C106.069 33.8736 97.0321 27.3293 86.5336 24.145ZM74 42.5264H92.8826C89.565 34.3755 84.926 27.5157 79.4338 22.5488C77.6515 22.2832 75.8385 22.1116 74 22.0393V42.5264ZM94.3686 46.5264L74 46.5264V70H98.3977C98.2011 61.5791 96.7682 53.639 94.3686 46.5264ZM70 22.0393V42.5264H50.17C53.4466 34.4764 58.012 27.6858 63.4153 22.7342C65.5662 22.362 67.7643 22.1272 70 22.0393ZM70 46.5264L48.684 46.5264C46.2844 53.639 44.8515 61.5791 44.6549 70H70V46.5264ZM56.1716 24.5572C51.9816 29.5801 48.4819 35.6749 45.8712 42.5264H31.6063C37.6691 34.2314 46.2252 27.8741 56.1716 24.5572ZM44.4759 46.5264H28.9666C24.8595 53.4496 22.3756 61.4489 22.0393 70H40.6539C40.8399 61.6793 42.1827 53.7456 44.4759 46.5264ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 48.1818C124.042 48.1818 132.182 40.0415 132.182 29.9999C132.182 19.9584 124.042 11.8181 114 11.8181C103.959 11.8181 95.8182 19.9584 95.8182 29.9999C95.8182 40.0415 103.959 48.1818 114 48.1818Z",
        fill: (p = (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.brand) == null ? void 0 : p.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 13.6364C104.963 13.6364 97.6364 20.9626 97.6364 30C97.6364 39.0374 104.963 46.3636 114 46.3636C123.037 46.3636 130.364 39.0374 130.364 30C130.364 20.9626 123.037 13.6364 114 13.6364ZM94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30Z",
        fill: (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M115.818 36.5197V18.1819H112.182V36.5196L105.818 30.156L103.247 32.7273L112.714 42.1948C113.424 42.9048 114.576 42.9048 115.286 42.1948L124.753 32.7273L122.182 30.156L115.818 36.5197Z",
        fill: (y = (v = r.semantic) == null ? void 0 : v.illustration) == null ? void 0 : y.background
      }
    )
  ] });
}, NetworkError = () => {
  var a, s, c, u, d, h, p, m, g, v;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.961 74H102.399C102.213 82.3207 100.87 90.2544 98.5766 97.4736H115.033C119.14 90.5504 121.624 82.5511 121.961 74ZM112.394 101.474H97.1814C94.4988 108.514 90.8777 114.755 86.5335 119.855C97.032 116.671 106.069 110.126 112.394 101.474ZM94.3685 97.4736C96.7682 90.361 98.2011 82.4209 98.3977 74H74V97.4736H94.3685ZM74 101.474H92.8825C89.5649 109.625 84.9259 116.484 79.4336 121.451C77.6514 121.717 75.8384 121.888 74 121.961V101.474ZM70 97.4736V74H44.6549C44.8515 82.4209 46.2845 90.361 48.6841 97.4736H70ZM50.1701 101.474H70V121.961C67.7643 121.873 65.5663 121.638 63.4155 121.266C58.0121 116.314 53.4467 109.524 50.1701 101.474ZM44.476 97.4736C42.1827 90.2544 40.8399 82.3207 40.6539 74H22.0393C22.3756 82.5511 24.8595 90.5504 28.9666 97.4736H44.476ZM31.6063 101.474H45.8712C48.482 108.325 51.9817 114.42 56.1717 119.443C46.2252 116.126 37.6692 109.769 31.6063 101.474ZM102.399 70C102.213 61.6793 100.87 53.7456 98.5767 46.5264H115.033C119.14 53.4496 121.624 61.4489 121.961 70H102.399ZM86.5336 24.145C90.8778 29.2453 94.4989 35.4864 97.1814 42.5264H112.394C106.069 33.8736 97.0321 27.3293 86.5336 24.145ZM74 42.5264H92.8826C89.565 34.3755 84.926 27.5157 79.4338 22.5488C77.6515 22.2832 75.8385 22.1116 74 22.0393V42.5264ZM94.3686 46.5264L74 46.5264V70H98.3977C98.2011 61.5791 96.7682 53.639 94.3686 46.5264ZM70 22.0393V42.5264H50.17C53.4466 34.4764 58.012 27.6858 63.4153 22.7342C65.5662 22.362 67.7643 22.1272 70 22.0393ZM70 46.5264L48.684 46.5264C46.2844 53.639 44.8515 61.5791 44.6549 70H70V46.5264ZM56.1716 24.5572C51.9816 29.5801 48.4819 35.6749 45.8712 42.5264H31.6063C37.6691 34.2314 46.2252 27.8741 56.1716 24.5572ZM44.4759 46.5264H28.9666C24.8595 53.4496 22.3756 61.4489 22.0393 70H40.6539C40.8399 61.6793 42.1827 53.7456 44.4759 46.5264ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
        fill: (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.critical
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
        fill: (m = (p = r.semantic) == null ? void 0 : p.illustration) == null ? void 0 : m.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M116 33V18H112V33H116ZM117 39C117 40.6569 115.657 42 114 42C112.343 42 111 40.6569 111 39C111 37.3431 112.343 36 114 36C115.657 36 117 37.3431 117 39Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.background
      }
    )
  ] });
}, NewEmail = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M127.5 122.49V63.3451C127.5 62.1301 126.949 60.9808 126.002 60.2208L74.5022 18.8824C73.04 17.7088 70.96 17.7088 69.4978 18.8824L17.9978 60.2208C17.051 60.9808 16.5 62.1301 16.5 63.3451V122.49C16.5 124.702 18.2909 126.495 20.5 126.495H123.5C125.709 126.495 127.5 124.702 127.5 122.49Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M73.2511 20.4446C72.52 19.8578 71.48 19.8578 70.7489 20.4446L19.2489 61.783C18.7755 62.163 18.5 62.7376 18.5 63.3451V122.49C18.5 123.596 19.3954 124.493 20.5 124.493H123.5C124.605 124.493 125.5 123.596 125.5 122.49V63.3451C125.5 62.7376 125.225 62.163 124.751 61.783L73.2511 20.4446ZM68.2467 17.3203C70.44 15.5599 73.5601 15.5599 75.7533 17.3204L127.253 58.6587C128.674 59.7988 129.5 61.5227 129.5 63.3451V122.49C129.5 125.808 126.814 128.497 123.5 128.497H20.5C17.1863 128.497 14.5 125.808 14.5 122.49V63.3451C14.5 61.5227 15.3265 59.7988 16.7467 58.6587L68.2467 17.3203Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.5 39.493C33.5 38.3872 34.3954 37.4907 35.5 37.4907H108.5C109.605 37.4907 110.5 38.3872 110.5 39.493V114.938C110.5 116.044 109.605 116.941 108.5 116.941H35.5C34.3954 116.941 33.5 116.044 33.5 114.938V39.493Z",
        fill: (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.5 39.493C31.5 37.2814 33.2909 35.4885 35.5 35.4885H108.5C110.709 35.4885 112.5 37.2814 112.5 39.493V114.939C112.5 117.15 110.709 118.943 108.5 118.943H35.5C33.2909 118.943 31.5 117.15 31.5 114.939V39.493ZM108.5 39.493L35.5 39.493V114.939L108.5 114.939V39.493Z",
        fill: (m = (p = r.semantic) == null ? void 0 : p.illustration) == null ? void 0 : m.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.5 61.6274L58.514 94.0631L69.3928 85.8545C70.7897 84.8005 72.7086 84.7773 74.1304 85.7974L87.0421 95.0611L127.5 61.6274V126.998H16.5V61.6274Z",
        fill: (y = (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.brand) == null ? void 0 : y.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M128.353 59.8163C129.053 60.1467 129.5 60.8523 129.5 61.6275V126.998C129.5 128.104 128.605 129 127.5 129H16.5C15.3954 129 14.5 128.104 14.5 126.998V61.6275C14.5 60.8643 14.9334 60.1674 15.6176 59.8307C16.3017 59.4939 17.1176 59.5759 17.7213 60.042L58.5279 91.5454L68.189 84.2556C70.2843 82.6746 73.1627 82.6399 75.2954 84.17L86.956 92.536L126.227 60.0834C126.824 59.5899 127.652 59.4858 128.353 59.8163ZM85.8398 96.6619L72.9654 87.425C72.2545 86.9149 71.295 86.9265 70.5966 87.4535L59.7324 95.651L22.2983 124.996H121.733L85.8398 96.6619ZM125.5 122.869L90.227 95.0255L125.5 65.8765V122.869ZM18.5 122.887V65.7L55.2545 94.0752L18.5 122.887Z",
        fill: (w = (x = r.semantic) == null ? void 0 : x.illustration) == null ? void 0 : w.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M111 50.5C118.18 50.5 124 44.6797 124 37.5C124 30.3203 118.18 24.5 111 24.5C103.82 24.5 98 30.3203 98 37.5C98 44.6797 103.82 50.5 111 50.5Z",
        fill: (P = (M = (S = r.semantic) == null ? void 0 : S.illustration) == null ? void 0 : M.brand) == null ? void 0 : P.primary
      }
    )
  ] });
}, NoItems = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 96 96", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("circle", { cx: "49.2682", cy: "48.3379", r: "36", fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M22.3877 55.713C24.8235 66.582 35.6092 73.4185 46.4782 70.9826C57.3472 68.5468 64.1837 57.7611 61.7478 46.8921C59.312 36.0231 48.5263 29.1866 37.6573 31.6225C26.7883 34.0583 19.9518 44.844 22.3877 55.713Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.3241 62.8113C33.3398 67.2497 39.5647 69.4576 45.8222 68.0552C52.0795 66.6529 56.7668 61.9995 58.5042 56.2719C54.2631 57.8649 49.3758 59.3201 44.1286 60.4961C38.881 61.6721 33.8396 62.4419 29.3241 62.8113ZM27.2316 59.9511C32.0186 59.6719 37.5886 58.8873 43.4725 57.5687C49.356 56.2501 54.7278 54.5827 59.1758 52.7922C59.3245 51.0795 59.2164 49.3151 58.8204 47.5481C56.7469 38.2959 47.5656 32.4764 38.3133 34.5499C29.0611 36.6234 23.2415 45.8047 25.3151 55.057C25.711 56.8239 26.3662 58.4656 27.2316 59.9511ZM25.6516 63.0277C30.2224 69.4211 38.3269 72.8094 46.4782 70.9826C54.6295 69.1559 60.5127 62.6328 61.9178 54.9004C63.3199 54.2969 64.626 53.6805 65.8221 53.0579C68.5164 51.6556 70.7313 50.1819 72.2284 48.6983C73.6611 47.2785 74.7825 45.4927 74.3505 43.5651C74.0518 42.2325 72.9682 41.3987 71.9197 40.8771C70.8292 40.3347 69.4364 39.9552 67.9163 39.685C65.146 39.1926 61.6596 39.0142 58.0942 39.0509C53.4622 32.9996 45.5819 29.8465 37.6573 31.6225C29.7326 33.3985 23.9516 39.6133 22.3452 47.0628C19.1056 48.5512 16.0291 50.2002 13.7342 51.8276C12.4749 52.7208 11.3772 53.6584 10.6226 54.6143C9.8969 55.5336 9.2728 56.75 9.57145 58.0826C10.0034 60.0102 11.7797 61.1467 13.6813 61.8192C15.6684 62.522 18.3004 62.9094 21.3354 63.0278C22.6826 63.0803 24.1264 63.0804 25.6516 63.0277ZM21.9072 50.5888C19.4221 51.8008 17.176 53.0647 15.4696 54.2748C14.3125 55.0953 13.4768 55.8404 12.9773 56.4732C12.4487 57.1428 12.4976 57.4212 12.4988 57.4266C12.5748 57.7657 13.0133 58.4008 14.6817 58.9909C16.2647 59.5508 18.558 59.9172 21.4523 60.0301C22.2314 60.0605 23.0476 60.0723 23.8976 60.0653C23.2431 58.705 22.732 57.2493 22.3877 55.713C22.002 53.9919 21.8487 52.2729 21.9072 50.5888ZM59.9952 42.0527C62.7604 42.0881 65.3314 42.2725 67.3913 42.6387C68.7879 42.8869 69.8617 43.2041 70.5835 43.5631C71.3473 43.9431 71.4219 44.2157 71.4231 44.2211C71.4991 44.5603 71.3736 45.3218 70.1167 46.5675C68.924 47.7494 67.0064 49.0595 64.4371 50.3968C63.7452 50.7569 63.0118 51.1161 62.2397 51.4727C62.2512 49.9631 62.0921 48.4284 61.7478 46.8921C61.3621 45.1709 60.7669 43.5508 59.9952 42.0527Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.1655 10.3594C19.2034 9.9771 19.7061 9.86295 19.9054 10.1914L22.3601 14.2347C22.4494 14.3818 22.6228 14.4553 22.7906 14.4171L27.4955 13.3486C27.8759 13.2622 28.1423 13.7159 27.8815 14.0061L24.7019 17.5439C24.584 17.6751 24.5659 17.8681 24.6575 18.0189L27.0954 22.0346C27.296 22.365 26.9579 22.7595 26.6007 22.6119L22.1567 20.7746C22.0001 20.7098 21.8196 20.7508 21.7064 20.8769L18.4919 24.4534C18.2335 24.7409 17.7581 24.5311 17.7963 24.1465L18.2606 19.4716C18.278 19.2961 18.1784 19.1299 18.0154 19.0625L13.6195 17.2451C13.259 17.0961 13.3033 16.5718 13.6837 16.4854L18.3886 15.4169C18.5564 15.3788 18.681 15.2376 18.698 15.0663L19.1655 10.3594Z",
        fill: (v = (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.brand) == null ? void 0 : v.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M76.0942 63.2097C76.2908 62.8585 76.8245 62.9848 76.8428 63.3868L77.1553 70.2281C77.1651 70.4438 77.3443 70.6127 77.5602 70.6098L84.408 70.5192C84.8104 70.5138 84.9679 71.0391 84.6289 71.256L78.8604 74.9473C78.6785 75.0636 78.6218 75.3033 78.7322 75.4888L82.2347 81.3738C82.4405 81.7196 82.0643 82.1187 81.707 81.9336L75.626 78.7835C75.4343 78.6842 75.1984 78.7549 75.093 78.9433L71.7476 84.919C71.551 85.2702 71.0174 85.1439 70.999 84.7419L70.6866 77.9006C70.6767 77.6849 70.4975 77.516 70.2817 77.5189L63.4338 77.6095C63.0315 77.6149 62.874 77.0895 63.213 76.8726L68.9815 73.1814C69.1633 73.0651 69.22 72.8254 69.1096 72.6399L65.6072 66.7549C65.4014 66.4091 65.7776 66.01 66.1349 66.1951L72.2158 69.3452C72.4075 69.4445 72.6434 69.3738 72.7489 69.1854L76.0942 63.2097Z",
        fill: (w = (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.brand) == null ? void 0 : w.primary
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "82.9747", cy: "29.898", r: "7.75701", fill: (P = (M = (S = r.semantic) == null ? void 0 : S.illustration) == null ? void 0 : M.brand) == null ? void 0 : P.primary }),
    /* @__PURE__ */ jsx("circle", { cx: "58.3888", cy: "18.3665", r: "3.8785", fill: (T = (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.brand) == null ? void 0 : T.primary }),
    /* @__PURE__ */ jsx("circle", { cx: "24.5733", cy: "84.5956", r: "3.8785", fill: (A = (R = (E = r.semantic) == null ? void 0 : E.illustration) == null ? void 0 : R.brand) == null ? void 0 : A.primary })
  ] });
}, useColorPalettes = () => useContext$1(ColorPalettesContext), useTheme = () => {
  const r = useTheme$1(), a = useColorPalettes();
  return {
    borderRadii: useBorderRadii(),
    colors: a,
    textStyles: r.textStyles,
    fonts: r.fonts
  };
}, PageNotFound = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k, V, B, q, z, Z, G, K, U, F, N, D, j, H, W, re, ae, ee, X, J, ie, oe, fe;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("circle", { cx: "70", cy: "70", r: "54", fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary }),
    /* @__PURE__ */ jsx("mask", { id: "mask0_11086_277", maskUnits: "userSpaceOnUse", x: "16", y: "16", width: "108", height: "108", children: /* @__PURE__ */ jsx("circle", { cx: "70", cy: "70", r: "54", fill: (h = (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.brand) == null ? void 0 : h.secondary }) }),
    /* @__PURE__ */ jsxs("g", { mask: "url(#mask0_11086_277)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M72.0001 80.4208V145.077H68.0001V80.4208H72.0001Z",
          fill: (m = (p = r.semantic) == null ? void 0 : p.illustration) == null ? void 0 : m.border
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M71.9023 81.0386L50.9023 145.695L47.0979 144.459L68.0979 79.803L71.9023 81.0386Z",
          fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.border
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M68.0979 81.0386L89.0979 145.695L92.9023 144.459L71.9023 79.803L68.0979 81.0386Z",
          fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M82 78.5364C82 85.1638 76.6274 90.5364 70 90.5364C63.3726 90.5364 58 85.1638 58 78.5364C58 71.909 63.3726 66.5364 70 66.5364C76.6274 66.5364 82 71.909 82 78.5364Z",
          fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.background
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70 86.5364C74.4183 86.5364 78 82.9547 78 78.5364C78 74.1181 74.4183 70.5364 70 70.5364C65.5817 70.5364 62 74.1181 62 78.5364C62 82.9547 65.5817 86.5364 70 86.5364ZM70 90.5364C76.6274 90.5364 82 85.1638 82 78.5364C82 71.909 76.6274 66.5364 70 66.5364C63.3726 66.5364 58 71.909 58 78.5364C58 85.1638 63.3726 90.5364 70 90.5364Z",
          fill: (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.border
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.1598 66.0598C19.8639 64.9384 20.5312 63.7824 21.6504 63.4779L46.5208 56.7108C47.6399 56.4063 48.787 57.0685 49.0829 58.1899L52.9431 72.8194C53.239 73.9409 52.5716 75.0968 51.4525 75.4013L26.5821 82.1685C25.463 82.473 24.3159 81.8108 24.02 80.6893L20.1598 66.0598Z",
        fill: (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.4635 52.8794C45.1676 51.758 45.835 50.602 46.9541 50.2975L78.9145 41.6012C80.0336 41.2966 81.1807 41.9589 81.4766 43.0803L88.2622 68.7966C88.5581 69.918 87.8908 71.0739 86.7717 71.3784L54.8112 80.0748C53.6921 80.3793 52.545 79.7171 52.2491 78.5956L45.4635 52.8794Z",
        fill: (E = (T = r.semantic) == null ? void 0 : T.illustration) == null ? void 0 : E.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M77.433 39.6011C77.1371 38.4796 77.8044 37.3237 78.9235 37.0192L111.303 28.2089C112.422 27.9044 113.569 28.5666 113.865 29.688L123.032 64.4277C123.327 65.5491 122.66 66.705 121.541 67.0095L89.1616 75.8199C88.0425 76.1244 86.8954 75.4621 86.5995 74.3407L77.433 39.6011Z",
        fill: (A = (R = r.semantic) == null ? void 0 : R.illustration) == null ? void 0 : A.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M125.327 71.8979C124.208 72.2024 123.06 71.5401 122.765 70.4187L110.556 24.1507C110.26 23.0293 110.927 21.8733 112.047 21.5688L118.213 19.8911C119.332 19.5865 120.479 20.2488 120.775 21.3702L132.983 67.6382C133.279 68.7596 132.612 69.9156 131.493 70.2201L125.327 71.8979Z",
        fill: (V = (k = r.semantic) == null ? void 0 : k.illustration) == null ? void 0 : V.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.0073 89.1098C18.8882 89.4143 17.7411 88.752 17.4452 87.6306L11.0167 63.2679C10.7208 62.1465 11.3882 60.9905 12.5073 60.686L18.6733 59.0082C19.7925 58.7037 20.9395 59.366 21.2354 60.4874L27.6639 84.8501C27.9598 85.9716 27.2925 87.1275 26.1733 87.432L20.0073 89.1098Z",
        fill: (q = (B = r.semantic) == null ? void 0 : B.illustration) == null ? void 0 : q.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.1586 65.7098C20.5809 63.5204 21.0074 61.5832 23.1923 60.9887L43.8763 55.4013C46.0612 54.8068 48.3008 56.0997 48.8785 58.2891L52.7387 72.9187C53.3164 75.1081 52.0135 77.3649 49.8286 77.9594L29.1446 83.5469C26.9597 84.1414 25.5966 82.5287 25.0188 80.3393L21.1586 65.7098ZM24.2128 64.8564C24.1596 64.8709 24.1988 64.803 24.2128 64.8564L26.072 72.2941L28.0021 79.6088C27.9488 79.6233 28.0162 79.6622 28.0021 79.6088L48.8081 74.0918C48.8614 74.0773 48.8931 74.0223 48.879 73.9689L45.0188 59.3393C45.0047 59.2859 44.9501 59.2544 44.8968 59.2689L24.2128 64.8564Z",
        fill: (Z = (z = r.semantic) == null ? void 0 : z.illustration) == null ? void 0 : Z.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.5338 53.4042C42.9561 51.2148 44.259 48.958 46.4439 48.3634L75.5164 40.4515C77.7014 39.857 79.9409 41.1499 80.5187 43.3394L87.3042 69.0556C87.882 71.2451 86.5791 73.5019 84.3941 74.0964L55.3216 82.0083C53.1367 82.6029 50.8971 81.3099 50.3194 79.1205L43.5338 53.4042ZM47.4645 52.2311C47.4112 52.2456 47.3794 52.3006 47.3935 52.354L54.1791 78.0703C54.1932 78.1237 54.2478 78.1552 54.3011 78.1407L83.3736 70.2288C83.4269 70.2143 83.4587 70.1592 83.4446 70.1058L76.659 44.3896C76.6449 44.3362 76.5903 44.3046 76.537 44.3191L47.4645 52.2311Z",
        fill: (K = (G = r.semantic) == null ? void 0 : G.illustration) == null ? void 0 : K.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M75.5033 40.1257C74.9256 37.9363 76.2285 35.6795 78.4134 35.0849L109.019 26.8394C111.204 26.2449 113.443 27.5378 114.021 29.7272L123.188 64.4669C123.765 66.6563 122.462 68.9132 120.277 69.5077L89.6721 77.7532C87.4871 78.3478 85.2476 77.0548 84.6699 74.8654L75.5033 40.1257ZM79.434 38.9526C79.3807 38.9671 79.3489 39.0221 79.363 39.0755L88.5295 73.8152C88.5436 73.8686 88.5982 73.9001 88.6515 73.8856L119.257 65.6401C119.31 65.6256 119.342 65.5705 119.328 65.5171L110.161 30.7774C110.147 30.724 110.093 30.6925 110.039 30.707L79.434 38.9526Z",
        fill: (F = (U = r.semantic) == null ? void 0 : U.illustration) == null ? void 0 : F.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.837 73.8313C123.652 74.4258 121.412 73.1328 120.835 70.9434L108.626 24.6754C108.049 22.4859 109.351 20.2291 111.536 19.6346L117.702 17.9568C119.887 17.3623 122.127 18.6553 122.705 20.8447L134.913 67.1127C135.491 69.3022 134.188 71.559 132.003 72.1535L125.837 73.8313ZM124.694 69.8932C124.708 69.9466 124.763 69.9781 124.816 69.9636L130.982 68.2859C131.036 68.2714 131.068 68.2163 131.053 68.1629L118.845 21.8949C118.831 21.8415 118.776 21.81 118.723 21.8245L112.557 23.5022C112.504 23.5167 112.472 23.5718 112.486 23.6252L124.694 69.8932Z",
        fill: (D = (N = r.semantic) == null ? void 0 : N.illustration) == null ? void 0 : D.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5176 91.0431C18.3326 91.6376 16.0931 90.3447 15.5154 88.1553L9.08691 63.7925C8.5092 61.6031 9.81211 59.3463 11.997 58.7518L18.1631 57.074C20.348 56.4795 22.5876 57.7724 23.1653 59.9618L29.5938 84.3246C30.1715 86.514 28.8686 88.7709 26.6836 89.3654L20.5176 91.0431ZM19.375 87.1051C19.3891 87.1585 19.4438 87.19 19.497 87.1755L25.6631 85.4977C25.7164 85.4832 25.7482 85.4282 25.7341 85.3748L19.3056 61.012C19.2915 60.9586 19.2369 60.9271 19.1836 60.9416L13.0176 62.6194C12.9643 62.6339 12.9325 62.6889 12.9466 62.7423L19.375 87.1051Z",
        fill: (H = (j = r.semantic) == null ? void 0 : j.illustration) == null ? void 0 : H.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.4644 17.6032C45.5208 17.0323 46.2729 16.8643 46.5744 17.3553L50.9227 24.436C51.058 24.6564 51.3191 24.7667 51.5709 24.7099L59.9186 22.8267C60.4929 22.6972 60.8961 23.3848 60.4994 23.817L54.8498 29.9732C54.6691 30.1701 54.6422 30.4635 54.7839 30.6919L59.125 37.6902C59.4316 38.1844 58.9283 38.7774 58.3894 38.5569L50.4931 35.3261C50.259 35.2303 49.9908 35.2902 49.8217 35.4761L44.1187 41.7448C43.7295 42.1727 43.0152 41.8517 43.0747 41.2757L43.9168 33.1195C43.9443 32.8533 43.7912 32.6002 43.5417 32.4993L35.743 29.3474C35.1954 29.1261 35.2572 28.3347 35.8319 28.2075L44.1878 26.3593C44.4398 26.3035 44.6268 26.0931 44.6521 25.8368L45.4644 17.6032Z",
        fill: (ae = (re = (W = r.semantic) == null ? void 0 : W.illustration) == null ? void 0 : re.brand) == null ? void 0 : ae.primary
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "122", cy: "122.438", r: "9", fill: (J = (X = (ee = r.semantic) == null ? void 0 : ee.illustration) == null ? void 0 : X.brand) == null ? void 0 : J.primary }),
    /* @__PURE__ */ jsx("circle", { cx: "45.5", cy: "103.814", r: "4.5", fill: (fe = (oe = (ie = r.semantic) == null ? void 0 : ie.illustration) == null ? void 0 : oe.brand) == null ? void 0 : fe.primary })
  ] });
}, PaymentRequestLink = () => {
  var a, s, c, u, d, h, p, m, g, v, y;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.9475 72.0005C34.9475 63.5709 41.781 56.7373 50.2106 56.7373H62.6317V60.7373H50.2106C43.9902 60.7373 38.9475 65.78 38.9475 72.0005C38.9475 78.2209 43.9902 83.2636 50.2106 83.2636H62.6317V87.2636H50.2106C42.4589 87.2636 36.0569 81.485 35.0773 74.0005H34.9475V72.0005ZM51.0925 70.0005H94.3942V74.0005H51.0925V70.0005ZM93.7896 56.7373C102.219 56.7373 109.053 63.5709 109.053 72.0005V74.0005H108.923C107.943 81.485 101.541 87.2636 93.7896 87.2636H81.3685V83.2636H93.7896C100.01 83.2636 105.053 78.2209 105.053 72.0005C105.053 65.78 100.01 60.7373 93.7896 60.7373H81.3685V56.7373H93.7896Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
        fill: (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M130 30C130 38.8366 122.837 46 114 46C105.163 46 98 38.8366 98 30C98 21.1634 105.163 14 114 14C122.837 14 130 21.1634 130 30ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30ZM115.999 39.9843C117.549 39.6648 118.751 38.9228 119.593 37.8646C120.67 36.5094 120.938 34.9077 120.938 33.7595V33.733L120.937 33.7065C120.912 32.7605 120.684 31.1755 119.683 29.7736C118.598 28.2536 116.79 27.2122 114.181 27.2122C112.828 27.2122 112.276 26.7507 112.013 26.4163C111.677 25.9896 111.561 25.4338 111.561 25.105C111.561 24.2063 111.828 23.721 112.12 23.447C112.43 23.1571 113.038 22.8511 114.181 22.8511C115.426 22.8511 116.095 23.1267 116.42 23.3895C116.672 23.5936 116.938 23.9636 116.938 24.8438V26.8438H120.938V24.8438C120.938 23.024 120.317 21.3977 118.936 20.2804C118.091 19.5964 117.079 19.1995 115.999 19.0044V16.1467H111.999V19.1186C111.015 19.3788 110.122 19.837 109.384 20.529C108.112 21.7218 107.561 23.3634 107.561 25.105C107.561 26.0964 107.849 27.5942 108.87 28.8911C109.964 30.2802 111.723 31.2122 114.181 31.2122C115.601 31.2122 116.151 31.711 116.428 32.0979C116.782 32.5945 116.92 33.2685 116.938 33.786C116.933 34.3888 116.779 34.9759 116.462 35.375C116.208 35.6945 115.644 36.16 114.181 36.16C112.696 36.16 112.158 35.6964 111.939 35.4193C111.657 35.0622 111.529 34.5263 111.558 33.9797L111.664 31.9825L107.669 31.771L107.564 33.7682C107.502 34.933 107.727 36.5401 108.8 37.8982C109.564 38.8664 110.638 39.5561 111.999 39.9035V42.8648H115.999V39.9843Z",
        fill: (y = (v = r.semantic) == null ? void 0 : v.illustration) == null ? void 0 : y.border
      }
    )
  ] });
}, PayZero = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44 113L100 113C101.105 113 102 112.105 102 111L102 57.0912L82.1613 32L44 32C42.8954 32 42 32.8954 42 34L42 111C42 112.105 42.8954 113 44 113Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M82.5 57V32L102 57H82.5Z", fill: (h = (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.brand) == null ? void 0 : h.primary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40 111C40 113.209 41.7909 115 44 115L100 115C102.209 115 104 113.209 104 111L104 56.3961L83.1296 30L44 30C41.7909 30 40 31.7909 40 34L40 111ZM100 111L44 111L44 34L80.1613 34L80.1613 55.0912C80.1613 57.3004 81.9522 59.0912 84.1613 59.0912L100 59.0912L100 111ZM97.869 55.0912L84.1613 55.0912L84.1613 37.7542L97.869 55.0912Z",
        fill: (m = (p = r.semantic) == null ? void 0 : p.illustration) == null ? void 0 : m.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M52 31C52 42.598 42.598 52 31 52C19.402 52 10 42.598 10 31C10 19.402 19.402 10 31 10C42.598 10 52 19.402 52 31Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48 31C48 40.3889 40.3888 48 31 48C21.6112 48 14 40.3889 14 31C14 21.6112 21.6112 14 31 14C40.3888 14 48 21.6112 48 31ZM52 31C52 42.598 42.598 52 31 52C19.402 52 10 42.598 10 31C10 19.4021 19.402 10 31 10C42.598 10 52 19.4021 52 31ZM33.0001 41.4037C34.6463 41.0816 35.9138 40.306 36.7951 39.1978C37.9078 37.7985 38.1857 36.1418 38.1857 34.9496V34.9231L38.185 34.8966C38.159 33.9139 37.922 32.2721 36.887 30.8225C35.7677 29.2549 33.9005 28.175 31.1916 28.175C29.7425 28.175 29.1334 27.6786 28.8362 27.3011C28.4662 26.8313 28.3401 26.2242 28.3401 25.8624C28.3401 24.8976 28.6278 24.3592 28.9592 24.0485C29.3074 23.722 29.9733 23.3958 31.1916 23.3958C32.511 23.3958 33.2394 23.6875 33.6049 23.9834C33.8979 24.2205 34.1857 24.6404 34.1857 25.5882V27.5882H38.1857V25.5882C38.1857 23.7008 37.5426 22.0246 36.1215 20.8743C35.2288 20.1517 34.1519 19.7379 33.0001 19.5407V16.5571H29.0001V19.654C27.951 19.92 27.0028 20.3996 26.2233 21.1305C24.9119 22.36 24.3401 24.0548 24.3401 25.8624C24.3401 26.8868 24.6384 28.4359 25.6936 29.7759C26.8215 31.2081 28.6382 32.175 31.1916 32.175C32.7119 32.175 33.3213 32.7122 33.6316 33.1468C34.02 33.6908 34.1671 34.4217 34.1856 34.9761C34.1812 35.6232 34.0165 36.2652 33.6643 36.7082C33.3753 37.0716 32.752 37.5702 31.1916 37.5702C29.6087 37.5702 29.0114 37.0743 28.7587 36.7543C28.4428 36.3544 28.3061 35.7649 28.3373 35.1755L28.443 33.1783L24.4486 32.9669L24.3429 34.9641C24.2789 36.1716 24.5132 37.8323 25.6195 39.2333C26.4207 40.2479 27.5535 40.9692 29.0001 41.3228V44.4106H33.0001V41.4037Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M134 113C134 124.598 124.598 134 113 134C101.402 134 92 124.598 92 113C92 101.402 101.402 92 113 92C124.598 92 134 101.402 134 113Z",
        fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.656 124.351C128.357 121.341 130 117.362 130 113C130 103.611 122.389 96 113 96C103.611 96 96 103.611 96 113C96 117.505 97.7521 121.6 100.612 124.642C103.156 119.399 107.844 115.882 113.206 115.882C118.469 115.882 123.082 119.269 125.656 124.351ZM122.53 127.08C120.609 122.522 116.855 119.882 113.206 119.882C109.5 119.882 105.687 122.605 103.794 127.294C106.447 129.006 109.608 130 113 130C116.532 130 119.812 128.923 122.53 127.08ZM113 134C124.598 134 134 124.598 134 113C134 101.402 124.598 92 113 92C101.402 92 92 101.402 92 113C92 124.598 101.402 134 113 134ZM113 108.882C114.227 108.882 115.222 107.887 115.222 106.66C115.222 105.432 114.227 104.438 113 104.438C111.772 104.438 110.777 105.432 110.777 106.66C110.777 107.887 111.772 108.882 113 108.882ZM113 112.882C116.436 112.882 119.222 110.096 119.222 106.66C119.222 103.223 116.436 100.438 113 100.438C109.563 100.438 106.777 103.223 106.777 106.66C106.777 110.096 109.563 112.882 113 112.882Z",
        fill: (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.9661 62.3212C26.0107 60.9563 23.9893 60.9563 23.0338 62.3212L15.2146 73.4915L18.4915 75.7854L23 69.3447V126.5C23 128.709 24.7909 130.5 27 130.5H74V126.5H27V69.3447L31.5084 75.7854L34.7854 73.4915L26.9661 62.3212Z",
        fill: (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121 74.1553L125.508 67.7146L128.785 70.0085L120.966 81.1788C120.011 82.5437 117.989 82.5437 117.034 81.1788L109.215 70.0085L112.492 67.7146L117 74.1553V17H70V13H117C119.209 13 121 14.7909 121 17V74.1553Z",
        fill: (E = (T = r.semantic) == null ? void 0 : T.illustration) == null ? void 0 : E.border
      }
    )
  ] });
}, Pending = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M125.5 72C125.5 101.823 101.323 126 71.5 126C41.6766 126 17.5 101.823 17.5 72C17.5 42.1766 41.6766 18 71.5 18C101.323 18 125.5 42.1766 125.5 72Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M54.5 42C54.5 40.8954 55.3954 40 56.5 40H87.5C88.6046 40 89.5 40.8954 89.5 42V42.5714C89.5 43.676 88.6046 44.5714 87.5 44.5714H56.5C55.3954 44.5714 54.5 43.676 54.5 42.5714V42ZM58.7628 47H85.638C86.7426 47 87.6836 47.8927 87.7109 48.997C87.7864 52.0464 87.5135 57.314 83.5888 60.9091C82.0973 62.2753 78.9797 64.0843 75.3239 66.2057L75.3236 66.2058C74.1282 66.8995 72.8753 67.6265 71.6028 68.3824C70.1841 67.4897 68.8013 66.6369 67.508 65.8392C64.0351 63.6973 61.2082 61.9538 60.0677 60.9091C56.8932 58.0012 56.6649 52.2438 56.7144 48.9984C56.7312 47.894 57.6582 47 58.7628 47ZM71.6028 68.3824C79.9005 73.6031 89.4245 80.183 89.4245 85.0182C89.4245 86.2719 89.4472 87.4048 89.4677 88.4283V88.4284C89.6519 97.6246 89.6595 98 71.4412 98C54.075 98 54.2115 95.6122 54.6017 88.7883C54.6665 87.6567 54.7381 86.4031 54.7381 85.0182C54.7381 79.089 63.5603 73.1598 71.6028 68.3824ZM56.5 99.4285C55.3954 99.4285 54.5 100.324 54.5 101.428V102C54.5 103.104 55.3954 104 56.5 104H87.5C88.6046 104 89.5 103.104 89.5 102V101.428C89.5 100.324 88.6046 99.4285 87.5 99.4285H56.5Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M87.5 92.6692C87.5 96.9698 80.3366 95.8755 71.5 95.8755C62.6634 95.8755 55.5 96.9698 55.5 92.6692C55.5 88.3686 66.1667 81 71.5 81C76.8333 81 87.5 88.3686 87.5 92.6692Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M56.5 36H87.5C90.8137 36 93.5 38.6863 93.5 42V42.5714C93.5 45.1389 91.8874 47.3297 89.6198 48.1862C89.6737 48.432 89.705 48.6867 89.7113 48.9483C89.7851 52.0162 89.5417 57.9786 84.9251 62.1244C83.4655 63.4352 80.811 64.9975 77.9388 66.6408C77.4049 66.9462 76.8574 67.2577 76.2996 67.5751L76.2991 67.5753C76.0311 67.7278 75.7607 67.8816 75.4883 68.0368C76.1142 68.4357 76.7405 68.8402 77.3626 69.2489C80.8066 71.5112 84.2132 73.9595 86.7781 76.375C88.0606 77.5828 89.189 78.8345 90.0085 80.1015C90.818 81.3532 91.4245 82.7717 91.4245 84.2727C91.4245 85.3813 91.4456 86.4462 91.4653 87.4413V87.4415C91.4966 89.0253 91.5245 90.4322 91.4582 91.5566C91.3653 93.1326 91.0791 94.7218 90.0619 96.0013C92.0941 96.9623 93.5 99.0312 93.5 101.428V102C93.5 105.314 90.8137 108 87.5 108H56.5C53.1863 108 50.5 105.314 50.5 102V101.428C50.5 98.8984 52.066 96.734 54.2817 95.8519C54.1683 95.7362 54.0598 95.6159 53.9563 95.4907C52.6552 93.9178 52.4843 91.9961 52.501 90.2691C52.5083 89.509 52.5566 88.6818 52.6055 87.8461C52.6133 87.7128 52.6211 87.5793 52.6287 87.4458C52.6856 86.4531 52.7381 85.4062 52.7381 84.2727C52.7381 81.0682 54.7056 78.1909 57.1204 75.7772C59.5886 73.3102 62.8699 70.9861 66.1989 68.8876C66.7056 68.5682 67.2162 68.2524 67.7279 67.9406C67.3034 67.6834 66.8855 67.4307 66.4757 67.1829L66.4736 67.1816C66.0834 66.9457 65.7006 66.7142 65.3265 66.4875C62.4737 64.7589 59.9203 63.1921 58.7313 62.1244C56.6934 60.2943 55.7172 57.6966 55.2297 55.3569C54.7358 52.9866 54.6898 50.6149 54.714 48.9697C54.7173 48.7481 54.7385 48.5311 54.7763 48.3202C52.3027 47.5796 50.5 45.286 50.5 42.5714V42C50.5 38.6863 53.1863 36 56.5 36ZM56.5 40C55.3954 40 54.5 40.8954 54.5 42V42.5714C54.5 43.676 55.3954 44.5714 56.5 44.5714H87.5C88.6046 44.5714 89.5 43.676 89.5 42.5714V42C89.5 40.8954 88.6046 40 87.5 40H56.5ZM56.5 99.4285C55.3954 99.4285 54.5 100.324 54.5 101.428V102C54.5 103.104 55.3954 104 56.5 104H87.5C88.6046 104 89.5 103.104 89.5 102V101.428C89.5 100.324 88.6046 99.4285 87.5 99.4285H56.5ZM74.3484 64.083C73.4739 64.5804 72.5631 65.0986 71.633 65.6345C70.5623 64.9794 69.523 64.351 68.5403 63.7568L68.5401 63.7567L68.5387 63.7559C68.1495 63.5205 67.7692 63.2906 67.3994 63.0665C64.3681 61.2298 62.2397 59.8988 61.404 59.1483C60.2807 58.1395 59.5565 56.513 59.1456 54.541C58.7415 52.6014 58.6909 50.5758 58.7135 49.0326C58.7151 49.03 58.7183 49.0252 58.7242 49.0195C58.7324 49.0115 58.7413 49.006 58.7485 49.0031C58.7544 49.0006 58.7584 49 58.7627 49H85.638C85.6464 49 85.6701 49.0038 85.696 49.0286C85.7055 49.0378 85.7105 49.0455 85.7126 49.0493C85.7824 51.972 85.45 56.2769 82.2525 59.1483C81.1814 60.1102 78.9641 61.4457 75.9524 63.1689C75.4349 63.4649 74.8989 63.7699 74.3484 64.083ZM68.3319 72.2715C69.4031 71.5962 70.4907 70.9382 71.574 70.2984C72.7675 71.0421 73.9748 71.8092 75.1665 72.592C78.5555 74.8183 81.7289 77.1144 84.0357 79.2869C85.1891 80.3731 86.0694 81.3765 86.6497 82.2738C87.2401 83.1866 87.4245 83.8419 87.4245 84.2727C87.4245 85.6287 87.4489 86.7803 87.4701 87.7856V87.7857C87.5001 89.1995 87.5239 90.3242 87.4651 91.3213C87.3693 92.9476 87.0664 93.4324 86.74 93.7061C86.275 94.0961 85.2294 94.5126 82.6152 94.7451C80.0868 94.97 76.5288 95 71.4412 95C66.4006 95 62.9728 94.7996 60.6403 94.3846C58.2674 93.9624 57.4 93.3782 57.0385 92.9411C56.6945 92.5254 56.4858 91.8618 56.5008 90.3076C56.5071 89.6531 56.5488 88.9365 56.5981 88.091L56.6222 87.6746C56.68 86.6663 56.7381 85.5256 56.7381 84.2727C56.7381 82.7046 57.7443 80.8092 59.9482 78.6063C62.0986 76.4569 65.0809 74.3207 68.3319 72.2715Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.215 33.3455C98.8767 25.9742 88.4027 21.3913 77.3124 20.2618C66.2224 19.1322 55.097 21.5149 45.5478 27.0583C35.9991 32.6013 28.5213 41.0172 24.1942 51.0844L24.19 51.0941C22.3616 55.2865 21.1338 59.715 20.5418 64.2532L20.2839 66.2305L16.3157 65.7165L16.5736 63.7392C17.2136 58.8324 18.541 54.0435 20.5179 49.5094C25.1854 38.6531 33.2481 29.5832 43.5336 23.6124C53.8203 17.641 65.7943 15.08 77.7193 16.2946C89.644 17.5091 100.905 22.4362 109.87 30.3623C118.24 37.7619 124.207 47.4191 127.034 58.0965L129.74 50.6865L133.5 52.0499L128.836 64.8244C128.267 66.3853 126.313 66.9069 125.037 65.8391L114.588 57.0998L117.161 54.0453L123.149 59.0541C120.518 49.1652 114.983 40.2129 107.215 33.3455ZM128.036 78.2917L127.769 80.2678C127.097 85.2429 125.737 90.1025 123.73 94.7079C118.989 105.735 110.861 114.979 100.522 121.097C90.1817 127.217 78.1669 129.893 66.219 128.737C54.2711 127.581 43.012 122.652 34.0742 114.666C25.6859 107.17 19.7521 97.3472 17.0087 86.4715L14.2605 93.9994L10.5 92.636L15.1636 79.8615C15.7334 78.3005 17.6868 77.7789 18.9635 78.8468L29.4116 87.5861L26.839 90.6406L20.9429 85.7088C23.5156 95.733 29.0072 104.782 36.7457 111.697C45.0484 119.116 55.5069 123.694 66.6058 124.768C77.7048 125.842 88.8686 123.356 98.4788 117.669C108.089 111.981 115.646 103.388 120.053 93.1341L120.057 93.1245C121.919 88.8544 123.18 84.3485 123.803 79.7357L124.07 77.7596L128.036 78.2917Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    )
  ] });
}, Processing = () => {
  var a, s, c, u, d;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M100.597 92.2215L94.8554 86.149C95.9426 84.3327 96.8005 82.4227 97.4161 80.4415L105.762 80.6724C106.154 80.6843 106.519 80.5729 106.824 80.3796C107.333 80.0552 107.683 79.4878 107.702 78.8374L107.999 68.1594C108.03 67.1164 107.207 66.2504 106.164 66.2194L97.8186 65.9885C97.3127 63.9783 96.562 62.02 95.5779 60.1461L101.65 54.4044C102.408 53.6867 102.442 52.4904 101.727 51.7343L94.387 43.9743C93.6693 43.2163 92.4763 43.1847 91.7201 43.8992L89.5785 45.9271L85.649 49.646C84.7415 49.1049 83.8075 48.6172 82.8567 48.1885L82.8406 48.1792C81.8962 47.7542 80.9298 47.3895 79.9466 47.0839L80.1775 38.7384C80.2084 37.6953 79.3855 36.8294 78.3424 36.7984L67.6645 36.5008C66.9674 36.4806 66.3522 36.847 66.0106 37.4014C65.9235 37.3812 65.4903 46.6795 65.4903 46.6795C63.4801 47.1854 61.5251 47.938 59.6498 48.917L53.9049 42.8426C53.5477 42.4646 53.0696 42.2659 52.5838 42.2517C52.1013 42.2394 51.6129 42.4084 51.2329 42.7689L43.4729 50.1092C42.7149 50.8269 42.6833 52.02 43.3978 52.7761L45.4258 54.9177L49.1446 58.8473C48.0573 60.6635 47.1976 62.5767 46.5839 64.5548L38.2384 64.3238C37.1953 64.2929 36.3294 65.1158 36.2984 66.1589L36.0008 76.8368C35.9806 77.5339 36.347 78.1491 36.9014 78.4907C36.8812 78.5778 46.1813 79.0077 46.1813 79.0077C46.6873 81.0179 47.4399 82.973 48.4189 84.8482L46.1504 86.9919L42.3464 90.5899C41.5883 91.3077 41.5567 92.5007 42.2713 93.2569L49.6115 101.017C50.0597 101.49 50.6933 101.68 51.2908 101.583C51.6509 101.524 51.994 101.362 52.2785 101.092L58.351 95.3503C59.5285 96.0559 60.7476 96.6524 61.9971 97.159C62.6755 97.4347 63.36 97.6924 64.0585 97.911L63.8275 106.256C63.8146 106.777 64.0109 107.256 64.3447 107.607C64.5922 107.871 64.919 108.063 65.2854 108.15C65.4071 108.178 65.5343 108.195 65.6658 108.198L76.3438 108.496C77.2572 108.521 78.0346 107.896 78.2359 107.041C78.2632 106.92 78.2809 106.792 78.2838 106.661L78.3167 105.473L78.5147 98.3154C80.5249 97.8095 82.4831 97.0587 84.3571 96.0746L90.0987 102.147C90.8165 102.905 92.0095 102.937 92.7657 102.222L100.526 94.882C101.284 94.1642 101.315 92.9712 100.603 92.2118L100.597 92.2215ZM72.0884 86.3065C79.666 86.3065 85.8088 80.1637 85.8088 72.5861C85.8088 65.0086 79.666 58.8658 72.0884 58.8658C64.5109 58.8658 58.3681 65.0086 58.3681 72.5861C58.3681 80.1637 64.5109 86.3065 72.0884 86.3065Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.215 33.3455C98.8767 25.9742 88.4027 21.3913 77.3124 20.2618C66.2224 19.1322 55.097 21.5149 45.5478 27.0583C35.9991 32.6013 28.5213 41.0172 24.1942 51.0844L24.19 51.0941C22.3616 55.2865 21.1338 59.715 20.5418 64.2532L20.2839 66.2305L16.3157 65.7165L16.5736 63.7392C17.2136 58.8324 18.541 54.0435 20.5179 49.5094C25.1854 38.6531 33.2481 29.5832 43.5336 23.6124C53.8203 17.641 65.7943 15.08 77.7193 16.2946C89.644 17.5091 100.905 22.4362 109.87 30.3623C118.24 37.7619 124.207 47.4191 127.034 58.0965L129.74 50.6865L133.5 52.0499L128.836 64.8244C128.267 66.3853 126.313 66.9069 125.037 65.8391L114.588 57.0998L117.161 54.0453L123.149 59.0541C120.518 49.1652 114.983 40.2129 107.215 33.3455ZM128.036 78.2917L127.769 80.2678C127.097 85.2429 125.737 90.1025 123.73 94.7079C118.989 105.735 110.861 114.979 100.522 121.097C90.1817 127.217 78.1669 129.893 66.219 128.737C54.2711 127.581 43.012 122.652 34.0742 114.666C25.6859 107.17 19.7521 97.3472 17.0087 86.4715L14.2605 93.9994L10.5 92.636L15.1636 79.8615C15.7334 78.3005 17.6868 77.7789 18.9635 78.8468L29.4116 87.5861L26.839 90.6406L20.9429 85.7088C23.5156 95.733 29.0072 104.782 36.7457 111.697C45.0484 119.116 55.5069 123.694 66.6058 124.768C77.7048 125.842 88.8686 123.356 98.4788 117.669C108.089 111.981 115.646 103.388 120.053 93.1341L120.057 93.1245C121.919 88.8544 123.18 84.3485 123.803 79.7357L124.07 77.7596L128.036 78.2917Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    )
  ] });
}, Sent = () => {
  var a, s, c, u, d, h, p;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("circle", { cx: "71.8068", cy: "72.2529", r: "54", fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.1499 81.8688L39.6753 81.0467L38.1734 81.9138L17.726 67.7509C16.3402 66.791 16.6907 64.6524 18.3104 64.1851L119.384 35.0265L119.385 35.0262L119.385 35.0264L61.7165 113.614C60.8624 114.778 59.0939 114.681 58.372 113.43L48.0823 95.6081C48.1781 95.7963 48.1107 96.0287 47.9256 96.1355L37.6994 102.04C36.1611 102.928 34.3147 101.519 34.7646 99.8011L39.4283 81.9866C39.5169 81.6481 39.9635 81.5811 40.1499 81.8688Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M120.974 36.2414C121.399 35.6843 121.515 34.924 121.225 34.2435C120.829 33.3133 119.802 32.8246 118.83 33.1048L17.7561 62.2636C14.5166 63.1981 13.8156 67.4753 16.5872 69.3951L36.9625 83.508L32.8298 99.2946C31.9301 102.731 35.6228 105.548 38.6994 103.772L47.5394 98.6679L56.64 114.431C58.0838 116.931 61.6206 117.125 63.329 114.797L120.974 36.2414ZM49.8041 94.5892C49.813 94.6046 49.8217 94.6201 49.8303 94.6357L60.1041 112.431L112.14 41.5185L42.4078 81.7784L49.8041 94.5892ZM36.6994 100.308L40.3765 86.2614L45.5394 95.2038L36.6994 100.308ZM38.2707 79.5483L104.184 41.4933L18.8648 66.1068L38.2707 79.5483ZM6.28183 97.6763C5.23599 98.0189 4.67131 99.1496 5.02059 100.202C5.36987 101.254 6.50083 101.829 7.54668 101.486L23.2871 96.3293C24.333 95.9867 24.8976 94.856 24.5484 93.8039C24.1991 92.7518 23.0681 92.1766 22.0223 92.5193L6.28183 97.6763ZM33.0454 131.808C32.0417 131.337 31.6101 130.149 32.0813 129.155L39.1733 114.186C39.6445 113.192 40.8402 112.767 41.8439 113.238C42.8475 113.708 43.2792 114.896 42.808 115.891L35.7159 130.859C35.2447 131.854 34.0491 132.279 33.0454 131.808ZM7.98896 121.216C7.14113 121.903 7.04387 123.147 7.7717 123.996C8.49954 124.845 9.77687 124.977 10.6247 124.29L28.2226 110.044C29.0705 109.358 29.1677 108.113 28.4399 107.264C27.7121 106.416 26.4347 106.284 25.5869 106.97L7.98896 121.216Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    )
  ] });
}, SmallBusiness = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M124.5 44C124.5 41.7909 122.709 40 120.5 40H24.5C22.2909 40 20.5 41.7909 20.5 44V120C20.5 122.209 22.2909 124 24.5 124H120.5C122.709 124 124.5 122.209 124.5 120V44Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M105.5 79.8555C105.5 77.6463 103.709 75.8555 101.5 75.8555H81.5C79.2909 75.8555 77.5 77.6463 77.5 79.8555V123.855H105.5V79.8555Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M65.0645 80.0137C65.0645 77.8045 63.2736 76.0137 61.0645 76.0137H41.0645C38.8553 76.0137 37.0645 77.8045 37.0645 80.0137V100.014C37.0645 102.223 38.8553 104.014 41.0645 104.014H61.0645C63.2736 104.014 65.0645 102.223 65.0645 100.014V80.0137Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.5 44H120.5V120H105.5V79.8555C105.5 77.6463 103.709 75.8555 101.5 75.8555H81.5C79.2909 75.8555 77.5 77.6463 77.5 79.8555V120H24.5V44ZM120.5 40C122.709 40 124.5 41.7909 124.5 44V120C124.5 122.209 122.709 124 120.5 124H24.5C22.2909 124 20.5 122.209 20.5 120V44C20.5 41.7909 22.2909 40 24.5 40H120.5ZM81.5 79.8555H101.5V119.855H81.5V79.8555ZM61.0645 80.0137H41.0645V100.014H61.0645V80.0137ZM65.0645 80.0137C65.0645 77.8045 63.2736 76.0137 61.0645 76.0137H41.0645C38.8553 76.0137 37.0645 77.8045 37.0645 80.0137V100.014C37.0645 102.223 38.8553 104.014 41.0645 104.014H61.0645C63.2736 104.014 65.0645 102.223 65.0645 100.014V80.0137Z",
        fill: (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M101.5 20H70.5V51.5C70.5 60.0604 77.4396 67 86 67C94.5604 67 101.5 60.0604 101.5 51.5V20Z",
        fill: (x = (y = (v = r.semantic) == null ? void 0 : v.illustration) == null ? void 0 : y.brand) == null ? void 0 : x.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M73.5 20H42.5V51.5C42.5 60.0604 49.4396 67 58 67C66.5604 67 73.5 60.0604 73.5 51.5V20Z",
        fill: (M = (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.brand) == null ? void 0 : M.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.5 20H16.5C15.3954 20 14.5 20.8954 14.5 22V51.5C14.5 60.0604 21.4396 67 30 67C38.5604 67 45.5 60.0604 45.5 51.5V20Z",
        fill: (I = (L = (P = r.semantic) == null ? void 0 : P.illustration) == null ? void 0 : L.brand) == null ? void 0 : I.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M129.5 22C129.5 20.8954 128.605 20 127.5 20H98.5V51.5C98.5 60.0604 105.44 67 114 67C122.56 67 129.5 60.0604 129.5 51.5V22Z",
        fill: (R = (E = (T = r.semantic) == null ? void 0 : T.illustration) == null ? void 0 : E.brand) == null ? void 0 : R.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.5 51.5V24H102.5V51.5C102.5 57.8513 107.649 63 114 63C120.351 63 125.5 57.8513 125.5 51.5ZM129.5 22C129.5 20.8954 128.605 20 127.5 20H101.5H98.5H73.5H70.5H45.5H42.5H16.5C15.3954 20 14.5 20.8954 14.5 22V51.5C14.5 60.0604 21.4396 67 30 67C36.1762 67 41.5087 63.3876 44 58.1605C46.4913 63.3876 51.8238 67 58 67C64.1762 67 69.5087 63.3876 72 58.1605C74.4913 63.3876 79.8238 67 86 67C92.1762 67 97.5087 63.3876 100 58.1605C102.491 63.3876 107.824 67 114 67C122.56 67 129.5 60.0604 129.5 51.5V22ZM97.5 24H74.5V51.5C74.5 57.8513 79.6487 63 86 63C92.3513 63 97.5 57.8513 97.5 51.5V24ZM69.5 24H46.5V51.5C46.5 57.8513 51.6487 63 58 63C64.3513 63 69.5 57.8513 69.5 51.5V24ZM18.5 24H41.5V51.5C41.5 57.8513 36.3513 63 30 63C23.6487 63 18.5 57.8513 18.5 51.5V24Z",
        fill: (k = (A = r.semantic) == null ? void 0 : A.illustration) == null ? void 0 : k.border
      }
    )
  ] });
}, Success = () => {
  var a, s, c, u, d, h;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.success
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
        fill: (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M104.849 53.7691C105.276 54.1227 105.333 54.756 104.978 55.1811L69.3697 97.7111C67.915 99.4485 65.299 99.6399 63.5943 98.1336L42.5603 79.5481C42.1449 79.181 42.1073 78.546 42.4767 78.1325L45.6683 74.5595C46.0348 74.1491 46.6639 74.112 47.0762 74.4763L65.1912 90.4826C65.6129 90.8552 66.2589 90.8066 66.6201 90.3752L99.7343 50.8236C100.088 50.4016 100.715 50.3444 101.139 50.6955L104.849 53.7691Z",
        fill: (h = (d = r.semantic) == null ? void 0 : d.illustration) == null ? void 0 : h.background
      }
    )
  ] });
}, SyncAccounts = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I, T, E, R, A, k, V, B, q;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M75.9531 64.375C77.0577 64.375 77.9531 63.4796 77.9531 62.375L77.9531 21.375C77.9531 20.2704 77.0577 19.375 75.9531 19.375L16.9531 19.375C15.8486 19.375 14.9531 20.2704 14.9531 21.375L14.9531 62.375C14.9531 63.4796 15.8486 64.375 16.9531 64.375L75.9531 64.375Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M75.9531 66.375C78.1623 66.375 79.9531 64.5841 79.9531 62.375L79.9531 21.375C79.9531 19.1659 78.1623 17.375 75.9531 17.375L16.9531 17.375C14.744 17.375 12.9531 19.1659 12.9531 21.375L12.9531 62.375C12.9531 64.5841 14.744 66.375 16.9531 66.375L75.9531 66.375ZM75.9531 21.375L75.9531 62.375L16.9531 62.375L16.9531 21.375L75.9531 21.375Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.9531 27.6816C29.9531 29.0624 31.0724 30.1816 32.4531 30.1816C33.8338 30.1816 34.9531 29.0624 34.9531 27.6816C34.9531 26.3009 33.8338 25.1816 32.4531 25.1816C31.0724 25.1816 29.9531 26.3009 29.9531 27.6816Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.9531 27.6816C21.9531 29.0624 23.0724 30.1816 24.4531 30.1816C25.8338 30.1816 26.9531 29.0624 26.9531 27.6816C26.9531 26.3009 25.8338 25.1816 24.4531 25.1816C23.0724 25.1816 21.9531 26.3009 21.9531 27.6816Z",
        fill: (y = (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.brand) == null ? void 0 : y.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M127.047 124.625C128.151 124.625 129.047 123.73 129.047 122.625L129.047 81.625C129.047 80.5204 128.151 79.625 127.047 79.625L68.0469 79.625C66.9423 79.625 66.0469 80.5204 66.0469 81.625L66.0469 122.625C66.0469 123.73 66.9423 124.625 68.0469 124.625L127.047 124.625Z",
        fill: (S = (w = (x = r.semantic) == null ? void 0 : x.illustration) == null ? void 0 : w.brand) == null ? void 0 : S.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M127.047 126.625C129.256 126.625 131.047 124.834 131.047 122.625L131.047 81.625C131.047 79.4159 129.256 77.625 127.047 77.625L68.0469 77.625C65.8377 77.625 64.0469 79.4159 64.0469 81.625L64.0469 122.625C64.0469 124.834 65.8377 126.625 68.0469 126.625L127.047 126.625ZM127.047 81.625L127.047 122.625L68.0469 122.625L68.0469 81.625L127.047 81.625Z",
        fill: (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M81.0469 88.1763C81.0469 89.557 82.1662 90.6763 83.5469 90.6763C84.9276 90.6763 86.0469 89.557 86.0469 88.1763C86.0469 86.7956 84.9276 85.6763 83.5469 85.6763C82.1662 85.6763 81.0469 86.7956 81.0469 88.1763Z",
        fill: (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M73.3479 88.1763C73.3479 89.557 74.4672 90.6763 75.8479 90.6763C77.2286 90.6763 78.3479 89.557 78.3479 88.1763C78.3479 86.7956 77.2286 85.6763 75.8479 85.6763C74.4672 85.6763 73.3479 86.7956 73.3479 88.1763Z",
        fill: (E = (T = r.semantic) == null ? void 0 : T.illustration) == null ? void 0 : E.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M89.6866 42.5977L91.4311 41.6196C94.6465 39.817 98.4105 38.7765 101.832 39.1324C105.408 39.5043 108.748 40.9957 111.375 43.3843C114.001 45.7726 115.781 48.9376 116.458 52.4233C117.015 55.2904 116.975 58.1411 116.068 60.7085L115.401 62.5941L119.172 63.9275L119.839 62.0419C121.045 58.6293 121.038 55.0227 120.385 51.6606C119.543 47.3289 117.33 43.3934 114.066 40.425C110.802 37.4569 106.661 35.6131 102.246 35.1538C97.7916 34.6905 93.2004 36.042 89.475 38.1306L87.7305 39.1086L89.6866 42.5977Z",
        fill: (A = (R = r.semantic) == null ? void 0 : R.illustration) == null ? void 0 : A.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M110.149 56.0093L116.368 64.0946C117.036 64.9626 118.277 65.1322 119.153 64.4752L126.753 58.7751L124.353 55.5751L118.334 60.0897L113.319 53.5705L110.149 56.0093Z",
        fill: (V = (k = r.semantic) == null ? void 0 : k.illustration) == null ? void 0 : V.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.4522 76.3078C27.3283 75.6508 28.5698 75.8204 29.2375 76.6884L35.4567 84.7737L32.2861 87.2125L28.8988 82.8087C28.6732 84.6016 28.7817 86.4772 29.1473 88.3597C29.8244 91.8454 31.6043 95.0104 34.2305 97.3988C36.8569 99.7874 40.1978 101.279 43.7733 101.651C47.1948 102.007 50.9588 100.966 54.1742 99.1634L55.9188 98.1853L57.8749 101.674L56.1303 102.652C52.4049 104.741 47.8137 106.092 43.3595 105.629C38.9439 105.17 34.8029 103.326 31.5392 100.358C28.2752 97.3896 26.0621 93.4541 25.2207 89.1225C24.8017 86.9649 24.6483 84.7067 24.9111 82.4636L21.252 85.2079L18.8521 82.0079L26.4522 76.3078Z",
        fill: (q = (B = r.semantic) == null ? void 0 : B.illustration) == null ? void 0 : q.border
      }
    )
  ] });
}, SyncUser = () => {
  var a, s, c, u, d;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72.5 73C82.9934 73 91.5 64.4934 91.5 54C91.5 43.5066 82.9934 35 72.5 35C62.0066 35 53.5 43.5066 53.5 54C53.5 64.4934 62.0066 73 72.5 73ZM35.5 113.531C40.5778 94.0874 55.5394 80 73.2062 80C90.4174 80 105.061 93.3701 110.5 112.037C98.8715 122.989 67.5916 138.621 35.5 113.531Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.215 33.3455C98.8767 25.9742 88.4027 21.3913 77.3124 20.2618C66.2224 19.1322 55.097 21.5149 45.5478 27.0583C35.9991 32.6013 28.5213 41.0172 24.1942 51.0844L24.19 51.0941C22.3616 55.2865 21.1338 59.715 20.5418 64.2532L20.2839 66.2305L16.3157 65.7165L16.5736 63.7392C17.2136 58.8324 18.541 54.0435 20.5179 49.5094C25.1854 38.6531 33.2481 29.5832 43.5336 23.6124C53.8203 17.641 65.7943 15.08 77.7193 16.2946C89.644 17.5091 100.905 22.4362 109.87 30.3623C118.24 37.7619 124.207 47.4191 127.034 58.0965L129.74 50.6865L133.5 52.0499L128.836 64.8244C128.267 66.3853 126.313 66.9069 125.037 65.8391L114.588 57.0998L117.161 54.0453L123.149 59.0541C120.518 49.1652 114.983 40.2129 107.215 33.3455ZM128.036 78.2917L127.769 80.2678C127.097 85.2429 125.737 90.1025 123.73 94.7079C118.989 105.735 110.861 114.979 100.522 121.097C90.1817 127.217 78.1669 129.893 66.219 128.737C54.2711 127.581 43.012 122.652 34.0742 114.666C25.6859 107.17 19.7521 97.3472 17.0087 86.4715L14.2605 93.9994L10.5 92.636L15.1636 79.8615C15.7334 78.3005 17.6868 77.7789 18.9635 78.8468L29.4116 87.5861L26.839 90.6406L20.9429 85.7088C23.5156 95.733 29.0072 104.782 36.7457 111.697C45.0484 119.116 55.5069 123.694 66.6058 124.768C77.7048 125.842 88.8686 123.356 98.4788 117.669C108.089 111.981 115.646 103.388 120.053 93.1341L120.057 93.1245C121.919 88.8544 123.18 84.3485 123.803 79.7357L124.07 77.7596L128.036 78.2917Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    )
  ] });
}, TaxForm = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M110 127L34 127C32.8954 127 32 126.105 32 125L32 20C32 18.8954 32.8954 18 34 18L85.5484 18L111.574 51.2214C111.85 51.5734 112 52.0077 112 52.4548L112 125C112 126.105 111.105 127 110 127Z",
        fill: (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M50.4787 29V32.4532C51.8964 32.6556 53.2072 33.13 54.2714 33.9914C55.8414 35.2623 56.5655 37.1207 56.5655 39.2544V41.2544H52.5655V39.2544C52.5655 38.0603 52.1967 37.4582 51.7548 37.1005C51.2403 36.6841 50.2949 36.3334 48.7032 36.3334C47.2127 36.3334 46.3361 36.7332 45.8451 37.1935C45.3709 37.6381 45.0084 38.3707 45.0084 39.5763C45.0084 40.0586 45.1715 40.8532 45.6653 41.4802C46.0864 42.015 46.9063 42.6385 48.7032 42.6385C51.7797 42.6385 53.8622 43.859 55.1057 45.6006C56.265 47.2242 56.5352 49.0735 56.5648 50.1901L56.5655 50.2166V50.243C56.5654 51.5958 56.249 53.4534 55.0086 55.0132C53.9839 56.3019 52.4792 57.1997 50.4787 57.5284V61.0002H46.4787L46.4787 57.447C44.7168 57.0732 43.3684 56.2374 42.4354 55.0559C41.2055 53.4984 40.9391 51.6421 41.0112 50.2784L41.117 48.2812L45.1114 48.4927L45.0057 50.4899C44.9662 51.2354 45.1352 52.0204 45.5747 52.5769C45.9509 53.0535 46.7632 53.6667 48.7032 53.6667C50.6208 53.6667 51.4611 53.0477 51.8778 52.5236C52.3574 51.9206 52.561 51.0782 52.5654 50.2696C52.5433 49.5805 52.3626 48.6424 51.8503 47.9249C51.4158 47.3163 50.5911 46.6385 48.7032 46.6385C45.802 46.6385 43.7745 45.5445 42.5228 43.955C41.3437 42.4577 41.0084 40.7212 41.0084 39.5763C41.0084 37.5278 41.655 35.6389 43.1091 34.2755C44.0381 33.4046 45.1899 32.8481 46.4787 32.5635L46.4787 29H50.4787Z",
        fill: (d = (u = (c = r.semantic) == null ? void 0 : c.illustration) == null ? void 0 : u.brand) == null ? void 0 : d.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40 70L73 70V74L40 74V70ZM52 92L48.2995 90.9473L40.7468 103.148L44.1478 105.253L48 99.0305V115H52V92ZM61 91C58.2386 91 56 93.2386 56 96V110C56 112.761 58.2386 115 61 115H63C65.7614 115 68 112.761 68 110V96C68 93.2386 65.7614 91 63 91H61ZM60 96C60 95.4477 60.4477 95 61 95H63C63.5523 95 64 95.4477 64 96V110C64 110.552 63.5523 111 63 111H61C60.4477 111 60 110.552 60 110V96ZM86 96C86 93.2386 88.2386 91 91 91H93C95.7614 91 98 93.2386 98 96V110C98 112.761 95.7614 115 93 115H91C88.2386 115 86 112.761 86 110V108.417H90V110C90 110.552 90.4477 111 91 111H93C93.5523 111 94 110.552 94 110V104.583H91C88.2386 104.583 86 102.345 86 99.5833V96ZM94 100.583V96C94 95.4477 93.5523 95 93 95H91C90.4477 95 90 95.4477 90 96V99.5833C90 100.136 90.4477 100.583 91 100.583H94ZM76 91C73.2386 91 71 93.2386 71 96V99.5833C71 102.345 73.2386 104.583 76 104.583H79V110C79 110.552 78.5523 111 78 111H76C75.4477 111 75 110.552 75 110V108.417H71V110C71 112.761 73.2386 115 76 115H78C80.7614 115 83 112.761 83 110V96C83 93.2386 80.7614 91 78 91H76ZM79 96V100.583H76C75.4477 100.583 75 100.136 75 99.5833V96C75 95.4477 75.4477 95 76 95H78C78.5523 95 79 95.4477 79 96ZM83 78L40 78V82L83 82V78Z",
        fill: (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.border
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M86 51.5V18.5L111 51.5H86Z", fill: (v = (g = (m = r.semantic) == null ? void 0 : m.illustration) == null ? void 0 : g.brand) == null ? void 0 : v.secondary }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34 129C31.7909 129 30 127.209 30 125L30 20C30 17.7909 31.7909 16 34 16L86.5222 16L113.149 49.988C113.7 50.692 114 51.5605 114 52.4548L114 125C114 127.209 112.209 129 110 129L34 129ZM34 125L110 125L110 54L87 54C85.3432 54 84 52.6569 84 51L84 20L34 20L34 125ZM88 24.3725L88 50L108.077 50L88 24.3725Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.border
      }
    )
  ] });
}, VendorAdd = () => {
  var a, s, c, u, d, h, p, m, g, v, y, x, w, S, M, P, L, I;
  const { colors: r } = useTheme();
  return /* @__PURE__ */ jsxs("svg", { height: "100%", viewBox: "0 0 144 144", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.4442 34.5262L17.8054 54.3967C17.2504 55.1018 16.9487 55.9731 16.9487 56.8705V116.165C16.9487 118.374 18.7395 120.165 20.9487 120.165H123.052C125.261 120.165 127.052 118.374 127.052 116.165V56.8506C127.052 55.9654 126.758 55.1053 126.217 54.4048L110.878 34.5542C110.121 33.574 108.952 33 107.713 33H36.5874C35.3611 33 34.2026 33.5625 33.4442 34.5262Z",
        fill: (c = (s = (a = r.semantic) == null ? void 0 : a.illustration) == null ? void 0 : s.brand) == null ? void 0 : c.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M36.5874 35C35.9743 35 35.395 35.2813 35.0158 35.7631L33.4442 34.5262L35.0158 35.7631L29.6181 42.6213L114.584 42.6213L109.295 35.7771C108.917 35.287 108.332 35 107.713 35H36.5874ZM20.1163 54.6943L26.47 46.6213L117.675 46.6213L123.913 54.6943H20.1163ZM18.9487 58.6943V116.165C18.9487 117.27 19.8441 118.165 20.9487 118.165H123.052C124.156 118.165 125.052 117.27 125.052 116.165V58.6943H18.9487ZM31.8725 33.2892C33.0102 31.8438 34.748 31 36.5874 31H107.713C109.571 31 111.324 31.861 112.461 33.3314L127.8 53.1819C128.611 54.2326 129.052 55.5228 129.052 56.8506V116.165C129.052 119.479 126.365 122.165 123.052 122.165H20.9487C17.635 122.165 14.9487 119.479 14.9487 116.165V56.8705C14.9487 55.5244 15.4013 54.2175 16.2338 53.1597L17.8054 54.3967L16.2338 53.1597L31.8725 33.2892Z",
        fill: (d = (u = r.semantic) == null ? void 0 : u.illustration) == null ? void 0 : d.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M58.3004 55.7491L62.1266 34.4574C62.4691 32.5517 64.1273 31.1649 66.0635 31.1649H77.6588C79.5763 31.1649 81.2241 32.5257 81.5866 34.4086L85.691 55.7253C85.739 55.9746 85.7631 56.2278 85.7631 56.4816V82.2165C85.7631 84.4256 83.9722 86.2165 81.7631 86.2165H62.2373C60.0282 86.2165 58.2373 84.4256 58.2373 82.2165V56.4566C58.2373 56.2194 58.2584 55.9826 58.3004 55.7491Z",
        fill: (m = (p = (h = r.semantic) == null ? void 0 : h.illustration) == null ? void 0 : p.brand) == null ? void 0 : m.primary
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M88.5155 35L53.6495 35L53.6495 31L88.5155 31L88.5155 35Z",
        fill: (v = (g = r.semantic) == null ? void 0 : g.illustration) == null ? void 0 : v.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
        fill: (x = (y = r.semantic) == null ? void 0 : y.illustration) == null ? void 0 : x.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30ZM112 32L105 32L105 28L112 28L112 21L116 21L116 28L123 28L123 32L116 32L116 39L112 39L112 32Z",
        fill: (S = (w = r.semantic) == null ? void 0 : w.illustration) == null ? void 0 : S.border
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M50 114C50 125.046 41.0457 134 30 134C18.9543 134 10 125.046 10 114C10 102.954 18.9543 94 30 94C41.0457 94 50 102.954 50 114Z",
        fill: (P = (M = r.semantic) == null ? void 0 : M.illustration) == null ? void 0 : P.background
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.9596 124.629C44.4731 121.803 46 118.08 46 114C46 105.163 38.8366 98 30 98C21.1634 98 14 105.163 14 114C14 118.214 15.6292 122.048 18.2921 124.905C20.7341 120.013 25.1519 116.746 30.1963 116.746C35.1452 116.746 39.4909 119.891 41.9596 124.629ZM38.8386 127.339C37.015 123.142 33.538 120.746 30.1963 120.746C26.8022 120.746 23.2683 123.218 21.4693 127.539C23.9385 129.098 26.8639 130 30 130C33.2675 130 36.3062 129.021 38.8386 127.339ZM30 134C41.0457 134 50 125.046 50 114C50 102.954 41.0457 94 30 94C18.9543 94 10 102.954 10 114C10 125.046 18.9543 134 30 134ZM29.9999 109.887C31.0635 109.887 31.9258 109.025 31.9258 107.961C31.9258 106.898 31.0635 106.035 29.9999 106.035C28.9362 106.035 28.0739 106.898 28.0739 107.961C28.0739 109.025 28.9362 109.887 29.9999 109.887ZM29.9999 113.887C33.2727 113.887 35.9258 111.234 35.9258 107.961C35.9258 104.689 33.2727 102.035 29.9999 102.035C26.7271 102.035 24.0739 104.689 24.0739 107.961C24.0739 111.234 26.7271 113.887 29.9999 113.887Z",
        fill: (I = (L = r.semantic) == null ? void 0 : L.illustration) == null ? void 0 : I.border
      }
    )
  ] });
}, illustrations = {
  "add-card": AddCard,
  "add-user": AddUser,
  bank: Bank,
  "bank-missing": BankMissing,
  "bank-success": BankSuccess,
  blocked: Blocked,
  celebration: Celebration,
  "customer-add": CustomerAdd,
  declined: Declined,
  expired: Expired,
  fast: Fast,
  "money-success": MoneySuccess,
  "network-download": NetworkDownload,
  "network-error": NetworkError,
  "new-email": NewEmail,
  "no-items": NoItems,
  "page-not-found": PageNotFound,
  "payment-request-link": PaymentRequestLink,
  "pay-zero": PayZero,
  pending: Pending,
  processing: Processing,
  sent: Sent,
  "small-business": SmallBusiness,
  success: Success,
  "sync-accounts": SyncAccounts,
  "sync-user": SyncUser,
  "tax-form": TaxForm,
  "vendor-add": VendorAdd
}, IllustrationsContext = React__default.createContext({}), IllustrationsProvider = ({ children: r, illustrations: a = {} }) => /* @__PURE__ */ jsx(IllustrationsContext.Provider, { value: lodashExports.merge(lodashExports.cloneDeep(illustrations), a), children: r }), LoaderContext = React__default.createContext({}), LoaderProvider = ({ children: r, loader: a }) => /* @__PURE__ */ jsx(LoaderContext.Provider, { value: a, children: r }), LogosContext = React__default.createContext({}), LogosProvider = ({ children: r, logos: a }) => /* @__PURE__ */ jsx(LogosContext.Provider, { value: a, children: r }), Box = forwardRef$1((r, a) => /* @__PURE__ */ jsx(Box$1, { "data-component": "Box", ...r, ref: a }));
Box.displayName = "Box";
const MelioWrapper = forwardRef$1((r, a) => /* @__PURE__ */ jsx("melio-wrapper", { children: /* @__PURE__ */ jsx(Box, { className: "melio-sdk-container", ...r, ref: a }) })), actionBarTheme = {
  baseStyle: {
    bar: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: { xs: "column", s: "row" },
      alignItems: { xs: "flex-start", s: "center" },
      gap: "xs",
      color: "semantic.text.inverse",
      minHeight: "40px"
    },
    itemLabel: {
      textStyle: "body2"
    },
    itemValue: {
      textStyle: "body2Semi"
    }
  }
}, applyToAllStates$2 = (r) => ({
  ...r,
  _hover: r,
  _focusVisible: r,
  _active: r
});
function getButtonVariants() {
  return {
    primary: {
      container: {
        backgroundColor: "semantic.action.primary.rest",
        color: "semantic.text.inverse",
        border: "none",
        _hover: {
          backgroundColor: "semantic.action.primary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.primary.pressed"
        },
        _loading: {
          backgroundColor: "semantic.action.primary.hover"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        '&[data-inverse="true"]': {
          _focusVisible: {
            outlineColor: "semantic.focus.inverse",
            outlineOffset: "2px",
            transition: "outline-color 0.2s"
          }
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.primary.disabled",
          color: "semantic.text.disabled"
        })
      }
    },
    "primary-inverse": {
      container: {
        backgroundColor: "semantic.action.inversePrimary.rest",
        color: "semantic.text.brand.rest",
        border: "none",
        _hover: {
          backgroundColor: "semantic.action.inversePrimary.hover",
          color: "semantic.text.brand.hover"
        },
        _active: {
          backgroundColor: "semantic.action.inversePrimary.pressed",
          color: "semantic.text.brand.pressed"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.inversePrimary.disabled",
          color: "semantic.text.disabled"
        })
      }
    },
    secondary: {
      container: {
        backgroundColor: "semantic.action.secondary.rest",
        color: "semantic.text.brand.rest",
        border: "basic.brand",
        borderColor: "semantic.border.brand",
        _hover: {
          backgroundColor: "semantic.action.secondary.hover",
          color: "semantic.text.brand.hover",
          borderColor: "semantic.border.brand"
        },
        _active: {
          backgroundColor: "semantic.action.secondary.pressed",
          color: "semantic.text.brand.pressed",
          borderColor: "semantic.border.brand"
        },
        _loading: {
          backgroundColor: "semantic.action.secondary.hover",
          color: "semantic.text.brand.hover",
          borderColor: "semantic.border.brand"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.secondary.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    },
    "secondary-inverse": {
      container: {
        backgroundColor: "semantic.action.inverseSecondary.rest",
        color: "semantic.text.inverse",
        border: "basic.white",
        borderColor: "semantic.border.inverse",
        _hover: {
          backgroundColor: "semantic.action.inverseSecondary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.inverseSecondary.pressed"
        },
        _loading: {
          backgroundColor: "semantic.action.inverseSecondary.hover"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.inverseSecondary.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    },
    tertiary: {
      container: {
        backgroundColor: "semantic.action.tertiary.rest",
        color: "semantic.text.primary",
        border: "basic.white",
        borderColor: "semantic.border.interactive.rest",
        _hover: {
          backgroundColor: "semantic.action.tertiary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.tertiary.pressed"
        },
        _loading: {
          backgroundColor: "semantic.action.tertiary.hover"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.primary.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    },
    success: {
      container: {
        backgroundColor: "semantic.action.success.rest",
        color: "semantic.text.inverse",
        _hover: {
          backgroundColor: "semantic.action.success.hover"
        },
        _active: {
          backgroundColor: "semantic.action.success.pressed"
        },
        _loading: {
          backgroundColor: "semantic.action.success.hover"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.success.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    },
    critical: {
      container: {
        backgroundColor: "semantic.action.criticalPrimary.rest",
        color: "semantic.text.inverse",
        border: "none",
        _hover: {
          backgroundColor: "semantic.action.criticalPrimary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.criticalPrimary.pressed"
        },
        _loading: {
          backgroundColor: "semantic.action.criticalPrimary.hover"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.criticalPrimary.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    },
    "critical-secondary": {
      container: {
        backgroundColor: "semantic.action.criticalSecondary.rest",
        color: "semantic.text.critical.rest",
        border: "basic.critical",
        borderColor: "semantic.border.critical",
        _hover: {
          backgroundColor: "semantic.action.criticalSecondary.hover",
          color: "semantic.text.critical.hover",
          borderColor: "semantic.border.critical"
        },
        _active: {
          backgroundColor: "semantic.action.criticalSecondary.pressed",
          color: "semantic.text.critical.pressed",
          borderColor: "semantic.border.critical"
        },
        _loading: {
          backgroundColor: "semantic.action.criticalSecondary.hover",
          color: "semantic.text.critical.hover",
          borderColor: "semantic.border.critical"
        },
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.criticalSecondary.disabled",
          color: "semantic.text.disabled",
          border: "none"
        })
      }
    }
  };
}
const buttonTheme = {
  baseStyle: ({ isLoading: r, isFullWidth: a }) => ({
    container: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      borderRadius: "semantic.action.medium",
      transitionProperty: "background-color,border-color,color",
      transitionDuration: "0.2s",
      width: a ? "100%" : "auto",
      outline: "transparent solid 2px",
      _loading: {
        pointerEvents: "none"
      },
      _disabled: {
        cursor: "not-allowed"
      }
    },
    label: {
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit",
      visibility: r ? "hidden" : "visible",
      whiteSpace: "nowrap"
    },
    loader: {
      display: "inline-flex",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)"
    }
  }),
  sizes: {
    small: ({ leftElement: r }) => ({
      container: {
        height: "32px",
        paddingInlineStart: r ? "xs" : "s",
        paddingInlineEnd: "s"
      },
      label: {
        minWidth: "64px"
      }
    }),
    medium: ({ leftElement: r }) => ({
      container: {
        height: "40px",
        paddingX: "s"
      },
      label: {
        minWidth: "72px",
        marginInlineEnd: r ? "xxs" : "none"
      }
    }),
    large: ({ leftElement: r }) => ({
      container: {
        height: "48px",
        paddingInlineStart: r ? "s" : "m",
        paddingInlineEnd: "m"
      },
      label: {
        minWidth: "72px",
        marginInlineStart: r ? "xxs" : "none"
      }
    })
  },
  variants: getButtonVariants()
}, floatingButtonTheme = {
  baseStyle: {
    transitionProperty: "background-color,border-color,color",
    transitionDuration: "0.2s",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    outline: "2px solid transparent",
    borderRadius: "semantic.action.medium",
    height: "48px",
    width: "48px",
    padding: "s",
    backgroundColor: "semantic.action.primary.rest",
    color: "semantic.text.inverse",
    position: "absolute",
    bottom: "s",
    right: "s",
    _active: {
      backgroundColor: "semantic.action.primary.pressed"
    },
    _disabled: applyToAllStates$2({
      cursor: "not-allowed",
      backgroundColor: "semantic.action.primary.disabled",
      color: "semantic.text.disabled"
    }),
    _focusVisible: {
      outlineColor: "semantic.focus.primary",
      outlineOffset: "2px",
      transition: "outline-color 0.2s"
    }
  }
}, iconButtonTheme = {
  baseStyle: ({ badge: r }) => ({
    container: {
      flexShrink: 0,
      position: r ? "relative" : "unset",
      transitionProperty: "background-color,border-color,color",
      transitionDuration: "0.2s",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      outline: "2px solid transparent",
      _disabled: {
        cursor: "not-allowed"
      },
      // 24px target size
      // https://www.w3.org/WAI/WCAG22/Understanding/target-size-minimum.html
      width: "24px",
      height: "24px"
    },
    badge: {
      display: "inline-flex",
      borderRadius: "global.full",
      border: "selection.transparent",
      borderColor: "semantic.border.inverse",
      position: "absolute",
      bottom: "-2px",
      right: "-2px",
      backgroundColor: "semantic.fill.primary",
      zIndex: 1
    }
  }),
  sizes: {
    small: {
      container: {
        height: "24px",
        width: "24px"
      }
    },
    medium: {
      container: {
        height: "32px",
        width: "32px"
      }
    },
    large: {
      container: {
        height: "40px",
        width: "40px"
      }
    }
  },
  variants: {
    primary: {
      container: {
        borderRadius: "semantic.action.medium",
        padding: "xs",
        border: "basic.black",
        backgroundColor: "semantic.action.tertiary.rest",
        color: "semantic.icon.primary",
        borderColor: "semantic.border.interactive.rest",
        _hover: {
          backgroundColor: "semantic.action.tertiary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.tertiary.pressed"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.tertiary.disabled",
          color: "semantic.icon.disabled",
          border: "none"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        }
      }
    },
    naked: {
      container: {
        color: "semantic.icon.primary",
        backgroundColor: "semantic.action.tertiary.rest",
        borderRadius: "semantic.action.medium",
        _hover: {
          backgroundColor: "semantic.action.tertiary.hover",
          color: "semantic.icon.primary"
        },
        _active: {
          backgroundColor: "semantic.action.tertiary.pressed",
          color: "semantic.icon.primary"
        },
        _disabled: applyToAllStates$2({
          color: "semantic.icon.disabled",
          backgroundColor: "semantic.action.tertiary.rest",
          border: "none"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.primary",
          transition: "outline-color 0.2s"
        }
      }
    },
    primaryInverse: {
      container: {
        borderRadius: "semantic.action.medium",
        padding: "xs",
        border: "basic.white",
        borderColor: "semantic.border.inverse",
        backgroundColor: "semantic.action.inverseTertiary.rest",
        color: "semantic.text.inverse",
        _hover: {
          backgroundColor: "semantic.action.inverseTertiary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.inverseTertiary.pressed"
        },
        _disabled: applyToAllStates$2({
          backgroundColor: "semantic.action.inverseTertiary.disabled",
          color: "semantic.icon.disabled",
          borderColor: "semantic.border.inverse"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        }
      }
    },
    nakedInverse: {
      container: {
        color: "semantic.text.inverse",
        backgroundColor: "semantic.action.inverseTertiary.rest",
        borderRadius: "semantic.action.medium",
        _hover: {
          backgroundColor: "semantic.action.inverseTertiary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.inverseTertiary.pressed"
        },
        _disabled: applyToAllStates$2({
          color: "semantic.icon.inverseDisabled",
          backgroundColor: "semantic.action.inverseTertiary.rest"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          transition: "outline-color 0.2s"
        }
      }
    },
    brand: {
      container: {
        borderRadius: "semantic.action.medium",
        padding: "xs",
        backgroundColor: "semantic.action.primary.rest",
        color: "semantic.text.inverse",
        _hover: {
          backgroundColor: "semantic.action.primary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.primary.pressed"
        },
        _disabled: applyToAllStates$2({
          color: "semantic.icon.disabled",
          backgroundColor: "semantic.action.tertiary.disabled"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          outlineOffset: "2px",
          transition: "outline-color 0.2s"
        }
      }
    },
    brandInverse: {
      container: {
        color: "semantic.text.inverse",
        borderRadius: "semantic.action.medium",
        _hover: {
          backgroundColor: "semantic.action.inverseTertiary.hover"
        },
        _active: {
          backgroundColor: "semantic.action.inverseTertiary.pressed"
        },
        _disabled: applyToAllStates$2({
          color: "semantic.icon.disabled",
          backgroundColor: "semantic.action.tertiary.disabled"
        }),
        _focusVisible: {
          outlineColor: "semantic.focus.inverse",
          transition: "outline-color 0.2s"
        }
      }
    }
  }
}, interactiveButtonTheme = {
  baseStyle: {
    container: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "xs",
      backgroundColor: "semantic.action.primary.rest",
      borderRadius: "semantic.action.medium",
      paddingX: "12px",
      maxWidth: "40px",
      height: "40px",
      overflow: "hidden",
      transition: "max-width 0.2s ease-in-out, padding 0.2s ease-in-out, outline-color 0.2s",
      outlineColor: "transparent",
      _hover: {
        backgroundColor: "semantic.action.primary.hover",
        paddingInlineEnd: "s",
        minWidth: "40px",
        maxWidth: "488px",
        svg: {
          transform: "rotate(-180deg)",
          transition: "transform 0.2s ease-out 0.1s"
        }
      },
      _active: {
        backgroundColor: "semantic.action.primary.pressed"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineWidth: "2px",
        outlineOffset: "2px",
        outlineStyle: "solid"
      }
    },
    text: {
      color: "semantic.text.inverse",
      textStyle: "body3Semi",
      overflow: "hidden",
      marginInlineEnd: "xxs",
      whiteSpace: "nowrap"
    }
  }
}, colorComponentTokenByVariantAndState = {
  primary: {
    rest: "component.button.textPrimary.rest.label",
    hover: "component.button.textPrimary.hover.label",
    pressed: "component.button.textPrimary.pressed.label",
    disabled: "component.button.textPrimary.disabled.label"
  },
  secondary: {
    rest: "component.button.textSecondary.rest.label",
    hover: "component.button.textSecondary.hover.label",
    pressed: "component.button.textSecondary.pressed.label",
    disabled: "component.button.textSecondary.disabled.label"
  },
  critical: {
    rest: "component.button.textCritical.rest.label",
    hover: "component.button.textCritical.hover.label",
    pressed: "component.button.textCritical.pressed.label",
    disabled: "component.button.textCritical.disabled.label"
  },
  invert: {
    rest: "component.button.textInverse.rest.label",
    hover: "component.button.textInverse.hover.label",
    pressed: "component.button.textInverse.pressed.label",
    disabled: "component.button.textInverse.disabled.label"
  }
}, getColorComponentToken = (r, a) => r ? colorComponentTokenByVariantAndState[r][a] ?? colorComponentTokenByVariantAndState.primary.rest : colorComponentTokenByVariantAndState.primary[a], secondaryTextStyles = {
  small: "body4Semi",
  medium: "body3Semi",
  large: "body2Semi"
}, nakedButtonTheme = {
  baseStyle: ({ shouldSupportEllipsis: r }) => ({
    ...r && {
      display: "inline-block",
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    transitionProperty: "color",
    transitionDuration: "0.2s",
    outline: "2px solid transparent",
    borderRadius: "global.100",
    _hover: {
      textDecoration: "underline"
    },
    _active: {
      textDecoration: "underline"
    },
    _disabled: {
      textDecoration: "none",
      cursor: "not-allowed"
    }
  }),
  sizes: {
    medium: {
      textStyle: "body3Semi"
    },
    large: {
      textStyle: "body2Semi"
    }
  },
  variants: {
    primary: ({ theme: r }) => ({
      color: getColorComponentToken("primary", "rest"),
      _hover: {
        color: getColorComponentToken("primary", "hover")
      },
      _active: {
        color: getColorComponentToken("primary", "pressed")
      },
      _disabled: applyToAllStates$2({
        color: getColorComponentToken("primary", "disabled")
      }),
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: r.space.xxs,
        transition: "outline-color 0.2s"
      }
    }),
    secondary: ({ size: r, theme: a }) => ({
      color: getColorComponentToken("secondary", "rest"),
      textStyle: r && secondaryTextStyles[r],
      _hover: {
        color: getColorComponentToken("secondary", "hover")
      },
      _active: {
        color: getColorComponentToken("secondary", "pressed")
      },
      _disabled: applyToAllStates$2({
        color: getColorComponentToken("secondary", "disabled")
      }),
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: a.space.xxs,
        transition: "outline-color 0.2s"
      }
    }),
    invert: ({ theme: r }) => ({
      color: getColorComponentToken("invert", "rest"),
      _hover: {
        color: getColorComponentToken("invert", "hover")
      },
      _active: {
        color: getColorComponentToken("invert", "pressed")
      },
      _disabled: applyToAllStates$2({
        color: getColorComponentToken("invert", "disabled")
      }),
      _focusVisible: {
        outlineColor: "semantic.focus.inverse",
        outlineOffset: r.space.xxs,
        transition: "outline-color 0.2s"
      }
    }),
    critical: ({ theme: r }) => ({
      color: getColorComponentToken("critical", "rest"),
      _hover: {
        color: getColorComponentToken("critical", "hover")
      },
      _active: {
        color: getColorComponentToken("critical", "pressed")
      },
      _disabled: applyToAllStates$2({
        color: getColorComponentToken("critical", "disabled")
      }),
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: r.space.xxs,
        transition: "outline-color 0.2s"
      }
    })
  }
}, BackgroundStyle$6 = {
  default: "semantic.fill.secondary",
  avatar1: "semantic.fill.decorative.1",
  avatar2: "semantic.fill.decorative.2",
  avatar3: "semantic.fill.decorative.3",
  avatar4: "semantic.fill.decorative.4",
  avatar5: "semantic.fill.decorative.5",
  avatar6: "semantic.fill.inverse"
}, avatarTheme = {
  baseStyle: ({ onClick: r, isDisabled: a, bgColor: s }) => ({
    container: {
      display: "inline-flex",
      position: "relative",
      width: "fit-content",
      height: "fit-content"
    },
    avatar: {
      overflow: "hidden",
      display: "inline-flex",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      border: "basic.light",
      width: "100%",
      height: "auto",
      backgroundColor: BackgroundStyle$6[s ?? "default"],
      color: s === "avatar6" ? "semantic.text.inverse" : "semantic.text.primary",
      userSelect: "none",
      _after: {
        content: "''",
        width: "100%",
        height: "100%",
        backgroundColor: "semantic.fill.inverse",
        opacity: "0",
        position: "absolute",
        top: "0px",
        left: "0px",
        transition: "opacity 0.3s ease"
      },
      _hover: {
        _after: {
          opacity: r && !a ? "0.35" : "0"
        }
      },
      _disabled: {
        backgroundColor: "semantic.fill.disabled",
        border: "none",
        color: "semantic.text.disabled",
        cursor: "not-allowed"
      },
      _selected: {
        outline: "2px solid",
        outlineColor: "semantic.border.interactive.selected",
        outlineOffset: "2px"
      }
    },
    image: {
      // So the image and the initials won't co-exist side-by-side for the flicker of time
      position: "absolute"
    },
    initials: {},
    badge: {
      display: "inline-flex",
      borderRadius: "global.full",
      border: "selection.selectedNeutral",
      borderColor: "semantic.border.inverse",
      backgroundColor: "semantic.fill.primary",
      zIndex: 1,
      overflow: "hidden"
    }
  }),
  variants: {
    circle: {
      avatar: {
        borderRadius: "global.full",
        _after: {
          borderRadius: "global.full"
        }
      }
    },
    square: {
      avatar: {
        borderRadius: "global.100",
        _after: {
          borderRadius: "global.100"
        }
      }
    }
  },
  sizes: {
    "extra-small": {
      avatar: {
        width: "16px",
        height: "16px"
      },
      initials: {
        textStyle: "caption1Semi"
      }
    },
    small: {
      avatar: {
        width: "24px",
        height: "24px"
      },
      initials: {
        textStyle: "caption1Semi"
      }
    },
    medium: {
      avatar: {
        width: "40px",
        height: "40px"
      },
      initials: {
        textStyle: "body4Semi"
      }
    },
    large: {
      avatar: {
        width: "56px",
        height: "56px"
      },
      initials: {
        textStyle: "body2Semi"
      }
    },
    "extra-large": {
      avatar: {
        width: "120px",
        height: "120px"
      },
      initials: {
        textStyle: "body1Semi"
      }
    }
  }
}, avatarGroupTheme = {
  baseStyle: ({ isLast: r }) => ({
    container: {
      display: "flex",
      position: "relative"
    },
    avatar: {
      display: "inline-flex",
      marginRight: r ? "none" : "-4px",
      borderRadius: "global.full",
      border: "basic.light",
      borderColor: "semantic.border.static",
      cursor: "pointer"
    },
    description: {
      display: "inline-flex",
      marginLeft: "xxxs",
      alignItems: "center",
      color: "semantic.text.secondary",
      textStyle: "body4Semi",
      cursor: "pointer"
    }
  })
}, avatarWithDetailsTheme = {
  baseStyle: ({ isAvatarHover: r, isSelected: a }) => ({
    container: {
      display: "flex",
      alignItems: "center",
      gap: "s",
      height: "44px"
    },
    avatarContainer: {
      position: "relative",
      _disabled: {
        pointerEvents: "none"
      }
    },
    avatar: {
      opacity: r || a ? "0" : "1",
      transition: "opacity 0.2s ease"
    },
    checkbox: {
      position: "absolute",
      inset: "0",
      display: "flex",
      width: "100%",
      height: "auto",
      justifyContent: "center",
      alignItems: "center",
      opacity: r || a ? "1" : "0",
      transition: "opacity 0.2s ease"
    }
  })
}, getPositionStyle = (r) => r ? {
  top: r.includes("top") ? "-2px" : void 0,
  bottom: r.includes("bottom") ? "-2px" : void 0,
  left: r.includes("left") ? "-2px" : void 0,
  right: r.includes("right") ? "-2px" : void 0
} : { bottom: "-2px", right: "-2px" }, badgeTheme = {
  baseStyle: ({ placement: r, customPositions: a }) => ({
    wrapper: {
      position: "relative",
      display: "inline-flex"
    },
    mark: {
      position: "absolute",
      display: "inline-flex",
      ...getPositionStyle(r),
      ...a
    }
  })
}, brandTheme = {
  baseStyle: {
    display: "inline-flex",
    height: "24px",
    width: "fit-content",
    justifyContent: "center"
  }
}, brandSymbolTheme = {
  baseStyle: {
    display: "inline-flex",
    _readOnly: {
      opacity: "0.65"
    },
    _disabled: {
      opacity: "0.35"
    }
  },
  sizes: {
    "extra-small": {
      width: iconSizeMapping["extra-small"],
      height: iconSizeMapping["extra-small"]
    },
    small: {
      width: iconSizeMapping.small,
      height: iconSizeMapping.small
    },
    medium: {
      width: iconSizeMapping.medium,
      height: iconSizeMapping.medium
    },
    "extra-large": {
      width: iconSizeMapping["extra-large"],
      height: iconSizeMapping["extra-large"]
    }
  }
}, BackgroundStyle$5 = {
  warning: "semantic.fill.warning.primary",
  critical: "semantic.fill.critical.primary",
  success: "semantic.fill.success.primary",
  neutral: "semantic.fill.inverse",
  brand: "semantic.fill.brand.primary",
  informative: "semantic.fill.informative.primary"
}, counterTheme = {
  baseStyle: ({ status: r, isFixedSize: a }) => ({
    paddingX: a ? "none" : "xxs",
    textStyle: "caption2Semi",
    display: "inline-flex",
    minWidth: "16px",
    height: "16px",
    borderRadius: "global.full",
    backgroundColor: BackgroundStyle$5[r],
    color: r === "warning" ? "semantic.text.primary" : "semantic.text.inverse",
    width: "fit-content",
    alignItems: "center",
    justifyContent: "center"
  })
}, currencyTheme = {
  baseStyle: {
    container: {
      display: "flex",
      alignItems: "flex-start"
    },
    integer: {
      display: "inline-flex"
    },
    currency: {
      display: "inline-flex"
    },
    fraction: {
      display: "inline-flex",
      marginLeft: "xxxs"
    }
  },
  sizes: {
    small: {
      integer: {
        textStyle: "heading2Semi"
      },
      currency: {
        textStyle: "heading2Semi",
        display: "inline-flex"
      },
      fraction: {
        textStyle: "body4Semi",
        marginLeft: "xxxs",
        lineHeight: "22px"
      }
    },
    large: {
      integer: {
        textStyle: "heading1Semi"
      },
      currency: {
        textStyle: "heading1Semi"
      },
      fraction: {
        textStyle: "body2Semi",
        marginLeft: "xxxs",
        lineHeight: "30px"
      }
    }
  },
  variants: {
    default: {
      container: {
        color: "semantic.text.primary"
      }
    },
    inverse: {
      container: {
        color: "semantic.text.inverse"
      }
    }
  }
}, dividerTheme = {
  baseStyle: {
    container: {
      display: "flex",
      alignItems: "center"
    },
    line: {
      flex: 1,
      backgroundColor: "semantic.border.static"
    },
    text: {
      paddingLeft: "s",
      paddingRight: "s",
      color: "semantic.text.primary",
      textStyle: "body3"
    }
  },
  variants: {
    vertical: {
      container: {
        flexDirection: "column",
        height: "100%",
        width: "auto"
      },
      line: {
        width: "1px"
      }
    },
    horizontal: {
      container: {
        flexDirection: "row",
        width: "100%"
      },
      line: {
        height: "1px"
      }
    }
  }
}, flagIconTheme = {
  baseStyle: {
    display: "inline-flex",
    // This makes sure the icon is vertically aligned to the text next to it.
    verticalAlign: "text-bottom",
    _disabled: {
      opacity: "0.35"
    }
  }
}, sectionBannerTheme = {
  baseStyle: ({ isCompact: r }) => ({
    container: {
      display: "flex",
      borderRadius: "global.200",
      gap: "s",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
      height: "fit-content",
      border: "surface.transparent",
      paddingX: "xs-s",
      paddingY: r ? "xs" : "xs-s"
    },
    defaultIcon: {
      display: "inline-flex",
      paddingTop: r ? "xxxs" : "none"
    },
    textWrapper: {
      display: "inline-flex",
      wordBreak: "break-word",
      maxWidth: "920px",
      paddingY: r ? "none" : "xxxs"
    }
  }),
  variants: {
    neutral: {
      container: {
        backgroundColor: "semantic.fill.secondary"
      }
    },
    warning: {
      container: {
        backgroundColor: "semantic.fill.warning.secondary"
      }
    },
    success: {
      container: {
        backgroundColor: "semantic.fill.success.secondary"
      }
    },
    critical: {
      container: {
        backgroundColor: "semantic.fill.critical.secondary"
      }
    },
    informative: {
      container: {
        backgroundColor: "semantic.fill.informative.secondary"
      }
    },
    brand: {
      container: {
        backgroundColor: "semantic.fill.brand.secondary"
      }
    },
    secondary: {
      container: {
        backgroundColor: "transparent",
        border: "basic.light",
        borderColor: "semantic.border.static"
      }
    }
  }
}, BackgroundStyle$4 = {
  neutral: "semantic.fill.secondary",
  informative: "semantic.fill.informative.secondary",
  warning: "semantic.fill.warning.secondary",
  critical: "semantic.fill.critical.secondary",
  success: "semantic.fill.success.secondary"
}, getVariant = (r) => ({
  container: {
    bgColor: BackgroundStyle$4[r],
    color: "semantic.text.primary"
  }
}), statusBarTheme = {
  baseStyle: {
    container: {
      borderTopRadius: "l",
      display: "flex",
      py: "m",
      px: "l",
      gridGap: "m"
    },
    content: {
      textStyle: "body3Semi",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1
    },
    icon: {
      display: "flex"
    }
  },
  variants: {
    informative: getVariant("informative"),
    success: getVariant("success"),
    warning: getVariant("warning"),
    critical: getVariant("critical"),
    neutral: getVariant("neutral")
  }
}, BackgroundStyle$3 = {
  brand: "semantic.fill.brand.primary",
  critical: "semantic.fill.critical.primary",
  warning: "semantic.fill.warning.primary",
  success: "semantic.fill.success.primary",
  informative: "semantic.fill.informative.primary",
  neutral: "semantic.fill.inverse",
  secondary: "semantic.fill.primary"
}, getStatusIndicatorStyles = (r, a) => {
  const s = r === "secondary";
  return { backgroundColor: s ? "semantic.icon.inverse" : BackgroundStyle$3[r], border: s ? "input-thick.readOnly" : a ? "2px solid #fff" : "none", borderColor: s ? "semantic.icon.primary" : a ? "semantic.icon.inverse" : void 0 };
}, getDisabledStatusIndicatorStyles = (r, a) => {
  const s = r === "secondary";
  return { backgroundColor: s ? "semantic.icon.inverse" : "semantic.icon.disabled", border: s ? "input-thick.disabled" : a ? "2px solid #fff" : "none", borderColor: s ? "semantic.icon.disabled" : a ? "semantic.icon.inverse" : void 0 };
}, statusIndicatorTheme = {
  baseStyle: ({ status: r, hasChildren: a }) => ({
    container: {
      display: "flex",
      position: "relative",
      width: "fit-content"
    },
    indicator: {
      position: a ? "absolute" : "relative",
      top: a ? "-2px" : "0",
      right: a ? "-2px" : "0",
      pointerEvents: a ? "none" : "all",
      boxSizing: r === "secondary" ? "border-box" : "content-box",
      display: "inline-flex",
      height: "8px",
      width: "8px",
      borderRadius: "global.full",
      zIndex: 1,
      ...getStatusIndicatorStyles(r, a),
      _disabled: {
        ...getDisabledStatusIndicatorStyles(r, a),
        display: a ? "none" : "inline-flex"
      },
      _readOnly: {
        backgroundColor: r === "secondary" ? "semantic.icon.inverse" : "semantic.icon.readOnly",
        borderColor: r === "secondary" ? "semantic.icon.readOnly" : void 0
      }
    }
  })
}, textTheme = {
  baseStyle: ({ color: r, textStyle: a, shouldSupportEllipsis: s }) => ({
    color: r,
    textStyle: a,
    ...s && {
      display: "inline-block",
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  })
}, tooltipTheme = {
  baseStyle: ({ position: r, top: a, left: s }) => ({
    trigger: {
      display: "inline-flex",
      maxWidth: "100%",
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "2px"
      }
    },
    content: {
      position: r,
      top: `${a ?? 0}px`,
      left: `${s ?? 0}px`,
      backgroundColor: "semantic.fill.inverse",
      color: "semantic.text.inverse",
      border: "none",
      borderRadius: "global.200",
      paddingX: "s",
      paddingY: "xs",
      textStyle: "body4",
      width: "max-content",
      maxWidth: "296px",
      textAlign: "start",
      zIndex: "tooltip",
      boxShadow: 0,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      _focus: {
        boxShadow: 0
      }
    }
  })
}, fadeStyle$2 = { position: "absolute", zIndex: zIndices.tooltip }, beaconTheme = {
  baseStyle: {
    // This wrapper is to prevent the beacon animation from affecting the popover position.
    beaconWrapper: {
      width: "24px",
      height: "24px",
      // Resets the button styles.
      padding: "none",
      border: "none",
      backgroundColor: "transparent",
      outline: "none"
    },
    beacon: {
      backgroundColor: "global.brand.200",
      height: "24px",
      width: "24px",
      borderRadius: "global.full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    beaconDot: {
      bgColor: "semantic.icon.brand",
      height: "8px",
      width: "8px",
      borderRadius: "global.full"
    }
  }
}, trackerTheme = {
  baseStyle: {
    display: "flex",
    flexWrap: "wrap"
  },
  variants: {
    horizontal: {
      flexDirection: "row"
    },
    vertical: {
      flexDirection: "column"
    }
  }
}, backgroundColor = {
  warning: "semantic.fill.warning.primary",
  critical: "semantic.fill.critical.primary",
  success: "semantic.fill.success.primary",
  neutral: "semantic.fill.inverse",
  brand: "semantic.fill.brand.primary",
  informative: "semantic.fill.informative.primary"
}, indicatorContainerSize = 24, indicatorContainerHalfSize = indicatorContainerSize / 2, connectorThickness = 2, borderThickness = 2, borderThicknessHalf = borderThickness / 2, verticalPadding = themeSpaces.s, horizontalStyles = {
  gridTemplateAreas: `"indicator"
    "content"`,
  gridTemplateRows: `${textStyles.body3Semi.lineHeight.xs} auto auto`,
  alignItems: "center",
  gridRowGap: "s"
}, verticalStyles = {
  gridTemplateAreas: `"indicator content"
  ". content"`,
  gridTemplateColumns: `${textStyles.body3Semi.lineHeight.xs} auto`,
  alignItems: "flex-start",
  gridColumnGap: "s",
  width: "100%"
}, trackerStepTheme = {
  baseStyle: ({ width: r, stepMaxWidth: a, status: s }) => ({
    stepContainer: {
      width: r === "full" ? a : "fit-content",
      maxWidth: a,
      display: "flex",
      flexDirection: "column",
      position: "relative"
    },
    grid: {
      display: "grid"
    },
    connector: {
      position: "absolute",
      backgroundColor: "semantic.fill.tertiary",
      "&[data-is-completed]": {
        backgroundColor: backgroundColor[s]
      },
      "&[data-is-last]": {
        display: "none"
      }
    },
    stepIndicatorContainer: {
      display: "inline-flex",
      gridArea: "indicator",
      justifySelf: "center",
      alignSelf: "center",
      zIndex: 1
    },
    stepIndicator: {
      display: "flex",
      width: "20px",
      height: "20px",
      borderRadius: "global.full",
      backgroundColor: "semantic.icon.disabled",
      color: s === "warning" ? "semantic.text.primary" : "semantic.text.inverse",
      justifyContent: "center",
      alignItems: "center",
      border: `${borderThickness}px solid`,
      borderColor: "semantic.border.inverse",
      boxSizing: "content-box",
      "&[data-is-completed], &[data-is-active]": {
        backgroundColor: backgroundColor[s]
      }
    },
    content: {
      gridArea: "content",
      display: "flex",
      flex: 1,
      width: "fit-content",
      flexDirection: "column",
      alignItems: "center",
      gap: "xxs",
      paddingX: "xxs",
      maxWidth: "100%",
      "&[data-is-first]": {
        paddingLeft: "none"
      },
      "&[data-is-last]": {
        paddingRight: "none"
      }
    }
  }),
  variants: {
    horizontal: ({ status: r }) => ({
      stepContainer: {
        alignItems: "center"
      },
      grid: horizontalStyles,
      connector: {
        height: `${connectorThickness}px`,
        top: `calc(${indicatorContainerHalfSize}px - ${connectorThickness}px)`,
        width: "100%",
        left: "50%",
        "&[data-is-active]": {
          bgGradient: `linear(to right, ${backgroundColor[r]}, semantic.fill.tertiary 66%)`
        }
      },
      content: {
        textAlign: "center"
      }
    }),
    vertical: ({ stepMaxWidth: r, status: a }) => ({
      stepContainer: {
        alignItems: "flex-start",
        paddingTop: "s",
        paddingBottom: "s",
        maxWidth: r,
        "&[data-is-first]": {
          paddingTop: "none"
        },
        "&[data-is-last]": {
          paddingBottom: "none"
        },
        "&[data-is-single]": {
          paddingTop: "none",
          paddingBottom: "none"
        }
      },
      grid: verticalStyles,
      connector: {
        height: "100%",
        top: `calc(${indicatorContainerHalfSize}px + ${verticalPadding})`,
        width: `${connectorThickness}px`,
        left: `calc(${indicatorContainerHalfSize}px - ${connectorThickness}px - ${borderThicknessHalf}px)`,
        "&[data-is-active]": {
          bgGradient: `linear(to bottom, ${backgroundColor[a]}, semantic.fill.tertiary 66%)`
        },
        "&[data-is-first]": {
          top: verticalPadding
        }
      },
      stepIndicator: {
        display: "inline-flex"
      },
      content: {
        alignItems: "flex-start",
        gap: "xxxs",
        width: "100%",
        paddingX: "none",
        marginTop: "xxxs",
        textAlign: "left",
        "&[data-is-last]": {
          paddingBottom: "none"
        }
      }
    })
  }
}, _descriptionTheme = {
  baseStyle: {
    textStyle: "body3",
    color: "semantic.text.secondary",
    _invalid: {
      color: "semantic.text.critical.rest"
    },
    _readOnly: {
      color: "semantic.text.secondary"
    },
    _disabled: {
      color: "semantic.text.disabled"
    }
  }
}, _labelTheme = {
  baseStyle: ({ labelShouldSupportEllipsis: r, descriptionShouldSupportEllipsis: a }) => ({
    container: {
      maxWidth: "100%",
      display: "flex"
    },
    label: {
      textStyle: "body4Semi",
      color: "semantic.text.secondary",
      _invalid: {
        color: "semantic.text.critical.rest"
      },
      '&[data-view-mode="true"]': {
        pointerEvents: "none"
      },
      _disabled: {
        color: "semantic.text.disabled"
      },
      ...r && {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    description: {
      marginStart: "xxs",
      textStyle: "body4",
      color: "semantic.text.secondary",
      ...a && {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      _invalid: {
        color: "semantic.text.critical.rest"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    },
    iconIndicator: {
      display: "inline-flex",
      color: "semantic.text.secondary",
      _disabled: {
        color: "semantic.text.disabled"
      }
    }
  })
}, _mainLabelTheme = {
  baseStyle: {
    label: {
      display: "contents",
      color: "semantic.text.primary",
      _readOnly: {
        color: "semantic.text.secondary",
        cursor: "default"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    },
    placeholder: {
      textStyle: "body2",
      display: "contents",
      color: "semantic.text.secondary"
    },
    secondaryLabel: {
      textStyle: "body2",
      color: "semantic.text.primary",
      _readOnly: {
        color: "semantic.text.secondary",
        cursor: "default"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    },
    iconIndicator: {
      display: "inline-flex",
      color: "semantic.text.primary",
      _readOnly: {
        color: "semantic.text.secondary",
        cursor: "default"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    }
  },
  variants: {
    default: ({ size: r }) => ({
      label: {
        textStyle: r === "small" ? "body3" : "body2"
      }
    }),
    bold: ({ size: r }) => ({
      label: {
        textStyle: r === "small" ? "body3Semi" : "body2Semi"
      }
    })
  }
}, _paragraphTheme = {
  baseStyle: () => ({
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "xxs",
      width: "100%"
    },
    title: {},
    content: {}
  }),
  sizes: {
    large: {
      title: {
        textStyle: "body2Semi"
      },
      content: {
        textStyle: "body2"
      }
    },
    small: {
      title: {
        textStyle: "body3Semi"
      },
      content: {
        textStyle: "body3"
      }
    }
  }
}, _paragraphListTheme = {
  baseStyle: ({ icon: r, type: a }) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    },
    bulletWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _after: {
        content: '"•"',
        fontSize: "15px"
      }
    },
    number: {
      wordBreak: "keep-all"
    },
    listItem: {
      listStyleType: "none",
      display: "flex",
      alignItems: a === "unordered" && !r ? "baseline" : void 0
    }
  }),
  sizes: {
    large: ({ icon: r, type: a }) => ({
      container: {
        gap: a === "unordered" && !r ? "xxs" : "m"
      },
      bulletWrapper: {
        height: "24px",
        width: "24px"
      },
      number: {
        textStyle: "body2Semi"
      },
      listItem: {
        gap: r ? "s" : "xxs"
      }
    }),
    small: ({ icon: r, type: a }) => ({
      container: {
        gap: a === "unordered" && !r ? "xxxs" : "s"
      },
      bulletWrapper: {
        height: "20px",
        width: "20px"
      },
      number: {
        textStyle: "body3Semi"
      },
      listItem: {
        gap: r ? "s" : "xxs"
      }
    })
  }
}, _sectionLabelTheme = {
  baseStyle: {
    display: "flex",
    gap: "xs",
    alignItems: "center",
    textStyle: "body3Semi",
    color: "semantic.text.secondary"
  }
}, virtualCardTheme = {
  baseStyle: {
    brand: {
      display: "inline-flex",
      width: "80px",
      justifyContent: "flex-end",
      // Override internal styles to avoid making adjustments to global components, which could potentially lead to UI changes.
      "> *": {
        maxWidth: "100%"
      },
      '[role="img"]': {
        maxWidth: "100%"
      }
    }
  }
}, blanketTheme = {
  baseStyle: {
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _before: {
        content: "''",
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 0,
        opacity: 0,
        transition: "opacity 0.25s"
      }
    },
    icon: {
      display: "inline-flex",
      position: "relative",
      zIndex: 1
    }
  },
  variants: {
    light: {
      container: {
        _before: {
          backgroundColor: "semantic.surface.primary.rest",
          opacity: 0.6
        }
      }
    },
    dark: ({ isLoading: r, isFullScreen: a }) => ({
      container: {
        cursor: r || a ? "default" : "pointer",
        _before: {
          backgroundColor: "semantic.surface.inverse",
          opacity: 0.35
        },
        _active: {
          _before: {
            opacity: r || a ? 0.35 : 0.6
          }
        }
      }
    }),
    darker: {
      container: {
        _before: {
          backgroundColor: "semantic.surface.inverse",
          opacity: 0.6
        }
      }
    }
  }
}, circularProgressTheme = {
  baseStyle: ({ strokeDasharray: r }) => ({
    container: {
      width: "24px",
      height: "24px",
      display: "inline-flex"
    },
    circle: {
      stroke: "semantic.border.static",
      fill: "transparent",
      strokeWidth: "10px"
    },
    track: {
      stroke: "semantic.fill.brand.primary",
      strokeWidth: "10px",
      fill: "transparent",
      opacity: 1,
      strokeDashoffset: 66,
      strokeDasharray: r,
      transitionProperty: "stroke-dasharray, stroke",
      transitionDuration: "0.6s",
      transitionTimingFunction: "ease",
      '&[data-progress="0"]': {
        opacity: 0
      }
    }
  })
}, linearProgressTheme = {
  baseStyle: ({ percentage: r, isFullWidth: a }) => ({
    container: {
      backgroundColor: "semantic.fill.tertiary",
      overflow: "hidden",
      width: "100%",
      maxWidth: a ? "100%" : "120px",
      height: "8px",
      borderRadius: "global.100"
    },
    track: {
      backgroundColor: "semantic.fill.brand.primary",
      width: `${r}%`,
      height: "100%",
      transition: "width 0.6s ease"
    }
  })
}, skeletonTheme = {
  baseStyle: {
    borderRadius: "global.full",
    backgroundColor: "global.neutral.600"
  }
}, skeletonCircleTheme = {
  baseStyle: {
    borderRadius: "global.full",
    backgroundColor: "global.neutral.600"
  }
}, skeletonTextTheme = {
  baseStyle: {
    borderColor: "global.neutral.600"
  }
}, BackgroundStyle$2 = {
  success: "semantic.fill.success.primary",
  error: "semantic.fill.critical.primary",
  informative: "semantic.fill.inverse"
}, toastTheme = {
  baseStyle: ({ type: r, isMobile: a }) => ({
    container: {
      minWidth: "auto",
      marginTop: a ? themeSpaces.m : themeSpaces.xl,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0
    },
    toast: {
      display: "flex",
      alignItems: "center",
      justifyContent: a ? "space-between" : "center",
      gap: "s",
      borderRadius: "semantic.container.small",
      height: "48px",
      width: a ? `calc(100vw - ${themeSpaces.s} * 2)` : "max-content",
      maxWidth: "480px",
      boxShadow: 500,
      paddingX: "s",
      color: "semantic.text.inverse",
      bgColor: BackgroundStyle$2[r]
    },
    content: {
      flexGrow: 1,
      textStyle: "body3",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  })
}, PrimaryBackgroundStyle = {
  warning: "semantic.fill.warning.primary",
  critical: "semantic.fill.critical.primary",
  success: "semantic.fill.success.primary",
  neutral: "semantic.fill.inverse",
  brand: "semantic.fill.brand.primary",
  informative: "semantic.fill.informative.primary"
}, SecondaryBackgroundStyle = {
  warning: "semantic.fill.warning.secondary",
  critical: "semantic.fill.critical.secondary",
  success: "semantic.fill.success.secondary",
  neutral: "semantic.fill.secondary",
  brand: "semantic.fill.brand.secondary",
  informative: "semantic.fill.informative.secondary"
}, SecondaryColorStyle = {
  warning: "component.pill.secondaryWarning.rest.label",
  critical: "component.pill.secondaryCritical.rest.label",
  success: "component.pill.secondarySuccess.rest.label",
  neutral: "component.pill.secondaryNeutral.rest.label",
  brand: "component.pill.secondaryBrand.rest.label",
  informative: "component.pill.secondaryInformative.rest.label"
}, getBackgroundColor = (r, a) => a === "status" ? "semantic.fill.primary" : a === "primary" ? PrimaryBackgroundStyle[r] : SecondaryBackgroundStyle[r], getColor = (r, a) => a === "status" || r === "warning" ? "semantic.text.primary" : a === "secondary" ? SecondaryColorStyle[r] : "semantic.text.inverse", _baseBadgeTheme = {
  baseStyle: ({ status: r, type: a }) => ({
    paddingX: "xs",
    paddingY: "xxxs",
    display: "inline-flex",
    flexShrink: 0,
    minWidth: "16px",
    height: "20px",
    textStyle: "body4",
    borderRadius: "global.400",
    whiteSpace: "nowrap",
    backgroundColor: getBackgroundColor(r, a),
    color: getColor(r, a),
    border: a === "status" ? "basic.light" : "none",
    borderColor: a === "status" ? "semantic.border.static" : void 0,
    width: "fit-content",
    alignItems: "center",
    justifyContent: "center",
    _readOnly: {
      backgroundColor: "semantic.fill.secondary",
      color: "semantic.text.secondary"
    },
    _disabled: {
      backgroundColor: "semantic.fill.disabled",
      color: "semantic.text.disabled"
    }
  })
}, baseHeaderHeight = 32, getHeaderHeight = (r) => r ? `${baseHeaderHeight + getThemeSpacingAsNumber("xs") * 2}px` : `${baseHeaderHeight}px`, headerTitleHeight = `calc(${baseHeaderHeight}px + ${getThemeSpacingAsNumber("xs")}px)`, _baseCalendarTheme = {
  baseStyle: ({ isMobileDatePicker: r }) => ({
    container: {
      width: r ? "100%" : "304px",
      display: "flex",
      flexDir: "column",
      color: "semantic.text.primary",
      gridGap: "xs"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      flexDir: "row",
      alignItems: "center",
      paddingY: r ? "xs" : "none",
      height: getHeaderHeight(r),
      "&[data-year-selection-open='true']": {
        justifyContent: "center"
      }
    },
    monthContainer: {
      display: "flex",
      flexDirection: "column",
      rowGap: r ? "xs" : "xxxs",
      "&[data-hidden='true']": {
        visibility: "hidden"
      }
    },
    calendar: {
      display: "grid",
      width: r ? "100%" : "fit-content",
      _disabled: {
        pointerEvents: "none",
        opacity: 0.5
      }
    },
    calendarRow: {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)"
    },
    headerCell: {
      width: "40px",
      height: "40px",
      textStyle: "body4Semi",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textTransform: "uppercase",
      userSelect: "none",
      textAlign: "center",
      color: "semantic.text.secondary"
    },
    cell: {
      width: "40px",
      height: "40px",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textStyle: "body3",
      border: "input-thick.transparent",
      borderRadius: "global.full",
      cursor: "pointer",
      color: "semantic.text.primary",
      '&:hover[aria-selected]:not([aria-selected="true"]):not([aria-disabled="true"])': {
        bgColor: "semantic.surface.primary.hover"
      },
      '&[data-secondary-selected-date="true"][aria-selected="false"]': {
        border: "selection.selectedNeutral",
        borderColor: "semantic.border.interactive.rest"
      },
      _selected: {
        color: "semantic.text.inverse",
        bgColor: "semantic.fill.brand.primary",
        '&[data-secondary-selected-date="true"]': {
          border: "selection.selectedNeutral",
          borderColor: "semantic.border.interactive.rest",
          bgColor: "semantic.fill.primary"
        }
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineStyle: "solid",
        outlineWidth: "2px",
        outlineOffset: "2px"
      },
      _disabled: {
        color: "semantic.text.disabled",
        cursor: "initial"
      },
      // `showToday` date style: applied only when the date is today's date and it's not selected / secondarySelected.
      '&[data-show-today="true"][aria-current="date"][data-secondary-selected-date="false"][aria-selected="false"]': {
        border: "input-dashed.enabled",
        borderColor: "semantic.border.interactive.rest",
        _disabled: {
          color: "semantic.text.disabled"
        }
      }
    },
    cellLabel: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "global.full",
      '&[data-selected-date="true"]': {
        backgroundColor: "semantic.fill.brand.primary",
        '&[data-secondary-selected-date="true"]': {
          border: "selection.selectedNeutral",
          borderColor: "semantic.border.inverse"
        }
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "100%"
    },
    yearSelectionHeader: {
      display: "flex",
      alignItems: "center"
    },
    yearSelectionHeaderTrigger: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      borderRadius: "global.200",
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineStyle: "solid",
        outlineWidth: "2px",
        outlineOffset: "-3px"
      }
    },
    yearSelectionContainer: {
      display: "flex",
      flexDirection: "column",
      rowGap: r ? "xs" : "none",
      position: "absolute",
      backgroundColor: "semantic.surface.primary.rest",
      zIndex: "docked",
      inset: 0,
      width: "100%",
      height: `calc(100% - ${headerTitleHeight})`,
      paddingTop: r ? "xs" : "xxs",
      top: headerTitleHeight
    },
    yearSelectionList: {
      display: "flex",
      flexDirection: "column",
      borderTop: "basic.light",
      borderColor: "semantic.border.static",
      overflowY: "auto",
      height: "100%"
    },
    yearSelectionListItem: {
      display: "flex",
      flexDirection: "column",
      rowGap: r ? "xs" : "none",
      width: "100%",
      borderBottom: "basic.light",
      borderColor: "semantic.border.static"
    },
    yearSelectionListItemTrigger: {
      display: "flex",
      justifyContent: "center",
      padding: "s",
      backgroundColor: "semantic.surface.primary.rest",
      textStyle: "body2Semi",
      color: "semantic.text.secondary",
      outlineColor: "semantic.focus.primary",
      outlineOffset: "-1px",
      _expanded: {
        backgroundColor: "semantic.surface.secondary.rest",
        color: "semantic.text.primary"
      },
      _disabled: {
        pointerEvents: "none",
        color: "semantic.text.disabled"
      },
      _hover: {
        backgroundColor: "semantic.surface.secondary.rest",
        color: "global.neutral.900",
        transition: "color 0.1s, background-color 0.1s",
        _expanded: {
          backgroundColor: "semantic.surface.secondary.rest"
        }
      },
      _active: {
        backgroundColor: "semantic.surface.secondary.hover",
        _expanded: {
          backgroundColor: "semantic.surface.secondary.rest",
          color: "semantic.text.primary"
        }
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "-2px",
        outlineStyle: "solid",
        outlineWidth: "2px"
      }
    },
    monthSelectionGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: "xs",
      padding: "s",
      paddingTop: "none",
      backgroundColor: "semantic.surface.secondary.rest"
    },
    monthSelectionCell: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      minWidth: "88px",
      padding: "xs",
      borderRadius: "global.200",
      textStyle: "body4Semi",
      _hover: {
        bgColor: "semantic.surface.primary.hover"
      },
      _active: {
        bgColor: "semantic.fill.brand.primary",
        color: "semantic.text.inverse"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "2px",
        outlineStyle: "solid",
        outlineWidth: "2px"
      },
      _disabled: {
        pointerEvents: "none",
        color: "semantic.text.disabled"
      }
    },
    legendsList: {
      paddingLeft: "xs"
    }
  }),
  sizes: {
    small: ({ isMobileDatePicker: r }) => ({
      calendar: {
        rowGap: r ? "xs" : "xxs"
      },
      calendarRow: {
        columnGap: r ? "xs" : "none"
      }
    }),
    large: ({ isMobileDatePicker: r }) => ({
      calendar: {
        rowGap: r ? "xs" : "xxxs"
      },
      calendarRow: {
        columnGap: "xxs"
      }
    })
  }
}, textContainerColumnGap = "xxs", indicatorSize = "8px", calendarLegendTheme = {
  baseStyle: ({ legendWidth: r, legendMaxWidth: a }) => ({
    container: {
      display: "flex",
      flexDir: "row",
      alignItems: "baseline",
      gridGap: "xs",
      width: r === "full" ? "100%" : "fit-content",
      maxWidth: a
    },
    indicator: {
      width: indicatorSize,
      height: indicatorSize,
      minWidth: indicatorSize,
      minHeight: indicatorSize,
      borderRadius: "global.full",
      border: "selection.selectedNeutral",
      borderColor: "semantic.icon.readOnly",
      bgColor: "transparent",
      '&[data-variant="primary"]': {
        borderColor: "semantic.icon.brand",
        bgColor: "semantic.icon.brand"
      },
      '&[data-variant="secondary"]': {
        borderColor: "semantic.icon.readOnly"
      },
      '&[data-variant="today"]': {
        border: "input-dashed.enabled",
        borderColor: "semantic.icon.readOnly"
      }
    },
    textContainer: {
      display: "flex",
      flexWrap: "wrap",
      color: "global.neutral.900",
      columnGap: textContainerColumnGap,
      // calculate the max width of the text container based on the full width and spaces.
      maxWidth: `calc(100% - ${`${getThemeSpacingAsNumber(textContainerColumnGap)}px`} - ${indicatorSize})`
    },
    label: {
      textStyle: "body4",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    date: {
      textStyle: "body4Semi",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  })
}, _baseFileUploadTheme = {
  baseStyle: {
    outerContainer: {},
    innerContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      borderRadius: "semantic.input.medium",
      height: "100%",
      width: "100%",
      border: "input-dashed.disabled",
      borderColor: "semantic.border.interactive.rest",
      gap: "s",
      padding: "s",
      cursor: "pointer",
      transition: "color 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, outline-color 0.2s",
      color: "semantic.text.secondary",
      outline: "transparent solid 2px",
      _hover: {
        color: "global.neutral.900",
        borderColor: "semantic.border.neutral"
      },
      _active: {
        color: "semantic.text.primary"
      },
      _readOnly: {
        cursor: "default",
        borderColor: "semantic.border.static"
      },
      _invalid: {
        border: "input-dashed.error",
        borderColor: "semantic.border.critical"
      },
      _disabled: {
        cursor: "not-allowed",
        borderColor: "semantic.border.static"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "2px"
      },
      _selected: {
        justifyContent: "space-between",
        pointerEvents: "all",
        gap: "none",
        _invalid: {
          border: "input-dashed.error",
          borderColor: "semantic.border.critical"
        }
      },
      '&[data-loading="true"]': {
        justifyContent: "center",
        cursor: "progress"
      }
    },
    placeholder: {
      display: "flex",
      gap: "s"
    },
    placeholderIcon: {
      display: "inline-flex",
      color: "semantic.icon.primary",
      _hover: {
        color: "semantic.icon.primary"
      },
      _readOnly: {
        color: "semantic.icon.readOnly"
      },
      _disabled: {
        color: "semantic.icon.disabled"
      }
    },
    placeholderLabel: {
      color: "semantic.text.secondary",
      _readOnly: {
        color: "semantic.text.secondary"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "row"
    },
    label: {
      textStyle: "body2",
      textDecorationLine: "underline",
      cursor: "pointer",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: "semantic.link.primary.rest",
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        transition: "outline-color 0.2s"
      },
      _disabled: {
        cursor: "not-allowed",
        color: "semantic.text.disabled",
        _focus: {
          outline: "none",
          boxShadow: 0
        },
        _hover: {
          color: "semantic.text.disabled"
        }
      },
      _hover: {
        color: "semantic.link.primary.hover"
      },
      _pressed: {
        color: "semantic.link.primary.pressed"
      }
    }
  },
  sizes: {
    small: {
      placeholderLabel: {
        color: "semantic.text.secondary",
        textStyle: "body2",
        _disabled: {
          color: "semantic.text.disabled"
        }
      },
      placeholder: {
        flexDirection: "row"
      },
      buttonsContainer: {
        marginLeft: "s",
        gap: "s"
      }
    },
    large: ({ value: r, isMobile: a }) => ({
      outerContainer: {
        gap: "s",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column"
      },
      placeholderLabel: {
        textStyle: "body3",
        textAlign: "center",
        color: "semantic.text.secondary",
        _disabled: {
          color: "semantic.text.disabled"
        }
      },
      placeholder: {
        flexDirection: "column",
        alignItems: "center"
      },
      buttonsContainer: {
        gap: a ? "m" : "l",
        justifyContent: "center"
      },
      innerContainer: {
        justifyContent: "center",
        border: "input-dashed-thick.disabled",
        borderColor: "semantic.border.interactive.rest",
        _invalid: {
          border: "input-dashed-thick.error",
          borderColor: "semantic.border.critical"
        },
        _selected: {
          justifyContent: "center",
          border: "none"
        },
        _disabled: {
          // Opacity should be only on preview
          "& > *": {
            opacity: r ? 0.35 : 1
          }
        }
      }
    })
  }
}, getIconSize = ({
  size: r = "medium",
  isURLIcon: a
}) => ({
  // Using explicit pixels because the icon is an svg and its size is determined by its parent's font-size.
  fontSize: iconSizeMapping[r],
  width: a ? iconSizeMapping[r] : void 0,
  height: a ? iconSizeMapping[r] : void 0
}), isBrandSymbol$1 = (r) => !!Object.keys(brandSymbolsMap).includes(r), iconColorMapping = {
  default: "semantic.icon.primary",
  inverse: "semantic.icon.inverse",
  inherit: "inherit",
  brand: "semantic.icon.brand"
}, baseIconTheme = {
  baseStyle: ({ isInverse: r }) => ({
    display: "inline-flex",
    borderRadius: "global.50",
    outlineColor: "transparent",
    transition: "outline-color 0.2s",
    _readOnly: {
      color: "semantic.icon.readOnly",
      '&[data-is-brand-color="true"]': {
        opacity: 0.6,
        color: iconColorMapping.brand
      }
    },
    _disabled: {
      color: "semantic.icon.disabled",
      '&[data-is-brand-color="true"]': {
        opacity: 0.35,
        color: iconColorMapping.brand
      }
    },
    _focusVisible: {
      outlineColor: r ? "semantic.focus.inverse" : "semantic.focus.primary",
      outlineWidth: "2px",
      outlineOffset: "2px",
      outlineStyle: "solid"
    }
  }),
  sizes: {
    "extra-small": getIconSize,
    small: getIconSize,
    "small-medium": getIconSize,
    medium: getIconSize,
    large: getIconSize,
    "extra-large": getIconSize
  }
}, _baseSheetTheme = {
  baseStyle: ({ placement: r, paddingX: a, paddingY: s, showFooterBorder: c, hasTitle: u }) => ({
    mainContainer: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      minHeight: "88px",
      maxHeight: r === "bottom" ? `calc(100dvh - ${themeSpaces.s})` : "inherit",
      borderTopRightRadius: r === "bottom" ? "xl" : "xxl",
      borderTopLeftRadius: r === "bottom" ? "xl" : "none",
      borderBottomRightRadius: r === "left" ? "xxl" : "none",
      backgroundColor: "semantic.surface.primary.rest",
      overflow: "auto"
    },
    loadingContainer: {
      minHeight: "inherit",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "m"
    },
    closeButtonLoadingState: {
      position: "absolute",
      top: s,
      right: a,
      zIndex: 1
    },
    closeButtonContainer: {
      minHeight: "32px",
      height: "100%",
      display: "flex",
      alignItems: "center"
    },
    header: {
      display: "flex",
      flexDirection: u ? "row" : "row-reverse",
      justifyContent: "space-between",
      gap: "s",
      paddingX: a,
      paddingY: s
    },
    body: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    },
    footer: {
      paddingX: a,
      paddingY: s,
      backgroundColor: "semantic.surface.primary.rest",
      position: "sticky",
      bottom: 0,
      zIndex: "sticky",
      ...c && { borderTop: "basic.light", borderColor: "semantic.border.static" }
    }
  })
}, applyToAllStates$1 = (r) => ({
  ...r,
  "&:hover": r,
  "&:focus": r
}), input = {
  field: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    transition: "outline-color 0.1s ease-in-out",
    color: "semantic.text.primary",
    paddingX: "none",
    background: "transparent",
    textStyle: "body2",
    // TODO: https://meliorisk.atlassian.net/browse/ME-58568
    border: "1px solid",
    borderColor: "semantic.border.interactive.rest",
    borderRadius: "semantic.input.medium",
    paddingLeft: "s",
    paddingRight: "s",
    "&.small": {
      height: "40px"
    },
    "&.large": {
      height: "48px"
    },
    _hover: {
      borderColor: "semantic.border.interactive.hover"
    },
    _focus: {
      borderColor: "semantic.border.interactive.disabled",
      outlineStyle: "solid",
      outlineOffset: "2px",
      outlineColor: "semantic.focus.primary",
      border: "input.brand"
    },
    _placeholder: {
      color: "semantic.text.secondary"
    },
    _readOnly: {
      boxShadow: "none !important",
      cursor: "auto",
      userSelect: "all",
      color: "semantic.text.secondary",
      borderColor: "semantic.border.interactive.disabled",
      backgroundColor: "semantic.surface.primary.disabled",
      _focus: {
        borderColor: "semantic.border.interactive.disabled"
      }
    },
    '&[data-view-mode="true"]': applyToAllStates$1({
      boxShadow: "none !important",
      cursor: "auto",
      userSelect: "all",
      pointerEvents: "none",
      color: "semantic.text.primary",
      borderColor: "transparent",
      paddingLeft: "none",
      paddingRight: "none",
      height: "auto",
      backgroundColor: "transparent",
      _hover: {
        borderColor: "transparent"
      },
      _disabled: {
        borderColor: "transparent"
      },
      '&[data-loading="true"]': {
        borderColor: "transparent"
      }
    }),
    _disabled: applyToAllStates$1({
      outline: "none",
      color: "semantic.text.disabled",
      cursor: "default",
      backgroundColor: "semantic.surface.primary.disabled",
      _hover: {
        borderColor: "semantic.border.interactive.disabled"
      },
      borderColor: "semantic.border.interactive.disabled",
      _placeholder: {
        color: "semantic.text.disabled"
      },
      '&[data-loading="true"]': {
        borderColor: "semantic.border.interactive.disabled",
        backgroundColor: "semantic.surface.primary.disabled"
      },
      '&[data-view-mode="true"]': {
        borderColor: "transparent",
        backgroundColor: "transparent"
      }
    }),
    _invalid: applyToAllStates$1({
      borderColor: "semantic.border.critical",
      _hover: {
        borderColor: "semantic.border.critical"
      }
    })
  }
}, formTextStyle = "body2", formHeight = {
  large: {
    height: "48px"
  },
  small: {
    height: "40px"
  }
}, customInputContainerTheme = {
  baseStyle: {
    field: {
      ...input.field,
      pb: "xxs",
      _groupInvalid: {
        ...input.field._invalid
      }
    }
  }
}, formTheme = {
  sizes: {
    large: {
      formContainer: {
        rowGap: "xxl"
      },
      form: {
        rowGap: "l",
        columnGap: "l"
      },
      container: {
        rowGap: "xxs"
      }
    },
    small: {
      formContainer: {
        rowGap: "xl"
      },
      form: {
        rowGap: "m",
        columnGap: "m"
      },
      container: {
        rowGap: "xxs"
      }
    }
  },
  baseStyle: ({ error: r }) => ({
    form: {
      width: "100%",
      position: "relative"
    },
    helperText: {
      color: "semantic.text.secondary",
      textStyle: "body4",
      _readOnly: {
        color: "semantic.text.secondary"
      },
      _disabled: {
        color: "semantic.text.disabled"
      },
      _hidden: {
        visibility: "hidden"
      }
    },
    errorContainer: {
      ...!r && { position: "absolute" }
    },
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      _hidden: {
        display: "none"
      }
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: "100%"
    },
    loader: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)"
    }
  })
}, rowHeight = 72, getSharedRowStyles = (r, a, s) => ({
  display: "flex",
  height: `${rowHeight}px`,
  backgroundColor: r ? s ? "semantic.surface.secondary.selected" : "semantic.surface.secondary.rest" : s ? "semantic.surface.primary.selected" : "semantic.surface.primary.rest",
  transition: `background-color ${s ? 0.3 : 0.1}s ease-in-out`,
  '> [role="cell"]:first-of-type': {
    // TODO: https://meliorisk.atlassian.net/browse/ME-58568
    borderBottom: r && !a ? "none" : "1px solid",
    borderColor: "semantic.border.static"
  }
}), tableTheme = {
  baseStyle: ({ isSubRow: r, isLastSubRow: a, isRowHighlighted: s, isLoading: c, isHeaderSticky: u }) => ({
    container: {
      isolation: "isolate",
      overflowX: u ? "initial" : "auto",
      width: "100%",
      position: "relative"
    },
    loaderContainer: {
      backgroundColor: "semantic.surface.primary.rest",
      height: `calc(5 * ${rowHeight}px)`,
      width: "100%",
      position: "relative",
      outline: 0
    },
    table: {
      display: "grid",
      flexDirection: "column",
      height: "100%"
    },
    tableBody: {
      position: "relative",
      height: c ? 0 : "auto",
      flexGrow: 1,
      opacity: c ? 0 : 1
    },
    tableHead: u ? {
      position: "sticky",
      top: 0,
      zIndex: "sticky"
    } : {},
    headerRow: {
      ...getSharedRowStyles(),
      borderTopRadius: "l",
      height: "auto",
      minHeight: "48px"
    },
    row: {
      ...getSharedRowStyles(r, a, s)
    },
    clickableRow: {
      ...getSharedRowStyles(r, a, s),
      cursor: "pointer",
      outlineColor: "transparent",
      transition: "outline-color 0.2s ease-in-out",
      _hover: {
        backgroundColor: r ? "semantic.surface.secondary.hover" : "semantic.surface.primary.hover"
      },
      _active: {
        backgroundColor: r ? "semantic.surface.secondary.pressed" : "semantic.surface.primary.pressed"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "-2px"
      }
    }
  })
}, baseColSizeMap = {
  xs: "48px",
  s: "140px",
  m: "288px",
  l: "350px"
}, getCellSizes = () => ({
  xs: {
    minWidth: baseColSizeMap.xs,
    maxWidth: baseColSizeMap.xs,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 0
  },
  s: {
    minWidth: baseColSizeMap.s,
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0
  },
  m: {
    minWidth: baseColSizeMap.m,
    flexGrow: 1.5,
    flexShrink: 0,
    flexBasis: 0
  },
  l: {
    minWidth: baseColSizeMap.l,
    flexGrow: 2.5,
    flexShrink: 0,
    flexBasis: 0
  }
}), getFixedCellSize$1 = (r) => typeof r == "number" ? {
  minWidth: `${r}px`,
  width: `${r}px`,
  maxWidth: `${r}px`
} : {}, getPinnedCellStyle = (r) => !r || r.left === void 0 && r.right === void 0 ? {} : {
  position: "sticky",
  zIndex: "docked",
  backgroundColor: "inherit",
  ...r.left !== void 0 && {
    left: `${r.left}px`,
    borderRight: r.showBorder ? "basic.light" : void 0
  },
  ...r.right !== void 0 && {
    right: `${r.right}px`,
    borderLeft: r.showBorder ? "basic.light" : void 0
  }
}, columnSizingHandler = (r, a, s, c) => {
  r && a().columnSizing[c.id] !== r.getBoundingClientRect().width && s((u) => ({
    ...u,
    // 100% accurate float-point width, even if table content is loaded async
    [c.id]: r.getBoundingClientRect().width
  }));
}, getPinOptions = (r, a, s, c) => {
  const u = r.getIsPinned(), d = u === "left", h = u === "right", p = a && !s, m = a && !c;
  return {
    left: d ? r.getStart("left") : void 0,
    right: h ? r.getAfter("right") : void 0,
    showBorder: d && p && r.getIsLastColumn("left") || h && m && r.getIsFirstColumn("right")
  };
}, _tableDataCellTheme = {
  baseStyle: ({ size: r, textAlign: a, pinOptions: s }) => ({
    position: "relative",
    ...getPinnedCellStyle(s),
    ...getFixedCellSize$1(r),
    textAlign: a,
    // TODO: https://meliorisk.atlassian.net/browse/ME-58568
    borderBottom: "basic.black",
    borderColor: "semantic.border.static",
    overflow: "hidden"
  }),
  sizes: getCellSizes()
}, _tableHeaderBaseCellTheme = {
  baseStyle: ({ size: r, textAlign: a, pinOptions: s }) => ({
    ...getPinnedCellStyle(s),
    minHeight: "49px",
    ...getFixedCellSize$1(r),
    textAlign: a,
    // TODO: https://meliorisk.atlassian.net/browse/ME-58568
    borderBottom: "basic.black",
    borderColor: "semantic.border.static",
    ":first-of-type": {
      borderTopLeftRadius: "l",
      overflow: "hidden"
    },
    ":last-of-type": {
      borderTopRightRadius: "l",
      overflow: "hidden"
    }
  }),
  variants: {
    light: {
      backgroundColor: "semantic.surface.primary.rest"
    },
    dark: {
      backgroundColor: "semantic.surface.secondary.rest",
      color: "global.neutral.900"
    }
  },
  sizes: getCellSizes()
}, tableAmountCellTheme = {
  baseStyle: ({ hasValue: r }) => ({
    value: {
      textStyle: "body3Semi",
      color: r ? "semantic.text.primary" : "semantic.text.secondary",
      _disabled: {
        color: "semantic.text.disabled",
        cursor: "not-allowed"
      }
    },
    additionalAmount: {
      color: "semantic.text.secondary",
      textStyle: "body4",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      columnGap: "xxs",
      _disabled: {
        color: "semantic.text.disabled",
        cursor: "not-allowed"
      }
    }
  })
}, _tableAmountInputTheme = {
  baseStyle: {
    field: {
      backgroundColor: "semantic.surface.primary.rest",
      textAlign: "end",
      padding: "xs",
      textStyle: "body3",
      transition: "all 0.1s ease-in-out",
      "&[data-error], &[data-error]:hover": {
        border: "input.error",
        borderColor: "semantic.border.critical"
      }
    },
    errorMessage: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }
}, clickableStyles = {
  cursor: "pointer",
  transition: "background-color, outline-color 0.2s ease-in-out",
  outlineColor: "transparent",
  _hover: {
    backgroundColor: "semantic.surface.primary.hover"
  },
  _focusVisible: {
    // A trick to avoid having the outline being cropped by the card container
    // https://stackoverflow.com/a/35201368
    outlineOffset: "-2px",
    outlineColor: "semantic.focus.primary",
    transition: "outline-color 0.2s"
  },
  _active: {
    backgroundColor: "semantic.surface.primary.pressed"
  }
}, unclickableStyles = {
  _hover: {
    backgroundColor: "initial"
  },
  _active: {
    backgroundColor: "initial"
  },
  _disabled: {
    cursor: "not-allowed",
    // prevents slight shift to the right when disabled
    display: "grid"
  },
  _readOnly: {
    cursor: "default"
  }
}, getSharedCellStyles = (r, a) => ({
  display: "flex",
  justifyContent: a,
  width: "100%",
  height: "100%",
  padding: "s",
  textAlign: a,
  ...r ? clickableStyles : unclickableStyles
}), tableCellTheme = {
  baseStyle: ({ hasChildren: r, isClickable: a, textAlign: s }) => ({
    ...getSharedCellStyles(a, s),
    backgroundColor: "initial",
    alignItems: "center",
    textStyle: "body3",
    textAlign: s,
    color: r ? "semantic.text.primary" : "semantic.text.secondary"
  })
}, tableHeaderCellTheme = {
  baseStyle: ({ isClickable: r, textAlign: a }) => ({
    ...getSharedCellStyles(r, a),
    color: "semantic.text.primary",
    textStyle: "body3Semi",
    alignItems: "flex-start",
    '&[data-component="TableSelectableCell"]': {
      padding: "xs",
      alignItems: "center"
    }
  }),
  variants: {
    light: {},
    dark: ({ isClickable: r }) => ({
      color: "global.neutral.900",
      _hover: {
        backgroundColor: r ? "semantic.surface.primary.hover" : "initial"
      },
      '&[data-selected="true"]': {
        color: "semantic.text.primary"
      },
      _active: {
        backgroundColor: r ? "semantic.surface.primary.pressed" : "initial"
      }
    })
  }
}, tableHeaderSortableCellTheme = {
  baseStyle: ({ isSorting: r, textAlign: a, isClickable: s }) => ({
    icon: {
      display: "inline-flex",
      alignItems: "center",
      opacity: r || !s && r ? 1 : 0,
      transition: "opacity 0.25s ease",
      order: a === "end" ? -1 : "initial",
      _hover: {
        opacity: 1
      }
    }
  })
}, tableMenuTriggerHeaderCellTheme = {
  baseStyle: {
    display: "flex",
    width: "100%"
  },
  variants: {
    light: {},
    dark: {
      color: "global.neutral.900"
    }
  }
}, tableMobileContainerTheme = {
  baseStyle: ({ isLoading: r }) => ({
    container: {
      isolation: "isolate",
      overflowY: "auto",
      overflowX: "hidden",
      width: "100%",
      opacity: r ? 0 : 1,
      height: r ? 0 : "auto"
    },
    row: {
      paddingY: "m",
      backgroundColor: "semantic.surface.primary.rest",
      transition: "background-color 0.1s ease-in-out",
      outlineColor: "transparent",
      _highlighted: {
        backgroundColor: "semantic.surface.primary.selected",
        transition: "background-color 0.3s ease-in-out"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineOffset: "-2px",
        transition: "outline-color 0.2s"
      }
    }
  })
}, tableSelectCellTheme = {
  baseStyle: {
    leftIcon: {
      display: "inline-flex",
      marginRight: "xs",
      flexShrink: 0
    },
    rightIcon: {
      display: "inline-flex",
      marginLeft: "auto",
      paddingLeft: "m",
      flexShrink: 0
    },
    warningIcon: {
      display: "inline-flex",
      marginLeft: "xxs",
      flexShrink: 0
    }
  }
}, basePopoverTheme = {
  baseStyle: ({ position: r, top: a, left: s }) => ({
    trigger: {
      outlineColor: "transparent",
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        transition: "outline-color 0.2s",
        outlineOffset: "2px"
      }
    },
    content: {
      position: r,
      top: `${a ?? 0}px`,
      left: `${s ?? 0}px`,
      backgroundColor: "semantic.surface.inverse",
      color: "semantic.text.inverse",
      border: "none",
      borderRadius: "global.200",
      textStyle: "body4",
      width: "max-content",
      maxWidth: "296px",
      textAlign: "start",
      zIndex: "popover",
      boxShadow: 0,
      paddingX: "s",
      paddingY: "s",
      _focus: {
        boxShadow: 0
      }
    },
    close: {
      position: "absolute",
      right: "xxs",
      top: "xxs"
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      paddingX: "none",
      paddingY: "none",
      marginRight: "m",
      marginBottom: "xxs",
      borderBottom: "none"
    },
    icon: {
      display: "inline-flex",
      marginY: "xxxs",
      marginRight: "xs"
    },
    title: {
      textStyle: "body3Semi",
      display: "inline-block",
      maxWidth: "100%",
      paddingX: "none",
      paddingY: "none"
    },
    body: {
      paddingX: "none",
      paddingY: "none",
      marginRight: "m",
      wordBreak: "break-word"
    },
    footer: {
      paddingX: "none",
      paddingY: "none",
      marginTop: "s",
      borderTop: "none",
      display: "flex",
      justifyContent: "flex-end"
    },
    footerText: {
      opacity: 0.8
    },
    arrow: {
      fill: "semantic.icon.primary",
      height: "22px",
      width: "22px"
    }
  })
}, fadeStyle$1 = { position: "absolute", zIndex: zIndices.popover }, sharedOptionStyles = {
  width: "100%",
  display: "flex",
  gap: "s",
  alignItems: "center",
  padding: "s",
  cursor: "pointer",
  transition: "background-color 0.1s ease-in-out",
  textStyle: "body3"
}, sharedIconStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  '&[data-view-mode="true"]': { display: "none" }
}, getValueRightElementWidth = (r) => r ? `calc(${themeSpaces.xs} + ${r}px)` : "0px", baseSelectTheme = {
  baseStyle: ({
    isOpen: r,
    shouldShowCreatableOption: a,
    strategy: s,
    x: c,
    y: u,
    clickableEmptyState: d,
    hasLeftElement: h,
    isViewMode: p,
    valueRightElementWidth: m = 0,
    placeholderValue: g
  }) => ({
    container: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    triggerInput: {
      position: "absolute",
      inset: "0",
      opacity: "0",
      cursor: "pointer"
    },
    trigger: {
      textOverflow: "ellipsis",
      position: "relative",
      textAlign: "start",
      textStyle: "body2",
      display: "flex",
      alignItems: "center",
      // Overrides the input's padding-right.
      paddingRight: p ? (
        // Using `!important` here to override the input's view-mode selector.
        `${getValueRightElementWidth(m)} !important`
      ) : `calc(${themeSpaces.xxl} + ${getValueRightElementWidth(m)})`,
      _placeholder: {
        color: "semantic.text.secondary",
        _readOnly: { color: "semantic.text.secondary" }
      },
      _disabled: {
        color: "semantic.text.disabled",
        cursor: "default",
        borderColor: "semantic.border.static",
        backgroundColor: p ? "transparent" : "semantic.surface.primary.disabled",
        _hover: { borderColor: "semantic.border.static" }
      },
      '&[data-ui-only="true"]': {
        pointerEvents: "none"
      }
    },
    loader: {
      marginRight: "s"
    },
    toggleButtonRightElement: {
      height: "100%",
      pointerEvents: "none"
    },
    triggerOverlay: {
      pointerEvents: p ? "unset" : "none",
      display: "flex",
      alignItems: "center",
      gap: "xs",
      position: p ? "initial" : "absolute",
      top: 0,
      width: "100%",
      // `triggerOverlay` text color should always be transparent so we only see the input's text.
      color: p ? "semantic.text.primary" : "transparent",
      paddingStart: p ? "none" : h ? "xl" : "s",
      paddingEnd: p ? void 0 : "xxl",
      textStyle: "body2",
      height: "100%"
    },
    valueRightElement: {
      display: "inline-flex"
    },
    triggerLeftIcon: {
      ...sharedIconStyles,
      paddingRight: "xs",
      paddingLeft: "s",
      _disabled: { color: "semantic.icon.disabled", cursor: "default" }
    },
    triggerRightIcon: {
      ...sharedIconStyles,
      height: "24px",
      width: "24px",
      borderRadius: "global.100",
      marginRight: "xs-s",
      _hover: { backgroundColor: "semantic.surface.primary.hover" },
      _active: { backgroundColor: "semantic.surface.primary.pressed" },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        transition: "outline-color 0.2s"
      },
      _disabled: { color: "semantic.text.disabled", cursor: "default" }
    },
    placeholder: {
      color: "semantic.text.disabled",
      display: "flex",
      minWidth: 0,
      _disabled: {
        color: "semantic.text.disabled"
      },
      _readOnly: {
        color: "semantic.text.secondary"
      },
      // Using CSS pseudo element because placeholder should be ignored by a11y tools.
      "::after": {
        content: `"${g}"`,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    dropdownMenu: {
      visibility: r ? "visible" : "hidden",
      zIndex: "popover",
      position: s,
      top: `${u ?? 0}px`,
      left: `${c ?? 0}px`
    },
    dropdownMenuContent: {
      textStyle: "body4Semi",
      borderRadius: "global.200",
      boxShadow: 500,
      border: "surface.default",
      backgroundColor: "semantic.surface.primary.rest",
      overflow: "hidden",
      paddingTop: "xs",
      paddingBottom: a ? "none" : "xs",
      marginTop: "xs"
    },
    optionsContainer: {
      maxHeight: "248px",
      overflowY: "auto",
      overflowX: "hidden",
      textStyle: "body3",
      _hover: { outline: "none" }
    },
    sectionLabel: {
      // Override the default "list-item" display of the "li" html tag
      display: "block",
      padding: "s"
    },
    option: {
      ...sharedOptionStyles,
      color: "semantic.text.primary",
      _hover: { backgroundColor: "semantic.surface.primary.hover" },
      _focus: { backgroundColor: "semantic.surface.primary.hover" },
      _active: { backgroundColor: "semantic.surface.primary.hover" },
      '&[data-is-selected="true"]': { backgroundColor: "semantic.surface.primary.selected" }
    },
    checkedIcon: {
      display: "inline-flex",
      marginLeft: "auto",
      flexShrink: 0
    },
    creatableOption: {
      ...sharedOptionStyles,
      cursor: "default"
    },
    emptyState: {
      ...sharedOptionStyles,
      justifyContent: d ? "flex-start" : "center",
      color: "semantic.text.secondary",
      _hover: { backgroundColor: d ? "none" : "semantic.text.disabled" },
      _active: { backgroundColor: d ? "none" : "semantic.text.disabled" },
      _disabled: { pointerEvents: "none" }
    },
    loading: {
      ...sharedOptionStyles,
      justifyContent: "center",
      color: "semantic.text.secondary",
      pointerEvents: "none"
    }
  })
}, baseVirtualCardTheme = {
  baseStyle: ({ backgroundImageSrc: r }) => ({
    container: {
      position: "relative",
      aspectRatio: "43 / 26",
      width: "100%",
      height: "auto",
      maxHeight: "208px",
      maxWidth: "344px",
      borderRadius: "global.400",
      padding: "m",
      border: "basic.light",
      boxShadow: 500
    },
    image: {
      position: "absolute",
      overflow: "hidden",
      borderRadius: "global.400",
      inset: "0",
      margin: "auto",
      width: "100%",
      height: "auto",
      backgroundImage: r && `url(${r})`,
      backgroundSize: "cover"
    },
    content: {
      position: "relative",
      zIndex: 1
    }
  }),
  variants: {
    white: {
      container: {
        background: "linear-gradient(228deg, #F1F1F1 21.35%, #FFF 65.63%)"
      }
    },
    black: {
      container: {
        background: "radial-gradient(188.74% 149.84% at 107.56% -4.33%, #666A79 0%, #313238 100%)"
      }
    },
    brand: ({ theme: r }) => {
      var s, c;
      const a = r.colors.global;
      return {
        container: {
          background: `radial-gradient(300.07% 141.42% at 100.00% -0.00%, ${(s = a == null ? void 0 : a.brand) == null ? void 0 : s["700"]} 0%, ${(c = a == null ? void 0 : a.brand) == null ? void 0 : c["900"]} 100%)`
        }
      };
    }
  }
}, baseVirtualCardDetailsTheme = {
  baseStyle: ({ enableCopy: r }) => ({
    label: {
      display: "inline-flex",
      width: "max-content",
      textStyle: "body4Semi"
    },
    mainLabel: {
      width: "max-content",
      display: "inline-flex",
      alignItems: "center",
      textStyle: "body2",
      cursor: r ? "pointer" : "default",
      gap: "xxs"
    },
    copyButton: {
      display: "inline-flex",
      alignItems: "center",
      opacity: 0,
      visibility: "hidden",
      transition: "opacity 0.2s ease-in-out",
      _hover: {
        visibility: "visible",
        opacity: 1
      }
    }
  }),
  variants: {
    default: {
      label: {
        color: "semantic.text.secondary"
      },
      mainLabel: {
        color: "semantic.text.primary"
      },
      copyButton: {
        color: "semantic.icon.primary"
      }
    },
    inverse: {
      label: {
        color: "semantic.text.inverse"
      },
      mainLabel: {
        color: "semantic.text.inverse"
      },
      copyButton: {
        color: "semantic.icon.inverse"
      }
    }
  }
}, imageTheme = {
  baseStyle: ({ objectFit: r, objectPosition: a, aspectRatio: s, borderRadius: c, width: u, height: d }) => ({
    image: {
      width: u,
      height: d,
      objectFit: r,
      objectPosition: a,
      aspectRatio: s,
      borderRadius: c,
      _disabled: {
        opacity: 0.35
      }
    },
    fallbackImage: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "semantic.surface.secondary.rest",
      height: d,
      width: u,
      objectFit: r,
      objectPosition: a,
      aspectRatio: s,
      borderRadius: c
    },
    fallbackIcon: {
      width: "100%",
      height: "100%",
      maxWidth: "40px",
      maxHeight: "40px"
    }
  }),
  variants: {
    circle: {
      image: {
        borderRadius: "global.full",
        aspectRatio: "1 / 1"
      }
    },
    square: {}
  }
}, lottieTheme = {
  baseStyle: ({ height: r, width: a }) => ({
    height: r,
    width: a
  })
}, deprecatedTabsTheme = {
  baseStyle: ({ variant: r }) => ({
    container: {
      display: "flex",
      flexDirection: "column"
    },
    tab: {
      color: "component.tab.neutral.rest.label",
      cursor: "pointer",
      textStyle: "body2Semi",
      borderBottom: "input-thick.transparent",
      transition: "0.1s ease-in-out",
      transitionProperty: "border, color",
      "&:first-of-type": {
        marginLeft: r === "section" ? "xl" : "none"
      },
      _hover: {
        color: "component.tab.neutral.hover.label",
        borderBottom: "input-thick.transparent"
      },
      _selected: {
        color: "component.tab.neutral.selected.label",
        borderBottom: "input-thick.focused"
      }
    }
  })
}, colorSemanticTokenByVariantAndState = {
  default: {
    rest: "semantic.link.primary.rest",
    hover: "semantic.link.primary.hover",
    pressed: "semantic.link.primary.pressed",
    disabled: "semantic.link.primary.disabled"
  },
  secondary: {
    rest: "semantic.link.secondary.rest",
    hover: "semantic.link.secondary.hover",
    pressed: "semantic.link.secondary.pressed",
    disabled: "semantic.link.secondary.disabled"
  },
  inverse: {
    rest: "semantic.link.inverse.rest",
    hover: "semantic.link.inverse.hover",
    pressed: "semantic.link.inverse.pressed",
    disabled: "semantic.link.inverse.disabled"
  }
}, getColorSemanticToken = (r, a) => !r || r === "inherit" ? "inherit" : colorSemanticTokenByVariantAndState[r][a] ?? colorSemanticTokenByVariantAndState.default[a], linkTheme = {
  baseStyle: ({ shouldSupportEllipsis: r, color: a = "default" }) => ({
    // `display: 'inline-grid'` is needed in order to support ellipsis: https://stackoverflow.com/a/71540221
    display: r ? "inline-grid" : "inline",
    textDecoration: "underline",
    transitionProperty: "color",
    transitionDuration: "0.15s",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    outline: "none",
    color: getColorSemanticToken(a, "rest"),
    ...r && {
      display: "inline-block",
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    _hover: {
      color: getColorSemanticToken(a, "hover"),
      textDecoration: "none"
    },
    _active: {
      color: getColorSemanticToken(a, "pressed"),
      textDecoration: "none"
    },
    _disabled: {
      color: getColorSemanticToken(a, "disabled"),
      cursor: "not-allowed",
      _hover: {
        textDecoration: "underline"
      }
    },
    _focusVisible: {
      outlineColor: a === "inverse" ? "semantic.focus.inverse" : "semantic.focus.primary",
      borderRadius: "global.100",
      transition: "outline-color 0.2s"
    }
  }),
  sizes: {
    large: ({ isBold: r }) => ({
      textStyle: r ? "body2Semi" : "body2"
    }),
    medium: ({ isBold: r }) => ({
      textStyle: r ? "body3Semi" : "body3",
      // This is the match the a11y criteria of a sufficient click area.
      lineHeight: "24px"
    })
  },
  variants: {
    standalone: {},
    inline: {
      width: "fit-content",
      textStyle: "inline"
    }
  }
}, navigationItemTheme = {
  baseStyle: ({ isFullWidth: r }) => ({
    display: "inline-block",
    borderRadius: "semantic.action.medium",
    textStyle: "body3",
    color: "semantic.text.primary",
    paddingX: "xs-s",
    paddingY: "xs",
    width: r ? "100%" : "fit-content",
    maxWidth: r ? "100%" : "240px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transition: "background-color 0.2s ease-in-out",
    _hover: {
      backgroundColor: "semantic.action.tertiary.hover"
    },
    _active: {
      backgroundColor: "semantic.action.tertiary.pressed"
    },
    _selected: {
      backgroundColor: "semantic.fill.brand.secondary",
      color: "semantic.text.brand.rest",
      textStyle: "body3Semi"
    },
    _focusVisible: {
      outlineColor: "semantic.focus.primary",
      outlineOffset: "2px",
      transition: "outline-color 0.2s"
    }
  })
}, tabsTheme = {
  baseStyle: ({ isFullWidth: r }) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      overflowX: "auto"
    },
    tabs: {
      display: "flex",
      overflowX: { xs: "auto", s: "unset" }
    },
    tab: {
      display: "flex",
      color: "component.tab.default.rest.label",
      cursor: "pointer",
      textStyle: { xs: "body3Semi", s: "body2Semi" },
      borderBottom: "selection.transparent",
      transition: "0.1s ease-in-out",
      transitionProperty: "border, color",
      width: r ? "100%" : "fit-content",
      justifyContent: r ? "center" : "flex-end",
      padding: "s",
      paddingTop: { xs: "xs", s: "s" },
      alignItems: "center",
      outlineColor: "semantic.focus.primary",
      outlineOffset: "-1px"
    },
    counters: {
      display: "flex",
      gap: "xxs",
      marginLeft: "xxs"
    },
    pills: {
      display: "flex",
      gap: "xxs",
      marginLeft: "xxs"
    }
  }),
  variants: {
    default: {
      tab: {
        _hover: {
          color: "component.tab.default.hover.label"
        },
        _selected: {
          color: "component.tab.default.selected.label",
          borderBottomColor: "component.tab.default.selected.border",
          outlineColor: "semantic.focus.primary"
        },
        _active: {
          color: "component.tab.default.pressed.label"
        }
      }
    },
    neutral: {
      tab: {
        color: "component.tab.neutral.rest.label",
        _hover: {
          color: "component.tab.neutral.hover.label"
        },
        _selected: {
          color: "component.tab.neutral.selected.label",
          borderBottomColor: "component.tab.neutral.selected.border",
          outlineColor: "semantic.focus.primary"
        },
        _active: {
          color: "component.tab.neutral.pressed.label"
        }
      }
    }
  }
}, amountFieldTheme = {
  baseStyle: {
    height: "calc(100% - 2px)",
    // the 2px is the text field's border width
    borderLeft: "basic.light",
    borderColor: "semantic.border.static",
    minWidth: "112px",
    borderRightRadius: "l",
    marginRight: "1px",
    // we need this because the background color is overriding the right border of the TextField
    _disabled: {
      cursor: "not-allowed",
      backgroundColor: "none"
    }
  }
}, amountInputTheme = {
  baseStyle: ({ inputWidthInChars: r, descriptionAlignment: a }) => ({
    field: {
      display: "inline-flex",
      flexDirection: "row",
      rowGap: "none",
      alignItems: "center",
      justifyContent: "center"
    },
    inputElement: {
      textStyle: "display2",
      paddingBottom: "none",
      margin: "none",
      border: "none",
      width: `${r}ch`,
      height: "1.2em",
      justifySelf: "center",
      backgroundColor: "transparent",
      _placeholder: {
        color: "semantic.text.secondary"
      },
      _focus: {
        border: "none",
        outline: "none"
      },
      '&[data-view-mode="true"]': { border: "none", pointerEvents: "none" }
    },
    inputDisplay: {
      textStyle: "display2",
      marginRight: "xs"
    },
    description: {
      display: "flex",
      justifyContent: a === "start" ? "start" : "center"
    }
  })
}, avatarImageControlTheme = {
  baseStyle: ({ isViewMode: r, isLoading: a }) => ({
    container: {
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "xs-s"
    },
    avatar: {
      w: "120px",
      h: "120px",
      position: "relative",
      overflow: "hidden",
      display: "flex",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      color: "semantic.text.primary",
      backgroundColor: "semantic.fill.secondary",
      border: "basic.light",
      borderColor: "semantic.border.static",
      shadow: r || a ? 0 : 500,
      transition: "shadow 0.1s ease-in-out",
      _hover: {
        cursor: r || a ? "default" : "pointer",
        shadow: r || a ? 0 : 600,
        transition: "shadow 0.1s ease-in-out"
      },
      _active: {
        backgroundColor: r || a ? "semantic.fill.secondary" : "semantic.fill.tertiary"
      }
    },
    image: {
      position: "absolute"
    },
    icon: {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "dropdown"
    },
    initials: {
      textStyle: "body1Semi"
    }
  }),
  variants: {
    circle: {
      avatar: {
        borderRadius: "global.full"
      }
    },
    square: {
      avatar: {
        borderRadius: "global.200"
      }
    }
  }
}, calendarTheme = {
  baseStyle: {
    position: "relative",
    marginTop: "s",
    paddingX: "s",
    paddingBottom: "s"
  }
}, disabledInputStyle$1 = {
  borderColor: "semantic.border.interactive.disabled",
  backgroundColor: "semantic.action.primary.disabled",
  color: "semantic.icon.disabled",
  cursor: "not-allowed"
}, readOnlyInputStyle$1 = {
  borderColor: "semantic.border.interactive.disabled",
  backgroundColor: "semantic.action.primary.disabled",
  color: "semantic.icon.readOnly",
  cursor: "default"
}, checkboxSizes = {
  height: "20px",
  width: "20px"
}, smallCheckboxSizes = {
  height: "16px",
  width: "16px"
}, checkboxTheme = {
  baseStyle: {
    container: {
      cursor: "pointer",
      display: "inline-flex",
      _disabled: {
        cursor: "not-allowed"
      },
      _readOnly: {
        cursor: "default"
      }
    },
    checkboxContainer: {
      display: "grid",
      gridTemplateColumns: "1fr",
      alignItems: "center",
      justifyContent: "center",
      height: "fit-content",
      width: "fit-content",
      '&[data-with-label="false"]': {
        marginTop: "none"
      }
    },
    checkbox: {
      appearance: "none",
      cursor: "pointer",
      paddingY: "xxxs",
      borderRadius: "semantic.input.small",
      border: "basic.dark",
      backgroundColor: "transparent",
      gridColumn: "1 / -1",
      gridRow: "1 / -1",
      alignSelf: "center",
      justifySelf: "center",
      ...checkboxSizes,
      _hover: {
        border: "basic.black"
      },
      _checked: {
        backgroundColor: "semantic.action.primary.rest",
        border: "none",
        _hover: {
          backgroundColor: "semantic.action.primary.hover",
          border: "none"
        },
        _disabled: applyToAllStates$1(disabledInputStyle$1),
        _readOnly: readOnlyInputStyle$1,
        _invalid: {
          border: "none",
          backgroundColor: "semantic.action.criticalPrimary.rest"
        }
      },
      _indeterminate: {
        backgroundColor: "semantic.action.primary.rest",
        border: "none",
        _disabled: disabledInputStyle$1,
        _invalid: {
          border: "none",
          backgroundColor: "semantic.action.criticalPrimary.rest"
        }
      },
      _invalid: {
        borderColor: "semantic.action.criticalPrimary.rest"
      },
      _readOnly: readOnlyInputStyle$1,
      _disabled: disabledInputStyle$1,
      _focusVisible: {
        outlineStyle: "solid",
        outlineWidth: "2px",
        outlineColor: "semantic.focus.primary",
        transition: "outline-color 0.1s"
      }
    },
    innerIcon: {
      color: "semantic.icon.inverse",
      gridColumn: "1 / -1",
      gridRow: "1 / -1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "center",
      justifySelf: "center",
      ...checkboxSizes,
      _readOnly: {
        color: "semantic.icon.readOnly"
      },
      _disabled: {
        color: "semantic.icon.disabled"
      }
    },
    label: {
      color: "semantic.text.primary",
      _disabled: {
        color: "semantic.text.disabled",
        opacity: 1
        //  override chakra's 0.4 opacity
      },
      _readOnly: {
        color: "semantic.text.secondary"
      }
    }
  },
  sizes: {
    small: {
      checkboxContainer: {
        marginTop: { xs: "xxs", s: "xxxs" }
      },
      checkbox: {
        ...smallCheckboxSizes
      },
      label: {
        textStyle: "body3"
      },
      innerIcon: {
        ...smallCheckboxSizes
      }
    },
    large: {
      checkboxContainer: {
        marginTop: "xxxs"
      },
      checkbox: {
        ...checkboxSizes
      },
      label: {
        textStyle: "body2"
      },
      innerIcon: {
        ...checkboxSizes
      }
    }
  }
}, chipTheme = {
  baseStyle: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    paddingY: "xs",
    paddingX: "s",
    height: "40px",
    borderRadius: "global.full",
    outlineColor: "transparent",
    color: "semantic.text.primary",
    border: "basic.dark",
    borderColor: "semantic.border.interactive.rest",
    textStyle: "body3Semi",
    transitionProperty: "color, background-color",
    transition: "0.2s ease-in-out",
    _hover: {
      backgroundColor: "semantic.surface.primary.hover"
    },
    _active: {
      backgroundColor: "semantic.surface.primary.pressed"
    },
    _pressed: {
      backgroundColor: "semantic.surface.inverse",
      color: "semantic.text.inverse",
      border: "basic.black",
      borderColor: "semantic.border.neutral"
    },
    _focusVisible: {
      outlineStyle: "solid",
      outlineWidth: "2px",
      outlineOffset: "2px",
      outlineColor: "semantic.focus.primary",
      transition: "outline-color 0.2s",
      border: "surface.transparent"
    }
  }
}, dateFieldTheme = {
  baseStyle: ({ isTypable: r }) => ({
    input: {
      ...!r && {
        cursor: "pointer",
        caretColor: "transparent"
      }
    },
    rightElement: {
      display: "flex",
      alignItems: "center",
      gap: "xxxs",
      paddingRight: "xs-s",
      height: "100%",
      cursor: r ? "text" : "pointer",
      _readOnly: {
        cursor: "default"
      },
      _disabled: {
        cursor: "default"
      }
    },
    popover: {
      position: "absolute",
      zIndex: "popover",
      width: "min-content",
      padding: "none"
    },
    calendar: {
      position: "relative",
      padding: "s",
      paddingTop: "none",
      marginTop: "s"
    }
  })
}, datePickerTheme = {
  baseStyle: ({ backButton: r }) => ({
    container: {
      borderRadius: "semantic.input.medium",
      overflow: "initial",
      width: { xs: "100%", s: "min-content" }
    },
    calendarContainer: {
      paddingX: "s",
      marginTop: { xs: "none", s: r ? "s" : "xs" },
      paddingBottom: "xs",
      position: "relative"
    },
    backButton: {
      textStyle: "body3Semi",
      textAlign: "start",
      paddingX: "s",
      paddingTop: "xs",
      paddingBottom: "s",
      _hover: {
        backgroundColor: "semantic.surface.primary.hover"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineWidth: "2px",
        outlineOffset: "-2px",
        transition: "outline-color 0.2s"
      }
    }
  })
}, deprecatedSearchBarTheme = {
  baseStyle: ({ value: r, isTyping: a }) => ({
    container: {
      display: "flex",
      height: "40px",
      isolation: "isolate",
      position: "relative",
      borderBottom: "none",
      borderRadius: "semantic.input.medium",
      transition: "background-color 0.1s ease-in-out, color 0.1s ease-in-out",
      shadow: 0,
      bg: "global.neutral.300",
      _hover: {
        shadow: r ? 0 : 500,
        bgColor: "global.neutral.100"
      },
      _focus: {
        shadow: a ? 400 : 500,
        bgColor: "global.neutral.100"
      },
      _active: {
        shadow: 400
      },
      _disabled: {
        shadow: 0,
        bgColor: "global.neutral.300"
      }
    },
    field: {
      height: "100%",
      padding: "none",
      borderBottom: "none",
      position: "relative",
      color: "global.neutral.1000",
      textStyle: "body3",
      paddingLeft: "s",
      _hover: {
        borderBottom: "none",
        _disabled: {
          _placeholder: {
            color: "global.neutral.600"
          }
        }
      },
      _focus: {
        borderBottom: "none",
        _placeholder: {
          color: "global.neutral.600"
        }
      },
      _disabled: {
        borderBottom: "none",
        cursor: "not-allowed",
        color: "global.neutral.600",
        _placeholder: {
          color: "global.neutral.600"
        }
      },
      _placeholder: {
        color: "global.neutral.600"
      }
    }
  })
}, fileAttachmentTheme = {
  baseStyle: ({ isEmpty: r, onViewModeClick: a, width: s }) => ({
    container: {
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center"
    },
    fileImageContainer: {
      display: "inline-flex",
      position: "relative",
      overflow: "hidden",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: `${s}px`,
      height: "auto",
      maxWidth: "176px",
      maxHeight: "224px",
      minWidth: "50px",
      aspectRatio: "176 / 224",
      border: r ? "surface.empty" : "surface.default",
      borderRadius: "semantic.input.medium",
      cursor: "pointer",
      shadow: 500,
      transition: "box-shadow 0.1s ease-in-out",
      _hover: {
        cursor: "pointer",
        shadow: 600
      },
      _loading: {
        shadow: 500,
        cursor: "default"
      },
      _active: {
        shadow: 600
      },
      '&[data-view-mode="true"]': {
        shadow: r ? 0 : 500,
        _hover: {
          cursor: r ? "default" : "pointer",
          shadow: r ? 0 : 600
        }
      },
      _readOnly: {
        shadow: 0,
        _hover: {
          cursor: "default",
          shadow: 0
        }
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineWidth: "2px",
        outlineOffset: "2px",
        outlineStyle: "solid"
      }
    },
    pdf: {
      position: "absolute",
      width: "180px",
      height: "233px",
      overflow: "hidden"
    },
    attachmentIconContainer: {
      position: "absolute",
      zIndex: "dropdown",
      display: "flex",
      borderRadius: "global.100",
      justifyContent: "center",
      alignItems: "center",
      '&[data-view-mode="true"]': {
        width: "24px",
        height: "24px",
        backgroundColor: "semantic.icon.primary",
        opacity: 0.3,
        top: "16px",
        right: "16px",
        _hover: {
          opacity: a && 0.6,
          transition: a && "opacity 0.1s ease-in-out"
        }
      },
      _readOnly: {
        width: "24px",
        height: "24px",
        backgroundColor: "semantic.icon.primary",
        opacity: 0.3,
        top: "16px",
        right: "16px"
      }
    },
    deleteButton: {
      marginTop: "xs-s"
    },
    noPreview: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      opacity: 0.6,
      textStyle: "body3",
      textAlign: "center",
      paddingX: "m",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      wordBreak: "break-word",
      maxWidth: "100%"
    }
  })
}, largeFileUploadTheme = {
  baseStyle: ({ isPdfPreview: r }) => ({
    fileContainer: { display: "flex", height: "100%", ...r && { width: "100%" }, shadow: 400 }
  })
}, disabledInputStyle = {
  borderColor: "semantic.border.interactive.disabled",
  backgroundColor: "semantic.surface.primary.disabled",
  cursor: "not-allowed"
}, readOnlyInputStyle = {
  borderColor: "semantic.border.interactive.disabled",
  backgroundColor: "semantic.surface.primary.disabled",
  cursor: "default"
}, radioTheme = {
  baseStyle: {
    radio: {
      cursor: "pointer",
      appearance: "none",
      border: "basic.dark",
      minWidth: "20px",
      height: "20px",
      borderRadius: "global.full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _before: {
        content: "''",
        width: "10px",
        height: "10px",
        borderRadius: "global.full",
        backgroundColor: "transparent",
        border: "transparent"
      },
      _hover: {
        border: "basic.black",
        borderColor: "semantic.border.interactive.hover"
      },
      _readOnly: readOnlyInputStyle,
      _focusVisible: {
        outlineStyle: "solid",
        outlineColor: "semantic.focus.primary",
        outlineOffset: "2px",
        outlineWidth: "2px"
      },
      _invalid: {
        border: "input.error",
        borderColor: "semantic.border.critical"
      },
      _checked: {
        border: "input.brand",
        borderColor: "semantic.border.interactive.selected",
        _before: {
          backgroundColor: "semantic.action.primary.rest",
          border: "input.brand"
        },
        _disabled: applyToAllStates$1({
          ...disabledInputStyle,
          opacity: 1,
          //  override chakra's 0.4 opacity
          _before: {
            backgroundColor: "semantic.icon.disabled",
            border: "none"
          }
        }),
        _readOnly: {
          ...readOnlyInputStyle,
          _before: {
            backgroundColor: "semantic.icon.readOnly",
            border: "none"
          },
          _hover: {
            _before: {
              backgroundColor: "semantic.icon.readOnly",
              border: "none"
            },
            borderColor: "semantic.border.interactive.disabled"
          }
        },
        _invalid: {
          border: "input.error",
          _before: {
            border: "input.error",
            borderColor: "semantic.border.critical",
            backgroundColor: "semantic.action.criticalPrimary.rest"
          },
          _hover: {
            _before: {
              backgroundColor: "semantic.action.criticalPrimary.rest",
              border: "none"
            },
            borderColor: "semantic.border.critical"
          }
        },
        _hover: {
          _before: {
            borderColor: "semantic.border.interactive.selected",
            backgroundColor: "semantic.action.primary.rest"
          },
          borderColor: "semantic.border.interactive.selected"
        }
      },
      _disabled: {
        ...disabledInputStyle,
        opacity: 1
        //  override chakra's 0.4 opacity
      }
    },
    iconIndicator: {
      display: "flex"
    },
    label: {
      cursor: "pointer",
      _disabled: {
        cursor: "not-allowed",
        opacity: 1
        //  override chakra's 0.4 opacity
      },
      _readOnly: {
        cursor: "default"
      }
    }
  }
}, radioGroupTheme = {
  baseStyle: {
    display: "flex",
    alignItems: "flex-start",
    paddingY: "xxs"
  },
  variants: {
    horizontal: {
      flexDir: "row",
      gridGap: { xs: "s", s: "m" },
      flexWrap: "wrap"
    },
    vertical: {
      flexDir: "column",
      gridGap: "s"
    }
  }
}, DESKTOP_EXPANDED_MAX_WIDTH = "380px", searchBarTheme = {
  baseStyle: ({ isExpanded: r, isFullWidth: a }) => ({
    container: {
      display: "flex",
      height: "40px",
      isolation: "isolate",
      position: "relative",
      borderBottom: "none",
      borderRadius: "semantic.input.medium",
      // TODO: https://meliorisk.atlassian.net/browse/ME-58568
      border: "1px solid",
      borderColor: "semantic.border.interactive.rest",
      width: "100%",
      maxWidth: { xs: "100%", s: a ? "100%" : r ? DESKTOP_EXPANDED_MAX_WIDTH : "330px" },
      transition: "max-width 0.4s ease-in-out, border 0.1s ease-in-out, color 0.1s ease-in-out",
      bg: "semantic.surface.primary.rest",
      color: "semantic.text.primary",
      paddingLeft: "s",
      paddingRight: "xs-s",
      overflow: "hidden",
      _hover: {
        borderColor: "semantic.border.interactive.rest",
        color: "semantic.text.primary",
        cursor: "text"
      },
      _focus: {
        maxWidth: { xs: "100%", s: a ? "100%" : DESKTOP_EXPANDED_MAX_WIDTH },
        color: "semantic.text.primary",
        outlineOffset: "2px",
        outlineWidth: "2px",
        outlineStyle: "solid",
        outlineColor: "semantic.focus.primary",
        border: "basic.brand",
        borderColor: "semantic.border.interactive.selected"
      },
      _disabled: {
        border: "basic.light",
        borderColor: "semantic.border.interactive.disabled",
        color: "semantic.text.disabled",
        cursor: "not-allowed",
        backgroundColor: "semantic.action.success.disabled"
      }
    },
    field: {
      height: "100%",
      width: "100%",
      padding: "none",
      borderBottom: "none",
      position: "relative",
      color: "semantic.text.primary",
      textStyle: "body2",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      _placeholder: {
        color: "semantic.text.secondary"
      },
      _hover: {
        borderBottom: "none"
      },
      _focus: {
        borderBottom: "none"
      },
      _disabled: {
        borderBottom: "none",
        color: "semantic.text.disabled",
        pointerEvents: "none",
        _placeholder: {
          color: "semantic.text.disabled"
        }
      }
    },
    label: {
      textStyle: "body3Semi",
      color: "semantic.text.secondary",
      whiteSpace: "nowrap",
      _disabled: {
        color: "semantic.text.disabled"
      }
    },
    divider: {
      height: "100%",
      paddingX: "xs"
    }
  })
}, securedTextFieldTheme = {
  baseStyle: ({ textVisible: r }) => ({
    container: {
      // While this is a non-standard CSS property, it is supported by all major browsers, and is the only way to not show the password in the input field and also to not prompt the user to save the password.
      // https://caniuse.com/mdn-css_properties_-webkit-text-security
      WebkitTextSecurity: r ? "none" : "disc"
    },
    inputRightIcon: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      marginRight: "xs-s"
    }
  })
}, selectNewTheme = {
  baseStyle: ({ hasCustomValue: r }) => ({
    trigger: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      ...r && {
        "&.small": { minHeight: "40px" },
        "&.large": { minHeight: "48px" }
      }
    },
    placeholder: {
      color: "semantic.text.secondary",
      display: "flex",
      minWidth: 0,
      _disabled: { color: "semantic.text.disabled" },
      _readOnly: { color: "semantic.text.secondary" }
    },
    triggerRightElement: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      pointerEvents: "none",
      paddingRight: "s",
      paddingLeft: "xs",
      color: "semantic.text.primary",
      _disabled: { color: "semantic.text.disabled", cursor: "default" },
      _loading: { cursor: "default" }
    },
    clearButton: {
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      marginRight: "36px",
      marginLeft: "xs"
    },
    emptyState: {
      textAlign: "center",
      color: "semantic.text.secondary",
      padding: "s"
    }
  })
}, switchTheme = {
  baseStyle: ({ isFullWidth: r }) => ({
    container: {
      display: "inline-flex",
      alignItems: "center",
      columnGap: "xs",
      minHeight: "24px",
      cursor: "pointer",
      width: r ? "100%" : "fit-content",
      justifyContent: r ? "space-between" : "unset",
      _disabled: {
        cursor: "not-allowed"
      },
      _readOnly: {
        cursor: "default"
      }
    },
    switch: {
      position: "relative",
      input: {
        cursor: "pointer",
        appearance: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "global.full",
        backgroundColor: "semantic.fill.readOnly",
        transition: "background-color .2s",
        _checked: {
          backgroundColor: "semantic.fill.brand.primary",
          _disabled: {
            backgroundColor: "semantic.fill.brand.secondary"
          }
        },
        _readOnly: {
          backgroundColor: "semantic.fill.primary",
          borderColor: "semantic.border.interactive.rest",
          borderWidth: "1px",
          cursor: "default"
        },
        _disabled: {
          cursor: "not-allowed",
          backgroundColor: "semantic.fill.disabled",
          border: "none"
        }
      }
    },
    slider: {
      content: '""',
      position: "absolute",
      top: "2px",
      left: "2px",
      borderRadius: "global.full",
      transition: "0.2s",
      backgroundColor: "semantic.fill.primary",
      _readOnly: {
        backgroundColor: "semantic.fill.readOnly"
      },
      _checked: {
        left: "calc(100% - 2px)",
        transform: "translate(-100%)"
      },
      _disabled: {
        backgroundColor: "semantic.icon.disabled",
        _checked: {
          backgroundColor: "semantic.icon.inverse"
        }
      }
    },
    label: {
      textStyle: "body2",
      color: "semantic.text.primary",
      _readOnly: {
        color: "semantic.text.secondary"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    }
  }),
  sizes: {
    large: {
      switch: {
        input: {
          width: "36px",
          height: "20px"
        }
      },
      slider: {
        width: "16px",
        height: "16px"
      }
    },
    small: {
      switch: {
        input: {
          width: "28px",
          height: "16px"
        }
      },
      slider: {
        width: "12px",
        height: "12px"
      }
    }
  }
}, textAreaTheme = {
  baseStyle: {
    container: {
      position: "relative",
      border: "1px solid",
      borderColor: "semantic.border.interactive.rest",
      borderRadius: "semantic.input.medium",
      _hover: { borderColor: "semantic.border.interactive.hover" },
      _focus: { borderColor: "semantic.border.interactive.selected" },
      '&[data-editable="false"]': applyToAllStates$1({
        borderColor: "semantic.border.static"
      }),
      _disabled: {
        borderColor: "semantic.border.interactive.disabled",
        backgroundColor: "semantic.surface.primary.disabled",
        color: "semantic.text.disabled"
      },
      '&[data-focus="true"]': {
        borderColor: "semantic.border.interactive.selected"
      },
      '&[data-readonly="true"]': applyToAllStates$1({
        cursor: "default",
        borderColor: "semantic.border.interactive.disabled",
        backgroundColor: "semantic.surface.primary.disabled",
        color: "semantic.text.secondary"
      }),
      _invalid: applyToAllStates$1({ borderColor: "semantic.border.critical" })
    },
    field: {
      resize: "none",
      padding: "s",
      width: "100%",
      borderRadius: "semantic.input.medium",
      textStyle: "body2",
      overflow: "auto",
      outlineColor: "transparent",
      transition: "outline-color 0.1s ease-in-out",
      _placeholder: {
        color: "semantic.text.secondary"
      },
      '&[data-editable="false"]': {
        color: "semantic.text.primary",
        textStyle: "body4",
        cursor: "default",
        _placeholder: {
          color: "semantic.text.secondary",
          textStyle: "body4"
        }
      },
      _readOnly: {
        cursor: "default",
        backgroundColor: "inherit",
        _placeholder: {
          color: "semantic.text.secondary"
        }
      },
      _disabled: {
        cursor: "not-allowed",
        color: "inherit",
        backgroundColor: "inherit",
        _placeholder: {
          color: "semantic.text.disabled"
        }
      },
      _focusVisible: {
        outlineStyle: "solid",
        outlineColor: "semantic.focus.primary",
        outlineWidth: "2px",
        // This is done here with 4px instead of 2px because of the input-group that wraps the actual textarea element
        outlineOffset: "4px"
      },
      '&[data-loading="true"]': {
        // add loader width padding - left padding (8px) + loader (56px) + right padding (16px)
        paddingRight: "80px"
      }
    },
    loaderContainer: {
      right: 0,
      position: "absolute",
      width: "fit-content",
      paddingRight: "s"
    },
    footerContainer: {
      padding: "s",
      display: "flex",
      alignItems: "center"
    }
  }
}, textFieldTheme = {
  baseStyle: {
    field: {
      ...input.field
    },
    leftElement: {
      height: "100%",
      pointerEvents: "none"
      // Fixes this bug ME-67292
    },
    rightElement: {
      height: "100%"
    },
    loader: {
      marginRight: "s"
    }
  }
}, verificationCodeFieldTheme = {
  baseStyle: ({ length: r }) => ({
    container: {
      maxWidth: "490px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "xs"
    },
    form: {
      gap: "s",
      gridRowGap: "xs",
      justifyContent: "center",
      gridTemplateColumns: `repeat(${r}, minmax(0, 48px))`
    },
    input: {
      textStyle: "body2",
      textAlign: "center",
      paddingLeft: "none"
    }
  })
}, formFieldTheme = {
  baseStyle: ({ error: r, helperText: a, isViewMode: s }) => ({
    container: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "xxs",
      width: "100%",
      justifyContent: "end"
    },
    label: {
      '&[data-hidden="true"]': {
        opacity: 0,
        position: "absolute"
      }
    },
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "100%",
      height: "auto"
    },
    field: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%"
    },
    helperText: {
      textStyle: "body4",
      gap: "m",
      width: "100%",
      display: "flex",
      justifyContent: r || a && !s ? "space-between" : "flex-end",
      color: "semantic.text.secondary",
      height: "16px",
      _invalid: {
        color: "semantic.text.critical.rest"
      },
      _readOnly: {
        color: "semantic.text.secondary"
      },
      _disabled: {
        color: "semantic.text.disabled"
      }
    }
  }),
  sizes: {
    small: {
      fieldGroup: {
        gap: "xxxs"
      },
      field: {
        minHeight: "40px"
      }
    },
    large: {
      fieldGroup: {
        gap: "xxs"
      },
      field: {
        minHeight: "48px"
      }
    }
  }
}, getFixedCellSize = (r) => typeof r == "number" ? {
  minWidth: `${r}px`,
  width: `${r}px`,
  maxWidth: `${r}px`
} : {}, cellAttributesBySize = {
  xs: {
    minWidth: "36px",
    flexShrink: 0,
    flexBasis: 0
  },
  s: {
    minWidth: "80px",
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0
  },
  m: {
    minWidth: "160px",
    flexGrow: 2,
    flexShrink: 0,
    flexBasis: 0
  },
  l: {
    minWidth: "240px",
    flexGrow: 3,
    flexShrink: 0,
    flexBasis: 0
  },
  xl: {
    minWidth: "320px",
    flexGrow: 4,
    flexShrink: 0,
    flexBasis: 0
  },
  xxl: {
    minWidth: "400px",
    flexGrow: 5,
    flexShrink: 0,
    flexBasis: 0
  }
}, formLineItemsTheme = {
  baseStyle: ({ size: r, hasOverflowX: a }) => ({
    container: {
      width: "100%",
      height: "100%",
      isolation: "isolate",
      overflowX: "auto",
      overflowY: "hidden",
      position: "relative",
      borderTopRadius: "l",
      ...a && {
        '[data-is-sticky="true"]': {
          '&[data-component="FormLineItems.HeaderCell"]': {
            borderLeft: "basic.light",
            position: "sticky",
            right: 0,
            top: 0
          },
          '&[data-component="FormLineItems.Cell"]': {
            zIndex: "sticky",
            borderLeft: "basic.light",
            position: "sticky",
            top: 0,
            right: 0,
            boxShadow: 400,
            '[data-is-sticky="true"]': {
              marginLeft: "s"
            }
          }
        }
      }
    },
    headerRow: {
      display: "flex",
      minHeight: "48px"
    },
    headerCell: {
      boxSizing: "content-box",
      backgroundColor: "semantic.surface.secondary.rest",
      borderBottom: "basic.lighter",
      ...getFixedCellSize(r),
      height: "48px"
    },
    // We need a cell content layer cause flex doesn't play well with padding
    headerCellContent: {
      overflowX: "hidden",
      margin: "s"
    },
    body: {
      position: "relative",
      backgroundColor: "semantic.surface.primary.rest",
      flexGrow: 1,
      '&[data-loading="true"]': {
        minHeight: "96px"
      }
    },
    row: {
      position: "relative",
      display: "flex",
      ":first-of-type": {
        "> div": {
          paddingTop: "m"
        }
      }
    },
    cell: {
      boxSizing: "content-box",
      backgroundColor: "semantic.surface.primary.rest",
      height: "72px",
      overflow: "hidden",
      ...getFixedCellSize(r)
    },
    // We need a cell content layer cause flex doesn't play well with padding
    cellContent: {
      height: "100%",
      marginX: "xs",
      marginY: "xxs"
    }
  }),
  sizes: {
    xs: {
      cell: {
        ...cellAttributesBySize.xs
      },
      headerCell: {
        ...cellAttributesBySize.xs
      }
    },
    s: {
      cell: {
        ...cellAttributesBySize.s
      },
      headerCell: {
        ...cellAttributesBySize.s
      }
    },
    m: {
      cell: {
        ...cellAttributesBySize.m
      },
      headerCell: {
        ...cellAttributesBySize.m
      }
    },
    l: {
      cell: {
        ...cellAttributesBySize.l
      },
      headerCell: {
        ...cellAttributesBySize.l
      }
    },
    xl: {
      cell: {
        ...cellAttributesBySize.xl
      },
      headerCell: {
        ...cellAttributesBySize.xl
      }
    },
    xxl: {
      cell: {
        ...cellAttributesBySize.xxl
      },
      headerCell: {
        ...cellAttributesBySize.xxl
      }
    }
  }
}, accordionTheme = {
  baseStyle: {
    container: {
      borderTop: "surface.default",
      borderColor: "semantic.border.static",
      ":last-of-type": {
        borderBottom: "surface.default",
        borderColor: "semantic.border.static"
      }
    },
    button: {
      height: "auto",
      minHeight: "56px",
      padding: "s",
      paddingBottom: "s",
      paddingTop: "s",
      paddingInlineStart: "s",
      paddingInlineEnd: "s",
      outlineOffset: 0,
      _hover: {
        backgroundColor: "semantic.surface.primary.hover"
      },
      _focus: {
        boxShadow: "none"
      },
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        transition: "outline-color 0.2s ease 0s"
      }
    },
    title: {
      flex: "1",
      textAlign: "left",
      textStyle: "body2",
      width: "100%",
      display: "flex",
      alignItems: "center",
      marginRight: "m"
    },
    panel: {
      textStyle: "body3",
      paddingInlineStart: "s",
      paddingInlineEnd: "s",
      paddingBottom: "s",
      paddingTop: "s"
    }
  }
}, applyToAllStates = (r) => ({
  ...r,
  _hover: r,
  _focus: r,
  _selected: r
}), interactiveStyles = (r) => ({
  cursor: r ? "pointer" : "default",
  '&[data-inactive="true"]': { cursor: "default" },
  _disabled: { cursor: "not-allowed" }
}), pseudoStyles = (r, a) => ({
  _before: {
    content: "''",
    position: "absolute",
    pointerEvents: "none",
    inset: "0px",
    borderRadius: "semantic.container.small",
    border: r
  },
  _after: {
    content: "''",
    position: "absolute",
    pointerEvents: "none",
    inset: "0px",
    borderRadius: "semantic.container.small",
    border: a
  }
}), disabledStyles = applyToAllStates({
  backgroundColor: "semantic.surface.primary.disabled",
  shadow: 0,
  ...pseudoStyles("basic.light", "selection.transparent")
}), cardTheme = {
  baseStyle: ({ hasClickHandler: r, paddingX: a, paddingY: s, width: c }) => ({
    container: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      backgroundColor: "semantic.surface.primary.rest",
      borderRadius: "semantic.container.small",
      paddingY: s,
      paddingX: a,
      width: c,
      overflow: "hidden",
      outline: "2px solid transparent",
      outlineOffset: "2px",
      transition: "outline-color 0.2s, box-shadow 0.2s, background-color 0.2s, border-color 0.1s ease-in-out",
      ...interactiveStyles(r)
    },
    input: {
      all: "unset",
      position: "absolute",
      inset: 0,
      pointerEvents: "none",
      zIndex: -1
    }
  }),
  variants: {
    default: ({ hasClickHandler: r }) => ({
      container: {
        shadow: 500,
        ...r && {
          ...pseudoStyles("surface.transparent", "selection.transparent"),
          _hover: { shadow: "600" },
          _focus: {
            outlineWidth: "2px",
            outlineOffset: "2px",
            outlineColor: "semantic.focus.primary"
          },
          _selected: {
            _before: { border: "surface.transparent" },
            _after: { border: "selection.selectedBrand" }
          }
        },
        '&[data-inactive="true"]': applyToAllStates({
          backgroundColor: "semantic.surface.primary.disabled",
          shadow: 500,
          ...pseudoStyles("surface.transparent", "selection.transparent")
        }),
        _disabled: disabledStyles
      }
    }),
    flat: ({ hasClickHandler: r }) => ({
      container: {
        borderRadius: "semantic.container.small",
        border: "none",
        backgroundColor: "semantic.surface.primary.rest",
        ...applyToAllStates({ shadow: 0 }),
        ...pseudoStyles("basic.dark", "selection.transparent"),
        ...r && {
          _hover: {
            backgroundColor: "semantic.surface.primary.hover",
            _before: { border: "basic.black" }
          },
          _focus: {
            outlineWidth: "2px",
            outlineOffset: "2px",
            outlineColor: "semantic.focus.primary",
            _hover: { _after: { border: "basic.black" } }
          },
          _selected: {
            shadow: 0,
            _before: { border: "surface.transparent" },
            _after: { border: "selection.selectedBrand" }
          }
        },
        '&[data-inactive="true"]': applyToAllStates({
          backgroundColor: "semantic.surface.primary.disabled",
          ...pseudoStyles("basic.light", "selection.transparent")
        }),
        _disabled: disabledStyles
      }
    })
  }
}, collapsibleCardTheme = {
  baseStyle: {
    header: {
      color: "semantic.text.primary",
      width: "100%",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      padding: "m",
      userSelect: "none",
      '&[data-inactive="true"]': {
        opacity: "0.65",
        cursor: "not-allowed"
      },
      _disabled: {
        color: "semantic.text.disabled",
        cursor: "not-allowed"
      }
    },
    customHeader: {
      width: "100%",
      _disabled: {
        opacity: "0.35"
      }
    },
    content: {
      padding: "m",
      paddingTop: "none",
      display: "flex",
      flexDirection: "column",
      gap: "m",
      cursor: "default"
    }
  }
}, headerGap = "m", headerWidth = "100%", labelMaxWidth = "80%", collapsibleTheme = {
  baseStyle: {
    header: {
      display: "flex",
      width: headerWidth,
      minHeight: "24px",
      alignItems: "center",
      justifyContent: "space-between",
      gap: headerGap
    },
    labelAndIcon: {
      display: "flex",
      gap: "xxs",
      alignItems: "center",
      justifyContent: "flex-start",
      textStyle: "body3Semi",
      color: "semantic.text.secondary",
      width: "max-content",
      maxWidth: labelMaxWidth,
      flexGrow: 1,
      _hover: {
        color: "semantic.text.primary",
        cursor: "pointer"
      },
      "&[data-full-view=true]": {
        width: "100%",
        justifyContent: "space-between",
        maxWidth: "100%"
      },
      _active: {
        color: "semantic.text.primary"
      }
    },
    secondaryLabel: {
      display: "flex",
      alignItems: "center",
      textStyle: "body4Semi",
      color: "semantic.text.secondary",
      flexShrink: 0,
      maxWidth: `calc(${headerWidth} - ${labelMaxWidth} - ${getThemeSpacingAsNumber(headerGap)}px)`
    }
  }
}, widthsMapping = {
  full: "100%",
  "fit-content": "fit-content",
  "min-content": "min-content",
  auto: "auto"
}, heightsMapping = {
  full: "100%",
  "fit-content": "fit-content",
  "min-content": "min-content",
  auto: "auto"
}, BackgroundColorOptions = {
  Light: "light",
  White: "white",
  Default: "default"
}, BorderOptions = {
  None: "none",
  Regular: "regular",
  Dashed: "dashed"
}, BorderStyle = {
  [BorderOptions.None]: {
    border: "none"
  },
  [BorderOptions.Regular]: {
    border: "surface.default",
    borderColor: "semantic.border.static",
    borderRadius: "semantic.container.small"
  },
  [BorderOptions.Dashed]: {
    border: "input-dashed.enabled",
    borderColor: "semantic.border.interactive.rest",
    borderRadius: "semantic.container.small"
  }
}, BackgroundStyle$1 = {
  default: "transparent",
  light: "semantic.surface.secondary.rest",
  white: "semantic.surface.primary.rest"
}, containerTheme = {
  baseStyle: ({
    paddingX: r,
    paddingY: a,
    paddingTop: s,
    paddingBottom: c,
    paddingLeft: u,
    paddingRight: d,
    border: h,
    backgroundColor: p,
    width: m,
    height: g,
    isSticky: v,
    alignItems: y,
    justifyContent: x,
    textAlign: w,
    overflow: S,
    position: M,
    maxWidth: P,
    top: L,
    bottom: I,
    left: T,
    right: E
  }) => ({
    paddingX: r,
    paddingY: a,
    paddingTop: s,
    paddingBottom: c,
    paddingLeft: u,
    paddingRight: d,
    alignItems: y,
    justifyContent: x,
    textAlign: w,
    ...BorderStyle[h],
    backgroundColor: BackgroundStyle$1[p],
    width: widthsMapping[m],
    height: heightsMapping[g],
    overflow: S,
    display: x || y ? "flex" : "block",
    maxWidth: P,
    position: M,
    top: L,
    bottom: I,
    left: T,
    right: E,
    ...v && {
      position: "sticky",
      top: 0
    }
  })
}, drawerTheme = {
  baseStyle: {
    content: {
      display: "flex",
      flexDirection: "column",
      zIndex: "modal",
      backgroundColor: "semantic.surface.primary.rest",
      height: "100%",
      width: "100%"
    },
    header: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "s",
      paddingY: { xs: "s", s: "m" },
      paddingX: { xs: "s", s: "l" }
    },
    body: {
      padding: { xs: "s", s: "l" }
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      borderTop: "basic.light",
      borderColor: "semantic.border.static",
      height: "80px",
      paddingY: "s",
      paddingX: "s"
    }
  }
}, groupTheme = {
  baseStyle: ({ spacing: r, width: a, height: s, allowOverflowX: c }) => ({
    display: "flex",
    gap: r,
    width: a,
    height: s,
    // Both `minWidth` and `maxWidth` are necessary to support text-ellipsis in descendant elements
    minWidth: 0,
    maxWidth: "100%",
    overflowX: c ? "auto" : "initial"
  }),
  variants: {
    horizontal: {
      flexDirection: "row"
    },
    vertical: {
      flexDirection: "column"
    }
  }
}, groupItemTheme = {
  baseStyle: ({ order: r, grow: a, shrink: s, basis: c, alignSelf: u }) => ({
    order: r,
    flexGrow: a,
    flexShrink: s,
    flexBasis: c,
    alignSelf: u,
    // `minWidth` is necessary for text-ellipsis to work
    minWidth: 0
  })
}, loadingContainerTheme = {
  baseStyle: ({ isLoading: r }) => ({
    loadingContainer: {
      position: "relative",
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      minHeight: "inherit"
    },
    loaderContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    childrenContainer: {
      height: "100%",
      opacity: r ? 0 : 1,
      minHeight: "inherit",
      display: "flex",
      flexDirection: "column"
    }
  })
}, baseMenuTheme = {
  baseStyle: ({ width: r, maxHeight: a, maxWidth: s, dropdownListPaddingY: c }) => ({
    dropdown: {
      ...r && { width: r },
      maxWidth: s,
      overflow: "hidden",
      borderRadius: "semantic.container.small",
      boxShadow: 500,
      border: "basic.light",
      backgroundColor: "semantic.surface.primary.rest",
      maxHeight: a,
      display: "flex",
      _focusVisible: {
        outline: "none"
      }
    },
    dropdownList: {
      height: "100%",
      overflowY: "auto",
      paddingY: c
    },
    item: {
      width: "100%",
      transition: "background-color 0.1s ease-in-out",
      textStyle: "body3",
      paddingX: "s",
      paddingY: "xs-s",
      minHeight: "48px",
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      cursor: "pointer",
      _highlighted: {
        backgroundColor: "semantic.surface.primary.hover"
      },
      _hover: {
        backgroundColor: "semantic.surface.primary.hover"
      },
      _focus: {
        backgroundColor: "semantic.surface.primary.hover",
        outline: "none"
      },
      _focusVisible: {
        backgroundColor: "semantic.surface.primary.hover",
        outline: "none"
      },
      _active: {
        backgroundColor: "semantic.surface.primary.pressed"
      },
      _selected: {
        backgroundColor: "semantic.surface.primary.selected"
      },
      _disabled: {
        backgroundColor: "unset",
        cursor: "not-allowed",
        color: "semantic.text.disabled"
      }
    },
    sectionLabel: {
      color: "semantic.text.secondary",
      textStyle: "body4Semi"
    }
  })
}, flatMenuTheme = {
  baseStyle: ({ maxHeight: r }) => ({
    width: "100%",
    height: "100%",
    maxHeight: r,
    backgroundColor: "semantic.surface.primary.rest"
  })
}, _menuFooterTheme = {
  baseStyle: {
    height: { xs: "auto", s: "56px" },
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingX: { xs: "none", s: "s" },
    paddingY: { xs: "none", s: "xs" },
    _focusVisible: {
      outlineOffset: "-2px"
    }
  }
}, _menuTitleTheme = {
  baseStyle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingX: "s",
    paddingTop: { xs: "none", s: "xs" },
    height: "40px"
  }
}, _menuTriggerTheme = {
  baseStyle: {
    display: "inline-block",
    width: "100%",
    height: "100%",
    position: "relative",
    _readOnly: {
      cursor: "default"
    },
    _disabled: { cursor: "not-allowed" }
  }
}, sheetMaxHeight = `100vh - ${themeSpaces.l}`, menuListPaddingY = `${themeSpaces.s} * 2`, titleHeight = "32px", titleAndGapHeight = `${titleHeight} - ${themeSpaces.xs}`, _mobileMenuDropdownTheme = {
  baseStyle: ({ hasTitle: r }) => ({
    title: {
      display: "flex",
      alignItems: "center",
      minHeight: titleHeight,
      height: "100%"
    },
    items: {
      overflowY: "auto",
      maxHeight: `calc(${sheetMaxHeight} - ${menuListPaddingY} - ${r ? titleAndGapHeight : "0px"})`
    }
  })
}, baseModalTheme = {
  baseStyle: ({ isLoading: r, showBorderTop: a, showBorderBottom: s, isBodyOverflowing: c, bottomSheetProps: u }) => {
    const d = themeSpaces.l;
    return {
      modalFloatingContent: {
        display: "flex",
        flexDirection: "column",
        height: "inherit",
        maxHeight: "inherit",
        minHeight: "inherit",
        paddingBottom: "m",
        justifyContent: "inherit"
      },
      modalContent: {
        minHeight: "248px",
        top: `${d}`,
        maxHeight: `calc(100vh - 2*${d})`,
        justifyContent: r ? "center" : "flex-start",
        padding: "none",
        overflow: "hidden",
        zIndex: "modal",
        marginY: "none",
        borderRadius: "global.400",
        backgroundColor: "semantic.surface.primary.rest",
        boxShadow: 500
      },
      header: {
        flexShrink: 0,
        paddingLeft: { xs: "none", s: "m" },
        paddingRight: {
          xs: "none",
          // header right padding + close icon + padding from close icon
          s: `calc(${themeSpaces.m} + ${themeSpaces.xl} + ${themeSpaces.m})`
        },
        paddingTop: { xs: "none", s: "m" },
        paddingBottom: { xs: "none", s: "m" }
      },
      mobileModalContent: {
        display: "flex",
        flexDirection: "column",
        paddingBottom: "s",
        height: "inherit",
        maxHeight: "inherit",
        minHeight: "inherit"
      },
      body: {
        height: "100%",
        width: "100%",
        flexGrow: 1,
        /// BottomSheet have overflowY:auto, so When it warppes the BaseModal.Body (on mobile), the BaseModal.Body don't need an overflowY.
        overflowY: { xs: "unset", s: "auto" },
        display: "flex",
        flexDirection: "column",
        paddingX: { xs: "s", s: "m" },
        paddingTop: { xs: "s", s: "xs" },
        paddingBottom: { xs: "s", s: "xs" },
        ...a && { borderTop: "basic.light" },
        // Has footer
        "&:not(:last-child)": {
          ...s && { borderBottom: "basic.light" }
        },
        // No footer
        ":last-child": {
          ...c && { paddingBottom: "none" }
        }
      },
      footer: {
        flexShrink: 0,
        ...u ? {
          position: "sticky",
          bottom: 0,
          zIndex: "sticky",
          backgroundColor: "semantic.surface.primary.rest",
          paddingX: u.paddingX,
          ...u.isOverflow ? { paddingY: u.paddingY } : { paddingTop: u.paddingY },
          ...u.showFooterBorder && {
            borderTop: "basic.light",
            borderColor: "semantic.border.static"
          }
        } : {
          paddingX: "m",
          paddingTop: "m"
        }
      },
      closeButton: {
        position: "absolute",
        top: { xs: "s", s: "m" },
        right: { xs: "s", s: "m" },
        zIndex: "docked"
      }
    };
  },
  sizes: {
    small: {
      modalContent: {
        width: "560px",
        marginX: "none"
      }
    },
    medium: {
      modalContent: {
        width: { s: "100%", l: "858px" },
        marginX: { s: "xxl", l: "none" }
      }
    },
    large: {
      modalContent: {
        width: "100%",
        marginX: "xxl"
      }
    }
  }
}, getAssetAspectRatio = (r) => {
  switch (r) {
    case "1 / 1":
      return "1 / 1";
    case "16 / 9":
      return "16 / 9";
    case "4 / 3":
      return "4 / 3";
    default:
      return "7 / 3";
  }
}, promotionalModalTheme = {
  baseStyle: ({ assetAspectRatio: r }) => ({
    borderTopRadius: "l",
    display: "block",
    justifyContent: "center",
    width: "100%",
    height: "fit-content",
    maxHeight: "560px",
    aspectRatio: getAssetAspectRatio(r),
    marginBottom: "s",
    "> *": {
      aspectRatio: "inherit"
    }
  })
}, panelTheme = {
  baseStyle: ({
    backgroundColor: r = "semantic.surface.inverse",
    paddingX: a,
    paddingY: s,
    maxWidth: c = "100%",
    width: u = "100%"
  }) => ({
    container: {
      position: "sticky",
      zIndex: "sticky",
      boxSizing: "content-box",
      width: u,
      maxWidth: c,
      '&[data-position="fixed"]': {
        position: "fixed"
      },
      '&[data-position="absolute"]': {
        position: "absolute"
      },
      '&[data-placement="bottom"]': {
        bottom: 0
      },
      '&[data-placement="top"]': {
        top: 0
      },
      '&[data-placement="left"]': {
        top: 0,
        left: 0,
        bottom: 0,
        width: "auto"
      },
      '&[data-placement="right"]': {
        top: 0,
        right: 0,
        bottom: 0,
        width: "auto"
      }
    },
    bar: {
      backgroundColor: r,
      paddingY: s ?? "s",
      paddingX: a ?? "m",
      '&[data-placement="bottom"]': {
        borderTopRadius: "l"
      },
      '&[data-placement="top"]': {
        borderBottomRadius: "l"
      },
      '&[data-placement="left"]': {
        borderRightRadius: "l",
        paddingX: a ?? "s",
        height: "100%"
      },
      '&[data-placement="right"]': {
        borderLeftRadius: "l",
        paddingX: a ?? "s",
        height: "100%"
      }
    }
  })
}, STACK_HEIGHT_IN_PX = 10, stackedContainerTheme = {
  baseStyle: ({ paddingX: r, paddingY: a, border: s, stacksToDisplay: c }) => {
    const u = BorderStyle[s], { border: d, borderRadius: h } = u, p = {
      borderBottom: d,
      borderRight: d,
      borderLeft: d,
      height: `${STACK_HEIGHT_IN_PX}px`,
      borderBottomRadius: h
    };
    return {
      wrapper: { ...{
        position: "relative",
        ...c > 0 && {
          marginBottom: `${2 * STACK_HEIGHT_IN_PX}px`
        }
      } },
      container: {
        paddingX: r,
        paddingY: a,
        ...u,
        backgroundColor: "transparent",
        // This overrides Chakra's Box's default of maxWidth: 60ch
        maxWidth: "none",
        overflow: "hidden"
      },
      stacksContainerItemsWrapper: {
        position: "absolute",
        bottom: `${c * STACK_HEIGHT_IN_PX * -1}px`,
        width: "100%"
      },
      firstStack: {
        ...p,
        marginX: "xs"
      },
      secondStack: {
        ...p,
        marginX: "s"
      }
    };
  }
}, illustrationTheme = {
  baseStyle: {
    display: "inline-flex"
  },
  sizes: {
    small: {
      height: "96px"
    },
    medium: {
      height: "120px"
    },
    large: {
      height: "144px"
    }
  }
}, getSharedStyles = (r) => ({
  position: "absolute",
  left: "8px",
  width: "8px",
  height: "8px",
  borderRadius: "full",
  backgroundColor: r
}), loaderTheme = {
  baseStyle: ({ color: r }) => ({
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "16px",
      overflow: "hidden"
    },
    dots: {
      position: "relative",
      width: "56px",
      height: "8px"
    },
    first: getSharedStyles(r),
    second: getSharedStyles(r),
    third: { ...getSharedStyles(r), left: "24px" },
    forth: { ...getSharedStyles(r), left: "40px" }
  })
}, logoTheme = {
  baseStyle: {
    display: "flex"
  },
  sizes: {
    small: {
      height: "24px"
    },
    large: {
      height: "32px"
    }
  }
}, sharedHeaderStyle = {
  width: "inherit",
  top: 0,
  left: 0,
  position: "fixed",
  backgroundColor: "semantic.background.brand.primary"
}, externalLayoutTheme = {
  baseStyle: ({ columns: r }) => ({
    container: {
      height: "100%",
      width: "100%",
      position: "relative",
      backgroundColor: "semantic.background.primary",
      // Aligns the loader to the center
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
      height: "inherit",
      width: "inherit",
      alignItems: "center",
      overflowY: "auto",
      _focusVisible: {
        outlineColor: "semantic.focus.primary",
        outlineWidth: "2px"
      }
    },
    header: {
      ...sharedHeaderStyle,
      height: { xs: "56px", s: "176px" }
    },
    fixedHeader: {
      ...sharedHeaderStyle,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      alignItems: "center",
      height: { xs: "56px", s: "72px" },
      paddingX: { xs: "s", s: "m", xl: "m" },
      zIndex: 1100,
      gap: "xs"
    },
    headerContainer: {
      gridRow: "1 / -1",
      justifySelf: "flex-end"
    },
    logoContainer: {
      gridRow: "-1 / 1",
      justifySelf: "flex-start"
    },
    grid: {
      maxWidth: { l: "1182px", xl: "1638px" },
      display: "grid",
      gridTemplateColumns: `repeat(${r}, minmax(0, 1fr))`,
      gridTemplateRows: "1fr",
      height: "inherit",
      width: "inherit",
      gap: { xs: "s", s: "m" },
      paddingX: { xs: "none", s: "xxl", xl: "xxl" },
      paddingY: { xs: "none", s: "xxxl" },
      overflow: "initial",
      flexGrow: 1,
      zIndex: { xs: 0, s: 1e3 }
    },
    gridItemContent: {
      display: "flex",
      flexDirection: "column",
      marginTop: { xs: "56px", s: "none" },
      gap: { xs: "m", s: "l", xl: "xl" },
      width: "100%",
      gridColumnStart: { xs: 1, s: 2, m: 3, xl: 6 },
      gridColumnEnd: { xs: -1, s: -2, m: -3, xl: -6 }
    }
  })
}, getPanelPadding = (r) => r ? { padding: r } : {
  paddingX: { s: "xxl", xs: "s" },
  paddingY: { xs: "s", s: "xl", xl: "xxl" }
}, splitScreenTheme = {
  baseStyle: ({ panelPadding: r }) => ({
    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      _loading: {
        justifyContent: "center",
        alignItems: "center"
      }
    },
    resizableBar: {
      flexBasis: "1px",
      flexShrink: "0",
      flexDirection: "column",
      position: "relative",
      outline: "none",
      transition: "background-color 0.2s ease-in-out",
      backgroundColor: "semantic.fill.tertiary",
      "&[data-resize-handle-active]": {
        backgroundColor: "global.neutral.600"
      }
    },
    handle: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "semantic.fill.secondary",
      padding: "xxs",
      borderRadius: "m"
    },
    panel: {
      height: { l: "100%", xs: "initial" },
      display: "flex",
      flexDirection: "column",
      overflow: { l: "initial", xs: "auto" },
      flexGrow: { l: "initial", xs: "1" },
      _loading: {
        justifyContent: "center",
        alignItems: "center"
      }
    },
    panelHeader: { display: "flex", flexShrink: 0 },
    panelFooter: { display: "flex", flexShrink: 0 },
    panelContent: {
      ...getPanelPadding(r),
      flexGrow: "1",
      overflow: { l: "auto", xs: "initial" }
    }
  })
}, BackgroundStyle = {
  default: "transparent",
  white: "semantic.background.primary",
  lightest: "semantic.background.secondary"
}, getContentPadding = (r) => ({
  padding: r ?? { xs: "s", m: "m", l: "l", xl: "xxl" }
}), layoutTheme = {
  baseStyle: ({ maxWidth: r, isLoading: a, backgroundColor: s, paddingContent: c }) => ({
    container: {
      height: "100%",
      width: "100%",
      backgroundColor: BackgroundStyle[s],
      display: "flex",
      flexDirection: "column",
      position: "relative",
      justifyContent: a ? "center" : "unset"
    },
    header: {
      width: "100%",
      flexShrink: 0
    },
    contentContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      alignItems: "center",
      overflow: "auto"
    },
    contentWrapper: {
      display: "flex",
      justifyContent: "center",
      flexGrow: 1,
      width: "100%",
      ...getContentPadding(c)
    },
    content: {
      flexGrow: 1,
      width: "100%",
      maxWidth: r
    },
    footer: {
      width: "100%",
      flexShrink: 0
    }
  })
}, SingleStyleConfigComponents = {
  AmountField: amountFieldTheme,
  _BaseBadge: _baseBadgeTheme,
  Chip: chipTheme,
  PromotionalModal: promotionalModalTheme,
  Counter: counterTheme,
  _Description: _descriptionTheme,
  _MenuTitle: _menuTitleTheme,
  _MenuFooter: _menuFooterTheme,
  BaseIcon: baseIconTheme,
  FlagIcon: flagIconTheme,
  BrandSymbol: brandSymbolTheme,
  Brand: brandTheme,
  Calendar: calendarTheme,
  FloatingButton: floatingButtonTheme,
  _SectionLabel: _sectionLabelTheme,
  Illustration: illustrationTheme,
  Link: linkTheme,
  Logo: logoTheme,
  Lottie: lottieTheme,
  NakedButton: nakedButtonTheme,
  NavigationItem: navigationItemTheme,
  RadioGroup: radioGroupTheme,
  Tracker: trackerTheme,
  TableCell: tableCellTheme,
  _TableHeaderBaseCell: _tableHeaderBaseCellTheme,
  _TableDataCell: _tableDataCellTheme,
  TableHeaderCell: tableHeaderCellTheme,
  TableMenuTriggerHeaderCell: tableMenuTriggerHeaderCellTheme,
  _MenuTrigger: _menuTriggerTheme,
  Container: containerTheme,
  Group: groupTheme,
  Skeleton: skeletonTheme,
  SkeletonCircle: skeletonCircleTheme,
  SkeletonText: skeletonTextTheme,
  GroupItem: groupItemTheme,
  Text: textTheme,
  FlatMenu: flatMenuTheme
}, MultiStyleConfigComponents = {
  AmountInput: amountInputTheme,
  BaseModal: baseModalTheme,
  _BaseSheet: _baseSheetTheme,
  _Paragraph: _paragraphTheme,
  _ParagraphList: _paragraphListTheme,
  _MainLabel: _mainLabelTheme,
  _Label: _labelTheme,
  TextArea: textAreaTheme,
  Input: textFieldTheme,
  BaseSelect: baseSelectTheme,
  Accordion: accordionTheme,
  Avatar: avatarTheme,
  Button: buttonTheme,
  Card: cardTheme,
  Checkbox: checkboxTheme,
  Badge: badgeTheme,
  _BaseCalendar: _baseCalendarTheme,
  CalendarLegend: calendarLegendTheme,
  Currency: currencyTheme,
  _BaseFileUpload: _baseFileUploadTheme,
  DateField: dateFieldTheme,
  Divider: dividerTheme,
  DatePicker: datePickerTheme,
  Collapsible: collapsibleTheme,
  CollapsibleCard: collapsibleCardTheme,
  FormField: formFieldTheme,
  Form: formTheme,
  IconButton: iconButtonTheme,
  Image: imageTheme,
  InteractiveButton: interactiveButtonTheme,
  AvatarWithDetails: avatarWithDetailsTheme,
  BasePopover: basePopoverTheme,
  Beacon: beaconTheme,
  LinearProgress: linearProgressTheme,
  CircularProgress: circularProgressTheme,
  Radio: radioTheme,
  DeprecatedSearch: deprecatedSearchBarTheme,
  SearchBar: searchBarTheme,
  Switch: switchTheme,
  DeprecatedTabs: deprecatedTabsTheme,
  Tabs: tabsTheme,
  Toast: toastTheme,
  Table: tableTheme,
  TableMobileContainer: tableMobileContainerTheme,
  TableSelectCell: tableSelectCellTheme,
  TableHeaderSortableCell: tableHeaderSortableCellTheme,
  _TableAmountInput: _tableAmountInputTheme,
  Tooltip: tooltipTheme,
  TrackerStep: trackerStepTheme,
  SectionBanner: sectionBannerTheme,
  StatusBar: statusBarTheme,
  AvatarImageControl: avatarImageControlTheme,
  FileAttachment: fileAttachmentTheme,
  LargeFileUpload: largeFileUploadTheme,
  TableAmountCell: tableAmountCellTheme,
  CustomInputContainer: customInputContainerTheme,
  LoadingContainer: loadingContainerTheme,
  Loader: loaderTheme,
  Drawer: drawerTheme,
  StatusIndicator: statusIndicatorTheme,
  AvatarGroup: avatarGroupTheme,
  VerificationCodeField: verificationCodeFieldTheme,
  Blanket: blanketTheme,
  ActionBar: actionBarTheme,
  _MobileMenuDropdown: _mobileMenuDropdownTheme,
  BaseVirtualCard: baseVirtualCardTheme,
  BaseVirtualCardDetails: baseVirtualCardDetailsTheme,
  VirtualCard: virtualCardTheme,
  SecuredTextField: securedTextFieldTheme,
  StackedContainer: stackedContainerTheme,
  SelectNew: selectNewTheme,
  Panel: panelTheme,
  // layouts
  ExternalLayout: externalLayoutTheme,
  SplitScreen: splitScreenTheme,
  Layout: layoutTheme,
  BaseMenu: baseMenuTheme,
  FormLineItems: formLineItemsTheme
}, components$7 = {
  ...MultiStyleConfigComponents,
  ...SingleStyleConfigComponents
}, styles = {
  global: {
    // Compensates for the parent `ul`'s `paddingInlineStart` since it's not inside melio-wrapper.
    "#chakra-toast-manager-top": {
      padding: 0
    },
    "melio-wrapper > div": {
      isolation: "isolate",
      display: "block",
      fontFamily: "primary",
      color: "semantic.text.primary",
      bg: "semantic.surface.primary.rest",
      // `html` tag reset
      lineHeight: "1.5",
      webkitTextSizeAdjust: "100%",
      webkitFontSmoothing: "antialiased",
      textRendering: "optimizeLegibility",
      mozOsxFontSmoothing: "grayscale",
      touchAction: "manipulation",
      // `body` tag reset
      height: "100%",
      minHeight: "100%",
      fontFeatureSettings: "kern",
      // Nested
      "*, *::before, *::after": {
        borderWidth: "0",
        borderStyle: "solid",
        boxSizing: "border-box"
      },
      main: {
        display: "block"
      },
      ".emphasize": {
        color: "global.neutral.900",
        fontStyle: "inherit"
      },
      hr: {
        borderTopWidth: "1px",
        boxSizing: "content-box",
        height: "0",
        overflow: "visible"
      },
      a: {
        backgroundColor: "transparent",
        color: "inherit",
        textDecoration: "inherit"
      },
      "abbr[title]": {
        borderBottom: "none",
        textDecoration: "underline dotted",
        webkitTextDecoration: "underline dotted",
        fallbacks: [
          {
            textDecoration: "underline"
          }
        ]
      },
      "b, strong": {
        fontWeight: 700
      },
      mark: {
        backgroundColor: "transparent",
        color: "inherit",
        fontWeight: 700
      },
      small: {
        fontSize: "80%"
      },
      "sub, sup": {
        fontSize: "75%",
        lineHeight: "0",
        position: "relative",
        verticalAlign: "baseline"
      },
      sub: {
        bottom: "-0.25em"
      },
      sup: {
        top: "-0.5em"
      },
      img: {
        borderStyle: "none",
        maxWidth: "100%",
        height: "auto"
      },
      "button, input, optgroup, select, textarea": {
        fontFamily: "inherit",
        fontSize: "100%",
        lineHeight: "inherit",
        margin: "0",
        padding: "0",
        fallbacks: [
          {
            lineHeight: "1.15"
          }
        ],
        color: "inherit"
      },
      "button, input": {
        overflow: "visible"
      },
      "button, select": {
        textTransform: "none"
      },
      'button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner': {
        borderStyle: "none",
        padding: "0"
      },
      fieldset: {
        padding: "0",
        margin: "0",
        fallbacks: [
          {
            padding: "0.35em 0.75em 0.625em"
          }
        ]
      },
      legend: {
        boxSizing: "border-box",
        color: "inherit",
        display: "table",
        maxWidth: "100%",
        padding: "0",
        whiteSpace: "normal"
      },
      progress: {
        verticalAlign: "baseline"
      },
      textarea: {
        overflow: "auto",
        resize: "vertical"
      },
      '[type="checkbox"], [type="radio"]': {
        boxSizing: "border-box",
        padding: "0"
      },
      '[type="number"]': {
        "::-webkit-inner-spin-button, ::-webkit-outer-spin-button": {
          appearance: "none !important"
        }
      },
      'input[type="text"]': {
        outline: "none"
      },
      'input[type="text"]:disabled': {
        backgroundColor: "semantic.primary.disabled"
      },
      'input[type="number"]': {
        mozAppearance: "textfield"
      },
      '[type="search"]': {
        appearance: "textfield",
        outlineOffset: "-2px"
      },
      '[type="search"]::-webkit-search-decoration': {
        appearance: "none !important"
      },
      "::-webkit-file-upload-button": {
        appearance: "button",
        font: "inherit"
      },
      'input[type="date"]::-webkit-inner-spin-button, input[type="date"]::-webkit-calendar-picker-indicator': {
        display: "none",
        appearance: "none"
      },
      details: {
        display: "block"
      },
      summary: {
        display: "list-item"
      },
      template: {
        display: "none"
      },
      "[hidden]": {
        display: "none !important"
      },
      "body, blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre": {
        margin: "0"
      },
      button: {
        background: "transparent",
        padding: "0",
        textAlign: "initial"
      },
      "ol, ul": {
        margin: "0",
        padding: "0"
      },
      'button, [role="button"]': {
        cursor: "pointer"
      },
      "button::-moz-focus-inner": {
        border: "0 !important"
      },
      table: {
        borderCollapse: "collapse"
      },
      "h1, h2, h3, h4, h5, h6": {
        fontSize: "inherit",
        fontWeight: "inherit"
      },
      "img, svg, video, canvas, audio, iframe, embed, object": {
        display: "block"
      },
      "[data-js-focus-visible] :focus:not([data-focus-visible-added])": {
        outline: "none",
        boxShadow: "none"
      },
      "select::-ms-expand": {
        display: "none"
      }
    }
  }
}, melioBaseTheme = {
  space: themeSpaces,
  breakpoints: themeBreakpoints,
  fonts,
  shadows,
  textStyles,
  icons,
  styles,
  components: components$7,
  sizes,
  zIndices,
  config: { useSystemColorMode: !0, cssVarPrefix: "penny" },
  direction: "ltr",
  fontSizes: {},
  fontWeights: {},
  letterSpacings: {},
  lineHeights: {},
  transition: {}
}, extendTheme = ({
  colors: r = {},
  borderRadii: a = {},
  ...s
}) => {
  const c = getColorPalettes(r), u = getBorders(c), d = getBorderRadii(a);
  return extendTheme$1(melioBaseTheme, s, {
    ...melioBaseTheme,
    borders: u,
    colors: c,
    radii: lodashExports.merge(d, radii),
    /// Keep the old radii tokens until we will finish the migretion [ME-77047]
    components: cleanChakraComponents()
  });
}, cleanChakraComponents = () => {
  const {
    Form: r,
    Input: a,
    Select: s,
    Button: c,
    Heading: u,
    Tabs: d,
    Badge: h,
    Avatar: p,
    Tooltip: m,
    Table: g,
    Link: v,
    Modal: y,
    Drawer: x,
    ...w
  } = theme.components;
  return {
    ...w,
    Form: {
      ...r,
      baseStyle: {
        ...r.baseStyle,
        helperText: {}
      }
    },
    Modal: {
      ...y,
      baseStyle: (S) => ({
        ...y.baseStyle(S),
        header: {},
        // this is to remove the default style
        body: {},
        // this is to remove the default style
        footer: {
          display: "block"
        }
      })
    },
    Drawer: {
      ...x,
      baseStyle: (S) => ({
        ...x.baseStyle(S),
        header: {}
        // this is to remove the default style
      })
    }
  };
}, ThemeProvider = ({ theme: r, children: a }) => {
  const { icons: s, colors: c = {}, borderRadii: u = {}, logos: d, illustrations: h, loader: p, ...m } = r, g = extendTheme({ colors: c, borderRadii: u, ...m });
  return /* @__PURE__ */ jsx(ColorPalettesProvider, { colors: c, children: /* @__PURE__ */ jsx(BorderRadiiProvider, { borderRadii: u, children: /* @__PURE__ */ jsx(ChakraProvider, { resetCSS: !1, cssVarsRoot: "melio-wrapper", theme: g, portalZIndex: 40, children: /* @__PURE__ */ jsx(IconsProvider, { icons: s, children: /* @__PURE__ */ jsx(LogosProvider, { logos: d, children: /* @__PURE__ */ jsx(IllustrationsProvider, { illustrations: h, children: /* @__PURE__ */ jsx(LoaderProvider, { loader: p, children: /* @__PURE__ */ jsx(MelioWrapper, { children: a }) }) }) }) }) }) }) });
}, PennyProvider = ({
  children: r,
  ...a
}) => /* @__PURE__ */ jsx(ThemeProvider, { ...a, children: r }), useBorderRadii = () => useContext$1(BorderRadiiContext), defaultCurrency = "USD", defaultCurrencySign = "$", defaultIntegerLimit = Number.MAX_SAFE_INTEGER, currencyDictionary = {
  AUD: {
    label: "Australian dollar",
    flag: "AU",
    sign: "$",
    currencyCode: "AUD"
  },
  USD: {
    label: "United States dollar",
    flag: "US",
    sign: "$",
    currencyCode: "USD"
  },
  EUR: {
    label: "Eurozone Countries",
    flag: "EU",
    sign: "€",
    currencyCode: "EUR"
  },
  GBP: {
    label: "British pounds",
    flag: "GB",
    sign: "£",
    currencyCode: "GBP"
  },
  INR: {
    label: "Indian roupee",
    flag: "IN",
    sign: "₹",
    currencyCode: "INR"
  },
  CAD: {
    label: "Canadian dollar",
    flag: "CA",
    sign: "$",
    currencyCode: "CAD"
  },
  SGD: {
    label: "Singapore Dollar",
    flag: "SG",
    sign: "$",
    currencyCode: "SGD"
  },
  ILS: {
    label: "Israeli New Sheqel",
    flag: "IL",
    sign: "₪",
    currencyCode: "ILS"
  },
  CHF: {
    label: "Swiss Franc",
    flag: "CH",
    sign: "CHF",
    currencyCode: "CHF"
  },
  CNY: {
    label: "Chinese Yuan",
    flag: "CN",
    sign: "¥",
    currencyCode: "CNY"
  },
  HKD: {
    label: "Hong Kong Dollar",
    flag: "HK",
    sign: "$",
    currencyCode: "HKD"
  },
  JPY: {
    label: "Japanese Yen",
    flag: "JP",
    sign: "¥",
    currencyCode: "JPY"
  },
  MXN: {
    label: "Mexican Peso",
    flag: "MX",
    sign: "$",
    currencyCode: "MXN"
  },
  NZD: {
    label: "New Zealand Dollar",
    flag: "NZ",
    sign: "$",
    currencyCode: "NZD"
  },
  SEK: {
    label: "Swedish Krona",
    flag: "SE",
    sign: "kr",
    currencyCode: "SEK"
  },
  PLN: {
    label: "Polish Złoty",
    flag: "PL",
    sign: "zł",
    currencyCode: "PLN"
  },
  PHP: {
    label: "Philippine Peso",
    flag: "PH",
    sign: "₱",
    currencyCode: "PHP"
  },
  BRL: {
    label: "Brazilian Real",
    flag: "BR",
    sign: "R$",
    currencyCode: "BRL"
  },
  GEL: {
    label: "Georgian Lari",
    flag: "GE",
    sign: "₾",
    currencyCode: "GEL"
  },
  KRW: {
    label: "South Korean Won",
    flag: "KR",
    sign: "₩",
    currencyCode: "KRW"
  },
  VND: {
    label: "Vietnamese dong",
    flag: "VN",
    sign: "₫",
    currencyCode: "VND"
  }
}, defaultCurrencyDetails = {
  label: "United States dollar",
  flag: "US",
  sign: "$",
  currencyCode: "USD"
}, nonDecimalCurrencies = ["JPY", "KRW", "VND"], getCurrencyDetails = (r) => currencyDictionary[r] ?? defaultCurrencyDetails, emptyString = "", comma = ",", period = ".", minus = "-", minusRegExp = /-/, nonDigitsRegExp = /\D+/g, number$1 = "number", digitRegExp = /\d/, caretTrap = "[]";
function createNumberMask({
  suffix: r = emptyString,
  includeThousandsSeparator: a = !0,
  thousandsSeparatorSymbol: s = comma,
  allowDecimal: c = !1,
  decimalSymbol: u = period,
  decimalLimit: d = 2,
  requireDecimal: h = !1,
  allowNegative: p = !1,
  allowLeadingZeroes: m = !1,
  integerLimit: g,
  currency: v = defaultCurrency,
  prefix: y = getCurrencyDetails(v).sign,
  currencySign: x,
  allowPrefix: w = !0
}) {
  const S = x || y, M = w && (S != null && S.length) ? S == null ? void 0 : S.length : 0, P = (r == null ? void 0 : r.length) || 0, L = (s == null ? void 0 : s.length) || 0;
  function I(T = emptyString) {
    const E = T.length, R = S.split(emptyString);
    if (T === emptyString || T[0] === S[0] && E === 1)
      return R.concat([digitRegExp]).concat(r.split(emptyString));
    if (T === u && c)
      return R.concat(["0", u, digitRegExp]).concat(r.split(emptyString));
    const A = T[0] === minus && p;
    A && (T = T.toString().slice(1));
    const k = T.indexOf(u), V = T.lastIndexOf(u), B = k !== -1;
    B && k != V && (T = T.toString().slice(0, -1));
    let q, z, Z;
    if (T.slice(P * -1) === r && (T = T.slice(0, P * -1)), B && (c || h) ? (q = T.slice(T.slice(0, M) === S ? M : 0, k), z = T.slice(k + 1, E), z = convertToMask(z.replace(nonDigitsRegExp, emptyString))) : T.slice(0, M) === S ? q = T.slice(M) : q = T, g && typeof g === number$1) {
      const G = s === "." ? "[.]" : `${s}`, K = (new RegExp(G, "g").exec(q) || []).length;
      q = q.slice(0, g + K * L);
    }
    return q = q.replace(nonDigitsRegExp, emptyString), m || (q = q.replace(/^0+(0$|[^0])/, "$1")), q = a ? addThousandsSeparator(q, s) : q, Z = convertToMask(q), (B && c || h === !0) && (T[k - 1] !== u && Z.push(caretTrap), Z.push(u, caretTrap), z && (typeof d === number$1 && (z = z.slice(0, d)), Z = Z.concat(z)), h === !0 && T[k - 1] === u && Z.push(digitRegExp)), M > 0 && (Z = S.split(emptyString).concat(Z)), A && (Z.length === M && Z.push(digitRegExp), Z = [minusRegExp].concat(Z)), r.length > 0 && (Z = Z.concat(r.split(emptyString))), Z;
  }
  return I.instanceOf = "createNumberMask", I;
}
function convertToMask(r) {
  return r.split(emptyString).map((a) => digitRegExp.test(a) ? digitRegExp : a);
}
function addThousandsSeparator(r, a) {
  return r.replace(/\B(?=(\d{3})+(?!\d))/g, a);
}
const convertDateToStringRepresentation = (r) => r == null ? void 0 : r.toISOString().substring(0, 10), disabledLinkAttributes = {
  "aria-disabled": !0,
  href: void 0,
  target: void 0,
  onClick: void 0,
  // For non-navigational links use <div> or <button> with role="link" to maintain semantic clarity and ensure accessibility.
  as: "div",
  role: "link"
}, getAriaProps = (r, a) => {
  const s = a.filter(Boolean).join(" ");
  return s ? { [r]: s } : {};
}, getInteractiveElementProps = ({
  isDisabled: r,
  isLoading: a,
  onClick: s,
  tabIndex: c
} = {}) => ({
  "aria-disabled": r || void 0,
  ...r || a ? { tabIndex: c ?? -1 } : { onClick: s, tabIndex: c }
});
function mergeRefs(r) {
  return (a) => {
    r.forEach((s) => {
      typeof s == "function" ? s(a) : s != null && (s.current = a);
    });
  };
}
const mergeRefArrays = (r, a) => {
  const s = r.slice();
  return a.forEach((c, u) => {
    c && (s[u] = c);
  }), s;
}, useDebounceCallback = (r, a = 500) => {
  const s = useRef$1(), c = useRef$1(r);
  return useEffect$1(() => {
    c.current = r;
  }, [r]), useEffect$1(() => () => clearTimeout(s.current), []), useCallback$1(
    (...u) => {
      clearTimeout(s.current), s.current = window.setTimeout(() => {
        c.current(...u);
      }, a);
    },
    [a]
  );
};
function hasWindow() {
  return typeof window < "u";
}
function getNodeName$2(r) {
  return isNode$1(r) ? (r.nodeName || "").toLowerCase() : "#document";
}
function getWindow$2(r) {
  var a;
  return (r == null || (a = r.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function getDocumentElement$2(r) {
  var a;
  return (a = (isNode$1(r) ? r.ownerDocument : r.document) || window.document) == null ? void 0 : a.documentElement;
}
function isNode$1(r) {
  return hasWindow() ? r instanceof Node || r instanceof getWindow$2(r).Node : !1;
}
function isElement$2(r) {
  return hasWindow() ? r instanceof Element || r instanceof getWindow$2(r).Element : !1;
}
function isHTMLElement$3(r) {
  return hasWindow() ? r instanceof HTMLElement || r instanceof getWindow$2(r).HTMLElement : !1;
}
function isShadowRoot$2(r) {
  return !hasWindow() || typeof ShadowRoot > "u" ? !1 : r instanceof ShadowRoot || r instanceof getWindow$2(r).ShadowRoot;
}
function isLastTraversableNode$1(r) {
  return ["html", "body", "#document"].includes(getNodeName$2(r));
}
function getComputedStyle$3(r) {
  return getWindow$2(r).getComputedStyle(r);
}
function getParentNode$2(r) {
  if (getNodeName$2(r) === "html")
    return r;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    r.assignedSlot || // DOM Element detected.
    r.parentNode || // ShadowRoot detected.
    isShadowRoot$2(r) && r.host || // Fallback.
    getDocumentElement$2(r)
  );
  return isShadowRoot$2(a) ? a.host : a;
}
function activeElement(r) {
  let a = r.activeElement;
  for (; ((s = a) == null || (s = s.shadowRoot) == null ? void 0 : s.activeElement) != null; ) {
    var s;
    a = a.shadowRoot.activeElement;
  }
  return a;
}
function contains$1(r, a) {
  if (!r || !a)
    return !1;
  const s = a.getRootNode == null ? void 0 : a.getRootNode();
  if (r.contains(a))
    return !0;
  if (s && isShadowRoot$2(s)) {
    let c = a;
    for (; c; ) {
      if (r === c)
        return !0;
      c = c.parentNode || c.host;
    }
  }
  return !1;
}
function getPlatform() {
  const r = navigator.userAgentData;
  return r != null && r.platform ? r.platform : navigator.platform;
}
function getUserAgent() {
  const r = navigator.userAgentData;
  return r && Array.isArray(r.brands) ? r.brands.map((a) => {
    let {
      brand: s,
      version: c
    } = a;
    return s + "/" + c;
  }).join(" ") : navigator.userAgent;
}
function isVirtualClick(r) {
  return r.mozInputSource === 0 && r.isTrusted ? !0 : isAndroid$1() && r.pointerType ? r.type === "click" && r.buttons === 1 : r.detail === 0 && !r.pointerType;
}
function isVirtualPointerEvent(r) {
  return isJSDOM() ? !1 : !isAndroid$1() && r.width === 0 && r.height === 0 || isAndroid$1() && r.width === 1 && r.height === 1 && r.pressure === 0 && r.detail === 0 && r.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  r.width < 1 && r.height < 1 && r.pressure === 0 && r.detail === 0 && r.pointerType === "touch";
}
function isSafari() {
  return /apple/i.test(navigator.vendor);
}
function isAndroid$1() {
  const r = /android/i;
  return r.test(getPlatform()) || r.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes("jsdom/");
}
function isMouseLikePointerType(r, a) {
  const s = ["mouse", "pen"];
  return a || s.push("", void 0), s.includes(r);
}
function isReactEvent(r) {
  return "nativeEvent" in r;
}
function isRootElement(r) {
  return r.matches("html,body");
}
function getDocument(r) {
  return (r == null ? void 0 : r.ownerDocument) || document;
}
function isEventTargetWithin(r, a) {
  if (a == null)
    return !1;
  if ("composedPath" in r)
    return r.composedPath().includes(a);
  const s = r;
  return s.target != null && a.contains(s.target);
}
function getTarget(r) {
  return "composedPath" in r ? r.composedPath()[0] : r.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(r) {
  return isHTMLElement$3(r) && r.matches(TYPEABLE_SELECTOR);
}
function stopEvent(r) {
  r.preventDefault(), r.stopPropagation();
}
function isTypeableCombobox(r) {
  return r ? r.getAttribute("role") === "combobox" && isTypeableElement(r) : !1;
}
const floor$1 = Math.floor;
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], candidateSelector = /* @__PURE__ */ candidateSelectors.join(","), NoElement = typeof Element > "u", matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, getRootNode = !NoElement && Element.prototype.getRootNode ? function(r) {
  var a;
  return r == null || (a = r.getRootNode) === null || a === void 0 ? void 0 : a.call(r);
} : function(r) {
  return r == null ? void 0 : r.ownerDocument;
}, isInert = function r(a, s) {
  var c;
  s === void 0 && (s = !0);
  var u = a == null || (c = a.getAttribute) === null || c === void 0 ? void 0 : c.call(a, "inert"), d = u === "" || u === "true", h = d || s && a && r(a.parentNode);
  return h;
}, isContentEditable = function r(a) {
  var s, c = a == null || (s = a.getAttribute) === null || s === void 0 ? void 0 : s.call(a, "contenteditable");
  return c === "" || c === "true";
}, getCandidates = function r(a, s, c) {
  if (isInert(a))
    return [];
  var u = Array.prototype.slice.apply(a.querySelectorAll(candidateSelector));
  return s && matches.call(a, candidateSelector) && u.unshift(a), u = u.filter(c), u;
}, getCandidatesIteratively = function r(a, s, c) {
  for (var u = [], d = Array.from(a); d.length; ) {
    var h = d.shift();
    if (!isInert(h, !1))
      if (h.tagName === "SLOT") {
        var p = h.assignedElements(), m = p.length ? p : h.children, g = r(m, !0, c);
        c.flatten ? u.push.apply(u, g) : u.push({
          scopeParent: h,
          candidates: g
        });
      } else {
        var v = matches.call(h, candidateSelector);
        v && c.filter(h) && (s || !a.includes(h)) && u.push(h);
        var y = h.shadowRoot || // check for an undisclosed shadow
        typeof c.getShadowRoot == "function" && c.getShadowRoot(h), x = !isInert(y, !1) && (!c.shadowRootFilter || c.shadowRootFilter(h));
        if (y && x) {
          var w = r(y === !0 ? h.children : y.children, !0, c);
          c.flatten ? u.push.apply(u, w) : u.push({
            scopeParent: h,
            candidates: w
          });
        } else
          d.unshift.apply(d, h.children);
      }
  }
  return u;
}, hasTabIndex = function r(a) {
  return !isNaN(parseInt(a.getAttribute("tabindex"), 10));
}, getTabIndex = function r(a) {
  if (!a)
    throw new Error("No node provided");
  return a.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(a.tagName) || isContentEditable(a)) && !hasTabIndex(a) ? 0 : a.tabIndex;
}, getSortOrderTabIndex = function r(a, s) {
  var c = getTabIndex(a);
  return c < 0 && s && !hasTabIndex(a) ? 0 : c;
}, sortOrderedTabbables = function r(a, s) {
  return a.tabIndex === s.tabIndex ? a.documentOrder - s.documentOrder : a.tabIndex - s.tabIndex;
}, isInput = function r(a) {
  return a.tagName === "INPUT";
}, isHiddenInput = function r(a) {
  return isInput(a) && a.type === "hidden";
}, isDetailsWithSummary = function r(a) {
  var s = a.tagName === "DETAILS" && Array.prototype.slice.apply(a.children).some(function(c) {
    return c.tagName === "SUMMARY";
  });
  return s;
}, getCheckedRadio = function r(a, s) {
  for (var c = 0; c < a.length; c++)
    if (a[c].checked && a[c].form === s)
      return a[c];
}, isTabbableRadio = function r(a) {
  if (!a.name)
    return !0;
  var s = a.form || getRootNode(a), c = function(p) {
    return s.querySelectorAll('input[type="radio"][name="' + p + '"]');
  }, u;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    u = c(window.CSS.escape(a.name));
  else
    try {
      u = c(a.name);
    } catch (h) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", h.message), !1;
    }
  var d = getCheckedRadio(u, a.form);
  return !d || d === a;
}, isRadio = function r(a) {
  return isInput(a) && a.type === "radio";
}, isNonTabbableRadio = function r(a) {
  return isRadio(a) && !isTabbableRadio(a);
}, isNodeAttached = function r(a) {
  var s, c = a && getRootNode(a), u = (s = c) === null || s === void 0 ? void 0 : s.host, d = !1;
  if (c && c !== a) {
    var h, p, m;
    for (d = !!((h = u) !== null && h !== void 0 && (p = h.ownerDocument) !== null && p !== void 0 && p.contains(u) || a != null && (m = a.ownerDocument) !== null && m !== void 0 && m.contains(a)); !d && u; ) {
      var g, v, y;
      c = getRootNode(u), u = (g = c) === null || g === void 0 ? void 0 : g.host, d = !!((v = u) !== null && v !== void 0 && (y = v.ownerDocument) !== null && y !== void 0 && y.contains(u));
    }
  }
  return d;
}, isZeroArea = function r(a) {
  var s = a.getBoundingClientRect(), c = s.width, u = s.height;
  return c === 0 && u === 0;
}, isHidden = function r(a, s) {
  var c = s.displayCheck, u = s.getShadowRoot;
  if (getComputedStyle(a).visibility === "hidden")
    return !0;
  var d = matches.call(a, "details>summary:first-of-type"), h = d ? a.parentElement : a;
  if (matches.call(h, "details:not([open]) *"))
    return !0;
  if (!c || c === "full" || c === "legacy-full") {
    if (typeof u == "function") {
      for (var p = a; a; ) {
        var m = a.parentElement, g = getRootNode(a);
        if (m && !m.shadowRoot && u(m) === !0)
          return isZeroArea(a);
        a.assignedSlot ? a = a.assignedSlot : !m && g !== a.ownerDocument ? a = g.host : a = m;
      }
      a = p;
    }
    if (isNodeAttached(a))
      return !a.getClientRects().length;
    if (c !== "legacy-full")
      return !0;
  } else if (c === "non-zero-area")
    return isZeroArea(a);
  return !1;
}, isDisabledFromFieldset = function r(a) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(a.tagName))
    for (var s = a.parentElement; s; ) {
      if (s.tagName === "FIELDSET" && s.disabled) {
        for (var c = 0; c < s.children.length; c++) {
          var u = s.children.item(c);
          if (u.tagName === "LEGEND")
            return matches.call(s, "fieldset[disabled] *") ? !0 : !u.contains(a);
        }
        return !0;
      }
      s = s.parentElement;
    }
  return !1;
}, isNodeMatchingSelectorFocusable = function r(a, s) {
  return !(s.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(s) || isHiddenInput(s) || isHidden(s, a) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(s) || isDisabledFromFieldset(s));
}, isNodeMatchingSelectorTabbable = function r(a, s) {
  return !(isNonTabbableRadio(s) || getTabIndex(s) < 0 || !isNodeMatchingSelectorFocusable(a, s));
}, isValidShadowRootTabbable = function r(a) {
  var s = parseInt(a.getAttribute("tabindex"), 10);
  return !!(isNaN(s) || s >= 0);
}, sortByOrder = function r(a) {
  var s = [], c = [];
  return a.forEach(function(u, d) {
    var h = !!u.scopeParent, p = h ? u.scopeParent : u, m = getSortOrderTabIndex(p, h), g = h ? r(u.candidates) : p;
    m === 0 ? h ? s.push.apply(s, g) : s.push(p) : c.push({
      documentOrder: d,
      tabIndex: m,
      item: u,
      isScope: h,
      content: g
    });
  }), c.sort(sortOrderedTabbables).reduce(function(u, d) {
    return d.isScope ? u.push.apply(u, d.content) : u.push(d.content), u;
  }, []).concat(s);
}, tabbable = function r(a, s) {
  s = s || {};
  var c;
  return s.getShadowRoot ? c = getCandidatesIteratively([a], s.includeContainer, {
    filter: isNodeMatchingSelectorTabbable.bind(null, s),
    flatten: !1,
    getShadowRoot: s.getShadowRoot,
    shadowRootFilter: isValidShadowRootTabbable
  }) : c = getCandidates(a, s.includeContainer, isNodeMatchingSelectorTabbable.bind(null, s)), sortByOrder(c);
}, isTabbable = function r(a, s) {
  if (s = s || {}, !a)
    throw new Error("No node provided");
  return matches.call(a, candidateSelector) === !1 ? !1 : isNodeMatchingSelectorTabbable(s, a);
};
const min$2 = Math.min, max$2 = Math.max, round$1 = Math.round, floor = Math.floor, createCoords = (r) => ({
  x: r,
  y: r
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(r, a, s) {
  return max$2(r, min$2(a, s));
}
function evaluate(r, a) {
  return typeof r == "function" ? r(a) : r;
}
function getSide(r) {
  return r.split("-")[0];
}
function getAlignment(r) {
  return r.split("-")[1];
}
function getOppositeAxis(r) {
  return r === "x" ? "y" : "x";
}
function getAxisLength(r) {
  return r === "y" ? "height" : "width";
}
function getSideAxis(r) {
  return ["top", "bottom"].includes(getSide(r)) ? "y" : "x";
}
function getAlignmentAxis(r) {
  return getOppositeAxis(getSideAxis(r));
}
function getAlignmentSides(r, a, s) {
  s === void 0 && (s = !1);
  const c = getAlignment(r), u = getAlignmentAxis(r), d = getAxisLength(u);
  let h = u === "x" ? c === (s ? "end" : "start") ? "right" : "left" : c === "start" ? "bottom" : "top";
  return a.reference[d] > a.floating[d] && (h = getOppositePlacement$1(h)), [h, getOppositePlacement$1(h)];
}
function getExpandedPlacements(r) {
  const a = getOppositePlacement$1(r);
  return [getOppositeAlignmentPlacement(r), a, getOppositeAlignmentPlacement(a)];
}
function getOppositeAlignmentPlacement(r) {
  return r.replace(/start|end/g, (a) => oppositeAlignmentMap[a]);
}
function getSideList(r, a, s) {
  const c = ["left", "right"], u = ["right", "left"], d = ["top", "bottom"], h = ["bottom", "top"];
  switch (r) {
    case "top":
    case "bottom":
      return s ? a ? u : c : a ? c : u;
    case "left":
    case "right":
      return a ? d : h;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(r, a, s, c) {
  const u = getAlignment(r);
  let d = getSideList(getSide(r), s === "start", c);
  return u && (d = d.map((h) => h + "-" + u), a && (d = d.concat(d.map(getOppositeAlignmentPlacement)))), d;
}
function getOppositePlacement$1(r) {
  return r.replace(/left|right|bottom|top/g, (a) => oppositeSideMap[a]);
}
function expandPaddingObject(r) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...r
  };
}
function getPaddingObject(r) {
  return typeof r != "number" ? expandPaddingObject(r) : {
    top: r,
    right: r,
    bottom: r,
    left: r
  };
}
function rectToClientRect$1(r) {
  const {
    x: a,
    y: s,
    width: c,
    height: u
  } = r;
  return {
    width: c,
    height: u,
    top: s,
    left: a,
    right: a + c,
    bottom: s + u,
    x: a,
    y: s
  };
}
function computeCoordsFromPlacement(r, a, s) {
  let {
    reference: c,
    floating: u
  } = r;
  const d = getSideAxis(a), h = getAlignmentAxis(a), p = getAxisLength(h), m = getSide(a), g = d === "y", v = c.x + c.width / 2 - u.width / 2, y = c.y + c.height / 2 - u.height / 2, x = c[p] / 2 - u[p] / 2;
  let w;
  switch (m) {
    case "top":
      w = {
        x: v,
        y: c.y - u.height
      };
      break;
    case "bottom":
      w = {
        x: v,
        y: c.y + c.height
      };
      break;
    case "right":
      w = {
        x: c.x + c.width,
        y
      };
      break;
    case "left":
      w = {
        x: c.x - u.width,
        y
      };
      break;
    default:
      w = {
        x: c.x,
        y: c.y
      };
  }
  switch (getAlignment(a)) {
    case "start":
      w[h] -= x * (s && g ? -1 : 1);
      break;
    case "end":
      w[h] += x * (s && g ? -1 : 1);
      break;
  }
  return w;
}
const computePosition$1 = async (r, a, s) => {
  const {
    placement: c = "bottom",
    strategy: u = "absolute",
    middleware: d = [],
    platform: h
  } = s, p = d.filter(Boolean), m = await (h.isRTL == null ? void 0 : h.isRTL(a));
  let g = await h.getElementRects({
    reference: r,
    floating: a,
    strategy: u
  }), {
    x: v,
    y
  } = computeCoordsFromPlacement(g, c, m), x = c, w = {}, S = 0;
  for (let M = 0; M < p.length; M++) {
    const {
      name: P,
      fn: L
    } = p[M], {
      x: I,
      y: T,
      data: E,
      reset: R
    } = await L({
      x: v,
      y,
      initialPlacement: c,
      placement: x,
      strategy: u,
      middlewareData: w,
      rects: g,
      platform: h,
      elements: {
        reference: r,
        floating: a
      }
    });
    v = I ?? v, y = T ?? y, w = {
      ...w,
      [P]: {
        ...w[P],
        ...E
      }
    }, R && S <= 50 && (S++, typeof R == "object" && (R.placement && (x = R.placement), R.rects && (g = R.rects === !0 ? await h.getElementRects({
      reference: r,
      floating: a,
      strategy: u
    }) : R.rects), {
      x: v,
      y
    } = computeCoordsFromPlacement(g, x, m)), M = -1);
  }
  return {
    x: v,
    y,
    placement: x,
    strategy: u,
    middlewareData: w
  };
};
async function detectOverflow$1(r, a) {
  var s;
  a === void 0 && (a = {});
  const {
    x: c,
    y: u,
    platform: d,
    rects: h,
    elements: p,
    strategy: m
  } = r, {
    boundary: g = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: y = "floating",
    altBoundary: x = !1,
    padding: w = 0
  } = evaluate(a, r), S = getPaddingObject(w), P = p[x ? y === "floating" ? "reference" : "floating" : y], L = rectToClientRect$1(await d.getClippingRect({
    element: (s = await (d.isElement == null ? void 0 : d.isElement(P))) == null || s ? P : P.contextElement || await (d.getDocumentElement == null ? void 0 : d.getDocumentElement(p.floating)),
    boundary: g,
    rootBoundary: v,
    strategy: m
  })), I = y === "floating" ? {
    x: c,
    y: u,
    width: h.floating.width,
    height: h.floating.height
  } : h.reference, T = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(p.floating)), E = await (d.isElement == null ? void 0 : d.isElement(T)) ? await (d.getScale == null ? void 0 : d.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = rectToClientRect$1(d.convertOffsetParentRelativeRectToViewportRelativeRect ? await d.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: p,
    rect: I,
    offsetParent: T,
    strategy: m
  }) : I);
  return {
    top: (L.top - R.top + S.top) / E.y,
    bottom: (R.bottom - L.bottom + S.bottom) / E.y,
    left: (L.left - R.left + S.left) / E.x,
    right: (R.right - L.right + S.right) / E.x
  };
}
const arrow$4 = (r) => ({
  name: "arrow",
  options: r,
  async fn(a) {
    const {
      x: s,
      y: c,
      placement: u,
      rects: d,
      platform: h,
      elements: p,
      middlewareData: m
    } = a, {
      element: g,
      padding: v = 0
    } = evaluate(r, a) || {};
    if (g == null)
      return {};
    const y = getPaddingObject(v), x = {
      x: s,
      y: c
    }, w = getAlignmentAxis(u), S = getAxisLength(w), M = await h.getDimensions(g), P = w === "y", L = P ? "top" : "left", I = P ? "bottom" : "right", T = P ? "clientHeight" : "clientWidth", E = d.reference[S] + d.reference[w] - x[w] - d.floating[S], R = x[w] - d.reference[w], A = await (h.getOffsetParent == null ? void 0 : h.getOffsetParent(g));
    let k = A ? A[T] : 0;
    (!k || !await (h.isElement == null ? void 0 : h.isElement(A))) && (k = p.floating[T] || d.floating[S]);
    const V = E / 2 - R / 2, B = k / 2 - M[S] / 2 - 1, q = min$2(y[L], B), z = min$2(y[I], B), Z = q, G = k - M[S] - z, K = k / 2 - M[S] / 2 + V, U = clamp(Z, K, G), F = !m.arrow && getAlignment(u) != null && K !== U && d.reference[S] / 2 - (K < Z ? q : z) - M[S] / 2 < 0, N = F ? K < Z ? K - Z : K - G : 0;
    return {
      [w]: x[w] + N,
      data: {
        [w]: U,
        centerOffset: K - U - N,
        ...F && {
          alignmentOffset: N
        }
      },
      reset: F
    };
  }
}), flip$4 = function(r) {
  return r === void 0 && (r = {}), {
    name: "flip",
    options: r,
    async fn(a) {
      var s, c;
      const {
        placement: u,
        middlewareData: d,
        rects: h,
        initialPlacement: p,
        platform: m,
        elements: g
      } = a, {
        mainAxis: v = !0,
        crossAxis: y = !0,
        fallbackPlacements: x,
        fallbackStrategy: w = "bestFit",
        fallbackAxisSideDirection: S = "none",
        flipAlignment: M = !0,
        ...P
      } = evaluate(r, a);
      if ((s = d.arrow) != null && s.alignmentOffset)
        return {};
      const L = getSide(u), I = getSideAxis(p), T = getSide(p) === p, E = await (m.isRTL == null ? void 0 : m.isRTL(g.floating)), R = x || (T || !M ? [getOppositePlacement$1(p)] : getExpandedPlacements(p)), A = S !== "none";
      !x && A && R.push(...getOppositeAxisPlacements(p, M, S, E));
      const k = [p, ...R], V = await detectOverflow$1(a, P), B = [];
      let q = ((c = d.flip) == null ? void 0 : c.overflows) || [];
      if (v && B.push(V[L]), y) {
        const K = getAlignmentSides(u, h, E);
        B.push(V[K[0]], V[K[1]]);
      }
      if (q = [...q, {
        placement: u,
        overflows: B
      }], !B.every((K) => K <= 0)) {
        var z, Z;
        const K = (((z = d.flip) == null ? void 0 : z.index) || 0) + 1, U = k[K];
        if (U)
          return {
            data: {
              index: K,
              overflows: q
            },
            reset: {
              placement: U
            }
          };
        let F = (Z = q.filter((N) => N.overflows[0] <= 0).sort((N, D) => N.overflows[1] - D.overflows[1])[0]) == null ? void 0 : Z.placement;
        if (!F)
          switch (w) {
            case "bestFit": {
              var G;
              const N = (G = q.filter((D) => {
                if (A) {
                  const j = getSideAxis(D.placement);
                  return j === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((j) => j > 0).reduce((j, H) => j + H, 0)]).sort((D, j) => D[1] - j[1])[0]) == null ? void 0 : G[0];
              N && (F = N);
              break;
            }
            case "initialPlacement":
              F = p;
              break;
          }
        if (u !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
async function convertValueToCoords(r, a) {
  const {
    placement: s,
    platform: c,
    elements: u
  } = r, d = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), h = getSide(s), p = getAlignment(s), m = getSideAxis(s) === "y", g = ["left", "top"].includes(h) ? -1 : 1, v = d && m ? -1 : 1, y = evaluate(a, r);
  let {
    mainAxis: x,
    crossAxis: w,
    alignmentAxis: S
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...y
  };
  return p && typeof S == "number" && (w = p === "end" ? S * -1 : S), m ? {
    x: w * v,
    y: x * g
  } : {
    x: x * g,
    y: w * v
  };
}
const offset$4 = function(r) {
  return r === void 0 && (r = 0), {
    name: "offset",
    options: r,
    async fn(a) {
      var s, c;
      const {
        x: u,
        y: d,
        placement: h,
        middlewareData: p
      } = a, m = await convertValueToCoords(a, r);
      return h === ((s = p.offset) == null ? void 0 : s.placement) && (c = p.arrow) != null && c.alignmentOffset ? {} : {
        x: u + m.x,
        y: d + m.y,
        data: {
          ...m,
          placement: h
        }
      };
    }
  };
}, shift$2 = function(r) {
  return r === void 0 && (r = {}), {
    name: "shift",
    options: r,
    async fn(a) {
      const {
        x: s,
        y: c,
        placement: u
      } = a, {
        mainAxis: d = !0,
        crossAxis: h = !1,
        limiter: p = {
          fn: (P) => {
            let {
              x: L,
              y: I
            } = P;
            return {
              x: L,
              y: I
            };
          }
        },
        ...m
      } = evaluate(r, a), g = {
        x: s,
        y: c
      }, v = await detectOverflow$1(a, m), y = getSideAxis(getSide(u)), x = getOppositeAxis(y);
      let w = g[x], S = g[y];
      if (d) {
        const P = x === "y" ? "top" : "left", L = x === "y" ? "bottom" : "right", I = w + v[P], T = w - v[L];
        w = clamp(I, w, T);
      }
      if (h) {
        const P = y === "y" ? "top" : "left", L = y === "y" ? "bottom" : "right", I = S + v[P], T = S - v[L];
        S = clamp(I, S, T);
      }
      const M = p.fn({
        ...a,
        [x]: w,
        [y]: S
      });
      return {
        ...M,
        data: {
          x: M.x - s,
          y: M.y - c
        }
      };
    }
  };
}, size$2 = function(r) {
  return r === void 0 && (r = {}), {
    name: "size",
    options: r,
    async fn(a) {
      const {
        placement: s,
        rects: c,
        platform: u,
        elements: d
      } = a, {
        apply: h = () => {
        },
        ...p
      } = evaluate(r, a), m = await detectOverflow$1(a, p), g = getSide(s), v = getAlignment(s), y = getSideAxis(s) === "y", {
        width: x,
        height: w
      } = c.floating;
      let S, M;
      g === "top" || g === "bottom" ? (S = g, M = v === (await (u.isRTL == null ? void 0 : u.isRTL(d.floating)) ? "start" : "end") ? "left" : "right") : (M = g, S = v === "end" ? "top" : "bottom");
      const P = w - m.top - m.bottom, L = x - m.left - m.right, I = min$2(w - m[S], P), T = min$2(x - m[M], L), E = !a.middlewareData.shift;
      let R = I, A = T;
      if (y ? A = v || E ? min$2(T, L) : L : R = v || E ? min$2(I, P) : P, E && !v) {
        const V = max$2(m.left, 0), B = max$2(m.right, 0), q = max$2(m.top, 0), z = max$2(m.bottom, 0);
        y ? A = x - 2 * (V !== 0 || B !== 0 ? V + B : max$2(m.left, m.right)) : R = w - 2 * (q !== 0 || z !== 0 ? q + z : max$2(m.top, m.bottom));
      }
      await h({
        ...a,
        availableWidth: A,
        availableHeight: R
      });
      const k = await u.getDimensions(d.floating);
      return x !== k.width || w !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function getNodeName$1(r) {
  return isNode(r) ? (r.nodeName || "").toLowerCase() : "#document";
}
function getWindow$1(r) {
  var a;
  return (r == null || (a = r.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function getDocumentElement$1(r) {
  var a;
  return (a = (isNode(r) ? r.ownerDocument : r.document) || window.document) == null ? void 0 : a.documentElement;
}
function isNode(r) {
  return r instanceof Node || r instanceof getWindow$1(r).Node;
}
function isElement$1(r) {
  return r instanceof Element || r instanceof getWindow$1(r).Element;
}
function isHTMLElement$2(r) {
  return r instanceof HTMLElement || r instanceof getWindow$1(r).HTMLElement;
}
function isShadowRoot$1(r) {
  return typeof ShadowRoot > "u" ? !1 : r instanceof ShadowRoot || r instanceof getWindow$1(r).ShadowRoot;
}
function isOverflowElement(r) {
  const {
    overflow: a,
    overflowX: s,
    overflowY: c,
    display: u
  } = getComputedStyle$2(r);
  return /auto|scroll|overlay|hidden|clip/.test(a + c + s) && !["inline", "contents"].includes(u);
}
function isTableElement$1(r) {
  return ["table", "td", "th"].includes(getNodeName$1(r));
}
function isTopLayer(r) {
  return [":popover-open", ":modal"].some((a) => {
    try {
      return r.matches(a);
    } catch {
      return !1;
    }
  });
}
function isContainingBlock(r) {
  const a = isWebKit(), s = getComputedStyle$2(r);
  return s.transform !== "none" || s.perspective !== "none" || (s.containerType ? s.containerType !== "normal" : !1) || !a && (s.backdropFilter ? s.backdropFilter !== "none" : !1) || !a && (s.filter ? s.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((c) => (s.willChange || "").includes(c)) || ["paint", "layout", "strict", "content"].some((c) => (s.contain || "").includes(c));
}
function getContainingBlock$1(r) {
  let a = getParentNode$1(r);
  for (; isHTMLElement$2(a) && !isLastTraversableNode(a); ) {
    if (isTopLayer(a))
      return null;
    if (isContainingBlock(a))
      return a;
    a = getParentNode$1(a);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(r) {
  return ["html", "body", "#document"].includes(getNodeName$1(r));
}
function getComputedStyle$2(r) {
  return getWindow$1(r).getComputedStyle(r);
}
function getNodeScroll$1(r) {
  return isElement$1(r) ? {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  } : {
    scrollLeft: r.scrollX,
    scrollTop: r.scrollY
  };
}
function getParentNode$1(r) {
  if (getNodeName$1(r) === "html")
    return r;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    r.assignedSlot || // DOM Element detected.
    r.parentNode || // ShadowRoot detected.
    isShadowRoot$1(r) && r.host || // Fallback.
    getDocumentElement$1(r)
  );
  return isShadowRoot$1(a) ? a.host : a;
}
function getNearestOverflowAncestor(r) {
  const a = getParentNode$1(r);
  return isLastTraversableNode(a) ? r.ownerDocument ? r.ownerDocument.body : r.body : isHTMLElement$2(a) && isOverflowElement(a) ? a : getNearestOverflowAncestor(a);
}
function getOverflowAncestors(r, a, s) {
  var c;
  a === void 0 && (a = []), s === void 0 && (s = !0);
  const u = getNearestOverflowAncestor(r), d = u === ((c = r.ownerDocument) == null ? void 0 : c.body), h = getWindow$1(u);
  return d ? a.concat(h, h.visualViewport || [], isOverflowElement(u) ? u : [], h.frameElement && s ? getOverflowAncestors(h.frameElement) : []) : a.concat(u, getOverflowAncestors(u, [], s));
}
function getCssDimensions(r) {
  const a = getComputedStyle$2(r);
  let s = parseFloat(a.width) || 0, c = parseFloat(a.height) || 0;
  const u = isHTMLElement$2(r), d = u ? r.offsetWidth : s, h = u ? r.offsetHeight : c, p = round$1(s) !== d || round$1(c) !== h;
  return p && (s = d, c = h), {
    width: s,
    height: c,
    $: p
  };
}
function unwrapElement(r) {
  return isElement$1(r) ? r : r.contextElement;
}
function getScale(r) {
  const a = unwrapElement(r);
  if (!isHTMLElement$2(a))
    return createCoords(1);
  const s = a.getBoundingClientRect(), {
    width: c,
    height: u,
    $: d
  } = getCssDimensions(a);
  let h = (d ? round$1(s.width) : s.width) / c, p = (d ? round$1(s.height) : s.height) / u;
  return (!h || !Number.isFinite(h)) && (h = 1), (!p || !Number.isFinite(p)) && (p = 1), {
    x: h,
    y: p
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(r) {
  const a = getWindow$1(r);
  return !isWebKit() || !a.visualViewport ? noOffsets : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(r, a, s) {
  return a === void 0 && (a = !1), !s || a && s !== getWindow$1(r) ? !1 : a;
}
function getBoundingClientRect$1(r, a, s, c) {
  a === void 0 && (a = !1), s === void 0 && (s = !1);
  const u = r.getBoundingClientRect(), d = unwrapElement(r);
  let h = createCoords(1);
  a && (c ? isElement$1(c) && (h = getScale(c)) : h = getScale(r));
  const p = shouldAddVisualOffsets(d, s, c) ? getVisualOffsets(d) : createCoords(0);
  let m = (u.left + p.x) / h.x, g = (u.top + p.y) / h.y, v = u.width / h.x, y = u.height / h.y;
  if (d) {
    const x = getWindow$1(d), w = c && isElement$1(c) ? getWindow$1(c) : c;
    let S = x, M = S.frameElement;
    for (; M && c && w !== S; ) {
      const P = getScale(M), L = M.getBoundingClientRect(), I = getComputedStyle$2(M), T = L.left + (M.clientLeft + parseFloat(I.paddingLeft)) * P.x, E = L.top + (M.clientTop + parseFloat(I.paddingTop)) * P.y;
      m *= P.x, g *= P.y, v *= P.x, y *= P.y, m += T, g += E, S = getWindow$1(M), M = S.frameElement;
    }
  }
  return rectToClientRect$1({
    width: v,
    height: y,
    x: m,
    y: g
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(r) {
  let {
    elements: a,
    rect: s,
    offsetParent: c,
    strategy: u
  } = r;
  const d = u === "fixed", h = getDocumentElement$1(c), p = a ? isTopLayer(a.floating) : !1;
  if (c === h || p && d)
    return s;
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  }, g = createCoords(1);
  const v = createCoords(0), y = isHTMLElement$2(c);
  if ((y || !y && !d) && ((getNodeName$1(c) !== "body" || isOverflowElement(h)) && (m = getNodeScroll$1(c)), isHTMLElement$2(c))) {
    const x = getBoundingClientRect$1(c);
    g = getScale(c), v.x = x.x + c.clientLeft, v.y = x.y + c.clientTop;
  }
  return {
    width: s.width * g.x,
    height: s.height * g.y,
    x: s.x * g.x - m.scrollLeft * g.x + v.x,
    y: s.y * g.y - m.scrollTop * g.y + v.y
  };
}
function getClientRects(r) {
  return Array.from(r.getClientRects());
}
function getWindowScrollBarX$1(r) {
  return getBoundingClientRect$1(getDocumentElement$1(r)).left + getNodeScroll$1(r).scrollLeft;
}
function getDocumentRect$1(r) {
  const a = getDocumentElement$1(r), s = getNodeScroll$1(r), c = r.ownerDocument.body, u = max$2(a.scrollWidth, a.clientWidth, c.scrollWidth, c.clientWidth), d = max$2(a.scrollHeight, a.clientHeight, c.scrollHeight, c.clientHeight);
  let h = -s.scrollLeft + getWindowScrollBarX$1(r);
  const p = -s.scrollTop;
  return getComputedStyle$2(c).direction === "rtl" && (h += max$2(a.clientWidth, c.clientWidth) - u), {
    width: u,
    height: d,
    x: h,
    y: p
  };
}
function getViewportRect$1(r, a) {
  const s = getWindow$1(r), c = getDocumentElement$1(r), u = s.visualViewport;
  let d = c.clientWidth, h = c.clientHeight, p = 0, m = 0;
  if (u) {
    d = u.width, h = u.height;
    const g = isWebKit();
    (!g || g && a === "fixed") && (p = u.offsetLeft, m = u.offsetTop);
  }
  return {
    width: d,
    height: h,
    x: p,
    y: m
  };
}
function getInnerBoundingClientRect$1(r, a) {
  const s = getBoundingClientRect$1(r, !0, a === "fixed"), c = s.top + r.clientTop, u = s.left + r.clientLeft, d = isHTMLElement$2(r) ? getScale(r) : createCoords(1), h = r.clientWidth * d.x, p = r.clientHeight * d.y, m = u * d.x, g = c * d.y;
  return {
    width: h,
    height: p,
    x: m,
    y: g
  };
}
function getClientRectFromClippingAncestor(r, a, s) {
  let c;
  if (a === "viewport")
    c = getViewportRect$1(r, s);
  else if (a === "document")
    c = getDocumentRect$1(getDocumentElement$1(r));
  else if (isElement$1(a))
    c = getInnerBoundingClientRect$1(a, s);
  else {
    const u = getVisualOffsets(r);
    c = {
      ...a,
      x: a.x - u.x,
      y: a.y - u.y
    };
  }
  return rectToClientRect$1(c);
}
function hasFixedPositionAncestor(r, a) {
  const s = getParentNode$1(r);
  return s === a || !isElement$1(s) || isLastTraversableNode(s) ? !1 : getComputedStyle$2(s).position === "fixed" || hasFixedPositionAncestor(s, a);
}
function getClippingElementAncestors(r, a) {
  const s = a.get(r);
  if (s)
    return s;
  let c = getOverflowAncestors(r, [], !1).filter((p) => isElement$1(p) && getNodeName$1(p) !== "body"), u = null;
  const d = getComputedStyle$2(r).position === "fixed";
  let h = d ? getParentNode$1(r) : r;
  for (; isElement$1(h) && !isLastTraversableNode(h); ) {
    const p = getComputedStyle$2(h), m = isContainingBlock(h);
    !m && p.position === "fixed" && (u = null), (d ? !m && !u : !m && p.position === "static" && !!u && ["absolute", "fixed"].includes(u.position) || isOverflowElement(h) && !m && hasFixedPositionAncestor(r, h)) ? c = c.filter((v) => v !== h) : u = p, h = getParentNode$1(h);
  }
  return a.set(r, c), c;
}
function getClippingRect$1(r) {
  let {
    element: a,
    boundary: s,
    rootBoundary: c,
    strategy: u
  } = r;
  const h = [...s === "clippingAncestors" ? isTopLayer(a) ? [] : getClippingElementAncestors(a, this._c) : [].concat(s), c], p = h[0], m = h.reduce((g, v) => {
    const y = getClientRectFromClippingAncestor(a, v, u);
    return g.top = max$2(y.top, g.top), g.right = min$2(y.right, g.right), g.bottom = min$2(y.bottom, g.bottom), g.left = max$2(y.left, g.left), g;
  }, getClientRectFromClippingAncestor(a, p, u));
  return {
    width: m.right - m.left,
    height: m.bottom - m.top,
    x: m.left,
    y: m.top
  };
}
function getDimensions(r) {
  const {
    width: a,
    height: s
  } = getCssDimensions(r);
  return {
    width: a,
    height: s
  };
}
function getRectRelativeToOffsetParent(r, a, s) {
  const c = isHTMLElement$2(a), u = getDocumentElement$1(a), d = s === "fixed", h = getBoundingClientRect$1(r, !0, d, a);
  let p = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const m = createCoords(0);
  if (c || !c && !d)
    if ((getNodeName$1(a) !== "body" || isOverflowElement(u)) && (p = getNodeScroll$1(a)), c) {
      const y = getBoundingClientRect$1(a, !0, d, a);
      m.x = y.x + a.clientLeft, m.y = y.y + a.clientTop;
    } else u && (m.x = getWindowScrollBarX$1(u));
  const g = h.left + p.scrollLeft - m.x, v = h.top + p.scrollTop - m.y;
  return {
    x: g,
    y: v,
    width: h.width,
    height: h.height
  };
}
function isStaticPositioned(r) {
  return getComputedStyle$2(r).position === "static";
}
function getTrueOffsetParent$1(r, a) {
  return !isHTMLElement$2(r) || getComputedStyle$2(r).position === "fixed" ? null : a ? a(r) : r.offsetParent;
}
function getOffsetParent$1(r, a) {
  const s = getWindow$1(r);
  if (isTopLayer(r))
    return s;
  if (!isHTMLElement$2(r)) {
    let u = getParentNode$1(r);
    for (; u && !isLastTraversableNode(u); ) {
      if (isElement$1(u) && !isStaticPositioned(u))
        return u;
      u = getParentNode$1(u);
    }
    return s;
  }
  let c = getTrueOffsetParent$1(r, a);
  for (; c && isTableElement$1(c) && isStaticPositioned(c); )
    c = getTrueOffsetParent$1(c, a);
  return c && isLastTraversableNode(c) && isStaticPositioned(c) && !isContainingBlock(c) ? s : c || getContainingBlock$1(r) || s;
}
const getElementRects = async function(r) {
  const a = this.getOffsetParent || getOffsetParent$1, s = this.getDimensions, c = await s(r.floating);
  return {
    reference: getRectRelativeToOffsetParent(r.reference, await a(r.floating), r.strategy),
    floating: {
      x: 0,
      y: 0,
      width: c.width,
      height: c.height
    }
  };
};
function isRTL(r) {
  return getComputedStyle$2(r).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent: getOffsetParent$1,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
function observeMove(r, a) {
  let s = null, c;
  const u = getDocumentElement$1(r);
  function d() {
    var p;
    clearTimeout(c), (p = s) == null || p.disconnect(), s = null;
  }
  function h(p, m) {
    p === void 0 && (p = !1), m === void 0 && (m = 1), d();
    const {
      left: g,
      top: v,
      width: y,
      height: x
    } = r.getBoundingClientRect();
    if (p || a(), !y || !x)
      return;
    const w = floor(v), S = floor(u.clientWidth - (g + y)), M = floor(u.clientHeight - (v + x)), P = floor(g), I = {
      rootMargin: -w + "px " + -S + "px " + -M + "px " + -P + "px",
      threshold: max$2(0, min$2(1, m)) || 1
    };
    let T = !0;
    function E(R) {
      const A = R[0].intersectionRatio;
      if (A !== m) {
        if (!T)
          return h();
        A ? h(!1, A) : c = setTimeout(() => {
          h(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      s = new IntersectionObserver(E, {
        ...I,
        // Handle <iframe>s
        root: u.ownerDocument
      });
    } catch {
      s = new IntersectionObserver(E, I);
    }
    s.observe(r);
  }
  return h(!0), d;
}
function autoUpdate(r, a, s, c) {
  c === void 0 && (c = {});
  const {
    ancestorScroll: u = !0,
    ancestorResize: d = !0,
    elementResize: h = typeof ResizeObserver == "function",
    layoutShift: p = typeof IntersectionObserver == "function",
    animationFrame: m = !1
  } = c, g = unwrapElement(r), v = u || d ? [...g ? getOverflowAncestors(g) : [], ...getOverflowAncestors(a)] : [];
  v.forEach((L) => {
    u && L.addEventListener("scroll", s, {
      passive: !0
    }), d && L.addEventListener("resize", s);
  });
  const y = g && p ? observeMove(g, s) : null;
  let x = -1, w = null;
  h && (w = new ResizeObserver((L) => {
    let [I] = L;
    I && I.target === g && w && (w.unobserve(a), cancelAnimationFrame(x), x = requestAnimationFrame(() => {
      var T;
      (T = w) == null || T.observe(a);
    })), s();
  }), g && !m && w.observe(g), w.observe(a));
  let S, M = m ? getBoundingClientRect$1(r) : null;
  m && P();
  function P() {
    const L = getBoundingClientRect$1(r);
    M && (L.x !== M.x || L.y !== M.y || L.width !== M.width || L.height !== M.height) && s(), M = L, S = requestAnimationFrame(P);
  }
  return s(), () => {
    var L;
    v.forEach((I) => {
      u && I.removeEventListener("scroll", s), d && I.removeEventListener("resize", s);
    }), y == null || y(), (L = w) == null || L.disconnect(), w = null, m && cancelAnimationFrame(S);
  };
}
const offset$3 = offset$4, shift$1 = shift$2, flip$3 = flip$4, size$1 = size$2, arrow$3 = arrow$4, computePosition = (r, a, s) => {
  const c = /* @__PURE__ */ new Map(), u = {
    platform,
    ...s
  }, d = {
    ...u.platform,
    _c: c
  };
  return computePosition$1(r, a, {
    ...u,
    platform: d
  });
};
var index$1 = typeof document < "u" ? useLayoutEffect$1 : useEffect$1;
function deepEqual$1(r, a) {
  if (r === a)
    return !0;
  if (typeof r != typeof a)
    return !1;
  if (typeof r == "function" && r.toString() === a.toString())
    return !0;
  let s, c, u;
  if (r && a && typeof r == "object") {
    if (Array.isArray(r)) {
      if (s = r.length, s !== a.length) return !1;
      for (c = s; c-- !== 0; )
        if (!deepEqual$1(r[c], a[c]))
          return !1;
      return !0;
    }
    if (u = Object.keys(r), s = u.length, s !== Object.keys(a).length)
      return !1;
    for (c = s; c-- !== 0; )
      if (!{}.hasOwnProperty.call(a, u[c]))
        return !1;
    for (c = s; c-- !== 0; ) {
      const d = u[c];
      if (!(d === "_owner" && r.$$typeof) && !deepEqual$1(r[d], a[d]))
        return !1;
    }
    return !0;
  }
  return r !== r && a !== a;
}
function getDPR(r) {
  return typeof window > "u" ? 1 : (r.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(r, a) {
  const s = getDPR(r);
  return Math.round(a * s) / s;
}
function useLatestRef$2(r) {
  const a = React.useRef(r);
  return index$1(() => {
    a.current = r;
  }), a;
}
function useFloating$1(r) {
  r === void 0 && (r = {});
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: c = [],
    platform: u,
    elements: {
      reference: d,
      floating: h
    } = {},
    transform: p = !0,
    whileElementsMounted: m,
    open: g
  } = r, [v, y] = React.useState({
    x: 0,
    y: 0,
    strategy: s,
    placement: a,
    middlewareData: {},
    isPositioned: !1
  }), [x, w] = React.useState(c);
  deepEqual$1(x, c) || w(c);
  const [S, M] = React.useState(null), [P, L] = React.useState(null), I = React.useCallback((D) => {
    D !== A.current && (A.current = D, M(D));
  }, []), T = React.useCallback((D) => {
    D !== k.current && (k.current = D, L(D));
  }, []), E = d || S, R = h || P, A = React.useRef(null), k = React.useRef(null), V = React.useRef(v), B = m != null, q = useLatestRef$2(m), z = useLatestRef$2(u), Z = useLatestRef$2(g), G = React.useCallback(() => {
    if (!A.current || !k.current)
      return;
    const D = {
      placement: a,
      strategy: s,
      middleware: x
    };
    z.current && (D.platform = z.current), computePosition(A.current, k.current, D).then((j) => {
      const H = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Z.current !== !1
      };
      K.current && !deepEqual$1(V.current, H) && (V.current = H, ReactDOM.flushSync(() => {
        y(H);
      }));
    });
  }, [x, a, s, z, Z]);
  index$1(() => {
    g === !1 && V.current.isPositioned && (V.current.isPositioned = !1, y((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [g]);
  const K = React.useRef(!1);
  index$1(() => (K.current = !0, () => {
    K.current = !1;
  }), []), index$1(() => {
    if (E && (A.current = E), R && (k.current = R), E && R) {
      if (q.current)
        return q.current(E, R, G);
      G();
    }
  }, [E, R, G, q, B]);
  const U = React.useMemo(() => ({
    reference: A,
    floating: k,
    setReference: I,
    setFloating: T
  }), [I, T]), F = React.useMemo(() => ({
    reference: E,
    floating: R
  }), [E, R]), N = React.useMemo(() => {
    const D = {
      position: s,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return D;
    const j = roundByDPR(F.floating, v.x), H = roundByDPR(F.floating, v.y);
    return p ? {
      ...D,
      transform: "translate(" + j + "px, " + H + "px)",
      ...getDPR(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: s,
      left: j,
      top: H
    };
  }, [s, p, F.floating, v.x, v.y]);
  return React.useMemo(() => ({
    ...v,
    update: G,
    refs: U,
    elements: F,
    floatingStyles: N
  }), [v, G, U, F, N]);
}
const arrow$1$1 = (r) => {
  function a(s) {
    return {}.hasOwnProperty.call(s, "current");
  }
  return {
    name: "arrow",
    options: r,
    fn(s) {
      const {
        element: c,
        padding: u
      } = typeof r == "function" ? r(s) : r;
      return c && a(c) ? c.current != null ? arrow$3({
        element: c.current,
        padding: u
      }).fn(s) : {} : c ? arrow$3({
        element: c,
        padding: u
      }).fn(s) : {};
    }
  };
}, offset$2 = (r, a) => ({
  ...offset$3(r),
  options: [r, a]
}), shift = (r, a) => ({
  ...shift$1(r),
  options: [r, a]
}), flip$2 = (r, a) => ({
  ...flip$3(r),
  options: [r, a]
}), size = (r, a) => ({
  ...size$1(r),
  options: [r, a]
}), arrow$2 = (r, a) => ({
  ...arrow$1$1(r),
  options: [r, a]
});
function useMergeRefs(r) {
  return React.useMemo(() => r.every((a) => a == null) ? null : (a) => {
    r.forEach((s) => {
      typeof s == "function" ? s(a) : s != null && (s.current = a);
    });
  }, r);
}
const SafeReact = {
  ...React
}, useInsertionEffect = SafeReact.useInsertionEffect, useSafeInsertionEffect = useInsertionEffect || ((r) => r());
function useEffectEvent(r) {
  const a = React.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return useSafeInsertionEffect(() => {
    a.current = r;
  }), React.useCallback(function() {
    for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
      c[u] = arguments[u];
    return a.current == null ? void 0 : a.current(...c);
  }, []);
}
const ARROW_UP = "ArrowUp", ARROW_DOWN = "ArrowDown", ARROW_LEFT = "ArrowLeft", ARROW_RIGHT = "ArrowRight";
function isDifferentRow(r, a, s) {
  return Math.floor(r / a) !== s;
}
function isIndexOutOfBounds(r, a) {
  return a < 0 || a >= r.current.length;
}
function getMinIndex(r, a) {
  return findNonDisabledIndex(r, {
    disabledIndices: a
  });
}
function getMaxIndex(r, a) {
  return findNonDisabledIndex(r, {
    decrement: !0,
    startingIndex: r.current.length,
    disabledIndices: a
  });
}
function findNonDisabledIndex(r, a) {
  let {
    startingIndex: s = -1,
    decrement: c = !1,
    disabledIndices: u,
    amount: d = 1
  } = a === void 0 ? {} : a;
  const h = r.current;
  let p = s;
  do
    p += c ? -d : d;
  while (p >= 0 && p <= h.length - 1 && isDisabled(h, p, u));
  return p;
}
function getGridNavigatedIndex(r, a) {
  let {
    event: s,
    orientation: c,
    loop: u,
    cols: d,
    disabledIndices: h,
    minIndex: p,
    maxIndex: m,
    prevIndex: g,
    stopEvent: v = !1
  } = a, y = g;
  if (s.key === ARROW_UP) {
    if (v && stopEvent(s), g === -1)
      y = m;
    else if (y = findNonDisabledIndex(r, {
      startingIndex: y,
      amount: d,
      decrement: !0,
      disabledIndices: h
    }), u && (g - d < p || y < 0)) {
      const x = g % d, w = m % d, S = m - (w - x);
      w === x ? y = m : y = w > x ? S : S - d;
    }
    isIndexOutOfBounds(r, y) && (y = g);
  }
  if (s.key === ARROW_DOWN && (v && stopEvent(s), g === -1 ? y = p : (y = findNonDisabledIndex(r, {
    startingIndex: g,
    amount: d,
    disabledIndices: h
  }), u && g + d > m && (y = findNonDisabledIndex(r, {
    startingIndex: g % d - d,
    amount: d,
    disabledIndices: h
  }))), isIndexOutOfBounds(r, y) && (y = g)), c === "both") {
    const x = floor$1(g / d);
    s.key === ARROW_RIGHT && (v && stopEvent(s), g % d !== d - 1 ? (y = findNonDisabledIndex(r, {
      startingIndex: g,
      disabledIndices: h
    }), u && isDifferentRow(y, d, x) && (y = findNonDisabledIndex(r, {
      startingIndex: g - g % d - 1,
      disabledIndices: h
    }))) : u && (y = findNonDisabledIndex(r, {
      startingIndex: g - g % d - 1,
      disabledIndices: h
    })), isDifferentRow(y, d, x) && (y = g)), s.key === ARROW_LEFT && (v && stopEvent(s), g % d !== 0 ? (y = findNonDisabledIndex(r, {
      startingIndex: g,
      decrement: !0,
      disabledIndices: h
    }), u && isDifferentRow(y, d, x) && (y = findNonDisabledIndex(r, {
      startingIndex: g + (d - g % d),
      decrement: !0,
      disabledIndices: h
    }))) : u && (y = findNonDisabledIndex(r, {
      startingIndex: g + (d - g % d),
      decrement: !0,
      disabledIndices: h
    })), isDifferentRow(y, d, x) && (y = g));
    const w = floor$1(m / d) === x;
    isIndexOutOfBounds(r, y) && (u && w ? y = s.key === ARROW_LEFT ? m : findNonDisabledIndex(r, {
      startingIndex: g - g % d - 1,
      disabledIndices: h
    }) : y = g);
  }
  return y;
}
function buildCellMap(r, a, s) {
  const c = [];
  let u = 0;
  return r.forEach((d, h) => {
    let {
      width: p,
      height: m
    } = d;
    if (p > a && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + h + " is greater than grid columns");
    let g = !1;
    for (s && (u = 0); !g; ) {
      const v = [];
      for (let y = 0; y < p; y++)
        for (let x = 0; x < m; x++)
          v.push(u + y + x * a);
      u % a + p <= a && v.every((y) => c[y] == null) ? (v.forEach((y) => {
        c[y] = h;
      }), g = !0) : u++;
    }
  }), [...c];
}
function getCellIndexOfCorner(r, a, s, c, u) {
  if (r === -1) return -1;
  const d = s.indexOf(r), h = a[r];
  switch (u) {
    case "tl":
      return d;
    case "tr":
      return h ? d + h.width - 1 : d;
    case "bl":
      return h ? d + (h.height - 1) * c : d;
    case "br":
      return s.lastIndexOf(r);
  }
}
function getCellIndices(r, a) {
  return a.flatMap((s, c) => r.includes(s) ? [c] : []);
}
function isDisabled(r, a, s) {
  if (s)
    return s.includes(a);
  const c = r[a];
  return c == null || c.hasAttribute("disabled") || c.getAttribute("aria-disabled") === "true";
}
let rafId = 0;
function enqueueFocus(r, a) {
  a === void 0 && (a = {});
  const {
    preventScroll: s = !1,
    cancelPrevious: c = !0,
    sync: u = !1
  } = a;
  c && cancelAnimationFrame(rafId);
  const d = () => r == null ? void 0 : r.focus({
    preventScroll: s
  });
  u ? d() : rafId = requestAnimationFrame(d);
}
var index = typeof document < "u" ? useLayoutEffect$1 : useEffect$1;
function sortByDocumentPosition(r, a) {
  const s = r.compareDocumentPosition(a);
  return s & Node.DOCUMENT_POSITION_FOLLOWING || s & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING || s & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
function areMapsEqual(r, a) {
  if (r.size !== a.size)
    return !1;
  for (const [s, c] of r.entries())
    if (c !== a.get(s))
      return !1;
  return !0;
}
const FloatingListContext = /* @__PURE__ */ React.createContext({
  register: () => {
  },
  unregister: () => {
  },
  map: /* @__PURE__ */ new Map(),
  elementsRef: {
    current: []
  }
});
function FloatingList(r) {
  const {
    children: a,
    elementsRef: s,
    labelsRef: c
  } = r, [u, d] = React.useState(() => /* @__PURE__ */ new Map()), h = React.useCallback((m) => {
    d((g) => new Map(g).set(m, null));
  }, []), p = React.useCallback((m) => {
    d((g) => {
      const v = new Map(g);
      return v.delete(m), v;
    });
  }, []);
  return index(() => {
    const m = new Map(u);
    Array.from(m.keys()).sort(sortByDocumentPosition).forEach((v, y) => {
      m.set(v, y);
    }), areMapsEqual(u, m) || d(m);
  }, [u]), /* @__PURE__ */ React.createElement(FloatingListContext.Provider, {
    value: React.useMemo(() => ({
      register: h,
      unregister: p,
      map: u,
      elementsRef: s,
      labelsRef: c
    }), [h, p, u, s, c])
  }, a);
}
function useListItem(r) {
  r === void 0 && (r = {});
  const {
    label: a
  } = r, {
    register: s,
    unregister: c,
    map: u,
    elementsRef: d,
    labelsRef: h
  } = React.useContext(FloatingListContext), [p, m] = React.useState(null), g = React.useRef(null), v = React.useCallback((y) => {
    if (g.current = y, p !== null && (d.current[p] = y, h)) {
      var x;
      const w = a !== void 0;
      h.current[p] = w ? a : (x = y == null ? void 0 : y.textContent) != null ? x : null;
    }
  }, [p, d, h, a]);
  return index(() => {
    const y = g.current;
    if (y)
      return s(y), () => {
        c(y);
      };
  }, [s, c]), index(() => {
    const y = g.current ? u.get(g.current) : null;
    y != null && m(y);
  }, [u]), React.useMemo(() => ({
    ref: v,
    index: p ?? -1
  }), [p, v]);
}
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var c in s)
        Object.prototype.hasOwnProperty.call(s, c) && (r[c] = s[c]);
    }
    return r;
  }, _extends$4.apply(this, arguments);
}
let serverHandoffComplete = !1, count$1 = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count$1++
);
function useFloatingId() {
  const [r, a] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  return index(() => {
    r == null && a(genId());
  }, []), React.useEffect(() => {
    serverHandoffComplete = !0;
  }, []), r;
}
const useReactId = SafeReact.useId, useId$1 = useReactId || useFloatingId;
let devMessageSet;
process.env.NODE_ENV !== "production" && (devMessageSet = /* @__PURE__ */ new Set());
function warn() {
  for (var r, a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  const u = "Floating UI: " + s.join(" ");
  if (!((r = devMessageSet) != null && r.has(u))) {
    var d;
    (d = devMessageSet) == null || d.add(u), console.warn(u);
  }
}
function error() {
  for (var r, a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  const u = "Floating UI: " + s.join(" ");
  if (!((r = devMessageSet) != null && r.has(u))) {
    var d;
    (d = devMessageSet) == null || d.add(u), console.error(u);
  }
}
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function r(a, s) {
  const {
    context: {
      placement: c,
      elements: {
        floating: u
      },
      middlewareData: {
        arrow: d,
        shift: h
      }
    },
    width: p = 14,
    height: m = 7,
    tipRadius: g = 0,
    strokeWidth: v = 0,
    staticOffset: y,
    stroke: x,
    d: w,
    style: {
      transform: S,
      ...M
    } = {},
    ...P
  } = a;
  process.env.NODE_ENV !== "production" && (s || warn("The `ref` prop is required for `FloatingArrow`."));
  const L = useId$1(), [I, T] = React.useState(!1);
  if (index(() => {
    if (!u) return;
    getComputedStyle$3(u).direction === "rtl" && T(!0);
  }, [u]), !u)
    return null;
  const [E, R] = c.split("-"), A = E === "top" || E === "bottom";
  let k = y;
  (A && h != null && h.x || !A && h != null && h.y) && (k = null);
  const V = v * 2, B = V / 2, q = p / 2 * (g / -8 + 1), z = m / 2 * g / 4, Z = !!w, G = k && R === "end" ? "bottom" : "top";
  let K = k && R === "end" ? "right" : "left";
  k && I && (K = R === "end" ? "left" : "right");
  const U = (d == null ? void 0 : d.x) != null ? k || d.x : "", F = (d == null ? void 0 : d.y) != null ? k || d.y : "", N = w || "M0,0" + (" H" + p) + (" L" + (p - q) + "," + (m - z)) + (" Q" + p / 2 + "," + m + " " + q + "," + (m - z)) + " Z", D = {
    top: Z ? "rotate(180deg)" : "",
    left: Z ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: Z ? "" : "rotate(180deg)",
    right: Z ? "rotate(-90deg)" : "rotate(90deg)"
  }[E];
  return /* @__PURE__ */ React.createElement("svg", _extends$4({}, P, {
    "aria-hidden": !0,
    ref: s,
    width: Z ? p : p + V,
    height: p,
    viewBox: "0 0 " + p + " " + (m > p ? m : p),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [K]: U,
      [G]: F,
      [E]: A || Z ? "100%" : "calc(100% - " + V / 2 + "px)",
      transform: [D, S].filter((j) => !!j).join(" "),
      ...M
    }
  }), V > 0 && /* @__PURE__ */ React.createElement("path", {
    clipPath: "url(#" + L + ")",
    fill: "none",
    stroke: x,
    strokeWidth: V + (w ? 0 : 1),
    d: N
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: V && !w ? P.fill : "none",
    d: N
  }), /* @__PURE__ */ React.createElement("clipPath", {
    id: L
  }, /* @__PURE__ */ React.createElement("rect", {
    x: -B,
    y: B * (Z ? -1 : 1),
    width: p + V,
    height: p
  })));
});
function createPubSub() {
  const r = /* @__PURE__ */ new Map();
  return {
    emit(a, s) {
      var c;
      (c = r.get(a)) == null || c.forEach((u) => u(s));
    },
    on(a, s) {
      r.set(a, [...r.get(a) || [], s]);
    },
    off(a, s) {
      var c;
      r.set(a, ((c = r.get(a)) == null ? void 0 : c.filter((u) => u !== s)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null), FloatingTreeContext = /* @__PURE__ */ React.createContext(null), useFloatingParentNodeId = () => {
  var r;
  return ((r = React.useContext(FloatingNodeContext)) == null ? void 0 : r.id) || null;
}, useFloatingTree = () => React.useContext(FloatingTreeContext);
function createAttribute(r) {
  return "data-floating-ui-" + r;
}
function useLatestRef$1(r) {
  const a = useRef$1(r);
  return index(() => {
    a.current = r;
  }), a;
}
const safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(r, a, s) {
  return s && !isMouseLikePointerType(s) ? 0 : typeof r == "number" ? r : r == null ? void 0 : r[a];
}
function useHover(r, a) {
  a === void 0 && (a = {});
  const {
    open: s,
    onOpenChange: c,
    dataRef: u,
    events: d,
    elements: h
  } = r, {
    enabled: p = !0,
    delay: m = 0,
    handleClose: g = null,
    mouseOnly: v = !1,
    restMs: y = 0,
    move: x = !0
  } = a, w = useFloatingTree(), S = useFloatingParentNodeId(), M = useLatestRef$1(g), P = useLatestRef$1(m), L = useLatestRef$1(s), I = React.useRef(), T = React.useRef(-1), E = React.useRef(), R = React.useRef(-1), A = React.useRef(!0), k = React.useRef(!1), V = React.useRef(() => {
  }), B = React.useCallback(() => {
    var U;
    const F = (U = u.current.openEvent) == null ? void 0 : U.type;
    return (F == null ? void 0 : F.includes("mouse")) && F !== "mousedown";
  }, [u]);
  React.useEffect(() => {
    if (!p) return;
    function U(F) {
      let {
        open: N
      } = F;
      N || (clearTimeout(T.current), clearTimeout(R.current), A.current = !0);
    }
    return d.on("openchange", U), () => {
      d.off("openchange", U);
    };
  }, [p, d]), React.useEffect(() => {
    if (!p || !M.current || !s) return;
    function U(N) {
      B() && c(!1, N, "hover");
    }
    const F = getDocument(h.floating).documentElement;
    return F.addEventListener("mouseleave", U), () => {
      F.removeEventListener("mouseleave", U);
    };
  }, [h.floating, s, c, p, M, B]);
  const q = React.useCallback(function(U, F, N) {
    F === void 0 && (F = !0), N === void 0 && (N = "hover");
    const D = getDelay(P.current, "close", I.current);
    D && !E.current ? (clearTimeout(T.current), T.current = window.setTimeout(() => c(!1, U, N), D)) : F && (clearTimeout(T.current), c(!1, U, N));
  }, [P, c]), z = useEffectEvent(() => {
    V.current(), E.current = void 0;
  }), Z = useEffectEvent(() => {
    if (k.current) {
      const U = getDocument(h.floating).body;
      U.style.pointerEvents = "", U.removeAttribute(safePolygonIdentifier), k.current = !1;
    }
  });
  React.useEffect(() => {
    if (!p) return;
    function U() {
      return u.current.openEvent ? ["click", "mousedown"].includes(u.current.openEvent.type) : !1;
    }
    function F(H) {
      if (clearTimeout(T.current), A.current = !1, v && !isMouseLikePointerType(I.current) || y > 0 && !getDelay(P.current, "open"))
        return;
      const W = getDelay(P.current, "open", I.current);
      W ? T.current = window.setTimeout(() => {
        L.current || c(!0, H, "hover");
      }, W) : c(!0, H, "hover");
    }
    function N(H) {
      if (U()) return;
      V.current();
      const W = getDocument(h.floating);
      if (clearTimeout(R.current), M.current && u.current.floatingContext) {
        s || clearTimeout(T.current), E.current = M.current({
          ...u.current.floatingContext,
          tree: w,
          x: H.clientX,
          y: H.clientY,
          onClose() {
            Z(), z(), q(H, !0, "safe-polygon");
          }
        });
        const ae = E.current;
        W.addEventListener("mousemove", ae), V.current = () => {
          W.removeEventListener("mousemove", ae);
        };
        return;
      }
      (I.current === "touch" ? !contains$1(h.floating, H.relatedTarget) : !0) && q(H);
    }
    function D(H) {
      U() || u.current.floatingContext && (M.current == null || M.current({
        ...u.current.floatingContext,
        tree: w,
        x: H.clientX,
        y: H.clientY,
        onClose() {
          Z(), z(), q(H);
        }
      })(H));
    }
    if (isElement$2(h.domReference)) {
      var j;
      const H = h.domReference;
      return s && H.addEventListener("mouseleave", D), (j = h.floating) == null || j.addEventListener("mouseleave", D), x && H.addEventListener("mousemove", F, {
        once: !0
      }), H.addEventListener("mouseenter", F), H.addEventListener("mouseleave", N), () => {
        var W;
        s && H.removeEventListener("mouseleave", D), (W = h.floating) == null || W.removeEventListener("mouseleave", D), x && H.removeEventListener("mousemove", F), H.removeEventListener("mouseenter", F), H.removeEventListener("mouseleave", N);
      };
    }
  }, [h, p, r, v, y, x, q, z, Z, c, s, L, w, P, M, u]), index(() => {
    var U;
    if (p && s && (U = M.current) != null && U.__options.blockPointerEvents && B()) {
      k.current = !0;
      const N = h.floating;
      if (isElement$2(h.domReference) && N) {
        var F;
        const D = getDocument(h.floating).body;
        D.setAttribute(safePolygonIdentifier, "");
        const j = h.domReference, H = w == null || (F = w.nodesRef.current.find((W) => W.id === S)) == null || (F = F.context) == null ? void 0 : F.elements.floating;
        return H && (H.style.pointerEvents = ""), D.style.pointerEvents = "none", j.style.pointerEvents = "auto", N.style.pointerEvents = "auto", () => {
          D.style.pointerEvents = "", j.style.pointerEvents = "", N.style.pointerEvents = "";
        };
      }
    }
  }, [p, s, S, h, w, M, B]), index(() => {
    s || (I.current = void 0, z(), Z());
  }, [s, z, Z]), React.useEffect(() => () => {
    z(), clearTimeout(T.current), clearTimeout(R.current), Z();
  }, [p, h.domReference, z, Z]);
  const G = React.useMemo(() => {
    function U(F) {
      I.current = F.pointerType;
    }
    return {
      onPointerDown: U,
      onPointerEnter: U,
      onMouseMove(F) {
        const {
          nativeEvent: N
        } = F;
        function D() {
          !A.current && !L.current && c(!0, N, "hover");
        }
        v && !isMouseLikePointerType(I.current) || s || y === 0 || (clearTimeout(R.current), I.current === "touch" ? D() : R.current = window.setTimeout(D, y));
      }
    };
  }, [v, c, s, L, y]), K = React.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(T.current);
    },
    onMouseLeave(U) {
      q(U.nativeEvent, !1);
    }
  }), [q]);
  return React.useMemo(() => p ? {
    reference: G,
    floating: K
  } : {}, [p, G, K]);
}
function getAncestors(r, a) {
  var s;
  let c = [], u = (s = r.find((d) => d.id === a)) == null ? void 0 : s.parentId;
  for (; u; ) {
    const d = r.find((h) => h.id === u);
    u = d == null ? void 0 : d.parentId, d && (c = c.concat(d));
  }
  return c;
}
function getChildren(r, a) {
  let s = r.filter((u) => {
    var d;
    return u.parentId === a && ((d = u.context) == null ? void 0 : d.open);
  }), c = s;
  for (; c.length; )
    c = r.filter((u) => {
      var d;
      return (d = c) == null ? void 0 : d.some((h) => {
        var p;
        return u.parentId === h.id && ((p = u.context) == null ? void 0 : p.open);
      });
    }), s = s.concat(c);
  return s;
}
function getDeepestNode(r, a) {
  let s, c = -1;
  function u(d, h) {
    h > c && (s = d, c = h), getChildren(r, d).forEach((m) => {
      u(m.id, h + 1);
    });
  }
  return u(a, 0), r.find((d) => d.id === s);
}
let counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {}, lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, unwrapHost = (r) => r && (r.host || unwrapHost(r.parentNode)), correctElements = (r, a) => a.map((s) => {
  if (r.contains(s))
    return s;
  const c = unwrapHost(s);
  return r.contains(c) ? c : null;
}).filter((s) => s != null);
function applyAttributeToOthers(r, a, s, c) {
  const u = "data-floating-ui-inert", d = c ? "inert" : s ? "aria-hidden" : null, h = correctElements(a, r), p = /* @__PURE__ */ new Set(), m = new Set(h), g = [];
  markerMap[u] || (markerMap[u] = /* @__PURE__ */ new WeakMap());
  const v = markerMap[u];
  h.forEach(y), x(a), p.clear();
  function y(w) {
    !w || p.has(w) || (p.add(w), w.parentNode && y(w.parentNode));
  }
  function x(w) {
    !w || m.has(w) || [].forEach.call(w.children, (S) => {
      if (getNodeName$2(S) !== "script")
        if (p.has(S))
          x(S);
        else {
          const M = d ? S.getAttribute(d) : null, P = M !== null && M !== "false", L = (counterMap.get(S) || 0) + 1, I = (v.get(S) || 0) + 1;
          counterMap.set(S, L), v.set(S, I), g.push(S), L === 1 && P && uncontrolledElementsSet.add(S), I === 1 && S.setAttribute(u, ""), !P && d && S.setAttribute(d, "true");
        }
    });
  }
  return lockCount$1++, () => {
    g.forEach((w) => {
      const S = (counterMap.get(w) || 0) - 1, M = (v.get(w) || 0) - 1;
      counterMap.set(w, S), v.set(w, M), S || (!uncontrolledElementsSet.has(w) && d && w.removeAttribute(d), uncontrolledElementsSet.delete(w)), M || w.removeAttribute(u);
    }), lockCount$1--, lockCount$1 || (counterMap = /* @__PURE__ */ new WeakMap(), counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {});
  };
}
function markOthers(r, a, s) {
  a === void 0 && (a = !1), s === void 0 && (s = !1);
  const c = getDocument(r[0]).body;
  return applyAttributeToOthers(r.concat(Array.from(c.querySelectorAll("[aria-live]"))), c, a, s);
}
const getTabbableOptions = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(r, a) {
  const s = tabbable(r, getTabbableOptions());
  a === "prev" && s.reverse();
  const c = s.indexOf(activeElement(getDocument(r)));
  return s.slice(c + 1)[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(r, a) {
  const s = a || r.currentTarget, c = r.relatedTarget;
  return !c || !contains$1(s, c);
}
function disableFocusInside(r) {
  tabbable(r, getTabbableOptions()).forEach((s) => {
    s.dataset.tabindex = s.getAttribute("tabindex") || "", s.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(r) {
  r.querySelectorAll("[data-tabindex]").forEach((s) => {
    const c = s.dataset.tabindex;
    delete s.dataset.tabindex, c ? s.setAttribute("tabindex", c) : s.removeAttribute("tabindex");
  });
}
const HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(r) {
  r.key === "Tab" && (r.target, clearTimeout(timeoutId));
}
const FocusGuard = /* @__PURE__ */ React.forwardRef(function r(a, s) {
  const [c, u] = React.useState();
  index(() => (isSafari() && u("button"), document.addEventListener("keydown", setActiveElementOnTab), () => {
    document.removeEventListener("keydown", setActiveElementOnTab);
  }), []);
  const d = {
    ref: s,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: c,
    "aria-hidden": c ? void 0 : !0,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ React.createElement("span", _extends$4({}, a, d));
}), PortalContext = /* @__PURE__ */ React.createContext(null), attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(r) {
  r === void 0 && (r = {});
  const {
    id: a,
    root: s
  } = r, c = useId$1(), u = usePortalContext(), [d, h] = React.useState(null), p = React.useRef(null);
  return index(() => () => {
    d == null || d.remove(), queueMicrotask(() => {
      p.current = null;
    });
  }, [d]), index(() => {
    if (!c || p.current) return;
    const m = a ? document.getElementById(a) : null;
    if (!m) return;
    const g = document.createElement("div");
    g.id = c, g.setAttribute(attr, ""), m.appendChild(g), p.current = g, h(g);
  }, [a, c]), index(() => {
    if (!c || p.current) return;
    let m = s || (u == null ? void 0 : u.portalNode);
    m && !isElement$2(m) && (m = m.current), m = m || document.body;
    let g = null;
    a && (g = document.createElement("div"), g.id = a, m.appendChild(g));
    const v = document.createElement("div");
    v.id = c, v.setAttribute(attr, ""), m = g || m, m.appendChild(v), p.current = v, h(v);
  }, [a, s, c, u]), d;
}
function FloatingPortal(r) {
  const {
    children: a,
    id: s,
    root: c = null,
    preserveTabOrder: u = !0
  } = r, d = useFloatingPortalNode({
    id: s,
    root: c
  }), [h, p] = React.useState(null), m = React.useRef(null), g = React.useRef(null), v = React.useRef(null), y = React.useRef(null), x = h == null ? void 0 : h.modal, w = h == null ? void 0 : h.open, S = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!h && // Guards are only for non-modal focus management.
    !h.modal && // Don't render if unmount is transitioning.
    h.open && u && !!(c || d)
  );
  return React.useEffect(() => {
    if (!d || !u || x)
      return;
    function M(P) {
      d && isOutsideEvent(P) && (P.type === "focusin" ? enableFocusInside : disableFocusInside)(d);
    }
    return d.addEventListener("focusin", M, !0), d.addEventListener("focusout", M, !0), () => {
      d.removeEventListener("focusin", M, !0), d.removeEventListener("focusout", M, !0);
    };
  }, [d, u, x]), React.useEffect(() => {
    d && (w || enableFocusInside(d));
  }, [w, d]), /* @__PURE__ */ React.createElement(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder: u,
      beforeOutsideRef: m,
      afterOutsideRef: g,
      beforeInsideRef: v,
      afterInsideRef: y,
      portalNode: d,
      setFocusManagerState: p
    }), [u, d])
  }, S && d && /* @__PURE__ */ React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: m,
    onFocus: (M) => {
      if (isOutsideEvent(M, d)) {
        var P;
        (P = v.current) == null || P.focus();
      } else {
        const L = getPreviousTabbable() || (h == null ? void 0 : h.refs.domReference.current);
        L == null || L.focus();
      }
    }
  }), S && d && /* @__PURE__ */ React.createElement("span", {
    "aria-owns": d.id,
    style: HIDDEN_STYLES
  }), d && /* @__PURE__ */ ReactDOM.createPortal(a, d), S && d && /* @__PURE__ */ React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: g,
    onFocus: (M) => {
      if (isOutsideEvent(M, d)) {
        var P;
        (P = y.current) == null || P.focus();
      } else {
        const L = getNextTabbable() || (h == null ? void 0 : h.refs.domReference.current);
        L == null || L.focus(), h != null && h.closeOnFocusOut && (h == null || h.onOpenChange(!1, M.nativeEvent, "focus-out"));
      }
    }
  }));
}
const usePortalContext = () => React.useContext(PortalContext), FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(r) {
  return r ? r.hasAttribute(FOCUSABLE_ATTRIBUTE) ? r : r.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || r : null;
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(r) {
  previouslyFocusedElements = previouslyFocusedElements.filter((s) => s.isConnected);
  let a = r;
  if (!(!a || getNodeName$2(a) === "body")) {
    if (!isTabbable(a, getTabbableOptions())) {
      const s = tabbable(a, getTabbableOptions())[0];
      s && (a = s);
    }
    previouslyFocusedElements.push(a), previouslyFocusedElements.length > LIST_LIMIT && (previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT));
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find((r) => r.isConnected);
}
const VisuallyHiddenDismiss = /* @__PURE__ */ React.forwardRef(function r(a, s) {
  return /* @__PURE__ */ React.createElement("button", _extends$4({}, a, {
    type: "button",
    ref: s,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
function FloatingFocusManager(r) {
  const {
    context: a,
    children: s,
    disabled: c = !1,
    order: u = ["content"],
    guards: d = !0,
    initialFocus: h = 0,
    returnFocus: p = !0,
    restoreFocus: m = !1,
    modal: g = !0,
    visuallyHiddenDismiss: v = !1,
    closeOnFocusOut: y = !0
  } = r, {
    open: x,
    refs: w,
    nodeId: S,
    onOpenChange: M,
    events: P,
    dataRef: L,
    floatingId: I,
    elements: {
      domReference: T,
      floating: E
    }
  } = a, R = typeof h == "number" && h < 0, A = isTypeableCombobox(T) && R, k = supportsInert() ? d : !0, V = useLatestRef$1(u), B = useLatestRef$1(h), q = useLatestRef$1(p), z = useFloatingTree(), Z = usePortalContext(), G = React.useRef(null), K = React.useRef(null), U = React.useRef(!1), F = React.useRef(!1), N = React.useRef(-1), D = Z != null, j = getFloatingFocusElement(E), H = useEffectEvent(function(ee) {
    return ee === void 0 && (ee = j), ee ? tabbable(ee, getTabbableOptions()) : [];
  }), W = useEffectEvent((ee) => {
    const X = H(ee);
    return V.current.map((J) => T && J === "reference" ? T : j && J === "floating" ? j : X).filter(Boolean).flat();
  });
  React.useEffect(() => {
    U.current = !1;
  }, [c]), React.useEffect(() => {
    if (c || !g) return;
    function ee(J) {
      if (J.key === "Tab") {
        contains$1(j, activeElement(getDocument(j))) && H().length === 0 && !A && stopEvent(J);
        const ie = W(), oe = getTarget(J);
        V.current[0] === "reference" && oe === T && (stopEvent(J), J.shiftKey ? enqueueFocus(ie[ie.length - 1]) : enqueueFocus(ie[1])), V.current[1] === "floating" && oe === j && J.shiftKey && (stopEvent(J), enqueueFocus(ie[0]));
      }
    }
    const X = getDocument(j);
    return X.addEventListener("keydown", ee), () => {
      X.removeEventListener("keydown", ee);
    };
  }, [c, T, j, g, V, A, H, W]), React.useEffect(() => {
    if (c || !E) return;
    function ee(X) {
      const J = getTarget(X), oe = H().indexOf(J);
      oe !== -1 && (N.current = oe);
    }
    return E.addEventListener("focusin", ee), () => {
      E.removeEventListener("focusin", ee);
    };
  }, [c, E, H]), React.useEffect(() => {
    if (c || !y) return;
    function ee() {
      F.current = !0, setTimeout(() => {
        F.current = !1;
      });
    }
    function X(J) {
      const ie = J.relatedTarget;
      queueMicrotask(() => {
        const oe = !(contains$1(T, ie) || contains$1(E, ie) || contains$1(ie, E) || contains$1(Z == null ? void 0 : Z.portalNode, ie) || ie != null && ie.hasAttribute(createAttribute("focus-guard")) || z && (getChildren(z.nodesRef.current, S).find((fe) => {
          var ve, ue;
          return contains$1((ve = fe.context) == null ? void 0 : ve.elements.floating, ie) || contains$1((ue = fe.context) == null ? void 0 : ue.elements.domReference, ie);
        }) || getAncestors(z.nodesRef.current, S).find((fe) => {
          var ve, ue;
          return ((ve = fe.context) == null ? void 0 : ve.elements.floating) === ie || ((ue = fe.context) == null ? void 0 : ue.elements.domReference) === ie;
        })));
        if (m && oe && activeElement(getDocument(j)) === getDocument(j).body) {
          isHTMLElement$3(j) && j.focus();
          const fe = N.current, ve = H(), ue = ve[fe] || ve[ve.length - 1] || j;
          isHTMLElement$3(ue) && ue.focus();
        }
        (A || !g) && ie && oe && !F.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        ie !== getPreviouslyFocusedElement() && (U.current = !0, M(!1, J, "focus-out"));
      });
    }
    if (E && isHTMLElement$3(T))
      return T.addEventListener("focusout", X), T.addEventListener("pointerdown", ee), E.addEventListener("focusout", X), () => {
        T.removeEventListener("focusout", X), T.removeEventListener("pointerdown", ee), E.removeEventListener("focusout", X);
      };
  }, [c, T, E, j, g, S, z, Z, M, y, m, H, A]), React.useEffect(() => {
    var ee;
    if (c) return;
    const X = Array.from((Z == null || (ee = Z.portalNode) == null ? void 0 : ee.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
    if (E) {
      const J = [E, ...X, G.current, K.current, V.current.includes("reference") || A ? T : null].filter((oe) => oe != null), ie = g || A ? markOthers(J, k, !k) : markOthers(J);
      return () => {
        ie();
      };
    }
  }, [c, T, E, g, V, Z, A, k]), index(() => {
    if (c || !isHTMLElement$3(j)) return;
    const ee = getDocument(j), X = activeElement(ee);
    queueMicrotask(() => {
      const J = W(j), ie = B.current, oe = (typeof ie == "number" ? J[ie] : ie.current) || j, fe = contains$1(j, X);
      !R && !fe && x && enqueueFocus(oe, {
        preventScroll: oe === j
      });
    });
  }, [c, x, j, R, W, B]), index(() => {
    if (c || !j) return;
    let ee = !1;
    const X = getDocument(j), J = activeElement(X);
    let oe = L.current.openEvent;
    addPreviouslyFocusedElement(J);
    function fe(ue) {
      let {
        open: pe,
        reason: we,
        event: ye,
        nested: Ie
      } = ue;
      pe && (oe = ye), we === "escape-key" && w.domReference.current && addPreviouslyFocusedElement(w.domReference.current), we === "hover" && ye.type === "mouseleave" && (U.current = !0), we === "outside-press" && (Ie ? (U.current = !1, ee = !0) : U.current = !(isVirtualClick(ye) || isVirtualPointerEvent(ye)));
    }
    P.on("openchange", fe);
    const ve = X.createElement("span");
    return ve.setAttribute("tabindex", "-1"), ve.setAttribute("aria-hidden", "true"), Object.assign(ve.style, HIDDEN_STYLES), D && T && T.insertAdjacentElement("afterend", ve), () => {
      P.off("openchange", fe);
      const ue = activeElement(X), pe = contains$1(E, ue) || z && getChildren(z.nodesRef.current, S).some((Ie) => {
        var Ee;
        return contains$1((Ee = Ie.context) == null ? void 0 : Ee.elements.floating, ue);
      });
      (pe || oe && ["click", "mousedown"].includes(oe.type)) && w.domReference.current && addPreviouslyFocusedElement(w.domReference.current);
      const ye = getPreviouslyFocusedElement() || ve;
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        q.current && !U.current && isHTMLElement$3(ye) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(ye !== ue && ue !== X.body) || pe) && ye.focus({
          preventScroll: ee
        }), ve.remove();
      });
    };
  }, [c, E, j, q, L, w, P, z, S, D, T]), index(() => {
    if (!c && Z)
      return Z.setFocusManagerState({
        modal: g,
        closeOnFocusOut: y,
        open: x,
        onOpenChange: M,
        refs: w
      }), () => {
        Z.setFocusManagerState(null);
      };
  }, [c, Z, g, x, M, w, y]), index(() => {
    if (c || !j || typeof MutationObserver != "function" || R) return;
    const ee = () => {
      const J = j.getAttribute("tabindex"), ie = H(), oe = activeElement(getDocument(E)), fe = ie.indexOf(oe);
      fe !== -1 && (N.current = fe), V.current.includes("floating") || oe !== w.domReference.current && ie.length === 0 ? J !== "0" && j.setAttribute("tabindex", "0") : J !== "-1" && j.setAttribute("tabindex", "-1");
    };
    ee();
    const X = new MutationObserver(ee);
    return X.observe(j, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      X.disconnect();
    };
  }, [c, E, j, w, V, H, R]);
  function re(ee) {
    return c || !v || !g ? null : /* @__PURE__ */ React.createElement(VisuallyHiddenDismiss, {
      ref: ee === "start" ? G : K,
      onClick: (X) => M(!1, X.nativeEvent)
    }, typeof v == "string" ? v : "Dismiss");
  }
  const ae = !c && k && (g ? !A : !0) && (D || g);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ae && /* @__PURE__ */ React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: Z == null ? void 0 : Z.beforeInsideRef,
    onFocus: (ee) => {
      if (g) {
        const J = W();
        enqueueFocus(u[0] === "reference" ? J[0] : J[J.length - 1]);
      } else if (Z != null && Z.preserveTabOrder && Z.portalNode)
        if (U.current = !1, isOutsideEvent(ee, Z.portalNode)) {
          const J = getNextTabbable() || T;
          J == null || J.focus();
        } else {
          var X;
          (X = Z.beforeOutsideRef.current) == null || X.focus();
        }
    }
  }), !A && re("start"), s, re("end"), ae && /* @__PURE__ */ React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: Z == null ? void 0 : Z.afterInsideRef,
    onFocus: (ee) => {
      if (g)
        enqueueFocus(W()[0]);
      else if (Z != null && Z.preserveTabOrder && Z.portalNode)
        if (y && (U.current = !0), isOutsideEvent(ee, Z.portalNode)) {
          const J = getPreviousTabbable() || T;
          J == null || J.focus();
        } else {
          var X;
          (X = Z.afterOutsideRef.current) == null || X.focus();
        }
    }
  }));
}
let lockCount = 0;
function enableScrollLock() {
  const r = /iP(hone|ad|od)|iOS/.test(getPlatform()), a = document.body.style, c = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", u = window.innerWidth - document.documentElement.clientWidth, d = a.left ? parseFloat(a.left) : window.scrollX, h = a.top ? parseFloat(a.top) : window.scrollY;
  if (a.overflow = "hidden", u && (a[c] = u + "px"), r) {
    var p, m;
    const g = ((p = window.visualViewport) == null ? void 0 : p.offsetLeft) || 0, v = ((m = window.visualViewport) == null ? void 0 : m.offsetTop) || 0;
    Object.assign(a, {
      position: "fixed",
      top: -(h - Math.floor(v)) + "px",
      left: -(d - Math.floor(g)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(a, {
      overflow: "",
      [c]: ""
    }), r && (Object.assign(a, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(d, h));
  };
}
let cleanup = () => {
};
const FloatingOverlay = /* @__PURE__ */ React.forwardRef(function r(a, s) {
  const {
    lockScroll: c = !1,
    ...u
  } = a;
  return index(() => {
    if (c)
      return lockCount++, lockCount === 1 && (cleanup = enableScrollLock()), () => {
        lockCount--, lockCount === 0 && cleanup();
      };
  }, [c]), /* @__PURE__ */ React.createElement("div", _extends$4({
    ref: s
  }, u, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...u.style
    }
  }));
});
function isButtonTarget(r) {
  return isHTMLElement$3(r.target) && r.target.tagName === "BUTTON";
}
function isSpaceIgnored(r) {
  return isTypeableElement(r);
}
function useClick(r, a) {
  a === void 0 && (a = {});
  const {
    open: s,
    onOpenChange: c,
    dataRef: u,
    elements: {
      domReference: d
    }
  } = r, {
    enabled: h = !0,
    event: p = "click",
    toggle: m = !0,
    ignoreMouse: g = !1,
    keyboardHandlers: v = !0
  } = a, y = React.useRef(), x = React.useRef(!1), w = React.useMemo(() => ({
    onPointerDown(S) {
      y.current = S.pointerType;
    },
    onMouseDown(S) {
      const M = y.current;
      S.button === 0 && p !== "click" && (isMouseLikePointerType(M, !0) && g || (s && m && (!u.current.openEvent || u.current.openEvent.type === "mousedown") ? c(!1, S.nativeEvent, "click") : (S.preventDefault(), c(!0, S.nativeEvent, "click"))));
    },
    onClick(S) {
      const M = y.current;
      if (p === "mousedown" && y.current) {
        y.current = void 0;
        return;
      }
      isMouseLikePointerType(M, !0) && g || (s && m && (!u.current.openEvent || u.current.openEvent.type === "click") ? c(!1, S.nativeEvent, "click") : c(!0, S.nativeEvent, "click"));
    },
    onKeyDown(S) {
      y.current = void 0, !(S.defaultPrevented || !v || isButtonTarget(S)) && (S.key === " " && !isSpaceIgnored(d) && (S.preventDefault(), x.current = !0), S.key === "Enter" && c(!(s && m), S.nativeEvent, "click"));
    },
    onKeyUp(S) {
      S.defaultPrevented || !v || isButtonTarget(S) || isSpaceIgnored(d) || S.key === " " && x.current && (x.current = !1, c(!(s && m), S.nativeEvent, "click"));
    }
  }), [u, d, p, g, v, c, s, m]);
  return React.useMemo(() => h ? {
    reference: w
  } : {}, [h, w]);
}
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, normalizeProp = (r) => {
  var a, s;
  return {
    escapeKey: typeof r == "boolean" ? r : (a = r == null ? void 0 : r.escapeKey) != null ? a : !1,
    outsidePress: typeof r == "boolean" ? r : (s = r == null ? void 0 : r.outsidePress) != null ? s : !0
  };
};
function useDismiss(r, a) {
  a === void 0 && (a = {});
  const {
    open: s,
    onOpenChange: c,
    elements: u,
    dataRef: d
  } = r, {
    enabled: h = !0,
    escapeKey: p = !0,
    outsidePress: m = !0,
    outsidePressEvent: g = "pointerdown",
    referencePress: v = !1,
    referencePressEvent: y = "pointerdown",
    ancestorScroll: x = !1,
    bubbles: w,
    capture: S
  } = a, M = useFloatingTree(), P = useEffectEvent(typeof m == "function" ? m : () => !1), L = typeof m == "function" ? P : m, I = React.useRef(!1), T = React.useRef(!1), {
    escapeKey: E,
    outsidePress: R
  } = normalizeProp(w), {
    escapeKey: A,
    outsidePress: k
  } = normalizeProp(S), V = useEffectEvent((K) => {
    var U;
    if (!s || !h || !p || K.key !== "Escape")
      return;
    const F = (U = d.current.floatingContext) == null ? void 0 : U.nodeId, N = M ? getChildren(M.nodesRef.current, F) : [];
    if (!E && (K.stopPropagation(), N.length > 0)) {
      let D = !0;
      if (N.forEach((j) => {
        var H;
        if ((H = j.context) != null && H.open && !j.context.dataRef.current.__escapeKeyBubbles) {
          D = !1;
          return;
        }
      }), !D)
        return;
    }
    c(!1, isReactEvent(K) ? K.nativeEvent : K, "escape-key");
  }), B = useEffectEvent((K) => {
    var U;
    const F = () => {
      var N;
      V(K), (N = getTarget(K)) == null || N.removeEventListener("keydown", F);
    };
    (U = getTarget(K)) == null || U.addEventListener("keydown", F);
  }), q = useEffectEvent((K) => {
    var U;
    const F = I.current;
    I.current = !1;
    const N = T.current;
    if (T.current = !1, g === "click" && N || F || typeof L == "function" && !L(K))
      return;
    const D = getTarget(K), j = "[" + createAttribute("inert") + "]", H = getDocument(u.floating).querySelectorAll(j);
    let W = isElement$2(D) ? D : null;
    for (; W && !isLastTraversableNode$1(W); ) {
      const X = getParentNode$2(W);
      if (isLastTraversableNode$1(X) || !isElement$2(X))
        break;
      W = X;
    }
    if (H.length && isElement$2(D) && !isRootElement(D) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains$1(D, u.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(H).every((X) => !contains$1(W, X)))
      return;
    if (isHTMLElement$3(D) && G) {
      const X = D.clientWidth > 0 && D.scrollWidth > D.clientWidth, J = D.clientHeight > 0 && D.scrollHeight > D.clientHeight;
      let ie = J && K.offsetX > D.clientWidth;
      if (J && getComputedStyle$3(D).direction === "rtl" && (ie = K.offsetX <= D.offsetWidth - D.clientWidth), ie || X && K.offsetY > D.clientHeight)
        return;
    }
    const re = (U = d.current.floatingContext) == null ? void 0 : U.nodeId, ae = M && getChildren(M.nodesRef.current, re).some((X) => {
      var J;
      return isEventTargetWithin(K, (J = X.context) == null ? void 0 : J.elements.floating);
    });
    if (isEventTargetWithin(K, u.floating) || isEventTargetWithin(K, u.domReference) || ae)
      return;
    const ee = M ? getChildren(M.nodesRef.current, re) : [];
    if (ee.length > 0) {
      let X = !0;
      if (ee.forEach((J) => {
        var ie;
        if ((ie = J.context) != null && ie.open && !J.context.dataRef.current.__outsidePressBubbles) {
          X = !1;
          return;
        }
      }), !X)
        return;
    }
    c(!1, K, "outside-press");
  }), z = useEffectEvent((K) => {
    var U;
    const F = () => {
      var N;
      q(K), (N = getTarget(K)) == null || N.removeEventListener(g, F);
    };
    (U = getTarget(K)) == null || U.addEventListener(g, F);
  });
  React.useEffect(() => {
    if (!s || !h)
      return;
    d.current.__escapeKeyBubbles = E, d.current.__outsidePressBubbles = R;
    function K(N) {
      c(!1, N, "ancestor-scroll");
    }
    const U = getDocument(u.floating);
    p && U.addEventListener("keydown", A ? B : V, A), L && U.addEventListener(g, k ? z : q, k);
    let F = [];
    return x && (isElement$2(u.domReference) && (F = getOverflowAncestors(u.domReference)), isElement$2(u.floating) && (F = F.concat(getOverflowAncestors(u.floating))), !isElement$2(u.reference) && u.reference && u.reference.contextElement && (F = F.concat(getOverflowAncestors(u.reference.contextElement)))), F = F.filter((N) => {
      var D;
      return N !== ((D = U.defaultView) == null ? void 0 : D.visualViewport);
    }), F.forEach((N) => {
      N.addEventListener("scroll", K, {
        passive: !0
      });
    }), () => {
      p && U.removeEventListener("keydown", A ? B : V, A), L && U.removeEventListener(g, k ? z : q, k), F.forEach((N) => {
        N.removeEventListener("scroll", K);
      });
    };
  }, [d, u, p, L, g, s, c, x, h, E, R, V, A, B, q, k, z]), React.useEffect(() => {
    I.current = !1;
  }, [L, g]);
  const Z = React.useMemo(() => ({
    onKeyDown: V,
    [bubbleHandlerKeys[y]]: (K) => {
      v && c(!1, K.nativeEvent, "reference-press");
    }
  }), [V, c, v, y]), G = React.useMemo(() => ({
    onKeyDown: V,
    onMouseDown() {
      T.current = !0;
    },
    onMouseUp() {
      T.current = !0;
    },
    [captureHandlerKeys[g]]: () => {
      I.current = !0;
    }
  }), [V, g]);
  return React.useMemo(() => h ? {
    reference: Z,
    floating: G
  } : {}, [h, Z, G]);
}
function useFloatingRootContext(r) {
  const {
    open: a = !1,
    onOpenChange: s,
    elements: c
  } = r, u = useId$1(), d = React.useRef({}), [h] = React.useState(() => createPubSub()), p = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const w = c.reference;
    w && !isElement$2(w) && error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [m, g] = React.useState(c.reference), v = useEffectEvent((w, S, M) => {
    d.current.openEvent = w ? S : void 0, h.emit("openchange", {
      open: w,
      event: S,
      reason: M,
      nested: p
    }), s == null || s(w, S, M);
  }), y = React.useMemo(() => ({
    setPositionReference: g
  }), []), x = React.useMemo(() => ({
    reference: m || c.reference || null,
    floating: c.floating || null,
    domReference: c.reference
  }), [m, c.reference, c.floating]);
  return React.useMemo(() => ({
    dataRef: d,
    open: a,
    onOpenChange: v,
    elements: x,
    events: h,
    floatingId: u,
    refs: y
  }), [a, v, x, h, u, y]);
}
function useFloating(r) {
  r === void 0 && (r = {});
  const {
    nodeId: a
  } = r, s = useFloatingRootContext({
    ...r,
    elements: {
      reference: null,
      floating: null,
      ...r.elements
    }
  }), c = r.rootContext || s, u = c.elements, [d, h] = React.useState(null), [p, m] = React.useState(null), v = (u == null ? void 0 : u.reference) || d, y = React.useRef(null), x = useFloatingTree();
  index(() => {
    v && (y.current = v);
  }, [v]);
  const w = useFloating$1({
    ...r,
    elements: {
      ...u,
      ...p && {
        reference: p
      }
    }
  }), S = React.useCallback((T) => {
    const E = isElement$2(T) ? {
      getBoundingClientRect: () => T.getBoundingClientRect(),
      contextElement: T
    } : T;
    m(E), w.refs.setReference(E);
  }, [w.refs]), M = React.useCallback((T) => {
    (isElement$2(T) || T === null) && (y.current = T, h(T)), (isElement$2(w.refs.reference.current) || w.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    T !== null && !isElement$2(T)) && w.refs.setReference(T);
  }, [w.refs]), P = React.useMemo(() => ({
    ...w.refs,
    setReference: M,
    setPositionReference: S,
    domReference: y
  }), [w.refs, M, S]), L = React.useMemo(() => ({
    ...w.elements,
    domReference: v
  }), [w.elements, v]), I = React.useMemo(() => ({
    ...w,
    ...c,
    refs: P,
    elements: L,
    nodeId: a
  }), [w, P, L, a, c]);
  return index(() => {
    c.dataRef.current.floatingContext = I;
    const T = x == null ? void 0 : x.nodesRef.current.find((E) => E.id === a);
    T && (T.context = I);
  }), React.useMemo(() => ({
    ...w,
    context: I,
    refs: P,
    elements: L
  }), [w, P, L, I]);
}
function useFocus$1(r, a) {
  a === void 0 && (a = {});
  const {
    open: s,
    onOpenChange: c,
    events: u,
    dataRef: d,
    elements: h
  } = r, {
    enabled: p = !0,
    visibleOnly: m = !0
  } = a, g = React.useRef(!1), v = React.useRef(), y = React.useRef(!0);
  React.useEffect(() => {
    if (!p) return;
    const w = getWindow$2(h.domReference);
    function S() {
      !s && isHTMLElement$3(h.domReference) && h.domReference === activeElement(getDocument(h.domReference)) && (g.current = !0);
    }
    function M() {
      y.current = !0;
    }
    return w.addEventListener("blur", S), w.addEventListener("keydown", M, !0), () => {
      w.removeEventListener("blur", S), w.removeEventListener("keydown", M, !0);
    };
  }, [h.domReference, s, p]), React.useEffect(() => {
    if (!p) return;
    function w(S) {
      let {
        reason: M
      } = S;
      (M === "reference-press" || M === "escape-key") && (g.current = !0);
    }
    return u.on("openchange", w), () => {
      u.off("openchange", w);
    };
  }, [u, p]), React.useEffect(() => () => {
    clearTimeout(v.current);
  }, []);
  const x = React.useMemo(() => ({
    onPointerDown(w) {
      isVirtualPointerEvent(w.nativeEvent) || (y.current = !1);
    },
    onMouseLeave() {
      g.current = !1;
    },
    onFocus(w) {
      if (g.current) return;
      const S = getTarget(w.nativeEvent);
      if (m && isElement$2(S))
        try {
          if (isSafari() && isMac()) throw Error();
          if (!S.matches(":focus-visible")) return;
        } catch {
          if (!y.current && !isTypeableElement(S))
            return;
        }
      c(!0, w.nativeEvent, "focus");
    },
    onBlur(w) {
      g.current = !1;
      const S = w.relatedTarget, M = w.nativeEvent, P = isElement$2(S) && S.hasAttribute(createAttribute("focus-guard")) && S.getAttribute("data-type") === "outside";
      v.current = window.setTimeout(() => {
        var L;
        const I = activeElement(h.domReference ? h.domReference.ownerDocument : document);
        !S && I === h.domReference || contains$1((L = d.current.floatingContext) == null ? void 0 : L.refs.floating.current, I) || contains$1(h.domReference, I) || P || c(!1, M, "focus");
      });
    }
  }), [d, h.domReference, c, m]);
  return React.useMemo(() => p ? {
    reference: x
  } : {}, [p, x]);
}
const ACTIVE_KEY = "active", SELECTED_KEY = "selected";
function mergeProps(r, a, s) {
  const c = /* @__PURE__ */ new Map(), u = s === "item";
  let d = r;
  if (u && r) {
    const {
      [ACTIVE_KEY]: h,
      [SELECTED_KEY]: p,
      ...m
    } = r;
    d = m;
  }
  return {
    ...s === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...d,
    ...a.map((h) => {
      const p = h ? h[s] : null;
      return typeof p == "function" ? r ? p(r) : null : p;
    }).concat(r).reduce((h, p) => (p && Object.entries(p).forEach((m) => {
      let [g, v] = m;
      if (!(u && [ACTIVE_KEY, SELECTED_KEY].includes(g)))
        if (g.indexOf("on") === 0) {
          if (c.has(g) || c.set(g, []), typeof v == "function") {
            var y;
            (y = c.get(g)) == null || y.push(v), h[g] = function() {
              for (var x, w = arguments.length, S = new Array(w), M = 0; M < w; M++)
                S[M] = arguments[M];
              return (x = c.get(g)) == null ? void 0 : x.map((P) => P(...S)).find((P) => P !== void 0);
            };
          }
        } else
          h[g] = v;
    }), h), {})
  };
}
function useInteractions(r) {
  r === void 0 && (r = []);
  const a = r.map((p) => p == null ? void 0 : p.reference), s = r.map((p) => p == null ? void 0 : p.floating), c = r.map((p) => p == null ? void 0 : p.item), u = React.useCallback(
    (p) => mergeProps(p, r, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a
  ), d = React.useCallback(
    (p) => mergeProps(p, r, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    s
  ), h = React.useCallback(
    (p) => mergeProps(p, r, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    c
  );
  return React.useMemo(() => ({
    getReferenceProps: u,
    getFloatingProps: d,
    getItemProps: h
  }), [u, d, h]);
}
let isPreventScrollSupported = !1;
function doSwitch(r, a, s) {
  switch (r) {
    case "vertical":
      return a;
    case "horizontal":
      return s;
    default:
      return a || s;
  }
}
function isMainOrientationKey(r, a) {
  return doSwitch(a, r === ARROW_UP || r === ARROW_DOWN, r === ARROW_LEFT || r === ARROW_RIGHT);
}
function isMainOrientationToEndKey(r, a, s) {
  return doSwitch(a, r === ARROW_DOWN, s ? r === ARROW_LEFT : r === ARROW_RIGHT) || r === "Enter" || r === " " || r === "";
}
function isCrossOrientationOpenKey(r, a, s) {
  return doSwitch(a, s ? r === ARROW_LEFT : r === ARROW_RIGHT, r === ARROW_DOWN);
}
function isCrossOrientationCloseKey(r, a, s) {
  return doSwitch(a, s ? r === ARROW_RIGHT : r === ARROW_LEFT, r === ARROW_UP);
}
function useListNavigation(r, a) {
  const {
    open: s,
    onOpenChange: c,
    elements: u
  } = r, {
    listRef: d,
    activeIndex: h,
    onNavigate: p = () => {
    },
    enabled: m = !0,
    selectedIndex: g = null,
    allowEscape: v = !1,
    loop: y = !1,
    nested: x = !1,
    rtl: w = !1,
    virtual: S = !1,
    focusItemOnOpen: M = "auto",
    focusItemOnHover: P = !0,
    openOnArrowKeyDown: L = !0,
    disabledIndices: I = void 0,
    orientation: T = "vertical",
    cols: E = 1,
    scrollItemIntoView: R = !0,
    virtualItemRef: A,
    itemSizes: k,
    dense: V = !1
  } = a;
  process.env.NODE_ENV !== "production" && (v && (y || warn("`useListNavigation` looping must be enabled to allow escaping."), S || warn("`useListNavigation` must be virtual to allow escaping.")), T === "vertical" && E > 1 && warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const B = getFloatingFocusElement(u.floating), q = useLatestRef$1(B), z = useFloatingParentNodeId(), Z = useFloatingTree(), G = useEffectEvent(p), K = React.useRef(M), U = React.useRef(g ?? -1), F = React.useRef(null), N = React.useRef(!0), D = React.useRef(G), j = React.useRef(!!u.floating), H = React.useRef(s), W = React.useRef(!1), re = React.useRef(!1), ae = useLatestRef$1(I), ee = useLatestRef$1(s), X = useLatestRef$1(R), J = useLatestRef$1(g), [ie, oe] = React.useState(), [fe, ve] = React.useState(), ue = useEffectEvent(function(se, de, Ce) {
    Ce === void 0 && (Ce = !1);
    function me(Se) {
      S ? (oe(Se.id), Z == null || Z.events.emit("virtualfocus", Se), A && (A.current = Se)) : enqueueFocus(Se, {
        preventScroll: !0,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: isMac() && isSafari() ? isPreventScrollSupported || W.current : !1
      });
    }
    const xe = se.current[de.current];
    xe && me(xe), requestAnimationFrame(() => {
      const Se = se.current[de.current] || xe;
      if (!Se) return;
      xe || me(Se);
      const Re = X.current;
      Re && we && (Ce || !N.current) && (Se.scrollIntoView == null || Se.scrollIntoView(typeof Re == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : Re));
    });
  });
  index(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return isPreventScrollSupported = !0, !1;
      }
    });
  }, []), index(() => {
    m && (s && u.floating ? K.current && g != null && (re.current = !0, U.current = g, G(g)) : j.current && (U.current = -1, D.current(null)));
  }, [m, s, u.floating, g, G]), index(() => {
    if (m && s && u.floating)
      if (h == null) {
        if (W.current = !1, J.current != null)
          return;
        if (j.current && (U.current = -1, ue(d, U)), (!H.current || !j.current) && K.current && (F.current != null || K.current === !0 && F.current == null)) {
          let se = 0;
          const de = () => {
            d.current[0] == null ? (se < 2 && (se ? requestAnimationFrame : queueMicrotask)(de), se++) : (U.current = F.current == null || isMainOrientationToEndKey(F.current, T, w) || x ? getMinIndex(d, ae.current) : getMaxIndex(d, ae.current), F.current = null, G(U.current));
          };
          de();
        }
      } else isIndexOutOfBounds(d, h) || (U.current = h, ue(d, U, re.current), re.current = !1);
  }, [m, s, u.floating, h, J, x, d, T, w, G, ue, ae]), index(() => {
    var se;
    if (!m || u.floating || !Z || S || !j.current)
      return;
    const de = Z.nodesRef.current, Ce = (se = de.find((Se) => Se.id === z)) == null || (se = se.context) == null ? void 0 : se.elements.floating, me = activeElement(getDocument(u.floating)), xe = de.some((Se) => Se.context && contains$1(Se.context.elements.floating, me));
    Ce && !xe && N.current && Ce.focus({
      preventScroll: !0
    });
  }, [m, u.floating, Z, z, S]), index(() => {
    if (!m || !Z || !S || z) return;
    function se(de) {
      ve(de.id), A && (A.current = de);
    }
    return Z.events.on("virtualfocus", se), () => {
      Z.events.off("virtualfocus", se);
    };
  }, [m, Z, S, z, A]), index(() => {
    D.current = G, j.current = !!u.floating;
  }), index(() => {
    s || (F.current = null);
  }, [s]), index(() => {
    H.current = s;
  }, [s]);
  const pe = h != null, we = React.useMemo(() => {
    function se(Ce) {
      if (!s) return;
      const me = d.current.indexOf(Ce);
      me !== -1 && G(me);
    }
    return {
      onFocus(Ce) {
        let {
          currentTarget: me
        } = Ce;
        se(me);
      },
      onClick: (Ce) => {
        let {
          currentTarget: me
        } = Ce;
        return me.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...P && {
        onMouseMove(Ce) {
          let {
            currentTarget: me
          } = Ce;
          se(me);
        },
        onPointerLeave(Ce) {
          let {
            pointerType: me
          } = Ce;
          !N.current || me === "touch" || (U.current = -1, ue(d, U), G(null), S || enqueueFocus(q.current, {
            preventScroll: !0
          }));
        }
      }
    };
  }, [s, q, ue, P, d, G, S]), ye = useEffectEvent((se) => {
    if (N.current = !1, W.current = !0, !ee.current && se.currentTarget === q.current)
      return;
    if (x && isCrossOrientationCloseKey(se.key, T, w)) {
      stopEvent(se), c(!1, se.nativeEvent, "list-navigation"), isHTMLElement$3(u.domReference) && !S && u.domReference.focus();
      return;
    }
    const de = U.current, Ce = getMinIndex(d, I), me = getMaxIndex(d, I);
    if (se.key === "Home" && (stopEvent(se), U.current = Ce, G(U.current)), se.key === "End" && (stopEvent(se), U.current = me, G(U.current)), E > 1) {
      const xe = k || Array.from({
        length: d.current.length
      }, () => ({
        width: 1,
        height: 1
      })), Se = buildCellMap(xe, E, V), Re = Se.findIndex((De) => De != null && !isDisabled(d.current, De, I)), Pe = Se.reduce((De, Fe, Xe) => Fe != null && !isDisabled(d.current, Fe, I) ? Xe : De, -1), ke = Se[getGridNavigatedIndex({
        current: Se.map((De) => De != null ? d.current[De] : null)
      }, {
        event: se,
        orientation: T,
        loop: y,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...I || d.current.map((De, Fe) => isDisabled(d.current, Fe) ? Fe : void 0), void 0], Se),
        minIndex: Re,
        maxIndex: Pe,
        prevIndex: getCellIndexOfCorner(
          U.current > me ? Ce : U.current,
          xe,
          Se,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          se.key === ARROW_DOWN ? "bl" : se.key === ARROW_RIGHT ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (ke != null && (U.current = ke, G(U.current)), T === "both")
        return;
    }
    if (isMainOrientationKey(se.key, T)) {
      if (stopEvent(se), s && !S && activeElement(se.currentTarget.ownerDocument) === se.currentTarget) {
        U.current = isMainOrientationToEndKey(se.key, T, w) ? Ce : me, G(U.current);
        return;
      }
      isMainOrientationToEndKey(se.key, T, w) ? y ? U.current = de >= me ? v && de !== d.current.length ? -1 : Ce : findNonDisabledIndex(d, {
        startingIndex: de,
        disabledIndices: I
      }) : U.current = Math.min(me, findNonDisabledIndex(d, {
        startingIndex: de,
        disabledIndices: I
      })) : y ? U.current = de <= Ce ? v && de !== -1 ? d.current.length : me : findNonDisabledIndex(d, {
        startingIndex: de,
        decrement: !0,
        disabledIndices: I
      }) : U.current = Math.max(Ce, findNonDisabledIndex(d, {
        startingIndex: de,
        decrement: !0,
        disabledIndices: I
      })), isIndexOutOfBounds(d, U.current) ? G(null) : G(U.current);
    }
  }), Ie = React.useMemo(() => S && s && pe && {
    "aria-activedescendant": fe || ie
  }, [S, s, pe, fe, ie]), Ee = React.useMemo(() => ({
    "aria-orientation": T === "both" ? void 0 : T,
    ...!isTypeableCombobox(u.domReference) && Ie,
    onKeyDown: ye,
    onPointerMove() {
      N.current = !0;
    }
  }), [Ie, ye, u.domReference, T]), ne = React.useMemo(() => {
    function se(Ce) {
      M === "auto" && isVirtualClick(Ce.nativeEvent) && (K.current = !0);
    }
    function de(Ce) {
      K.current = M, M === "auto" && isVirtualPointerEvent(Ce.nativeEvent) && (K.current = !0);
    }
    return {
      ...Ie,
      onKeyDown(Ce) {
        N.current = !1;
        const me = Ce.key.indexOf("Arrow") === 0, xe = isCrossOrientationOpenKey(Ce.key, T, w), Se = isCrossOrientationCloseKey(Ce.key, T, w), Re = isMainOrientationKey(Ce.key, T), Pe = (x ? xe : Re) || Ce.key === "Enter" || Ce.key.trim() === "";
        if (S && s) {
          const Xe = Z == null ? void 0 : Z.nodesRef.current.find((Ge) => Ge.parentId == null), ze = Z && Xe ? getDeepestNode(Z.nodesRef.current, Xe.id) : null;
          if (me && ze && A) {
            const Ge = new KeyboardEvent("keydown", {
              key: Ce.key,
              bubbles: !0
            });
            if (xe || Se) {
              var ke, De;
              const Tt = ((ke = ze.context) == null ? void 0 : ke.elements.domReference) === Ce.currentTarget, _t = Se && !Tt ? (De = ze.context) == null ? void 0 : De.elements.domReference : xe ? d.current.find((ht) => (ht == null ? void 0 : ht.id) === ie) : null;
              _t && (stopEvent(Ce), _t.dispatchEvent(Ge), ve(void 0));
            }
            if (Re && ze.context && ze.context.open && ze.parentId && Ce.currentTarget !== ze.context.elements.domReference) {
              var Fe;
              stopEvent(Ce), (Fe = ze.context.elements.domReference) == null || Fe.dispatchEvent(Ge);
              return;
            }
          }
          return ye(Ce);
        }
        if (!(!s && !L && me)) {
          if (Pe && (F.current = x && Re ? null : Ce.key), x) {
            xe && (stopEvent(Ce), s ? (U.current = getMinIndex(d, ae.current), G(U.current)) : c(!0, Ce.nativeEvent, "list-navigation"));
            return;
          }
          Re && (g != null && (U.current = g), stopEvent(Ce), !s && L ? c(!0, Ce.nativeEvent, "list-navigation") : ye(Ce), s && G(U.current));
        }
      },
      onFocus() {
        s && !S && G(null);
      },
      onPointerDown: de,
      onMouseDown: se,
      onClick: se
    };
  }, [ie, Ie, ye, ae, M, d, x, G, c, s, L, T, w, g, Z, S, A]);
  return React.useMemo(() => m ? {
    reference: ne,
    floating: Ee,
    item: we
  } : {}, [m, ne, Ee, we]);
}
const componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function useRole(r, a) {
  var s;
  a === void 0 && (a = {});
  const {
    open: c,
    floatingId: u
  } = r, {
    enabled: d = !0,
    role: h = "dialog"
  } = a, p = (s = componentRoleToAriaRoleMap.get(h)) != null ? s : h, m = useId$1(), v = useFloatingParentNodeId() != null, y = React.useMemo(() => p === "tooltip" || h === "label" ? {
    ["aria-" + (h === "label" ? "labelledby" : "describedby")]: c ? u : void 0
  } : {
    "aria-expanded": c ? "true" : "false",
    "aria-haspopup": p === "alertdialog" ? "dialog" : p,
    "aria-controls": c ? u : void 0,
    ...p === "listbox" && {
      role: "combobox"
    },
    ...p === "menu" && {
      id: m
    },
    ...p === "menu" && v && {
      role: "menuitem"
    },
    ...h === "select" && {
      "aria-autocomplete": "none"
    },
    ...h === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [p, u, v, c, m, h]), x = React.useMemo(() => {
    const S = {
      id: u,
      ...p && {
        role: p
      }
    };
    return p === "tooltip" || h === "label" ? S : {
      ...S,
      ...p === "menu" && {
        "aria-labelledby": m
      }
    };
  }, [p, u, m, h]), w = React.useCallback((S) => {
    let {
      active: M,
      selected: P
    } = S;
    const L = {
      role: "option",
      ...M && {
        id: u + "-option"
      }
    };
    switch (h) {
      case "select":
        return {
          ...L,
          "aria-selected": M && P
        };
      case "combobox":
        return {
          ...L,
          ...M && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [u, h]);
  return React.useMemo(() => d ? {
    reference: y,
    floating: x,
    item: w
  } : {}, [d, y, x, w]);
}
function useTypeahead(r, a) {
  var s;
  const {
    open: c,
    dataRef: u
  } = r, {
    listRef: d,
    activeIndex: h,
    onMatch: p,
    onTypingChange: m,
    enabled: g = !0,
    findMatch: v = null,
    resetMs: y = 750,
    ignoreKeys: x = [],
    selectedIndex: w = null
  } = a, S = React.useRef(), M = React.useRef(""), P = React.useRef((s = w ?? h) != null ? s : -1), L = React.useRef(null), I = useEffectEvent(p), T = useEffectEvent(m), E = useLatestRef$1(v), R = useLatestRef$1(x);
  index(() => {
    c && (clearTimeout(S.current), L.current = null, M.current = "");
  }, [c]), index(() => {
    if (c && M.current === "") {
      var q;
      P.current = (q = w ?? h) != null ? q : -1;
    }
  }, [c, w, h]);
  const A = useEffectEvent((q) => {
    q ? u.current.typing || (u.current.typing = q, T(q)) : u.current.typing && (u.current.typing = q, T(q));
  }), k = useEffectEvent((q) => {
    function z(F, N, D) {
      const j = E.current ? E.current(N, D) : N.find((H) => (H == null ? void 0 : H.toLocaleLowerCase().indexOf(D.toLocaleLowerCase())) === 0);
      return j ? F.indexOf(j) : -1;
    }
    const Z = d.current;
    if (M.current.length > 0 && M.current[0] !== " " && (z(Z, Z, M.current) === -1 ? A(!1) : q.key === " " && stopEvent(q)), Z == null || R.current.includes(q.key) || // Character key.
    q.key.length !== 1 || // Modifier key.
    q.ctrlKey || q.metaKey || q.altKey)
      return;
    c && q.key !== " " && (stopEvent(q), A(!0)), Z.every((F) => {
      var N, D;
      return F ? ((N = F[0]) == null ? void 0 : N.toLocaleLowerCase()) !== ((D = F[1]) == null ? void 0 : D.toLocaleLowerCase()) : !0;
    }) && M.current === q.key && (M.current = "", P.current = L.current), M.current += q.key, clearTimeout(S.current), S.current = setTimeout(() => {
      M.current = "", P.current = L.current, A(!1);
    }, y);
    const K = P.current, U = z(Z, [...Z.slice((K || 0) + 1), ...Z.slice(0, (K || 0) + 1)], M.current);
    U !== -1 ? (I(U), L.current = U) : q.key !== " " && (M.current = "", A(!1));
  }), V = React.useMemo(() => ({
    onKeyDown: k
  }), [k]), B = React.useMemo(() => ({
    onKeyDown: k,
    onKeyUp(q) {
      q.key === " " && A(!1);
    }
  }), [k, A]);
  return React.useMemo(() => g ? {
    reference: V,
    floating: B
  } : {}, [g, V, B]);
}
function isPointInPolygon(r, a) {
  const [s, c] = r;
  let u = !1;
  const d = a.length;
  for (let h = 0, p = d - 1; h < d; p = h++) {
    const [m, g] = a[h] || [0, 0], [v, y] = a[p] || [0, 0];
    g >= c != y >= c && s <= (v - m) * (c - g) / (y - g) + m && (u = !u);
  }
  return u;
}
function isInside(r, a) {
  return r[0] >= a.x && r[0] <= a.x + a.width && r[1] >= a.y && r[1] <= a.y + a.height;
}
function safePolygon(r) {
  r === void 0 && (r = {});
  const {
    buffer: a = 0.5,
    blockPointerEvents: s = !1,
    requireIntent: c = !0
  } = r;
  let u, d = !1, h = null, p = null, m = performance.now();
  function g(y, x) {
    const w = performance.now(), S = w - m;
    if (h === null || p === null || S === 0)
      return h = y, p = x, m = w, null;
    const M = y - h, P = x - p, I = Math.sqrt(M * M + P * P) / S;
    return h = y, p = x, m = w, I;
  }
  const v = (y) => {
    let {
      x,
      y: w,
      placement: S,
      elements: M,
      onClose: P,
      nodeId: L,
      tree: I
    } = y;
    return function(E) {
      function R() {
        clearTimeout(u), P();
      }
      if (clearTimeout(u), !M.domReference || !M.floating || S == null || x == null || w == null)
        return;
      const {
        clientX: A,
        clientY: k
      } = E, V = [A, k], B = getTarget(E), q = E.type === "mouseleave", z = contains$1(M.floating, B), Z = contains$1(M.domReference, B), G = M.domReference.getBoundingClientRect(), K = M.floating.getBoundingClientRect(), U = S.split("-")[0], F = x > K.right - K.width / 2, N = w > K.bottom - K.height / 2, D = isInside(V, G), j = K.width > G.width, H = K.height > G.height, W = (j ? G : K).left, re = (j ? G : K).right, ae = (H ? G : K).top, ee = (H ? G : K).bottom;
      if (z && (d = !0, !q))
        return;
      if (Z && (d = !1), Z && !q) {
        d = !0;
        return;
      }
      if (q && isElement$2(E.relatedTarget) && contains$1(M.floating, E.relatedTarget) || I && getChildren(I.nodesRef.current, L).some((ie) => {
        let {
          context: oe
        } = ie;
        return oe == null ? void 0 : oe.open;
      }))
        return;
      if (U === "top" && w >= G.bottom - 1 || U === "bottom" && w <= G.top + 1 || U === "left" && x >= G.right - 1 || U === "right" && x <= G.left + 1)
        return R();
      let X = [];
      switch (U) {
        case "top":
          X = [[W, G.top + 1], [W, K.bottom - 1], [re, K.bottom - 1], [re, G.top + 1]];
          break;
        case "bottom":
          X = [[W, K.top + 1], [W, G.bottom - 1], [re, G.bottom - 1], [re, K.top + 1]];
          break;
        case "left":
          X = [[K.right - 1, ee], [K.right - 1, ae], [G.left + 1, ae], [G.left + 1, ee]];
          break;
        case "right":
          X = [[G.right - 1, ee], [G.right - 1, ae], [K.left + 1, ae], [K.left + 1, ee]];
          break;
      }
      function J(ie) {
        let [oe, fe] = ie;
        switch (U) {
          case "top": {
            const ve = [j ? oe + a / 2 : F ? oe + a * 4 : oe - a * 4, fe + a + 1], ue = [j ? oe - a / 2 : F ? oe + a * 4 : oe - a * 4, fe + a + 1], pe = [[K.left, F || j ? K.bottom - a : K.top], [K.right, F ? j ? K.bottom - a : K.top : K.bottom - a]];
            return [ve, ue, ...pe];
          }
          case "bottom": {
            const ve = [j ? oe + a / 2 : F ? oe + a * 4 : oe - a * 4, fe - a], ue = [j ? oe - a / 2 : F ? oe + a * 4 : oe - a * 4, fe - a], pe = [[K.left, F || j ? K.top + a : K.bottom], [K.right, F ? j ? K.top + a : K.bottom : K.top + a]];
            return [ve, ue, ...pe];
          }
          case "left": {
            const ve = [oe + a + 1, H ? fe + a / 2 : N ? fe + a * 4 : fe - a * 4], ue = [oe + a + 1, H ? fe - a / 2 : N ? fe + a * 4 : fe - a * 4];
            return [...[[N || H ? K.right - a : K.left, K.top], [N ? H ? K.right - a : K.left : K.right - a, K.bottom]], ve, ue];
          }
          case "right": {
            const ve = [oe - a, H ? fe + a / 2 : N ? fe + a * 4 : fe - a * 4], ue = [oe - a, H ? fe - a / 2 : N ? fe + a * 4 : fe - a * 4], pe = [[N || H ? K.left + a : K.right, K.top], [N ? H ? K.left + a : K.right : K.left + a, K.bottom]];
            return [ve, ue, ...pe];
          }
        }
      }
      if (!isPointInPolygon([A, k], X)) {
        if (d && !D)
          return R();
        if (!q && c) {
          const ie = g(E.clientX, E.clientY);
          if (ie !== null && ie < 0.1)
            return R();
        }
        isPointInPolygon([A, k], J([x, w])) ? !d && c && (u = window.setTimeout(R, 40)) : R();
      }
    };
  };
  return v.__options = {
    blockPointerEvents: s
  }, v;
}
const useFloatingFocus = (r, a) => useFocus$1(r, a), useFocusManager = (r = !1, a) => {
  const s = useRef$1(null), c = useRef$1(null);
  return useEffect$1(() => {
    var d;
    const u = c.current;
    return r ? (s.current = document.activeElement, u && (u.setAttribute("tabindex", "-1"), u.focus())) : ((d = s.current) != null && d.focus && s.current.focus(), u && u.removeAttribute("tabindex")), () => {
      u && u.removeAttribute("tabindex");
    };
  }, [r, a]), c;
}, mobileVersionMatches = typeof (navigator == null ? void 0 : navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i)), iOSVersion = mobileVersionMatches != null && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null, androidVersion = mobileVersionMatches != null && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null, isWindowsOS = () => /Win/i.test(navigator.userAgent), isIOS = () => /iPad|iPhone|iPod/.test(navigator == null ? void 0 : navigator.userAgent) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
!window.MSStream, isAndroid = () => /Android/i.test(navigator.userAgent), isMobileiOS = () => isIOS() && iOSVersion !== null, isMobileAndroid = () => isAndroid() && androidVersion !== null, isMobileDevice = () => isMobileiOS() || isMobileAndroid(), useScrollWidth = () => {
  const [r, a] = useState$1(), s = useRef$1(null);
  return useEffect$1(() => {
    const c = () => {
      var u;
      return a((u = s.current) == null ? void 0 : u.scrollWidth);
    };
    return window.addEventListener("resize", c), c(), () => window.removeEventListener("resize", c);
  }, []), {
    ref: s,
    scrollWidth: r
  };
}, useWindowSize = ({ isDisabled: r = !1, debounce: a = 500 }) => {
  const [s, c] = useState$1({
    width: window.innerWidth,
    height: window.innerHeight
  });
  return useEffect$1(() => {
    if (r) return;
    const u = lodashExports.debounce(() => {
      c({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }, a);
    return window.addEventListener("resize", u), () => {
      c({
        width: void 0,
        height: void 0
      }), window.removeEventListener("resize", u);
    };
  }, []), s;
}, useBreakpoint = (r = {}) => {
  const { defaultBreakpoint: a = "xs", debounce: s = 500 } = r, { width: c } = useWindowSize({ debounce: s }), u = (h) => {
    let p;
    const m = Object.keys(themeBreakpoints), g = Object.values(themeBreakpoints);
    let v = 0;
    for (const y of g) {
      const x = parseInt(y, 10), w = parseInt(g[v + 1] ?? themeBreakpoints.xl, 10);
      if (x <= h && h < w) {
        p = m[v];
        break;
      }
      v = v + 1;
    }
    return p || (p = "xl"), p;
  }, d = useMemo$1(
    () => u(c || (window.innerWidth ?? parseInt(themeBreakpoints[a], 10))),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [window.innerWidth, c]
  );
  return {
    breakpoint: d ?? a,
    isExtraSmallScreen: d === "xs",
    isSmallScreen: d === "s",
    isMediumScreen: d === "m",
    isLargeScreen: d === "l",
    isExtraLargeScreen: d === "xl"
  };
}, sortInitiatedValues = (r) => {
  const a = {};
  return Object.keys(themeBreakpoints).forEach((s) => {
    a[s] = r[s];
  }), a;
}, sortBreakpoints = (r) => {
  const a = sortInitiatedValues(r), s = {};
  let c = Object.keys(a).filter(
    (u) => a[u] !== void 0
  )[0];
  return Object.keys(a).forEach((u) => {
    s[u] = r[u] || void 0, a[u] !== void 0 ? (s[u] = a[u], c = u) : s[u] = a[c];
  }), s;
};
function useBreakpointValue(r, a) {
  const { breakpoint: s } = useBreakpoint({ defaultBreakpoint: a, debounce: 0 });
  return sortBreakpoints(r)[s];
}
const themeBreakpointsKeys = ["xs", "s", "m", "l", "xl"], isResponsiveType = (r) => typeof r != "object" || r === null ? !1 : Object.keys(r).every((a) => themeBreakpointsKeys.includes(a)), useCustomSize = (r) => {
  const a = isResponsiveType(r) ? r : { xs: r };
  return useBreakpointValue(a);
}, useDelayUnmount = ({ isOpen: r, delay: a = 500 }) => {
  const [s, c] = useState$1(r);
  return useEffect$1(() => {
    let u;
    return r ? c(!0) : u = setTimeout(() => {
      c(!1);
    }, a), () => clearTimeout(u);
  }, [a, r]), s;
}, isNotStatusMessage = (r) => !/a11y-status-message/.test(r.id), setAttributes = (r, a) => {
  r.forEach((s) => {
    !a.contains(s) && isNotStatusMessage(s) && (s.setAttribute("aria-hidden", "true"), s.setAttribute("data-floating-ui-inert", ""), s.setAttribute("inert", ""));
  });
}, removeAttributes = (r, a) => {
  r.forEach((s) => {
    !a.contains(s) && isNotStatusMessage(s) && (s.removeAttribute("aria-hidden"), s.removeAttribute("data-floating-ui-inert"), s.removeAttribute("inert"));
  });
}, useHideFromSR = ({ ignoreEl: r, enable: a }) => {
  const s = r == null ? void 0 : r.closest("melio-wrapper"), c = a && s;
  useEffect$1(() => {
    const u = document.querySelectorAll("melio-wrapper"), d = document.querySelectorAll("[aria-live]");
    let h;
    return c && (isMobileiOS() && (h = setTimeout(() => {
      r == null || r.querySelectorAll("[data-floating-ui-focus-guard]").forEach((p) => {
        p.setAttribute("aria-hidden", "true"), p.removeAttribute("role");
      });
    }, 100)), setAttributes(u, s), setAttributes(d, s)), () => {
      c && (removeAttributes(u, s), removeAttributes(d, s), clearTimeout(h));
    };
  }, [r, s, c]);
}, useIcons = () => useContext$1(IconsContext);
function isIconBySizes(r) {
  return typeof r != "string" && !!r && "small" in r && "medium" in r;
}
const useIconAsset = (r, a) => {
  const s = useIcons(), u = (() => {
    switch (a) {
      case "medium":
      case "large":
      case "extra-large":
        return "medium";
      default:
        return "small";
    }
  })();
  return isIconBySizes(s[r]) ? s[r][u] : s[r];
}, useIllustrations = () => useContext$1(IllustrationsContext), useLoader = () => useContext$1(LoaderContext), useLogos = () => useContext$1(LogosContext), useEventListener = ({ ref: r, eventName: a, callback: s }) => {
  const c = r.current;
  useEffect$1(() => (c && c.addEventListener(a, s), () => {
    c && c.removeEventListener(a, s);
  }), [a, c, s]);
}, useScrollBorders = ({ ref: r }) => {
  const [a, s] = useState$1(!1), [c, u] = useState$1(!1), [d, h] = useState$1(!1), [p, m] = useState$1(!1), [g, v] = useState$1(!1), [y, x] = useState$1(!1), [w, S] = useState$1(!1), { width: M, height: P } = useResizeObserver({ ref: r }), L = r.current;
  useEffect$1(() => {
    if (L) {
      const E = L.scrollHeight > L.clientHeight, R = L.scrollWidth > L.clientWidth;
      s(E), m(R), I(L), S(!0);
    }
  }, [L, M, P]);
  const I = (E) => {
    u(E.scrollTop === 0), h(E.scrollHeight - Math.ceil(E.scrollTop) === E.clientHeight), v(E.scrollLeft === 0), x(E.scrollWidth - Math.ceil(E.scrollLeft) === E.clientWidth);
  }, T = useCallback$1((E) => {
    I(E.target);
  }, []);
  return useEventListener({ ref: r, eventName: "scroll", callback: T }), {
    isOverflowY: a,
    scrollAtTop: c,
    scrollAtBottom: d,
    isOverflowX: p,
    scrollAtLeft: g,
    scrollAtRight: y,
    isMounted: w
  };
}, hexToLottieColor = (r) => {
  const a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, s = r.replace(a, (u, d, h, p) => d + d + h + h + p + p), c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(s);
  return [parseInt(c[1], 16) / 255, parseInt(c[2], 16) / 255, parseInt(c[3], 16) / 255];
}, Lottie = forwardRef$1(
  ({ animation: r, colors: a = [], loop: s = !0, height: c = "340px", width: u = "450px", ...d }, h) => {
    const { colors: p } = useTheme(), m = typeof r == "function" ? r(...a.map((v) => hexToLottieColor(lodashExports.get(p, v)))) : r, g = useStyleConfig("Lottie", { width: u, height: c });
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: Lottie$1,
        __css: g,
        "data-component": "Lottie",
        lottieRef: h,
        loop: s,
        animationData: m,
        ...d
      }
    );
  }
);
Lottie.displayName = "Lottie";
const Video = forwardRef$1(
  ({ hideControls: r, autoPlay: a, isMuted: s, ...c }, u) => /* @__PURE__ */ jsx(
    "video",
    {
      "data-component": "Video",
      ref: u,
      controls: !r,
      autoPlay: a,
      muted: a || s,
      ...c
    }
  )
);
Video.displayName = "Video";
const Badge = forwardRef$1(
  ({ placement: r = "bottom-right", customPositions: a, mark: s, children: c, "data-testid": u = "badge", ...d }, h) => {
    const p = useMultiStyleConfig("Badge", { placement: r, customPositions: a }), m = useTestId(u);
    return /* @__PURE__ */ jsxs(Box, { "data-component": "Badge", ...d, ...m(), __css: p.wrapper, ref: h, children: [
      c,
      /* @__PURE__ */ jsx(Box, { __css: p.mark, ...m("mark"), children: s })
    ] });
  }
);
Badge.displayName = "Badge";
const BrandSymbol = forwardRef$1(
  ({ type: r, size: a = "medium", isDisabled: s, isReadOnly: c, variant: u = "default", ...d }, h) => {
    const p = useStyleConfig("BrandSymbol", { size: a, ...d }), m = brandSymbolsMap[r][u];
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: p,
        as: "img",
        src: m,
        alt: `${r} logo`,
        "data-disabled": s || null,
        "data-readonly": c || null,
        ref: h,
        "aria-label": `${r} brand symbol`,
        "data-component": "BrandSymbol",
        ...d
      }
    );
  }
);
BrandSymbol.displayName = "BrandSymbol";
const getAvatarInitials = (r, a) => {
  const [s, c] = r.replace(/[!@#$%^&*().,-]/g, "").split(" "), u = s == null ? void 0 : s.charAt(0).toUpperCase();
  return a ? u : s && c ? `${s.charAt(0).toUpperCase()}${c.charAt(0).toUpperCase()}` : u;
}, isBrandSymbol = isBrandSymbol$1, AvatarComponent = (r, a) => {
  const {
    name: s,
    isSelected: c,
    isDisabled: u,
    src: d,
    onClick: h,
    badge: p,
    badgeColor: m,
    "data-testid": g = "avatar",
    bgColor: v,
    variant: y = "circle",
    size: x = "medium",
    ...w
  } = r, [S, M] = useState$1(!1), P = y === "square", L = useMultiStyleConfig("Avatar", {
    onClick: h,
    bgColor: v,
    isDisabled: u,
    variant: y,
    size: x,
    ...w
  }), I = p === "verified" && "brand" || m, T = {
    borderRadius: "global.full"
  }, E = {
    borderRadius: "global.100",
    aspectRatio: "1 / 1"
  }, R = x === "small", A = P ? E : T, k = useTestId(g), V = p ? /* @__PURE__ */ jsx(Box, { __css: L.badge, ...k("badge"), children: isBrandSymbol(p) ? /* @__PURE__ */ jsx(BrandSymbol, { type: p, size: R ? "extra-small" : "small", isDisabled: u }) : /* @__PURE__ */ jsx(
    _BaseIcon,
    {
      type: p,
      size: R ? "extra-small" : "small",
      color: iconColorMapping[I ?? "default"],
      isDisabled: u
    }
  ) }) : void 0;
  return /* @__PURE__ */ jsx(
    ConditionalWrapper,
    {
      condition: !!p,
      wrapper: (B) => /* @__PURE__ */ jsx(Badge, { mark: V, customPositions: R ? { bottom: "-4px", right: "-4px" } : {}, children: B }),
      children: /* @__PURE__ */ jsx(Box, { "data-component": "Avatar", ...w, ...k(), __css: L.container, ref: a, children: /* @__PURE__ */ jsx(
        Box,
        {
          "aria-disabled": u,
          "data-selected": c || null,
          ...k("content"),
          ...!u && h && { role: "button", tabIndex: 0, onClick: h },
          __css: L.avatar,
          children: d && !S ? /* @__PURE__ */ jsx(Box, { __css: L.image, children: /* @__PURE__ */ jsx(
            Image$1,
            {
              src: d,
              alt: s,
              onError: () => M(!0),
              isDisabled: u,
              ...k("image"),
              ...A
            }
          ) }) : /* @__PURE__ */ jsx(Box, { __css: L.initials, ...k("initials"), children: getAvatarInitials(s, x === "extra-small") })
        }
      ) })
    }
  );
}, Avatar = forwardRef$1(AvatarComponent);
Avatar.displayName = "Avatar";
const Collapse = forwardRef$1((r, a) => /* @__PURE__ */ jsx(
  Collapse$1,
  {
    "data-component": "Collapse",
    type: "button",
    ref: a,
    ...r
  }
));
Collapse.displayName = "Collapse";
const defaultProps$5 = {
  transition: {
    enter: { duration: 0.4 }
  }
}, Fade = forwardRef$1(({ children: r, ...a }, s) => /* @__PURE__ */ jsx(Fade$1, { "data-component": "Fade", ...lodashExports.merge(a, defaultProps$5), ref: s, children: r }));
Fade.displayName = "Fade";
const ScaleFade = forwardRef$1((r, a) => /* @__PURE__ */ jsx(ScaleFade$1, { "data-component": "ScaleFade", ref: a, ...r }));
ScaleFade.displayName = "ScaleFade";
const Slide = forwardRef$1(({ unmountOnExit: r = !0, ...a }, s) => /* @__PURE__ */ jsx(Slide$1, { "data-component": "Slide", ref: s, unmountOnExit: r, ...a }));
Slide.displayName = "Slide";
const useTooltip = ({
  placement: r = "top",
  isEnabled: a = !0,
  isOpen: s,
  onOpenChange: c
}) => {
  const [u, d] = React__default.useState(!1), h = s ?? u, p = c ?? d;
  useEffect$1(() => {
    h && !a && p(!1);
  }, [a, h, p]);
  const m = useDelayUnmount({ isOpen: h }), g = useFloating({
    // Since we removed the `Portal` on mobile, we must change the position to "fixed".
    strategy: isMobileDevice() ? "fixed" : "absolute",
    placement: r,
    open: h,
    onOpenChange: p,
    whileElementsMounted: autoUpdate,
    middleware: [offset$2(getThemeSpacingAsNumber("xs")), flip$2(), shift({ padding: getThemeSpacingAsNumber("m") })]
  }), { context: v } = g, y = useHover(v, {
    move: !1,
    enabled: a,
    handleClose: safePolygon()
  }), x = useClick(v, {
    enabled: !1
  }), w = useFloatingFocus(v, { enabled: a, visibleOnly: !isMobileDevice() }), S = useDismiss(v), M = useRole(v, { role: "tooltip" }), P = useInteractions([y, x, w, S, M]);
  return {
    isOpen: h,
    setIsOpen: p,
    isMounted: m,
    ...P,
    ...g
  };
}, TooltipContext = React__default.createContext(null), useTooltipContext = () => {
  const r = React__default.useContext(TooltipContext);
  if (r === null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return r;
}, TooltipContent = forwardRef$1((r, a) => {
  const { refs: s, getFloatingProps: c, x: u, y: d, strategy: h, isOpen: p, isMounted: m } = useTooltipContext(), g = useMultiStyleConfig("Tooltip", { position: h, top: d, left: u }), v = useRef$1(null), y = useRef$1(), x = mergeRefs([s.setFloating, a, v]), { role: w, ...S } = c(r), M = useCallback$1(() => {
    var L;
    (L = v.current) == null || L.setAttribute("role", w ?? "tooltip");
  }, [w, v]);
  useEffect$1(() => {
    var L;
    isMobileDevice() && p ? ((L = v.current) == null || L.setAttribute("role", "alert"), y.current = window.setTimeout(() => {
      M();
    }, 1e3)) : M();
  }, [p, M]), useEffect$1(
    () => () => {
      y.current && (clearTimeout(y.current), M());
    },
    [M]
  );
  const P = useFloatingParentNodeId();
  return /* @__PURE__ */ jsx(
    ConditionalWrapper,
    {
      condition: !isMobileDevice(),
      wrapper: (L) => /* @__PURE__ */ jsx(Fragment, { children: m && /* @__PURE__ */ jsx(Portal, { id: P || void 0, children: L }) }),
      children: /* @__PURE__ */ jsx(Fade, { in: p, unmountOnExit: !0, style: fadeStyle$2, children: /* @__PURE__ */ jsx(Box, { __css: g.content, "data-component": "TooltipContent", ref: x, ...S }) })
    }
  );
});
TooltipContent.displayName = "TooltipContent";
const TooltipTrigger = React__default.forwardRef(({ children: r, shouldAddTriggerFocus: a, "aria-label": s, isEnabled: c, ...u }, d) => {
  const { refs: h, isOpen: p, getReferenceProps: m } = useTooltipContext(), g = r.ref, v = mergeRefs([h.setReference, d, g]), y = mergeRefs([h.setReference, d]), x = {
    "data-state": p ? "open" : "closed"
  }, { "aria-describedby": w, ...S } = m({
    ref: React__default.isValidElement(r) || a ? y : void 0,
    tabIndex: 0,
    ...x,
    ...u
  }), M = useMultiStyleConfig("Tooltip", {});
  if (React__default.isValidElement(r) && !a) {
    const {
      "aria-labelledby": P,
      "aria-describedby": L,
      ...I
    } = r.props, {
      "aria-labelledby": T,
      "aria-describedby": E,
      ...R
    } = m({
      ref: v,
      ...x,
      ...u,
      ...I
    }), A = () => {
      const k = getAriaProps("aria-labelledby", [T, P]), V = getAriaProps("aria-describedby", [E, L]);
      return { ...k, ...V };
    };
    return React__default.cloneElement(r, {
      ...R,
      // Add tabIndex to the children element if it is enabled to override disabled elements with tooltip to be focusable.
      ...c ? { tabIndex: 0 } : {},
      ...A()
    });
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-component": "TooltipTrigger",
      ...isMobileDevice() ? { as: "button", type: "button" } : { as: "span", role: "text" },
      "data-testid": "tooltip-trigger-wrapper",
      "aria-label": s,
      __css: M.trigger,
      "aria-labelledby": w,
      "aria-describedby": w,
      ...S,
      children: r
    }
  );
});
TooltipTrigger.displayName = "TooltipTrigger";
const Tooltip = forwardRef$1(
  ({
    children: r,
    content: a,
    placement: s,
    isEnabled: c = !0,
    disableFocusTrigger: u = !1,
    shouldAddTriggerFocus: d = !1,
    triggerAriaLabel: h = "More info",
    dontDescribeChild: p = !1,
    isOpen: m,
    onOpenChange: g,
    ...v
  }, y) => {
    const x = useTooltip({ placement: s, isEnabled: c, isOpen: m, onOpenChange: g });
    return /* @__PURE__ */ jsxs(TooltipContext.Provider, { value: x, children: [
      /* @__PURE__ */ jsx(
        TooltipTrigger,
        {
          shouldAddTriggerFocus: d,
          "aria-label": h,
          ...p && {
            "aria-describedby": void 0
          },
          isEnabled: c && !u,
          children: r
        }
      ),
      /* @__PURE__ */ jsx(TooltipContent, { ref: y, "data-component": "Tooltip", ...v, children: /* @__PURE__ */ jsx(Group, { variant: "vertical", spacing: "none", children: a }) })
    ] });
  }
);
Tooltip.displayName = "Tooltip";
const MAX_ITEMS = 4, MAX_ITEMS_IN_TOOLTIP = 8, getRestItemsTooltip = (r) => {
  if (r.length >= MAX_ITEMS_IN_TOOLTIP) {
    const a = r.slice(0, MAX_ITEMS_IN_TOOLTIP).map((c) => c.name).join(`
`), s = `And ${r.slice(MAX_ITEMS_IN_TOOLTIP, r.length).length} Others`;
    return `${a}

${s}`;
  }
  return r.map((a) => a.name).join(`
`);
}, AvatarItem = ({ isLast: r, ...a }) => {
  const s = useMultiStyleConfig("AvatarGroup", { isLast: r });
  return /* @__PURE__ */ jsx(Tooltip, { content: a.name, placement: "top", children: /* @__PURE__ */ jsx(Box, { as: "span", __css: s.avatar, "aria-label": a.name, tabIndex: 0, children: /* @__PURE__ */ jsx(Avatar, { ...a, size: "extra-small" }) }) });
};
AvatarItem.displayName = "AvatarItem";
const AvatarGroup = forwardRef$1(({ items: r, ...a }, s) => {
  const c = useMultiStyleConfig("AvatarGroup", {}), u = r.slice(0, MAX_ITEMS), d = r.length > MAX_ITEMS ? r.slice(MAX_ITEMS, r.length) : void 0;
  return /* @__PURE__ */ jsxs(Box, { "data-component": "AvatarGroup", "data-testid": "avatar-group", ...a, __css: c.container, ref: s, children: [
    u.map((h, p) => /* @__PURE__ */ jsx(AvatarItem, { ...h, isLast: p === u.length - 1 }, `${h.name}-${p}`)),
    d && /* @__PURE__ */ jsx(Tooltip, { content: getRestItemsTooltip(d), children: /* @__PURE__ */ jsxs(Box, { as: "span", __css: c.description, "data-testid": "avatar-group-description", tabIndex: 0, children: [
      "+",
      d.length
    ] }) })
  ] });
});
AvatarGroup.displayName = "AvatarGroup";
const Icon = forwardRef$1(
  ({ size: r = "large", type: a, color: s = "default", ...c }, u) => {
    const d = r === "small" ? "small" : "medium";
    return /* @__PURE__ */ jsx(
      _BaseIcon,
      {
        "data-component": "Icon",
        "data-testid": `${a}-icon`,
        ref: u,
        size: d,
        type: a,
        color: iconColorMapping[s],
        ...c
      }
    );
  }
);
Icon.displayName = "Icon";
const CheckboxInput = forwardRef$1(
  ({
    hasLabel: r = !1,
    size: a = "large",
    isDisabled: s,
    onChange: c,
    isChecked: u,
    value: d,
    isIndeterminate: h,
    isViewMode: p,
    isReadOnly: m,
    isInvalid: g,
    tooltipProps: v,
    autoFocus: y,
    "aria-label": x,
    "aria-required": w,
    "aria-describedby": S,
    "aria-labelledby": M,
    "aria-controls": P,
    id: L,
    ...I
  }, T) => {
    const E = useMultiStyleConfig("Checkbox", { size: a }), R = u ?? d, A = !!v, k = isMobileAndroid(), V = useMemo$1(
      () => getAriaProps("aria-describedby", [
        w && k ? "required-hidden" : void 0,
        S
      ]),
      [w, S, k]
    ), B = R || h ? /* @__PURE__ */ jsx(Box, { __css: E.innerIcon, "aria-hidden": !0, "data-readonly": m || void 0, "aria-disabled": s, children: /* @__PURE__ */ jsx(
      Icon,
      {
        type: h ? "remove" : a === "small" ? "checked-mini" : "checked",
        size: "small",
        color: "inherit"
      }
    ) }) : null, q = getInteractiveElementProps({
      isDisabled: s
    }), z = /* @__PURE__ */ jsx(
      ConditionalWrapper,
      {
        condition: A,
        wrapper: (Z) => v && /* @__PURE__ */ jsx(Tooltip, { ...v, children: Z }),
        children: /* @__PURE__ */ jsx(
          Box,
          {
            as: "input",
            __css: E.checkbox,
            type: "checkbox",
            role: "checkbox",
            id: L,
            disabled: s,
            checked: R,
            "aria-controls": P,
            "aria-checked": R,
            "aria-invalid": g,
            "aria-label": x ?? "checkbox",
            "data-checked": h ? "mixed" : R || void 0,
            "data-testid": "checkbox-input",
            "data-readonly": m || void 0,
            autoFocus: y,
            onChange: !s && !m ? c : void 0,
            ref: T,
            ...q,
            ...V,
            ...getAriaProps("aria-labelledby", [M]),
            ...k ? null : { "aria-required": w },
            ...I
          }
        )
      }
    );
    return /* @__PURE__ */ jsxs(Box, { __css: E.checkboxContainer, "data-with-label": r, children: [
      z,
      B
    ] });
  }
);
CheckboxInput.displayName = "CheckboxInput";
const Checkbox = forwardRef$1(
  ({
    size: r = "large",
    label: a,
    isDisabled: s,
    onChange: c,
    isChecked: u,
    value: d,
    isIndeterminate: h,
    isViewMode: p,
    isReadOnly: m,
    isInvalid: g,
    tooltipProps: v,
    children: y,
    autoFocus: x,
    "aria-label": w,
    "aria-required": S,
    "aria-describedby": M,
    "aria-labelledby": P,
    "aria-controls": L,
    id: I,
    ...T
  }, E) => {
    const R = useMultiStyleConfig("Checkbox", { size: r }), A = y ?? a, k = !!(v && !s), [V, B] = useState$1(!1), q = (G) => {
      k && B(G);
    }, z = A ? /* @__PURE__ */ jsx(
      Box,
      {
        __css: R.label,
        "data-disabled": s || void 0,
        "data-readonly": m || void 0,
        onMouseEnter: () => q(!0),
        onMouseLeave: () => q(!1),
        children: A
      }
    ) : null, Z = {
      ref: E,
      id: I,
      value: d,
      isDisabled: s,
      isIndeterminate: h,
      isReadOnly: m,
      isInvalid: g,
      size: r,
      isChecked: u,
      onChange: c,
      autoFocus: x,
      hasLabel: !!z,
      tooltipProps: v && {
        isEnabled: k,
        isOpen: V,
        onOpenChange: q,
        shouldAddTriggerFocus: v == null ? void 0 : v.shouldAddTriggerFocus,
        ...v
      },
      "aria-label": w ?? a,
      "aria-required": S,
      "aria-describedby": M,
      "aria-labelledby": P,
      "aria-controls": L
    };
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "Checkbox",
        __css: R.container,
        as: "label",
        "data-disabled": s || void 0,
        "data-readonly": m || void 0,
        onClick: (G) => G.stopPropagation(),
        "data-testid": "checkbox",
        ...T,
        children: /* @__PURE__ */ jsxs(
          ConditionalWrapper,
          {
            condition: !!(z || S),
            wrapper: (G) => /* @__PURE__ */ jsx(Group, { spacing: "xs", alignItems: "flex-start", children: G }),
            children: [
              /* @__PURE__ */ jsx(CheckboxInput, { ...Z }),
              z,
              S && /* @__PURE__ */ jsx(VisuallyHidden, { "aria-hidden": !0, id: "required-hidden", children: "Required" })
            ]
          }
        )
      }
    );
  }
);
Checkbox.displayName = "Checkbox";
const Divider = forwardRef$1(({ label: r, variant: a = "horizontal", ...s }, c) => {
  const u = useMultiStyleConfig("Divider", { variant: a }), d = !!(r && a === "horizontal");
  return /* @__PURE__ */ jsxs(Box, { __css: u.container, "data-component": "Divider", ...s, ref: c, children: [
    /* @__PURE__ */ jsx(Box, { __css: u.line }),
    d && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Box, { __css: u.text, children: r }),
      /* @__PURE__ */ jsx(Box, { __css: u.line })
    ] })
  ] });
});
Divider.displayName = "Divider";
const DeprecatedTabs = forwardRef$1(
  ({ variant: r = "main", tabs: a, activeTab: s, onChange: c, ...u }, d) => {
    const h = useMultiStyleConfig("DeprecatedTabs", { variant: r });
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "DeprecatedTabs",
        "data-testid": "tabs",
        role: "tablist",
        __css: h.container,
        ref: d,
        ...u,
        children: [
          /* @__PURE__ */ jsx(Group, { children: a.map((p) => /* @__PURE__ */ jsx(
            Box,
            {
              role: "tab",
              tabIndex: 0,
              sx: h.tab,
              "data-testid": `tab_${p.name}`,
              "aria-selected": s === p.name,
              onClick: () => c(p.name),
              children: p.label
            },
            `tab-${p.name}`
          )) }),
          r === "section" && /* @__PURE__ */ jsx(Divider, {})
        ]
      }
    );
  }
);
DeprecatedTabs.displayName = "DeprecatedTabs";
const Link = forwardRef$1(
  ({ label: r, variant: a = "inline", size: s, newTab: c, shouldSupportEllipsis: u, color: d, isDisabled: h, isBold: p, ...m }, g) => {
    const v = useStyleConfig("Link", {
      variant: a,
      size: a === "standalone" ? s ?? "large" : void 0,
      shouldSupportEllipsis: u,
      color: d,
      isBold: p
    }), y = useRef$1(null), x = mergeRefs([y, g]), { hasOverflowX: w } = useHasOverflow(y);
    return /* @__PURE__ */ jsx(Tooltip, { content: r, isEnabled: !!u && w, children: /* @__PURE__ */ jsx(
      Box,
      {
        __css: v,
        as: "a",
        "data-component": "Link",
        target: c ? "_blank" : "_self",
        ...m,
        ...h && disabledLinkAttributes,
        ref: x,
        children: r
      }
    ) });
  }
);
Link.displayName = "Link";
const getButtonLinkProps = ({
  isDisabled: r,
  link: a
} = {}) => ({
  ...(a == null ? void 0 : a.href) && { as: "a" },
  ...r && a ? disabledLinkAttributes : a
}), NavigationItem = forwardRef$1(
  ({
    link: r,
    isFullWidth: a = !1,
    "data-testid": s = "navigation-item",
    isSelected: c = !1,
    role: u = "button",
    "aria-label": d = "navigation-item",
    ...h
  }, p) => {
    const m = useStyleConfig("NavigationItem", { isFullWidth: a }), g = getButtonLinkProps({ link: r }), v = useTestId(s);
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "NavigationItem",
        as: "button",
        type: "button",
        role: u,
        "aria-label": d,
        ...g,
        ...v(),
        ...h,
        "data-selected": c || null,
        __css: m,
        ref: p
      }
    );
  }
);
NavigationItem.displayName = "NavigationItem";
const getStartIndex = (r, a, s) => {
  const c = getTotalPages(s, r), u = Math.min(a, c);
  return Math.max(1, 1 + r * (u - 1));
}, getEndIndex = (r, a, s) => {
  const c = Math.max(a, 1);
  return Math.min(r * c, s);
}, getTotalPages = (r, a) => Math.ceil(r / a), getPreviousEnabled = (r) => r > 1, getNextEnabled = (r, a, s) => {
  const c = getTotalPages(a, s);
  return r + 1 <= c;
}, Pagination = forwardRef$1(
  ({ onPageChange: r, currentPage: a = 1, totalItems: s, pageSize: c, ariaLabels: u, ...d }, h) => {
    const p = getStartIndex(c, a, s), m = getEndIndex(c, a, s), g = getPreviousEnabled(a), v = getNextEnabled(a, s, c), y = `${p}-${m} of ${s}`;
    return /* @__PURE__ */ jsxs(
      Group,
      {
        "data-component": "Pagination",
        alignItems: "center",
        "aria-label": "Pagination",
        role: "navigation",
        ...d,
        ref: h,
        children: [
          /* @__PURE__ */ jsx(Text, { textStyle: "body4", "data-testid": "pagination-text", children: y }),
          /* @__PURE__ */ jsxs(Group, { spacing: "xs-s", children: [
            /* @__PURE__ */ jsx(Tooltip, { content: "Previous page", dontDescribeChild: !0, children: /* @__PURE__ */ jsx(
              IconButton,
              {
                "aria-label": (u == null ? void 0 : u.chevronLeftLabel) ?? "Previous page",
                "data-testid": "chevron-left",
                icon: "chevron-left",
                variant: "naked",
                size: "small",
                onClick: () => r == null ? void 0 : r(a - 1),
                isDisabled: !g
              }
            ) }),
            /* @__PURE__ */ jsx(Tooltip, { content: "Next page", dontDescribeChild: !0, children: /* @__PURE__ */ jsx(
              IconButton,
              {
                "aria-label": (u == null ? void 0 : u.chevronRightLabel) ?? "Next page",
                "data-testid": "chevron-right",
                icon: "chevron-right",
                variant: "naked",
                size: "small",
                onClick: () => r == null ? void 0 : r(a + 1),
                isDisabled: !v
              }
            ) })
          ] })
        ]
      }
    );
  }
);
Pagination.displayName = "Pagination";
const useScrollToActiveTab = ({
  tabsListRef: r,
  tabs: a,
  activeTabIndex: s
}) => {
  const [c, u] = useState$1([]), [d, h] = useState$1(), p = useCallback$1(() => {
    var m;
    d && ((m = r.current) == null || m.scrollTo({
      left: d.offsetLeft,
      behavior: "smooth"
    }));
  }, [d, r]);
  return useEffect$1(() => {
    if (c.length === 0) {
      const m = Array(a.length).fill("").map(() => createRef()), g = a.map((v) => v.ref);
      u(mergeRefArrays(m, g));
    }
  }, [a, c.length, r]), useEffect$1(() => {
    var v;
    if (!c.length) return;
    h((v = c[s]) == null ? void 0 : v.current), p();
    const m = () => {
      c.find((x) => x.current === document.activeElement) && p();
    }, g = r.current;
    return g == null || g.addEventListener("focusin", m), () => {
      g == null || g.removeEventListener("focusin", m);
    };
  }, [p, c.length, s, c, r]), { tabsRefs: c };
}, useTabs = ({
  tabs: r,
  onChange: a,
  activeTabIndex: s,
  tabsRefs: c
}) => ({ handleKeyDown: (d) => {
  var h, p, m, g;
  if (d.key === "ArrowRight") {
    const v = s === r.length - 1 ? 0 : s + 1;
    (p = (h = c[v]) == null ? void 0 : h.current) == null || p.focus(), a(r[v].name);
  }
  if (d.key === "ArrowLeft") {
    const v = s === 0 ? r.length - 1 : s - 1;
    (g = (m = c[v]) == null ? void 0 : m.current) == null || g.focus(), a(r[v].name);
  }
} }), Tabs = forwardRef$1(
  ({ tabs: r, activeTab: a, onChange: s, variant: c = "default", "data-testid": u = "tabs", isFullWidth: d, ...h }, p) => {
    const m = useMultiStyleConfig("Tabs", { variant: c, isFullWidth: d }), g = useTestId(u), v = useRef$1(null);
    useImperativeHandle$1(p, () => v.current);
    const y = useCallback$1((P) => {
      if (P.counters)
        return P.counters.map((L, I) => I <= 1 && /* @__PURE__ */ jsx(Counter, { ...L }, `tab-${P.name}-counter-${I}`));
    }, []), x = useCallback$1(
      (P, L) => {
        if (!P.pills) return;
        const I = L === r.length - 1;
        return P.pills.map(
          (T, E) => (E === 0 || I && E === 1) && /* @__PURE__ */ jsx(Pill, { ...T }, `tab-${P.name}-pill-${E}`)
        );
      },
      [r]
    ), w = useMemo$1(() => r.findIndex((P) => P.name === a), [r, a]), { tabsRefs: S } = useScrollToActiveTab({ tabsListRef: v, tabs: r, activeTabIndex: w }), { handleKeyDown: M } = useTabs({ tabs: r, activeTabIndex: w, onChange: s, tabsRefs: S });
    return /* @__PURE__ */ jsxs(Box, { "data-component": "Tabs", __css: m.container, ...h, ...g(), children: [
      /* @__PURE__ */ jsx(Box, { __css: m.tabs, role: "tablist", ref: v, ...g("list"), children: r.map((P, L) => {
        const { name: I, counters: T, pills: E, ...R } = P;
        return /* @__PURE__ */ jsxs(
          Box,
          {
            role: "tab",
            as: "button",
            __css: m.tab,
            ...g(`tab-${I}`),
            "aria-selected": a === I,
            "aria-label": P["aria-label"],
            onClick: () => {
              s(I);
            },
            onKeyDown: M,
            ...R,
            ref: S[L],
            children: [
              /* @__PURE__ */ jsx(Box, { as: "span", id: `tab-${I}`, children: P.label }),
              T && /* @__PURE__ */ jsx(Box, { sx: m.counters, ...g("tab-counters"), children: y(P) }),
              E && /* @__PURE__ */ jsx(Box, { sx: m.pills, ...g("tab-pills"), children: x(P, L) })
            ]
          },
          `tab-${I}`
        );
      }) }),
      /* @__PURE__ */ jsx(Divider, {})
    ] });
  }
);
Tabs.displayName = "Tabs";
const _Description = forwardRef$1(
  ({ label: r, isDisabled: a, isInvalid: s, isReadOnly: c, action: u, link: d, ...h }, p) => {
    const m = useStyleConfig("_Description"), g = !a && !c;
    return /* @__PURE__ */ jsxs(
      Box,
      {
        ref: p,
        "data-component": "_Description",
        __css: m,
        "aria-disabled": a || void 0,
        "data-invalid": s || null,
        "data-readonly": c || null,
        ...h,
        children: [
          r,
          d && g && /* @__PURE__ */ jsxs(Fragment, { children: [
            " ",
            /* @__PURE__ */ jsx(
              Link,
              {
                ...d,
                onClick: (v) => {
                  var y;
                  v.stopPropagation(), (y = d.onClick) == null || y.call(d, v);
                }
              }
            )
          ] }),
          u && g && /* @__PURE__ */ jsxs(Fragment, { children: [
            " ",
            /* @__PURE__ */ jsx(
              NakedButton,
              {
                ...u,
                variant: "secondary",
                onClick: (v) => {
                  var y;
                  v.stopPropagation(), (y = u.onClick) == null || y.call(u, v);
                }
              }
            )
          ] })
        ]
      }
    );
  }
);
_Description.displayName = "_Description";
const closeDelay = 500, horizontalPlacementEdges = ["left-start", "right-start", "left-end", "right-end"], verticalPlacementEdges = ["top-start", "bottom-start", "top-end", "bottom-end"], edgesPlacements = [...horizontalPlacementEdges, ...verticalPlacementEdges], usePopover = ({
  triggerEvent: r = "hover",
  defaultIsOpen: a = !1,
  placement: s,
  isOpen: c,
  onOpenChange: u,
  arrowRef: d,
  showArrow: h,
  enableAnimationFrame: p = !1
}) => {
  const [m, g] = React__default.useState(a), [v, y] = React__default.useState(), [x, w] = React__default.useState(), S = c ?? m, M = (K, U) => {
    if (u) {
      u(K, U);
      return;
    }
    g(K);
  }, P = getThemeSpacingAsNumber("xs"), L = h ? P * 2 : P, I = h ? getThemeSpacingAsNumber("s") : 0, T = [
    offset$2({ mainAxis: L, alignmentAxis: -I }),
    flip$2(),
    shift({
      padding: getThemeSpacingAsNumber("m")
    })
  ], E = useDelayUnmount({ isOpen: S }), R = useFloating({
    placement: s,
    open: S,
    onOpenChange: (K) => M(K, "outside"),
    whileElementsMounted: (K, U, F) => autoUpdate(K, U, F, { animationFrame: p }),
    middleware: d ? [...T, arrow$2({ element: d })] : T
  }), { context: A } = R, k = r === "click", B = useHover(A, {
    enabled: r === "hover" && !c,
    handleClose: safePolygon(),
    delay: { close: closeDelay }
  }), q = useClick(A, { enabled: !c }), z = useDismiss(A), Z = useRole(A), G = useInteractions([B, q, z, Z]);
  return {
    isOpen: S,
    setIsOpen: M,
    isMounted: E,
    triggeredByClick: k,
    ...G,
    ...R,
    descriptionId: x,
    setDescriptionId: w,
    titleId: v,
    setTitleId: y
  };
}, PopoverContext = React__default.createContext(null), usePopoverContext = () => {
  const r = React__default.useContext(PopoverContext);
  if (r === null)
    throw new Error("BasePopover components must be wrapped in <BasePopover />");
  return r;
}, BasePopoverBody = forwardRef$1((r, a) => {
  const { setDescriptionId: s } = usePopoverContext(), c = useId$1();
  React__default.useLayoutEffect(() => (s(c), () => s(void 0)), [c, s]);
  const u = useMultiStyleConfig("BasePopover", {});
  return /* @__PURE__ */ jsx(Box, { ...r, __css: u.body, ref: a, as: "p", id: c });
});
BasePopoverBody.displayName = "BasePopoverBody";
const Portal = ({ children: r, ...a }) => /* @__PURE__ */ jsx(FloatingPortal, { ...a, children: /* @__PURE__ */ jsx(MelioWrapper, { background: "transparent", children: r }) });
Portal.displayName = "Portal";
const BasePopoverContent = forwardRef$1(({ shouldTrapFocus: r, ...a }, s) => {
  const { refs: c, getFloatingProps: u, x: d, y: h, strategy: p, isOpen: m, isMounted: g, context: v, titleId: y } = usePopoverContext(), x = useMultiStyleConfig("BasePopover", { position: p, top: h, left: d }), w = mergeRefs([c.setFloating, s]), S = getAriaProps("aria-labelledby", [y ?? void 0]);
  return /* @__PURE__ */ jsx(Fragment, { children: g && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Fade, { in: m, unmountOnExit: !0, style: fadeStyle$1, children: /* @__PURE__ */ jsx(FloatingFocusManager, { context: v, modal: r, children: /* @__PURE__ */ jsx(
    Box,
    {
      __css: x.content,
      "data-component": a["data-component"],
      ref: w,
      ...S,
      ...u(a),
      onClick: (M) => M.stopPropagation()
    }
  ) }) }) }) });
});
BasePopoverContent.displayName = "BasePopoverContent";
const BasePopoverFooter = forwardRef$1(
  ({ actionRenderer: r, backButtonRenderer: a, footerText: s, "data-testid": c = "base-popover-footer", ...u }, d) => {
    const h = useTestId(c), p = useMultiStyleConfig("BasePopover", {}), { setIsOpen: m } = usePopoverContext();
    return /* @__PURE__ */ jsx(Box, { ...u, __css: p.footer, ref: d, children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", justifyContent: s ? "space-between" : "flex-end", width: "full", children: [
      s && /* @__PURE__ */ jsx(Box, { __css: p.footerText, children: s }),
      /* @__PURE__ */ jsxs(Group, { spacing: "xs-s", children: [
        a && a({ ...h("button-back") }),
        r({ onClose: () => m(!1, "cta"), ...h("button-action") })
      ] })
    ] }) });
  }
);
BasePopoverFooter.displayName = "BasePopoverFooter";
const BasePopoverTrigger = React__default.forwardRef(
  ({ children: r, triggerProps: a, ...s }, c) => {
    const { refs: u, setIsOpen: d, isOpen: h, triggeredByClick: p, getReferenceProps: m, descriptionId: g, titleId: v } = usePopoverContext(), y = r.ref, S = {
      ref: mergeRefs([u.setReference, c, y]),
      "data-state": h ? "open" : "closed",
      tabIndex: 0
    }, M = (I) => {
      I.stopPropagation(), p && d(!h, "children");
    }, P = useMultiStyleConfig("BasePopover", {}), L = p ? {
      "aria-describedby": g,
      "aria-labelledby": v
    } : {};
    if (React__default.isValidElement(r)) {
      const I = m({
        ...S,
        ...s,
        ...r.props,
        onClick: (T) => {
          var E, R;
          M(T), (R = (E = r.props).onClick) == null || R.call(E, T);
        }
      });
      return React__default.cloneElement(r, { ...I, ...L });
    }
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": s["data-component"],
        as: p ? "button" : "span",
        role: p ? void 0 : "button",
        __css: P.trigger,
        ...S,
        ...m(s),
        onClick: M,
        ...L,
        ...a,
        children: r
      }
    );
  }
);
BasePopoverTrigger.displayName = "BasePopoverTrigger";
const BasePopoverClose = ({
  onClose: r,
  closeButtonSize: a = "small",
  "data-component": s,
  ...c
}) => {
  const u = useMultiStyleConfig("BasePopover", {});
  return /* @__PURE__ */ jsx(Box, { as: "span", __css: u.close, "data-component": s, children: /* @__PURE__ */ jsx(
    IconButton,
    {
      "aria-label": "Close popover",
      ...c,
      variant: "nakedInverse",
      icon: "close",
      size: a,
      onClick: r
    }
  ) });
};
BasePopoverClose.displayName = "BasePopoverClose";
const BasePopoverHeader = forwardRef$1(
  ({ title: r, icon: a, ...s }, c) => {
    const u = useMultiStyleConfig("BasePopover", {}), { setTitleId: d } = usePopoverContext(), h = useId$1();
    return React__default.useLayoutEffect(() => (d(h), () => d(void 0)), [h, d]), /* @__PURE__ */ jsxs(Box, { as: "h2", ...s, __css: u.header, "data-component": s["data-component"], ref: c, id: h, children: [
      a && /* @__PURE__ */ jsx(Box, { as: "span", __css: u.icon, children: /* @__PURE__ */ jsx(Icon, { type: a, size: "small", color: "inverse" }) }),
      r && /* @__PURE__ */ jsx(Box, { as: "span", __css: u.title, children: r })
    ] });
  }
);
BasePopoverHeader.displayName = "BasePopoverHeader";
const BasePopover = forwardRef$1(
  ({
    children: r,
    hideCloseButton: a = !1,
    title: s,
    icon: c,
    description: u,
    actionRenderer: d,
    backButtonRenderer: h,
    footerText: p,
    closeButtonSize: m,
    showArrow: g = !0,
    placement: v = "top",
    "data-testid": y = "base-popover",
    triggerProps: x,
    shouldTrapFocus: w = !1,
    "aria-label": S,
    ...M
  }, P) => {
    const L = useRef$1(null), I = usePopover({ ...M, placement: v, showArrow: g, arrowRef: L }), T = s || c ? { title: s, icon: c } : void 0, E = M.triggerEvent === "click" && !a, R = useMultiStyleConfig("BasePopover", {}), A = useTestId(y), k = (V) => [M["data-component"] || "BasePopover", V].filter(Boolean).join("");
    return /* @__PURE__ */ jsxs(PopoverContext.Provider, { value: I, children: [
      /* @__PURE__ */ jsx(BasePopoverTrigger, { "data-component": k("Trigger"), triggerProps: x, children: r }),
      /* @__PURE__ */ jsxs(
        BasePopoverContent,
        {
          ref: P,
          ...A(),
          "data-component": k(),
          shouldTrapFocus: w,
          "aria-label": S,
          children: [
            E && /* @__PURE__ */ jsx(
              BasePopoverClose,
              {
                ...A("close"),
                "data-component": k("Close"),
                onClose: () => I.setIsOpen(!1, "close"),
                closeButtonSize: m
              }
            ),
            T && /* @__PURE__ */ jsx(BasePopoverHeader, { ...T, "data-component": k("Header") }),
            /* @__PURE__ */ jsx(BasePopoverBody, { "data-component": k("Body"), children: u }),
            /* @__PURE__ */ jsx(
              BasePopoverFooter,
              {
                actionRenderer: d,
                backButtonRenderer: h,
                footerText: p,
                ...A("footer"),
                "data-component": k("Footer")
              }
            ),
            g && /* @__PURE__ */ jsx(
              Box,
              {
                __css: R.arrow,
                as: FloatingArrow,
                ref: L,
                context: I.context,
                tipRadius: 1,
                staticOffset: edgesPlacements.includes(v) ? getThemeSpacingAsNumber("s") : void 0
              }
            )
          ]
        }
      )
    ] });
  }
);
BasePopover.displayName = "BasePopover";
const Popover = forwardRef$1(({ children: r, showArrow: a = !1, ...s }, c) => /* @__PURE__ */ jsx(BasePopover, { "data-testid": "popover", "data-component": "Popover", ...s, showArrow: a, ref: c, children: r }));
Popover.displayName = "Popover";
const ColorStyle$1 = {
  pending: "global.warning.900",
  warning: "global.warning.900",
  success: "semantic.icon.success",
  informative: "semantic.icon.informative",
  scheduled: "semantic.icon.informative",
  processing: "semantic.text.primary",
  neutral: "inherit",
  help: "semantic.text.primary",
  cancel: "semantic.icon.critical",
  decline: "semantic.icon.critical",
  alert: "semantic.icon.critical"
}, statusIconOutlinedType = {
  pending: "pause-circle",
  warning: "warning",
  success: "checked-circle",
  informative: "info",
  scheduled: "stopwatch",
  processing: "process",
  neutral: "info",
  help: "help-circle",
  cancel: "cancel-circle",
  decline: "decline",
  alert: "error"
}, StatusIconOutlined = forwardRef$1(
  ({ variant: r, size: a, ...s }, c) => /* @__PURE__ */ jsx(
    _BaseIcon,
    {
      ref: c,
      type: statusIconOutlinedType[r],
      size: a,
      color: ColorStyle$1[r],
      "data-component": "StatusIconOutlined",
      ...s
    }
  )
);
StatusIconOutlined.displayName = "StatusIconOutlined";
const ColorStyle = {
  pending: "semantic.icon.warning",
  warning: "semantic.icon.warning",
  success: "semantic.icon.success",
  informative: "semantic.icon.informative",
  scheduled: "semantic.icon.informative",
  processing: "semantic.icon.primary",
  help: "semantic.icon.primary",
  issues: "semantic.icon.primary",
  cancel: "semantic.icon.critical",
  decline: "semantic.icon.critical",
  alert: "semantic.icon.critical"
}, statusIconSolidType = {
  pending: "pause-solid",
  warning: "warning-solid",
  success: "checked-circle-fill",
  informative: "info-fill",
  scheduled: "stopwatch-fill",
  processing: "process-fill",
  help: "help-circle-fill",
  issues: "refresh-fill",
  cancel: "cancel",
  decline: "decline-fill",
  alert: "error-fill"
}, StatusIconSolid = forwardRef$1(({ variant: r, size: a, ...s }, c) => {
  const u = statusIconSolidType[r];
  return /* @__PURE__ */ jsx(
    _BaseIcon,
    {
      ref: c,
      type: u,
      size: a,
      color: ColorStyle[r],
      "data-component": "StatusIconSolid",
      ...s
    }
  );
});
StatusIconSolid.displayName = "StatusIconSolid";
const _IconIndicator = forwardRef$1(
  ({ variant: r = "informative", tooltip: a, popover: s, "data-testid": c = "icon-indicator", ...u }, d) => {
    const h = r === "warning" ? /* @__PURE__ */ jsx(
      Box,
      {
        as: StatusIconSolid,
        "data-component": "_IconIndicator",
        "data-testid": c,
        ...u,
        ref: d,
        size: "small",
        variant: "warning"
      }
    ) : /* @__PURE__ */ jsx(
      Box,
      {
        as: StatusIconOutlined,
        "data-component": "_IconIndicator",
        "data-testid": c,
        ...u,
        ref: d,
        size: "small",
        variant: r === "informative" ? "neutral" : r
      }
    );
    return a ? /* @__PURE__ */ jsx(Tooltip, { content: a.content, triggerAriaLabel: a.triggerAriaLabel, shouldAddTriggerFocus: !0, children: h }) : s ? /* @__PURE__ */ jsx(Popover, { ...s, children: h }) : h;
  }
);
_IconIndicator.displayName = "_IconIndicator";
const _Label = forwardRef$1(
  ({
    label: r,
    isInvalid: a,
    tooltipProps: s,
    description: c,
    isDisabled: u,
    isReadOnly: d,
    isViewMode: h,
    id: p,
    as: m,
    labelShouldSupportEllipsis: g,
    descriptionShouldSupportEllipsis: v,
    onClick: y,
    ...x
  }, w) => {
    const S = useMultiStyleConfig("_Label", { labelShouldSupportEllipsis: g, descriptionShouldSupportEllipsis: v }), M = useRef$1(null), P = useRef$1(null), L = {
      "data-view-mode": h || null,
      ...!h && {
        "data-disabled": u || null,
        "data-invalid": a || null,
        "data-readonly": d || null
      }
    }, { hasOverflowX: I } = useHasOverflow(M), { hasOverflowX: T } = useHasOverflow(P), E = g && I, R = v && T;
    return /* @__PURE__ */ jsxs(
      Group,
      {
        ref: w,
        "data-component": "_Label",
        ...L,
        "aria-disabled": u,
        alignItems: "center",
        ...x,
        spacing: "xxs",
        children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              as: m,
              htmlFor: h ? void 0 : p,
              id: p ? `${p}-label` : void 0,
              __css: S.container,
              onClick: y,
              ...L,
              children: [
                /* @__PURE__ */ jsx(Tooltip, { content: r, isEnabled: !!E, children: /* @__PURE__ */ jsx(Box, { __css: S.label, ...L, ref: M, children: r }) }),
                c && /* @__PURE__ */ jsx(Tooltip, { content: c, isEnabled: !!R, children: /* @__PURE__ */ jsx(Box, { __css: S.description, as: "span", ...L, ref: P, children: c }) })
              ]
            }
          ),
          s && /* @__PURE__ */ jsx(Box, { __css: S.iconIndicator, ...L, children: /* @__PURE__ */ jsx(_IconIndicator, { tooltip: s, "data-testid": "label-tooltip-trigger" }) })
        ]
      }
    );
  }
);
_Label.displayName = "_Label";
const Pill = forwardRef$1((r, a) => /* @__PURE__ */ jsx(_BaseBadge, { "data-component": "Pill", ...r, ref: a }));
Pill.displayName = "Pill";
const Text = forwardRef$1(
  ({
    color: r = "semantic.text.primary",
    textStyle: a = "body2",
    as: s = "span",
    children: c,
    shouldSupportEllipsis: u = !1,
    ...d
  }, h) => {
    const p = useRef$1(null), m = mergeRefs([p, h]), g = useStyleConfig("Text", { color: r, textStyle: a, shouldSupportEllipsis: u }), { hasOverflowX: v } = useHasOverflow(p);
    return /* @__PURE__ */ jsx(Box, { "data-component": "Text", as: s, ...d, ref: m, __css: g, title: u && v && typeof c == "string" ? c : void 0, children: c });
  }
);
Text.displayName = "Text";
const _MainLabel = forwardRef$1(
  ({
    label: r,
    secondaryLabel: a,
    statusIcon: s,
    tooltipProps: c,
    pillProps: u,
    isDisabled: d,
    variant: h = "default",
    size: p = "large",
    isReadOnly: m,
    id: g,
    ...v
  }, y) => {
    const x = useMultiStyleConfig("_MainLabel", { variant: h, size: p }), w = r ? /* @__PURE__ */ jsx(Box, { __css: x.label, "aria-disabled": d, "data-readonly": m || null, id: g, children: /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: r }) }) : "placeholder" in v && /* @__PURE__ */ jsx(Box, { __css: x.placeholder, id: g, children: /* @__PURE__ */ jsx(Text, { color: "inherit", textStyle: "inline", shouldSupportEllipsis: !0, children: v.placeholder }) });
    let S;
    return c ? S = /* @__PURE__ */ jsx(
      _IconIndicator,
      {
        tooltip: c,
        "data-testid": "line-item-tooltip-trigger",
        variant: c.triggerStatus ?? "informative"
      }
    ) : s && (s === "warning" ? S = /* @__PURE__ */ jsx(
      StatusIconSolid,
      {
        "data-testid": "line-item-icon",
        size: "small",
        variant: s,
        isDisabled: d,
        isReadOnly: m
      }
    ) : S = /* @__PURE__ */ jsx(
      StatusIconOutlined,
      {
        "data-testid": "line-item-icon",
        size: "small",
        variant: s,
        isDisabled: d,
        isReadOnly: m
      }
    )), /* @__PURE__ */ jsxs(Group, { ref: y, "data-component": "_MainLabel", ...v, spacing: "xxs", alignItems: "center", children: [
      w,
      a && /* @__PURE__ */ jsx(Box, { __css: x.secondaryLabel, "aria-disabled": d, "data-readonly": m || null, children: a }),
      (c || s) && /* @__PURE__ */ jsx(Box, { __css: x.iconIndicator, "aria-disabled": d, "data-readonly": m || null, children: S }),
      u && /* @__PURE__ */ jsx(
        ConditionalWrapper,
        {
          condition: Array.isArray(u) && u.length > 1,
          wrapper: (M) => /* @__PURE__ */ jsx(Group, { spacing: "xxs", children: M }),
          children: /* @__PURE__ */ jsx(Fragment, { children: (Array.isArray(u) ? u : [u]).map((M, P) => /* @__PURE__ */ jsx(
            Pill,
            {
              isDisabled: d,
              status: M.status,
              label: M.label,
              type: M.type,
              isReadOnly: m
            },
            P
          )) })
        }
      )
    ] });
  }
);
_MainLabel.displayName = "_MainLabel";
const _Paragraph = forwardRef$1(
  ({ title: r, size: a = "small", content: s, ...c }, u) => {
    const d = useMultiStyleConfig("_Paragraph", { size: a });
    return /* @__PURE__ */ jsxs(Box, { ref: u, "data-component": "_Paragraph", __css: d.container, ...c, children: [
      r && /* @__PURE__ */ jsx(Box, { as: "h2", __css: d.title, children: r }),
      s && /* @__PURE__ */ jsx(Box, { as: "p", __css: d.content, children: s })
    ] });
  }
);
_Paragraph.displayName = "_Paragraph";
const _ParagraphList = forwardRef$1(
  ({ list: r, size: a = "small", type: s, ...c }, u) => {
    const d = r.every((g) => "icon" in g), h = useMultiStyleConfig("_ParagraphList", { size: a, icon: d, type: s }), p = (g) => !!g && "icon" in g, m = (g) => p(g) ? g.icon && /* @__PURE__ */ jsx(
      Icon,
      {
        type: g.icon,
        "aria-hidden": "true",
        color: "inherit"
      }
    ) : /* @__PURE__ */ jsx(Box, { __css: h.bulletWrapper });
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: s === "ordered" ? "ol" : "ul",
        ref: u,
        "data-component": "_ParagraphList",
        "data-testid": "paragraph-list",
        __css: h.container,
        ...c,
        children: r.map((g, v) => /* @__PURE__ */ jsxs(Box, { as: "li", __css: h.listItem, children: [
          s === "unordered" ? m(g) : /* @__PURE__ */ jsxs(Box, { __css: h.number, children: [
            v + 1,
            "."
          ] }),
          /* @__PURE__ */ jsx(_Paragraph, { ...g, size: a })
        ] }, v + 1))
      }
    );
  }
);
_ParagraphList.displayName = "_ParagraphList";
const _SectionLabel = forwardRef$1(
  ({ label: r, as: a = "div", tooltipProps: s, isVerified: c, ...u }, d) => {
    const h = useStyleConfig("_SectionLabel", {});
    return /* @__PURE__ */ jsxs(Box, { ref: d, "data-component": "_SectionLabel", __css: h, "data-testid": "section-label", ...u, as: a, children: [
      r,
      s && /* @__PURE__ */ jsx(_IconIndicator, { tooltip: s }),
      c && /* @__PURE__ */ jsx(Icon, { type: "verified", size: "small", color: "brand" })
    ] });
  }
);
_SectionLabel.displayName = "_SectionLabel";
const updateDisplayName = (r) => {
  const a = forwardRef$1((s, c) => /* @__PURE__ */ jsx(r, { ref: c, ...s }));
  return r != null && r.displayName && (a.displayName = r.displayName.replace("_", "Typography.")), a;
}, Typography = {
  Description: updateDisplayName(_Description),
  Label: updateDisplayName(_Label),
  MainLabel: updateDisplayName(_MainLabel),
  Paragraph: updateDisplayName(_Paragraph),
  ParagraphList: updateDisplayName(_ParagraphList),
  SectionLabel: updateDisplayName(_SectionLabel)
}, AvatarWithDetails = forwardRef$1(
  ({
    mainLabelProps: r,
    description: a,
    defaultDescription: s,
    actionProps: c,
    avatarProps: u,
    isDisabled: d,
    selectionProps: h,
    "data-testid": p = "avatar-with-details",
    ...m
  }, g) => {
    const [v, y] = useBoolean(!1), x = useMultiStyleConfig("AvatarWithDetails", { isAvatarHover: v, isSelected: h == null ? void 0 : h.isSelected }), w = a || s, S = useCallback$1((M) => {
      h && (M ? y.on() : y.off());
    }, []);
    return /* @__PURE__ */ jsxs(Box, { "data-testid": p, ...m, __css: x.container, "data-component": "AvatarWithDetails", ref: g, children: [
      /* @__PURE__ */ jsxs(
        Box,
        {
          "aria-disabled": d,
          onMouseOver: () => S(!0),
          onMouseOut: () => S(),
          __css: x.avatarContainer,
          "data-testid": `${p}-avatar-container`,
          children: [
            /* @__PURE__ */ jsx(Box, { __css: x.avatar, children: /* @__PURE__ */ jsx(Avatar, { ...u, isDisabled: d }) }),
            h && /* @__PURE__ */ jsx(Box, { __css: x.checkbox, children: /* @__PURE__ */ jsx(
              Checkbox,
              {
                onChange: () => h.onSelect(h.isSelected),
                isChecked: h.isSelected,
                isDisabled: d
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxxs", children: [
        /* @__PURE__ */ jsx(Typography.MainLabel, { ...r, variant: "bold", isDisabled: d }),
        w && /* @__PURE__ */ jsx(Typography.Description, { label: w, isDisabled: d, action: c, link: void 0 })
      ] })
    ] });
  }
);
AvatarWithDetails.displayName = "AvatarWithDetails";
const Brand = forwardRef$1(({ type: r, variant: a = "default", ...s }, c) => {
  const u = useStyleConfig("Brand"), d = brandMap[r][a];
  return /* @__PURE__ */ jsx(
    Box,
    {
      __css: u,
      as: "img",
      src: d,
      alt: `${r} logo`,
      ref: c,
      "aria-label": `${r} brand`,
      "data-component": "Brand",
      ...s
    }
  );
});
Brand.displayName = "Brand";
const LENGTH = 2, FIX_SIZE_LENGTH = 2, Counter = forwardRef$1(({ status: r, number: a, ...s }, c) => {
  const u = useMemo$1(() => {
    const p = Math.pow(10, LENGTH) - 1;
    return p < a ? `+${p}` : `${a}`;
  }, [a]), d = u.length <= FIX_SIZE_LENGTH, h = useStyleConfig("Counter", { status: r, isFixedSize: d });
  return /* @__PURE__ */ jsx(_BaseBadge, { "data-component": "Counter", status: r, ...s, __css: h, ref: c, label: u });
});
Counter.displayName = "Counter";
const Currency = forwardRef$1(
  ({ value: r, size: a = "small", variant: s = "default", currency: c = "USD", ...u }, d) => {
    const h = useMultiStyleConfig("Currency", { size: a, variant: s }), { formatNumberToParts: p } = useIntl(), m = p(Number(r.toFixed(2)), {
      style: "currency",
      currencyDisplay: "narrowSymbol",
      currency: c
    });
    return /* @__PURE__ */ jsx(Box, { __css: h.container, "data-component": "Currency", ...u, ref: d, children: m.map((g, v) => {
      if (g.type === "currency")
        return /* @__PURE__ */ jsx(Box, { __css: h.currency, as: "span", children: g.value }, v);
      if (g.type === "fraction")
        return /* @__PURE__ */ jsx(Box, { __css: h.fraction, "data-testid": "fraction", as: "span", children: g.value }, v);
      if (g.type !== "decimal")
        return /* @__PURE__ */ jsx(Box, { __css: h.integer, as: "span", children: g.value }, v);
    }) });
  }
);
Currency.displayName = "Currency";
const FlagIcon = forwardRef$1(
  ({ countryCode: r, size: a = "medium", isDisabled: s, ...c }, u) => {
    const d = useStyleConfig("FlagIcon");
    return /* @__PURE__ */ jsx(Box, { __css: d, as: "span", "data-disabled": s || null, children: /* @__PURE__ */ jsx(
      _BaseIcon,
      {
        ref: u,
        type: r,
        size: a,
        color: "inherit",
        "aria-label": `${r} flag icon`,
        "data-component": "FlagIcon",
        role: "img",
        ...c
      }
    ) });
  }
);
FlagIcon.displayName = "FlagIcon";
const ListItem = forwardRef$1(
  ({ labelProps: r, descriptionProps: a, mainLabelProps: s, isDisabled: c, isReadOnly: u, isInvalid: d, textAlign: h = "start", ...p }, m) => {
    const g = {
      start: "flex-start",
      center: "center"
    };
    return /* @__PURE__ */ jsxs(
      Group,
      {
        "data-component": "ListItem",
        ref: m,
        ...p,
        variant: "vertical",
        spacing: "xxxs",
        alignItems: g[h],
        children: [
          r && /* @__PURE__ */ jsx(Typography.Label, { ...r, isDisabled: c }),
          /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", alignItems: g[h], children: [
            /* @__PURE__ */ jsx(Typography.MainLabel, { ...s, isDisabled: c, isReadOnly: u }),
            a && /* @__PURE__ */ jsx(
              Typography.Description,
              {
                ...a,
                isDisabled: c,
                isInvalid: d,
                isReadOnly: u
              }
            )
          ] })
        ]
      }
    );
  }
);
ListItem.displayName = "ListItem";
const Illustration = forwardRef$1(
  ({ size: r = "medium", type: a, ...s }, c) => {
    const u = useIllustrations(), d = useStyleConfig("Illustration", { size: r });
    return /* @__PURE__ */ jsx(Box, { as: "span", "data-component": "Illustration", ref: c, ...s, __css: d, children: /* @__PURE__ */ jsx(Box, { as: u[a] }) });
  }
);
Illustration.displayName = "Illustration";
const Loader = forwardRef$1(
  ({ color: r = "semantic.icon.brand", loadingText: a, hideLoadingText: s, ...c }, u) => {
    const d = useMultiStyleConfig("Loader", { color: r }), h = useCssAnimation("appear"), p = useCssAnimation("shiftRight"), m = useCssAnimation("disappear"), g = useLoader();
    return /* @__PURE__ */ jsx(Box, { "data-component": "Loader", ...c, ref: u, __css: d.container, children: g ? React__default.createElement(g, {
      color: r
    }) : /* @__PURE__ */ jsxs(Box, { __css: d.dots, children: [
      !s && /* @__PURE__ */ jsx(VisuallyHidden, { children: a ?? "Loading..." }),
      /* @__PURE__ */ jsx(Box, { animation: h, __css: d.first, "aria-hidden": !0 }),
      /* @__PURE__ */ jsx(Box, { animation: p, __css: d.second, "aria-hidden": !0 }),
      /* @__PURE__ */ jsx(Box, { animation: p, __css: d.third, "aria-hidden": !0 }),
      /* @__PURE__ */ jsx(Box, { animation: m, __css: d.forth, "aria-hidden": !0 })
    ] }) });
  }
);
Loader.displayName = "Loader";
const Logo = forwardRef$1(({ size: r = "large", type: a, ...s }, c) => {
  const u = useLogos(), d = useStyleConfig("Logo", { size: r });
  return /* @__PURE__ */ jsx(Box, { "data-component": "Logo", ref: c, ...s, __css: d, children: React__default.createElement(u[a]) });
});
Logo.displayName = "Logo";
const SectionBanner = forwardRef$1(
  ({
    variant: r = "informative",
    isCompact: a = !1,
    hideIcon: s = !1,
    leftElement: c,
    showCloseIcon: u = !1,
    closeButtonAriaLabel: d = "close",
    onClose: h,
    title: p,
    description: m,
    action: g,
    "data-testid": v = "section-banner",
    ...y
  }, x) => {
    const w = useMultiStyleConfig("SectionBanner", { variant: r, isCompact: a }), S = useTestId(v), M = {
      neutral: "help",
      warning: "warning",
      critical: "alert",
      informative: "informative",
      success: "success",
      brand: "help",
      secondary: "help"
    }, P = /* @__PURE__ */ jsx(Box, { __css: w.defaultIcon, children: /* @__PURE__ */ jsx(
      StatusIconSolid,
      {
        variant: M[r],
        size: a ? "small" : "medium",
        "aria-hidden": !0,
        ...S("icon")
      }
    ) });
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "SectionBanner",
        ...S(),
        ...y,
        ref: x,
        __css: w.container,
        "data-type": r,
        "data-compact": a,
        children: [
          /* @__PURE__ */ jsx(Container, { paddingY: a ? "xxxs" : "none", children: /* @__PURE__ */ jsxs(Group, { spacing: "s", alignItems: "flex-start", width: "full", children: [
            c ?? (!s && P),
            /* @__PURE__ */ jsxs(Group, { variant: "vertical", justifyContent: "center", alignItems: "flex-start", spacing: "xxxs", width: "full", children: [
              /* @__PURE__ */ jsxs(Group, { variant: "vertical", justifyContent: "center", spacing: "none", width: "full", children: [
                p && /* @__PURE__ */ jsx(Box, { __css: w.textWrapper, children: /* @__PURE__ */ jsx(Text, { textStyle: "body3Semi", ...S("title"), children: p }) }),
                m && /* @__PURE__ */ jsx(Box, { __css: w.textWrapper, children: /* @__PURE__ */ jsx(Text, { textStyle: "body3", ...S("description"), children: m }) })
              ] }),
              !a && g
            ] })
          ] }) }),
          a && g && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: g }),
          u && /* @__PURE__ */ jsx(
            IconButton,
            {
              icon: "close",
              ...S("close-button"),
              "aria-label": d,
              variant: "naked",
              size: "small",
              onClick: h
            }
          )
        ]
      }
    );
  }
);
SectionBanner.displayName = "SectionBanner";
const iconMapping = {
  informative: "scheduled",
  success: "success",
  warning: "pending",
  critical: "cancel",
  neutral: "processing"
}, StatusBar = forwardRef$1(
  ({ variant: r = "informative", content: a, ...s }, c) => {
    const u = useMultiStyleConfig("StatusBar", { ...s, variant: r });
    return /* @__PURE__ */ jsxs(Box, { "data-component": "StatusBar", ...s, ref: c, __css: u.container, children: [
      /* @__PURE__ */ jsx(Box, { __css: u.icon, children: /* @__PURE__ */ jsx(StatusIconOutlined, { variant: iconMapping[r], size: "large" }) }),
      a && /* @__PURE__ */ jsx(Box, { __css: u.content, children: a })
    ] });
  }
);
StatusBar.displayName = "StatusBar";
const StatusIndicator = forwardRef$1(
  ({ children: r, isDisabled: a, isReadOnly: s, status: c = "brand", ...u }, d) => {
    const p = useMultiStyleConfig("StatusIndicator", { status: c, hasChildren: !!r });
    return /* @__PURE__ */ jsxs(Box, { as: "span", __css: p.container, children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          as: "span",
          __css: p.indicator,
          "data-component": "StatusIndicator",
          "data-disabled": a || null,
          "data-readonly": s || null,
          ...u,
          ref: d
        }
      ),
      r
    ] });
  }
);
StatusIndicator.displayName = "StatusIndicator";
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(r, a) {
  return r.concat([a + "-" + start, a + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(r, a) {
  return r.concat([a, a + "-" + start, a + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(r) {
  return r ? (r.nodeName || "").toLowerCase() : null;
}
function getWindow(r) {
  if (r == null)
    return window;
  if (r.toString() !== "[object Window]") {
    var a = r.ownerDocument;
    return a && a.defaultView || window;
  }
  return r;
}
function isElement(r) {
  var a = getWindow(r).Element;
  return r instanceof a || r instanceof Element;
}
function isHTMLElement$1(r) {
  var a = getWindow(r).HTMLElement;
  return r instanceof a || r instanceof HTMLElement;
}
function isShadowRoot(r) {
  if (typeof ShadowRoot > "u")
    return !1;
  var a = getWindow(r).ShadowRoot;
  return r instanceof a || r instanceof ShadowRoot;
}
function applyStyles(r) {
  var a = r.state;
  Object.keys(a.elements).forEach(function(s) {
    var c = a.styles[s] || {}, u = a.attributes[s] || {}, d = a.elements[s];
    !isHTMLElement$1(d) || !getNodeName(d) || (Object.assign(d.style, c), Object.keys(u).forEach(function(h) {
      var p = u[h];
      p === !1 ? d.removeAttribute(h) : d.setAttribute(h, p === !0 ? "" : p);
    }));
  });
}
function effect$2(r) {
  var a = r.state, s = {
    popper: {
      position: a.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(a.elements.popper.style, s.popper), a.styles = s, a.elements.arrow && Object.assign(a.elements.arrow.style, s.arrow), function() {
    Object.keys(a.elements).forEach(function(c) {
      var u = a.elements[c], d = a.attributes[c] || {}, h = Object.keys(a.styles.hasOwnProperty(c) ? a.styles[c] : s[c]), p = h.reduce(function(m, g) {
        return m[g] = "", m;
      }, {});
      !isHTMLElement$1(u) || !getNodeName(u) || (Object.assign(u.style, p), Object.keys(d).forEach(function(m) {
        u.removeAttribute(m);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(r) {
  return r.split("-")[0];
}
var max$1 = Math.max, min$1 = Math.min, round = Math.round;
function getUAString() {
  var r = navigator.userAgentData;
  return r != null && r.brands && Array.isArray(r.brands) ? r.brands.map(function(a) {
    return a.brand + "/" + a.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(r, a, s) {
  a === void 0 && (a = !1), s === void 0 && (s = !1);
  var c = r.getBoundingClientRect(), u = 1, d = 1;
  a && isHTMLElement$1(r) && (u = r.offsetWidth > 0 && round(c.width) / r.offsetWidth || 1, d = r.offsetHeight > 0 && round(c.height) / r.offsetHeight || 1);
  var h = isElement(r) ? getWindow(r) : window, p = h.visualViewport, m = !isLayoutViewport() && s, g = (c.left + (m && p ? p.offsetLeft : 0)) / u, v = (c.top + (m && p ? p.offsetTop : 0)) / d, y = c.width / u, x = c.height / d;
  return {
    width: y,
    height: x,
    top: v,
    right: g + y,
    bottom: v + x,
    left: g,
    x: g,
    y: v
  };
}
function getLayoutRect(r) {
  var a = getBoundingClientRect(r), s = r.offsetWidth, c = r.offsetHeight;
  return Math.abs(a.width - s) <= 1 && (s = a.width), Math.abs(a.height - c) <= 1 && (c = a.height), {
    x: r.offsetLeft,
    y: r.offsetTop,
    width: s,
    height: c
  };
}
function contains(r, a) {
  var s = a.getRootNode && a.getRootNode();
  if (r.contains(a))
    return !0;
  if (s && isShadowRoot(s)) {
    var c = a;
    do {
      if (c && r.isSameNode(c))
        return !0;
      c = c.parentNode || c.host;
    } while (c);
  }
  return !1;
}
function getComputedStyle$1(r) {
  return getWindow(r).getComputedStyle(r);
}
function isTableElement(r) {
  return ["table", "td", "th"].indexOf(getNodeName(r)) >= 0;
}
function getDocumentElement(r) {
  return ((isElement(r) ? r.ownerDocument : (
    // $FlowFixMe[prop-missing]
    r.document
  )) || window.document).documentElement;
}
function getParentNode(r) {
  return getNodeName(r) === "html" ? r : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    (isShadowRoot(r) ? r.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(r)
  );
}
function getTrueOffsetParent(r) {
  return !isHTMLElement$1(r) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(r).position === "fixed" ? null : r.offsetParent;
}
function getContainingBlock(r) {
  var a = /firefox/i.test(getUAString()), s = /Trident/i.test(getUAString());
  if (s && isHTMLElement$1(r)) {
    var c = getComputedStyle$1(r);
    if (c.position === "fixed")
      return null;
  }
  var u = getParentNode(r);
  for (isShadowRoot(u) && (u = u.host); isHTMLElement$1(u) && ["html", "body"].indexOf(getNodeName(u)) < 0; ) {
    var d = getComputedStyle$1(u);
    if (d.transform !== "none" || d.perspective !== "none" || d.contain === "paint" || ["transform", "perspective"].indexOf(d.willChange) !== -1 || a && d.willChange === "filter" || a && d.filter && d.filter !== "none")
      return u;
    u = u.parentNode;
  }
  return null;
}
function getOffsetParent(r) {
  for (var a = getWindow(r), s = getTrueOffsetParent(r); s && isTableElement(s) && getComputedStyle$1(s).position === "static"; )
    s = getTrueOffsetParent(s);
  return s && (getNodeName(s) === "html" || getNodeName(s) === "body" && getComputedStyle$1(s).position === "static") ? a : s || getContainingBlock(r) || a;
}
function getMainAxisFromPlacement(r) {
  return ["top", "bottom"].indexOf(r) >= 0 ? "x" : "y";
}
function within(r, a, s) {
  return max$1(r, min$1(a, s));
}
function withinMaxClamp(r, a, s) {
  var c = within(r, a, s);
  return c > s ? s : c;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(r) {
  return Object.assign({}, getFreshSideObject(), r);
}
function expandToHashMap(r, a) {
  return a.reduce(function(s, c) {
    return s[c] = r, s;
  }, {});
}
var toPaddingObject = function r(a, s) {
  return a = typeof a == "function" ? a(Object.assign({}, s.rects, {
    placement: s.placement
  })) : a, mergePaddingObject(typeof a != "number" ? a : expandToHashMap(a, basePlacements));
};
function arrow(r) {
  var a, s = r.state, c = r.name, u = r.options, d = s.elements.arrow, h = s.modifiersData.popperOffsets, p = getBasePlacement(s.placement), m = getMainAxisFromPlacement(p), g = [left, right].indexOf(p) >= 0, v = g ? "height" : "width";
  if (!(!d || !h)) {
    var y = toPaddingObject(u.padding, s), x = getLayoutRect(d), w = m === "y" ? top : left, S = m === "y" ? bottom : right, M = s.rects.reference[v] + s.rects.reference[m] - h[m] - s.rects.popper[v], P = h[m] - s.rects.reference[m], L = getOffsetParent(d), I = L ? m === "y" ? L.clientHeight || 0 : L.clientWidth || 0 : 0, T = M / 2 - P / 2, E = y[w], R = I - x[v] - y[S], A = I / 2 - x[v] / 2 + T, k = within(E, A, R), V = m;
    s.modifiersData[c] = (a = {}, a[V] = k, a.centerOffset = k - A, a);
  }
}
function effect$1(r) {
  var a = r.state, s = r.options, c = s.element, u = c === void 0 ? "[data-popper-arrow]" : c;
  u != null && (typeof u == "string" && (u = a.elements.popper.querySelector(u), !u) || contains(a.elements.popper, u) && (a.elements.arrow = u));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(r) {
  return r.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(r, a) {
  var s = r.x, c = r.y, u = a.devicePixelRatio || 1;
  return {
    x: round(s * u) / u || 0,
    y: round(c * u) / u || 0
  };
}
function mapToStyles(r) {
  var a, s = r.popper, c = r.popperRect, u = r.placement, d = r.variation, h = r.offsets, p = r.position, m = r.gpuAcceleration, g = r.adaptive, v = r.roundOffsets, y = r.isFixed, x = h.x, w = x === void 0 ? 0 : x, S = h.y, M = S === void 0 ? 0 : S, P = typeof v == "function" ? v({
    x: w,
    y: M
  }) : {
    x: w,
    y: M
  };
  w = P.x, M = P.y;
  var L = h.hasOwnProperty("x"), I = h.hasOwnProperty("y"), T = left, E = top, R = window;
  if (g) {
    var A = getOffsetParent(s), k = "clientHeight", V = "clientWidth";
    if (A === getWindow(s) && (A = getDocumentElement(s), getComputedStyle$1(A).position !== "static" && p === "absolute" && (k = "scrollHeight", V = "scrollWidth")), A = A, u === top || (u === left || u === right) && d === end) {
      E = bottom;
      var B = y && A === R && R.visualViewport ? R.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[k]
      );
      M -= B - c.height, M *= m ? 1 : -1;
    }
    if (u === left || (u === top || u === bottom) && d === end) {
      T = right;
      var q = y && A === R && R.visualViewport ? R.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[V]
      );
      w -= q - c.width, w *= m ? 1 : -1;
    }
  }
  var z = Object.assign({
    position: p
  }, g && unsetSides), Z = v === !0 ? roundOffsetsByDPR({
    x: w,
    y: M
  }, getWindow(s)) : {
    x: w,
    y: M
  };
  if (w = Z.x, M = Z.y, m) {
    var G;
    return Object.assign({}, z, (G = {}, G[E] = I ? "0" : "", G[T] = L ? "0" : "", G.transform = (R.devicePixelRatio || 1) <= 1 ? "translate(" + w + "px, " + M + "px)" : "translate3d(" + w + "px, " + M + "px, 0)", G));
  }
  return Object.assign({}, z, (a = {}, a[E] = I ? M + "px" : "", a[T] = L ? w + "px" : "", a.transform = "", a));
}
function computeStyles(r) {
  var a = r.state, s = r.options, c = s.gpuAcceleration, u = c === void 0 ? !0 : c, d = s.adaptive, h = d === void 0 ? !0 : d, p = s.roundOffsets, m = p === void 0 ? !0 : p, g = {
    placement: getBasePlacement(a.placement),
    variation: getVariation(a.placement),
    popper: a.elements.popper,
    popperRect: a.rects.popper,
    gpuAcceleration: u,
    isFixed: a.options.strategy === "fixed"
  };
  a.modifiersData.popperOffsets != null && (a.styles.popper = Object.assign({}, a.styles.popper, mapToStyles(Object.assign({}, g, {
    offsets: a.modifiersData.popperOffsets,
    position: a.options.strategy,
    adaptive: h,
    roundOffsets: m
  })))), a.modifiersData.arrow != null && (a.styles.arrow = Object.assign({}, a.styles.arrow, mapToStyles(Object.assign({}, g, {
    offsets: a.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: m
  })))), a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-placement": a.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(r) {
  var a = r.state, s = r.instance, c = r.options, u = c.scroll, d = u === void 0 ? !0 : u, h = c.resize, p = h === void 0 ? !0 : h, m = getWindow(a.elements.popper), g = [].concat(a.scrollParents.reference, a.scrollParents.popper);
  return d && g.forEach(function(v) {
    v.addEventListener("scroll", s.update, passive);
  }), p && m.addEventListener("resize", s.update, passive), function() {
    d && g.forEach(function(v) {
      v.removeEventListener("scroll", s.update, passive);
    }), p && m.removeEventListener("resize", s.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function r() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(r) {
  return r.replace(/left|right|bottom|top/g, function(a) {
    return hash$1[a];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(r) {
  return r.replace(/start|end/g, function(a) {
    return hash[a];
  });
}
function getWindowScroll(r) {
  var a = getWindow(r), s = a.pageXOffset, c = a.pageYOffset;
  return {
    scrollLeft: s,
    scrollTop: c
  };
}
function getWindowScrollBarX(r) {
  return getBoundingClientRect(getDocumentElement(r)).left + getWindowScroll(r).scrollLeft;
}
function getViewportRect(r, a) {
  var s = getWindow(r), c = getDocumentElement(r), u = s.visualViewport, d = c.clientWidth, h = c.clientHeight, p = 0, m = 0;
  if (u) {
    d = u.width, h = u.height;
    var g = isLayoutViewport();
    (g || !g && a === "fixed") && (p = u.offsetLeft, m = u.offsetTop);
  }
  return {
    width: d,
    height: h,
    x: p + getWindowScrollBarX(r),
    y: m
  };
}
function getDocumentRect(r) {
  var a, s = getDocumentElement(r), c = getWindowScroll(r), u = (a = r.ownerDocument) == null ? void 0 : a.body, d = max$1(s.scrollWidth, s.clientWidth, u ? u.scrollWidth : 0, u ? u.clientWidth : 0), h = max$1(s.scrollHeight, s.clientHeight, u ? u.scrollHeight : 0, u ? u.clientHeight : 0), p = -c.scrollLeft + getWindowScrollBarX(r), m = -c.scrollTop;
  return getComputedStyle$1(u || s).direction === "rtl" && (p += max$1(s.clientWidth, u ? u.clientWidth : 0) - d), {
    width: d,
    height: h,
    x: p,
    y: m
  };
}
function isScrollParent(r) {
  var a = getComputedStyle$1(r), s = a.overflow, c = a.overflowX, u = a.overflowY;
  return /auto|scroll|overlay|hidden/.test(s + u + c);
}
function getScrollParent(r) {
  return ["html", "body", "#document"].indexOf(getNodeName(r)) >= 0 ? r.ownerDocument.body : isHTMLElement$1(r) && isScrollParent(r) ? r : getScrollParent(getParentNode(r));
}
function listScrollParents(r, a) {
  var s;
  a === void 0 && (a = []);
  var c = getScrollParent(r), u = c === ((s = r.ownerDocument) == null ? void 0 : s.body), d = getWindow(c), h = u ? [d].concat(d.visualViewport || [], isScrollParent(c) ? c : []) : c, p = a.concat(h);
  return u ? p : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    p.concat(listScrollParents(getParentNode(h)))
  );
}
function rectToClientRect(r) {
  return Object.assign({}, r, {
    left: r.x,
    top: r.y,
    right: r.x + r.width,
    bottom: r.y + r.height
  });
}
function getInnerBoundingClientRect(r, a) {
  var s = getBoundingClientRect(r, !1, a === "fixed");
  return s.top = s.top + r.clientTop, s.left = s.left + r.clientLeft, s.bottom = s.top + r.clientHeight, s.right = s.left + r.clientWidth, s.width = r.clientWidth, s.height = r.clientHeight, s.x = s.left, s.y = s.top, s;
}
function getClientRectFromMixedType(r, a, s) {
  return a === viewport ? rectToClientRect(getViewportRect(r, s)) : isElement(a) ? getInnerBoundingClientRect(a, s) : rectToClientRect(getDocumentRect(getDocumentElement(r)));
}
function getClippingParents(r) {
  var a = listScrollParents(getParentNode(r)), s = ["absolute", "fixed"].indexOf(getComputedStyle$1(r).position) >= 0, c = s && isHTMLElement$1(r) ? getOffsetParent(r) : r;
  return isElement(c) ? a.filter(function(u) {
    return isElement(u) && contains(u, c) && getNodeName(u) !== "body";
  }) : [];
}
function getClippingRect(r, a, s, c) {
  var u = a === "clippingParents" ? getClippingParents(r) : [].concat(a), d = [].concat(u, [s]), h = d[0], p = d.reduce(function(m, g) {
    var v = getClientRectFromMixedType(r, g, c);
    return m.top = max$1(v.top, m.top), m.right = min$1(v.right, m.right), m.bottom = min$1(v.bottom, m.bottom), m.left = max$1(v.left, m.left), m;
  }, getClientRectFromMixedType(r, h, c));
  return p.width = p.right - p.left, p.height = p.bottom - p.top, p.x = p.left, p.y = p.top, p;
}
function computeOffsets(r) {
  var a = r.reference, s = r.element, c = r.placement, u = c ? getBasePlacement(c) : null, d = c ? getVariation(c) : null, h = a.x + a.width / 2 - s.width / 2, p = a.y + a.height / 2 - s.height / 2, m;
  switch (u) {
    case top:
      m = {
        x: h,
        y: a.y - s.height
      };
      break;
    case bottom:
      m = {
        x: h,
        y: a.y + a.height
      };
      break;
    case right:
      m = {
        x: a.x + a.width,
        y: p
      };
      break;
    case left:
      m = {
        x: a.x - s.width,
        y: p
      };
      break;
    default:
      m = {
        x: a.x,
        y: a.y
      };
  }
  var g = u ? getMainAxisFromPlacement(u) : null;
  if (g != null) {
    var v = g === "y" ? "height" : "width";
    switch (d) {
      case start:
        m[g] = m[g] - (a[v] / 2 - s[v] / 2);
        break;
      case end:
        m[g] = m[g] + (a[v] / 2 - s[v] / 2);
        break;
    }
  }
  return m;
}
function detectOverflow(r, a) {
  a === void 0 && (a = {});
  var s = a, c = s.placement, u = c === void 0 ? r.placement : c, d = s.strategy, h = d === void 0 ? r.strategy : d, p = s.boundary, m = p === void 0 ? clippingParents : p, g = s.rootBoundary, v = g === void 0 ? viewport : g, y = s.elementContext, x = y === void 0 ? popper : y, w = s.altBoundary, S = w === void 0 ? !1 : w, M = s.padding, P = M === void 0 ? 0 : M, L = mergePaddingObject(typeof P != "number" ? P : expandToHashMap(P, basePlacements)), I = x === popper ? reference : popper, T = r.rects.popper, E = r.elements[S ? I : x], R = getClippingRect(isElement(E) ? E : E.contextElement || getDocumentElement(r.elements.popper), m, v, h), A = getBoundingClientRect(r.elements.reference), k = computeOffsets({
    reference: A,
    element: T,
    strategy: "absolute",
    placement: u
  }), V = rectToClientRect(Object.assign({}, T, k)), B = x === popper ? V : A, q = {
    top: R.top - B.top + L.top,
    bottom: B.bottom - R.bottom + L.bottom,
    left: R.left - B.left + L.left,
    right: B.right - R.right + L.right
  }, z = r.modifiersData.offset;
  if (x === popper && z) {
    var Z = z[u];
    Object.keys(q).forEach(function(G) {
      var K = [right, bottom].indexOf(G) >= 0 ? 1 : -1, U = [top, bottom].indexOf(G) >= 0 ? "y" : "x";
      q[G] += Z[U] * K;
    });
  }
  return q;
}
function computeAutoPlacement(r, a) {
  a === void 0 && (a = {});
  var s = a, c = s.placement, u = s.boundary, d = s.rootBoundary, h = s.padding, p = s.flipVariations, m = s.allowedAutoPlacements, g = m === void 0 ? placements : m, v = getVariation(c), y = v ? p ? variationPlacements : variationPlacements.filter(function(S) {
    return getVariation(S) === v;
  }) : basePlacements, x = y.filter(function(S) {
    return g.indexOf(S) >= 0;
  });
  x.length === 0 && (x = y);
  var w = x.reduce(function(S, M) {
    return S[M] = detectOverflow(r, {
      placement: M,
      boundary: u,
      rootBoundary: d,
      padding: h
    })[getBasePlacement(M)], S;
  }, {});
  return Object.keys(w).sort(function(S, M) {
    return w[S] - w[M];
  });
}
function getExpandedFallbackPlacements(r) {
  if (getBasePlacement(r) === auto)
    return [];
  var a = getOppositePlacement(r);
  return [getOppositeVariationPlacement(r), a, getOppositeVariationPlacement(a)];
}
function flip(r) {
  var a = r.state, s = r.options, c = r.name;
  if (!a.modifiersData[c]._skip) {
    for (var u = s.mainAxis, d = u === void 0 ? !0 : u, h = s.altAxis, p = h === void 0 ? !0 : h, m = s.fallbackPlacements, g = s.padding, v = s.boundary, y = s.rootBoundary, x = s.altBoundary, w = s.flipVariations, S = w === void 0 ? !0 : w, M = s.allowedAutoPlacements, P = a.options.placement, L = getBasePlacement(P), I = L === P, T = m || (I || !S ? [getOppositePlacement(P)] : getExpandedFallbackPlacements(P)), E = [P].concat(T).reduce(function(ee, X) {
      return ee.concat(getBasePlacement(X) === auto ? computeAutoPlacement(a, {
        placement: X,
        boundary: v,
        rootBoundary: y,
        padding: g,
        flipVariations: S,
        allowedAutoPlacements: M
      }) : X);
    }, []), R = a.rects.reference, A = a.rects.popper, k = /* @__PURE__ */ new Map(), V = !0, B = E[0], q = 0; q < E.length; q++) {
      var z = E[q], Z = getBasePlacement(z), G = getVariation(z) === start, K = [top, bottom].indexOf(Z) >= 0, U = K ? "width" : "height", F = detectOverflow(a, {
        placement: z,
        boundary: v,
        rootBoundary: y,
        altBoundary: x,
        padding: g
      }), N = K ? G ? right : left : G ? bottom : top;
      R[U] > A[U] && (N = getOppositePlacement(N));
      var D = getOppositePlacement(N), j = [];
      if (d && j.push(F[Z] <= 0), p && j.push(F[N] <= 0, F[D] <= 0), j.every(function(ee) {
        return ee;
      })) {
        B = z, V = !1;
        break;
      }
      k.set(z, j);
    }
    if (V)
      for (var H = S ? 3 : 1, W = function(X) {
        var J = E.find(function(ie) {
          var oe = k.get(ie);
          if (oe)
            return oe.slice(0, X).every(function(fe) {
              return fe;
            });
        });
        if (J)
          return B = J, "break";
      }, re = H; re > 0; re--) {
        var ae = W(re);
        if (ae === "break") break;
      }
    a.placement !== B && (a.modifiersData[c]._skip = !0, a.placement = B, a.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(r, a, s) {
  return s === void 0 && (s = {
    x: 0,
    y: 0
  }), {
    top: r.top - a.height - s.y,
    right: r.right - a.width + s.x,
    bottom: r.bottom - a.height + s.y,
    left: r.left - a.width - s.x
  };
}
function isAnySideFullyClipped(r) {
  return [top, right, bottom, left].some(function(a) {
    return r[a] >= 0;
  });
}
function hide(r) {
  var a = r.state, s = r.name, c = a.rects.reference, u = a.rects.popper, d = a.modifiersData.preventOverflow, h = detectOverflow(a, {
    elementContext: "reference"
  }), p = detectOverflow(a, {
    altBoundary: !0
  }), m = getSideOffsets(h, c), g = getSideOffsets(p, u, d), v = isAnySideFullyClipped(m), y = isAnySideFullyClipped(g);
  a.modifiersData[s] = {
    referenceClippingOffsets: m,
    popperEscapeOffsets: g,
    isReferenceHidden: v,
    hasPopperEscaped: y
  }, a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-reference-hidden": v,
    "data-popper-escaped": y
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(r, a, s) {
  var c = getBasePlacement(r), u = [left, top].indexOf(c) >= 0 ? -1 : 1, d = typeof s == "function" ? s(Object.assign({}, a, {
    placement: r
  })) : s, h = d[0], p = d[1];
  return h = h || 0, p = (p || 0) * u, [left, right].indexOf(c) >= 0 ? {
    x: p,
    y: h
  } : {
    x: h,
    y: p
  };
}
function offset(r) {
  var a = r.state, s = r.options, c = r.name, u = s.offset, d = u === void 0 ? [0, 0] : u, h = placements.reduce(function(v, y) {
    return v[y] = distanceAndSkiddingToXY(y, a.rects, d), v;
  }, {}), p = h[a.placement], m = p.x, g = p.y;
  a.modifiersData.popperOffsets != null && (a.modifiersData.popperOffsets.x += m, a.modifiersData.popperOffsets.y += g), a.modifiersData[c] = h;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(r) {
  var a = r.state, s = r.name;
  a.modifiersData[s] = computeOffsets({
    reference: a.rects.reference,
    element: a.rects.popper,
    strategy: "absolute",
    placement: a.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(r) {
  return r === "x" ? "y" : "x";
}
function preventOverflow(r) {
  var a = r.state, s = r.options, c = r.name, u = s.mainAxis, d = u === void 0 ? !0 : u, h = s.altAxis, p = h === void 0 ? !1 : h, m = s.boundary, g = s.rootBoundary, v = s.altBoundary, y = s.padding, x = s.tether, w = x === void 0 ? !0 : x, S = s.tetherOffset, M = S === void 0 ? 0 : S, P = detectOverflow(a, {
    boundary: m,
    rootBoundary: g,
    padding: y,
    altBoundary: v
  }), L = getBasePlacement(a.placement), I = getVariation(a.placement), T = !I, E = getMainAxisFromPlacement(L), R = getAltAxis(E), A = a.modifiersData.popperOffsets, k = a.rects.reference, V = a.rects.popper, B = typeof M == "function" ? M(Object.assign({}, a.rects, {
    placement: a.placement
  })) : M, q = typeof B == "number" ? {
    mainAxis: B,
    altAxis: B
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, B), z = a.modifiersData.offset ? a.modifiersData.offset[a.placement] : null, Z = {
    x: 0,
    y: 0
  };
  if (A) {
    if (d) {
      var G, K = E === "y" ? top : left, U = E === "y" ? bottom : right, F = E === "y" ? "height" : "width", N = A[E], D = N + P[K], j = N - P[U], H = w ? -V[F] / 2 : 0, W = I === start ? k[F] : V[F], re = I === start ? -V[F] : -k[F], ae = a.elements.arrow, ee = w && ae ? getLayoutRect(ae) : {
        width: 0,
        height: 0
      }, X = a.modifiersData["arrow#persistent"] ? a.modifiersData["arrow#persistent"].padding : getFreshSideObject(), J = X[K], ie = X[U], oe = within(0, k[F], ee[F]), fe = T ? k[F] / 2 - H - oe - J - q.mainAxis : W - oe - J - q.mainAxis, ve = T ? -k[F] / 2 + H + oe + ie + q.mainAxis : re + oe + ie + q.mainAxis, ue = a.elements.arrow && getOffsetParent(a.elements.arrow), pe = ue ? E === "y" ? ue.clientTop || 0 : ue.clientLeft || 0 : 0, we = (G = z == null ? void 0 : z[E]) != null ? G : 0, ye = N + fe - we - pe, Ie = N + ve - we, Ee = within(w ? min$1(D, ye) : D, N, w ? max$1(j, Ie) : j);
      A[E] = Ee, Z[E] = Ee - N;
    }
    if (p) {
      var ne, se = E === "x" ? top : left, de = E === "x" ? bottom : right, Ce = A[R], me = R === "y" ? "height" : "width", xe = Ce + P[se], Se = Ce - P[de], Re = [top, left].indexOf(L) !== -1, Pe = (ne = z == null ? void 0 : z[R]) != null ? ne : 0, ke = Re ? xe : Ce - k[me] - V[me] - Pe + q.altAxis, De = Re ? Ce + k[me] + V[me] - Pe - q.altAxis : Se, Fe = w && Re ? withinMaxClamp(ke, Ce, De) : within(w ? ke : xe, Ce, w ? De : Se);
      A[R] = Fe, Z[R] = Fe - Ce;
    }
    a.modifiersData[c] = Z;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(r) {
  return {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  };
}
function getNodeScroll(r) {
  return r === getWindow(r) || !isHTMLElement$1(r) ? getWindowScroll(r) : getHTMLElementScroll(r);
}
function isElementScaled(r) {
  var a = r.getBoundingClientRect(), s = round(a.width) / r.offsetWidth || 1, c = round(a.height) / r.offsetHeight || 1;
  return s !== 1 || c !== 1;
}
function getCompositeRect(r, a, s) {
  s === void 0 && (s = !1);
  var c = isHTMLElement$1(a), u = isHTMLElement$1(a) && isElementScaled(a), d = getDocumentElement(a), h = getBoundingClientRect(r, u, s), p = {
    scrollLeft: 0,
    scrollTop: 0
  }, m = {
    x: 0,
    y: 0
  };
  return (c || !c && !s) && ((getNodeName(a) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(d)) && (p = getNodeScroll(a)), isHTMLElement$1(a) ? (m = getBoundingClientRect(a, !0), m.x += a.clientLeft, m.y += a.clientTop) : d && (m.x = getWindowScrollBarX(d))), {
    x: h.left + p.scrollLeft - m.x,
    y: h.top + p.scrollTop - m.y,
    width: h.width,
    height: h.height
  };
}
function order(r) {
  var a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set(), c = [];
  r.forEach(function(d) {
    a.set(d.name, d);
  });
  function u(d) {
    s.add(d.name);
    var h = [].concat(d.requires || [], d.requiresIfExists || []);
    h.forEach(function(p) {
      if (!s.has(p)) {
        var m = a.get(p);
        m && u(m);
      }
    }), c.push(d);
  }
  return r.forEach(function(d) {
    s.has(d.name) || u(d);
  }), c;
}
function orderModifiers(r) {
  var a = order(r);
  return modifierPhases.reduce(function(s, c) {
    return s.concat(a.filter(function(u) {
      return u.phase === c;
    }));
  }, []);
}
function debounce$2(r) {
  var a;
  return function() {
    return a || (a = new Promise(function(s) {
      Promise.resolve().then(function() {
        a = void 0, s(r());
      });
    })), a;
  };
}
function mergeByName(r) {
  var a = r.reduce(function(s, c) {
    var u = s[c.name];
    return s[c.name] = u ? Object.assign({}, u, c, {
      options: Object.assign({}, u.options, c.options),
      data: Object.assign({}, u.data, c.data)
    }) : c, s;
  }, {});
  return Object.keys(a).map(function(s) {
    return a[s];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++)
    a[s] = arguments[s];
  return !a.some(function(c) {
    return !(c && typeof c.getBoundingClientRect == "function");
  });
}
function popperGenerator(r) {
  r === void 0 && (r = {});
  var a = r, s = a.defaultModifiers, c = s === void 0 ? [] : s, u = a.defaultOptions, d = u === void 0 ? DEFAULT_OPTIONS : u;
  return function(p, m, g) {
    g === void 0 && (g = d);
    var v = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, d),
      modifiersData: {},
      elements: {
        reference: p,
        popper: m
      },
      attributes: {},
      styles: {}
    }, y = [], x = !1, w = {
      state: v,
      setOptions: function(L) {
        var I = typeof L == "function" ? L(v.options) : L;
        M(), v.options = Object.assign({}, d, v.options, I), v.scrollParents = {
          reference: isElement(p) ? listScrollParents(p) : p.contextElement ? listScrollParents(p.contextElement) : [],
          popper: listScrollParents(m)
        };
        var T = orderModifiers(mergeByName([].concat(c, v.options.modifiers)));
        return v.orderedModifiers = T.filter(function(E) {
          return E.enabled;
        }), S(), w.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!x) {
          var L = v.elements, I = L.reference, T = L.popper;
          if (areValidElements(I, T)) {
            v.rects = {
              reference: getCompositeRect(I, getOffsetParent(T), v.options.strategy === "fixed"),
              popper: getLayoutRect(T)
            }, v.reset = !1, v.placement = v.options.placement, v.orderedModifiers.forEach(function(q) {
              return v.modifiersData[q.name] = Object.assign({}, q.data);
            });
            for (var E = 0; E < v.orderedModifiers.length; E++) {
              if (v.reset === !0) {
                v.reset = !1, E = -1;
                continue;
              }
              var R = v.orderedModifiers[E], A = R.fn, k = R.options, V = k === void 0 ? {} : k, B = R.name;
              typeof A == "function" && (v = A({
                state: v,
                options: V,
                name: B,
                instance: w
              }) || v);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function() {
        return new Promise(function(P) {
          w.forceUpdate(), P(v);
        });
      }),
      destroy: function() {
        M(), x = !0;
      }
    };
    if (!areValidElements(p, m))
      return w;
    w.setOptions(g).then(function(P) {
      !x && g.onFirstUpdate && g.onFirstUpdate(P);
    });
    function S() {
      v.orderedModifiers.forEach(function(P) {
        var L = P.name, I = P.options, T = I === void 0 ? {} : I, E = P.effect;
        if (typeof E == "function") {
          var R = E({
            state: v,
            name: L,
            instance: w,
            options: T
          }), A = function() {
          };
          y.push(R || A);
        }
      });
    }
    function M() {
      y.forEach(function(P) {
        return P();
      }), y = [];
    }
    return w;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
}), DOM_PROPERTIES_TO_CHECK = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
], objectTypes = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
], primitiveTypes = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function getObjectType$1(r) {
  var a = Object.prototype.toString.call(r).slice(8, -1);
  if (/HTML\w+Element/.test(a))
    return "HTMLElement";
  if (isObjectType$1(a))
    return a;
}
function isObjectOfType(r) {
  return function(a) {
    return getObjectType$1(a) === r;
  };
}
function isObjectType$1(r) {
  return objectTypes.includes(r);
}
function isOfType$1(r) {
  return function(a) {
    return typeof a === r;
  };
}
function isPrimitiveType(r) {
  return primitiveTypes.includes(r);
}
function is(r) {
  if (r === null)
    return "null";
  switch (typeof r) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (is.array(r))
    return "Array";
  if (is.plainFunction(r))
    return "Function";
  var a = getObjectType$1(r);
  return a || "Object";
}
is.array = Array.isArray;
is.arrayOf = function(r, a) {
  return !is.array(r) && !is.function(a) ? !1 : r.every(function(s) {
    return a(s);
  });
};
is.asyncGeneratorFunction = function(r) {
  return getObjectType$1(r) === "AsyncGeneratorFunction";
};
is.asyncFunction = isObjectOfType("AsyncFunction");
is.bigint = isOfType$1("bigint");
is.boolean = function(r) {
  return r === !0 || r === !1;
};
is.date = isObjectOfType("Date");
is.defined = function(r) {
  return !is.undefined(r);
};
is.domElement = function(r) {
  return is.object(r) && !is.plainObject(r) && r.nodeType === 1 && is.string(r.nodeName) && DOM_PROPERTIES_TO_CHECK.every(function(a) {
    return a in r;
  });
};
is.empty = function(r) {
  return is.string(r) && r.length === 0 || is.array(r) && r.length === 0 || is.object(r) && !is.map(r) && !is.set(r) && Object.keys(r).length === 0 || is.set(r) && r.size === 0 || is.map(r) && r.size === 0;
};
is.error = isObjectOfType("Error");
is.function = isOfType$1("function");
is.generator = function(r) {
  return is.iterable(r) && is.function(r.next) && is.function(r.throw);
};
is.generatorFunction = isObjectOfType("GeneratorFunction");
is.instanceOf = function(r, a) {
  return !r || !a ? !1 : Object.getPrototypeOf(r) === a.prototype;
};
is.iterable = function(r) {
  return !is.nullOrUndefined(r) && is.function(r[Symbol.iterator]);
};
is.map = isObjectOfType("Map");
is.nan = function(r) {
  return Number.isNaN(r);
};
is.null = function(r) {
  return r === null;
};
is.nullOrUndefined = function(r) {
  return is.null(r) || is.undefined(r);
};
is.number = function(r) {
  return isOfType$1("number")(r) && !is.nan(r);
};
is.numericString = function(r) {
  return is.string(r) && r.length > 0 && !Number.isNaN(Number(r));
};
is.object = function(r) {
  return !is.nullOrUndefined(r) && (is.function(r) || typeof r == "object");
};
is.oneOf = function(r, a) {
  return is.array(r) ? r.indexOf(a) > -1 : !1;
};
is.plainFunction = isObjectOfType("Function");
is.plainObject = function(r) {
  if (getObjectType$1(r) !== "Object")
    return !1;
  var a = Object.getPrototypeOf(r);
  return a === null || a === Object.getPrototypeOf({});
};
is.primitive = function(r) {
  return is.null(r) || isPrimitiveType(typeof r);
};
is.promise = isObjectOfType("Promise");
is.propertyOf = function(r, a, s) {
  if (!is.object(r) || !a)
    return !1;
  var c = r[a];
  return is.function(s) ? s(c) : is.defined(c);
};
is.regexp = isObjectOfType("RegExp");
is.set = isObjectOfType("Set");
is.string = isOfType$1("string");
is.symbol = isOfType$1("symbol");
is.undefined = isOfType$1("undefined");
is.weakMap = isObjectOfType("WeakMap");
is.weakSet = isObjectOfType("WeakSet");
function isOfType(r) {
  return function(a) {
    return typeof a === r;
  };
}
var isFunction$5 = isOfType("function"), isNull = function(r) {
  return r === null;
}, isRegex$1 = function(r) {
  return Object.prototype.toString.call(r).slice(8, -1) === "RegExp";
}, isObject$5 = function(r) {
  return !isUndefined$1(r) && !isNull(r) && (isFunction$5(r) || typeof r == "object");
}, isUndefined$1 = isOfType("undefined"), __values = function(r) {
  var a = typeof Symbol == "function" && Symbol.iterator, s = a && r[a], c = 0;
  if (s) return s.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && c >= r.length && (r = void 0), { value: r && r[c++], done: !r };
    }
  };
  throw new TypeError(a ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function equalArray(r, a) {
  var s = r.length;
  if (s !== a.length)
    return !1;
  for (var c = s; c-- !== 0; )
    if (!equal(r[c], a[c]))
      return !1;
  return !0;
}
function equalArrayBuffer(r, a) {
  if (r.byteLength !== a.byteLength)
    return !1;
  for (var s = new DataView(r.buffer), c = new DataView(a.buffer), u = r.byteLength; u--; )
    if (s.getUint8(u) !== c.getUint8(u))
      return !1;
  return !0;
}
function equalMap(r, a) {
  var s, c, u, d;
  if (r.size !== a.size)
    return !1;
  try {
    for (var h = __values(r.entries()), p = h.next(); !p.done; p = h.next()) {
      var m = p.value;
      if (!a.has(m[0]))
        return !1;
    }
  } catch (y) {
    s = { error: y };
  } finally {
    try {
      p && !p.done && (c = h.return) && c.call(h);
    } finally {
      if (s) throw s.error;
    }
  }
  try {
    for (var g = __values(r.entries()), v = g.next(); !v.done; v = g.next()) {
      var m = v.value;
      if (!equal(m[1], a.get(m[0])))
        return !1;
    }
  } catch (y) {
    u = { error: y };
  } finally {
    try {
      v && !v.done && (d = g.return) && d.call(g);
    } finally {
      if (u) throw u.error;
    }
  }
  return !0;
}
function equalSet(r, a) {
  var s, c;
  if (r.size !== a.size)
    return !1;
  try {
    for (var u = __values(r.entries()), d = u.next(); !d.done; d = u.next()) {
      var h = d.value;
      if (!a.has(h[0]))
        return !1;
    }
  } catch (p) {
    s = { error: p };
  } finally {
    try {
      d && !d.done && (c = u.return) && c.call(u);
    } finally {
      if (s) throw s.error;
    }
  }
  return !0;
}
function equal(r, a) {
  if (r === a)
    return !0;
  if (r && isObject$5(r) && a && isObject$5(a)) {
    if (r.constructor !== a.constructor)
      return !1;
    if (Array.isArray(r) && Array.isArray(a))
      return equalArray(r, a);
    if (r instanceof Map && a instanceof Map)
      return equalMap(r, a);
    if (r instanceof Set && a instanceof Set)
      return equalSet(r, a);
    if (ArrayBuffer.isView(r) && ArrayBuffer.isView(a))
      return equalArrayBuffer(r, a);
    if (isRegex$1(r) && isRegex$1(a))
      return r.source === a.source && r.flags === a.flags;
    if (r.valueOf !== Object.prototype.valueOf)
      return r.valueOf() === a.valueOf();
    if (r.toString !== Object.prototype.toString)
      return r.toString() === a.toString();
    var s = Object.keys(r), c = Object.keys(a);
    if (s.length !== c.length)
      return !1;
    for (var u = s.length; u-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(a, s[u]))
        return !1;
    for (var u = s.length; u-- !== 0; ) {
      var d = s[u];
      if (!(d === "_owner" && r.$$typeof) && !equal(r[d], a[d]))
        return !1;
    }
    return !0;
  }
  return Number.isNaN(r) && Number.isNaN(a) ? !0 : r === a;
}
function canHaveLength() {
  for (var r = [], a = 0; a < arguments.length; a++)
    r[a] = arguments[a];
  return r.every(function(s) {
    return is.string(s) || is.array(s) || is.plainObject(s);
  });
}
function checkEquality(r, a, s) {
  return isSameType(r, a) ? [r, a].every(is.array) ? !r.some(hasValue(s)) && a.some(hasValue(s)) : [r, a].every(is.plainObject) ? !Object.entries(r).some(hasEntry(s)) && Object.entries(a).some(hasEntry(s)) : a === s : !1;
}
function compareNumbers(r, a, s) {
  var c = s.actual, u = s.key, d = s.previous, h = s.type, p = nested(r, u), m = nested(a, u), g = [p, m].every(is.number) && (h === "increased" ? p < m : p > m);
  return is.undefined(c) || (g = g && m === c), is.undefined(d) || (g = g && p === d), g;
}
function compareValues(r, a, s) {
  var c = s.key, u = s.type, d = s.value, h = nested(r, c), p = nested(a, c), m = u === "added" ? h : p, g = u === "added" ? p : h;
  if (!is.nullOrUndefined(d)) {
    if (is.defined(m)) {
      if (is.array(m) || is.plainObject(m))
        return checkEquality(m, g, d);
    } else
      return equal(g, d);
    return !1;
  }
  return [h, p].every(is.array) ? !g.every(isEqualPredicate(m)) : [h, p].every(is.plainObject) ? hasExtraKeys(Object.keys(m), Object.keys(g)) : ![h, p].every(function(v) {
    return is.primitive(v) && is.defined(v);
  }) && (u === "added" ? !is.defined(h) && is.defined(p) : is.defined(h) && !is.defined(p));
}
function getIterables(r, a, s) {
  var c = s === void 0 ? {} : s, u = c.key, d = nested(r, u), h = nested(a, u);
  if (!isSameType(d, h))
    throw new TypeError("Inputs have different types");
  if (!canHaveLength(d, h))
    throw new TypeError("Inputs don't have length");
  return [d, h].every(is.plainObject) && (d = Object.keys(d), h = Object.keys(h)), [d, h];
}
function hasEntry(r) {
  return function(a) {
    var s = a[0], c = a[1];
    return is.array(r) ? equal(r, c) || r.some(function(u) {
      return equal(u, c) || is.array(c) && isEqualPredicate(c)(u);
    }) : is.plainObject(r) && r[s] ? !!r[s] && equal(r[s], c) : equal(r, c);
  };
}
function hasExtraKeys(r, a) {
  return a.some(function(s) {
    return !r.includes(s);
  });
}
function hasValue(r) {
  return function(a) {
    return is.array(r) ? r.some(function(s) {
      return equal(s, a) || is.array(a) && isEqualPredicate(a)(s);
    }) : equal(r, a);
  };
}
function includesOrEqualsTo(r, a) {
  return is.array(r) ? r.some(function(s) {
    return equal(s, a);
  }) : equal(r, a);
}
function isEqualPredicate(r) {
  return function(a) {
    return r.some(function(s) {
      return equal(s, a);
    });
  };
}
function isSameType() {
  for (var r = [], a = 0; a < arguments.length; a++)
    r[a] = arguments[a];
  return r.every(is.array) || r.every(is.number) || r.every(is.plainObject) || r.every(is.string);
}
function nested(r, a) {
  if (is.plainObject(r) || is.array(r)) {
    if (is.string(a)) {
      var s = a.split(".");
      return s.reduce(function(c, u) {
        return c && c[u];
      }, r);
    }
    return is.number(a) ? r[a] : r;
  }
  return r;
}
function treeChanges(r, a) {
  if ([r, a].some(is.nullOrUndefined))
    throw new Error("Missing required parameters");
  if (![r, a].every(function(y) {
    return is.plainObject(y) || is.array(y);
  }))
    throw new Error("Expected plain objects or array");
  var s = function(y, x) {
    try {
      return compareValues(r, a, { key: y, type: "added", value: x });
    } catch {
      return !1;
    }
  }, c = function(y, x, w) {
    try {
      var S = nested(r, y), M = nested(a, y), P = is.defined(x), L = is.defined(w);
      if (P || L) {
        var I = L ? includesOrEqualsTo(w, S) : !includesOrEqualsTo(x, S), T = includesOrEqualsTo(x, M);
        return I && T;
      }
      return [S, M].every(is.array) || [S, M].every(is.plainObject) ? !equal(S, M) : S !== M;
    } catch {
      return !1;
    }
  }, u = function(y, x, w) {
    if (!is.defined(y))
      return !1;
    try {
      var S = nested(r, y), M = nested(a, y), P = is.defined(w);
      return includesOrEqualsTo(x, S) && (P ? includesOrEqualsTo(w, M) : !P);
    } catch {
      return !1;
    }
  }, d = function(y, x) {
    return is.defined(y) ? (process.env.NODE_ENV === "development" && console.warn("`changedTo` is deprecated! Replace it with `change`"), c(y, x)) : !1;
  }, h = function(y, x, w) {
    if (!is.defined(y))
      return !1;
    try {
      return compareNumbers(r, a, { key: y, actual: x, previous: w, type: "decreased" });
    } catch {
      return !1;
    }
  }, p = function(y) {
    try {
      var x = getIterables(r, a, { key: y }), w = x[0], S = x[1];
      return !!w.length && !S.length;
    } catch {
      return !1;
    }
  }, m = function(y) {
    try {
      var x = getIterables(r, a, { key: y }), w = x[0], S = x[1];
      return !w.length && !!S.length;
    } catch {
      return !1;
    }
  }, g = function(y, x, w) {
    if (!is.defined(y))
      return !1;
    try {
      return compareNumbers(r, a, { key: y, actual: x, previous: w, type: "increased" });
    } catch {
      return !1;
    }
  }, v = function(y, x) {
    try {
      return compareValues(r, a, { key: y, type: "removed", value: x });
    } catch {
      return !1;
    }
  };
  return { added: s, changed: c, changedFrom: u, changedTo: d, decreased: h, emptied: p, filled: m, increased: g, removed: v };
}
function useTreeChanges(r) {
  var a = useRef$1(r), s = equal(a.current, r), c = useRef$1(s), u = useRef$1(treeChanges(a.current, r));
  return useEffect$1(function() {
    a.current = r;
  }), (c.current !== s || !s) && (c.current = s, u.current = treeChanges(a.current, r)), u.current;
}
var __assign$9 = function() {
  return __assign$9 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$9.apply(this, arguments);
};
function FloaterArrow(r) {
  var a = r.arrowRef, s = r.placement, c = r.styles, u = c.arrow, d = u.color, h = u.display, p = u.length, m = u.position, g = u.spread, v = { display: h, position: m }, y, x = g, w = p;
  return s.startsWith("top") ? y = "0,0 ".concat(x / 2, ",").concat(w, " ").concat(x, ",0") : s.startsWith("bottom") ? y = "".concat(x, ",").concat(w, " ").concat(x / 2, ",0 0,").concat(w) : s.startsWith("left") ? (w = g, x = p, y = "0,0 ".concat(x, ",").concat(w / 2, " 0,").concat(w)) : s.startsWith("right") && (w = g, x = p, y = "".concat(x, ",").concat(w, " ").concat(x, ",0 0,").concat(w / 2)), jsx("span", __assign$9({ ref: a, className: "__floater__arrow", style: v }, { children: jsx("svg", __assign$9({ height: w, version: "1.1", width: x, xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("polygon", { fill: d, points: y }) })) }));
}
var __assign$8 = function() {
  return __assign$8 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$8.apply(this, arguments);
}, __rest$3 = function(r, a) {
  var s = {};
  for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && a.indexOf(c) < 0 && (s[c] = r[c]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, c = Object.getOwnPropertySymbols(r); u < c.length; u++)
      a.indexOf(c[u]) < 0 && Object.prototype.propertyIsEnumerable.call(r, c[u]) && (s[c[u]] = r[c[u]]);
  return s;
};
function FloaterCloseButton(r) {
  var a = r.onClick, s = r.styles, c = s.color, u = s.height, d = s.width, h = __rest$3(s, ["color", "height", "width"]);
  return jsx("button", __assign$8({ "aria-label": "close", onClick: a, style: h, type: "button" }, { children: jsx("svg", __assign$8({ height: "".concat(u, "px"), preserveAspectRatio: "xMidYMid", version: "1.1", viewBox: "0 0 18 18", width: "".concat(d, "px"), xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("g", { children: jsx("path", { d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z", fill: c }) }) })) }));
}
var __assign$7 = function() {
  return __assign$7 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$7.apply(this, arguments);
};
function FloaterContainer(r) {
  var a = r.content, s = r.footer, c = r.onClick, u = r.open, d = r.positionWrapper, h = r.showCloseButton, p = r.styles, m = r.title, g = {
    content: React.isValidElement(a) ? a : jsx("div", __assign$7({ className: "__floater__content", style: p.content }, { children: a }))
  };
  return m && (g.title = React.isValidElement(m) ? m : jsx("div", __assign$7({ className: "__floater__title", style: p.title }, { children: m }))), s && (g.footer = React.isValidElement(s) ? s : jsx("div", __assign$7({ className: "__floater__footer", style: p.footer }, { children: s }))), (h || d) && !is.boolean(u) && (g.close = jsx(FloaterCloseButton, { onClick: c, styles: p.close })), jsxs("div", __assign$7({ className: "__floater__container", style: p.container }, { children: [g.close, g.title, g.content, g.footer] }));
}
var POSITIONING_PROPS = ["position", "top", "right", "bottom", "left"], STATUS = {
  INIT: "init",
  IDLE: "idle",
  RENDER: "render",
  OPENING: "opening",
  OPEN: "open",
  CLOSING: "closing",
  ERROR: "error"
}, __assign$6 = function() {
  return __assign$6 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$6.apply(this, arguments);
};
function Floater(r) {
  var a = r.component, s = r.content, c = r.floaterRef, u = r.hideArrow, d = r.id, h = r.onClick, p = r.placement, m = r.status, g = r.styles, v = React.useMemo(function() {
    var P = g.arrow.length, L = g.floater, I = g.floaterCentered, T = g.floaterClosing, E = g.floaterOpening, R = g.floaterWithComponent, A = __assign$6({}, L);
    return u || (p.startsWith("top") ? A.padding = "0 0 ".concat(P, "px") : p.startsWith("bottom") ? A.padding = "".concat(P, "px 0 0") : p.startsWith("left") ? A.padding = "0 ".concat(P, "px 0 0") : p.startsWith("right") && (A.padding = "0 0 0 ".concat(P, "px"))), m === STATUS.CLOSING && (A = __assign$6(__assign$6({}, A), T)), (m === STATUS.OPENING || m === STATUS.OPEN) && (A = __assign$6(__assign$6({}, A), E)), p === "center" && (A = __assign$6(__assign$6({}, A), I)), a && (A = __assign$6(__assign$6({}, A), R)), A;
  }, [a, u, p, m, g]), y = ["render", "open", "opening", "closing"].includes(m), x = {}, w = ["__floater"], S = { id: d, role: "tooltip" };
  if (a) {
    var M = __assign$6({ closeFn: h }, S);
    x.content = React.isValidElement(a) ? React.cloneElement(a, M) : a(M);
  } else
    x.content = jsx(FloaterContainer, __assign$6({}, r, { content: s }));
  return m === STATUS.OPEN && w.push("__floater__open"), u || (x.arrow = jsx(FloaterArrow, __assign$6({}, r))), y ? jsx("div", __assign$6({ ref: c, style: { zIndex: g.options.zIndex } }, { children: jsx("div", __assign$6({ className: w.join(" "), style: v }, S, { children: jsxs("div", __assign$6({ className: "__floater__body" }, { children: [x.content, x.arrow] })) })) })) : null;
}
const Floater$1 = React.memo(Floater), actions = {
  defaultMerge: Symbol("deepmerge-ts: default merge"),
  skip: Symbol("deepmerge-ts: skip")
};
actions.defaultMerge;
function defaultMetaDataUpdater(r, a) {
  return a;
}
function getObjectType(r) {
  return typeof r != "object" || r === null ? 0 : Array.isArray(r) ? 2 : isRecord(r) ? 1 : r instanceof Set ? 3 : r instanceof Map ? 4 : 5;
}
function getKeys(r) {
  const a = /* @__PURE__ */ new Set();
  for (const s of r)
    for (const c of [
      ...Object.keys(s),
      ...Object.getOwnPropertySymbols(s)
    ])
      a.add(c);
  return a;
}
function objectHasProperty(r, a) {
  return typeof r == "object" && Object.prototype.propertyIsEnumerable.call(r, a);
}
function getIterableOfIterables(r) {
  return {
    *[Symbol.iterator]() {
      for (const a of r)
        for (const s of a)
          yield s;
    }
  };
}
const validRecordToStringValues = /* @__PURE__ */ new Set([
  "[object Object]",
  "[object Module]"
]);
function isRecord(r) {
  if (!validRecordToStringValues.has(Object.prototype.toString.call(r)))
    return !1;
  const { constructor: a } = r;
  if (a === void 0)
    return !0;
  const s = a.prototype;
  return !(s === null || typeof s != "object" || !validRecordToStringValues.has(Object.prototype.toString.call(s)) || !s.hasOwnProperty("isPrototypeOf"));
}
function mergeRecords$2(r, a, s) {
  const c = {};
  for (const u of getKeys(r)) {
    const d = [];
    for (const m of r)
      objectHasProperty(m, u) && d.push(m[u]);
    if (d.length === 0)
      continue;
    const h = a.metaDataUpdater(s, {
      key: u,
      parents: r
    }), p = mergeUnknowns(d, a, h);
    p !== actions.skip && (u === "__proto__" ? Object.defineProperty(c, u, {
      value: p,
      configurable: !0,
      enumerable: !0,
      writable: !0
    }) : c[u] = p);
  }
  return c;
}
function mergeArrays$2(r) {
  return r.flat();
}
function mergeSets$2(r) {
  return new Set(getIterableOfIterables(r));
}
function mergeMaps$2(r) {
  return new Map(getIterableOfIterables(r));
}
function mergeOthers$2(r) {
  return r[r.length - 1];
}
var defaultMergeFunctions = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  mergeRecords: mergeRecords$2,
  mergeArrays: mergeArrays$2,
  mergeSets: mergeSets$2,
  mergeMaps: mergeMaps$2,
  mergeOthers: mergeOthers$2
});
function deepmerge(...r) {
  return deepmergeCustom({})(...r);
}
function deepmergeCustom(r, a) {
  const s = getUtils(r, c);
  function c(...u) {
    return mergeUnknowns(u, s, a);
  }
  return c;
}
function getUtils(r, a) {
  var s, c;
  return {
    defaultMergeFunctions,
    mergeFunctions: {
      ...defaultMergeFunctions,
      ...Object.fromEntries(Object.entries(r).filter(([u, d]) => Object.prototype.hasOwnProperty.call(defaultMergeFunctions, u)).map(([u, d]) => d === !1 ? [u, mergeOthers$2] : [u, d]))
    },
    metaDataUpdater: (s = r.metaDataUpdater) !== null && s !== void 0 ? s : defaultMetaDataUpdater,
    deepmerge: a,
    useImplicitDefaultMerging: (c = r.enableImplicitDefaultMerging) !== null && c !== void 0 ? c : !1,
    actions
  };
}
function mergeUnknowns(r, a, s) {
  if (r.length === 0)
    return;
  if (r.length === 1)
    return mergeOthers$1(r, a, s);
  const c = getObjectType(r[0]);
  if (c !== 0 && c !== 5) {
    for (let u = 1; u < r.length; u++)
      if (getObjectType(r[u]) !== c)
        return mergeOthers$1(r, a, s);
  }
  switch (c) {
    case 1:
      return mergeRecords$1(r, a, s);
    case 2:
      return mergeArrays$1(r, a, s);
    case 3:
      return mergeSets$1(r, a, s);
    case 4:
      return mergeMaps$1(r, a, s);
    default:
      return mergeOthers$1(r, a, s);
  }
}
function mergeRecords$1(r, a, s) {
  const c = a.mergeFunctions.mergeRecords(r, a, s);
  return c === actions.defaultMerge || a.useImplicitDefaultMerging && c === void 0 && a.mergeFunctions.mergeRecords !== a.defaultMergeFunctions.mergeRecords ? a.defaultMergeFunctions.mergeRecords(r, a, s) : c;
}
function mergeArrays$1(r, a, s) {
  const c = a.mergeFunctions.mergeArrays(r, a, s);
  return c === actions.defaultMerge || a.useImplicitDefaultMerging && c === void 0 && a.mergeFunctions.mergeArrays !== a.defaultMergeFunctions.mergeArrays ? a.defaultMergeFunctions.mergeArrays(r) : c;
}
function mergeSets$1(r, a, s) {
  const c = a.mergeFunctions.mergeSets(r, a, s);
  return c === actions.defaultMerge || a.useImplicitDefaultMerging && c === void 0 && a.mergeFunctions.mergeSets !== a.defaultMergeFunctions.mergeSets ? a.defaultMergeFunctions.mergeSets(r) : c;
}
function mergeMaps$1(r, a, s) {
  const c = a.mergeFunctions.mergeMaps(r, a, s);
  return c === actions.defaultMerge || a.useImplicitDefaultMerging && c === void 0 && a.mergeFunctions.mergeMaps !== a.defaultMergeFunctions.mergeMaps ? a.defaultMergeFunctions.mergeMaps(r) : c;
}
function mergeOthers$1(r, a, s) {
  const c = a.mergeFunctions.mergeOthers(r, a, s);
  return c === actions.defaultMerge || a.useImplicitDefaultMerging && c === void 0 && a.mergeFunctions.mergeOthers !== a.defaultMergeFunctions.mergeOthers ? a.defaultMergeFunctions.mergeOthers(r) : c;
}
var exenv = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(r) {
  (function() {
    var a = !!(typeof window < "u" && window.document && window.document.createElement), s = {
      canUseDOM: a,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: a && !!(window.addEventListener || window.attachEvent),
      canUseViewport: a && !!window.screen
    };
    r.exports ? r.exports = s : window.ExecutionEnvironment = s;
  })();
})(exenv);
var exenvExports = exenv.exports, __assign$5 = function() {
  return __assign$5 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$5.apply(this, arguments);
}, canUseDOM = exenvExports.canUseDOM, portalId = "react-floater-portal";
function enhanceProps(r) {
  return __assign$5({ autoOpen: !1, debug: !1, disableFlip: !1, disableHoverToClick: !1, event: "click", eventDelay: 0.4, hideArrow: !1, offset: 15, placement: "bottom", showCloseButton: !1, styles: {}, target: null, wrapperOptions: {
    position: !1
  } }, r);
}
function getFallbackPlacements(r) {
  if (r.startsWith("left"))
    return ["top", "bottom"];
  if (r.startsWith("right"))
    return ["bottom", "top"];
}
function getModifiers(r) {
  var a = {
    flip: {
      name: "flip",
      enabled: !0,
      options: {
        padding: 20
      }
    },
    preventOverflow: {
      name: "preventOverflow",
      enabled: !0,
      options: {
        padding: 10
      }
    }
  };
  return deepmerge(a, r || {});
}
function isFixed(r) {
  if (!r)
    return !1;
  var a = r.nodeName;
  return a === "BODY" || a === "HTML" ? !1 : getComputedStyle(r).position === "fixed" ? !0 : r.parentNode instanceof HTMLElement ? isFixed(r.parentNode) : !1;
}
function isMobile() {
  return "ontouchstart" in window && /Mobi/.test(navigator.userAgent);
}
function log(r) {
  var a = r.data, s = r.debug, c = s === void 0 ? !1 : s, u = r.title, d = console.log;
  c && u && a && (console.groupCollapsed("%creact-floater: ".concat(u), "color: #9b00ff; font-weight: bold; font-size: 12px;"), Array.isArray(a) ? a.forEach(function(h) {
    is.plainObject(h) && h.key ? d.apply(console, [h.key, h.value]) : d.apply(console, [h]);
  }) : d.apply(console, [a]), console.groupEnd());
}
function mergeModifier(r, a) {
  return deepmerge(r, a || {});
}
function off(r, a, s, c) {
  c === void 0 && (c = !1), r.removeEventListener(a, s, c);
}
function on(r, a, s, c) {
  c === void 0 && (c = !1), r.addEventListener(a, s, c);
}
function once$1(r, a, s, c) {
  c === void 0 && (c = !1);
  var u;
  u = function(d) {
    s(d), off(r, a, u);
  }, on(r, a, u, c);
}
function randomId() {
  return "rf-".concat(Math.round(Math.random() * 1e5));
}
var __assign$4 = function() {
  return __assign$4 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$4.apply(this, arguments);
}, __read$1 = function(r, a) {
  var s = typeof Symbol == "function" && r[Symbol.iterator];
  if (!s) return r;
  var c = s.call(r), u, d = [], h;
  try {
    for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) d.push(u.value);
  } catch (p) {
    h = { error: p };
  } finally {
    try {
      u && !u.done && (s = c.return) && s.call(c);
    } finally {
      if (h) throw h.error;
    }
  }
  return d;
};
function useEffectOnce(r) {
  useEffect$1(r, []);
}
function useMount(r) {
  useEffectOnce(r);
}
function useSetState(r) {
  r === void 0 && (r = {});
  var a = __read$1(useState$1(r), 2), s = a[0], c = a[1], u = useCallback$1(function(d) {
    c(function(h) {
      return __assign$4(__assign$4({}, h), d instanceof Function ? d(h) : d);
    });
  }, [c]);
  return [s, u];
}
function useSingleton(r) {
  var a = useRef$1(!1);
  a.current || (r(), a.current = !0);
}
function useUnmount(r) {
  var a = useRef$1(r);
  a.current = r, useEffectOnce(function() {
    return function() {
      return a.current();
    };
  });
}
function useUpdateEffect(r, a) {
  var s = useRef$1(!0);
  useEffect$1(function() {
    s.current || r();
  }, a), s.current && (s.current = !1);
}
function ReactFloaterPortal(r) {
  var a = r.children, s = r.hasChildren, c = r.placement, u = r.portalElement, d = r.target, h = r.zIndex, p = React.useRef(null), m = React.useCallback(function() {
    if (canUseDOM && (u && (p.current = is.string(u) ? document.querySelector(u) : u), !u || !p.current)) {
      var g = document.getElementById("react-floater-portal");
      g ? p.current = g : (p.current = document.createElement("div"), p.current.id = portalId, p.current.style.zIndex = "".concat(h), document.body.appendChild(p.current));
    }
  }, [u, h]);
  return useSingleton(m), useMount(function() {
    !u && !document.getElementById(portalId) && (p.current ? document.body.appendChild(p.current) : m());
  }), useUnmount(function() {
    if (!(!canUseDOM || !p.current))
      try {
        p.current.id === portalId && p.current.childElementCount === 0 && document.body.contains(p.current) && (document.body.removeChild(p.current), p.current = null);
      } catch {
        p.current = null;
      }
  }), p.current ? !s && !d && c !== "center" ? null : createPortal(a, p.current) : null;
}
var __assign$3 = function() {
  return __assign$3 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$3.apply(this, arguments);
};
function FloaterWrapper(r) {
  var a = r.childRef, s = r.children, c = r.id, u = r.isControlled, d = r.onClick, h = r.onMouseEnter, p = r.onMouseLeave, m = r.status, g = r.style, v = r.styles, y = r.wrapperRef, x, w = React.useMemo(function() {
    return __assign$3(__assign$3(__assign$3({}, v), g), React.isValidElement(s) ? s.props.style : void 0);
  }, [s, g, v]), S = {
    "aria-describedby": [STATUS.OPENING, STATUS.OPEN, STATUS.CLOSING].includes(m) ? c : void 0,
    "data-id": c,
    style: w
  };
  return u || (S = __assign$3(__assign$3({}, S), { onClick: d, onMouseEnter: h, onMouseLeave: p })), s && (React.Children.count(s) === 1 && React.isValidElement(s) && s.type !== React.Fragment ? is.function(s.type) ? x = jsx("span", __assign$3({ ref: y }, { children: React.cloneElement(React.Children.only(s), __assign$3({ innerRef: a }, S)) })) : x = React.cloneElement(React.Children.only(s), __assign$3({ ref: y }, S)) : x = jsx("span", __assign$3({ ref: y }, S, { children: s }))), x || null;
}
const Wrapper = React.memo(FloaterWrapper);
var __rest$2 = function(r, a) {
  var s = {};
  for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && a.indexOf(c) < 0 && (s[c] = r[c]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, c = Object.getOwnPropertySymbols(r); u < c.length; u++)
      a.indexOf(c[u]) < 0 && Object.prototype.propertyIsEnumerable.call(r, c[u]) && (s[c[u]] = r[c[u]]);
  return s;
}, defaultOptions$1 = {
  zIndex: 100
};
function getStyles(r) {
  var a = r || {}, s = a.options, c = s === void 0 ? {} : s, u = __rest$2(a, ["options"]);
  return deepmerge({
    arrow: {
      color: "#fff",
      display: "inline-flex",
      length: 16,
      position: "absolute",
      spread: 32
    },
    close: {
      backgroundColor: "transparent",
      border: 0,
      borderRadius: 0,
      color: "#555",
      fontSize: 0,
      height: 15,
      outline: "none",
      padding: 10,
      position: "absolute",
      right: 0,
      top: 0,
      width: 15,
      WebkitAppearance: "none"
    },
    container: {
      backgroundColor: "#fff",
      color: "#666",
      minHeight: 60,
      minWidth: 200,
      padding: 20,
      position: "relative",
      zIndex: 10
    },
    content: {
      fontSize: 15
    },
    footer: {
      borderTop: "1px solid #ccc",
      fontSize: 13,
      marginTop: 10,
      paddingTop: 5
    },
    floater: {
      display: "inline-block",
      filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))",
      maxWidth: 300,
      opacity: 0,
      position: "relative",
      transition: "opacity 0.3s",
      visibility: "hidden",
      zIndex: c.zIndex
    },
    floaterCentered: {
      left: "50%",
      position: "fixed",
      top: "50%",
      transform: "translate(-50%, -50%)"
    },
    floaterClosing: {
      opacity: 0,
      visibility: "visible"
    },
    floaterOpening: {
      opacity: 1,
      visibility: "visible"
    },
    floaterWithComponent: {
      maxWidth: "100%"
    },
    title: {
      borderBottom: "1px solid #555",
      color: "#555",
      fontSize: 18,
      marginBottom: 5,
      paddingBottom: 6,
      paddingRight: 18
    },
    wrapper: {
      cursor: "help",
      zIndex: c.zIndex
    },
    wrapperPosition: {
      left: -1e3,
      position: "absolute",
      top: -1e3,
      visibility: "hidden"
    },
    options: deepmerge(defaultOptions$1, c)
  }, u);
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(r) {
    for (var a, s = 1, c = arguments.length; s < c; s++) {
      a = arguments[s];
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }
    return r;
  }, __assign$2.apply(this, arguments);
}, __rest$1 = function(r, a) {
  var s = {};
  for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && a.indexOf(c) < 0 && (s[c] = r[c]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, c = Object.getOwnPropertySymbols(r); u < c.length; u++)
      a.indexOf(c[u]) < 0 && Object.prototype.propertyIsEnumerable.call(r, c[u]) && (s[c[u]] = r[c[u]]);
  return s;
}, __read = function(r, a) {
  var s = typeof Symbol == "function" && r[Symbol.iterator];
  if (!s) return r;
  var c = s.call(r), u, d = [], h;
  try {
    for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) d.push(u.value);
  } catch (p) {
    h = { error: p };
  } finally {
    try {
      u && !u.done && (s = c.return) && s.call(c);
    } finally {
      if (h) throw h.error;
    }
  }
  return d;
}, __spreadArray$1 = function(r, a, s) {
  if (s || arguments.length === 2) for (var c = 0, u = a.length, d; c < u; c++)
    (d || !(c in a)) && (d || (d = Array.prototype.slice.call(a, 0, c)), d[c] = a[c]);
  return r.concat(d || Array.prototype.slice.call(a));
};
function ReactFloater(r) {
  var a = enhanceProps(r), s = a.autoOpen, c = a.callback, u = a.children, d = a.component, h = a.content, p = a.debug, m = a.disableFlip, g = a.disableHoverToClick, v = a.event, y = a.eventDelay, x = a.footer, w = a.getPopper, S = a.hideArrow, M = a.id, P = a.modifiers, L = a.offset, I = a.open, T = a.placement, E = T === void 0 ? "bottom" : T, R = a.portalElement, A = a.showCloseButton, k = a.style, V = a.styles, B = a.target, q = a.title, z = a.wrapperOptions, Z = __read(useSetState({
    currentPlacement: E,
    positionWrapper: !!(z != null && z.position) && !!B,
    status: STATUS.INIT,
    statusWrapper: STATUS.INIT
  }), 2), G = Z[0], K = Z[1], U = React.useRef(null), F = React.useRef(null), N = React.useRef(), D = React.useRef(null), j = React.useRef(randomId()), H = React.useRef(!1), W = React.useRef(), re = React.useRef(G), ae = React.useRef(), ee = React.useRef(null), X = React.useRef({}), J = G.currentPlacement, ie = G.positionWrapper, oe = G.status, fe = G.statusWrapper, ve = useTreeChanges(G).changed, ue = useTreeChanges(r).changed, pe = React.useCallback(function(ke, De) {
    H.current && (K(ke), re.current = __assign$2(__assign$2({}, G), ke), De && De());
  }, [K, G]), we = React.useCallback(function(ke) {
    var De = re.current.status === STATUS.OPEN ? STATUS.CLOSING : STATUS.RENDER;
    is.undefined(ke) || (De = ke), pe({
      status: De,
      statusWrapper: De === STATUS.CLOSING ? STATUS.RENDER : STATUS.IDLE
    });
  }, [pe]), ye = React.useRef(function() {
    return canUseDOM ? B ? is.domElement(B) ? B : document.querySelector(B) : F.current || ee.current : null;
  }), Ie = React.useMemo(function() {
    return canUseDOM && (p || !!window.ReactFloaterDebug);
  }, [p]), Ee = React.useMemo(function() {
    return v === "hover" && isMobile() && !g ? "click" : v;
  }, [g, v]), ne = React.useMemo(function() {
    var ke, De = getStyles(V), Fe = ye.current();
    if (ie) {
      var Xe = void 0;
      oe !== STATUS.IDLE ? Xe = De.wrapperPosition : fe === STATUS.RENDER && (Xe = (ke = ae.current) === null || ke === void 0 ? void 0 : ke.state.styles), De.wrapper = __assign$2(__assign$2({}, De.wrapper), Xe);
    }
    if (Fe) {
      var ze = window.getComputedStyle(Fe);
      X.current ? De.wrapper = __assign$2(__assign$2({}, De.wrapper), X.current) : ["relative", "static"].includes(ze.position) || (X.current = {}, ie || (POSITIONING_PROPS.forEach(function(Ge) {
        X.current[Ge] = ze[Ge];
      }), De.wrapper = __assign$2(__assign$2({}, De.wrapper), X.current)));
    }
    return De;
  }, [ie, oe, fe, V]), se = React.useRef(function() {
    W.current && (W.current.destroy(), W.current = void 0), ae.current && (ae.current.destroy(), ae.current = void 0);
  }), de = React.useRef(function() {
    var ke = re.current.status === STATUS.RENDER ? STATUS.OPENING : STATUS.IDLE, De = ye.current();
    if (E === "center")
      setTimeout(function() {
        pe({ status: ke });
      }, 100);
    else if (De)
      if (D.current) {
        var Fe = getModifiers(P), Xe = Fe.arrow, ze = Fe.flip, Ge = Fe.offset, Tt = __rest$1(Fe, ["arrow", "flip", "offset"]);
        W.current = createPopper(De, D.current, {
          placement: E,
          strategy: isFixed(F.current) ? "fixed" : "absolute",
          modifiers: __spreadArray$1([
            mergeModifier({
              name: "arrow",
              enabled: !S,
              options: {
                element: U.current,
                padding: 8
              }
            }, Xe),
            mergeModifier({
              name: "flip",
              enabled: !m,
              options: {
                altAxis: !1,
                fallbackPlacements: getFallbackPlacements(E || "bottom")
              }
            }, ze),
            mergeModifier({
              name: "offset",
              enabled: !0,
              options: {
                offset: [0, L]
              }
            }, Ge),
            {
              name: "updatePlacement",
              enabled: !0,
              phase: "afterWrite",
              fn: function(ht) {
                var Ye = ht.instance, et = ht.state;
                et.placement !== re.current.currentPlacement && (W.current = Ye, pe({ currentPlacement: et.placement }));
              }
            },
            {
              name: "applyArrowStyle",
              enabled: !0,
              phase: "write",
              fn: function(ht) {
                var Ye = ht.state, et = Ye.elements.arrow, nt = Ye.placement;
                et && (nt.startsWith("top") ? (et.style.bottom = "0px", et.style.right = "") : nt.startsWith("bottom") ? (et.style.top = "0px", et.style.right = "") : nt.startsWith("left") ? (et.style.right = "0px", et.style.bottom = "") : nt.startsWith("right") && (et.style.left = "0px", et.style.bottom = ""));
              }
            }
          ], __read(Object.values(Tt)), !1),
          onFirstUpdate: function(ht) {
            pe({
              currentPlacement: ht.placement,
              status: ke
            }), E !== ht.placement && setTimeout(function() {
              var Ye;
              (Ye = W.current) === null || Ye === void 0 || Ye.forceUpdate();
            });
          }
        }), w && W.current && w(W.current, "floater");
      } else
        pe({
          status: STATUS.IDLE
        });
    if (De && !ae.current && re.current.positionWrapper && ee.current && E !== "center") {
      var _t = z != null && z.offset ? z.offset : 0;
      ae.current = createPopper(De, ee.current, {
        placement: (z == null ? void 0 : z.placement) || E,
        modifiers: [
          {
            name: "arrow",
            enabled: !1
          },
          {
            name: "offset",
            options: {
              offset: [0, _t]
            }
          },
          {
            name: "flip",
            enabled: !1
          }
        ],
        onFirstUpdate: function(ht) {
          pe({ statusWrapper: STATUS.RENDER }), E !== ht.placement && setTimeout(function() {
            var Ye;
            (Ye = ae.current) === null || Ye === void 0 || Ye.forceUpdate();
          });
        }
      }), w && w(ae.current, "wrapper");
    }
  }), Ce = React.useRef(function() {
    W.current && W.current.forceUpdate(), ae.current && ae.current.forceUpdate();
  }), me = React.useRef(function() {
    ae.current && ae.current.forceUpdate(), pe({
      status: re.current.status === STATUS.OPENING ? STATUS.OPEN : STATUS.IDLE
    }, function() {
      c && c(re.current.status === STATUS.OPEN ? "open" : "close", enhanceProps(r));
    });
  }), xe = React.useCallback(function() {
    is.boolean(I) || (Ee === "click" || Ee === "hover" && ie) && (log({
      title: "click",
      data: [{ event: v, status: oe === STATUS.OPEN ? "closing" : "opening" }],
      debug: Ie
    }), we(oe === "idle" ? STATUS.RENDER : void 0));
  }, [Ie, Ee, v, I, ie, oe, we]), Se = React.useCallback(function() {
    is.boolean(I) || isMobile() || Ee !== "hover" || (log({
      title: "mouseEnter",
      data: [{ key: "originalEvent", value: v }],
      debug: Ie
    }), oe === STATUS.IDLE && (clearTimeout(N.current), N.current = void 0, we(STATUS.RENDER)));
  }, [Ie, Ee, v, I, oe, we]), Re = React.useCallback(function() {
    if (!(is.boolean(I) || isMobile()) && Ee === "hover") {
      log({
        title: "mouseLeave",
        data: [{ key: "originalEvent", value: v }],
        debug: Ie
      });
      var ke = [STATUS.OPENING, STATUS.OPEN].includes(oe);
      y ? ie || ke && (clearTimeout(N.current), N.current = window.setTimeout(function() {
        we(), N.current = void 0;
      }, y * 1e3)) : we(oe === STATUS.CLOSING ? STATUS.IDLE : STATUS.CLOSING);
    }
  }, [Ie, Ee, v, y, I, ie, oe, we]);
  useSingleton(function() {
    canUseDOM && window.addEventListener("load", Ce.current);
  }), useMount(function() {
    H.current = !0, log({
      title: "init",
      data: {
        hasChildren: !!u,
        hasTarget: !!B,
        isControlled: is.boolean(I),
        positionWrapper: ie,
        target: ye.current(),
        floater: D.current
      },
      debug: Ie
    }), de.current();
  }), useUnmount(function() {
    H.current = !1, se.current(), window.removeEventListener("load", Ce.current);
  }), useUpdateEffect(function() {
    if (canUseDOM) {
      if (ue("open")) {
        var ke = void 0;
        is.boolean(I) && (ke = I ? STATUS.RENDER : STATUS.CLOSING), we(ke);
      }
      (ue("wrapperOptions.position") || ue("target")) && pe({
        positionWrapper: !!(z != null && z.position) && !!B
      }), (ve("status", STATUS.IDLE) && I || ve("status", STATUS.IDLE, STATUS.INIT) && s) && we(STATUS.RENDER), ve("status", STATUS.RENDER) && (W.current && W.current.destroy(), de.current()), D.current && ve("status", [STATUS.RENDER, STATUS.CLOSING]) && once$1(D.current, "transitionend", me.current), ve("status", STATUS.IDLE, STATUS.CLOSING) && W.current && (W.current.destroy(), W.current = void 0, ae.current && ae.current.forceUpdate());
    }
  });
  var Pe = jsx(Wrapper, __assign$2({ childRef: F, id: M || j.current, isControlled: is.boolean(I), onClick: xe, onMouseEnter: Se, onMouseLeave: Re, status: oe, style: k, styles: ne.wrapper, wrapperRef: ee }, { children: u }));
  return jsxs(Fragment, { children: [jsxs(ReactFloaterPortal, __assign$2({ hasChildren: !!u, placement: J, portalElement: R, target: B, zIndex: ne.options.zIndex }, { children: [jsx(Floater$1, { arrowRef: U, component: d, content: h, floaterRef: D, footer: x, hideArrow: S || J === "center", id: M || j.current, onClick: xe, placement: J, positionWrapper: ie, showCloseButton: A, status: oe, styles: ne, title: q }), ie && Pe] })), !ie && Pe] });
}
ReactFloater.defaultProps = {
  autoOpen: !1,
  debug: !1,
  disableFlip: !1,
  disableHoverToClick: !1,
  event: "click",
  eventDelay: 0.4,
  hideArrow: !1,
  offset: 15,
  placement: "bottom",
  showCloseButton: !1
};
const Beacon = forwardRef$1((r, a) => {
  const s = useCssAnimation("breathing"), c = useMultiStyleConfig("Beacon", {});
  return /* @__PURE__ */ jsx(Box, { "data-component": "Beacon", "data-testid": "beacon", ref: a, ...r, __css: c.beaconWrapper, children: /* @__PURE__ */ jsx(Box, { __css: c.beacon, animation: s, children: /* @__PURE__ */ jsx(Box, { __css: c.beaconDot }) }) });
});
Beacon.displayName = "Beacon";
const TourPopover = forwardRef$1(
  ({
    onNextClick: r,
    onPrevClick: a,
    onOutsideClick: s,
    onTriggerClick: c,
    onCloseClick: u,
    nextButtonLabel: d = "Next",
    prevButtonLabel: h,
    placement: p = "bottom-end",
    triggerProps: m,
    shouldTrapFocus: g,
    ...v
  }, y) => {
    const x = (S, M) => {
      M === "outside" ? s == null || s() : M === "close" ? u == null || u() : M === "children" && (c == null || c());
    }, w = verticalPlacementEdges.includes(p) ? p.includes("start") ? p.replace("start", "end") : p.replace("end", "start") : p;
    return /* @__PURE__ */ jsx(
      BasePopover,
      {
        "data-component": "TourPopover",
        ...v,
        onOpenChange: x,
        actionRenderer: ({ onClose: S, ...M }) => /* @__PURE__ */ jsx(
          Button,
          {
            ...M,
            variant: "secondary-inverse",
            size: "small",
            onClick: () => {
              S(), r == null || r();
            },
            label: d
          }
        ),
        backButtonRenderer: (S) => h && /* @__PURE__ */ jsx(Button, { ...S, variant: "secondary-inverse", size: "small", onClick: a, label: h }),
        triggerEvent: "click",
        closeButtonSize: "small",
        placement: w,
        ref: y,
        enableAnimationFrame: !0,
        triggerProps: m,
        shouldTrapFocus: g
      }
    );
  }
);
TourPopover.displayName = "TourPopover";
function isElementVisible(r) {
  if (!r) return !1;
  let a = r;
  for (; a && a !== document.body; ) {
    if (a instanceof HTMLElement) {
      const { display: s, visibility: c } = getComputedStyle(a);
      if (s === "none" || c === "hidden")
        return !1;
    }
    a = a.parentNode;
  }
  return !0;
}
function getElement(r) {
  return typeof r == "string" ? document.querySelector(r) : r;
}
const Tourtip = ({
  run: r = !0,
  steps: a,
  onTourStart: s,
  onNextClick: c,
  onPrevClick: u,
  onTourComplete: d,
  onTargetNotFound: h,
  onStepChange: p,
  onTourDismiss: m,
  onTourMinimize: g,
  onBeaconClick: v,
  defaultLabels: y,
  stepIndex: x,
  defaultStepIndex: w = x ?? 0,
  defaultIsMinimize: S = !1,
  enableMinimize: M = !1,
  disableScrolling: P = !1,
  "data-testid": L = "tourtip",
  shouldTrapFocus: I = !0
}) => {
  const [T, E] = useState$1(x ?? w), [R, A] = useState$1(r), [k, V] = useState$1(S && !R), B = x !== void 0, q = useMemo$1(
    () => a[B ? x : T],
    [a, B, x, T]
  ), { target: z, placement: Z = "bottom-end", ...G } = q, K = T === a.length - 1, [U, F] = useState$1("ready");
  useEffect$1(() => {
    r !== void 0 && A(r);
  }, [r]), useEffect$1(() => {
    M && (A(!S), V(S));
  }, [M, S]), useEffect$1(() => {
    B && E(x);
  }, [B, x]);
  const N = useCallback$1(() => {
    M && k && (A(!0), V(!1), v == null || v({ currentIndex: T }));
  }, [T, M, k, v]), D = useCallback$1(() => {
    A(!1), !B && E(w);
  }, [w, B]), j = useCallback$1(() => {
    M && (A(!1), V(!0), g == null || g({ currentIndex: T }));
  }, [M, g, T]), H = useCallback$1(() => {
    if (F("next"), K)
      D(), d == null || d({ currentIndex: T });
    else if (T >= 0) {
      const X = T + 1;
      if (c == null || c({ currentIndex: T, newIndex: B ? void 0 : X }), B) return;
      E(X);
    }
  }, [T, K, B, c, d, D]), W = useCallback$1(() => {
    const X = T - 1;
    F("prev"), u == null || u({ currentIndex: T, newIndex: B ? void 0 : X }), !B && E(X);
  }, [T, B, u]), re = useCallback$1(() => {
    D(), m == null || m({ currentIndex: T });
  }, [T, m, D]);
  useEffect$1(() => {
    if (!R) return;
    const X = getElement(z), J = !!X;
    if (J && isElementVisible(X))
      U === "ready" && R && T === w && (s == null || s({ currentIndex: T }), F("start")), P || X.scrollIntoView({ behavior: "smooth" });
    else {
      h == null || h({ currentIndex: T, action: U }), console.warn(J ? "Target not visible" : "Target not mounted", q);
      const ie = U === "prev" ? T - 1 : T + 1;
      if (T >= 0 && U !== "prev")
        if (K)
          D(), d == null || d({ currentIndex: T });
        else {
          if (B) return;
          p == null || p({ currentIndex: T, newIndex: B ? void 0 : ie }), E(ie);
        }
      else {
        if (B) return;
        p == null || p({ currentIndex: T, newIndex: B ? void 0 : ie }), E(ie);
      }
    }
  }, [
    B,
    R,
    z,
    T,
    q,
    K,
    U,
    w,
    P,
    p,
    d,
    h,
    s,
    D
  ]);
  const ae = (y == null ? void 0 : y.progressLabel) ?? (y != null && y.progressSeparator ? `${T + 1} ${y.progressSeparator} ${a.length}` : void 0), ee = useTestId(L);
  return /* @__PURE__ */ createElement$1(
    Box,
    {
      "data-component": "Tourtip",
      ...ee(),
      key: `Tourtip-${T}`,
      "data-state": R ? "open" : "closed"
    },
    /* @__PURE__ */ jsx(
      ReactFloater,
      {
        open: k || R,
        component: /* @__PURE__ */ jsx(
          TourPopover,
          {
            ...G,
            ...ee(`popover-${T}`),
            placement: Z,
            isOpen: R,
            nextButtonLabel: (q == null ? void 0 : q.nextButtonLabel) || y.nextButtonLabel,
            prevButtonLabel: T > 0 || w > 0 ? (q == null ? void 0 : q.prevButtonLabel) || y.prevButtonLabel : void 0,
            footerText: ae,
            onNextClick: H,
            onPrevClick: W,
            onCloseClick: re,
            onOutsideClick: j,
            triggerProps: M ? void 0 : { "aria-expanded": void 0 },
            shouldTrapFocus: I,
            children: /* @__PURE__ */ jsx(
              Beacon,
              {
                onClick: N,
                ...ee(`beacon-${T}`),
                ...M ? { cursor: "pointer", "aria-label": q == null ? void 0 : q.beaconAriaLabel, as: "button" } : { cursor: "default", "aria-expanded": void 0 }
              }
            )
          }
        ),
        target: z,
        offset: -24,
        placement: Z,
        styles: {
          floaterOpening: {
            filter: "none"
          }
        },
        hideArrow: !0
      }
    )
  );
};
Tourtip.displayName = "Tourtip";
const DEFAULT_TRACKER_VARIANT = "horizontal", DEFAULT_TRACKER_STATUS = "success", DEFAULT_TRACKER_WIDTH = "full", TrackerContext = createContext$1({
  stepsAmount: 0,
  variant: DEFAULT_TRACKER_VARIANT,
  width: DEFAULT_TRACKER_WIDTH,
  status: DEFAULT_TRACKER_STATUS
}), useTrackerContext = () => useContext$1(TrackerContext), Tracker$1 = forwardRef$1(
  ({
    variant: r = DEFAULT_TRACKER_VARIANT,
    status: a = DEFAULT_TRACKER_STATUS,
    width: s = DEFAULT_TRACKER_WIDTH,
    children: c,
    ...u
  }, d) => {
    const h = useStyleConfig("Tracker", { variant: r }), p = Children.count(c), m = Children.map(c, (g, v) => {
      const y = p === 1 && "true" || void 0, x = !y && v === 0 && "true" || void 0, w = !y && v === p - 1 && "true" || void 0;
      return isValidElement(g) ? cloneElement(g, {
        "data-is-first": x,
        "data-is-last": w,
        "data-is-single": y
      }) : null;
    });
    return /* @__PURE__ */ jsx(TrackerContext.Provider, { value: { variant: r, width: s, stepsAmount: p, status: a }, children: /* @__PURE__ */ jsx(Box, { as: "ol", "data-component": "Tracker", "data-testid": "tracker", ref: d, __css: h, ...u, children: m }) });
  }
);
Tracker$1.displayName = "Tracker";
const TrackerStepContext = createContext$1({
  variant: DEFAULT_TRACKER_VARIANT,
  status: DEFAULT_TRACKER_STATUS
}), useTrackerStepContext = () => useContext$1(TrackerStepContext), TrackerStepDescription = ({ label: r, ...a }) => {
  const { isActive: s, isCompleted: c } = useTrackerStepContext();
  return typeof r == "string" ? /* @__PURE__ */ jsx(Typography.Description, { ...a, label: r, isReadOnly: !s && !c }) : r;
};
TrackerStepDescription.displayName = "Tracker.StepDescription";
const TrackerStepTitle = (r) => {
  const { isActive: a, isCompleted: s } = useTrackerStepContext();
  return /* @__PURE__ */ jsx(Typography.MainLabel, { size: "small", variant: "bold", isReadOnly: !a && !s, ...r });
};
TrackerStepTitle.displayName = "Tracker.StepTitle";
const TrackerStepIndicator = ({ children: r, ...a }) => {
  const { variant: s, isCompleted: c, status: u } = useTrackerStepContext(), d = useMultiStyleConfig("TrackerStep", { variant: s, status: u }), h = /* @__PURE__ */ jsx(Icon, { type: "checked-mini", color: "inherit", size: "small", "aria-hidden": !0 });
  return /* @__PURE__ */ jsx(Box, { __css: d.stepIndicatorContainer, children: /* @__PURE__ */ jsxs(Box, { __css: d.stepIndicator, ...a, children: [
    r,
    !r && c && h
  ] }) });
};
TrackerStepIndicator.displayName = "TrackerStepIndicator";
const TrackerStep = forwardRef$1(
  ({
    isActive: r = !1,
    isCompleted: a = !1,
    "data-is-first": s,
    "data-is-last": c,
    "data-is-single": u,
    indicator: d,
    children: h,
    ...p
  }, m) => {
    const { variant: g, width: v, stepsAmount: y, status: x } = useTrackerContext(), w = {
      "data-is-first": s,
      "data-is-last": c,
      "data-is-single": u,
      ...a && { "data-is-completed": "true" },
      ...r && { "data-is-active": "true" }
    }, S = useMultiStyleConfig("TrackerStep", {
      width: v,
      variant: g,
      stepMaxWidth: g === "horizontal" ? `${100 / y}%` : "100%",
      status: x
    });
    return /* @__PURE__ */ jsx(TrackerStepContext.Provider, { value: { variant: g, isActive: r, isCompleted: a, status: x }, children: /* @__PURE__ */ jsxs(
      Box,
      {
        as: "li",
        "data-component": "TrackerStep",
        "data-testid": "tracker-step",
        __css: S.stepContainer,
        "aria-current": r ? "step" : void 0,
        ...w,
        ...p,
        ref: m,
        children: [
          !u && /* @__PURE__ */ jsx(Box, { __css: S.connector, ...w }),
          /* @__PURE__ */ jsxs(Box, { __css: S.grid, children: [
            /* @__PURE__ */ jsx(TrackerStepIndicator, { ...w, children: d }),
            h && /* @__PURE__ */ jsx(Box, { __css: S.content, children: h })
          ] })
        ]
      }
    ) });
  }
);
TrackerStep.displayName = "Tracker.Step";
const components$6 = { Step: TrackerStep, StepDescription: TrackerStepDescription, StepTitle: TrackerStepTitle }, Tracker = Object.assign(Tracker$1, components$6), BaseVirtualCard$1 = forwardRef$1(
  ({ variant: r = "white", backgroundImageSrc: a, children: s, "data-testid": c = "base-virtual-card", ...u }, d) => {
    const h = useMultiStyleConfig("BaseVirtualCard", { variant: r, backgroundImageSrc: a, ...u }), p = useTestId(c);
    return /* @__PURE__ */ jsx(Box, { ref: d, "data-component": "BaseVirtualCard", ...p(), ...u, __css: h.container, children: /* @__PURE__ */ jsxs(Fragment, { children: [
      a && /* @__PURE__ */ jsx(Box, { __css: h.image }),
      /* @__PURE__ */ jsx(Box, { __css: h.content, children: s })
    ] }) });
  }
);
BaseVirtualCard$1.displayName = "BaseVirtualCard";
const BaseVirtualCardDetails = forwardRef$1(
  ({
    label: r,
    mainLabel: a,
    onCopy: s,
    variant: c = "default",
    enableCopy: u = !0,
    dataDogPrivacy: d,
    "data-testid": h = "base-virtual-card-details",
    ...p
  }, m) => {
    const g = useMultiStyleConfig("BaseVirtualCardDetails", { variant: c, enableCopy: u }), [v, y] = useState$1(!1), [x, w] = useBoolean(!1), S = useRef$1(null), M = useTestId(h), P = useCallback$1(
      (L) => {
        u && (navigator.clipboard.writeText(a), s == null || s(L), y(!0), S.current && clearTimeout(S.current), S.current = window.setTimeout(() => {
          y(!1);
        }, 2e3));
      },
      [u, a, s]
    );
    return useEffect$1(
      () => () => {
        S.current && clearTimeout(S.current);
      },
      []
    ), /* @__PURE__ */ jsx(Box, { ref: m, "data-component": "BaseVirtualCardDetails", ...M(), ...p, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxs", children: [
      /* @__PURE__ */ jsx(Box, { __css: g.label, children: /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: r }) }),
      /* @__PURE__ */ jsxs(
        Box,
        {
          __css: g.mainLabel,
          onMouseOver: w.on,
          onMouseOut: w.off,
          onClick: P,
          children: [
            /* @__PURE__ */ jsx(
              Text,
              {
                ...M("main-label"),
                shouldSupportEllipsis: !0,
                "data-dd-privacy": d,
                textStyle: "inline",
                color: "inherit",
                children: a
              }
            ),
            u && /* @__PURE__ */ jsx(Box, { __css: g.copyButton, "data-hover": x || void 0, children: /* @__PURE__ */ jsx(Tooltip, { content: v ? "Copied" : "Copy", placement: "top", children: /* @__PURE__ */ jsx(
              IconButton,
              {
                ...M("copy-button"),
                onClick: P,
                icon: "duplicate-flip",
                "aria-label": "copy",
                size: "small",
                variant: c === "inverse" ? "nakedInverse" : "naked"
              }
            ) }) })
          ]
        }
      )
    ] }) });
  }
);
BaseVirtualCardDetails.displayName = "BaseVirtualCardDetails";
const CardNumber = ({
  cardNumber: r,
  label: a,
  showDetails: s = !0,
  onCopy: c,
  "data-testid": u = "card-number",
  ...d
}) => {
  const h = useMemo$1(() => {
    const m = r.toString().replace(/\s/g, ""), g = Math.min(m.length, 4), v = "•".repeat(m.length - g), y = m.slice(-g);
    return (s ? m : v + y).replace(/(.{4})/g, "$1 ");
  }, [r, s]), p = useTestId(u);
  return /* @__PURE__ */ jsx(
    BaseVirtualCardDetails,
    {
      "data-component": "BaseVirtualCard.CardNumber",
      mainLabel: h,
      label: "Card Number",
      onCopy: s ? c : void 0,
      enableCopy: s,
      dataDogPrivacy: "mask",
      ...p(),
      ...d
    }
  );
};
CardNumber.displayName = "BaseVirtualCard.CardNumber";
const CvvNumber = ({
  cvv: r,
  label: a,
  showDetails: s = !0,
  onCopy: c,
  "data-testid": u = "cvv-number",
  ...d
}) => {
  const h = useMemo$1(() => {
    const m = r.toString();
    return s ? m : m.replace(/\d/g, "•");
  }, [r, s]), p = useTestId(u);
  return /* @__PURE__ */ jsx(
    BaseVirtualCardDetails,
    {
      "data-component": "BaseVirtualCard.CvvNumber",
      mainLabel: h,
      label: "CVV",
      onCopy: s ? c : void 0,
      enableCopy: s,
      dataDogPrivacy: "mask",
      ...p(),
      ...d
    }
  );
};
CvvNumber.displayName = "BaseVirtualCard.CvvNumber";
const ExpirationDate = ({
  month: r,
  year: a,
  label: s,
  showDetails: c = !0,
  onCopy: u,
  "data-testid": d = "expiration-date",
  ...h
}) => {
  const p = useMemo$1(() => {
    const g = `${r}/${a}`;
    return c ? g : g.replace(/\d/g, "•");
  }, [r, a, c]), m = useTestId(d);
  return /* @__PURE__ */ jsx(
    BaseVirtualCardDetails,
    {
      "data-component": "BaseVirtualCard.ExpirationDate",
      mainLabel: p,
      label: "Expiry date",
      onCopy: c ? u : void 0,
      enableCopy: c,
      ...m(),
      ...h
    }
  );
};
ExpirationDate.displayName = "BaseVirtualCard.ExpirationDate";
const components$5 = { CardNumber, ExpirationDate, CvvNumber }, BaseVirtualCard = Object.assign(BaseVirtualCard$1, components$5), VirtualCard = forwardRef$1(
  ({
    variant: r,
    amount: a,
    showDetails: s,
    brandSymbolProps: c,
    brandType: u,
    cardNumberProps: d,
    cvvNumberProps: h,
    expirationDateProps: p,
    "data-testid": m = "virtual-card",
    ...g
  }, v) => {
    const y = useMultiStyleConfig("VirtualCard", {}), x = r !== "white" ? "inverse" : "default", w = r !== "white" ? "inverse" : "neutral", S = useBreakpointValue({ xs: "xxs", s: "s" }), M = useTestId(m);
    return /* @__PURE__ */ jsx(BaseVirtualCard, { "data-component": "VirtualCard", ref: v, ...M(), ...g, variant: r, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", height: "full", justifyContent: "space-evenly", spacing: S, children: [
      /* @__PURE__ */ jsxs(Group, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ jsx(Currency, { value: a, variant: x }),
        /* @__PURE__ */ jsx(BrandSymbol, { ...c, size: "extra-large" })
      ] }),
      /* @__PURE__ */ jsx(
        BaseVirtualCard.CardNumber,
        {
          ...d,
          showDetails: s,
          variant: x,
          ...M("card-number")
        }
      ),
      /* @__PURE__ */ jsxs(Group, { justifyContent: "space-between", alignItems: "flex-end", children: [
        /* @__PURE__ */ jsxs(Group, { spacing: "m", children: [
          /* @__PURE__ */ jsx(
            BaseVirtualCard.ExpirationDate,
            {
              ...p,
              showDetails: s,
              variant: x,
              ...M("expiration-date")
            }
          ),
          /* @__PURE__ */ jsx(
            BaseVirtualCard.CvvNumber,
            {
              ...h,
              showDetails: s,
              variant: x,
              ...M("cvv-number")
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Box, { __css: y.brand, children: /* @__PURE__ */ jsx(Brand, { type: u, variant: w }) })
      ] })
    ] }) });
  }
);
VirtualCard.displayName = "VirtualCard";
const ConditionalWrapper = ({ condition: r, wrapper: a, children: s }) => /* @__PURE__ */ jsx(Fragment, { children: r ? a(s) : s });
ConditionalWrapper.displayName = "ConditionalWrapper";
const _BaseBadge = forwardRef$1(
  ({ isDisabled: r, isReadOnly: a, status: s, label: c, type: u = "primary", ...d }, h) => {
    const p = useStyleConfig("_BaseBadge", { status: s, type: u });
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: "span",
        __css: p,
        "data-component": "_BaseBadge",
        "aria-disabled": r || void 0,
        "data-readonly": a || null,
        ...d,
        ref: h,
        children: /* @__PURE__ */ jsx(
          ConditionalWrapper,
          {
            condition: u === "status",
            wrapper: (g) => /* @__PURE__ */ jsx(Group, { spacing: "xxs", alignItems: "center", children: g }),
            children: /* @__PURE__ */ jsxs(Fragment, { children: [
              u === "status" && /* @__PURE__ */ jsx(StatusIndicator, { status: {
                brand: "brand",
                neutral: "neutral",
                critical: "critical",
                warning: "warning",
                success: "success",
                informative: "informative"
              }[s], isDisabled: r, isReadOnly: a }),
              c
            ] })
          }
        )
      }
    );
  }
);
_BaseBadge.displayName = "_BaseBadge";
const CalendarContext = createContext$1({ weeks: [] }), useCalendarContext = () => useContext$1(CalendarContext), CalendarLegend = forwardRef$1(
  ({ label: r, date: a, variant: s = "primary", legendWidth: c, legendMaxWidth: u = "100%", ...d }, h) => {
    const p = useMultiStyleConfig("CalendarLegend", { legendWidth: c, legendMaxWidth: u }), m = useRef$1(null), g = useRef$1(null), { hasOverflowX: v } = useHasOverflow(m), { hasOverflowX: y } = useHasOverflow(g), x = v || y;
    return /* @__PURE__ */ jsxs(Box, { __css: p.container, "data-component": "CalendarLegend", ...d, ref: h, children: [
      /* @__PURE__ */ jsx(Box, { "data-variant": s, __css: p.indicator }),
      /* @__PURE__ */ jsx(Tooltip, { content: a ? `${r} - ${a}` : r, isEnabled: x, children: /* @__PURE__ */ jsxs(Box, { __css: p.textContainer, children: [
        /* @__PURE__ */ jsx(Box, { __css: p.label, as: "span", ref: m, children: r }),
        a ? /* @__PURE__ */ jsx(Box, { __css: p.date, as: "span", ref: g, children: a }) : null
      ] }) })
    ] });
  }
);
CalendarLegend.displayName = "CalendarLegend";
const createActiveMonth = (r) => {
  const a = getMonth(r), s = getYear(r), c = new Date(s, a, 15, 12);
  return { month: a, year: s, date: c };
}, getDaysDictionary = (r) => r.reduce(
  (a, s) => (s && (a[s.date.getTime()] = s), a),
  {}
), getPartialWeeks = ({
  activeMonth: r,
  secondarySelectedDate: a,
  selectedDate: s,
  isBeforeMinDate: c,
  isAfterMaxDate: u,
  isHoliday: d,
  isInWeekDays: h
}) => {
  const p = setDate(r.date, 1), m = getWeeksInMonth(p), g = [], v = getWeek(p);
  for (let y = 0; y < m; y++) {
    g[y] || (g[y] = []);
    const x = g[y], w = setWeek(p, v + y);
    for (let S = 0; S < 7; S++) {
      const M = setDay(w, S);
      isSameMonth(p, M) ? x.push({
        isDisabled: c(M) || !h(M) || d(M) || u(M),
        isSecondarySelectedDate: !!a && isSameDay(a, M),
        isSelected: !!s && isSameDay(s, M),
        date: M
      }) : x.push(null);
    }
  }
  return g;
}, isDateCanBeFocused = ({ weeks: r, date: a }) => {
  var d;
  const s = getDaysInMonth(r);
  return !((d = getDaysDictionary(s)[a.getTime()]) == null ? void 0 : d.isDisabled);
}, getClosestDateInMonth = ({
  date: r,
  isBeforeFocusedDate: a,
  weeks: s
}) => {
  var d;
  const c = getDaysInMonth(s);
  return (d = (a ? c.slice().reverse() : c).find((h) => (a ? isBefore(h.date, r) : isAfter(h.date, r)) && !h.isDisabled)) == null ? void 0 : d.date;
}, getDaysInMonth = (r) => lodashExports.flatten(r).filter((a) => a !== null), findClosestDateToFocus = ({
  date: r,
  weeks: a,
  activeMonth: s,
  focusedDate: c,
  ...u
}) => {
  if (u.isBeforeMinDate(r) || u.isAfterMaxDate(r)) return;
  const d = c && isBefore(r, c), h = createActiveMonth(addMonths(s.date, d ? -1 : 1)), p = () => isDateCanBeFocused({ weeks: a, date: r }) ? r : getClosestDateInMonth({
    date: r,
    weeks: a,
    isBeforeFocusedDate: d
  }), m = () => getClosestDateInMonth({
    date: r,
    weeks: getPartialWeeks({
      ...u,
      activeMonth: h
    }),
    isBeforeFocusedDate: d
  });
  return isSameMonth(r, s.date) && (p() ?? m()) || findClosestDateToFocus({
    ...u,
    weeks: getPartialWeeks({
      ...u,
      activeMonth: h
    }),
    date: r,
    focusedDate: c,
    activeMonth: h
  });
}, getFocusableDate = (r, a = 0) => {
  const s = r.find((m) => m && (m == null ? void 0 : m.isSelected)), c = r.find((m) => m && (m == null ? void 0 : m.isSecondarySelectedDate)), u = s || c, d = r.find(
    (m) => m && (u ? isAfter(m == null ? void 0 : m.date, u.date) && !(m != null && m.isDisabled) : !(m != null && m.isDisabled))
  ), h = r.reverse().find(
    (m) => m && (u ? isBefore(m == null ? void 0 : m.date, u.date) && !(m != null && m.isDisabled) : !(m != null && m.isDisabled))
  ), p = a < 0 ? h : d;
  return u && !u.isDisabled ? u == null ? void 0 : u.date : p == null ? void 0 : p.date;
}, getTargetDayDateByArrowKeyType = (r, a, s) => {
  switch (r) {
    case "ArrowUp":
      return addDays(a, -7);
    case "ArrowDown":
      return addDays(a, 7);
    case "ArrowLeft":
      return addDays(a, -1);
    case "ArrowRight":
      return addDays(a, 1);
    case "Home": {
      const c = (s == null ? void 0 : s[0]) ?? 0;
      return setHours(startOfWeek(a, { weekStartsOn: c }), 12);
    }
    case "End": {
      const u = ((s == null ? void 0 : s[s.length - 1]) ?? 6) - a.getDay();
      return addDays(a, u);
    }
    case "PageUp":
      return addMonths(a, 1);
    case "PageDown":
      return addMonths(a, -1);
    case "PageUp + Shift":
      return addYears(a, 1);
    case "PageDown + Shift":
      return addYears(a, -1);
    default:
      return;
  }
}, getMonthNumber = (r) => {
  const a = r.getMonth() + 1;
  return {
    monthNumber: a,
    isFirstMonth: a === 1,
    isLastMonth: a === 12,
    isOnFirstRow: a <= 3,
    isOnLastRow: a >= 10
  };
}, getTargetMonthByArrowKeyType = (r, a) => {
  const { isFirstMonth: s, isLastMonth: c, isOnFirstRow: u, isOnLastRow: d } = getMonthNumber(a);
  switch (r) {
    case "ArrowUp":
      return u ? void 0 : addMonths(a, -3);
    case "ArrowDown":
      return d ? void 0 : addMonths(a, 3);
    case "ArrowLeft":
      return s ? void 0 : addMonths(a, -1);
    case "ArrowRight":
      return c ? void 0 : addMonths(a, 1);
    default:
      return;
  }
}, getNextAvailableDay = ({
  selectedDate: r,
  activeMonth: a,
  ...s
}) => {
  const c = getPartialWeeks({ selectedDate: r, activeMonth: a, ...s });
  return lodashExports.flatten(c).find((h) => h ? !(h != null && h.isDisabled) : void 0) ?? getNextAvailableDay({
    selectedDate: r,
    ...s,
    activeMonth: createActiveMonth(addMonths(a.date, 1))
  });
}, useDaysUtilities = ({
  excludeHolidays: r = !1,
  minDate: a,
  maxDate: s,
  weekDays: c
}) => {
  const { timeZone: u } = useIntl(), { createDate: d } = useDateUtils(), h = (y) => d(convertDateToStringRepresentation(y)), p = useCallback$1(
    (y) => !!a && isBefore(h(y), h(a)),
    [a]
    // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `wrap` function
  ), m = useCallback$1(
    (y) => !!s && isAfter(h(y), h(s)),
    [s]
    // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `wrap` function
  ), g = useCallback$1(
    (y) => r && isHoliday(y, u),
    [r]
    // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `timeZone` variable
  ), v = useCallback$1((y) => !c || c.includes(getDay(y)), [c]);
  return {
    isBeforeMinDate: p,
    isAfterMaxDate: m,
    isHoliday: g,
    isInWeekDays: v
  };
}, useWeeks = ({
  activeMonth: r,
  excludeHolidays: a = !1,
  minDate: s,
  maxDate: c,
  weekDays: u,
  secondarySelectedDate: d,
  selectedDate: h,
  onSelect: p
}) => {
  const { formatDate: m } = useIntl(), { isBeforeMinDate: g, isAfterMaxDate: v, isHoliday: y, isInWeekDays: x } = useDaysUtilities({
    excludeHolidays: a,
    minDate: s,
    maxDate: c,
    weekDays: u
  });
  return useMemo$1(
    () => getPartialWeeks({
      activeMonth: r,
      secondarySelectedDate: d,
      selectedDate: h,
      isBeforeMinDate: g,
      isAfterMaxDate: v,
      isHoliday: y,
      isInWeekDays: x
    }).map(
      (w) => w.map(
        (S) => S && { ...S, label: m(S.date, { day: "numeric" }), selectDay: () => p(S.date) }
      )
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `formatDate` function
    [
      r,
      d,
      v,
      g,
      y,
      x,
      p,
      h
    ]
  );
}, useMonth = (r) => {
  const { formatDate: a } = useIntl(), { monthsToAdd: s, activeMonth: c } = r, u = s ? addMonths(c.date, s) : c.date, d = useWeeks({
    ...r,
    activeMonth: createActiveMonth(u),
    onSelect: (v) => {
      var y;
      r.onSelect(v), (y = r.setFocusableDate) == null || y.call(r, v);
    }
  }), h = useMemo$1(() => d.some((v) => v.some((y) => y && !y.isDisabled)), [d]), p = useMemo$1(() => getFocusableDate(d.flat(), s), [d, s]), m = () => {
    var v;
    h && r.onSelect(u), (v = r.setFocusableDate) == null || v.call(r, p);
  }, g = h ? {
    short: a(u, { month: "short" }),
    full: a(u, { month: "long" }),
    year: createActiveMonth(u).year
  } : void 0;
  return {
    month: d,
    hasMonth: h,
    monthLabels: g,
    goToMonth: m
  };
}, useActiveMonth = (r) => {
  const { createDate: a } = useDateUtils(), { isBeforeMinDate: s, isAfterMaxDate: c, isHoliday: u, isInWeekDays: d } = useDaysUtilities({
    excludeHolidays: r.excludeHolidays,
    minDate: r.minDate,
    maxDate: r.maxDate,
    weekDays: r.weekDays
  }), h = a(), [p, m] = useState$1(createActiveMonth(r.selectedDate ?? h)), [g, v] = useState$1(void 0), [y, x] = useState$1(void 0), { minDate: w, secondarySelectedDate: S, selectedDate: M } = r, P = useMemo$1(
    () => ({
      selectedDate: M,
      secondarySelectedDate: S,
      isBeforeMinDate: s,
      isAfterMaxDate: c,
      isHoliday: u,
      isInWeekDays: d
    }),
    [c, s, u, d, S, M]
  ), L = useCallback$1(() => {
    if (!w || M && M >= w) return;
    const R = getNextAvailableDay({
      ...P,
      activeMonth: createActiveMonth(w)
      // save iterations by setting the `minDate` instead of checking all months from `activeMonth`.
    });
    R && m(createActiveMonth(R.date));
  }, [w, M, P]);
  useEffect$1(() => {
    L();
  }, []);
  const { month: I } = useMonth({
    activeMonth: p,
    ...r,
    onSelect: (R) => {
      r.onSelect(R), m(createActiveMonth(R)), v(R);
    }
  }), T = useMemo$1(() => getFocusableDate(I.flat()), [I]), E = useCallback$1(
    (R) => {
      const A = findClosestDateToFocus({
        ...P,
        activeMonth: p,
        focusedDate: y,
        date: R,
        weeks: I
      });
      A && p && !isSameMonth(A, p.date) && (m(createActiveMonth(A)), v(A)), A && x(A);
    },
    [P, y, I, p]
  );
  return {
    today: h,
    weeks: I,
    activeMonth: p,
    defaultFocusableDay: T,
    setActiveMonth: m,
    focusableDate: g ?? T,
    setFocusableDate: v,
    focusedDate: y,
    setFocusedDate: x,
    getClosestDateToFocus: E
  };
}, isMonthDisabled = (r) => {
  const a = r.isBeforeMinDate(r.activeMonth.date), s = r.isAfterMaxDate(r.activeMonth.date);
  return a || s ? getPartialWeeks(r).every((d) => d.every((h) => h === null || (h == null ? void 0 : h.isDisabled))) : !1;
}, useYears = ({
  excludeHolidays: r,
  minDate: a,
  maxDate: s,
  weekDays: c,
  yearsRange: u = 100,
  ...d
}) => {
  const { formatDate: h } = useIntl(), p = createDate(), m = createActiveMonth(d.selectedDate ?? p), g = a ? m.year - createActiveMonth(a).year : u, v = s ? Math.abs(m.year - createActiveMonth(s).year) : u, { isBeforeMinDate: y, isAfterMaxDate: x, isHoliday: w, isInWeekDays: S } = useDaysUtilities({
    excludeHolidays: r,
    minDate: a,
    maxDate: s,
    weekDays: c
  }), M = useCallback$1(
    (T) => eachMonthOfInterval({
      start: createDate(`${T}-01-01`),
      // January 1st
      end: createDate(`${T}-12-31`)
      // December 31st
    }).map((R) => ({
      date: R,
      label: h(createActiveMonth(R).date, { month: "short" }),
      fullLabel: h(createActiveMonth(R).date, { month: "long" }),
      isDisabled: isMonthDisabled({
        activeMonth: createActiveMonth(R),
        ...d,
        isBeforeMinDate: y,
        isAfterMaxDate: x,
        isHoliday: w,
        isInWeekDays: S
      })
    })),
    [h, d, y, x, w, S]
  ), P = (T) => {
    const E = M(T);
    return {
      year: T,
      months: E,
      isDisabled: E.every((R) => R.isDisabled)
    };
  }, L = (T) => {
    const E = Array.from(
      { length: g },
      (A, k) => P(T - g + k)
    ), R = Array.from({ length: v }, (A, k) => P(T + 1 + k));
    return [...E, P(T), ...R];
  };
  return ((T) => L(T).reduce((R, A) => (R[Number(A.year)] = A, R), {}))(m.year);
}, useCalendar = (r) => {
  const {
    weeks: a,
    activeMonth: s,
    setActiveMonth: c,
    focusableDate: u,
    setFocusableDate: d,
    focusedDate: h,
    setFocusedDate: p,
    getClosestDateToFocus: m
  } = useActiveMonth(r), [g, v] = useState$1(!1), y = (T) => {
    c(createActiveMonth(T));
  }, {
    hasMonth: x,
    monthLabels: w,
    goToMonth: S
  } = useMonth({
    ...r,
    monthsToAdd: -1,
    activeMonth: s,
    onSelect: y,
    setFocusableDate: d
  }), {
    hasMonth: M,
    monthLabels: P,
    goToMonth: L
  } = useMonth({
    ...r,
    monthsToAdd: 1,
    activeMonth: s,
    onSelect: y,
    setFocusableDate: d
  });
  return {
    years: useYears(r),
    weeks: a,
    activeMonth: s,
    goToNextMonth: L,
    goToPreviousMonth: S,
    hasPreviousMonth: x,
    previousMonthLabels: w,
    hasNextMonth: M,
    nextMonthLabels: P,
    showYearSelection: g,
    setShowYearSelection: v,
    setSelectedYear: (T) => {
      y(T), d(void 0);
    },
    focusableDate: u,
    focusedDate: h,
    setFocusedDate: p,
    // get the available date to focus.
    getClosestDateToFocus: m
  };
}, useFocus = ({
  ref: r,
  isFocused: a,
  handleOnFocus: s,
  handleOnBlur: c
}) => {
  const u = useMemo$1(() => a && r.current !== document.activeElement, [r, a]);
  useEffect$1(() => {
    r.current && u && r.current.focus();
  }, [r, u]);
  const d = useCallback$1(
    (p) => {
      s && (p.preventDefault(), s == null || s());
    },
    [s]
  );
  return { onBlur: useCallback$1(
    (p) => {
      c && (p.preventDefault(), c == null || c());
    },
    [c]
  ), onFocus: d };
}, arrowKeyArray = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
  "PageDown + Shift",
  "PageUp + Shift"
], isArrowKey = (r, a) => !!(a && arrowKeyArray.includes(r)), selectKeyArray = ["Enter", "Space"], isSelectKey = (r, a) => !!(a && selectKeyArray.includes(r)), isTabKey = (r, a) => !!(a && r === "Tab"), isShiftTabKey = (r, a) => !!(a && r === "Tab + Shift"), isEscapeKey = (r, a) => !!(a && r === "Escape"), getKey = (r) => r.shiftKey ? `${r.code} + Shift` : r.code, useKeyDown = ({
  handleArrowKey: r,
  handleSelectKey: a,
  handleFocus: s,
  handleBlur: c,
  handleEscape: u
}) => ({ onKeyDown: useCallback$1(
  (h) => {
    switch (!0) {
      case isArrowKey(getKey(h), r):
        h.preventDefault(), r == null || r(getKey(h));
        break;
      case isSelectKey(h.code, a):
        h.preventDefault(), a == null || a(h.code);
        break;
      case isTabKey(getKey(h), s):
        h.preventDefault(), s == null || s();
        break;
      case isShiftTabKey(getKey(h), c):
        h.preventDefault(), c == null || c();
        break;
      case isEscapeKey(h.code, u):
        h.preventDefault(), u == null || u();
        break;
    }
  },
  [r, a, s, c, u]
) }), MonthSelectionCell = ({
  month: r,
  isActiveMonth: a,
  goToYear: s,
  focusedMonth: c,
  onFocusMonthChange: u,
  handleEscape: d,
  onBlurMonth: h,
  isActiveYear: p
}) => {
  const { size: m, isMobileDatePicker: g } = useCalendarContext(), v = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: g, size: m }), y = useRef$1(null), x = useMemo$1(() => c && isEqual(c, r.date), [c, r]), { isFirstMonth: w } = getMonthNumber(r.date), { onKeyDown: S } = useKeyDown({
    handleArrowKey: (T) => {
      const E = getTargetMonthByArrowKeyType(T, r.date);
      E && u(E);
    },
    handleSelectKey: () => s(r.date),
    handleEscape: d,
    handleBlur: h
  }), { onFocus: M, onBlur: P } = useFocus({
    ref: y,
    isFocused: x,
    handleOnFocus: () => {
      u(r.date);
    },
    handleOnBlur: () => {
      u(void 0);
    }
  }), I = c ? x : p ? a : w;
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "button",
      "data-active": a || null,
      __css: v.monthSelectionCell,
      onClick: () => s(r.date),
      "aria-disabled": r.isDisabled,
      "data-testid": `year-selection-list-item-month-${r.fullLabel.toLowerCase()}`,
      "aria-label": `Month ${r.fullLabel}`,
      "aria-checked": a,
      tabIndex: I ? 0 : -1,
      role: "radio",
      onKeyDown: S,
      onFocus: M,
      onBlur: P,
      ref: y,
      children: r.label
    }
  );
}, YearSelectionListItem = ({
  yearItem: r,
  isOpen: a,
  activeMonth: s,
  goToYear: c,
  onToggleYear: u,
  scrollToElement: d,
  focusedYear: h,
  onFocusYearChange: p,
  onBlurYear: m,
  isActiveYear: g,
  shouldTriggerScrollToElement: v,
  handleEscape: y
}) => {
  const { size: x, isMobileDatePicker: w } = useCalendarContext(), { formatDate: S } = useIntl(), M = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: w, size: x }), P = useRef$1(null), L = useRef$1(null), I = useMemo$1(() => h === r.year, [h, r]), [T, E] = useState$1(), R = useCallback$1(
    (z) => {
      const Z = z && r.months.find((G) => lodashExports.isEqual(G.date, z) && !G.isDisabled);
      E(Z == null ? void 0 : Z.date);
    },
    [r]
  );
  useEffect$1(() => {
    v && (d(P), isMobileiOS() && requestAnimationFrame(() => {
      var z;
      (z = L.current) == null || z.focus();
    }));
  }, [v, d]);
  const A = useCallback$1(
    (z) => {
      var Z, G;
      return g && ((Z = r.months[s.month]) == null ? void 0 : Z.date) === ((G = r.months[z]) == null ? void 0 : G.date);
    },
    [g, s, r]
  ), { onFocus: k, onBlur: V } = useFocus({
    ref: L,
    isFocused: I,
    handleOnFocus: () => {
      p(r.year, L);
    },
    handleOnBlur: () => {
      p(void 0);
    }
  }), { onKeyDown: B } = useKeyDown({
    handleArrowKey: (z) => {
      z === "ArrowDown" ? p(r.year + 1, L) : z === "ArrowUp" && p(r.year - 1);
    },
    handleSelectKey: () => {
      u(r.year, P);
    },
    handleBlur: m,
    handleEscape: y
  }), q = h ? I : g;
  return /* @__PURE__ */ jsxs(Box, { __css: M.yearSelectionListItem, "data-testid": "year-selection-item", ref: P, role: "listitem", children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        as: "button",
        __css: M.yearSelectionListItemTrigger,
        onMouseDown: () => {
          u(r.year, P);
        },
        "aria-expanded": a,
        "aria-label": `Year ${r.year}`,
        "aria-disabled": r.isDisabled,
        tabIndex: q ? 0 : -1,
        ref: L,
        onFocus: k,
        onBlur: V,
        onKeyDown: B,
        "data-testid": `year-selection-list-item-year-${r.year}`,
        children: r.year
      }
    ),
    a && /* @__PURE__ */ jsx(Box, { __css: M.monthSelectionGrid, "aria-label": "Month selection options", role: "radiogroup", children: r.months.map((z, Z) => /* @__PURE__ */ jsx(
      MonthSelectionCell,
      {
        month: z,
        isActiveMonth: A(Z),
        isActiveYear: g,
        goToYear: c,
        focusedMonth: T,
        onFocusMonthChange: R,
        onBlurMonth: () => {
          var G;
          (G = L.current) == null || G.focus();
        },
        handleEscape: y,
        ...z
      },
      S(z.date)
    )) })
  ] });
};
YearSelectionListItem.displayName = "YearSelectionListItem";
const YearSelection = ({ activeMonth: r, closeYearSelection: a, onBlurYearList: s }) => {
  const { size: c, isMobileDatePicker: u, years: d, showYearSelection: h } = useCalendarContext(), p = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: u, size: c }), [m, g] = useState$1(r.year), v = useRef$1(null), [y, x] = useState$1(!1), w = (T, E) => {
    m === T ? g(void 0) : (g(T), E && P(E));
  }, [S, M] = useState$1(), P = useCallback$1(
    (T) => {
      if (v.current && T.current) {
        const E = v.current.getBoundingClientRect(), A = T.current.getBoundingClientRect().top - E.top;
        v.current.scrollTo({
          top: v.current.scrollTop + A,
          // we want to avoid smooth scroll when the user opens the year selection for the first time and when focus the year with the keyboard.
          behavior: y && T.current.ariaExpanded !== "false" ? "smooth" : "auto"
        });
      }
      x(!0);
    },
    [y]
  ), L = (T, E) => {
    M(T), E && P(E);
  }, I = () => {
    a();
  };
  return /* @__PURE__ */ jsx(Box, { __css: p.yearSelectionContainer, "data-testid": "year-selection", children: /* @__PURE__ */ jsx(Group, { variant: "vertical", spacing: "s", height: "full", children: /* @__PURE__ */ jsx(
    Box,
    {
      __css: p.yearSelectionList,
      "data-testid": "year-selection-list",
      ref: v,
      role: "list",
      "aria-label": "Year Selection List",
      children: /* @__PURE__ */ jsx(Fade, { in: h, children: d && /* @__PURE__ */ jsx(Fragment, { children: Object.keys(d).map((T) => {
        const E = d[Number(T)], R = m === Number(T);
        return E ? /* @__PURE__ */ jsx(
          YearSelectionListItem,
          {
            yearItem: E,
            isOpen: R,
            goToYear: a,
            activeMonth: r,
            onToggleYear: w,
            scrollToElement: P,
            focusedYear: S,
            onFocusYearChange: L,
            onBlurYear: s,
            isActiveYear: r.year === E.year,
            shouldTriggerScrollToElement: R && !y,
            handleEscape: I
          },
          T
        ) : null;
      }) }) })
    }
  ) }) });
};
YearSelection.displayName = "YearSelection";
const YearSelectionHeaderTrigger = forwardRef$1(
  ({ activeMonth: r, toggleYearSelection: a, ...s }, c) => {
    const { size: u, isMobileDatePicker: d, showYearSelection: h, disableYearSelection: p } = useCalendarContext(), { formatDate: m } = useIntl(), g = m(r.date, { month: "long", year: "numeric" }), v = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: d, size: u }), y = /* @__PURE__ */ jsx(Text, { as: "h2", textStyle: "body3Semi", "aria-live": "polite", children: g }), { onKeyDown: x } = useKeyDown({
      handleEscape: () => a(!1)
    });
    return /* @__PURE__ */ jsxs(Box, { __css: v.yearSelectionHeader, children: [
      y,
      !p && /* @__PURE__ */ jsx(
        Box,
        {
          as: "button",
          "aria-expanded": h,
          __css: v.yearSelectionHeaderTrigger,
          onClick: () => a(!h),
          ref: c,
          "aria-label": "Change month or year",
          onKeyDown: x,
          tabIndex: 0,
          ...s,
          children: /* @__PURE__ */ jsx(Icon, { type: h ? "caret-up" : "caret-down", size: "large", color: "inherit", "aria-hidden": !0 })
        }
      )
    ] });
  }
);
YearSelectionHeaderTrigger.displayName = "YearSelectionHeaderTrigger";
const Header = forwardRef$1(
  ({
    activeMonth: r,
    goToPreviousMonth: a,
    goToNextMonth: s,
    hasPreviousMonth: c,
    hasNextMonth: u,
    toggleYearSelection: d,
    nextMonthLabels: h,
    previousMonthLabels: p,
    shouldFocusYearSelectionTrigger: m,
    ...g
  }, v) => {
    const { size: y, isDisabled: x, isMobileDatePicker: w, showYearSelection: S } = useCalendarContext(), M = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: w, size: y }), P = useRef$1(null);
    useEffect$1(() => {
      var I;
      m && ((I = P.current) == null || I.focus());
    }, [m]);
    const L = (I, T) => T ? `${I} month ${T == null ? void 0 : T.full} ${T == null ? void 0 : T.year}` : `${I} month is not available`;
    return /* @__PURE__ */ jsxs(Box, { __css: M.header, ...g, "data-year-selection-open": S, ref: v, children: [
      !S && /* @__PURE__ */ jsx(
        IconButton,
        {
          "data-testid": "calendar-previous-month-button",
          onClick: a,
          "aria-label": L("Previous", p),
          size: "medium",
          variant: "naked",
          icon: "chevron-left",
          isDisabled: x || !c
        }
      ),
      /* @__PURE__ */ jsx(
        YearSelectionHeaderTrigger,
        {
          activeMonth: r,
          toggleYearSelection: d,
          "data-testid": "year-selection-header-open-trigger",
          ref: P,
          "aria-live": "polite"
        }
      ),
      !S && /* @__PURE__ */ jsx(
        IconButton,
        {
          "data-testid": "calendar-next-month-button",
          "aria-label": L("Next", h),
          onClick: s,
          variant: "naked",
          isDisabled: x || !u,
          icon: "chevron-right",
          size: "medium",
          tabIndex: 0
        }
      )
    ] });
  }
), getAriaLabel = ({
  day: r,
  currentDateAriaLabel: a,
  selectedDateAriaLabel: s,
  secondaryDateAriaLabel: c
}) => {
  const u = format(r.date, "do MMMM yyyy");
  return r.isSelected && s ? `${u} ${s}` : r.isSecondarySelectedDate && c ? `${u} ${c}` : isToday(r.date) && a ? `${u} ${a}` : u;
}, Day = forwardRef$1(
  ({
    day: r,
    selectedDateAriaLabel: a,
    secondaryDateAriaLabel: s,
    currentDateAriaLabel: c,
    onChangeFocusedDate: u,
    getClosestDateToFocus: d,
    ["aria-colindex"]: h,
    ...p
  }, m) => {
    const {
      size: g,
      showToday: v,
      isDisabled: y,
      isMobileDatePicker: x,
      focusableDate: w,
      focusedDate: S,
      weekDays: M
    } = useCalendarContext(), P = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: x, size: g }), { formatDate: L } = useIntl(), I = useRef$1(null);
    useImperativeHandle$1(m, () => I.current);
    const T = useMemo$1(() => !!(S && r && isEqual(S, r.date)), [S, r]), E = useCallback$1(
      (z) => {
        if (!r) return;
        const Z = getTargetDayDateByArrowKeyType(z, r.date, M);
        Z && d(Z);
      },
      [r, d, M]
    ), { onKeyDown: R } = useKeyDown({
      handleArrowKey: E,
      handleSelectKey: () => r == null ? void 0 : r.selectDay()
    }), { onFocus: A, onBlur: k } = useFocus({
      ref: I,
      isFocused: T,
      handleOnFocus: () => {
        u(r == null ? void 0 : r.date);
      },
      handleOnBlur: () => {
        u(void 0);
      }
    });
    if (!r)
      return /* @__PURE__ */ jsx(Box, { ...p, role: "gridcell", ref: I });
    const V = !y && (S ? T : w && isEqual(w, r.date)), B = getAriaLabel({ day: r, currentDateAriaLabel: c, selectedDateAriaLabel: a, secondaryDateAriaLabel: s }), q = isMobileiOS();
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: P.cell,
        onClick: r != null && r.isDisabled ? void 0 : r.selectDay,
        "data-show-today": v,
        "aria-selected": r.isSelected ?? void 0,
        "data-secondary-selected-date": r.isSecondarySelectedDate,
        "aria-disabled": r.isDisabled,
        "data-testid": `calendar-day-${L(r.date, { day: "numeric" })}`,
        tabIndex: V ? 0 : -1,
        ...p,
        ref: I,
        onKeyDown: R,
        onFocus: A,
        onBlur: k,
        "aria-current": isToday(r.date) ? "date" : void 0,
        role: "gridcell",
        type: "button",
        "aria-colindex": h,
        "data-timestamp": r.date.getTime(),
        children: /* @__PURE__ */ jsxs(
          Box,
          {
            as: "span",
            __css: P.cellLabel,
            role: "time",
            "aria-label": B,
            "data-testid": v && isToday(r.date) ? "today-marker" : void 0,
            "data-secondary-selected-date": r.isSecondarySelectedDate,
            "data-selected-date": r.isSelected,
            "data-disabled": r.isDisabled,
            "aria-describedby": q ? r.label : void 0,
            children: [
              r.label,
              q && /* @__PURE__ */ jsx(VisuallyHidden, { "aria-hidden": !0, id: r.label, children: B })
            ]
          }
        )
      }
    );
  }
), MonthDaysGrid = forwardRef$1(
  ({
    onChangeFocusedDate: r,
    getClosestDateToFocus: a,
    currentDateAriaLabel: s,
    selectedDateAriaLabel: c,
    secondaryDateAriaLabel: u,
    ...d
  }, h) => {
    const { size: p, isDisabled: m, weeks: g, isMobileDatePicker: v } = useCalendarContext(), y = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: v, size: p });
    return /* @__PURE__ */ jsx(Box, { role: "presentation", children: /* @__PURE__ */ jsx(
      Box,
      {
        role: "rowgroup",
        __css: y.calendar,
        ref: h,
        "data-testid": "calendar-month-grid",
        "data-disabled": m || void 0,
        ...d,
        children: g.map((x, w) => /* @__PURE__ */ jsx(Box, { role: "row", "aria-rowindex": w + 1, __css: y.calendarRow, children: x.map((S, M) => /* @__PURE__ */ jsx(
          Day,
          {
            day: S,
            onChangeFocusedDate: r,
            getClosestDateToFocus: a,
            "aria-colindex": M + 1,
            selectedDateAriaLabel: c,
            secondaryDateAriaLabel: u,
            currentDateAriaLabel: s
          },
          S ? S.date.getTime() : `day-week-${w}-cell-${M}`
        )) }, `week-${w}`))
      }
    ) });
  }
), useWeekDays = () => {
  const { locale: r } = useIntl(), a = (s, c) => {
    const u = new Intl.DateTimeFormat(r, { weekday: "short" }).format(setDay(/* @__PURE__ */ new Date(), c)), d = new Intl.DateTimeFormat(r, { weekday: "long" }).format(setDay(/* @__PURE__ */ new Date(), c));
    return {
      label: r.startsWith("en") ? u.substring(0, 2) : u,
      fullLabel: d
    };
  };
  return useMemo$1(() => Array.from({ length: 7 }).map(a), []);
}, WeekDaysHeader = forwardRef$1((r, a) => {
  const { size: s, isMobileDatePicker: c } = useCalendarContext(), u = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: c, size: s }), d = useWeekDays(), h = (p) => /* @__PURE__ */ jsxs(Box, { as: "span", role: "text", children: [
    /* @__PURE__ */ jsx(Box, { as: "span", "aria-hidden": !0, children: p.label }),
    /* @__PURE__ */ jsx(VisuallyHidden, { children: p.fullLabel })
  ] });
  return /* @__PURE__ */ jsx(Box, { role: "row", __css: u.calendarRow, ...r, ref: a, children: d.map((p) => /* @__PURE__ */ jsx(Box, { role: "columnheader", __css: u.headerCell, "aria-label": p.fullLabel, children: isMobileiOS() ? h(p) : p.label }, p.label)) });
}), Month = forwardRef$1(
  ({
    onChangeFocusedDate: r,
    getClosestDateToFocus: a,
    selectedDateAriaLabel: s,
    secondaryDateAriaLabel: c,
    currentDateAriaLabel: u,
    ...d
  }, h) => {
    const { size: p, isMobileDatePicker: m, showYearSelection: g } = useCalendarContext(), v = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: m, size: p });
    return /* @__PURE__ */ jsxs(
      Box,
      {
        ...d,
        ref: h,
        __css: v.monthContainer,
        "data-hidden": g || null,
        role: "grid",
        children: [
          /* @__PURE__ */ jsx(WeekDaysHeader, {}),
          /* @__PURE__ */ jsx(
            MonthDaysGrid,
            {
              onChangeFocusedDate: r,
              getClosestDateToFocus: a,
              selectedDateAriaLabel: s,
              secondaryDateAriaLabel: c,
              currentDateAriaLabel: u
            }
          )
        ]
      }
    );
  }
), LEGENDS_SPACING = "s", getLegendMaxWidth = (r, a) => `calc(${r - getThemeSpacingAsNumber(LEGENDS_SPACING) * a}px / ${a})`, _BaseCalendar = forwardRef$1(
  ({
    secondarySelectedDate: r,
    onSelect: a,
    selectedDate: s,
    excludeHolidays: c,
    maxDate: u,
    minDate: d,
    weekDays: h,
    isDisabled: p,
    selectedDateAriaLabel: m,
    secondaryDateAriaLabel: g,
    currentDateAriaLabel: v,
    size: y = "large",
    showToday: x,
    legendItems: w,
    isMobileDatePicker: S,
    yearsRange: M,
    legendWidth: P = "fit-content",
    disableYearSelection: L = !1,
    ...I
  }, T) => {
    var oe;
    const {
      activeMonth: E,
      weeks: R,
      goToNextMonth: A,
      goToPreviousMonth: k,
      hasNextMonth: V,
      nextMonthLabels: B,
      hasPreviousMonth: q,
      previousMonthLabels: z,
      showYearSelection: Z,
      setShowYearSelection: G,
      setSelectedYear: K,
      focusableDate: U,
      years: F,
      getClosestDateToFocus: N,
      setFocusedDate: D,
      focusedDate: j
    } = useCalendar({
      secondarySelectedDate: r,
      onSelect: a,
      selectedDate: s,
      excludeHolidays: c,
      maxDate: u,
      minDate: d,
      weekDays: h,
      yearsRange: M
    }), [H, W] = useState$1(0), re = useMultiStyleConfig("_BaseCalendar", { isMobileDatePicker: S, size: y }), [ae, ee] = useState$1(!1), X = useRef$1(null), J = (fe) => {
      G(!!fe);
    }, ie = (fe) => {
      fe && K(fe), G(!1), ee(!0);
    };
    return useEffect$1(() => {
      ae && ee(!1);
    }, [ae]), useEffect$1(() => {
      X.current && W(X.current.clientWidth);
    }, [(oe = X.current) == null ? void 0 : oe.clientWidth]), /* @__PURE__ */ jsx(
      CalendarContext.Provider,
      {
        value: {
          showToday: x,
          weeks: R,
          isDisabled: p,
          size: y,
          isMobileDatePicker: S,
          years: F,
          showYearSelection: Z,
          focusableDate: U,
          focusedDate: j,
          weekDays: h,
          disableYearSelection: L
        },
        children: E && /* @__PURE__ */ jsxs(
          Group,
          {
            variant: "vertical",
            spacing: "s",
            ref: T,
            "data-component": "_BaseCalendar",
            "data-testid": "calendar-component",
            ...I,
            children: [
              /* @__PURE__ */ jsxs(Box, { "data-disabled": p || void 0, __css: re.container, ref: X, children: [
                /* @__PURE__ */ jsx(
                  Header,
                  {
                    activeMonth: E,
                    hasPreviousMonth: q,
                    hasNextMonth: V,
                    nextMonthLabels: B,
                    previousMonthLabels: z,
                    goToPreviousMonth: k,
                    goToNextMonth: A,
                    toggleYearSelection: J,
                    shouldFocusYearSelectionTrigger: ae
                  }
                ),
                Z && /* @__PURE__ */ jsx(
                  YearSelection,
                  {
                    activeMonth: E,
                    closeYearSelection: ie,
                    onBlurYearList: () => ee(!0)
                  }
                ),
                /* @__PURE__ */ jsx(
                  Month,
                  {
                    onChangeFocusedDate: D,
                    getClosestDateToFocus: N,
                    selectedDateAriaLabel: m,
                    secondaryDateAriaLabel: g,
                    currentDateAriaLabel: v
                  }
                )
              ] }),
              w != null && w.length ? /* @__PURE__ */ jsx(
                Box,
                {
                  as: Group,
                  __css: re.legendsList,
                  variant: "horizontal",
                  spacing: LEGENDS_SPACING,
                  width: "full",
                  children: w.map((fe, ve) => /* @__PURE__ */ jsx(
                    CalendarLegend,
                    {
                      "data-testid": fe.testId ?? `legend-item-${ve}`,
                      label: fe.label,
                      date: fe.date,
                      variant: fe.variant,
                      legendWidth: P,
                      legendMaxWidth: getLegendMaxWidth(H, w.length)
                    },
                    `legend-${fe.label}`
                  ))
                }
              ) : null
            ]
          }
        )
      }
    );
  }
);
_BaseCalendar.displayName = "_BaseCalendar";
const fileSignatures = {
  jpg: [255, 216, 255],
  png: [137, 80, 78, 71],
  pdf: [37, 80, 68, 70]
}, fileTypes = {
  jpg: "image/jpeg",
  pdf: "application/pdf",
  png: "image/png"
}, getInputFileAcceptByType = (r = []) => r.map((a) => fileTypes[a]).join(", "), getFileTypeBySignature = (r) => new Promise((a, s) => {
  const c = new FileReader();
  c.onloadend = () => {
    const d = c.result;
    if (d) {
      const h = new Uint8Array(d);
      for (const p in fileSignatures) {
        const m = fileSignatures[p];
        if (m && m.every((g, v) => g === h[v])) {
          a(p);
          return;
        }
      }
      a("unknown");
    } else
      a("unknown");
  }, c.onerror = () => {
    s("Error reading file");
  };
  const u = r.slice(0, 4);
  c.readAsArrayBuffer(u);
}), isAcceptedType = async (r, a) => {
  if (!a) return !0;
  const s = await getFileTypeBySignature(r);
  return a.includes(s);
}, Actions = ({
  size: r,
  replaceBtnProps: a,
  deleteBtnProps: s
}) => {
  const c = useBreakpointValue({ xs: "small", s: "medium" }), u = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(NakedButton, { ...a, variant: "primary" }),
    /* @__PURE__ */ jsx(NakedButton, { ...s, variant: "critical" })
  ] }), d = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button, { ...a, variant: "tertiary", size: c }),
    /* @__PURE__ */ jsx(Button, { ...s, variant: "critical-secondary", size: c })
  ] });
  return r === "small" ? u : d;
};
Actions.displayName = "Actions";
const _BaseFileUpload = forwardRef$1(
  ({
    children: r,
    value: a,
    as: s = "div",
    placeholder: c,
    isInvalid: u,
    isLoading: d,
    isReadOnly: h,
    isDisabled: p,
    isViewMode: m,
    acceptTypes: g,
    onChange: v,
    setFileDataURL: y,
    setSelectedFile: x,
    selectedFile: w,
    hiddenFileInputRef: S,
    errorMessage: M,
    invalidFileTypeErrorMessage: P = "Invalid file type",
    size: L = "small",
    replaceFileLabel: I = "Replace",
    deleteFileLabel: T = "Delete",
    "aria-label": E = "Upload file",
    "aria-required": R,
    "aria-describedby": A,
    uploadFileButtonAriaLabel: k = "Upload file",
    replaceFileButtonAriaLabel: V = "Replace file",
    deleteFileButtonAriaLabel: B = "Delete file",
    id: q,
    name: z,
    onDelete: Z,
    onReplace: G,
    ...K
  }, U) => {
    var Ce;
    const { isExtraSmallScreen: F } = useBreakpoint(), N = useMultiStyleConfig("_BaseFileUpload", { size: L, value: a, isMobile: F }), D = w && !p && !h, j = !m && !p, [H, W] = useBoolean(!1), [re, ae] = useState$1(""), ee = useRef$1(null), X = useMemo$1(() => {
      if (!(!M && !re))
        return lodashExports.uniqueId("invalid-");
    }, [M, re]), J = {
      "aria-label": E,
      "aria-describedby": A,
      "aria-required": R,
      name: z
    };
    useUpdateEffect$1(() => {
      a !== void 0 && x(a);
    }, [a]);
    const ie = () => {
      var me;
      d || (me = S.current) == null || me.click();
    }, oe = (me) => {
      ie(), G == null || G();
    }, fe = (me) => {
      me.stopPropagation();
      const {
        target: { files: xe }
      } = me, Se = xe == null ? void 0 : xe[0];
      Se && (async () => {
        try {
          await isAcceptedType(Se, g) ? (x(Se), ae(""), v == null || v(Se)) : (ae(P), x(null), v == null || v(null));
        } catch {
          ae("Error reading file. Please try again"), x(null), v == null || v(null);
        }
      })();
    }, ve = (me) => {
      if (me.stopPropagation(), Z) {
        Z();
        return;
      }
      S.current && (S.current.value = ""), x(null), v == null || v(null);
    };
    useEffect$1(() => {
      let me, xe = !1;
      return !!w && w instanceof File ? (me = new FileReader(), me.onload = (Re) => {
        if (!Re.target) return;
        const { result: Pe } = Re.target;
        Pe && !xe && !lodashExports.isNull(Pe) && y(Pe);
      }, me.readAsDataURL(w)) : y(null), () => {
        xe = !0, me && me.readyState === 1 && me.abort();
      };
    }, [w]), useEffect$1(() => {
      u && x(null);
    }, [u]);
    const ue = /* @__PURE__ */ jsxs(Box, { __css: N.placeholder, children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          __css: N.placeholderIcon,
          "data-hover": H || null,
          "aria-disabled": p,
          "data-readonly": h || null,
          children: /* @__PURE__ */ jsx(Icon, { type: "file-add", color: "inherit", "aria-hidden": !0 })
        }
      ),
      /* @__PURE__ */ jsx(Box, { __css: N.placeholderLabel, "aria-disabled": p, "data-readonly": h || null, children: c })
    ] }), pe = {
      replaceBtnProps: {
        "data-testid": "replace-file",
        onClick: oe,
        isDisabled: p || h,
        label: I,
        "aria-label": V
      },
      deleteBtnProps: {
        "data-testid": "delete-file",
        onClick: ve,
        isDisabled: p || h,
        label: T,
        "aria-label": B
      }
    }, we = /* @__PURE__ */ jsx(Box, { __css: N.buttonsContainer, children: /* @__PURE__ */ jsx(Actions, { size: L, ...pe }) }), ye = /* @__PURE__ */ jsx(
      Box,
      {
        as: "input",
        type: "file",
        "data-testid": "upload-file-input",
        accept: getInputFileAcceptByType(g),
        ref: S,
        style: { display: "none" },
        onChange: fe,
        placeholder: c,
        disabled: p,
        id: q,
        ...J
      }
    ), Ie = useMemo$1(() => lodashExports.uniqueId("loader-"), []), Ee = d && (((Ce = ee.current) == null ? void 0 : Ce.contains(document.activeElement)) || ee.current == document.activeElement), ne = useFocusManager(Ee), se = getAriaProps("aria-labelledby", [
      d ? Ie : void 0,
      M || re ? X : void 0
    ]), de = L === "large" && (w && we || M || re);
    return /* @__PURE__ */ jsxs(
      Box,
      {
        __css: N.outerContainer,
        onMouseOver: W.on,
        onMouseOut: W.off,
        ref: ee,
        children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              ref: mergeRefs([U, ne]),
              onClick: !h && !w ? ie : void 0,
              "aria-invalid": u,
              "data-loading": d,
              "data-readonly": d || h || m || null,
              "aria-disabled": p,
              "data-selected": !!w || null,
              "data-hover": H || null,
              __css: N.innerContainer,
              tabIndex: j && !w ? 0 : -1,
              as: s,
              type: s === "button" ? "button" : void 0,
              "aria-label": !w && !d ? k : void 0,
              ...se,
              ...K,
              children: [
                d && /* @__PURE__ */ jsx(Container, { paddingY: "xxs", width: "fit-content", children: /* @__PURE__ */ jsx(Loader, { id: Ie }) }),
                !d && !w && ue,
                !d && w && r,
                D && L === "small" && we,
                ye
              ]
            }
          ),
          de && /* @__PURE__ */ jsxs(Group, { spacing: "xs", variant: "vertical", alignItems: "center", children: [
            w && we,
            (M || re) && /* @__PURE__ */ jsx(Text, { textStyle: "body4", color: "semantic.text.critical.rest", id: X, children: M || re })
          ] })
        ]
      }
    );
  }
);
_BaseFileUpload.displayName = "_BaseFileUpload";
function isRegularIcon(r) {
  return !!r && Object.keys(icons).includes(r);
}
const _BaseIcon = forwardRef$1(
  ({ type: r, size: a = "small", isDisabled: s, isReadOnly: c, isInverse: u = !1, ...d }, h) => {
    const p = useIcons(), m = useIconAsset(r, a), g = isRegularIcon(r) ? m : p[r], v = typeof m == "string", y = useStyleConfig("BaseIcon", { size: a, isInverse: u, isURLIcon: v });
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: "span",
        "data-component": "_BaseIcon",
        __css: y,
        ref: h,
        "data-disabled": s || void 0,
        "data-readonly": c || void 0,
        "data-is-brand-color": iconColorMapping.brand === d.color,
        ...d,
        children: v ? /* @__PURE__ */ jsx("img", { src: m, alt: m }) : /* @__PURE__ */ jsx(Box, { as: g })
      }
    );
  }
);
_BaseIcon.displayName = "_BaseIcon";
const LoadingContainer = forwardRef$1(
  ({ children: r, isLoading: a, loadingText: s, "data-testid": c = "loading-container", ...u }, d) => {
    const h = useMultiStyleConfig("LoadingContainer", { isLoading: a }), p = useTestId(c);
    return /* @__PURE__ */ jsxs(Box, { __css: h.loadingContainer, "data-component": "LoadingContainer", ...p(), ...u, ref: d, children: [
      a && /* @__PURE__ */ jsx(Box, { ...p("loader"), __css: h.loaderContainer, children: /* @__PURE__ */ jsx(Loader, { loadingText: s }) }),
      /* @__PURE__ */ jsx(Box, { __css: h.childrenContainer, ...p("children-container"), children: r })
    ] });
  }
);
LoadingContainer.displayName = "LoadingContainer";
const fadeStyle = { zIndex: zIndices.docked, inset: 0 }, Blanket = forwardRef$1(
  ({ isOpen: r = !1, icon: a, isFullScreen: s, variant: c, isLoading: u, onClick: d, loadingText: h, hideLoadingText: p, ...m }, g) => {
    const v = useMultiStyleConfig("Blanket", {
      variant: c ?? (s ? "darker" : "dark"),
      isFullScreen: s,
      isLoading: u
    }), y = useCallback$1(() => {
      s && d && d();
    }, [s, d]);
    return /* @__PURE__ */ jsx(
      Fade,
      {
        in: r,
        unmountOnExit: !0,
        transition: {
          enter: { duration: 0.1 },
          exit: { duration: 0.1 }
        },
        style: { ...fadeStyle, position: s ? "fixed" : "absolute" },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            "data-component": "Blanket",
            __css: v.container,
            ref: g,
            ...m,
            onClick: y,
            ...s && {
              as: FloatingOverlay,
              lockScroll: !0
            },
            children: u ? /* @__PURE__ */ jsx(
              Loader,
              {
                "data-testid": "loader",
                color: c !== "light" ? "semantic.text.inverse" : void 0,
                hideLoadingText: p,
                loadingText: h
              }
            ) : a && /* @__PURE__ */ jsx(Box, { __css: v.icon, children: /* @__PURE__ */ jsx(Icon, { type: a, color: c === "light" ? "default" : "inverse" }) })
          }
        )
      }
    );
  }
);
Blanket.displayName = "Blanket";
const _BaseSheetContext = createContext$1({
  paddingX: "s",
  paddingY: "s",
  onClose: () => {
  },
  isOverflow: void 0,
  showFooterBorder: void 0,
  closeButtonAriaLabel: void 0
}), _useBaseSheetContext = () => useContext$1(_BaseSheetContext), _BaseSheet$1 = forwardRef$1(
  ({
    isOpen: r,
    onClose: a,
    onCloseComplete: s,
    placement: c = "left",
    isLoading: u = !1,
    closeButtonAriaLabel: d = "Close sheet",
    children: h,
    paddingX: p = "s",
    paddingY: m = "s",
    initialFocus: g,
    ...v
  }, y) => {
    const { refs: x, context: w } = useFloating({
      open: r,
      onOpenChange: a
    }), S = useRef$1(null), {
      isOverflowY: M,
      scrollAtBottom: P,
      isMounted: L
    } = useScrollBorders({ ref: S }), I = M && !P, T = useMergeRefs([x.setFloating, y, S]), E = useRole(w), R = useDismiss(w, { outsidePressEvent: "mousedown" }), { getFloatingProps: A } = useInteractions([E, R]), k = useCallback$1((q) => {
      q !== "enter" && (s == null || s());
    }, []), V = useMultiStyleConfig("_BaseSheet", { placement: c, paddingX: p, paddingY: m });
    useHideFromSR({
      ignoreEl: S.current,
      enable: r
    });
    const B = useDelayUnmount({ isOpen: r });
    return /* @__PURE__ */ jsx(
      _BaseSheetContext.Provider,
      {
        value: { paddingX: p, paddingY: m, onClose: a, closeButtonAriaLabel: d, showFooterBorder: I, isOverflow: M },
        children: B && /* @__PURE__ */ jsxs(Portal, { children: [
          /* @__PURE__ */ jsx(Blanket, { isOpen: r, isFullScreen: !0, "data-testid": "base-sheet-overlay" }),
          /* @__PURE__ */ jsx(FloatingFocusManager, { context: w, initialFocus: g, disabled: !L, children: /* @__PURE__ */ jsx(
            Slide,
            {
              direction: c,
              in: r,
              style: {
                zIndex: zIndices.modal,
                width: c === "bottom" ? "100vw" : `calc(100vw - ${themeSpaces.xxxl})`,
                maxWidth: c === "bottom" ? "100vw" : "375px"
              },
              onAnimationComplete: k,
              transition: {
                enter: { duration: 0.3 },
                exit: { duration: 0.3 }
              },
              children: /* @__PURE__ */ jsx(
                Box,
                {
                  __css: V.mainContainer,
                  "data-component": "_BaseSheet",
                  ref: T,
                  ...v,
                  ...A(),
                  children: u ? /* @__PURE__ */ jsxs(Box, { __css: V.loadingContainer, children: [
                    /* @__PURE__ */ jsx(Box, { __css: V.closeButtonLoadingState, children: /* @__PURE__ */ jsx(
                      IconButton,
                      {
                        variant: "naked",
                        size: "medium",
                        onClick: a,
                        icon: "close",
                        "aria-label": d
                      }
                    ) }),
                    /* @__PURE__ */ jsx(LoadingContainer, { isLoading: !0 })
                  ] }) : h
                }
              )
            }
          ) })
        ] })
      }
    );
  }
);
_BaseSheet$1.displayName = "_BaseSheet";
const _Body = forwardRef$1(({ children: r, ...a }, s) => {
  const c = useMultiStyleConfig("_BaseSheet", {});
  return /* @__PURE__ */ jsx(Box, { "data-component": "BaseSheet.Body", __css: c.body, ...a, ref: s, children: r });
});
_Body.displayName = "_BaseSheet.Body";
const _Footer = forwardRef$1(({ children: r, ...a }, s) => {
  const { paddingX: c, paddingY: u, showFooterBorder: d } = _useBaseSheetContext(), h = useMultiStyleConfig("_BaseSheet", { paddingX: c, paddingY: u, showFooterBorder: d });
  return /* @__PURE__ */ jsx(Box, { "data-component": "BaseSheet.Footer", ...a, __css: h.footer, ref: s, children: r });
});
_Footer.displayName = "_BaseSheet.Footer";
const _Header = forwardRef$1(({ children: r, ...a }, s) => {
  const { paddingX: c, paddingY: u, onClose: d, closeButtonAriaLabel: h } = _useBaseSheetContext(), p = useMultiStyleConfig("_BaseSheet", { paddingX: c, paddingY: u, hasTitle: !!r });
  return /* @__PURE__ */ jsxs(Box, { "data-component": "BaseSheet.Header", __css: p.header, ...a, ref: s, children: [
    r && (typeof r == "string" ? /* @__PURE__ */ jsx(Container, { alignItems: "center", children: /* @__PURE__ */ jsx(Text, { textStyle: "body3", children: r }) }) : r),
    /* @__PURE__ */ jsx(Box, { __css: p.closeButtonContainer, children: /* @__PURE__ */ jsx(
      IconButton,
      {
        variant: "naked",
        size: "medium",
        onClick: d,
        icon: "close",
        "aria-label": h,
        "data-testid": "sheet-close-button"
      }
    ) })
  ] });
});
_Header.displayName = "_BaseSheet.Header";
const components$4 = { Header: _Header, Body: _Body, Footer: _Footer }, _BaseSheet = Object.assign(_BaseSheet$1, components$4), Grid = forwardRef$1((r, a) => /* @__PURE__ */ jsx(Grid$1, { "data-component": "Grid", ...r, ref: a }));
Grid.displayName = "Grid";
const GridItem = forwardRef$1((r, a) => /* @__PURE__ */ jsx(GridItem$1, { "data-component": "GridItem", ...r, ref: a }));
GridItem.displayName = "GridItem";
const SimpleGrid = forwardRef$1((r, a) => /* @__PURE__ */ jsx(SimpleGrid$1, { "data-component": "SimpleGrid", ...r, ref: a }));
SimpleGrid.displayName = "SimpleGrid";
const _ContentBox = forwardRef$1((r, a) => /* @__PURE__ */ jsx(GridItem, { "data-component": "_ContentBox", ...r, ref: a }));
_ContentBox.displayName = "_ContentBox";
const _CustomInputContainer = forwardRef$1(
  ({ children: r, size: a = "large", ...s }, c) => {
    const u = useMultiStyleConfig("CustomInputContainer", { size: a });
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: "textbox",
        "data-component": "_CustomInputContainer",
        __css: u.field,
        className: a,
        ...s,
        ref: c,
        children: r
      }
    );
  }
);
_CustomInputContainer.displayName = "_CustomInputContainer";
const FormContext = createContext$1({ columns: 1 }), useFormContext$1 = () => useContext$1(FormContext), _Form = forwardRef$1(
  ({
    children: r,
    inputRef: a,
    isDisabled: s,
    isReadOnly: c,
    isViewMode: u,
    isLoading: d,
    columns: h = 1,
    error: p,
    as: m,
    size: g = "large",
    ...v
  }, y) => {
    const x = useMultiStyleConfig("Form", { size: g, error: p });
    return /* @__PURE__ */ jsx(Box, { __css: x.formContainer, children: /* @__PURE__ */ jsxs(FormContext.Provider, { value: { size: g, columns: h, isDisabled: s, isReadOnly: c, isViewMode: u, isLoading: d }, children: [
      /* @__PURE__ */ jsx(Box, { __css: x.errorContainer, role: "status", children: p ? /* @__PURE__ */ jsx(
        SectionBanner,
        {
          title: p.title,
          description: p.description,
          variant: "critical",
          "data-testid": "form-general-error"
        }
      ) : null }),
      /* @__PURE__ */ jsxs(
        Box,
        {
          "data-component": "_Form",
          gridTemplateColumns: { xs: "none", s: `repeat(${h}, minmax(0, 1fr))` },
          ...v,
          as: m ?? (u ? "ul" : "form"),
          display: "grid",
          "data-readonly": c,
          "data-view-mode": u,
          __css: x.form,
          "aria-disabled": s,
          ref: y,
          noValidate: !0,
          children: [
            r,
            /* @__PURE__ */ jsx("input", { ref: a, type: "submit", hidden: !0 }),
            d && /* @__PURE__ */ jsx(Box, { __css: x.loader, children: /* @__PURE__ */ jsx(Loader, { "data-testid": "form-loader" }) })
          ]
        }
      )
    ] }) });
  }
);
_Form.displayName = "_Form";
const getAutoCompleteProps = ({ name: r, autoComplete: a = "off" }) => ({
  autoComplete: a,
  // We must use a valid value for a11y reasons
  ...r && { name: a === "off" ? `${r}-${Math.random().toString(36).substring(2, 7)}` : r }
});
function drillProps(r, a, s) {
  return Children.map(r, (c, u) => isValidElement(c) ? cloneElement(c, { ...a }) : c);
}
const getAriaDescribedByProps = ({
  id: r,
  error: a,
  helperText: s,
  maxChars: c
}) => {
  const u = s ? `${r}-helper-text` : "", d = a != null && a.message ? `${r}-error-message` : "", h = c ? `${r}-max-chars` : "", p = [u, d, h].filter((m) => !!m).join(" ");
  return {
    helperTextId: u,
    errorMessageId: d,
    maxCharsId: h,
    "aria-describedby": p
  };
}, FormControl = forwardRef$1(
  ({ "data-testid": r, isHidden: a, isViewMode: s, labelProps: c, isInvalid: u, gridColumn: d, children: h, ...p }, m) => {
    const g = {
      ref: m,
      children: h,
      "data-testid": r,
      "data-hidden": a || null,
      gridColumn: d
    }, v = useFormContext$1();
    return v.isViewMode ? /* @__PURE__ */ jsx(
      Box,
      {
        as: "li",
        listStyleType: "none",
        display: "flex",
        flexDirection: "column",
        rowGap: "4px",
        minWidth: 0,
        "data-view-mode": v.isViewMode ?? s,
        ...g
      }
    ) : /* @__PURE__ */ jsx(
      FormControl$1,
      {
        "data-component": "FormControl",
        ...p,
        ...g,
        label: c == null ? void 0 : c.label,
        isInvalid: u
      }
    );
  }
);
FormControl.displayName = "FormControl";
const FormControlContext = createContext$1({}), useFormControlContext = () => useContext$1(FormControlContext), InputComp = ({ children: r, ...a }) => {
  const s = useFormControlContext$1();
  return /* @__PURE__ */ jsx(Fragment, { children: drillProps(r, { isInvalid: s == null ? void 0 : s.isInvalid, ...a }) });
}, _FormField = forwardRef$1(
  ({
    error: r,
    labelProps: a,
    "aria-label": s,
    helperTextProps: c,
    maxChars: u,
    isDisabled: d,
    isReadOnly: h,
    isViewMode: p,
    size: m,
    name: g,
    colSpan: v = 1,
    columns: y = 1,
    isRequired: x,
    showOptionalIndicator: w,
    children: S,
    id: M,
    value: P,
    autoComplete: L,
    ...I
  }, T) => {
    const E = !!r, R = (K) => g && `${K}-${g}`, A = u && `${(P == null ? void 0 : P.length) ?? "0"}/${u}`, k = useMemo$1(() => getAutoCompleteProps({ name: g, autoComplete: L }), [g, L]), { helperTextId: V, errorMessageId: B, maxCharsId: q, ...z } = getAriaDescribedByProps({
      id: M,
      error: r,
      helperText: c == null ? void 0 : c.label,
      maxChars: u
    }), G = E || (c == null ? void 0 : c.label) && !p || !!u ? m === "small" ? "xxxs" : "xxs" : "none";
    return /* @__PURE__ */ jsx(FormControlContext.Provider, { value: { maxChars: u, isInvalid: E }, children: /* @__PURE__ */ jsxs(
      FormControl,
      {
        gridColumn: { xs: "1 / 1", s: `span ${v} / span ${y}` },
        minWidth: 0,
        size: m,
        isInvalid: E,
        isDisabled: d,
        isReadOnly: h,
        isViewMode: p,
        "data-testid": R("form-field"),
        "data-component": "_FormField",
        id: M,
        ...I,
        ref: T,
        children: [
          a && /* @__PURE__ */ jsx(
            Typography.Label,
            {
              as: p ? "div" : "label",
              "data-testid": R("form-label"),
              isInvalid: E,
              isReadOnly: h,
              isViewMode: p,
              isDisabled: d,
              description: p ? void 0 : x ? "*" : w ? "(optional)" : void 0,
              id: M,
              ...a
            }
          ),
          /* @__PURE__ */ jsxs(Group, { spacing: G, variant: "vertical", children: [
            /* @__PURE__ */ jsx(
              InputComp,
              {
                ...k,
                "aria-label": s,
                "aria-required": !p && x,
                ...z,
                children: S
              }
            ),
            /* @__PURE__ */ jsxs(
              Group,
              {
                justifyContent: r || c != null && c.label && !p ? "space-between" : "flex-end",
                "aria-live": "polite",
                children: [
                  r != null && r.message ? /* @__PURE__ */ jsx(
                    Text,
                    {
                      textStyle: "body4",
                      color: "semantic.text.critical.rest",
                      id: B,
                      "data-testid": R("form-error-message"),
                      children: r == null ? void 0 : r.message
                    }
                  ) : c != null && c.label && !p ? /* @__PURE__ */ jsx(
                    Text,
                    {
                      "data-testid": R("form-helper-text"),
                      id: V,
                      textStyle: "body4",
                      color: d ? "semantic.text.disabled" : "semantic.text.secondary",
                      "aria-disabled": d,
                      children: c.label
                    }
                  ) : null,
                  A && /* @__PURE__ */ jsx(
                    Text,
                    {
                      textStyle: "body4",
                      color: E ? "semantic.text.critical.rest" : d ? "semantic.text.disabled" : "semantic.text.secondary",
                      "data-testid": "max-chars",
                      id: q,
                      children: A
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ) });
  }
);
_FormField.displayName = "_FormField";
const _Table = forwardRef$1(
  ({ isLoading: r, isHeaderSticky: a, headerVariant: s, ...c }, u) => {
    const d = useMultiStyleConfig("Table", { isLoading: r, isHeaderSticky: a });
    return /* @__PURE__ */ jsx(Box, { __css: d.container, "data-testid": "table-container", ref: u, children: /* @__PURE__ */ jsx(Box, { role: "table", "data-component": "_Table", __css: d.table, ...c }) });
  }
);
_Table.displayName = "_Table";
const _TableBody = forwardRef$1(({ isLoading: r, ...a }, s) => {
  const { ref: c, scrollWidth: u } = useScrollWidth();
  useImperativeHandle$1(s, () => c.current);
  const d = useMultiStyleConfig("Table", { tableWidth: u, isLoading: r });
  return /* @__PURE__ */ jsx(Box, { ref: c, role: "rowgroup", "data-component": "TableBody", __css: d.tableBody, ...a });
});
_TableBody.displayName = "TableBody";
const _useCellSize = (r = "m") => useBreakpointValue({ xs: (() => {
  switch (r) {
    case "m":
      return "s";
    case "l":
      return "m";
    default:
      return r;
  }
})(), s: r }), _TableDataCell = forwardRef$1(
  ({ size: r, textAlign: a = "start", pinOptions: s, isRowHeader: c, onKeyDown: u, ...d }, h) => {
    const p = useRef$1(null);
    useImperativeHandle$1(h, () => p.current);
    const m = useStyleConfig("_TableDataCell", {
      size: _useCellSize(r),
      textAlign: a,
      pinOptions: s
    });
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: c ? "rowheader" : "cell",
        __css: m,
        "data-component": "TableDataCell",
        ...d,
        ref: p,
        onKeyDown: (v) => {
          v.stopPropagation(), u == null || u(v);
        }
      }
    );
  }
);
_TableDataCell.displayName = "TableDataCell";
const _TableHead = forwardRef$1(({ isHeaderSticky: r, ...a }, s) => {
  const c = useMultiStyleConfig("Table", { isHeaderSticky: r });
  return /* @__PURE__ */ jsx(
    Box,
    {
      role: "rowgroup",
      "data-component": "TableHead",
      "data-testid": "table-head",
      ...a,
      ref: s,
      __css: c.tableHead
    }
  );
});
_TableHead.displayName = "TableHead";
const ariaSortBySortDirection = {
  asc: "ascending",
  desc: "descending"
}, _TableHeaderBaseCell = forwardRef$1(
  ({ size: r, textAlign: a = "start", pinOptions: s, variant: c, sortDirection: u, ...d }, h) => {
    const p = useRef$1(null);
    useImperativeHandle$1(h, () => p.current);
    const m = useStyleConfig("_TableHeaderBaseCell", {
      size: _useCellSize(r),
      textAlign: a,
      variant: c,
      pinOptions: s
    }), g = u ? ariaSortBySortDirection[u] : void 0, v = d.children ? "columnheader" : "cell";
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: v,
        __css: m,
        "data-component": "TableHeaderBaseCell",
        "aria-sort": g,
        ...d,
        ref: p
      }
    );
  }
);
_TableHeaderBaseCell.displayName = "TableHeaderBaseCell";
const _TableHeaderRow = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Table", {});
  return /* @__PURE__ */ jsx(Box, { role: "row", __css: s.headerRow, "data-component": "TableHeaderRow", ...r, ref: a });
});
_TableHeaderRow.displayName = "TableHeaderRow";
const _TableRow = forwardRef$1(
  ({ onClick: r, isSubRow: a, isLastSubRow: s, isRowHighlighted: c, ...u }, d) => {
    const h = useMultiStyleConfig("Table", { isSubRow: a, isLastSubRow: s, isRowHighlighted: c }), p = useRef$1(), m = mergeRefs([d, p]), g = (v) => {
      var y, x;
      r && (v.key === " " && (v.preventDefault(), (y = p.current) == null || y.click()), v.key === "Enter" && ((x = p.current) == null || x.click()));
    };
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: "row",
        __css: r ? h.clickableRow : h.row,
        "data-component": "TableRow",
        "data-highlighted": c || void 0,
        onClick: r,
        onKeyDown: g,
        ...u,
        ref: m
      }
    );
  }
);
_TableRow.displayName = "TableRow";
const useBaseMenu = ({
  isOpen: r,
  onOpenChange: a,
  width: s,
  disableMenuShift: c,
  disableTypeahead: u,
  disableOpenByTriggerClick: d,
  isVirtualList: h,
  focusItemOnOpen: p,
  role: m = "menu",
  triggerDropdownGap: g = 8,
  trigger: v,
  isDisabled: y,
  isReadOnly: x,
  initialFocus: w
}) => {
  const S = (z, Z) => {
    a(z, Z);
  }, { context: M, ...P } = useFloating({
    open: r,
    onOpenChange: (z, Z, G) => {
      isMobileDevice() && Z.pointerType === "touch" && G === "outside-press" || S(z, z ? "trigger" : "outside");
    },
    placement: "bottom-start",
    middleware: [
      offset$2({
        mainAxis: g,
        alignmentAxis: 0
      }),
      s === "match-trigger" && size({
        apply: ({ rects: z }) => {
          P.refs.floating.current && Object.assign(P.refs.floating.current.style, {
            width: `${z.reference.width}px`
          });
        }
      }),
      flip$2(),
      !c && shift()
    ],
    whileElementsMounted: autoUpdate
  }), [L, I] = useState$1(null), T = useRef$1([]), E = useRef$1([]), R = useListNavigation(M, {
    listRef: T,
    activeIndex: L,
    onNavigate: I,
    focusItemOnOpen: p,
    loop: !0,
    virtual: h
  }), A = useTypeahead(M, {
    listRef: E,
    activeIndex: L,
    onMatch: I,
    enabled: !u
  }), k = useClick(M, { enabled: !d }), V = useRole(M, { role: m }), B = useDismiss(M), q = useInteractions([k, V, B, R, A]);
  return {
    ...P,
    ...q,
    activeIndex: L,
    setActiveIndex: I,
    elementsRef: T,
    labelsRef: E,
    context: M,
    isOpen: r,
    setIsOpen: a,
    trigger: v,
    isDisabled: y,
    isReadOnly: x,
    initialFocus: w
  };
}, BaseMenuContext = React__default.createContext({}), useBaseMenuContext = () => useContext$1(BaseMenuContext), MenuContext = ({ onOpenChange: r, isOpen: a, isDisabled: s, isReadOnly: c, children: u, ...d }) => {
  const h = useBaseMenu({
    onOpenChange: (p, m) => {
      s || c || r(p, m);
    },
    isOpen: s || c ? !1 : a,
    isDisabled: s,
    isReadOnly: c,
    ...d
  });
  return /* @__PURE__ */ jsx(BaseMenuContext.Provider, { value: h, children: u });
};
MenuContext.displayName = "MenuContext";
const _GroupItem = forwardRef$1(
  ({ children: r, order: a, grow: s, shrink: c, basis: u, alignSelf: d }, h) => {
    const p = useStyleConfig("GroupItem", { order: a, grow: s, shrink: c, basis: u, alignSelf: d });
    return /* @__PURE__ */ jsx(Box, { ...{
      "data-component": "Group.Item",
      ref: h,
      __css: p
    }, children: r });
  }
);
_GroupItem.displayName = "Group.Item";
const GroupVariants = {
  horizontal: "horizontal",
  vertical: "vertical"
}, GroupDivider = ({ isVertical: r, dividerProps: a }) => /* @__PURE__ */ jsx(
  Box,
  {
    as: (s) => /* @__PURE__ */ jsx(Divider, { ...s, variant: r ? "vertical" : "horizontal", ...a }),
    alignSelf: "stretch",
    height: r ? "auto" : void 0,
    flexGrow: 0,
    "data-component": "GroupDivider"
  }
);
GroupDivider.displayName = "GroupDivider";
const Group$1 = forwardRef$1(
  ({
    children: r,
    spacing: a = "s",
    variant: s = GroupVariants.horizontal,
    hasDivider: c,
    width: u = "auto",
    height: d = "auto",
    as: h,
    allowOverflowX: p,
    dividerProps: m,
    ...g
  }, v) => {
    const y = useStyleConfig("Group", { variant: s, spacing: a, width: u, height: d, allowOverflowX: p }), x = Children.toArray(r), w = h === "ul" || h === "ol", S = (M, P) => isValidElement(M) ? M.key : P;
    return /* @__PURE__ */ jsx(Box, { "data-component": "Group", ...g, as: h, ref: v, __css: y, children: x.map(
      (M, P) => c && P + 1 < x.length ? /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        M,
        /* @__PURE__ */ jsx(
          GroupDivider,
          {
            isVertical: s === GroupVariants.horizontal,
            dividerProps: { as: w ? "li" : "div", ...m }
          },
          P
        )
      ] }, S(M, P)) : /* @__PURE__ */ jsx(React__default.Fragment, { children: M }, S(M, P))
    ) });
  }
);
Group$1.displayName = "Group";
const Group = Object.assign(Group$1, { Item: _GroupItem }), Dropdown = forwardRef$1(
  ({
    content: r,
    width: a,
    header: s,
    footer: c,
    maxHeight: u,
    "data-testid": d = "base-menu-dropdown",
    maxWidth: h,
    hasItems: p,
    "data-component": m,
    shouldTrapFocus: g = !1,
    initialFocus: v,
    ...y
  }, x) => {
    const { refs: w, elementsRef: S, floatingStyles: M, labelsRef: P, getFloatingProps: L, isOpen: I, context: T } = useBaseMenuContext(), E = useMergeRefs([w.setFloating, x]), R = useTestId(d), A = useMultiStyleConfig("BaseMenu", {
      width: a,
      maxWidth: h,
      maxHeight: u
    }), { onKeyDown: k, role: V, ...B } = L({
      ...y,
      onKeyDown: (z) => {
        z.stopPropagation();
      }
    }), q = p ? V : void 0;
    return /* @__PURE__ */ jsx(Fragment, { children: I && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(FloatingFocusManager, { context: T, modal: g, initialFocus: v, children: /* @__PURE__ */ jsx(
      Box,
      {
        ref: E,
        __css: { ...A.dropdown, ...M },
        "data-component": m,
        ...R(),
        onKeyDown: k,
        onClick: (z) => z.stopPropagation(),
        ...B,
        role: q,
        children: /* @__PURE__ */ jsx(FloatingList, { elementsRef: S, labelsRef: P, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", hasDivider: !0, width: "full", ...R("container"), children: [
          s && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: s }),
          r,
          c && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: c })
        ] }) })
      }
    ) }) }) });
  }
), Trigger$1 = React__default.forwardRef((r, a) => {
  const { getReferenceProps: s, refs: c, trigger: u, isDisabled: d, isReadOnly: h } = useBaseMenuContext(), p = mergeRefs([c.setReference, a]), m = {
    "aria-disabled": d,
    "data-readonly": h || null,
    ref: p,
    tabIndex: d ? -1 : 0
  };
  return isValidElement(u) ? cloneElement(u, {
    role: "button",
    ...s({
      onClick: (g) => {
        g.stopPropagation();
      },
      ...m,
      ...u.props,
      ...r
    }),
    // floating ui - `getReferenceProps`, always returns `onClick`
    // we want `trigger` to know when it's clickable so we override it
    ...d && { onClick: void 0 }
  }) : /* @__PURE__ */ jsx(Fragment, { children: u });
}), BaseMenu$1 = forwardRef$1(
  ({
    trigger: r,
    content: a,
    isOpen: s,
    onOpenChange: c,
    header: u,
    footer: d,
    width: h = "240px",
    maxWidth: p,
    maxHeight: m = "256px",
    isDisabled: g,
    isReadOnly: v,
    disableMenuShift: y,
    disableTypeahead: x,
    disableOpenByTriggerClick: w,
    isVirtualList: S,
    role: M = "menu",
    dropdownTestId: P,
    hasItems: L = !0,
    "data-component": I = "BaseMenu",
    focusItemOnOpen: T,
    ...E
  }, R) => /* @__PURE__ */ jsxs(
    MenuContext,
    {
      isOpen: s,
      onOpenChange: c,
      trigger: r,
      width: h,
      disableMenuShift: y,
      disableTypeahead: x,
      disableOpenByTriggerClick: w,
      isVirtualList: S,
      role: M,
      isDisabled: g,
      isReadOnly: v,
      focusItemOnOpen: T,
      children: [
        /* @__PURE__ */ jsx(Trigger$1, { ref: R }),
        /* @__PURE__ */ jsx(
          Dropdown,
          {
            width: h,
            maxWidth: p,
            maxHeight: m,
            header: u,
            content: a,
            footer: d,
            "data-testid": P,
            hasItems: L,
            "data-component": I,
            ...E
          }
        )
      ]
    }
  )
);
BaseMenu$1.displayName = "BaseMenu";
const Container = forwardRef$1(
  ({
    border: r = BorderOptions.None,
    backgroundColor: a = BackgroundColorOptions.Default,
    paddingX: s = "none",
    paddingY: c = "none",
    paddingTop: u,
    paddingBottom: d,
    paddingLeft: h,
    paddingRight: p,
    isSticky: m,
    alignItems: g,
    justifyContent: v,
    textAlign: y,
    width: x = "full",
    height: w = "auto",
    overflow: S = "hidden",
    position: M = "initial",
    maxWidth: P = "none",
    top: L = "initial",
    ...I
  }, T) => {
    const E = useStyleConfig("Container", {
      ...I,
      border: r,
      backgroundColor: a,
      paddingX: s,
      paddingY: c,
      paddingTop: u,
      paddingBottom: d,
      paddingLeft: h,
      paddingRight: p,
      isSticky: m,
      alignItems: g,
      justifyContent: v,
      textAlign: y,
      width: x,
      height: w,
      overflow: S,
      position: M,
      maxWidth: P,
      top: L
    });
    return /* @__PURE__ */ jsx(Box, { "data-component": "Container", ...I, ref: T, __css: E });
  }
);
Container.displayName = "Container";
const BaseMenuDivider = forwardRef$1(({ children: r, ...a }, s) => /* @__PURE__ */ jsx(Container, { "data-component": "BaseMenu.Divider", "aria-hidden": !0, overflow: "initial", paddingY: "xxs", ...a, ref: s, children: /* @__PURE__ */ jsx(Divider, {}) }));
BaseMenuDivider.displayName = "BaseMenu.Divider";
const DropdownList = forwardRef$1(
  ({ children: r, paddingY: a = "none", as: s = "ul", ...c }, u) => {
    const d = useMultiStyleConfig("BaseMenu", { dropdownListPaddingY: a });
    return /* @__PURE__ */ jsx(Box, { __css: d.dropdownList, as: s, ...c, ref: u, children: r });
  }
), BaseMenuFooter = forwardRef$1((r, a) => /* @__PURE__ */ jsx(Container, { paddingY: "s", paddingX: "s", ...r, ref: a })), BaseMenuHeader = forwardRef$1((r, a) => /* @__PURE__ */ jsx(Container, { paddingY: "s", paddingX: "s", ...r, ref: a })), Item = forwardRef$1(
  ({ onClick: r, children: a, isSelected: s, disabled: c, label: u, index: d, ...h }, p) => {
    const { getItemProps: m, activeIndex: g, elementsRef: v } = useBaseMenuContext(), { ref: y, index: x } = useListItem({ label: u }), w = useMultiStyleConfig("BaseMenu", {}), S = d ?? x, P = useMergeRefs([y, (V) => {
      v.current[S] = V;
    }, p]), L = c == null ? void 0 : c.message, I = !!(c != null && c.isDisabled && L), T = (c == null ? void 0 : c.isDisabled) || !1, E = !T && g === S, R = (V) => {
      ["Space", "Enter"].includes(V.code) && (V.preventDefault(), r == null || r(V, "content"));
    }, { onMouseMove: A, ...k } = m({
      ref: P,
      tabIndex: E ? 0 : -1,
      onClick: T ? void 0 : (V) => r == null ? void 0 : r(V, "content"),
      onKeyDown: R,
      ...h
    });
    return /* @__PURE__ */ jsx(Tooltip, { content: L, isEnabled: I, disableFocusTrigger: !0, children: /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "BaseMenu.Item",
        role: "menuitem",
        as: "li",
        "data-testid": `base-menu-item-${S}`,
        "aria-selected": s,
        "aria-disabled": T,
        "data-highlighted": E || null,
        __css: w.item,
        ...k,
        onMouseMove: T ? void 0 : A,
        children: a
      }
    ) });
  }
);
Item.displayName = "BaseMenu.Item";
const BaseMenuSection = forwardRef$1(
  ({ children: r, label: a, "data-testid": s = "base-menu-section", ...c }, u) => {
    const d = lodashExports.uniqueId("section-"), h = useTestId(s), p = useMultiStyleConfig("BaseMenu", {});
    return /* @__PURE__ */ jsxs(
      Group,
      {
        variant: "vertical",
        alignItems: "center",
        spacing: "none",
        role: "group",
        "aria-labelledby": d,
        ref: u,
        ...h(),
        ...c,
        children: [
          /* @__PURE__ */ jsx(Container, { paddingX: "s", paddingY: "xs-s", as: "h3", id: d, ...h("title"), children: /* @__PURE__ */ jsx(
            ConditionalWrapper,
            {
              condition: typeof a == "string",
              wrapper: (m) => /* @__PURE__ */ jsx(Box, { as: "span", __css: p.sectionLabel, children: m }),
              children: a
            }
          ) }),
          /* @__PURE__ */ jsx(Container, { "data-testid": !0, as: "ul", ...h("content"), children: r })
        ]
      }
    );
  }
), BaseMenuSelectionItem = ({
  children: r,
  isSelected: a = !1,
  isMulti: s = !1,
  ...c
}) => /* @__PURE__ */ jsx(Item, { "data-component": "BaseMenu.SelectionItem", ...c, isSelected: a, children: /* @__PURE__ */ jsx(
  ConditionalWrapper,
  {
    condition: a || s,
    wrapper: (u) => /* @__PURE__ */ jsx(Group, { alignItems: "center", spacing: "s", width: "full", children: u }),
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      s && /* @__PURE__ */ jsx(CheckboxInput, { isChecked: a, tabIndex: -1, "aria-hidden": !0 }),
      r,
      /* @__PURE__ */ jsx(Group.Item, { grow: 1 }),
      a && !s && /* @__PURE__ */ jsx(Icon, { size: "small", type: "checked", color: "brand", "aria-hidden": !0 })
    ] })
  }
) });
BaseMenuSelectionItem.displayName = "BaseMenu.SelectionItem";
const ActionTrigger = forwardRef$1(
  ({ icon: r, variant: a = "default", label: s, size: c, ...u }, d) => {
    const { isOpen: h } = useBaseMenuContext(), p = r && (c === "medium" ? /* @__PURE__ */ jsx(Container, { alignItems: "center", paddingLeft: "xxs", children: /* @__PURE__ */ jsx(Icon, { "aria-hidden": !0, size: "small", type: r, color: "inherit" }) }) : /* @__PURE__ */ jsx(Icon, { "aria-hidden": !0, size: "small", type: r, color: "inherit" }));
    return /* @__PURE__ */ jsx(
      Button,
      {
        "data-component": "BaseMenu.ActionTrigger",
        variant: a === "default" ? "tertiary" : "secondary-inverse",
        size: c,
        "aria-haspopup": "menu",
        leftElement: p,
        label: s,
        rightElement: c === "medium" || !p ? /* @__PURE__ */ jsx(Icon, { "aria-hidden": !0, type: h ? "caret-up" : "caret-down", size: "small", color: "inherit" }) : /* @__PURE__ */ jsx(Container, { alignItems: "center", paddingRight: "xxs", children: /* @__PURE__ */ jsx(Icon, { "aria-hidden": !0, type: h ? "caret-up" : "caret-down", size: "small", color: "inherit" }) }),
        ...u,
        ref: d
      }
    );
  }
);
ActionTrigger.displayName = "BaseMenu.ActionTrigger";
const ThreeDotsTrigger = forwardRef$1(
  ({ variant: r = "default", ...a }, s) => /* @__PURE__ */ jsx(
    IconButton,
    {
      "data-component": "BaseMenu.ThreeDotsTrigger",
      ...a,
      ref: s,
      size: "large",
      icon: "more",
      "aria-haspopup": "menu",
      variant: r === "default" ? "primary" : "primaryInverse"
    }
  )
);
ThreeDotsTrigger.displayName = "BaseMenu.ThreeDotsTrigger";
const menuTriggers = {
  ActionTrigger,
  ThreeDotsTrigger
}, menuComponents = {
  Item,
  SelectionItem: BaseMenuSelectionItem,
  Header: BaseMenuHeader,
  Footer: BaseMenuFooter,
  Section: BaseMenuSection,
  Divider: BaseMenuDivider,
  DropdownList,
  ...menuTriggers
}, BaseMenu = Object.assign(BaseMenu$1, menuComponents), FloatingMenu = Object.assign(BaseMenu$1, menuComponents), _MenuFooter = forwardRef$1(
  ({ label: r, isDisabled: a, onClick: s, dataTestId: c, children: u, ...d }, h) => {
    const [p, m] = useState$1(!1), g = useStyleConfig("_MenuFooter"), { getItemProps: v, activeIndex: y } = useBaseMenuContext(), { ref: x, index: w } = useListItem(), S = () => {
      a || s == null || s();
    }, M = v({
      ref: x,
      tabIndex: y === w ? 0 : -1,
      onClick: S,
      onKeyDown: (L) => {
        L.preventDefault(), L.key === "Enter" && S();
      }
    }), P = isValidElement(u) && cloneElement(u, { "data-hover": p || void 0, isDisabled: a, ...M });
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref: h,
        "data-component": "Menu.Footer",
        __css: g,
        role: "menuitem",
        "data-disabled": a || void 0,
        ...d,
        "aria-label": r,
        onMouseEnter: () => m(!0),
        onMouseLeave: () => m(!1),
        "data-testid": c ?? "menu-footer-btn",
        children: P
      }
    );
  }
);
_MenuFooter.displayName = "Menu.Footer";
const _MenuTitle = forwardRef$1(({ label: r, ...a }, s) => {
  const c = useStyleConfig("_MenuTitle");
  return /* @__PURE__ */ jsx(Box, { ref: s, "data-component": "Menu.Title", __css: c, role: "menuitem", "aria-label": r, ...a, children: /* @__PURE__ */ jsx(Typography.SectionLabel, { label: r }) });
});
_MenuTitle.displayName = "Menu.Title";
const _MenuTrigger = React__default.forwardRef((r, a) => {
  const { getReferenceProps: s, refs: c, isOpen: u, trigger: d, isDisabled: h, isReadOnly: p } = useBaseMenuContext(), m = useStyleConfig("_MenuTrigger"), g = mergeRefs([c.setReference, a]), v = {
    role: "button",
    "aria-expanded": u,
    "aria-disabled": h,
    "data-readonly": p || null,
    ref: g,
    "data-testid": r["data-testid"] ?? "menu-wrapper-trigger",
    tabIndex: h || p ? -1 : 0
  };
  return React__default.isValidElement(d) ? React__default.cloneElement(
    d,
    s({
      onClick(y) {
        y.stopPropagation();
      },
      ...v,
      ...d.props
    })
  ) : /* @__PURE__ */ jsx(Box, { __css: m, ...v, ...s(), children: d });
}), BottomSheet$1 = forwardRef$1((r, a) => /* @__PURE__ */ jsx(_BaseSheet$1, { "data-component": "BottomSheet", ref: a, ...r, placement: "bottom" }));
BottomSheet$1.displayName = "BottomSheet";
const components$3 = components$4, BottomSheet = Object.assign(BottomSheet$1, components$3), _MobileMenuDropdown = forwardRef$1(
  ({ children: r, dropdownTestId: a, title: s, footer: c, ...u }, d) => {
    const p = !!Children.count(r), m = useMultiStyleConfig("_MobileMenuDropdown", {
      hasTitle: !!s
    }), { isOpen: g, setIsOpen: v, refs: y, elementsRef: x, labelsRef: w, getFloatingProps: S } = useBaseMenuContext(), M = !!(c != null && c.label) && /* @__PURE__ */ jsx(_MenuFooter, { ...c, children: typeof (c == null ? void 0 : c.children) == "string" ? /* @__PURE__ */ jsx(Box, { children: c == null ? void 0 : c.children }) : c.children });
    return /* @__PURE__ */ jsx(
      BottomSheet,
      {
        "data-component": "_MobileMenu",
        ...u,
        onClose: () => v(!1),
        isOpen: g,
        "data-testid": a,
        ref: d,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            "data-testid": "mobile-menu-dropdown-menu-list",
            ref: y.setFloating,
            ...S({
              onClick: (P) => P.stopPropagation()
            }),
            children: /* @__PURE__ */ jsx(FloatingList, { elementsRef: x, labelsRef: w, children: /* @__PURE__ */ jsxs(Group, { spacing: "none", variant: "vertical", children: [
              /* @__PURE__ */ jsx(BottomSheet.Header, { children: s ? /* @__PURE__ */ jsx(Box, { role: "menuitem", __css: m.title, "aria-label": s, children: /* @__PURE__ */ jsx(Typography.SectionLabel, { label: s }) }) : void 0 }),
              /* @__PURE__ */ jsx(Box, { __css: m.items, children: /* @__PURE__ */ jsxs(Group, { hasDivider: !0, variant: "vertical", spacing: "none", children: [
                p && /* @__PURE__ */ jsx(BottomSheet.Body, { children: /* @__PURE__ */ jsx(Group, { variant: "vertical", spacing: "xs", children: r }) }),
                M && /* @__PURE__ */ jsx(BottomSheet.Footer, { children: M })
              ] }) })
            ] }) })
          }
        )
      }
    );
  }
);
_MobileMenuDropdown.displayName = "_MobileMenuDropdown";
const Menu = forwardRef$1(
  ({
    children: r,
    onOpenChange: a,
    isOpen: s,
    title: c,
    footer: u,
    size: d,
    dropdownTestId: h,
    maxHeight: p,
    trigger: m,
    isDisabled: g,
    isReadOnly: v,
    shouldTrapFocus: y,
    hasItems: x = !0,
    hasSections: w,
    ...S
  }, M) => {
    const { isExtraSmallScreen: P } = useBreakpoint(), I = useBreakpointValue({ xs: "100vw", s: d === "small" && "198px" || d === "large" && "234px" || "fit-content" });
    return P ? /* @__PURE__ */ jsxs(
      MenuContext,
      {
        isOpen: s,
        onOpenChange: a,
        trigger: m,
        isDisabled: g,
        isReadOnly: v,
        width: I,
        focusItemOnOpen: !1,
        children: [
          /* @__PURE__ */ jsx(_MenuTrigger, { ref: M, ...S }),
          /* @__PURE__ */ jsx(_MobileMenuDropdown, { title: c, footer: u, size: d, dropdownTestId: h, children: r })
        ]
      }
    ) : /* @__PURE__ */ jsx(
      FloatingMenu,
      {
        "data-component": "Menu",
        ref: M,
        ...S,
        trigger: m,
        isOpen: !g && s,
        onOpenChange: a,
        content: /* @__PURE__ */ jsxs(FloatingMenu.DropdownList, { paddingY: "xs", as: x && !w ? "ul" : "div", children: [
          c && /* @__PURE__ */ jsx(_MenuTitle, { label: c }),
          r
        ] }),
        footer: u && /* @__PURE__ */ jsx(_MenuFooter, { ...u }),
        width: I,
        maxHeight: p,
        isDisabled: g,
        isReadOnly: v,
        dropdownTestId: h,
        shouldTrapFocus: y,
        hasItems: x
      }
    );
  }
);
Menu.displayName = "Menu";
const variantColor = {
  critical: "semantic.text.critical.rest",
  default: "inherit"
}, MenuItem = forwardRef$1((r, a) => {
  const {
    label: s,
    disabled: c,
    onClick: u,
    variant: d = "default",
    dataTestId: h,
    leftElement: p,
    rightElement: m,
    textStyle: g = "inline",
    ...v
  } = r, y = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", width: "full", children: [
    p,
    /* @__PURE__ */ jsx(Text, { textStyle: g, color: variantColor[d], shouldSupportEllipsis: !0, children: s }),
    /* @__PURE__ */ jsx(Group.Item, { grow: 1 }),
    m
  ] }) });
  return /* @__PURE__ */ jsx(
    FloatingMenu.Item,
    {
      ref: a,
      "data-component": "MenuItem",
      "data-testid": h,
      onClick: c != null && c.isDisabled ? void 0 : () => u == null ? void 0 : u("content"),
      disabled: c,
      ...v,
      children: y
    }
  );
});
MenuItem.displayName = "MenuItem";
const ActionItem = forwardRef$1(
  ({ variant: r = "default", disabled: a, icon: s, ...c }, u) => {
    const { isExtraSmallScreen: d } = useBreakpoint(), h = s ? isBrandSymbol$1(s) ? /* @__PURE__ */ jsx(BrandSymbol, { type: s, size: d ? "medium" : "small", isDisabled: a == null ? void 0 : a.isDisabled }) : /* @__PURE__ */ jsx(Icon, { type: s, size: d ? "large" : "small", color: "inherit", isDisabled: a == null ? void 0 : a.isDisabled }) : void 0;
    return /* @__PURE__ */ jsx(
      MenuItem,
      {
        "data-component": "Menu.ActionItem",
        variant: r,
        ...c,
        textStyle: "body3Semi",
        leftElement: h,
        disabled: a,
        ref: u
      }
    );
  }
);
ActionItem.displayName = "Menu.ActionItem";
const ActionsDropdownMenuComponent = ({
  isOpen: r,
  onOpenChange: a,
  trigger: s,
  label: c,
  title: u,
  items: d,
  size: h = "medium",
  variant: p = "default",
  icon: m,
  isDisabled: g,
  "data-testid": v,
  shouldCloseMenuOnItemClick: y = !0,
  triggerAriaLabel: x,
  isFullWidthTrigger: w = !1,
  dropdownTestId: S = "actions-dropdown-menu-list",
  ...M
}, P) => {
  const { isExtraSmallScreen: L } = useBreakpoint(), I = h === "small" ? /* @__PURE__ */ jsx(
    FloatingMenu.ThreeDotsTrigger,
    {
      "data-component": "ActionsDropdownMenu",
      "aria-label": x,
      "aria-expanded": r,
      "data-testid": v ?? "actions-dropdown-menu",
      variant: p,
      ...M
    }
  ) : /* @__PURE__ */ jsx(
    FloatingMenu.ActionTrigger,
    {
      "data-component": "ActionsDropdownMenu",
      size: h,
      label: c,
      "aria-label": x,
      "aria-expanded": r,
      variant: p,
      icon: m,
      "data-testid": v ?? "actions-dropdown-menu",
      isFullWidth: w,
      ...M
    }
  );
  return /* @__PURE__ */ jsx(
    Menu,
    {
      dropdownTestId: S,
      ...M,
      isOpen: r,
      onOpenChange: a,
      size: h === "large" ? "large" : "small",
      trigger: s ?? I,
      title: u ?? (L ? c : void 0),
      isDisabled: g,
      ref: P,
      children: d.map(({ dataTestId: T, label: E, onClick: R, ...A }, k) => /* @__PURE__ */ createElement$1(
        ActionItem,
        {
          "data-testid": T ?? `actions-dropdown-menu-item-${k}`,
          onClick: () => {
            y && a(!1), R == null || R();
          },
          ...A,
          label: E,
          key: `${E}-${k}`
        }
      ))
    }
  );
}, ActionsDropdownMenu = forwardRef$1(ActionsDropdownMenuComponent);
ActionsDropdownMenu.displayName = "ActionsDropdownMenu";
const _TableCell = forwardRef$1(
  ({ children: r, placeholder: a, onClick: s, textAlign: c = "start", isLoading: u, isDisabled: d, onKeyDown: h, ...p }, m) => {
    const g = React__default.Children.toArray(r).length > 0, v = !!s && !d, y = useStyleConfig("TableCell", {
      hasChildren: g,
      isClickable: v,
      textAlign: c
    });
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref: m,
        "data-component": "_TableCell",
        __css: y,
        onClick: (S) => {
          v && (S.stopPropagation(), s == null || s(S));
        },
        onKeyDown: (S) => {
          h && (S.stopPropagation(), h == null || h(S));
        },
        "aria-disabled": d,
        ...p,
        children: g ? r : a
      }
    );
  }
);
_TableCell.displayName = "_TableCell";
const _TableActionsCell = forwardRef$1(
  ({
    options: r,
    isDisabled: a = !1,
    isLoading: s,
    tooltipLabel: c = "Options",
    "aria-label": u = "Table actions trigger",
    ...d
  }, h) => {
    const [p, m] = useState$1(!1);
    return s ? /* @__PURE__ */ jsx(_TableCell, { ref: h }) : /* @__PURE__ */ jsx(
      _TableCell,
      {
        "data-component": "_TableActionsCell",
        "data-testid": "table-actions-cell",
        ref: h,
        ...d,
        textAlign: "center",
        children: /* @__PURE__ */ jsx(Tooltip, { content: c, isEnabled: !p, children: /* @__PURE__ */ jsx(
          ActionsDropdownMenu,
          {
            isOpen: p,
            onOpenChange: m,
            trigger: /* @__PURE__ */ jsx(
              IconButton,
              {
                isDisabled: a,
                icon: "more-vertical",
                "data-testid": "table-actions-cell-button",
                size: "small",
                variant: "naked",
                "aria-label": u
              }
            ),
            isDisabled: a,
            items: r
          }
        ) })
      }
    );
  }
);
_TableActionsCell.displayName = "_TableActionsCell";
const _TableAmountCell = forwardRef$1(
  ({ value: r = 0, additionalAmount: a, currency: s = defaultCurrency, textAlign: c = "end", isDisabled: u, ...d }, h) => {
    const { formatCurrency: p } = useIntl(), m = !!r, g = useMultiStyleConfig("TableAmountCell", { hasValue: m }), v = (y) => `${y > 0 ? "+" : ""}${p(y, s)}`;
    return /* @__PURE__ */ jsx(_TableCell, { ref: h, "data-component": "_TableAmountCell", textAlign: c, isDisabled: u, ...d, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxs", children: [
      /* @__PURE__ */ jsx(Box, { __css: g.value, "aria-disabled": u, children: p(m ? r : 0, s) }),
      m && !!a && /* @__PURE__ */ jsxs(Box, { __css: g.additionalAmount, "aria-disabled": u, children: [
        v(a.amount),
        a.tooltip && !u && /* @__PURE__ */ jsx(_IconIndicator, { variant: "informative", tooltip: a.tooltip })
      ] })
    ] }) });
  }
);
_TableAmountCell.displayName = "_TableAmountCell";
var reactTextMask = { exports: {} };
(function(r, a) {
  (function(s, c) {
    r.exports = c(React__default);
  })(commonjsGlobal, function(s) {
    return function(c) {
      function u(h) {
        if (d[h]) return d[h].exports;
        var p = d[h] = { exports: {}, id: h, loaded: !1 };
        return c[h].call(p.exports, p, p.exports, u), p.loaded = !0, p.exports;
      }
      var d = {};
      return u.m = c, u.c = d, u.p = "", u(0);
    }([function(c, u, d) {
      function h(A) {
        return A && A.__esModule ? A : { default: A };
      }
      function p(A, k) {
        var V = {};
        for (var B in A) k.indexOf(B) >= 0 || Object.prototype.hasOwnProperty.call(A, B) && (V[B] = A[B]);
        return V;
      }
      function m(A, k) {
        if (!(A instanceof k)) throw new TypeError("Cannot call a class as a function");
      }
      function g(A, k) {
        if (!A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !k || typeof k != "object" && typeof k != "function" ? A : k;
      }
      function v(A, k) {
        if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof k);
        A.prototype = Object.create(k && k.prototype, { constructor: { value: A, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(A, k) : A.__proto__ = k);
      }
      Object.defineProperty(u, "__esModule", { value: !0 }), u.conformToMask = void 0;
      var y = Object.assign || function(A) {
        for (var k = 1; k < arguments.length; k++) {
          var V = arguments[k];
          for (var B in V) Object.prototype.hasOwnProperty.call(V, B) && (A[B] = V[B]);
        }
        return A;
      }, x = /* @__PURE__ */ function() {
        function A(k, V) {
          for (var B = 0; B < V.length; B++) {
            var q = V[B];
            q.enumerable = q.enumerable || !1, q.configurable = !0, "value" in q && (q.writable = !0), Object.defineProperty(k, q.key, q);
          }
        }
        return function(k, V, B) {
          return V && A(k.prototype, V), B && A(k, B), k;
        };
      }(), w = d(3);
      Object.defineProperty(u, "conformToMask", { enumerable: !0, get: function() {
        return h(w).default;
      } });
      var S = d(11), M = h(S), P = d(9), L = h(P), I = d(5), T = h(I), E = d(2), R = function(A) {
        function k() {
          var V;
          m(this, k);
          for (var B = arguments.length, q = Array(B), z = 0; z < B; z++) q[z] = arguments[z];
          var Z = g(this, (V = k.__proto__ || Object.getPrototypeOf(k)).call.apply(V, [this].concat(q)));
          return Z.setRef = Z.setRef.bind(Z), Z.onBlur = Z.onBlur.bind(Z), Z.onChange = Z.onChange.bind(Z), Z;
        }
        return v(k, A), x(k, [{ key: "setRef", value: function(V) {
          this.inputElement = V;
        } }, { key: "initTextMask", value: function() {
          var V = this.props, B = this.props.value;
          this.textMaskInputElement = (0, T.default)(y({ inputElement: this.inputElement }, V)), this.textMaskInputElement.update(B);
        } }, { key: "componentDidMount", value: function() {
          this.initTextMask();
        } }, { key: "componentDidUpdate", value: function(V) {
          var B = this.props, q = B.value, z = B.pipe, Z = B.mask, G = B.guide, K = B.placeholderChar, U = B.showMask, F = { guide: G, placeholderChar: K, showMask: U }, N = typeof z == "function" && typeof V.pipe == "function" ? z.toString() !== V.pipe.toString() : (0, E.isNil)(z) && !(0, E.isNil)(V.pipe) || !(0, E.isNil)(z) && (0, E.isNil)(V.pipe), D = Z.toString() !== V.mask.toString(), j = Object.keys(F).some(function(W) {
            return F[W] !== V[W];
          }) || D || N, H = q !== this.inputElement.value;
          (H || j) && this.initTextMask();
        } }, { key: "render", value: function() {
          var B = this.props, q = B.render, z = p(B, ["render"]);
          return delete z.mask, delete z.guide, delete z.pipe, delete z.placeholderChar, delete z.keepCharPositions, delete z.value, delete z.onBlur, delete z.onChange, delete z.showMask, q(this.setRef, y({ onBlur: this.onBlur, onChange: this.onChange, defaultValue: this.props.value }, z));
        } }, { key: "onChange", value: function(V) {
          this.textMaskInputElement.update(), typeof this.props.onChange == "function" && this.props.onChange(V);
        } }, { key: "onBlur", value: function(V) {
          typeof this.props.onBlur == "function" && this.props.onBlur(V);
        } }]), k;
      }(M.default.PureComponent);
      u.default = R, R.propTypes = { mask: L.default.oneOfType([L.default.array, L.default.func, L.default.bool, L.default.shape({ mask: L.default.oneOfType([L.default.array, L.default.func]), pipe: L.default.func })]).isRequired, guide: L.default.bool, value: L.default.oneOfType([L.default.string, L.default.number]), pipe: L.default.func, placeholderChar: L.default.string, keepCharPositions: L.default.bool, showMask: L.default.bool }, R.defaultProps = { render: function(A, k) {
        return M.default.createElement("input", y({ ref: A }, k));
      } };
    }, function(c, u) {
      Object.defineProperty(u, "__esModule", { value: !0 }), u.placeholderChar = "_", u.strFunction = "function";
    }, function(c, u, d) {
      function h() {
        var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : w, P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x.placeholderChar;
        if (!p(M)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
        if (M.indexOf(P) !== -1) throw new Error(`Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.

` + ("The placeholder character that was received is: " + JSON.stringify(P) + `

`) + ("The mask that was received is: " + JSON.stringify(M)));
        return M.map(function(L) {
          return L instanceof RegExp ? P : L;
        }).join("");
      }
      function p(M) {
        return Array.isArray && Array.isArray(M) || M instanceof Array;
      }
      function m(M) {
        return typeof M == "string" || M instanceof String;
      }
      function g(M) {
        return typeof M == "number" && M.length === void 0 && !isNaN(M);
      }
      function v(M) {
        return typeof M > "u" || M === null;
      }
      function y(M) {
        for (var P = [], L = void 0; L = M.indexOf(S), L !== -1; ) P.push(L), M.splice(L, 1);
        return { maskWithoutCaretTraps: M, indexes: P };
      }
      Object.defineProperty(u, "__esModule", { value: !0 }), u.convertMaskToPlaceholder = h, u.isArray = p, u.isString = m, u.isNumber = g, u.isNil = v, u.processCaretTraps = y;
      var x = d(1), w = [], S = "[]";
    }, function(c, u, d) {
      function h() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : y, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : v, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!(0, m.isArray)(w)) {
          if ((typeof w > "u" ? "undefined" : p(w)) !== g.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
          w = w(x, S), w = (0, m.processCaretTraps)(w).maskWithoutCaretTraps;
        }
        var M = S.guide, P = M === void 0 || M, L = S.previousConformedValue, I = L === void 0 ? y : L, T = S.placeholderChar, E = T === void 0 ? g.placeholderChar : T, R = S.placeholder, A = R === void 0 ? (0, m.convertMaskToPlaceholder)(w, E) : R, k = S.currentCaretPosition, V = S.keepCharPositions, B = P === !1 && I !== void 0, q = x.length, z = I.length, Z = A.length, G = w.length, K = q - z, U = K > 0, F = k + (U ? -K : 0), N = F + Math.abs(K);
        if (V === !0 && !U) {
          for (var D = y, j = F; j < N; j++) A[j] === E && (D += E);
          x = x.slice(0, F) + D + x.slice(F, q);
        }
        for (var H = x.split(y).map(function(ne, se) {
          return { char: ne, isNew: se >= F && se < N };
        }), W = q - 1; W >= 0; W--) {
          var re = H[W].char;
          if (re !== E) {
            var ae = W >= F && z === G;
            re === A[ae ? W - K : W] && H.splice(W, 1);
          }
        }
        var ee = y, X = !1;
        e: for (var J = 0; J < Z; J++) {
          var ie = A[J];
          if (ie === E) {
            if (H.length > 0) for (; H.length > 0; ) {
              var oe = H.shift(), fe = oe.char, ve = oe.isNew;
              if (fe === E && B !== !0) {
                ee += E;
                continue e;
              }
              if (w[J].test(fe)) {
                if (V === !0 && ve !== !1 && I !== y && P !== !1 && U) {
                  for (var ue = H.length, pe = null, we = 0; we < ue; we++) {
                    var ye = H[we];
                    if (ye.char !== E && ye.isNew === !1) break;
                    if (ye.char === E) {
                      pe = we;
                      break;
                    }
                  }
                  pe !== null ? (ee += fe, H.splice(pe, 1)) : J--;
                } else ee += fe;
                continue e;
              }
              X = !0;
            }
            B === !1 && (ee += A.substr(J, Z));
            break;
          }
          ee += ie;
        }
        if (B && U === !1) {
          for (var Ie = null, Ee = 0; Ee < ee.length; Ee++) A[Ee] === E && (Ie = Ee);
          ee = Ie !== null ? ee.substr(0, Ie + 1) : y;
        }
        return { conformedValue: ee, meta: { someCharsRejected: X } };
      }
      Object.defineProperty(u, "__esModule", { value: !0 });
      var p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
        return typeof x;
      } : function(x) {
        return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
      };
      u.default = h;
      var m = d(2), g = d(1), v = [], y = "";
    }, function(c, u) {
      function d(m) {
        var g = m.previousConformedValue, v = g === void 0 ? p : g, y = m.previousPlaceholder, x = y === void 0 ? p : y, w = m.currentCaretPosition, S = w === void 0 ? 0 : w, M = m.conformedValue, P = m.rawValue, L = m.placeholderChar, I = m.placeholder, T = m.indexesOfPipedChars, E = T === void 0 ? h : T, R = m.caretTrapIndexes, A = R === void 0 ? h : R;
        if (S === 0 || !P.length) return 0;
        var k = P.length, V = v.length, B = I.length, q = M.length, z = k - V, Z = z > 0, G = V === 0, K = z > 1 && !Z && !G;
        if (K) return S;
        var U = Z && (v === M || M === I), F = 0, N = void 0, D = void 0;
        if (U) F = S - z;
        else {
          var j = M.toLowerCase(), H = P.toLowerCase(), W = H.substr(0, S).split(p), re = W.filter(function(de) {
            return j.indexOf(de) !== -1;
          });
          D = re[re.length - 1];
          var ae = x.substr(0, re.length).split(p).filter(function(de) {
            return de !== L;
          }).length, ee = I.substr(0, re.length).split(p).filter(function(de) {
            return de !== L;
          }).length, X = ee !== ae, J = x[re.length - 1] !== void 0 && I[re.length - 2] !== void 0 && x[re.length - 1] !== L && x[re.length - 1] !== I[re.length - 1] && x[re.length - 1] === I[re.length - 2];
          !Z && (X || J) && ae > 0 && I.indexOf(D) > -1 && P[S] !== void 0 && (N = !0, D = P[S]);
          for (var ie = E.map(function(de) {
            return j[de];
          }), oe = ie.filter(function(de) {
            return de === D;
          }).length, fe = re.filter(function(de) {
            return de === D;
          }).length, ve = I.substr(0, I.indexOf(L)).split(p).filter(function(de, Ce) {
            return de === D && P[Ce] !== de;
          }).length, ue = ve + fe + oe + (N ? 1 : 0), pe = 0, we = 0; we < q; we++) {
            var ye = j[we];
            if (F = we + 1, ye === D && pe++, pe >= ue) break;
          }
        }
        if (Z) {
          for (var Ie = F, Ee = F; Ee <= B; Ee++) if (I[Ee] === L && (Ie = Ee), I[Ee] === L || A.indexOf(Ee) !== -1 || Ee === B) return Ie;
        } else if (N) {
          for (var ne = F - 1; ne >= 0; ne--) if (M[ne] === D || A.indexOf(ne) !== -1 || ne === 0) return ne;
        } else for (var se = F; se >= 0; se--) if (I[se - 1] === L || A.indexOf(se) !== -1 || se === 0) return se;
      }
      Object.defineProperty(u, "__esModule", { value: !0 }), u.default = d;
      var h = [], p = "";
    }, function(c, u, d) {
      function h(k) {
        return k && k.__esModule ? k : { default: k };
      }
      function p(k) {
        var V = { previousConformedValue: void 0, previousPlaceholder: void 0 };
        return { state: V, update: function(B) {
          var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : k, z = q.inputElement, Z = q.mask, G = q.guide, K = q.pipe, U = q.placeholderChar, F = U === void 0 ? L.placeholderChar : U, N = q.keepCharPositions, D = N !== void 0 && N, j = q.showMask, H = j !== void 0 && j;
          if (typeof B > "u" && (B = z.value), B !== V.previousConformedValue) {
            (typeof Z > "u" ? "undefined" : y(Z)) === E && Z.pipe !== void 0 && Z.mask !== void 0 && (K = Z.pipe, Z = Z.mask);
            var W = void 0, re = void 0;
            if (Z instanceof Array && (W = (0, P.convertMaskToPlaceholder)(Z, F)), Z !== !1) {
              var ae = g(B), ee = z.selectionEnd, X = V.previousConformedValue, J = V.previousPlaceholder, ie = void 0;
              if ((typeof Z > "u" ? "undefined" : y(Z)) === L.strFunction) {
                if (re = Z(ae, { currentCaretPosition: ee, previousConformedValue: X, placeholderChar: F }), re === !1) return;
                var oe = (0, P.processCaretTraps)(re), fe = oe.maskWithoutCaretTraps, ve = oe.indexes;
                re = fe, ie = ve, W = (0, P.convertMaskToPlaceholder)(re, F);
              } else re = Z;
              var ue = { previousConformedValue: X, guide: G, placeholderChar: F, pipe: K, placeholder: W, currentCaretPosition: ee, keepCharPositions: D }, pe = (0, M.default)(ae, re, ue), we = pe.conformedValue, ye = (typeof K > "u" ? "undefined" : y(K)) === L.strFunction, Ie = {};
              ye && (Ie = K(we, v({ rawValue: ae }, ue)), Ie === !1 ? Ie = { value: X, rejected: !0 } : (0, P.isString)(Ie) && (Ie = { value: Ie }));
              var Ee = ye ? Ie.value : we, ne = (0, w.default)({ previousConformedValue: X, previousPlaceholder: J, conformedValue: Ee, placeholder: W, rawValue: ae, currentCaretPosition: ee, placeholderChar: F, indexesOfPipedChars: Ie.indexesOfPipedChars, caretTrapIndexes: ie }), se = Ee === W && ne === 0, de = H ? W : I, Ce = se ? de : Ee;
              V.previousConformedValue = Ce, V.previousPlaceholder = W, z.value !== Ce && (z.value = Ce, m(z, ne));
            }
          }
        } };
      }
      function m(k, V) {
        document.activeElement === k && (R ? A(function() {
          return k.setSelectionRange(V, V, T);
        }, 0) : k.setSelectionRange(V, V, T));
      }
      function g(k) {
        if ((0, P.isString)(k)) return k;
        if ((0, P.isNumber)(k)) return String(k);
        if (k == null) return I;
        throw new Error(`The 'value' provided to Text Mask needs to be a string or a number. The value received was:

 ` + JSON.stringify(k));
      }
      Object.defineProperty(u, "__esModule", { value: !0 });
      var v = Object.assign || function(k) {
        for (var V = 1; V < arguments.length; V++) {
          var B = arguments[V];
          for (var q in B) Object.prototype.hasOwnProperty.call(B, q) && (k[q] = B[q]);
        }
        return k;
      }, y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(k) {
        return typeof k;
      } : function(k) {
        return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
      };
      u.default = p;
      var x = d(4), w = h(x), S = d(3), M = h(S), P = d(2), L = d(1), I = "", T = "none", E = "object", R = typeof navigator < "u" && /Android/i.test(navigator.userAgent), A = typeof requestAnimationFrame < "u" ? requestAnimationFrame : setTimeout;
    }, function(c, u) {
      function d(p) {
        return function() {
          return p;
        };
      }
      var h = function() {
      };
      h.thatReturns = d, h.thatReturnsFalse = d(!1), h.thatReturnsTrue = d(!0), h.thatReturnsNull = d(null), h.thatReturnsThis = function() {
        return this;
      }, h.thatReturnsArgument = function(p) {
        return p;
      }, c.exports = h;
    }, function(c, u, d) {
      function h(p, m, g, v, y, x, w, S) {
        if (!p) {
          var M;
          if (m === void 0) M = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
          else {
            var P = [g, v, y, x, w, S], L = 0;
            M = new Error(m.replace(/%s/g, function() {
              return P[L++];
            })), M.name = "Invariant Violation";
          }
          throw M.framesToPop = 1, M;
        }
      }
      c.exports = h;
    }, function(c, u, d) {
      var h = d(6), p = d(7), m = d(10);
      c.exports = function() {
        function g(x, w, S, M, P, L) {
          L !== m && p(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        }
        function v() {
          return g;
        }
        g.isRequired = g;
        var y = { array: g, bool: g, func: g, number: g, object: g, string: g, symbol: g, any: g, arrayOf: v, element: g, instanceOf: v, node: g, objectOf: v, oneOf: v, oneOfType: v, shape: v, exact: v };
        return y.checkPropTypes = h, y.PropTypes = y, y;
      };
    }, function(c, u, d) {
      c.exports = d(8)();
    }, function(c, u) {
      var d = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      c.exports = d;
    }, function(c, u) {
      c.exports = s;
    }]);
  });
})(reactTextMask);
var reactTextMaskExports = reactTextMask.exports;
const MaskedInput = /* @__PURE__ */ getDefaultExportFromCjs(reactTextMaskExports), _TableAmountInput = forwardRef$1((r, a) => {
  const { formatCurrency: s } = useIntl(), {
    value: c,
    onChange: u,
    onBlur: d,
    currency: h = defaultCurrency,
    placeholder: p = s(0, h),
    isDisabled: m,
    isReadOnly: g,
    errorMessage: v,
    testKey: y,
    allowNegativeValue: x = !0,
    decimalLimit: w = 2,
    integerLimit: S = defaultIntegerLimit,
    ...M
  } = r, P = useMultiStyleConfig("_TableAmountInput", {}), L = {
    as: MaskedInput,
    guide: !1,
    mask: createNumberMask({
      includeThousandsSeparator: !0,
      thousandsSeparatorSymbol: ",",
      allowDecimal: !0,
      decimalSymbol: ".",
      decimalLimit: w,
      integerLimit: S,
      allowNegative: x,
      currency: h
    })
  }, I = (G) => ["table-amount-input", G, y].filter(Boolean).join("-"), { sign: T } = getCurrencyDetails(h), E = useCallback$1((G) => removeNonDigitsFromCurrency(G), []), R = useCallback$1((G) => Number(G).toFixed(w), [w]), A = useCallback$1(
    (G) => G === T || G === "" ? "" : R(E(G)),
    [R, E, T]
  ), [k, V] = useState$1(c ? A(c == null ? void 0 : c.slice(0, S)) : ""), B = (G) => {
    G.target.value === "" ? V(T) : V(G.target.value);
    const K = G.target.value === "" ? G.target.value : E(G.target.value);
    u == null || u({ target: { value: K } });
  }, q = useRef$1(null), z = () => {
    if (q.current) {
      const G = q.current.inputElement;
      setTimeout(() => {
        const { length: K } = G.value;
        G.setSelectionRange(K, K);
      }, 0);
    }
  }, Z = (G) => {
    if (k === T || k === "")
      V(""), d == null || d({ target: { value: "" } });
    else {
      const K = A(G.target.value);
      V(K), d == null || d({ target: { value: K } });
    }
  };
  return /* @__PURE__ */ jsxs(
    Group,
    {
      "data-component": "_TableAmountInput",
      ref: a,
      "data-testid": I("container"),
      ...M,
      variant: "vertical",
      spacing: "xxxs",
      width: "full",
      children: [
        /* @__PURE__ */ jsx(
          Input$1,
          {
            ...L,
            ref: q,
            sx: P.field,
            value: k,
            placeholder: p,
            onChange: B,
            onBlur: Z,
            onFocus: z,
            onClick: (G) => G.stopPropagation(),
            isDisabled: m,
            isReadOnly: g,
            "data-error": v || void 0,
            "data-testid": I()
          }
        ),
        v && /* @__PURE__ */ jsx(Box, { __css: P.errorMessage, children: /* @__PURE__ */ jsx(Typography.Description, { label: v, isInvalid: !0, "data-testid": I("error-message") }) })
      ]
    }
  );
});
_TableAmountInput.displayName = "_TableAmountInput";
const useIsSelectingDifferentDate = () => {
  const { isDatePartEqual: r } = useDateUtils();
  return { isSelectingDifferentDate: (s) => (c) => !s || !r(c, s) };
}, _DatePicker = forwardRef$1(
  ({
    minDate: r,
    maxDate: a,
    excludeHolidays: s,
    weekDays: c,
    secondarySelectedDate: u,
    showToday: d,
    legendItems: h,
    onSelect: p,
    value: m,
    backButton: g,
    footer: v,
    disableYearSelection: y,
    ...x
  }, w) => {
    const { isExtraSmallScreen: S } = useBreakpoint(), M = useMultiStyleConfig("DatePicker", { backButton: g, legendItems: h }), { setIsOpen: P } = useBaseMenuContext(), L = () => {
      P(!1, "content");
    }, { isSelectingDifferentDate: I } = useIsSelectingDifferentDate(), T = (R) => {
      I(m)(R) && p(R), L();
    }, E = "dropdown-date-picker";
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "_DatePicker",
        "data-testid": E,
        role: "menuitem",
        "aria-label": "date-picker",
        ref: w,
        __css: M.container,
        ...x,
        children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", hasDivider: !0, children: [
          !S && g && /* @__PURE__ */ jsx(
            Box,
            {
              "data-testid": `${x["data-testid"] || E}-back-button`,
              as: "button",
              __css: M.backButton,
              onClick: g.onBack,
              children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", children: [
                /* @__PURE__ */ jsx(Icon, { type: "chevron-left", color: "inherit" }),
                g.label
              ] })
            }
          ),
          /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xs", children: [
            /* @__PURE__ */ jsx(Box, { __css: M.calendarContainer, children: /* @__PURE__ */ jsx(
              _BaseCalendar,
              {
                onSelect: T,
                minDate: r,
                maxDate: a,
                excludeHolidays: s,
                weekDays: c,
                secondarySelectedDate: u,
                showToday: d,
                selectedDate: m,
                legendItems: h,
                isMobileDatePicker: S,
                disableYearSelection: y
              }
            ) }),
            v && /* @__PURE__ */ jsxs(Box, { children: [
              /* @__PURE__ */ jsx(Divider, {}),
              v
            ] })
          ] })
        ] })
      }
    );
  }
);
_DatePicker.displayName = "_DatePicker";
const DatePicker = forwardRef$1(
  ({
    minDate: r,
    maxDate: a,
    excludeHolidays: s,
    weekDays: c,
    secondarySelectedDate: u,
    showToday: d,
    legendItems: h,
    onSelect: p,
    value: m,
    backButton: g,
    size: v,
    trigger: y,
    footer: x,
    "data-testid": w = "date-picker",
    disableYearSelection: S,
    shouldTrapFocus: M = !0,
    ...P
  }, L) => {
    const I = {
      minDate: r,
      maxDate: a,
      excludeHolidays: s,
      weekDays: c,
      secondarySelectedDate: u,
      showToday: d,
      onSelect: p,
      value: m,
      legendItems: h,
      backButton: g,
      footer: x,
      disableYearSelection: S
    }, T = useBreakpointValue({ xs: v, s: "fit-content" }), E = useTestId(w);
    return /* @__PURE__ */ jsx(
      Menu,
      {
        "data-component": "DatePicker",
        ...E(),
        ...P,
        trigger: y,
        size: T,
        maxHeight: "100%",
        ref: L,
        shouldTrapFocus: M,
        hasItems: !1,
        children: /* @__PURE__ */ jsx(_DatePicker, { ...I })
      }
    );
  }
);
DatePicker.displayName = "DatePicker";
const _TableDateCell = forwardRef$1(
  ({
    isReadOnly: r,
    isDisabled: a,
    isLoading: s,
    placeholder: c,
    value: u,
    displayValue: d,
    onSelect: h,
    defaultIsOpen: p,
    weekDays: m,
    excludeHolidays: g,
    secondarySelectedDate: v,
    minDate: y,
    maxDate: x,
    showToday: w,
    backButton: S,
    legendItems: M,
    format: P,
    footer: L,
    isOpen: I,
    onOpenChange: T,
    selectedDate: E,
    shouldTrapFocus: R,
    ...A
  }, k) => {
    const V = !a && !r && !s, [B, q] = useState$1(((p || I) ?? !1) && V), [z, Z] = useState$1(u ?? E ?? void 0), G = I !== void 0 && T !== void 0;
    useEffect$1(() => {
      G && q(I);
    }, [G, I]), useEffect$1(() => {
      Z(E);
    }, [E]), useEffect$1(() => {
      E ? E && u && isEqual(u, E) && Z(u) : Z(u);
    }, [u, E]);
    const K = (W, re) => {
      T ? T(W, re) : q(W);
    }, U = formatDateTime(u, { format: P }), F = u ? a ? "semantic.text.disabled" : "semantic.text.primary" : "semantic.text.secondary", N = typeof d == "string" ? /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: F, shouldSupportEllipsis: !0, children: d }) : d, D = /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: F, shouldSupportEllipsis: !0, children: u ? U : c }), j = (
      // TODO: remove empty onClick. It must be passed in order for the hover background color to show.
      // ticket - ME-452 - https://meliorisk.atlassian.net/browse/ME-452
      /* @__PURE__ */ jsx(
        _TableCell,
        {
          "data-component": "_TableDateCell",
          "data-testid": "table-date-cell",
          onClick: r || a ? void 0 : lodashExports.noop,
          ref: k,
          ...A,
          children: /* @__PURE__ */ jsx(Group, { width: "full", alignItems: "center", justifyContent: "space-between", spacing: "m", children: /* @__PURE__ */ jsxs(Fragment, { children: [
            N ?? D,
            !r && !a && !s && /* @__PURE__ */ jsx(Icon, { type: B ? "caret-up" : "caret-down", size: "small", color: "default", "aria-hidden": !0 })
          ] }) })
        }
      )
    ), H = `${A["data-testid"] || "table-date-cell"}-dropdown-date-picker`;
    return /* @__PURE__ */ jsx(
      DatePicker,
      {
        trigger: j,
        isOpen: B,
        onOpenChange: K,
        isReadOnly: r,
        isDisabled: a,
        onSelect: h,
        value: z,
        weekDays: m,
        excludeHolidays: g,
        secondarySelectedDate: v,
        minDate: y,
        maxDate: x,
        showToday: w,
        backButton: S,
        legendItems: M,
        "data-testid": H,
        footer: L,
        shouldTrapFocus: R
      }
    );
  }
);
_TableDateCell.displayName = "_TableDateCell";
const _TableExpandCell = forwardRef$1(
  ({ isExpanded: r, toggleExpanded: a, ...s }, c) => /* @__PURE__ */ jsx(
    _TableCell,
    {
      "data-component": "TableExpandCell",
      ref: c,
      onClick: a,
      as: "button",
      type: "button",
      "aria-label": `${r ? "expanded" : "closed"}`,
      ...s,
      textAlign: "center",
      children: /* @__PURE__ */ jsx(Icon, { type: `${r ? "chevron-down" : "chevron-right"}` })
    }
  )
);
_TableExpandCell.displayName = "TableExpandCell";
const _TableContext = createContext$1({}), _useTableContext = () => useContext$1(_TableContext), _TableHeaderCell = forwardRef$2(
  ({ textAlign: r = "start", onClick: a, children: s, isDisabled: c, ...u }, d) => {
    const { headerVariant: h } = _useTableContext(), p = useStyleConfig("TableHeaderCell", {
      textAlign: r,
      isClickable: !!a && !c,
      variant: h
    });
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: p,
        "data-component": "_TableHeaderCell",
        onClick: a,
        "aria-disabled": c,
        ...u,
        ref: d,
        children: typeof s == "string" ? /* @__PURE__ */ jsx(Text, { color: "inherit", textStyle: "inline", shouldSupportEllipsis: !0, children: s }) : s ?? "Empty Cell"
      }
    );
  }
);
_TableHeaderCell.displayName = "_TableHeaderCell";
const _TableHeaderCellDescription = forwardRef$1(
  ({ text: r, ...a }, s) => /* @__PURE__ */ jsx(
    Text,
    {
      "data-component": "_TableHeaderCellDescription",
      ...a,
      textStyle: "body4",
      color: "semantic.text.secondary",
      ref: s,
      shouldSupportEllipsis: !0,
      children: r
    }
  )
);
_TableHeaderCellDescription.displayName = "_TableHeaderCellDescription";
const _useCellFocus = ({
  focusedCellId: r,
  ref: a
}) => {
  useEffect$1(() => {
    var c, u;
    ((c = a.current) == null ? void 0 : c.id) === r && ((u = a.current) == null || u.focus());
  }, [r, a]);
}, _TableHeaderSortableCell = forwardRef$2(
  ({
    onClick: r,
    children: a,
    sortDirection: s,
    textAlign: c = "start",
    initialSortDirection: u = "desc",
    instructionsText: d = "Press enter to change sorting",
    "aria-labelledby": h,
    ...p
  }, m) => {
    const [g, v] = useBoolean(!1), y = !!s, x = useMultiStyleConfig("TableHeaderSortableCell", {
      isSorting: y,
      textAlign: c,
      isClickable: !!r
    }), w = useMemo$1(
      () => u === "desc" ? ["none", "desc", "asc"] : ["none", "asc", "desc"],
      [u]
    ), S = {
      none: void 0,
      desc: "arrow-down",
      asc: "arrow-up"
    }, M = useMemo$1(() => w.indexOf(s ?? "none"), [s]), P = useMemo$1(
      () => M === w.length - 1 ? w[0] : w[M + 1],
      [M, w]
    ), L = (s && S[s]) ?? (P && S[P]), T = s ? {
      asc: "sorted ascending",
      desc: "sorted descending"
    }[s] : void 0, E = useCallback$1(() => {
      r == null || r(P === "none" ? void 0 : P);
    }, [r, P]), { focusedCellId: R } = _useTableContext(), A = useRef$1(null), k = mergeRefs([A, m]);
    _useCellFocus({ focusedCellId: R, ref: A });
    const [V, B] = useBoolean(!1), q = useMemo$1(() => lodashExports.uniqueId("header-sortable-cell-children-"), []), z = useMemo$1(() => lodashExports.uniqueId("header-sortable-cell-sort-"), []), Z = useMemo$1(() => {
      const G = [
        h,
        typeof a == "string" && q || void 0,
        V && z || void 0
      ].filter((K) => !!K).join(" ");
      return G ? { "aria-labelledby": G } : {};
    }, [h, a, q, z, V]);
    return /* @__PURE__ */ jsx(
      _TableHeaderCell,
      {
        "data-testid": "header-sortable-cell",
        "data-component": "_TableHeaderSortableCell",
        onClick: r && E,
        ref: k,
        onMouseOver: v.on,
        onMouseOut: v.off,
        "data-hover": r && g || void 0,
        "data-selected": y,
        textAlign: c,
        ...Z,
        onFocus: B.on,
        onBlur: B.off,
        as: "button",
        ...p,
        children: /* @__PURE__ */ jsxs(Group, { spacing: "xs", children: [
          typeof a == "string" ? /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, id: q, children: a }) : a,
          /* @__PURE__ */ jsxs(
            Box,
            {
              __css: x.icon,
              "data-hover": r && g || void 0,
              "data-testid": `header-sortable-cell-icon-${s}`,
              id: z,
              children: [
                /* @__PURE__ */ jsx(VisuallyHidden, { children: T ?? d }),
                /* @__PURE__ */ jsx(Icon, { type: L, color: "inherit", size: "small", "aria-hidden": !0 })
              ]
            }
          )
        ] })
      }
    );
  }
);
_TableHeaderSortableCell.displayName = "_TableHeaderSortableCell";
const _TableMenuTriggerHeaderCell = forwardRef$2(
  ({ label: r, isMenuOpen: a, description: s, tooltipLabel: c, ...u }, d) => {
    const { headerVariant: h, focusedCellId: p } = _useTableContext(), m = useStyleConfig("TableMenuTriggerHeaderCell", {
      variant: h
    }), g = useRef$1(null), v = mergeRefs([g, d]);
    return _useCellFocus({ focusedCellId: p, ref: g }), /* @__PURE__ */ jsx(Tooltip, { content: c ?? "", isEnabled: !!c && !a, children: /* @__PURE__ */ jsx(_TableHeaderCell, { "data-component": "_TableMenuTriggerHeaderCell", as: "button", ...u, ref: v, children: /* @__PURE__ */ jsx(Box, { __css: m, children: /* @__PURE__ */ jsxs(Grid, { templateColumns: "1fr auto", columnGap: "m", rowGap: "xxxs", alignItems: "center", width: "100%", children: [
      /* @__PURE__ */ jsx(Text, { textStyle: "body3Semi", color: "inherit", shouldSupportEllipsis: !0, children: r }),
      /* @__PURE__ */ jsx(Icon, { type: a ? "caret-up" : "caret-down", size: "small", color: "inherit" }),
      s && /* @__PURE__ */ jsx(_TableHeaderCellDescription, { text: s })
    ] }) }) }) });
  }
);
_TableMenuTriggerHeaderCell.displayName = "_TableMenuTriggerHeaderCell";
const _TableMobileContainer = ({
  getRowModel: r,
  onRowClick: a,
  highlightedRowIds: s,
  isLoading: c,
  mobileRowRenderer: u
}) => {
  const d = useMultiStyleConfig("TableMobileContainer", { isLoading: c }), h = (p, m, g) => {
    a && [" ", "Enter"].includes(p.key) && (p.preventDefault(), a({ rowId: m, rowData: g }));
  };
  return /* @__PURE__ */ jsx(Box, { __css: d.container, children: /* @__PURE__ */ jsx(Group, { variant: "vertical", spacing: "none", hasDivider: !0, children: r().rows.map((p) => {
    const { id: m, original: g } = p, v = s == null ? void 0 : s.includes(m);
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: a && "button",
        "data-highlighted": v || null,
        "data-testid": `table-row-${m}`,
        __css: d.row,
        onClick: a ? () => a({ rowId: m, rowData: g }) : void 0,
        onKeyDown: (y) => h(y, m, g),
        tabIndex: a ? 0 : -1,
        children: u(g)
      },
      m
    );
  }) }) });
};
_TableMobileContainer.displayName = "_TableMobileContainer";
const SkipNavLink = forwardRef$1((r, a) => /* @__PURE__ */ jsx(SkipNavLink$1, { ref: a, "data-component": "SkipNavLink", ...r }));
SkipNavLink.displayName = "SkipNavLink";
const _TableSelectableCell = forwardRef$1(
  ({
    isChecked: r,
    isIndeterminate: a,
    onChange: s,
    isDisabled: c,
    "aria-label": u,
    "aria-controls": d,
    isHeader: h,
    skipToLink: p,
    tooltip: m,
    id: g,
    cellDataTestId: v,
    ...y
  }, x) => {
    const w = h ? _TableHeaderCell : _TableCell, { focusedCellId: S } = _useTableContext(), M = useRef$1(null);
    return _useCellFocus({ focusedCellId: S, ref: M }), /* @__PURE__ */ jsxs(w, { ref: x, isDisabled: c, textAlign: "center", "data-testid": v, children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          "data-testid": `table-selectable${h ? "-header" : ""}-cell`,
          "data-component": "TableSelectableCell",
          id: g,
          isChecked: r,
          isIndeterminate: a,
          onChange: s,
          isDisabled: c,
          "aria-label": u,
          "aria-controls": d,
          ref: M,
          tooltipProps: m ? { ...m, shouldAddTriggerFocus: !1 } : void 0,
          ...y
        }
      ),
      p && r && /* @__PURE__ */ jsx(SkipNavLink, { id: p.id, children: p.content })
    ] });
  }
);
_TableSelectableCell.displayName = "TableSelectableCell";
const _TableSelectCell = forwardRef$1(
  ({
    placeholder: r,
    value: a,
    onSelect: s,
    options: c,
    addButton: u,
    isReadOnly: d,
    footerAction: h,
    isLoading: p,
    optionsToDisplayOnSelect: m,
    isInvalid: g,
    popoverProps: v,
    tooltipProps: y,
    ...x
  }, w) => {
    var F;
    const S = useMultiStyleConfig("TableSelectCell", {}), M = (m == null ? void 0 : m.find((N) => N.value === a)) || (c == null ? void 0 : c.find((N) => N.value === a)), [P, L] = useState$1(!1), [I, T] = useState$1(!1), E = (N) => {
      (!a || N.value !== a) && s(N.value), L(!1);
    }, R = M != null && M.icon ? isBrandSymbol$1(M.icon) ? /* @__PURE__ */ jsx(BrandSymbol, { type: M.icon, size: "medium" }) : /* @__PURE__ */ jsx(Icon, { size: "small", type: M == null ? void 0 : M.icon, color: "default" }) : (M == null ? void 0 : M.image) && /* @__PURE__ */ jsx(Image$1, { src: M.image.src, alt: M.image.alt }), A = (M == null ? void 0 : M.label) ?? r, k = x["data-testid"] ?? "table-select-cell", V = `${k}-dropdown-selectable`, B = /* @__PURE__ */ jsx(
      _IconIndicator,
      {
        variant: "warning",
        ...v ? { popover: v } : y ? { tooltip: y } : {},
        "data-testid": `${k}-warning-icon`
      }
    ), q = /* @__PURE__ */ jsx(Icon, { type: P ? "caret-up" : "caret-down", size: "small", color: "default", "aria-hidden": !0 }), z = !p && g, Z = !p && !d && q, G = z ? B : void 0, K = /* @__PURE__ */ jsx(_TableCell, { "data-component": "_TableSelectCell", "data-testid": "table-select-cell", ...x, children: /* @__PURE__ */ jsxs(Group, { width: "full", alignItems: "center", spacing: "none", children: [
      !!R && /* @__PURE__ */ jsx(Box, { __css: S.leftIcon, children: R }),
      A && /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: a ? "inherit" : "semantic.text.secondary", shouldSupportEllipsis: !0, children: A }),
      !!z && /* @__PURE__ */ jsx(Box, { __css: S.warningIcon, children: B }),
      !!Z && /* @__PURE__ */ jsx(Box, { __css: S.rightIcon, children: Z })
    ] }) }), U = c == null ? void 0 : c.map((N, D) => ({
      ...N,
      index: D,
      dataTestId: `table-select-cell-dropdown-item-${N.value}`
    }));
    return /* @__PURE__ */ jsx(Fragment, { children: c != null && c.length || M ? /* @__PURE__ */ jsx(
      SelectableDropdownMenu,
      {
        selectedItemValue: (F = c == null ? void 0 : c.find((N) => N.value === a)) == null ? void 0 : F.value,
        trigger: K,
        items: U,
        onOpenChange: L,
        onSelect: E,
        isOpen: P,
        isReadOnly: d,
        ref: w,
        footer: h != null && h.label ? h : void 0,
        dropdownTestId: V,
        size: "small"
      }
    ) : /* @__PURE__ */ jsx(
      _TableCell,
      {
        "data-component": "_TableSelectCell",
        onClick: u == null ? void 0 : u.onClick,
        ref: w,
        onMouseEnter: () => T(!0),
        onMouseLeave: () => T(!1),
        ...x,
        children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", justifyContent: "flex-start", spacing: "xxs", width: "full", children: [
          /* @__PURE__ */ jsx(
            NakedButton,
            {
              variant: "secondary",
              "data-hover": I || void 0,
              onClick: u == null ? void 0 : u.onClick,
              "data-testid": u == null ? void 0 : u.dataTestId,
              label: (u == null ? void 0 : u.text) || "Add"
            }
          ),
          G
        ] })
      }
    ) });
  }
);
_TableSelectCell.displayName = "_TableSelectCell";
const _TableSelectHeaderCell = forwardRef$1(
  ({ label: r, options: a, onSelect: s, footerAction: c, value: u, description: d, ...h }, p) => {
    const [m, g] = useState$1(!1), v = (M) => {
      (!u || M.value !== u) && s(M.value), g(!1);
    }, y = a == null ? void 0 : a.find((M) => M.value === u), x = /* @__PURE__ */ jsx(
      _TableMenuTriggerHeaderCell,
      {
        "data-component": "_TableSelectHeaderCell",
        label: r,
        "data-testid": "table-select-cell",
        onClick: lodashExports.noop,
        isMenuOpen: m,
        description: d,
        ...h,
        ref: p
      }
    ), w = `${h["data-testid"] ?? "table-select-header-cell"}-dropdown-selectable`, S = a.map((M, P) => ({
      ...M,
      index: P
    }));
    return /* @__PURE__ */ jsx(
      SelectableDropdownMenu,
      {
        trigger: x,
        items: S,
        onOpenChange: g,
        isOpen: m,
        dropdownTestId: w,
        onSelect: v,
        footer: c && { ...c, type: "naked", variant: "secondary" },
        selectedItemValue: y == null ? void 0 : y.value,
        size: "large"
      }
    );
  }
);
_TableSelectHeaderCell.displayName = "_TableSelectHeaderCell";
const BaseSelect$1 = forwardRef$1(({ trigger: r, dropdownMenu: a, ...s }, c) => {
  const u = useMultiStyleConfig("BaseSelect", {}), d = useTestId("base-select");
  return /* @__PURE__ */ jsxs(Box, { "data-component": "BaseSelect", __css: u.container, ref: c, ...d("container"), ...s, children: [
    r,
    a
  ] });
});
BaseSelect$1.displayName = "BaseSelect";
const CreatableOption = forwardRef$1(
  // We need to destructure the `role` prop to avoid counting it as an option by screen readers.
  ({ isHighlighted: r, isFocused: a, message: s, children: c, role: u, ...d }, h) => {
    const p = useMultiStyleConfig("BaseSelect", {}), m = useTestId("base-select");
    return /* @__PURE__ */ jsx(Box, { "data-component": "BaseSelect.CreatableOption", __css: p.creatableOption, children: /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        isFullWidth: !0,
        label: s,
        ref: h,
        ...m("creatable-option"),
        ...d,
        leftElement: /* @__PURE__ */ jsx(Icon, { size: "small", type: "add", color: "inherit", "aria-hidden": !0 }),
        "data-hover": r || void 0,
        "data-focus": a || void 0
      }
    ) });
  }
);
CreatableOption.displayName = "BaseSelect.CreatableOption";
const defaultFormatSelectedValue = (r) => r.label, checkHasSections$1 = (r) => r.some((a) => "options" in a), getOptionsGroupedBySection = (r) => {
  const a = r.map((c, u) => ({ ...c, index: u }));
  return a.reduce((c, u) => {
    const {
      section: { label: d, ...h }
    } = u;
    return c[d] = {
      section: h,
      options: a.filter((p) => p.section.label === d)
    }, c;
  }, {});
}, getOptionsWithSection = (r) => r.flatMap((a) => a.options.map((s) => ({ ...s, section: a.metadata }))), EmptyState$1 = forwardRef$1(
  ({ emptyState: r, closeMenu: a, "data-testid": s = "base-select" }, c) => {
    const u = !!r.onClick, d = useMultiStyleConfig("BaseSelect", {
      clickableEmptyState: u
    }), h = () => {
      var g;
      (g = r.onClick) == null || g.call(r), a == null || a();
    }, p = {
      "data-component": "BaseSelect.EmptyState",
      __css: d.emptyState,
      ref: c
    }, m = useTestId(s);
    return u ? /* @__PURE__ */ jsx(Box, { ...p, onClick: h, ...m("clickable-empty-state"), children: /* @__PURE__ */ jsx(NakedButton, { variant: "secondary", label: r.label }) }) : /* @__PURE__ */ jsx(Box, { ...p, "data-disabled": !0, ...m("empty-state"), children: r.label });
  }
);
EmptyState$1.displayName = "BaseSelect.EmptyState";
const Section = forwardRef$1(({ label: r, isVerified: a, children: s }, c) => {
  const u = useMultiStyleConfig("BaseSelect", {}), d = lodashExports.uniqueId("base-select-section-");
  return /* @__PURE__ */ jsxs(Box, { role: "group", "aria-labelledby": d, "data-component": "BaseSelect.Section", ref: c, children: [
    /* @__PURE__ */ jsx(Box, { as: "h3", __css: u.sectionLabel, id: d, children: /* @__PURE__ */ jsx(Typography.SectionLabel, { label: r, isVerified: a, tooltipProps: void 0 }) }),
    /* @__PURE__ */ jsx(Box, { as: "ul", children: s })
  ] });
});
Section.displayName = "BaseSelect.Section";
const DropdownMenuContentComponent = ({
  hasSections: r,
  options: a,
  isLoading: s,
  loadingStateComponent: c,
  emptyState: u,
  shouldShowCreatableOption: d,
  creatableOptionComponent: h,
  closeMenu: p,
  renderOption: m,
  ...g
}, v) => {
  const y = useMultiStyleConfig("BaseSelect", { shouldShowCreatableOption: d }), x = useTestId("base-select");
  return /* @__PURE__ */ jsx(Box, { __css: y.dropdownMenuContent, ref: v, children: /* @__PURE__ */ jsxs(Group, { hasDivider: !0, spacing: "none", width: "full", variant: "vertical", children: [
    s ? c : a.length > 0 ? /* @__PURE__ */ jsx(
      Box,
      {
        as: r ? "div" : "ul",
        __css: y.optionsContainer,
        ...x("options-container"),
        ...g,
        children: r ? /* @__PURE__ */ jsx(Group, { variant: "vertical", width: "full", spacing: "none", hasDivider: !0, children: Object.entries(getOptionsGroupedBySection(a)).map(
          ([w, S], M) => {
            var P;
            return /* @__PURE__ */ jsx(
              Section,
              {
                label: w,
                isVerified: ((P = S.section) == null ? void 0 : P.icon) === "verified",
                children: S.options.map((L) => m(L, L.index))
              },
              `${w}-${M}`
            );
          }
        ) }) : a.map((w, S) => m(w, S))
      }
    ) : u && /* @__PURE__ */ jsx(EmptyState$1, { emptyState: u, closeMenu: p }),
    d && !s && h
  ] }) });
}, DropdownMenuContent = React__default.forwardRef(DropdownMenuContentComponent);
DropdownMenuContent.displayName = "BaseSelect.DropdownMenuContent";
const DropdownMenuComponent = ({
  isOpen: r,
  x: a,
  y: s,
  context: c,
  ignoreElement: u = null,
  strategy: d,
  contentProps: h,
  isLoading: p,
  loadingStateComponent: m,
  creatableOptionComponent: g,
  renderOption: v,
  "aria-labelledby": y,
  ...x
}, w) => {
  const S = useMultiStyleConfig("BaseSelect", { isOpen: r, x: a, y: s, strategy: d }), M = useTestId("base-select"), P = useDelayUnmount({ isOpen: r });
  useHideFromSR({
    ignoreEl: u,
    enable: isMobileiOS() && r
  });
  const L = isMobileiOS() ? P : r;
  return (
    // This usage of wrapper is solving an issue on iOS devices, when screen reader focus would get lost after selecting an item from the dropdown.
    /* @__PURE__ */ jsx(
      ConditionalWrapper,
      {
        condition: isMobileiOS(),
        wrapper: (I) => /* @__PURE__ */ jsx(FloatingFocusManager, { context: c, disabled: !P, order: ["reference", "content"], children: /* @__PURE__ */ jsx(Fragment, { children: I }) }),
        children: /* @__PURE__ */ jsx(Fragment, { children: L && /* @__PURE__ */ jsx(
          Box,
          {
            "data-component": "BaseSelect.DropdownMenu",
            __css: S.dropdownMenu,
            ref: w,
            ...x,
            ...M("dropdown-menu"),
            children: /* @__PURE__ */ jsx(
              DropdownMenuContent,
              {
                ...h,
                "aria-labelledby": y,
                isLoading: p,
                loadingStateComponent: m,
                creatableOptionComponent: g,
                renderOption: v
              }
            )
          }
        ) })
      }
    )
  );
}, DropdownMenu = React__default.forwardRef(DropdownMenuComponent);
DropdownMenu.displayName = "BaseSelect.DropdownMenu";
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(a) {
    for (var s, c = 1, u = arguments.length; c < u; c++) {
      s = arguments[c];
      for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (a[d] = s[d]);
    }
    return a;
  }, __assign$1.apply(this, arguments);
};
function __rest(r, a) {
  var s = {};
  for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && a.indexOf(c) < 0 && (s[c] = r[c]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, c = Object.getOwnPropertySymbols(r); u < c.length; u++)
      a.indexOf(c[u]) < 0 && Object.prototype.propertyIsEnumerable.call(r, c[u]) && (s[c[u]] = r[c[u]]);
  return s;
}
function __spreadArray(r, a, s) {
  if (s || arguments.length === 2) for (var c = 0, u = a.length, d; c < u; c++)
    (d || !(c in a)) && (d || (d = Array.prototype.slice.call(a, 0, c)), d[c] = a[c]);
  return r.concat(d || Array.prototype.slice.call(a));
}
typeof SuppressedError == "function" && SuppressedError;
var escapeRegExp = function(r) {
  return r.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}, abbrMap = { k: 1e3, m: 1e6, b: 1e9 }, parseAbbrValue = function(r, a) {
  a === void 0 && (a = ".");
  var s = new RegExp("(\\d+(".concat(escapeRegExp(a), "\\d*)?)([kmb])$"), "i"), c = r.match(s);
  if (c) {
    var u = c[1], d = c[3], h = abbrMap[d.toLowerCase()];
    return Number(u.replace(a, ".")) * h;
  }
}, removeSeparators = function(r, a) {
  a === void 0 && (a = ",");
  var s = new RegExp(escapeRegExp(a), "g");
  return r.replace(s, "");
}, removeInvalidChars = function(r, a) {
  var s = escapeRegExp(a.join("")), c = new RegExp("[^\\d".concat(s, "]"), "gi");
  return r.replace(c, "");
}, cleanValue = function(r) {
  var a = r.value, s = r.groupSeparator, c = s === void 0 ? "," : s, u = r.decimalSeparator, d = u === void 0 ? "." : u, h = r.allowDecimals, p = h === void 0 ? !0 : h, m = r.decimalsLimit, g = m === void 0 ? 2 : m, v = r.allowNegativeValue, y = v === void 0 ? !0 : v, x = r.disableAbbreviations, w = x === void 0 ? !1 : x, S = r.prefix, M = S === void 0 ? "" : S, P = r.transformRawValue, L = P === void 0 ? function(H) {
    return H;
  } : P, I = L(a);
  if (I === "-")
    return I;
  var T = w ? [] : ["k", "m", "b"], E = new RegExp("((^|\\D)-\\d)|(-".concat(escapeRegExp(M), ")")), R = E.test(I), A = RegExp("(\\d+)-?".concat(escapeRegExp(M))).exec(a) || [], k = A[0], V = A[1], B = M ? k ? I.replace(k, "").concat(V) : I.replace(M, "") : I, q = removeSeparators(B, c), z = removeInvalidChars(q, __spreadArray([
    c,
    d
  ], T, !0)), Z = z;
  if (!w) {
    if (T.some(function(H) {
      return H === z.toLowerCase().replace(d, "");
    }))
      return "";
    var G = parseAbbrValue(z, d);
    G && (Z = String(G));
  }
  var K = R && y ? "-" : "";
  if (d && Z.includes(d)) {
    var U = z.split(d), F = U[0], N = U[1], D = g && N ? N.slice(0, g) : N, j = p ? "".concat(d).concat(D) : "";
    return "".concat(K).concat(F).concat(j);
  }
  return "".concat(K).concat(Z);
}, fixedDecimalValue = function(r, a, s) {
  if (s !== void 0 && r.length > 1) {
    if (s === 0)
      return r.replace(a, "");
    if (r.includes(a)) {
      var c = r.split(a), u = c[0], d = c[1];
      if (d.length === s)
        return r;
      if (d.length > s)
        return "".concat(u).concat(a).concat(d.slice(0, s));
    }
    var h = r.length > s ? new RegExp("(\\d+)(\\d{".concat(s, "})")) : new RegExp("(\\d)(\\d+)"), p = r.match(h);
    if (p) {
      var u = p[1], d = p[2];
      return "".concat(u).concat(a).concat(d);
    }
  }
  return r;
}, getSuffix = function(r, a) {
  var s = a.groupSeparator, c = s === void 0 ? "," : s, u = a.decimalSeparator, d = u === void 0 ? "." : u, h = new RegExp("\\d([^".concat(escapeRegExp(c)).concat(escapeRegExp(d), "0-9]+)")), p = r.match(h);
  return p ? p[1] : void 0;
}, formatValue = function(r) {
  var a = r.value, s = r.decimalSeparator, c = r.intlConfig, u = r.decimalScale, d = r.prefix, h = d === void 0 ? "" : d, p = r.suffix, m = p === void 0 ? "" : p;
  if (a === "" || a === void 0)
    return "";
  if (a === "-")
    return "-";
  var g = new RegExp("^\\d?-".concat(h ? "".concat(escapeRegExp(h), "?") : "", "\\d")).test(a), v = s !== "." ? replaceDecimalSeparator(a, s, g) : a;
  s && s !== "-" && v.startsWith(s) && (v = "0" + v);
  var y = {
    minimumFractionDigits: u || 0,
    maximumFractionDigits: 20
  }, x = c ? new Intl.NumberFormat(c.locale, c.currency ? __assign$1(__assign$1({}, y), { style: "currency", currency: c.currency }) : y) : new Intl.NumberFormat(void 0, y), w = x.formatToParts(Number(v)), S = replaceParts(w, r), M = getSuffix(S, __assign$1({}, r)), P = a.slice(-1) === s ? s : "", L = v.match(RegExp("\\d+\\.(\\d+)")) || [], I = L[1];
  return u === void 0 && I && s && (S.includes(s) ? S = S.replace(RegExp("(\\d+)(".concat(escapeRegExp(s), ")(\\d+)"), "g"), "$1$2".concat(I)) : M && !m ? S = S.replace(M, "".concat(s).concat(I).concat(M)) : S = "".concat(S).concat(s).concat(I)), m && P ? "".concat(S).concat(P).concat(m) : M && P ? S.replace(M, "".concat(P).concat(M)) : M && m ? S.replace(M, "".concat(P).concat(m)) : [S, P, m].join("");
}, replaceDecimalSeparator = function(r, a, s) {
  var c = r;
  return a && a !== "." && (c = c.replace(RegExp(escapeRegExp(a), "g"), "."), s && a === "-" && (c = "-".concat(c.slice(1)))), c;
}, replaceParts = function(r, a) {
  var s = a.prefix, c = a.groupSeparator, u = a.decimalSeparator, d = a.decimalScale, h = a.disableGroupSeparators, p = h === void 0 ? !1 : h;
  return r.reduce(function(m, g, v) {
    var y = g.type, x = g.value;
    return v === 0 && s ? y === "minusSign" ? [x, s] : y === "currency" ? __spreadArray(__spreadArray([], m, !0), [s], !1) : [s, x] : y === "currency" ? s ? m : __spreadArray(__spreadArray([], m, !0), [x], !1) : y === "group" ? p ? m : __spreadArray(__spreadArray([], m, !0), [c !== void 0 ? c : x], !1) : y === "decimal" ? d !== void 0 && d === 0 ? m : __spreadArray(__spreadArray([], m, !0), [u !== void 0 ? u : x], !1) : y === "fraction" ? __spreadArray(__spreadArray([], m, !0), [d !== void 0 ? x.slice(0, d) : x], !1) : __spreadArray(__spreadArray([], m, !0), [x], !1);
  }, [""]).join("");
}, defaultConfig = {
  currencySymbol: "",
  groupSeparator: "",
  decimalSeparator: "",
  prefix: "",
  suffix: ""
}, getLocaleConfig = function(r) {
  var a = r || {}, s = a.locale, c = a.currency, u = s ? new Intl.NumberFormat(s, c ? { currency: c, style: "currency" } : void 0) : new Intl.NumberFormat();
  return u.formatToParts(1000.1).reduce(function(d, h, p) {
    return h.type === "currency" ? p === 0 ? __assign$1(__assign$1({}, d), { currencySymbol: h.value, prefix: h.value }) : __assign$1(__assign$1({}, d), { currencySymbol: h.value, suffix: h.value }) : h.type === "group" ? __assign$1(__assign$1({}, d), { groupSeparator: h.value }) : h.type === "decimal" ? __assign$1(__assign$1({}, d), { decimalSeparator: h.value }) : d;
  }, defaultConfig);
}, isNumber = function(r) {
  return RegExp(/\d/, "gi").test(r);
}, padTrimValue = function(r, a, s) {
  if (a === void 0 && (a = "."), s === void 0 || r === "" || r === void 0)
    return r;
  if (!r.match(/\d/g))
    return "";
  var c = r.split(a), u = c[0], d = c[1];
  if (s === 0)
    return u;
  var h = d || "";
  if (h.length < s)
    for (; h.length < s; )
      h += "0";
  else
    h = h.slice(0, s);
  return "".concat(u).concat(a).concat(h);
}, repositionCursor = function(r) {
  var a = r.selectionStart, s = r.value, c = r.lastKeyStroke, u = r.stateValue, d = r.groupSeparator, h = a, p = s;
  if (u && h) {
    var m = s.split("");
    return c === "Backspace" && u[h] === d && (m.splice(h - 1, 1), h -= 1), c === "Delete" && u[h] === d && (m.splice(h, 1), h += 1), p = m.join(""), { modifiedValue: p, cursorPosition: h };
  }
  return { modifiedValue: p, cursorPosition: a };
}, CurrencyInput = forwardRef$1(function(r, a) {
  var s = r.allowDecimals, c = s === void 0 ? !0 : s, u = r.allowNegativeValue, d = u === void 0 ? !0 : u, h = r.id, p = r.name, m = r.className, g = r.customInput, v = r.decimalsLimit, y = r.defaultValue, x = r.disabled, w = x === void 0 ? !1 : x, S = r.maxLength, M = r.value, P = r.onValueChange, L = r.fixedDecimalLength, I = r.placeholder, T = r.decimalScale, E = r.prefix, R = r.suffix, A = r.intlConfig, k = r.step, V = r.min, B = r.max, q = r.disableGroupSeparators, z = q === void 0 ? !1 : q, Z = r.disableAbbreviations, G = Z === void 0 ? !1 : Z, K = r.decimalSeparator, U = r.groupSeparator, F = r.onChange, N = r.onFocus, D = r.onBlur, j = r.onKeyDown, H = r.onKeyUp, W = r.transformRawValue, re = r.formatValueOnBlur, ae = re === void 0 ? !0 : re, ee = __rest(r, ["allowDecimals", "allowNegativeValue", "id", "name", "className", "customInput", "decimalsLimit", "defaultValue", "disabled", "maxLength", "value", "onValueChange", "fixedDecimalLength", "placeholder", "decimalScale", "prefix", "suffix", "intlConfig", "step", "min", "max", "disableGroupSeparators", "disableAbbreviations", "decimalSeparator", "groupSeparator", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "transformRawValue", "formatValueOnBlur"]);
  if (K && isNumber(K))
    throw new Error("decimalSeparator cannot be a number");
  if (U && isNumber(U))
    throw new Error("groupSeparator cannot be a number");
  var X = useMemo$1(function() {
    return getLocaleConfig(A);
  }, [A]), J = K || X.decimalSeparator || "", ie = U || X.groupSeparator || "";
  if (J && ie && J === ie && z === !1)
    throw new Error("decimalSeparator cannot be the same as groupSeparator");
  var oe = {
    decimalSeparator: J,
    groupSeparator: ie,
    disableGroupSeparators: z,
    intlConfig: A,
    prefix: E || X.prefix,
    suffix: R
  }, fe = {
    decimalSeparator: J,
    groupSeparator: ie,
    allowDecimals: c,
    decimalsLimit: v || L || 2,
    allowNegativeValue: d,
    disableAbbreviations: G,
    prefix: E || X.prefix,
    transformRawValue: W
  }, ve = useState$1(function() {
    return y != null ? formatValue(__assign$1(__assign$1({}, oe), { decimalScale: T, value: String(y) })) : M != null ? formatValue(__assign$1(__assign$1({}, oe), { decimalScale: T, value: String(M) })) : "";
  }), ue = ve[0], pe = ve[1], we = useState$1(!1), ye = we[0], Ie = we[1], Ee = useState$1(0), ne = Ee[0], se = Ee[1], de = useState$1(0), Ce = de[0], me = de[1], xe = useState$1(null), Se = xe[0], Re = xe[1], Pe = useRef$1(null);
  useImperativeHandle$1(a, function() {
    return Pe.current;
  });
  var ke = function(Ye, et) {
    Ie(!0);
    var nt = repositionCursor({
      selectionStart: et,
      value: Ye,
      lastKeyStroke: Se,
      stateValue: ue,
      groupSeparator: ie
    }), vt = nt.modifiedValue, xt = nt.cursorPosition, mt = cleanValue(__assign$1({ value: vt }, fe));
    if (!(S && mt.replace(/-/g, "").length > S)) {
      if (mt === "" || mt === "-" || mt === J) {
        P && P(void 0, p, { float: null, formatted: "", value: "" }), pe(mt), se(1);
        return;
      }
      var tr = J ? mt.replace(J, ".") : mt, rr = parseFloat(tr), br = formatValue(__assign$1({ value: mt }, oe));
      if (xt != null) {
        var Be = xt + (br.length - Ye.length);
        Be = Be <= 0 ? E ? E.length : 0 : Be, se(Be), me(Ce + 1);
      }
      if (pe(br), P) {
        var pt = {
          float: rr,
          formatted: br,
          value: mt
        };
        P(mt, p, pt);
      }
    }
  }, De = function(Ye) {
    var et = Ye.target, nt = et.value, vt = et.selectionStart;
    ke(nt, vt), F && F(Ye);
  }, Fe = function(Ye) {
    return N && N(Ye), ue ? ue.length : 0;
  }, Xe = function(Ye) {
    var et = Ye.target.value, nt = cleanValue(__assign$1({ value: et }, fe));
    if (nt === "-" || nt === J || !nt) {
      pe(""), D && D(Ye);
      return;
    }
    var vt = fixedDecimalValue(nt, J, L), xt = padTrimValue(vt, J, T !== void 0 ? T : L), mt = parseFloat(xt.replace(J, ".")), tr = formatValue(__assign$1(__assign$1({}, oe), { value: xt }));
    P && ae && P(xt, p, {
      float: mt,
      formatted: tr,
      value: xt
    }), pe(tr), D && D(Ye);
  }, ze = function(Ye) {
    var et = Ye.key;
    if (Re(et), k && (et === "ArrowUp" || et === "ArrowDown")) {
      Ye.preventDefault(), se(ue.length);
      var nt = parseFloat(M != null ? String(M).replace(J, ".") : cleanValue(__assign$1({ value: ue }, fe))) || 0, vt = et === "ArrowUp" ? nt + k : nt - k;
      if (V !== void 0 && vt < Number(V) || B !== void 0 && vt > Number(B))
        return;
      var xt = String(k).includes(".") ? Number(String(k).split(".")[1].length) : void 0;
      ke(String(xt ? vt.toFixed(xt) : vt).replace(".", J));
    }
    j && j(Ye);
  }, Ge = function(Ye) {
    var et = Ye.key, nt = Ye.currentTarget.selectionStart;
    if (et !== "ArrowUp" && et !== "ArrowDown" && ue !== "-") {
      var vt = getSuffix(ue, { groupSeparator: ie, decimalSeparator: J });
      if (vt && nt && nt > ue.length - vt.length && Pe.current) {
        var xt = ue.length - vt.length;
        Pe.current.setSelectionRange(xt, xt);
      }
    }
    H && H(Ye);
  };
  useEffect$1(function() {
    M == null && y == null && pe("");
  }, [y, M]), useEffect$1(function() {
    ye && ue !== "-" && Pe.current && document.activeElement === Pe.current && Pe.current.setSelectionRange(ne, ne);
  }, [ue, ne, Pe, ye, Ce]);
  var Tt = function() {
    return M != null && ue !== "-" && (!J || ue !== J) ? formatValue(__assign$1(__assign$1({}, oe), { decimalScale: ye ? void 0 : T, value: String(M) })) : ue;
  }, _t = __assign$1({ type: "text", inputMode: "decimal", id: h, name: p, className: m, onChange: De, onBlur: Xe, onFocus: Fe, onKeyDown: ze, onKeyUp: Ge, placeholder: I, disabled: w, value: Tt(), ref: Pe }, ee);
  if (g) {
    var ht = g;
    return React__default.createElement(ht, __assign$1({}, _t));
  }
  return React__default.createElement("input", __assign$1({}, _t));
});
CurrencyInput.displayName = "CurrencyInput";
const intlConfigByCurrency = {
  AUD: { locale: "en-AU", currency: "AUD" },
  CAD: { locale: "en-CA", currency: "CAD" },
  CHF: { locale: "fr-CH", currency: "CHF" },
  CNY: { locale: "zh", currency: "CNY" },
  GBP: { locale: "en-GB", currency: "GBP" },
  EUR: { locale: "en-IE", currency: "EUR" },
  HKD: { locale: "zh-HK", currency: "HKD" },
  ILS: { locale: "en-IL", currency: "ILS" },
  INR: { locale: "en-US", currency: "INR" },
  JPY: { locale: "ja-JP", currency: "JPY" },
  MXN: { locale: "es-MX", currency: "MXN" },
  NZD: { locale: "en-NZ", currency: "NZD" },
  SGD: { locale: "zh-SG", currency: "SGD" },
  USD: { locale: "en-US", currency: "USD" },
  SEK: { locale: "en-US", currency: "SEK" },
  PLN: { locale: "en-US", currency: "PLN" },
  PHP: { locale: "en-PH", currency: "PHP" },
  BRL: { locale: "en-US", currency: "BRL" },
  GEL: { locale: "en-US", currency: "GEL" },
  KRW: { locale: "en-US", currency: "KRW" },
  VND: { locale: "en-US", currency: "VND" }
};
function getValidValue(r, a, s, c) {
  if (_.isNil(r))
    return;
  const u = String(r), d = u.startsWith("-"), h = d ? u.slice(1) : u, [p = "", m = ""] = h.split("."), g = c && s > 0 && (!!m || h.endsWith(".")), v = p + m, y = v.slice(0, Math.min(a, p.length)), x = g ? `.${v.slice(
    y.length,
    y.length + Math.min(s, m.length)
  )}` : "";
  return `${d ? "-" : ""}${y}${x}`;
}
const _CurrencyInput = forwardRef$1(
  ({
    value: r,
    onValueChange: a,
    currency: s,
    integerLimit: c = 8,
    decimalLimit: u = 2,
    allowDecimals: d = !0,
    allowNegativeValue: h = !0,
    placeholder: p,
    ...m
  }, g) => {
    const v = nonDecimalCurrencies.includes(s), y = v ? !1 : d, x = v ? 0 : u, w = {
      decimalScale: void 0,
      decimalSeparator: void 0,
      fixedDecimalLength: void 0,
      decimalLimit: x,
      allowDecimals: y
    }, S = intlConfigByCurrency[s], { sign: M } = getCurrencyDetails(s), P = (L) => {
      const I = getValidValue(L, c, x, y);
      a == null || a(I);
    };
    return /* @__PURE__ */ jsx(
      CurrencyInput,
      {
        ...m,
        transformRawValue: (L) => h ? L : L.replace("-", ""),
        ref: g,
        value: getValidValue(r, c, x, y),
        prefix: M,
        intlConfig: S,
        allowNegativeValue: h,
        onValueChange: P,
        decimalsLimit: x,
        placeholder: p,
        allowDecimals: y,
        ...v && w
      }
    );
  }
);
_CurrencyInput.displayName = "_CurrencyInput";
const InputGroup = forwardRef$1((r, a) => /* @__PURE__ */ jsx(InputGroup$1, { ref: a, "data-component": "InputGroup", ...r }));
InputGroup.displayName = "InputGroup";
const InputLeftElement = forwardRef$1((r, a) => /* @__PURE__ */ jsx(InputLeftElement$1, { ref: a, ...r })), InputRightElement = forwardRef$1((r, a) => /* @__PURE__ */ jsx(InputRightElement$1, { ref: a, ...r })), TextField = forwardRef$2(
  ({
    leftElement: r,
    rightElement: a,
    size: s = "large",
    isViewMode: c,
    isReadOnly: u,
    isDisabled: d,
    isLoading: h,
    autoFocus: p,
    maskProps: m,
    containerRef: g = null,
    placeholder: v,
    viewModePlaceholder: y,
    "aria-required": x = !1,
    ...w
  }, S) => {
    var D, j;
    const M = useRef$1(), P = useMergeRefs([M, S]), [L, I] = useState$1(null), T = !lodashExports.isEmpty(useFormControlContext()), E = y ?? v, R = c && y ? y : v, { targetRef: A, isVisible: k } = useIntersectionObserver(), V = useCallback$1(
      (H) => {
        H && I(H.clientWidth);
      },
      // This needs to update when `isLoading` changes in order to update the padding.
      // If the text field is inside a collapsed card, we need to trigger an update when the card becomes visible.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [h, k]
    ), [B, q] = useState$1(null), z = useCallback$1(
      (H) => {
        H && q(H.clientWidth);
      },
      // This needs to update when `isLoading` changes in order to update the padding.
      // If the text field is inside a collapsed card, we need to trigger an update when the card becomes visible.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [h, k]
    );
    useEffect$1(() => {
      var H;
      (H = M.current) == null || H.setAttribute("aria-invalid", w.isInvalid ? "true" : "false");
    }, [w.isInvalid]);
    const Z = {
      as: MaskedInput,
      guide: !1,
      ref: (H) => {
        P && (typeof P == "function" ? P(H == null ? void 0 : H.inputElement) : typeof P == "object" && (P.current = H == null ? void 0 : H.inputElement));
      },
      ...m
    }, G = T ? E : R, K = {
      ref: P,
      "data-component": "TextField",
      autoFocus: p,
      "data-loading": h || void 0,
      isDisabled: d,
      // We need to mark the input as `readOnly` when it's in view mode for accessibility reasons.
      isReadOnly: u || h || c,
      className: s,
      placeholder: G,
      ...w,
      paddingLeft: L ? `${L}px` : "s",
      paddingRight: B ? `calc(${B}px + ${themeSpaces.m})` : "none",
      isRequired: x
    }, U = m ? { ...K, ...Z } : K, F = Object.entries(U).reduce(
      (H, [W, re]) => (W.startsWith("data-") && (H[W] = re), H),
      {}
    ), N = useMultiStyleConfig("Input", { size: s });
    if (c) {
      let H = (D = U.value) == null ? void 0 : D.toString();
      return m != null && m.mask && (H = reactTextMaskExports.conformToMask(((j = U.value) == null ? void 0 : j.toString()) ?? "", m == null ? void 0 : m.mask, { guide: !1 }).conformedValue), /* @__PURE__ */ jsx(
        Typography.MainLabel,
        {
          ref: P,
          ...F,
          "data-view-mode": !0,
          label: H,
          placeholder: G
        }
      );
    }
    return /* @__PURE__ */ jsxs(InputGroup, { alignItems: "center", ref: mergeRefs([g, A]), children: [
      !c && r && /* @__PURE__ */ jsx(InputLeftElement, { ref: V, sx: N.leftElement, children: r }),
      /* @__PURE__ */ jsx(Input$1, { ...U }),
      (h || a) && /* @__PURE__ */ jsx(
        InputRightElement,
        {
          ref: z,
          sx: N.rightElement,
          onClick: h ? void 0 : w.onClick,
          children: h ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Box, { as: Loader, __css: N.loader, "aria-hidden": !0 }),
            /* @__PURE__ */ jsx(VisuallyHidden, { "aria-live": "polite", children: "Loading" })
          ] }) : !c && a
        }
      )
    ] });
  }
);
TextField.displayName = "TextField";
const AmountField$1 = forwardRef$1(
  ({
    currency: r = defaultCurrency,
    placeholder: a,
    size: s = "large",
    onChange: c,
    allowNegativeValue: u = !0,
    endElement: d,
    value: h,
    isViewMode: p,
    decimalScale: m,
    ...g
  }, v) => {
    const { formatCurrency: y } = useIntl(), x = formatValue({
      value: h == null ? void 0 : h.toString(),
      intlConfig: intlConfigByCurrency[r],
      decimalScale: m
    }), w = p ? x : h, S = a ?? y(0, r, { currencyDisplay: "code" });
    return /* @__PURE__ */ jsx(
      TextField,
      {
        "data-component": "AmountField",
        ref: v,
        as: _CurrencyInput,
        ...g,
        value: w,
        allowNegativeValue: u,
        placeholder: S,
        size: s,
        rightElement: d,
        currency: r,
        onValueChange: (M) => {
          c == null || c({ target: { value: M ?? "" } });
        },
        isViewMode: p,
        decimalScale: m
      }
    );
  }
);
AmountField$1.displayName = "AmountField";
const EndElement = forwardRef$1(({ isDisabled: r, onClick: a, ...s }, c) => {
  const u = useStyleConfig("AmountField", s);
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-component": "AmountField.EndElement",
      as: a ? "button" : "div",
      ...a && { type: "button" },
      onClick: r ? void 0 : a,
      "aria-disabled": r,
      ref: c,
      ...s,
      __css: u
    }
  );
});
EndElement.displayName = "AmountField.EndElement";
const endElement = { EndElement }, AmountField = Object.assign(AmountField$1, endElement), AmountInput = forwardRef$1(
  ({
    onChange: r,
    onBlur: a,
    onFocus: s,
    value: c,
    currency: u = defaultCurrency,
    currencySign: d = defaultCurrencySign,
    helperText: h,
    editButtonTooltip: p,
    integerLimitMask: m,
    errorMessage: g,
    allowNegativeValue: v = !0,
    descriptionAlignment: y = "center",
    autoComplete: x,
    ...w
  }, S) => {
    const { formatCurrency: M } = useIntl(), [P, L] = useState$1(M(c, u) ?? ""), [I, T] = useState$1(M(c, u)), [E, R] = useState$1(!1), [A, k] = useState$1(!1), V = P.length > 0 ? P.length : I.length, B = useMultiStyleConfig("AmountInput", { inputWidthInChars: V, descriptionAlignment: y }), q = useRef$1(null);
    useImperativeHandle$1(S, () => {
      var D;
      return (D = q.current) == null ? void 0 : D.inputElement;
    });
    const z = createNumberMask({
      currencySign: d,
      includeThousandsSeparator: !0,
      thousandsSeparatorSymbol: ",",
      allowDecimal: !0,
      decimalSymbol: ".",
      integerLimit: m ?? c.toFixed(0).length,
      allowNegative: v,
      allowLeadingZeroes: !0
    });
    useEffect$1(() => {
      g && R(!0);
    }, [g]);
    const Z = (D) => {
      if (D.target.value === "") return;
      L(D.target.value), T(D.target.value);
      const j = removeNonDigitsFromCurrency(D.target.value);
      r == null || r({ target: { value: j } });
    }, G = (D) => {
      const { value: j } = D.target, H = convertCurrencyToNumber(j.length ? j : I), W = M(H, u);
      L(W), T(W), g || (k(!1), R(!1)), a == null || a(D);
    }, K = () => {
      var D;
      k(!0), R(!0), L(""), (D = q.current) == null || D.inputElement.focus();
    }, U = useCallback$1(
      (D) => {
        var j;
        D.key === "Enter" && ((j = q.current) == null || j.inputElement.blur());
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [P]
    ), F = /* @__PURE__ */ jsx(
      IconButton,
      {
        "aria-label": "amount-edit-button",
        "data-testid": "amount-edit-button",
        icon: "edit",
        variant: "primary",
        onClick: K
      }
    ), N = !g && h && !E;
    return /* @__PURE__ */ jsxs(
      Group,
      {
        variant: "vertical",
        justifyContent: "center",
        spacing: "xs",
        width: "fit-content",
        "data-component": "AmountInput",
        ...w,
        children: [
          /* @__PURE__ */ jsxs(Box, { __css: B.field, children: [
            E || g ? /* @__PURE__ */ jsx(
              Box,
              {
                type: "text",
                value: P,
                guide: !1,
                "aria-label": "amount input",
                "data-testid": "amount-input",
                placeholder: I,
                onChange: Z,
                sx: B.inputElement,
                ref: q,
                as: MaskedInput,
                mask: z,
                onBlur: G,
                onFocus: (D) => {
                  k(!0), s == null || s(D);
                },
                onKeyDown: U,
                "data-view-mode": !E && !g || null,
                autoFocus: A,
                autoComplete: x
              }
            ) : /* @__PURE__ */ jsx(Box, { as: "span", sx: B.inputDisplay, "data-testid": "amount-input-display", children: P }),
            !E && !g && /* @__PURE__ */ jsx(
              ConditionalWrapper,
              {
                condition: !!p,
                wrapper: (D) => /* @__PURE__ */ jsx(Tooltip, { content: p, children: D }),
                children: F
              }
            )
          ] }),
          (g || N) && /* @__PURE__ */ jsxs(Box, { sx: B.description, children: [
            g && /* @__PURE__ */ jsx(Typography.Description, { label: g, isInvalid: !0, "data-testid": "amount-input-error-message" }),
            N && /* @__PURE__ */ jsx(Typography.Description, { label: h, "data-testid": "amount-input-helper-text" })
          ] })
        ]
      }
    );
  }
);
AmountInput.displayName = "AmountInput";
const RADIUS = 42, circleAttributes = { cx: 50, cy: 50, r: RADIUS, strokeLinecap: "round" };
function useCircleSvg(r) {
  const a = Math.PI * RADIUS * 2, s = r * (a / 100), c = `${s} ${a - s}`;
  return { circleAttributes, strokeDasharray: c };
}
const CircularProgress = forwardRef$1(({ percentage: r, ...a }, s) => {
  const [c, u] = useState$1(0), d = useRef$1(), { circleAttributes: h, strokeDasharray: p } = useCircleSvg(c), m = useMultiStyleConfig("CircularProgress", { strokeDasharray: p });
  return useEffect$1(() => (d.current = window.setTimeout(() => {
    u(r);
  }, 0), () => {
    clearTimeout(d.current);
  }), [r]), /* @__PURE__ */ jsxs(
    Box,
    {
      ref: s,
      __css: m.container,
      "data-component": "CircularProgress",
      ...a,
      as: "svg",
      viewBox: "0 0 100 100",
      children: [
        /* @__PURE__ */ jsx(Box, { as: "circle", __css: m.circle, ...h }),
        /* @__PURE__ */ jsx(Box, { as: "circle", __css: m.track, ...h, "data-progress": c })
      ]
    }
  );
});
CircularProgress.displayName = "CircularProgress";
const LinearProgress = forwardRef$1((r, a) => {
  const { currentStep: s, totalSteps: c, isFullWidth: u = !1, ...d } = r, h = Math.min(Math.max(s, 0), c), p = useRef$1(), [m, g] = useState$1(0), v = useMultiStyleConfig("LinearProgress", { percentage: m, isFullWidth: u });
  return useEffect$1(() => (p.current = window.setTimeout(() => {
    g(s / c * 100);
  }, 0), () => {
    clearTimeout(p.current);
  }), [s, c]), /* @__PURE__ */ jsx(
    Box,
    {
      "data-component": "LinearProgress",
      __css: v.container,
      role: "progressbar",
      "aria-label": "Steps progress",
      "data-testid": "linearprogress",
      "data-progress": m,
      "aria-valuemin": 0,
      "aria-valuemax": c,
      "aria-valuenow": h,
      ...d,
      ref: a,
      children: /* @__PURE__ */ jsx(Box, { __css: v.track })
    }
  );
});
LinearProgress.displayName = "LinearProgress";
const skeletonColors = {
  startColor: "global.neutral.300",
  endColor: "global.neutral.600"
}, Skeleton = forwardRef$1(
  ({ height: r = "20px", "data-testid": a = "skeleton", ...s }, c) => {
    const u = useStyleConfig("Skeleton", s), d = useTestId(a);
    return /* @__PURE__ */ jsx(
      Skeleton$1,
      {
        "data-component": "Skeleton",
        ...s,
        ref: c,
        ...d(),
        height: r,
        __css: u,
        speed: 1.2,
        ...skeletonColors
      }
    );
  }
);
Skeleton.displayName = "Skeleton";
const SkeletonCircle = ({
  diameter: r = "20px",
  "data-testid": a = "skeleton-circle",
  ...s
}) => {
  const c = useStyleConfig("SkeletonCircle", s), u = useTestId(a);
  return /* @__PURE__ */ jsx(
    SkeletonCircle$1,
    {
      "data-component": "SkeletonCircle",
      ...s,
      ...u(),
      size: r.toString(),
      __css: c,
      speed: 1.2,
      ...skeletonColors
    }
  );
};
SkeletonCircle.displayName = "SkeletonCircle";
const SkeletonText = ({
  numberOfLines: r = 2,
  spacing: a = "xs",
  "data-testid": s = "skeleton-text",
  ...c
}) => {
  const u = useStyleConfig("SkeletonText", c), d = useTestId(s);
  return /* @__PURE__ */ jsx(
    SkeletonText$1,
    {
      "data-component": "SkeletonText",
      ...c,
      noOfLines: r,
      spacing: a,
      ...d(),
      __css: u,
      speed: 1.2,
      ...skeletonColors
    }
  );
};
SkeletonText.displayName = "SkeletonText";
const getIconByType = (r) => ({
  success: /* @__PURE__ */ jsx(Icon, { type: "checked-circle", color: "inverse", "aria-hidden": !0 }),
  error: /* @__PURE__ */ jsx(Icon, { type: "error", color: "inverse", "aria-hidden": !0 }),
  informative: null
})[r], CLOSE_BUTTON_ARIA_LABEL_PREFIX = "Close toast", Toast = forwardRef$1(
  ({
    id: r,
    onClose: a,
    type: s = "informative",
    title: c,
    actionType: u = "button",
    actionText: d,
    onAction: h,
    "data-testid": p = "toast",
    closeButtonAriaLabel: m = typeof c == "string" ? `${CLOSE_BUTTON_ARIA_LABEL_PREFIX} ${c}` : "Close toast"
  }, g) => {
    const { isExtraSmallScreen: v } = useBreakpoint(), y = useMultiStyleConfig("Toast", { type: s, isMobile: v }), x = useTestId(p);
    return /* @__PURE__ */ jsx(MelioWrapper, { background: "transparent", children: /* @__PURE__ */ jsx(
      Box,
      {
        id: `toast-${r}`,
        __css: y.toast,
        "data-component": "Toast",
        ...x(`${r}`),
        role: "alert",
        ref: g,
        children: /* @__PURE__ */ jsxs(Group, { spacing: "xs", alignItems: "center", justifyContent: "space-between", width: "full", children: [
          /* @__PURE__ */ jsxs(Group, { spacing: "s", alignItems: "center", justifyContent: "space-between", width: "full", children: [
            /* @__PURE__ */ jsxs(Group, { spacing: "xs", alignItems: "center", children: [
              getIconByType(s),
              c && /* @__PURE__ */ jsx(Box, { __css: y.content, ...x("title"), children: c })
            ] }),
            u === "button" && d && h && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: /* @__PURE__ */ jsx(
              NakedButton,
              {
                ...x("action"),
                variant: "invert",
                onClick: () => h == null ? void 0 : h(() => a()),
                label: d
              }
            ) }),
            u === "link" && d && h && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: /* @__PURE__ */ jsx(
              Link,
              {
                ...x("action"),
                href: "#",
                variant: "standalone",
                color: "inherit",
                label: d,
                onClick: () => h == null ? void 0 : h(() => a()),
                size: "medium"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              size: "small",
              icon: "close-mini",
              variant: "nakedInverse",
              onClick: a,
              "aria-label": m,
              ...x("close-button")
            }
          )
        ] })
      }
    ) });
  }
), useToast = () => {
  const r = useToast$1(), a = useIcons(), { isExtraSmallScreen: s } = useBreakpoint(), c = useMultiStyleConfig("Toast", { isMobile: s });
  return { toast: ({ action: d, ...h }) => {
    r.closeAll(), r({
      position: "top",
      duration: null,
      containerStyle: c.container,
      render: (p) => {
        const m = d ? { actionType: d.type, onAction: d.onAction, actionText: d.text } : {}, g = useRef$1(null);
        return useEffect$1(() => {
          g.current && g.current.focus();
        }, [g]), // Re-wrap the toast with the icons provider since it's not being rendered in the root element.
        // (Chakra does it already with the ThemeProvider)
        /* @__PURE__ */ jsx(IconsProvider, { icons: a, children: /* @__PURE__ */ jsx(Toast, { ...p, ...m, ...h, ...r, ref: g }) });
      },
      ...h
    });
  }, closeToast: r.closeAll };
}, AvatarImageControl = forwardRef$1(
  ({
    isViewMode: r,
    viewModePlaceholder: a,
    deleteButtonText: s,
    value: c,
    onChange: u,
    isLoading: d,
    acceptTypes: h,
    variant: p = "circle",
    ...m
  }, g) => {
    const [v, y] = useBoolean(!1), x = useMultiStyleConfig("AvatarImageControl", { isViewMode: r, isLoading: d, variant: p }), w = useRef$1(null), S = () => {
      var k;
      r || d || (k = w.current) == null || k.click();
    }, M = ({ target: { files: k } }) => {
      k != null && k[0] && (u == null || u(k[0]));
    }, P = (k) => {
      k.stopPropagation(), w.current && (w.current.value = ""), u == null || u(null);
    }, L = !!c, I = !r && !d, T = r && !c, E = !r && c, R = !r, A = d && !r;
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "AvatarImageControl",
        ...m,
        ref: g,
        __css: x.container,
        onMouseOver: y.on,
        onMouseOut: y.off,
        children: [
          /* @__PURE__ */ jsxs(Box, { __css: x.avatar, onClick: S, children: [
            I && /* @__PURE__ */ jsx(Box, { __css: x.icon, children: /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: "image-add",
                variant: "nakedInverse",
                "aria-label": "Add Image",
                "data-hover": v || null,
                color: L ? "semantic.icon.inverse" : "semantic.icon.primary"
              }
            ) }),
            L && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Blanket, { isOpen: R, isLoading: A }),
              /* @__PURE__ */ jsx(Box, { __css: x.image, children: /* @__PURE__ */ jsx(Image$1, { alt: "avatar image", src: c }) })
            ] }),
            A && /* @__PURE__ */ jsx(Loader, { "data-testid": "loader", color: "semantic.icon.primary" }),
            T && /* @__PURE__ */ jsx(Box, { __css: x.initials, "data-testid": "avatar-initials", children: getAvatarInitials(a) }),
            /* @__PURE__ */ jsx(
              Box,
              {
                as: "input",
                type: "file",
                "aria-label": "upload image",
                "data-testid": "upload-image-input",
                accept: getInputFileAcceptByType(h),
                ref: w,
                style: { display: "none" },
                onChange: M
              }
            )
          ] }),
          E && /* @__PURE__ */ jsx(
            NakedButton,
            {
              "data-testid": "delete-image",
              isDisabled: d,
              variant: "critical",
              onClick: P,
              label: s
            }
          )
        ]
      }
    );
  }
);
AvatarImageControl.displayName = "AvatarImageControl";
const Calendar = forwardRef$1(
  ({
    isDisabled: r,
    secondarySelectedDate: a,
    selectedDate: s,
    selectedDateAriaLabel: c,
    currentDateAriaLabel: u,
    onSelect: d,
    minDate: h,
    maxDate: p,
    excludeHolidays: m,
    weekDays: g,
    legendItems: v,
    showToday: y,
    footer: x,
    disableYearSelection: w,
    yearsRange: S,
    ...M
  }, P) => {
    const L = useStyleConfig("Calendar");
    return /* @__PURE__ */ jsx(Card, { width: "min-content", paddingX: "none", paddingY: "none", "data-component": "Calendar", ...M, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", children: [
      /* @__PURE__ */ jsx(Box, { __css: L, children: /* @__PURE__ */ jsx(
        _BaseCalendar,
        {
          ref: P,
          isDisabled: r,
          secondarySelectedDate: a,
          selectedDate: s,
          onSelect: d,
          minDate: h,
          maxDate: p,
          excludeHolidays: m,
          weekDays: g,
          legendItems: v,
          showToday: y,
          selectedDateAriaLabel: c,
          currentDateAriaLabel: u,
          disableYearSelection: w,
          yearsRange: S
        }
      ) }),
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Box, { children: x })
    ] }) });
  }
);
Calendar.displayName = "Calendar";
const Chip = forwardRef$1(({ label: r, onClick: a, isSelected: s, status: c, ...u }, d) => {
  const h = useStyleConfig("Chip"), p = /* @__PURE__ */ jsx(
    Box,
    {
      "data-component": "Chip",
      as: "button",
      onClick: a,
      "aria-pressed": s,
      ...u,
      ref: d,
      __css: h,
      children: r
    }
  );
  return c && !s ? /* @__PURE__ */ jsx(StatusIndicator, { status: c, children: p }) : p;
});
Chip.displayName = "Chip";
const defaultFormat = "MM/dd/yyyy", DateField = forwardRef$1(
  ({
    value: r,
    onChange: a,
    onClick: s,
    onBlur: c,
    onFocus: u,
    autoFocus: d = !1,
    onKeyDown: h,
    defaultIsOpen: p,
    isOpen: m,
    onOpenChange: g,
    selectedDate: v,
    onSelectDate: y,
    minDate: x,
    maxDate: w,
    secondarySelectedDate: S,
    legendItems: M,
    legendWidth: P,
    showToday: L = !0,
    excludeHolidays: I = !0,
    weekDays: T = [1, 2, 3, 4, 5],
    footer: E,
    size: R = "large",
    hideClear: A = !1,
    isTypable: k = !1,
    isDisabled: V,
    isReadOnly: B,
    isLoading: q,
    isViewMode: z,
    format: Z = defaultFormat,
    selectedDateAriaLabel: G,
    secondaryDateAriaLabel: K,
    currentDateAriaLabel: U,
    placeholder: F = k ? Z === defaultFormat ? "MM/DD/YYYY" : "DD/MM/YYYY" : "Select a date...",
    toggleDatePickerRef: N,
    toggleDatePickerAriaLabel: D = "Date picker",
    clearDateAriaLabel: j = "Clear date",
    "data-testid": H = "date-field",
    disableYearSelection: W,
    shouldTrapFocus: re = !0,
    ...ae
  }, ee) => {
    const X = !!y, J = !B && !q && !z && !V, [ie, oe] = useState$1(p && J), [fe, ve] = useState$1(), [ue, pe] = useState$1(null), [we, ye] = useState$1(!1), [Ie, Ee] = useBoolean(!1), ne = k && (Ie || !r), se = m ?? ie, de = g ?? oe, Ce = v ?? fe, me = useRef$1(null), xe = useRef$1(null), Se = me.current;
    useUpdateEffect$1(() => {
      Se && we && (pe(null), Se.focus());
    }, [Se]), useEffect$1(() => {
      var Be;
      (Be = xe.current) != null && Be.contains(ue) ? ye(!0) : (ye(!1), pe(null));
    }, [ue]), useEffect$1(() => {
      X || ve(r ?? void 0);
    }, [X, r]), useUpdateEffect$1(() => {
      se || !X || r && (a == null || a(r));
    }, [X, r]);
    const [Re, Pe] = useState$1(""), ke = useMemo$1(
      () => ne ? Re : formatDateTime(r, { format: "MMM d, yyyy" }),
      [r, ne, Re]
    ), De = ne && r;
    useEffect$1(() => {
      var Be;
      De && Ge.current && ((Be = Ge.current) == null || Be.focus());
    }, [De]), useEffect$1(() => {
      p && Pe(formatDateTime(r, { format: Z }));
    }, []);
    const Fe = se || !isValid(r), Xe = !!(!Ce && Re);
    useEffect$1(() => {
      X || Fe || Xe || Pe(formatDateTime(Ce, { format: Z }));
    }, [Z, Xe, X, Ce, Fe]), useEffect$1(() => {
      !X || Fe || Pe(formatDateTime(r, { format: Z }));
    }, [Z, X, Fe, r]);
    const ze = (Be) => {
      const pt = !lodashExports.isEqual(Be, Ce);
      X ? pt && (y == null || y(Be)) : (ve(Be), de(!1), Be && Pe(formatDateTime(Be, { format: Z })), Be && pt && (a == null || a(Be)));
    }, Ge = useRef$1(), Tt = (Be) => {
      var pt;
      Be.stopPropagation(), ze(void 0), a == null || a(void 0), Pe(""), de(!1), (pt = Ge.current) == null || pt.focus();
    }, _t = (Be) => {
      if (!J || (Ee.off(), c == null || c(Be), !k)) return;
      const pt = Be.target.value;
      if (!pt) {
        a == null || a(void 0);
        return;
      }
      const [Rr, Ur, $r] = pt.split("/"), t1 = $r && +$r < 1901, r1 = !isValid(parse(pt, Z, createDate()));
      if (t1 || r1) {
        a == null || a(null), X || ze(void 0);
        return;
      }
      const qr = (
        // When the format is not the default one, we need to swap the month and day.
        createDate(Z === defaultFormat ? `${$r}-${Rr}-${Ur}` : `${$r}-${Ur}-${Rr}`)
      );
      r && isSameDay(qr, r) || (a == null || a(qr), X || ze(qr));
    }, { x: ht, y: Ye, refs: et, context: nt } = useFloating({
      placement: "bottom-end",
      strategy: "absolute",
      open: se,
      onOpenChange: de,
      middleware: [
        offset$2({ mainAxis: R === "large" ? 20 : 16, crossAxis: 12 }),
        flip$2(),
        shift({ padding: 24 }),
        size({
          apply({ availableHeight: Be, elements: pt }) {
            pt.floating.style.maxHeight = `${Be}px`;
          }
        })
      ],
      whileElementsMounted: (Be, pt, Rr) => autoUpdate(Be, pt, Rr, {
        animationFrame: !0,
        elementResize: !1
      })
    }), { getReferenceProps: vt, getFloatingProps: xt } = useInteractions([
      useClick(nt),
      useDismiss(nt),
      useRole(nt)
    ]), mt = useMultiStyleConfig("DateField", { isTypable: k }), tr = J && !!Re && !A, rr = useTestId(H), br = /* @__PURE__ */ jsxs(
      Box,
      {
        __css: mt.rightElement,
        "data-disabled": V || null,
        "data-readonly": B || null,
        onClick: V ? void 0 : () => {
          var Be;
          return (Be = Ge.current) == null ? void 0 : Be.focus();
        },
        children: [
          tr && /* @__PURE__ */ jsx(
            IconButton,
            {
              icon: "close",
              variant: "naked",
              size: "small",
              onClick: Tt,
              "aria-label": j,
              ...rr("clear")
            }
          ),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              icon: "calendar",
              variant: "naked",
              size: "small",
              isDisabled: B || V,
              "aria-label": D,
              "aria-haspopup": "dialog",
              ...rr("toggle"),
              ...vt({
                onClick: (Be) => {
                  Be.stopPropagation(), pe(document.activeElement);
                }
              }),
              ref: useMergeRefs([et.setReference, N, me])
            }
          )
        ]
      }
    );
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        TextField,
        {
          "data-component": "DateField",
          ref: useMergeRefs([ee, Ge]),
          sx: mt.input,
          value: ke,
          onChange: (Be) => {
            k && Pe(Be.target.value);
          },
          onFocus: (Be) => {
            J && (Ee.on(), u == null || u(Be));
          },
          onBlur: _t,
          onClick: (Be) => {
            var pt;
            J && (k ? ((pt = Ge.current) == null || pt.focus(), de(!1)) : de(!0), s == null || s(Be));
          },
          onKeyDown: (Be) => {
            J && (pe(document.activeElement), h == null || h(Be), !k && (Be.code === "Enter" || Be.code === "Space") && de(!0));
          },
          placeholder: F,
          size: R,
          autoFocus: d,
          isLoading: q,
          isDisabled: V,
          isReadOnly: B,
          isViewMode: z,
          rightElement: br,
          containerRef: xe,
          ...rr(),
          ...ae,
          maskProps: ne ? { mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/] } : void 0,
          "data-focus": se || Ie || null,
          "aria-haspopup": k ? void 0 : "dialog"
        }
      ),
      se && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(FloatingFocusManager, { context: nt, modal: re, children: /* @__PURE__ */ jsx(
        Box,
        {
          as: Card,
          __css: mt.popover,
          style: { top: Ye, left: ht, overflow: "auto", display: "block" },
          ...xt(),
          ref: et.setFloating,
          children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", children: [
            /* @__PURE__ */ jsx(Box, { __css: mt.calendar, children: /* @__PURE__ */ jsx(
              _BaseCalendar,
              {
                ...rr("calendar"),
                selectedDate: Ce,
                onSelect: ze,
                minDate: x,
                maxDate: w,
                weekDays: T,
                excludeHolidays: I,
                legendItems: M,
                legendWidth: P,
                secondarySelectedDate: S,
                selectedDateAriaLabel: G,
                secondaryDateAriaLabel: K,
                currentDateAriaLabel: U,
                showToday: L,
                disableYearSelection: W
              }
            ) }),
            E && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Divider, {}),
              E
            ] })
          ] })
        }
      ) }) })
    ] });
  }
);
DateField.displayName = "DateField";
const DeprecatedSearchBar = forwardRef$1(
  ({ onChange: r, defaultValue: a = "", placeholder: s, isDisabled: c = !1, autoFocus: u, ...d }, h) => {
    const [p, m] = useBoolean(!1), [g, v] = useState$1(a), [y, x] = useState$1(!1), [w, S] = useState$1(!1), [M, P] = useState$1(!1), L = useMultiStyleConfig("DeprecatedSearch", { value: g, isTyping: M, isHover: w }), I = createRef();
    useImperativeHandle$1(h, () => I.current);
    const T = () => {
      m.on(), v(""), x(!0), I.current && I.current.focus();
    }, E = ({ target: { value: R } }) => {
      v(R);
    };
    return useUpdateEffect$1(() => {
      r(g, { clear: p }), m.off();
    }, [g]), useEffect$1(() => {
      const R = setTimeout(() => {
        M && P(!1);
      }, 500);
      return () => {
        clearTimeout(R);
      };
    }, [M]), /* @__PURE__ */ jsx(
      InputGroup,
      {
        "data-component": "DeprecatedSearchBar",
        __css: L.container,
        "aria-disabled": c || void 0,
        "data-focus": !c && y || void 0,
        onMouseEnter: () => S(!0),
        onMouseLeave: () => S(!1),
        ...d,
        children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", spacing: "xs", width: "full", children: [
          /* @__PURE__ */ jsx(
            Input$1,
            {
              "aria-label": "search input",
              "data-testid": "search-input",
              placeholder: s,
              value: g,
              isDisabled: c,
              onChange: E,
              onInput: () => P(!0),
              onFocus: () => x(!0),
              onBlur: () => x(!1),
              "data-focus": !c && y || void 0,
              sx: L.field,
              autoFocus: u,
              ref: I
            }
          ),
          g && /* @__PURE__ */ jsx(Container, { paddingX: "xs", paddingY: "xs", width: "fit-content", children: /* @__PURE__ */ jsx(
            IconButton,
            {
              icon: "close-mini",
              "aria-label": "close",
              variant: "naked",
              size: "medium",
              "data-testid": "search-clear-button",
              onClick: T
            }
          ) })
        ] })
      }
    );
  }
);
DeprecatedSearchBar.displayName = "DeprecatedSearchBar";
const IFrame = forwardRef$1(({ title: r, width: a, height: s, ...c }, u) => /* @__PURE__ */ jsx(
  Box,
  {
    "data-component": "IFrame",
    ...c,
    width: a,
    height: s,
    ref: u,
    as: "iframe",
    "aria-label": r
  }
));
IFrame.displayName = "IFrame";
const FileAttachmentEmpty = () => /* @__PURE__ */ jsxs("svg", { width: "176", height: "224", viewBox: "0 0 176 224", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("rect", { width: "176", height: "224", fill: "white" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M55.5747 36.206H57.2547V32.666H59.9307V31.334H57.2547V29.186H60.7467V27.83H55.5747V36.206Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M62.338 36.206H64.018V27.83H62.338V36.206Z", fill: "#C2C2C3" }),
  /* @__PURE__ */ jsx("path", { d: "M66.0778 27.83V36.206H70.5178V34.874H67.7578V27.83H66.0778Z", fill: "#C2C2C3" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M76.8456 27.818H71.9856V36.206H76.8456V34.838H73.6656V32.618H76.4856V31.286H73.6656V29.186H76.8456V27.818Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M82.0317 36.206H83.7117V27.83H82.0317V36.206Z", fill: "#C2C2C3" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M85.7716 36.206H87.4516V30.758L89.7076 36.206H90.9796L93.2236 30.758V36.206H94.9036V27.83H93.0076L90.3436 34.058L87.6796 27.83H85.7716V36.206Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M102.653 36.206H104.429L101.417 27.818H99.4605L96.4485 36.206H98.2125L98.7645 34.61H102.101L102.653 36.206ZM101.645 33.266H99.2206L100.433 29.762L101.645 33.266Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M109.818 27.722C107.394 27.722 105.546 29.498 105.546 32.006C105.546 34.514 107.394 36.278 109.83 36.278C112.062 36.278 113.586 34.718 113.922 33.014V31.55H109.386V32.834H112.266C112.014 34.022 111.186 34.766 109.89 34.766C108.33 34.766 107.274 33.71 107.274 32.006C107.274 30.338 108.318 29.27 109.818 29.27C110.706 29.27 111.402 29.642 111.786 30.35H113.718C113.178 28.67 111.69 27.722 109.818 27.722Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M120.425 27.818H115.565V36.206H120.425V34.838H117.245V32.618H120.065V31.286H117.245V29.186H120.425V27.818Z",
      fill: "#C2C2C3"
    }
  ),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "68", width: "56", height: "4", rx: "2", fill: "#EDEDED" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "56", width: "80", height: "8", rx: "4", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "105", width: "40", height: "4", rx: "2", fill: "#EDEDED" }),
  /* @__PURE__ */ jsx("rect", { x: "136", y: "96", width: "24", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "96", width: "56", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "126", width: "40", height: "4", rx: "2", fill: "#EDEDED" }),
  /* @__PURE__ */ jsx("rect", { x: "136", y: "117", width: "24", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "117", width: "56", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "147", width: "40", height: "4", rx: "2", fill: "#EDEDED" }),
  /* @__PURE__ */ jsx("rect", { x: "136", y: "138", width: "24", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "138", width: "56", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "168", width: "40", height: "4", rx: "2", fill: "#EDEDED" }),
  /* @__PURE__ */ jsx("rect", { x: "136", y: "159", width: "24", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "159", width: "56", height: "4", rx: "2", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "120", y: "192", width: "40", height: "8", rx: "4", fill: "#D8D8D8" }),
  /* @__PURE__ */ jsx("rect", { x: "16", y: "192", width: "80", height: "8", rx: "4", fill: "#EDEDED" })
] }), FileAttachment = forwardRef$1(
  ({
    isReadOnly: r,
    isViewMode: a,
    value: s,
    isLoading: c,
    onChange: u,
    onViewModeClick: d,
    acceptTypes: h,
    deleteButtonText: p = "Delete File",
    fileAltText: m,
    overrideFileName: g,
    width: v = 176,
    "aria-label": y = "file attachment",
    "aria-hidden": x = void 0,
    fileInputAriaLabel: w = "upload file",
    deleteButtonAriaLabel: S = "Delete file",
    viewModeIcon: M = "attachment",
    ...P
  }, L) => {
    const I = useRef$1(null), T = !s, [E, R] = useBoolean(!1), [A, k] = useState$1(), [V, B] = useState$1(), q = g ?? m ?? s ?? (A == null ? void 0 : A.name), z = useRef$1(null), { hasOverflowY: Z } = useHasOverflow(z), G = !r && !a, K = T, U = !T && !V, F = G, N = c, D = G && s, j = a && !d && !T || r, re = !T && !G && !c || G && !c, ae = !r && (!a || !T || a && d) && !c, ee = () => {
      var oe;
      if (ae) {
        if (a && s) {
          d == null || d(s);
          return;
        }
        (oe = I.current) == null || oe.click();
      }
    }, X = ({ target: { files: oe } }) => {
      if (oe != null && oe[0]) {
        B(!1), k(oe[0]);
        const fe = URL.createObjectURL(oe[0]);
        u == null || u(fe, oe[0]);
      }
    }, J = (oe) => {
      oe.stopPropagation(), I.current && (I.current.value = ""), u == null || u(null);
    }, ie = useMultiStyleConfig("FileAttachment", { isEmpty: T, onViewModeClick: d, width: v });
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "FileAttachment",
        ...P,
        ref: L,
        __css: ie.container,
        onMouseOver: R.on,
        onMouseOut: R.off,
        children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              as: "button",
              "data-testid": "file-image-container",
              "aria-label": y,
              "data-view-mode": a || null,
              "data-readonly": j || null,
              "data-loading": c || null,
              __css: ie.fileImageContainer,
              tabIndex: ae ? 0 : -1,
              onClick: ee,
              "aria-hidden": x ?? !ae,
              children: [
                re && /* @__PURE__ */ jsx(
                  Box,
                  {
                    __css: ie.attachmentIconContainer,
                    "data-view-mode": a || null,
                    "data-readonly": r || null,
                    "data-hover": E || null,
                    children: /* @__PURE__ */ jsx(
                      Icon,
                      {
                        type: a || r ? M : "image-add",
                        color: "inverse",
                        size: a || r ? "small" : "large",
                        "data-hover": E || null
                      }
                    )
                  }
                ),
                K && /* @__PURE__ */ jsx(FileAttachmentEmpty, {}),
                U && (A != null && A.type.includes("pdf") ? /* @__PURE__ */ jsx(IFrame, { title: m ?? A.name, __css: ie.pdf, src: s }) : /* @__PURE__ */ jsx(Image$1, { alt: m ?? s, src: s, onError: () => B(!0), width: "inherit" })),
                V && s && /* @__PURE__ */ jsx(
                  ConditionalWrapper,
                  {
                    condition: Z,
                    wrapper: (oe) => /* @__PURE__ */ jsx(Tooltip, { content: q, children: oe }),
                    children: /* @__PURE__ */ jsx(Box, { as: "span", __css: ie.noPreview, ref: z, children: q })
                  }
                ),
                /* @__PURE__ */ jsx(Blanket, { isOpen: F, isLoading: N }),
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    as: "input",
                    type: "file",
                    "aria-label": w,
                    "data-testid": "upload-file-input",
                    accept: getInputFileAcceptByType(h),
                    ref: I,
                    style: { display: "none" },
                    onChange: X
                  }
                )
              ]
            }
          ),
          D && /* @__PURE__ */ jsx(Box, { __css: ie.deleteButton, children: /* @__PURE__ */ jsx(
            NakedButton,
            {
              "data-testid": "delete-file",
              isDisabled: c,
              variant: "critical",
              onClick: J,
              label: p,
              "aria-label": S
            }
          ) })
        ]
      }
    );
  }
);
FileAttachment.displayName = "FileAttachment";
const previewDataURLFile = (r) => {
  if (!r) return;
  const a = window.open();
  a == null || a.document.write(
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    `<iframe width="100%" height="100%" src=${r.toString()} frameborder="0" allowfullscreen></iframe>`
  );
};
function getPreviewFileMetadata(r, a) {
  if (!r)
    return null;
  const s = r instanceof File, c = !s && typeof (r == null ? void 0 : r.url) == "string";
  return !s && !c ? null : s ? a ? { url: a.toString(), type: r.type, name: r.name } : null : r;
}
const FileUpload = forwardRef$1(
  ({
    isDisabled: r,
    isLoading: a,
    placeholder: s = "Upload a file attachment",
    onPreview: c,
    "data-testid": u = "file-upload",
    ...d
  }, h) => {
    const p = useMultiStyleConfig("_BaseFileUpload", { size: "small" }), [m, g] = useState$1(d.value ?? null), [v, y] = useState$1(null), x = useRef$1(null), w = useTestId(u), S = getPreviewFileMetadata(m, v), M = S && /* @__PURE__ */ jsx(
      Box,
      {
        onClick: r ? void 0 : () => c == null ? void 0 : c(S),
        "aria-disabled": r,
        __css: p.label,
        tabIndex: r ? -1 : 0,
        placeholder: s,
        as: "button",
        type: "button",
        ...w("selected-file"),
        children: S.name
      }
    );
    return /* @__PURE__ */ jsx(
      _BaseFileUpload,
      {
        "data-component": "FileUpload",
        ref: h,
        as: m || a ? "div" : "button",
        isDisabled: r,
        selectedFile: m,
        setSelectedFile: g,
        setFileDataURL: y,
        hiddenFileInputRef: x,
        isLoading: a,
        placeholder: s,
        ...w(),
        ...d,
        size: "small",
        children: M
      }
    );
  }
);
FileUpload.displayName = "FileUpload";
const LargeFileUpload = forwardRef$1(
  ({ invalid: r, isLoading: a, onPreview: s, previewFileAriaLabel: c = "File preview", ...u }, d) => {
    const [h, p] = useState$1(null), m = useRef$1(null), [g, v] = useState$1(u.value ?? null), y = getPreviewFileMetadata(g, h), x = () => {
      y && previewDataURLFile(y.url), y && (s == null || s(y));
    }, w = (y == null ? void 0 : y.type) === fileTypes.pdf, S = useMultiStyleConfig("LargeFileUpload", { isPdfPreview: w }), M = y && /* @__PURE__ */ jsx(
      Box,
      {
        as: "a",
        role: "link",
        tabIndex: 0,
        onKeyDown: (P) => {
          P.key === "Enter" && (P.preventDefault(), x());
        },
        onClick: x,
        "aria-label": c,
        __css: S.fileContainer,
        children: w ? /* @__PURE__ */ jsx(
          IFrame,
          {
            title: y.name,
            src: `${y.url}#view=fit`,
            height: "100%",
            width: "100%",
            "aria-hidden": !0
          }
        ) : /* @__PURE__ */ jsx(
          Image$1,
          {
            height: "100%",
            objectFit: "contain",
            alt: y.name,
            title: y.name,
            src: y.url,
            "aria-hidden": !0
          }
        )
      }
    );
    return /* @__PURE__ */ jsx(
      _BaseFileUpload,
      {
        ref: d,
        "data-component": "LargeFileUpload",
        as: M || a ? "div" : "button",
        selectedFile: g,
        setSelectedFile: v,
        setFileDataURL: p,
        hiddenFileInputRef: m,
        placeholder: u.placeholder ?? "Browse to upload your invoice image/file",
        isInvalid: r == null ? void 0 : r.isInvalid,
        isLoading: a,
        errorMessage: r == null ? void 0 : r.errorMessage,
        size: "large",
        ...u,
        children: M
      }
    );
  }
);
LargeFileUpload.displayName = "LargeFileUpload";
const Option$2 = forwardRef$1(
  ({
    label: r,
    pillProps: a,
    description: s,
    rightIcon: c,
    isSelected: u,
    onClick: d,
    // Both `value` and `testId` are not used in the component.
    value: h,
    testId: p,
    ...m
  }, g) => /* @__PURE__ */ jsxs(BaseSelect.Option, { "data-component": "MultiSelect.Option", ref: g, ...m, onClick: d, children: [
    /* @__PURE__ */ jsx(Checkbox, { isChecked: u, onChange: d }),
    /* @__PURE__ */ jsx(BaseSelect.OptionContent, { label: r, rightIcon: c, pillProps: a, description: s })
  ] })
);
Option$2.displayName = "MultiSelect.Option";
const MultiSelect = forwardRef$1(
  ({
    options: r,
    size: a = "large",
    placeholder: s,
    isDisabled: c = !1,
    isReadOnly: u = !1,
    isLoading: d = !1,
    isViewMode: h = !1,
    onChange: p,
    value: m,
    onClick: g,
    onKeyDown: v,
    creatableOption: y,
    ...x
  }, w) => {
    const { anchorRef: S, dropdownMenuProps: M, toggleButtonProps: P, getOptionProps: L, selectedOptions: I } = useMultiSelect({
      ref: w,
      value: m,
      options: r,
      onClick: g,
      onChange: p,
      onKeyDown: v,
      creatableOption: y
    }), T = lodashExports.isEmpty(I) ? s ?? "" : I.map(({ label: R }) => R).join(", ");
    let E;
    if (y) {
      const R = typeof y.label == "string" ? y.label : y.label("");
      E = /* @__PURE__ */ jsx(
        BaseSelect.CreatableOption,
        {
          message: R,
          ...L({
            option: { value: R.toLocaleLowerCase(), label: R },
            index: r.length,
            isCreatableOption: !0
          })
        }
      );
    }
    return h ? /* @__PURE__ */ jsx(Typography.MainLabel, { label: T }) : /* @__PURE__ */ jsx(
      BaseSelect,
      {
        ref: S,
        trigger: /* @__PURE__ */ jsx(
          BaseSelect.ToggleButton,
          {
            "data-component": "MultiSelect",
            ...P,
            onKeyDown: (R) => {
              var A;
              u || d || (A = P == null ? void 0 : P.onKeyDown) == null || A.call(P, R);
            },
            ...x,
            selectValue: I,
            placeholder: s,
            size: a,
            isDisabled: c,
            isReadOnly: u,
            isViewMode: h,
            isLoading: d
          }
        ),
        dropdownMenu: /* @__PURE__ */ jsx(
          BaseSelect.DropdownMenu,
          {
            ...M,
            renderOption: (R, A) => /* @__PURE__ */ jsx(
              Option$2,
              {
                ...L({ option: R, index: A }),
                isSelected: !!I.find((k) => lodashExports.isEqual(k.value, R.value)),
                ...R
              }
            ),
            creatableOptionComponent: E
          }
        )
      }
    );
  }
);
MultiSelect.displayName = "MultiSelect";
const PhoneField = forwardRef$1(
  ({ onChange: r, isReadOnly: a, isViewMode: s, autoFocus: c = !1, ...u }, d) => /* @__PURE__ */ jsx(
    TextField,
    {
      "data-component": "PhoneField",
      ...u,
      autoFocus: c,
      onChange: (p) => {
        const m = p.target.value.replace(/[^\d]/g, "");
        r == null || r({ target: { value: m } });
      },
      isReadOnly: a,
      isViewMode: s,
      ref: d,
      maskProps: { mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/] }
    }
  )
);
PhoneField.defaultProps = {
  autoComplete: "tel",
  inputMode: "tel"
};
PhoneField.displayName = "PhoneField";
const Radio = forwardRef$1(
  ({
    label: r,
    onChange: a,
    mainLabelProps: s,
    value: c,
    isChecked: u,
    isInvalid: d,
    isReadOnly: h,
    descriptionProps: p,
    isDisabled: m,
    disabledMessage: g,
    ariaLabel: v,
    "aria-describedby": y,
    ...x
  }, w) => {
    const S = useMultiStyleConfig("Radio", x), M = (G) => {
      !m && !h && (a == null || a(G));
    }, P = p == null ? void 0 : p.label, L = useMemo$1(() => lodashExports.uniqueId("radio-description-"), []), I = useMemo$1(
      () => getAriaProps("aria-describedby", [
        (P && ((p == null ? void 0 : p.id) ?? L)) ?? void 0,
        y
      ]),
      [y, L, p, P]
    ), T = !!(m && g), [E, R] = useState$1(!1), A = (G) => {
      T && R(G);
    }, k = {
      onMouseEnter: () => A(!0),
      onMouseLeave: () => A(!1)
    }, V = getInteractiveElementProps({
      isDisabled: m
    }), B = /* @__PURE__ */ jsx(
      Tooltip,
      {
        content: g,
        isEnabled: T,
        isOpen: E,
        onOpenChange: A,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            "data-component": "Radio",
            __css: S.radio,
            as: "input",
            type: "radio",
            value: c,
            onChange: M,
            checked: u,
            "aria-checked": u,
            "data-readonly": h || void 0,
            "aria-invalid": d,
            "aria-label": v ?? (s == null ? void 0 : s.label),
            ...V,
            ...I,
            ...x
          }
        )
      }
    ), q = s && /* @__PURE__ */ jsx(
      Typography.MainLabel,
      {
        ...s,
        isReadOnly: h,
        variant: P ? "bold" : "default",
        isDisabled: m
      }
    ), z = p && /* @__PURE__ */ jsx(
      Typography.Description,
      {
        ...p,
        isReadOnly: h,
        isDisabled: m,
        id: p.id ?? L
      }
    ), Z = r ? /* @__PURE__ */ jsx(
      Box,
      {
        as: "label",
        htmlFor: x.id,
        ...k,
        children: r
      }
    ) : /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxxs", children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          as: "label",
          htmlFor: x.id,
          __css: S.label,
          "aria-disabled": m,
          ...k,
          children: q
        }
      ),
      z
    ] });
    return /* @__PURE__ */ jsxs(
      Group,
      {
        ref: w,
        variant: "horizontal",
        alignItems: "baseline",
        spacing: "xs",
        width: "fit-content",
        "data-testid": "radio-component",
        children: [
          B,
          Z
        ]
      }
    );
  }
);
Radio.displayName = "Radio";
function checkAutoFocus(r, a, s, c) {
  return r ? a ? s === a : c === 0 : !1;
}
const RadioGroup = forwardRef$1(
  ({
    onChange: r,
    isReadOnly: a,
    isViewMode: s,
    isDisabled: c,
    value: u,
    options: d,
    isInvalid: h,
    name: p,
    variant: m,
    size: g,
    id: v,
    autoFocus: y,
    "aria-describedby": x,
    ...w
  }, S) => {
    var L;
    const M = useBreakpointValue({ xs: "vertical", s: "horizontal" }), P = useStyleConfig("RadioGroup", { variant: m ?? M });
    if (s) {
      const I = d.find((E) => E.value === u), T = ((L = I == null ? void 0 : I.mainLabelProps) == null ? void 0 : L.label) ?? "";
      return /* @__PURE__ */ jsx(
        Typography.MainLabel,
        {
          "data-view-mode": !0,
          "data-testid": w["data-testid"],
          size: g,
          label: T,
          placeholder: w.placeholder
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "RadioGroup",
        ref: S,
        role: "radiogroup",
        ...w,
        name: p,
        id: v,
        "aria-disabled": c,
        "data-invalid": h || null,
        __css: P,
        children: d.map(({ disabled: I, id: T, ...E }, R) => /* @__PURE__ */ createElement$1(
          Radio,
          {
            ...E,
            key: E.value,
            value: E.value,
            isDisabled: (I == null ? void 0 : I.isDisabled) ?? c,
            disabledMessage: I == null ? void 0 : I.message,
            onChange: r,
            isChecked: E.value === u,
            isInvalid: h,
            isReadOnly: E.isReadOnly || a,
            name: p,
            id: T ?? lodashExports.uniqueId(`${v ?? "radio-group"}_`),
            "data-testid": `${w["data-testid"] ?? "radio-group"}-${E.value}`,
            autoFocus: checkAutoFocus(!!y, u, E.value, R),
            "aria-describedby": x
          }
        ))
      }
    );
  }
);
RadioGroup.displayName = "RadioGroup";
const useClickOutside = (r, a, s) => {
  useEffect$1(() => {
    if (!(a != null && a.current) || !(r != null && r.current) || !s)
      return;
    const c = (u) => {
      var d, h;
      !((d = r.current) != null && d.contains(u.target)) && !((h = a.current) != null && h.contains(u.target)) && s();
    };
    return document.addEventListener("click", c), () => {
      document.removeEventListener("click", c);
    };
  }, [r == null ? void 0 : r.current, a == null ? void 0 : a.current, s]);
}, Search = forwardRef$1(
  ({
    onInputChange: r,
    debounce: a = 250,
    options: s,
    children: c,
    size: u = "large",
    valueRightElement: d,
    emptyState: h,
    creatableOption: p,
    placeholder: m,
    isDisabled: g = !1,
    isReadOnly: v = !1,
    isViewMode: y = !1,
    isLoading: x = !1,
    isLoadingField: w = !1,
    autoFocus: S = !1,
    shouldShowPresetOptions: M = !1,
    onChange: P,
    value: L,
    filterOptions: I,
    formatSelectedValue: T,
    onClick: E,
    onFocus: R,
    onBlur: A,
    onKeyDown: k,
    onSearchTermReset: V,
    onClear: B,
    clearButtonAriaLabel: q = "Clear search input",
    id: z,
    statusMessageParentSelector: Z,
    ...G
  }, K) => {
    const U = useDebounceCallback((Ce) => {
      r == null || r(Ce);
    }, a), F = (Ce, me) => me ? Ce.filter((xe) => xe.label.toLowerCase().includes(me.toLowerCase())) : [], N = useRef$1(null), D = useMergeRefs([K, N]), j = useRef$1(null), {
      anchorRef: H,
      hasSections: W,
      openMenu: re,
      closeMenu: ae,
      inputValue: ee,
      inputProps: X,
      dropdownMenuProps: J,
      getOptionProps: ie,
      selectedOption: oe,
      filteredOptions: fe,
      clearSelect: ve
    } = useSearch({
      ref: D,
      clearButtonRef: j,
      value: L,
      formatSelectedValue: T,
      options: s,
      filterOptions: I ?? F,
      creatableOption: p,
      emptyState: h,
      disableInputClick: g || x || v || !M,
      isLoading: x,
      shouldShowPresetOptions: M,
      onClick: E,
      onChange: P,
      onInputChange: U,
      onKeyDown: k,
      onBlur: A,
      onSearchTermReset: V,
      onClear: B,
      id: z,
      statusMessageParentSelector: Z
    }), ue = useRef$1(), pe = mergeRefs([ue, J.ref]), we = useRef$1(null), ye = useMergeRefs([H, we]), Ie = G["aria-label"] ? (
      // 'aria-labelledby': undefined will reset the default value from downshift
      { "aria-label": G["aria-label"], "aria-labelledby": void 0 }
    ) : { "aria-labelledby": `${z}-label` }, Ee = !g && !v && !y;
    useEffect$1(() => {
      Ee && x && re();
    }, [x, re, Ee]), useClickOutside(ue, N, ae);
    const ne = typeof p == "object" && /* @__PURE__ */ jsx(
      BaseSelect.CreatableOption,
      {
        message: typeof p.label == "string" ? p.label : p.label(ee),
        ...ie({
          option: { value: ee.toLocaleLowerCase(), label: ee },
          index: fe.length,
          isCreatableOption: !0
        })
      }
    ), se = /* @__PURE__ */ jsx(
      BaseSelect.TriggerLeftIcon,
      {
        type: "search",
        size: u,
        isReadOnly: v,
        isDisabled: g,
        isViewMode: y,
        "aria-hidden": !0
      }
    ), de = Ee && ee ? /* @__PURE__ */ jsx(
      BaseSelect.TriggerRightIcon,
      {
        ref: j,
        "data-testid": "clear-search-input",
        "aria-label": q,
        icon: "close",
        onClick: () => {
          var Ce;
          ve(), (Ce = N.current) == null || Ce.focus();
        }
      }
    ) : void 0;
    return /* @__PURE__ */ jsx(
      BaseSelect,
      {
        ref: ye,
        trigger: /* @__PURE__ */ jsx(
          BaseSelect.Input,
          {
            "data-component": "Search",
            ...X,
            ...G,
            role: v ? void 0 : X.role,
            "aria-expanded": v ? void 0 : X["aria-expanded"],
            "aria-controls": v ? void 0 : X["aria-controls"],
            onFocus: R,
            placeholder: m,
            size: u,
            isDisabled: g,
            isReadOnly: v,
            isViewMode: y,
            isLoading: w,
            selectValue: L,
            selectedOption: oe,
            hasSections: W,
            valueRightElement: d,
            leftElement: se,
            rightElement: de,
            autoFocus: S
          }
        ),
        dropdownMenu: /* @__PURE__ */ jsx(
          BaseSelect.DropdownMenu,
          {
            ...J,
            ...Ie,
            ref: pe,
            isLoading: x,
            ignoreElement: we.current,
            loadingStateComponent: /* @__PURE__ */ jsx(BaseSelect.LoadingState, {}),
            creatableOptionComponent: ne,
            renderOption: (Ce, me) => /* @__PURE__ */ jsx(BaseSelect.Option, { ...ie({ option: Ce, index: me }), children: /* @__PURE__ */ jsx(BaseSelect.OptionContent, { ...Ce, isSelected: lodashExports.isEqual(Ce.value, oe == null ? void 0 : oe.value) }) })
          }
        )
      }
    );
  }
);
Search.displayName = "Search";
const SearchBar$1 = forwardRef$1(
  ({
    onChange: r,
    onBlur: a,
    onFocus: s,
    value: c,
    placeholder: u,
    isDisabled: d = !1,
    autoFocus: h,
    onClear: p,
    onKeyDown: m,
    onKeyUp: g,
    "aria-label": v = "Search",
    isFullWidth: y = !1,
    label: x,
    instructionsText: w = "Type and press Enter to start searching",
    valueClearedMessage: S = "Value cleared",
    onSearch: M,
    searchButtonAriaLabel: P = "Search",
    clearButtonAriaLabel: L = "clear search",
    ...I
  }, T) => {
    const [E, R] = useState$1(c), [A, k] = useState$1(!1), [V, B] = useState$1(!1), [q, z] = useState$1(!1), G = useMultiStyleConfig("SearchBar", { isFullWidth: y, isExpanded: A || !!E || q }), K = createRef(), U = useRef$1(null), F = useRef$1(null);
    useImperativeHandle$1(T, () => K.current);
    const N = useCallback$1(() => {
      B(!1);
    }, []), D = useCallback$1(
      (ee) => {
        r == null || r(ee), R(ee.target.value), N();
      },
      [r, N]
    ), j = useCallback$1(() => {
      p == null || p(), D({ target: { value: "" } }), B(!0), k(!0);
    }, [D, p]), H = useCallback$1(
      (ee) => {
        A && (a == null || a(ee)), k(!1), N();
      },
      [a, A, N]
    ), W = useCallback$1(
      (ee) => {
        A || s == null || s(ee), k(!0);
      },
      [s, A]
    );
    useEffect$1(() => {
      R(c);
    }, [c]);
    const re = useCallback$1(() => {
      M == null || M(E);
    }, [M, E]), ae = useCallback$1(
      (ee) => {
        m == null || m(ee), ee.key === "Enter" && re();
      },
      [m, re]
    );
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        VisuallyHidden,
        {
          id: "search-instructions",
          "aria-hidden": isMobileDevice() ? !A && !V : !0,
          "aria-live": "polite",
          children: V ? `${S} ${w}` : w
        }
      ),
      /* @__PURE__ */ jsx(
        InputGroup,
        {
          "data-component": "SearchBar",
          __css: G.container,
          "aria-disabled": d || void 0,
          "data-focus": !d && A || void 0,
          onClick: () => {
            var ee;
            return (ee = K.current) == null ? void 0 : ee.focus();
          },
          ...I,
          children: /* @__PURE__ */ jsxs(Group, { alignItems: "center", spacing: "xxs", width: "full", children: [
            x && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Box, { __css: G.label, "data-disabled": d || void 0, children: x }),
              /* @__PURE__ */ jsx(Box, { __css: G.divider, children: /* @__PURE__ */ jsx(Divider, { variant: "vertical" }) })
            ] }),
            !M && /* @__PURE__ */ jsx(Icon, { type: "search", color: "inherit", size: "small", "aria-hidden": !0 }),
            /* @__PURE__ */ jsx(
              Box,
              {
                as: "input",
                type: "text",
                "aria-label": v,
                "aria-describedby": "search-instructions",
                "data-testid": "search-input",
                placeholder: u,
                value: E,
                disabled: d,
                onChange: D,
                onFocus: W,
                onBlur: H,
                onKeyUp: (ee) => g == null ? void 0 : g(ee),
                onKeyDown: ae,
                "data-focus": !d && A || void 0,
                sx: G.field,
                autoFocus: h,
                ref: K
              }
            ),
            !!E && /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: "close",
                "aria-label": L,
                variant: "naked",
                size: "small",
                "data-testid": "search-clear-button",
                tabIndex: E ? 0 : -1,
                onClick: j,
                isDisabled: d,
                ref: U
              }
            ),
            M && /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: "search",
                color: "inherit",
                size: "small",
                variant: "naked",
                ref: F,
                "aria-label": P,
                onFocus: () => z(!0),
                onBlur: () => z(!1),
                onClick: re
              }
            )
          ] })
        }
      )
    ] });
  }
);
SearchBar$1.displayName = "SearchBar";
const SecuredTextField = forwardRef$1(
  ({
    type: r = "text",
    disableToggle: a = !1,
    isTextVisible: s = !1,
    isReadOnly: c,
    isViewMode: u,
    isDisabled: d,
    autoFocus: h = !1,
    getToggleVisibilityAriaLabel: p,
    value: m,
    onFocus: g,
    onBlur: v,
    "data-testid": y = "secured-text-field",
    ...x
  }, w) => {
    const S = useTestId(y), [M, P] = useState$1(s), L = a || c || u;
    useEffect$1(() => {
      P(s);
    }, [s]);
    const I = useMultiStyleConfig("SecuredTextField", { textVisible: M }), T = (p == null ? void 0 : p(M)) ?? `Toggle visibility ${M ? "off" : "on"}`, E = useCallback$1(() => {
      c || u || P(!M);
    }, [c, u, M]), R = L ? void 0 : /* @__PURE__ */ jsx(Box, { __css: I.inputRightIcon, children: /* @__PURE__ */ jsx(
      IconButton,
      {
        size: "small",
        icon: M ? "hide" : "show",
        variant: "naked",
        onClick: E,
        isDisabled: !m || d,
        "aria-label": T,
        "data-testid": `toggle${x.id ? `-${x.id}` : ""}-input-visibility`
      }
    ) }), [A, k] = useBoolean(!1), V = useMemo$1(
      () => M ? "text" : A ? r : "password",
      [A, M, r]
    );
    return /* @__PURE__ */ jsx(
      TextField,
      {
        ...S(),
        type: V,
        ref: w,
        autoFocus: h,
        "data-component": "SecuredTextField",
        "data-private": !0,
        isViewMode: u,
        isReadOnly: c,
        isDisabled: d,
        ...x,
        onFocus: (B) => {
          k.on(), g == null || g(B);
        },
        onBlur: (B) => {
          k.off(), v == null || v(B);
        },
        value: u && !M ? Array.from((m == null ? void 0 : m.toString()) ?? "").map(() => "•").join("") : m,
        sx: I.container,
        rightElement: R
      }
    );
  }
);
SecuredTextField.displayName = "SecuredTextField";
const Select = forwardRef$1(
  ({
    options: r,
    children: a,
    size: s = "large",
    valueRightElement: c,
    emptyState: u,
    creatableOption: d,
    isDisabled: h = !1,
    isReadOnly: p = !1,
    isViewMode: m = !1,
    isLoading: g = !1,
    autoFocus: v = !1,
    value: y,
    placeholder: x,
    onInputChange: w,
    onChange: S,
    formatSelectedValue: M,
    onClick: P,
    onKeyDown: L,
    onFocus: I,
    onBlur: T,
    onSearchTermReset: E,
    id: R,
    ...A
  }, k) => {
    const V = (ae, ee) => ee ? ae.filter((X) => X.label.toLowerCase().includes(ee.toLowerCase())) : ae, {
      anchorRef: B,
      isOpen: q,
      hasSections: z,
      getToggleButtonProps: Z,
      inputValue: G,
      inputProps: K,
      dropdownMenuProps: U,
      getOptionProps: F,
      selectedOption: N,
      filteredOptions: D
    } = useSelect({
      ref: k,
      value: y,
      formatSelectedValue: M,
      options: r,
      filterOptions: V,
      creatableOption: d,
      emptyState: u,
      disableInputClick: h || g || p,
      onClick: P,
      onChange: S,
      onInputChange: w,
      onKeyDown: L,
      onSearchTermReset: E
    }), j = A["aria-label"] ? (
      // 'aria-labelledby': undefined will reset the default value from downshift
      { "aria-label": A["aria-label"], "aria-labelledby": void 0 }
    ) : { "aria-labelledby": `${R}-label` }, H = typeof d == "object" && /* @__PURE__ */ jsx(
      BaseSelect.CreatableOption,
      {
        message: typeof d.label == "string" ? d.label : d.label(G),
        ...F({
          option: { value: G.toLocaleLowerCase(), label: G },
          index: D.length,
          isCreatableOption: !0
        })
      }
    ), W = {
      isDisabled: h,
      isViewMode: m,
      isReadOnly: p || g
    }, re = /* @__PURE__ */ jsx(
      BaseSelect.TriggerRightIcon,
      {
        "data-testid": "select-toggle-button",
        "aria-label": "Toggle select dropdown menu",
        icon: q ? "caret-up" : "caret-down",
        ...W,
        ...!h && !p && !g && Z()
      }
    );
    return /* @__PURE__ */ jsx(
      BaseSelect,
      {
        ref: B,
        "data-component": "Select",
        trigger: /* @__PURE__ */ jsx(
          BaseSelect.Input,
          {
            ...K,
            onKeyDown: (ae) => {
              var ee;
              p || g || (ee = K == null ? void 0 : K.onKeyDown) == null || ee.call(K, ae);
            },
            ...A,
            ...W,
            isLoading: g,
            id: R,
            onFocus: I,
            onBlur: T,
            placeholder: x,
            size: s,
            selectValue: y,
            selectedOption: N,
            hasSections: z,
            valueRightElement: c,
            rightElement: re,
            autoFocus: v
          }
        ),
        dropdownMenu: /* @__PURE__ */ jsx(
          BaseSelect.DropdownMenu,
          {
            ...U,
            ...j,
            isLoading: g,
            loadingStateComponent: /* @__PURE__ */ jsx(BaseSelect.LoadingState, {}),
            creatableOptionComponent: H,
            renderOption: (ae, ee) => /* @__PURE__ */ jsx(BaseSelect.Option, { ...F({ option: ae, index: ee }), children: /* @__PURE__ */ jsx(BaseSelect.OptionContent, { ...ae, isSelected: lodashExports.isEqual(ae.value, N == null ? void 0 : N.value) }) })
          }
        )
      }
    );
  }
);
Select.displayName = "Select";
const EmptyState = ({
  emptyState: r = "No options",
  ...a
}) => {
  const s = useMultiStyleConfig("SelectNew", {});
  return /* @__PURE__ */ jsx(Box, { "data-component": "SelectNew.EmptyState", __css: s.emptyState, ...a, children: r });
};
EmptyState.displayName = "SelectNew.EmptyState";
const Footer = (r) => /* @__PURE__ */ jsx(FloatingMenu.Footer, { "data-component": "SelectNew.Footer", ...r });
Footer.displayName = "SelectNew.Footer";
const Option$1 = ({
  option: r,
  optionRenderer: a,
  onClick: s,
  isSelected: c = !1,
  id: u,
  setActiveOptionId: d,
  ...h
}) => {
  var p;
  return /* @__PURE__ */ jsx(
    FloatingMenu.SelectionItem,
    {
      "data-component": "SelectNew.Option",
      role: "option",
      label: r.label,
      isSelected: c,
      disabled: r.disabled,
      id: u,
      ...!((p = r.disabled) != null && p.isDisabled) && {
        onClick: s,
        onFocus: () => d(u),
        onBlur: () => d("")
      },
      ...h,
      children: (a == null ? void 0 : a(r, c)) ?? /* @__PURE__ */ jsx(Box, { as: "span", textStyle: "inline", color: "inherit", children: r.label })
    }
  );
};
Option$1.displayName = "SelectNew.Option";
const SearchBar = (r) => {
  const { ref: a } = useListItem();
  return /* @__PURE__ */ jsx(SearchBar$1, { ...r, "data-component": "SelectNew.SearchBar", isFullWidth: !0, ref: a });
};
SearchBar.displayName = "SelectNew.SearchBar";
const ClearButton = ({ setClearButtonWidth: r, ...a }) => {
  const s = useCallback$1(
    (u) => {
      u && r(u.offsetWidth);
    },
    [r]
  ), c = useMultiStyleConfig("SelectNew", {});
  return /* @__PURE__ */ jsx(InputRightElement, { "data-component": "SelectNew.ClearButton", ref: s, sx: c.clearButton, children: /* @__PURE__ */ jsx(IconButton, { ...a, icon: "close", size: "small", variant: "naked" }) });
};
ClearButton.displayName = "SelectNew.ClearButton";
const TriggerContainerComponent = ({
  selectedOption: r,
  placeholder: a,
  "data-testid": s = "select",
  isViewMode: c,
  ...u
}, d) => {
  const h = useTestId(s);
  return c ? /* @__PURE__ */ jsx(
    Typography.MainLabel,
    {
      ref: d,
      "data-component": "SelectNew",
      ...h("trigger"),
      "data-view-mode": !0,
      label: (r == null ? void 0 : r.label) ?? "",
      placeholder: a
    }
  ) : /* @__PURE__ */ jsx(InputGroup, { "data-component": "SelectNew", ...h(), ...u });
}, TriggerContainer = forwardRef$1(TriggerContainerComponent);
TriggerContainer.displayName = "SelectNew.TriggerContainer";
const TriggerRightElement = ({
  isDisabled: r,
  isReadOnly: a,
  isLoading: s,
  isOpen: c,
  setRightElementWidth: u
}) => {
  const d = useCallback$1(
    (p) => {
      p && u(p.offsetWidth);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We nedd to recalculate when `isLoading` changes because the loader has a different width.
    [u, s]
  ), h = useMultiStyleConfig("SelectNew", {});
  return /* @__PURE__ */ jsx(
    InputRightElement,
    {
      ref: d,
      "data-component": "SelectNew.TriggerRightElement",
      sx: h.triggerRightElement,
      "data-readonly": a || s || void 0,
      "data-loading": s || void 0,
      "aria-disabled": r || a || void 0,
      "aria-hidden": !0,
      children: s ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(Icon, { size: "small", type: c ? "caret-up" : "caret-down", color: "inherit" })
    }
  );
};
TriggerRightElement.displayName = "SelectNew.TriggerRightElement";
const TriggerValue = ({
  selectedOption: r,
  valueRenderer: a,
  isDisabled: s,
  placeholder: c
}) => {
  const u = useMultiStyleConfig("SelectNew", {});
  return /* @__PURE__ */ jsx(Fragment, { children: r ? (a == null ? void 0 : a(r)) ?? /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: r.label }) : /* @__PURE__ */ jsx(Box, { __css: u.placeholder, "data-disabled": s || void 0, children: /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: c }) }) });
};
TriggerValue.displayName = "SelectNew.TriggerValue";
const useTriggerFocus = ({
  inputRef: r,
  autoFocus: a,
  disableClick: s,
  isOpen: c,
  isFocusable: u,
  onFocus: d,
  onBlur: h
}) => {
  useEffect$1(() => {
    var g;
    a && ((g = r.current) == null || g.focus());
  }, [a, r]);
  const [p, m] = useState$1(!1);
  return useEffect$1(() => {
    var g;
    c || !p || (g = r.current) == null || g.focus();
  }, [c, p, r]), {
    onFocus: (g) => {
      p || !u || (m(!0), !s && (d == null || d(g)));
    },
    onBlur: (g) => {
      c || !p || (m(!1), h == null || h(g));
    },
    "data-focus": p || void 0,
    tabIndex: u ? 0 : -1
  };
}, useTriggerStyles = ({
  hasCustomValue: r,
  showClearButton: a,
  size: s
}) => {
  const c = useMultiStyleConfig("SelectNew", { hasCustomValue: r }), [u, d] = useState$1(0), [h, p] = useState$1(0);
  return {
    styleProps: {
      sx: c.trigger,
      className: s,
      paddingRight: a ? `calc(${h}px + ${themeSpaces.xxl})` : `${u}px`
    },
    widthSetters: {
      setRightElementWidth: d,
      setClearButtonWidth: p
    }
  };
}, TriggerComponent = ({
  selectedOption: r,
  placeholder: a = "Select",
  viewModePlaceholder: s,
  size: c = "large",
  isDisabled: u,
  isReadOnly: d,
  isViewMode: h,
  isInvalid: p,
  isLoading: m,
  isOpen: g,
  autoFocus: v = !1,
  shouldHideClearButton: y = !1,
  clearButtonAriaLabel: x = "Clear selected option",
  "data-testid": w = "select",
  onClear: S,
  onClick: M,
  onFocus: P,
  onBlur: L,
  valueRenderer: I,
  isRequired: T,
  "aria-required": E,
  id: R,
  ...A
}, k) => {
  const V = useTestId(w), B = !lodashExports.isEmpty(useFormControlContext()), Z = B ? s ?? a : h && s ? s : a, G = !!(u || m || h || d), K = !u && !h, U = !y && !!r && !G, F = !h || m, N = useRef$1(null), D = useMergeRefs([k, N]), { setActiveIndex: j } = useBaseMenuContext(), H = useCallback$1(
    (J) => {
      var ie;
      G || (M == null || M(J), g || ((ie = N.current) == null || ie.focus(), j(0)));
    },
    [G, g, M, j]
  ), W = B ? (
    // We pass `aria-labelledby` so the screen reader can announce the selected option or placeholder when in form context.
    { "aria-labelledby": `${R}-label` }
  ) : (
    // We pass `aria-label` so the screen reader can announce the selected option or placeholder when NOT in form context.
    { "aria-label": (r == null ? void 0 : r.label) || Z }
  ), re = useTriggerFocus({ autoFocus: v, disableClick: G, isOpen: g, isFocusable: K, inputRef: N, onFocus: P, onBlur: L }), {
    styleProps: ae,
    widthSetters: { setRightElementWidth: ee, setClearButtonWidth: X }
  } = useTriggerStyles({ hasCustomValue: !!I, showClearButton: U, size: c });
  return /* @__PURE__ */ jsxs(
    TriggerContainer,
    {
      ref: k,
      selectedOption: r,
      isViewMode: h,
      placeholder: Z,
      ...V(),
      children: [
        /* @__PURE__ */ jsxs(
          Input$1,
          {
            ref: D,
            "data-component": "SelectNew.Trigger",
            as: "div",
            ...V("trigger"),
            ...W,
            "data-value": (r == null ? void 0 : r.value) || null,
            ...A,
            id: R,
            "aria-readonly": d || m || void 0,
            "aria-disabled": u || void 0,
            "data-loading": m || void 0,
            "data-invalid": p || void 0,
            isRequired: T || !!E,
            onClick: H,
            ...re,
            ...ae,
            children: [
              /* @__PURE__ */ jsx(
                TriggerValue,
                {
                  selectedOption: r,
                  valueRenderer: I,
                  isDisabled: u,
                  placeholder: Z
                }
              ),
              d && /* @__PURE__ */ jsx(VisuallyHidden, { children: "read only" })
            ]
          }
        ),
        F && /* @__PURE__ */ jsx(
          TriggerRightElement,
          {
            isOpen: g,
            isDisabled: u,
            isLoading: m,
            isReadOnly: d,
            setRightElementWidth: ee
          }
        ),
        U && /* @__PURE__ */ jsx(
          ClearButton,
          {
            "aria-label": x,
            ...V("clear-button"),
            onClick: (J) => {
              var ie;
              J.stopPropagation(), S == null || S(), (ie = N.current) == null || ie.focus();
            },
            setClearButtonWidth: X
          }
        )
      ]
    }
  );
}, Trigger = forwardRef$1(TriggerComponent);
Trigger.displayName = "SelectNew.Trigger";
const checkHasSections = (r) => r.some((a) => "options" in a), getFlatOptions = (r) => checkHasSections(r) ? r.flatMap((c) => c.options) : r, id = "select-a11y-status-message", getstatusMessageParentSelectorElement$1 = (r) => r && document.querySelector(r) || document.body, getStatusElement$1 = (r) => {
  let a = document.getElementById(id);
  return a || (a = document.createElement("div"), a.setAttribute("data-component", "SelectNew.A11yStatusMessage"), a.setAttribute("id", id), a.setAttribute("role", "status"), a.setAttribute("aria-live", "polite"), a.setAttribute("aria-relevant", "additions text"), Object.assign(a.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), getstatusMessageParentSelectorElement$1(r).appendChild(a), a);
}, cleanupStatus$2 = lodashExports.debounce((r) => {
  getStatusElement$1(r).textContent = "";
}, 500), setStatus$2 = (r, a) => {
  getStatusElement$1(a).textContent = r, cleanupStatus$2(a);
}, cleanupStatusElement$1 = () => {
  var r;
  (r = document.getElementById(id)) == null || r.remove();
}, useA11yStatusMessage = ({
  selectedOptionLabel: r,
  isOpen: a,
  optionsCount: s,
  statusMessageParentSelector: c
}) => {
  const { isExtraSmallScreen: u } = useBreakpoint();
  useEffect$1(() => (getStatusElement$1(c), () => cleanupStatusElement$1()), [c]);
  const [d, h] = useState$1("");
  useEffect$1(() => {
    d && (setStatus$2(d, c), h(""));
  }, [d, c]), useEffect$1(() => {
    if (!a || s === void 0) return;
    const p = s ? `${s} ${s > 1 ? "results" : "result"} available. ${u ? "" : " Use up and down arrow keys to navigate. Press Enter key to select."}` : "No results available.";
    h(p);
  }, [a, s, u]), useEffect$1(() => {
    r && h(`${r} has been selected.`);
  }, [r]);
}, useSelect$2 = ({
  options: r,
  searchBarProps: a,
  value: s,
  size: c,
  autoFocus: u,
  isLoading: d,
  isReadOnly: h,
  isViewMode: p,
  emptyState: m,
  footer: g,
  "data-testid": v = "select",
  onClick: y,
  onChange: x,
  onClear: w,
  optionRenderer: S,
  statusMessageParentSelector: M,
  id: P,
  menuWidth: L = "match-trigger",
  menuMaxWidth: I,
  ...T
}) => {
  const E = s && !x;
  useEffect$1(() => {
    E && console.error(
      "Warning: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. Please set either `onChange` or `isReadOnly`."
    );
  }, [E]);
  const [R, A] = useState$1(r);
  useEffect$1(() => {
    A(r);
  }, [r]);
  const k = useMemo$1(
    () => getFlatOptions(R).find((H) => lodashExports.isEqual(H.value, s)) ?? null,
    [R, s]
  ), [V, B] = useState$1(k);
  useEffect$1(() => {
    E || B(k);
  }, [E, k]);
  const q = (H) => {
    const W = lodashExports.isEqual(H, V);
    E || W || (B(H), x == null || x({ target: { value: (H == null ? void 0 : H.value) ?? null } }));
  }, [z, Z] = useState$1(!1), G = (H) => {
    h || d || Z(H);
  };
  useA11yStatusMessage({
    selectedOptionLabel: V == null ? void 0 : V.label,
    isOpen: z,
    optionsCount: a == null ? void 0 : a.options.length,
    statusMessageParentSelector: M
  });
  const K = useTestId(v), [U, F] = useState$1(""), N = ({ option: H, index: W }) => ({
    ...K("option", H.testId || `${W}`),
    option: H,
    optionRenderer: S,
    onClick: () => {
      q(H), G(!1);
    },
    onKeyDown: (re) => {
      var ae;
      re.preventDefault(), !(!["Enter", "Space", "Tab"].includes(re.code) || (ae = H.disabled) != null && ae.isDisabled) && (q(H), G(!1));
    },
    isSelected: lodashExports.isEqual(H, V),
    id: `select-option-${W}`,
    setActiveOptionId: F
  });
  useEffect$1(() => {
    var H;
    z || (H = a == null ? void 0 : a.onChange) == null || H.call(a, { target: { value: "" } });
  }, [z]);
  const D = (a == null ? void 0 : a.options) ?? R, j = useMemo$1(() => !!getFlatOptions(D).length, [D]);
  return {
    options: D,
    triggerProps: {
      onClick: (H) => {
        G(!z), y == null || y(H);
      },
      onClear: () => {
        q(null), w == null || w();
      },
      isOpen: z,
      isLoading: d,
      isReadOnly: h,
      isViewMode: p,
      size: c,
      selectedOption: V,
      autoFocus: u,
      "aria-activedescendant": z ? U : "",
      id: P,
      ...K(),
      ...T
    },
    menuProps: {
      width: L,
      maxWidth: I,
      maxHeight: "300px",
      footer: g,
      isReadOnly: h || d || p,
      isOpen: z,
      onOpenChange: G,
      disableMenuShift: !0,
      // We disable the typeahead feature if `searchBarProps` is provided because it handles the filtering.
      disableTypeahead: !!a,
      role: "listbox",
      hasItems: j,
      // We need to pass the form-field label id to the menu for a11y.
      "aria-labelledby": P && `${P}-label`,
      ...K("menu")
    },
    // We need to remove `options` from `searchBarProps` because it's not a valid prop for `SearchBar`.
    searchBarProps: a && lodashExports.pickBy(a, (H, W) => W !== "options"),
    getOptionProps: N,
    emptyStateProps: {
      emptyState: m,
      ...K("empty-state")
    }
  };
}, SelectNewComponent = (r, a) => {
  const { options: s, triggerProps: c, menuProps: u, searchBarProps: d, getOptionProps: h, emptyStateProps: p } = useSelect$2(r), m = useTestId(u["data-testid"] ?? "");
  return /* @__PURE__ */ jsx(
    FloatingMenu,
    {
      ...u,
      ref: a,
      trigger: /* @__PURE__ */ jsx(Trigger, { ...c }),
      header: d && /* @__PURE__ */ jsx(FloatingMenu.Header, { children: /* @__PURE__ */ jsx(SearchBar, { ...d }) }),
      content: /* @__PURE__ */ jsx(
        FloatingMenu.DropdownList,
        {
          as: checkHasSections(s) ? "div" : "ul",
          paddingY: "xs",
          ...m("content"),
          children: s.length ? checkHasSections(s) ? s.map((g, v) => /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              FloatingMenu.Section,
              {
                label: g.label,
                "data-component": "SelectNew.Section",
                children: g.options.map((y, x) => /* @__PURE__ */ jsx(
                  Option$1,
                  {
                    ...h({ option: y, index: x })
                  },
                  `${y.label}-${x}`
                ))
              },
              `section-${v}`
            ),
            v !== s.length - 1 && /* @__PURE__ */ jsx(FloatingMenu.Divider, { "data-component": "SelectNew.Divider" })
          ] })) : s.map((g, v) => /* @__PURE__ */ jsx(Option$1, { ...h({ option: g, index: v }) }, `${g.label}-${v}`)) : /* @__PURE__ */ jsx(EmptyState, { ...p })
        }
      )
    }
  );
}, SelectNew$1 = forwardRef$1(SelectNewComponent);
SelectNew$1.displayName = "SelectNew";
const components$2 = { Footer }, SelectNew = Object.assign(SelectNew$1, components$2), SwitchComponent = (r, a) => {
  const {
    label: s,
    id: c,
    isDisabled: u,
    defaultIsChecked: d = !1,
    value: h,
    onChange: p,
    size: m = "large",
    isViewMode: g,
    isReadOnly: v,
    isInvalid: y,
    isFullWidth: x,
    "data-testid": w = "switch",
    "aria-label": S,
    ...M
  } = r, [P, L] = useState$1(d), I = lodashExports.uniqueId("switch_"), T = useMultiStyleConfig("Switch", {
    size: m,
    isFullWidth: x
  }), E = h ?? P, R = useTestId(w), A = (k) => {
    v || (L(k.target.checked), p == null || p(k.target.checked));
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      id: c,
      "data-component": "Switch",
      ref: a,
      __css: T.container,
      "aria-disabled": u,
      "data-readonly": v || void 0,
      as: "label",
      htmlFor: I,
      ...R(),
      children: [
        s && /* @__PURE__ */ jsx(
          Box,
          {
            as: "span",
            __css: T.label,
            "data-disabled": u || void 0,
            "data-readonly": v || void 0,
            children: s
          }
        ),
        /* @__PURE__ */ jsxs(Box, { __css: T.switch, children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              as: "input",
              type: "checkbox",
              onChange: A,
              onClick: (k) => k.stopPropagation(),
              disabled: u,
              "data-readonly": v || void 0,
              role: "switch",
              "aria-label": S ?? s ?? "Switch",
              "aria-checked": E,
              checked: E,
              "data-testid": "switch-input",
              "aria-readonly": v,
              ...M,
              id: I
            }
          ),
          /* @__PURE__ */ jsx(
            Box,
            {
              as: "span",
              __css: T.slider,
              "data-checked": E || void 0,
              "data-disabled": u || void 0,
              "data-readonly": v || void 0
            }
          )
        ] })
      ]
    }
  );
}, Switch = forwardRef$1(SwitchComponent);
Switch.displayName = "Switch";
const TextAreaComponent = ({
  isViewMode: r,
  isEditable: a = !0,
  isLoading: s,
  placeholder: c,
  footer: u,
  isReadOnly: d,
  isDisabled: h,
  isInvalid: p,
  numberOfRows: m,
  maxChars: g,
  "data-testid": v = "text-area-input",
  ...y
}, x) => {
  const w = !h && a, [S, M] = useState$1(!1), P = useMultiStyleConfig("TextArea", {}), { maxChars: L } = useFormControlContext(), I = useTestId(v);
  return /* @__PURE__ */ jsx(
    InputGroup,
    {
      __css: P.container,
      "aria-disabled": h,
      "data-editable": a,
      "data-readonly": d || s,
      "data-loading": s || void 0,
      "aria-invalid": p,
      "data-focus": w && S || void 0,
      onFocus: () => M(!0),
      onBlur: () => M(!1),
      onMouseDown: w ? void 0 : (T) => T.preventDefault(),
      children: /* @__PURE__ */ jsxs(Group, { spacing: "none", hasDivider: !0, variant: "vertical", children: [
        /* @__PURE__ */ jsxs(Group, { width: "full", spacing: "xs", alignItems: "center", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              as: "textarea",
              "data-component": "TextArea",
              "aria-label": "text area input",
              ...I(),
              "data-loading": s || void 0,
              placeholder: c,
              sx: P.field,
              "data-editable": a,
              "aria-disabled": h,
              "aria-readonly": d,
              "aria-invalid": p,
              disabled: h,
              readOnly: d || s,
              ...a && y,
              rows: m || 4,
              maxLength: g ?? L,
              ref: x
            }
          ),
          s && /* @__PURE__ */ jsx(Box, { __css: P.loaderContainer, children: /* @__PURE__ */ jsx(Loader, {}) })
        ] }),
        u && !a && /* @__PURE__ */ jsx(Box, { __css: P.footerContainer, children: /* @__PURE__ */ jsx(Checkbox, { ...!a && y, ...u }) })
      ] })
    }
  );
}, TextArea = forwardRef$1(TextAreaComponent);
TextArea.displayName = "TextArea";
const checkIfAllValid = (r) => r.every((a) => {
  var s;
  return (s = a.current) == null ? void 0 : s.value;
}), checkIsNumeric = (r) => typeof r != "string" ? !1 : !isNaN(+r) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
!isNaN(parseFloat(r)), DEFAULT_LENGTH = 4, DEFAULT_INVALID_MESSAGE = "The code does not match the latest code or the latest code is invalid", DEFAULT_EMPTY_FIELD_INVALID_MESSAGE = "All fields are required", VerificationCodeField = forwardRef$1(
  ({
    onComplete: r,
    length: a = DEFAULT_LENGTH,
    invalidErrorMessages: s,
    requiredFieldsErrorMessages: c,
    fieldAriaLabel: u = "Verification code field",
    autoFocus: d = !1,
    ...h
  }, p) => {
    const m = useMultiStyleConfig("VerificationCodeField", { length: a }), [g, v] = useState$1([]), [y, x] = useState$1(!1), [w, S] = useState$1([]), [M, P] = useState$1(!1), [L, I] = useState$1(), T = !w.every((U) => U), E = L || M && T;
    useEffect$1(() => {
      var U;
      if (L) {
        x(!1);
        const F = (U = g[0]) == null ? void 0 : U.current;
        F && A(F);
      }
    }, [L]), useEffect$1(() => {
      T || I(!1);
    }, [T]), useEffect$1(() => {
      const U = a > w.length ? w.concat(Array(a - w.length).fill("")) : w.slice(0, a);
      S(U), v(
        Array(a).fill("").map(() => createRef())
      );
    }, [a]);
    const R = useCallback$1((U) => {
      var F;
      return (F = g[U]) == null ? void 0 : F.current;
    }, [g]), A = useCallback$1((U) => {
      U.focus(), U.value && setTimeout(() => {
        U.select();
      });
    }, []), k = useCallback$1(
      async (U) => {
        I(!1), x(!0);
        const F = await r(U);
        F || I(!F);
      },
      [r]
    ), V = useCallback$1(
      async (U, F) => {
        var W;
        if (!g[U]) return;
        const N = (W = g[U]) == null ? void 0 : W.current;
        if (N != null && N.value && !checkIsNumeric(N.value)) return;
        const D = R(U + 1), j = w.map((re, ae) => ae === U ? (N == null ? void 0 : N.value) ?? "" : re), H = F && checkIfAllValid(g);
        S(j), N != null && N.value && (!H && D ? A(D) : H && (N.blur(), await k(j.join(""))));
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [r, w]
    ), B = useCallback$1(
      (U) => {
        var D;
        if (!g[U]) return;
        const F = (D = g[U]) == null ? void 0 : D.current;
        if (F != null && F.value) {
          const j = w.map((H, W) => W === U ? "" : H);
          S(j);
          return;
        }
        const N = R(U - 1);
        N && A(N);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [w, R, A]
    ), q = useCallback$1(
      (U) => {
        const F = R(U);
        F && A(F);
      },
      [R, A]
    ), z = useCallback$1(
      (U, F) => {
        switch (U.code) {
          case "Backspace":
            B(F);
            break;
          case "ArrowLeft": {
            const N = F === 0 ? 0 : F - 1;
            q(N);
            break;
          }
          case "ArrowRight": {
            const N = w.length - 1, D = F === N ? N : F + 1;
            q(D);
            break;
          }
          case "KeyZ":
          case "KeyY": {
            U.preventDefault();
            return;
          }
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [B, q]
    ), Z = useCallback$1(
      async (U) => {
        U.preventDefault(), P(!0), checkIfAllValid(g) && await k(w.join(""));
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [k, w]
    ), G = useCallback$1(
      async (U, F) => {
        if (F > 0) return;
        U.preventDefault();
        const N = U.clipboardData.getData("text");
        if (!checkIsNumeric(N)) return;
        const D = w.map((H, W) => N[W] ?? H);
        if (S(D), D.every((H) => H))
          x(!0), await k(D.join(""));
        else {
          const H = R(N.length);
          H && A(H);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [w]
    ), K = useCallback$1(
      (U) => {
        var N;
        if (!g[U]) return;
        const F = (N = g[U]) == null ? void 0 : N.current;
        F && A(F);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [A]
    );
    return /* @__PURE__ */ jsxs(Box, { __css: m.container, children: [
      /* @__PURE__ */ jsx(
        _Form,
        {
          isLoading: y,
          onSubmit: Z,
          ref: p,
          "data-component": "VerificationCodeField",
          "data-testid": "verification-code-field",
          ...h,
          sx: m.form,
          children: w.map((U, F) => /* @__PURE__ */ jsx(
            TextField,
            {
              onFocus: () => K(F),
              onInput: async () => {
                const N = F === w.length - 1;
                await V(F, N);
              },
              onKeyDown: (N) => z(N, F),
              onPaste: async (N) => await G(N, F),
              "data-testid": `verification-code-field-input-${F}`,
              ref: g[F],
              isDisabled: y,
              isInvalid: E,
              type: "text",
              maxLength: 1,
              value: U,
              size: "large",
              sx: m.input,
              "aria-label": `${u} ${F + 1}`,
              autoFocus: F === 0 && d,
              inputMode: "numeric"
            },
            `verification-code-field-input-${F}`
          ))
        }
      ),
      E && /* @__PURE__ */ jsx(
        Typography.Description,
        {
          isInvalid: E,
          label: T ? c ?? DEFAULT_EMPTY_FIELD_INVALID_MESSAGE : s ?? DEFAULT_INVALID_MESSAGE
        }
      )
    ] });
  }
);
VerificationCodeField.displayName = "VerificationCodeField";
const InputComponent = ({
  selectValue: r,
  valueRightElement: a,
  onFocus: s,
  onBlur: c,
  size: u,
  isDisabled: d,
  isReadOnly: h,
  isViewMode: p,
  selectedOption: m,
  hasSections: g,
  leftElement: v,
  rightElement: y,
  value: x,
  autoFocus: w = !1,
  ...S
}, M) => {
  const P = useTestId("base-select"), [L, I] = useState$1(0), T = useCallback$1((q) => {
    q && I(q.offsetWidth);
  }, []), [E, R] = useState$1(!1), [A, k] = useState$1(!1), V = useMultiStyleConfig("BaseSelect", {
    hasLeftElement: !!v,
    isViewMode: p,
    // Passing `valueRightElementWidth` only when overlay is visible so that we can type until the end of the input.
    valueRightElementWidth: A ? L : 0
  });
  useEffect$1(() => {
    var Z;
    const q = !!m || !!r, z = g || !!((Z = m == null ? void 0 : m.avatarProps) != null && Z.badge) || !!a;
    k(z && q && !E);
  }, [g, m, a, r, E]);
  const B = (m == null ? void 0 : m.label) ?? r;
  return p ? /* @__PURE__ */ jsxs(
    Box,
    {
      ref: M,
      __css: V.triggerOverlay,
      "data-disabled": d || null,
      "data-readonly": h || null,
      "data-view-mode": p || null,
      "data-testid": S["data-testid"],
      children: [
        /* @__PURE__ */ jsx(
          Text,
          {
            textStyle: "inline",
            color: B ? "inherit" : "semantic.text.secondary",
            shouldSupportEllipsis: !0,
            children: x != null && x.length ? x : S.viewModePlaceholder ?? S.placeholder
          }
        ),
        a && /* @__PURE__ */ jsx(Box, { ref: T, __css: V.valueRightElement, children: a })
      ]
    }
  ) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      TextField,
      {
        "data-component": "BaseSelect.Input",
        ref: M,
        sx: V.trigger,
        ...P("input"),
        ...S,
        onFocus: (q) => {
          R(!0), s == null || s(q);
        },
        onBlur: (q) => {
          R(!1), c == null || c(q);
        },
        size: u,
        isDisabled: d,
        isReadOnly: h,
        isViewMode: p,
        leftElement: v,
        rightElement: y,
        value: x,
        autoFocus: w
      }
    ),
    A && /* @__PURE__ */ jsxs(
      Box,
      {
        __css: V.triggerOverlay,
        "data-disabled": d || null,
        "data-readonly": h || null,
        "data-view-mode": p || null,
        ...P("input", "overlay"),
        children: [
          B && /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: B }),
          a && /* @__PURE__ */ jsx(Box, { ref: T, __css: V.valueRightElement, children: a })
        ]
      }
    )
  ] });
}, Input = React__default.forwardRef(InputComponent);
Input.displayName = "BaseSelect.Input";
const LoadingState = forwardRef$1(
  ({ "data-testid": r = "base-select", ...a }, s) => {
    const c = useMultiStyleConfig("BaseSelect", {}), u = useTestId(r);
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "BaseSelect.LoadingState",
        __css: c.loading,
        ref: s,
        ...u("loading-state"),
        ...a,
        children: "Loading..."
      }
    );
  }
);
LoadingState.displayName = "BaseSelect.LoadingState";
const Option = forwardRef$1(
  ({ isHighlighted: r, isFocused: a, isSelected: s, ...c }, u) => {
    const d = useMultiStyleConfig("BaseSelect", {}), [h, p] = useBoolean(!1);
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: "li",
        "data-component": "BaseSelect.Option",
        ref: u,
        __css: d.option,
        onMouseOver: p.on,
        onMouseOut: p.off,
        ...c,
        "data-active": h || h && r || void 0,
        "data-focus": a || void 0,
        "data-is-selected": s || void 0
      }
    );
  }
);
Option.displayName = "BaseSelect.Option";
const OptionContent = ({
  avatarProps: r,
  leftIcon: a,
  rightIcon: s,
  pillProps: c,
  description: u,
  label: d,
  isSelected: h
}) => {
  const p = useMultiStyleConfig("BaseSelect", {});
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    a && /* @__PURE__ */ jsx(BrandSymbol, { type: a, size: "small" }),
    r && /* @__PURE__ */ jsx(Avatar, { ...r, name: r.name ?? d, size: "small", isSelected: h, "aria-hidden": !0 }),
    /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxs", children: [
      /* @__PURE__ */ jsxs(Group, { spacing: "xxs", alignItems: "center", children: [
        /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: d }),
        s && /* @__PURE__ */ jsx(Icon, { type: s, size: "small" }),
        c && /* @__PURE__ */ jsx(Pill, { type: "secondary", ...c })
      ] }),
      u && /* @__PURE__ */ jsx(Typography.Description, { label: u })
    ] }),
    h && /* @__PURE__ */ jsx(Box, { __css: p.checkedIcon, children: /* @__PURE__ */ jsx(Icon, { type: "checked", color: "brand", size: "small" }) })
  ] });
};
OptionContent.displayName = "BaseSelect.OptionContent";
const TriggerRightIcon = forwardRef$1(
  ({ icon: r, isDisabled: a, isReadOnly: s, isViewMode: c, onClick: u, ...d }, h) => {
    const p = useMultiStyleConfig("BaseSelect", {}), m = useTestId("base-select");
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "BaseSelect.TriggerRightIcon",
        ref: h,
        as: "button",
        type: "button",
        __css: p.triggerRightIcon,
        disabled: a || s,
        "data-view-mode": c || void 0,
        onClick: (g) => {
          g.stopPropagation(), u == null || u(g);
        },
        ...m("trigger-right-icon"),
        ...d,
        children: /* @__PURE__ */ jsx(Icon, { size: "small", type: r, color: "inherit", "aria-hidden": !0 })
      }
    );
  }
);
TriggerRightIcon.displayName = "BaseSelect.TriggerRightIcon";
const ToggleButtonComponent = ({
  selectValue: r,
  placeholder: a = "Select",
  viewModePlaceholder: s,
  size: c,
  isDisabled: u,
  isReadOnly: d,
  isViewMode: h,
  isInvalid: p,
  isLoading: m,
  "aria-expanded": g,
  id: v,
  onClick: y,
  onFocus: x,
  onBlur: w,
  ...S
}, M) => {
  const P = useTestId("base-select"), [L, I] = useState$1(null), T = useCallback$1((D) => {
    D && I(D.clientWidth);
  }, []), E = lodashExports.isArray(r) ? r.map(({ label: D }) => D).join(", ") : r == null ? void 0 : r.label, V = !lodashExports.isEmpty(useFormControlContext()) ? s ?? a : h && s ? s : a, B = u || m || d || h, q = !u && !h, z = useMultiStyleConfig("BaseSelect", { isViewMode: h, placeholderValue: V }), Z = {
    "aria-disabled": u || void 0,
    "data-readonly": d || m || h || void 0,
    "data-loading": m || void 0,
    "data-view-mode": h || void 0,
    "data-invalid": p || void 0
  }, G = useCallback$1(
    (D) => {
      B || (D.stopPropagation(), y == null || y(D));
    },
    [y, B]
  ), [K, U] = useBoolean(!1), [F, N] = useBoolean(!1);
  return (
    // Using chakra's `Input` so we can inherit the styles for the button from `form.utils.ts`.
    /* @__PURE__ */ jsxs(InputGroup, { children: [
      /* @__PURE__ */ jsx(
        Input$1,
        {
          "data-component": "BaseSelect.ToggleButton",
          ref: M,
          sx: z.triggerInput,
          className: c,
          ...P("trigger-input"),
          ...S,
          id: v,
          onMouseDown: G,
          "aria-expanded": g,
          placeholder: V,
          tabIndex: q ? 0 : -1,
          ...Z,
          onFocus: (D) => {
            U.on(), !B && (x == null || x(D));
          },
          onBlur: (D) => {
            U.off(), !B && (w == null || w(D));
          },
          onMouseOver: N.on,
          onMouseOut: N.off
        }
      ),
      /* @__PURE__ */ jsx(
        Input$1,
        {
          as: "div",
          sx: z.trigger,
          className: c,
          ...P("trigger-value"),
          id: `select-trigger-ui${v ? `-${v}` : ""}`,
          ...Z,
          paddingRight: L ? `calc(${L}px + ${themeSpaces.xs})` : "none",
          "data-focus": K || void 0,
          "data-hover": !K && F || void 0,
          tabIndex: -1,
          "aria-hidden": !0,
          "data-ui-only": !0,
          children: E ? /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, "aria-hidden": !0, children: E }) : /* @__PURE__ */ jsx(
            Box,
            {
              __css: z.placeholder,
              "data-disabled": u || void 0,
              "data-readonly": d || void 0,
              "aria-hidden": !0
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(InputRightElement, { ref: T, sx: z.toggleButtonRightElement, children: m ? /* @__PURE__ */ jsx(Box, { as: Loader, __css: z.loader }) : /* @__PURE__ */ jsx(
        TriggerRightIcon,
        {
          "aria-label": "Toggle select dropdown menu",
          icon: g ? "caret-up" : "caret-down",
          isDisabled: u,
          isReadOnly: d,
          isViewMode: h,
          onClick: G
        }
      ) })
    ] })
  );
}, ToggleButton = React__default.forwardRef(ToggleButtonComponent);
ToggleButton.displayName = "BaseSelect.ToggleButton";
const TriggerLeftIcon = forwardRef$1(
  ({ type: r, size: a, isDisabled: s, isReadOnly: c, isViewMode: u, ...d }, h) => {
    const p = useMultiStyleConfig("BaseSelect", {}), m = useTestId("base-select");
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "BaseSelect.TriggerLeftIcon",
        ref: h,
        as: "span",
        __css: p.triggerLeftIcon,
        "data-view-mode": u || void 0,
        "data-disabled": s || c || void 0,
        ...m("trigger-left-icon"),
        ...d,
        children: /* @__PURE__ */ jsx(Icon, { size: "small", type: r, color: "inherit" })
      }
    );
  }
);
TriggerLeftIcon.displayName = "BaseSelect.TriggerLeftIcon";
const components$1 = {
  CreatableOption,
  DropdownMenu,
  EmptyState: EmptyState$1,
  Input,
  TriggerLeftIcon,
  TriggerRightIcon,
  LoadingState,
  Option,
  OptionContent,
  Section,
  ToggleButton
};
function _objectWithoutPropertiesLoose$1(r, a) {
  if (r == null) return {};
  var s = {};
  for (var c in r) if ({}.hasOwnProperty.call(r, c)) {
    if (a.includes(c)) continue;
    s[c] = r[c];
  }
  return s;
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var c in s) ({}).hasOwnProperty.call(s, c) && (r[c] = s[c]);
    }
    return r;
  }, _extends$3.apply(null, arguments);
}
function _assertThisInitialized(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function _setPrototypeOf(r, a) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, c) {
    return s.__proto__ = c, s;
  }, _setPrototypeOf(r, a);
}
function _inheritsLoose(r, a) {
  r.prototype = Object.create(a.prototype), r.prototype.constructor = r, _setPrototypeOf(r, a);
}
var propTypes$3 = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var r = typeof Symbol == "function" && Symbol.for, a = r ? Symbol.for("react.element") : 60103, s = r ? Symbol.for("react.portal") : 60106, c = r ? Symbol.for("react.fragment") : 60107, u = r ? Symbol.for("react.strict_mode") : 60108, d = r ? Symbol.for("react.profiler") : 60114, h = r ? Symbol.for("react.provider") : 60109, p = r ? Symbol.for("react.context") : 60110, m = r ? Symbol.for("react.async_mode") : 60111, g = r ? Symbol.for("react.concurrent_mode") : 60111, v = r ? Symbol.for("react.forward_ref") : 60112, y = r ? Symbol.for("react.suspense") : 60113, x = r ? Symbol.for("react.suspense_list") : 60120, w = r ? Symbol.for("react.memo") : 60115, S = r ? Symbol.for("react.lazy") : 60116, M = r ? Symbol.for("react.block") : 60121, P = r ? Symbol.for("react.fundamental") : 60117, L = r ? Symbol.for("react.responder") : 60118, I = r ? Symbol.for("react.scope") : 60119;
  function T(R) {
    if (typeof R == "object" && R !== null) {
      var A = R.$$typeof;
      switch (A) {
        case a:
          switch (R = R.type, R) {
            case m:
            case g:
            case c:
            case d:
            case u:
            case y:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case p:
                case v:
                case S:
                case w:
                case h:
                  return R;
                default:
                  return A;
              }
          }
        case s:
          return A;
      }
    }
  }
  function E(R) {
    return T(R) === g;
  }
  return reactIs_production_min$1.AsyncMode = m, reactIs_production_min$1.ConcurrentMode = g, reactIs_production_min$1.ContextConsumer = p, reactIs_production_min$1.ContextProvider = h, reactIs_production_min$1.Element = a, reactIs_production_min$1.ForwardRef = v, reactIs_production_min$1.Fragment = c, reactIs_production_min$1.Lazy = S, reactIs_production_min$1.Memo = w, reactIs_production_min$1.Portal = s, reactIs_production_min$1.Profiler = d, reactIs_production_min$1.StrictMode = u, reactIs_production_min$1.Suspense = y, reactIs_production_min$1.isAsyncMode = function(R) {
    return E(R) || T(R) === m;
  }, reactIs_production_min$1.isConcurrentMode = E, reactIs_production_min$1.isContextConsumer = function(R) {
    return T(R) === p;
  }, reactIs_production_min$1.isContextProvider = function(R) {
    return T(R) === h;
  }, reactIs_production_min$1.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === a;
  }, reactIs_production_min$1.isForwardRef = function(R) {
    return T(R) === v;
  }, reactIs_production_min$1.isFragment = function(R) {
    return T(R) === c;
  }, reactIs_production_min$1.isLazy = function(R) {
    return T(R) === S;
  }, reactIs_production_min$1.isMemo = function(R) {
    return T(R) === w;
  }, reactIs_production_min$1.isPortal = function(R) {
    return T(R) === s;
  }, reactIs_production_min$1.isProfiler = function(R) {
    return T(R) === d;
  }, reactIs_production_min$1.isStrictMode = function(R) {
    return T(R) === u;
  }, reactIs_production_min$1.isSuspense = function(R) {
    return T(R) === y;
  }, reactIs_production_min$1.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === c || R === g || R === d || R === u || R === y || R === x || typeof R == "object" && R !== null && (R.$$typeof === S || R.$$typeof === w || R.$$typeof === h || R.$$typeof === p || R.$$typeof === v || R.$$typeof === P || R.$$typeof === L || R.$$typeof === I || R.$$typeof === M);
  }, reactIs_production_min$1.typeOf = T, reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, a = r ? Symbol.for("react.element") : 60103, s = r ? Symbol.for("react.portal") : 60106, c = r ? Symbol.for("react.fragment") : 60107, u = r ? Symbol.for("react.strict_mode") : 60108, d = r ? Symbol.for("react.profiler") : 60114, h = r ? Symbol.for("react.provider") : 60109, p = r ? Symbol.for("react.context") : 60110, m = r ? Symbol.for("react.async_mode") : 60111, g = r ? Symbol.for("react.concurrent_mode") : 60111, v = r ? Symbol.for("react.forward_ref") : 60112, y = r ? Symbol.for("react.suspense") : 60113, x = r ? Symbol.for("react.suspense_list") : 60120, w = r ? Symbol.for("react.memo") : 60115, S = r ? Symbol.for("react.lazy") : 60116, M = r ? Symbol.for("react.block") : 60121, P = r ? Symbol.for("react.fundamental") : 60117, L = r ? Symbol.for("react.responder") : 60118, I = r ? Symbol.for("react.scope") : 60119;
    function T(pe) {
      return typeof pe == "string" || typeof pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      pe === c || pe === g || pe === d || pe === u || pe === y || pe === x || typeof pe == "object" && pe !== null && (pe.$$typeof === S || pe.$$typeof === w || pe.$$typeof === h || pe.$$typeof === p || pe.$$typeof === v || pe.$$typeof === P || pe.$$typeof === L || pe.$$typeof === I || pe.$$typeof === M);
    }
    function E(pe) {
      if (typeof pe == "object" && pe !== null) {
        var we = pe.$$typeof;
        switch (we) {
          case a:
            var ye = pe.type;
            switch (ye) {
              case m:
              case g:
              case c:
              case d:
              case u:
              case y:
                return ye;
              default:
                var Ie = ye && ye.$$typeof;
                switch (Ie) {
                  case p:
                  case v:
                  case S:
                  case w:
                  case h:
                    return Ie;
                  default:
                    return we;
                }
            }
          case s:
            return we;
        }
      }
    }
    var R = m, A = g, k = p, V = h, B = a, q = v, z = c, Z = S, G = w, K = s, U = d, F = u, N = y, D = !1;
    function j(pe) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(pe) || E(pe) === m;
    }
    function H(pe) {
      return E(pe) === g;
    }
    function W(pe) {
      return E(pe) === p;
    }
    function re(pe) {
      return E(pe) === h;
    }
    function ae(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === a;
    }
    function ee(pe) {
      return E(pe) === v;
    }
    function X(pe) {
      return E(pe) === c;
    }
    function J(pe) {
      return E(pe) === S;
    }
    function ie(pe) {
      return E(pe) === w;
    }
    function oe(pe) {
      return E(pe) === s;
    }
    function fe(pe) {
      return E(pe) === d;
    }
    function ve(pe) {
      return E(pe) === u;
    }
    function ue(pe) {
      return E(pe) === y;
    }
    reactIs_development$1.AsyncMode = R, reactIs_development$1.ConcurrentMode = A, reactIs_development$1.ContextConsumer = k, reactIs_development$1.ContextProvider = V, reactIs_development$1.Element = B, reactIs_development$1.ForwardRef = q, reactIs_development$1.Fragment = z, reactIs_development$1.Lazy = Z, reactIs_development$1.Memo = G, reactIs_development$1.Portal = K, reactIs_development$1.Profiler = U, reactIs_development$1.StrictMode = F, reactIs_development$1.Suspense = N, reactIs_development$1.isAsyncMode = j, reactIs_development$1.isConcurrentMode = H, reactIs_development$1.isContextConsumer = W, reactIs_development$1.isContextProvider = re, reactIs_development$1.isElement = ae, reactIs_development$1.isForwardRef = ee, reactIs_development$1.isFragment = X, reactIs_development$1.isLazy = J, reactIs_development$1.isMemo = ie, reactIs_development$1.isPortal = oe, reactIs_development$1.isProfiler = fe, reactIs_development$1.isStrictMode = ve, reactIs_development$1.isSuspense = ue, reactIs_development$1.isValidElementType = T, reactIs_development$1.typeOf = E;
  }()), reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var r = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function c(d) {
    if (d == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(d);
  }
  function u() {
    try {
      if (!Object.assign)
        return !1;
      var d = new String("abc");
      if (d[5] = "de", Object.getOwnPropertyNames(d)[0] === "5")
        return !1;
      for (var h = {}, p = 0; p < 10; p++)
        h["_" + String.fromCharCode(p)] = p;
      var m = Object.getOwnPropertyNames(h).map(function(v) {
        return h[v];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var g = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        g[v] = v;
      }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = u() ? Object.assign : function(d, h) {
    for (var p, m = c(d), g, v = 1; v < arguments.length; v++) {
      p = Object(arguments[v]);
      for (var y in p)
        a.call(p, y) && (m[y] = p[y]);
      if (r) {
        g = r(p);
        for (var x = 0; x < g.length; x++)
          s.call(p, g[x]) && (m[g[x]] = p[g[x]]);
      }
    }
    return m;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = r, ReactPropTypesSecret_1;
}
var has$3, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$3 = Function.call.bind(Object.prototype.hasOwnProperty)), has$3;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = requireReactPropTypesSecret(), s = {}, c = requireHas();
    r = function(d) {
      var h = "Warning: " + d;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {
      }
    };
  }
  function u(d, h, p, m, g) {
    if (process.env.NODE_ENV !== "production") {
      for (var v in d)
        if (c(d, v)) {
          var y;
          try {
            if (typeof d[v] != "function") {
              var x = Error(
                (m || "React class") + ": " + p + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw x.name = "Invariant Violation", x;
            }
            y = d[v](h, v, m, p, null, a);
          } catch (S) {
            y = S;
          }
          if (y && !(y instanceof Error) && r(
            (m || "React class") + ": type specification of " + p + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in s)) {
            s[y.message] = !0;
            var w = g ? g() : "";
            r(
              "Failed " + p + " type: " + y.message + (w ?? "")
            );
          }
        }
    }
  }
  return u.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (s = {});
  }, checkPropTypes_1 = u, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var r = requireReactIs(), a = requireObjectAssign(), s = requireReactPropTypesSecret(), c = requireHas(), u = requireCheckPropTypes(), d = function() {
  };
  process.env.NODE_ENV !== "production" && (d = function(p) {
    var m = "Warning: " + p;
    typeof console < "u" && console.error(m);
    try {
      throw new Error(m);
    } catch {
    }
  });
  function h() {
    return null;
  }
  return factoryWithTypeCheckers = function(p, m) {
    var g = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function y(H) {
      var W = H && (g && H[g] || H[v]);
      if (typeof W == "function")
        return W;
    }
    var x = "<<anonymous>>", w = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: I(),
      arrayOf: T,
      element: E(),
      elementType: R(),
      instanceOf: A,
      node: q(),
      objectOf: V,
      oneOf: k,
      oneOfType: B,
      shape: Z,
      exact: G
    };
    function S(H, W) {
      return H === W ? H !== 0 || 1 / H === 1 / W : H !== H && W !== W;
    }
    function M(H, W) {
      this.message = H, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    M.prototype = Error.prototype;
    function P(H) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, re = 0;
      function ae(X, J, ie, oe, fe, ve, ue) {
        if (oe = oe || x, ve = ve || ie, ue !== s) {
          if (m) {
            var pe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw pe.name = "Invariant Violation", pe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var we = oe + ":" + ie;
            !W[we] && // Avoid spamming the console because they are often not actionable except for lib authors
            re < 3 && (d(
              "You are manually calling a React.PropTypes validation function for the `" + ve + "` prop on `" + oe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[we] = !0, re++);
          }
        }
        return J[ie] == null ? X ? J[ie] === null ? new M("The " + fe + " `" + ve + "` is marked as required " + ("in `" + oe + "`, but its value is `null`.")) : new M("The " + fe + " `" + ve + "` is marked as required in " + ("`" + oe + "`, but its value is `undefined`.")) : null : H(J, ie, oe, fe, ve);
      }
      var ee = ae.bind(null, !1);
      return ee.isRequired = ae.bind(null, !0), ee;
    }
    function L(H) {
      function W(re, ae, ee, X, J, ie) {
        var oe = re[ae], fe = F(oe);
        if (fe !== H) {
          var ve = N(oe);
          return new M(
            "Invalid " + X + " `" + J + "` of type " + ("`" + ve + "` supplied to `" + ee + "`, expected ") + ("`" + H + "`."),
            { expectedType: H }
          );
        }
        return null;
      }
      return P(W);
    }
    function I() {
      return P(h);
    }
    function T(H) {
      function W(re, ae, ee, X, J) {
        if (typeof H != "function")
          return new M("Property `" + J + "` of component `" + ee + "` has invalid PropType notation inside arrayOf.");
        var ie = re[ae];
        if (!Array.isArray(ie)) {
          var oe = F(ie);
          return new M("Invalid " + X + " `" + J + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected an array."));
        }
        for (var fe = 0; fe < ie.length; fe++) {
          var ve = H(ie, fe, ee, X, J + "[" + fe + "]", s);
          if (ve instanceof Error)
            return ve;
        }
        return null;
      }
      return P(W);
    }
    function E() {
      function H(W, re, ae, ee, X) {
        var J = W[re];
        if (!p(J)) {
          var ie = F(J);
          return new M("Invalid " + ee + " `" + X + "` of type " + ("`" + ie + "` supplied to `" + ae + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(H);
    }
    function R() {
      function H(W, re, ae, ee, X) {
        var J = W[re];
        if (!r.isValidElementType(J)) {
          var ie = F(J);
          return new M("Invalid " + ee + " `" + X + "` of type " + ("`" + ie + "` supplied to `" + ae + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(H);
    }
    function A(H) {
      function W(re, ae, ee, X, J) {
        if (!(re[ae] instanceof H)) {
          var ie = H.name || x, oe = j(re[ae]);
          return new M("Invalid " + X + " `" + J + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected ") + ("instance of `" + ie + "`."));
        }
        return null;
      }
      return P(W);
    }
    function k(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? d(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : d("Invalid argument supplied to oneOf, expected an array.")), h;
      function W(re, ae, ee, X, J) {
        for (var ie = re[ae], oe = 0; oe < H.length; oe++)
          if (S(ie, H[oe]))
            return null;
        var fe = JSON.stringify(H, function(ue, pe) {
          var we = N(pe);
          return we === "symbol" ? String(pe) : pe;
        });
        return new M("Invalid " + X + " `" + J + "` of value `" + String(ie) + "` " + ("supplied to `" + ee + "`, expected one of " + fe + "."));
      }
      return P(W);
    }
    function V(H) {
      function W(re, ae, ee, X, J) {
        if (typeof H != "function")
          return new M("Property `" + J + "` of component `" + ee + "` has invalid PropType notation inside objectOf.");
        var ie = re[ae], oe = F(ie);
        if (oe !== "object")
          return new M("Invalid " + X + " `" + J + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected an object."));
        for (var fe in ie)
          if (c(ie, fe)) {
            var ve = H(ie, fe, ee, X, J + "." + fe, s);
            if (ve instanceof Error)
              return ve;
          }
        return null;
      }
      return P(W);
    }
    function B(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && d("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var W = 0; W < H.length; W++) {
        var re = H[W];
        if (typeof re != "function")
          return d(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + D(re) + " at index " + W + "."
          ), h;
      }
      function ae(ee, X, J, ie, oe) {
        for (var fe = [], ve = 0; ve < H.length; ve++) {
          var ue = H[ve], pe = ue(ee, X, J, ie, oe, s);
          if (pe == null)
            return null;
          pe.data && c(pe.data, "expectedType") && fe.push(pe.data.expectedType);
        }
        var we = fe.length > 0 ? ", expected one of type [" + fe.join(", ") + "]" : "";
        return new M("Invalid " + ie + " `" + oe + "` supplied to " + ("`" + J + "`" + we + "."));
      }
      return P(ae);
    }
    function q() {
      function H(W, re, ae, ee, X) {
        return K(W[re]) ? null : new M("Invalid " + ee + " `" + X + "` supplied to " + ("`" + ae + "`, expected a ReactNode."));
      }
      return P(H);
    }
    function z(H, W, re, ae, ee) {
      return new M(
        (H || "React class") + ": " + W + " type `" + re + "." + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ee + "`."
      );
    }
    function Z(H) {
      function W(re, ae, ee, X, J) {
        var ie = re[ae], oe = F(ie);
        if (oe !== "object")
          return new M("Invalid " + X + " `" + J + "` of type `" + oe + "` " + ("supplied to `" + ee + "`, expected `object`."));
        for (var fe in H) {
          var ve = H[fe];
          if (typeof ve != "function")
            return z(ee, X, J, fe, N(ve));
          var ue = ve(ie, fe, ee, X, J + "." + fe, s);
          if (ue)
            return ue;
        }
        return null;
      }
      return P(W);
    }
    function G(H) {
      function W(re, ae, ee, X, J) {
        var ie = re[ae], oe = F(ie);
        if (oe !== "object")
          return new M("Invalid " + X + " `" + J + "` of type `" + oe + "` " + ("supplied to `" + ee + "`, expected `object`."));
        var fe = a({}, re[ae], H);
        for (var ve in fe) {
          var ue = H[ve];
          if (c(H, ve) && typeof ue != "function")
            return z(ee, X, J, ve, N(ue));
          if (!ue)
            return new M(
              "Invalid " + X + " `" + J + "` key `" + ve + "` supplied to `" + ee + "`.\nBad object: " + JSON.stringify(re[ae], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  ")
            );
          var pe = ue(ie, ve, ee, X, J + "." + ve, s);
          if (pe)
            return pe;
        }
        return null;
      }
      return P(W);
    }
    function K(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H))
            return H.every(K);
          if (H === null || p(H))
            return !0;
          var W = y(H);
          if (W) {
            var re = W.call(H), ae;
            if (W !== H.entries) {
              for (; !(ae = re.next()).done; )
                if (!K(ae.value))
                  return !1;
            } else
              for (; !(ae = re.next()).done; ) {
                var ee = ae.value;
                if (ee && !K(ee[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U(H, W) {
      return H === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function F(H) {
      var W = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : U(W, H) ? "symbol" : W;
    }
    function N(H) {
      if (typeof H > "u" || H === null)
        return "" + H;
      var W = F(H);
      if (W === "object") {
        if (H instanceof Date)
          return "date";
        if (H instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function D(H) {
      var W = N(H);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function j(H) {
      return !H.constructor || !H.constructor.name ? x : H.constructor.name;
    }
    return w.checkPropTypes = u, w.resetWarningCache = u.resetWarningCache, w.PropTypes = w, w;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var r = requireReactPropTypesSecret();
  function a() {
  }
  function s() {
  }
  return s.resetWarningCache = a, factoryWithThrowingShims = function() {
    function c(h, p, m, g, v, y) {
      if (y !== r) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    c.isRequired = c;
    function u() {
      return c;
    }
    var d = {
      array: c,
      bigint: c,
      bool: c,
      func: c,
      number: c,
      object: c,
      string: c,
      symbol: c,
      any: c,
      arrayOf: u,
      element: c,
      elementType: c,
      instanceOf: u,
      node: c,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: s,
      resetWarningCache: a
    };
    return d.PropTypes = d, d;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes$3.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes$3.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes$3.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var r = 60103, a = 60106, s = 60107, c = 60108, u = 60114, d = 60109, h = 60110, p = 60112, m = 60113, g = 60120, v = 60115, y = 60116, x = 60121, w = 60122, S = 60117, M = 60129, P = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var L = Symbol.for;
    r = L("react.element"), a = L("react.portal"), s = L("react.fragment"), c = L("react.strict_mode"), u = L("react.profiler"), d = L("react.provider"), h = L("react.context"), p = L("react.forward_ref"), m = L("react.suspense"), g = L("react.suspense_list"), v = L("react.memo"), y = L("react.lazy"), x = L("react.block"), w = L("react.server.block"), S = L("react.fundamental"), M = L("react.debug_trace_mode"), P = L("react.legacy_hidden");
  }
  function I(G) {
    if (typeof G == "object" && G !== null) {
      var K = G.$$typeof;
      switch (K) {
        case r:
          switch (G = G.type, G) {
            case s:
            case u:
            case c:
            case m:
            case g:
              return G;
            default:
              switch (G = G && G.$$typeof, G) {
                case h:
                case p:
                case y:
                case v:
                case d:
                  return G;
                default:
                  return K;
              }
          }
        case a:
          return K;
      }
    }
  }
  var T = d, E = r, R = p, A = s, k = y, V = v, B = a, q = u, z = c, Z = m;
  return reactIs_production_min.ContextConsumer = h, reactIs_production_min.ContextProvider = T, reactIs_production_min.Element = E, reactIs_production_min.ForwardRef = R, reactIs_production_min.Fragment = A, reactIs_production_min.Lazy = k, reactIs_production_min.Memo = V, reactIs_production_min.Portal = B, reactIs_production_min.Profiler = q, reactIs_production_min.StrictMode = z, reactIs_production_min.Suspense = Z, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(G) {
    return I(G) === h;
  }, reactIs_production_min.isContextProvider = function(G) {
    return I(G) === d;
  }, reactIs_production_min.isElement = function(G) {
    return typeof G == "object" && G !== null && G.$$typeof === r;
  }, reactIs_production_min.isForwardRef = function(G) {
    return I(G) === p;
  }, reactIs_production_min.isFragment = function(G) {
    return I(G) === s;
  }, reactIs_production_min.isLazy = function(G) {
    return I(G) === y;
  }, reactIs_production_min.isMemo = function(G) {
    return I(G) === v;
  }, reactIs_production_min.isPortal = function(G) {
    return I(G) === a;
  }, reactIs_production_min.isProfiler = function(G) {
    return I(G) === u;
  }, reactIs_production_min.isStrictMode = function(G) {
    return I(G) === c;
  }, reactIs_production_min.isSuspense = function(G) {
    return I(G) === m;
  }, reactIs_production_min.isValidElementType = function(G) {
    return typeof G == "string" || typeof G == "function" || G === s || G === u || G === M || G === c || G === m || G === g || G === P || typeof G == "object" && G !== null && (G.$$typeof === y || G.$$typeof === v || G.$$typeof === d || G.$$typeof === h || G.$$typeof === p || G.$$typeof === S || G.$$typeof === x || G[0] === w);
  }, reactIs_production_min.typeOf = I, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var r = 60103, a = 60106, s = 60107, c = 60108, u = 60114, d = 60109, h = 60110, p = 60112, m = 60113, g = 60120, v = 60115, y = 60116, x = 60121, w = 60122, S = 60117, M = 60129, P = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var L = Symbol.for;
      r = L("react.element"), a = L("react.portal"), s = L("react.fragment"), c = L("react.strict_mode"), u = L("react.profiler"), d = L("react.provider"), h = L("react.context"), p = L("react.forward_ref"), m = L("react.suspense"), g = L("react.suspense_list"), v = L("react.memo"), y = L("react.lazy"), x = L("react.block"), w = L("react.server.block"), S = L("react.fundamental"), L("react.scope"), L("react.opaque.id"), M = L("react.debug_trace_mode"), L("react.offscreen"), P = L("react.legacy_hidden");
    }
    var I = !1;
    function T(ue) {
      return !!(typeof ue == "string" || typeof ue == "function" || ue === s || ue === u || ue === M || ue === c || ue === m || ue === g || ue === P || I || typeof ue == "object" && ue !== null && (ue.$$typeof === y || ue.$$typeof === v || ue.$$typeof === d || ue.$$typeof === h || ue.$$typeof === p || ue.$$typeof === S || ue.$$typeof === x || ue[0] === w));
    }
    function E(ue) {
      if (typeof ue == "object" && ue !== null) {
        var pe = ue.$$typeof;
        switch (pe) {
          case r:
            var we = ue.type;
            switch (we) {
              case s:
              case u:
              case c:
              case m:
              case g:
                return we;
              default:
                var ye = we && we.$$typeof;
                switch (ye) {
                  case h:
                  case p:
                  case y:
                  case v:
                  case d:
                    return ye;
                  default:
                    return pe;
                }
            }
          case a:
            return pe;
        }
      }
    }
    var R = h, A = d, k = r, V = p, B = s, q = y, z = v, Z = a, G = u, K = c, U = m, F = !1, N = !1;
    function D(ue) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(ue) {
      return N || (N = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function H(ue) {
      return E(ue) === h;
    }
    function W(ue) {
      return E(ue) === d;
    }
    function re(ue) {
      return typeof ue == "object" && ue !== null && ue.$$typeof === r;
    }
    function ae(ue) {
      return E(ue) === p;
    }
    function ee(ue) {
      return E(ue) === s;
    }
    function X(ue) {
      return E(ue) === y;
    }
    function J(ue) {
      return E(ue) === v;
    }
    function ie(ue) {
      return E(ue) === a;
    }
    function oe(ue) {
      return E(ue) === u;
    }
    function fe(ue) {
      return E(ue) === c;
    }
    function ve(ue) {
      return E(ue) === m;
    }
    reactIs_development.ContextConsumer = R, reactIs_development.ContextProvider = A, reactIs_development.Element = k, reactIs_development.ForwardRef = V, reactIs_development.Fragment = B, reactIs_development.Lazy = q, reactIs_development.Memo = z, reactIs_development.Portal = Z, reactIs_development.Profiler = G, reactIs_development.StrictMode = K, reactIs_development.Suspense = U, reactIs_development.isAsyncMode = D, reactIs_development.isConcurrentMode = j, reactIs_development.isContextConsumer = H, reactIs_development.isContextProvider = W, reactIs_development.isElement = re, reactIs_development.isForwardRef = ae, reactIs_development.isFragment = ee, reactIs_development.isLazy = X, reactIs_development.isMemo = J, reactIs_development.isPortal = ie, reactIs_development.isProfiler = oe, reactIs_development.isStrictMode = fe, reactIs_development.isSuspense = ve, reactIs_development.isValidElementType = T, reactIs_development.typeOf = E;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports;
let e$1 = (r) => typeof r == "object" && r != null && r.nodeType === 1, t$1 = (r, a) => (!a || r !== "hidden") && r !== "visible" && r !== "clip", n = (r, a) => {
  if (r.clientHeight < r.scrollHeight || r.clientWidth < r.scrollWidth) {
    let s = getComputedStyle(r, null);
    return t$1(s.overflowY, a) || t$1(s.overflowX, a) || ((c) => {
      let u = ((d) => {
        if (!d.ownerDocument || !d.ownerDocument.defaultView) return null;
        try {
          return d.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(c);
      return !!u && (u.clientHeight < c.scrollHeight || u.clientWidth < c.scrollWidth);
    })(r);
  }
  return !1;
}, l = (r, a, s, c, u, d, h, p) => d < r && h > a || d > r && h < a ? 0 : d <= r && p <= s || h >= a && p >= s ? d - r - c : h > a && p < s || d < r && p > s ? h - a + u : 0, i = (r) => {
  let a = r.parentElement;
  return a ?? (r.getRootNode().host || null);
};
var o$1 = (r, a) => {
  var s, c, u, d, h, p;
  if (typeof document > "u") return [];
  let { scrollMode: m, block: g, inline: v, boundary: y, skipOverflowHiddenElements: x } = a, w = typeof y == "function" ? y : (K) => K !== y;
  if (!e$1(r)) throw new TypeError("Invalid target");
  let S = document.scrollingElement || document.documentElement, M = [], P = r;
  for (; e$1(P) && w(P); ) {
    if (P = i(P), P === S) {
      M.push(P);
      break;
    }
    P != null && P === document.body && n(P) && !n(document.documentElement) || P != null && n(P, x) && M.push(P);
  }
  let L = (c = (s = window.visualViewport) == null ? void 0 : s.width) != null ? c : innerWidth, I = (d = (u = window.visualViewport) == null ? void 0 : u.height) != null ? d : innerHeight, T = (h = window.scrollX) != null ? h : pageXOffset, E = (p = window.scrollY) != null ? p : pageYOffset, { height: R, width: A, top: k, right: V, bottom: B, left: q } = r.getBoundingClientRect(), z = g === "start" || g === "nearest" ? k : g === "end" ? B : k + R / 2, Z = v === "center" ? q + A / 2 : v === "end" ? V : q, G = [];
  for (let K = 0; K < M.length; K++) {
    let U = M[K], { height: F, width: N, top: D, right: j, bottom: H, left: W } = U.getBoundingClientRect();
    if (m === "if-needed" && k >= 0 && q >= 0 && B <= I && V <= L && k >= D && B <= H && q >= W && V <= j) return G;
    let re = getComputedStyle(U), ae = parseInt(re.borderLeftWidth, 10), ee = parseInt(re.borderTopWidth, 10), X = parseInt(re.borderRightWidth, 10), J = parseInt(re.borderBottomWidth, 10), ie = 0, oe = 0, fe = "offsetWidth" in U ? U.offsetWidth - U.clientWidth - ae - X : 0, ve = "offsetHeight" in U ? U.offsetHeight - U.clientHeight - ee - J : 0, ue = "offsetWidth" in U ? U.offsetWidth === 0 ? 0 : N / U.offsetWidth : 0, pe = "offsetHeight" in U ? U.offsetHeight === 0 ? 0 : F / U.offsetHeight : 0;
    if (S === U) ie = g === "start" ? z : g === "end" ? z - I : g === "nearest" ? l(E, E + I, I, ee, J, E + z, E + z + R, R) : z - I / 2, oe = v === "start" ? Z : v === "center" ? Z - L / 2 : v === "end" ? Z - L : l(T, T + L, L, ae, X, T + Z, T + Z + A, A), ie = Math.max(0, ie + E), oe = Math.max(0, oe + T);
    else {
      ie = g === "start" ? z - D - ee : g === "end" ? z - H + J + ve : g === "nearest" ? l(D, H, F, ee, J + ve, z, z + R, R) : z - (D + F / 2) + ve / 2, oe = v === "start" ? Z - W - ae : v === "center" ? Z - (W + N / 2) + fe / 2 : v === "end" ? Z - j + X + fe : l(W, j, N, ae, X + fe, Z, Z + A, A);
      let { scrollLeft: we, scrollTop: ye } = U;
      ie = Math.max(0, Math.min(ye + ie / pe, U.scrollHeight - F / pe + ve)), oe = Math.max(0, Math.min(we + oe / ue, U.scrollWidth - N / ue + fe)), z += ye - ie, Z += we - oe;
    }
    G.push({ el: U, top: ie, left: oe });
  }
  return G;
}, __assign = function() {
  return __assign = Object.assign || function(a) {
    for (var s, c = 1, u = arguments.length; c < u; c++) {
      s = arguments[c];
      for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (a[d] = s[d]);
    }
    return a;
  }, __assign.apply(this, arguments);
};
typeof SuppressedError == "function" && SuppressedError;
var idCounter = 0;
function cbToCb(r) {
  return typeof r == "function" ? r : noop;
}
function noop() {
}
function scrollIntoView(r, a) {
  if (r) {
    var s = o$1(r, {
      boundary: a,
      block: "nearest",
      scrollMode: "if-needed"
    });
    s.forEach(function(c) {
      var u = c.el, d = c.top, h = c.left;
      u.scrollTop = d, u.scrollLeft = h;
    });
  }
}
function isOrContainsNode(r, a, s) {
  var c = r === a || a instanceof s.Node && r.contains && r.contains(a);
  return c;
}
function debounce$1(r, a) {
  var s;
  function c() {
    s && clearTimeout(s);
  }
  function u() {
    for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
      h[p] = arguments[p];
    c(), s = setTimeout(function() {
      s = null, r.apply(void 0, h);
    }, a);
  }
  return u.cancel = c, u;
}
function callAllEventHandlers() {
  for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++)
    a[s] = arguments[s];
  return function(c) {
    for (var u = arguments.length, d = new Array(u > 1 ? u - 1 : 0), h = 1; h < u; h++)
      d[h - 1] = arguments[h];
    return a.some(function(p) {
      return p && p.apply(void 0, [c].concat(d)), c.preventDownshiftDefault || c.hasOwnProperty("nativeEvent") && c.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++)
    a[s] = arguments[s];
  return function(c) {
    a.forEach(function(u) {
      typeof u == "function" ? u(c) : u && (u.current = c);
    });
  };
}
function generateId$1() {
  return String(idCounter++);
}
function getA11yStatusMessage$1(r) {
  var a = r.isOpen, s = r.resultCount, c = r.previousResultCount;
  return a ? s ? s !== c ? s + " result" + (s === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function unwrapArray(r, a) {
  return r = Array.isArray(r) ? (
    /* istanbul ignore next (preact) */
    r[0]
  ) : r, !r && a ? a : r;
}
function isDOMElement(r) {
  return typeof r.type == "string";
}
function getElementProps(r) {
  return r.props;
}
function requiredProp(r, a) {
  console.error('The property "' + a + '" is required in "' + r + '"');
}
var stateKeys = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function pickState(r) {
  r === void 0 && (r = {});
  var a = {};
  return stateKeys.forEach(function(s) {
    r.hasOwnProperty(s) && (a[s] = r[s]);
  }), a;
}
function getState(r, a) {
  return Object.keys(r).reduce(function(s, c) {
    return s[c] = isControlledProp(a, c) ? a[c] : r[c], s;
  }, {});
}
function isControlledProp(r, a) {
  return r[a] !== void 0;
}
function normalizeArrowKey(r) {
  var a = r.key, s = r.keyCode;
  return s >= 37 && s <= 40 && a.indexOf("Arrow") !== 0 ? "Arrow" + a : a;
}
function isPlainObject$1(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function getHighlightedIndex(r, a, s, c, u) {
  u === void 0 && (u = !1);
  var d = s.length;
  if (d === 0)
    return -1;
  var h = d - 1;
  (typeof r != "number" || r < 0 || r > h) && (r = a > 0 ? -1 : h + 1);
  var p = r + a;
  p < 0 ? p = u ? h : 0 : p > h && (p = u ? 0 : h);
  var m = getNonDisabledIndex(p, a < 0, s, c, u);
  return m === -1 ? r >= d ? -1 : r : m;
}
function getNonDisabledIndex(r, a, s, c, u) {
  u === void 0 && (u = !1);
  var d = s.length;
  if (a) {
    for (var h = r; h >= 0; h--)
      if (!c(s[h], h))
        return h;
  } else
    for (var p = r; p < d; p++)
      if (!c(s[p], p))
        return p;
  return u ? getNonDisabledIndex(a ? d - 1 : 0, a, s, c) : -1;
}
function targetWithinDownshift(r, a, s, c) {
  return c === void 0 && (c = !0), a.some(function(u) {
    return u && (isOrContainsNode(u, r, s) || c && isOrContainsNode(u, s.document.activeElement, s));
  });
}
var validateControlledUnchanged = noop;
process.env.NODE_ENV !== "production" && (validateControlledUnchanged = function(a, s, c) {
  var u = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(a).forEach(function(d) {
    s[d] !== void 0 && c[d] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + d + '" to be uncontrolled. ' + u) : s[d] === void 0 && c[d] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + d + '" to be controlled. ' + u);
  });
});
var cleanupStatus$1 = debounce$1(function(r) {
  getStatusDiv(r).textContent = "";
}, 500);
function setStatus$1(r, a) {
  var s = getStatusDiv(a);
  r && (s.textContent = r, cleanupStatus$1(a));
}
function getStatusDiv(r) {
  r === void 0 && (r = document);
  var a = r.getElementById("a11y-status-message");
  return a || (a = r.createElement("div"), a.setAttribute("id", "a11y-status-message"), a.setAttribute("role", "status"), a.setAttribute("aria-live", "polite"), a.setAttribute("aria-relevant", "additions text"), Object.assign(a.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), r.body.appendChild(a), a);
}
var unknown = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, mouseUp = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, itemMouseEnter = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, keyDownArrowUp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, keyDownArrowDown = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, keyDownEscape = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, keyDownEnter = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, keyDownHome = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, keyDownEnd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, clickItem = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, blurInput = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, changeInput = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, keyDownSpaceButton = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, clickButton = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, blurButton = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, touchEnd = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, stateChangeTypes$3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown,
  mouseUp,
  itemMouseEnter,
  keyDownArrowUp,
  keyDownArrowDown,
  keyDownEscape,
  keyDownEnter,
  keyDownHome,
  keyDownEnd,
  clickItem,
  blurInput,
  changeInput,
  keyDownSpaceButton,
  clickButton,
  blurButton,
  controlledPropUpdatedSelectedItem,
  touchEnd
}), _excluded$4 = ["refKey", "ref"], _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], _excluded4$1 = ["refKey", "ref"], _excluded5 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Downshift = /* @__PURE__ */ function() {
  var r = /* @__PURE__ */ function(a) {
    _inheritsLoose(s, a);
    function s(u) {
      var d;
      d = a.call(this, u) || this, d.id = d.props.id || "downshift-" + generateId$1(), d.menuId = d.props.menuId || d.id + "-menu", d.labelId = d.props.labelId || d.id + "-label", d.inputId = d.props.inputId || d.id + "-input", d.getItemId = d.props.getItemId || function(I) {
        return d.id + "-item-" + I;
      }, d.input = null, d.items = [], d.itemCount = null, d.previousResultCount = 0, d.timeoutIds = [], d.internalSetTimeout = function(I, T) {
        var E = setTimeout(function() {
          d.timeoutIds = d.timeoutIds.filter(function(R) {
            return R !== E;
          }), I();
        }, T);
        d.timeoutIds.push(E);
      }, d.setItemCount = function(I) {
        d.itemCount = I;
      }, d.unsetItemCount = function() {
        d.itemCount = null;
      }, d.isItemDisabled = function(I, T) {
        var E = d.getItemNodeFromIndex(T);
        return E && E.hasAttribute("disabled");
      }, d.setHighlightedIndex = function(I, T) {
        I === void 0 && (I = d.props.defaultHighlightedIndex), T === void 0 && (T = {}), T = pickState(T), d.internalSetState(_extends$3({
          highlightedIndex: I
        }, T));
      }, d.clearSelection = function(I) {
        d.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: d.props.defaultHighlightedIndex,
          isOpen: d.props.defaultIsOpen
        }, I);
      }, d.selectItem = function(I, T, E) {
        T = pickState(T), d.internalSetState(_extends$3({
          isOpen: d.props.defaultIsOpen,
          highlightedIndex: d.props.defaultHighlightedIndex,
          selectedItem: I,
          inputValue: d.props.itemToString(I)
        }, T), E);
      }, d.selectItemAtIndex = function(I, T, E) {
        var R = d.items[I];
        R != null && d.selectItem(R, T, E);
      }, d.selectHighlightedItem = function(I, T) {
        return d.selectItemAtIndex(d.getState().highlightedIndex, I, T);
      }, d.internalSetState = function(I, T) {
        var E, R, A = {}, k = typeof I == "function";
        return !k && I.hasOwnProperty("inputValue") && d.props.onInputValueChange(I.inputValue, _extends$3({}, d.getStateAndHelpers(), I)), d.setState(function(V) {
          V = d.getState(V);
          var B = k ? I(V) : I;
          B = d.props.stateReducer(V, B), E = B.hasOwnProperty("selectedItem");
          var q = {};
          return E && B.selectedItem !== V.selectedItem && (R = B.selectedItem), B.type = B.type || unknown, Object.keys(B).forEach(function(z) {
            V[z] !== B[z] && (A[z] = B[z]), z !== "type" && (B[z], isControlledProp(d.props, z) || (q[z] = B[z]));
          }), k && B.hasOwnProperty("inputValue") && d.props.onInputValueChange(B.inputValue, _extends$3({}, d.getStateAndHelpers(), B)), q;
        }, function() {
          cbToCb(T)();
          var V = Object.keys(A).length > 1;
          V && d.props.onStateChange(A, d.getStateAndHelpers()), E && d.props.onSelect(I.selectedItem, d.getStateAndHelpers()), R !== void 0 && d.props.onChange(R, d.getStateAndHelpers()), d.props.onUserAction(A, d.getStateAndHelpers());
        });
      }, d.rootRef = function(I) {
        return d._rootNode = I;
      }, d.getRootProps = function(I, T) {
        var E, R = I === void 0 ? {} : I, A = R.refKey, k = A === void 0 ? "ref" : A, V = R.ref, B = _objectWithoutPropertiesLoose$1(R, _excluded$4), q = T === void 0 ? {} : T, z = q.suppressRefError, Z = z === void 0 ? !1 : z;
        d.getRootProps.called = !0, d.getRootProps.refKey = k, d.getRootProps.suppressRefError = Z;
        var G = d.getState(), K = G.isOpen;
        return _extends$3((E = {}, E[k] = handleRefs(V, d.rootRef), E.role = "combobox", E["aria-expanded"] = K, E["aria-haspopup"] = "listbox", E["aria-owns"] = K ? d.menuId : void 0, E["aria-labelledby"] = d.labelId, E), B);
      }, d.keyDownHandlers = {
        ArrowDown: function(T) {
          var E = this;
          if (T.preventDefault(), this.getState().isOpen) {
            var R = T.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(R, {
              type: keyDownArrowDown
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: keyDownArrowDown
            }, function() {
              var A = E.getItemCount();
              if (A > 0) {
                var k = E.getState(), V = k.highlightedIndex, B = getHighlightedIndex(V, 1, {
                  length: A
                }, E.isItemDisabled, !0);
                E.setHighlightedIndex(B, {
                  type: keyDownArrowDown
                });
              }
            });
        },
        ArrowUp: function(T) {
          var E = this;
          if (T.preventDefault(), this.getState().isOpen) {
            var R = T.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(R, {
              type: keyDownArrowUp
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: keyDownArrowUp
            }, function() {
              var A = E.getItemCount();
              if (A > 0) {
                var k = E.getState(), V = k.highlightedIndex, B = getHighlightedIndex(V, -1, {
                  length: A
                }, E.isItemDisabled, !0);
                E.setHighlightedIndex(B, {
                  type: keyDownArrowUp
                });
              }
            });
        },
        Enter: function(T) {
          if (T.which !== 229) {
            var E = this.getState(), R = E.isOpen, A = E.highlightedIndex;
            if (R && A != null) {
              T.preventDefault();
              var k = this.items[A], V = this.getItemNodeFromIndex(A);
              if (k == null || V && V.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: keyDownEnter
              });
            }
          }
        },
        Escape: function(T) {
          T.preventDefault(), this.reset(_extends$3({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, d.buttonKeyDownHandlers = _extends$3({}, d.keyDownHandlers, {
        " ": function(T) {
          T.preventDefault(), this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      }), d.inputKeyDownHandlers = _extends$3({}, d.keyDownHandlers, {
        Home: function(T) {
          var E = this.getState(), R = E.isOpen;
          if (R) {
            T.preventDefault();
            var A = this.getItemCount();
            if (!(A <= 0 || !R)) {
              var k = getNonDisabledIndex(0, !1, {
                length: A
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: keyDownHome
              });
            }
          }
        },
        End: function(T) {
          var E = this.getState(), R = E.isOpen;
          if (R) {
            T.preventDefault();
            var A = this.getItemCount();
            if (!(A <= 0 || !R)) {
              var k = getNonDisabledIndex(A - 1, !0, {
                length: A
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: keyDownEnd
              });
            }
          }
        }
      }), d.getToggleButtonProps = function(I) {
        var T = I === void 0 ? {} : I, E = T.onClick;
        T.onPress;
        var R = T.onKeyDown, A = T.onKeyUp, k = T.onBlur, V = _objectWithoutPropertiesLoose$1(T, _excluded2$3), B = d.getState(), q = B.isOpen, z = {
          onClick: callAllEventHandlers(E, d.buttonHandleClick),
          onKeyDown: callAllEventHandlers(R, d.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(A, d.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(k, d.buttonHandleBlur)
        }, Z = V.disabled ? {} : z;
        return _extends$3({
          type: "button",
          role: "button",
          "aria-label": q ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, Z, V);
      }, d.buttonHandleKeyUp = function(I) {
        I.preventDefault();
      }, d.buttonHandleKeyDown = function(I) {
        var T = normalizeArrowKey(I);
        d.buttonKeyDownHandlers[T] && d.buttonKeyDownHandlers[T].call(_assertThisInitialized(d), I);
      }, d.buttonHandleClick = function(I) {
        I.preventDefault(), d.props.environment.document.activeElement === d.props.environment.document.body && I.target.focus(), process.env.NODE_ENV === "test" ? d.toggleMenu({
          type: clickButton
        }) : d.internalSetTimeout(function() {
          return d.toggleMenu({
            type: clickButton
          });
        });
      }, d.buttonHandleBlur = function(I) {
        var T = I.target;
        d.internalSetTimeout(function() {
          !d.isMouseDown && (d.props.environment.document.activeElement == null || d.props.environment.document.activeElement.id !== d.inputId) && d.props.environment.document.activeElement !== T && d.reset({
            type: blurButton
          });
        });
      }, d.getLabelProps = function(I) {
        return _extends$3({
          htmlFor: d.inputId,
          id: d.labelId
        }, I);
      }, d.getInputProps = function(I) {
        var T = I === void 0 ? {} : I, E = T.onKeyDown, R = T.onBlur, A = T.onChange, k = T.onInput;
        T.onChangeText;
        var V = _objectWithoutPropertiesLoose$1(T, _excluded3$2), B, q = {};
        B = "onChange";
        var z = d.getState(), Z = z.inputValue, G = z.isOpen, K = z.highlightedIndex;
        if (!V.disabled) {
          var U;
          q = (U = {}, U[B] = callAllEventHandlers(A, k, d.inputHandleChange), U.onKeyDown = callAllEventHandlers(E, d.inputHandleKeyDown), U.onBlur = callAllEventHandlers(R, d.inputHandleBlur), U);
        }
        return _extends$3({
          "aria-autocomplete": "list",
          "aria-activedescendant": G && typeof K == "number" && K >= 0 ? d.getItemId(K) : void 0,
          "aria-controls": G ? d.menuId : void 0,
          "aria-labelledby": V && V["aria-label"] ? void 0 : d.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: Z,
          id: d.inputId
        }, q, V);
      }, d.inputHandleKeyDown = function(I) {
        var T = normalizeArrowKey(I);
        T && d.inputKeyDownHandlers[T] && d.inputKeyDownHandlers[T].call(_assertThisInitialized(d), I);
      }, d.inputHandleChange = function(I) {
        d.internalSetState({
          type: changeInput,
          isOpen: !0,
          inputValue: I.target.value,
          highlightedIndex: d.props.defaultHighlightedIndex
        });
      }, d.inputHandleBlur = function() {
        d.internalSetTimeout(function() {
          var I = d.props.environment.document && !!d.props.environment.document.activeElement && !!d.props.environment.document.activeElement.dataset && d.props.environment.document.activeElement.dataset.toggle && d._rootNode && d._rootNode.contains(d.props.environment.document.activeElement);
          !d.isMouseDown && !I && d.reset({
            type: blurInput
          });
        });
      }, d.menuRef = function(I) {
        d._menuNode = I;
      }, d.getMenuProps = function(I, T) {
        var E, R = I === void 0 ? {} : I, A = R.refKey, k = A === void 0 ? "ref" : A, V = R.ref, B = _objectWithoutPropertiesLoose$1(R, _excluded4$1), q = T === void 0 ? {} : T, z = q.suppressRefError, Z = z === void 0 ? !1 : z;
        return d.getMenuProps.called = !0, d.getMenuProps.refKey = k, d.getMenuProps.suppressRefError = Z, _extends$3((E = {}, E[k] = handleRefs(V, d.menuRef), E.role = "listbox", E["aria-labelledby"] = B && B["aria-label"] ? void 0 : d.labelId, E.id = d.menuId, E), B);
      }, d.getItemProps = function(I) {
        var T, E = I === void 0 ? {} : I, R = E.onMouseMove, A = E.onMouseDown, k = E.onClick;
        E.onPress;
        var V = E.index, B = E.item, q = B === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : requiredProp("getItemProps", "item") : B, z = _objectWithoutPropertiesLoose$1(E, _excluded5);
        V === void 0 ? (d.items.push(q), V = d.items.indexOf(q)) : d.items[V] = q;
        var Z = "onClick", G = k, K = (T = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(R, function() {
            V !== d.getState().highlightedIndex && (d.setHighlightedIndex(V, {
              type: itemMouseEnter
            }), d.avoidScrolling = !0, d.internalSetTimeout(function() {
              return d.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: callAllEventHandlers(A, function(F) {
            F.preventDefault();
          })
        }, T[Z] = callAllEventHandlers(G, function() {
          d.selectItemAtIndex(V, {
            type: clickItem
          });
        }), T), U = z.disabled ? {
          onMouseDown: K.onMouseDown
        } : K;
        return _extends$3({
          id: d.getItemId(V),
          role: "option",
          "aria-selected": d.getState().highlightedIndex === V
        }, U, z);
      }, d.clearItems = function() {
        d.items = [];
      }, d.reset = function(I, T) {
        I === void 0 && (I = {}), I = pickState(I), d.internalSetState(function(E) {
          var R = E.selectedItem;
          return _extends$3({
            isOpen: d.props.defaultIsOpen,
            highlightedIndex: d.props.defaultHighlightedIndex,
            inputValue: d.props.itemToString(R)
          }, I);
        }, T);
      }, d.toggleMenu = function(I, T) {
        I === void 0 && (I = {}), I = pickState(I), d.internalSetState(function(E) {
          var R = E.isOpen;
          return _extends$3({
            isOpen: !R
          }, R && {
            highlightedIndex: d.props.defaultHighlightedIndex
          }, I);
        }, function() {
          var E = d.getState(), R = E.isOpen, A = E.highlightedIndex;
          R && d.getItemCount() > 0 && typeof A == "number" && d.setHighlightedIndex(A, I), cbToCb(T)();
        });
      }, d.openMenu = function(I) {
        d.internalSetState({
          isOpen: !0
        }, I);
      }, d.closeMenu = function(I) {
        d.internalSetState({
          isOpen: !1
        }, I);
      }, d.updateStatus = debounce$1(function() {
        var I = d.getState(), T = d.items[I.highlightedIndex], E = d.getItemCount(), R = d.props.getA11yStatusMessage(_extends$3({
          itemToString: d.props.itemToString,
          previousResultCount: d.previousResultCount,
          resultCount: E,
          highlightedItem: T
        }, I));
        d.previousResultCount = E, setStatus$1(R, d.props.environment.document);
      }, 200);
      var h = d.props, p = h.defaultHighlightedIndex, m = h.initialHighlightedIndex, g = m === void 0 ? p : m, v = h.defaultIsOpen, y = h.initialIsOpen, x = y === void 0 ? v : y, w = h.initialInputValue, S = w === void 0 ? "" : w, M = h.initialSelectedItem, P = M === void 0 ? null : M, L = d.getState({
        highlightedIndex: g,
        isOpen: x,
        inputValue: S,
        selectedItem: P
      });
      return L.selectedItem != null && d.props.initialInputValue === void 0 && (L.inputValue = d.props.itemToString(L.selectedItem)), d.state = L, d;
    }
    var c = s.prototype;
    return c.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(d) {
        clearTimeout(d);
      }), this.timeoutIds = [];
    }, c.getState = function(d) {
      return d === void 0 && (d = this.state), getState(d, this.props);
    }, c.getItemCount = function() {
      var d = this.items.length;
      return this.itemCount != null ? d = this.itemCount : this.props.itemCount !== void 0 && (d = this.props.itemCount), d;
    }, c.getItemNodeFromIndex = function(d) {
      return this.props.environment.document.getElementById(this.getItemId(d));
    }, c.scrollHighlightedItemIntoView = function() {
      {
        var d = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(d, this._menuNode);
      }
    }, c.moveHighlightedIndex = function(d, h) {
      var p = this.getItemCount(), m = this.getState(), g = m.highlightedIndex;
      if (p > 0) {
        var v = getHighlightedIndex(g, d, {
          length: p
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(v, h);
      }
    }, c.getStateAndHelpers = function() {
      var d = this.getState(), h = d.highlightedIndex, p = d.inputValue, m = d.selectedItem, g = d.isOpen, v = this.props.itemToString, y = this.id, x = this.getRootProps, w = this.getToggleButtonProps, S = this.getLabelProps, M = this.getMenuProps, P = this.getInputProps, L = this.getItemProps, I = this.openMenu, T = this.closeMenu, E = this.toggleMenu, R = this.selectItem, A = this.selectItemAtIndex, k = this.selectHighlightedItem, V = this.setHighlightedIndex, B = this.clearSelection, q = this.clearItems, z = this.reset, Z = this.setItemCount, G = this.unsetItemCount, K = this.internalSetState;
      return {
        // prop getters
        getRootProps: x,
        getToggleButtonProps: w,
        getLabelProps: S,
        getMenuProps: M,
        getInputProps: P,
        getItemProps: L,
        // actions
        reset: z,
        openMenu: I,
        closeMenu: T,
        toggleMenu: E,
        selectItem: R,
        selectItemAtIndex: A,
        selectHighlightedItem: k,
        setHighlightedIndex: V,
        clearSelection: B,
        clearItems: q,
        setItemCount: Z,
        unsetItemCount: G,
        setState: K,
        // props
        itemToString: v,
        // derived
        id: y,
        // state
        highlightedIndex: h,
        inputValue: p,
        isOpen: g,
        selectedItem: m
      };
    }, c.componentDidMount = function() {
      var d = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      {
        var h = function() {
          d.isMouseDown = !0;
        }, p = function(w) {
          d.isMouseDown = !1;
          var S = targetWithinDownshift(w.target, [d._rootNode, d._menuNode], d.props.environment);
          !S && d.getState().isOpen && d.reset({
            type: mouseUp
          }, function() {
            return d.props.onOuterClick(d.getStateAndHelpers());
          });
        }, m = function() {
          d.isTouchMove = !1;
        }, g = function() {
          d.isTouchMove = !0;
        }, v = function(w) {
          var S = targetWithinDownshift(w.target, [d._rootNode, d._menuNode], d.props.environment, !1);
          !d.isTouchMove && !S && d.getState().isOpen && d.reset({
            type: touchEnd
          }, function() {
            return d.props.onOuterClick(d.getStateAndHelpers());
          });
        }, y = this.props.environment;
        y.addEventListener("mousedown", h), y.addEventListener("mouseup", p), y.addEventListener("touchstart", m), y.addEventListener("touchmove", g), y.addEventListener("touchend", v), this.cleanup = function() {
          d.internalClearTimeouts(), d.updateStatus.cancel(), y.removeEventListener("mousedown", h), y.removeEventListener("mouseup", p), y.removeEventListener("touchstart", m), y.removeEventListener("touchmove", g), y.removeEventListener("touchend", v);
        };
      }
    }, c.shouldScroll = function(d, h) {
      var p = this.props.highlightedIndex === void 0 ? this.getState() : this.props, m = p.highlightedIndex, g = h.highlightedIndex === void 0 ? d : h, v = g.highlightedIndex, y = m && this.getState().isOpen && !d.isOpen, x = m !== v;
      return y || x;
    }, c.componentDidUpdate = function(d, h) {
      process.env.NODE_ENV !== "production" && (validateControlledUnchanged(this.state, d, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps)), isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(d.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: controlledPropUpdatedSelectedItem,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(h, d) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, c.componentWillUnmount = function() {
      this.cleanup();
    }, c.render = function() {
      var d = unwrapArray(this.props.children, noop);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var h = unwrapArray(d(this.getStateAndHelpers()));
      if (!h)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && validateGetRootPropsCalledCorrectly(h, this.getRootProps), h;
      if (isDOMElement(h))
        return /* @__PURE__ */ cloneElement(h, this.getRootProps(getElementProps(h)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, s;
  }(Component);
  return r.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function(s) {
      return s == null ? "" : (process.env.NODE_ENV !== "production" && isPlainObject$1(s) && !s.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", s), String(s));
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function(s, c) {
      return s !== c;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(s, c) {
      return c;
    },
    suppressRefError: !1,
    scrollIntoView
  }, r.stateChangeTypes = stateChangeTypes$3, r;
}();
process.env.NODE_ENV !== "production" && (Downshift.propTypes = {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
    document: PropTypes.shape({
      createElement: PropTypes.func.isRequired,
      getElementById: PropTypes.func.isRequired,
      activeElement: PropTypes.any.isRequired,
      body: PropTypes.any.isRequired
    }).isRequired,
    Node: PropTypes.func.isRequired
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */
});
function validateGetMenuPropsCalledCorrectly(r, a) {
  var s = a.refKey;
  r || console.error('downshift: The ref prop "' + s + '" from getMenuProps was not applied correctly on your menu element.');
}
function validateGetRootPropsCalledCorrectly(r, a) {
  var s = a.refKey, c = s !== "ref", u = !isDOMElement(r);
  u && !c && !reactIsExports.isForwardRef(r) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !u && c && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + s + '"'), !reactIsExports.isForwardRef(r) && !getElementProps(r)[s] && console.error('downshift: You must apply the ref prop "' + s + '" from getRootProps onto your root element.');
}
var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"], dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function callOnChangeProps(r, a, s) {
  var c = r.props, u = r.type, d = {};
  Object.keys(a).forEach(function(h) {
    invokeOnChangeHandler(h, r, a, s), s[h] !== a[h] && (d[h] = s[h]);
  }), c.onStateChange && Object.keys(d).length && c.onStateChange(_extends$3({
    type: u
  }, d));
}
function invokeOnChangeHandler(r, a, s, c) {
  var u = a.props, d = a.type, h = "on" + capitalizeString(r) + "Change";
  u[h] && c[r] !== void 0 && c[r] !== s[r] && u[h](_extends$3({
    type: d
  }, c));
}
function stateReducer(r, a) {
  return a.changes;
}
function getA11ySelectionMessage(r) {
  var a = r.selectedItem, s = r.itemToString;
  return a ? s(a) + " has been selected." : "";
}
var updateA11yStatus = debounce$1(function(r, a) {
  setStatus$1(r(), a);
}, 200), useIsomorphicLayoutEffect$1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? useLayoutEffect$1 : useEffect$1, useElementIds = "useId" in React__default ? function r(a) {
  var s = a.id, c = a.labelId, u = a.menuId, d = a.getItemId, h = a.toggleButtonId, p = a.inputId, m = "downshift-" + React__default.useId();
  s || (s = m);
  var g = useRef$1({
    labelId: c || s + "-label",
    menuId: u || s + "-menu",
    getItemId: d || function(v) {
      return s + "-item-" + v;
    },
    toggleButtonId: h || s + "-toggle-button",
    inputId: p || s + "-input"
  });
  return g.current;
} : function r(a) {
  var s = a.id, c = s === void 0 ? "downshift-" + generateId$1() : s, u = a.labelId, d = a.menuId, h = a.getItemId, p = a.toggleButtonId, m = a.inputId, g = useRef$1({
    labelId: u || c + "-label",
    menuId: d || c + "-menu",
    getItemId: h || function(v) {
      return c + "-item-" + v;
    },
    toggleButtonId: p || c + "-toggle-button",
    inputId: m || c + "-input"
  });
  return g.current;
};
function getItemAndIndex(r, a, s, c) {
  var u, d;
  if (r === void 0) {
    if (a === void 0)
      throw new Error(c);
    u = s[a], d = a;
  } else
    d = a === void 0 ? s.indexOf(r) : a, u = r;
  return [u, d];
}
function itemToString(r) {
  return r ? String(r) : "";
}
function isAcceptedCharacterKey(r) {
  return /^\S{1}$/.test(r);
}
function capitalizeString(r) {
  return "" + r.slice(0, 1).toUpperCase() + r.slice(1);
}
function useLatestRef(r) {
  var a = useRef$1(r);
  return a.current = r, a;
}
function useEnhancedReducer(r, a, s) {
  var c = useRef$1(), u = useRef$1(), d = useCallback$1(function(x, w) {
    u.current = w, x = getState(x, w.props);
    var S = r(x, w), M = w.props.stateReducer(x, _extends$3({}, w, {
      changes: S
    }));
    return M;
  }, [r]), h = useReducer(d, a), p = h[0], m = h[1], g = useLatestRef(s), v = useCallback$1(function(x) {
    return m(_extends$3({
      props: g.current
    }, x));
  }, [g]), y = u.current;
  return useEffect$1(function() {
    y && c.current && c.current !== p && callOnChangeProps(y, getState(c.current, y.props), p), c.current = p;
  }, [p, s, y]), [p, v];
}
function useControlledReducer$1(r, a, s) {
  var c = useEnhancedReducer(r, a, s), u = c[0], d = c[1];
  return [getState(u, s), d];
}
var defaultProps$3 = {
  itemToString,
  stateReducer,
  getA11ySelectionMessage,
  scrollIntoView,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function getDefaultValue$1(r, a, s) {
  s === void 0 && (s = dropdownDefaultStateValues);
  var c = r["default" + capitalizeString(a)];
  return c !== void 0 ? c : s[a];
}
function getInitialValue$1(r, a, s) {
  s === void 0 && (s = dropdownDefaultStateValues);
  var c = r[a];
  if (c !== void 0)
    return c;
  var u = r["initial" + capitalizeString(a)];
  return u !== void 0 ? u : getDefaultValue$1(r, a, s);
}
function getInitialState$2(r) {
  var a = getInitialValue$1(r, "selectedItem"), s = getInitialValue$1(r, "isOpen"), c = getInitialValue$1(r, "highlightedIndex"), u = getInitialValue$1(r, "inputValue");
  return {
    highlightedIndex: c < 0 && a && s ? r.items.indexOf(a) : c,
    isOpen: s,
    selectedItem: a,
    inputValue: u
  };
}
function getHighlightedIndexOnOpen(r, a, s) {
  var c = r.items, u = r.initialHighlightedIndex, d = r.defaultHighlightedIndex, h = a.selectedItem, p = a.highlightedIndex;
  return c.length === 0 ? -1 : u !== void 0 && p === u ? u : d !== void 0 ? d : h ? c.indexOf(h) : s === 0 ? -1 : s < 0 ? c.length - 1 : 0;
}
function useMouseAndTouchTracker(r, a, s, c) {
  var u = useRef$1({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return useEffect$1(function() {
    if ((s == null ? void 0 : s.addEventListener) != null) {
      var d = function() {
        u.current.isMouseDown = !0;
      }, h = function(y) {
        u.current.isMouseDown = !1, r && !targetWithinDownshift(y.target, a.map(function(x) {
          return x.current;
        }), s) && c();
      }, p = function() {
        u.current.isTouchMove = !1;
      }, m = function() {
        u.current.isTouchMove = !0;
      }, g = function(y) {
        r && !u.current.isTouchMove && !targetWithinDownshift(y.target, a.map(function(x) {
          return x.current;
        }), s, !1) && c();
      };
      return s.addEventListener("mousedown", d), s.addEventListener("mouseup", h), s.addEventListener("touchstart", p), s.addEventListener("touchmove", m), s.addEventListener("touchend", g), function() {
        s.removeEventListener("mousedown", d), s.removeEventListener("mouseup", h), s.removeEventListener("touchstart", p), s.removeEventListener("touchmove", m), s.removeEventListener("touchend", g);
      };
    }
  }, [r, s]), u;
}
var useGetterPropsCalledChecker = function r() {
  return noop;
};
process.env.NODE_ENV !== "production" && (useGetterPropsCalledChecker = function() {
  for (var a = useRef$1(!0), s = arguments.length, c = new Array(s), u = 0; u < s; u++)
    c[u] = arguments[u];
  var d = useRef$1(c.reduce(function(p, m) {
    return p[m] = {}, p;
  }, {}));
  useEffect$1(function() {
    Object.keys(d.current).forEach(function(p) {
      var m = d.current[p];
      if (a.current && !Object.keys(m).length) {
        console.error("downshift: You forgot to call the " + p + " getter function on your component / element.");
        return;
      }
      var g = m.suppressRefError, v = m.refKey, y = m.elementRef;
      (!y || !y.current) && !g && console.error('downshift: The ref prop "' + v + '" from ' + p + " was not applied correctly on your element.");
    }), a.current = !1;
  });
  var h = useCallback$1(function(p, m, g, v) {
    d.current[p] = {
      suppressRefError: m,
      refKey: g,
      elementRef: v
    };
  }, []);
  return h;
});
function useA11yMessageSetter(r, a, s) {
  var c = s.isInitialMount, u = s.highlightedIndex, d = s.items, h = s.environment, p = _objectWithoutPropertiesLoose$1(s, _excluded$3);
  useEffect$1(function() {
    c || updateA11yStatus(function() {
      return r(_extends$3({
        highlightedIndex: u,
        highlightedItem: d[u],
        resultCount: d.length
      }, p));
    }, h.document);
  }, a);
}
function useScrollIntoView(r) {
  var a = r.highlightedIndex, s = r.isOpen, c = r.itemRefs, u = r.getItemNodeFromIndex, d = r.menuElement, h = r.scrollIntoView, p = useRef$1(!0);
  return useIsomorphicLayoutEffect$1(function() {
    a < 0 || !s || !Object.keys(c.current).length || (p.current === !1 ? p.current = !0 : h(u(a), d));
  }, [a]), p;
}
var useControlPropsValidator = noop;
process.env.NODE_ENV !== "production" && (useControlPropsValidator = function(a) {
  var s = a.isInitialMount, c = a.props, u = a.state, d = useRef$1(c);
  useEffect$1(function() {
    s || (validateControlledUnchanged(u, d.current, c), d.current = c);
  }, [u, c, s]);
});
function getChangesOnSelection(r, a, s) {
  var c;
  s === void 0 && (s = !0);
  var u = ((c = r.items) == null ? void 0 : c.length) && a >= 0;
  return _extends$3({
    isOpen: !1,
    highlightedIndex: -1
  }, u && _extends$3({
    selectedItem: r.items[a],
    isOpen: getDefaultValue$1(r, "isOpen"),
    highlightedIndex: getDefaultValue$1(r, "highlightedIndex")
  }, s && {
    inputValue: r.itemToString(r.items[a])
  }));
}
var commonPropTypes = {
  environment: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
    document: PropTypes.shape({
      createElement: PropTypes.func.isRequired,
      getElementById: PropTypes.func.isRequired,
      activeElement: PropTypes.any.isRequired,
      body: PropTypes.any.isRequired
    }).isRequired,
    Node: PropTypes.func.isRequired
  }),
  itemToString: PropTypes.func,
  stateReducer: PropTypes.func
}, commonDropdownPropTypes = _extends$3({}, commonPropTypes, {
  getA11yStatusMessage: PropTypes.func,
  highlightedIndex: PropTypes.number,
  defaultHighlightedIndex: PropTypes.number,
  initialHighlightedIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  selectedItem: PropTypes.any,
  initialSelectedItem: PropTypes.any,
  defaultSelectedItem: PropTypes.any,
  id: PropTypes.string,
  labelId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func,
  toggleButtonId: PropTypes.string,
  onSelectedItemChange: PropTypes.func,
  onHighlightedIndexChange: PropTypes.func,
  onStateChange: PropTypes.func,
  onIsOpenChange: PropTypes.func,
  scrollIntoView: PropTypes.func
});
function downshiftCommonReducer(r, a, s) {
  var c = a.type, u = a.props, d;
  switch (c) {
    case s.ItemMouseMove:
      d = {
        highlightedIndex: a.disabled ? -1 : a.index
      };
      break;
    case s.MenuMouseLeave:
      d = {
        highlightedIndex: -1
      };
      break;
    case s.ToggleButtonClick:
    case s.FunctionToggleMenu:
      d = {
        isOpen: !r.isOpen,
        highlightedIndex: r.isOpen ? -1 : getHighlightedIndexOnOpen(u, r, 0)
      };
      break;
    case s.FunctionOpenMenu:
      d = {
        isOpen: !0,
        highlightedIndex: getHighlightedIndexOnOpen(u, r, 0)
      };
      break;
    case s.FunctionCloseMenu:
      d = {
        isOpen: !1
      };
      break;
    case s.FunctionSetHighlightedIndex:
      d = {
        highlightedIndex: a.highlightedIndex
      };
      break;
    case s.FunctionSetInputValue:
      d = {
        inputValue: a.inputValue
      };
      break;
    case s.FunctionReset:
      d = {
        highlightedIndex: getDefaultValue$1(u, "highlightedIndex"),
        isOpen: getDefaultValue$1(u, "isOpen"),
        selectedItem: getDefaultValue$1(u, "selectedItem"),
        inputValue: getDefaultValue$1(u, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends$3({}, r, d);
}
function getItemIndexByCharacterKey(r) {
  for (var a = r.keysSoFar, s = r.highlightedIndex, c = r.items, u = r.itemToString, d = r.isItemDisabled, h = a.toLowerCase(), p = 0; p < c.length; p++) {
    var m = (p + s + (a.length < 2 ? 1 : 0)) % c.length, g = c[m];
    if (g !== void 0 && u(g).toLowerCase().startsWith(h) && !d(g, m))
      return m;
  }
  return s;
}
var propTypes$2 = __assign(__assign({}, commonDropdownPropTypes), { items: PropTypes.array.isRequired, isItemDisabled: PropTypes.func, getA11ySelectionMessage: PropTypes.func });
function getA11yStatusMessage(r) {
  var a = r.isOpen, s = r.resultCount, c = r.previousResultCount;
  return a ? s ? s !== c ? "".concat(s, " result").concat(s === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
var defaultProps$2 = __assign(__assign({}, defaultProps$3), { getA11yStatusMessage, isItemDisabled: function() {
  return !1;
} }), validatePropTypes$2 = noop;
process.env.NODE_ENV !== "production" && (validatePropTypes$2 = function(r, a) {
  PropTypes.checkPropTypes(propTypes$2, r, "prop", a.name);
});
var ToggleButtonClick$1 = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, ToggleButtonKeyDownArrowDown = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, ToggleButtonKeyDownArrowUp = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, ToggleButtonKeyDownCharacter = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, ToggleButtonKeyDownEscape = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, ToggleButtonKeyDownHome = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, ToggleButtonKeyDownEnd = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, ToggleButtonKeyDownEnter = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, ToggleButtonKeyDownSpaceButton = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, ToggleButtonKeyDownPageUp = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, ToggleButtonKeyDownPageDown = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, ToggleButtonBlur = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, MenuMouseLeave$1 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, ItemMouseMove$1 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, ItemClick$1 = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, FunctionToggleMenu$1 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, FunctionOpenMenu$1 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, FunctionCloseMenu$1 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, FunctionSetHighlightedIndex$1 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, FunctionSelectItem$1 = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, FunctionSetInputValue$1 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, FunctionReset$2 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, stateChangeTypes$2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownEscape,
  ToggleButtonKeyDownHome,
  ToggleButtonKeyDownEnd,
  ToggleButtonKeyDownEnter,
  ToggleButtonKeyDownSpaceButton,
  ToggleButtonKeyDownPageUp,
  ToggleButtonKeyDownPageDown,
  ToggleButtonBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$2
});
function downshiftSelectReducer(r, a) {
  var s, c = a.type, u = a.props, d = a.altKey, h;
  switch (c) {
    case ItemClick$1:
      h = {
        isOpen: getDefaultValue$1(u, "isOpen"),
        highlightedIndex: getDefaultValue$1(u, "highlightedIndex"),
        selectedItem: u.items[a.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var p = a.key, m = "" + r.inputValue + p, g = !r.isOpen && r.selectedItem ? u.items.indexOf(r.selectedItem) : r.highlightedIndex, v = getItemIndexByCharacterKey({
          keysSoFar: m,
          highlightedIndex: g,
          items: u.items,
          itemToString: u.itemToString,
          isItemDisabled: u.isItemDisabled
        });
        h = {
          inputValue: m,
          highlightedIndex: v,
          isOpen: !0
        };
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      {
        var y = r.isOpen ? getHighlightedIndex(r.highlightedIndex, 1, u.items, u.isItemDisabled) : d && r.selectedItem == null ? -1 : getHighlightedIndexOnOpen(u, r, 1);
        h = {
          highlightedIndex: y,
          isOpen: !0
        };
      }
      break;
    case ToggleButtonKeyDownArrowUp:
      if (r.isOpen && d)
        h = getChangesOnSelection(u, r.highlightedIndex, !1);
      else {
        var x = r.isOpen ? getHighlightedIndex(r.highlightedIndex, -1, u.items, u.isItemDisabled) : getHighlightedIndexOnOpen(u, r, -1);
        h = {
          highlightedIndex: x,
          isOpen: !0
        };
      }
      break;
    case ToggleButtonKeyDownEnter:
    case ToggleButtonKeyDownSpaceButton:
      h = getChangesOnSelection(u, r.highlightedIndex, !1);
      break;
    case ToggleButtonKeyDownHome:
      h = {
        highlightedIndex: getNonDisabledIndex(0, !1, u.items, u.isItemDisabled),
        isOpen: !0
      };
      break;
    case ToggleButtonKeyDownEnd:
      h = {
        highlightedIndex: getNonDisabledIndex(u.items.length - 1, !0, u.items, u.isItemDisabled),
        isOpen: !0
      };
      break;
    case ToggleButtonKeyDownPageUp:
      h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, -10, u.items, u.isItemDisabled)
      };
      break;
    case ToggleButtonKeyDownPageDown:
      h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, 10, u.items, u.isItemDisabled)
      };
      break;
    case ToggleButtonKeyDownEscape:
      h = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case ToggleButtonBlur:
      h = _extends$3({
        isOpen: !1,
        highlightedIndex: -1
      }, r.highlightedIndex >= 0 && ((s = u.items) == null ? void 0 : s.length) && {
        selectedItem: u.items[r.highlightedIndex]
      });
      break;
    case FunctionSelectItem$1:
      h = {
        selectedItem: a.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(r, a, stateChangeTypes$2);
  }
  return _extends$3({}, r, h);
}
var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"], _excluded2$2 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "onPress", "refKey", "disabled", "ref"];
useSelect$1.stateChangeTypes = stateChangeTypes$2;
function useSelect$1(r) {
  r === void 0 && (r = {}), validatePropTypes$2(r, useSelect$1);
  var a = _extends$3({}, defaultProps$2, r), s = a.items, c = a.scrollIntoView, u = a.environment, d = a.itemToString, h = a.getA11ySelectionMessage, p = a.getA11yStatusMessage, m = getInitialState$2(a), g = useControlledReducer$1(downshiftSelectReducer, m, a), v = g[0], y = g[1], x = v.isOpen, w = v.highlightedIndex, S = v.selectedItem, M = v.inputValue, P = useRef$1(null), L = useRef$1(null), I = useRef$1({}), T = useRef$1(null), E = useElementIds(a), R = useRef$1(), A = useRef$1(!0), k = useLatestRef({
    state: v,
    props: a
  }), V = useCallback$1(function(ee) {
    return I.current[E.getItemId(ee)];
  }, [E]);
  useA11yMessageSetter(p, [x, w, M, s], _extends$3({
    isInitialMount: A.current,
    previousResultCount: R.current,
    items: s,
    environment: u,
    itemToString: d
  }, v)), useA11yMessageSetter(h, [S], _extends$3({
    isInitialMount: A.current,
    previousResultCount: R.current,
    items: s,
    environment: u,
    itemToString: d
  }, v));
  var B = useScrollIntoView({
    menuElement: L.current,
    highlightedIndex: w,
    isOpen: x,
    itemRefs: I,
    scrollIntoView: c,
    getItemNodeFromIndex: V
  });
  useEffect$1(function() {
    return T.current = debounce$1(function(ee) {
      ee({
        type: FunctionSetInputValue$1,
        inputValue: ""
      });
    }, 500), function() {
      T.current.cancel();
    };
  }, []), useEffect$1(function() {
    M && T.current(y);
  }, [y, M]), useControlPropsValidator({
    isInitialMount: A.current,
    props: a,
    state: v
  }), useEffect$1(function() {
    A.current || (R.current = s.length);
  }), useEffect$1(function() {
    var ee = getInitialValue$1(a, "isOpen");
    ee && P.current && P.current.focus();
  }, []);
  var q = useMouseAndTouchTracker(x, [L, P], u, function() {
    y({
      type: ToggleButtonBlur
    });
  }), z = useGetterPropsCalledChecker("getMenuProps", "getToggleButtonProps");
  useEffect$1(function() {
    return A.current = !1, function() {
      A.current = !0;
    };
  }, []), useEffect$1(function() {
    x || (I.current = {});
  }, [x]);
  var Z = useMemo$1(function() {
    return {
      ArrowDown: function(X) {
        X.preventDefault(), y({
          type: ToggleButtonKeyDownArrowDown,
          altKey: X.altKey
        });
      },
      ArrowUp: function(X) {
        X.preventDefault(), y({
          type: ToggleButtonKeyDownArrowUp,
          altKey: X.altKey
        });
      },
      Home: function(X) {
        X.preventDefault(), y({
          type: ToggleButtonKeyDownHome
        });
      },
      End: function(X) {
        X.preventDefault(), y({
          type: ToggleButtonKeyDownEnd
        });
      },
      Escape: function() {
        k.current.state.isOpen && y({
          type: ToggleButtonKeyDownEscape
        });
      },
      Enter: function(X) {
        X.preventDefault(), y({
          type: k.current.state.isOpen ? ToggleButtonKeyDownEnter : ToggleButtonClick$1
        });
      },
      PageUp: function(X) {
        k.current.state.isOpen && (X.preventDefault(), y({
          type: ToggleButtonKeyDownPageUp
        }));
      },
      PageDown: function(X) {
        k.current.state.isOpen && (X.preventDefault(), y({
          type: ToggleButtonKeyDownPageDown
        }));
      },
      " ": function(X) {
        X.preventDefault();
        var J = k.current.state;
        if (!J.isOpen) {
          y({
            type: ToggleButtonClick$1
          });
          return;
        }
        J.inputValue ? y({
          type: ToggleButtonKeyDownCharacter,
          key: " "
        }) : y({
          type: ToggleButtonKeyDownSpaceButton
        });
      }
    };
  }, [y, k]), G = useCallback$1(function() {
    y({
      type: FunctionToggleMenu$1
    });
  }, [y]), K = useCallback$1(function() {
    y({
      type: FunctionCloseMenu$1
    });
  }, [y]), U = useCallback$1(function() {
    y({
      type: FunctionOpenMenu$1
    });
  }, [y]), F = useCallback$1(function(ee) {
    y({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: ee
    });
  }, [y]), N = useCallback$1(function(ee) {
    y({
      type: FunctionSelectItem$1,
      selectedItem: ee
    });
  }, [y]), D = useCallback$1(function() {
    y({
      type: FunctionReset$2
    });
  }, [y]), j = useCallback$1(function(ee) {
    y({
      type: FunctionSetInputValue$1,
      inputValue: ee
    });
  }, [y]), H = useCallback$1(function(ee) {
    return _extends$3({
      id: E.labelId,
      htmlFor: E.toggleButtonId
    }, ee);
  }, [E]), W = useCallback$1(function(ee, X) {
    var J, ie = ee === void 0 ? {} : ee, oe = ie.onMouseLeave, fe = ie.refKey, ve = fe === void 0 ? "ref" : fe;
    ie.onKeyDown, ie.onBlur;
    var ue = ie.ref, pe = _objectWithoutPropertiesLoose$1(ie, _excluded$2), we = X === void 0 ? {} : X, ye = we.suppressRefError, Ie = ye === void 0 ? !1 : ye, Ee = function() {
      y({
        type: MenuMouseLeave$1
      });
    };
    return z("getMenuProps", Ie, ve, L), _extends$3((J = {}, J[ve] = handleRefs(ue, function(ne) {
      L.current = ne;
    }), J.id = E.menuId, J.role = "listbox", J["aria-labelledby"] = pe && pe["aria-label"] ? void 0 : "" + E.labelId, J.onMouseLeave = callAllEventHandlers(oe, Ee), J), pe);
  }, [y, z, E]), re = useCallback$1(function(ee, X) {
    var J, ie = ee === void 0 ? {} : ee, oe = ie.onBlur, fe = ie.onClick;
    ie.onPress;
    var ve = ie.onKeyDown, ue = ie.refKey, pe = ue === void 0 ? "ref" : ue, we = ie.ref, ye = _objectWithoutPropertiesLoose$1(ie, _excluded2$2), Ie = X === void 0 ? {} : X, Ee = Ie.suppressRefError, ne = Ee === void 0 ? !1 : Ee, se = k.current.state, de = function() {
      y({
        type: ToggleButtonClick$1
      });
    }, Ce = function() {
      se.isOpen && !q.current.isMouseDown && y({
        type: ToggleButtonBlur
      });
    }, me = function(Re) {
      var Pe = normalizeArrowKey(Re);
      Pe && Z[Pe] ? Z[Pe](Re) : isAcceptedCharacterKey(Pe) && y({
        type: ToggleButtonKeyDownCharacter,
        key: Pe
      });
    }, xe = _extends$3((J = {}, J[pe] = handleRefs(we, function(Se) {
      P.current = Se;
    }), J["aria-activedescendant"] = se.isOpen && se.highlightedIndex > -1 ? E.getItemId(se.highlightedIndex) : "", J["aria-controls"] = E.menuId, J["aria-expanded"] = k.current.state.isOpen, J["aria-haspopup"] = "listbox", J["aria-labelledby"] = ye && ye["aria-label"] ? void 0 : "" + E.labelId, J.id = E.toggleButtonId, J.role = "combobox", J.tabIndex = 0, J.onBlur = callAllEventHandlers(oe, Ce), J), ye);
    return ye.disabled || (xe.onClick = callAllEventHandlers(fe, de), xe.onKeyDown = callAllEventHandlers(ve, me)), z("getToggleButtonProps", ne, pe, P), xe;
  }, [k, E, z, y, q, Z]), ae = useCallback$1(function(ee) {
    var X, J = ee === void 0 ? {} : ee, ie = J.item, oe = J.index, fe = J.onMouseMove, ve = J.onClick;
    J.onPress;
    var ue = J.refKey, pe = ue === void 0 ? "ref" : ue, we = J.disabled, ye = J.ref, Ie = _objectWithoutPropertiesLoose$1(J, _excluded3$1);
    we !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    var Ee = k.current, ne = Ee.state, se = Ee.props, de = getItemAndIndex(ie, oe, se.items, "Pass either item or index to getItemProps!"), Ce = de[0], me = de[1], xe = se.isItemDisabled(Ce, me), Se = function() {
      me !== ne.highlightedIndex && (B.current = !1, y({
        type: ItemMouseMove$1,
        index: me,
        disabled: xe
      }));
    }, Re = function() {
      y({
        type: ItemClick$1,
        index: me
      });
    }, Pe = _extends$3((X = {}, X[pe] = handleRefs(ye, function(ke) {
      ke && (I.current[E.getItemId(me)] = ke);
    }), X["aria-disabled"] = xe, X["aria-selected"] = "" + (Ce === ne.selectedItem), X.id = E.getItemId(me), X.role = "option", X), Ie);
    return xe || (Pe.onClick = callAllEventHandlers(ve, Re)), Pe.onMouseMove = callAllEventHandlers(fe, Se), Pe;
  }, [k, E, B, y]);
  return {
    // prop getters.
    getToggleButtonProps: re,
    getLabelProps: H,
    getMenuProps: W,
    getItemProps: ae,
    // actions.
    toggleMenu: G,
    openMenu: U,
    closeMenu: K,
    setHighlightedIndex: F,
    selectItem: N,
    reset: D,
    setInputValue: j,
    // state.
    highlightedIndex: w,
    isOpen: x,
    selectedItem: S,
    inputValue: M
  };
}
var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, InputKeyDownEscape = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, InputKeyDownHome = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, InputKeyDownEnd = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, InputKeyDownPageUp = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, InputKeyDownPageDown = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, InputKeyDownEnter = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, InputChange = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, InputBlur = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, InputClick = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, MenuMouseLeave = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, ItemMouseMove = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, ItemClick = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, ToggleButtonClick = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, FunctionToggleMenu = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, FunctionOpenMenu = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, FunctionCloseMenu = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, FunctionSelectItem = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, FunctionSetInputValue = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, FunctionReset$1 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, stateChangeTypes$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown,
  InputKeyDownArrowUp,
  InputKeyDownEscape,
  InputKeyDownHome,
  InputKeyDownEnd,
  InputKeyDownPageUp,
  InputKeyDownPageDown,
  InputKeyDownEnter,
  InputChange,
  InputBlur,
  InputClick,
  MenuMouseLeave,
  ItemMouseMove,
  ItemClick,
  ToggleButtonClick,
  FunctionToggleMenu,
  FunctionOpenMenu,
  FunctionCloseMenu,
  FunctionSetHighlightedIndex,
  FunctionSelectItem,
  FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem
});
function getInitialState$1(r) {
  var a = getInitialState$2(r), s = a.selectedItem, c = a.inputValue;
  return c === "" && s && r.defaultInputValue === void 0 && r.initialInputValue === void 0 && r.inputValue === void 0 && (c = r.itemToString(s)), _extends$3({}, a, {
    inputValue: c
  });
}
var propTypes$1 = _extends$3({}, commonDropdownPropTypes, {
  items: PropTypes.array.isRequired,
  isItemDisabled: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  getA11ySelectionMessage: PropTypes.func,
  inputValue: PropTypes.string,
  defaultInputValue: PropTypes.string,
  initialInputValue: PropTypes.string,
  inputId: PropTypes.string,
  onInputValueChange: PropTypes.func
});
function useControlledReducer(r, a, s) {
  var c = useRef$1(), u = useEnhancedReducer(r, a, s), d = u[0], h = u[1];
  return useEffect$1(function() {
    isControlledProp(s, "selectedItem") && (s.selectedItemChanged(c.current, s.selectedItem) && h({
      type: ControlledPropUpdatedSelectedItem,
      inputValue: s.itemToString(s.selectedItem)
    }), c.current = d.selectedItem === c.current ? s.selectedItem : d.selectedItem);
  }, [d.selectedItem, s.selectedItem]), [getState(d, s), h];
}
var validatePropTypes$1 = noop;
process.env.NODE_ENV !== "production" && (validatePropTypes$1 = function(a, s) {
  PropTypes.checkPropTypes(propTypes$1, a, "prop", s.name);
});
var defaultProps$1 = _extends$3({}, defaultProps$3, {
  selectedItemChanged: function r(a, s) {
    return a !== s;
  },
  getA11yStatusMessage: getA11yStatusMessage$1,
  isItemDisabled: function r() {
    return !1;
  }
});
function downshiftUseComboboxReducer(r, a) {
  var s, c = a.type, u = a.props, d = a.altKey, h;
  switch (c) {
    case ItemClick:
      h = {
        isOpen: getDefaultValue$1(u, "isOpen"),
        highlightedIndex: getDefaultValue$1(u, "highlightedIndex"),
        selectedItem: u.items[a.index],
        inputValue: u.itemToString(u.items[a.index])
      };
      break;
    case InputKeyDownArrowDown:
      r.isOpen ? h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, 1, u.items, u.isItemDisabled, !0)
      } : h = {
        highlightedIndex: d && r.selectedItem == null ? -1 : getHighlightedIndexOnOpen(u, r, 1),
        isOpen: u.items.length >= 0
      };
      break;
    case InputKeyDownArrowUp:
      r.isOpen ? d ? h = getChangesOnSelection(u, r.highlightedIndex) : h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, -1, u.items, u.isItemDisabled, !0)
      } : h = {
        highlightedIndex: getHighlightedIndexOnOpen(u, r, -1),
        isOpen: u.items.length >= 0
      };
      break;
    case InputKeyDownEnter:
      h = getChangesOnSelection(u, r.highlightedIndex);
      break;
    case InputKeyDownEscape:
      h = _extends$3({
        isOpen: !1,
        highlightedIndex: -1
      }, !r.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case InputKeyDownPageUp:
      h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, -10, u.items, u.isItemDisabled, !0)
      };
      break;
    case InputKeyDownPageDown:
      h = {
        highlightedIndex: getHighlightedIndex(r.highlightedIndex, 10, u.items, u.isItemDisabled, !0)
      };
      break;
    case InputKeyDownHome:
      h = {
        highlightedIndex: getNonDisabledIndex(0, !1, u.items, u.isItemDisabled)
      };
      break;
    case InputKeyDownEnd:
      h = {
        highlightedIndex: getNonDisabledIndex(u.items.length - 1, !0, u.items, u.isItemDisabled)
      };
      break;
    case InputBlur:
      h = _extends$3({
        isOpen: !1,
        highlightedIndex: -1
      }, r.highlightedIndex >= 0 && ((s = u.items) == null ? void 0 : s.length) && a.selectItem && {
        selectedItem: u.items[r.highlightedIndex],
        inputValue: u.itemToString(u.items[r.highlightedIndex])
      });
      break;
    case InputChange:
      h = {
        isOpen: !0,
        highlightedIndex: getDefaultValue$1(u, "highlightedIndex"),
        inputValue: a.inputValue
      };
      break;
    case InputClick:
      h = {
        isOpen: !r.isOpen,
        highlightedIndex: r.isOpen ? -1 : getHighlightedIndexOnOpen(u, r, 0)
      };
      break;
    case FunctionSelectItem:
      h = {
        selectedItem: a.selectedItem,
        inputValue: u.itemToString(a.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      h = {
        inputValue: a.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(r, a, stateChangeTypes$1);
  }
  return _extends$3({}, r, h);
}
var _excluded$1 = ["onMouseLeave", "refKey", "ref"], _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], _excluded3 = ["onClick", "onPress", "refKey", "ref"], _excluded4 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(r) {
  r === void 0 && (r = {}), validatePropTypes$1(r, useCombobox);
  var a = _extends$3({}, defaultProps$1, r), s = a.items, c = a.scrollIntoView, u = a.environment, d = a.getA11yStatusMessage, h = a.getA11ySelectionMessage, p = a.itemToString, m = getInitialState$1(a), g = useControlledReducer(downshiftUseComboboxReducer, m, a), v = g[0], y = g[1], x = v.isOpen, w = v.highlightedIndex, S = v.selectedItem, M = v.inputValue, P = useRef$1(null), L = useRef$1({}), I = useRef$1(null), T = useRef$1(null), E = useRef$1(!0), R = useElementIds(a), A = useRef$1(), k = useLatestRef({
    state: v,
    props: a
  }), V = useCallback$1(function(X) {
    return L.current[R.getItemId(X)];
  }, [R]);
  useA11yMessageSetter(d, [x, w, M, s], _extends$3({
    isInitialMount: E.current,
    previousResultCount: A.current,
    items: s,
    environment: u,
    itemToString: p
  }, v)), useA11yMessageSetter(h, [S], _extends$3({
    isInitialMount: E.current,
    previousResultCount: A.current,
    items: s,
    environment: u,
    itemToString: p
  }, v));
  var B = useScrollIntoView({
    menuElement: P.current,
    highlightedIndex: w,
    isOpen: x,
    itemRefs: L,
    scrollIntoView: c,
    getItemNodeFromIndex: V
  });
  useControlPropsValidator({
    isInitialMount: E.current,
    props: a,
    state: v
  }), useEffect$1(function() {
    var X = getInitialValue$1(a, "isOpen");
    X && I.current && I.current.focus();
  }, []), useEffect$1(function() {
    E.current || (A.current = s.length);
  });
  var q = useMouseAndTouchTracker(x, [I, P, T], u, function() {
    y({
      type: InputBlur,
      selectItem: !1
    });
  }), z = useGetterPropsCalledChecker("getInputProps", "getMenuProps");
  useEffect$1(function() {
    return E.current = !1, function() {
      E.current = !0;
    };
  }, []), useEffect$1(function() {
    var X;
    if (!x)
      L.current = {};
    else if (((X = u.document) == null ? void 0 : X.activeElement) !== I.current) {
      var J;
      I == null || (J = I.current) == null || J.focus();
    }
  }, [x, u]);
  var Z = useMemo$1(function() {
    return {
      ArrowDown: function(J) {
        J.preventDefault(), y({
          type: InputKeyDownArrowDown,
          altKey: J.altKey
        });
      },
      ArrowUp: function(J) {
        J.preventDefault(), y({
          type: InputKeyDownArrowUp,
          altKey: J.altKey
        });
      },
      Home: function(J) {
        k.current.state.isOpen && (J.preventDefault(), y({
          type: InputKeyDownHome
        }));
      },
      End: function(J) {
        k.current.state.isOpen && (J.preventDefault(), y({
          type: InputKeyDownEnd
        }));
      },
      Escape: function(J) {
        var ie = k.current.state;
        (ie.isOpen || ie.inputValue || ie.selectedItem || ie.highlightedIndex > -1) && (J.preventDefault(), y({
          type: InputKeyDownEscape
        }));
      },
      Enter: function(J) {
        var ie = k.current.state;
        !ie.isOpen || J.which === 229 || (J.preventDefault(), y({
          type: InputKeyDownEnter
        }));
      },
      PageUp: function(J) {
        k.current.state.isOpen && (J.preventDefault(), y({
          type: InputKeyDownPageUp
        }));
      },
      PageDown: function(J) {
        k.current.state.isOpen && (J.preventDefault(), y({
          type: InputKeyDownPageDown
        }));
      }
    };
  }, [y, k]), G = useCallback$1(function(X) {
    return _extends$3({
      id: R.labelId,
      htmlFor: R.inputId
    }, X);
  }, [R]), K = useCallback$1(function(X, J) {
    var ie, oe = X === void 0 ? {} : X, fe = oe.onMouseLeave, ve = oe.refKey, ue = ve === void 0 ? "ref" : ve, pe = oe.ref, we = _objectWithoutPropertiesLoose$1(oe, _excluded$1), ye = J === void 0 ? {} : J, Ie = ye.suppressRefError, Ee = Ie === void 0 ? !1 : Ie;
    return z("getMenuProps", Ee, ue, P), _extends$3((ie = {}, ie[ue] = handleRefs(pe, function(ne) {
      P.current = ne;
    }), ie.id = R.menuId, ie.role = "listbox", ie["aria-labelledby"] = we && we["aria-label"] ? void 0 : "" + R.labelId, ie.onMouseLeave = callAllEventHandlers(fe, function() {
      y({
        type: MenuMouseLeave
      });
    }), ie), we);
  }, [y, z, R]), U = useCallback$1(function(X) {
    var J, ie, oe = X === void 0 ? {} : X, fe = oe.item, ve = oe.index, ue = oe.refKey, pe = ue === void 0 ? "ref" : ue, we = oe.ref, ye = oe.onMouseMove, Ie = oe.onMouseDown, Ee = oe.onClick;
    oe.onPress;
    var ne = oe.disabled, se = _objectWithoutPropertiesLoose$1(oe, _excluded2$1);
    ne !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var de = k.current, Ce = de.props, me = de.state, xe = getItemAndIndex(fe, ve, Ce.items, "Pass either item or index to getItemProps!"), Se = xe[0], Re = xe[1], Pe = Ce.isItemDisabled(Se, Re), ke = "onClick", De = Ee, Fe = function() {
      Re !== me.highlightedIndex && (B.current = !1, y({
        type: ItemMouseMove,
        index: Re,
        disabled: Pe
      }));
    }, Xe = function() {
      y({
        type: ItemClick,
        index: Re
      });
    }, ze = function(Tt) {
      return Tt.preventDefault();
    };
    return _extends$3((J = {}, J[pe] = handleRefs(we, function(Ge) {
      Ge && (L.current[R.getItemId(Re)] = Ge);
    }), J["aria-disabled"] = Pe, J["aria-selected"] = "" + (Re === me.highlightedIndex), J.id = R.getItemId(Re), J.role = "option", J), !Pe && (ie = {}, ie[ke] = callAllEventHandlers(De, Xe), ie), {
      onMouseMove: callAllEventHandlers(ye, Fe),
      onMouseDown: callAllEventHandlers(Ie, ze)
    }, se);
  }, [y, k, B, R]), F = useCallback$1(function(X) {
    var J, ie = X === void 0 ? {} : X, oe = ie.onClick;
    ie.onPress;
    var fe = ie.refKey, ve = fe === void 0 ? "ref" : fe, ue = ie.ref, pe = _objectWithoutPropertiesLoose$1(ie, _excluded3), we = k.current.state, ye = function() {
      y({
        type: ToggleButtonClick
      });
    };
    return _extends$3((J = {}, J[ve] = handleRefs(ue, function(Ie) {
      T.current = Ie;
    }), J["aria-controls"] = R.menuId, J["aria-expanded"] = we.isOpen, J.id = R.toggleButtonId, J.tabIndex = -1, J), !pe.disabled && _extends$3({}, {
      onClick: callAllEventHandlers(oe, ye)
    }), pe);
  }, [y, k, R]), N = useCallback$1(function(X, J) {
    var ie, oe = X === void 0 ? {} : X, fe = oe.onKeyDown, ve = oe.onChange, ue = oe.onInput, pe = oe.onBlur;
    oe.onChangeText;
    var we = oe.onClick, ye = oe.refKey, Ie = ye === void 0 ? "ref" : ye, Ee = oe.ref, ne = _objectWithoutPropertiesLoose$1(oe, _excluded4), se = J === void 0 ? {} : J, de = se.suppressRefError, Ce = de === void 0 ? !1 : de;
    z("getInputProps", Ce, Ie, I);
    var me = k.current.state, xe = function(ze) {
      var Ge = normalizeArrowKey(ze);
      Ge && Z[Ge] && Z[Ge](ze);
    }, Se = function(ze) {
      y({
        type: InputChange,
        inputValue: ze.target.value
      });
    }, Re = function(ze) {
      if (me.isOpen && !q.current.isMouseDown) {
        var Ge = ze.relatedTarget === null && u.document.activeElement !== u.document.body;
        y({
          type: InputBlur,
          selectItem: !Ge
        });
      }
    }, Pe = function() {
      y({
        type: InputClick
      });
    }, ke = "onChange", De = {};
    if (!ne.disabled) {
      var Fe;
      De = (Fe = {}, Fe[ke] = callAllEventHandlers(ve, ue, Se), Fe.onKeyDown = callAllEventHandlers(fe, xe), Fe.onBlur = callAllEventHandlers(pe, Re), Fe.onClick = callAllEventHandlers(we, Pe), Fe);
    }
    return _extends$3((ie = {}, ie[Ie] = handleRefs(Ee, function(Xe) {
      I.current = Xe;
    }), ie["aria-activedescendant"] = me.isOpen && me.highlightedIndex > -1 ? R.getItemId(me.highlightedIndex) : "", ie["aria-autocomplete"] = "list", ie["aria-controls"] = R.menuId, ie["aria-expanded"] = me.isOpen, ie["aria-labelledby"] = ne && ne["aria-label"] ? void 0 : R.labelId, ie.autoComplete = "off", ie.id = R.inputId, ie.role = "combobox", ie.value = me.inputValue, ie), De, ne);
  }, [z, k, R, Z, y, q, u]), D = useCallback$1(function() {
    y({
      type: FunctionToggleMenu
    });
  }, [y]), j = useCallback$1(function() {
    y({
      type: FunctionCloseMenu
    });
  }, [y]), H = useCallback$1(function() {
    y({
      type: FunctionOpenMenu
    });
  }, [y]), W = useCallback$1(function(X) {
    y({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: X
    });
  }, [y]), re = useCallback$1(function(X) {
    y({
      type: FunctionSelectItem,
      selectedItem: X
    });
  }, [y]), ae = useCallback$1(function(X) {
    y({
      type: FunctionSetInputValue,
      inputValue: X
    });
  }, [y]), ee = useCallback$1(function() {
    y({
      type: FunctionReset$1
    });
  }, [y]);
  return {
    // prop getters.
    getItemProps: U,
    getLabelProps: G,
    getMenuProps: K,
    getInputProps: N,
    getToggleButtonProps: F,
    // actions.
    toggleMenu: D,
    openMenu: H,
    closeMenu: j,
    setHighlightedIndex: W,
    setInputValue: ae,
    selectItem: re,
    reset: ee,
    // state.
    highlightedIndex: w,
    isOpen: x,
    selectedItem: S,
    inputValue: M
  };
}
var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};
function getInitialValue(r, a) {
  return getInitialValue$1(r, a, defaultStateValues);
}
function getDefaultValue(r, a) {
  return getDefaultValue$1(r, a, defaultStateValues);
}
function getInitialState(r) {
  var a = getInitialValue(r, "activeIndex"), s = getInitialValue(r, "selectedItems");
  return {
    activeIndex: a,
    selectedItems: s
  };
}
function isKeyDownOperationPermitted(r) {
  if (r.shiftKey || r.metaKey || r.ctrlKey || r.altKey)
    return !1;
  var a = r.target;
  return !(a instanceof HTMLInputElement && // if element is a text input
  a.value !== "" && // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  (a.selectionStart !== 0 || a.selectionEnd !== 0));
}
function getA11yRemovalMessage(r) {
  var a = r.removedSelectedItem, s = r.itemToString;
  return s(a) + " has been removed.";
}
var propTypes = _extends$3({}, commonPropTypes, {
  selectedItems: PropTypes.array,
  initialSelectedItems: PropTypes.array,
  defaultSelectedItems: PropTypes.array,
  getA11yRemovalMessage: PropTypes.func,
  activeIndex: PropTypes.number,
  initialActiveIndex: PropTypes.number,
  defaultActiveIndex: PropTypes.number,
  onActiveIndexChange: PropTypes.func,
  onSelectedItemsChange: PropTypes.func,
  keyNavigationNext: PropTypes.string,
  keyNavigationPrevious: PropTypes.string
}), defaultProps$4 = {
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
}, validatePropTypes = noop;
process.env.NODE_ENV !== "production" && (validatePropTypes = function(a, s) {
  PropTypes.checkPropTypes(propTypes, a, "prop", s.name);
});
var SelectedItemClick = process.env.NODE_ENV !== "production" ? "__selected_item_click__" : 0, SelectedItemKeyDownDelete = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_delete__" : 1, SelectedItemKeyDownBackspace = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_backspace__" : 2, SelectedItemKeyDownNavigationNext = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_next__" : 3, SelectedItemKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_previous__" : 4, DropdownKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_navigation_previous__" : 5, DropdownKeyDownBackspace = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_backspace__" : 6, DropdownClick = process.env.NODE_ENV !== "production" ? "__dropdown_click__" : 7, FunctionAddSelectedItem = process.env.NODE_ENV !== "production" ? "__function_add_selected_item__" : 8, FunctionRemoveSelectedItem = process.env.NODE_ENV !== "production" ? "__function_remove_selected_item__" : 9, FunctionSetSelectedItems = process.env.NODE_ENV !== "production" ? "__function_set_selected_items__" : 10, FunctionSetActiveIndex = process.env.NODE_ENV !== "production" ? "__function_set_active_index__" : 11, FunctionReset = process.env.NODE_ENV !== "production" ? "__function_reset__" : 12, stateChangeTypes = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  SelectedItemClick,
  SelectedItemKeyDownDelete,
  SelectedItemKeyDownBackspace,
  SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious,
  DropdownKeyDownNavigationPrevious,
  DropdownKeyDownBackspace,
  DropdownClick,
  FunctionAddSelectedItem,
  FunctionRemoveSelectedItem,
  FunctionSetSelectedItems,
  FunctionSetActiveIndex,
  FunctionReset
});
function downshiftMultipleSelectionReducer(r, a) {
  var s = a.type, c = a.index, u = a.props, d = a.selectedItem, h = r.activeIndex, p = r.selectedItems, m;
  switch (s) {
    case SelectedItemClick:
      m = {
        activeIndex: c
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      m = {
        activeIndex: h - 1 < 0 ? 0 : h - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      m = {
        activeIndex: h + 1 >= p.length ? -1 : h + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete: {
      if (h < 0)
        break;
      var g = h;
      p.length === 1 ? g = -1 : h === p.length - 1 && (g = p.length - 2), m = _extends$3({
        selectedItems: [].concat(p.slice(0, h), p.slice(h + 1))
      }, {
        activeIndex: g
      });
      break;
    }
    case DropdownKeyDownNavigationPrevious:
      m = {
        activeIndex: p.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      m = {
        selectedItems: p.slice(0, p.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      m = {
        selectedItems: [].concat(p, [d])
      };
      break;
    case DropdownClick:
      m = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem: {
      var v = h, y = p.indexOf(d);
      if (y < 0)
        break;
      p.length === 1 ? v = -1 : y === p.length - 1 && (v = p.length - 2), m = {
        selectedItems: [].concat(p.slice(0, y), p.slice(y + 1)),
        activeIndex: v
      };
      break;
    }
    case FunctionSetSelectedItems: {
      var x = a.selectedItems;
      m = {
        selectedItems: x
      };
      break;
    }
    case FunctionSetActiveIndex: {
      var w = a.activeIndex;
      m = {
        activeIndex: w
      };
      break;
    }
    case FunctionReset:
      m = {
        activeIndex: getDefaultValue(u, "activeIndex"),
        selectedItems: getDefaultValue(u, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends$3({}, r, m);
}
var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"], _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;
function useMultipleSelection(r) {
  r === void 0 && (r = {}), validatePropTypes(r, useMultipleSelection);
  var a = _extends$3({}, defaultProps$4, r), s = a.getA11yRemovalMessage, c = a.itemToString, u = a.environment, d = a.keyNavigationNext, h = a.keyNavigationPrevious, p = useControlledReducer$1(downshiftMultipleSelectionReducer, getInitialState(a), a), m = p[0], g = p[1], v = m.activeIndex, y = m.selectedItems, x = useRef$1(!0), w = useRef$1(null), S = useRef$1(y), M = useRef$1();
  M.current = [];
  var P = useLatestRef({
    state: m,
    props: a
  });
  useEffect$1(function() {
    if (!x.current) {
      if (y.length < S.current.length) {
        var z = S.current.find(function(Z) {
          return y.indexOf(Z) < 0;
        });
        setStatus$1(s({
          itemToString: c,
          resultCount: y.length,
          removedSelectedItem: z,
          activeIndex: v,
          activeSelectedItem: y[v]
        }), u.document);
      }
      S.current = y;
    }
  }, [y.length]), useEffect$1(function() {
    x.current || (v === -1 && w.current ? w.current.focus() : M.current[v] && M.current[v].focus());
  }, [v]), useControlPropsValidator({
    isInitialMount: x.current,
    props: a,
    state: m
  });
  var L = useGetterPropsCalledChecker("getDropdownProps");
  useEffect$1(function() {
    return x.current = !1, function() {
      x.current = !0;
    };
  }, []);
  var I = useMemo$1(function() {
    var z;
    return z = {}, z[h] = function() {
      g({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, z[d] = function() {
      g({
        type: SelectedItemKeyDownNavigationNext
      });
    }, z.Delete = function() {
      g({
        type: SelectedItemKeyDownDelete
      });
    }, z.Backspace = function() {
      g({
        type: SelectedItemKeyDownBackspace
      });
    }, z;
  }, [g, d, h]), T = useMemo$1(function() {
    var z;
    return z = {}, z[h] = function(Z) {
      isKeyDownOperationPermitted(Z) && g({
        type: DropdownKeyDownNavigationPrevious
      });
    }, z.Backspace = function(G) {
      isKeyDownOperationPermitted(G) && g({
        type: DropdownKeyDownBackspace
      });
    }, z;
  }, [g, h]), E = useCallback$1(function(z) {
    var Z, G = z === void 0 ? {} : z, K = G.refKey, U = K === void 0 ? "ref" : K, F = G.ref, N = G.onClick, D = G.onKeyDown, j = G.selectedItem, H = G.index, W = _objectWithoutPropertiesLoose$1(G, _excluded), re = P.current.state, ae = getItemAndIndex(j, H, re.selectedItems, "Pass either item or index to getSelectedItemProps!"), ee = ae[1], X = ee > -1 && ee === re.activeIndex, J = function() {
      g({
        type: SelectedItemClick,
        index: ee
      });
    }, ie = function(fe) {
      var ve = normalizeArrowKey(fe);
      ve && I[ve] && I[ve](fe);
    };
    return _extends$3((Z = {}, Z[U] = handleRefs(F, function(oe) {
      oe && M.current.push(oe);
    }), Z.tabIndex = X ? 0 : -1, Z.onClick = callAllEventHandlers(N, J), Z.onKeyDown = callAllEventHandlers(D, ie), Z), W);
  }, [g, P, I]), R = useCallback$1(function(z, Z) {
    var G, K = z === void 0 ? {} : z, U = K.refKey, F = U === void 0 ? "ref" : U, N = K.ref, D = K.onKeyDown, j = K.onClick, H = K.preventKeyAction, W = H === void 0 ? !1 : H, re = _objectWithoutPropertiesLoose$1(K, _excluded2), ae = Z === void 0 ? {} : Z, ee = ae.suppressRefError, X = ee === void 0 ? !1 : ee;
    L("getDropdownProps", X, F, w);
    var J = function(fe) {
      var ve = normalizeArrowKey(fe);
      ve && T[ve] && T[ve](fe);
    }, ie = function() {
      g({
        type: DropdownClick
      });
    };
    return _extends$3((G = {}, G[F] = handleRefs(N, function(oe) {
      oe && (w.current = oe);
    }), G), !W && {
      onKeyDown: callAllEventHandlers(D, J),
      onClick: callAllEventHandlers(j, ie)
    }, re);
  }, [g, T, L]), A = useCallback$1(function(z) {
    g({
      type: FunctionAddSelectedItem,
      selectedItem: z
    });
  }, [g]), k = useCallback$1(function(z) {
    g({
      type: FunctionRemoveSelectedItem,
      selectedItem: z
    });
  }, [g]), V = useCallback$1(function(z) {
    g({
      type: FunctionSetSelectedItems,
      selectedItems: z
    });
  }, [g]), B = useCallback$1(function(z) {
    g({
      type: FunctionSetActiveIndex,
      activeIndex: z
    });
  }, [g]), q = useCallback$1(function() {
    g({
      type: FunctionReset
    });
  }, [g]);
  return {
    getSelectedItemProps: E,
    getDropdownProps: R,
    addSelectedItem: A,
    removeSelectedItem: k,
    setSelectedItems: V,
    setActiveIndex: B,
    reset: q,
    selectedItems: y,
    activeIndex: v
  };
}
const useCreatableOption = ({
  query: r,
  options: a,
  creatableOption: s
}) => {
  const [c, u] = useState$1(!1), [d, h] = useState$1(null), p = !!s, m = useCallback$1(
    (v) => !!(v && !a.find((y) => v.toLocaleLowerCase() === y.label.toLowerCase())),
    [a]
  ), g = (s == null ? void 0 : s.shouldDisplay) ?? m;
  return useEffect$1(() => {
    p && g(r ?? "") ? (u(!0), h({
      value: (r ?? "").toLocaleLowerCase(),
      label: r ?? ""
    })) : (u(!1), h(null));
  }, [p, r, g]), {
    shouldShowCreatableOption: c,
    setShouldShowCreatableOption: u,
    newOption: d
  };
}, useDropdownMenuProps = ({
  isOpen: r,
  shouldShowCreatableOption: a,
  getMenuProps: s,
  emptyState: c,
  closeMenu: u,
  hasSections: d,
  options: h
}) => {
  const { x: p, y: m, strategy: g, refs: v, context: y } = useFloating({
    whileElementsMounted: autoUpdate,
    // This is used instead of a portal to keep the dropdown next to the trigger in the DOM tree.
    strategy: "fixed",
    middleware: [
      size({
        apply: ({ rects: w }) => {
          v.floating.current && Object.assign(v.floating.current.style, {
            width: `${w.reference.width}px`
          });
        }
      }),
      flip$2()
    ]
  }), x = {
    isOpen: r,
    context: y,
    x: p,
    y: m,
    strategy: g,
    ref: v.setFloating,
    // Dropdown menu content props:
    contentProps: {
      // `suppressRefError` was added due to this issue: https://github.com/downshift-js/downshift/issues/1272
      ...s({}, { suppressRefError: !0 }),
      shouldShowCreatableOption: a,
      emptyState: c,
      closeMenu: u,
      hasSections: d,
      options: h
    }
  };
  return {
    anchorRef: v.setReference,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dropdownMenuProps: x
  };
}, getOptionPropsHelper = ({
  getItemProps: r,
  highlightedIndex: a,
  focusedIndex: s,
  getTestId: c,
  resetFocusedIndex: u,
  selectedOption: d
}) => ({ option: h, index: p, isCreatableOption: m }) => ({
  ...r({ item: h, index: p }),
  isHighlighted: a === p,
  isFocused: s === p,
  key: `${h.label}-${p}`,
  onMouseLeave: () => {
    s === p && (u == null || u());
  },
  ...!m && {
    isSelected: lodashExports.isEqual(h.value, d == null ? void 0 : d.value),
    "data-testid": h.testId || c(`option-${p}`)["data-testid"]
  }
}), useGetStatusMessage = ({
  isLoading: r,
  optionsCount: a,
  emptyStateLabel: s
}) => {
  const { isExtraSmallScreen: c } = useBreakpoint();
  let u = "";
  return r ? u = "Loading options." : a ? u = `${a} ${a > 1 ? "results" : "result"} available.${c ? "" : " Use up and down arrow keys to navigate. Press Enter key to select."}` : u = s ?? "No results available.", (d) => d ? u : "";
}, useMultiSelect = ({
  ref: r,
  value: a,
  options: s,
  onClick: c,
  onChange: u,
  onKeyDown: d,
  creatableOption: h
}) => {
  var K;
  const [p, m] = useState$1(s);
  useEffect$1(() => {
    m(s);
  }, [s]);
  const g = a !== void 0 && !u;
  useEffect$1(() => {
    g && console.error(
      "Warning: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. Please set either `onChange` or `isReadOnly`."
    );
  }, [g]);
  const v = useMemo$1(
    () => p.filter((U) => a == null ? void 0 : a.find((F) => lodashExports.isEqual(F, U.value))),
    [p, a]
  ), [y, x] = useState$1(v);
  useEffect$1(() => {
    g || x(v);
  }, [g, v]);
  const w = (U) => {
    if (g) return;
    x(U);
    const F = U.map((N) => N.value);
    u == null || u({ target: { value: F } });
  }, { getDropdownProps: S, addSelectedItem: M, removeSelectedItem: P } = useMultipleSelection({
    selectedItems: y
  }), [L, I] = useState$1(-1), T = () => I(-1), { shouldShowCreatableOption: E, newOption: R } = useCreatableOption({
    query: typeof (h == null ? void 0 : h.label) == "string" ? h == null ? void 0 : h.label : (K = h == null ? void 0 : h.label) == null ? void 0 : K.call(h, ""),
    options: p,
    creatableOption: h
  }), { isOpen: A, getToggleButtonProps: k, getMenuProps: V, highlightedIndex: B, getItemProps: q } = useSelect$1({
    defaultHighlightedIndex: 0,
    items: [...p, ...E && R ? [R] : []],
    stateReducer: (U, { changes: F, type: N }) => {
      switch (N) {
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect$1.stateChangeTypes.ItemClick:
          return {
            ...F,
            isOpen: !0,
            // This prevents the `highlightedIndex` from being reset and keeps it on the current selected item.
            highlightedIndex: U.highlightedIndex
          };
      }
      return F;
    },
    onStateChange: ({ type: U, selectedItem: F }) => {
      var N;
      switch (U) {
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect$1.stateChangeTypes.ItemClick:
          F && (F === R ? (N = h == null ? void 0 : h.onClick) == null || N.call(h, "") : y != null && y.find((D) => lodashExports.isEqual(D.value, F.value)) ? (P(F), w(y.filter((D) => !lodashExports.isEqual(D.value, F.value)))) : (M(F), w([...y, F])));
          break;
      }
    },
    onHighlightedIndexChange: ({ type: U, highlightedIndex: F = -1 }) => {
      switch (U) {
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownArrowUp:
          I(F);
          break;
        case useSelect$1.stateChangeTypes.ToggleButtonKeyDownArrowDown:
          I(L < 0 && 0 || F);
          break;
        default:
          T();
          break;
      }
    },
    onIsOpenChange: ({ isOpen: U, highlightedIndex: F = -1 }) => {
      U && I(F);
    },
    // Disables single selection.
    selectedItem: null
  }), z = (U) => {
    U.key === "Enter" && U.preventDefault(), d == null || d(U);
  }, { anchorRef: Z, dropdownMenuProps: G } = useDropdownMenuProps({
    isOpen: A,
    getMenuProps: V,
    options: p,
    shouldShowCreatableOption: E
  });
  return {
    anchorRef: Z,
    dropdownMenuProps: G,
    toggleButtonProps: k(
      S(
        {
          preventKeyAction: A,
          ref: r,
          onClick: c,
          onKeyDown: z,
          // 'aria-labelledby' causes a11y issue because its value doesn't correspond to an element in the document.
          // The reason is because we use our own label (only when needed) using `FormField` wrapper instead of using `downshift`.
          "aria-labelledby": void 0
        },
        // `suppressRefError` was added due to this issue: https://github.com/downshift-js/downshift/issues/1272
        { suppressRefError: !0 }
      ),
      // `suppressRefError` was added due to this issue: https://github.com/downshift-js/downshift/issues/1272
      { suppressRefError: !0 }
    ),
    getOptionProps: getOptionPropsHelper({
      getItemProps: q,
      highlightedIndex: B,
      focusedIndex: L,
      getTestId: useTestId("base-select"),
      resetFocusedIndex: T
    }),
    selectedOptions: y
  };
}, useInputProps = ({
  ref: r,
  getInputProps: a,
  disableClick: s,
  onClick: c,
  onKeyDown: u,
  onBlur: d,
  closeMenu: h,
  isLoading: p
}) => {
  const m = (S) => {
    S.key === "Enter" && (p && (S.nativeEvent.preventDownshiftDefault = !0), S.preventDefault()), S.key === "Tab" && h(), u == null || u(S);
  }, {
    onClick: g,
    autoComplete: v,
    ...y
  } = a({
    ref: r,
    onKeyDown: m,
    onBlur: d,
    // 'aria-labelledby' causes a11y issue because its value doesn't correspond to an element in the document.
    // The reason is because we use our own label (only when needed) using `FormField` wrapper instead of using `downshift`.
    "aria-labelledby": void 0
  }), x = (S) => {
    s || (c == null || c(S), g(S));
  }, w = useMemo$1(() => getAutoCompleteProps({ autoComplete: v }), [v]);
  return {
    ...y,
    onClick: x,
    ...w
  };
}, useOptions = ({
  options: r,
  filterOptions: a,
  query: s,
  shouldShowPresetOptions: c
}) => {
  const u = checkHasSections$1(r), d = useMemo$1(
    () => u ? getOptionsWithSection(r) : r,
    [u, r]
  ), [h, p] = useState$1(d), [m, g] = useState$1(
    a(h, s)
  );
  useEffect$1(() => {
    g(a(h, s));
  }, [h, s]), useEffect$1(() => {
    p(d);
  }, [d]);
  const v = () => {
    c || p([]);
  };
  return useEffect$1(() => {
    c && m.length === 0 && !s && g(h);
  }, [h, c, m, s]), {
    hasSections: u,
    options: h,
    filteredOptions: m,
    clearOptions: v
  };
}, getstatusMessageParentSelectorElement = (r) => r && document.querySelector(r) || document.body, getStatusElement = ({
  statusMessageParentSelector: r,
  id: a
}) => {
  let s = document.getElementById(a);
  return s || (s = document.createElement("div"), s.setAttribute("data-component", "Search.A11yStatusMessage"), s.setAttribute("id", a), s.setAttribute("data-testid", a), s.setAttribute("role", "status"), s.setAttribute("aria-live", "polite"), s.setAttribute("aria-relevant", "additions text"), Object.assign(s.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), getstatusMessageParentSelectorElement(r).appendChild(s), s);
}, cleanupStatus = lodashExports.debounce(
  ({ statusMessageParentSelector: r, id: a }) => {
    getStatusElement({ statusMessageParentSelector: r, id: a }).textContent = "";
  },
  500
), setStatus = ({
  status: r,
  statusMessageParentSelector: a,
  id: s
}) => {
  getStatusElement({ statusMessageParentSelector: a, id: s }).textContent = r, cleanupStatus({ statusMessageParentSelector: a, id: s });
}, cleanupStatusElement = (r) => {
  var a;
  (a = document.getElementById(r)) == null || a.remove();
}, useSearchA11yStatusMessage = ({
  isOpen: r,
  selectedOptionLabel: a,
  optionsCount: s,
  statusMessageParentSelector: c,
  isLoading: u,
  emptyStateLabel: d
}) => {
  const h = useMemo$1(() => lodashExports.uniqueId("search-a11y-status-message-"), []);
  useEffect$1(() => (getStatusElement({ statusMessageParentSelector: c, id: h }), () => cleanupStatusElement(h)), [c, h]);
  const [p, m] = useState$1("");
  useEffect$1(() => {
    p && (setStatus({ status: p, statusMessageParentSelector: c, id: h }), m(""));
  }, [p, c, h]);
  const { isExtraSmallScreen: g } = useBreakpoint();
  useEffect$1(() => {
    if (!r || s === void 0) return;
    const v = s ? `${s} ${s > 1 ? "results" : "result"} available.${g ? "" : " Use up and down arrow keys to navigate. Press Enter key to select."}` : d ?? "No results available.";
    m(u ? "Loading options." : v);
  }, [r, s, u, d, g]), useEffect$1(() => {
    a && setTimeout(() => m(`${a} has been selected.`), 500);
  }, [a]);
}, useStateReducer$1 = ({
  formatSelectedValue: r,
  hasFilteredOptions: a,
  hasEmptyState: s,
  hasCreatableOption: c,
  shouldOpenMenuOnClick: u,
  shouldShowPresetOptions: d,
  clearSelectedOption: h,
  setQuery: p,
  onInputChange: m,
  isLoading: g
}) => (y, x) => {
  const { type: w, changes: S } = x, {
    ControlledPropUpdatedSelectedItem: M,
    ItemClick: P,
    FunctionOpenMenu: L,
    InputClick: I,
    InputChange: T,
    InputKeyDownArrowDown: E,
    InputKeyDownArrowUp: R,
    InputBlur: A
  } = useCombobox.stateChangeTypes, k = !!S.inputValue, V = S;
  switch (w) {
    case M:
      return {
        ...V,
        isOpen: !1,
        inputValue: S.selectedItem ? r(S.selectedItem) : ""
      };
    case P:
      return p(null), k || h(), {
        ...V,
        inputValue: k && S.selectedItem ? r(S.selectedItem) : ""
      };
    case L:
      return {
        ...V,
        highlightedIndex: 0
      };
    case I:
      return {
        ...V,
        isOpen: d && (a || s || c || u)
      };
    case T:
      return m(S.inputValue ?? ""), {
        ...V,
        isOpen: g || d || a
      };
    case E:
    case R:
      return {
        ...V,
        isOpen: a || s || c
      };
    case A:
      return {
        ...y
      };
    default:
      return V;
  }
}, useSearch = ({
  ref: r,
  clearButtonRef: a,
  value: s,
  formatSelectedValue: c = defaultFormatSelectedValue,
  options: u,
  filterOptions: d,
  shouldShowPresetOptions: h = !1,
  creatableOption: p,
  emptyState: m,
  disableInputClick: g,
  isLoading: v,
  onClick: y,
  onChange: x,
  onInputChange: w,
  onKeyDown: S,
  onBlur: M,
  onSearchTermReset: P,
  onClear: L,
  id: I,
  statusMessageParentSelector: T
}) => {
  const [E, R] = useState$1(), { hasSections: A, options: k, filteredOptions: V, clearOptions: B } = useOptions({
    options: u,
    filterOptions: d,
    query: E,
    shouldShowPresetOptions: h
  }), [q, z] = useState$1(null);
  useEffect$1(() => {
    if (q || lodashExports.isNil(s) || v) return;
    const ne = { label: s, value: s }, se = k.find((de) => lodashExports.isEqual(de.value, s));
    z(se || ne);
  }, [v, k, q, s]);
  const Z = (ne) => {
    x == null || x({ target: { value: ne } });
  }, G = () => {
    z(null), Z(null);
  }, K = (ne) => {
    w == null || w(ne), R(ne);
  }, { shouldShowCreatableOption: U, setShouldShowCreatableOption: F, newOption: N } = useCreatableOption({
    query: E,
    options: k,
    creatableOption: p
  }), D = useStateReducer$1({
    formatSelectedValue: c,
    hasFilteredOptions: !!V.length,
    hasEmptyState: !!m,
    hasCreatableOption: U,
    shouldOpenMenuOnClick: !s && !!k.length,
    shouldShowPresetOptions: h,
    clearSelectedOption: G,
    setQuery: R,
    onInputChange: K,
    isLoading: v
  }), [j, H] = useState$1(-1), W = () => H(-1), {
    isOpen: re,
    getMenuProps: ae,
    getInputProps: ee,
    getItemProps: X,
    highlightedIndex: J,
    inputValue: ie,
    setInputValue: oe,
    openMenu: fe,
    closeMenu: ve,
    selectItem: ue
  } = useCombobox({
    defaultHighlightedIndex: 0,
    inputId: I,
    // Make sure the new creatable option is available for keyboard navigation.
    items: [...V, ...U && N ? [N] : []],
    itemToString: (ne) => ne ? c(ne) : "",
    selectedItem: q,
    onSelectedItemChange: ({ selectedItem: ne }) => {
      var se;
      z(ne), N && ne === N && (F(!1), (se = p == null ? void 0 : p.onClick) == null || se.call(p, E ?? "")), ne && ne !== N && Z(ne.value);
    },
    onHighlightedIndexChange: ({ type: ne, highlightedIndex: se = -1 }) => {
      switch (ne) {
        case useCombobox.stateChangeTypes.InputChange:
        case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
          H(se);
          break;
        case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
          H(j < 0 && 0 || se);
          break;
        default:
          W();
          break;
      }
    },
    onIsOpenChange: ({ isOpen: ne, highlightedIndex: se = -1 }) => {
      ne && H(se);
    },
    stateReducer: D
  });
  useSearchA11yStatusMessage({
    selectedOptionLabel: isMobileDevice() ? q == null ? void 0 : q.label : "",
    isOpen: re,
    isLoading: v,
    optionsCount: V.length,
    emptyStateLabel: m == null ? void 0 : m.label,
    statusMessageParentSelector: T
  }), useUpdateEffect$1(() => {
    if (!s || v) return;
    const ne = k.find((se) => lodashExports.isEqual(se.value, s));
    ne && (oe(c(ne)), ue(ne));
  }, [s]), useUpdateEffect$1(() => {
    s || (oe(""), ue(null), R(null));
  }, [s]), useEffect$1(() => {
    E === null && (P == null || P());
  }, [E, P]);
  const pe = (ne) => {
    (a == null ? void 0 : a.current) && ne.relatedTarget === (a == null ? void 0 : a.current) || (ie || R(null), ie || G()), M == null || M(ne);
  }, we = () => {
    ue(null), z(null), Z(null), R(null), B(), L == null || L();
  }, { dropdownMenuProps: ye, anchorRef: Ie } = useDropdownMenuProps({
    isOpen: re,
    shouldShowCreatableOption: U,
    getMenuProps: ae,
    hasSections: A,
    options: V,
    emptyState: m,
    closeMenu: ve
  }), Ee = useInputProps({
    ref: r,
    getInputProps: ee,
    onClick: y,
    onKeyDown: S,
    onBlur: pe,
    disableClick: g,
    closeMenu: ve,
    isLoading: v
  });
  return {
    anchorRef: Ie,
    dropdownMenuProps: ye,
    inputProps: Ee,
    hasSections: A,
    openMenu: fe,
    closeMenu: ve,
    clearSelect: we,
    getOptionProps: getOptionPropsHelper({
      getItemProps: X,
      highlightedIndex: J,
      focusedIndex: j,
      getTestId: useTestId("base-select"),
      // resets the focusedIndex when the leave the focused item (covers an use case when the user uses the mouse and the keyboard to navigate the options)
      resetFocusedIndex: W,
      selectedOption: q
    }),
    inputValue: ie,
    selectedOption: q,
    filteredOptions: V
  };
}, useStateReducer = ({
  formatSelectedValue: r,
  hasFilteredOptions: a,
  hasEmptyState: s,
  hasCreatableOption: c,
  shouldOpenMenuOnClick: u,
  clearSelectedOption: d,
  setQuery: h,
  onInputChange: p
}) => (g, v) => {
  const { type: y, changes: x } = v, {
    ControlledPropUpdatedSelectedItem: w,
    InputBlur: S,
    InputKeyDownEscape: M,
    ToggleButtonClick: P,
    FunctionOpenMenu: L,
    FunctionCloseMenu: I,
    InputClick: T,
    InputChange: E,
    InputKeyDownArrowDown: R,
    InputKeyDownArrowUp: A
  } = useCombobox.stateChangeTypes, k = !!x.inputValue, V = x;
  switch (y) {
    case w:
      return {
        ...V,
        isOpen: !1,
        inputValue: x.selectedItem ? r(x.selectedItem) : ""
      };
    case S:
    case M:
    case I:
      return h(null), k || d(), {
        ...V,
        inputValue: k && x.selectedItem ? r(x.selectedItem) : ""
      };
    case P:
      return {
        ...V,
        isOpen: !!x.isOpen && (a || s)
      };
    case L:
      return {
        ...V,
        highlightedIndex: 0
      };
    case T:
      return {
        ...V,
        isOpen: a || s || c || u
      };
    case E:
      return p(x.inputValue ?? ""), {
        ...V,
        isOpen: k || a
      };
    case R:
    case A:
      return {
        ...V,
        isOpen: a || s && !c || c
      };
    default:
      return V;
  }
}, useSelect = ({
  ref: r,
  value: a,
  formatSelectedValue: s = defaultFormatSelectedValue,
  options: c,
  filterOptions: u,
  shouldShowPresetOptions: d = !1,
  creatableOption: h,
  emptyState: p,
  disableInputClick: m,
  onClick: g,
  onChange: v,
  onInputChange: y,
  onKeyDown: x,
  onSearchTermReset: w
}) => {
  const [S, M] = useState$1(), { hasSections: P, options: L, filteredOptions: I } = useOptions({
    options: c,
    filterOptions: u,
    query: S,
    shouldShowPresetOptions: d
  }), [T, E] = useState$1(null);
  useEffect$1(() => {
    if (T || lodashExports.isNil(a) || !L.length) return;
    const fe = null, ve = L.find((ue) => lodashExports.isEqual(ue.value, a));
    E(ve || fe);
  }, [L, T, a]);
  const R = (fe) => {
    v == null || v({ target: { value: fe } });
  }, A = () => {
    E(null), R(null);
  }, k = (fe) => {
    y == null || y(fe), M(fe);
  }, { shouldShowCreatableOption: V, setShouldShowCreatableOption: B, newOption: q } = useCreatableOption({
    query: S,
    options: L,
    creatableOption: h
  }), z = useStateReducer({
    formatSelectedValue: s,
    hasFilteredOptions: !!I.length,
    hasEmptyState: !!p,
    hasCreatableOption: V,
    shouldOpenMenuOnClick: !a && !!L.length,
    clearSelectedOption: A,
    setQuery: M,
    onInputChange: k
  }), [Z, G] = useState$1(-1), K = () => G(-1), U = useGetStatusMessage({
    optionsCount: I.length,
    emptyStateLabel: p == null ? void 0 : p.label
  }), {
    isOpen: F,
    getMenuProps: N,
    getInputProps: D,
    getItemProps: j,
    getToggleButtonProps: H,
    highlightedIndex: W,
    inputValue: re,
    setInputValue: ae,
    closeMenu: ee,
    selectItem: X
  } = useCombobox({
    getA11yStatusMessage: ({ isOpen: fe }) => U(fe),
    defaultHighlightedIndex: 0,
    // Make sure the new creatable option is available for keyboard navigation.
    items: [...I, ...V && q ? [q] : []],
    itemToString: (fe) => fe ? s(fe) : "",
    selectedItem: T,
    onSelectedItemChange: ({ selectedItem: fe }) => {
      var ve;
      E(fe), M(null), q && fe === q && (B(!1), (ve = h == null ? void 0 : h.onClick) == null || ve.call(h, S ?? "")), fe && fe !== q && R(fe.value);
    },
    onHighlightedIndexChange: ({ type: fe, highlightedIndex: ve = -1 }) => {
      switch (fe) {
        case useCombobox.stateChangeTypes.InputChange:
        case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
          G(ve);
          break;
        case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
          G(Z < 0 && 0 || ve);
          break;
        default:
          K();
          break;
      }
    },
    onIsOpenChange: ({ isOpen: fe, highlightedIndex: ve = -1 }) => {
      fe && G(ve);
    },
    stateReducer: z
  });
  useEffect$1(() => {
    a || (ae(""), X(null), M(null));
  }, [a]), useEffect$1(() => {
    S === null && (w == null || w());
  }, [S, w]);
  const { dropdownMenuProps: J, anchorRef: ie } = useDropdownMenuProps({
    isOpen: F,
    shouldShowCreatableOption: V,
    getMenuProps: N,
    hasSections: P,
    options: I,
    emptyState: p,
    closeMenu: ee
  }), oe = useInputProps({
    ref: r,
    getInputProps: D,
    onClick: g,
    onKeyDown: x,
    disableClick: m,
    closeMenu: ee
  });
  return {
    anchorRef: ie,
    dropdownMenuProps: J,
    inputProps: oe,
    isOpen: F,
    hasSections: P,
    getToggleButtonProps: H,
    getOptionProps: getOptionPropsHelper({
      getItemProps: j,
      highlightedIndex: W,
      focusedIndex: Z,
      getTestId: useTestId("base-select"),
      // resets the focusedIndex when the leave the focused item (covers an use case when the user uses the mouse and the keyboard to navigate the options)
      resetFocusedIndex: K,
      selectedOption: T
    }),
    inputValue: re,
    selectedOption: T,
    filteredOptions: I
  };
}, BaseSelect = Object.assign(BaseSelect$1, components$1), AccordionItem = forwardRef$1(
  ({ children: r, content: a, title: s, index: c, ...u }, d) => {
    const h = useMultiStyleConfig("Accordion", {});
    return /* @__PURE__ */ jsx(AccordionItem$1, { "data-component": "AccordionItem", ...u, ref: d, "data-testid": `accordion-item-${c}`, children: ({ isExpanded: p }) => /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(AccordionButton, { __css: h.button, "data-testid": `accordion-button-${c}`, children: [
        /* @__PURE__ */ jsx(Box, { as: "h2", __css: h.title, "data-testid": `accordion-title-${c}`, children: s }),
        p ? /* @__PURE__ */ jsx(Icon, { size: "small", type: "remove", color: "inherit", "data-testid": `accordion-icon-expanded-${c}` }) : /* @__PURE__ */ jsx(Icon, { size: "small", type: "add", color: "inherit", "data-testid": `accordion-icon-collapsed-${c}` })
      ] }),
      /* @__PURE__ */ jsx(AccordionPanel, { __css: h.panel, "data-testid": `accordion-panel-${c}`, children: r || a })
    ] }) });
  }
);
AccordionItem.displayName = "AccordionItem";
const Accordion = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Accordion", {}), { items: c, ...u } = r;
  return /* @__PURE__ */ jsx(Accordion$1, { "data-component": "Accordion", allowToggle: !0, ...u, __css: s.container, ref: a, children: c.map(({ title: d, ...h }, p) => /* @__PURE__ */ jsx(AccordionItem, { title: d, index: p, ...h }, d)) });
});
Accordion.displayName = "Accordion";
const Card = forwardRef$1(
  ({
    onClick: r,
    isSelected: a = !1,
    isDisabled: s = !1,
    isInactive: c = !1,
    variant: u = "default",
    paddingX: d = "m",
    paddingY: h = "m",
    width: p = "full",
    children: m,
    inputProps: g,
    "data-testid": v = "card",
    ...y
  }, x) => {
    const w = useTestId(v), S = !!r, M = S && !s && !c, P = useMultiStyleConfig("Card", { paddingX: d, paddingY: h, width: p, variant: u, hasClickHandler: S }), L = (R) => {
      M && (r == null || r(R));
    }, [I, T] = useState$1(!1), E = useMemo$1(() => S ? lodashExports.uniqueId("card-") : void 0, [S]);
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "Card",
        ref: x,
        __css: P.container,
        ...w(),
        ...y,
        id: E,
        onClick: L,
        "data-selected": a || null,
        "data-inactive": c || null,
        "data-disabled": s || null,
        "data-focus": I || null,
        children: [
          S && /* @__PURE__ */ jsx(
            Box,
            {
              as: "input",
              type: "button",
              __css: P.input,
              ...g,
              "aria-labelledby": E,
              "aria-disabled": !M,
              ...w("input"),
              ...M && {
                onFocus: (R) => {
                  var A;
                  T(!0), (A = g == null ? void 0 : g.onFocus) == null || A.call(g, R);
                },
                onBlur: (R) => {
                  var A;
                  T(!1), (A = g == null ? void 0 : g.onBlur) == null || A.call(g, R);
                },
                onKeyDown: (R) => {
                  var k;
                  const { code: A } = R;
                  (A === "Space" || A === "Enter") && (R.preventDefault(), L(R)), (k = g == null ? void 0 : g.onKeyDown) == null || k.call(g, R);
                }
              }
            }
          ),
          m
        ]
      }
    );
  }
);
Card.displayName = "Card";
const CollapsibleCardComponent = (r, a) => {
  const {
    title: s,
    description: c,
    header: u,
    children: d,
    isDisabled: h = !1,
    isInactive: p = !1,
    status: m,
    onClick: g,
    defaultIsExpanded: v = !1,
    isExpanded: y,
    onExpandChange: x,
    "data-testid": w = "collapsible-card",
    ...S
  } = r, M = useMultiStyleConfig("CollapsibleCard", {}), P = useRef$1(null), [L, I] = useState$1(!!(v || y)), T = y !== void 0, E = useTestId(w), R = useRef$1(null), A = useCallback$1(
    (k) => {
      var q;
      const V = k.target === R.current;
      if (k.target === P.current || (q = P.current) != null && q.contains(k.target) || // This is to handle the case when the user use the keyboard to navigate and press enter or space
      V) {
        const z = !L;
        if (x == null || x(z), g == null || g(k), T) return;
        I(z);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [L]
  );
  return useEffect$1(() => {
    T && I(y);
  }, [T, y, L]), /* @__PURE__ */ jsx(
    Card,
    {
      "data-component": "CollapsibleCard",
      ref: a,
      inputProps: {
        ref: R,
        "aria-expanded": L
      },
      paddingX: "none",
      paddingY: "none",
      onClick: A,
      isDisabled: h,
      isInactive: p,
      ...E(),
      ...S,
      children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "none", width: "full", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            ref: P,
            __css: M.header,
            "data-inactive": p || null,
            "aria-disabled": h || void 0,
            ...E("header"),
            "data-state": L ? "expanded" : "collapsed",
            children: u ? /* @__PURE__ */ jsx(
              Box,
              {
                __css: M.customHeader,
                "data-inactive": p || null,
                "aria-disabled": h || void 0,
                children: u
              }
            ) : /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "xxs", width: "full", children: [
              /* @__PURE__ */ jsxs(Group, { spacing: "xxs", alignItems: "center", justifyContent: "space-between", children: [
                /* @__PURE__ */ jsxs(Group, { spacing: "xs", alignItems: "center", children: [
                  /* @__PURE__ */ jsx(Text, { as: "h2", textStyle: "heading3Semi", color: "inherit", children: s }),
                  m && /* @__PURE__ */ jsx(StatusIconSolid, { variant: m, size: "medium", isReadOnly: p, isDisabled: h })
                ] }),
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    type: L ? "chevron-up" : "chevron-down",
                    size: "large",
                    color: "inherit",
                    "aria-hidden": "true"
                  }
                )
              ] }),
              c && /* @__PURE__ */ jsx(Typography.Description, { label: c, isReadOnly: p, isDisabled: h })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(Collapse, { ...E("collapse"), in: L, children: /* @__PURE__ */ jsxs(Box, { __css: M.content, children: [
          /* @__PURE__ */ jsx(Divider, {}),
          d
        ] }) })
      ] })
    }
  );
}, CollapsibleCard = forwardRef$1(CollapsibleCardComponent);
CollapsibleCard.displayName = "CollapsibleCard";
const SelectableItem = forwardRef$1(
  ({ disabled: r, icon: a, image: s, isSelected: c, ...u }, d) => {
    const { isExtraSmallScreen: h } = useBreakpoint(), p = a ? isBrandSymbol$1(a) ? /* @__PURE__ */ jsx(BrandSymbol, { type: a, size: h ? "medium" : "small", isDisabled: r == null ? void 0 : r.isDisabled }) : /* @__PURE__ */ jsx(Icon, { type: a, size: h ? "large" : "small", color: "inherit", isDisabled: r == null ? void 0 : r.isDisabled }) : s && /* @__PURE__ */ jsx(Image$1, { aspectRatio: "1 / 1", width: h ? "20px" : "16px", src: s.src, alt: s.alt });
    return /* @__PURE__ */ jsx(
      MenuItem,
      {
        "data-component": "Menu.SelectableItem",
        ...u,
        textStyle: "body3Semi",
        leftElement: p,
        disabled: r,
        isSelected: c,
        ref: d
      }
    );
  }
);
SelectableItem.displayName = "Menu.SelectableItem";
const SelectableDropdownMenu = forwardRef$1(
  ({ items: r, selectedItemValue: a, onSelect: s, footer: c, ...u }, d) => {
    const { isExtraSmallScreen: h } = useBreakpoint(), p = c && ((c == null ? void 0 : c.type) === "button" ? /* @__PURE__ */ jsx(
      Button,
      {
        label: c.label,
        isDisabled: c.isDisabled,
        variant: "tertiary",
        isFullWidth: !0,
        size: h ? "large" : "medium"
      }
    ) : /* @__PURE__ */ jsx(NakedButton, { label: c.label, isDisabled: c.isDisabled, variant: c.variant ?? "secondary" }));
    return /* @__PURE__ */ jsx(
      Menu,
      {
        dropdownTestId: "selectable-dropdown-menu",
        "data-component": "SelectableDropdownMenu",
        ...u,
        footer: c && { ...c, children: p },
        ref: d,
        children: r == null ? void 0 : r.map((m, g) => {
          const { dataTestId: v, label: y, value: x, onClick: w, ...S } = m;
          return /* @__PURE__ */ createElement$1(
            SelectableItem,
            {
              "data-testid": v ?? `selectable-dropdown-menu-item-${x}`,
              ...S,
              label: y,
              value: x,
              key: `${y}-${g}`,
              isSelected: a === m.value,
              onClick: () => {
                w == null || w(), s == null || s(m);
              }
            }
          );
        })
      }
    );
  }
);
SelectableDropdownMenu.displayName = "SelectableDropdownMenu";
const SortItem = forwardRef$1(
  ({ label: r, disabled: a, onClick: s, sortDirection: c = "none", ...u }, d) => {
    const h = c === "asc" ? "arrow-up" : c === "desc" ? "arrow-down" : void 0, p = h ? c === "asc" ? "ascending" : "descending" : "";
    return /* @__PURE__ */ jsx(
      MenuItem,
      {
        "data-component": "Menu.SortItem",
        rightElement: h && /* @__PURE__ */ jsx(Icon, { size: "small", type: h, color: "inherit" }),
        ...u,
        textStyle: "body3Semi",
        onClick: a != null && a.isDisabled ? void 0 : s,
        disabled: a,
        label: r,
        "aria-label": `${r} ${p}`,
        "aria-disabled": a == null ? void 0 : a.isDisabled,
        ref: d
      }
    );
  }
);
SortItem.displayName = "Menu.SortItem";
const SortDropdownMenu = forwardRef$1(
  ({ items: r, selectedItemIndex: a, sortDirection: s, trigger: c, ...u }, d) => {
    const h = cloneElement(c, { "data-component": "SortDropdownMenu" });
    return /* @__PURE__ */ jsx(
      Menu,
      {
        "data-component": "SortDropdownMenu",
        "data-testid": "sort-dropdown-menu",
        ...u,
        trigger: h,
        ref: d,
        children: r.map(({ dataTestId: p, onClick: m, ...g }, v) => /* @__PURE__ */ createElement$1(
          SortItem,
          {
            ...g,
            "data-testid": p ?? `sort-dropdown-menu-item-${v}`,
            sortDirection: a === v ? s : "none",
            onClick: () => m == null ? void 0 : m(v),
            key: v
          }
        ))
      }
    );
  }
);
SortDropdownMenu.displayName = "SortDropdownMenu";
const SelectionCardImageIcon = ({ image: r, icon: a, isDisabled: s }) => {
  const [c, u] = useState$1(!1), d = () => {
    u(!0);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    r && (c && r.fallbackIcon ? /* @__PURE__ */ jsx(
      _BaseIcon,
      {
        type: r.fallbackIcon,
        size: "medium",
        color: "semantic.icon.primary",
        role: "img",
        "aria-label": r.alt,
        isDisabled: s,
        "data-testid": "fallback-icon"
      }
    ) : /* @__PURE__ */ jsx(
      Image$1,
      {
        src: r.src,
        alt: r.alt,
        onError: d,
        width: "24px",
        height: "24px",
        isDisabled: s
      }
    )),
    a && /* @__PURE__ */ jsx(Fragment, { children: isBrandSymbol$1(a) ? /* @__PURE__ */ jsx(BrandSymbol, { type: a, isDisabled: s, "data-testid": "card-brand-symbol" }) : /* @__PURE__ */ jsx(Icon, { type: a, isDisabled: s }) })
  ] });
}, SelectionCard = forwardRef$1(
  ({
    labelProps: r,
    descriptionProps: a,
    mainLabelProps: s,
    icon: c,
    image: u,
    isDisabled: d = !1,
    isSelected: h = !1,
    onClick: p,
    action: m,
    menuActions: g,
    ...v
  }, y) => {
    const [x, w] = useState$1(!1), S = x ? "Expanded Selection Card Actions" : "Collapsed Selection Card Actions", M = m && /* @__PURE__ */ jsx(
      NakedButton,
      {
        variant: "secondary",
        size: "medium",
        onClick: (I) => {
          I.stopPropagation(), m.onClick(I);
        },
        "data-testid": v["data-testid"] ? `${v["data-testid"]}-action` : "selection-card-action",
        label: m.label
      }
    ), P = g == null ? void 0 : g.items.map((I) => ({
      ...I,
      onClick: () => {
        var T;
        (T = I.onClick) == null || T.call(I), w(!1);
      }
    })), L = g && /* @__PURE__ */ jsx(
      ActionsDropdownMenu,
      {
        isOpen: x,
        onOpenChange: w,
        items: P ?? [],
        label: "Selection Card Actions",
        size: "small",
        triggerAriaLabel: g.triggerAriaLabel || S
      }
    );
    return /* @__PURE__ */ jsx(
      Card,
      {
        "data-component": "SelectionCard",
        ref: y,
        ...v,
        isSelected: h,
        isDisabled: d,
        onClick: p,
        children: /* @__PURE__ */ jsxs(Group, { width: "full", children: [
          (u || c) && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: /* @__PURE__ */ jsx(Container, { width: "fit-content", alignItems: "center", height: "full", children: /* @__PURE__ */ jsx(SelectionCardImageIcon, { icon: c, image: u, isDisabled: d }) }) }),
          /* @__PURE__ */ jsx(Container, { height: "full", alignItems: "flex-start", children: /* @__PURE__ */ jsx(
            ListItem,
            {
              labelProps: r,
              descriptionProps: a,
              mainLabelProps: {
                ...s,
                variant: "bold"
              },
              isDisabled: d
            }
          ) }),
          !d && (M || L) && /* @__PURE__ */ jsx(Group.Item, { shrink: 0, children: /* @__PURE__ */ jsx(Container, { height: "full", alignItems: "flex-start", overflow: "initial", children: M || L }) })
        ] })
      }
    );
  }
);
SelectionCard.displayName = "SelectionCard";
const SimpleSelectionCard = forwardRef$1(
  ({ mainLabelProps: r, icon: a, image: s, isDisabled: c = !1, isSelected: u = !1, onClick: d, ...h }, p) => /* @__PURE__ */ jsx(
    Card,
    {
      "data-component": "SimpleSelectionCard",
      ref: p,
      ...h,
      isSelected: u,
      isDisabled: c,
      onClick: d,
      children: /* @__PURE__ */ jsxs(Group, { width: "full", justifyContent: "center", children: [
        /* @__PURE__ */ jsx(SelectionCardImageIcon, { icon: a, image: s, isDisabled: c }),
        /* @__PURE__ */ jsx(
          ListItem,
          {
            mainLabelProps: {
              ...r,
              variant: "bold"
            },
            isDisabled: c
          }
        )
      ] })
    }
  )
);
SimpleSelectionCard.displayName = "SimpleSelectionCard";
const VerticalSelectionCard = forwardRef$1(
  ({ descriptionProps: r, mainLabelProps: a, icon: s, image: c, isDisabled: u = !1, isSelected: d = !1, onClick: h, ...p }, m) => /* @__PURE__ */ jsx(
    Card,
    {
      "data-component": "VerticalSelectionCard",
      ref: m,
      ...p,
      isSelected: d,
      isDisabled: u,
      onClick: h,
      children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", width: "full", alignItems: "center", children: [
        /* @__PURE__ */ jsx(SelectionCardImageIcon, { icon: s, image: c, isDisabled: u }),
        /* @__PURE__ */ jsx(
          ListItem,
          {
            descriptionProps: r,
            mainLabelProps: {
              ...a,
              variant: "bold"
            },
            isDisabled: u,
            textAlign: "center"
          }
        )
      ] })
    }
  )
);
VerticalSelectionCard.displayName = "VerticalSelectionCard";
const Collapsible = forwardRef$1(
  ({ label: r, secondaryLabel: a, defaultIsExpanded: s = !1, labelView: c = "default", children: u, ...d }, h) => {
    const p = useMultiStyleConfig("Collapsible", {}), [m, g] = useState$1(s);
    return /* @__PURE__ */ jsx(Box, { "data-component": "Collapsible", ref: h, ...d, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "s", children: [
      /* @__PURE__ */ jsxs(Box, { __css: p.header, children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            __css: p.labelAndIcon,
            onClick: () => g((v) => !v),
            "data-full-view": c === "full" && !a,
            as: "button",
            type: "button",
            "data-testid": "collapse-trigger",
            "aria-expanded": m,
            children: [
              /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: r }),
              /* @__PURE__ */ jsx(Icon, { type: m ? "chevron-up" : "chevron-down", size: "small", color: "inherit" })
            ]
          }
        ),
        m && a && /* @__PURE__ */ jsx(Box, { __css: p.secondaryLabel, children: /* @__PURE__ */ jsx(Text, { textStyle: "inline", color: "inherit", shouldSupportEllipsis: !0, children: a }) })
      ] }),
      /* @__PURE__ */ jsx(Collapse, { "data-testid": "collapse", in: m, children: u })
    ] }) });
  }
);
Collapsible.displayName = "Collapsible";
const DrawerContext = createContext$1(null), useDrawerContext = () => {
  const r = useContext$1(DrawerContext);
  if (r === null)
    throw new Error("Drawer components must be wrapped in <Drawer />");
  return r;
}, DrawerBody = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Drawer", {}), { setDescriptionId: c, getTestId: u } = useDrawerContext(), d = useId$1();
  return useLayoutEffect$1(() => (c(d), () => c(void 0)), [d, c]), /* @__PURE__ */ jsx(
    Box,
    {
      as: "section",
      "data-component": "DrawerBody",
      __css: s.body,
      ref: a,
      ...u("body"),
      ...r,
      id: d
    }
  );
});
DrawerBody.displayName = "DrawerBody";
const DrawerCloseButton = forwardRef$1((r, a) => {
  const { onClose: s, closeButtonAriaLabel: c, getTestId: u } = useDrawerContext();
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      "data-component": "DrawerCloseButton",
      ref: a,
      "aria-label": c,
      icon: "close",
      onClick: s,
      ...u("close-button"),
      ...r
    }
  );
});
DrawerCloseButton.displayName = "DrawerCloseButton";
function useDrawer({
  isOpen: r,
  onClose: a,
  onCloseComplete: s,
  size: c = "m",
  shouldReturnFocus: u,
  shouldRestoreFocus: d,
  "data-testid": h = "drawer",
  closeButtonAriaLabel: p = "Close drawer"
}) {
  const m = useTestId(h), [g, v] = useState$1(), [y, x] = useState$1(), w = useDelayUnmount({ isOpen: r }), S = useFloating({ open: r, onOpenChange: a }), M = S.context, P = useDismiss(M, { outsidePress: !1 }), L = useRole(M), I = useInteractions([P, L]);
  return useMemo$1(
    () => ({
      shouldReturnFocus: u,
      shouldRestoreFocus: d,
      isOpen: r,
      isMounted: w,
      onClose: a,
      onCloseComplete: s,
      closeButtonAriaLabel: p,
      getTestId: m,
      size: c,
      ...I,
      ...S,
      labelId: g,
      descriptionId: y,
      setLabelId: v,
      setDescriptionId: x
    }),
    [
      u,
      d,
      p,
      S,
      y,
      m,
      I,
      w,
      r,
      g,
      a,
      s,
      c
    ]
  );
}
const DrawerBreakpointSizesMap = {
  s: { xs: "100vw", s: "320px", m: "480px" },
  m: { xs: "100vw", s: "708px" },
  l: { xs: "100vw", s: "812px", m: "1000px", l: "1216px" }
}, checkSizeType = (r) => r === "s" || r === "m" || r === "l", useDrawerSize = (r) => {
  const a = checkSizeType(r) ? DrawerBreakpointSizesMap[r] : r, s = useCustomSize(a);
  return typeof s == "number" ? `${s}px` : s;
}, DrawerContent = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Drawer", {}), {
    context: c,
    isOpen: u,
    isMounted: d,
    onClose: h,
    onCloseComplete: p,
    getFloatingProps: m,
    refs: g,
    labelId: v,
    descriptionId: y,
    getTestId: x,
    shouldReturnFocus: w,
    shouldRestoreFocus: S,
    size: M
  } = useDrawerContext(), P = useRef$1(null), L = useMergeRefs([g.setFloating, a, P]), I = useDrawerSize(M), T = useCallback$1(
    (E) => {
      E !== "enter" && (p == null || p());
    },
    [p]
  );
  return useHideFromSR({
    ignoreEl: P.current,
    enable: u
  }), /* @__PURE__ */ jsx(Fragment, { children: d && /* @__PURE__ */ jsxs(Portal, { children: [
    /* @__PURE__ */ jsx(Blanket, { isOpen: u, isFullScreen: !0, ...x("overlay"), onClick: h }),
    /* @__PURE__ */ jsx(FloatingFocusManager, { context: c, returnFocus: w, restoreFocus: S, children: /* @__PURE__ */ jsx(
      Slide,
      {
        direction: "right",
        in: u,
        style: {
          zIndex: zIndices.modal,
          width: "100%",
          maxWidth: I
        },
        onAnimationComplete: T,
        transition: {
          enter: { duration: 0.3 },
          exit: { duration: 0.3 }
        },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            __css: s.content,
            ref: L,
            "aria-labelledby": v,
            "aria-describedby": y,
            "aria-modal": !0,
            ...x(),
            ...m(r)
          }
        )
      }
    ) })
  ] }) });
});
DrawerContent.displayName = "DrawerContent";
const DrawerFooter = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Drawer", {}), { getTestId: c } = useDrawerContext();
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "footer",
      "data-component": "DrawerFooter",
      __css: s.footer,
      ref: a,
      ...c("footer"),
      ...r
    }
  );
});
DrawerFooter.displayName = "DrawerFooter";
const DrawerHeader = forwardRef$1((r, a) => {
  const s = useMultiStyleConfig("Drawer", {}), { setLabelId: c, getTestId: u } = useDrawerContext(), d = useId$1();
  return useLayoutEffect$1(() => (c(d), () => c(void 0)), [d, c]), /* @__PURE__ */ jsx(
    Box,
    {
      as: "header",
      "data-component": "DrawerHeader",
      __css: s.header,
      ref: a,
      ...u("header"),
      ...r,
      id: d
    }
  );
});
DrawerHeader.displayName = "DrawerHeader";
const Drawer = forwardRef$1(
  ({
    isOpen: r,
    onClose: a,
    onCloseComplete: s,
    "data-testid": c,
    closeButtonAriaLabel: u,
    header: d,
    body: h,
    footer: p,
    isLoading: m,
    closeButtonAriaLabelledBy: g,
    shouldReturnFocus: v,
    shouldRestoreFocus: y,
    size: x,
    ...w
  }, S) => {
    const M = useMemo$1(() => lodashExports.uniqueId("loader-"), []), P = useMemo$1(() => {
      const L = [m ? M : void 0, g].filter((I) => !!I).join(" ");
      return L ? { "aria-labelledby": L } : {};
    }, [g, m, M]);
    return /* @__PURE__ */ jsx(
      DrawerContext.Provider,
      {
        value: useDrawer({
          isOpen: r,
          onClose: a,
          onCloseComplete: s,
          "data-testid": c,
          closeButtonAriaLabel: u,
          shouldReturnFocus: v,
          shouldRestoreFocus: y,
          size: x
        }),
        children: /* @__PURE__ */ jsxs(
          DrawerContent,
          {
            "data-component": "Drawer",
            ref: S,
            ...w,
            "aria-describedby": void 0,
            "aria-labelledby": void 0,
            children: [
              /* @__PURE__ */ jsxs(DrawerHeader, { "data-component": "DrawerHeader", children: [
                /* @__PURE__ */ jsx(
                  DrawerCloseButton,
                  {
                    "data-component": "DrawerCloseButton",
                    ...P
                  }
                ),
                /* @__PURE__ */ jsx(Container, { width: "full", children: d })
              ] }),
              /* @__PURE__ */ jsx(Divider, {}),
              m ? /* @__PURE__ */ jsx(LoadingContainer, { isLoading: !0, id: M }) : /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(DrawerBody, { "data-component": "DrawerBody", children: h }),
                p && /* @__PURE__ */ jsx(DrawerFooter, { "data-component": "DrawerFooter", children: p })
              ] })
            ]
          }
        )
      }
    );
  }
);
Drawer.displayName = "Drawer";
const useRefCallback = (r) => {
  const a = useRef$1(null);
  return useCallback$1(
    (s) => {
      a.current && (a.current(), a.current = null), s && (a.current = r(s));
    },
    [r]
  );
}, useActiveElementIndex = () => {
  const [r, a] = useState$1(0), s = useRefCallback(
    useCallback$1((u) => {
      function d(h) {
        const m = (u ? tabbable(u) : []).findIndex((g) => g === h.target);
        a(m);
      }
      return u == null || u.addEventListener("focusin", d), () => {
        u == null || u.removeEventListener("focusin", d);
      };
    }, [])
  );
  return { activeElementIndex: r, setActiveElementRef: s, resetActiveElementIndex: () => {
    a(0);
  } };
}, DesktopModalContext = createContext$1({
  setIsBodyMounted: void 0
}), useDesktopModalContext = () => useContext$1(DesktopModalContext), BaseModalBody = (r) => {
  const a = useRef$1(null), {
    scrollAtBottom: s,
    scrollAtTop: c,
    isOverflowY: u,
    isMounted: d
  } = useScrollBorders({ ref: a }), m = useMultiStyleConfig("BaseModal", {
    showBorderBottom: u && !s,
    showBorderTop: u && !c,
    isBodyOverflowing: u
  }), { isExtraSmallScreen: g } = useBreakpoint(), v = useDesktopModalContext(), y = _useBaseSheetContext();
  useEffect$1(() => {
    var S;
    d && ((S = v == null ? void 0 : v.setIsBodyMounted) == null || S.call(v, !0));
  }, [d, v == null ? void 0 : v.setIsBodyMounted]);
  const w = (g ? y == null ? void 0 : y.isOverflow : u) ? 0 : -1;
  return g ? /* @__PURE__ */ jsx(BottomSheet.Body, { children: /* @__PURE__ */ jsx(Box, { as: "section", __css: m.body, "data-component": "BaseModal.Body", ...r, tabIndex: w }) }) : /* @__PURE__ */ jsx(
    ModalBody,
    {
      sx: m.body,
      "data-component": "BaseModal.Body",
      tabIndex: w,
      ...r,
      ref: a,
      id: void 0
    }
  );
};
BaseModalBody.displayName = "BaseModalBody";
const BaseModalCloseButton = ({ closeButtonAriaLabel: r = "Close modal" }) => {
  const a = useMultiStyleConfig("BaseModal", {}), { onClose: s } = useModalContext();
  return /* @__PURE__ */ jsx(Box, { __css: a.closeButton, children: /* @__PURE__ */ jsx(IconButton, { "data-testid": "modal-close-button", icon: "close", onClick: s, "aria-label": r }) });
};
BaseModalCloseButton.displayName = "BaseModalCloseButton";
const BaseModalFooter = ({ children: r, ...a }) => {
  const s = _useBaseSheetContext(), { isExtraSmallScreen: c } = useBreakpoint();
  let u;
  if (c) {
    const { isOverflow: h, showFooterBorder: p, paddingY: m, paddingX: g } = s;
    u = { isOverflow: h, showFooterBorder: p, paddingY: m, paddingX: g };
  }
  const d = useMultiStyleConfig("BaseModal", { bottomSheetProps: u });
  return r ? c ? /* @__PURE__ */ jsx(Box, { as: "footer", __css: d.footer, "data-component": "BaseModal.Footer", ...a, children: r }) : /* @__PURE__ */ jsx(ModalFooter$1, { sx: d.footer, "data-component": "BaseModal.Footer", ...a, children: r }) : null;
};
BaseModalFooter.displayName = "BaseModalFooter";
const BaseModalHeader = ({ children: r, ...a }) => {
  const { isExtraSmallScreen: s } = useBreakpoint(), c = useMultiStyleConfig("BaseModal", {});
  return r ? s ? /* @__PURE__ */ jsx(Box, { as: "header", __css: c.header, "data-component": "BaseModal.Header", ...a, children: /* @__PURE__ */ jsx(BottomSheet.Header, { children: r }) }) : /* @__PURE__ */ jsx(ModalHeader, { sx: c.header, "data-component": "BaseModal.Header", ...a, children: r }) : null;
};
BaseModalHeader.displayName = "BaseModalHeader";
var ModalEvents = /* @__PURE__ */ ((r) => (r.OPENED = "MODAL_OPENED", r))(ModalEvents || {});
function dispatchModalOpenedEvent() {
  document.dispatchEvent(new Event(
    "MODAL_OPENED"
    /* OPENED */
  ));
}
const useDispatchState = (r) => {
  useEffect$1(() => {
    r && dispatchModalOpenedEvent();
  }, [r]);
}, BaseModal$1 = forwardRef$1(
  ({
    isOpen: r,
    onClose: a,
    size: s = "small",
    children: c,
    isLoading: u,
    closeButtonAriaLabel: d,
    role: h = "dialog",
    "aria-modal": p,
    shouldReturnFocus: m,
    ...g
  }, v) => {
    const { isExtraSmallScreen: y } = useBreakpoint(), { context: x, refs: w } = useFloating({
      open: r
    }), S = useRole(x, { role: h }), M = useDismiss(x), { getFloatingProps: P } = useInteractions([S, M]), [L, I] = useState$1(!1), { activeElementIndex: T, setActiveElementRef: E, resetActiveElementIndex: R } = useActiveElementIndex();
    useEffect$1(() => {
      r || R();
    }, [r]);
    const A = useMultiStyleConfig("BaseModal", {
      size: s,
      isLoading: u
    }), k = useRef$1(null), V = useMergeRefs([v, w.setFloating, E, k]), B = useMergeRefs([v, E]);
    useDispatchState(r);
    const q = P().id;
    return useHideFromSR({
      ignoreEl: k.current,
      enable: r
    }), useEffect$1(() => {
      p === !1 && L && k.current && k.current.removeAttribute("aria-modal");
    }, [L, p]), y ? /* @__PURE__ */ jsx(
      BottomSheet,
      {
        ...g,
        ref: B,
        isOpen: r,
        onClose: a,
        isLoading: u,
        closeButtonAriaLabel: d,
        initialFocus: T,
        children: /* @__PURE__ */ jsx(Box, { __css: A.mobileModalContent, children: c })
      }
    ) : /* @__PURE__ */ jsx(DesktopModalContext.Provider, { value: { setIsBodyMounted: I }, children: /* @__PURE__ */ jsx(Modal$1, { isOpen: r, onClose: a, size: "unset", trapFocus: !1, children: /* @__PURE__ */ jsxs(Portal, { children: [
      /* @__PURE__ */ jsx(Blanket, { isOpen: r, isFullScreen: !0, "data-testid": "base-modal-overlay" }),
      /* @__PURE__ */ jsx(
        FloatingFocusManager,
        {
          context: x,
          initialFocus: T,
          disabled: !L && !u,
          returnFocus: m,
          children: /* @__PURE__ */ jsx(
            ModalContent,
            {
              "data-component": "BaseModal",
              ref: V,
              ...g,
              sx: A.modalContent,
              role: h,
              children: /* @__PURE__ */ jsxs(Box, { __css: A.modalFloatingContent, id: q, children: [
                /* @__PURE__ */ jsx(BaseModalCloseButton, { closeButtonAriaLabel: d }),
                u ? /* @__PURE__ */ jsx(LoadingContainer, { isLoading: !0 }) : c
              ] })
            }
          )
        }
      )
    ] }) }) });
  }
);
BaseModal$1.displayName = "BaseModal";
const baseModalAtoms = {
  Header: BaseModalHeader,
  Body: BaseModalBody,
  Footer: BaseModalFooter
}, BaseModal = Object.assign(BaseModal$1, baseModalAtoms), Button = forwardRef$1((r, a) => {
  const {
    leftElement: s,
    rightElement: c,
    label: u,
    isDisabled: d,
    isLoading: h,
    variant: p = "primary",
    isFullWidth: m,
    children: g,
    link: v,
    loadingText: y,
    hideLoadingText: x,
    "aria-label": w,
    "aria-labelledby": S,
    size: M = "medium",
    ...P
  } = r, L = useMultiStyleConfig("Button", { isLoading: h, isFullWidth: m, leftElement: s, size: M, variant: p }), I = {
    primary: "semantic.text.inverse",
    "primary-inverse": void 0,
    secondary: void 0,
    "secondary-inverse": "semantic.text.inverse",
    tertiary: "semantic.text.primary",
    success: "semantic.text.inverse",
    critical: "semantic.text.inverse",
    "critical-secondary": "semantic.text.critical.hover"
  }, T = useMemo$1(() => lodashExports.uniqueId("loader-"), []), E = getAriaProps("aria-labelledby", [h ? T : void 0, S]), R = getButtonLinkProps({ link: v, isDisabled: d || h });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-component": "Button",
      as: "button",
      type: "button",
      __css: L.container,
      "aria-label": h ? void 0 : w ?? u,
      ...E,
      ...R,
      disabled: d,
      ...P,
      "data-loading": h || null,
      ref: a,
      children: [
        /* @__PURE__ */ jsx(Box, { as: "span", __css: L.label, children: /* @__PURE__ */ jsxs(Group, { spacing: "xs", alignItems: "center", justifyContent: "center", children: [
          s,
          /* @__PURE__ */ jsx(Text, { color: "inherit", textStyle: M === "large" ? "body2Semi" : "body3Semi", children: u }),
          c
        ] }) }),
        h && /* @__PURE__ */ jsx(Box, { as: "span", __css: L.loader, children: /* @__PURE__ */ jsx(
          Loader,
          {
            id: T,
            color: I[p],
            loadingText: y,
            hideLoadingText: x,
            ...isMobileAndroid() || isWindowsOS() ? { "aria-live": "polite" } : void 0
          }
        ) })
      ]
    }
  );
});
Button.displayName = "Button";
const ModalFooter = ({ children: r, primaryButton: a, secondaryButton: s }) => {
  const { isExtraSmallScreen: c } = useBreakpoint(), u = !!a || !!s, d = u && !(a && s), h = /* @__PURE__ */ jsxs(Group, { spacing: "s", variant: "horizontal", justifyContent: d ? "flex-end" : "space-between", children: [
    s && /* @__PURE__ */ jsx(Button, { ...s, "data-testid": "modal-btn-secondary", size: "medium" }),
    a && /* @__PURE__ */ jsx(Button, { ...a, "data-testid": "modal-btn-primary", size: "medium" })
  ] }), p = /* @__PURE__ */ jsxs(Group, { spacing: "s", variant: "horizontal", justifyContent: d ? "flex-end" : "space-between", children: [
    s && /* @__PURE__ */ jsx(Group.Item, { grow: 1, children: /* @__PURE__ */ jsx(Button, { ...s, "data-testid": "modal-btn-secondary", size: "medium", isFullWidth: !0 }) }),
    a && /* @__PURE__ */ jsx(Group.Item, { grow: 1, children: /* @__PURE__ */ jsx(Button, { ...a, "data-testid": "modal-btn-primary", size: "medium", isFullWidth: !0 }) })
  ] });
  return /* @__PURE__ */ jsx(BaseModal.Footer, { children: (u || r) && /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: c ? "s" : "m", children: [
    u && c && p,
    u && !c && h,
    r
  ] }) });
};
ModalFooter.displayName = "ModalFooter";
const Modal = forwardRef$1(
  ({ header: r, primaryButton: a, secondaryButton: s, children: c, footer: u, ...d }, h) => {
    const { isExtraSmallScreen: p } = useBreakpoint(), m = !!u || !!a || !!s;
    let g;
    return typeof r != "string" ? g = r : g = /* @__PURE__ */ jsx(Container, { paddingTop: p ? "none" : "xxs", children: /* @__PURE__ */ jsx(Text, { as: "h2", textStyle: "heading2Semi", "data-testid": "modal-header-text", children: r }) }), /* @__PURE__ */ jsxs(BaseModal, { "data-component": "Modal", ...d, ref: h, children: [
      /* @__PURE__ */ jsx(BaseModal.Header, { children: g }),
      /* @__PURE__ */ jsx(BaseModal.Body, { children: c }),
      m && /* @__PURE__ */ jsx(ModalFooter, { primaryButton: a, secondaryButton: s, children: u })
    ] });
  }
);
Modal.displayName = "Modal";
const PromotionalModalBody = ({ children: r, assetAspectRatio: a, asset: s }) => {
  const c = useStyleConfig("PromotionalModal", { assetAspectRatio: a });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { __css: c, "data-aspect-ratio": a, children: s }),
    r
  ] });
};
PromotionalModalBody.displayName = "PromotionalModalBody";
const PromotionalModal = forwardRef$1(
  ({ header: r, primaryButton: a, secondaryButton: s, children: c, footer: u, asset: d, assetAspectRatio: h = "7 / 3", ...p }, m) => /* @__PURE__ */ jsx(
    Modal,
    {
      header: r,
      footer: u,
      primaryButton: a,
      secondaryButton: s,
      "data-component": "PromotionalModal",
      ...p,
      ref: m,
      children: /* @__PURE__ */ jsx(PromotionalModalBody, { asset: d, assetAspectRatio: h, children: c })
    }
  )
);
PromotionalModal.displayName = "PromotionalModal";
const criticalVariants = ["cancel", "decline", "alert"], StatusModal = forwardRef$1(
  ({ header: r, primaryButton: a, secondaryButton: s, children: c, footer: u, variant: d, ...h }, p) => {
    const m = useBreakpointValue({ xs: "none", s: "xxs" }), g = /* @__PURE__ */ jsx(Container, { paddingTop: m, children: /* @__PURE__ */ jsxs(Group, { spacing: "s", alignItems: "flex-start", children: [
      d && /* @__PURE__ */ jsx(StatusIconSolid, { size: "large", variant: d, "aria-hidden": !0 }),
      /* @__PURE__ */ jsx(Text, { as: "h2", textStyle: "heading2Semi", "data-testid": "modal-header-text", children: r })
    ] }) }), v = !!(d && criticalVariants.includes(d)), y = a ? {
      ...a,
      variant: v ? "critical" : a.variant
    } : void 0;
    return /* @__PURE__ */ jsx(
      Modal,
      {
        header: g,
        footer: u,
        primaryButton: y,
        secondaryButton: s,
        "data-component": "StatusModal",
        ...h,
        ref: p,
        children: c
      }
    );
  }
);
StatusModal.displayName = "StatusModal";
const SideSheet = forwardRef$1((r, a) => /* @__PURE__ */ jsx(_BaseSheet, { "data-component": "SideSheet", ref: a, ...r, placement: "left" }));
SideSheet.displayName = "SideSheet";
const StackedContainerItems = (r) => {
  const { stacksToDisplay: a } = r, { stacksContainerItemsWrapper: s, firstStack: c, secondStack: u } = useMultiStyleConfig("StackedContainer", r), d = a > 0, h = a > 1;
  return /* @__PURE__ */ jsxs(Box, { __css: s, children: [
    d && /* @__PURE__ */ jsx(Box, { __css: c }),
    h && /* @__PURE__ */ jsx(Box, { __css: u })
  ] });
};
StackedContainerItems.displayName = "StackedContainerItems";
const StackedContainer = forwardRef$1(
  ({ border: r = BorderOptions.Regular, paddingX: a = "none", paddingY: s = "none", children: c, stacksToDisplay: u, ...d }, h) => {
    const p = useMultiStyleConfig("StackedContainer", { stacksToDisplay: u, paddingX: a, paddingY: s, border: r });
    return /* @__PURE__ */ jsxs(Box, { "data-component": "StackedContainer", __css: p.wrapper, ref: h, ...d, children: [
      /* @__PURE__ */ jsx(Box, { __css: p.container, children: c }),
      u > 0 && /* @__PURE__ */ jsx(
        StackedContainerItems,
        {
          stacksToDisplay: u,
          paddingX: a,
          paddingY: s,
          border: r,
          ...d
        }
      )
    ] });
  }
);
StackedContainer.displayName = "StackedContainer";
const Panel$1 = forwardRef$1(
  ({
    backgroundColor: r,
    placement: a = "bottom",
    position: s = "sticky",
    children: c,
    paddingX: u,
    paddingY: d,
    transitionConfig: h,
    maxWidth: p,
    width: m,
    ...g
  }, v) => {
    const y = useMultiStyleConfig("Panel", { backgroundColor: r, paddingX: u, paddingY: d, maxWidth: p, width: m }), x = a === "top" || a === "bottom", w = /* @__PURE__ */ jsx(Box, { __css: y.bar, "data-placement": a, children: c });
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: y.container,
        "data-component": "Panel",
        "data-placement": a,
        "data-position": s,
        "aria-hidden": h ? !h.in : void 0,
        "data-testid": "panel",
        ...g,
        ref: v,
        children: h ? /* @__PURE__ */ jsx(
          Slide,
          {
            ...h,
            "data-placement": a,
            style: {
              zIndex: zIndices.docked,
              position: "relative",
              height: x ? "auto" : "100%",
              width: x ? "100%" : "auto"
            },
            direction: a,
            children: w
          }
        ) : w
      }
    );
  }
);
Panel$1.displayName = "Panel";
const LayoutMaxWidthDefault = "1600px", IconButton = forwardRef$1((r, a) => {
  const { icon: s, size: c = "large", isDisabled: u, status: d, badge: h, link: p, variant: m = "primary", ...g } = r, v = useMultiStyleConfig("IconButton", { badge: h, size: c, variant: m }), y = getButtonLinkProps({ link: p, isDisabled: u }), x = {
    small: "small",
    medium: "large",
    large: "large"
  }, w = /* @__PURE__ */ jsxs(
    Box,
    {
      "data-component": "IconButton",
      as: "button",
      type: "button",
      ...y,
      disabled: u,
      "aria-disabled": u,
      ...g,
      __css: v.container,
      ref: a,
      children: [
        /* @__PURE__ */ jsx(Icon, { type: s, size: x[c], color: "inherit", "aria-hidden": !0 }),
        h && /* @__PURE__ */ jsx(Box, { __css: v.badge, "data-testid": "icon-button-badge", children: isBrandSymbol$1(h) ? /* @__PURE__ */ jsx(BrandSymbol, { type: h, size: "extra-small", isDisabled: u }) : /* @__PURE__ */ jsx(
          _BaseIcon,
          {
            type: h,
            size: "extra-small",
            color: iconColorMapping[h === "verified" && "brand" || "default"],
            isDisabled: u
          }
        ) })
      ]
    }
  );
  return d ? /* @__PURE__ */ jsx(StatusIndicator, { status: d, isDisabled: u, children: w }) : w;
});
IconButton.displayName = "IconButton";
const NakedButton = forwardRef$1(
  ({ size: r = "medium", variant: a = "primary", isDisabled: s, label: c, link: u, shouldSupportEllipsis: d = !1, ...h }, p) => {
    const m = useStyleConfig("NakedButton", { size: r, variant: a, shouldSupportEllipsis: d }), g = getButtonLinkProps({ link: u, isDisabled: s }), v = useRef$1(null), y = mergeRefs([v, p]), { hasOverflowX: x } = useHasOverflow(v);
    return /* @__PURE__ */ jsx(Tooltip, { content: c, isEnabled: d && x, children: /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "NakedButton",
        as: "button",
        type: "button",
        __css: m,
        "aria-label": c,
        ...h,
        ...g,
        disabled: s,
        "aria-disabled": s,
        ref: y,
        children: c
      }
    ) });
  }
);
NakedButton.displayName = "NakedButton";
const paddingByBreakpoint = { xs: "s", m: "m", l: "l", xl: "xxl" }, actionComponentNames = [
  Button == null ? void 0 : Button.displayName,
  IconButton == null ? void 0 : IconButton.displayName,
  NakedButton == null ? void 0 : NakedButton.displayName,
  ActionsDropdownMenu == null ? void 0 : ActionsDropdownMenu.displayName
], ActionBar = forwardRef$1(
  ({
    maxWidth: r = LayoutMaxWidthDefault,
    isOpen: a,
    isLoading: s,
    summaryItems: c,
    actions: u,
    backgroundColor: d,
    loadingText: h,
    ...p
  }, m) => {
    const g = useMultiStyleConfig("ActionBar", { backgroundColor: d }), v = useBreakpointValue(paddingByBreakpoint), y = useBreakpointValue({ xs: "vertical", m: "horizontal" }), x = useBreakpointValue({ xs: "none", s: "xs", m: "s" }), w = useBreakpointValue({ xs: null, m: "|" }), S = useBreakpointValue({ xs: "vertical", s: "horizontal" }), M = useBreakpointValue({ xs: "xs", s: "s" });
    return /* @__PURE__ */ jsx(
      Panel$1,
      {
        backgroundColor: d,
        transitionConfig: { in: a },
        "data-component": "ActionBar",
        position: "absolute",
        maxWidth: r,
        width: `calc(100% - ${themeSpaces[v]} * 2)`,
        ...p,
        ref: m,
        children: /* @__PURE__ */ jsx(Box, { __css: g.bar, children: /* @__PURE__ */ jsx(Fragment, { children: s ? /* @__PURE__ */ jsxs(Group, { alignItems: "center", spacing: "s", children: [
          /* @__PURE__ */ jsx(Loader, { color: "semantic.icon.inverse" }),
          h
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Group, { variant: y, spacing: x, children: c == null ? void 0 : c.map(({ label: P, value: L, tooltip: I, testId: T }, E) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
            /* @__PURE__ */ jsxs(
              Group,
              {
                spacing: "xs",
                alignItems: "center",
                "data-testid": T || `action-bar-summary-item-${E}`,
                children: [
                  /* @__PURE__ */ jsx(Box, { __css: g.itemLabel, children: P }),
                  /* @__PURE__ */ jsx(Box, { __css: g.itemValue, children: L }),
                  I && /* @__PURE__ */ jsx(_IconIndicator, { variant: "informative", tooltip: I, isInverse: !0 })
                ]
              },
              `${P}-${E}`
            ),
            E !== c.length - 1 && w
          ] }, P)) }),
          /* @__PURE__ */ jsx(Group, { variant: S, spacing: M, children: u == null ? void 0 : u.map((P, L) => {
            const { displayName: I } = P.component;
            if (!(I && actionComponentNames.includes(I))) return null;
            const T = P.component;
            return /* @__PURE__ */ jsx(
              T,
              {
                ...P.props,
                "data-testid": P.testId || `action-bar-action-${L}`,
                "data-inverse": !0
              },
              `${I}-${L}`
            );
          }) })
        ] }) }) })
      }
    );
  }
);
ActionBar.displayName = "ActionBar";
const FloatingButton = forwardRef$1((r, a) => {
  const { icon: s, isDisabled: c, link: u, ...d } = r, h = useStyleConfig("FloatingButton"), p = getButtonLinkProps({ link: u, isDisabled: c });
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-component": "FloatingButton",
      as: "button",
      type: "button",
      ...d,
      ...p,
      disabled: c,
      __css: h,
      ref: a,
      children: /* @__PURE__ */ jsx(Icon, { type: s, size: "large", color: "inherit" })
    }
  );
});
FloatingButton.displayName = "FloatingButton";
const InteractiveButton = forwardRef$1(
  ({ label: r, link: a, ...s }, c) => {
    const u = useMultiStyleConfig("InteractiveButton", {}), d = getButtonLinkProps({ link: a });
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "data-component": "InteractiveButton",
        as: "button",
        type: "button",
        ...s,
        ...d,
        __css: u.container,
        ref: c,
        children: [
          /* @__PURE__ */ jsx(Icon, { size: "small", type: "add", color: "inverse" }),
          /* @__PURE__ */ jsx(Box, { __css: u.text, children: r })
        ]
      }
    );
  }
);
InteractiveButton.displayName = "InteractiveButton";
const Form$1 = React__default.forwardRef((r, a) => /* @__PURE__ */ jsx(_Form, { "data-component": "Form", ref: a, ...r }));
Form$1.displayName = "Form";
var isCheckBoxInput = (r) => r.type === "checkbox", isDateObject = (r) => r instanceof Date, isNullOrUndefined = (r) => r == null;
const isObjectType = (r) => typeof r == "object";
var isObject$4 = (r) => !isNullOrUndefined(r) && !Array.isArray(r) && isObjectType(r) && !isDateObject(r), getEventValue = (r) => isObject$4(r) && r.target ? isCheckBoxInput(r.target) ? r.target.checked : r.target.value : r, getNodeParentName = (r) => r.substring(0, r.search(/\.\d+(\.|$)/)) || r, isNameInFieldArray = (r, a) => r.has(getNodeParentName(a)), isPlainObject = (r) => {
  const a = r.constructor && r.constructor.prototype;
  return isObject$4(a) && a.hasOwnProperty("isPrototypeOf");
}, isWeb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cloneObject(r) {
  let a;
  const s = Array.isArray(r);
  if (r instanceof Date)
    a = new Date(r);
  else if (r instanceof Set)
    a = new Set(r);
  else if (!(isWeb && (r instanceof Blob || r instanceof FileList)) && (s || isObject$4(r)))
    if (a = s ? [] : {}, !s && !isPlainObject(r))
      a = r;
    else
      for (const c in r)
        r.hasOwnProperty(c) && (a[c] = cloneObject(r[c]));
  else
    return r;
  return a;
}
var compact = (r) => Array.isArray(r) ? r.filter(Boolean) : [], isUndefined = (r) => r === void 0, get$2 = (r, a, s) => {
  if (!a || !isObject$4(r))
    return s;
  const c = compact(a.split(/[,[\].]+?/)).reduce((u, d) => isNullOrUndefined(u) ? u : u[d], r);
  return isUndefined(c) || c === r ? isUndefined(r[a]) ? s : r[a] : c;
}, isBoolean = (r) => typeof r == "boolean";
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, HookFormContext = React__default.createContext(null), useFormContext = () => React__default.useContext(HookFormContext);
var getProxyFormState = (r, a, s, c = !0) => {
  const u = {
    defaultValues: a._defaultValues
  };
  for (const d in r)
    Object.defineProperty(u, d, {
      get: () => {
        const h = d;
        return a._proxyFormState[h] !== VALIDATION_MODE.all && (a._proxyFormState[h] = !c || VALIDATION_MODE.all), s && (s[h] = !0), r[h];
      }
    });
  return u;
}, isEmptyObject = (r) => isObject$4(r) && !Object.keys(r).length, shouldRenderFormState = (r, a, s, c) => {
  s(r);
  const { name: u, ...d } = r;
  return isEmptyObject(d) || Object.keys(d).length >= Object.keys(a).length || Object.keys(d).find((h) => a[h] === (!c || VALIDATION_MODE.all));
}, convertToArrayPayload = (r) => Array.isArray(r) ? r : [r], shouldSubscribeByName = (r, a, s) => !r || !a || r === a || convertToArrayPayload(r).some((c) => c && (s ? c === a : c.startsWith(a) || a.startsWith(c)));
function useSubscribe(r) {
  const a = React__default.useRef(r);
  a.current = r, React__default.useEffect(() => {
    const s = !r.disabled && a.current.subject && a.current.subject.subscribe({
      next: a.current.next
    });
    return () => {
      s && s.unsubscribe();
    };
  }, [r.disabled]);
}
function useFormState(r) {
  const a = useFormContext(), { control: s = a.control, disabled: c, name: u, exact: d } = r || {}, [h, p] = React__default.useState(s._formState), m = React__default.useRef(!0), g = React__default.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), v = React__default.useRef(u);
  return v.current = u, useSubscribe({
    disabled: c,
    next: (y) => m.current && shouldSubscribeByName(v.current, y.name, d) && shouldRenderFormState(y, g.current, s._updateFormState) && p({
      ...s._formState,
      ...y
    }),
    subject: s._subjects.state
  }), React__default.useEffect(() => (m.current = !0, g.current.isValid && s._updateValid(!0), () => {
    m.current = !1;
  }), [s]), getProxyFormState(h, s, g.current, !1);
}
var isString = (r) => typeof r == "string", generateWatchOutput = (r, a, s, c, u) => isString(r) ? (c && a.watch.add(r), get$2(s, r, u)) : Array.isArray(r) ? r.map((d) => (c && a.watch.add(d), get$2(s, d))) : (c && (a.watchAll = !0), s);
function useWatch(r) {
  const a = useFormContext(), { control: s = a.control, name: c, defaultValue: u, disabled: d, exact: h } = r || {}, p = React__default.useRef(c);
  p.current = c, useSubscribe({
    disabled: d,
    subject: s._subjects.values,
    next: (v) => {
      shouldSubscribeByName(p.current, v.name, h) && g(cloneObject(generateWatchOutput(p.current, s._names, v.values || s._formValues, !1, u)));
    }
  });
  const [m, g] = React__default.useState(s._getWatch(c, u));
  return React__default.useEffect(() => s._removeUnmounted()), m;
}
var isKey$4 = (r) => /^\w*$/.test(r), stringToPath$2 = (r) => compact(r.replace(/["|']|\]/g, "").split(/\.|\[/));
function set$1(r, a, s) {
  let c = -1;
  const u = isKey$4(a) ? [a] : stringToPath$2(a), d = u.length, h = d - 1;
  for (; ++c < d; ) {
    const p = u[c];
    let m = s;
    if (c !== h) {
      const g = r[p];
      m = isObject$4(g) || Array.isArray(g) ? g : isNaN(+u[c + 1]) ? {} : [];
    }
    r[p] = m, r = r[p];
  }
  return r;
}
function useController(r) {
  const a = useFormContext(), { name: s, disabled: c, control: u = a.control, shouldUnregister: d } = r, h = isNameInFieldArray(u._names.array, s), p = useWatch({
    control: u,
    name: s,
    defaultValue: get$2(u._formValues, s, get$2(u._defaultValues, s, r.defaultValue)),
    exact: !0
  }), m = useFormState({
    control: u,
    name: s
  }), g = React__default.useRef(u.register(s, {
    ...r.rules,
    value: p
  }));
  return g.current = u.register(s, r.rules), React__default.useEffect(() => {
    const v = u._options.shouldUnregister || d, y = (x, w) => {
      const S = get$2(u._fields, x);
      S && (S._f.mount = w);
    };
    if (y(s, !0), v) {
      const x = cloneObject(get$2(u._options.defaultValues, s));
      set$1(u._defaultValues, s, x), isUndefined(get$2(u._formValues, s)) && set$1(u._formValues, s, x);
    }
    return () => {
      (h ? v && !u._state.action : v) ? u.unregister(s) : y(s, !1);
    };
  }, [s, u, h, d]), React__default.useEffect(() => {
    get$2(u._fields, s) && u._updateDisabledField({
      disabled: c,
      fields: u._fields,
      name: s
    });
  }, [c, s, u]), {
    field: {
      name: s,
      value: p,
      ...isBoolean(c) ? { disabled: c } : {},
      onChange: React__default.useCallback((v) => g.current.onChange({
        target: {
          value: getEventValue(v),
          name: s
        },
        type: EVENTS.CHANGE
      }), [s]),
      onBlur: React__default.useCallback(() => g.current.onBlur({
        target: {
          value: get$2(u._formValues, s),
          name: s
        },
        type: EVENTS.BLUR
      }), [s, u]),
      ref: (v) => {
        const y = get$2(u._fields, s);
        y && v && (y._f.ref = {
          focus: () => v.focus(),
          select: () => v.select(),
          setCustomValidity: (x) => v.setCustomValidity(x),
          reportValidity: () => v.reportValidity()
        });
      }
    },
    formState: m,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!get$2(m.errors, s)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!get$2(m.dirtyFields, s)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!get$2(m.touchedFields, s)
      },
      error: {
        enumerable: !0,
        get: () => get$2(m.errors, s)
      }
    })
  };
}
var appendErrors = (r, a, s, c, u) => a ? {
  ...s[r],
  types: {
    ...s[r] && s[r].types ? s[r].types : {},
    [c]: u || !0
  }
} : {};
const focusFieldBy = (r, a, s) => {
  for (const c of s || Object.keys(r)) {
    const u = get$2(r, c);
    if (u) {
      const { _f: d, ...h } = u;
      if (d && a(d.name)) {
        if (d.ref.focus) {
          d.ref.focus();
          break;
        } else if (d.refs && d.refs[0].focus) {
          d.refs[0].focus();
          break;
        }
      } else isObject$4(h) && focusFieldBy(h, a);
    }
  }
};
var generateId = () => {
  const r = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (a) => {
    const s = (Math.random() * 16 + r) % 16 | 0;
    return (a == "x" ? s : s & 3 | 8).toString(16);
  });
}, getFocusFieldName = (r, a, s = {}) => s.shouldFocus || isUndefined(s.shouldFocus) ? s.focusName || `${r}.${isUndefined(s.focusIndex) ? a : s.focusIndex}.` : "", getValidationModes = (r) => ({
  isOnSubmit: !r || r === VALIDATION_MODE.onSubmit,
  isOnBlur: r === VALIDATION_MODE.onBlur,
  isOnChange: r === VALIDATION_MODE.onChange,
  isOnAll: r === VALIDATION_MODE.all,
  isOnTouch: r === VALIDATION_MODE.onTouched
}), isWatched = (r, a, s) => !s && (a.watchAll || a.watch.has(r) || [...a.watch].some((c) => r.startsWith(c) && /^\.\w+/.test(r.slice(c.length)))), updateFieldArrayRootError = (r, a, s) => {
  const c = compact(get$2(r, s));
  return set$1(c, "root", a[s]), set$1(r, s, c), r;
}, isFileInput = (r) => r.type === "file", isFunction$4 = (r) => typeof r == "function", isHTMLElement = (r) => {
  if (!isWeb)
    return !1;
  const a = r ? r.ownerDocument : 0;
  return r instanceof (a && a.defaultView ? a.defaultView.HTMLElement : HTMLElement);
}, isMessage = (r) => isString(r), isRadioInput = (r) => r.type === "radio", isRegex = (r) => r instanceof RegExp;
const defaultResult = {
  value: !1,
  isValid: !1
}, validResult = { value: !0, isValid: !0 };
var getCheckboxValue = (r) => {
  if (Array.isArray(r)) {
    if (r.length > 1) {
      const a = r.filter((s) => s && s.checked && !s.disabled).map((s) => s.value);
      return { value: a, isValid: !!a.length };
    }
    return r[0].checked && !r[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      r[0].attributes && !isUndefined(r[0].attributes.value) ? isUndefined(r[0].value) || r[0].value === "" ? validResult : { value: r[0].value, isValid: !0 } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: !1,
  value: null
};
var getRadioValue = (r) => Array.isArray(r) ? r.reduce((a, s) => s && s.checked && !s.disabled ? {
  isValid: !0,
  value: s.value
} : a, defaultReturn) : defaultReturn;
function getValidateError(r, a, s = "validate") {
  if (isMessage(r) || Array.isArray(r) && r.every(isMessage) || isBoolean(r) && !r)
    return {
      type: s,
      message: isMessage(r) ? r : "",
      ref: a
    };
}
var getValueAndMessage = (r) => isObject$4(r) && !isRegex(r) ? r : {
  value: r,
  message: ""
}, validateField = async (r, a, s, c, u) => {
  const { ref: d, refs: h, required: p, maxLength: m, minLength: g, min: v, max: y, pattern: x, validate: w, name: S, valueAsNumber: M, mount: P, disabled: L } = r._f, I = get$2(a, S);
  if (!P || L)
    return {};
  const T = h ? h[0] : d, E = (Z) => {
    c && T.reportValidity && (T.setCustomValidity(isBoolean(Z) ? "" : Z || ""), T.reportValidity());
  }, R = {}, A = isRadioInput(d), k = isCheckBoxInput(d), V = A || k, B = (M || isFileInput(d)) && isUndefined(d.value) && isUndefined(I) || isHTMLElement(d) && d.value === "" || I === "" || Array.isArray(I) && !I.length, q = appendErrors.bind(null, S, s, R), z = (Z, G, K, U = INPUT_VALIDATION_RULES.maxLength, F = INPUT_VALIDATION_RULES.minLength) => {
    const N = Z ? G : K;
    R[S] = {
      type: Z ? U : F,
      message: N,
      ref: d,
      ...q(Z ? U : F, N)
    };
  };
  if (u ? !Array.isArray(I) || !I.length : p && (!V && (B || isNullOrUndefined(I)) || isBoolean(I) && !I || k && !getCheckboxValue(h).isValid || A && !getRadioValue(h).isValid)) {
    const { value: Z, message: G } = isMessage(p) ? { value: !!p, message: p } : getValueAndMessage(p);
    if (Z && (R[S] = {
      type: INPUT_VALIDATION_RULES.required,
      message: G,
      ref: T,
      ...q(INPUT_VALIDATION_RULES.required, G)
    }, !s))
      return E(G), R;
  }
  if (!B && (!isNullOrUndefined(v) || !isNullOrUndefined(y))) {
    let Z, G;
    const K = getValueAndMessage(y), U = getValueAndMessage(v);
    if (!isNullOrUndefined(I) && !isNaN(I)) {
      const F = d.valueAsNumber || I && +I;
      isNullOrUndefined(K.value) || (Z = F > K.value), isNullOrUndefined(U.value) || (G = F < U.value);
    } else {
      const F = d.valueAsDate || new Date(I), N = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), D = d.type == "time", j = d.type == "week";
      isString(K.value) && I && (Z = D ? N(I) > N(K.value) : j ? I > K.value : F > new Date(K.value)), isString(U.value) && I && (G = D ? N(I) < N(U.value) : j ? I < U.value : F < new Date(U.value));
    }
    if ((Z || G) && (z(!!Z, K.message, U.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min), !s))
      return E(R[S].message), R;
  }
  if ((m || g) && !B && (isString(I) || u && Array.isArray(I))) {
    const Z = getValueAndMessage(m), G = getValueAndMessage(g), K = !isNullOrUndefined(Z.value) && I.length > +Z.value, U = !isNullOrUndefined(G.value) && I.length < +G.value;
    if ((K || U) && (z(K, Z.message, G.message), !s))
      return E(R[S].message), R;
  }
  if (x && !B && isString(I)) {
    const { value: Z, message: G } = getValueAndMessage(x);
    if (isRegex(Z) && !I.match(Z) && (R[S] = {
      type: INPUT_VALIDATION_RULES.pattern,
      message: G,
      ref: d,
      ...q(INPUT_VALIDATION_RULES.pattern, G)
    }, !s))
      return E(G), R;
  }
  if (w) {
    if (isFunction$4(w)) {
      const Z = await w(I, a), G = getValidateError(Z, T);
      if (G && (R[S] = {
        ...G,
        ...q(INPUT_VALIDATION_RULES.validate, G.message)
      }, !s))
        return E(G.message), R;
    } else if (isObject$4(w)) {
      let Z = {};
      for (const G in w) {
        if (!isEmptyObject(Z) && !s)
          break;
        const K = getValidateError(await w[G](I, a), T, G);
        K && (Z = {
          ...K,
          ...q(G, K.message)
        }, E(K.message), s && (R[S] = Z));
      }
      if (!isEmptyObject(Z) && (R[S] = {
        ref: T,
        ...Z
      }, !s))
        return R;
    }
  }
  return E(!0), R;
};
function append(r, a) {
  return [...r, ...convertToArrayPayload(a)];
}
var fillEmptyArray = (r) => Array.isArray(r) ? r.map(() => {
}) : void 0;
function insert(r, a, s) {
  return [
    ...r.slice(0, a),
    ...convertToArrayPayload(s),
    ...r.slice(a)
  ];
}
var moveArrayAt = (r, a, s) => Array.isArray(r) ? (isUndefined(r[s]) && (r[s] = void 0), r.splice(s, 0, r.splice(a, 1)[0]), r) : [];
function prepend(r, a) {
  return [...convertToArrayPayload(a), ...convertToArrayPayload(r)];
}
function removeAtIndexes(r, a) {
  let s = 0;
  const c = [...r];
  for (const u of a)
    c.splice(u - s, 1), s++;
  return compact(c).length ? c : [];
}
var removeArrayAt = (r, a) => isUndefined(a) ? [] : removeAtIndexes(r, convertToArrayPayload(a).sort((s, c) => s - c)), swapArrayAt = (r, a, s) => {
  r[a] = [r[s], r[s] = r[a]][0];
};
function baseGet$3(r, a) {
  const s = a.slice(0, -1).length;
  let c = 0;
  for (; c < s; )
    r = isUndefined(r) ? c++ : r[a[c++]];
  return r;
}
function isEmptyArray(r) {
  for (const a in r)
    if (r.hasOwnProperty(a) && !isUndefined(r[a]))
      return !1;
  return !0;
}
function unset(r, a) {
  const s = Array.isArray(a) ? a : isKey$4(a) ? [a] : stringToPath$2(a), c = s.length === 1 ? r : baseGet$3(r, s), u = s.length - 1, d = s[u];
  return c && delete c[d], u !== 0 && (isObject$4(c) && isEmptyObject(c) || Array.isArray(c) && isEmptyArray(c)) && unset(r, s.slice(0, -1)), r;
}
var updateAt = (r, a, s) => (r[a] = s, r);
function useFieldArray(r) {
  const a = useFormContext(), { control: s = a.control, name: c, keyName: u = "id", shouldUnregister: d } = r, [h, p] = React__default.useState(s._getFieldArray(c)), m = React__default.useRef(s._getFieldArray(c).map(generateId)), g = React__default.useRef(h), v = React__default.useRef(c), y = React__default.useRef(!1);
  v.current = c, g.current = h, s._names.array.add(c), r.rules && s.register(c, r.rules), useSubscribe({
    next: ({ values: R, name: A }) => {
      if (A === v.current || !A) {
        const k = get$2(R, v.current);
        Array.isArray(k) && (p(k), m.current = k.map(generateId));
      }
    },
    subject: s._subjects.array
  });
  const x = React__default.useCallback((R) => {
    y.current = !0, s._updateFieldArray(c, R);
  }, [s, c]), w = (R, A) => {
    const k = convertToArrayPayload(cloneObject(R)), V = append(s._getFieldArray(c), k);
    s._names.focus = getFocusFieldName(c, V.length - 1, A), m.current = append(m.current, k.map(generateId)), x(V), p(V), s._updateFieldArray(c, V, append, {
      argA: fillEmptyArray(R)
    });
  }, S = (R, A) => {
    const k = convertToArrayPayload(cloneObject(R)), V = prepend(s._getFieldArray(c), k);
    s._names.focus = getFocusFieldName(c, 0, A), m.current = prepend(m.current, k.map(generateId)), x(V), p(V), s._updateFieldArray(c, V, prepend, {
      argA: fillEmptyArray(R)
    });
  }, M = (R) => {
    const A = removeArrayAt(s._getFieldArray(c), R);
    m.current = removeArrayAt(m.current, R), x(A), p(A), s._updateFieldArray(c, A, removeArrayAt, {
      argA: R
    });
  }, P = (R, A, k) => {
    const V = convertToArrayPayload(cloneObject(A)), B = insert(s._getFieldArray(c), R, V);
    s._names.focus = getFocusFieldName(c, R, k), m.current = insert(m.current, R, V.map(generateId)), x(B), p(B), s._updateFieldArray(c, B, insert, {
      argA: R,
      argB: fillEmptyArray(A)
    });
  }, L = (R, A) => {
    const k = s._getFieldArray(c);
    swapArrayAt(k, R, A), swapArrayAt(m.current, R, A), x(k), p(k), s._updateFieldArray(c, k, swapArrayAt, {
      argA: R,
      argB: A
    }, !1);
  }, I = (R, A) => {
    const k = s._getFieldArray(c);
    moveArrayAt(k, R, A), moveArrayAt(m.current, R, A), x(k), p(k), s._updateFieldArray(c, k, moveArrayAt, {
      argA: R,
      argB: A
    }, !1);
  }, T = (R, A) => {
    const k = cloneObject(A), V = updateAt(s._getFieldArray(c), R, k);
    m.current = [...V].map((B, q) => !B || q === R ? generateId() : m.current[q]), x(V), p([...V]), s._updateFieldArray(c, V, updateAt, {
      argA: R,
      argB: k
    }, !0, !1);
  }, E = (R) => {
    const A = convertToArrayPayload(cloneObject(R));
    m.current = A.map(generateId), x([...A]), p([...A]), s._updateFieldArray(c, [...A], (k) => k, {}, !0, !1);
  };
  return React__default.useEffect(() => {
    if (s._state.action = !1, isWatched(c, s._names) && s._subjects.state.next({
      ...s._formState
    }), y.current && (!getValidationModes(s._options.mode).isOnSubmit || s._formState.isSubmitted))
      if (s._options.resolver)
        s._executeSchema([c]).then((R) => {
          const A = get$2(R.errors, c), k = get$2(s._formState.errors, c);
          (k ? !A && k.type || A && (k.type !== A.type || k.message !== A.message) : A && A.type) && (A ? set$1(s._formState.errors, c, A) : unset(s._formState.errors, c), s._subjects.state.next({
            errors: s._formState.errors
          }));
        });
      else {
        const R = get$2(s._fields, c);
        R && R._f && validateField(R, s._formValues, s._options.criteriaMode === VALIDATION_MODE.all, s._options.shouldUseNativeValidation, !0).then((A) => !isEmptyObject(A) && s._subjects.state.next({
          errors: updateFieldArrayRootError(s._formState.errors, A, c)
        }));
      }
    s._subjects.values.next({
      name: c,
      values: { ...s._formValues }
    }), s._names.focus && focusFieldBy(s._fields, (R) => !!R && R.startsWith(s._names.focus || "")), s._names.focus = "", s._updateValid(), y.current = !1;
  }, [h, c, s]), React__default.useEffect(() => (!get$2(s._formValues, c) && s._updateFieldArray(c), () => {
    (s._options.shouldUnregister || d) && s.unregister(c);
  }), [c, s, u, d]), {
    swap: React__default.useCallback(L, [x, c, s]),
    move: React__default.useCallback(I, [x, c, s]),
    prepend: React__default.useCallback(S, [x, c, s]),
    append: React__default.useCallback(w, [x, c, s]),
    remove: React__default.useCallback(M, [x, c, s]),
    insert: React__default.useCallback(P, [x, c, s]),
    update: React__default.useCallback(T, [x, c, s]),
    replace: React__default.useCallback(E, [x, c, s]),
    fields: React__default.useMemo(() => h.map((R, A) => ({
      ...R,
      [u]: m.current[A] || generateId()
    })), [h, u])
  };
}
function createSubject() {
  let r = [];
  return {
    get observers() {
      return r;
    },
    next: (u) => {
      for (const d of r)
        d.next && d.next(u);
    },
    subscribe: (u) => (r.push(u), {
      unsubscribe: () => {
        r = r.filter((d) => d !== u);
      }
    }),
    unsubscribe: () => {
      r = [];
    }
  };
}
var isPrimitive$1 = (r) => isNullOrUndefined(r) || !isObjectType(r);
function deepEqual(r, a) {
  if (isPrimitive$1(r) || isPrimitive$1(a))
    return r === a;
  if (isDateObject(r) && isDateObject(a))
    return r.getTime() === a.getTime();
  const s = Object.keys(r), c = Object.keys(a);
  if (s.length !== c.length)
    return !1;
  for (const u of s) {
    const d = r[u];
    if (!c.includes(u))
      return !1;
    if (u !== "ref") {
      const h = a[u];
      if (isDateObject(d) && isDateObject(h) || isObject$4(d) && isObject$4(h) || Array.isArray(d) && Array.isArray(h) ? !deepEqual(d, h) : d !== h)
        return !1;
    }
  }
  return !0;
}
var isMultipleSelect = (r) => r.type === "select-multiple", isRadioOrCheckbox = (r) => isRadioInput(r) || isCheckBoxInput(r), live = (r) => isHTMLElement(r) && r.isConnected, objectHasFunction = (r) => {
  for (const a in r)
    if (isFunction$4(r[a]))
      return !0;
  return !1;
};
function markFieldsDirty(r, a = {}) {
  const s = Array.isArray(r);
  if (isObject$4(r) || s)
    for (const c in r)
      Array.isArray(r[c]) || isObject$4(r[c]) && !objectHasFunction(r[c]) ? (a[c] = Array.isArray(r[c]) ? [] : {}, markFieldsDirty(r[c], a[c])) : isNullOrUndefined(r[c]) || (a[c] = !0);
  return a;
}
function getDirtyFieldsFromDefaultValues(r, a, s) {
  const c = Array.isArray(r);
  if (isObject$4(r) || c)
    for (const u in r)
      Array.isArray(r[u]) || isObject$4(r[u]) && !objectHasFunction(r[u]) ? isUndefined(a) || isPrimitive$1(s[u]) ? s[u] = Array.isArray(r[u]) ? markFieldsDirty(r[u], []) : { ...markFieldsDirty(r[u]) } : getDirtyFieldsFromDefaultValues(r[u], isNullOrUndefined(a) ? {} : a[u], s[u]) : s[u] = !deepEqual(r[u], a[u]);
  return s;
}
var getDirtyFields = (r, a) => getDirtyFieldsFromDefaultValues(r, a, markFieldsDirty(a)), getFieldValueAs = (r, { valueAsNumber: a, valueAsDate: s, setValueAs: c }) => isUndefined(r) ? r : a ? r === "" ? NaN : r && +r : s && isString(r) ? new Date(r) : c ? c(r) : r;
function getFieldValue(r) {
  const a = r.ref;
  if (!(r.refs ? r.refs.every((s) => s.disabled) : a.disabled))
    return isFileInput(a) ? a.files : isRadioInput(a) ? getRadioValue(r.refs).value : isMultipleSelect(a) ? [...a.selectedOptions].map(({ value: s }) => s) : isCheckBoxInput(a) ? getCheckboxValue(r.refs).value : getFieldValueAs(isUndefined(a.value) ? r.ref.value : a.value, r);
}
var getResolverOptions = (r, a, s, c) => {
  const u = {};
  for (const d of r) {
    const h = get$2(a, d);
    h && set$1(u, d, h._f);
  }
  return {
    criteriaMode: s,
    names: [...r],
    fields: u,
    shouldUseNativeValidation: c
  };
}, getRuleValue = (r) => isUndefined(r) ? r : isRegex(r) ? r.source : isObject$4(r) ? isRegex(r.value) ? r.value.source : r.value : r, hasValidation = (r) => r.mount && (r.required || r.min || r.max || r.maxLength || r.minLength || r.pattern || r.validate);
function schemaErrorLookup(r, a, s) {
  const c = get$2(r, s);
  if (c || isKey$4(s))
    return {
      error: c,
      name: s
    };
  const u = s.split(".");
  for (; u.length; ) {
    const d = u.join("."), h = get$2(a, d), p = get$2(r, d);
    if (h && !Array.isArray(h) && s !== d)
      return { name: s };
    if (p && p.type)
      return {
        name: d,
        error: p
      };
    u.pop();
  }
  return {
    name: s
  };
}
var skipValidation = (r, a, s, c, u) => u.isOnAll ? !1 : !s && u.isOnTouch ? !(a || r) : (s ? c.isOnBlur : u.isOnBlur) ? !r : (s ? c.isOnChange : u.isOnChange) ? r : !0, unsetEmptyArray = (r, a) => !compact(get$2(r, a)).length && unset(r, a);
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: !0
};
function createFormControl(r = {}, a) {
  let s = {
    ...defaultOptions,
    ...r
  }, c = {
    submitCount: 0,
    isDirty: !1,
    isLoading: isFunction$4(s.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, u = {}, d = isObject$4(s.defaultValues) || isObject$4(s.values) ? cloneObject(s.defaultValues || s.values) || {} : {}, h = s.shouldUnregister ? {} : cloneObject(d), p = {
    action: !1,
    mount: !1,
    watch: !1
  }, m = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, g, v = 0;
  const y = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, x = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  }, w = r.resetOptions && r.resetOptions.keepDirtyValues, S = getValidationModes(s.mode), M = getValidationModes(s.reValidateMode), P = s.criteriaMode === VALIDATION_MODE.all, L = (ne) => (se) => {
    clearTimeout(v), v = setTimeout(ne, se);
  }, I = async (ne) => {
    if (y.isValid || ne) {
      const se = s.resolver ? isEmptyObject((await B()).errors) : await z(u, !0);
      se !== c.isValid && x.state.next({
        isValid: se
      });
    }
  }, T = (ne) => y.isValidating && x.state.next({
    isValidating: ne
  }), E = (ne, se = [], de, Ce, me = !0, xe = !0) => {
    if (Ce && de) {
      if (p.action = !0, xe && Array.isArray(get$2(u, ne))) {
        const Se = de(get$2(u, ne), Ce.argA, Ce.argB);
        me && set$1(u, ne, Se);
      }
      if (xe && Array.isArray(get$2(c.errors, ne))) {
        const Se = de(get$2(c.errors, ne), Ce.argA, Ce.argB);
        me && set$1(c.errors, ne, Se), unsetEmptyArray(c.errors, ne);
      }
      if (y.touchedFields && xe && Array.isArray(get$2(c.touchedFields, ne))) {
        const Se = de(get$2(c.touchedFields, ne), Ce.argA, Ce.argB);
        me && set$1(c.touchedFields, ne, Se);
      }
      y.dirtyFields && (c.dirtyFields = getDirtyFields(d, h)), x.state.next({
        name: ne,
        isDirty: G(ne, se),
        dirtyFields: c.dirtyFields,
        errors: c.errors,
        isValid: c.isValid
      });
    } else
      set$1(h, ne, se);
  }, R = (ne, se) => {
    set$1(c.errors, ne, se), x.state.next({
      errors: c.errors
    });
  }, A = (ne, se, de, Ce) => {
    const me = get$2(u, ne);
    if (me) {
      const xe = get$2(h, ne, isUndefined(de) ? get$2(d, ne) : de);
      isUndefined(xe) || Ce && Ce.defaultChecked || se ? set$1(h, ne, se ? xe : getFieldValue(me._f)) : F(ne, xe), p.mount && I();
    }
  }, k = (ne, se, de, Ce, me) => {
    let xe = !1, Se = !1;
    const Re = {
      name: ne
    };
    if (!de || Ce) {
      y.isDirty && (Se = c.isDirty, c.isDirty = Re.isDirty = G(), xe = Se !== Re.isDirty);
      const Pe = deepEqual(get$2(d, ne), se);
      Se = get$2(c.dirtyFields, ne), Pe ? unset(c.dirtyFields, ne) : set$1(c.dirtyFields, ne, !0), Re.dirtyFields = c.dirtyFields, xe = xe || y.dirtyFields && Se !== !Pe;
    }
    if (de) {
      const Pe = get$2(c.touchedFields, ne);
      Pe || (set$1(c.touchedFields, ne, de), Re.touchedFields = c.touchedFields, xe = xe || y.touchedFields && Pe !== de);
    }
    return xe && me && x.state.next(Re), xe ? Re : {};
  }, V = (ne, se, de, Ce) => {
    const me = get$2(c.errors, ne), xe = y.isValid && isBoolean(se) && c.isValid !== se;
    if (r.delayError && de ? (g = L(() => R(ne, de)), g(r.delayError)) : (clearTimeout(v), g = null, de ? set$1(c.errors, ne, de) : unset(c.errors, ne)), (de ? !deepEqual(me, de) : me) || !isEmptyObject(Ce) || xe) {
      const Se = {
        ...Ce,
        ...xe && isBoolean(se) ? { isValid: se } : {},
        errors: c.errors,
        name: ne
      };
      c = {
        ...c,
        ...Se
      }, x.state.next(Se);
    }
    T(!1);
  }, B = async (ne) => s.resolver(h, s.context, getResolverOptions(ne || m.mount, u, s.criteriaMode, s.shouldUseNativeValidation)), q = async (ne) => {
    const { errors: se } = await B(ne);
    if (ne)
      for (const de of ne) {
        const Ce = get$2(se, de);
        Ce ? set$1(c.errors, de, Ce) : unset(c.errors, de);
      }
    else
      c.errors = se;
    return se;
  }, z = async (ne, se, de = {
    valid: !0
  }) => {
    for (const Ce in ne) {
      const me = ne[Ce];
      if (me) {
        const { _f: xe, ...Se } = me;
        if (xe) {
          const Re = m.array.has(xe.name), Pe = await validateField(me, h, P, s.shouldUseNativeValidation && !se, Re);
          if (Pe[xe.name] && (de.valid = !1, se))
            break;
          !se && (get$2(Pe, xe.name) ? Re ? updateFieldArrayRootError(c.errors, Pe, xe.name) : set$1(c.errors, xe.name, Pe[xe.name]) : unset(c.errors, xe.name));
        }
        Se && await z(Se, se, de);
      }
    }
    return de.valid;
  }, Z = () => {
    for (const ne of m.unMount) {
      const se = get$2(u, ne);
      se && (se._f.refs ? se._f.refs.every((de) => !live(de)) : !live(se._f.ref)) && J(ne);
    }
    m.unMount = /* @__PURE__ */ new Set();
  }, G = (ne, se) => (ne && se && set$1(h, ne, se), !deepEqual(W(), d)), K = (ne, se, de) => generateWatchOutput(ne, m, {
    ...p.mount ? h : isUndefined(se) ? d : isString(ne) ? { [ne]: se } : se
  }, de, se), U = (ne) => compact(get$2(p.mount ? h : d, ne, r.shouldUnregister ? get$2(d, ne, []) : [])), F = (ne, se, de = {}) => {
    const Ce = get$2(u, ne);
    let me = se;
    if (Ce) {
      const xe = Ce._f;
      xe && (!xe.disabled && set$1(h, ne, getFieldValueAs(se, xe)), me = isHTMLElement(xe.ref) && isNullOrUndefined(se) ? "" : se, isMultipleSelect(xe.ref) ? [...xe.ref.options].forEach((Se) => Se.selected = me.includes(Se.value)) : xe.refs ? isCheckBoxInput(xe.ref) ? xe.refs.length > 1 ? xe.refs.forEach((Se) => (!Se.defaultChecked || !Se.disabled) && (Se.checked = Array.isArray(me) ? !!me.find((Re) => Re === Se.value) : me === Se.value)) : xe.refs[0] && (xe.refs[0].checked = !!me) : xe.refs.forEach((Se) => Se.checked = Se.value === me) : isFileInput(xe.ref) ? xe.ref.value = "" : (xe.ref.value = me, xe.ref.type || x.values.next({
        name: ne,
        values: { ...h }
      })));
    }
    (de.shouldDirty || de.shouldTouch) && k(ne, me, de.shouldTouch, de.shouldDirty, !0), de.shouldValidate && H(ne);
  }, N = (ne, se, de) => {
    for (const Ce in se) {
      const me = se[Ce], xe = `${ne}.${Ce}`, Se = get$2(u, xe);
      (m.array.has(ne) || !isPrimitive$1(me) || Se && !Se._f) && !isDateObject(me) ? N(xe, me, de) : F(xe, me, de);
    }
  }, D = (ne, se, de = {}) => {
    const Ce = get$2(u, ne), me = m.array.has(ne), xe = cloneObject(se);
    set$1(h, ne, xe), me ? (x.array.next({
      name: ne,
      values: { ...h }
    }), (y.isDirty || y.dirtyFields) && de.shouldDirty && x.state.next({
      name: ne,
      dirtyFields: getDirtyFields(d, h),
      isDirty: G(ne, xe)
    })) : Ce && !Ce._f && !isNullOrUndefined(xe) ? N(ne, xe, de) : F(ne, xe, de), isWatched(ne, m) && x.state.next({ ...c }), x.values.next({
      name: ne,
      values: { ...h }
    }), !p.mount && a();
  }, j = async (ne) => {
    const se = ne.target;
    let de = se.name, Ce = !0;
    const me = get$2(u, de), xe = () => se.type ? getFieldValue(me._f) : getEventValue(ne);
    if (me) {
      let Se, Re;
      const Pe = xe(), ke = ne.type === EVENTS.BLUR || ne.type === EVENTS.FOCUS_OUT, De = !hasValidation(me._f) && !s.resolver && !get$2(c.errors, de) && !me._f.deps || skipValidation(ke, get$2(c.touchedFields, de), c.isSubmitted, M, S), Fe = isWatched(de, m, ke);
      set$1(h, de, Pe), ke ? (me._f.onBlur && me._f.onBlur(ne), g && g(0)) : me._f.onChange && me._f.onChange(ne);
      const Xe = k(de, Pe, ke, !1), ze = !isEmptyObject(Xe) || Fe;
      if (!ke && x.values.next({
        name: de,
        type: ne.type,
        values: { ...h }
      }), De)
        return y.isValid && I(), ze && x.state.next({ name: de, ...Fe ? {} : Xe });
      if (!ke && Fe && x.state.next({ ...c }), T(!0), s.resolver) {
        const { errors: Ge } = await B([de]), Tt = schemaErrorLookup(c.errors, u, de), _t = schemaErrorLookup(Ge, u, Tt.name || de);
        Se = _t.error, de = _t.name, Re = isEmptyObject(Ge);
      } else
        Se = (await validateField(me, h, P, s.shouldUseNativeValidation))[de], Ce = Number.isNaN(Pe) || Pe === get$2(h, de, Pe), Ce && (Se ? Re = !1 : y.isValid && (Re = await z(u, !0)));
      Ce && (me._f.deps && H(me._f.deps), V(de, Re, Se, Xe));
    }
  }, H = async (ne, se = {}) => {
    let de, Ce;
    const me = convertToArrayPayload(ne);
    if (T(!0), s.resolver) {
      const xe = await q(isUndefined(ne) ? ne : me);
      de = isEmptyObject(xe), Ce = ne ? !me.some((Se) => get$2(xe, Se)) : de;
    } else ne ? (Ce = (await Promise.all(me.map(async (xe) => {
      const Se = get$2(u, xe);
      return await z(Se && Se._f ? { [xe]: Se } : Se);
    }))).every(Boolean), !(!Ce && !c.isValid) && I()) : Ce = de = await z(u);
    return x.state.next({
      ...!isString(ne) || y.isValid && de !== c.isValid ? {} : { name: ne },
      ...s.resolver || !ne ? { isValid: de } : {},
      errors: c.errors,
      isValidating: !1
    }), se.shouldFocus && !Ce && focusFieldBy(u, (xe) => xe && get$2(c.errors, xe), ne ? me : m.mount), Ce;
  }, W = (ne) => {
    const se = {
      ...d,
      ...p.mount ? h : {}
    };
    return isUndefined(ne) ? se : isString(ne) ? get$2(se, ne) : ne.map((de) => get$2(se, de));
  }, re = (ne, se) => ({
    invalid: !!get$2((se || c).errors, ne),
    isDirty: !!get$2((se || c).dirtyFields, ne),
    isTouched: !!get$2((se || c).touchedFields, ne),
    error: get$2((se || c).errors, ne)
  }), ae = (ne) => {
    ne && convertToArrayPayload(ne).forEach((se) => unset(c.errors, se)), x.state.next({
      errors: ne ? c.errors : {}
    });
  }, ee = (ne, se, de) => {
    const Ce = (get$2(u, ne, { _f: {} })._f || {}).ref;
    set$1(c.errors, ne, {
      ...se,
      ref: Ce
    }), x.state.next({
      name: ne,
      errors: c.errors,
      isValid: !1
    }), de && de.shouldFocus && Ce && Ce.focus && Ce.focus();
  }, X = (ne, se) => isFunction$4(ne) ? x.values.subscribe({
    next: (de) => ne(K(void 0, se), de)
  }) : K(ne, se, !0), J = (ne, se = {}) => {
    for (const de of ne ? convertToArrayPayload(ne) : m.mount)
      m.mount.delete(de), m.array.delete(de), se.keepValue || (unset(u, de), unset(h, de)), !se.keepError && unset(c.errors, de), !se.keepDirty && unset(c.dirtyFields, de), !se.keepTouched && unset(c.touchedFields, de), !s.shouldUnregister && !se.keepDefaultValue && unset(d, de);
    x.values.next({
      values: { ...h }
    }), x.state.next({
      ...c,
      ...se.keepDirty ? { isDirty: G() } : {}
    }), !se.keepIsValid && I();
  }, ie = ({ disabled: ne, name: se, field: de, fields: Ce }) => {
    if (isBoolean(ne)) {
      const me = ne ? void 0 : get$2(h, se, getFieldValue(de ? de._f : get$2(Ce, se)._f));
      set$1(h, se, me), k(se, me, !1, !1, !0);
    }
  }, oe = (ne, se = {}) => {
    let de = get$2(u, ne);
    const Ce = isBoolean(se.disabled);
    return set$1(u, ne, {
      ...de || {},
      _f: {
        ...de && de._f ? de._f : { ref: { name: ne } },
        name: ne,
        mount: !0,
        ...se
      }
    }), m.mount.add(ne), de ? ie({
      field: de,
      disabled: se.disabled,
      name: ne
    }) : A(ne, !0, se.value), {
      ...Ce ? { disabled: se.disabled } : {},
      ...s.progressive ? {
        required: !!se.required,
        min: getRuleValue(se.min),
        max: getRuleValue(se.max),
        minLength: getRuleValue(se.minLength),
        maxLength: getRuleValue(se.maxLength),
        pattern: getRuleValue(se.pattern)
      } : {},
      name: ne,
      onChange: j,
      onBlur: j,
      ref: (me) => {
        if (me) {
          oe(ne, se), de = get$2(u, ne);
          const xe = isUndefined(me.value) && me.querySelectorAll && me.querySelectorAll("input,select,textarea")[0] || me, Se = isRadioOrCheckbox(xe), Re = de._f.refs || [];
          if (Se ? Re.find((Pe) => Pe === xe) : xe === de._f.ref)
            return;
          set$1(u, ne, {
            _f: {
              ...de._f,
              ...Se ? {
                refs: [
                  ...Re.filter(live),
                  xe,
                  ...Array.isArray(get$2(d, ne)) ? [{}] : []
                ],
                ref: { type: xe.type, name: ne }
              } : { ref: xe }
            }
          }), A(ne, !1, void 0, xe);
        } else
          de = get$2(u, ne, {}), de._f && (de._f.mount = !1), (s.shouldUnregister || se.shouldUnregister) && !(isNameInFieldArray(m.array, ne) && p.action) && m.unMount.add(ne);
      }
    };
  }, fe = () => s.shouldFocusError && focusFieldBy(u, (ne) => ne && get$2(c.errors, ne), m.mount), ve = (ne, se) => async (de) => {
    de && (de.preventDefault && de.preventDefault(), de.persist && de.persist());
    let Ce = cloneObject(h);
    if (x.state.next({
      isSubmitting: !0
    }), s.resolver) {
      const { errors: me, values: xe } = await B();
      c.errors = me, Ce = xe;
    } else
      await z(u);
    unset(c.errors, "root"), isEmptyObject(c.errors) ? (x.state.next({
      errors: {}
    }), await ne(Ce, de)) : (se && await se({ ...c.errors }, de), fe(), setTimeout(fe)), x.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: isEmptyObject(c.errors),
      submitCount: c.submitCount + 1,
      errors: c.errors
    });
  }, ue = (ne, se = {}) => {
    get$2(u, ne) && (isUndefined(se.defaultValue) ? D(ne, get$2(d, ne)) : (D(ne, se.defaultValue), set$1(d, ne, se.defaultValue)), se.keepTouched || unset(c.touchedFields, ne), se.keepDirty || (unset(c.dirtyFields, ne), c.isDirty = se.defaultValue ? G(ne, get$2(d, ne)) : G()), se.keepError || (unset(c.errors, ne), y.isValid && I()), x.state.next({ ...c }));
  }, pe = (ne, se = {}) => {
    const de = ne ? cloneObject(ne) : d, Ce = cloneObject(de), me = ne && !isEmptyObject(ne) ? Ce : d;
    if (se.keepDefaultValues || (d = de), !se.keepValues) {
      if (se.keepDirtyValues || w)
        for (const xe of m.mount)
          get$2(c.dirtyFields, xe) ? set$1(me, xe, get$2(h, xe)) : D(xe, get$2(me, xe));
      else {
        if (isWeb && isUndefined(ne))
          for (const xe of m.mount) {
            const Se = get$2(u, xe);
            if (Se && Se._f) {
              const Re = Array.isArray(Se._f.refs) ? Se._f.refs[0] : Se._f.ref;
              if (isHTMLElement(Re)) {
                const Pe = Re.closest("form");
                if (Pe) {
                  Pe.reset();
                  break;
                }
              }
            }
          }
        u = {};
      }
      h = r.shouldUnregister ? se.keepDefaultValues ? cloneObject(d) : {} : cloneObject(me), x.array.next({
        values: { ...me }
      }), x.values.next({
        values: { ...me }
      });
    }
    m = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !p.mount && a(), p.mount = !y.isValid || !!se.keepIsValid, p.watch = !!r.shouldUnregister, x.state.next({
      submitCount: se.keepSubmitCount ? c.submitCount : 0,
      isDirty: se.keepDirty ? c.isDirty : !!(se.keepDefaultValues && !deepEqual(ne, d)),
      isSubmitted: se.keepIsSubmitted ? c.isSubmitted : !1,
      dirtyFields: se.keepDirtyValues ? c.dirtyFields : se.keepDefaultValues && ne ? getDirtyFields(d, ne) : {},
      touchedFields: se.keepTouched ? c.touchedFields : {},
      errors: se.keepErrors ? c.errors : {},
      isSubmitSuccessful: se.keepIsSubmitSuccessful ? c.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, we = (ne, se) => pe(isFunction$4(ne) ? ne(h) : ne, se);
  return {
    control: {
      register: oe,
      unregister: J,
      getFieldState: re,
      handleSubmit: ve,
      setError: ee,
      _executeSchema: B,
      _getWatch: K,
      _getDirty: G,
      _updateValid: I,
      _removeUnmounted: Z,
      _updateFieldArray: E,
      _updateDisabledField: ie,
      _getFieldArray: U,
      _reset: pe,
      _resetDefaultValues: () => isFunction$4(s.defaultValues) && s.defaultValues().then((ne) => {
        we(ne, s.resetOptions), x.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ne) => {
        c = {
          ...c,
          ...ne
        };
      },
      _subjects: x,
      _proxyFormState: y,
      get _fields() {
        return u;
      },
      get _formValues() {
        return h;
      },
      get _state() {
        return p;
      },
      set _state(ne) {
        p = ne;
      },
      get _defaultValues() {
        return d;
      },
      get _names() {
        return m;
      },
      set _names(ne) {
        m = ne;
      },
      get _formState() {
        return c;
      },
      set _formState(ne) {
        c = ne;
      },
      get _options() {
        return s;
      },
      set _options(ne) {
        s = {
          ...s,
          ...ne
        };
      }
    },
    trigger: H,
    register: oe,
    handleSubmit: ve,
    watch: X,
    setValue: D,
    getValues: W,
    reset: we,
    resetField: ue,
    clearErrors: ae,
    unregister: J,
    setError: ee,
    setFocus: (ne, se = {}) => {
      const de = get$2(u, ne), Ce = de && de._f;
      if (Ce) {
        const me = Ce.refs ? Ce.refs[0] : Ce.ref;
        me.focus && (me.focus(), se.shouldSelect && me.select());
      }
    },
    getFieldState: re
  };
}
function useForm(r = {}) {
  const a = React__default.useRef(), s = React__default.useRef(), [c, u] = React__default.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: isFunction$4(r.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction$4(r.defaultValues) ? void 0 : r.defaultValues
  });
  a.current || (a.current = {
    ...createFormControl(r, () => u((h) => ({ ...h }))),
    formState: c
  });
  const d = a.current.control;
  return d._options = r, useSubscribe({
    subject: d._subjects.state,
    next: (h) => {
      shouldRenderFormState(h, d._proxyFormState, d._updateFormState, !0) && u({ ...d._formState });
    }
  }), React__default.useEffect(() => {
    r.values && !deepEqual(r.values, s.current) ? (d._reset(r.values, d._options.resetOptions), s.current = r.values) : d._resetDefaultValues();
  }, [r.values, d]), React__default.useEffect(() => {
    d._state.mount || (d._updateValid(), d._state.mount = !0), d._state.watch && (d._state.watch = !1, d._subjects.state.next({ ...d._formState })), d._removeUnmounted();
  }), a.current.formState = getProxyFormState(c, d), a.current;
}
function createFormFieldInput(r) {
  const a = forwardRef$1(
    ({
      labelProps: s,
      "aria-label": c,
      colSpan: u,
      error: d,
      helperTextProps: h,
      maxChars: p,
      isDisabled: m,
      isReadOnly: g,
      isViewMode: v,
      isRequired: y,
      showOptionalIndicator: x,
      isHidden: w,
      size: S,
      name: M,
      id: P,
      control: L,
      viewModePlaceholder: I,
      autoComplete: T,
      ...E
    }, R) => {
      const { autoComplete: A, ...k } = r.defaultProps ?? {}, V = T ?? A, B = useRef$1(null), q = {
        ...k,
        // Manually focus the field when the label is clicked in case it's a non-semantic form element.
        labelProps: s && { ...s, onClick: () => {
          var N;
          return (N = B.current) == null ? void 0 : N.focus();
        } },
        "aria-label": c,
        colSpan: u,
        error: d,
        helperTextProps: h,
        maxChars: p,
        isReadOnly: g,
        isViewMode: v,
        isRequired: y,
        showOptionalIndicator: x,
        isHidden: w,
        name: M,
        id: P,
        autoComplete: V
      }, { field: z } = useController({ name: M, control: L }), Z = useFormContext$1(), G = Z.isDisabled || m, K = Z.isReadOnly || g || Z.isLoading, U = Z.isViewMode || v, F = S ?? Z.size;
      return /* @__PURE__ */ jsx(
        _FormField,
        {
          ...q,
          size: F,
          isDisabled: G,
          isReadOnly: K,
          isViewMode: U,
          columns: Z.columns,
          value: z.value,
          children: /* @__PURE__ */ jsx(
            r,
            {
              ...z,
              "data-testid": M && `form-input-${M}`,
              ...E,
              id: P,
              placeholder: U ? I : E.placeholder,
              isDisabled: G,
              isReadOnly: K,
              isViewMode: U,
              size: F,
              ref: mergeRefs([z.ref, R, B])
            }
          )
        }
      );
    }
  );
  return r.displayName && (a.displayName = `Form.${r.displayName.slice(1)}`), a;
}
const inputs = {
  TextField: createFormFieldInput(
    TextField
  ),
  TextArea: createFormFieldInput(
    TextArea
  ),
  SecuredTextField: createFormFieldInput(SecuredTextField),
  AmountField: createFormFieldInput(AmountField),
  /**
   * @deprecated Please use `SelectNew` instead.
   */
  // eslint-disable-next-line import/no-deprecated
  Select: createFormFieldInput(Select),
  SelectNew: createFormFieldInput(
    SelectNew
  ),
  Search: createFormFieldInput(Search),
  MultiSelect: createFormFieldInput(MultiSelect),
  RadioGroup: createFormFieldInput(RadioGroup),
  Checkbox: createFormFieldInput(Checkbox),
  DateField: createFormFieldInput(DateField),
  FileUpload: createFormFieldInput(FileUpload),
  PhoneField: createFormFieldInput(PhoneField),
  /**
   * @deprecated Use `FormField` instead
   */
  ContentBox: _ContentBox,
  Switch: createFormFieldInput(Switch)
}, Form = Object.assign(Form$1, inputs), FormFieldControlRender = ({
  name: r,
  control: a,
  render: s,
  setLocalValue: c,
  maxChars: u,
  ...d
}) => {
  const { field: h } = useController({ name: r, control: a });
  useEffect$1(() => {
    u && c(`${h.value ?? ""}`);
  }, [h.value, c, u]);
  const p = {
    ...u && { maxChars: u },
    ...d,
    ...h
  };
  return /* @__PURE__ */ jsx(Fragment, { children: s(p) });
}, MaxCharsCounter = ({
  maxChars: r,
  valueLength: a = 0,
  ...s
}) => {
  const c = a >= r ? r : a;
  return /* @__PURE__ */ jsx(Text, { ...s, textStyle: "inline", children: `${c}/${r}` });
}, FormField = forwardRef$1(
  ({
    error: r,
    labelProps: a,
    helperText: s,
    maxChars: c,
    isDisabled: u,
    isReadOnly: d,
    isViewMode: h,
    isLoading: p,
    size: m,
    isRequired: g,
    showOptionalIndicator: v,
    children: y,
    render: x,
    "data-testid": w = "form-field",
    id: S,
    colSpan: M = 1,
    name: P,
    control: L,
    ...I
  }, T) => {
    const E = !!r, { isHidden: R, ...A } = a, [k, V] = useState$1(""), B = useTestId(w), q = useFormContext$1(), z = u ?? q.isDisabled, Z = d ?? (q.isReadOnly || q.isLoading), G = h ?? q.isViewMode, K = m ?? q.size ?? "large", U = useMultiStyleConfig("FormField", {
      size: K,
      error: r,
      helperText: s,
      isViewMode: G
    }), F = S ?? a.id, { helperTextId: N, errorMessageId: D, maxCharsId: j, ...H } = getAriaDescribedByProps({
      id: F,
      error: r,
      helperText: s,
      maxChars: c
    }), W = {
      size: K,
      isDisabled: z,
      isReadOnly: Z,
      isViewMode: G,
      isLoading: p,
      isInvalid: E,
      ...B("render-field"),
      id: F,
      ...H,
      "aria-required": !G && g,
      ...c && { maxChars: c }
    };
    return /* @__PURE__ */ jsxs(
      Box,
      {
        __css: U.container,
        ...B(),
        "data-component": "FormField",
        as: q.isViewMode ? "li" : "div",
        gridColumn: { xs: "1 / 1", s: `span ${M} / span 1` },
        ...I,
        ref: T,
        children: [
          /* @__PURE__ */ jsx(Box, { __css: U.label, ...B("label-container"), "data-hidden": a.isHidden, children: /* @__PURE__ */ jsx(
            Typography.Label,
            {
              ...B("label"),
              as: G ? "div" : "label",
              isInvalid: E,
              isReadOnly: Z || p,
              isViewMode: G,
              isDisabled: z,
              description: G ? void 0 : g ? "*" : v ? "(optional)" : void 0,
              ...A,
              id: F
            }
          ) }),
          /* @__PURE__ */ jsxs(Box, { __css: U.fieldGroup, children: [
            /* @__PURE__ */ jsx(Box, { __css: U.field, children: L && P ? /* @__PURE__ */ jsx(
              FormFieldControlRender,
              {
                control: L,
                name: P,
                render: x,
                setLocalValue: V,
                ...W
              }
            ) : x(W) }),
            /* @__PURE__ */ jsxs(
              Box,
              {
                __css: U.helperText,
                "aria-disabled": z,
                "data-invalid": E || null,
                "data-readonly": Z || p || null,
                "aria-live": "assertive",
                children: [
                  r != null && r.message ? /* @__PURE__ */ jsx(Text, { color: "inherit", textStyle: "inline", id: D, ...B("error-message"), children: r.message }) : s && !G ? /* @__PURE__ */ jsx(Text, { color: "inherit", textStyle: "inline", id: N, ...B("helper-text"), children: s }) : null,
                  !G && typeof k == "string" && c && /* @__PURE__ */ jsx(
                    MaxCharsCounter,
                    {
                      maxChars: c,
                      id: j,
                      valueLength: k.length,
                      ...B("chars-counter")
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    );
  }
);
FormField.displayName = "FormField";
const Body = forwardRef$1(
  ({ isLoading: r, children: a, "data-testid": s = "form-line-items-body", ...c }, u) => {
    const d = useMultiStyleConfig("FormLineItems", {}), h = useTestId(s);
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: d.body,
        ref: u,
        "data-loading": r,
        "data-component": "FormLineItems.Body",
        role: "rowgroup",
        ...h(),
        ...c,
        children: /* @__PURE__ */ jsx(LoadingContainer, { isLoading: r, children: a })
      }
    );
  }
);
Body.displayName = "FormLineItems.Body";
const Cell = forwardRef$1(
  ({ children: r, size: a, isSticky: s, "data-testid": c = "form-line-items-cell", ...u }, d) => {
    const h = useMultiStyleConfig("FormLineItems", { size: a }), p = useTestId(c);
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: h.cell,
        ref: d,
        "data-is-sticky": s,
        "data-component": "FormLineItems.Cell",
        role: "cell",
        ...p(),
        ...u,
        children: /* @__PURE__ */ jsx(Box, { __css: h.cellContent, "data-is-sticky": s, children: r })
      }
    );
  }
);
Cell.displayName = "FormLineItems.Cell";
const HeaderCell = forwardRef$1(
  ({ children: r, size: a, isSticky: s, "data-testid": c = "form-line-items-header-cell", ...u }, d) => {
    const h = useMultiStyleConfig("FormLineItems", { size: a }), p = useTestId(c), m = typeof r == "string" ? /* @__PURE__ */ jsx(Text, { color: "semantic.text.secondary", textStyle: "body4Semi", shouldSupportEllipsis: !0, children: r }) : r, g = m ? "columnheader" : "cell";
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: h.headerCell,
        ref: d,
        "data-is-sticky": s,
        "data-component": "FormLineItems.HeaderCell",
        role: g,
        ...p(),
        ...u,
        children: /* @__PURE__ */ jsx(Box, { __css: h.headerCellContent, children: m })
      }
    );
  }
);
HeaderCell.displayName = "FormLineItems.HeaderCell";
const HeaderRow = forwardRef$1(
  ({ "data-testid": r = "form-line-items-header-row", children: a, ...s }, c) => {
    const u = useMultiStyleConfig("FormLineItems", {}), d = useTestId(r);
    return /* @__PURE__ */ jsx(Box, { "data-component": "FormLineItems.HeaderRow", role: "rowgroup", ref: c, ...d(), ...s, children: /* @__PURE__ */ jsx(Box, { __css: u.headerRow, role: "row", children: a }) });
  }
);
HeaderRow.displayName = "FormLineItems.HeaderRow";
const MobileList = forwardRef$1(
  ({ children: r, "data-testid": a = "form-line-items-mobile-list", ...s }, c) => {
    const u = useTestId(a);
    return /* @__PURE__ */ jsx(
      Group,
      {
        variant: "vertical",
        spacing: "s",
        ref: c,
        "data-component": "FormLineItems.MobileList",
        ...u(),
        ...s,
        children: r
      }
    );
  }
);
MobileList.displayName = "FormLineItems.MobileList";
const MobileListItem = forwardRef$1(
  ({ index: r, children: a, "data-testid": s = "form-line-items-mobile-list-item", ...c }, u) => {
    const d = useTestId(s);
    return /* @__PURE__ */ jsx(Card, { variant: "flat", paddingX: "s", paddingY: "s", ...d, ...c, ref: u, children: /* @__PURE__ */ jsx(Container, { width: "full", children: /* @__PURE__ */ jsx(Collapsible, { label: `#${r + 1}`, labelView: "full", children: a }) }) });
  }
);
MobileListItem.displayName = "FormLineItems.MobileListItem";
const Row = forwardRef$1(
  ({ isLoading: r, children: a, "data-testid": s = "form-line-items-row", ...c }, u) => {
    const d = useMultiStyleConfig("FormLineItems", {}), h = useTestId(s);
    return /* @__PURE__ */ jsxs(Box, { __css: d.row, ref: u, "data-component": "FormLineItems.Row", role: "row", ...h(), ...c, children: [
      a,
      /* @__PURE__ */ jsx(Blanket, { isOpen: r, variant: "light" })
    ] });
  }
);
Row.displayName = "FormLineItems.Row";
const FormLineItems$1 = forwardRef$1(
  ({ "data-testid": r = "form-line-items", ...a }, s) => {
    const c = useRef$1(null), u = mergeRefs([c, s]), { hasOverflowX: d } = useHasOverflow(c), h = useMultiStyleConfig("FormLineItems", { hasOverflowX: d }), p = useTestId(r);
    return /* @__PURE__ */ jsx(
      Box,
      {
        __css: h.container,
        ref: u,
        "data-component": "FormLineItems",
        role: "table",
        ...p(),
        ...a
      }
    );
  }
);
FormLineItems$1.displayName = "FormLineItems";
const components = {
  HeaderRow,
  HeaderCell,
  Body,
  Row,
  Cell,
  MobileList,
  MobileListItem
}, FormLineItems = Object.assign(FormLineItems$1, components);
function useFormSubmissionController() {
  const [r, a] = useState$1();
  return {
    ...r,
    onSubmissionStateChange: a
  };
}
var e = function(r, a, s) {
  if (r && "reportValidity" in r) {
    var c = get$2(s, a);
    r.setCustomValidity(c && c.message || ""), r.reportValidity();
  }
}, t = function(r, a) {
  var s = function(u) {
    var d = a.fields[u];
    d && d.ref && "reportValidity" in d.ref ? e(d.ref, u, r) : d.refs && d.refs.forEach(function(h) {
      return e(h, u, r);
    });
  };
  for (var c in a.fields) s(c);
}, f = function(r, a) {
  a.shouldUseNativeValidation && t(r, a);
  var s = {};
  for (var c in r) {
    var u = get$2(a.fields, c);
    set$1(s, c, Object.assign(r[c], { ref: u && u.ref }));
  }
  return s;
}, o = function(r, a, s) {
  return a === void 0 && (a = {}), s === void 0 && (s = {}), function(c, u, d) {
    try {
      return Promise.resolve(function(h, p) {
        try {
          var m = (a.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(r[s.mode === "sync" ? "validateSync" : "validate"](c, Object.assign({ abortEarly: !1 }, a, { context: u }))).then(function(g) {
            return d.shouldUseNativeValidation && t({}, d), { values: s.rawValues ? c : g, errors: {} };
          }));
        } catch (g) {
          return p(g);
        }
        return m && m.then ? m.then(void 0, p) : m;
      }(0, function(h) {
        if (!h.inner) throw h;
        return { values: {}, errors: f((p = h, m = !d.shouldUseNativeValidation && d.criteriaMode === "all", (p.inner || []).reduce(function(g, v) {
          if (g[v.path] || (g[v.path] = { message: v.message, type: v.type }), m) {
            var y = g[v.path].types, x = y && y[v.type];
            g[v.path] = appendErrors(v.path, m, g, v.type, x ? [].concat(x, v.message) : v.message);
          }
          return g;
        }, {})), d) };
        var p, m;
      }));
    } catch (h) {
      return Promise.reject(h);
    }
  };
}, has$2 = Object.prototype.hasOwnProperty;
function find(r, a, s) {
  for (s of r.keys())
    if (dequal(s, a)) return s;
}
function dequal(r, a) {
  var s, c, u;
  if (r === a) return !0;
  if (r && a && (s = r.constructor) === a.constructor) {
    if (s === Date) return r.getTime() === a.getTime();
    if (s === RegExp) return r.toString() === a.toString();
    if (s === Array) {
      if ((c = r.length) === a.length)
        for (; c-- && dequal(r[c], a[c]); ) ;
      return c === -1;
    }
    if (s === Set) {
      if (r.size !== a.size)
        return !1;
      for (c of r)
        if (u = c, u && typeof u == "object" && (u = find(a, u), !u) || !a.has(u)) return !1;
      return !0;
    }
    if (s === Map) {
      if (r.size !== a.size)
        return !1;
      for (c of r)
        if (u = c[0], u && typeof u == "object" && (u = find(a, u), !u) || !dequal(c[1], a.get(u)))
          return !1;
      return !0;
    }
    if (s === ArrayBuffer)
      r = new Uint8Array(r), a = new Uint8Array(a);
    else if (s === DataView) {
      if ((c = r.byteLength) === a.byteLength)
        for (; c-- && r.getInt8(c) === a.getInt8(c); ) ;
      return c === -1;
    }
    if (ArrayBuffer.isView(r)) {
      if ((c = r.byteLength) === a.byteLength)
        for (; c-- && r[c] === a[c]; ) ;
      return c === -1;
    }
    if (!s || typeof r == "object") {
      c = 0;
      for (s in r)
        if (has$2.call(r, s) && ++c && !has$2.call(a, s) || !(s in a) || !dequal(r[s], a[s])) return !1;
      return Object.keys(a).length === c;
    }
  }
  return r !== r && a !== a;
}
function checkDeps(r) {
  if (!r || !r.length)
    throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
  if (r.every(isPrimitive))
    throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
}
function isPrimitive(r) {
  return r == null || /^[sbn]/.test(typeof r);
}
function useDeepCompareMemoize(r) {
  var a = React.useRef(r), s = React.useRef(0);
  return dequal(r, a.current) || (a.current = r, s.current += 1), React.useMemo(function() {
    return a.current;
  }, [s.current]);
}
function useDeepCompareEffect(r, a) {
  return process.env.NODE_ENV !== "production" && checkDeps(a), React.useEffect(r, useDeepCompareMemoize(a));
}
var map;
try {
  map = Map;
} catch (r) {
}
var set;
try {
  set = Set;
} catch (r) {
}
function baseClone(r, a, s) {
  if (!r || typeof r != "object" || typeof r == "function")
    return r;
  if (r.nodeType && "cloneNode" in r)
    return r.cloneNode(!0);
  if (r instanceof Date)
    return new Date(r.getTime());
  if (r instanceof RegExp)
    return new RegExp(r);
  if (Array.isArray(r))
    return r.map(clone);
  if (map && r instanceof map)
    return new Map(Array.from(r.entries()));
  if (set && r instanceof set)
    return new Set(Array.from(r.values()));
  if (r instanceof Object) {
    a.push(r);
    var c = Object.create(r);
    s.push(c);
    for (var u in r) {
      var d = a.findIndex(function(h) {
        return h === r[u];
      });
      c[u] = d > -1 ? s[d] : baseClone(r[u], a, s);
    }
    return c;
  }
  return r;
}
function clone(r) {
  return baseClone(r, [], []);
}
const toString$3 = Object.prototype.toString, errorToString = Error.prototype.toString, regExpToString = RegExp.prototype.toString, symbolToString$1 = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(r) {
  return r != +r ? "NaN" : r === 0 && 1 / r < 0 ? "-0" : "" + r;
}
function printSimpleValue(r, a = !1) {
  if (r == null || r === !0 || r === !1) return "" + r;
  const s = typeof r;
  if (s === "number") return printNumber(r);
  if (s === "string") return a ? `"${r}"` : r;
  if (s === "function") return "[Function " + (r.name || "anonymous") + "]";
  if (s === "symbol") return symbolToString$1.call(r).replace(SYMBOL_REGEXP, "Symbol($1)");
  const c = toString$3.call(r).slice(8, -1);
  return c === "Date" ? isNaN(r.getTime()) ? "" + r : r.toISOString(r) : c === "Error" || r instanceof Error ? "[" + errorToString.call(r) + "]" : c === "RegExp" ? regExpToString.call(r) : null;
}
function printValue(r, a) {
  let s = printSimpleValue(r, a);
  return s !== null ? s : JSON.stringify(r, function(c, u) {
    let d = printSimpleValue(this[c], a);
    return d !== null ? d : u;
  }, 2);
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: r,
    type: a,
    value: s,
    originalValue: c
  }) => {
    let u = c != null && c !== s, d = `${r} must be a \`${a}\` type, but the final value was: \`${printValue(s, !0)}\`` + (u ? ` (cast from the value \`${printValue(c, !0)}\`).` : ".");
    return s === null && (d += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), d;
  },
  defined: "${path} must be defined"
}, string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, boolean = {
  isValue: "${path} field must be ${value}"
}, object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});
var objectProto$c = Object.prototype, hasOwnProperty$9 = objectProto$c.hasOwnProperty;
function baseHas$1(r, a) {
  return r != null && hasOwnProperty$9.call(r, a);
}
var _baseHas = baseHas$1, isArray$8 = Array.isArray, isArray_1 = isArray$8, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$8 = freeGlobal || freeSelf || Function("return this")(), _root = root$8, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$b = Object.prototype, hasOwnProperty$8 = objectProto$b.hasOwnProperty, nativeObjectToString$1 = objectProto$b.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(r) {
  var a = hasOwnProperty$8.call(r, symToStringTag$1), s = r[symToStringTag$1];
  try {
    r[symToStringTag$1] = void 0;
    var c = !0;
  } catch {
  }
  var u = nativeObjectToString$1.call(r);
  return c && (a ? r[symToStringTag$1] = s : delete r[symToStringTag$1]), u;
}
var _getRawTag = getRawTag$1, objectProto$a = Object.prototype, nativeObjectToString = objectProto$a.toString;
function objectToString$1(r) {
  return nativeObjectToString.call(r);
}
var _objectToString = objectToString$1, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$5(r) {
  return r == null ? r === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(r) ? getRawTag(r) : objectToString(r);
}
var _baseGetTag = baseGetTag$5;
function isObjectLike$5(r) {
  return r != null && typeof r == "object";
}
var isObjectLike_1 = isObjectLike$5, baseGetTag$4 = _baseGetTag, isObjectLike$4 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$3(r) {
  return typeof r == "symbol" || isObjectLike$4(r) && baseGetTag$4(r) == symbolTag$1;
}
var isSymbol_1 = isSymbol$3, isArray$7 = isArray_1, isSymbol$2 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(r, a) {
  if (isArray$7(r))
    return !1;
  var s = typeof r;
  return s == "number" || s == "symbol" || s == "boolean" || r == null || isSymbol$2(r) ? !0 : reIsPlainProp.test(r) || !reIsDeepProp.test(r) || a != null && r in Object(a);
}
var _isKey = isKey$3;
function isObject$3(r) {
  var a = typeof r;
  return r != null && (a == "object" || a == "function");
}
var isObject_1 = isObject$3, baseGetTag$3 = _baseGetTag, isObject$2 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(r) {
  if (!isObject$2(r))
    return !1;
  var a = baseGetTag$3(r);
  return a == funcTag$1 || a == genTag || a == asyncTag || a == proxyTag;
}
var isFunction_1 = isFunction$3, root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var r = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function isMasked$1(r) {
  return !!maskSrcKey && maskSrcKey in r;
}
var _isMasked = isMasked$1, funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource$2(r) {
  if (r != null) {
    try {
      return funcToString$1.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$2 = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$9 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$7 = objectProto$9.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(r) {
  if (!isObject$1(r) || isMasked(r))
    return !1;
  var a = isFunction$2(r) ? reIsNative : reIsHostCtor;
  return a.test(toSource$1(r));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(r, a) {
  return r == null ? void 0 : r[a];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(r, a) {
  var s = getValue(r, a);
  return baseIsNative(s) ? s : void 0;
}
var _getNative = getNative$7, getNative$6 = _getNative, nativeCreate$4 = getNative$6(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(r) {
  var a = this.has(r) && delete this.__data__[r];
  return this.size -= a ? 1 : 0, a;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(r) {
  var a = this.__data__;
  if (nativeCreate$2) {
    var s = a[r];
    return s === HASH_UNDEFINED$2 ? void 0 : s;
  }
  return hasOwnProperty$6.call(a, r) ? a[r] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$7 = Object.prototype, hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(r) {
  var a = this.__data__;
  return nativeCreate$1 ? a[r] !== void 0 : hasOwnProperty$5.call(a, r);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(r, a) {
  var s = this.__data__;
  return this.size += this.has(r) ? 0 : 1, s[r] = nativeCreate && a === void 0 ? HASH_UNDEFINED$1 : a, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(r) {
  var a = -1, s = r == null ? 0 : r.length;
  for (this.clear(); ++a < s; ) {
    var c = r[a];
    this.set(c[0], c[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(r, a) {
  return r === a || r !== r && a !== a;
}
var eq_1 = eq$2, eq$1 = eq_1;
function assocIndexOf$4(r, a) {
  for (var s = r.length; s--; )
    if (eq$1(r[s][0], a))
      return s;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(r) {
  var a = this.__data__, s = assocIndexOf$3(a, r);
  if (s < 0)
    return !1;
  var c = a.length - 1;
  return s == c ? a.pop() : splice.call(a, s, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(r) {
  var a = this.__data__, s = assocIndexOf$2(a, r);
  return s < 0 ? void 0 : a[s][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(r) {
  return assocIndexOf$1(this.__data__, r) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(r, a) {
  var s = this.__data__, c = assocIndexOf(s, r);
  return c < 0 ? (++this.size, s.push([r, a])) : s[c][1] = a, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(r) {
  var a = -1, s = r == null ? 0 : r.length;
  for (this.clear(); ++a < s; ) {
    var c = r[a];
    this.set(c[0], c[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$5 = _getNative, root$5 = _root, Map$4 = getNative$5(root$5, "Map"), _Map = Map$4, Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$3)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(r) {
  var a = typeof r;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? r !== "__proto__" : r === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(r, a) {
  var s = r.__data__;
  return isKeyable(a) ? s[typeof a == "string" ? "string" : "hash"] : s.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(r) {
  var a = getMapData$3(this, r).delete(r);
  return this.size -= a ? 1 : 0, a;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(r) {
  return getMapData$2(this, r).get(r);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(r) {
  return getMapData$1(this, r).has(r);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(r, a) {
  var s = getMapData(this, r), c = s.size;
  return s.set(r, a), this.size += s.size == c ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(r) {
  var a = -1, s = r == null ? 0 : r.length;
  for (this.clear(); ++a < s; ) {
    var c = r[a];
    this.set(c[0], c[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(r, a) {
  if (typeof r != "function" || a != null && typeof a != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var s = function() {
    var c = arguments, u = a ? a.apply(this, c) : c[0], d = s.cache;
    if (d.has(u))
      return d.get(u);
    var h = r.apply(this, c);
    return s.cache = d.set(u, h) || d, h;
  };
  return s.cache = new (memoize$1.Cache || MapCache$2)(), s;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(r) {
  var a = memoize(r, function(c) {
    return s.size === MAX_MEMOIZE_SIZE && s.clear(), c;
  }), s = a.cache;
  return a;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(r) {
  var a = [];
  return r.charCodeAt(0) === 46 && a.push(""), r.replace(rePropName, function(s, c, u, d) {
    a.push(u ? d.replace(reEscapeChar, "$1") : c || s);
  }), a;
}), _stringToPath = stringToPath$1;
function arrayMap$1(r, a) {
  for (var s = -1, c = r == null ? 0 : r.length, u = Array(c); ++s < c; )
    u[s] = a(r[s], s, r);
  return u;
}
var _arrayMap = arrayMap$1, Symbol$2 = _Symbol, arrayMap = _arrayMap, isArray$6 = isArray_1, isSymbol$1 = isSymbol_1, INFINITY$1 = 1 / 0, symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(r) {
  if (typeof r == "string")
    return r;
  if (isArray$6(r))
    return arrayMap(r, baseToString$1) + "";
  if (isSymbol$1(r))
    return symbolToString ? symbolToString.call(r) : "";
  var a = r + "";
  return a == "0" && 1 / r == -INFINITY$1 ? "-0" : a;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$2(r) {
  return r == null ? "" : baseToString(r);
}
var toString_1 = toString$2, isArray$5 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$1 = toString_1;
function castPath$2(r, a) {
  return isArray$5(r) ? r : isKey$2(r, a) ? [r] : stringToPath(toString$1(r));
}
var _castPath = castPath$2, baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(r) {
  return isObjectLike$3(r) && baseGetTag$2(r) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1, objectProto$6 = Object.prototype, hasOwnProperty$4 = objectProto$6.hasOwnProperty, propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable, isArguments$2 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(r) {
  return isObjectLike$2(r) && hasOwnProperty$4.call(r, "callee") && !propertyIsEnumerable$1.call(r, "callee");
}, isArguments_1 = isArguments$2, MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(r, a) {
  var s = typeof r;
  return a = a ?? MAX_SAFE_INTEGER$1, !!a && (s == "number" || s != "symbol" && reIsUint.test(r)) && r > -1 && r % 1 == 0 && r < a;
}
var _isIndex = isIndex$2, MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3, isSymbol = isSymbol_1, INFINITY = 1 / 0;
function toKey$4(r) {
  if (typeof r == "string" || isSymbol(r))
    return r;
  var a = r + "";
  return a == "0" && 1 / r == -INFINITY ? "-0" : a;
}
var _toKey = toKey$4, castPath$1 = _castPath, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isIndex$1 = _isIndex, isLength$2 = isLength_1, toKey$3 = _toKey;
function hasPath$2(r, a, s) {
  a = castPath$1(a, r);
  for (var c = -1, u = a.length, d = !1; ++c < u; ) {
    var h = toKey$3(a[c]);
    if (!(d = r != null && s(r, h)))
      break;
    r = r[h];
  }
  return d || ++c != u ? d : (u = r == null ? 0 : r.length, !!u && isLength$2(u) && isIndex$1(h, u) && (isArray$4(r) || isArguments$1(r)));
}
var _hasPath = hasPath$2, baseHas = _baseHas, hasPath$1 = _hasPath;
function has(r, a) {
  return r != null && hasPath$1(r, a, baseHas);
}
var has_1 = has;
const has$1 = /* @__PURE__ */ getDefaultExportFromCjs(has_1), isSchema = (r) => r && r.__isYupSchema__;
class Condition {
  constructor(a, s) {
    if (this.fn = void 0, this.refs = a, this.refs = a, typeof s == "function") {
      this.fn = s;
      return;
    }
    if (!has$1(s, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!s.then && !s.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: c,
      then: u,
      otherwise: d
    } = s, h = typeof c == "function" ? c : (...p) => p.every((m) => m === c);
    this.fn = function(...p) {
      let m = p.pop(), g = p.pop(), v = h(...p) ? u : d;
      if (v)
        return typeof v == "function" ? v(g) : g.concat(v.resolve(m));
    };
  }
  resolve(a, s) {
    let c = this.refs.map((d) => d.getValue(s == null ? void 0 : s.value, s == null ? void 0 : s.parent, s == null ? void 0 : s.context)), u = this.fn.apply(a, c.concat(a, s));
    if (u === void 0 || u === a) return a;
    if (!isSchema(u)) throw new TypeError("conditions must return a schema object");
    return u.resolve(s);
  }
}
function toArray(r) {
  return r == null ? [] : [].concat(r);
}
function _extends$2() {
  return _extends$2 = Object.assign || function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var c in s)
        Object.prototype.hasOwnProperty.call(s, c) && (r[c] = s[c]);
    }
    return r;
  }, _extends$2.apply(this, arguments);
}
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(a, s) {
    const c = s.label || s.path || "this";
    return c !== s.path && (s = _extends$2({}, s, {
      path: c
    })), typeof a == "string" ? a.replace(strReg, (u, d) => printValue(s[d])) : typeof a == "function" ? a(s) : a;
  }
  static isError(a) {
    return a && a.name === "ValidationError";
  }
  constructor(a, s, c, u) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = s, this.path = c, this.type = u, this.errors = [], this.inner = [], toArray(a).forEach((d) => {
      ValidationError.isError(d) ? (this.errors.push(...d.errors), this.inner = this.inner.concat(d.inner.length ? d.inner : d)) : this.errors.push(d);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, ValidationError);
  }
}
const once = (r) => {
  let a = !1;
  return (...s) => {
    a || (a = !0, r(...s));
  };
};
function runTests(r, a) {
  let {
    endEarly: s,
    tests: c,
    args: u,
    value: d,
    errors: h,
    sort: p,
    path: m
  } = r, g = once(a), v = c.length;
  const y = [];
  if (h = h || [], !v) return h.length ? g(new ValidationError(h, d, m)) : g(null, d);
  for (let x = 0; x < c.length; x++) {
    const w = c[x];
    w(u, function(M) {
      if (M) {
        if (!ValidationError.isError(M))
          return g(M, d);
        if (s)
          return M.value = d, g(M, d);
        y.push(M);
      }
      if (--v <= 0) {
        if (y.length && (p && y.sort(p), h.length && y.push(...h), h = y), h.length) {
          g(new ValidationError(h, d, m), d);
          return;
        }
        g(null, d);
      }
    });
  }
}
var getNative$4 = _getNative, defineProperty$1 = function() {
  try {
    var r = getNative$4(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}(), _defineProperty = defineProperty$1, defineProperty = _defineProperty;
function baseAssignValue$1(r, a, s) {
  a == "__proto__" && defineProperty ? defineProperty(r, a, {
    configurable: !0,
    enumerable: !0,
    value: s,
    writable: !0
  }) : r[a] = s;
}
var _baseAssignValue = baseAssignValue$1;
function createBaseFor$1(r) {
  return function(a, s, c) {
    for (var u = -1, d = Object(a), h = c(a), p = h.length; p--; ) {
      var m = h[r ? p : ++u];
      if (s(d[m], m, d) === !1)
        break;
    }
    return a;
  };
}
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$1 = createBaseFor(), _baseFor = baseFor$1;
function baseTimes$1(r, a) {
  for (var s = -1, c = Array(r); ++s < r; )
    c[s] = a(s);
  return c;
}
var _baseTimes = baseTimes$1, isBuffer$2 = { exports: {} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(r, a) {
  var s = _root, c = stubFalse_1, u = a && !a.nodeType && a, d = u && !0 && r && !r.nodeType && r, h = d && d.exports === u, p = h ? s.Buffer : void 0, m = p ? p.isBuffer : void 0, g = m || c;
  r.exports = g;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports, baseGetTag$1 = _baseGetTag, isLength$1 = isLength_1, isObjectLike$1 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(r) {
  return isObjectLike$1(r) && isLength$1(r.length) && !!typedArrayTags[baseGetTag$1(r)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(r) {
  return function(a) {
    return r(a);
  };
}
var _baseUnary = baseUnary$1, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(r, a) {
  var s = _freeGlobal, c = a && !a.nodeType && a, u = c && !0 && r && !r.nodeType && r, d = u && u.exports === c, h = d && s.process, p = function() {
    try {
      var m = u && u.require && u.require("util").types;
      return m || h && h.binding && h.binding("util");
    } catch {
    }
  }();
  r.exports = p;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$2, baseTimes = _baseTimes, isArguments = isArguments_1, isArray$3 = isArray_1, isBuffer$1 = isBufferExports, isIndex = _isIndex, isTypedArray$1 = isTypedArray_1, objectProto$5 = Object.prototype, hasOwnProperty$3 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$1(r, a) {
  var s = isArray$3(r), c = !s && isArguments(r), u = !s && !c && isBuffer$1(r), d = !s && !c && !u && isTypedArray$1(r), h = s || c || u || d, p = h ? baseTimes(r.length, String) : [], m = p.length;
  for (var g in r)
    (a || hasOwnProperty$3.call(r, g)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
    (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    u && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    d && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
    isIndex(g, m))) && p.push(g);
  return p;
}
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$4 = Object.prototype;
function isPrototype$1(r) {
  var a = r && r.constructor, s = typeof a == "function" && a.prototype || objectProto$4;
  return r === s;
}
var _isPrototype = isPrototype$1;
function overArg$1(r, a) {
  return function(s) {
    return r(a(s));
  };
}
var _overArg = overArg$1, overArg = _overArg, nativeKeys$1 = overArg(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$3 = Object.prototype, hasOwnProperty$2 = objectProto$3.hasOwnProperty;
function baseKeys$1(r) {
  if (!isPrototype(r))
    return nativeKeys(r);
  var a = [];
  for (var s in Object(r))
    hasOwnProperty$2.call(r, s) && s != "constructor" && a.push(s);
  return a;
}
var _baseKeys = baseKeys$1, isFunction$1 = isFunction_1, isLength = isLength_1;
function isArrayLike$1(r) {
  return r != null && isLength(r.length) && !isFunction$1(r);
}
var isArrayLike_1 = isArrayLike$1, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike = isArrayLike_1;
function keys$3(r) {
  return isArrayLike(r) ? arrayLikeKeys(r) : baseKeys(r);
}
var keys_1 = keys$3, baseFor = _baseFor, keys$2 = keys_1;
function baseForOwn$1(r, a) {
  return r && baseFor(r, a, keys$2);
}
var _baseForOwn = baseForOwn$1, ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(r) {
  var a = this.__data__, s = a.delete(r);
  return this.size = a.size, s;
}
var _stackDelete = stackDelete$1;
function stackGet$1(r) {
  return this.__data__.get(r);
}
var _stackGet = stackGet$1;
function stackHas$1(r) {
  return this.__data__.has(r);
}
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(r, a) {
  var s = this.__data__;
  if (s instanceof ListCache$1) {
    var c = s.__data__;
    if (!Map$2 || c.length < LARGE_ARRAY_SIZE - 1)
      return c.push([r, a]), this.size = ++s.size, this;
    s = this.__data__ = new MapCache$1(c);
  }
  return s.set(r, a), this.size = s.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(r) {
  var a = this.__data__ = new ListCache(r);
  this.size = a.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(r) {
  return this.__data__.set(r, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(r) {
  return this.__data__.has(r);
}
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(r) {
  var a = -1, s = r == null ? 0 : r.length;
  for (this.__data__ = new MapCache(); ++a < s; )
    this.add(r[a]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(r, a) {
  for (var s = -1, c = r == null ? 0 : r.length; ++s < c; )
    if (a(r[s], s, r))
      return !0;
  return !1;
}
var _arraySome = arraySome$1;
function cacheHas$1(r, a) {
  return r.has(a);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(r, a, s, c, u, d) {
  var h = s & COMPARE_PARTIAL_FLAG$5, p = r.length, m = a.length;
  if (p != m && !(h && m > p))
    return !1;
  var g = d.get(r), v = d.get(a);
  if (g && v)
    return g == a && v == r;
  var y = -1, x = !0, w = s & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (d.set(r, a), d.set(a, r); ++y < p; ) {
    var S = r[y], M = a[y];
    if (c)
      var P = h ? c(M, S, y, a, r, d) : c(S, M, y, r, a, d);
    if (P !== void 0) {
      if (P)
        continue;
      x = !1;
      break;
    }
    if (w) {
      if (!arraySome(a, function(L, I) {
        if (!cacheHas(w, I) && (S === L || u(S, L, s, c, d)))
          return w.push(I);
      })) {
        x = !1;
        break;
      }
    } else if (!(S === M || u(S, M, s, c, d))) {
      x = !1;
      break;
    }
  }
  return d.delete(r), d.delete(a), x;
}
var _equalArrays = equalArrays$2, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(r) {
  var a = -1, s = Array(r.size);
  return r.forEach(function(c, u) {
    s[++a] = [u, c];
  }), s;
}
var _mapToArray = mapToArray$1;
function setToArray$1(r) {
  var a = -1, s = Array(r.size);
  return r.forEach(function(c) {
    s[++a] = c;
  }), s;
}
var _setToArray = setToArray$1, Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(r, a, s, c, u, d, h) {
  switch (s) {
    case dataViewTag$1:
      if (r.byteLength != a.byteLength || r.byteOffset != a.byteOffset)
        return !1;
      r = r.buffer, a = a.buffer;
    case arrayBufferTag:
      return !(r.byteLength != a.byteLength || !d(new Uint8Array$1(r), new Uint8Array$1(a)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+r, +a);
    case errorTag:
      return r.name == a.name && r.message == a.message;
    case regexpTag:
    case stringTag:
      return r == a + "";
    case mapTag$1:
      var p = mapToArray;
    case setTag$1:
      var m = c & COMPARE_PARTIAL_FLAG$4;
      if (p || (p = setToArray), r.size != a.size && !m)
        return !1;
      var g = h.get(r);
      if (g)
        return g == a;
      c |= COMPARE_UNORDERED_FLAG$2, h.set(r, a);
      var v = equalArrays$1(p(r), p(a), c, u, d, h);
      return h.delete(r), v;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(r) == symbolValueOf.call(a);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(r, a) {
  for (var s = -1, c = a.length, u = r.length; ++s < c; )
    r[u + s] = a[s];
  return r;
}
var _arrayPush = arrayPush$1, arrayPush = _arrayPush, isArray$2 = isArray_1;
function baseGetAllKeys$1(r, a, s) {
  var c = a(r);
  return isArray$2(r) ? c : arrayPush(c, s(r));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(r, a) {
  for (var s = -1, c = r == null ? 0 : r.length, u = 0, d = []; ++s < c; ) {
    var h = r[s];
    a(h, s, r) && (d[u++] = h);
  }
  return d;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$2 = Object.prototype, propertyIsEnumerable = objectProto$2.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(r) {
  return r == null ? [] : (r = Object(r), arrayFilter(nativeGetSymbols(r), function(a) {
    return propertyIsEnumerable.call(r, a);
  }));
} : stubArray, _getSymbols = getSymbols$1, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(r) {
  return baseGetAllKeys(r, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(r, a, s, c, u, d) {
  var h = s & COMPARE_PARTIAL_FLAG$3, p = getAllKeys(r), m = p.length, g = getAllKeys(a), v = g.length;
  if (m != v && !h)
    return !1;
  for (var y = m; y--; ) {
    var x = p[y];
    if (!(h ? x in a : hasOwnProperty$1.call(a, x)))
      return !1;
  }
  var w = d.get(r), S = d.get(a);
  if (w && S)
    return w == a && S == r;
  var M = !0;
  d.set(r, a), d.set(a, r);
  for (var P = h; ++y < m; ) {
    x = p[y];
    var L = r[x], I = a[x];
    if (c)
      var T = h ? c(I, L, x, a, r, d) : c(L, I, x, r, a, d);
    if (!(T === void 0 ? L === I || u(L, I, s, c, d) : T)) {
      M = !1;
      break;
    }
    P || (P = x == "constructor");
  }
  if (M && !P) {
    var E = r.constructor, R = a.constructor;
    E != R && "constructor" in r && "constructor" in a && !(typeof E == "function" && E instanceof E && typeof R == "function" && R instanceof R) && (M = !1);
  }
  return d.delete(r), d.delete(a), M;
}
var _equalObjects = equalObjects$1, getNative$3 = _getNative, root$3 = _root, DataView$2 = getNative$3(root$3, "DataView"), _DataView = DataView$2, getNative$2 = _getNative, root$2 = _root, Promise$2 = getNative$2(root$2, "Promise"), _Promise = Promise$2, getNative$1 = _getNative, root$1 = _root, Set$2 = getNative$1(root$1, "Set"), _Set = Set$2, getNative = _getNative, root = _root, WeakMap$2 = getNative(root, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag$1 = baseGetTag;
(DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) && (getTag$1 = function(r) {
  var a = baseGetTag(r), s = a == objectTag$1 ? r.constructor : void 0, c = s ? toSource(s) : "";
  if (c)
    switch (c) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return a;
});
var _getTag = getTag$1, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$1 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(r, a, s, c, u, d) {
  var h = isArray$1(r), p = isArray$1(a), m = h ? arrayTag : getTag(r), g = p ? arrayTag : getTag(a);
  m = m == argsTag ? objectTag : m, g = g == argsTag ? objectTag : g;
  var v = m == objectTag, y = g == objectTag, x = m == g;
  if (x && isBuffer(r)) {
    if (!isBuffer(a))
      return !1;
    h = !0, v = !1;
  }
  if (x && !v)
    return d || (d = new Stack$1()), h || isTypedArray(r) ? equalArrays(r, a, s, c, u, d) : equalByTag(r, a, m, s, c, u, d);
  if (!(s & COMPARE_PARTIAL_FLAG$2)) {
    var w = v && hasOwnProperty.call(r, "__wrapped__"), S = y && hasOwnProperty.call(a, "__wrapped__");
    if (w || S) {
      var M = w ? r.value() : r, P = S ? a.value() : a;
      return d || (d = new Stack$1()), u(M, P, s, c, d);
    }
  }
  return x ? (d || (d = new Stack$1()), equalObjects(r, a, s, c, u, d)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(r, a, s, c, u) {
  return r === a ? !0 : r == null || a == null || !isObjectLike(r) && !isObjectLike(a) ? r !== r && a !== a : baseIsEqualDeep(r, a, s, c, baseIsEqual$2, u);
}
var _baseIsEqual = baseIsEqual$2, Stack = _Stack, baseIsEqual$1 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(r, a, s, c) {
  var u = s.length, d = u, h = !c;
  if (r == null)
    return !d;
  for (r = Object(r); u--; ) {
    var p = s[u];
    if (h && p[2] ? p[1] !== r[p[0]] : !(p[0] in r))
      return !1;
  }
  for (; ++u < d; ) {
    p = s[u];
    var m = p[0], g = r[m], v = p[1];
    if (h && p[2]) {
      if (g === void 0 && !(m in r))
        return !1;
    } else {
      var y = new Stack();
      if (c)
        var x = c(g, v, m, r, a, y);
      if (!(x === void 0 ? baseIsEqual$1(v, g, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, c, y) : x))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject = isObject_1;
function isStrictComparable$2(r) {
  return r === r && !isObject(r);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(r) {
  for (var a = keys(r), s = a.length; s--; ) {
    var c = a[s], u = r[c];
    a[s] = [c, u, isStrictComparable$1(u)];
  }
  return a;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(r, a) {
  return function(s) {
    return s == null ? !1 : s[r] === a && (a !== void 0 || r in Object(s));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(r) {
  var a = getMatchData(r);
  return a.length == 1 && a[0][2] ? matchesStrictComparable$1(a[0][0], a[0][1]) : function(s) {
    return s === r || baseIsMatch(s, r, a);
  };
}
var _baseMatches = baseMatches$1, castPath = _castPath, toKey$2 = _toKey;
function baseGet$2(r, a) {
  a = castPath(a, r);
  for (var s = 0, c = a.length; r != null && s < c; )
    r = r[toKey$2(a[s++])];
  return s && s == c ? r : void 0;
}
var _baseGet = baseGet$2, baseGet$1 = _baseGet;
function get$1(r, a, s) {
  var c = r == null ? void 0 : baseGet$1(r, a);
  return c === void 0 ? s : c;
}
var get_1 = get$1;
function baseHasIn$1(r, a) {
  return r != null && a in Object(r);
}
var _baseHasIn = baseHasIn$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(r, a) {
  return r != null && hasPath(r, a, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(r, a) {
  return isKey$1(r) && isStrictComparable(a) ? matchesStrictComparable(toKey$1(r), a) : function(s) {
    var c = get(s, r);
    return c === void 0 && c === a ? hasIn(s, r) : baseIsEqual(a, c, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$1(r) {
  return r;
}
var identity_1 = identity$1;
function baseProperty$1(r) {
  return function(a) {
    return a == null ? void 0 : a[r];
  };
}
var _baseProperty = baseProperty$1, baseGet = _baseGet;
function basePropertyDeep$1(r) {
  return function(a) {
    return baseGet(a, r);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(r) {
  return isKey(r) ? baseProperty(toKey(r)) : basePropertyDeep(r);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray = isArray_1, property = property_1;
function baseIteratee$1(r) {
  return typeof r == "function" ? r : r == null ? identity : typeof r == "object" ? isArray(r) ? baseMatchesProperty(r[0], r[1]) : baseMatches(r) : property(r);
}
var _baseIteratee = baseIteratee$1, baseAssignValue = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee = _baseIteratee;
function mapValues(r, a) {
  var s = {};
  return a = baseIteratee(a), baseForOwn(r, function(c, u, d) {
    baseAssignValue(s, u, a(c, u, d));
  }), s;
}
var mapValues_1 = mapValues;
const mapValues$1 = /* @__PURE__ */ getDefaultExportFromCjs(mapValues_1);
function Cache(r) {
  this._maxSize = r, this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Cache.prototype.get = function(r) {
  return this._values[r];
};
Cache.prototype.set = function(r, a) {
  return this._size >= this._maxSize && this.clear(), r in this._values || this._size++, this._values[r] = a;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512, pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE), propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(r) {
    var a = normalizePath(r);
    return setCache.get(r) || setCache.set(r, function(c, u) {
      for (var d = 0, h = a.length, p = c; d < h - 1; ) {
        var m = a[d];
        if (m === "__proto__" || m === "constructor" || m === "prototype")
          return c;
        p = p[a[d++]];
      }
      p[a[d]] = u;
    });
  },
  getter: function(r, a) {
    var s = normalizePath(r);
    return getCache.get(r) || getCache.set(r, function(u) {
      for (var d = 0, h = s.length; d < h; )
        if (u != null || !a) u = u[s[d++]];
        else return;
      return u;
    });
  },
  join: function(r) {
    return r.reduce(function(a, s) {
      return a + (isQuoted(s) || DIGIT_REGEX.test(s) ? "[" + s + "]" : (a ? "." : "") + s);
    }, "");
  },
  forEach: function(r, a, s) {
    forEach(Array.isArray(r) ? r : split(r), a, s);
  }
};
function normalizePath(r) {
  return pathCache.get(r) || pathCache.set(
    r,
    split(r).map(function(a) {
      return a.replace(CLEAN_QUOTES_REGEX, "$2");
    })
  );
}
function split(r) {
  return r.match(SPLIT_REGEX) || [""];
}
function forEach(r, a, s) {
  var c = r.length, u, d, h, p;
  for (d = 0; d < c; d++)
    u = r[d], u && (shouldBeQuoted(u) && (u = '"' + u + '"'), p = isQuoted(u), h = !p && /^\d+$/.test(u), a.call(s, u, p, h, d, r));
}
function isQuoted(r) {
  return typeof r == "string" && r && ["'", '"'].indexOf(r.charAt(0)) !== -1;
}
function hasLeadingNumber(r) {
  return r.match(LEAD_DIGIT_REGEX) && !r.match(DIGIT_REGEX);
}
function hasSpecialChars(r) {
  return SPEC_CHAR_REGEX.test(r);
}
function shouldBeQuoted(r) {
  return !isQuoted(r) && (hasLeadingNumber(r) || hasSpecialChars(r));
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(a, s = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof a != "string") throw new TypeError("ref must be a string, got: " + a);
    if (this.key = a.trim(), a === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context, this.isValue = this.key[0] === prefixes.value, this.isSibling = !this.isContext && !this.isValue;
    let c = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(c.length), this.getter = this.path && propertyExpr.getter(this.path, !0), this.map = s.map;
  }
  getValue(a, s, c) {
    let u = this.isContext ? c : this.isValue ? a : s;
    return this.getter && (u = this.getter(u || {})), this.map && (u = this.map(u)), u;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(a, s) {
    return this.getValue(a, s == null ? void 0 : s.parent, s == null ? void 0 : s.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(a) {
    return a && a.__isYupRef;
  }
}
Reference.prototype.__isYupRef = !0;
function _extends$1() {
  return _extends$1 = Object.assign || function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var c in s)
        Object.prototype.hasOwnProperty.call(s, c) && (r[c] = s[c]);
    }
    return r;
  }, _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(r, a) {
  if (r == null) return {};
  var s = {}, c = Object.keys(r), u, d;
  for (d = 0; d < c.length; d++)
    u = c[d], !(a.indexOf(u) >= 0) && (s[u] = r[u]);
  return s;
}
function createValidation(r) {
  function a(s, c) {
    let {
      value: u,
      path: d = "",
      label: h,
      options: p,
      originalValue: m,
      sync: g
    } = s, v = _objectWithoutPropertiesLoose(s, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: y,
      test: x,
      params: w,
      message: S
    } = r;
    let {
      parent: M,
      context: P
    } = p;
    function L(A) {
      return Reference.isRef(A) ? A.getValue(u, M, P) : A;
    }
    function I(A = {}) {
      const k = mapValues$1(_extends$1({
        value: u,
        originalValue: m,
        label: h,
        path: A.path || d
      }, w, A.params), L), V = new ValidationError(ValidationError.formatError(A.message || S, k), u, k.path, A.type || y);
      return V.params = k, V;
    }
    let T = _extends$1({
      path: d,
      parent: M,
      type: y,
      createError: I,
      resolve: L,
      options: p,
      originalValue: m
    }, v);
    if (!g) {
      try {
        Promise.resolve(x.call(T, u, T)).then((A) => {
          ValidationError.isError(A) ? c(A) : A ? c(null, A) : c(I());
        }).catch(c);
      } catch (A) {
        c(A);
      }
      return;
    }
    let E;
    try {
      var R;
      if (E = x.call(T, u, T), typeof ((R = E) == null ? void 0 : R.then) == "function")
        throw new Error(`Validation test of type: "${T.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (A) {
      c(A);
      return;
    }
    ValidationError.isError(E) ? c(E) : E ? c(null, E) : c(I());
  }
  return a.OPTIONS = r, a;
}
let trim = (r) => r.substr(0, r.length - 1).substr(1);
function getIn(r, a, s, c = s) {
  let u, d, h;
  return a ? (propertyExpr.forEach(a, (p, m, g) => {
    let v = m ? trim(p) : p;
    if (r = r.resolve({
      context: c,
      parent: u,
      value: s
    }), r.innerType) {
      let y = g ? parseInt(v, 10) : 0;
      if (s && y >= s.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${p}, in the path: ${a}. because there is no value at that index. `);
      u = s, s = s && s[y], r = r.innerType;
    }
    if (!g) {
      if (!r.fields || !r.fields[v]) throw new Error(`The schema does not contain the path: ${a}. (failed at: ${h} which is a type: "${r._type}")`);
      u = s, s = s && s[v], r = r.fields[v];
    }
    d = v, h = m ? "[" + p + "]" : "." + p;
  }), {
    schema: r,
    parent: u,
    parentPath: d
  }) : {
    parent: u,
    parentPath: a,
    schema: r
  };
}
const reach = (r, a, s, c) => getIn(r, a, s, c).schema;
class ReferenceSet {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const a = [];
    for (const s of this.list) a.push(s);
    for (const [, s] of this.refs) a.push(s.describe());
    return a;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(a) {
    return this.toArray().reduce((s, c) => s.concat(Reference.isRef(c) ? a(c) : c), []);
  }
  add(a) {
    Reference.isRef(a) ? this.refs.set(a.key, a) : this.list.add(a);
  }
  delete(a) {
    Reference.isRef(a) ? this.refs.delete(a.key) : this.list.delete(a);
  }
  clone() {
    const a = new ReferenceSet();
    return a.list = new Set(this.list), a.refs = new Map(this.refs), a;
  }
  merge(a, s) {
    const c = this.clone();
    return a.list.forEach((u) => c.add(u)), a.refs.forEach((u) => c.add(u)), s.list.forEach((u) => c.delete(u)), s.refs.forEach((u) => c.delete(u)), c;
  }
}
function _extends() {
  return _extends = Object.assign || function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var c in s)
        Object.prototype.hasOwnProperty.call(s, c) && (r[c] = s[c]);
    }
    return r;
  }, _extends.apply(this, arguments);
}
class BaseSchema {
  constructor(a) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new ReferenceSet(), this._blacklist = new ReferenceSet(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(mixed.notType);
    }), this.type = (a == null ? void 0 : a.type) || "mixed", this.spec = _extends({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, a == null ? void 0 : a.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(a) {
    return !0;
  }
  clone(a) {
    if (this._mutate)
      return a && Object.assign(this.spec, a), this;
    const s = Object.create(Object.getPrototypeOf(this));
    return s.type = this.type, s._typeError = this._typeError, s._whitelistError = this._whitelistError, s._blacklistError = this._blacklistError, s._whitelist = this._whitelist.clone(), s._blacklist = this._blacklist.clone(), s.exclusiveTests = _extends({}, this.exclusiveTests), s.deps = [...this.deps], s.conditions = [...this.conditions], s.tests = [...this.tests], s.transforms = [...this.transforms], s.spec = clone(_extends({}, this.spec, a)), s;
  }
  label(a) {
    let s = this.clone();
    return s.spec.label = a, s;
  }
  meta(...a) {
    if (a.length === 0) return this.spec.meta;
    let s = this.clone();
    return s.spec.meta = Object.assign(s.spec.meta || {}, a[0]), s;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(a) {
    let s = this._mutate;
    this._mutate = !0;
    let c = a(this);
    return this._mutate = s, c;
  }
  concat(a) {
    if (!a || a === this) return this;
    if (a.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${a.type}`);
    let s = this, c = a.clone();
    const u = _extends({}, s.spec, c.spec);
    return c.spec = u, c._typeError || (c._typeError = s._typeError), c._whitelistError || (c._whitelistError = s._whitelistError), c._blacklistError || (c._blacklistError = s._blacklistError), c._whitelist = s._whitelist.merge(a._whitelist, a._blacklist), c._blacklist = s._blacklist.merge(a._blacklist, a._whitelist), c.tests = s.tests, c.exclusiveTests = s.exclusiveTests, c.withMutation((d) => {
      a.tests.forEach((h) => {
        d.test(h.OPTIONS);
      });
    }), c.transforms = [...s.transforms, ...c.transforms], c;
  }
  isType(a) {
    return this.spec.nullable && a === null ? !0 : this._typeCheck(a);
  }
  resolve(a) {
    let s = this;
    if (s.conditions.length) {
      let c = s.conditions;
      s = s.clone(), s.conditions = [], s = c.reduce((u, d) => d.resolve(u, a), s), s = s.resolve(a);
    }
    return s;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(a, s = {}) {
    let c = this.resolve(_extends({
      value: a
    }, s)), u = c._cast(a, s);
    if (a !== void 0 && s.assert !== !1 && c.isType(u) !== !0) {
      let d = printValue(a), h = printValue(u);
      throw new TypeError(`The value of ${s.path || "field"} could not be cast to a value that satisfies the schema type: "${c._type}". 

attempted value: ${d} 
` + (h !== d ? `result of cast: ${h}` : ""));
    }
    return u;
  }
  _cast(a, s) {
    let c = a === void 0 ? a : this.transforms.reduce((u, d) => d.call(this, u, a, this), a);
    return c === void 0 && (c = this.getDefault()), c;
  }
  _validate(a, s = {}, c) {
    let {
      sync: u,
      path: d,
      from: h = [],
      originalValue: p = a,
      strict: m = this.spec.strict,
      abortEarly: g = this.spec.abortEarly
    } = s, v = a;
    m || (v = this._cast(v, _extends({
      assert: !1
    }, s)));
    let y = {
      value: v,
      path: d,
      options: s,
      originalValue: p,
      schema: this,
      label: this.spec.label,
      sync: u,
      from: h
    }, x = [];
    this._typeError && x.push(this._typeError);
    let w = [];
    this._whitelistError && w.push(this._whitelistError), this._blacklistError && w.push(this._blacklistError), runTests({
      args: y,
      value: v,
      path: d,
      sync: u,
      tests: x,
      endEarly: g
    }, (S) => {
      if (S) return void c(S, v);
      runTests({
        tests: this.tests.concat(w),
        args: y,
        path: d,
        sync: u,
        value: v,
        endEarly: g
      }, c);
    });
  }
  validate(a, s, c) {
    let u = this.resolve(_extends({}, s, {
      value: a
    }));
    return typeof c == "function" ? u._validate(a, s, c) : new Promise((d, h) => u._validate(a, s, (p, m) => {
      p ? h(p) : d(m);
    }));
  }
  validateSync(a, s) {
    let c = this.resolve(_extends({}, s, {
      value: a
    })), u;
    return c._validate(a, _extends({}, s, {
      sync: !0
    }), (d, h) => {
      if (d) throw d;
      u = h;
    }), u;
  }
  isValid(a, s) {
    return this.validate(a, s).then(() => !0, (c) => {
      if (ValidationError.isError(c)) return !1;
      throw c;
    });
  }
  isValidSync(a, s) {
    try {
      return this.validateSync(a, s), !0;
    } catch (c) {
      if (ValidationError.isError(c)) return !1;
      throw c;
    }
  }
  _getDefault() {
    let a = this.spec.default;
    return a == null ? a : typeof a == "function" ? a.call(this) : clone(a);
  }
  getDefault(a) {
    return this.resolve(a || {})._getDefault();
  }
  default(a) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: a
    });
  }
  strict(a = !0) {
    let s = this.clone();
    return s.spec.strict = a, s;
  }
  _isPresent(a) {
    return a != null;
  }
  defined(a = mixed.defined) {
    return this.test({
      message: a,
      name: "defined",
      exclusive: !0,
      test(s) {
        return s !== void 0;
      }
    });
  }
  required(a = mixed.required) {
    return this.clone({
      presence: "required"
    }).withMutation((s) => s.test({
      message: a,
      name: "required",
      exclusive: !0,
      test(c) {
        return this.schema._isPresent(c);
      }
    }));
  }
  notRequired() {
    let a = this.clone({
      presence: "optional"
    });
    return a.tests = a.tests.filter((s) => s.OPTIONS.name !== "required"), a;
  }
  nullable(a = !0) {
    return this.clone({
      nullable: a !== !1
    });
  }
  transform(a) {
    let s = this.clone();
    return s.transforms.push(a), s;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...a) {
    let s;
    if (a.length === 1 ? typeof a[0] == "function" ? s = {
      test: a[0]
    } : s = a[0] : a.length === 2 ? s = {
      name: a[0],
      test: a[1]
    } : s = {
      name: a[0],
      message: a[1],
      test: a[2]
    }, s.message === void 0 && (s.message = mixed.default), typeof s.test != "function") throw new TypeError("`test` is a required parameters");
    let c = this.clone(), u = createValidation(s), d = s.exclusive || s.name && c.exclusiveTests[s.name] === !0;
    if (s.exclusive && !s.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return s.name && (c.exclusiveTests[s.name] = !!s.exclusive), c.tests = c.tests.filter((h) => !(h.OPTIONS.name === s.name && (d || h.OPTIONS.test === u.OPTIONS.test))), c.tests.push(u), c;
  }
  when(a, s) {
    !Array.isArray(a) && typeof a != "string" && (s = a, a = ".");
    let c = this.clone(), u = toArray(a).map((d) => new Reference(d));
    return u.forEach((d) => {
      d.isSibling && c.deps.push(d.key);
    }), c.conditions.push(new Condition(u, s)), c;
  }
  typeError(a) {
    let s = this.clone();
    return s._typeError = createValidation({
      message: a,
      name: "typeError",
      test(c) {
        return c !== void 0 && !this.schema.isType(c) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), s;
  }
  oneOf(a, s = mixed.oneOf) {
    let c = this.clone();
    return a.forEach((u) => {
      c._whitelist.add(u), c._blacklist.delete(u);
    }), c._whitelistError = createValidation({
      message: s,
      name: "oneOf",
      test(u) {
        if (u === void 0) return !0;
        let d = this.schema._whitelist, h = d.resolveAll(this.resolve);
        return h.includes(u) ? !0 : this.createError({
          params: {
            values: d.toArray().join(", "),
            resolved: h
          }
        });
      }
    }), c;
  }
  notOneOf(a, s = mixed.notOneOf) {
    let c = this.clone();
    return a.forEach((u) => {
      c._blacklist.add(u), c._whitelist.delete(u);
    }), c._blacklistError = createValidation({
      message: s,
      name: "notOneOf",
      test(u) {
        let d = this.schema._blacklist, h = d.resolveAll(this.resolve);
        return h.includes(u) ? this.createError({
          params: {
            values: d.toArray().join(", "),
            resolved: h
          }
        }) : !0;
      }
    }), c;
  }
  strip(a = !0) {
    let s = this.clone();
    return s.spec.strip = a, s;
  }
  describe() {
    const a = this.clone(), {
      label: s,
      meta: c
    } = a.spec;
    return {
      meta: c,
      label: s,
      type: a.type,
      oneOf: a._whitelist.describe(),
      notOneOf: a._blacklist.describe(),
      tests: a.tests.map((d) => ({
        name: d.OPTIONS.name,
        params: d.OPTIONS.params
      })).filter((d, h, p) => p.findIndex((m) => m.name === d.name) === h)
    };
  }
}
BaseSchema.prototype.__isYupSchema__ = !0;
for (const r of ["validate", "validateSync"]) BaseSchema.prototype[`${r}At`] = function(a, s, c = {}) {
  const {
    parent: u,
    parentPath: d,
    schema: h
  } = getIn(this, a, s, c.context);
  return h[r](u && u[d], _extends({}, c, {
    parent: u,
    path: a
  }));
};
for (const r of ["equals", "is"]) BaseSchema.prototype[r] = BaseSchema.prototype.oneOf;
for (const r of ["not", "nope"]) BaseSchema.prototype[r] = BaseSchema.prototype.notOneOf;
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
var toposort$1 = { exports: {} };
toposort$1.exports = function(r) {
  return toposort(uniqueNodes(r), r);
};
toposort$1.exports.array = toposort;
function toposort(r, a) {
  var s = r.length, c = new Array(s), u = {}, d = s, h = makeOutgoingEdges(a), p = makeNodesHash(r);
  for (a.forEach(function(g) {
    if (!p.has(g[0]) || !p.has(g[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); d--; )
    u[d] || m(r[d], d, /* @__PURE__ */ new Set());
  return c;
  function m(g, v, y) {
    if (y.has(g)) {
      var x;
      try {
        x = ", node was:" + JSON.stringify(g);
      } catch {
        x = "";
      }
      throw new Error("Cyclic dependency" + x);
    }
    if (!p.has(g))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(g));
    if (!u[v]) {
      u[v] = !0;
      var w = h.get(g) || /* @__PURE__ */ new Set();
      if (w = Array.from(w), v = w.length) {
        y.add(g);
        do {
          var S = w[--v];
          m(S, p.get(S), y);
        } while (v);
        y.delete(g);
      }
      c[--s] = g;
    }
  }
}
function uniqueNodes(r) {
  for (var a = /* @__PURE__ */ new Set(), s = 0, c = r.length; s < c; s++) {
    var u = r[s];
    a.add(u[0]), a.add(u[1]);
  }
  return Array.from(a);
}
function makeOutgoingEdges(r) {
  for (var a = /* @__PURE__ */ new Map(), s = 0, c = r.length; s < c; s++) {
    var u = r[s];
    a.has(u[0]) || a.set(u[0], /* @__PURE__ */ new Set()), a.has(u[1]) || a.set(u[1], /* @__PURE__ */ new Set()), a.get(u[0]).add(u[1]);
  }
  return a;
}
function makeNodesHash(r) {
  for (var a = /* @__PURE__ */ new Map(), s = 0, c = r.length; s < c; s++)
    a.set(r[s], s);
  return a;
}
const isFieldRequiredBySchema = (r, a) => {
  var s, c;
  try {
    return !!((c = (s = reach(a, r)) == null ? void 0 : s.exclusiveTests) != null && c.required);
  } catch {
    return !1;
  }
}, getFieldError = (r, a) => lodashExports.get(a, r), defaultProps = {
  criteriaMode: "all",
  reValidateMode: "onChange",
  mode: "onSubmit",
  defaultValues: {}
}, defaultFormProps = {
  autoComplete: "off"
  // We must use a valid value for a11y reasons
};
function createDefaultValue(r) {
  switch (r) {
    case "number":
      return 0;
    case "string":
      return "";
    case "boolean":
      return !1;
  }
}
const useMelioForm = ({
  schema: r,
  onSubmit: a,
  onError: s,
  isSaving: c,
  isLoading: u,
  onSubmissionStateChange: d,
  subscribeToDefaultValuesChanges: h,
  subscribeToDefaultValuesChangesOptions: p,
  showOptionalIndicator: m,
  ...g
}) => {
  const { defaultValues: v, ...y } = lodashExports.defaults(g, defaultProps), x = useForm({
    resolver: r && o(r),
    ...y,
    // TODO: https://meliorisk.atlassian.net/browse/ME-385
    defaultValues: {
      ...Object.entries((r == null ? void 0 : r.fields) || {}).reduce(
        (R, [A, k]) => ({
          ...R,
          [A]: createDefaultValue(k.type)
        }),
        {}
      ),
      ...v
    }
  }), w = useRef$1(null), { isValid: S, errors: M } = x.formState, P = (y.mode == "onSubmit" || S) && !u, L = {
    ...defaultFormProps,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onSubmit: x.handleSubmit((R, A) => {
      var k, V;
      a(R, A, (k = w.current) == null ? void 0 : k.dataset.target), (V = w.current) != null && V.dataset.target && delete w.current.dataset.target;
    }, s),
    inputRef: w,
    isReadOnly: c || u,
    isLoading: u
  }, I = (R) => ({
    error: getFieldError(R, M),
    control: x.control,
    name: R,
    id: R,
    isRequired: r ? isFieldRequiredBySchema(R, r) : !1,
    showOptionalIndicator: m
  }), T = (R) => () => {
    var A;
    R && w.current && (w.current.dataset.target = R), (A = w.current) == null || A.click();
  }, E = {
    ...x,
    registerField: I,
    formProps: L,
    handleSubmit: T,
    submitButtonProps: {
      onClick: T(),
      isDisabled: !P,
      isLoading: c
    },
    cancelButtonProps: {
      isDisabled: c
    }
  };
  return useEffect$1(() => {
    d == null || d(E);
  }, [P, c, S, u]), useDeepCompareEffect(() => {
    h && x.reset(v, p);
  }, [v, h]), E;
};
function createTableCell(r) {
  const a = forwardRef$1((s, c) => /* @__PURE__ */ jsx(r, { ref: c, ...s }));
  return r.displayName && (a.displayName = `Table.${r.displayName.replace("_Table", "")}`), a;
}
const cells = {
  HeaderCell: createTableCell(_TableHeaderCell),
  HeaderCellDescription: createTableCell(_TableHeaderCellDescription),
  HeaderSortableCell: createTableCell(_TableHeaderSortableCell),
  SelectHeaderCell: createTableCell(_TableSelectHeaderCell),
  _MenuTriggerHeaderCell: createTableCell(_TableMenuTriggerHeaderCell),
  Cell: createTableCell(_TableCell),
  AmountCell: createTableCell(_TableAmountCell),
  AmountInput: createTableCell(_TableAmountInput),
  ActionsCell: createTableCell(_TableActionsCell),
  SelectCell: createTableCell(_TableSelectCell),
  DateCell: createTableCell(_TableDateCell)
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function functionalUpdate(r, a) {
  return typeof r == "function" ? r(a) : r;
}
function makeStateUpdater(r, a) {
  return (s) => {
    a.setState((c) => ({
      ...c,
      [r]: functionalUpdate(s, c[r])
    }));
  };
}
function isFunction(r) {
  return r instanceof Function;
}
function isNumberArray(r) {
  return Array.isArray(r) && r.every((a) => typeof a == "number");
}
function flattenBy(r, a) {
  const s = [], c = (u) => {
    u.forEach((d) => {
      s.push(d);
      const h = a(d);
      h != null && h.length && c(h);
    });
  };
  return c(r), s;
}
function memo(r, a, s) {
  let c = [], u;
  return (d) => {
    let h;
    s.key && s.debug && (h = Date.now());
    const p = r(d);
    if (!(p.length !== c.length || p.some((v, y) => c[y] !== v)))
      return u;
    c = p;
    let g;
    if (s.key && s.debug && (g = Date.now()), u = a(...p), s == null || s.onChange == null || s.onChange(u), s.key && s.debug && s != null && s.debug()) {
      const v = Math.round((Date.now() - h) * 100) / 100, y = Math.round((Date.now() - g) * 100) / 100, x = y / 16, w = (S, M) => {
        for (S = String(S); S.length < M; )
          S = " " + S;
        return S;
      };
      console.info(`%c⏱ ${w(y, 5)} /${w(v, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * x, 120))}deg 100% 31%);`, s == null ? void 0 : s.key);
    }
    return u;
  };
}
function getMemoOptions(r, a, s, c) {
  return {
    debug: () => {
      var u;
      return (u = r == null ? void 0 : r.debugAll) != null ? u : r[a];
    },
    key: process.env.NODE_ENV === "development" && s,
    onChange: c
  };
}
function createCell(r, a, s, c) {
  const u = () => {
    var h;
    return (h = d.getValue()) != null ? h : r.options.renderFallbackValue;
  }, d = {
    id: `${a.id}_${s.id}`,
    row: a,
    column: s,
    getValue: () => a.getValue(c),
    renderValue: u,
    getContext: memo(() => [r, s, a, d], (h, p, m, g) => ({
      table: h,
      column: p,
      row: m,
      cell: g,
      getValue: g.getValue,
      renderValue: g.renderValue
    }), getMemoOptions(r.options, "debugCells", "cell.getContext"))
  };
  return r._features.forEach((h) => {
    h.createCell == null || h.createCell(d, s, a, r);
  }, {}), d;
}
function createColumn(r, a, s, c) {
  var u, d;
  const p = {
    ...r._getDefaultColumnDef(),
    ...a
  }, m = p.accessorKey;
  let g = (u = (d = p.id) != null ? d : m ? m.replace(".", "_") : void 0) != null ? u : typeof p.header == "string" ? p.header : void 0, v;
  if (p.accessorFn ? v = p.accessorFn : m && (m.includes(".") ? v = (x) => {
    let w = x;
    for (const M of m.split(".")) {
      var S;
      w = (S = w) == null ? void 0 : S[M], process.env.NODE_ENV !== "production" && w === void 0 && console.warn(`"${M}" in deeply nested key "${m}" returned undefined.`);
    }
    return w;
  } : v = (x) => x[p.accessorKey]), !g)
    throw process.env.NODE_ENV !== "production" ? new Error(p.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let y = {
    id: `${String(g)}`,
    accessorFn: v,
    parent: c,
    depth: s,
    columnDef: p,
    columns: [],
    getFlatColumns: memo(() => [!0], () => {
      var x;
      return [y, ...(x = y.columns) == null ? void 0 : x.flatMap((w) => w.getFlatColumns())];
    }, getMemoOptions(r.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: memo(() => [r._getOrderColumnsFn()], (x) => {
      var w;
      if ((w = y.columns) != null && w.length) {
        let S = y.columns.flatMap((M) => M.getLeafColumns());
        return x(S);
      }
      return [y];
    }, getMemoOptions(r.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const x of r._features)
    x.createColumn == null || x.createColumn(y, r);
  return y;
}
const debug = "debugHeaders";
function createHeader(r, a, s) {
  var c;
  let d = {
    id: (c = s.id) != null ? c : a.id,
    column: a,
    index: s.index,
    isPlaceholder: !!s.isPlaceholder,
    placeholderId: s.placeholderId,
    depth: s.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const h = [], p = (m) => {
        m.subHeaders && m.subHeaders.length && m.subHeaders.map(p), h.push(m);
      };
      return p(d), h;
    },
    getContext: () => ({
      table: r,
      header: d,
      column: a
    })
  };
  return r._features.forEach((h) => {
    h.createHeader == null || h.createHeader(d, r);
  }), d;
}
const Headers = {
  createTable: (r) => {
    r.getHeaderGroups = memo(() => [r.getAllColumns(), r.getVisibleLeafColumns(), r.getState().columnPinning.left, r.getState().columnPinning.right], (a, s, c, u) => {
      var d, h;
      const p = (d = c == null ? void 0 : c.map((y) => s.find((x) => x.id === y)).filter(Boolean)) != null ? d : [], m = (h = u == null ? void 0 : u.map((y) => s.find((x) => x.id === y)).filter(Boolean)) != null ? h : [], g = s.filter((y) => !(c != null && c.includes(y.id)) && !(u != null && u.includes(y.id)));
      return buildHeaderGroups(a, [...p, ...g, ...m], r);
    }, getMemoOptions(r.options, debug, "getHeaderGroups")), r.getCenterHeaderGroups = memo(() => [r.getAllColumns(), r.getVisibleLeafColumns(), r.getState().columnPinning.left, r.getState().columnPinning.right], (a, s, c, u) => (s = s.filter((d) => !(c != null && c.includes(d.id)) && !(u != null && u.includes(d.id))), buildHeaderGroups(a, s, r, "center")), getMemoOptions(r.options, debug, "getCenterHeaderGroups")), r.getLeftHeaderGroups = memo(() => [r.getAllColumns(), r.getVisibleLeafColumns(), r.getState().columnPinning.left], (a, s, c) => {
      var u;
      const d = (u = c == null ? void 0 : c.map((h) => s.find((p) => p.id === h)).filter(Boolean)) != null ? u : [];
      return buildHeaderGroups(a, d, r, "left");
    }, getMemoOptions(r.options, debug, "getLeftHeaderGroups")), r.getRightHeaderGroups = memo(() => [r.getAllColumns(), r.getVisibleLeafColumns(), r.getState().columnPinning.right], (a, s, c) => {
      var u;
      const d = (u = c == null ? void 0 : c.map((h) => s.find((p) => p.id === h)).filter(Boolean)) != null ? u : [];
      return buildHeaderGroups(a, d, r, "right");
    }, getMemoOptions(r.options, debug, "getRightHeaderGroups")), r.getFooterGroups = memo(() => [r.getHeaderGroups()], (a) => [...a].reverse(), getMemoOptions(r.options, debug, "getFooterGroups")), r.getLeftFooterGroups = memo(() => [r.getLeftHeaderGroups()], (a) => [...a].reverse(), getMemoOptions(r.options, debug, "getLeftFooterGroups")), r.getCenterFooterGroups = memo(() => [r.getCenterHeaderGroups()], (a) => [...a].reverse(), getMemoOptions(r.options, debug, "getCenterFooterGroups")), r.getRightFooterGroups = memo(() => [r.getRightHeaderGroups()], (a) => [...a].reverse(), getMemoOptions(r.options, debug, "getRightFooterGroups")), r.getFlatHeaders = memo(() => [r.getHeaderGroups()], (a) => a.map((s) => s.headers).flat(), getMemoOptions(r.options, debug, "getFlatHeaders")), r.getLeftFlatHeaders = memo(() => [r.getLeftHeaderGroups()], (a) => a.map((s) => s.headers).flat(), getMemoOptions(r.options, debug, "getLeftFlatHeaders")), r.getCenterFlatHeaders = memo(() => [r.getCenterHeaderGroups()], (a) => a.map((s) => s.headers).flat(), getMemoOptions(r.options, debug, "getCenterFlatHeaders")), r.getRightFlatHeaders = memo(() => [r.getRightHeaderGroups()], (a) => a.map((s) => s.headers).flat(), getMemoOptions(r.options, debug, "getRightFlatHeaders")), r.getCenterLeafHeaders = memo(() => [r.getCenterFlatHeaders()], (a) => a.filter((s) => {
      var c;
      return !((c = s.subHeaders) != null && c.length);
    }), getMemoOptions(r.options, debug, "getCenterLeafHeaders")), r.getLeftLeafHeaders = memo(() => [r.getLeftFlatHeaders()], (a) => a.filter((s) => {
      var c;
      return !((c = s.subHeaders) != null && c.length);
    }), getMemoOptions(r.options, debug, "getLeftLeafHeaders")), r.getRightLeafHeaders = memo(() => [r.getRightFlatHeaders()], (a) => a.filter((s) => {
      var c;
      return !((c = s.subHeaders) != null && c.length);
    }), getMemoOptions(r.options, debug, "getRightLeafHeaders")), r.getLeafHeaders = memo(() => [r.getLeftHeaderGroups(), r.getCenterHeaderGroups(), r.getRightHeaderGroups()], (a, s, c) => {
      var u, d, h, p, m, g;
      return [...(u = (d = a[0]) == null ? void 0 : d.headers) != null ? u : [], ...(h = (p = s[0]) == null ? void 0 : p.headers) != null ? h : [], ...(m = (g = c[0]) == null ? void 0 : g.headers) != null ? m : []].map((v) => v.getLeafHeaders()).flat();
    }, getMemoOptions(r.options, debug, "getLeafHeaders"));
  }
};
function buildHeaderGroups(r, a, s, c) {
  var u, d;
  let h = 0;
  const p = function(x, w) {
    w === void 0 && (w = 1), h = Math.max(h, w), x.filter((S) => S.getIsVisible()).forEach((S) => {
      var M;
      (M = S.columns) != null && M.length && p(S.columns, w + 1);
    }, 0);
  };
  p(r);
  let m = [];
  const g = (x, w) => {
    const S = {
      depth: w,
      id: [c, `${w}`].filter(Boolean).join("_"),
      headers: []
    }, M = [];
    x.forEach((P) => {
      const L = [...M].reverse()[0], I = P.column.depth === S.depth;
      let T, E = !1;
      if (I && P.column.parent ? T = P.column.parent : (T = P.column, E = !0), L && (L == null ? void 0 : L.column) === T)
        L.subHeaders.push(P);
      else {
        const R = createHeader(s, T, {
          id: [c, w, T.id, P == null ? void 0 : P.id].filter(Boolean).join("_"),
          isPlaceholder: E,
          placeholderId: E ? `${M.filter((A) => A.column === T).length}` : void 0,
          depth: w,
          index: M.length
        });
        R.subHeaders.push(P), M.push(R);
      }
      S.headers.push(P), P.headerGroup = S;
    }), m.push(S), w > 0 && g(M, w - 1);
  }, v = a.map((x, w) => createHeader(s, x, {
    depth: h,
    index: w
  }));
  g(v, h - 1), m.reverse();
  const y = (x) => x.filter((S) => S.column.getIsVisible()).map((S) => {
    let M = 0, P = 0, L = [0];
    S.subHeaders && S.subHeaders.length ? (L = [], y(S.subHeaders).forEach((T) => {
      let {
        colSpan: E,
        rowSpan: R
      } = T;
      M += E, L.push(R);
    })) : M = 1;
    const I = Math.min(...L);
    return P = P + I, S.colSpan = M, S.rowSpan = P, {
      colSpan: M,
      rowSpan: P
    };
  });
  return y((u = (d = m[0]) == null ? void 0 : d.headers) != null ? u : []), m;
}
const createRow = (r, a, s, c, u, d, h) => {
  let p = {
    id: a,
    index: c,
    original: s,
    depth: u,
    parentId: h,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (m) => {
      if (p._valuesCache.hasOwnProperty(m))
        return p._valuesCache[m];
      const g = r.getColumn(m);
      if (g != null && g.accessorFn)
        return p._valuesCache[m] = g.accessorFn(p.original, c), p._valuesCache[m];
    },
    getUniqueValues: (m) => {
      if (p._uniqueValuesCache.hasOwnProperty(m))
        return p._uniqueValuesCache[m];
      const g = r.getColumn(m);
      if (g != null && g.accessorFn)
        return g.columnDef.getUniqueValues ? (p._uniqueValuesCache[m] = g.columnDef.getUniqueValues(p.original, c), p._uniqueValuesCache[m]) : (p._uniqueValuesCache[m] = [p.getValue(m)], p._uniqueValuesCache[m]);
    },
    renderValue: (m) => {
      var g;
      return (g = p.getValue(m)) != null ? g : r.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => flattenBy(p.subRows, (m) => m.subRows),
    getParentRow: () => p.parentId ? r.getRow(p.parentId, !0) : void 0,
    getParentRows: () => {
      let m = [], g = p;
      for (; ; ) {
        const v = g.getParentRow();
        if (!v) break;
        m.push(v), g = v;
      }
      return m.reverse();
    },
    getAllCells: memo(() => [r.getAllLeafColumns()], (m) => m.map((g) => createCell(r, p, g, g.id)), getMemoOptions(r.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: memo(() => [p.getAllCells()], (m) => m.reduce((g, v) => (g[v.column.id] = v, g), {}), getMemoOptions(r.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let m = 0; m < r._features.length; m++) {
    const g = r._features[m];
    g == null || g.createRow == null || g.createRow(p, r);
  }
  return p;
}, ColumnFaceting = {
  createColumn: (r, a) => {
    r._getFacetedRowModel = a.options.getFacetedRowModel && a.options.getFacetedRowModel(a, r.id), r.getFacetedRowModel = () => r._getFacetedRowModel ? r._getFacetedRowModel() : a.getPreFilteredRowModel(), r._getFacetedUniqueValues = a.options.getFacetedUniqueValues && a.options.getFacetedUniqueValues(a, r.id), r.getFacetedUniqueValues = () => r._getFacetedUniqueValues ? r._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), r._getFacetedMinMaxValues = a.options.getFacetedMinMaxValues && a.options.getFacetedMinMaxValues(a, r.id), r.getFacetedMinMaxValues = () => {
      if (r._getFacetedMinMaxValues)
        return r._getFacetedMinMaxValues();
    };
  }
}, includesString = (r, a, s) => {
  var c;
  const u = s.toLowerCase();
  return !!(!((c = r.getValue(a)) == null || (c = c.toString()) == null || (c = c.toLowerCase()) == null) && c.includes(u));
};
includesString.autoRemove = (r) => testFalsey(r);
const includesStringSensitive = (r, a, s) => {
  var c;
  return !!(!((c = r.getValue(a)) == null || (c = c.toString()) == null) && c.includes(s));
};
includesStringSensitive.autoRemove = (r) => testFalsey(r);
const equalsString = (r, a, s) => {
  var c;
  return ((c = r.getValue(a)) == null || (c = c.toString()) == null ? void 0 : c.toLowerCase()) === (s == null ? void 0 : s.toLowerCase());
};
equalsString.autoRemove = (r) => testFalsey(r);
const arrIncludes = (r, a, s) => {
  var c;
  return (c = r.getValue(a)) == null ? void 0 : c.includes(s);
};
arrIncludes.autoRemove = (r) => testFalsey(r) || !(r != null && r.length);
const arrIncludesAll = (r, a, s) => !s.some((c) => {
  var u;
  return !((u = r.getValue(a)) != null && u.includes(c));
});
arrIncludesAll.autoRemove = (r) => testFalsey(r) || !(r != null && r.length);
const arrIncludesSome = (r, a, s) => s.some((c) => {
  var u;
  return (u = r.getValue(a)) == null ? void 0 : u.includes(c);
});
arrIncludesSome.autoRemove = (r) => testFalsey(r) || !(r != null && r.length);
const equals = (r, a, s) => r.getValue(a) === s;
equals.autoRemove = (r) => testFalsey(r);
const weakEquals = (r, a, s) => r.getValue(a) == s;
weakEquals.autoRemove = (r) => testFalsey(r);
const inNumberRange = (r, a, s) => {
  let [c, u] = s;
  const d = r.getValue(a);
  return d >= c && d <= u;
};
inNumberRange.resolveFilterValue = (r) => {
  let [a, s] = r, c = typeof a != "number" ? parseFloat(a) : a, u = typeof s != "number" ? parseFloat(s) : s, d = a === null || Number.isNaN(c) ? -1 / 0 : c, h = s === null || Number.isNaN(u) ? 1 / 0 : u;
  if (d > h) {
    const p = d;
    d = h, h = p;
  }
  return [d, h];
};
inNumberRange.autoRemove = (r) => testFalsey(r) || testFalsey(r[0]) && testFalsey(r[1]);
const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals,
  weakEquals,
  inNumberRange
};
function testFalsey(r) {
  return r == null || r === "";
}
const ColumnFiltering = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (r) => ({
    columnFilters: [],
    ...r
  }),
  getDefaultOptions: (r) => ({
    onColumnFiltersChange: makeStateUpdater("columnFilters", r),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (r, a) => {
    r.getAutoFilterFn = () => {
      const s = a.getCoreRowModel().flatRows[0], c = s == null ? void 0 : s.getValue(r.id);
      return typeof c == "string" ? filterFns.includesString : typeof c == "number" ? filterFns.inNumberRange : typeof c == "boolean" || c !== null && typeof c == "object" ? filterFns.equals : Array.isArray(c) ? filterFns.arrIncludes : filterFns.weakEquals;
    }, r.getFilterFn = () => {
      var s, c;
      return isFunction(r.columnDef.filterFn) ? r.columnDef.filterFn : r.columnDef.filterFn === "auto" ? r.getAutoFilterFn() : (
        // @ts-ignore
        (s = (c = a.options.filterFns) == null ? void 0 : c[r.columnDef.filterFn]) != null ? s : filterFns[r.columnDef.filterFn]
      );
    }, r.getCanFilter = () => {
      var s, c, u;
      return ((s = r.columnDef.enableColumnFilter) != null ? s : !0) && ((c = a.options.enableColumnFilters) != null ? c : !0) && ((u = a.options.enableFilters) != null ? u : !0) && !!r.accessorFn;
    }, r.getIsFiltered = () => r.getFilterIndex() > -1, r.getFilterValue = () => {
      var s;
      return (s = a.getState().columnFilters) == null || (s = s.find((c) => c.id === r.id)) == null ? void 0 : s.value;
    }, r.getFilterIndex = () => {
      var s, c;
      return (s = (c = a.getState().columnFilters) == null ? void 0 : c.findIndex((u) => u.id === r.id)) != null ? s : -1;
    }, r.setFilterValue = (s) => {
      a.setColumnFilters((c) => {
        const u = r.getFilterFn(), d = c == null ? void 0 : c.find((v) => v.id === r.id), h = functionalUpdate(s, d ? d.value : void 0);
        if (shouldAutoRemoveFilter(u, h, r)) {
          var p;
          return (p = c == null ? void 0 : c.filter((v) => v.id !== r.id)) != null ? p : [];
        }
        const m = {
          id: r.id,
          value: h
        };
        if (d) {
          var g;
          return (g = c == null ? void 0 : c.map((v) => v.id === r.id ? m : v)) != null ? g : [];
        }
        return c != null && c.length ? [...c, m] : [m];
      });
    };
  },
  createRow: (r, a) => {
    r.columnFilters = {}, r.columnFiltersMeta = {};
  },
  createTable: (r) => {
    r.setColumnFilters = (a) => {
      const s = r.getAllLeafColumns(), c = (u) => {
        var d;
        return (d = functionalUpdate(a, u)) == null ? void 0 : d.filter((h) => {
          const p = s.find((m) => m.id === h.id);
          if (p) {
            const m = p.getFilterFn();
            if (shouldAutoRemoveFilter(m, h.value, p))
              return !1;
          }
          return !0;
        });
      };
      r.options.onColumnFiltersChange == null || r.options.onColumnFiltersChange(c);
    }, r.resetColumnFilters = (a) => {
      var s, c;
      r.setColumnFilters(a ? [] : (s = (c = r.initialState) == null ? void 0 : c.columnFilters) != null ? s : []);
    }, r.getPreFilteredRowModel = () => r.getCoreRowModel(), r.getFilteredRowModel = () => (!r._getFilteredRowModel && r.options.getFilteredRowModel && (r._getFilteredRowModel = r.options.getFilteredRowModel(r)), r.options.manualFiltering || !r._getFilteredRowModel ? r.getPreFilteredRowModel() : r._getFilteredRowModel());
  }
};
function shouldAutoRemoveFilter(r, a, s) {
  return (r && r.autoRemove ? r.autoRemove(a, s) : !1) || typeof a > "u" || typeof a == "string" && !a;
}
const sum = (r, a, s) => s.reduce((c, u) => {
  const d = u.getValue(r);
  return c + (typeof d == "number" ? d : 0);
}, 0), min = (r, a, s) => {
  let c;
  return s.forEach((u) => {
    const d = u.getValue(r);
    d != null && (c > d || c === void 0 && d >= d) && (c = d);
  }), c;
}, max = (r, a, s) => {
  let c;
  return s.forEach((u) => {
    const d = u.getValue(r);
    d != null && (c < d || c === void 0 && d >= d) && (c = d);
  }), c;
}, extent = (r, a, s) => {
  let c, u;
  return s.forEach((d) => {
    const h = d.getValue(r);
    h != null && (c === void 0 ? h >= h && (c = u = h) : (c > h && (c = h), u < h && (u = h)));
  }), [c, u];
}, mean = (r, a) => {
  let s = 0, c = 0;
  if (a.forEach((u) => {
    let d = u.getValue(r);
    d != null && (d = +d) >= d && (++s, c += d);
  }), s) return c / s;
}, median = (r, a) => {
  if (!a.length)
    return;
  const s = a.map((d) => d.getValue(r));
  if (!isNumberArray(s))
    return;
  if (s.length === 1)
    return s[0];
  const c = Math.floor(s.length / 2), u = s.sort((d, h) => d - h);
  return s.length % 2 !== 0 ? u[c] : (u[c - 1] + u[c]) / 2;
}, unique = (r, a) => Array.from(new Set(a.map((s) => s.getValue(r))).values()), uniqueCount = (r, a) => new Set(a.map((s) => s.getValue(r))).size, count = (r, a) => a.length, aggregationFns = {
  sum,
  min,
  max,
  extent,
  mean,
  median,
  unique,
  uniqueCount,
  count
}, ColumnGrouping = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (r) => {
      var a, s;
      return (a = (s = r.getValue()) == null || s.toString == null ? void 0 : s.toString()) != null ? a : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (r) => ({
    grouping: [],
    ...r
  }),
  getDefaultOptions: (r) => ({
    onGroupingChange: makeStateUpdater("grouping", r),
    groupedColumnMode: "reorder"
  }),
  createColumn: (r, a) => {
    r.toggleGrouping = () => {
      a.setGrouping((s) => s != null && s.includes(r.id) ? s.filter((c) => c !== r.id) : [...s ?? [], r.id]);
    }, r.getCanGroup = () => {
      var s, c;
      return ((s = r.columnDef.enableGrouping) != null ? s : !0) && ((c = a.options.enableGrouping) != null ? c : !0) && (!!r.accessorFn || !!r.columnDef.getGroupingValue);
    }, r.getIsGrouped = () => {
      var s;
      return (s = a.getState().grouping) == null ? void 0 : s.includes(r.id);
    }, r.getGroupedIndex = () => {
      var s;
      return (s = a.getState().grouping) == null ? void 0 : s.indexOf(r.id);
    }, r.getToggleGroupingHandler = () => {
      const s = r.getCanGroup();
      return () => {
        s && r.toggleGrouping();
      };
    }, r.getAutoAggregationFn = () => {
      const s = a.getCoreRowModel().flatRows[0], c = s == null ? void 0 : s.getValue(r.id);
      if (typeof c == "number")
        return aggregationFns.sum;
      if (Object.prototype.toString.call(c) === "[object Date]")
        return aggregationFns.extent;
    }, r.getAggregationFn = () => {
      var s, c;
      if (!r)
        throw new Error();
      return isFunction(r.columnDef.aggregationFn) ? r.columnDef.aggregationFn : r.columnDef.aggregationFn === "auto" ? r.getAutoAggregationFn() : (s = (c = a.options.aggregationFns) == null ? void 0 : c[r.columnDef.aggregationFn]) != null ? s : aggregationFns[r.columnDef.aggregationFn];
    };
  },
  createTable: (r) => {
    r.setGrouping = (a) => r.options.onGroupingChange == null ? void 0 : r.options.onGroupingChange(a), r.resetGrouping = (a) => {
      var s, c;
      r.setGrouping(a ? [] : (s = (c = r.initialState) == null ? void 0 : c.grouping) != null ? s : []);
    }, r.getPreGroupedRowModel = () => r.getFilteredRowModel(), r.getGroupedRowModel = () => (!r._getGroupedRowModel && r.options.getGroupedRowModel && (r._getGroupedRowModel = r.options.getGroupedRowModel(r)), r.options.manualGrouping || !r._getGroupedRowModel ? r.getPreGroupedRowModel() : r._getGroupedRowModel());
  },
  createRow: (r, a) => {
    r.getIsGrouped = () => !!r.groupingColumnId, r.getGroupingValue = (s) => {
      if (r._groupingValuesCache.hasOwnProperty(s))
        return r._groupingValuesCache[s];
      const c = a.getColumn(s);
      return c != null && c.columnDef.getGroupingValue ? (r._groupingValuesCache[s] = c.columnDef.getGroupingValue(r.original), r._groupingValuesCache[s]) : r.getValue(s);
    }, r._groupingValuesCache = {};
  },
  createCell: (r, a, s, c) => {
    r.getIsGrouped = () => a.getIsGrouped() && a.id === s.groupingColumnId, r.getIsPlaceholder = () => !r.getIsGrouped() && a.getIsGrouped(), r.getIsAggregated = () => {
      var u;
      return !r.getIsGrouped() && !r.getIsPlaceholder() && !!((u = s.subRows) != null && u.length);
    };
  }
};
function orderColumns(r, a, s) {
  if (!(a != null && a.length) || !s)
    return r;
  const c = r.filter((d) => !a.includes(d.id));
  return s === "remove" ? c : [...a.map((d) => r.find((h) => h.id === d)).filter(Boolean), ...c];
}
const ColumnOrdering = {
  getInitialState: (r) => ({
    columnOrder: [],
    ...r
  }),
  getDefaultOptions: (r) => ({
    onColumnOrderChange: makeStateUpdater("columnOrder", r)
  }),
  createColumn: (r, a) => {
    r.getIndex = memo((s) => [_getVisibleLeafColumns(a, s)], (s) => s.findIndex((c) => c.id === r.id), getMemoOptions(a.options, "debugColumns", "getIndex")), r.getIsFirstColumn = (s) => {
      var c;
      return ((c = _getVisibleLeafColumns(a, s)[0]) == null ? void 0 : c.id) === r.id;
    }, r.getIsLastColumn = (s) => {
      var c;
      const u = _getVisibleLeafColumns(a, s);
      return ((c = u[u.length - 1]) == null ? void 0 : c.id) === r.id;
    };
  },
  createTable: (r) => {
    r.setColumnOrder = (a) => r.options.onColumnOrderChange == null ? void 0 : r.options.onColumnOrderChange(a), r.resetColumnOrder = (a) => {
      var s;
      r.setColumnOrder(a ? [] : (s = r.initialState.columnOrder) != null ? s : []);
    }, r._getOrderColumnsFn = memo(() => [r.getState().columnOrder, r.getState().grouping, r.options.groupedColumnMode], (a, s, c) => (u) => {
      let d = [];
      if (!(a != null && a.length))
        d = u;
      else {
        const h = [...a], p = [...u];
        for (; p.length && h.length; ) {
          const m = h.shift(), g = p.findIndex((v) => v.id === m);
          g > -1 && d.push(p.splice(g, 1)[0]);
        }
        d = [...d, ...p];
      }
      return orderColumns(d, s, c);
    }, getMemoOptions(r.options, "debugTable", "_getOrderColumnsFn"));
  }
}, getDefaultColumnPinningState = () => ({
  left: [],
  right: []
}), ColumnPinning = {
  getInitialState: (r) => ({
    columnPinning: getDefaultColumnPinningState(),
    ...r
  }),
  getDefaultOptions: (r) => ({
    onColumnPinningChange: makeStateUpdater("columnPinning", r)
  }),
  createColumn: (r, a) => {
    r.pin = (s) => {
      const c = r.getLeafColumns().map((u) => u.id).filter(Boolean);
      a.setColumnPinning((u) => {
        var d, h;
        if (s === "right") {
          var p, m;
          return {
            left: ((p = u == null ? void 0 : u.left) != null ? p : []).filter((y) => !(c != null && c.includes(y))),
            right: [...((m = u == null ? void 0 : u.right) != null ? m : []).filter((y) => !(c != null && c.includes(y))), ...c]
          };
        }
        if (s === "left") {
          var g, v;
          return {
            left: [...((g = u == null ? void 0 : u.left) != null ? g : []).filter((y) => !(c != null && c.includes(y))), ...c],
            right: ((v = u == null ? void 0 : u.right) != null ? v : []).filter((y) => !(c != null && c.includes(y)))
          };
        }
        return {
          left: ((d = u == null ? void 0 : u.left) != null ? d : []).filter((y) => !(c != null && c.includes(y))),
          right: ((h = u == null ? void 0 : u.right) != null ? h : []).filter((y) => !(c != null && c.includes(y)))
        };
      });
    }, r.getCanPin = () => r.getLeafColumns().some((c) => {
      var u, d, h;
      return ((u = c.columnDef.enablePinning) != null ? u : !0) && ((d = (h = a.options.enableColumnPinning) != null ? h : a.options.enablePinning) != null ? d : !0);
    }), r.getIsPinned = () => {
      const s = r.getLeafColumns().map((p) => p.id), {
        left: c,
        right: u
      } = a.getState().columnPinning, d = s.some((p) => c == null ? void 0 : c.includes(p)), h = s.some((p) => u == null ? void 0 : u.includes(p));
      return d ? "left" : h ? "right" : !1;
    }, r.getPinnedIndex = () => {
      var s, c;
      const u = r.getIsPinned();
      return u ? (s = (c = a.getState().columnPinning) == null || (c = c[u]) == null ? void 0 : c.indexOf(r.id)) != null ? s : -1 : 0;
    };
  },
  createRow: (r, a) => {
    r.getCenterVisibleCells = memo(() => [r._getAllVisibleCells(), a.getState().columnPinning.left, a.getState().columnPinning.right], (s, c, u) => {
      const d = [...c ?? [], ...u ?? []];
      return s.filter((h) => !d.includes(h.column.id));
    }, getMemoOptions(a.options, "debugRows", "getCenterVisibleCells")), r.getLeftVisibleCells = memo(() => [r._getAllVisibleCells(), a.getState().columnPinning.left], (s, c) => (c ?? []).map((d) => s.find((h) => h.column.id === d)).filter(Boolean).map((d) => ({
      ...d,
      position: "left"
    })), getMemoOptions(a.options, "debugRows", "getLeftVisibleCells")), r.getRightVisibleCells = memo(() => [r._getAllVisibleCells(), a.getState().columnPinning.right], (s, c) => (c ?? []).map((d) => s.find((h) => h.column.id === d)).filter(Boolean).map((d) => ({
      ...d,
      position: "right"
    })), getMemoOptions(a.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (r) => {
    r.setColumnPinning = (a) => r.options.onColumnPinningChange == null ? void 0 : r.options.onColumnPinningChange(a), r.resetColumnPinning = (a) => {
      var s, c;
      return r.setColumnPinning(a ? getDefaultColumnPinningState() : (s = (c = r.initialState) == null ? void 0 : c.columnPinning) != null ? s : getDefaultColumnPinningState());
    }, r.getIsSomeColumnsPinned = (a) => {
      var s;
      const c = r.getState().columnPinning;
      if (!a) {
        var u, d;
        return !!((u = c.left) != null && u.length || (d = c.right) != null && d.length);
      }
      return !!((s = c[a]) != null && s.length);
    }, r.getLeftLeafColumns = memo(() => [r.getAllLeafColumns(), r.getState().columnPinning.left], (a, s) => (s ?? []).map((c) => a.find((u) => u.id === c)).filter(Boolean), getMemoOptions(r.options, "debugColumns", "getLeftLeafColumns")), r.getRightLeafColumns = memo(() => [r.getAllLeafColumns(), r.getState().columnPinning.right], (a, s) => (s ?? []).map((c) => a.find((u) => u.id === c)).filter(Boolean), getMemoOptions(r.options, "debugColumns", "getRightLeafColumns")), r.getCenterLeafColumns = memo(() => [r.getAllLeafColumns(), r.getState().columnPinning.left, r.getState().columnPinning.right], (a, s, c) => {
      const u = [...s ?? [], ...c ?? []];
      return a.filter((d) => !u.includes(d.id));
    }, getMemoOptions(r.options, "debugColumns", "getCenterLeafColumns"));
  }
}, defaultColumnSizing = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), ColumnSizing = {
  getDefaultColumnDef: () => defaultColumnSizing,
  getInitialState: (r) => ({
    columnSizing: {},
    columnSizingInfo: getDefaultColumnSizingInfoState(),
    ...r
  }),
  getDefaultOptions: (r) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: makeStateUpdater("columnSizing", r),
    onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", r)
  }),
  createColumn: (r, a) => {
    r.getSize = () => {
      var s, c, u;
      const d = a.getState().columnSizing[r.id];
      return Math.min(Math.max((s = r.columnDef.minSize) != null ? s : defaultColumnSizing.minSize, (c = d ?? r.columnDef.size) != null ? c : defaultColumnSizing.size), (u = r.columnDef.maxSize) != null ? u : defaultColumnSizing.maxSize);
    }, r.getStart = memo((s) => [s, _getVisibleLeafColumns(a, s), a.getState().columnSizing], (s, c) => c.slice(0, r.getIndex(s)).reduce((u, d) => u + d.getSize(), 0), getMemoOptions(a.options, "debugColumns", "getStart")), r.getAfter = memo((s) => [s, _getVisibleLeafColumns(a, s), a.getState().columnSizing], (s, c) => c.slice(r.getIndex(s) + 1).reduce((u, d) => u + d.getSize(), 0), getMemoOptions(a.options, "debugColumns", "getAfter")), r.resetSize = () => {
      a.setColumnSizing((s) => {
        let {
          [r.id]: c,
          ...u
        } = s;
        return u;
      });
    }, r.getCanResize = () => {
      var s, c;
      return ((s = r.columnDef.enableResizing) != null ? s : !0) && ((c = a.options.enableColumnResizing) != null ? c : !0);
    }, r.getIsResizing = () => a.getState().columnSizingInfo.isResizingColumn === r.id;
  },
  createHeader: (r, a) => {
    r.getSize = () => {
      let s = 0;
      const c = (u) => {
        if (u.subHeaders.length)
          u.subHeaders.forEach(c);
        else {
          var d;
          s += (d = u.column.getSize()) != null ? d : 0;
        }
      };
      return c(r), s;
    }, r.getStart = () => {
      if (r.index > 0) {
        const s = r.headerGroup.headers[r.index - 1];
        return s.getStart() + s.getSize();
      }
      return 0;
    }, r.getResizeHandler = (s) => {
      const c = a.getColumn(r.column.id), u = c == null ? void 0 : c.getCanResize();
      return (d) => {
        if (!c || !u || (d.persist == null || d.persist(), isTouchStartEvent(d) && d.touches && d.touches.length > 1))
          return;
        const h = r.getSize(), p = r ? r.getLeafHeaders().map((L) => [L.column.id, L.column.getSize()]) : [[c.id, c.getSize()]], m = isTouchStartEvent(d) ? Math.round(d.touches[0].clientX) : d.clientX, g = {}, v = (L, I) => {
          typeof I == "number" && (a.setColumnSizingInfo((T) => {
            var E, R;
            const A = a.options.columnResizeDirection === "rtl" ? -1 : 1, k = (I - ((E = T == null ? void 0 : T.startOffset) != null ? E : 0)) * A, V = Math.max(k / ((R = T == null ? void 0 : T.startSize) != null ? R : 0), -0.999999);
            return T.columnSizingStart.forEach((B) => {
              let [q, z] = B;
              g[q] = Math.round(Math.max(z + z * V, 0) * 100) / 100;
            }), {
              ...T,
              deltaOffset: k,
              deltaPercentage: V
            };
          }), (a.options.columnResizeMode === "onChange" || L === "end") && a.setColumnSizing((T) => ({
            ...T,
            ...g
          })));
        }, y = (L) => v("move", L), x = (L) => {
          v("end", L), a.setColumnSizingInfo((I) => ({
            ...I,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, w = s || typeof document < "u" ? document : null, S = {
          moveHandler: (L) => y(L.clientX),
          upHandler: (L) => {
            w == null || w.removeEventListener("mousemove", S.moveHandler), w == null || w.removeEventListener("mouseup", S.upHandler), x(L.clientX);
          }
        }, M = {
          moveHandler: (L) => (L.cancelable && (L.preventDefault(), L.stopPropagation()), y(L.touches[0].clientX), !1),
          upHandler: (L) => {
            var I;
            w == null || w.removeEventListener("touchmove", M.moveHandler), w == null || w.removeEventListener("touchend", M.upHandler), L.cancelable && (L.preventDefault(), L.stopPropagation()), x((I = L.touches[0]) == null ? void 0 : I.clientX);
          }
        }, P = passiveEventSupported() ? {
          passive: !1
        } : !1;
        isTouchStartEvent(d) ? (w == null || w.addEventListener("touchmove", M.moveHandler, P), w == null || w.addEventListener("touchend", M.upHandler, P)) : (w == null || w.addEventListener("mousemove", S.moveHandler, P), w == null || w.addEventListener("mouseup", S.upHandler, P)), a.setColumnSizingInfo((L) => ({
          ...L,
          startOffset: m,
          startSize: h,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: p,
          isResizingColumn: c.id
        }));
      };
    };
  },
  createTable: (r) => {
    r.setColumnSizing = (a) => r.options.onColumnSizingChange == null ? void 0 : r.options.onColumnSizingChange(a), r.setColumnSizingInfo = (a) => r.options.onColumnSizingInfoChange == null ? void 0 : r.options.onColumnSizingInfoChange(a), r.resetColumnSizing = (a) => {
      var s;
      r.setColumnSizing(a ? {} : (s = r.initialState.columnSizing) != null ? s : {});
    }, r.resetHeaderSizeInfo = (a) => {
      var s;
      r.setColumnSizingInfo(a ? getDefaultColumnSizingInfoState() : (s = r.initialState.columnSizingInfo) != null ? s : getDefaultColumnSizingInfoState());
    }, r.getTotalSize = () => {
      var a, s;
      return (a = (s = r.getHeaderGroups()[0]) == null ? void 0 : s.headers.reduce((c, u) => c + u.getSize(), 0)) != null ? a : 0;
    }, r.getLeftTotalSize = () => {
      var a, s;
      return (a = (s = r.getLeftHeaderGroups()[0]) == null ? void 0 : s.headers.reduce((c, u) => c + u.getSize(), 0)) != null ? a : 0;
    }, r.getCenterTotalSize = () => {
      var a, s;
      return (a = (s = r.getCenterHeaderGroups()[0]) == null ? void 0 : s.headers.reduce((c, u) => c + u.getSize(), 0)) != null ? a : 0;
    }, r.getRightTotalSize = () => {
      var a, s;
      return (a = (s = r.getRightHeaderGroups()[0]) == null ? void 0 : s.headers.reduce((c, u) => c + u.getSize(), 0)) != null ? a : 0;
    };
  }
};
let passiveSupported = null;
function passiveEventSupported() {
  if (typeof passiveSupported == "boolean") return passiveSupported;
  let r = !1;
  try {
    const a = {
      get passive() {
        return r = !0, !1;
      }
    }, s = () => {
    };
    window.addEventListener("test", s, a), window.removeEventListener("test", s);
  } catch {
    r = !1;
  }
  return passiveSupported = r, passiveSupported;
}
function isTouchStartEvent(r) {
  return r.type === "touchstart";
}
const ColumnVisibility = {
  getInitialState: (r) => ({
    columnVisibility: {},
    ...r
  }),
  getDefaultOptions: (r) => ({
    onColumnVisibilityChange: makeStateUpdater("columnVisibility", r)
  }),
  createColumn: (r, a) => {
    r.toggleVisibility = (s) => {
      r.getCanHide() && a.setColumnVisibility((c) => ({
        ...c,
        [r.id]: s ?? !r.getIsVisible()
      }));
    }, r.getIsVisible = () => {
      var s, c;
      const u = r.columns;
      return (s = u.length ? u.some((d) => d.getIsVisible()) : (c = a.getState().columnVisibility) == null ? void 0 : c[r.id]) != null ? s : !0;
    }, r.getCanHide = () => {
      var s, c;
      return ((s = r.columnDef.enableHiding) != null ? s : !0) && ((c = a.options.enableHiding) != null ? c : !0);
    }, r.getToggleVisibilityHandler = () => (s) => {
      r.toggleVisibility == null || r.toggleVisibility(s.target.checked);
    };
  },
  createRow: (r, a) => {
    r._getAllVisibleCells = memo(() => [r.getAllCells(), a.getState().columnVisibility], (s) => s.filter((c) => c.column.getIsVisible()), getMemoOptions(a.options, "debugRows", "_getAllVisibleCells")), r.getVisibleCells = memo(() => [r.getLeftVisibleCells(), r.getCenterVisibleCells(), r.getRightVisibleCells()], (s, c, u) => [...s, ...c, ...u], getMemoOptions(a.options, "debugRows", "getVisibleCells"));
  },
  createTable: (r) => {
    const a = (s, c) => memo(() => [c(), c().filter((u) => u.getIsVisible()).map((u) => u.id).join("_")], (u) => u.filter((d) => d.getIsVisible == null ? void 0 : d.getIsVisible()), getMemoOptions(r.options, "debugColumns", s));
    r.getVisibleFlatColumns = a("getVisibleFlatColumns", () => r.getAllFlatColumns()), r.getVisibleLeafColumns = a("getVisibleLeafColumns", () => r.getAllLeafColumns()), r.getLeftVisibleLeafColumns = a("getLeftVisibleLeafColumns", () => r.getLeftLeafColumns()), r.getRightVisibleLeafColumns = a("getRightVisibleLeafColumns", () => r.getRightLeafColumns()), r.getCenterVisibleLeafColumns = a("getCenterVisibleLeafColumns", () => r.getCenterLeafColumns()), r.setColumnVisibility = (s) => r.options.onColumnVisibilityChange == null ? void 0 : r.options.onColumnVisibilityChange(s), r.resetColumnVisibility = (s) => {
      var c;
      r.setColumnVisibility(s ? {} : (c = r.initialState.columnVisibility) != null ? c : {});
    }, r.toggleAllColumnsVisible = (s) => {
      var c;
      s = (c = s) != null ? c : !r.getIsAllColumnsVisible(), r.setColumnVisibility(r.getAllLeafColumns().reduce((u, d) => ({
        ...u,
        [d.id]: s || !(d.getCanHide != null && d.getCanHide())
      }), {}));
    }, r.getIsAllColumnsVisible = () => !r.getAllLeafColumns().some((s) => !(s.getIsVisible != null && s.getIsVisible())), r.getIsSomeColumnsVisible = () => r.getAllLeafColumns().some((s) => s.getIsVisible == null ? void 0 : s.getIsVisible()), r.getToggleAllColumnsVisibilityHandler = () => (s) => {
      var c;
      r.toggleAllColumnsVisible((c = s.target) == null ? void 0 : c.checked);
    };
  }
};
function _getVisibleLeafColumns(r, a) {
  return a ? a === "center" ? r.getCenterVisibleLeafColumns() : a === "left" ? r.getLeftVisibleLeafColumns() : r.getRightVisibleLeafColumns() : r.getVisibleLeafColumns();
}
const GlobalFaceting = {
  createTable: (r) => {
    r._getGlobalFacetedRowModel = r.options.getFacetedRowModel && r.options.getFacetedRowModel(r, "__global__"), r.getGlobalFacetedRowModel = () => r.options.manualFiltering || !r._getGlobalFacetedRowModel ? r.getPreFilteredRowModel() : r._getGlobalFacetedRowModel(), r._getGlobalFacetedUniqueValues = r.options.getFacetedUniqueValues && r.options.getFacetedUniqueValues(r, "__global__"), r.getGlobalFacetedUniqueValues = () => r._getGlobalFacetedUniqueValues ? r._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), r._getGlobalFacetedMinMaxValues = r.options.getFacetedMinMaxValues && r.options.getFacetedMinMaxValues(r, "__global__"), r.getGlobalFacetedMinMaxValues = () => {
      if (r._getGlobalFacetedMinMaxValues)
        return r._getGlobalFacetedMinMaxValues();
    };
  }
}, GlobalFiltering = {
  getInitialState: (r) => ({
    globalFilter: void 0,
    ...r
  }),
  getDefaultOptions: (r) => ({
    onGlobalFilterChange: makeStateUpdater("globalFilter", r),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (a) => {
      var s;
      const c = (s = r.getCoreRowModel().flatRows[0]) == null || (s = s._getAllCellsByColumnId()[a.id]) == null ? void 0 : s.getValue();
      return typeof c == "string" || typeof c == "number";
    }
  }),
  createColumn: (r, a) => {
    r.getCanGlobalFilter = () => {
      var s, c, u, d;
      return ((s = r.columnDef.enableGlobalFilter) != null ? s : !0) && ((c = a.options.enableGlobalFilter) != null ? c : !0) && ((u = a.options.enableFilters) != null ? u : !0) && ((d = a.options.getColumnCanGlobalFilter == null ? void 0 : a.options.getColumnCanGlobalFilter(r)) != null ? d : !0) && !!r.accessorFn;
    };
  },
  createTable: (r) => {
    r.getGlobalAutoFilterFn = () => filterFns.includesString, r.getGlobalFilterFn = () => {
      var a, s;
      const {
        globalFilterFn: c
      } = r.options;
      return isFunction(c) ? c : c === "auto" ? r.getGlobalAutoFilterFn() : (a = (s = r.options.filterFns) == null ? void 0 : s[c]) != null ? a : filterFns[c];
    }, r.setGlobalFilter = (a) => {
      r.options.onGlobalFilterChange == null || r.options.onGlobalFilterChange(a);
    }, r.resetGlobalFilter = (a) => {
      r.setGlobalFilter(a ? void 0 : r.initialState.globalFilter);
    };
  }
}, RowExpanding = {
  getInitialState: (r) => ({
    expanded: {},
    ...r
  }),
  getDefaultOptions: (r) => ({
    onExpandedChange: makeStateUpdater("expanded", r),
    paginateExpandedRows: !0
  }),
  createTable: (r) => {
    let a = !1, s = !1;
    r._autoResetExpanded = () => {
      var c, u;
      if (!a) {
        r._queue(() => {
          a = !0;
        });
        return;
      }
      if ((c = (u = r.options.autoResetAll) != null ? u : r.options.autoResetExpanded) != null ? c : !r.options.manualExpanding) {
        if (s) return;
        s = !0, r._queue(() => {
          r.resetExpanded(), s = !1;
        });
      }
    }, r.setExpanded = (c) => r.options.onExpandedChange == null ? void 0 : r.options.onExpandedChange(c), r.toggleAllRowsExpanded = (c) => {
      c ?? !r.getIsAllRowsExpanded() ? r.setExpanded(!0) : r.setExpanded({});
    }, r.resetExpanded = (c) => {
      var u, d;
      r.setExpanded(c ? {} : (u = (d = r.initialState) == null ? void 0 : d.expanded) != null ? u : {});
    }, r.getCanSomeRowsExpand = () => r.getPrePaginationRowModel().flatRows.some((c) => c.getCanExpand()), r.getToggleAllRowsExpandedHandler = () => (c) => {
      c.persist == null || c.persist(), r.toggleAllRowsExpanded();
    }, r.getIsSomeRowsExpanded = () => {
      const c = r.getState().expanded;
      return c === !0 || Object.values(c).some(Boolean);
    }, r.getIsAllRowsExpanded = () => {
      const c = r.getState().expanded;
      return typeof c == "boolean" ? c === !0 : !(!Object.keys(c).length || r.getRowModel().flatRows.some((u) => !u.getIsExpanded()));
    }, r.getExpandedDepth = () => {
      let c = 0;
      return (r.getState().expanded === !0 ? Object.keys(r.getRowModel().rowsById) : Object.keys(r.getState().expanded)).forEach((d) => {
        const h = d.split(".");
        c = Math.max(c, h.length);
      }), c;
    }, r.getPreExpandedRowModel = () => r.getSortedRowModel(), r.getExpandedRowModel = () => (!r._getExpandedRowModel && r.options.getExpandedRowModel && (r._getExpandedRowModel = r.options.getExpandedRowModel(r)), r.options.manualExpanding || !r._getExpandedRowModel ? r.getPreExpandedRowModel() : r._getExpandedRowModel());
  },
  createRow: (r, a) => {
    r.toggleExpanded = (s) => {
      a.setExpanded((c) => {
        var u;
        const d = c === !0 ? !0 : !!(c != null && c[r.id]);
        let h = {};
        if (c === !0 ? Object.keys(a.getRowModel().rowsById).forEach((p) => {
          h[p] = !0;
        }) : h = c, s = (u = s) != null ? u : !d, !d && s)
          return {
            ...h,
            [r.id]: !0
          };
        if (d && !s) {
          const {
            [r.id]: p,
            ...m
          } = h;
          return m;
        }
        return c;
      });
    }, r.getIsExpanded = () => {
      var s;
      const c = a.getState().expanded;
      return !!((s = a.options.getIsRowExpanded == null ? void 0 : a.options.getIsRowExpanded(r)) != null ? s : c === !0 || c != null && c[r.id]);
    }, r.getCanExpand = () => {
      var s, c, u;
      return (s = a.options.getRowCanExpand == null ? void 0 : a.options.getRowCanExpand(r)) != null ? s : ((c = a.options.enableExpanding) != null ? c : !0) && !!((u = r.subRows) != null && u.length);
    }, r.getIsAllParentsExpanded = () => {
      let s = !0, c = r;
      for (; s && c.parentId; )
        c = a.getRow(c.parentId, !0), s = c.getIsExpanded();
      return s;
    }, r.getToggleExpandedHandler = () => {
      const s = r.getCanExpand();
      return () => {
        s && r.toggleExpanded();
      };
    };
  }
}, defaultPageIndex = 0, defaultPageSize = 10, getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize
}), RowPagination = {
  getInitialState: (r) => ({
    ...r,
    pagination: {
      ...getDefaultPaginationState(),
      ...r == null ? void 0 : r.pagination
    }
  }),
  getDefaultOptions: (r) => ({
    onPaginationChange: makeStateUpdater("pagination", r)
  }),
  createTable: (r) => {
    let a = !1, s = !1;
    r._autoResetPageIndex = () => {
      var c, u;
      if (!a) {
        r._queue(() => {
          a = !0;
        });
        return;
      }
      if ((c = (u = r.options.autoResetAll) != null ? u : r.options.autoResetPageIndex) != null ? c : !r.options.manualPagination) {
        if (s) return;
        s = !0, r._queue(() => {
          r.resetPageIndex(), s = !1;
        });
      }
    }, r.setPagination = (c) => {
      const u = (d) => functionalUpdate(c, d);
      return r.options.onPaginationChange == null ? void 0 : r.options.onPaginationChange(u);
    }, r.resetPagination = (c) => {
      var u;
      r.setPagination(c ? getDefaultPaginationState() : (u = r.initialState.pagination) != null ? u : getDefaultPaginationState());
    }, r.setPageIndex = (c) => {
      r.setPagination((u) => {
        let d = functionalUpdate(c, u.pageIndex);
        const h = typeof r.options.pageCount > "u" || r.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : r.options.pageCount - 1;
        return d = Math.max(0, Math.min(d, h)), {
          ...u,
          pageIndex: d
        };
      });
    }, r.resetPageIndex = (c) => {
      var u, d;
      r.setPageIndex(c ? defaultPageIndex : (u = (d = r.initialState) == null || (d = d.pagination) == null ? void 0 : d.pageIndex) != null ? u : defaultPageIndex);
    }, r.resetPageSize = (c) => {
      var u, d;
      r.setPageSize(c ? defaultPageSize : (u = (d = r.initialState) == null || (d = d.pagination) == null ? void 0 : d.pageSize) != null ? u : defaultPageSize);
    }, r.setPageSize = (c) => {
      r.setPagination((u) => {
        const d = Math.max(1, functionalUpdate(c, u.pageSize)), h = u.pageSize * u.pageIndex, p = Math.floor(h / d);
        return {
          ...u,
          pageIndex: p,
          pageSize: d
        };
      });
    }, r.setPageCount = (c) => r.setPagination((u) => {
      var d;
      let h = functionalUpdate(c, (d = r.options.pageCount) != null ? d : -1);
      return typeof h == "number" && (h = Math.max(-1, h)), {
        ...u,
        pageCount: h
      };
    }), r.getPageOptions = memo(() => [r.getPageCount()], (c) => {
      let u = [];
      return c && c > 0 && (u = [...new Array(c)].fill(null).map((d, h) => h)), u;
    }, getMemoOptions(r.options, "debugTable", "getPageOptions")), r.getCanPreviousPage = () => r.getState().pagination.pageIndex > 0, r.getCanNextPage = () => {
      const {
        pageIndex: c
      } = r.getState().pagination, u = r.getPageCount();
      return u === -1 ? !0 : u === 0 ? !1 : c < u - 1;
    }, r.previousPage = () => r.setPageIndex((c) => c - 1), r.nextPage = () => r.setPageIndex((c) => c + 1), r.firstPage = () => r.setPageIndex(0), r.lastPage = () => r.setPageIndex(r.getPageCount() - 1), r.getPrePaginationRowModel = () => r.getExpandedRowModel(), r.getPaginationRowModel = () => (!r._getPaginationRowModel && r.options.getPaginationRowModel && (r._getPaginationRowModel = r.options.getPaginationRowModel(r)), r.options.manualPagination || !r._getPaginationRowModel ? r.getPrePaginationRowModel() : r._getPaginationRowModel()), r.getPageCount = () => {
      var c;
      return (c = r.options.pageCount) != null ? c : Math.ceil(r.getRowCount() / r.getState().pagination.pageSize);
    }, r.getRowCount = () => {
      var c;
      return (c = r.options.rowCount) != null ? c : r.getPrePaginationRowModel().rows.length;
    };
  }
}, getDefaultRowPinningState = () => ({
  top: [],
  bottom: []
}), RowPinning = {
  getInitialState: (r) => ({
    rowPinning: getDefaultRowPinningState(),
    ...r
  }),
  getDefaultOptions: (r) => ({
    onRowPinningChange: makeStateUpdater("rowPinning", r)
  }),
  createRow: (r, a) => {
    r.pin = (s, c, u) => {
      const d = c ? r.getLeafRows().map((m) => {
        let {
          id: g
        } = m;
        return g;
      }) : [], h = u ? r.getParentRows().map((m) => {
        let {
          id: g
        } = m;
        return g;
      }) : [], p = /* @__PURE__ */ new Set([...h, r.id, ...d]);
      a.setRowPinning((m) => {
        var g, v;
        if (s === "bottom") {
          var y, x;
          return {
            top: ((y = m == null ? void 0 : m.top) != null ? y : []).filter((M) => !(p != null && p.has(M))),
            bottom: [...((x = m == null ? void 0 : m.bottom) != null ? x : []).filter((M) => !(p != null && p.has(M))), ...Array.from(p)]
          };
        }
        if (s === "top") {
          var w, S;
          return {
            top: [...((w = m == null ? void 0 : m.top) != null ? w : []).filter((M) => !(p != null && p.has(M))), ...Array.from(p)],
            bottom: ((S = m == null ? void 0 : m.bottom) != null ? S : []).filter((M) => !(p != null && p.has(M)))
          };
        }
        return {
          top: ((g = m == null ? void 0 : m.top) != null ? g : []).filter((M) => !(p != null && p.has(M))),
          bottom: ((v = m == null ? void 0 : m.bottom) != null ? v : []).filter((M) => !(p != null && p.has(M)))
        };
      });
    }, r.getCanPin = () => {
      var s;
      const {
        enableRowPinning: c,
        enablePinning: u
      } = a.options;
      return typeof c == "function" ? c(r) : (s = c ?? u) != null ? s : !0;
    }, r.getIsPinned = () => {
      const s = [r.id], {
        top: c,
        bottom: u
      } = a.getState().rowPinning, d = s.some((p) => c == null ? void 0 : c.includes(p)), h = s.some((p) => u == null ? void 0 : u.includes(p));
      return d ? "top" : h ? "bottom" : !1;
    }, r.getPinnedIndex = () => {
      var s, c;
      const u = r.getIsPinned();
      if (!u) return -1;
      const d = (s = u === "top" ? a.getTopRows() : a.getBottomRows()) == null ? void 0 : s.map((h) => {
        let {
          id: p
        } = h;
        return p;
      });
      return (c = d == null ? void 0 : d.indexOf(r.id)) != null ? c : -1;
    };
  },
  createTable: (r) => {
    r.setRowPinning = (a) => r.options.onRowPinningChange == null ? void 0 : r.options.onRowPinningChange(a), r.resetRowPinning = (a) => {
      var s, c;
      return r.setRowPinning(a ? getDefaultRowPinningState() : (s = (c = r.initialState) == null ? void 0 : c.rowPinning) != null ? s : getDefaultRowPinningState());
    }, r.getIsSomeRowsPinned = (a) => {
      var s;
      const c = r.getState().rowPinning;
      if (!a) {
        var u, d;
        return !!((u = c.top) != null && u.length || (d = c.bottom) != null && d.length);
      }
      return !!((s = c[a]) != null && s.length);
    }, r._getPinnedRows = (a, s, c) => {
      var u;
      return ((u = r.options.keepPinnedRows) == null || u ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (s ?? []).map((h) => {
          const p = r.getRow(h, !0);
          return p.getIsAllParentsExpanded() ? p : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (s ?? []).map((h) => a.find((p) => p.id === h))
      )).filter(Boolean).map((h) => ({
        ...h,
        position: c
      }));
    }, r.getTopRows = memo(() => [r.getRowModel().rows, r.getState().rowPinning.top], (a, s) => r._getPinnedRows(a, s, "top"), getMemoOptions(r.options, "debugRows", "getTopRows")), r.getBottomRows = memo(() => [r.getRowModel().rows, r.getState().rowPinning.bottom], (a, s) => r._getPinnedRows(a, s, "bottom"), getMemoOptions(r.options, "debugRows", "getBottomRows")), r.getCenterRows = memo(() => [r.getRowModel().rows, r.getState().rowPinning.top, r.getState().rowPinning.bottom], (a, s, c) => {
      const u = /* @__PURE__ */ new Set([...s ?? [], ...c ?? []]);
      return a.filter((d) => !u.has(d.id));
    }, getMemoOptions(r.options, "debugRows", "getCenterRows"));
  }
}, RowSelection = {
  getInitialState: (r) => ({
    rowSelection: {},
    ...r
  }),
  getDefaultOptions: (r) => ({
    onRowSelectionChange: makeStateUpdater("rowSelection", r),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (r) => {
    r.setRowSelection = (a) => r.options.onRowSelectionChange == null ? void 0 : r.options.onRowSelectionChange(a), r.resetRowSelection = (a) => {
      var s;
      return r.setRowSelection(a ? {} : (s = r.initialState.rowSelection) != null ? s : {});
    }, r.toggleAllRowsSelected = (a) => {
      r.setRowSelection((s) => {
        a = typeof a < "u" ? a : !r.getIsAllRowsSelected();
        const c = {
          ...s
        }, u = r.getPreGroupedRowModel().flatRows;
        return a ? u.forEach((d) => {
          d.getCanSelect() && (c[d.id] = !0);
        }) : u.forEach((d) => {
          delete c[d.id];
        }), c;
      });
    }, r.toggleAllPageRowsSelected = (a) => r.setRowSelection((s) => {
      const c = typeof a < "u" ? a : !r.getIsAllPageRowsSelected(), u = {
        ...s
      };
      return r.getRowModel().rows.forEach((d) => {
        mutateRowIsSelected(u, d.id, c, !0, r);
      }), u;
    }), r.getPreSelectedRowModel = () => r.getCoreRowModel(), r.getSelectedRowModel = memo(() => [r.getState().rowSelection, r.getCoreRowModel()], (a, s) => Object.keys(a).length ? selectRowsFn(r, s) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, getMemoOptions(r.options, "debugTable", "getSelectedRowModel")), r.getFilteredSelectedRowModel = memo(() => [r.getState().rowSelection, r.getFilteredRowModel()], (a, s) => Object.keys(a).length ? selectRowsFn(r, s) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, getMemoOptions(r.options, "debugTable", "getFilteredSelectedRowModel")), r.getGroupedSelectedRowModel = memo(() => [r.getState().rowSelection, r.getSortedRowModel()], (a, s) => Object.keys(a).length ? selectRowsFn(r, s) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, getMemoOptions(r.options, "debugTable", "getGroupedSelectedRowModel")), r.getIsAllRowsSelected = () => {
      const a = r.getFilteredRowModel().flatRows, {
        rowSelection: s
      } = r.getState();
      let c = !!(a.length && Object.keys(s).length);
      return c && a.some((u) => u.getCanSelect() && !s[u.id]) && (c = !1), c;
    }, r.getIsAllPageRowsSelected = () => {
      const a = r.getPaginationRowModel().flatRows.filter((u) => u.getCanSelect()), {
        rowSelection: s
      } = r.getState();
      let c = !!a.length;
      return c && a.some((u) => !s[u.id]) && (c = !1), c;
    }, r.getIsSomeRowsSelected = () => {
      var a;
      const s = Object.keys((a = r.getState().rowSelection) != null ? a : {}).length;
      return s > 0 && s < r.getFilteredRowModel().flatRows.length;
    }, r.getIsSomePageRowsSelected = () => {
      const a = r.getPaginationRowModel().flatRows;
      return r.getIsAllPageRowsSelected() ? !1 : a.filter((s) => s.getCanSelect()).some((s) => s.getIsSelected() || s.getIsSomeSelected());
    }, r.getToggleAllRowsSelectedHandler = () => (a) => {
      r.toggleAllRowsSelected(a.target.checked);
    }, r.getToggleAllPageRowsSelectedHandler = () => (a) => {
      r.toggleAllPageRowsSelected(a.target.checked);
    };
  },
  createRow: (r, a) => {
    r.toggleSelected = (s, c) => {
      const u = r.getIsSelected();
      a.setRowSelection((d) => {
        var h;
        if (s = typeof s < "u" ? s : !u, r.getCanSelect() && u === s)
          return d;
        const p = {
          ...d
        };
        return mutateRowIsSelected(p, r.id, s, (h = c == null ? void 0 : c.selectChildren) != null ? h : !0, a), p;
      });
    }, r.getIsSelected = () => {
      const {
        rowSelection: s
      } = a.getState();
      return isRowSelected(r, s);
    }, r.getIsSomeSelected = () => {
      const {
        rowSelection: s
      } = a.getState();
      return isSubRowSelected(r, s) === "some";
    }, r.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: s
      } = a.getState();
      return isSubRowSelected(r, s) === "all";
    }, r.getCanSelect = () => {
      var s;
      return typeof a.options.enableRowSelection == "function" ? a.options.enableRowSelection(r) : (s = a.options.enableRowSelection) != null ? s : !0;
    }, r.getCanSelectSubRows = () => {
      var s;
      return typeof a.options.enableSubRowSelection == "function" ? a.options.enableSubRowSelection(r) : (s = a.options.enableSubRowSelection) != null ? s : !0;
    }, r.getCanMultiSelect = () => {
      var s;
      return typeof a.options.enableMultiRowSelection == "function" ? a.options.enableMultiRowSelection(r) : (s = a.options.enableMultiRowSelection) != null ? s : !0;
    }, r.getToggleSelectedHandler = () => {
      const s = r.getCanSelect();
      return (c) => {
        var u;
        s && r.toggleSelected((u = c.target) == null ? void 0 : u.checked);
      };
    };
  }
}, mutateRowIsSelected = (r, a, s, c, u) => {
  var d;
  const h = u.getRow(a, !0);
  s ? (h.getCanMultiSelect() || Object.keys(r).forEach((p) => delete r[p]), h.getCanSelect() && (r[a] = !0)) : delete r[a], c && (d = h.subRows) != null && d.length && h.getCanSelectSubRows() && h.subRows.forEach((p) => mutateRowIsSelected(r, p.id, s, c, u));
};
function selectRowsFn(r, a) {
  const s = r.getState().rowSelection, c = [], u = {}, d = function(h, p) {
    return h.map((m) => {
      var g;
      const v = isRowSelected(m, s);
      if (v && (c.push(m), u[m.id] = m), (g = m.subRows) != null && g.length && (m = {
        ...m,
        subRows: d(m.subRows)
      }), v)
        return m;
    }).filter(Boolean);
  };
  return {
    rows: d(a.rows),
    flatRows: c,
    rowsById: u
  };
}
function isRowSelected(r, a) {
  var s;
  return (s = a[r.id]) != null ? s : !1;
}
function isSubRowSelected(r, a, s) {
  var c;
  if (!((c = r.subRows) != null && c.length)) return !1;
  let u = !0, d = !1;
  return r.subRows.forEach((h) => {
    if (!(d && !u) && (h.getCanSelect() && (isRowSelected(h, a) ? d = !0 : u = !1), h.subRows && h.subRows.length)) {
      const p = isSubRowSelected(h, a);
      p === "all" ? d = !0 : (p === "some" && (d = !0), u = !1);
    }
  }), u ? "all" : d ? "some" : !1;
}
const reSplitAlphaNumeric = /([0-9]+)/gm, alphanumeric = (r, a, s) => compareAlphanumeric(toString(r.getValue(s)).toLowerCase(), toString(a.getValue(s)).toLowerCase()), alphanumericCaseSensitive = (r, a, s) => compareAlphanumeric(toString(r.getValue(s)), toString(a.getValue(s))), text = (r, a, s) => compareBasic(toString(r.getValue(s)).toLowerCase(), toString(a.getValue(s)).toLowerCase()), textCaseSensitive = (r, a, s) => compareBasic(toString(r.getValue(s)), toString(a.getValue(s))), datetime = (r, a, s) => {
  const c = r.getValue(s), u = a.getValue(s);
  return c > u ? 1 : c < u ? -1 : 0;
}, basic = (r, a, s) => compareBasic(r.getValue(s), a.getValue(s));
function compareBasic(r, a) {
  return r === a ? 0 : r > a ? 1 : -1;
}
function toString(r) {
  return typeof r == "number" ? isNaN(r) || r === 1 / 0 || r === -1 / 0 ? "" : String(r) : typeof r == "string" ? r : "";
}
function compareAlphanumeric(r, a) {
  const s = r.split(reSplitAlphaNumeric).filter(Boolean), c = a.split(reSplitAlphaNumeric).filter(Boolean);
  for (; s.length && c.length; ) {
    const u = s.shift(), d = c.shift(), h = parseInt(u, 10), p = parseInt(d, 10), m = [h, p].sort();
    if (isNaN(m[0])) {
      if (u > d)
        return 1;
      if (d > u)
        return -1;
      continue;
    }
    if (isNaN(m[1]))
      return isNaN(h) ? -1 : 1;
    if (h > p)
      return 1;
    if (p > h)
      return -1;
  }
  return s.length - c.length;
}
const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic
}, RowSorting = {
  getInitialState: (r) => ({
    sorting: [],
    ...r
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (r) => ({
    onSortingChange: makeStateUpdater("sorting", r),
    isMultiSortEvent: (a) => a.shiftKey
  }),
  createColumn: (r, a) => {
    r.getAutoSortingFn = () => {
      const s = a.getFilteredRowModel().flatRows.slice(10);
      let c = !1;
      for (const u of s) {
        const d = u == null ? void 0 : u.getValue(r.id);
        if (Object.prototype.toString.call(d) === "[object Date]")
          return sortingFns.datetime;
        if (typeof d == "string" && (c = !0, d.split(reSplitAlphaNumeric).length > 1))
          return sortingFns.alphanumeric;
      }
      return c ? sortingFns.text : sortingFns.basic;
    }, r.getAutoSortDir = () => {
      const s = a.getFilteredRowModel().flatRows[0];
      return typeof (s == null ? void 0 : s.getValue(r.id)) == "string" ? "asc" : "desc";
    }, r.getSortingFn = () => {
      var s, c;
      if (!r)
        throw new Error();
      return isFunction(r.columnDef.sortingFn) ? r.columnDef.sortingFn : r.columnDef.sortingFn === "auto" ? r.getAutoSortingFn() : (s = (c = a.options.sortingFns) == null ? void 0 : c[r.columnDef.sortingFn]) != null ? s : sortingFns[r.columnDef.sortingFn];
    }, r.toggleSorting = (s, c) => {
      const u = r.getNextSortingOrder(), d = typeof s < "u" && s !== null;
      a.setSorting((h) => {
        const p = h == null ? void 0 : h.find((w) => w.id === r.id), m = h == null ? void 0 : h.findIndex((w) => w.id === r.id);
        let g = [], v, y = d ? s : u === "desc";
        if (h != null && h.length && r.getCanMultiSort() && c ? p ? v = "toggle" : v = "add" : h != null && h.length && m !== h.length - 1 ? v = "replace" : p ? v = "toggle" : v = "replace", v === "toggle" && (d || u || (v = "remove")), v === "add") {
          var x;
          g = [...h, {
            id: r.id,
            desc: y
          }], g.splice(0, g.length - ((x = a.options.maxMultiSortColCount) != null ? x : Number.MAX_SAFE_INTEGER));
        } else v === "toggle" ? g = h.map((w) => w.id === r.id ? {
          ...w,
          desc: y
        } : w) : v === "remove" ? g = h.filter((w) => w.id !== r.id) : g = [{
          id: r.id,
          desc: y
        }];
        return g;
      });
    }, r.getFirstSortDir = () => {
      var s, c;
      return ((s = (c = r.columnDef.sortDescFirst) != null ? c : a.options.sortDescFirst) != null ? s : r.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, r.getNextSortingOrder = (s) => {
      var c, u;
      const d = r.getFirstSortDir(), h = r.getIsSorted();
      return h ? h !== d && ((c = a.options.enableSortingRemoval) == null || c) && // If enableSortRemove, enable in general
      (!(s && (u = a.options.enableMultiRemove) != null) || u) ? !1 : h === "desc" ? "asc" : "desc" : d;
    }, r.getCanSort = () => {
      var s, c;
      return ((s = r.columnDef.enableSorting) != null ? s : !0) && ((c = a.options.enableSorting) != null ? c : !0) && !!r.accessorFn;
    }, r.getCanMultiSort = () => {
      var s, c;
      return (s = (c = r.columnDef.enableMultiSort) != null ? c : a.options.enableMultiSort) != null ? s : !!r.accessorFn;
    }, r.getIsSorted = () => {
      var s;
      const c = (s = a.getState().sorting) == null ? void 0 : s.find((u) => u.id === r.id);
      return c ? c.desc ? "desc" : "asc" : !1;
    }, r.getSortIndex = () => {
      var s, c;
      return (s = (c = a.getState().sorting) == null ? void 0 : c.findIndex((u) => u.id === r.id)) != null ? s : -1;
    }, r.clearSorting = () => {
      a.setSorting((s) => s != null && s.length ? s.filter((c) => c.id !== r.id) : []);
    }, r.getToggleSortingHandler = () => {
      const s = r.getCanSort();
      return (c) => {
        s && (c.persist == null || c.persist(), r.toggleSorting == null || r.toggleSorting(void 0, r.getCanMultiSort() ? a.options.isMultiSortEvent == null ? void 0 : a.options.isMultiSortEvent(c) : !1));
      };
    };
  },
  createTable: (r) => {
    r.setSorting = (a) => r.options.onSortingChange == null ? void 0 : r.options.onSortingChange(a), r.resetSorting = (a) => {
      var s, c;
      r.setSorting(a ? [] : (s = (c = r.initialState) == null ? void 0 : c.sorting) != null ? s : []);
    }, r.getPreSortedRowModel = () => r.getGroupedRowModel(), r.getSortedRowModel = () => (!r._getSortedRowModel && r.options.getSortedRowModel && (r._getSortedRowModel = r.options.getSortedRowModel(r)), r.options.manualSorting || !r._getSortedRowModel ? r.getPreSortedRowModel() : r._getSortedRowModel());
  }
}, builtInFeatures = [
  Headers,
  ColumnVisibility,
  ColumnOrdering,
  ColumnPinning,
  ColumnFaceting,
  ColumnFiltering,
  GlobalFaceting,
  //depends on ColumnFaceting
  GlobalFiltering,
  //depends on ColumnFiltering
  RowSorting,
  ColumnGrouping,
  //depends on RowSorting
  RowExpanding,
  RowPagination,
  RowPinning,
  RowSelection,
  ColumnSizing
];
function createTable(r) {
  var a, s;
  process.env.NODE_ENV !== "production" && (r.debugAll || r.debugTable) && console.info("Creating Table Instance...");
  const c = [...builtInFeatures, ...(a = r._features) != null ? a : []];
  let u = {
    _features: c
  };
  const d = u._features.reduce((x, w) => Object.assign(x, w.getDefaultOptions == null ? void 0 : w.getDefaultOptions(u)), {}), h = (x) => u.options.mergeOptions ? u.options.mergeOptions(d, x) : {
    ...d,
    ...x
  };
  let m = {
    ...{},
    ...(s = r.initialState) != null ? s : {}
  };
  u._features.forEach((x) => {
    var w;
    m = (w = x.getInitialState == null ? void 0 : x.getInitialState(m)) != null ? w : m;
  });
  const g = [];
  let v = !1;
  const y = {
    _features: c,
    options: {
      ...d,
      ...r
    },
    initialState: m,
    _queue: (x) => {
      g.push(x), v || (v = !0, Promise.resolve().then(() => {
        for (; g.length; )
          g.shift()();
        v = !1;
      }).catch((w) => setTimeout(() => {
        throw w;
      })));
    },
    reset: () => {
      u.setState(u.initialState);
    },
    setOptions: (x) => {
      const w = functionalUpdate(x, u.options);
      u.options = h(w);
    },
    getState: () => u.options.state,
    setState: (x) => {
      u.options.onStateChange == null || u.options.onStateChange(x);
    },
    _getRowId: (x, w, S) => {
      var M;
      return (M = u.options.getRowId == null ? void 0 : u.options.getRowId(x, w, S)) != null ? M : `${S ? [S.id, w].join(".") : w}`;
    },
    getCoreRowModel: () => (u._getCoreRowModel || (u._getCoreRowModel = u.options.getCoreRowModel(u)), u._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => u.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (x, w) => {
      let S = (w ? u.getPrePaginationRowModel() : u.getRowModel()).rowsById[x];
      if (!S && (S = u.getCoreRowModel().rowsById[x], !S))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${x}`) : new Error();
      return S;
    },
    _getDefaultColumnDef: memo(() => [u.options.defaultColumn], (x) => {
      var w;
      return x = (w = x) != null ? w : {}, {
        header: (S) => {
          const M = S.header.column.columnDef;
          return M.accessorKey ? M.accessorKey : M.accessorFn ? M.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (S) => {
          var M, P;
          return (M = (P = S.renderValue()) == null || P.toString == null ? void 0 : P.toString()) != null ? M : null;
        },
        ...u._features.reduce((S, M) => Object.assign(S, M.getDefaultColumnDef == null ? void 0 : M.getDefaultColumnDef()), {}),
        ...x
      };
    }, getMemoOptions(r, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => u.options.columns,
    getAllColumns: memo(() => [u._getColumnDefs()], (x) => {
      const w = function(S, M, P) {
        return P === void 0 && (P = 0), S.map((L) => {
          const I = createColumn(u, L, P, M), T = L;
          return I.columns = T.columns ? w(T.columns, I, P + 1) : [], I;
        });
      };
      return w(x);
    }, getMemoOptions(r, "debugColumns", "getAllColumns")),
    getAllFlatColumns: memo(() => [u.getAllColumns()], (x) => x.flatMap((w) => w.getFlatColumns()), getMemoOptions(r, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: memo(() => [u.getAllFlatColumns()], (x) => x.reduce((w, S) => (w[S.id] = S, w), {}), getMemoOptions(r, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: memo(() => [u.getAllColumns(), u._getOrderColumnsFn()], (x, w) => {
      let S = x.flatMap((M) => M.getLeafColumns());
      return w(S);
    }, getMemoOptions(r, "debugColumns", "getAllLeafColumns")),
    getColumn: (x) => {
      const w = u._getAllFlatColumnsById()[x];
      return process.env.NODE_ENV !== "production" && !w && console.error(`[Table] Column with id '${x}' does not exist.`), w;
    }
  };
  Object.assign(u, y);
  for (let x = 0; x < u._features.length; x++) {
    const w = u._features[x];
    w == null || w.createTable == null || w.createTable(u);
  }
  return u;
}
function getCoreRowModel() {
  return (r) => memo(() => [r.options.data], (a) => {
    const s = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, c = function(u, d, h) {
      d === void 0 && (d = 0);
      const p = [];
      for (let g = 0; g < u.length; g++) {
        const v = createRow(r, r._getRowId(u[g], g, h), u[g], g, d, void 0, h == null ? void 0 : h.id);
        if (s.flatRows.push(v), s.rowsById[v.id] = v, p.push(v), r.options.getSubRows) {
          var m;
          v.originalSubRows = r.options.getSubRows(u[g], g), (m = v.originalSubRows) != null && m.length && (v.subRows = c(v.originalSubRows, d + 1, v));
        }
      }
      return p;
    };
    return s.rows = c(a), s;
  }, getMemoOptions(r.options, "debugTable", "getRowModel", () => r._autoResetPageIndex()));
}
function getExpandedRowModel() {
  return (r) => memo(() => [r.getState().expanded, r.getPreExpandedRowModel(), r.options.paginateExpandedRows], (a, s, c) => !s.rows.length || a !== !0 && !Object.keys(a ?? {}).length || !c ? s : expandRows(s), getMemoOptions(r.options, "debugTable", "getExpandedRowModel"));
}
function expandRows(r) {
  const a = [], s = (c) => {
    var u;
    a.push(c), (u = c.subRows) != null && u.length && c.getIsExpanded() && c.subRows.forEach(s);
  };
  return r.rows.forEach(s), {
    rows: a,
    flatRows: r.flatRows,
    rowsById: r.rowsById
  };
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function flexRender(r, a) {
  return r ? isReactComponent(r) ? /* @__PURE__ */ React.createElement(r, a) : r : null;
}
function isReactComponent(r) {
  return isClassComponent(r) || typeof r == "function" || isExoticComponent(r);
}
function isClassComponent(r) {
  return typeof r == "function" && (() => {
    const a = Object.getPrototypeOf(r);
    return a.prototype && a.prototype.isReactComponent;
  })();
}
function isExoticComponent(r) {
  return typeof r == "object" && typeof r.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(r.$$typeof.description);
}
function useReactTable(r) {
  const a = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...r
  }, [s] = React.useState(() => ({
    current: createTable(a)
  })), [c, u] = React.useState(() => s.current.initialState);
  return s.current.setOptions((d) => ({
    ...d,
    ...r,
    state: {
      ...c,
      ...r.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (h) => {
      u(h), r.onStateChange == null || r.onStateChange(h);
    }
  })), s.current;
}
const _useTableFocus = ({ ref: r }) => {
  const [a, s] = useState$1();
  return useEffect$1(() => {
    const c = r.current, u = () => {
      var d;
      s(((d = document.activeElement) == null ? void 0 : d.getAttribute("id")) || void 0);
    };
    return c == null || c.addEventListener("focusin", u), () => {
      c == null || c.removeEventListener("focusin", u);
    };
  }, [r]), a;
}, expandColumnId = "expand", getSelectRowId = (r) => `selectable-row-checkbox-${r}`, DesktopTableComponent = ({
  captionId: r,
  getHeaderGroups: a,
  getState: s,
  setColumnSizing: c,
  getRowModel: u,
  onRowClick: d,
  isLoading: h,
  hideHeaderWhileLoading: p,
  loadingRowIds: m = [],
  highlightedRowIds: g = [],
  isHeaderSticky: v,
  sortingState: y,
  headerVariant: x,
  ...w
}, S) => {
  var k, V;
  const M = [], P = !h || !p, L = useRef$1(null), I = useMergeRefs([S, L]), T = _useTableFocus({ ref: L }), { scrollAtLeft: E, scrollAtRight: R, isOverflowX: A } = useScrollBorders({ ref: L });
  return /* @__PURE__ */ jsx(_TableContext.Provider, { value: { headerVariant: x, focusedCellId: T }, children: /* @__PURE__ */ jsxs(
    _Table,
    {
      ...w,
      ref: I,
      isLoading: h,
      isHeaderSticky: v,
      "data-component": "Table",
      "aria-labelledby": r,
      "aria-rowcount": u().rows.length,
      "aria-colcount": (k = a()[0]) == null ? void 0 : k.headers.length,
      "data-rowcount": u().rows.length,
      "data-colcount": (V = a()[0]) == null ? void 0 : V.headers.length,
      "aria-busy": h,
      children: [
        P && /* @__PURE__ */ jsx(_TableHead, { isHeaderSticky: v, children: a().map((B, q) => /* @__PURE__ */ jsx(_TableHeaderRow, { "aria-rowindex": q + 1, "data-rowindex": q + 1, children: B.headers.map((z, Z) => {
          const { size: G, textAlign: K } = z.column.columnDef.meta, U = z.getContext(), F = flexRender(z.column.columnDef.header, U), N = F ? typeof z.column.columnDef.header == "string" ? /* @__PURE__ */ jsx(_TableHeaderCell, { textAlign: K, children: z.column.columnDef.header }) : isValidElement(F) && cloneElement(F, {
            id: `${z.id}-header`,
            meta: U.table.options.meta
          }) : null;
          return /* @__PURE__ */ jsx(
            _TableHeaderBaseCell,
            {
              size: G,
              textAlign: K,
              variant: x,
              pinOptions: getPinOptions(z.column, A, E, R),
              "data-testid": `table-header-cell-${z.column.columnDef.id}`,
              sortDirection: (y == null ? void 0 : y.id) === z.id ? y.sortDirection : void 0,
              "aria-colindex": Z + 1,
              "data-colindex": Z + 1,
              ref: (D) => columnSizingHandler(D, s, c, z.column),
              children: N
            },
            z.id
          );
        }) }, B.id)) }),
        /* @__PURE__ */ jsx(_TableBody, { isLoading: h, children: u().rows.map((B) => {
          var K;
          if (B.subRows.length > 0) {
            const U = (K = B.subRows[B.subRows.length - 1]) == null ? void 0 : K.id;
            M.push(U);
          }
          const q = m.includes(B.id), z = g.includes(B.id), Z = B.depth > 0, G = Z ? `table-sub-row-${B.id}` : `table-row-${B.id}`;
          return /* @__PURE__ */ jsx(
            _TableRow,
            {
              onClick: d ? () => d({ rowId: B.id, rowData: B.original }) : void 0,
              isSubRow: Z,
              isLastSubRow: M.includes(B.id),
              "data-testid": G,
              isRowHighlighted: z,
              "aria-rowindex": B.index + 1,
              "data-rowindex": B.index + 1,
              children: B.getVisibleCells().map((U, F) => {
                const { size: N, textAlign: D } = U.column.columnDef.meta, j = !(B.depth === 0 && U.id.includes(expandColumnId));
                return /* @__PURE__ */ jsxs(
                  _TableDataCell,
                  {
                    size: N,
                    textAlign: D,
                    pinOptions: getPinOptions(U.column, A, E, R),
                    "aria-colindex": F + 1,
                    "data-colindex": F + 1,
                    children: [
                      /* @__PURE__ */ jsx(Blanket, { variant: "light", isOpen: q && j }),
                      flexRender(U.column.columnDef.cell, {
                        ...U.getContext(),
                        isLoading: q
                      })
                    ]
                  },
                  U.id
                );
              })
            },
            B.id
          );
        }) })
      ]
    }
  ) });
}, DesktopTable = React__default.forwardRef(DesktopTableComponent);
DesktopTable.displayName = "Table";
const TableComponent = ({
  getRowModel: r,
  onRowClick: a,
  isLoading: s,
  loadingRowIds: c = [],
  highlightedRowIds: u = [],
  mobileRowRenderer: d,
  isHeaderSticky: h,
  sortingState: p,
  getHeaderGroups: m,
  ...g
}, v) => {
  const { isExtraSmallScreen: y } = useBreakpoint(), x = useMultiStyleConfig("Table", {}), w = {
    getRowModel: r,
    onRowClick: a,
    isLoading: s,
    getHeaderGroups: m,
    isHeaderSticky: h
  }, S = useFocusManager(s);
  return /* @__PURE__ */ jsxs(Container, { overflow: "initial", children: [
    y && d ? /* @__PURE__ */ jsx(
      _TableMobileContainer,
      {
        ...w,
        highlightedRowIds: u,
        mobileRowRenderer: d
      }
    ) : /* @__PURE__ */ jsx(
      DesktopTable,
      {
        ref: v,
        ...w,
        loadingRowIds: c,
        highlightedRowIds: u,
        ...g
      }
    ),
    s && /* @__PURE__ */ jsx(Box, { __css: x.loaderContainer, ref: S, children: /* @__PURE__ */ jsx(Blanket, { isOpen: !0, variant: "light", isLoading: !0 }) })
  ] });
}, Table$1 = React__default.forwardRef(TableComponent);
Table$1.displayName = "Table";
const Table = Object.assign(Table$1, cells), toPennySortingState = (r) => {
  const a = r && r.length > 0 ? r[0] : void 0;
  if (a)
    return {
      id: a.id,
      sortDirection: a.desc ? "desc" : "asc"
    };
}, toReactTableSortingState = (r) => r ? [
  {
    id: r.id,
    desc: r.sortDirection === "desc"
  }
] : [], toReactTableOnSortingChange = (r) => (a) => {
  if (r) {
    if (typeof a == "function") {
      r((s) => {
        const c = toReactTableSortingState(s), u = a(c);
        return toPennySortingState(u);
      });
      return;
    }
    r(toPennySortingState(a));
  }
};
function renderSelectableHeader({ table: r, column: a }) {
  var u;
  const { selectableRowOptions: s, skipToLink: c } = a.columnDef.meta;
  return /* @__PURE__ */ jsx(
    _TableSelectableCell,
    {
      isChecked: r.getIsAllRowsSelected(),
      isIndeterminate: r.getIsSomeRowsSelected(),
      onChange: (d) => {
        var h;
        return (h = s == null ? void 0 : s.onAllRowsSelectionChange) == null || h.call(s, !r.getIsAllRowsSelected()), r.getToggleAllRowsSelectedHandler()(d);
      },
      isDisabled: s == null ? void 0 : s.disableAllRowsSelection,
      tooltip: (u = s == null ? void 0 : s.rowSelectionTooltips) == null ? void 0 : u.header,
      "data-testid": "table-selectable-header-cell",
      isHeader: !0,
      "aria-label": s == null ? void 0 : s.allRowsSelectionAriaLabel,
      "aria-controls": s == null ? void 0 : s.data.map((d, h) => getSelectRowId(h)).join(" "),
      skipToLink: c,
      id: "select-all-checkbox"
    }
  );
}
function renderSelectableCell({ row: r, column: a }) {
  var u, d, h, p, m;
  const { selectableRowOptions: s, skipToLink: c } = a.columnDef.meta;
  return /* @__PURE__ */ jsx(
    _TableSelectableCell,
    {
      isChecked: r.getIsSelected(),
      isIndeterminate: r.getIsSomeSelected(),
      id: getSelectRowId(r.index),
      onChange: (g) => {
        var v;
        (v = s == null ? void 0 : s.onRowSelectionChange) == null || v.call(s, {
          rowId: r.id,
          rowData: r.original,
          isSelected: !r.getIsSelected()
        }), r.getToggleSelectedHandler()(g);
      },
      isDisabled: !r.getCanSelect(),
      tooltip: (d = (u = s == null ? void 0 : s.rowSelectionTooltips) == null ? void 0 : u.row) == null ? void 0 : d.call(u, {
        rowData: r.original,
        isSelectionDisabled: !r.getCanSelect()
      }),
      "data-testid": `table-row-${r.id}-selectable-cell`,
      "aria-label": (h = s == null ? void 0 : s.getRowSelectionAriaLabel) == null ? void 0 : h.call(s, r.original),
      skipToLink: c,
      cellDataTestId: `table-selectable-row-${r.id}`,
      "aria-labelledby": (p = s == null ? void 0 : s.getRowSelectionAriaLabelledBy) == null ? void 0 : p.call(s, {
        ...r.original,
        index: r.index,
        isSelectionDisabled: !r.getCanSelect()
      }),
      "aria-describedby": (m = s == null ? void 0 : s.getRowSelectionAriaDescribedBy) == null ? void 0 : m.call(s, {
        ...r.original,
        index: r.index,
        isSelectionDisabled: !r.getCanSelect()
      })
    }
  );
}
function renderCell({ row: r, cell: a, column: s, table: c, isLoading: u }) {
  var m, g;
  const d = a.column.columnDef.meta, h = r.depth > 0, p = h ? (m = d.subRowCellRenderer) == null ? void 0 : m.call(d, {
    row: r.original,
    rowIndex: r.index,
    columnId: s.id,
    meta: c.options.meta
  }) : (g = d.cellRenderer) == null ? void 0 : g.call(d, {
    row: r.original,
    rowIndex: r.index,
    columnId: s.id,
    meta: c.options.meta
  });
  return isValidElement(p) ? cloneElement(p, {
    isLoading: u,
    id: `${s.id}-${r.index}-${h ? "sub-row-cell" : "cell"}`
  }) : /* @__PURE__ */ jsx(Table.Cell, { children: p });
}
const useColumnDefs = ({
  columns: r,
  data: a,
  disableAllRowsSelection: s,
  rowSelectionTooltips: c,
  onRowSelectionChange: u,
  allRowsSelectionAriaLabel: d,
  onAllRowsSelectionChange: h,
  getRowSelectionAriaLabel: p,
  onRowExpandChange: m,
  skipToLink: g,
  getRowSelectionAriaLabelledBy: v,
  getRowSelectionAriaDescribedBy: y
}) => {
  const x = useMemo$1(
    () => ({
      id: expandColumnId,
      header: void 0,
      cell: ({ row: P }) => P.getCanExpand() ? /* @__PURE__ */ jsx(
        _TableExpandCell,
        {
          toggleExpanded: () => (m == null || m({
            rowId: P.id,
            isExpanded: !P.getIsExpanded()
          }), P.getToggleExpandedHandler()()),
          isExpanded: P.getIsExpanded(),
          "data-testid": `table-row-${P.id}-expand-cell`
        }
      ) : /* @__PURE__ */ jsx(Table.Cell, {}),
      meta: {
        textAlign: "start",
        size: "xs",
        isPinnedToLeft: r.some((P) => P.isPinnedToLeft)
      }
    }),
    [r, m]
  ), w = useMemo$1(
    () => r.map(
      ({ size: P, cell: L, subRowCell: I, header: T, textAlign: E, isPinnedToLeft: R, isPinnedToRight: A, isRowHeader: k, ...V }) => ({
        ...V,
        header: T || void 0,
        cell: renderCell,
        meta: {
          size: P || "m",
          textAlign: E,
          isPinnedToLeft: !!R,
          isPinnedToRight: !!A,
          isRowHeader: !!k,
          cellRenderer: L,
          subRowCellRenderer: I
        }
      })
    ),
    [r]
  ), S = useMemo$1(
    () => ({
      id: "selectable",
      header: renderSelectableHeader,
      cell: renderSelectableCell,
      meta: {
        textAlign: "start",
        size: "xs",
        isPinnedToLeft: r.some((P) => P.isPinnedToLeft),
        selectableRowOptions: {
          disableAllRowsSelection: s,
          onRowSelectionChange: u,
          rowSelectionTooltips: c,
          getRowSelectionAriaLabel: p,
          allRowsSelectionAriaLabel: d,
          data: a,
          onAllRowsSelectionChange: h,
          getRowSelectionAriaLabelledBy: v,
          getRowSelectionAriaDescribedBy: y
        },
        skipToLink: g
      }
    }),
    [
      r,
      s,
      u,
      c,
      p,
      d,
      a,
      h,
      v,
      y,
      g
    ]
  ), M = useMemo$1(
    () => [...w].sort((P, L) => {
      const I = P.meta, T = L.meta, E = !!I.isPinnedToLeft, R = !!T.isPinnedToLeft, A = !!I.isPinnedToRight, k = !!T.isPinnedToRight;
      return E && !R ? -1 : !E && R || A && !k ? 1 : !A && k ? -1 : 0;
    }),
    [w]
  );
  return useMemo$1(() => {
    const P = [];
    return (u || h) && P.push(S), a.some((I) => {
      var T;
      return !!((T = I.subRows) != null && T.length);
    }) && P.push(x), [...P, ...M];
  }, [u, h, S, a, x, M]);
}, useTable = ({
  data: r,
  columns: a,
  meta: s,
  captionId: c,
  onRowClick: u,
  isLoading: d,
  hideHeaderWhileLoading: h,
  loadingRowIds: p,
  disableAllRowsSelection: m,
  disableRowSelection: g,
  rowSelectionTooltips: v,
  defaultSelectedRows: y = {},
  mobileRowRenderer: x,
  isHeaderSticky: w,
  selectedRows: S,
  setSelectedRows: M,
  onRowSelectionChange: P,
  onAllRowsSelectionChange: L,
  getRowSelectionAriaLabel: I,
  allRowsSelectionAriaLabel: T,
  defaultExpandedRows: E = {},
  onRowExpandChange: R,
  highlightedRowIds: A,
  headerVariant: k = "light",
  sortingState: V,
  setSortState: B,
  skipToLink: q,
  getRowSelectionAriaLabelledBy: z,
  getRowSelectionAriaDescribedBy: Z,
  ...G
}) => {
  const [K, U] = React__default.useState(y), F = S ?? K, N = M ?? U, [D, j] = React__default.useState(E), H = useColumnDefs({
    columns: a,
    data: r,
    disableAllRowsSelection: m,
    rowSelectionTooltips: v,
    onRowSelectionChange: P,
    onAllRowsSelectionChange: L,
    getRowSelectionAriaLabel: I,
    allRowsSelectionAriaLabel: T,
    onRowExpandChange: R,
    skipToLink: q,
    getRowSelectionAriaLabelledBy: z,
    getRowSelectionAriaDescribedBy: Z
  }), W = {
    left: H.filter((J) => J.meta.isPinnedToLeft).map((J) => J.id),
    right: H.filter((J) => J.meta.isPinnedToRight).map((J) => J.id)
  }, { getHeaderGroups: re, getRowModel: ae, getState: ee, setColumnSizing: X } = useReactTable({
    data: r,
    columns: H,
    state: { expanded: D, rowSelection: F, sorting: toReactTableSortingState(V), columnPinning: W },
    onSortingChange: toReactTableOnSortingChange(B),
    // Suppress type error by casting to the expected type.
    meta: s,
    onRowSelectionChange: N,
    onExpandedChange: j,
    // Suppress type error by casting to the expected type.
    getSubRows: (J) => J.subRows,
    getExpandedRowModel: getExpandedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getRowId: (J, ie, oe) => J.id || `${oe ? `${oe.index}.${ie}` : ie}`,
    ...G,
    enableRowSelection: (J) => m ? !1 : g ? !g(J.original) : !0
  });
  return {
    getHeaderGroups: re,
    getRowModel: ae,
    onRowClick: u,
    isLoading: d,
    hideHeaderWhileLoading: h,
    loadingRowIds: p,
    highlightedRowIds: A,
    headerVariant: k,
    mobileRowRenderer: x ? (J) => x(J, s) : void 0,
    isHeaderSticky: w,
    captionId: c,
    sortingState: toPennySortingState(ee().sorting),
    getState: ee,
    setColumnSizing: X
  };
}, {
  createElement,
  createContext,
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} = React, useId = React.useId, useIsomorphicLayoutEffect = useLayoutEffect, wrappedUseId = typeof useId == "function" ? useId : () => null;
let counter = 0;
function useUniqueId(r = null) {
  const a = wrappedUseId(), s = useRef(r || a || null);
  return s.current === null && (s.current = "" + counter++), s.current;
}
const PanelGroupContext = createContext(null);
PanelGroupContext.displayName = "PanelGroupContext";
function PanelWithForwardedRef({
  children: r = null,
  className: a = "",
  collapsedSize: s = 0,
  collapsible: c = !1,
  defaultSize: u = null,
  forwardedRef: d,
  id: h = null,
  maxSize: p = null,
  minSize: m,
  onCollapse: g = null,
  onResize: v = null,
  order: y = null,
  style: x = {},
  tagName: w = "div"
}) {
  const S = useContext(PanelGroupContext);
  if (S === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const M = useUniqueId(h), {
    collapsePanel: P,
    expandPanel: L,
    getPanelSize: I,
    getPanelStyle: T,
    registerPanel: E,
    resizePanel: R,
    units: A,
    unregisterPanel: k
  } = S;
  m == null && (A === "percentages" ? m = 10 : m = 0);
  const V = useRef({
    onCollapse: g,
    onResize: v
  });
  useEffect(() => {
    V.current.onCollapse = g, V.current.onResize = v;
  });
  const B = T(M, u), q = useRef({
    size: parseSizeFromStyle(B)
  }), z = useRef({
    callbacksRef: V,
    collapsedSize: s,
    collapsible: c,
    defaultSize: u,
    id: M,
    idWasAutoGenerated: h == null,
    maxSize: p,
    minSize: m,
    order: y
  });
  return useIsomorphicLayoutEffect(() => {
    q.current.size = parseSizeFromStyle(B), z.current.callbacksRef = V, z.current.collapsedSize = s, z.current.collapsible = c, z.current.defaultSize = u, z.current.id = M, z.current.idWasAutoGenerated = h == null, z.current.maxSize = p, z.current.minSize = m, z.current.order = y;
  }), useIsomorphicLayoutEffect(() => (E(M, z), () => {
    k(M);
  }), [y, M, E, k]), useImperativeHandle(d, () => ({
    collapse: () => P(M),
    expand: () => L(M),
    getCollapsed() {
      return q.current.size === 0;
    },
    getId() {
      return M;
    },
    getSize(Z) {
      return I(M, Z);
    },
    resize: (Z, G) => R(M, Z, G)
  }), [P, L, I, M, R]), createElement(w, {
    children: r,
    className: a,
    "data-panel": "",
    "data-panel-collapsible": c || void 0,
    "data-panel-id": M,
    "data-panel-size": parseFloat("" + B.flexGrow).toFixed(1),
    id: `data-panel-id-${M}`,
    style: {
      ...B,
      ...x
    }
  });
}
const Panel = forwardRef((r, a) => createElement(PanelWithForwardedRef, {
  ...r,
  forwardedRef: a
}));
PanelWithForwardedRef.displayName = "Panel";
Panel.displayName = "forwardRef(Panel)";
function parseSizeFromStyle(r) {
  const {
    flexGrow: a
  } = r;
  return typeof a == "string" ? parseFloat(a) : a;
}
const PRECISION = 10;
function adjustByDelta(r, a, s, c, u, d, h, p) {
  const {
    id: m,
    panels: g,
    units: v
  } = a, y = v === "pixels" ? getAvailableGroupSizePixels(m) : NaN, {
    sizes: x
  } = p || {}, w = x || d, S = panelsMapToSortedArray(g), M = w.concat();
  let P = 0;
  {
    const T = u < 0 ? c : s, E = S.findIndex((V) => V.current.id === T), R = S[E], A = w[E], k = safeResizePanel(v, y, R, A, A + Math.abs(u), r);
    if (A === k)
      return w;
    k === 0 && A > 0 && h.set(T, A), u = u < 0 ? A - k : k - A;
  }
  let L = u < 0 ? s : c, I = S.findIndex((T) => T.current.id === L);
  for (; ; ) {
    const T = S[I], E = w[I], R = Math.abs(u) - Math.abs(P), A = safeResizePanel(v, y, T, E, E - R, r);
    if (E !== A && (A === 0 && E > 0 && h.set(T.current.id, E), P += E - A, M[I] = A, P.toPrecision(PRECISION).localeCompare(Math.abs(u).toPrecision(PRECISION), void 0, {
      numeric: !0
    }) >= 0))
      break;
    if (u < 0) {
      if (--I < 0)
        break;
    } else if (++I >= S.length)
      break;
  }
  return P === 0 ? w : (L = u < 0 ? c : s, I = S.findIndex((T) => T.current.id === L), M[I] = w[I] + P, M);
}
function callPanelCallbacks(r, a, s) {
  a.forEach((c, u) => {
    const d = r[u];
    if (!d)
      return;
    const {
      callbacksRef: h,
      collapsedSize: p,
      collapsible: m,
      id: g
    } = d.current, v = s[g];
    if (v !== c) {
      s[g] = c;
      const {
        onCollapse: y,
        onResize: x
      } = h.current;
      x && x(c, v), m && y && ((v == null || v === p) && c !== p ? y(!1) : v !== p && c === p && y(!0));
    }
  });
}
function calculateDefaultLayout({
  groupId: r,
  panels: a,
  units: s
}) {
  const c = s === "pixels" ? getAvailableGroupSizePixels(r) : NaN, u = panelsMapToSortedArray(a), d = Array(u.length);
  let h = 0, p = 100;
  for (let m = 0; m < u.length; m++) {
    const g = u[m], {
      defaultSize: v
    } = g.current;
    v != null && (h++, d[m] = s === "pixels" ? v / c * 100 : v, p -= d[m]);
  }
  for (let m = 0; m < u.length; m++) {
    const g = u[m];
    let {
      defaultSize: v,
      id: y,
      maxSize: x,
      minSize: w
    } = g.current;
    if (v != null)
      continue;
    s === "pixels" && (w = w / c * 100, x != null && (x = x / c * 100));
    const S = u.length - h, M = Math.min(x ?? 100, Math.max(w, p / S));
    d[m] = M, h++, p -= M;
  }
  if (p !== 0)
    for (let m = 0; m < u.length; m++) {
      const g = u[m];
      let {
        maxSize: v,
        minSize: y
      } = g.current;
      s === "pixels" && (y = y / c * 100, v != null && (v = v / c * 100));
      const x = Math.min(v ?? 100, Math.max(y, d[m] + p));
      if (x !== d[m] && (p -= x - d[m], d[m] = x, Math.abs(p).toFixed(3) === "0.000"))
        break;
    }
  return Math.abs(p).toFixed(3), d;
}
function getBeforeAndAfterIds(r, a) {
  if (a.length < 2)
    return [null, null];
  const s = a.findIndex((h) => h.current.id === r);
  if (s < 0)
    return [null, null];
  const c = s === a.length - 1, u = c ? a[s - 1].current.id : r, d = c ? r : a[s + 1].current.id;
  return [u, d];
}
function getAvailableGroupSizePixels(r) {
  const a = getPanelGroup(r);
  if (a == null)
    return NaN;
  const s = a.getAttribute("data-panel-group-direction"), c = getResizeHandlesForGroup(r);
  return s === "horizontal" ? a.offsetWidth - c.reduce((u, d) => u + d.offsetWidth, 0) : a.offsetHeight - c.reduce((u, d) => u + d.offsetHeight, 0);
}
function getFlexGrow(r, a, s) {
  if (r.size === 1)
    return "100";
  const u = panelsMapToSortedArray(r).findIndex((h) => h.current.id === a), d = s[u];
  return d == null ? "0" : d.toPrecision(PRECISION);
}
function getPanel(r) {
  const a = document.querySelector(`[data-panel-id="${r}"]`);
  return a || null;
}
function getPanelGroup(r) {
  const a = document.querySelector(`[data-panel-group-id="${r}"]`);
  return a || null;
}
function getResizeHandle(r) {
  const a = document.querySelector(`[data-panel-resize-handle-id="${r}"]`);
  return a || null;
}
function getResizeHandleIndex(r) {
  return getResizeHandles().findIndex((c) => c.getAttribute("data-panel-resize-handle-id") === r) ?? null;
}
function getResizeHandles() {
  return Array.from(document.querySelectorAll("[data-panel-resize-handle-id]"));
}
function getResizeHandlesForGroup(r) {
  return Array.from(document.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${r}"]`));
}
function getResizeHandlePanelIds(r, a, s) {
  var m, g, v, y;
  const c = getResizeHandle(a), u = getResizeHandlesForGroup(r), d = c ? u.indexOf(c) : -1, h = ((g = (m = s[d]) == null ? void 0 : m.current) == null ? void 0 : g.id) ?? null, p = ((y = (v = s[d + 1]) == null ? void 0 : v.current) == null ? void 0 : y.id) ?? null;
  return [h, p];
}
function panelsMapToSortedArray(r) {
  return Array.from(r.values()).sort((a, s) => {
    const c = a.current.order, u = s.current.order;
    return c == null && u == null ? 0 : c == null ? -1 : u == null ? 1 : c - u;
  });
}
function safeResizePanel(r, a, s, c, u, d = null) {
  var v;
  let {
    collapsedSize: h,
    collapsible: p,
    maxSize: m,
    minSize: g
  } = s.current;
  if (r === "pixels" && (h = h / a * 100, m != null && (m = m / a * 100), g = g / a * 100), p) {
    if (c > h) {
      if (u <= g / 2 + h)
        return h;
    } else if (!((v = d == null ? void 0 : d.type) == null ? void 0 : v.startsWith("key")) && u < g)
      return h;
  }
  return Math.min(m ?? 100, Math.max(g, u));
}
function validatePanelProps(r, a) {
  const {
    collapsible: s,
    defaultSize: c,
    maxSize: u,
    minSize: d
  } = a.current;
  (d < 0 || r === "percentages" && d > 100) && (a.current.minSize = 0), u != null && (u < 0 || r === "percentages" && u > 100) && (a.current.maxSize = null), c !== null && (c < 0 || r === "percentages" && c > 100 ? a.current.defaultSize = null : c < d && !s ? a.current.defaultSize = d : u != null && c > u && (a.current.defaultSize = u));
}
function validatePanelGroupLayout({
  groupId: r,
  panels: a,
  nextSizes: s,
  prevSizes: c,
  units: u
}) {
  s = [...s];
  const d = panelsMapToSortedArray(a), h = u === "pixels" ? getAvailableGroupSizePixels(r) : NaN;
  let p = 0;
  for (let m = 0; m < d.length; m++) {
    const g = d[m], v = c[m], y = s[m], x = safeResizePanel(u, h, g, v, y);
    y != x && (p += y - x, s[m] = x);
  }
  if (p.toFixed(3) !== "0.000")
    for (let m = 0; m < d.length; m++) {
      const g = d[m];
      let {
        maxSize: v,
        minSize: y
      } = g.current;
      u === "pixels" && (y = y / h * 100, v != null && (v = v / h * 100));
      const x = Math.min(v ?? 100, Math.max(y, s[m] + p));
      if (x !== s[m] && (p -= x - s[m], s[m] = x, Math.abs(p).toFixed(3) === "0.000"))
        break;
    }
  return p.toFixed(3), s;
}
function assert(r, a = "Assertion failed!") {
  if (!r)
    throw console.error(a), Error(a);
}
function useWindowSplitterPanelGroupBehavior({
  committedValuesRef: r,
  groupId: a,
  panels: s,
  setSizes: c,
  sizes: u,
  panelSizeBeforeCollapse: d
}) {
  useEffect(() => {
    const {
      direction: h,
      panels: p
    } = r.current, m = getPanelGroup(a);
    assert(m != null, `No group found for id "${a}"`);
    const {
      height: g,
      width: v
    } = m.getBoundingClientRect(), x = getResizeHandlesForGroup(a).map((w) => {
      const S = w.getAttribute("data-panel-resize-handle-id"), M = panelsMapToSortedArray(p), [P, L] = getResizeHandlePanelIds(a, S, M);
      if (P == null || L == null)
        return () => {
        };
      let I = 0, T = 100, E = 0, R = 0;
      M.forEach((z) => {
        const {
          id: Z,
          maxSize: G,
          minSize: K
        } = z.current;
        Z === P ? (I = K, T = G ?? 100) : (E += K, R += G ?? 100);
      });
      const A = Math.min(T, 100 - E), k = Math.max(I, (M.length - 1) * 100 - R), V = getFlexGrow(p, P, u);
      w.setAttribute("aria-valuemax", "" + Math.round(A)), w.setAttribute("aria-valuemin", "" + Math.round(k)), w.setAttribute("aria-valuenow", "" + Math.round(parseInt(V)));
      const B = (z) => {
        if (!z.defaultPrevented)
          switch (z.key) {
            case "Enter": {
              z.preventDefault();
              const Z = M.findIndex((G) => G.current.id === P);
              if (Z >= 0) {
                const G = M[Z], K = u[Z];
                if (K != null) {
                  let U = 0;
                  K.toPrecision(PRECISION) <= G.current.minSize.toPrecision(PRECISION) ? U = h === "horizontal" ? v : g : U = -(h === "horizontal" ? v : g);
                  const F = adjustByDelta(z, r.current, P, L, U, u, d.current, null);
                  u !== F && c(F);
                }
              }
              break;
            }
          }
      };
      w.addEventListener("keydown", B);
      const q = getPanel(P);
      return q != null && w.setAttribute("aria-controls", q.id), () => {
        w.removeAttribute("aria-valuemax"), w.removeAttribute("aria-valuemin"), w.removeAttribute("aria-valuenow"), w.removeEventListener("keydown", B), q != null && w.removeAttribute("aria-controls");
      };
    });
    return () => {
      x.forEach((w) => w());
    };
  }, [r, a, s, d, c, u]);
}
function useWindowSplitterResizeHandlerBehavior({
  disabled: r,
  handleId: a,
  resizeHandler: s
}) {
  useEffect(() => {
    if (r || s == null)
      return;
    const c = getResizeHandle(a);
    if (c == null)
      return;
    const u = (d) => {
      if (!d.defaultPrevented)
        switch (d.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            d.preventDefault(), s(d);
            break;
          }
          case "F6": {
            d.preventDefault();
            const h = getResizeHandles(), p = getResizeHandleIndex(a);
            assert(p !== null);
            const m = d.shiftKey ? p > 0 ? p - 1 : h.length - 1 : p + 1 < h.length ? p + 1 : 0;
            h[m].focus();
            break;
          }
        }
    };
    return c.addEventListener("keydown", u), () => {
      c.removeEventListener("keydown", u);
    };
  }, [r, a, s]);
}
function areEqual(r, a) {
  if (r.length !== a.length)
    return !1;
  for (let s = 0; s < r.length; s++)
    if (r[s] !== a[s])
      return !1;
  return !0;
}
function getDragOffset(r, a, s, c = 0, u = null) {
  const d = s === "horizontal";
  let h = 0;
  if (isMouseEvent(r))
    h = d ? r.clientX : r.clientY;
  else if (isTouchEvent(r)) {
    const v = r.touches[0];
    h = d ? v.screenX : v.screenY;
  } else
    return 0;
  const p = getResizeHandle(a), m = u || p.getBoundingClientRect(), g = d ? m.left : m.top;
  return h - g - c;
}
function getMovement(r, a, s, c, u, d, h) {
  const {
    dragOffset: p = 0,
    dragHandleRect: m,
    sizes: g
  } = h || {}, v = g || d;
  if (isKeyDown(r)) {
    const y = u === "horizontal", w = getPanelGroup(a).getBoundingClientRect(), S = y ? w.width : w.height, M = r.shiftKey ? 10 : 100, P = S / M;
    let L = 0;
    switch (r.key) {
      case "ArrowDown":
        L = y ? 0 : P;
        break;
      case "ArrowLeft":
        L = y ? -P : 0;
        break;
      case "ArrowRight":
        L = y ? P : 0;
        break;
      case "ArrowUp":
        L = y ? 0 : -P;
        break;
      case "End":
        L = S;
        break;
      case "Home":
        L = -S;
        break;
    }
    const [I, T] = getResizeHandlePanelIds(a, s, c), E = L < 0 ? I : T, R = c.findIndex((k) => k.current.id === E), A = c[R];
    if (A.current.collapsible) {
      const k = v[R];
      (k === 0 || k.toPrecision(PRECISION) === A.current.minSize.toPrecision(PRECISION)) && (L = L < 0 ? -A.current.minSize * S : A.current.minSize * S);
    }
    return L;
  } else
    return getDragOffset(r, s, u, p, m);
}
function isKeyDown(r) {
  return r.type === "keydown";
}
function isMouseEvent(r) {
  return r.type.startsWith("mouse");
}
function isTouchEvent(r) {
  return r.type.startsWith("touch");
}
let currentState = null, element = null;
function getCursorStyle(r) {
  switch (r) {
    case "horizontal":
      return "ew-resize";
    case "horizontal-max":
      return "w-resize";
    case "horizontal-min":
      return "e-resize";
    case "vertical":
      return "ns-resize";
    case "vertical-max":
      return "n-resize";
    case "vertical-min":
      return "s-resize";
  }
}
function resetGlobalCursorStyle() {
  element !== null && (document.head.removeChild(element), currentState = null, element = null);
}
function setGlobalCursorStyle(r) {
  if (currentState === r)
    return;
  currentState = r;
  const a = getCursorStyle(r);
  element === null && (element = document.createElement("style"), document.head.appendChild(element)), element.innerHTML = `*{cursor: ${a}!important;}`;
}
function debounce(r, a = 10) {
  let s = null;
  return (...u) => {
    s !== null && clearTimeout(s), s = setTimeout(() => {
      r(...u);
    }, a);
  };
}
function getSerializationKey(r) {
  return r.map((a) => {
    const {
      minSize: s,
      order: c
    } = a.current;
    return c ? `${c}:${s}` : `${s}`;
  }).sort((a, s) => a.localeCompare(s)).join(",");
}
function loadSerializedPanelGroupState(r, a) {
  try {
    const s = a.getItem(`PanelGroup:sizes:${r}`);
    if (s) {
      const c = JSON.parse(s);
      if (typeof c == "object" && c != null)
        return c;
    }
  } catch {
  }
  return null;
}
function loadPanelLayout(r, a, s) {
  const c = loadSerializedPanelGroupState(r, s);
  if (c) {
    const u = getSerializationKey(a);
    return c[u] ?? null;
  }
  return null;
}
function savePanelGroupLayout(r, a, s, c) {
  const u = getSerializationKey(a), d = loadSerializedPanelGroupState(r, c) || {};
  d[u] = s;
  try {
    c.setItem(`PanelGroup:sizes:${r}`, JSON.stringify(d));
  } catch (h) {
    console.error(h);
  }
}
const debounceMap = {};
function initializeDefaultStorage(r) {
  try {
    if (typeof localStorage < "u")
      r.getItem = (a) => localStorage.getItem(a), r.setItem = (a, s) => {
        localStorage.setItem(a, s);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (a) {
    console.error(a), r.getItem = () => null, r.setItem = () => {
    };
  }
}
const defaultStorage = {
  getItem: (r) => (initializeDefaultStorage(defaultStorage), defaultStorage.getItem(r)),
  setItem: (r, a) => {
    initializeDefaultStorage(defaultStorage), defaultStorage.setItem(r, a);
  }
};
function PanelGroupWithForwardedRef({
  autoSaveId: r,
  children: a = null,
  className: s = "",
  direction: c,
  disablePointerEventsDuringResize: u = !1,
  forwardedRef: d,
  id: h = null,
  onLayout: p,
  storage: m = defaultStorage,
  style: g = {},
  tagName: v = "div",
  units: y = "percentages"
}) {
  const x = useUniqueId(h), [w, S] = useState(null), [M, P] = useState(/* @__PURE__ */ new Map()), L = useRef(null);
  useRef({
    didLogDefaultSizeWarning: !1,
    didLogIdAndOrderWarning: !1,
    didLogInvalidLayoutWarning: !1,
    prevPanelIds: []
  });
  const I = useRef({
    onLayout: p
  });
  useEffect(() => {
    I.current.onLayout = p;
  });
  const T = useRef({}), [E, R] = useState([]), A = useRef(/* @__PURE__ */ new Map()), k = useRef(0), V = useRef({
    direction: c,
    id: x,
    panels: M,
    sizes: E,
    units: y
  });
  useImperativeHandle(d, () => ({
    getId: () => x,
    getLayout: (j) => {
      const {
        sizes: H,
        units: W
      } = V.current;
      if ((j ?? W) === "pixels") {
        const ae = getAvailableGroupSizePixels(x);
        return H.map((ee) => ee / 100 * ae);
      } else
        return H;
    },
    setLayout: (j, H) => {
      const {
        id: W,
        panels: re,
        sizes: ae,
        units: ee
      } = V.current;
      if ((H || ee) === "pixels") {
        const oe = getAvailableGroupSizePixels(W);
        j = j.map((fe) => fe / oe * 100);
      }
      const X = T.current, J = panelsMapToSortedArray(re), ie = validatePanelGroupLayout({
        groupId: W,
        panels: re,
        nextSizes: j,
        prevSizes: ae,
        units: ee
      });
      areEqual(ae, ie) || (R(ie), callPanelCallbacks(J, ie, X));
    }
  }), [x]), useIsomorphicLayoutEffect(() => {
    V.current.direction = c, V.current.id = x, V.current.panels = M, V.current.sizes = E, V.current.units = y;
  }), useWindowSplitterPanelGroupBehavior({
    committedValuesRef: V,
    groupId: x,
    panels: M,
    setSizes: R,
    sizes: E,
    panelSizeBeforeCollapse: A
  }), useEffect(() => {
    const {
      onLayout: j
    } = I.current, {
      panels: H,
      sizes: W
    } = V.current;
    if (W.length > 0) {
      j && j(W);
      const re = T.current, ae = panelsMapToSortedArray(H);
      callPanelCallbacks(ae, W, re);
    }
  }, [E]), useIsomorphicLayoutEffect(() => {
    const {
      id: j,
      sizes: H,
      units: W
    } = V.current;
    if (H.length === M.size)
      return;
    let re = null;
    if (r) {
      const ae = panelsMapToSortedArray(M);
      re = loadPanelLayout(r, ae, m);
    }
    if (re != null) {
      const ae = validatePanelGroupLayout({
        groupId: j,
        panels: M,
        nextSizes: re,
        prevSizes: re,
        units: W
      });
      R(ae);
    } else {
      const ae = calculateDefaultLayout({
        groupId: j,
        panels: M,
        units: W
      });
      R(ae);
    }
  }, [r, M, m]), useEffect(() => {
    if (r) {
      if (E.length === 0 || E.length !== M.size)
        return;
      const j = panelsMapToSortedArray(M);
      debounceMap[r] || (debounceMap[r] = debounce(savePanelGroupLayout, 100)), debounceMap[r](r, j, E, m);
    }
  }, [r, M, E, m]), useIsomorphicLayoutEffect(() => {
    if (y === "pixels") {
      const j = new ResizeObserver(() => {
        const {
          panels: H,
          sizes: W
        } = V.current, re = validatePanelGroupLayout({
          groupId: x,
          panels: H,
          nextSizes: W,
          prevSizes: W,
          units: y
        });
        areEqual(W, re) || R(re);
      });
      return j.observe(getPanelGroup(x)), () => {
        j.disconnect();
      };
    }
  }, [x, y]);
  const B = useCallback((j, H) => {
    const {
      panels: W,
      units: re
    } = V.current, ee = panelsMapToSortedArray(W).findIndex((ie) => ie.current.id === j), X = E[ee];
    if ((H ?? re) === "pixels") {
      const ie = getAvailableGroupSizePixels(x);
      return X / 100 * ie;
    } else
      return X;
  }, [x, E]), q = useCallback((j, H) => {
    const {
      panels: W
    } = V.current;
    return W.size === 0 ? {
      flexBasis: 0,
      flexGrow: H ?? void 0,
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden"
    } : {
      flexBasis: 0,
      flexGrow: getFlexGrow(W, j, E),
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden",
      // Disable pointer events inside of a panel during resize.
      // This avoid edge cases like nested iframes.
      pointerEvents: u && w !== null ? "none" : void 0
    };
  }, [w, u, E]), z = useCallback((j, H) => {
    const {
      units: W
    } = V.current;
    validatePanelProps(W, H), P((re) => {
      if (re.has(j))
        return re;
      const ae = new Map(re);
      return ae.set(j, H), ae;
    });
  }, []), Z = useCallback((j) => (W) => {
    W.preventDefault();
    const {
      direction: re,
      panels: ae,
      sizes: ee
    } = V.current, X = panelsMapToSortedArray(ae), [J, ie] = getResizeHandlePanelIds(x, j, X);
    if (J == null || ie == null)
      return;
    let oe = getMovement(W, x, j, X, re, ee, L.current);
    if (oe === 0)
      return;
    const ve = getPanelGroup(x).getBoundingClientRect(), ue = re === "horizontal";
    document.dir === "rtl" && ue && (oe = -oe);
    const pe = ue ? ve.width : ve.height, we = oe / pe * 100, ye = adjustByDelta(W, V.current, J, ie, we, ee, A.current, L.current), Ie = !areEqual(ee, ye);
    if ((isMouseEvent(W) || isTouchEvent(W)) && k.current != we && setGlobalCursorStyle(Ie ? ue ? "horizontal" : "vertical" : ue ? oe < 0 ? "horizontal-min" : "horizontal-max" : oe < 0 ? "vertical-min" : "vertical-max"), Ie) {
      const Ee = T.current;
      R(ye), callPanelCallbacks(X, ye, Ee);
    }
    k.current = we;
  }, [x]), G = useCallback((j) => {
    P((H) => {
      if (!H.has(j))
        return H;
      const W = new Map(H);
      return W.delete(j), W;
    });
  }, []), K = useCallback((j) => {
    const {
      panels: H,
      sizes: W
    } = V.current, re = H.get(j);
    if (re == null)
      return;
    const {
      collapsedSize: ae,
      collapsible: ee
    } = re.current;
    if (!ee)
      return;
    const X = panelsMapToSortedArray(H), J = X.indexOf(re);
    if (J < 0)
      return;
    const ie = W[J];
    if (ie === ae)
      return;
    A.current.set(j, ie);
    const [oe, fe] = getBeforeAndAfterIds(j, X);
    if (oe == null || fe == null)
      return;
    const ue = J === X.length - 1 ? ie : ae - ie, pe = adjustByDelta(null, V.current, oe, fe, ue, W, A.current, null);
    if (W !== pe) {
      const we = T.current;
      R(pe), callPanelCallbacks(X, pe, we);
    }
  }, []), U = useCallback((j) => {
    const {
      panels: H,
      sizes: W
    } = V.current, re = H.get(j);
    if (re == null)
      return;
    const {
      collapsedSize: ae,
      minSize: ee
    } = re.current, X = A.current.get(j) || ee;
    if (!X)
      return;
    const J = panelsMapToSortedArray(H), ie = J.indexOf(re);
    if (ie < 0 || W[ie] !== ae)
      return;
    const [fe, ve] = getBeforeAndAfterIds(j, J);
    if (fe == null || ve == null)
      return;
    const pe = ie === J.length - 1 ? ae - X : X, we = adjustByDelta(null, V.current, fe, ve, pe, W, A.current, null);
    if (W !== we) {
      const ye = T.current;
      R(we), callPanelCallbacks(J, we, ye);
    }
  }, []), F = useCallback((j, H, W) => {
    const {
      id: re,
      panels: ae,
      sizes: ee,
      units: X
    } = V.current;
    if ((W || X) === "pixels") {
      const de = getAvailableGroupSizePixels(re);
      H = H / de * 100;
    }
    const J = ae.get(j);
    if (J == null)
      return;
    let {
      collapsedSize: ie,
      collapsible: oe,
      maxSize: fe,
      minSize: ve
    } = J.current;
    if (X === "pixels") {
      const de = getAvailableGroupSizePixels(re);
      ve = ve / de * 100, fe != null && (fe = fe / de * 100);
    }
    const ue = panelsMapToSortedArray(ae), pe = ue.indexOf(J);
    if (pe < 0)
      return;
    const we = ee[pe];
    if (we === H)
      return;
    oe && H === ie || (H = Math.min(fe ?? 100, Math.max(ve, H)));
    const [ye, Ie] = getBeforeAndAfterIds(j, ue);
    if (ye == null || Ie == null)
      return;
    const ne = pe === ue.length - 1 ? we - H : H - we, se = adjustByDelta(null, V.current, ye, Ie, ne, ee, A.current, null);
    if (ee !== se) {
      const de = T.current;
      R(se), callPanelCallbacks(ue, se, de);
    }
  }, []), N = useMemo(() => ({
    activeHandleId: w,
    collapsePanel: K,
    direction: c,
    expandPanel: U,
    getPanelSize: B,
    getPanelStyle: q,
    groupId: x,
    registerPanel: z,
    registerResizeHandle: Z,
    resizePanel: F,
    startDragging: (j, H) => {
      if (S(j), isMouseEvent(H) || isTouchEvent(H)) {
        const W = getResizeHandle(j);
        L.current = {
          dragHandleRect: W.getBoundingClientRect(),
          dragOffset: getDragOffset(H, j, c),
          sizes: V.current.sizes
        };
      }
    },
    stopDragging: () => {
      resetGlobalCursorStyle(), S(null), L.current = null;
    },
    units: y,
    unregisterPanel: G
  }), [w, K, c, U, B, q, x, z, Z, F, y, G]), D = {
    display: "flex",
    flexDirection: c === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return createElement(PanelGroupContext.Provider, {
    children: createElement(v, {
      children: a,
      className: s,
      "data-panel-group": "",
      "data-panel-group-direction": c,
      "data-panel-group-id": x,
      "data-panel-group-units": y,
      style: {
        ...D,
        ...g
      }
    }),
    value: N
  });
}
const PanelGroup = forwardRef((r, a) => createElement(PanelGroupWithForwardedRef, {
  ...r,
  forwardedRef: a
}));
PanelGroupWithForwardedRef.displayName = "PanelGroup";
PanelGroup.displayName = "forwardRef(PanelGroup)";
function PanelResizeHandle({
  children: r = null,
  className: a = "",
  disabled: s = !1,
  id: c = null,
  onDragging: u,
  style: d = {},
  tagName: h = "div"
}) {
  const p = useRef(null), m = useRef({
    onDragging: u
  });
  useEffect(() => {
    m.current.onDragging = u;
  });
  const g = useContext(PanelGroupContext);
  if (g === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    activeHandleId: v,
    direction: y,
    groupId: x,
    registerResizeHandle: w,
    startDragging: S,
    stopDragging: M
  } = g, P = useUniqueId(c), L = v === P, [I, T] = useState(!1), [E, R] = useState(null), A = useCallback(() => {
    p.current.blur(), M();
    const {
      onDragging: B
    } = m.current;
    B && B(!1);
  }, [M]);
  useEffect(() => {
    if (s)
      R(null);
    else {
      const V = w(P);
      R(() => V);
    }
  }, [s, P, w]), useEffect(() => {
    if (s || E == null || !L)
      return;
    const V = (Z) => {
      E(Z);
    }, B = (Z) => {
      E(Z);
    }, z = p.current.ownerDocument;
    return z.body.addEventListener("contextmenu", A), z.body.addEventListener("mousemove", V), z.body.addEventListener("touchmove", V), z.body.addEventListener("mouseleave", B), window.addEventListener("mouseup", A), window.addEventListener("touchend", A), () => {
      z.body.removeEventListener("contextmenu", A), z.body.removeEventListener("mousemove", V), z.body.removeEventListener("touchmove", V), z.body.removeEventListener("mouseleave", B), window.removeEventListener("mouseup", A), window.removeEventListener("touchend", A);
    };
  }, [y, s, L, E, A]), useWindowSplitterResizeHandlerBehavior({
    disabled: s,
    handleId: P,
    resizeHandler: E
  });
  const k = {
    cursor: getCursorStyle(y),
    touchAction: "none",
    userSelect: "none"
  };
  return createElement(h, {
    children: r,
    className: a,
    "data-resize-handle-active": L ? "pointer" : I ? "keyboard" : void 0,
    "data-panel-group-direction": y,
    "data-panel-group-id": x,
    "data-panel-resize-handle-enabled": !s,
    "data-panel-resize-handle-id": P,
    onBlur: () => T(!1),
    onFocus: () => T(!0),
    onMouseDown: (V) => {
      S(P, V.nativeEvent);
      const {
        onDragging: B
      } = m.current;
      B && B(!0);
    },
    onMouseUp: A,
    onTouchCancel: A,
    onTouchEnd: A,
    onTouchStart: (V) => {
      S(P, V.nativeEvent);
      const {
        onDragging: B
      } = m.current;
      B && B(!0);
    },
    ref: p,
    role: "separator",
    style: {
      ...k,
      ...d
    },
    tabIndex: 0
  });
}
PanelResizeHandle.displayName = "PanelResizeHandle";
const variantToSizeMap = {
  "2:1": { panelA: 66.67, panelB: 33.33 },
  "1:2": { panelA: 33.33, panelB: 66.67 },
  "1:1": { panelA: 50, panelB: 50 }
}, ResizeHandle = ({
  id: r,
  shouldAllowResizing: a,
  ...s
}) => {
  const c = useMultiStyleConfig("SplitScreen", {}), u = useBreakpointValue({ xs: "horizontal", l: "vertical" });
  return /* @__PURE__ */ jsx(Fragment, { children: a ? /* @__PURE__ */ jsx(Box, { as: PanelResizeHandle, id: r, __css: c.resizableBar, ...s, children: /* @__PURE__ */ jsx(Box, { as: Icon, type: "resize", size: "small", __css: c.handle, "aria-hidden": !0 }) }) : /* @__PURE__ */ jsx(Box, { __css: c.resizableBar, ...s, children: /* @__PURE__ */ jsx(Divider, { variant: u }) }) });
}, PanelElements = ({
  panel: r,
  ...a
}) => {
  const s = useMultiStyleConfig("SplitScreen", { panelPadding: r == null ? void 0 : r.padding });
  return /* @__PURE__ */ jsxs(Box, { __css: s.panel, "data-loading": (r == null ? void 0 : r.isLoading) || void 0, ...a, children: [
    !(r != null && r.isLoading) && (r == null ? void 0 : r.header) && /* @__PURE__ */ jsx(Box, { __css: s.panelHeader, children: r == null ? void 0 : r.header }),
    r != null && r.isLoading ? /* @__PURE__ */ jsx(Loader, {}) : (
      // Scrollable container should be accessible by keyboard
      // https://dequeuniversity.com/rules/axe/4.8/scrollable-region-focusable?application=axeAPI
      /* @__PURE__ */ jsx(Box, { __css: s.panelContent, tabIndex: r == null ? void 0 : r.tabIndex, children: r == null ? void 0 : r.content })
    ),
    !(r != null && r.isLoading) && (r == null ? void 0 : r.footer) && /* @__PURE__ */ jsx(Box, { __css: s.panelFooter, children: r == null ? void 0 : r.footer })
  ] });
}, SmallScreensPanelElements = ({ panel: r, ...a }) => {
  const s = useMultiStyleConfig("SplitScreen", { panelPadding: r == null ? void 0 : r.padding });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !(r != null && r.isLoading) && (r == null ? void 0 : r.header) && /* @__PURE__ */ jsx(Box, { __css: s.panelHeader, children: r == null ? void 0 : r.header }),
    /* @__PURE__ */ jsx(Box, { __css: s.panelContent, ...a, tabIndex: r == null ? void 0 : r.tabIndex, children: r == null ? void 0 : r.content }),
    !(r != null && r.isLoading) && (r == null ? void 0 : r.footer) && /* @__PURE__ */ jsx(Box, { __css: s.panelFooter, children: r == null ? void 0 : r.footer })
  ] });
}, SplitScreen = forwardRef$1(
  ({
    isLoading: r,
    header: a,
    footer: s,
    panelA: c,
    panelB: u,
    variant: d = "1:2",
    "data-testid": h = "split-screen",
    ...p
  }, m) => {
    const v = (c == null ? void 0 : c.maxWidth) ?? 66.67, y = (c == null ? void 0 : c.minWidth) ?? 12.5, x = useMultiStyleConfig("SplitScreen", {}), w = useBreakpointValue({ xs: !0, l: !1 }), { isExtraSmallScreen: S } = useBreakpoint({ debounce: 0 }), M = (c == null ? void 0 : c.isLoading) || (u == null ? void 0 : u.isLoading), P = useTestId(h);
    return r ? /* @__PURE__ */ jsx(
      Box,
      {
        "data-component": "SplitScreen",
        __css: x.container,
        ...P(),
        ...p,
        ref: m,
        "data-loading": !0,
        children: /* @__PURE__ */ jsx(Loader, {})
      }
    ) : w ? /* @__PURE__ */ jsxs(Box, { "data-component": "SplitScreen", __css: x.container, ...P(), ...p, ref: m, children: [
      a,
      /* @__PURE__ */ jsx(Box, { __css: x.panel, "data-loading": M, children: M ? /* @__PURE__ */ jsx(Loader, { ...P("loader") }) : /* @__PURE__ */ jsxs(Group, { variant: "vertical", hasDivider: !0, spacing: S ? "xs" : "none", height: "full", children: [
        /* @__PURE__ */ jsx(SmallScreensPanelElements, { panel: c, ...P("panel-a") }),
        /* @__PURE__ */ jsx(SmallScreensPanelElements, { panel: u, ...P("panel-b") })
      ] }) }),
      s
    ] }) : /* @__PURE__ */ jsxs(Box, { "data-component": "SplitScreen", __css: x.container, ...P(), ...p, ref: m, children: [
      a,
      /* @__PURE__ */ jsxs(PanelGroup, { direction: "horizontal", children: [
        /* @__PURE__ */ jsx(
          Panel,
          {
            id: "panelA",
            defaultSize: variantToSizeMap[d].panelA,
            minSize: y,
            maxSize: v,
            order: 1,
            children: /* @__PURE__ */ jsx(PanelElements, { panel: c, ...P("panel-a") })
          }
        ),
        /* @__PURE__ */ jsx(ResizeHandle, { shouldAllowResizing: !1, ...P("resize-handle") }),
        /* @__PURE__ */ jsx(Panel, { id: "panelB", defaultSize: variantToSizeMap[d].panelB, order: 2, children: /* @__PURE__ */ jsx(PanelElements, { panel: u, ...P("panel-b") }) })
      ] }),
      s
    ] });
  }
);
SplitScreen.displayName = "SplitScreen";
const ExternalLayout = forwardRef$1(
  ({ header: r, content: a, footer: s, isLoading: c, logo: u, tabIndex: d, ...h }, p) => {
    const m = useBreakpointValue({ xs: 4, s: 8, m: 8, l: 8, xl: 16 }), g = useMultiStyleConfig("ExternalLayout", { columns: m }), v = /* @__PURE__ */ jsx(Logo, { "data-testid": "logo", size: "large", type: "light" });
    return /* @__PURE__ */ jsx(Box, { __css: g.container, "data-component": "ExternalLayout", ...h, ref: p, children: c ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(Fade, { in: !0, style: { width: "inherit", height: "inherit" }, children: /* @__PURE__ */ jsxs(Box, { __css: g.wrapper, tabIndex: d, children: [
      /* @__PURE__ */ jsx(Box, { __css: g.header }),
      /* @__PURE__ */ jsxs(Box, { __css: g.fixedHeader, children: [
        /* @__PURE__ */ jsx(Box, { __css: g.logoContainer, children: u ?? v }),
        r && /* @__PURE__ */ jsx(Box, { __css: g.headerContainer, children: r })
      ] }),
      /* @__PURE__ */ jsx(Box, { __css: g.grid, children: /* @__PURE__ */ jsx(Box, { __css: g.gridItemContent, children: /* @__PURE__ */ jsxs(Group, { variant: "vertical", spacing: "m", children: [
        a,
        s
      ] }) }) })
    ] }) }) });
  }
);
ExternalLayout.displayName = "ExternalLayout";
const Layout = forwardRef$1(
  ({
    maxWidth: r = LayoutMaxWidthDefault,
    backgroundColor: a = "default",
    isLoading: s,
    header: c,
    footer: u,
    children: d,
    paddingContent: h,
    "data-testid": p = "layout",
    tabIndex: m,
    ...g
  }, v) => {
    const y = useMultiStyleConfig("Layout", { maxWidth: r, isLoading: s, backgroundColor: a, paddingContent: h }), x = useTestId(p), w = /* @__PURE__ */ jsx(Box, { __css: y.header, ...x("header"), children: c == null ? void 0 : c.content }), S = /* @__PURE__ */ jsx(Box, { __css: y.footer, ...x("footer"), children: u == null ? void 0 : u.content });
    return /* @__PURE__ */ jsx(Box, { ...x(), "data-component": "Layout", ref: v, ...g, __css: y.container, children: s ? /* @__PURE__ */ jsx(Loader, { ...x("loader") }) : /* @__PURE__ */ jsxs(Fade, { in: !s, style: { display: "flex", flexDirection: "column", height: "100%" }, children: [
      (c == null ? void 0 : c.isSticky) && w,
      /* @__PURE__ */ jsxs(
        Box,
        {
          __css: y.contentContainer,
          tabIndex: m,
          children: [
            c && !(c != null && c.isSticky) && w,
            /* @__PURE__ */ jsx(Box, { __css: y.contentWrapper, children: /* @__PURE__ */ jsx(Box, { __css: y.content, ...x("content"), children: d }) }),
            u && !(u != null && u.isSticky) && S
          ]
        }
      ),
      (u == null ? void 0 : u.isSticky) && S
    ] }) });
  }
);
Layout.displayName = "Layout";
export {
  Accordion,
  ActionBar,
  ActionsDropdownMenu,
  AmountField,
  AmountInput,
  Avatar,
  AvatarGroup,
  AvatarImageControl,
  AvatarWithDetails,
  Badge,
  BaseMenu,
  BaseModal,
  Blanket,
  BorderRadiiContext,
  BorderRadiiProvider,
  BottomSheet,
  Brand,
  BrandSymbol,
  Button,
  Calendar,
  CalendarLegend,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Collapsible,
  CollapsibleCard,
  ColorPalettesContext,
  ColorPalettesProvider,
  ConditionalWrapper,
  Container,
  Counter,
  Currency,
  DateField,
  DatePicker,
  DeprecatedSearchBar,
  DeprecatedTabs,
  Divider,
  Drawer,
  ExternalLayout,
  Fade,
  FileAttachment,
  FileUpload,
  FlagIcon,
  FloatingButton,
  FloatingMenu,
  Form,
  FormControl,
  FormControlContext,
  FormField,
  FormLineItems,
  Grid,
  GridItem,
  Group,
  IFrame,
  Icon,
  IconButton,
  IconsContext,
  IconsProvider,
  Illustration,
  IllustrationsContext,
  IllustrationsProvider,
  Image$1 as Image,
  InteractiveButton,
  LargeFileUpload,
  Layout,
  LinearProgress,
  Link,
  ListItem,
  Loader,
  LoaderContext,
  LoaderProvider,
  LoadingContainer,
  Logo,
  LogosContext,
  LogosProvider,
  Lottie,
  Menu,
  Modal,
  ModalEvents,
  MultiSelect,
  NakedButton,
  NavigationItem,
  Pagination,
  PennyProvider,
  PhoneField,
  Pill,
  Popover,
  PromotionalModal,
  RadioGroup,
  ScaleFade,
  Search,
  SearchBar$1 as SearchBar,
  SectionBanner,
  SecuredTextField,
  Select,
  SelectNew,
  SelectableDropdownMenu,
  SelectionCard,
  SideSheet,
  SimpleGrid,
  SimpleSelectionCard,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Slide,
  SortDropdownMenu,
  SplitScreen,
  StackedContainer,
  StatusBar,
  StatusIconOutlined,
  StatusIconSolid,
  StatusIndicator,
  StatusModal,
  Switch,
  Table,
  Tabs,
  Text,
  TextArea,
  TextField,
  ThemeProvider,
  Toast,
  Tooltip,
  Tourtip,
  Tracker,
  Typography,
  VerificationCodeField,
  VerticalSelectionCard,
  Video,
  VirtualCard,
  VisuallyHidden,
  _BaseCalendar,
  _CustomInputContainer,
  _IconIndicator,
  _TableDateCell,
  _TableHeaderCell,
  _TableHeaderCellDescription,
  _TableHeaderSortableCell,
  createFormFieldInput as _createFormFieldInput,
  allIcons,
  applyToAllStates$1 as applyToAllStates,
  brandMap,
  brandSymbolsMap,
  createNumberMask,
  defaultDesignTokens,
  extendTheme,
  flags,
  formHeight,
  formTextStyle,
  heightsMapping,
  iconSizeMapping,
  iconSizes,
  icons,
  illustrations,
  input,
  useListItem as useBaseMenuItem,
  useBorderRadii,
  useBreakpoint,
  useBreakpointValue,
  useColorPalettes,
  useCssAnimation,
  useCustomSize,
  useDelayUnmount,
  useFieldArray,
  useFormContext$1 as useFormContext,
  useFormControlContext,
  useFormSubmissionController,
  useHideFromSR,
  useIconAsset,
  useIcons,
  useIllustrations,
  useLoader,
  useLogos,
  useMelioForm,
  useScrollBorders,
  useTable,
  useTheme,
  useToast,
  useWatch,
  widthsMapping
};
//# sourceMappingURL=index.mjs.map
